var z7 = Object.defineProperty;
var cg = (e) => {
  throw TypeError(e);
};
var V7 = (e, t, r) => t in e ? z7(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var ze = (e, t, r) => V7(e, typeof t != "symbol" ? t + "" : t, r), Af = (e, t, r) => t.has(e) || cg("Cannot " + r);
var Xe = (e, t, r) => (Af(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Ar = (e, t, r) => t.has(e) ? cg("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), mr = (e, t, r, n) => (Af(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), Br = (e, t, r) => (Af(e, t, "access private method"), r);
var lg = (e, t, r, n) => ({
  set _(s) {
    mr(e, t, s, r);
  },
  get _() {
    return Xe(e, t, n);
  }
});
import { g as q7, c as $7, a as K7 } from "./_commonjsHelpers-BVfed4GL.js";
import { N as pt, i as J7 } from "./network-BL4Bpk6W.js";
import { e as Q7 } from "./urls-CNhUmPu2.js";
import { a as ct, b as Yt, d as lr, c as Zp, e as l4, i as L0, m as oh, r as Qf, f as d4 } from "./errors-Jh6CB33H.js";
var Yp = { exports: {} };
const Z7 = {}, Y7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z7
}, Symbol.toStringTag, { value: "Module" })), X7 = /* @__PURE__ */ q7(Y7);
Yp.exports;
(function(e) {
  (function(t, r) {
    function n(o, u) {
      if (!o) throw new Error(u || "Assertion failed");
    }
    function s(o, u) {
      o.super_ = u;
      var h = function() {
      };
      h.prototype = u.prototype, o.prototype = new h(), o.prototype.constructor = o;
    }
    function i(o, u, h) {
      if (i.isBN(o))
        return o;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, o !== null && ((u === "le" || u === "be") && (h = u, u = 10), this._init(o || 0, u || 10, h || "be"));
    }
    typeof t == "object" ? t.exports = i : r.BN = i, i.BN = i, i.wordSize = 26;
    var a;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? a = window.Buffer : a = X7.Buffer;
    } catch {
    }
    i.isBN = function(u) {
      return u instanceof i ? !0 : u !== null && typeof u == "object" && u.constructor.wordSize === i.wordSize && Array.isArray(u.words);
    }, i.max = function(u, h) {
      return u.cmp(h) > 0 ? u : h;
    }, i.min = function(u, h) {
      return u.cmp(h) < 0 ? u : h;
    }, i.prototype._init = function(u, h, y) {
      if (typeof u == "number")
        return this._initNumber(u, h, y);
      if (typeof u == "object")
        return this._initArray(u, h, y);
      h === "hex" && (h = 16), n(h === (h | 0) && h >= 2 && h <= 36), u = u.toString().replace(/\s+/g, "");
      var E = 0;
      u[0] === "-" && (E++, this.negative = 1), E < u.length && (h === 16 ? this._parseHex(u, E, y) : (this._parseBase(u, h, E), y === "le" && this._initArray(this.toArray(), h, y)));
    }, i.prototype._initNumber = function(u, h, y) {
      u < 0 && (this.negative = 1, u = -u), u < 67108864 ? (this.words = [u & 67108863], this.length = 1) : u < 4503599627370496 ? (this.words = [
        u & 67108863,
        u / 67108864 & 67108863
      ], this.length = 2) : (n(u < 9007199254740992), this.words = [
        u & 67108863,
        u / 67108864 & 67108863,
        1
      ], this.length = 3), y === "le" && this._initArray(this.toArray(), h, y);
    }, i.prototype._initArray = function(u, h, y) {
      if (n(typeof u.length == "number"), u.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(u.length / 3), this.words = new Array(this.length);
      for (var E = 0; E < this.length; E++)
        this.words[E] = 0;
      var P, w, m = 0;
      if (y === "be")
        for (E = u.length - 1, P = 0; E >= 0; E -= 3)
          w = u[E] | u[E - 1] << 8 | u[E - 2] << 16, this.words[P] |= w << m & 67108863, this.words[P + 1] = w >>> 26 - m & 67108863, m += 24, m >= 26 && (m -= 26, P++);
      else if (y === "le")
        for (E = 0, P = 0; E < u.length; E += 3)
          w = u[E] | u[E + 1] << 8 | u[E + 2] << 16, this.words[P] |= w << m & 67108863, this.words[P + 1] = w >>> 26 - m & 67108863, m += 24, m >= 26 && (m -= 26, P++);
      return this._strip();
    };
    function f(o, u) {
      var h = o.charCodeAt(u);
      if (h >= 48 && h <= 57)
        return h - 48;
      if (h >= 65 && h <= 70)
        return h - 55;
      if (h >= 97 && h <= 102)
        return h - 87;
      n(!1, "Invalid character in " + o);
    }
    function d(o, u, h) {
      var y = f(o, h);
      return h - 1 >= u && (y |= f(o, h - 1) << 4), y;
    }
    i.prototype._parseHex = function(u, h, y) {
      this.length = Math.ceil((u.length - h) / 6), this.words = new Array(this.length);
      for (var E = 0; E < this.length; E++)
        this.words[E] = 0;
      var P = 0, w = 0, m;
      if (y === "be")
        for (E = u.length - 1; E >= h; E -= 2)
          m = d(u, h, E) << P, this.words[w] |= m & 67108863, P >= 18 ? (P -= 18, w += 1, this.words[w] |= m >>> 26) : P += 8;
      else {
        var l = u.length - h;
        for (E = l % 2 === 0 ? h + 1 : h; E < u.length; E += 2)
          m = d(u, h, E) << P, this.words[w] |= m & 67108863, P >= 18 ? (P -= 18, w += 1, this.words[w] |= m >>> 26) : P += 8;
      }
      this._strip();
    };
    function c(o, u, h, y) {
      for (var E = 0, P = 0, w = Math.min(o.length, h), m = u; m < w; m++) {
        var l = o.charCodeAt(m) - 48;
        E *= y, l >= 49 ? P = l - 49 + 10 : l >= 17 ? P = l - 17 + 10 : P = l, n(l >= 0 && P < y, "Invalid character"), E += P;
      }
      return E;
    }
    i.prototype._parseBase = function(u, h, y) {
      this.words = [0], this.length = 1;
      for (var E = 0, P = 1; P <= 67108863; P *= h)
        E++;
      E--, P = P / h | 0;
      for (var w = u.length - y, m = w % E, l = Math.min(w, w - m) + y, b = 0, W = y; W < l; W += E)
        b = c(u, W, W + E, h), this.imuln(P), this.words[0] + b < 67108864 ? this.words[0] += b : this._iaddn(b);
      if (m !== 0) {
        var X = 1;
        for (b = c(u, W, u.length, h), W = 0; W < m; W++)
          X *= h;
        this.imuln(X), this.words[0] + b < 67108864 ? this.words[0] += b : this._iaddn(b);
      }
      this._strip();
    }, i.prototype.copy = function(u) {
      u.words = new Array(this.length);
      for (var h = 0; h < this.length; h++)
        u.words[h] = this.words[h];
      u.length = this.length, u.negative = this.negative, u.red = this.red;
    };
    function p(o, u) {
      o.words = u.words, o.length = u.length, o.negative = u.negative, o.red = u.red;
    }
    if (i.prototype._move = function(u) {
      p(u, this);
    }, i.prototype.clone = function() {
      var u = new i(null);
      return this.copy(u), u;
    }, i.prototype._expand = function(u) {
      for (; this.length < u; )
        this.words[this.length++] = 0;
      return this;
    }, i.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, i.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        i.prototype[Symbol.for("nodejs.util.inspect.custom")] = g;
      } catch {
        i.prototype.inspect = g;
      }
    else
      i.prototype.inspect = g;
    function g() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var v = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], O = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], N = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    i.prototype.toString = function(u, h) {
      u = u || 10, h = h | 0 || 1;
      var y;
      if (u === 16 || u === "hex") {
        y = "";
        for (var E = 0, P = 0, w = 0; w < this.length; w++) {
          var m = this.words[w], l = ((m << E | P) & 16777215).toString(16);
          P = m >>> 24 - E & 16777215, E += 2, E >= 26 && (E -= 26, w--), P !== 0 || w !== this.length - 1 ? y = v[6 - l.length] + l + y : y = l + y;
        }
        for (P !== 0 && (y = P.toString(16) + y); y.length % h !== 0; )
          y = "0" + y;
        return this.negative !== 0 && (y = "-" + y), y;
      }
      if (u === (u | 0) && u >= 2 && u <= 36) {
        var b = O[u], W = N[u];
        y = "";
        var X = this.clone();
        for (X.negative = 0; !X.isZero(); ) {
          var G = X.modrn(W).toString(u);
          X = X.idivn(W), X.isZero() ? y = G + y : y = v[b - G.length] + G + y;
        }
        for (this.isZero() && (y = "0" + y); y.length % h !== 0; )
          y = "0" + y;
        return this.negative !== 0 && (y = "-" + y), y;
      }
      n(!1, "Base should be between 2 and 36");
    }, i.prototype.toNumber = function() {
      var u = this.words[0];
      return this.length === 2 ? u += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? u += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -u : u;
    }, i.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, a && (i.prototype.toBuffer = function(u, h) {
      return this.toArrayLike(a, u, h);
    }), i.prototype.toArray = function(u, h) {
      return this.toArrayLike(Array, u, h);
    };
    var S = function(u, h) {
      return u.allocUnsafe ? u.allocUnsafe(h) : new u(h);
    };
    i.prototype.toArrayLike = function(u, h, y) {
      this._strip();
      var E = this.byteLength(), P = y || Math.max(1, E);
      n(E <= P, "byte array longer than desired length"), n(P > 0, "Requested array length <= 0");
      var w = S(u, P), m = h === "le" ? "LE" : "BE";
      return this["_toArrayLike" + m](w, E), w;
    }, i.prototype._toArrayLikeLE = function(u, h) {
      for (var y = 0, E = 0, P = 0, w = 0; P < this.length; P++) {
        var m = this.words[P] << w | E;
        u[y++] = m & 255, y < u.length && (u[y++] = m >> 8 & 255), y < u.length && (u[y++] = m >> 16 & 255), w === 6 ? (y < u.length && (u[y++] = m >> 24 & 255), E = 0, w = 0) : (E = m >>> 24, w += 2);
      }
      if (y < u.length)
        for (u[y++] = E; y < u.length; )
          u[y++] = 0;
    }, i.prototype._toArrayLikeBE = function(u, h) {
      for (var y = u.length - 1, E = 0, P = 0, w = 0; P < this.length; P++) {
        var m = this.words[P] << w | E;
        u[y--] = m & 255, y >= 0 && (u[y--] = m >> 8 & 255), y >= 0 && (u[y--] = m >> 16 & 255), w === 6 ? (y >= 0 && (u[y--] = m >> 24 & 255), E = 0, w = 0) : (E = m >>> 24, w += 2);
      }
      if (y >= 0)
        for (u[y--] = E; y >= 0; )
          u[y--] = 0;
    }, Math.clz32 ? i.prototype._countBits = function(u) {
      return 32 - Math.clz32(u);
    } : i.prototype._countBits = function(u) {
      var h = u, y = 0;
      return h >= 4096 && (y += 13, h >>>= 13), h >= 64 && (y += 7, h >>>= 7), h >= 8 && (y += 4, h >>>= 4), h >= 2 && (y += 2, h >>>= 2), y + h;
    }, i.prototype._zeroBits = function(u) {
      if (u === 0) return 26;
      var h = u, y = 0;
      return h & 8191 || (y += 13, h >>>= 13), h & 127 || (y += 7, h >>>= 7), h & 15 || (y += 4, h >>>= 4), h & 3 || (y += 2, h >>>= 2), h & 1 || y++, y;
    }, i.prototype.bitLength = function() {
      var u = this.words[this.length - 1], h = this._countBits(u);
      return (this.length - 1) * 26 + h;
    };
    function j(o) {
      for (var u = new Array(o.bitLength()), h = 0; h < u.length; h++) {
        var y = h / 26 | 0, E = h % 26;
        u[h] = o.words[y] >>> E & 1;
      }
      return u;
    }
    i.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var u = 0, h = 0; h < this.length; h++) {
        var y = this._zeroBits(this.words[h]);
        if (u += y, y !== 26) break;
      }
      return u;
    }, i.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, i.prototype.toTwos = function(u) {
      return this.negative !== 0 ? this.abs().inotn(u).iaddn(1) : this.clone();
    }, i.prototype.fromTwos = function(u) {
      return this.testn(u - 1) ? this.notn(u).iaddn(1).ineg() : this.clone();
    }, i.prototype.isNeg = function() {
      return this.negative !== 0;
    }, i.prototype.neg = function() {
      return this.clone().ineg();
    }, i.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, i.prototype.iuor = function(u) {
      for (; this.length < u.length; )
        this.words[this.length++] = 0;
      for (var h = 0; h < u.length; h++)
        this.words[h] = this.words[h] | u.words[h];
      return this._strip();
    }, i.prototype.ior = function(u) {
      return n((this.negative | u.negative) === 0), this.iuor(u);
    }, i.prototype.or = function(u) {
      return this.length > u.length ? this.clone().ior(u) : u.clone().ior(this);
    }, i.prototype.uor = function(u) {
      return this.length > u.length ? this.clone().iuor(u) : u.clone().iuor(this);
    }, i.prototype.iuand = function(u) {
      var h;
      this.length > u.length ? h = u : h = this;
      for (var y = 0; y < h.length; y++)
        this.words[y] = this.words[y] & u.words[y];
      return this.length = h.length, this._strip();
    }, i.prototype.iand = function(u) {
      return n((this.negative | u.negative) === 0), this.iuand(u);
    }, i.prototype.and = function(u) {
      return this.length > u.length ? this.clone().iand(u) : u.clone().iand(this);
    }, i.prototype.uand = function(u) {
      return this.length > u.length ? this.clone().iuand(u) : u.clone().iuand(this);
    }, i.prototype.iuxor = function(u) {
      var h, y;
      this.length > u.length ? (h = this, y = u) : (h = u, y = this);
      for (var E = 0; E < y.length; E++)
        this.words[E] = h.words[E] ^ y.words[E];
      if (this !== h)
        for (; E < h.length; E++)
          this.words[E] = h.words[E];
      return this.length = h.length, this._strip();
    }, i.prototype.ixor = function(u) {
      return n((this.negative | u.negative) === 0), this.iuxor(u);
    }, i.prototype.xor = function(u) {
      return this.length > u.length ? this.clone().ixor(u) : u.clone().ixor(this);
    }, i.prototype.uxor = function(u) {
      return this.length > u.length ? this.clone().iuxor(u) : u.clone().iuxor(this);
    }, i.prototype.inotn = function(u) {
      n(typeof u == "number" && u >= 0);
      var h = Math.ceil(u / 26) | 0, y = u % 26;
      this._expand(h), y > 0 && h--;
      for (var E = 0; E < h; E++)
        this.words[E] = ~this.words[E] & 67108863;
      return y > 0 && (this.words[E] = ~this.words[E] & 67108863 >> 26 - y), this._strip();
    }, i.prototype.notn = function(u) {
      return this.clone().inotn(u);
    }, i.prototype.setn = function(u, h) {
      n(typeof u == "number" && u >= 0);
      var y = u / 26 | 0, E = u % 26;
      return this._expand(y + 1), h ? this.words[y] = this.words[y] | 1 << E : this.words[y] = this.words[y] & ~(1 << E), this._strip();
    }, i.prototype.iadd = function(u) {
      var h;
      if (this.negative !== 0 && u.negative === 0)
        return this.negative = 0, h = this.isub(u), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && u.negative !== 0)
        return u.negative = 0, h = this.isub(u), u.negative = 1, h._normSign();
      var y, E;
      this.length > u.length ? (y = this, E = u) : (y = u, E = this);
      for (var P = 0, w = 0; w < E.length; w++)
        h = (y.words[w] | 0) + (E.words[w] | 0) + P, this.words[w] = h & 67108863, P = h >>> 26;
      for (; P !== 0 && w < y.length; w++)
        h = (y.words[w] | 0) + P, this.words[w] = h & 67108863, P = h >>> 26;
      if (this.length = y.length, P !== 0)
        this.words[this.length] = P, this.length++;
      else if (y !== this)
        for (; w < y.length; w++)
          this.words[w] = y.words[w];
      return this;
    }, i.prototype.add = function(u) {
      var h;
      return u.negative !== 0 && this.negative === 0 ? (u.negative = 0, h = this.sub(u), u.negative ^= 1, h) : u.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = u.sub(this), this.negative = 1, h) : this.length > u.length ? this.clone().iadd(u) : u.clone().iadd(this);
    }, i.prototype.isub = function(u) {
      if (u.negative !== 0) {
        u.negative = 0;
        var h = this.iadd(u);
        return u.negative = 1, h._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(u), this.negative = 1, this._normSign();
      var y = this.cmp(u);
      if (y === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var E, P;
      y > 0 ? (E = this, P = u) : (E = u, P = this);
      for (var w = 0, m = 0; m < P.length; m++)
        h = (E.words[m] | 0) - (P.words[m] | 0) + w, w = h >> 26, this.words[m] = h & 67108863;
      for (; w !== 0 && m < E.length; m++)
        h = (E.words[m] | 0) + w, w = h >> 26, this.words[m] = h & 67108863;
      if (w === 0 && m < E.length && E !== this)
        for (; m < E.length; m++)
          this.words[m] = E.words[m];
      return this.length = Math.max(this.length, m), E !== this && (this.negative = 1), this._strip();
    }, i.prototype.sub = function(u) {
      return this.clone().isub(u);
    };
    function B(o, u, h) {
      h.negative = u.negative ^ o.negative;
      var y = o.length + u.length | 0;
      h.length = y, y = y - 1 | 0;
      var E = o.words[0] | 0, P = u.words[0] | 0, w = E * P, m = w & 67108863, l = w / 67108864 | 0;
      h.words[0] = m;
      for (var b = 1; b < y; b++) {
        for (var W = l >>> 26, X = l & 67108863, G = Math.min(b, u.length - 1), re = Math.max(0, b - o.length + 1); re <= G; re++) {
          var ce = b - re | 0;
          E = o.words[ce] | 0, P = u.words[re] | 0, w = E * P + X, W += w / 67108864 | 0, X = w & 67108863;
        }
        h.words[b] = X | 0, l = W | 0;
      }
      return l !== 0 ? h.words[b] = l | 0 : h.length--, h._strip();
    }
    var M = function(u, h, y) {
      var E = u.words, P = h.words, w = y.words, m = 0, l, b, W, X = E[0] | 0, G = X & 8191, re = X >>> 13, ce = E[1] | 0, pe = ce & 8191, ve = ce >>> 13, Ee = E[2] | 0, Pe = Ee & 8191, xe = Ee >>> 13, me = E[3] | 0, te = me & 8191, U = me >>> 13, ue = E[4] | 0, we = ue & 8191, ke = ue >>> 13, Re = E[5] | 0, fe = Re & 8191, x = Re >>> 13, _ = E[6] | 0, q = _ & 8191, ne = _ >>> 13, de = E[7] | 0, ye = de & 8191, ge = de >>> 13, be = E[8] | 0, Me = be & 8191, Ce = be >>> 13, je = E[9] | 0, Ue = je & 8191, Qe = je >>> 13, Ye = P[0] | 0, et = Ye & 8191, At = Ye >>> 13, it = P[1] | 0, tt = it & 8191, Pt = it >>> 13, dt = P[2] | 0, st = dt & 8191, zt = dt >>> 13, xt = P[3] | 0, lt = xt & 8191, $t = xt >>> 13, Tt = P[4] | 0, at = Tt & 8191, Ut = Tt >>> 13, Ot = P[5] | 0, He = Ot & 8191, Vt = Ot >>> 13, yt = P[6] | 0, ut = yt & 8191, It = yt >>> 13, kt = P[7] | 0, ot = kt & 8191, Rt = kt >>> 13, Nt = P[8] | 0, rt = Nt & 8191, Dt = Nt >>> 13, St = P[9] | 0, T = St & 8191, F = St >>> 13;
      y.negative = u.negative ^ h.negative, y.length = 19, l = Math.imul(G, et), b = Math.imul(G, At), b = b + Math.imul(re, et) | 0, W = Math.imul(re, At);
      var H = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (H >>> 26) | 0, H &= 67108863, l = Math.imul(pe, et), b = Math.imul(pe, At), b = b + Math.imul(ve, et) | 0, W = Math.imul(ve, At), l = l + Math.imul(G, tt) | 0, b = b + Math.imul(G, Pt) | 0, b = b + Math.imul(re, tt) | 0, W = W + Math.imul(re, Pt) | 0;
      var z = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (z >>> 26) | 0, z &= 67108863, l = Math.imul(Pe, et), b = Math.imul(Pe, At), b = b + Math.imul(xe, et) | 0, W = Math.imul(xe, At), l = l + Math.imul(pe, tt) | 0, b = b + Math.imul(pe, Pt) | 0, b = b + Math.imul(ve, tt) | 0, W = W + Math.imul(ve, Pt) | 0, l = l + Math.imul(G, st) | 0, b = b + Math.imul(G, zt) | 0, b = b + Math.imul(re, st) | 0, W = W + Math.imul(re, zt) | 0;
      var Q = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (Q >>> 26) | 0, Q &= 67108863, l = Math.imul(te, et), b = Math.imul(te, At), b = b + Math.imul(U, et) | 0, W = Math.imul(U, At), l = l + Math.imul(Pe, tt) | 0, b = b + Math.imul(Pe, Pt) | 0, b = b + Math.imul(xe, tt) | 0, W = W + Math.imul(xe, Pt) | 0, l = l + Math.imul(pe, st) | 0, b = b + Math.imul(pe, zt) | 0, b = b + Math.imul(ve, st) | 0, W = W + Math.imul(ve, zt) | 0, l = l + Math.imul(G, lt) | 0, b = b + Math.imul(G, $t) | 0, b = b + Math.imul(re, lt) | 0, W = W + Math.imul(re, $t) | 0;
      var Z = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (Z >>> 26) | 0, Z &= 67108863, l = Math.imul(we, et), b = Math.imul(we, At), b = b + Math.imul(ke, et) | 0, W = Math.imul(ke, At), l = l + Math.imul(te, tt) | 0, b = b + Math.imul(te, Pt) | 0, b = b + Math.imul(U, tt) | 0, W = W + Math.imul(U, Pt) | 0, l = l + Math.imul(Pe, st) | 0, b = b + Math.imul(Pe, zt) | 0, b = b + Math.imul(xe, st) | 0, W = W + Math.imul(xe, zt) | 0, l = l + Math.imul(pe, lt) | 0, b = b + Math.imul(pe, $t) | 0, b = b + Math.imul(ve, lt) | 0, W = W + Math.imul(ve, $t) | 0, l = l + Math.imul(G, at) | 0, b = b + Math.imul(G, Ut) | 0, b = b + Math.imul(re, at) | 0, W = W + Math.imul(re, Ut) | 0;
      var ie = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (ie >>> 26) | 0, ie &= 67108863, l = Math.imul(fe, et), b = Math.imul(fe, At), b = b + Math.imul(x, et) | 0, W = Math.imul(x, At), l = l + Math.imul(we, tt) | 0, b = b + Math.imul(we, Pt) | 0, b = b + Math.imul(ke, tt) | 0, W = W + Math.imul(ke, Pt) | 0, l = l + Math.imul(te, st) | 0, b = b + Math.imul(te, zt) | 0, b = b + Math.imul(U, st) | 0, W = W + Math.imul(U, zt) | 0, l = l + Math.imul(Pe, lt) | 0, b = b + Math.imul(Pe, $t) | 0, b = b + Math.imul(xe, lt) | 0, W = W + Math.imul(xe, $t) | 0, l = l + Math.imul(pe, at) | 0, b = b + Math.imul(pe, Ut) | 0, b = b + Math.imul(ve, at) | 0, W = W + Math.imul(ve, Ut) | 0, l = l + Math.imul(G, He) | 0, b = b + Math.imul(G, Vt) | 0, b = b + Math.imul(re, He) | 0, W = W + Math.imul(re, Vt) | 0;
      var he = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, l = Math.imul(q, et), b = Math.imul(q, At), b = b + Math.imul(ne, et) | 0, W = Math.imul(ne, At), l = l + Math.imul(fe, tt) | 0, b = b + Math.imul(fe, Pt) | 0, b = b + Math.imul(x, tt) | 0, W = W + Math.imul(x, Pt) | 0, l = l + Math.imul(we, st) | 0, b = b + Math.imul(we, zt) | 0, b = b + Math.imul(ke, st) | 0, W = W + Math.imul(ke, zt) | 0, l = l + Math.imul(te, lt) | 0, b = b + Math.imul(te, $t) | 0, b = b + Math.imul(U, lt) | 0, W = W + Math.imul(U, $t) | 0, l = l + Math.imul(Pe, at) | 0, b = b + Math.imul(Pe, Ut) | 0, b = b + Math.imul(xe, at) | 0, W = W + Math.imul(xe, Ut) | 0, l = l + Math.imul(pe, He) | 0, b = b + Math.imul(pe, Vt) | 0, b = b + Math.imul(ve, He) | 0, W = W + Math.imul(ve, Vt) | 0, l = l + Math.imul(G, ut) | 0, b = b + Math.imul(G, It) | 0, b = b + Math.imul(re, ut) | 0, W = W + Math.imul(re, It) | 0;
      var J = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (J >>> 26) | 0, J &= 67108863, l = Math.imul(ye, et), b = Math.imul(ye, At), b = b + Math.imul(ge, et) | 0, W = Math.imul(ge, At), l = l + Math.imul(q, tt) | 0, b = b + Math.imul(q, Pt) | 0, b = b + Math.imul(ne, tt) | 0, W = W + Math.imul(ne, Pt) | 0, l = l + Math.imul(fe, st) | 0, b = b + Math.imul(fe, zt) | 0, b = b + Math.imul(x, st) | 0, W = W + Math.imul(x, zt) | 0, l = l + Math.imul(we, lt) | 0, b = b + Math.imul(we, $t) | 0, b = b + Math.imul(ke, lt) | 0, W = W + Math.imul(ke, $t) | 0, l = l + Math.imul(te, at) | 0, b = b + Math.imul(te, Ut) | 0, b = b + Math.imul(U, at) | 0, W = W + Math.imul(U, Ut) | 0, l = l + Math.imul(Pe, He) | 0, b = b + Math.imul(Pe, Vt) | 0, b = b + Math.imul(xe, He) | 0, W = W + Math.imul(xe, Vt) | 0, l = l + Math.imul(pe, ut) | 0, b = b + Math.imul(pe, It) | 0, b = b + Math.imul(ve, ut) | 0, W = W + Math.imul(ve, It) | 0, l = l + Math.imul(G, ot) | 0, b = b + Math.imul(G, Rt) | 0, b = b + Math.imul(re, ot) | 0, W = W + Math.imul(re, Rt) | 0;
      var Y = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, l = Math.imul(Me, et), b = Math.imul(Me, At), b = b + Math.imul(Ce, et) | 0, W = Math.imul(Ce, At), l = l + Math.imul(ye, tt) | 0, b = b + Math.imul(ye, Pt) | 0, b = b + Math.imul(ge, tt) | 0, W = W + Math.imul(ge, Pt) | 0, l = l + Math.imul(q, st) | 0, b = b + Math.imul(q, zt) | 0, b = b + Math.imul(ne, st) | 0, W = W + Math.imul(ne, zt) | 0, l = l + Math.imul(fe, lt) | 0, b = b + Math.imul(fe, $t) | 0, b = b + Math.imul(x, lt) | 0, W = W + Math.imul(x, $t) | 0, l = l + Math.imul(we, at) | 0, b = b + Math.imul(we, Ut) | 0, b = b + Math.imul(ke, at) | 0, W = W + Math.imul(ke, Ut) | 0, l = l + Math.imul(te, He) | 0, b = b + Math.imul(te, Vt) | 0, b = b + Math.imul(U, He) | 0, W = W + Math.imul(U, Vt) | 0, l = l + Math.imul(Pe, ut) | 0, b = b + Math.imul(Pe, It) | 0, b = b + Math.imul(xe, ut) | 0, W = W + Math.imul(xe, It) | 0, l = l + Math.imul(pe, ot) | 0, b = b + Math.imul(pe, Rt) | 0, b = b + Math.imul(ve, ot) | 0, W = W + Math.imul(ve, Rt) | 0, l = l + Math.imul(G, rt) | 0, b = b + Math.imul(G, Dt) | 0, b = b + Math.imul(re, rt) | 0, W = W + Math.imul(re, Dt) | 0;
      var ee = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (ee >>> 26) | 0, ee &= 67108863, l = Math.imul(Ue, et), b = Math.imul(Ue, At), b = b + Math.imul(Qe, et) | 0, W = Math.imul(Qe, At), l = l + Math.imul(Me, tt) | 0, b = b + Math.imul(Me, Pt) | 0, b = b + Math.imul(Ce, tt) | 0, W = W + Math.imul(Ce, Pt) | 0, l = l + Math.imul(ye, st) | 0, b = b + Math.imul(ye, zt) | 0, b = b + Math.imul(ge, st) | 0, W = W + Math.imul(ge, zt) | 0, l = l + Math.imul(q, lt) | 0, b = b + Math.imul(q, $t) | 0, b = b + Math.imul(ne, lt) | 0, W = W + Math.imul(ne, $t) | 0, l = l + Math.imul(fe, at) | 0, b = b + Math.imul(fe, Ut) | 0, b = b + Math.imul(x, at) | 0, W = W + Math.imul(x, Ut) | 0, l = l + Math.imul(we, He) | 0, b = b + Math.imul(we, Vt) | 0, b = b + Math.imul(ke, He) | 0, W = W + Math.imul(ke, Vt) | 0, l = l + Math.imul(te, ut) | 0, b = b + Math.imul(te, It) | 0, b = b + Math.imul(U, ut) | 0, W = W + Math.imul(U, It) | 0, l = l + Math.imul(Pe, ot) | 0, b = b + Math.imul(Pe, Rt) | 0, b = b + Math.imul(xe, ot) | 0, W = W + Math.imul(xe, Rt) | 0, l = l + Math.imul(pe, rt) | 0, b = b + Math.imul(pe, Dt) | 0, b = b + Math.imul(ve, rt) | 0, W = W + Math.imul(ve, Dt) | 0, l = l + Math.imul(G, T) | 0, b = b + Math.imul(G, F) | 0, b = b + Math.imul(re, T) | 0, W = W + Math.imul(re, F) | 0;
      var se = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (se >>> 26) | 0, se &= 67108863, l = Math.imul(Ue, tt), b = Math.imul(Ue, Pt), b = b + Math.imul(Qe, tt) | 0, W = Math.imul(Qe, Pt), l = l + Math.imul(Me, st) | 0, b = b + Math.imul(Me, zt) | 0, b = b + Math.imul(Ce, st) | 0, W = W + Math.imul(Ce, zt) | 0, l = l + Math.imul(ye, lt) | 0, b = b + Math.imul(ye, $t) | 0, b = b + Math.imul(ge, lt) | 0, W = W + Math.imul(ge, $t) | 0, l = l + Math.imul(q, at) | 0, b = b + Math.imul(q, Ut) | 0, b = b + Math.imul(ne, at) | 0, W = W + Math.imul(ne, Ut) | 0, l = l + Math.imul(fe, He) | 0, b = b + Math.imul(fe, Vt) | 0, b = b + Math.imul(x, He) | 0, W = W + Math.imul(x, Vt) | 0, l = l + Math.imul(we, ut) | 0, b = b + Math.imul(we, It) | 0, b = b + Math.imul(ke, ut) | 0, W = W + Math.imul(ke, It) | 0, l = l + Math.imul(te, ot) | 0, b = b + Math.imul(te, Rt) | 0, b = b + Math.imul(U, ot) | 0, W = W + Math.imul(U, Rt) | 0, l = l + Math.imul(Pe, rt) | 0, b = b + Math.imul(Pe, Dt) | 0, b = b + Math.imul(xe, rt) | 0, W = W + Math.imul(xe, Dt) | 0, l = l + Math.imul(pe, T) | 0, b = b + Math.imul(pe, F) | 0, b = b + Math.imul(ve, T) | 0, W = W + Math.imul(ve, F) | 0;
      var le = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (le >>> 26) | 0, le &= 67108863, l = Math.imul(Ue, st), b = Math.imul(Ue, zt), b = b + Math.imul(Qe, st) | 0, W = Math.imul(Qe, zt), l = l + Math.imul(Me, lt) | 0, b = b + Math.imul(Me, $t) | 0, b = b + Math.imul(Ce, lt) | 0, W = W + Math.imul(Ce, $t) | 0, l = l + Math.imul(ye, at) | 0, b = b + Math.imul(ye, Ut) | 0, b = b + Math.imul(ge, at) | 0, W = W + Math.imul(ge, Ut) | 0, l = l + Math.imul(q, He) | 0, b = b + Math.imul(q, Vt) | 0, b = b + Math.imul(ne, He) | 0, W = W + Math.imul(ne, Vt) | 0, l = l + Math.imul(fe, ut) | 0, b = b + Math.imul(fe, It) | 0, b = b + Math.imul(x, ut) | 0, W = W + Math.imul(x, It) | 0, l = l + Math.imul(we, ot) | 0, b = b + Math.imul(we, Rt) | 0, b = b + Math.imul(ke, ot) | 0, W = W + Math.imul(ke, Rt) | 0, l = l + Math.imul(te, rt) | 0, b = b + Math.imul(te, Dt) | 0, b = b + Math.imul(U, rt) | 0, W = W + Math.imul(U, Dt) | 0, l = l + Math.imul(Pe, T) | 0, b = b + Math.imul(Pe, F) | 0, b = b + Math.imul(xe, T) | 0, W = W + Math.imul(xe, F) | 0;
      var Ae = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, l = Math.imul(Ue, lt), b = Math.imul(Ue, $t), b = b + Math.imul(Qe, lt) | 0, W = Math.imul(Qe, $t), l = l + Math.imul(Me, at) | 0, b = b + Math.imul(Me, Ut) | 0, b = b + Math.imul(Ce, at) | 0, W = W + Math.imul(Ce, Ut) | 0, l = l + Math.imul(ye, He) | 0, b = b + Math.imul(ye, Vt) | 0, b = b + Math.imul(ge, He) | 0, W = W + Math.imul(ge, Vt) | 0, l = l + Math.imul(q, ut) | 0, b = b + Math.imul(q, It) | 0, b = b + Math.imul(ne, ut) | 0, W = W + Math.imul(ne, It) | 0, l = l + Math.imul(fe, ot) | 0, b = b + Math.imul(fe, Rt) | 0, b = b + Math.imul(x, ot) | 0, W = W + Math.imul(x, Rt) | 0, l = l + Math.imul(we, rt) | 0, b = b + Math.imul(we, Dt) | 0, b = b + Math.imul(ke, rt) | 0, W = W + Math.imul(ke, Dt) | 0, l = l + Math.imul(te, T) | 0, b = b + Math.imul(te, F) | 0, b = b + Math.imul(U, T) | 0, W = W + Math.imul(U, F) | 0;
      var Te = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, l = Math.imul(Ue, at), b = Math.imul(Ue, Ut), b = b + Math.imul(Qe, at) | 0, W = Math.imul(Qe, Ut), l = l + Math.imul(Me, He) | 0, b = b + Math.imul(Me, Vt) | 0, b = b + Math.imul(Ce, He) | 0, W = W + Math.imul(Ce, Vt) | 0, l = l + Math.imul(ye, ut) | 0, b = b + Math.imul(ye, It) | 0, b = b + Math.imul(ge, ut) | 0, W = W + Math.imul(ge, It) | 0, l = l + Math.imul(q, ot) | 0, b = b + Math.imul(q, Rt) | 0, b = b + Math.imul(ne, ot) | 0, W = W + Math.imul(ne, Rt) | 0, l = l + Math.imul(fe, rt) | 0, b = b + Math.imul(fe, Dt) | 0, b = b + Math.imul(x, rt) | 0, W = W + Math.imul(x, Dt) | 0, l = l + Math.imul(we, T) | 0, b = b + Math.imul(we, F) | 0, b = b + Math.imul(ke, T) | 0, W = W + Math.imul(ke, F) | 0;
      var Ie = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, l = Math.imul(Ue, He), b = Math.imul(Ue, Vt), b = b + Math.imul(Qe, He) | 0, W = Math.imul(Qe, Vt), l = l + Math.imul(Me, ut) | 0, b = b + Math.imul(Me, It) | 0, b = b + Math.imul(Ce, ut) | 0, W = W + Math.imul(Ce, It) | 0, l = l + Math.imul(ye, ot) | 0, b = b + Math.imul(ye, Rt) | 0, b = b + Math.imul(ge, ot) | 0, W = W + Math.imul(ge, Rt) | 0, l = l + Math.imul(q, rt) | 0, b = b + Math.imul(q, Dt) | 0, b = b + Math.imul(ne, rt) | 0, W = W + Math.imul(ne, Dt) | 0, l = l + Math.imul(fe, T) | 0, b = b + Math.imul(fe, F) | 0, b = b + Math.imul(x, T) | 0, W = W + Math.imul(x, F) | 0;
      var We = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, l = Math.imul(Ue, ut), b = Math.imul(Ue, It), b = b + Math.imul(Qe, ut) | 0, W = Math.imul(Qe, It), l = l + Math.imul(Me, ot) | 0, b = b + Math.imul(Me, Rt) | 0, b = b + Math.imul(Ce, ot) | 0, W = W + Math.imul(Ce, Rt) | 0, l = l + Math.imul(ye, rt) | 0, b = b + Math.imul(ye, Dt) | 0, b = b + Math.imul(ge, rt) | 0, W = W + Math.imul(ge, Dt) | 0, l = l + Math.imul(q, T) | 0, b = b + Math.imul(q, F) | 0, b = b + Math.imul(ne, T) | 0, W = W + Math.imul(ne, F) | 0;
      var Ke = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (Ke >>> 26) | 0, Ke &= 67108863, l = Math.imul(Ue, ot), b = Math.imul(Ue, Rt), b = b + Math.imul(Qe, ot) | 0, W = Math.imul(Qe, Rt), l = l + Math.imul(Me, rt) | 0, b = b + Math.imul(Me, Dt) | 0, b = b + Math.imul(Ce, rt) | 0, W = W + Math.imul(Ce, Dt) | 0, l = l + Math.imul(ye, T) | 0, b = b + Math.imul(ye, F) | 0, b = b + Math.imul(ge, T) | 0, W = W + Math.imul(ge, F) | 0;
      var Le = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, l = Math.imul(Ue, rt), b = Math.imul(Ue, Dt), b = b + Math.imul(Qe, rt) | 0, W = Math.imul(Qe, Dt), l = l + Math.imul(Me, T) | 0, b = b + Math.imul(Me, F) | 0, b = b + Math.imul(Ce, T) | 0, W = W + Math.imul(Ce, F) | 0;
      var De = (m + l | 0) + ((b & 8191) << 13) | 0;
      m = (W + (b >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, l = Math.imul(Ue, T), b = Math.imul(Ue, F), b = b + Math.imul(Qe, T) | 0, W = Math.imul(Qe, F);
      var Ge = (m + l | 0) + ((b & 8191) << 13) | 0;
      return m = (W + (b >>> 13) | 0) + (Ge >>> 26) | 0, Ge &= 67108863, w[0] = H, w[1] = z, w[2] = Q, w[3] = Z, w[4] = ie, w[5] = he, w[6] = J, w[7] = Y, w[8] = ee, w[9] = se, w[10] = le, w[11] = Ae, w[12] = Te, w[13] = Ie, w[14] = We, w[15] = Ke, w[16] = Le, w[17] = De, w[18] = Ge, m !== 0 && (w[19] = m, y.length++), y;
    };
    Math.imul || (M = B);
    function I(o, u, h) {
      h.negative = u.negative ^ o.negative, h.length = o.length + u.length;
      for (var y = 0, E = 0, P = 0; P < h.length - 1; P++) {
        var w = E;
        E = 0;
        for (var m = y & 67108863, l = Math.min(P, u.length - 1), b = Math.max(0, P - o.length + 1); b <= l; b++) {
          var W = P - b, X = o.words[W] | 0, G = u.words[b] | 0, re = X * G, ce = re & 67108863;
          w = w + (re / 67108864 | 0) | 0, ce = ce + m | 0, m = ce & 67108863, w = w + (ce >>> 26) | 0, E += w >>> 26, w &= 67108863;
        }
        h.words[P] = m, y = w, w = E;
      }
      return y !== 0 ? h.words[P] = y : h.length--, h._strip();
    }
    function A(o, u, h) {
      return I(o, u, h);
    }
    i.prototype.mulTo = function(u, h) {
      var y, E = this.length + u.length;
      return this.length === 10 && u.length === 10 ? y = M(this, u, h) : E < 63 ? y = B(this, u, h) : E < 1024 ? y = I(this, u, h) : y = A(this, u, h), y;
    }, i.prototype.mul = function(u) {
      var h = new i(null);
      return h.words = new Array(this.length + u.length), this.mulTo(u, h);
    }, i.prototype.mulf = function(u) {
      var h = new i(null);
      return h.words = new Array(this.length + u.length), A(this, u, h);
    }, i.prototype.imul = function(u) {
      return this.clone().mulTo(u, this);
    }, i.prototype.imuln = function(u) {
      var h = u < 0;
      h && (u = -u), n(typeof u == "number"), n(u < 67108864);
      for (var y = 0, E = 0; E < this.length; E++) {
        var P = (this.words[E] | 0) * u, w = (P & 67108863) + (y & 67108863);
        y >>= 26, y += P / 67108864 | 0, y += w >>> 26, this.words[E] = w & 67108863;
      }
      return y !== 0 && (this.words[E] = y, this.length++), h ? this.ineg() : this;
    }, i.prototype.muln = function(u) {
      return this.clone().imuln(u);
    }, i.prototype.sqr = function() {
      return this.mul(this);
    }, i.prototype.isqr = function() {
      return this.imul(this.clone());
    }, i.prototype.pow = function(u) {
      var h = j(u);
      if (h.length === 0) return new i(1);
      for (var y = this, E = 0; E < h.length && h[E] === 0; E++, y = y.sqr())
        ;
      if (++E < h.length)
        for (var P = y.sqr(); E < h.length; E++, P = P.sqr())
          h[E] !== 0 && (y = y.mul(P));
      return y;
    }, i.prototype.iushln = function(u) {
      n(typeof u == "number" && u >= 0);
      var h = u % 26, y = (u - h) / 26, E = 67108863 >>> 26 - h << 26 - h, P;
      if (h !== 0) {
        var w = 0;
        for (P = 0; P < this.length; P++) {
          var m = this.words[P] & E, l = (this.words[P] | 0) - m << h;
          this.words[P] = l | w, w = m >>> 26 - h;
        }
        w && (this.words[P] = w, this.length++);
      }
      if (y !== 0) {
        for (P = this.length - 1; P >= 0; P--)
          this.words[P + y] = this.words[P];
        for (P = 0; P < y; P++)
          this.words[P] = 0;
        this.length += y;
      }
      return this._strip();
    }, i.prototype.ishln = function(u) {
      return n(this.negative === 0), this.iushln(u);
    }, i.prototype.iushrn = function(u, h, y) {
      n(typeof u == "number" && u >= 0);
      var E;
      h ? E = (h - h % 26) / 26 : E = 0;
      var P = u % 26, w = Math.min((u - P) / 26, this.length), m = 67108863 ^ 67108863 >>> P << P, l = y;
      if (E -= w, E = Math.max(0, E), l) {
        for (var b = 0; b < w; b++)
          l.words[b] = this.words[b];
        l.length = w;
      }
      if (w !== 0) if (this.length > w)
        for (this.length -= w, b = 0; b < this.length; b++)
          this.words[b] = this.words[b + w];
      else
        this.words[0] = 0, this.length = 1;
      var W = 0;
      for (b = this.length - 1; b >= 0 && (W !== 0 || b >= E); b--) {
        var X = this.words[b] | 0;
        this.words[b] = W << 26 - P | X >>> P, W = X & m;
      }
      return l && W !== 0 && (l.words[l.length++] = W), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, i.prototype.ishrn = function(u, h, y) {
      return n(this.negative === 0), this.iushrn(u, h, y);
    }, i.prototype.shln = function(u) {
      return this.clone().ishln(u);
    }, i.prototype.ushln = function(u) {
      return this.clone().iushln(u);
    }, i.prototype.shrn = function(u) {
      return this.clone().ishrn(u);
    }, i.prototype.ushrn = function(u) {
      return this.clone().iushrn(u);
    }, i.prototype.testn = function(u) {
      n(typeof u == "number" && u >= 0);
      var h = u % 26, y = (u - h) / 26, E = 1 << h;
      if (this.length <= y) return !1;
      var P = this.words[y];
      return !!(P & E);
    }, i.prototype.imaskn = function(u) {
      n(typeof u == "number" && u >= 0);
      var h = u % 26, y = (u - h) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= y)
        return this;
      if (h !== 0 && y++, this.length = Math.min(y, this.length), h !== 0) {
        var E = 67108863 ^ 67108863 >>> h << h;
        this.words[this.length - 1] &= E;
      }
      return this._strip();
    }, i.prototype.maskn = function(u) {
      return this.clone().imaskn(u);
    }, i.prototype.iaddn = function(u) {
      return n(typeof u == "number"), n(u < 67108864), u < 0 ? this.isubn(-u) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= u ? (this.words[0] = u - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(u), this.negative = 1, this) : this._iaddn(u);
    }, i.prototype._iaddn = function(u) {
      this.words[0] += u;
      for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
        this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
      return this.length = Math.max(this.length, h + 1), this;
    }, i.prototype.isubn = function(u) {
      if (n(typeof u == "number"), n(u < 67108864), u < 0) return this.iaddn(-u);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(u), this.negative = 1, this;
      if (this.words[0] -= u, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var h = 0; h < this.length && this.words[h] < 0; h++)
          this.words[h] += 67108864, this.words[h + 1] -= 1;
      return this._strip();
    }, i.prototype.addn = function(u) {
      return this.clone().iaddn(u);
    }, i.prototype.subn = function(u) {
      return this.clone().isubn(u);
    }, i.prototype.iabs = function() {
      return this.negative = 0, this;
    }, i.prototype.abs = function() {
      return this.clone().iabs();
    }, i.prototype._ishlnsubmul = function(u, h, y) {
      var E = u.length + y, P;
      this._expand(E);
      var w, m = 0;
      for (P = 0; P < u.length; P++) {
        w = (this.words[P + y] | 0) + m;
        var l = (u.words[P] | 0) * h;
        w -= l & 67108863, m = (w >> 26) - (l / 67108864 | 0), this.words[P + y] = w & 67108863;
      }
      for (; P < this.length - y; P++)
        w = (this.words[P + y] | 0) + m, m = w >> 26, this.words[P + y] = w & 67108863;
      if (m === 0) return this._strip();
      for (n(m === -1), m = 0, P = 0; P < this.length; P++)
        w = -(this.words[P] | 0) + m, m = w >> 26, this.words[P] = w & 67108863;
      return this.negative = 1, this._strip();
    }, i.prototype._wordDiv = function(u, h) {
      var y = this.length - u.length, E = this.clone(), P = u, w = P.words[P.length - 1] | 0, m = this._countBits(w);
      y = 26 - m, y !== 0 && (P = P.ushln(y), E.iushln(y), w = P.words[P.length - 1] | 0);
      var l = E.length - P.length, b;
      if (h !== "mod") {
        b = new i(null), b.length = l + 1, b.words = new Array(b.length);
        for (var W = 0; W < b.length; W++)
          b.words[W] = 0;
      }
      var X = E.clone()._ishlnsubmul(P, 1, l);
      X.negative === 0 && (E = X, b && (b.words[l] = 1));
      for (var G = l - 1; G >= 0; G--) {
        var re = (E.words[P.length + G] | 0) * 67108864 + (E.words[P.length + G - 1] | 0);
        for (re = Math.min(re / w | 0, 67108863), E._ishlnsubmul(P, re, G); E.negative !== 0; )
          re--, E.negative = 0, E._ishlnsubmul(P, 1, G), E.isZero() || (E.negative ^= 1);
        b && (b.words[G] = re);
      }
      return b && b._strip(), E._strip(), h !== "div" && y !== 0 && E.iushrn(y), {
        div: b || null,
        mod: E
      };
    }, i.prototype.divmod = function(u, h, y) {
      if (n(!u.isZero()), this.isZero())
        return {
          div: new i(0),
          mod: new i(0)
        };
      var E, P, w;
      return this.negative !== 0 && u.negative === 0 ? (w = this.neg().divmod(u, h), h !== "mod" && (E = w.div.neg()), h !== "div" && (P = w.mod.neg(), y && P.negative !== 0 && P.iadd(u)), {
        div: E,
        mod: P
      }) : this.negative === 0 && u.negative !== 0 ? (w = this.divmod(u.neg(), h), h !== "mod" && (E = w.div.neg()), {
        div: E,
        mod: w.mod
      }) : this.negative & u.negative ? (w = this.neg().divmod(u.neg(), h), h !== "div" && (P = w.mod.neg(), y && P.negative !== 0 && P.isub(u)), {
        div: w.div,
        mod: P
      }) : u.length > this.length || this.cmp(u) < 0 ? {
        div: new i(0),
        mod: this
      } : u.length === 1 ? h === "div" ? {
        div: this.divn(u.words[0]),
        mod: null
      } : h === "mod" ? {
        div: null,
        mod: new i(this.modrn(u.words[0]))
      } : {
        div: this.divn(u.words[0]),
        mod: new i(this.modrn(u.words[0]))
      } : this._wordDiv(u, h);
    }, i.prototype.div = function(u) {
      return this.divmod(u, "div", !1).div;
    }, i.prototype.mod = function(u) {
      return this.divmod(u, "mod", !1).mod;
    }, i.prototype.umod = function(u) {
      return this.divmod(u, "mod", !0).mod;
    }, i.prototype.divRound = function(u) {
      var h = this.divmod(u);
      if (h.mod.isZero()) return h.div;
      var y = h.div.negative !== 0 ? h.mod.isub(u) : h.mod, E = u.ushrn(1), P = u.andln(1), w = y.cmp(E);
      return w < 0 || P === 1 && w === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
    }, i.prototype.modrn = function(u) {
      var h = u < 0;
      h && (u = -u), n(u <= 67108863);
      for (var y = (1 << 26) % u, E = 0, P = this.length - 1; P >= 0; P--)
        E = (y * E + (this.words[P] | 0)) % u;
      return h ? -E : E;
    }, i.prototype.modn = function(u) {
      return this.modrn(u);
    }, i.prototype.idivn = function(u) {
      var h = u < 0;
      h && (u = -u), n(u <= 67108863);
      for (var y = 0, E = this.length - 1; E >= 0; E--) {
        var P = (this.words[E] | 0) + y * 67108864;
        this.words[E] = P / u | 0, y = P % u;
      }
      return this._strip(), h ? this.ineg() : this;
    }, i.prototype.divn = function(u) {
      return this.clone().idivn(u);
    }, i.prototype.egcd = function(u) {
      n(u.negative === 0), n(!u.isZero());
      var h = this, y = u.clone();
      h.negative !== 0 ? h = h.umod(u) : h = h.clone();
      for (var E = new i(1), P = new i(0), w = new i(0), m = new i(1), l = 0; h.isEven() && y.isEven(); )
        h.iushrn(1), y.iushrn(1), ++l;
      for (var b = y.clone(), W = h.clone(); !h.isZero(); ) {
        for (var X = 0, G = 1; !(h.words[0] & G) && X < 26; ++X, G <<= 1) ;
        if (X > 0)
          for (h.iushrn(X); X-- > 0; )
            (E.isOdd() || P.isOdd()) && (E.iadd(b), P.isub(W)), E.iushrn(1), P.iushrn(1);
        for (var re = 0, ce = 1; !(y.words[0] & ce) && re < 26; ++re, ce <<= 1) ;
        if (re > 0)
          for (y.iushrn(re); re-- > 0; )
            (w.isOdd() || m.isOdd()) && (w.iadd(b), m.isub(W)), w.iushrn(1), m.iushrn(1);
        h.cmp(y) >= 0 ? (h.isub(y), E.isub(w), P.isub(m)) : (y.isub(h), w.isub(E), m.isub(P));
      }
      return {
        a: w,
        b: m,
        gcd: y.iushln(l)
      };
    }, i.prototype._invmp = function(u) {
      n(u.negative === 0), n(!u.isZero());
      var h = this, y = u.clone();
      h.negative !== 0 ? h = h.umod(u) : h = h.clone();
      for (var E = new i(1), P = new i(0), w = y.clone(); h.cmpn(1) > 0 && y.cmpn(1) > 0; ) {
        for (var m = 0, l = 1; !(h.words[0] & l) && m < 26; ++m, l <<= 1) ;
        if (m > 0)
          for (h.iushrn(m); m-- > 0; )
            E.isOdd() && E.iadd(w), E.iushrn(1);
        for (var b = 0, W = 1; !(y.words[0] & W) && b < 26; ++b, W <<= 1) ;
        if (b > 0)
          for (y.iushrn(b); b-- > 0; )
            P.isOdd() && P.iadd(w), P.iushrn(1);
        h.cmp(y) >= 0 ? (h.isub(y), E.isub(P)) : (y.isub(h), P.isub(E));
      }
      var X;
      return h.cmpn(1) === 0 ? X = E : X = P, X.cmpn(0) < 0 && X.iadd(u), X;
    }, i.prototype.gcd = function(u) {
      if (this.isZero()) return u.abs();
      if (u.isZero()) return this.abs();
      var h = this.clone(), y = u.clone();
      h.negative = 0, y.negative = 0;
      for (var E = 0; h.isEven() && y.isEven(); E++)
        h.iushrn(1), y.iushrn(1);
      do {
        for (; h.isEven(); )
          h.iushrn(1);
        for (; y.isEven(); )
          y.iushrn(1);
        var P = h.cmp(y);
        if (P < 0) {
          var w = h;
          h = y, y = w;
        } else if (P === 0 || y.cmpn(1) === 0)
          break;
        h.isub(y);
      } while (!0);
      return y.iushln(E);
    }, i.prototype.invm = function(u) {
      return this.egcd(u).a.umod(u);
    }, i.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, i.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, i.prototype.andln = function(u) {
      return this.words[0] & u;
    }, i.prototype.bincn = function(u) {
      n(typeof u == "number");
      var h = u % 26, y = (u - h) / 26, E = 1 << h;
      if (this.length <= y)
        return this._expand(y + 1), this.words[y] |= E, this;
      for (var P = E, w = y; P !== 0 && w < this.length; w++) {
        var m = this.words[w] | 0;
        m += P, P = m >>> 26, m &= 67108863, this.words[w] = m;
      }
      return P !== 0 && (this.words[w] = P, this.length++), this;
    }, i.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, i.prototype.cmpn = function(u) {
      var h = u < 0;
      if (this.negative !== 0 && !h) return -1;
      if (this.negative === 0 && h) return 1;
      this._strip();
      var y;
      if (this.length > 1)
        y = 1;
      else {
        h && (u = -u), n(u <= 67108863, "Number is too big");
        var E = this.words[0] | 0;
        y = E === u ? 0 : E < u ? -1 : 1;
      }
      return this.negative !== 0 ? -y | 0 : y;
    }, i.prototype.cmp = function(u) {
      if (this.negative !== 0 && u.negative === 0) return -1;
      if (this.negative === 0 && u.negative !== 0) return 1;
      var h = this.ucmp(u);
      return this.negative !== 0 ? -h | 0 : h;
    }, i.prototype.ucmp = function(u) {
      if (this.length > u.length) return 1;
      if (this.length < u.length) return -1;
      for (var h = 0, y = this.length - 1; y >= 0; y--) {
        var E = this.words[y] | 0, P = u.words[y] | 0;
        if (E !== P) {
          E < P ? h = -1 : E > P && (h = 1);
          break;
        }
      }
      return h;
    }, i.prototype.gtn = function(u) {
      return this.cmpn(u) === 1;
    }, i.prototype.gt = function(u) {
      return this.cmp(u) === 1;
    }, i.prototype.gten = function(u) {
      return this.cmpn(u) >= 0;
    }, i.prototype.gte = function(u) {
      return this.cmp(u) >= 0;
    }, i.prototype.ltn = function(u) {
      return this.cmpn(u) === -1;
    }, i.prototype.lt = function(u) {
      return this.cmp(u) === -1;
    }, i.prototype.lten = function(u) {
      return this.cmpn(u) <= 0;
    }, i.prototype.lte = function(u) {
      return this.cmp(u) <= 0;
    }, i.prototype.eqn = function(u) {
      return this.cmpn(u) === 0;
    }, i.prototype.eq = function(u) {
      return this.cmp(u) === 0;
    }, i.red = function(u) {
      return new C(u);
    }, i.prototype.toRed = function(u) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), u.convertTo(this)._forceRed(u);
    }, i.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, i.prototype._forceRed = function(u) {
      return this.red = u, this;
    }, i.prototype.forceRed = function(u) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(u);
    }, i.prototype.redAdd = function(u) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, u);
    }, i.prototype.redIAdd = function(u) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, u);
    }, i.prototype.redSub = function(u) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, u);
    }, i.prototype.redISub = function(u) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, u);
    }, i.prototype.redShl = function(u) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, u);
    }, i.prototype.redMul = function(u) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, u), this.red.mul(this, u);
    }, i.prototype.redIMul = function(u) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, u), this.red.imul(this, u);
    }, i.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, i.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, i.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, i.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, i.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, i.prototype.redPow = function(u) {
      return n(this.red && !u.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, u);
    };
    var R = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function L(o, u) {
      this.name = o, this.p = new i(u, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    L.prototype._tmp = function() {
      var u = new i(null);
      return u.words = new Array(Math.ceil(this.n / 13)), u;
    }, L.prototype.ireduce = function(u) {
      var h = u, y;
      do
        this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), y = h.bitLength();
      while (y > this.n);
      var E = y < this.n ? -1 : h.ucmp(this.p);
      return E === 0 ? (h.words[0] = 0, h.length = 1) : E > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
    }, L.prototype.split = function(u, h) {
      u.iushrn(this.n, 0, h);
    }, L.prototype.imulK = function(u) {
      return u.imul(this.k);
    };
    function K() {
      L.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(K, L), K.prototype.split = function(u, h) {
      for (var y = 4194303, E = Math.min(u.length, 9), P = 0; P < E; P++)
        h.words[P] = u.words[P];
      if (h.length = E, u.length <= 9) {
        u.words[0] = 0, u.length = 1;
        return;
      }
      var w = u.words[9];
      for (h.words[h.length++] = w & y, P = 10; P < u.length; P++) {
        var m = u.words[P] | 0;
        u.words[P - 10] = (m & y) << 4 | w >>> 22, w = m;
      }
      w >>>= 22, u.words[P - 10] = w, w === 0 && u.length > 10 ? u.length -= 10 : u.length -= 9;
    }, K.prototype.imulK = function(u) {
      u.words[u.length] = 0, u.words[u.length + 1] = 0, u.length += 2;
      for (var h = 0, y = 0; y < u.length; y++) {
        var E = u.words[y] | 0;
        h += E * 977, u.words[y] = h & 67108863, h = E * 64 + (h / 67108864 | 0);
      }
      return u.words[u.length - 1] === 0 && (u.length--, u.words[u.length - 1] === 0 && u.length--), u;
    };
    function $() {
      L.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s($, L);
    function k() {
      L.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(k, L);
    function V() {
      L.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(V, L), V.prototype.imulK = function(u) {
      for (var h = 0, y = 0; y < u.length; y++) {
        var E = (u.words[y] | 0) * 19 + h, P = E & 67108863;
        E >>>= 26, u.words[y] = P, h = E;
      }
      return h !== 0 && (u.words[u.length++] = h), u;
    }, i._prime = function(u) {
      if (R[u]) return R[u];
      var h;
      if (u === "k256")
        h = new K();
      else if (u === "p224")
        h = new $();
      else if (u === "p192")
        h = new k();
      else if (u === "p25519")
        h = new V();
      else
        throw new Error("Unknown prime " + u);
      return R[u] = h, h;
    };
    function C(o) {
      if (typeof o == "string") {
        var u = i._prime(o);
        this.m = u.p, this.prime = u;
      } else
        n(o.gtn(1), "modulus must be greater than 1"), this.m = o, this.prime = null;
    }
    C.prototype._verify1 = function(u) {
      n(u.negative === 0, "red works only with positives"), n(u.red, "red works only with red numbers");
    }, C.prototype._verify2 = function(u, h) {
      n((u.negative | h.negative) === 0, "red works only with positives"), n(
        u.red && u.red === h.red,
        "red works only with red numbers"
      );
    }, C.prototype.imod = function(u) {
      return this.prime ? this.prime.ireduce(u)._forceRed(this) : (p(u, u.umod(this.m)._forceRed(this)), u);
    }, C.prototype.neg = function(u) {
      return u.isZero() ? u.clone() : this.m.sub(u)._forceRed(this);
    }, C.prototype.add = function(u, h) {
      this._verify2(u, h);
      var y = u.add(h);
      return y.cmp(this.m) >= 0 && y.isub(this.m), y._forceRed(this);
    }, C.prototype.iadd = function(u, h) {
      this._verify2(u, h);
      var y = u.iadd(h);
      return y.cmp(this.m) >= 0 && y.isub(this.m), y;
    }, C.prototype.sub = function(u, h) {
      this._verify2(u, h);
      var y = u.sub(h);
      return y.cmpn(0) < 0 && y.iadd(this.m), y._forceRed(this);
    }, C.prototype.isub = function(u, h) {
      this._verify2(u, h);
      var y = u.isub(h);
      return y.cmpn(0) < 0 && y.iadd(this.m), y;
    }, C.prototype.shl = function(u, h) {
      return this._verify1(u), this.imod(u.ushln(h));
    }, C.prototype.imul = function(u, h) {
      return this._verify2(u, h), this.imod(u.imul(h));
    }, C.prototype.mul = function(u, h) {
      return this._verify2(u, h), this.imod(u.mul(h));
    }, C.prototype.isqr = function(u) {
      return this.imul(u, u.clone());
    }, C.prototype.sqr = function(u) {
      return this.mul(u, u);
    }, C.prototype.sqrt = function(u) {
      if (u.isZero()) return u.clone();
      var h = this.m.andln(3);
      if (n(h % 2 === 1), h === 3) {
        var y = this.m.add(new i(1)).iushrn(2);
        return this.pow(u, y);
      }
      for (var E = this.m.subn(1), P = 0; !E.isZero() && E.andln(1) === 0; )
        P++, E.iushrn(1);
      n(!E.isZero());
      var w = new i(1).toRed(this), m = w.redNeg(), l = this.m.subn(1).iushrn(1), b = this.m.bitLength();
      for (b = new i(2 * b * b).toRed(this); this.pow(b, l).cmp(m) !== 0; )
        b.redIAdd(m);
      for (var W = this.pow(b, E), X = this.pow(u, E.addn(1).iushrn(1)), G = this.pow(u, E), re = P; G.cmp(w) !== 0; ) {
        for (var ce = G, pe = 0; ce.cmp(w) !== 0; pe++)
          ce = ce.redSqr();
        n(pe < re);
        var ve = this.pow(W, new i(1).iushln(re - pe - 1));
        X = X.redMul(ve), W = ve.redSqr(), G = G.redMul(W), re = pe;
      }
      return X;
    }, C.prototype.invm = function(u) {
      var h = u._invmp(this.m);
      return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
    }, C.prototype.pow = function(u, h) {
      if (h.isZero()) return new i(1).toRed(this);
      if (h.cmpn(1) === 0) return u.clone();
      var y = 4, E = new Array(1 << y);
      E[0] = new i(1).toRed(this), E[1] = u;
      for (var P = 2; P < E.length; P++)
        E[P] = this.mul(E[P - 1], u);
      var w = E[0], m = 0, l = 0, b = h.bitLength() % 26;
      for (b === 0 && (b = 26), P = h.length - 1; P >= 0; P--) {
        for (var W = h.words[P], X = b - 1; X >= 0; X--) {
          var G = W >> X & 1;
          if (w !== E[0] && (w = this.sqr(w)), G === 0 && m === 0) {
            l = 0;
            continue;
          }
          m <<= 1, m |= G, l++, !(l !== y && (P !== 0 || X !== 0)) && (w = this.mul(w, E[m]), l = 0, m = 0);
        }
        b = 26;
      }
      return w;
    }, C.prototype.convertTo = function(u) {
      var h = u.umod(this.m);
      return h === u ? h.clone() : h;
    }, C.prototype.convertFrom = function(u) {
      var h = u.clone();
      return h.red = null, h;
    }, i.mont = function(u) {
      return new D(u);
    };
    function D(o) {
      C.call(this, o), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(D, C), D.prototype.convertTo = function(u) {
      return this.imod(u.ushln(this.shift));
    }, D.prototype.convertFrom = function(u) {
      var h = this.imod(u.mul(this.rinv));
      return h.red = null, h;
    }, D.prototype.imul = function(u, h) {
      if (u.isZero() || h.isZero())
        return u.words[0] = 0, u.length = 1, u;
      var y = u.imul(h), E = y.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), P = y.isub(E).iushrn(this.shift), w = P;
      return P.cmp(this.m) >= 0 ? w = P.isub(this.m) : P.cmpn(0) < 0 && (w = P.iadd(this.m)), w._forceRed(this);
    }, D.prototype.mul = function(u, h) {
      if (u.isZero() || h.isZero()) return new i(0)._forceRed(this);
      var y = u.mul(h), E = y.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), P = y.isub(E).iushrn(this.shift), w = P;
      return P.cmp(this.m) >= 0 ? w = P.isub(this.m) : P.cmpn(0) < 0 && (w = P.iadd(this.m)), w._forceRed(this);
    }, D.prototype.invm = function(u) {
      var h = this.imod(u._invmp(this.m).mul(this.r2));
      return h._forceRed(this);
    };
  })(e, $7);
})(Yp);
var e9 = Yp.exports;
const t9 = /* @__PURE__ */ K7(e9), r9 = "logger/5.7.0";
let dg = !1, hg = !1;
const Hd = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let fg = Hd.default, Ef = null;
function n9() {
  try {
    const e = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((t) => {
      try {
        if ("test".normalize(t) !== "test")
          throw new Error("bad normalize");
      } catch {
        e.push(t);
      }
    }), e.length)
      throw new Error("missing " + e.join(", "));
    if ("é".normalize("NFD") !== "é")
      throw new Error("broken implementation");
  } catch (e) {
    return e.message;
  }
  return null;
}
const pg = n9();
var Zf;
(function(e) {
  e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})(Zf || (Zf = {}));
var Fi;
(function(e) {
  e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})(Fi || (Fi = {}));
const gg = "0123456789abcdef";
class dr {
  constructor(t) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }
  _log(t, r) {
    const n = t.toLowerCase();
    Hd[n] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !(fg > Hd[n]) && console.log.apply(console, r);
  }
  debug(...t) {
    this._log(dr.levels.DEBUG, t);
  }
  info(...t) {
    this._log(dr.levels.INFO, t);
  }
  warn(...t) {
    this._log(dr.levels.WARNING, t);
  }
  makeError(t, r, n) {
    if (hg)
      return this.makeError("censored error", r, {});
    r || (r = dr.errors.UNKNOWN_ERROR), n || (n = {});
    const s = [];
    Object.keys(n).forEach((d) => {
      const c = n[d];
      try {
        if (c instanceof Uint8Array) {
          let p = "";
          for (let g = 0; g < c.length; g++)
            p += gg[c[g] >> 4], p += gg[c[g] & 15];
          s.push(d + "=Uint8Array(0x" + p + ")");
        } else
          s.push(d + "=" + JSON.stringify(c));
      } catch {
        s.push(d + "=" + JSON.stringify(n[d].toString()));
      }
    }), s.push(`code=${r}`), s.push(`version=${this.version}`);
    const i = t;
    let a = "";
    switch (r) {
      case Fi.NUMERIC_FAULT: {
        a = "NUMERIC_FAULT";
        const d = t;
        switch (d) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            a += "-" + d;
            break;
          case "negative-power":
          case "negative-width":
            a += "-unsupported";
            break;
          case "unbound-bitwise-result":
            a += "-unbound-result";
            break;
        }
        break;
      }
      case Fi.CALL_EXCEPTION:
      case Fi.INSUFFICIENT_FUNDS:
      case Fi.MISSING_NEW:
      case Fi.NONCE_EXPIRED:
      case Fi.REPLACEMENT_UNDERPRICED:
      case Fi.TRANSACTION_REPLACED:
      case Fi.UNPREDICTABLE_GAS_LIMIT:
        a = r;
        break;
    }
    a && (t += " [ See: https://links.ethers.org/v5-errors-" + a + " ]"), s.length && (t += " (" + s.join(", ") + ")");
    const f = new Error(t);
    return f.reason = i, f.code = r, Object.keys(n).forEach(function(d) {
      f[d] = n[d];
    }), f;
  }
  throwError(t, r, n) {
    throw this.makeError(t, r, n);
  }
  throwArgumentError(t, r, n) {
    return this.throwError(t, dr.errors.INVALID_ARGUMENT, {
      argument: r,
      value: n
    });
  }
  assert(t, r, n, s) {
    t || this.throwError(r, n, s);
  }
  assertArgument(t, r, n, s) {
    t || this.throwArgumentError(r, n, s);
  }
  checkNormalize(t) {
    pg && this.throwError("platform missing String.prototype.normalize", dr.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: pg
    });
  }
  checkSafeUint53(t, r) {
    typeof t == "number" && (r == null && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, dr.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: t
    }), t % 1 && this.throwError(r, dr.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: t
    }));
  }
  checkArgumentCount(t, r, n) {
    n ? n = ": " + n : n = "", t < r && this.throwError("missing argument" + n, dr.errors.MISSING_ARGUMENT, {
      count: t,
      expectedCount: r
    }), t > r && this.throwError("too many arguments" + n, dr.errors.UNEXPECTED_ARGUMENT, {
      count: t,
      expectedCount: r
    });
  }
  checkNew(t, r) {
    (t === Object || t == null) && this.throwError("missing new", dr.errors.MISSING_NEW, { name: r.name });
  }
  checkAbstract(t, r) {
    t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", dr.errors.UNSUPPORTED_OPERATION, { name: t.name, operation: "new" }) : (t === Object || t == null) && this.throwError("missing new", dr.errors.MISSING_NEW, { name: r.name });
  }
  static globalLogger() {
    return Ef || (Ef = new dr(r9)), Ef;
  }
  static setCensorship(t, r) {
    if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", dr.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), dg) {
      if (!t)
        return;
      this.globalLogger().throwError("error censorship permanent", dr.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    hg = !!t, dg = !!r;
  }
  static setLogLevel(t) {
    const r = Hd[t.toLowerCase()];
    if (r == null) {
      dr.globalLogger().warn("invalid log level - " + t);
      return;
    }
    fg = r;
  }
  static from(t) {
    return new dr(t);
  }
}
dr.errors = Fi;
dr.levels = Zf;
const i9 = "bytes/5.7.0", Po = new dr(i9);
function h4(e) {
  return !!e.toHexString;
}
function Wd(e) {
  return e.slice || (e.slice = function() {
    const t = Array.prototype.slice.call(arguments);
    return Wd(new Uint8Array(Array.prototype.slice.apply(e, t)));
  }), e;
}
function mg(e) {
  return typeof e == "number" && e == e && e % 1 === 0;
}
function ad(e) {
  if (e == null)
    return !1;
  if (e.constructor === Uint8Array)
    return !0;
  if (typeof e == "string" || !mg(e.length) || e.length < 0)
    return !1;
  for (let t = 0; t < e.length; t++) {
    const r = e[t];
    if (!mg(r) || r < 0 || r >= 256)
      return !1;
  }
  return !0;
}
function s9(e, t) {
  if (t || (t = {}), typeof e == "number") {
    Po.checkSafeUint53(e, "invalid arrayify value");
    const r = [];
    for (; e; )
      r.unshift(e & 255), e = parseInt(String(e / 256));
    return r.length === 0 && r.push(0), Wd(new Uint8Array(r));
  }
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), h4(e) && (e = e.toHexString()), Du(e)) {
    let r = e.substring(2);
    r.length % 2 && (t.hexPad === "left" ? r = "0" + r : t.hexPad === "right" ? r += "0" : Po.throwArgumentError("hex data is odd-length", "value", e));
    const n = [];
    for (let s = 0; s < r.length; s += 2)
      n.push(parseInt(r.substring(s, s + 2), 16));
    return Wd(new Uint8Array(n));
  }
  return ad(e) ? Wd(new Uint8Array(e)) : Po.throwArgumentError("invalid arrayify value", "value", e);
}
function Du(e, t) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/));
}
const Pf = "0123456789abcdef";
function f4(e, t) {
  if (t || (t = {}), typeof e == "number") {
    Po.checkSafeUint53(e, "invalid hexlify value");
    let r = "";
    for (; e; )
      r = Pf[e & 15] + r, e = Math.floor(e / 16);
    return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
  }
  if (typeof e == "bigint")
    return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), h4(e))
    return e.toHexString();
  if (Du(e))
    return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : Po.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
  if (ad(e)) {
    let r = "0x";
    for (let n = 0; n < e.length; n++) {
      let s = e[n];
      r += Pf[(s & 240) >> 4] + Pf[s & 15];
    }
    return r;
  }
  return Po.throwArgumentError("invalid hexlify value", "value", e);
}
function yg(e, t) {
  for (typeof e != "string" ? e = f4(e) : Du(e) || Po.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && Po.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2; )
    e = "0x0" + e.substring(2);
  return e;
}
const p4 = "bignumber/5.7.0";
var Yf = t9.BN;
const Fs = new dr(p4), Of = {}, bg = 9007199254740991;
function o9(e) {
  return e != null && (Dr.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || Du(e) || typeof e == "bigint" || ad(e));
}
let wg = !1;
class Dr {
  constructor(t, r) {
    t !== Of && Fs.throwError("cannot call constructor directly; use BigNumber.from", dr.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(t) {
    return kn(sr(this).fromTwos(t));
  }
  toTwos(t) {
    return kn(sr(this).toTwos(t));
  }
  abs() {
    return this._hex[0] === "-" ? Dr.from(this._hex.substring(1)) : this;
  }
  add(t) {
    return kn(sr(this).add(sr(t)));
  }
  sub(t) {
    return kn(sr(this).sub(sr(t)));
  }
  div(t) {
    return Dr.from(t).isZero() && ri("division-by-zero", "div"), kn(sr(this).div(sr(t)));
  }
  mul(t) {
    return kn(sr(this).mul(sr(t)));
  }
  mod(t) {
    const r = sr(t);
    return r.isNeg() && ri("division-by-zero", "mod"), kn(sr(this).umod(r));
  }
  pow(t) {
    const r = sr(t);
    return r.isNeg() && ri("negative-power", "pow"), kn(sr(this).pow(r));
  }
  and(t) {
    const r = sr(t);
    return (this.isNegative() || r.isNeg()) && ri("unbound-bitwise-result", "and"), kn(sr(this).and(r));
  }
  or(t) {
    const r = sr(t);
    return (this.isNegative() || r.isNeg()) && ri("unbound-bitwise-result", "or"), kn(sr(this).or(r));
  }
  xor(t) {
    const r = sr(t);
    return (this.isNegative() || r.isNeg()) && ri("unbound-bitwise-result", "xor"), kn(sr(this).xor(r));
  }
  mask(t) {
    return (this.isNegative() || t < 0) && ri("negative-width", "mask"), kn(sr(this).maskn(t));
  }
  shl(t) {
    return (this.isNegative() || t < 0) && ri("negative-width", "shl"), kn(sr(this).shln(t));
  }
  shr(t) {
    return (this.isNegative() || t < 0) && ri("negative-width", "shr"), kn(sr(this).shrn(t));
  }
  eq(t) {
    return sr(this).eq(sr(t));
  }
  lt(t) {
    return sr(this).lt(sr(t));
  }
  lte(t) {
    return sr(this).lte(sr(t));
  }
  gt(t) {
    return sr(this).gt(sr(t));
  }
  gte(t) {
    return sr(this).gte(sr(t));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return sr(this).isZero();
  }
  toNumber() {
    try {
      return sr(this).toNumber();
    } catch {
      ri("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return Fs.throwError("this platform does not support BigInt", dr.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? wg || (wg = !0, Fs.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? Fs.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", dr.errors.UNEXPECTED_ARGUMENT, {}) : Fs.throwError("BigNumber.toString does not accept parameters", dr.errors.UNEXPECTED_ARGUMENT, {})), sr(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(t) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(t) {
    if (t instanceof Dr)
      return t;
    if (typeof t == "string")
      return t.match(/^-?0x[0-9a-f]+$/i) ? new Dr(Of, H0(t)) : t.match(/^-?[0-9]+$/) ? new Dr(Of, H0(new Yf(t))) : Fs.throwArgumentError("invalid BigNumber string", "value", t);
    if (typeof t == "number")
      return t % 1 && ri("underflow", "BigNumber.from", t), (t >= bg || t <= -bg) && ri("overflow", "BigNumber.from", t), Dr.from(String(t));
    const r = t;
    if (typeof r == "bigint")
      return Dr.from(r.toString());
    if (ad(r))
      return Dr.from(f4(r));
    if (r)
      if (r.toHexString) {
        const n = r.toHexString();
        if (typeof n == "string")
          return Dr.from(n);
      } else {
        let n = r._hex;
        if (n == null && r.type === "BigNumber" && (n = r.hex), typeof n == "string" && (Du(n) || n[0] === "-" && Du(n.substring(1))))
          return Dr.from(n);
      }
    return Fs.throwArgumentError("invalid BigNumber value", "value", t);
  }
  static isBigNumber(t) {
    return !!(t && t._isBigNumber);
  }
}
function H0(e) {
  if (typeof e != "string")
    return H0(e.toString(16));
  if (e[0] === "-")
    return e = e.substring(1), e[0] === "-" && Fs.throwArgumentError("invalid hex", "value", e), e = H0(e), e === "0x00" ? e : "-" + e;
  if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x")
    return "0x00";
  for (e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00"; )
    e = "0x" + e.substring(4);
  return e;
}
function kn(e) {
  return Dr.from(H0(e));
}
function sr(e) {
  const t = Dr.from(e).toHexString();
  return t[0] === "-" ? new Yf("-" + t.substring(3), 16) : new Yf(t.substring(2), 16);
}
function ri(e, t, r) {
  const n = { fault: e, operation: t };
  return r != null && (n.value = r), Fs.throwError(e, dr.errors.NUMERIC_FAULT, n);
}
const En = new dr(p4), M0 = {}, g4 = Dr.from(0), m4 = Dr.from(-1);
function y4(e, t, r, n) {
  const s = { fault: t, operation: r };
  return n !== void 0 && (s.value = n), En.throwError(e, dr.errors.NUMERIC_FAULT, s);
}
let I0 = "0";
for (; I0.length < 256; )
  I0 += I0;
function Xp(e) {
  if (typeof e != "number")
    try {
      e = Dr.from(e).toNumber();
    } catch {
    }
  return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + I0.substring(0, e) : En.throwArgumentError("invalid decimal size", "decimals", e);
}
function Gd(e, t) {
  t == null && (t = 0);
  const r = Xp(t);
  e = Dr.from(e);
  const n = e.lt(g4);
  n && (e = e.mul(m4));
  let s = e.mod(r).toString();
  for (; s.length < r.length - 1; )
    s = "0" + s;
  s = s.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const i = e.div(r).toString();
  return r.length === 1 ? e = i : e = i + "." + s, n && (e = "-" + e), e;
}
function Ps(e, t) {
  t == null && (t = 0);
  const r = Xp(t);
  (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && En.throwArgumentError("invalid decimal value", "value", e);
  const n = e.substring(0, 1) === "-";
  n && (e = e.substring(1)), e === "." && En.throwArgumentError("missing value", "value", e);
  const s = e.split(".");
  s.length > 2 && En.throwArgumentError("too many decimal points", "value", e);
  let i = s[0], a = s[1];
  for (i || (i = "0"), a || (a = "0"); a[a.length - 1] === "0"; )
    a = a.substring(0, a.length - 1);
  for (a.length > r.length - 1 && y4("fractional component exceeds decimals", "underflow", "parseFixed"), a === "" && (a = "0"); a.length < r.length - 1; )
    a += "0";
  const f = Dr.from(i), d = Dr.from(a);
  let c = f.mul(r).add(d);
  return n && (c = c.mul(m4)), c;
}
class Tu {
  constructor(t, r, n, s) {
    t !== M0 && En.throwError("cannot use FixedFormat constructor; use FixedFormat.from", dr.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = r, this.width = n, this.decimals = s, this.name = (r ? "" : "u") + "fixed" + String(n) + "x" + String(s), this._multiplier = Xp(s), Object.freeze(this);
  }
  static from(t) {
    if (t instanceof Tu)
      return t;
    typeof t == "number" && (t = `fixed128x${t}`);
    let r = !0, n = 128, s = 18;
    if (typeof t == "string") {
      if (t !== "fixed") if (t === "ufixed")
        r = !1;
      else {
        const i = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
        i || En.throwArgumentError("invalid fixed format", "format", t), r = i[1] !== "u", n = parseInt(i[2]), s = parseInt(i[3]);
      }
    } else if (t) {
      const i = (a, f, d) => t[a] == null ? d : (typeof t[a] !== f && En.throwArgumentError("invalid fixed format (" + a + " not " + f + ")", "format." + a, t[a]), t[a]);
      r = i("signed", "boolean", r), n = i("width", "number", n), s = i("decimals", "number", s);
    }
    return n % 8 && En.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", n), s > 80 && En.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", s), new Tu(M0, r, n, s);
  }
}
class rn {
  constructor(t, r, n, s) {
    t !== M0 && En.throwError("cannot use FixedNumber constructor; use FixedNumber.from", dr.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = s, this._hex = r, this._value = n, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(t) {
    this.format.name !== t.format.name && En.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
  }
  addUnsafe(t) {
    this._checkFormat(t);
    const r = Ps(this._value, this.format.decimals), n = Ps(t._value, t.format.decimals);
    return rn.fromValue(r.add(n), this.format.decimals, this.format);
  }
  subUnsafe(t) {
    this._checkFormat(t);
    const r = Ps(this._value, this.format.decimals), n = Ps(t._value, t.format.decimals);
    return rn.fromValue(r.sub(n), this.format.decimals, this.format);
  }
  mulUnsafe(t) {
    this._checkFormat(t);
    const r = Ps(this._value, this.format.decimals), n = Ps(t._value, t.format.decimals);
    return rn.fromValue(r.mul(n).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(t) {
    this._checkFormat(t);
    const r = Ps(this._value, this.format.decimals), n = Ps(t._value, t.format.decimals);
    return rn.fromValue(r.mul(this.format._multiplier).div(n), this.format.decimals, this.format);
  }
  floor() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let r = rn.from(t[0], this.format);
    const n = !t[1].match(/^(0*)$/);
    return this.isNegative() && n && (r = r.subUnsafe(vg.toFormat(r.format))), r;
  }
  ceiling() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let r = rn.from(t[0], this.format);
    const n = !t[1].match(/^(0*)$/);
    return !this.isNegative() && n && (r = r.addUnsafe(vg.toFormat(r.format))), r;
  }
  // @TODO: Support other rounding algorithms
  round(t) {
    t == null && (t = 0);
    const r = this.toString().split(".");
    if (r.length === 1 && r.push("0"), (t < 0 || t > 80 || t % 1) && En.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t)
      return this;
    const n = rn.from("1" + I0.substring(0, t), this.format), s = a9.toFormat(this.format);
    return this.mulUnsafe(n).addUnsafe(s).floor().divUnsafe(n);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(t) {
    if (t == null)
      return this._hex;
    t % 8 && En.throwArgumentError("invalid byte width", "width", t);
    const r = Dr.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
    return yg(r, t / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(t) {
    return rn.fromString(this._value, t);
  }
  static fromValue(t, r, n) {
    return n == null && r != null && !o9(r) && (n = r, r = null), r == null && (r = 0), n == null && (n = "fixed"), rn.fromString(Gd(t, r), Tu.from(n));
  }
  static fromString(t, r) {
    r == null && (r = "fixed");
    const n = Tu.from(r), s = Ps(t, n.decimals);
    !n.signed && s.lt(g4) && y4("unsigned value cannot be negative", "overflow", "value", t);
    let i = null;
    n.signed ? i = s.toTwos(n.width).toHexString() : (i = s.toHexString(), i = yg(i, n.width / 8));
    const a = Gd(s, n.decimals);
    return new rn(M0, i, a, n);
  }
  static fromBytes(t, r) {
    r == null && (r = "fixed");
    const n = Tu.from(r);
    if (s9(t).length > n.width / 8)
      throw new Error("overflow");
    let s = Dr.from(t);
    n.signed && (s = s.fromTwos(n.width));
    const i = s.toTwos((n.signed ? 0 : 1) + n.width).toHexString(), a = Gd(s, n.decimals);
    return new rn(M0, i, a, n);
  }
  static from(t, r) {
    if (typeof t == "string")
      return rn.fromString(t, r);
    if (ad(t))
      return rn.fromBytes(t, r);
    try {
      return rn.fromValue(t, 0, r);
    } catch (n) {
      if (n.code !== dr.errors.INVALID_ARGUMENT)
        throw n;
    }
    return En.throwArgumentError("invalid FixedNumber value", "value", t);
  }
  static isFixedNumber(t) {
    return !!(t && t._isFixedNumber);
  }
}
const vg = rn.from(1), a9 = rn.from("0.5"), u9 = "units/5.7.0", c9 = new dr(u9), l9 = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function d9(e) {
  const t = String(e).split(".");
  (t.length > 2 || !t[0].match(/^-?[0-9]*$/) || t[1] && !t[1].match(/^[0-9]*$/) || e === "." || e === "-.") && c9.throwArgumentError("invalid value", "value", e);
  let r = t[0], n = "";
  for (r.substring(0, 1) === "-" && (n = "-", r = r.substring(1)); r.substring(0, 1) === "0"; )
    r = r.substring(1);
  r === "" && (r = "0");
  let s = "";
  for (t.length === 2 && (s = "." + (t[1] || "0")); s.length > 2 && s[s.length - 1] === "0"; )
    s = s.substring(0, s.length - 1);
  const i = [];
  for (; r.length; )
    if (r.length <= 3) {
      i.unshift(r);
      break;
    } else {
      const a = r.length - 3;
      i.unshift(r.substring(a)), r = r.substring(0, a);
    }
  return n + i.join(",") + s;
}
function Ag(e, t) {
  if (typeof t == "string") {
    const r = l9.indexOf(t);
    r !== -1 && (t = 3 * r);
  }
  return Gd(e, t ?? 18);
}
/*!
 *  decimal.js v10.4.3
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var Pu = 9e15, Io = 1e9, Xf = "0123456789abcdef", ah = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", uh = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", ep = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -Pu,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: Pu,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, b4, Gs, qt = !0, Ih = "[DecimalError] ", To = Ih + "Invalid argument: ", w4 = Ih + "Precision limit exceeded", v4 = Ih + "crypto unavailable", A4 = "[object Decimal]", mn = Math.floor, Qr = Math.pow, h9 = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, f9 = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, p9 = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, E4 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Gi = 1e7, jt = 7, g9 = 9007199254740991, m9 = ah.length - 1, tp = uh.length - 1, Je = { toStringTag: A4 };
Je.absoluteValue = Je.abs = function() {
  var e = new this.constructor(this);
  return e.s < 0 && (e.s = 1), _t(e);
};
Je.ceil = function() {
  return _t(new this.constructor(this), this.e + 1, 2);
};
Je.clampedTo = Je.clamp = function(e, t) {
  var r, n = this, s = n.constructor;
  if (e = new s(e), t = new s(t), !e.s || !t.s) return new s(NaN);
  if (e.gt(t)) throw Error(To + t);
  return r = n.cmp(e), r < 0 ? e : n.cmp(t) > 0 ? t : new s(n);
};
Je.comparedTo = Je.cmp = function(e) {
  var t, r, n, s, i = this, a = i.d, f = (e = new i.constructor(e)).d, d = i.s, c = e.s;
  if (!a || !f)
    return !d || !c ? NaN : d !== c ? d : a === f ? 0 : !a ^ d < 0 ? 1 : -1;
  if (!a[0] || !f[0]) return a[0] ? d : f[0] ? -c : 0;
  if (d !== c) return d;
  if (i.e !== e.e) return i.e > e.e ^ d < 0 ? 1 : -1;
  for (n = a.length, s = f.length, t = 0, r = n < s ? n : s; t < r; ++t)
    if (a[t] !== f[t]) return a[t] > f[t] ^ d < 0 ? 1 : -1;
  return n === s ? 0 : n > s ^ d < 0 ? 1 : -1;
};
Je.cosine = Je.cos = function() {
  var e, t, r = this, n = r.constructor;
  return r.d ? r.d[0] ? (e = n.precision, t = n.rounding, n.precision = e + Math.max(r.e, r.sd()) + jt, n.rounding = 1, r = y9(n, T4(n, r)), n.precision = e, n.rounding = t, _t(Gs == 2 || Gs == 3 ? r.neg() : r, e, t, !0)) : new n(1) : new n(NaN);
};
Je.cubeRoot = Je.cbrt = function() {
  var e, t, r, n, s, i, a, f, d, c, p = this, g = p.constructor;
  if (!p.isFinite() || p.isZero()) return new g(p);
  for (qt = !1, i = p.s * Qr(p.s * p, 1 / 3), !i || Math.abs(i) == 1 / 0 ? (r = an(p.d), e = p.e, (i = (e - r.length + 1) % 3) && (r += i == 1 || i == -2 ? "0" : "00"), i = Qr(r, 1 / 3), e = mn((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2)), i == 1 / 0 ? r = "5e" + e : (r = i.toExponential(), r = r.slice(0, r.indexOf("e") + 1) + e), n = new g(r), n.s = p.s) : n = new g(i.toString()), a = (e = g.precision) + 3; ; )
    if (f = n, d = f.times(f).times(f), c = d.plus(p), n = xr(c.plus(p).times(f), c.plus(d), a + 2, 1), an(f.d).slice(0, a) === (r = an(n.d)).slice(0, a))
      if (r = r.slice(a - 3, a + 1), r == "9999" || !s && r == "4999") {
        if (!s && (_t(f, e + 1, 0), f.times(f).times(f).eq(p))) {
          n = f;
          break;
        }
        a += 4, s = 1;
      } else {
        (!+r || !+r.slice(1) && r.charAt(0) == "5") && (_t(n, e + 1, 1), t = !n.times(n).times(n).eq(p));
        break;
      }
  return qt = !0, _t(n, e, g.rounding, t);
};
Je.decimalPlaces = Je.dp = function() {
  var e, t = this.d, r = NaN;
  if (t) {
    if (e = t.length - 1, r = (e - mn(this.e / jt)) * jt, e = t[e], e) for (; e % 10 == 0; e /= 10) r--;
    r < 0 && (r = 0);
  }
  return r;
};
Je.dividedBy = Je.div = function(e) {
  return xr(this, new this.constructor(e));
};
Je.dividedToIntegerBy = Je.divToInt = function(e) {
  var t = this, r = t.constructor;
  return _t(xr(t, new r(e), 0, 1, 1), r.precision, r.rounding);
};
Je.equals = Je.eq = function(e) {
  return this.cmp(e) === 0;
};
Je.floor = function() {
  return _t(new this.constructor(this), this.e + 1, 3);
};
Je.greaterThan = Je.gt = function(e) {
  return this.cmp(e) > 0;
};
Je.greaterThanOrEqualTo = Je.gte = function(e) {
  var t = this.cmp(e);
  return t == 1 || t === 0;
};
Je.hyperbolicCosine = Je.cosh = function() {
  var e, t, r, n, s, i = this, a = i.constructor, f = new a(1);
  if (!i.isFinite()) return new a(i.s ? 1 / 0 : NaN);
  if (i.isZero()) return f;
  r = a.precision, n = a.rounding, a.precision = r + Math.max(i.e, i.sd()) + 4, a.rounding = 1, s = i.d.length, s < 32 ? (e = Math.ceil(s / 3), t = (1 / Ch(4, e)).toString()) : (e = 16, t = "2.3283064365386962890625e-10"), i = ju(a, 1, i.times(t), new a(1), !0);
  for (var d, c = e, p = new a(8); c--; )
    d = i.times(i), i = f.minus(d.times(p.minus(d.times(p))));
  return _t(i, a.precision = r, a.rounding = n, !0);
};
Je.hyperbolicSine = Je.sinh = function() {
  var e, t, r, n, s = this, i = s.constructor;
  if (!s.isFinite() || s.isZero()) return new i(s);
  if (t = i.precision, r = i.rounding, i.precision = t + Math.max(s.e, s.sd()) + 4, i.rounding = 1, n = s.d.length, n < 3)
    s = ju(i, 2, s, s, !0);
  else {
    e = 1.4 * Math.sqrt(n), e = e > 16 ? 16 : e | 0, s = s.times(1 / Ch(5, e)), s = ju(i, 2, s, s, !0);
    for (var a, f = new i(5), d = new i(16), c = new i(20); e--; )
      a = s.times(s), s = s.times(f.plus(a.times(d.times(a).plus(c))));
  }
  return i.precision = t, i.rounding = r, _t(s, t, r, !0);
};
Je.hyperbolicTangent = Je.tanh = function() {
  var e, t, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e = n.precision, t = n.rounding, n.precision = e + 7, n.rounding = 1, xr(r.sinh(), r.cosh(), n.precision = e, n.rounding = t)) : new n(r.s);
};
Je.inverseCosine = Je.acos = function() {
  var e, t = this, r = t.constructor, n = t.abs().cmp(1), s = r.precision, i = r.rounding;
  return n !== -1 ? n === 0 ? t.isNeg() ? Wi(r, s, i) : new r(0) : new r(NaN) : t.isZero() ? Wi(r, s + 4, i).times(0.5) : (r.precision = s + 6, r.rounding = 1, t = t.asin(), e = Wi(r, s + 4, i).times(0.5), r.precision = s, r.rounding = i, e.minus(t));
};
Je.inverseHyperbolicCosine = Je.acosh = function() {
  var e, t, r = this, n = r.constructor;
  return r.lte(1) ? new n(r.eq(1) ? 0 : NaN) : r.isFinite() ? (e = n.precision, t = n.rounding, n.precision = e + Math.max(Math.abs(r.e), r.sd()) + 4, n.rounding = 1, qt = !1, r = r.times(r).minus(1).sqrt().plus(r), qt = !0, n.precision = e, n.rounding = t, r.ln()) : new n(r);
};
Je.inverseHyperbolicSine = Je.asinh = function() {
  var e, t, r = this, n = r.constructor;
  return !r.isFinite() || r.isZero() ? new n(r) : (e = n.precision, t = n.rounding, n.precision = e + 2 * Math.max(Math.abs(r.e), r.sd()) + 6, n.rounding = 1, qt = !1, r = r.times(r).plus(1).sqrt().plus(r), qt = !0, n.precision = e, n.rounding = t, r.ln());
};
Je.inverseHyperbolicTangent = Je.atanh = function() {
  var e, t, r, n, s = this, i = s.constructor;
  return s.isFinite() ? s.e >= 0 ? new i(s.abs().eq(1) ? s.s / 0 : s.isZero() ? s : NaN) : (e = i.precision, t = i.rounding, n = s.sd(), Math.max(n, e) < 2 * -s.e - 1 ? _t(new i(s), e, t, !0) : (i.precision = r = n - s.e, s = xr(s.plus(1), new i(1).minus(s), r + e, 1), i.precision = e + 4, i.rounding = 1, s = s.ln(), i.precision = e, i.rounding = t, s.times(0.5))) : new i(NaN);
};
Je.inverseSine = Je.asin = function() {
  var e, t, r, n, s = this, i = s.constructor;
  return s.isZero() ? new i(s) : (t = s.abs().cmp(1), r = i.precision, n = i.rounding, t !== -1 ? t === 0 ? (e = Wi(i, r + 4, n).times(0.5), e.s = s.s, e) : new i(NaN) : (i.precision = r + 6, i.rounding = 1, s = s.div(new i(1).minus(s.times(s)).sqrt().plus(1)).atan(), i.precision = r, i.rounding = n, s.times(2)));
};
Je.inverseTangent = Je.atan = function() {
  var e, t, r, n, s, i, a, f, d, c = this, p = c.constructor, g = p.precision, v = p.rounding;
  if (c.isFinite()) {
    if (c.isZero())
      return new p(c);
    if (c.abs().eq(1) && g + 4 <= tp)
      return a = Wi(p, g + 4, v).times(0.25), a.s = c.s, a;
  } else {
    if (!c.s) return new p(NaN);
    if (g + 4 <= tp)
      return a = Wi(p, g + 4, v).times(0.5), a.s = c.s, a;
  }
  for (p.precision = f = g + 10, p.rounding = 1, r = Math.min(28, f / jt + 2 | 0), e = r; e; --e) c = c.div(c.times(c).plus(1).sqrt().plus(1));
  for (qt = !1, t = Math.ceil(f / jt), n = 1, d = c.times(c), a = new p(c), s = c; e !== -1; )
    if (s = s.times(d), i = a.minus(s.div(n += 2)), s = s.times(d), a = i.plus(s.div(n += 2)), a.d[t] !== void 0) for (e = t; a.d[e] === i.d[e] && e--; ) ;
  return r && (a = a.times(2 << r - 1)), qt = !0, _t(a, p.precision = g, p.rounding = v, !0);
};
Je.isFinite = function() {
  return !!this.d;
};
Je.isInteger = Je.isInt = function() {
  return !!this.d && mn(this.e / jt) > this.d.length - 2;
};
Je.isNaN = function() {
  return !this.s;
};
Je.isNegative = Je.isNeg = function() {
  return this.s < 0;
};
Je.isPositive = Je.isPos = function() {
  return this.s > 0;
};
Je.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
Je.lessThan = Je.lt = function(e) {
  return this.cmp(e) < 0;
};
Je.lessThanOrEqualTo = Je.lte = function(e) {
  return this.cmp(e) < 1;
};
Je.logarithm = Je.log = function(e) {
  var t, r, n, s, i, a, f, d, c = this, p = c.constructor, g = p.precision, v = p.rounding, O = 5;
  if (e == null)
    e = new p(10), t = !0;
  else {
    if (e = new p(e), r = e.d, e.s < 0 || !r || !r[0] || e.eq(1)) return new p(NaN);
    t = e.eq(10);
  }
  if (r = c.d, c.s < 0 || !r || !r[0] || c.eq(1))
    return new p(r && !r[0] ? -1 / 0 : c.s != 1 ? NaN : r ? 0 : 1 / 0);
  if (t)
    if (r.length > 1)
      i = !0;
    else {
      for (s = r[0]; s % 10 === 0; ) s /= 10;
      i = s !== 1;
    }
  if (qt = !1, f = g + O, a = Eo(c, f), n = t ? ch(p, f + 10) : Eo(e, f), d = xr(a, n, f, 1), W0(d.d, s = g, v))
    do
      if (f += 10, a = Eo(c, f), n = t ? ch(p, f + 10) : Eo(e, f), d = xr(a, n, f, 1), !i) {
        +an(d.d).slice(s + 1, s + 15) + 1 == 1e14 && (d = _t(d, g + 1, 0));
        break;
      }
    while (W0(d.d, s += 10, v));
  return qt = !0, _t(d, g, v);
};
Je.minus = Je.sub = function(e) {
  var t, r, n, s, i, a, f, d, c, p, g, v, O = this, N = O.constructor;
  if (e = new N(e), !O.d || !e.d)
    return !O.s || !e.s ? e = new N(NaN) : O.d ? e.s = -e.s : e = new N(e.d || O.s !== e.s ? O : NaN), e;
  if (O.s != e.s)
    return e.s = -e.s, O.plus(e);
  if (c = O.d, v = e.d, f = N.precision, d = N.rounding, !c[0] || !v[0]) {
    if (v[0]) e.s = -e.s;
    else if (c[0]) e = new N(O);
    else return new N(d === 3 ? -0 : 0);
    return qt ? _t(e, f, d) : e;
  }
  if (r = mn(e.e / jt), p = mn(O.e / jt), c = c.slice(), i = p - r, i) {
    for (g = i < 0, g ? (t = c, i = -i, a = v.length) : (t = v, r = p, a = c.length), n = Math.max(Math.ceil(f / jt), a) + 2, i > n && (i = n, t.length = 1), t.reverse(), n = i; n--; ) t.push(0);
    t.reverse();
  } else {
    for (n = c.length, a = v.length, g = n < a, g && (a = n), n = 0; n < a; n++)
      if (c[n] != v[n]) {
        g = c[n] < v[n];
        break;
      }
    i = 0;
  }
  for (g && (t = c, c = v, v = t, e.s = -e.s), a = c.length, n = v.length - a; n > 0; --n) c[a++] = 0;
  for (n = v.length; n > i; ) {
    if (c[--n] < v[n]) {
      for (s = n; s && c[--s] === 0; ) c[s] = Gi - 1;
      --c[s], c[n] += Gi;
    }
    c[n] -= v[n];
  }
  for (; c[--a] === 0; ) c.pop();
  for (; c[0] === 0; c.shift()) --r;
  return c[0] ? (e.d = c, e.e = Rh(c, r), qt ? _t(e, f, d) : e) : new N(d === 3 ? -0 : 0);
};
Je.modulo = Je.mod = function(e) {
  var t, r = this, n = r.constructor;
  return e = new n(e), !r.d || !e.s || e.d && !e.d[0] ? new n(NaN) : !e.d || r.d && !r.d[0] ? _t(new n(r), n.precision, n.rounding) : (qt = !1, n.modulo == 9 ? (t = xr(r, e.abs(), 0, 3, 1), t.s *= e.s) : t = xr(r, e, 0, n.modulo, 1), t = t.times(e), qt = !0, r.minus(t));
};
Je.naturalExponential = Je.exp = function() {
  return rp(this);
};
Je.naturalLogarithm = Je.ln = function() {
  return Eo(this);
};
Je.negated = Je.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, _t(e);
};
Je.plus = Je.add = function(e) {
  var t, r, n, s, i, a, f, d, c, p, g = this, v = g.constructor;
  if (e = new v(e), !g.d || !e.d)
    return !g.s || !e.s ? e = new v(NaN) : g.d || (e = new v(e.d || g.s === e.s ? g : NaN)), e;
  if (g.s != e.s)
    return e.s = -e.s, g.minus(e);
  if (c = g.d, p = e.d, f = v.precision, d = v.rounding, !c[0] || !p[0])
    return p[0] || (e = new v(g)), qt ? _t(e, f, d) : e;
  if (i = mn(g.e / jt), n = mn(e.e / jt), c = c.slice(), s = i - n, s) {
    for (s < 0 ? (r = c, s = -s, a = p.length) : (r = p, n = i, a = c.length), i = Math.ceil(f / jt), a = i > a ? i + 1 : a + 1, s > a && (s = a, r.length = 1), r.reverse(); s--; ) r.push(0);
    r.reverse();
  }
  for (a = c.length, s = p.length, a - s < 0 && (s = a, r = p, p = c, c = r), t = 0; s; )
    t = (c[--s] = c[s] + p[s] + t) / Gi | 0, c[s] %= Gi;
  for (t && (c.unshift(t), ++n), a = c.length; c[--a] == 0; ) c.pop();
  return e.d = c, e.e = Rh(c, n), qt ? _t(e, f, d) : e;
};
Je.precision = Je.sd = function(e) {
  var t, r = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(To + e);
  return r.d ? (t = P4(r.d), e && r.e + 1 > t && (t = r.e + 1)) : t = NaN, t;
};
Je.round = function() {
  var e = this, t = e.constructor;
  return _t(new t(e), e.e + 1, t.rounding);
};
Je.sine = Je.sin = function() {
  var e, t, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e = n.precision, t = n.rounding, n.precision = e + Math.max(r.e, r.sd()) + jt, n.rounding = 1, r = w9(n, T4(n, r)), n.precision = e, n.rounding = t, _t(Gs > 2 ? r.neg() : r, e, t, !0)) : new n(NaN);
};
Je.squareRoot = Je.sqrt = function() {
  var e, t, r, n, s, i, a = this, f = a.d, d = a.e, c = a.s, p = a.constructor;
  if (c !== 1 || !f || !f[0])
    return new p(!c || c < 0 && (!f || f[0]) ? NaN : f ? a : 1 / 0);
  for (qt = !1, c = Math.sqrt(+a), c == 0 || c == 1 / 0 ? (t = an(f), (t.length + d) % 2 == 0 && (t += "0"), c = Math.sqrt(t), d = mn((d + 1) / 2) - (d < 0 || d % 2), c == 1 / 0 ? t = "5e" + d : (t = c.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + d), n = new p(t)) : n = new p(c.toString()), r = (d = p.precision) + 3; ; )
    if (i = n, n = i.plus(xr(a, i, r + 2, 1)).times(0.5), an(i.d).slice(0, r) === (t = an(n.d)).slice(0, r))
      if (t = t.slice(r - 3, r + 1), t == "9999" || !s && t == "4999") {
        if (!s && (_t(i, d + 1, 0), i.times(i).eq(a))) {
          n = i;
          break;
        }
        r += 4, s = 1;
      } else {
        (!+t || !+t.slice(1) && t.charAt(0) == "5") && (_t(n, d + 1, 1), e = !n.times(n).eq(a));
        break;
      }
  return qt = !0, _t(n, d, p.rounding, e);
};
Je.tangent = Je.tan = function() {
  var e, t, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e = n.precision, t = n.rounding, n.precision = e + 10, n.rounding = 1, r = r.sin(), r.s = 1, r = xr(r, new n(1).minus(r.times(r)).sqrt(), e + 10, 0), n.precision = e, n.rounding = t, _t(Gs == 2 || Gs == 4 ? r.neg() : r, e, t, !0)) : new n(NaN);
};
Je.times = Je.mul = function(e) {
  var t, r, n, s, i, a, f, d, c, p = this, g = p.constructor, v = p.d, O = (e = new g(e)).d;
  if (e.s *= p.s, !v || !v[0] || !O || !O[0])
    return new g(!e.s || v && !v[0] && !O || O && !O[0] && !v ? NaN : !v || !O ? e.s / 0 : e.s * 0);
  for (r = mn(p.e / jt) + mn(e.e / jt), d = v.length, c = O.length, d < c && (i = v, v = O, O = i, a = d, d = c, c = a), i = [], a = d + c, n = a; n--; ) i.push(0);
  for (n = c; --n >= 0; ) {
    for (t = 0, s = d + n; s > n; )
      f = i[s] + O[n] * v[s - n - 1] + t, i[s--] = f % Gi | 0, t = f / Gi | 0;
    i[s] = (i[s] + t) % Gi | 0;
  }
  for (; !i[--a]; ) i.pop();
  return t ? ++r : i.shift(), e.d = i, e.e = Rh(i, r), qt ? _t(e, g.precision, g.rounding) : e;
};
Je.toBinary = function(e, t) {
  return e1(this, 2, e, t);
};
Je.toDecimalPlaces = Je.toDP = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (Cn(e, 0, Io), t === void 0 ? t = n.rounding : Cn(t, 0, 8), _t(r, e + r.e + 1, t));
};
Je.toExponential = function(e, t) {
  var r, n = this, s = n.constructor;
  return e === void 0 ? r = ms(n, !0) : (Cn(e, 0, Io), t === void 0 ? t = s.rounding : Cn(t, 0, 8), n = _t(new s(n), e + 1, t), r = ms(n, !0, e + 1)), n.isNeg() && !n.isZero() ? "-" + r : r;
};
Je.toFixed = function(e, t) {
  var r, n, s = this, i = s.constructor;
  return e === void 0 ? r = ms(s) : (Cn(e, 0, Io), t === void 0 ? t = i.rounding : Cn(t, 0, 8), n = _t(new i(s), e + s.e + 1, t), r = ms(n, !1, e + n.e + 1)), s.isNeg() && !s.isZero() ? "-" + r : r;
};
Je.toFraction = function(e) {
  var t, r, n, s, i, a, f, d, c, p, g, v, O = this, N = O.d, S = O.constructor;
  if (!N) return new S(O);
  if (c = r = new S(1), n = d = new S(0), t = new S(n), i = t.e = P4(N) - O.e - 1, a = i % jt, t.d[0] = Qr(10, a < 0 ? jt + a : a), e == null)
    e = i > 0 ? t : c;
  else {
    if (f = new S(e), !f.isInt() || f.lt(c)) throw Error(To + f);
    e = f.gt(t) ? i > 0 ? t : c : f;
  }
  for (qt = !1, f = new S(an(N)), p = S.precision, S.precision = i = N.length * jt * 2; g = xr(f, t, 0, 1, 1), s = r.plus(g.times(n)), s.cmp(e) != 1; )
    r = n, n = s, s = c, c = d.plus(g.times(s)), d = s, s = t, t = f.minus(g.times(s)), f = s;
  return s = xr(e.minus(r), n, 0, 1, 1), d = d.plus(s.times(c)), r = r.plus(s.times(n)), d.s = c.s = O.s, v = xr(c, n, i, 1).minus(O).abs().cmp(xr(d, r, i, 1).minus(O).abs()) < 1 ? [c, n] : [d, r], S.precision = p, qt = !0, v;
};
Je.toHexadecimal = Je.toHex = function(e, t) {
  return e1(this, 16, e, t);
};
Je.toNearest = function(e, t) {
  var r = this, n = r.constructor;
  if (r = new n(r), e == null) {
    if (!r.d) return r;
    e = new n(1), t = n.rounding;
  } else {
    if (e = new n(e), t === void 0 ? t = n.rounding : Cn(t, 0, 8), !r.d) return e.s ? r : e;
    if (!e.d)
      return e.s && (e.s = r.s), e;
  }
  return e.d[0] ? (qt = !1, r = xr(r, e, 0, t, 1).times(e), qt = !0, _t(r)) : (e.s = r.s, r = e), r;
};
Je.toNumber = function() {
  return +this;
};
Je.toOctal = function(e, t) {
  return e1(this, 8, e, t);
};
Je.toPower = Je.pow = function(e) {
  var t, r, n, s, i, a, f = this, d = f.constructor, c = +(e = new d(e));
  if (!f.d || !e.d || !f.d[0] || !e.d[0]) return new d(Qr(+f, c));
  if (f = new d(f), f.eq(1)) return f;
  if (n = d.precision, i = d.rounding, e.eq(1)) return _t(f, n, i);
  if (t = mn(e.e / jt), t >= e.d.length - 1 && (r = c < 0 ? -c : c) <= g9)
    return s = O4(d, f, r, n), e.s < 0 ? new d(1).div(s) : _t(s, n, i);
  if (a = f.s, a < 0) {
    if (t < e.d.length - 1) return new d(NaN);
    if (e.d[t] & 1 || (a = 1), f.e == 0 && f.d[0] == 1 && f.d.length == 1)
      return f.s = a, f;
  }
  return r = Qr(+f, c), t = r == 0 || !isFinite(r) ? mn(c * (Math.log("0." + an(f.d)) / Math.LN10 + f.e + 1)) : new d(r + "").e, t > d.maxE + 1 || t < d.minE - 1 ? new d(t > 0 ? a / 0 : 0) : (qt = !1, d.rounding = f.s = 1, r = Math.min(12, (t + "").length), s = rp(e.times(Eo(f, n + r)), n), s.d && (s = _t(s, n + 5, 1), W0(s.d, n, i) && (t = n + 10, s = _t(rp(e.times(Eo(f, t + r)), t), t + 5, 1), +an(s.d).slice(n + 1, n + 15) + 1 == 1e14 && (s = _t(s, n + 1, 0)))), s.s = a, qt = !0, d.rounding = i, _t(s, n, i));
};
Je.toPrecision = function(e, t) {
  var r, n = this, s = n.constructor;
  return e === void 0 ? r = ms(n, n.e <= s.toExpNeg || n.e >= s.toExpPos) : (Cn(e, 1, Io), t === void 0 ? t = s.rounding : Cn(t, 0, 8), n = _t(new s(n), e, t), r = ms(n, e <= n.e || n.e <= s.toExpNeg, e)), n.isNeg() && !n.isZero() ? "-" + r : r;
};
Je.toSignificantDigits = Je.toSD = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (Cn(e, 1, Io), t === void 0 ? t = n.rounding : Cn(t, 0, 8)), _t(new n(r), e, t);
};
Je.toString = function() {
  var e = this, t = e.constructor, r = ms(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
  return e.isNeg() && !e.isZero() ? "-" + r : r;
};
Je.truncated = Je.trunc = function() {
  return _t(new this.constructor(this), this.e + 1, 1);
};
Je.valueOf = Je.toJSON = function() {
  var e = this, t = e.constructor, r = ms(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
  return e.isNeg() ? "-" + r : r;
};
function an(e) {
  var t, r, n, s = e.length - 1, i = "", a = e[0];
  if (s > 0) {
    for (i += a, t = 1; t < s; t++)
      n = e[t] + "", r = jt - n.length, r && (i += go(r)), i += n;
    a = e[t], n = a + "", r = jt - n.length, r && (i += go(r));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; ) a /= 10;
  return i + a;
}
function Cn(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(To + e);
}
function W0(e, t, r, n) {
  var s, i, a, f;
  for (i = e[0]; i >= 10; i /= 10) --t;
  return --t < 0 ? (t += jt, s = 0) : (s = Math.ceil((t + 1) / jt), t %= jt), i = Qr(10, jt - t), f = e[s] % i | 0, n == null ? t < 3 ? (t == 0 ? f = f / 100 | 0 : t == 1 && (f = f / 10 | 0), a = r < 4 && f == 99999 || r > 3 && f == 49999 || f == 5e4 || f == 0) : a = (r < 4 && f + 1 == i || r > 3 && f + 1 == i / 2) && (e[s + 1] / i / 100 | 0) == Qr(10, t - 2) - 1 || (f == i / 2 || f == 0) && (e[s + 1] / i / 100 | 0) == 0 : t < 4 ? (t == 0 ? f = f / 1e3 | 0 : t == 1 ? f = f / 100 | 0 : t == 2 && (f = f / 10 | 0), a = (n || r < 4) && f == 9999 || !n && r > 3 && f == 4999) : a = ((n || r < 4) && f + 1 == i || !n && r > 3 && f + 1 == i / 2) && (e[s + 1] / i / 1e3 | 0) == Qr(10, t - 3) - 1, a;
}
function zd(e, t, r) {
  for (var n, s = [0], i, a = 0, f = e.length; a < f; ) {
    for (i = s.length; i--; ) s[i] *= t;
    for (s[0] += Xf.indexOf(e.charAt(a++)), n = 0; n < s.length; n++)
      s[n] > r - 1 && (s[n + 1] === void 0 && (s[n + 1] = 0), s[n + 1] += s[n] / r | 0, s[n] %= r);
  }
  return s.reverse();
}
function y9(e, t) {
  var r, n, s;
  if (t.isZero()) return t;
  n = t.d.length, n < 32 ? (r = Math.ceil(n / 3), s = (1 / Ch(4, r)).toString()) : (r = 16, s = "2.3283064365386962890625e-10"), e.precision += r, t = ju(e, 1, t.times(s), new e(1));
  for (var i = r; i--; ) {
    var a = t.times(t);
    t = a.times(a).minus(a).times(8).plus(1);
  }
  return e.precision -= r, t;
}
var xr = /* @__PURE__ */ function() {
  function e(n, s, i) {
    var a, f = 0, d = n.length;
    for (n = n.slice(); d--; )
      a = n[d] * s + f, n[d] = a % i | 0, f = a / i | 0;
    return f && n.unshift(f), n;
  }
  function t(n, s, i, a) {
    var f, d;
    if (i != a)
      d = i > a ? 1 : -1;
    else
      for (f = d = 0; f < i; f++)
        if (n[f] != s[f]) {
          d = n[f] > s[f] ? 1 : -1;
          break;
        }
    return d;
  }
  function r(n, s, i, a) {
    for (var f = 0; i--; )
      n[i] -= f, f = n[i] < s[i] ? 1 : 0, n[i] = f * a + n[i] - s[i];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, s, i, a, f, d) {
    var c, p, g, v, O, N, S, j, B, M, I, A, R, L, K, $, k, V, C, D, o = n.constructor, u = n.s == s.s ? 1 : -1, h = n.d, y = s.d;
    if (!h || !h[0] || !y || !y[0])
      return new o(
        // Return NaN if either NaN, or both Infinity or 0.
        !n.s || !s.s || (h ? y && h[0] == y[0] : !y) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          h && h[0] == 0 || !y ? u * 0 : u / 0
        )
      );
    for (d ? (O = 1, p = n.e - s.e) : (d = Gi, O = jt, p = mn(n.e / O) - mn(s.e / O)), C = y.length, k = h.length, B = new o(u), M = B.d = [], g = 0; y[g] == (h[g] || 0); g++) ;
    if (y[g] > (h[g] || 0) && p--, i == null ? (L = i = o.precision, a = o.rounding) : f ? L = i + (n.e - s.e) + 1 : L = i, L < 0)
      M.push(1), N = !0;
    else {
      if (L = L / O + 2 | 0, g = 0, C == 1) {
        for (v = 0, y = y[0], L++; (g < k || v) && L--; g++)
          K = v * d + (h[g] || 0), M[g] = K / y | 0, v = K % y | 0;
        N = v || g < k;
      } else {
        for (v = d / (y[0] + 1) | 0, v > 1 && (y = e(y, v, d), h = e(h, v, d), C = y.length, k = h.length), $ = C, I = h.slice(0, C), A = I.length; A < C; ) I[A++] = 0;
        D = y.slice(), D.unshift(0), V = y[0], y[1] >= d / 2 && ++V;
        do
          v = 0, c = t(y, I, C, A), c < 0 ? (R = I[0], C != A && (R = R * d + (I[1] || 0)), v = R / V | 0, v > 1 ? (v >= d && (v = d - 1), S = e(y, v, d), j = S.length, A = I.length, c = t(S, I, j, A), c == 1 && (v--, r(S, C < j ? D : y, j, d))) : (v == 0 && (c = v = 1), S = y.slice()), j = S.length, j < A && S.unshift(0), r(I, S, A, d), c == -1 && (A = I.length, c = t(y, I, C, A), c < 1 && (v++, r(I, C < A ? D : y, A, d))), A = I.length) : c === 0 && (v++, I = [0]), M[g++] = v, c && I[0] ? I[A++] = h[$] || 0 : (I = [h[$]], A = 1);
        while (($++ < k || I[0] !== void 0) && L--);
        N = I[0] !== void 0;
      }
      M[0] || M.shift();
    }
    if (O == 1)
      B.e = p, b4 = N;
    else {
      for (g = 1, v = M[0]; v >= 10; v /= 10) g++;
      B.e = g + p * O - 1, _t(B, f ? i + B.e + 1 : i, a, N);
    }
    return B;
  };
}();
function _t(e, t, r, n) {
  var s, i, a, f, d, c, p, g, v, O = e.constructor;
  e: if (t != null) {
    if (g = e.d, !g) return e;
    for (s = 1, f = g[0]; f >= 10; f /= 10) s++;
    if (i = t - s, i < 0)
      i += jt, a = t, p = g[v = 0], d = p / Qr(10, s - a - 1) % 10 | 0;
    else if (v = Math.ceil((i + 1) / jt), f = g.length, v >= f)
      if (n) {
        for (; f++ <= v; ) g.push(0);
        p = d = 0, s = 1, i %= jt, a = i - jt + 1;
      } else
        break e;
    else {
      for (p = f = g[v], s = 1; f >= 10; f /= 10) s++;
      i %= jt, a = i - jt + s, d = a < 0 ? 0 : p / Qr(10, s - a - 1) % 10 | 0;
    }
    if (n = n || t < 0 || g[v + 1] !== void 0 || (a < 0 ? p : p % Qr(10, s - a - 1)), c = r < 4 ? (d || n) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : d > 5 || d == 5 && (r == 4 || n || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (i > 0 ? a > 0 ? p / Qr(10, s - a) : 0 : g[v - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7)), t < 1 || !g[0])
      return g.length = 0, c ? (t -= e.e + 1, g[0] = Qr(10, (jt - t % jt) % jt), e.e = -t || 0) : g[0] = e.e = 0, e;
    if (i == 0 ? (g.length = v, f = 1, v--) : (g.length = v + 1, f = Qr(10, jt - i), g[v] = a > 0 ? (p / Qr(10, s - a) % Qr(10, a) | 0) * f : 0), c)
      for (; ; )
        if (v == 0) {
          for (i = 1, a = g[0]; a >= 10; a /= 10) i++;
          for (a = g[0] += f, f = 1; a >= 10; a /= 10) f++;
          i != f && (e.e++, g[0] == Gi && (g[0] = 1));
          break;
        } else {
          if (g[v] += f, g[v] != Gi) break;
          g[v--] = 0, f = 1;
        }
    for (i = g.length; g[--i] === 0; ) g.pop();
  }
  return qt && (e.e > O.maxE ? (e.d = null, e.e = NaN) : e.e < O.minE && (e.e = 0, e.d = [0])), e;
}
function ms(e, t, r) {
  if (!e.isFinite()) return x4(e);
  var n, s = e.e, i = an(e.d), a = i.length;
  return t ? (r && (n = r - a) > 0 ? i = i.charAt(0) + "." + i.slice(1) + go(n) : a > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (e.e < 0 ? "e" : "e+") + e.e) : s < 0 ? (i = "0." + go(-s - 1) + i, r && (n = r - a) > 0 && (i += go(n))) : s >= a ? (i += go(s + 1 - a), r && (n = r - s - 1) > 0 && (i = i + "." + go(n))) : ((n = s + 1) < a && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - a) > 0 && (s + 1 === a && (i += "."), i += go(n))), i;
}
function Rh(e, t) {
  var r = e[0];
  for (t *= jt; r >= 10; r /= 10) t++;
  return t;
}
function ch(e, t, r) {
  if (t > m9)
    throw qt = !0, r && (e.precision = r), Error(w4);
  return _t(new e(ah), t, 1, !0);
}
function Wi(e, t, r) {
  if (t > tp) throw Error(w4);
  return _t(new e(uh), t, r, !0);
}
function P4(e) {
  var t = e.length - 1, r = t * jt + 1;
  if (t = e[t], t) {
    for (; t % 10 == 0; t /= 10) r--;
    for (t = e[0]; t >= 10; t /= 10) r++;
  }
  return r;
}
function go(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function O4(e, t, r, n) {
  var s, i = new e(1), a = Math.ceil(n / jt + 4);
  for (qt = !1; ; ) {
    if (r % 2 && (i = i.times(t), Pg(i.d, a) && (s = !0)), r = mn(r / 2), r === 0) {
      r = i.d.length - 1, s && i.d[r] === 0 && ++i.d[r];
      break;
    }
    t = t.times(t), Pg(t.d, a);
  }
  return qt = !0, i;
}
function Eg(e) {
  return e.d[e.d.length - 1] & 1;
}
function N4(e, t, r) {
  for (var n, s = new e(t[0]), i = 0; ++i < t.length; )
    if (n = new e(t[i]), n.s)
      s[r](n) && (s = n);
    else {
      s = n;
      break;
    }
  return s;
}
function rp(e, t) {
  var r, n, s, i, a, f, d, c = 0, p = 0, g = 0, v = e.constructor, O = v.rounding, N = v.precision;
  if (!e.d || !e.d[0] || e.e > 17)
    return new v(e.d ? e.d[0] ? e.s < 0 ? 0 : 1 / 0 : 1 : e.s ? e.s < 0 ? 0 : e : NaN);
  for (t == null ? (qt = !1, d = N) : d = t, f = new v(0.03125); e.e > -2; )
    e = e.times(f), g += 5;
  for (n = Math.log(Qr(2, g)) / Math.LN10 * 2 + 5 | 0, d += n, r = i = a = new v(1), v.precision = d; ; ) {
    if (i = _t(i.times(e), d, 1), r = r.times(++p), f = a.plus(xr(i, r, d, 1)), an(f.d).slice(0, d) === an(a.d).slice(0, d)) {
      for (s = g; s--; ) a = _t(a.times(a), d, 1);
      if (t == null)
        if (c < 3 && W0(a.d, d - n, O, c))
          v.precision = d += 10, r = i = f = new v(1), p = 0, c++;
        else
          return _t(a, v.precision = N, O, qt = !0);
      else
        return v.precision = N, a;
    }
    a = f;
  }
}
function Eo(e, t) {
  var r, n, s, i, a, f, d, c, p, g, v, O = 1, N = 10, S = e, j = S.d, B = S.constructor, M = B.rounding, I = B.precision;
  if (S.s < 0 || !j || !j[0] || !S.e && j[0] == 1 && j.length == 1)
    return new B(j && !j[0] ? -1 / 0 : S.s != 1 ? NaN : j ? 0 : S);
  if (t == null ? (qt = !1, p = I) : p = t, B.precision = p += N, r = an(j), n = r.charAt(0), Math.abs(i = S.e) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      S = S.times(e), r = an(S.d), n = r.charAt(0), O++;
    i = S.e, n > 1 ? (S = new B("0." + r), i++) : S = new B(n + "." + r.slice(1));
  } else
    return c = ch(B, p + 2, I).times(i + ""), S = Eo(new B(n + "." + r.slice(1)), p - N).plus(c), B.precision = I, t == null ? _t(S, I, M, qt = !0) : S;
  for (g = S, d = a = S = xr(S.minus(1), S.plus(1), p, 1), v = _t(S.times(S), p, 1), s = 3; ; ) {
    if (a = _t(a.times(v), p, 1), c = d.plus(xr(a, new B(s), p, 1)), an(c.d).slice(0, p) === an(d.d).slice(0, p))
      if (d = d.times(2), i !== 0 && (d = d.plus(ch(B, p + 2, I).times(i + ""))), d = xr(d, new B(O), p, 1), t == null)
        if (W0(d.d, p - N, M, f))
          B.precision = p += N, c = a = S = xr(g.minus(1), g.plus(1), p, 1), v = _t(S.times(S), p, 1), s = f = 1;
        else
          return _t(d, B.precision = I, M, qt = !0);
      else
        return B.precision = I, d;
    d = c, s += 2;
  }
}
function x4(e) {
  return String(e.s * e.s / 0);
}
function np(e, t) {
  var r, n, s;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; n++) ;
  for (s = t.length; t.charCodeAt(s - 1) === 48; --s) ;
  if (t = t.slice(n, s), t) {
    if (s -= n, e.e = r = r - n - 1, e.d = [], n = (r + 1) % jt, r < 0 && (n += jt), n < s) {
      for (n && e.d.push(+t.slice(0, n)), s -= jt; n < s; ) e.d.push(+t.slice(n, n += jt));
      t = t.slice(n), n = jt - t.length;
    } else
      n -= s;
    for (; n--; ) t += "0";
    e.d.push(+t), qt && (e.e > e.constructor.maxE ? (e.d = null, e.e = NaN) : e.e < e.constructor.minE && (e.e = 0, e.d = [0]));
  } else
    e.e = 0, e.d = [0];
  return e;
}
function b9(e, t) {
  var r, n, s, i, a, f, d, c, p;
  if (t.indexOf("_") > -1) {
    if (t = t.replace(/(\d)_(?=\d)/g, "$1"), E4.test(t)) return np(e, t);
  } else if (t === "Infinity" || t === "NaN")
    return +t || (e.s = NaN), e.e = NaN, e.d = null, e;
  if (f9.test(t))
    r = 16, t = t.toLowerCase();
  else if (h9.test(t))
    r = 2;
  else if (p9.test(t))
    r = 8;
  else
    throw Error(To + t);
  for (i = t.search(/p/i), i > 0 ? (d = +t.slice(i + 1), t = t.substring(2, i)) : t = t.slice(2), i = t.indexOf("."), a = i >= 0, n = e.constructor, a && (t = t.replace(".", ""), f = t.length, i = f - i, s = O4(n, new n(r), i, i * 2)), c = zd(t, r, Gi), p = c.length - 1, i = p; c[i] === 0; --i) c.pop();
  return i < 0 ? new n(e.s * 0) : (e.e = Rh(c, p), e.d = c, qt = !1, a && (e = xr(e, s, f * 4)), d && (e = e.times(Math.abs(d) < 54 ? Qr(2, d) : Lu.pow(2, d))), qt = !0, e);
}
function w9(e, t) {
  var r, n = t.d.length;
  if (n < 3)
    return t.isZero() ? t : ju(e, 2, t, t);
  r = 1.4 * Math.sqrt(n), r = r > 16 ? 16 : r | 0, t = t.times(1 / Ch(5, r)), t = ju(e, 2, t, t);
  for (var s, i = new e(5), a = new e(16), f = new e(20); r--; )
    s = t.times(t), t = t.times(i.plus(s.times(a.times(s).minus(f))));
  return t;
}
function ju(e, t, r, n, s) {
  var i, a, f, d, c = e.precision, p = Math.ceil(c / jt);
  for (qt = !1, d = r.times(r), f = new e(n); ; ) {
    if (a = xr(f.times(d), new e(t++ * t++), c, 1), f = s ? n.plus(a) : n.minus(a), n = xr(a.times(d), new e(t++ * t++), c, 1), a = f.plus(n), a.d[p] !== void 0) {
      for (i = p; a.d[i] === f.d[i] && i--; ) ;
      if (i == -1) break;
    }
    i = f, f = n, n = a, a = i;
  }
  return qt = !0, a.d.length = p + 1, a;
}
function Ch(e, t) {
  for (var r = e; --t; ) r *= e;
  return r;
}
function T4(e, t) {
  var r, n = t.s < 0, s = Wi(e, e.precision, 1), i = s.times(0.5);
  if (t = t.abs(), t.lte(i))
    return Gs = n ? 4 : 1, t;
  if (r = t.divToInt(s), r.isZero())
    Gs = n ? 3 : 2;
  else {
    if (t = t.minus(r.times(s)), t.lte(i))
      return Gs = Eg(r) ? n ? 2 : 3 : n ? 4 : 1, t;
    Gs = Eg(r) ? n ? 1 : 4 : n ? 3 : 2;
  }
  return t.minus(s).abs();
}
function e1(e, t, r, n) {
  var s, i, a, f, d, c, p, g, v, O = e.constructor, N = r !== void 0;
  if (N ? (Cn(r, 1, Io), n === void 0 ? n = O.rounding : Cn(n, 0, 8)) : (r = O.precision, n = O.rounding), !e.isFinite())
    p = x4(e);
  else {
    for (p = ms(e), a = p.indexOf("."), N ? (s = 2, t == 16 ? r = r * 4 - 3 : t == 8 && (r = r * 3 - 2)) : s = t, a >= 0 && (p = p.replace(".", ""), v = new O(1), v.e = p.length - a, v.d = zd(ms(v), 10, s), v.e = v.d.length), g = zd(p, 10, s), i = d = g.length; g[--d] == 0; ) g.pop();
    if (!g[0])
      p = N ? "0p+0" : "0";
    else {
      if (a < 0 ? i-- : (e = new O(e), e.d = g, e.e = i, e = xr(e, v, r, n, 0, s), g = e.d, i = e.e, c = b4), a = g[r], f = s / 2, c = c || g[r + 1] !== void 0, c = n < 4 ? (a !== void 0 || c) && (n === 0 || n === (e.s < 0 ? 3 : 2)) : a > f || a === f && (n === 4 || c || n === 6 && g[r - 1] & 1 || n === (e.s < 0 ? 8 : 7)), g.length = r, c)
        for (; ++g[--r] > s - 1; )
          g[r] = 0, r || (++i, g.unshift(1));
      for (d = g.length; !g[d - 1]; --d) ;
      for (a = 0, p = ""; a < d; a++) p += Xf.charAt(g[a]);
      if (N) {
        if (d > 1)
          if (t == 16 || t == 8) {
            for (a = t == 16 ? 4 : 3, --d; d % a; d++) p += "0";
            for (g = zd(p, s, t), d = g.length; !g[d - 1]; --d) ;
            for (a = 1, p = "1."; a < d; a++) p += Xf.charAt(g[a]);
          } else
            p = p.charAt(0) + "." + p.slice(1);
        p = p + (i < 0 ? "p" : "p+") + i;
      } else if (i < 0) {
        for (; ++i; ) p = "0" + p;
        p = "0." + p;
      } else if (++i > d) for (i -= d; i--; ) p += "0";
      else i < d && (p = p.slice(0, i) + "." + p.slice(i));
    }
    p = (t == 16 ? "0x" : t == 2 ? "0b" : t == 8 ? "0o" : "") + p;
  }
  return e.s < 0 ? "-" + p : p;
}
function Pg(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function v9(e) {
  return new this(e).abs();
}
function A9(e) {
  return new this(e).acos();
}
function E9(e) {
  return new this(e).acosh();
}
function P9(e, t) {
  return new this(e).plus(t);
}
function O9(e) {
  return new this(e).asin();
}
function N9(e) {
  return new this(e).asinh();
}
function x9(e) {
  return new this(e).atan();
}
function T9(e) {
  return new this(e).atanh();
}
function k9(e, t) {
  e = new this(e), t = new this(t);
  var r, n = this.precision, s = this.rounding, i = n + 4;
  return !e.s || !t.s ? r = new this(NaN) : !e.d && !t.d ? (r = Wi(this, i, 1).times(t.s > 0 ? 0.25 : 0.75), r.s = e.s) : !t.d || e.isZero() ? (r = t.s < 0 ? Wi(this, n, s) : new this(0), r.s = e.s) : !e.d || t.isZero() ? (r = Wi(this, i, 1).times(0.5), r.s = e.s) : t.s < 0 ? (this.precision = i, this.rounding = 1, r = this.atan(xr(e, t, i, 1)), t = Wi(this, i, 1), this.precision = n, this.rounding = s, r = e.s < 0 ? r.minus(t) : r.plus(t)) : r = this.atan(xr(e, t, i, 1)), r;
}
function S9(e) {
  return new this(e).cbrt();
}
function M9(e) {
  return _t(e = new this(e), e.e + 1, 2);
}
function I9(e, t, r) {
  return new this(e).clamp(t, r);
}
function R9(e) {
  if (!e || typeof e != "object") throw Error(Ih + "Object expected");
  var t, r, n, s = e.defaults === !0, i = [
    "precision",
    1,
    Io,
    "rounding",
    0,
    8,
    "toExpNeg",
    -Pu,
    0,
    "toExpPos",
    0,
    Pu,
    "maxE",
    0,
    Pu,
    "minE",
    -Pu,
    0,
    "modulo",
    0,
    9
  ];
  for (t = 0; t < i.length; t += 3)
    if (r = i[t], s && (this[r] = ep[r]), (n = e[r]) !== void 0)
      if (mn(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
      else throw Error(To + r + ": " + n);
  if (r = "crypto", s && (this[r] = ep[r]), (n = e[r]) !== void 0)
    if (n === !0 || n === !1 || n === 0 || n === 1)
      if (n)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[r] = !0;
        else
          throw Error(v4);
      else
        this[r] = !1;
    else
      throw Error(To + r + ": " + n);
  return this;
}
function C9(e) {
  return new this(e).cos();
}
function B9(e) {
  return new this(e).cosh();
}
function k4(e) {
  var t, r, n;
  function s(i) {
    var a, f, d, c = this;
    if (!(c instanceof s)) return new s(i);
    if (c.constructor = s, Og(i)) {
      c.s = i.s, qt ? !i.d || i.e > s.maxE ? (c.e = NaN, c.d = null) : i.e < s.minE ? (c.e = 0, c.d = [0]) : (c.e = i.e, c.d = i.d.slice()) : (c.e = i.e, c.d = i.d ? i.d.slice() : i.d);
      return;
    }
    if (d = typeof i, d === "number") {
      if (i === 0) {
        c.s = 1 / i < 0 ? -1 : 1, c.e = 0, c.d = [0];
        return;
      }
      if (i < 0 ? (i = -i, c.s = -1) : c.s = 1, i === ~~i && i < 1e7) {
        for (a = 0, f = i; f >= 10; f /= 10) a++;
        qt ? a > s.maxE ? (c.e = NaN, c.d = null) : a < s.minE ? (c.e = 0, c.d = [0]) : (c.e = a, c.d = [i]) : (c.e = a, c.d = [i]);
        return;
      } else if (i * 0 !== 0) {
        i || (c.s = NaN), c.e = NaN, c.d = null;
        return;
      }
      return np(c, i.toString());
    } else if (d !== "string")
      throw Error(To + i);
    return (f = i.charCodeAt(0)) === 45 ? (i = i.slice(1), c.s = -1) : (f === 43 && (i = i.slice(1)), c.s = 1), E4.test(i) ? np(c, i) : b9(c, i);
  }
  if (s.prototype = Je, s.ROUND_UP = 0, s.ROUND_DOWN = 1, s.ROUND_CEIL = 2, s.ROUND_FLOOR = 3, s.ROUND_HALF_UP = 4, s.ROUND_HALF_DOWN = 5, s.ROUND_HALF_EVEN = 6, s.ROUND_HALF_CEIL = 7, s.ROUND_HALF_FLOOR = 8, s.EUCLID = 9, s.config = s.set = R9, s.clone = k4, s.isDecimal = Og, s.abs = v9, s.acos = A9, s.acosh = E9, s.add = P9, s.asin = O9, s.asinh = N9, s.atan = x9, s.atanh = T9, s.atan2 = k9, s.cbrt = S9, s.ceil = M9, s.clamp = I9, s.cos = C9, s.cosh = B9, s.div = _9, s.exp = F9, s.floor = U9, s.hypot = D9, s.ln = j9, s.log = L9, s.log10 = W9, s.log2 = H9, s.max = G9, s.min = z9, s.mod = V9, s.mul = q9, s.pow = $9, s.random = K9, s.round = J9, s.sign = Q9, s.sin = Z9, s.sinh = Y9, s.sqrt = X9, s.sub = eA, s.sum = tA, s.tan = rA, s.tanh = nA, s.trunc = iA, e === void 0 && (e = {}), e && e.defaults !== !0)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return s.config(e), s;
}
function _9(e, t) {
  return new this(e).div(t);
}
function F9(e) {
  return new this(e).exp();
}
function U9(e) {
  return _t(e = new this(e), e.e + 1, 3);
}
function D9() {
  var e, t, r = new this(0);
  for (qt = !1, e = 0; e < arguments.length; )
    if (t = new this(arguments[e++]), t.d)
      r.d && (r = r.plus(t.times(t)));
    else {
      if (t.s)
        return qt = !0, new this(1 / 0);
      r = t;
    }
  return qt = !0, r.sqrt();
}
function Og(e) {
  return e instanceof Lu || e && e.toStringTag === A4 || !1;
}
function j9(e) {
  return new this(e).ln();
}
function L9(e, t) {
  return new this(e).log(t);
}
function H9(e) {
  return new this(e).log(2);
}
function W9(e) {
  return new this(e).log(10);
}
function G9() {
  return N4(this, arguments, "lt");
}
function z9() {
  return N4(this, arguments, "gt");
}
function V9(e, t) {
  return new this(e).mod(t);
}
function q9(e, t) {
  return new this(e).mul(t);
}
function $9(e, t) {
  return new this(e).pow(t);
}
function K9(e) {
  var t, r, n, s, i = 0, a = new this(1), f = [];
  if (e === void 0 ? e = this.precision : Cn(e, 1, Io), n = Math.ceil(e / jt), this.crypto)
    if (crypto.getRandomValues)
      for (t = crypto.getRandomValues(new Uint32Array(n)); i < n; )
        s = t[i], s >= 429e7 ? t[i] = crypto.getRandomValues(new Uint32Array(1))[0] : f[i++] = s % 1e7;
    else if (crypto.randomBytes) {
      for (t = crypto.randomBytes(n *= 4); i < n; )
        s = t[i] + (t[i + 1] << 8) + (t[i + 2] << 16) + ((t[i + 3] & 127) << 24), s >= 214e7 ? crypto.randomBytes(4).copy(t, i) : (f.push(s % 1e7), i += 4);
      i = n / 4;
    } else
      throw Error(v4);
  else for (; i < n; ) f[i++] = Math.random() * 1e7 | 0;
  for (n = f[--i], e %= jt, n && e && (s = Qr(10, jt - e), f[i] = (n / s | 0) * s); f[i] === 0; i--) f.pop();
  if (i < 0)
    r = 0, f = [0];
  else {
    for (r = -1; f[0] === 0; r -= jt) f.shift();
    for (n = 1, s = f[0]; s >= 10; s /= 10) n++;
    n < jt && (r -= jt - n);
  }
  return a.e = r, a.d = f, a;
}
function J9(e) {
  return _t(e = new this(e), e.e + 1, this.rounding);
}
function Q9(e) {
  return e = new this(e), e.d ? e.d[0] ? e.s : 0 * e.s : e.s || NaN;
}
function Z9(e) {
  return new this(e).sin();
}
function Y9(e) {
  return new this(e).sinh();
}
function X9(e) {
  return new this(e).sqrt();
}
function eA(e, t) {
  return new this(e).sub(t);
}
function tA() {
  var e = 0, t = arguments, r = new this(t[e]);
  for (qt = !1; r.s && ++e < t.length; ) r = r.plus(t[e]);
  return qt = !0, _t(r, this.precision, this.rounding);
}
function rA(e) {
  return new this(e).tan();
}
function nA(e) {
  return new this(e).tanh();
}
function iA(e) {
  return _t(e = new this(e), e.e + 1, 1);
}
Je[Symbol.for("nodejs.util.inspect.custom")] = Je.toString;
Je[Symbol.toStringTag] = "Decimal";
var Lu = Je.constructor = k4(ep);
ah = new Lu(ah);
uh = new Lu(uh);
function S4(e, t, r) {
  if (e instanceof Uint8Array)
    return r ? new Uint8Array(e) : e;
  if (typeof e == "string" && e.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
    const n = new Uint8Array((e.length - 2) / 2);
    let s = 2;
    for (let i = 0; i < n.length; i++)
      n[i] = parseInt(e.substring(s, s + 2), 16), s += 2;
    return n;
  }
  ct(!1, "invalid BytesLike value", t || "value", e);
}
function Js(e, t) {
  return S4(e, t, !1);
}
function fs(e, t) {
  return S4(e, t, !0);
}
function zs(e, t) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || typeof t == "number" && e.length !== 2 + 2 * t || t === !0 && e.length % 2 !== 0);
}
function sA(e) {
  return zs(e, !0) || e instanceof Uint8Array;
}
const Ng = "0123456789abcdef";
function Zr(e) {
  const t = Js(e);
  let r = "0x";
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    r += Ng[(s & 240) >> 4] + Ng[s & 15];
  }
  return r;
}
function ku(e) {
  return "0x" + e.map((t) => Zr(t).substring(2)).join("");
}
function iu(e, t, r) {
  const n = Js(e);
  return r != null && r > n.length && Yt(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
    buffer: n,
    length: n.length,
    offset: r
  }), Zr(n.slice(t ?? 0, r ?? n.length));
}
function M4(e, t, r) {
  const n = Js(e);
  Yt(t >= n.length, "padding exceeds data length", "BUFFER_OVERRUN", {
    buffer: new Uint8Array(n),
    length: t,
    offset: t + 1
  });
  const s = new Uint8Array(t);
  return s.fill(0), r ? s.set(n, t - n.length) : s.set(n, 0), Zr(s);
}
function oA(e, t) {
  return M4(e, t, !0);
}
function aA(e, t) {
  return M4(e, t, !1);
}
const Bh = BigInt(0), Hi = BigInt(1), Ou = 9007199254740991;
function uA(e, t) {
  const r = _h(e, "value"), n = BigInt(Xs(t, "width"));
  if (Yt(r >> n === Bh, "overflow", "NUMERIC_FAULT", {
    operation: "fromTwos",
    fault: "overflow",
    value: e
  }), r >> n - Hi) {
    const s = (Hi << n) - Hi;
    return -((~r & s) + Hi);
  }
  return r;
}
function cA(e, t) {
  let r = Ro(e, "value");
  const n = BigInt(Xs(t, "width")), s = Hi << n - Hi;
  if (r < Bh) {
    r = -r, Yt(r <= s, "too low", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: e
    });
    const i = (Hi << n) - Hi;
    return (~r & i) + Hi;
  } else
    Yt(r < s, "too high", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: e
    });
  return r;
}
function Nd(e, t) {
  const r = _h(e, "value"), n = BigInt(Xs(t, "bits"));
  return r & (Hi << n) - Hi;
}
function Ro(e, t) {
  switch (typeof e) {
    case "bigint":
      return e;
    case "number":
      return ct(Number.isInteger(e), "underflow", t || "value", e), ct(e >= -Ou && e <= Ou, "overflow", t || "value", e), BigInt(e);
    case "string":
      try {
        if (e === "")
          throw new Error("empty string");
        return e[0] === "-" && e[1] !== "-" ? -BigInt(e.substring(1)) : BigInt(e);
      } catch (r) {
        ct(!1, `invalid BigNumberish string: ${r.message}`, t || "value", e);
      }
  }
  ct(!1, "invalid BigNumberish value", t || "value", e);
}
function _h(e, t) {
  const r = Ro(e, t);
  return Yt(r >= Bh, "unsigned value cannot be negative", "NUMERIC_FAULT", {
    fault: "overflow",
    operation: "getUint",
    value: e
  }), r;
}
const xg = "0123456789abcdef";
function I4(e) {
  if (e instanceof Uint8Array) {
    let t = "0x0";
    for (const r of e)
      t += xg[r >> 4], t += xg[r & 15];
    return BigInt(t);
  }
  return Ro(e);
}
function Xs(e, t) {
  switch (typeof e) {
    case "bigint":
      return ct(e >= -Ou && e <= Ou, "overflow", t || "value", e), Number(e);
    case "number":
      return ct(Number.isInteger(e), "underflow", t || "value", e), ct(e >= -Ou && e <= Ou, "overflow", t || "value", e), e;
    case "string":
      try {
        if (e === "")
          throw new Error("empty string");
        return Xs(BigInt(e), t);
      } catch (r) {
        ct(!1, `invalid numeric string: ${r.message}`, t || "value", e);
      }
  }
  ct(!1, "invalid numeric value", t || "value", e);
}
function lA(e) {
  return Xs(I4(e));
}
function R4(e, t) {
  let n = _h(e, "value").toString(16);
  if (t == null)
    n.length % 2 && (n = "0" + n);
  else {
    const s = Xs(t, "width");
    for (Yt(s * 2 >= n.length, `value exceeds width (${s} bytes)`, "NUMERIC_FAULT", {
      operation: "toBeHex",
      fault: "overflow",
      value: e
    }); n.length < s * 2; )
      n = "0" + n;
  }
  return "0x" + n;
}
function dA(e) {
  const t = _h(e, "value");
  if (t === Bh)
    return new Uint8Array([]);
  let r = t.toString(16);
  r.length % 2 && (r = "0" + r);
  const n = new Uint8Array(r.length / 2);
  for (let s = 0; s < n.length; s++) {
    const i = s * 2;
    n[s] = parseInt(r.substring(i, i + 2), 16);
  }
  return n;
}
var Cu;
class hA {
  /**
   *  Create a new **EventPayload** for %%emitter%% with
   *  the %%listener%% and for %%filter%%.
   */
  constructor(t, r, n) {
    /**
     *  The event filter.
     */
    ze(this, "filter");
    /**
     *  The **EventEmitterable**.
     */
    ze(this, "emitter");
    Ar(this, Cu);
    mr(this, Cu, r), lr(this, { emitter: t, filter: n });
  }
  /**
   *  Unregister the triggered listener for future events.
   */
  async removeListener() {
    Xe(this, Cu) != null && await this.emitter.off(this.filter, Xe(this, Cu));
  }
}
Cu = new WeakMap();
function fA(e, t, r, n, s) {
  ct(!1, `invalid codepoint at offset ${t}; ${e}`, "bytes", r);
}
function C4(e, t, r, n, s) {
  if (e === "BAD_PREFIX" || e === "UNEXPECTED_CONTINUE") {
    let i = 0;
    for (let a = t + 1; a < r.length && r[a] >> 6 === 2; a++)
      i++;
    return i;
  }
  return e === "OVERRUN" ? r.length - t - 1 : 0;
}
function pA(e, t, r, n, s) {
  return e === "OVERLONG" ? (ct(typeof s == "number", "invalid bad code point for replacement", "badCodepoint", s), n.push(s), 0) : (n.push(65533), C4(e, t, r));
}
const gA = Object.freeze({
  error: fA,
  ignore: C4,
  replace: pA
});
function mA(e, t) {
  t == null && (t = gA.error);
  const r = Js(e, "bytes"), n = [];
  let s = 0;
  for (; s < r.length; ) {
    const i = r[s++];
    if (!(i >> 7)) {
      n.push(i);
      continue;
    }
    let a = null, f = null;
    if ((i & 224) === 192)
      a = 1, f = 127;
    else if ((i & 240) === 224)
      a = 2, f = 2047;
    else if ((i & 248) === 240)
      a = 3, f = 65535;
    else {
      (i & 192) === 128 ? s += t("UNEXPECTED_CONTINUE", s - 1, r, n) : s += t("BAD_PREFIX", s - 1, r, n);
      continue;
    }
    if (s - 1 + a >= r.length) {
      s += t("OVERRUN", s - 1, r, n);
      continue;
    }
    let d = i & (1 << 8 - a - 1) - 1;
    for (let c = 0; c < a; c++) {
      let p = r[s];
      if ((p & 192) != 128) {
        s += t("MISSING_CONTINUE", s, r, n), d = null;
        break;
      }
      d = d << 6 | p & 63, s++;
    }
    if (d !== null) {
      if (d > 1114111) {
        s += t("OUT_OF_RANGE", s - 1 - a, r, n, d);
        continue;
      }
      if (d >= 55296 && d <= 57343) {
        s += t("UTF16_SURROGATE", s - 1 - a, r, n, d);
        continue;
      }
      if (d <= f) {
        s += t("OVERLONG", s - 1 - a, r, n, d);
        continue;
      }
      n.push(d);
    }
  }
  return n;
}
function B4(e, t) {
  ct(typeof e == "string", "invalid string value", "str", e);
  let r = [];
  for (let n = 0; n < e.length; n++) {
    const s = e.charCodeAt(n);
    if (s < 128)
      r.push(s);
    else if (s < 2048)
      r.push(s >> 6 | 192), r.push(s & 63 | 128);
    else if ((s & 64512) == 55296) {
      n++;
      const i = e.charCodeAt(n);
      ct(n < e.length && (i & 64512) === 56320, "invalid surrogate pair", "str", e);
      const a = 65536 + ((s & 1023) << 10) + (i & 1023);
      r.push(a >> 18 | 240), r.push(a >> 12 & 63 | 128), r.push(a >> 6 & 63 | 128), r.push(a & 63 | 128);
    } else
      r.push(s >> 12 | 224), r.push(s >> 6 & 63 | 128), r.push(s & 63 | 128);
  }
  return new Uint8Array(r);
}
function yA(e) {
  return e.map((t) => t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10 & 1023) + 55296, (t & 1023) + 56320))).join("");
}
function bA(e, t) {
  return yA(mA(e, t));
}
const Nn = 32, ip = new Uint8Array(Nn), wA = ["then"], xd = {}, _4 = /* @__PURE__ */ new WeakMap();
function Da(e) {
  return _4.get(e);
}
function Tg(e, t) {
  _4.set(e, t);
}
function cc(e, t) {
  const r = new Error(`deferred error during ABI decoding triggered accessing ${e}`);
  throw r.error = t, r;
}
function sp(e, t, r) {
  return e.indexOf(null) >= 0 ? t.map((n, s) => n instanceof Hu ? sp(Da(n), n, r) : n) : e.reduce((n, s, i) => {
    let a = t.getValue(s);
    return s in n || (r && a instanceof Hu && (a = sp(Da(a), a, r)), n[s] = a), n;
  }, {});
}
var Bu;
const xu = class xu extends Array {
  /**
   *  @private
   */
  constructor(...r) {
    const n = r[0];
    let s = r[1], i = (r[2] || []).slice(), a = !0;
    n !== xd && (s = r, i = [], a = !1);
    super(s.length);
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    Ar(this, Bu);
    s.forEach((c, p) => {
      this[p] = c;
    });
    const f = i.reduce((c, p) => (typeof p == "string" && c.set(p, (c.get(p) || 0) + 1), c), /* @__PURE__ */ new Map());
    if (Tg(this, Object.freeze(s.map((c, p) => {
      const g = i[p];
      return g != null && f.get(g) === 1 ? g : null;
    }))), mr(this, Bu, []), Xe(this, Bu) == null && Xe(this, Bu), !a)
      return;
    Object.freeze(this);
    const d = new Proxy(this, {
      get: (c, p, g) => {
        if (typeof p == "string") {
          if (p.match(/^[0-9]+$/)) {
            const O = Xs(p, "%index");
            if (O < 0 || O >= this.length)
              throw new RangeError("out of result range");
            const N = c[O];
            return N instanceof Error && cc(`index ${O}`, N), N;
          }
          if (wA.indexOf(p) >= 0)
            return Reflect.get(c, p, g);
          const v = c[p];
          if (v instanceof Function)
            return function(...O) {
              return v.apply(this === g ? c : this, O);
            };
          if (!(p in c))
            return c.getValue.apply(this === g ? c : this, [p]);
        }
        return Reflect.get(c, p, g);
      }
    });
    return Tg(d, Da(this)), d;
  }
  /**
   *  Returns the Result as a normal Array. If %%deep%%, any children
   *  which are Result objects are also converted to a normal Array.
   *
   *  This will throw if there are any outstanding deferred
   *  errors.
   */
  toArray(r) {
    const n = [];
    return this.forEach((s, i) => {
      s instanceof Error && cc(`index ${i}`, s), r && s instanceof xu && (s = s.toArray(r)), n.push(s);
    }), n;
  }
  /**
   *  Returns the Result as an Object with each name-value pair. If
   *  %%deep%%, any children which are Result objects are also
   *  converted to an Object.
   *
   *  This will throw if any value is unnamed, or if there are
   *  any outstanding deferred errors.
   */
  toObject(r) {
    const n = Da(this);
    return n.reduce((s, i, a) => (Yt(i != null, `value at index ${a} unnamed`, "UNSUPPORTED_OPERATION", {
      operation: "toObject()"
    }), sp(n, this, r)), {});
  }
  /**
   *  @_ignore
   */
  slice(r, n) {
    r == null && (r = 0), r < 0 && (r += this.length, r < 0 && (r = 0)), n == null && (n = this.length), n < 0 && (n += this.length, n < 0 && (n = 0)), n > this.length && (n = this.length);
    const s = Da(this), i = [], a = [];
    for (let f = r; f < n; f++)
      i.push(this[f]), a.push(s[f]);
    return new xu(xd, i, a);
  }
  /**
   *  @_ignore
   */
  filter(r, n) {
    const s = Da(this), i = [], a = [];
    for (let f = 0; f < this.length; f++) {
      const d = this[f];
      d instanceof Error && cc(`index ${f}`, d), r.call(n, d, f, this) && (i.push(d), a.push(s[f]));
    }
    return new xu(xd, i, a);
  }
  /**
   *  @_ignore
   */
  map(r, n) {
    const s = [];
    for (let i = 0; i < this.length; i++) {
      const a = this[i];
      a instanceof Error && cc(`index ${i}`, a), s.push(r.call(n, a, i, this));
    }
    return s;
  }
  /**
   *  Returns the value for %%name%%.
   *
   *  Since it is possible to have a key whose name conflicts with
   *  a method on a [[Result]] or its superclass Array, or any
   *  JavaScript keyword, this ensures all named values are still
   *  accessible by name.
   */
  getValue(r) {
    const n = Da(this).indexOf(r);
    if (n === -1)
      return;
    const s = this[n];
    return s instanceof Error && cc(`property ${JSON.stringify(r)}`, s.error), s;
  }
  /**
   *  Creates a new [[Result]] for %%items%% with each entry
   *  also accessible by its corresponding name in %%keys%%.
   */
  static fromItems(r, n) {
    return new xu(xd, r, n);
  }
};
Bu = new WeakMap();
let Hu = xu;
function kg(e) {
  let t = dA(e);
  return Yt(t.length <= Nn, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: t, length: Nn, offset: t.length }), t.length !== Nn && (t = fs(ku([ip.slice(t.length % Nn), t]))), t;
}
class eo {
  constructor(t, r, n, s) {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    ze(this, "name");
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    ze(this, "type");
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    ze(this, "localName");
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    ze(this, "dynamic");
    lr(this, { name: t, type: r, localName: n, dynamic: s }, {
      name: "string",
      type: "string",
      localName: "string",
      dynamic: "boolean"
    });
  }
  _throwError(t, r) {
    ct(!1, t, this.localName, r);
  }
}
var Ws, Ga, _u, Vd;
class op {
  constructor() {
    Ar(this, _u);
    // An array of WordSize lengthed objects to concatenation
    Ar(this, Ws);
    Ar(this, Ga);
    mr(this, Ws, []), mr(this, Ga, 0);
  }
  get data() {
    return ku(Xe(this, Ws));
  }
  get length() {
    return Xe(this, Ga);
  }
  appendWriter(t) {
    return Br(this, _u, Vd).call(this, fs(t.data));
  }
  // Arrayish item; pad on the right to *nearest* WordSize
  writeBytes(t) {
    let r = fs(t);
    const n = r.length % Nn;
    return n && (r = fs(ku([r, ip.slice(n)]))), Br(this, _u, Vd).call(this, r);
  }
  // Numeric item; pad on the left *to* WordSize
  writeValue(t) {
    return Br(this, _u, Vd).call(this, kg(t));
  }
  // Inserts a numeric place-holder, returning a callback that can
  // be used to asjust the value later
  writeUpdatableValue() {
    const t = Xe(this, Ws).length;
    return Xe(this, Ws).push(ip), mr(this, Ga, Xe(this, Ga) + Nn), (r) => {
      Xe(this, Ws)[t] = kg(r);
    };
  }
}
Ws = new WeakMap(), Ga = new WeakMap(), _u = new WeakSet(), Vd = function(t) {
  return Xe(this, Ws).push(t), mr(this, Ga, Xe(this, Ga) + t.length), t.length;
};
var In, Qn, za, Va, wo, tu, up, F4;
const ag = class ag {
  constructor(t, r, n) {
    Ar(this, tu);
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    ze(this, "allowLoose");
    Ar(this, In);
    Ar(this, Qn);
    Ar(this, za);
    Ar(this, Va);
    Ar(this, wo);
    lr(this, { allowLoose: !!r }), mr(this, In, fs(t)), mr(this, za, 0), mr(this, Va, null), mr(this, wo, n ?? 1024), mr(this, Qn, 0);
  }
  get data() {
    return Zr(Xe(this, In));
  }
  get dataLength() {
    return Xe(this, In).length;
  }
  get consumed() {
    return Xe(this, Qn);
  }
  get bytes() {
    return new Uint8Array(Xe(this, In));
  }
  // Create a sub-reader with the same underlying data, but offset
  subReader(t) {
    const r = new ag(Xe(this, In).slice(Xe(this, Qn) + t), this.allowLoose, Xe(this, wo));
    return mr(r, Va, this), r;
  }
  // Read bytes
  readBytes(t, r) {
    let n = Br(this, tu, F4).call(this, 0, t, !!r);
    return Br(this, tu, up).call(this, t), mr(this, Qn, Xe(this, Qn) + n.length), n.slice(0, t);
  }
  // Read a numeric values
  readValue() {
    return I4(this.readBytes(Nn));
  }
  readIndex() {
    return lA(this.readBytes(Nn));
  }
};
In = new WeakMap(), Qn = new WeakMap(), za = new WeakMap(), Va = new WeakMap(), wo = new WeakMap(), tu = new WeakSet(), up = function(t) {
  var r;
  if (Xe(this, Va))
    return Br(r = Xe(this, Va), tu, up).call(r, t);
  mr(this, za, Xe(this, za) + t), Yt(Xe(this, wo) < 1 || Xe(this, za) <= Xe(this, wo) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${Xe(this, wo)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
    buffer: fs(Xe(this, In)),
    offset: Xe(this, Qn),
    length: t,
    info: {
      bytesRead: Xe(this, za),
      dataLength: this.dataLength
    }
  });
}, F4 = function(t, r, n) {
  let s = Math.ceil(r / Nn) * Nn;
  return Xe(this, Qn) + s > Xe(this, In).length && (this.allowLoose && n && Xe(this, Qn) + r <= Xe(this, In).length ? s = r : Yt(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
    buffer: fs(Xe(this, In)),
    length: Xe(this, In).length,
    offset: Xe(this, Qn) + s
  })), Xe(this, In).slice(Xe(this, Qn), Xe(this, Qn) + s);
};
let ap = ag;
function Sg(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function U4(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function Mg(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function vA(e, t) {
  U4(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const AA = (e) => e instanceof Uint8Array, EA = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), PA = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!PA)
  throw new Error("Non little-endian hardware is not supported");
function OA(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function D4(e) {
  if (typeof e == "string" && (e = OA(e)), !AA(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
class NA {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function xA(e) {
  const t = (n) => e().update(D4(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
const Td = /* @__PURE__ */ BigInt(2 ** 32 - 1), Ig = /* @__PURE__ */ BigInt(32);
function TA(e, t = !1) {
  return t ? { h: Number(e & Td), l: Number(e >> Ig & Td) } : { h: Number(e >> Ig & Td) | 0, l: Number(e & Td) | 0 };
}
function kA(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let s = 0; s < e.length; s++) {
    const { h: i, l: a } = TA(e[s], t);
    [r[s], n[s]] = [i, a];
  }
  return [r, n];
}
const SA = (e, t, r) => e << r | t >>> 32 - r, MA = (e, t, r) => t << r | e >>> 32 - r, IA = (e, t, r) => t << r - 32 | e >>> 64 - r, RA = (e, t, r) => e << r - 32 | t >>> 64 - r, [j4, L4, H4] = [[], [], []], CA = /* @__PURE__ */ BigInt(0), lc = /* @__PURE__ */ BigInt(1), BA = /* @__PURE__ */ BigInt(2), _A = /* @__PURE__ */ BigInt(7), FA = /* @__PURE__ */ BigInt(256), UA = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = lc, r = 1, n = 0; e < 24; e++) {
  [r, n] = [n, (2 * r + 3 * n) % 5], j4.push(2 * (5 * n + r)), L4.push((e + 1) * (e + 2) / 2 % 64);
  let s = CA;
  for (let i = 0; i < 7; i++)
    t = (t << lc ^ (t >> _A) * UA) % FA, t & BA && (s ^= lc << (lc << /* @__PURE__ */ BigInt(i)) - lc);
  H4.push(s);
}
const [DA, jA] = /* @__PURE__ */ kA(H4, !0), Rg = (e, t, r) => r > 32 ? IA(e, t, r) : SA(e, t, r), Cg = (e, t, r) => r > 32 ? RA(e, t, r) : MA(e, t, r);
function LA(e, t = 24) {
  const r = new Uint32Array(10);
  for (let n = 24 - t; n < 24; n++) {
    for (let a = 0; a < 10; a++)
      r[a] = e[a] ^ e[a + 10] ^ e[a + 20] ^ e[a + 30] ^ e[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const f = (a + 8) % 10, d = (a + 2) % 10, c = r[d], p = r[d + 1], g = Rg(c, p, 1) ^ r[f], v = Cg(c, p, 1) ^ r[f + 1];
      for (let O = 0; O < 50; O += 10)
        e[a + O] ^= g, e[a + O + 1] ^= v;
    }
    let s = e[2], i = e[3];
    for (let a = 0; a < 24; a++) {
      const f = L4[a], d = Rg(s, i, f), c = Cg(s, i, f), p = j4[a];
      s = e[p], i = e[p + 1], e[p] = d, e[p + 1] = c;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let f = 0; f < 10; f++)
        r[f] = e[a + f];
      for (let f = 0; f < 10; f++)
        e[a + f] ^= ~r[(f + 2) % 10] & r[(f + 4) % 10];
    }
    e[0] ^= DA[n], e[1] ^= jA[n];
  }
  r.fill(0);
}
class t1 extends NA {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, r, n, s = !1, i = 24) {
    if (super(), this.blockLen = t, this.suffix = r, this.outputLen = n, this.enableXOF = s, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Sg(n), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = EA(this.state);
  }
  keccak() {
    LA(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    Mg(this);
    const { blockLen: r, state: n } = this;
    t = D4(t);
    const s = t.length;
    for (let i = 0; i < s; ) {
      const a = Math.min(r - this.pos, s - i);
      for (let f = 0; f < a; f++)
        n[this.pos++] ^= t[i++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: r, pos: n, blockLen: s } = this;
    t[n] ^= r, r & 128 && n === s - 1 && this.keccak(), t[s - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    Mg(this, !1), U4(t), this.finish();
    const r = this.state, { blockLen: n } = this;
    for (let s = 0, i = t.length; s < i; ) {
      this.posOut >= n && this.keccak();
      const a = Math.min(n - this.posOut, i - s);
      t.set(r.subarray(this.posOut, this.posOut + a), s), this.posOut += a, s += a;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return Sg(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (vA(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: r, suffix: n, outputLen: s, rounds: i, enableXOF: a } = this;
    return t || (t = new t1(r, n, s, a, i)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = i, t.suffix = n, t.outputLen = s, t.enableXOF = a, t.destroyed = this.destroyed, t;
  }
}
const HA = (e, t, r) => xA(() => new t1(t, e, r)), WA = /* @__PURE__ */ HA(1, 136, 256 / 8);
let W4 = !1;
const G4 = function(e) {
  return WA(e);
};
let z4 = G4;
function ko(e) {
  const t = Js(e, "data");
  return Zr(z4(t));
}
ko._ = G4;
ko.lock = function() {
  W4 = !0;
};
ko.register = function(e) {
  if (W4)
    throw new TypeError("keccak256 is locked");
  z4 = e;
};
Object.freeze(ko);
const GA = BigInt(0), zA = BigInt(36);
function Bg(e) {
  e = e.toLowerCase();
  const t = e.substring(2).split(""), r = new Uint8Array(40);
  for (let s = 0; s < 40; s++)
    r[s] = t[s].charCodeAt(0);
  const n = Js(ko(r));
  for (let s = 0; s < 40; s += 2)
    n[s >> 1] >> 4 >= 8 && (t[s] = t[s].toUpperCase()), (n[s >> 1] & 15) >= 8 && (t[s + 1] = t[s + 1].toUpperCase());
  return "0x" + t.join("");
}
const r1 = {};
for (let e = 0; e < 10; e++)
  r1[String(e)] = String(e);
for (let e = 0; e < 26; e++)
  r1[String.fromCharCode(65 + e)] = String(10 + e);
const _g = 15;
function VA(e) {
  e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
  let t = e.split("").map((n) => r1[n]).join("");
  for (; t.length >= _g; ) {
    let n = t.substring(0, _g);
    t = parseInt(n, 10) % 97 + t.substring(n.length);
  }
  let r = String(98 - parseInt(t, 10) % 97);
  for (; r.length < 2; )
    r = "0" + r;
  return r;
}
const qA = function() {
  const e = {};
  for (let t = 0; t < 36; t++) {
    const r = "0123456789abcdefghijklmnopqrstuvwxyz"[t];
    e[r] = BigInt(t);
  }
  return e;
}();
function $A(e) {
  e = e.toLowerCase();
  let t = GA;
  for (let r = 0; r < e.length; r++)
    t = t * zA + qA[e[r]];
  return t;
}
function So(e) {
  if (ct(typeof e == "string", "invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    e.startsWith("0x") || (e = "0x" + e);
    const t = Bg(e);
    return ct(!e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || t === e, "bad address checksum", "address", e), t;
  }
  if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    ct(e.substring(2, 4) === VA(e), "bad icap checksum", "address", e);
    let t = $A(e.substring(4)).toString(16);
    for (; t.length < 40; )
      t = "0" + t;
    return Bg("0x" + t);
  }
  ct(!1, "invalid address", "address", e);
}
function V4(e) {
  return e && typeof e.getAddress == "function";
}
function KA(e) {
  try {
    return So(e), !0;
  } catch {
  }
  return !1;
}
async function Nf(e, t) {
  const r = await t;
  return (r == null || r === "0x0000000000000000000000000000000000000000") && (Yt(typeof e != "string", "unconfigured name", "UNCONFIGURED_NAME", { value: e }), ct(!1, "invalid AddressLike value; did not resolve to a value address", "target", e)), So(r);
}
function G0(e, t) {
  if (typeof e == "string")
    return e.match(/^0x[0-9a-f]{40}$/i) ? So(e) : (Yt(t != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" }), Nf(e, t.resolveName(e)));
  if (V4(e))
    return Nf(e, e.getAddress());
  if (e && typeof e.then == "function")
    return Nf(e, e);
  ct(!1, "unsupported addressable value", "target", e);
}
const Us = {};
function Et(e, t) {
  let r = !1;
  return t < 0 && (r = !0, t *= -1), new gn(Us, `${r ? "" : "u"}int${t}`, e, { signed: r, width: t });
}
function br(e, t) {
  return new gn(Us, `bytes${t || ""}`, e, { size: t });
}
const Fg = Symbol.for("_ethers_typed");
var qa;
const Ls = class Ls {
  /**
   *  @_ignore:
   */
  constructor(t, r, n, s) {
    /**
     *  The type, as a Solidity-compatible type.
     */
    ze(this, "type");
    /**
     *  The actual value.
     */
    ze(this, "value");
    Ar(this, qa);
    /**
     *  @_ignore:
     */
    ze(this, "_typedSymbol");
    s == null && (s = null), Zp(Us, t, "Typed"), lr(this, { _typedSymbol: Fg, type: r, value: n }), mr(this, qa, s), this.format();
  }
  /**
   *  Format the type as a Human-Readable type.
   */
  format() {
    if (this.type === "array")
      throw new Error("");
    if (this.type === "dynamicArray")
      throw new Error("");
    return this.type === "tuple" ? `tuple(${this.value.map((t) => t.format()).join(",")})` : this.type;
  }
  /**
   *  The default value returned by this type.
   */
  defaultValue() {
    return 0;
  }
  /**
   *  The minimum value for numeric types.
   */
  minValue() {
    return 0;
  }
  /**
   *  The maximum value for numeric types.
   */
  maxValue() {
    return 0;
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
   */
  isBigInt() {
    return !!this.type.match(/^u?int[0-9]+$/);
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
   */
  isData() {
    return this.type.startsWith("bytes");
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
   */
  isString() {
    return this.type === "string";
  }
  /**
   *  Returns the tuple name, if this is a tuple. Throws otherwise.
   */
  get tupleName() {
    if (this.type !== "tuple")
      throw TypeError("not a tuple");
    return Xe(this, qa);
  }
  // Returns the length of this type as an array
  // - `null` indicates the length is unforced, it could be dynamic
  // - `-1` indicates the length is dynamic
  // - any other value indicates it is a static array and is its length
  /**
   *  Returns the length of the array type or ``-1`` if it is dynamic.
   *
   *  Throws if the type is not an array.
   */
  get arrayLength() {
    if (this.type !== "array")
      throw TypeError("not an array");
    return Xe(this, qa) === !0 ? -1 : Xe(this, qa) === !1 ? this.value.length : null;
  }
  /**
   *  Returns a new **Typed** of %%type%% with the %%value%%.
   */
  static from(t, r) {
    return new Ls(Us, t, r);
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static uint8(t) {
    return Et(t, 8);
  }
  /**
   *  Return a new ``uint16`` type for %%v%%.
   */
  static uint16(t) {
    return Et(t, 16);
  }
  /**
   *  Return a new ``uint24`` type for %%v%%.
   */
  static uint24(t) {
    return Et(t, 24);
  }
  /**
   *  Return a new ``uint32`` type for %%v%%.
   */
  static uint32(t) {
    return Et(t, 32);
  }
  /**
   *  Return a new ``uint40`` type for %%v%%.
   */
  static uint40(t) {
    return Et(t, 40);
  }
  /**
   *  Return a new ``uint48`` type for %%v%%.
   */
  static uint48(t) {
    return Et(t, 48);
  }
  /**
   *  Return a new ``uint56`` type for %%v%%.
   */
  static uint56(t) {
    return Et(t, 56);
  }
  /**
   *  Return a new ``uint64`` type for %%v%%.
   */
  static uint64(t) {
    return Et(t, 64);
  }
  /**
   *  Return a new ``uint72`` type for %%v%%.
   */
  static uint72(t) {
    return Et(t, 72);
  }
  /**
   *  Return a new ``uint80`` type for %%v%%.
   */
  static uint80(t) {
    return Et(t, 80);
  }
  /**
   *  Return a new ``uint88`` type for %%v%%.
   */
  static uint88(t) {
    return Et(t, 88);
  }
  /**
   *  Return a new ``uint96`` type for %%v%%.
   */
  static uint96(t) {
    return Et(t, 96);
  }
  /**
   *  Return a new ``uint104`` type for %%v%%.
   */
  static uint104(t) {
    return Et(t, 104);
  }
  /**
   *  Return a new ``uint112`` type for %%v%%.
   */
  static uint112(t) {
    return Et(t, 112);
  }
  /**
   *  Return a new ``uint120`` type for %%v%%.
   */
  static uint120(t) {
    return Et(t, 120);
  }
  /**
   *  Return a new ``uint128`` type for %%v%%.
   */
  static uint128(t) {
    return Et(t, 128);
  }
  /**
   *  Return a new ``uint136`` type for %%v%%.
   */
  static uint136(t) {
    return Et(t, 136);
  }
  /**
   *  Return a new ``uint144`` type for %%v%%.
   */
  static uint144(t) {
    return Et(t, 144);
  }
  /**
   *  Return a new ``uint152`` type for %%v%%.
   */
  static uint152(t) {
    return Et(t, 152);
  }
  /**
   *  Return a new ``uint160`` type for %%v%%.
   */
  static uint160(t) {
    return Et(t, 160);
  }
  /**
   *  Return a new ``uint168`` type for %%v%%.
   */
  static uint168(t) {
    return Et(t, 168);
  }
  /**
   *  Return a new ``uint176`` type for %%v%%.
   */
  static uint176(t) {
    return Et(t, 176);
  }
  /**
   *  Return a new ``uint184`` type for %%v%%.
   */
  static uint184(t) {
    return Et(t, 184);
  }
  /**
   *  Return a new ``uint192`` type for %%v%%.
   */
  static uint192(t) {
    return Et(t, 192);
  }
  /**
   *  Return a new ``uint200`` type for %%v%%.
   */
  static uint200(t) {
    return Et(t, 200);
  }
  /**
   *  Return a new ``uint208`` type for %%v%%.
   */
  static uint208(t) {
    return Et(t, 208);
  }
  /**
   *  Return a new ``uint216`` type for %%v%%.
   */
  static uint216(t) {
    return Et(t, 216);
  }
  /**
   *  Return a new ``uint224`` type for %%v%%.
   */
  static uint224(t) {
    return Et(t, 224);
  }
  /**
   *  Return a new ``uint232`` type for %%v%%.
   */
  static uint232(t) {
    return Et(t, 232);
  }
  /**
   *  Return a new ``uint240`` type for %%v%%.
   */
  static uint240(t) {
    return Et(t, 240);
  }
  /**
   *  Return a new ``uint248`` type for %%v%%.
   */
  static uint248(t) {
    return Et(t, 248);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint256(t) {
    return Et(t, 256);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint(t) {
    return Et(t, 256);
  }
  /**
   *  Return a new ``int8`` type for %%v%%.
   */
  static int8(t) {
    return Et(t, -8);
  }
  /**
   *  Return a new ``int16`` type for %%v%%.
   */
  static int16(t) {
    return Et(t, -16);
  }
  /**
   *  Return a new ``int24`` type for %%v%%.
   */
  static int24(t) {
    return Et(t, -24);
  }
  /**
   *  Return a new ``int32`` type for %%v%%.
   */
  static int32(t) {
    return Et(t, -32);
  }
  /**
   *  Return a new ``int40`` type for %%v%%.
   */
  static int40(t) {
    return Et(t, -40);
  }
  /**
   *  Return a new ``int48`` type for %%v%%.
   */
  static int48(t) {
    return Et(t, -48);
  }
  /**
   *  Return a new ``int56`` type for %%v%%.
   */
  static int56(t) {
    return Et(t, -56);
  }
  /**
   *  Return a new ``int64`` type for %%v%%.
   */
  static int64(t) {
    return Et(t, -64);
  }
  /**
   *  Return a new ``int72`` type for %%v%%.
   */
  static int72(t) {
    return Et(t, -72);
  }
  /**
   *  Return a new ``int80`` type for %%v%%.
   */
  static int80(t) {
    return Et(t, -80);
  }
  /**
   *  Return a new ``int88`` type for %%v%%.
   */
  static int88(t) {
    return Et(t, -88);
  }
  /**
   *  Return a new ``int96`` type for %%v%%.
   */
  static int96(t) {
    return Et(t, -96);
  }
  /**
   *  Return a new ``int104`` type for %%v%%.
   */
  static int104(t) {
    return Et(t, -104);
  }
  /**
   *  Return a new ``int112`` type for %%v%%.
   */
  static int112(t) {
    return Et(t, -112);
  }
  /**
   *  Return a new ``int120`` type for %%v%%.
   */
  static int120(t) {
    return Et(t, -120);
  }
  /**
   *  Return a new ``int128`` type for %%v%%.
   */
  static int128(t) {
    return Et(t, -128);
  }
  /**
   *  Return a new ``int136`` type for %%v%%.
   */
  static int136(t) {
    return Et(t, -136);
  }
  /**
   *  Return a new ``int144`` type for %%v%%.
   */
  static int144(t) {
    return Et(t, -144);
  }
  /**
   *  Return a new ``int52`` type for %%v%%.
   */
  static int152(t) {
    return Et(t, -152);
  }
  /**
   *  Return a new ``int160`` type for %%v%%.
   */
  static int160(t) {
    return Et(t, -160);
  }
  /**
   *  Return a new ``int168`` type for %%v%%.
   */
  static int168(t) {
    return Et(t, -168);
  }
  /**
   *  Return a new ``int176`` type for %%v%%.
   */
  static int176(t) {
    return Et(t, -176);
  }
  /**
   *  Return a new ``int184`` type for %%v%%.
   */
  static int184(t) {
    return Et(t, -184);
  }
  /**
   *  Return a new ``int92`` type for %%v%%.
   */
  static int192(t) {
    return Et(t, -192);
  }
  /**
   *  Return a new ``int200`` type for %%v%%.
   */
  static int200(t) {
    return Et(t, -200);
  }
  /**
   *  Return a new ``int208`` type for %%v%%.
   */
  static int208(t) {
    return Et(t, -208);
  }
  /**
   *  Return a new ``int216`` type for %%v%%.
   */
  static int216(t) {
    return Et(t, -216);
  }
  /**
   *  Return a new ``int224`` type for %%v%%.
   */
  static int224(t) {
    return Et(t, -224);
  }
  /**
   *  Return a new ``int232`` type for %%v%%.
   */
  static int232(t) {
    return Et(t, -232);
  }
  /**
   *  Return a new ``int240`` type for %%v%%.
   */
  static int240(t) {
    return Et(t, -240);
  }
  /**
   *  Return a new ``int248`` type for %%v%%.
   */
  static int248(t) {
    return Et(t, -248);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int256(t) {
    return Et(t, -256);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int(t) {
    return Et(t, -256);
  }
  /**
   *  Return a new ``bytes1`` type for %%v%%.
   */
  static bytes1(t) {
    return br(t, 1);
  }
  /**
   *  Return a new ``bytes2`` type for %%v%%.
   */
  static bytes2(t) {
    return br(t, 2);
  }
  /**
   *  Return a new ``bytes3`` type for %%v%%.
   */
  static bytes3(t) {
    return br(t, 3);
  }
  /**
   *  Return a new ``bytes4`` type for %%v%%.
   */
  static bytes4(t) {
    return br(t, 4);
  }
  /**
   *  Return a new ``bytes5`` type for %%v%%.
   */
  static bytes5(t) {
    return br(t, 5);
  }
  /**
   *  Return a new ``bytes6`` type for %%v%%.
   */
  static bytes6(t) {
    return br(t, 6);
  }
  /**
   *  Return a new ``bytes7`` type for %%v%%.
   */
  static bytes7(t) {
    return br(t, 7);
  }
  /**
   *  Return a new ``bytes8`` type for %%v%%.
   */
  static bytes8(t) {
    return br(t, 8);
  }
  /**
   *  Return a new ``bytes9`` type for %%v%%.
   */
  static bytes9(t) {
    return br(t, 9);
  }
  /**
   *  Return a new ``bytes10`` type for %%v%%.
   */
  static bytes10(t) {
    return br(t, 10);
  }
  /**
   *  Return a new ``bytes11`` type for %%v%%.
   */
  static bytes11(t) {
    return br(t, 11);
  }
  /**
   *  Return a new ``bytes12`` type for %%v%%.
   */
  static bytes12(t) {
    return br(t, 12);
  }
  /**
   *  Return a new ``bytes13`` type for %%v%%.
   */
  static bytes13(t) {
    return br(t, 13);
  }
  /**
   *  Return a new ``bytes14`` type for %%v%%.
   */
  static bytes14(t) {
    return br(t, 14);
  }
  /**
   *  Return a new ``bytes15`` type for %%v%%.
   */
  static bytes15(t) {
    return br(t, 15);
  }
  /**
   *  Return a new ``bytes16`` type for %%v%%.
   */
  static bytes16(t) {
    return br(t, 16);
  }
  /**
   *  Return a new ``bytes17`` type for %%v%%.
   */
  static bytes17(t) {
    return br(t, 17);
  }
  /**
   *  Return a new ``bytes18`` type for %%v%%.
   */
  static bytes18(t) {
    return br(t, 18);
  }
  /**
   *  Return a new ``bytes19`` type for %%v%%.
   */
  static bytes19(t) {
    return br(t, 19);
  }
  /**
   *  Return a new ``bytes20`` type for %%v%%.
   */
  static bytes20(t) {
    return br(t, 20);
  }
  /**
   *  Return a new ``bytes21`` type for %%v%%.
   */
  static bytes21(t) {
    return br(t, 21);
  }
  /**
   *  Return a new ``bytes22`` type for %%v%%.
   */
  static bytes22(t) {
    return br(t, 22);
  }
  /**
   *  Return a new ``bytes23`` type for %%v%%.
   */
  static bytes23(t) {
    return br(t, 23);
  }
  /**
   *  Return a new ``bytes24`` type for %%v%%.
   */
  static bytes24(t) {
    return br(t, 24);
  }
  /**
   *  Return a new ``bytes25`` type for %%v%%.
   */
  static bytes25(t) {
    return br(t, 25);
  }
  /**
   *  Return a new ``bytes26`` type for %%v%%.
   */
  static bytes26(t) {
    return br(t, 26);
  }
  /**
   *  Return a new ``bytes27`` type for %%v%%.
   */
  static bytes27(t) {
    return br(t, 27);
  }
  /**
   *  Return a new ``bytes28`` type for %%v%%.
   */
  static bytes28(t) {
    return br(t, 28);
  }
  /**
   *  Return a new ``bytes29`` type for %%v%%.
   */
  static bytes29(t) {
    return br(t, 29);
  }
  /**
   *  Return a new ``bytes30`` type for %%v%%.
   */
  static bytes30(t) {
    return br(t, 30);
  }
  /**
   *  Return a new ``bytes31`` type for %%v%%.
   */
  static bytes31(t) {
    return br(t, 31);
  }
  /**
   *  Return a new ``bytes32`` type for %%v%%.
   */
  static bytes32(t) {
    return br(t, 32);
  }
  /**
   *  Return a new ``address`` type for %%v%%.
   */
  static address(t) {
    return new Ls(Us, "address", t);
  }
  /**
   *  Return a new ``bool`` type for %%v%%.
   */
  static bool(t) {
    return new Ls(Us, "bool", !!t);
  }
  /**
   *  Return a new ``bytes`` type for %%v%%.
   */
  static bytes(t) {
    return new Ls(Us, "bytes", t);
  }
  /**
   *  Return a new ``string`` type for %%v%%.
   */
  static string(t) {
    return new Ls(Us, "string", t);
  }
  /**
   *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
   */
  static array(t, r) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
   */
  static tuple(t, r) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static overrides(t) {
    return new Ls(Us, "overrides", Object.assign({}, t));
  }
  /**
   *  Returns true only if %%value%% is a [[Typed]] instance.
   */
  static isTyped(t) {
    return t && typeof t == "object" && "_typedSymbol" in t && t._typedSymbol === Fg;
  }
  /**
   *  If the value is a [[Typed]] instance, validates the underlying value
   *  and returns it, otherwise returns value directly.
   *
   *  This is useful for functions that with to accept either a [[Typed]]
   *  object or values.
   */
  static dereference(t, r) {
    if (Ls.isTyped(t)) {
      if (t.type !== r)
        throw new Error(`invalid type: expecetd ${r}, got ${t.type}`);
      return t.value;
    }
    return t;
  }
};
qa = new WeakMap();
let gn = Ls;
class JA extends eo {
  constructor(t) {
    super("address", "address", t, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(t, r) {
    let n = gn.dereference(r, "string");
    try {
      n = So(n);
    } catch (s) {
      return this._throwError(s.message, r);
    }
    return t.writeValue(n);
  }
  decode(t) {
    return So(R4(t.readValue(), 20));
  }
}
class QA extends eo {
  constructor(r) {
    super(r.name, r.type, "_", r.dynamic);
    ze(this, "coder");
    this.coder = r;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(r, n) {
    return this.coder.encode(r, n);
  }
  decode(r) {
    return this.coder.decode(r);
  }
}
function q4(e, t, r) {
  let n = [];
  if (Array.isArray(r))
    n = r;
  else if (r && typeof r == "object") {
    let d = {};
    n = t.map((c) => {
      const p = c.localName;
      return Yt(p, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder: c }, value: r }), Yt(!d[p], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder: c }, value: r }), d[p] = !0, r[p];
    });
  } else
    ct(!1, "invalid tuple value", "tuple", r);
  ct(t.length === n.length, "types/value length mismatch", "tuple", r);
  let s = new op(), i = new op(), a = [];
  t.forEach((d, c) => {
    let p = n[c];
    if (d.dynamic) {
      let g = i.length;
      d.encode(i, p);
      let v = s.writeUpdatableValue();
      a.push((O) => {
        v(O + g);
      });
    } else
      d.encode(s, p);
  }), a.forEach((d) => {
    d(s.length);
  });
  let f = e.appendWriter(s);
  return f += e.appendWriter(i), f;
}
function $4(e, t) {
  let r = [], n = [], s = e.subReader(0);
  return t.forEach((i) => {
    let a = null;
    if (i.dynamic) {
      let f = e.readIndex(), d = s.subReader(f);
      try {
        a = i.decode(d);
      } catch (c) {
        if (L0(c, "BUFFER_OVERRUN"))
          throw c;
        a = c, a.baseType = i.name, a.name = i.localName, a.type = i.type;
      }
    } else
      try {
        a = i.decode(e);
      } catch (f) {
        if (L0(f, "BUFFER_OVERRUN"))
          throw f;
        a = f, a.baseType = i.name, a.name = i.localName, a.type = i.type;
      }
    if (a == null)
      throw new Error("investigate");
    r.push(a), n.push(i.localName || null);
  }), Hu.fromItems(r, n);
}
class ZA extends eo {
  constructor(r, n, s) {
    const i = r.type + "[" + (n >= 0 ? n : "") + "]", a = n === -1 || r.dynamic;
    super("array", i, s, a);
    ze(this, "coder");
    ze(this, "length");
    lr(this, { coder: r, length: n });
  }
  defaultValue() {
    const r = this.coder.defaultValue(), n = [];
    for (let s = 0; s < this.length; s++)
      n.push(r);
    return n;
  }
  encode(r, n) {
    const s = gn.dereference(n, "array");
    Array.isArray(s) || this._throwError("expected array value", s);
    let i = this.length;
    i === -1 && (i = s.length, r.writeValue(s.length)), l4(s.length, i, "coder array" + (this.localName ? " " + this.localName : ""));
    let a = [];
    for (let f = 0; f < s.length; f++)
      a.push(this.coder);
    return q4(r, a, s);
  }
  decode(r) {
    let n = this.length;
    n === -1 && (n = r.readIndex(), Yt(n * Nn <= r.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: r.bytes, offset: n * Nn, length: r.dataLength }));
    let s = [];
    for (let i = 0; i < n; i++)
      s.push(new QA(this.coder));
    return $4(r, s);
  }
}
class YA extends eo {
  constructor(t) {
    super("bool", "bool", t, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(t, r) {
    const n = gn.dereference(r, "bool");
    return t.writeValue(n ? 1 : 0);
  }
  decode(t) {
    return !!t.readValue();
  }
}
class K4 extends eo {
  constructor(t, r) {
    super(t, t, r, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(t, r) {
    r = fs(r);
    let n = t.writeValue(r.length);
    return n += t.writeBytes(r), n;
  }
  decode(t) {
    return t.readBytes(t.readIndex(), !0);
  }
}
class XA extends K4 {
  constructor(t) {
    super("bytes", t);
  }
  decode(t) {
    return Zr(super.decode(t));
  }
}
class eE extends eo {
  constructor(r, n) {
    let s = "bytes" + String(r);
    super(s, s, n, !1);
    ze(this, "size");
    lr(this, { size: r }, { size: "number" });
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(r, n) {
    let s = fs(gn.dereference(n, this.type));
    return s.length !== this.size && this._throwError("incorrect data length", n), r.writeBytes(s);
  }
  decode(r) {
    return Zr(r.readBytes(this.size));
  }
}
const tE = new Uint8Array([]);
class rE extends eo {
  constructor(t) {
    super("null", "", t, !1);
  }
  defaultValue() {
    return null;
  }
  encode(t, r) {
    return r != null && this._throwError("not null", r), t.writeBytes(tE);
  }
  decode(t) {
    return t.readBytes(0), null;
  }
}
const nE = BigInt(0), iE = BigInt(1), sE = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class oE extends eo {
  constructor(r, n, s) {
    const i = (n ? "int" : "uint") + r * 8;
    super(i, i, s, !1);
    ze(this, "size");
    ze(this, "signed");
    lr(this, { size: r, signed: n }, { size: "number", signed: "boolean" });
  }
  defaultValue() {
    return 0;
  }
  encode(r, n) {
    let s = Ro(gn.dereference(n, this.type)), i = Nd(sE, Nn * 8);
    if (this.signed) {
      let a = Nd(i, this.size * 8 - 1);
      (s > a || s < -(a + iE)) && this._throwError("value out-of-bounds", n), s = cA(s, 8 * Nn);
    } else (s < nE || s > Nd(i, this.size * 8)) && this._throwError("value out-of-bounds", n);
    return r.writeValue(s);
  }
  decode(r) {
    let n = Nd(r.readValue(), this.size * 8);
    return this.signed && (n = uA(n, this.size * 8)), n;
  }
}
class aE extends K4 {
  constructor(t) {
    super("string", t);
  }
  defaultValue() {
    return "";
  }
  encode(t, r) {
    return super.encode(t, B4(gn.dereference(r, "string")));
  }
  decode(t) {
    return bA(super.decode(t));
  }
}
class kd extends eo {
  constructor(r, n) {
    let s = !1;
    const i = [];
    r.forEach((f) => {
      f.dynamic && (s = !0), i.push(f.type);
    });
    const a = "tuple(" + i.join(",") + ")";
    super("tuple", a, n, s);
    ze(this, "coders");
    lr(this, { coders: Object.freeze(r.slice()) });
  }
  defaultValue() {
    const r = [];
    this.coders.forEach((s) => {
      r.push(s.defaultValue());
    });
    const n = this.coders.reduce((s, i) => {
      const a = i.localName;
      return a && (s[a] || (s[a] = 0), s[a]++), s;
    }, {});
    return this.coders.forEach((s, i) => {
      let a = s.localName;
      !a || n[a] !== 1 || (a === "length" && (a = "_length"), r[a] == null && (r[a] = r[i]));
    }), Object.freeze(r);
  }
  encode(r, n) {
    const s = gn.dereference(n, "tuple");
    return q4(r, this.coders, s);
  }
  decode(r) {
    return $4(r, this.coders);
  }
}
function z0(e) {
  return ko(B4(e));
}
function xf(e, t) {
  return {
    address: So(e),
    storageKeys: t.map((r, n) => (ct(zs(r, 32), "invalid slot", `storageKeys[${n}]`, r), r.toLowerCase()))
  };
}
function uE(e) {
  if (Array.isArray(e))
    return e.map((r, n) => Array.isArray(r) ? (ct(r.length === 2, "invalid slot set", `value[${n}]`, r), xf(r[0], r[1])) : (ct(r != null && typeof r == "object", "invalid address-slot set", "value", e), xf(r.address, r.storageKeys)));
  ct(e != null && typeof e == "object", "invalid access list", "value", e);
  const t = Object.keys(e).map((r) => {
    const n = e[r].reduce((s, i) => (s[i] = !0, s), {});
    return xf(r, Object.keys(n).sort());
  });
  return t.sort((r, n) => r.address.localeCompare(n.address)), t;
}
function xn(e) {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((r) => t.add(r)), Object.freeze(t);
}
const cE = "external public payable override", lE = xn(cE.split(" ")), J4 = "constant external internal payable private public pure view override", dE = xn(J4.split(" ")), Q4 = "constructor error event fallback function receive struct", Z4 = xn(Q4.split(" ")), Y4 = "calldata memory storage payable indexed", hE = xn(Y4.split(" ")), fE = "tuple returns", pE = [Q4, Y4, fE, J4].join(" "), gE = xn(pE.split(" ")), mE = {
  "(": "OPEN_PAREN",
  ")": "CLOSE_PAREN",
  "[": "OPEN_BRACKET",
  "]": "CLOSE_BRACKET",
  ",": "COMMA",
  "@": "AT"
}, yE = new RegExp("^(\\s*)"), bE = new RegExp("^([0-9]+)"), wE = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), X4 = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), ev = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
var on, ji, nd, cp;
const Sh = class Sh {
  constructor(t) {
    Ar(this, nd);
    Ar(this, on);
    Ar(this, ji);
    mr(this, on, 0), mr(this, ji, t.slice());
  }
  get offset() {
    return Xe(this, on);
  }
  get length() {
    return Xe(this, ji).length - Xe(this, on);
  }
  clone() {
    return new Sh(Xe(this, ji));
  }
  reset() {
    mr(this, on, 0);
  }
  // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
  popKeyword(t) {
    const r = this.peek();
    if (r.type !== "KEYWORD" || !t.has(r.text))
      throw new Error(`expected keyword ${r.text}`);
    return this.pop().text;
  }
  // Pops and returns the value of the next token if it is `type`; throws if out of tokens
  popType(t) {
    if (this.peek().type !== t) {
      const r = this.peek();
      throw new Error(`expected ${t}; got ${r.type} ${JSON.stringify(r.text)}`);
    }
    return this.pop().text;
  }
  // Pops and returns a "(" TOKENS ")"
  popParen() {
    const t = this.peek();
    if (t.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const r = Br(this, nd, cp).call(this, Xe(this, on) + 1, t.match + 1);
    return mr(this, on, t.match + 1), r;
  }
  // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
  popParams() {
    const t = this.peek();
    if (t.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const r = [];
    for (; Xe(this, on) < t.match - 1; ) {
      const n = this.peek().linkNext;
      r.push(Br(this, nd, cp).call(this, Xe(this, on) + 1, n)), mr(this, on, n);
    }
    return mr(this, on, t.match + 1), r;
  }
  // Returns the top Token, throwing if out of tokens
  peek() {
    if (Xe(this, on) >= Xe(this, ji).length)
      throw new Error("out-of-bounds");
    return Xe(this, ji)[Xe(this, on)];
  }
  // Returns the next value, if it is a keyword in `allowed`
  peekKeyword(t) {
    const r = this.peekType("KEYWORD");
    return r != null && t.has(r) ? r : null;
  }
  // Returns the value of the next token if it is `type`
  peekType(t) {
    if (this.length === 0)
      return null;
    const r = this.peek();
    return r.type === t ? r.text : null;
  }
  // Returns the next token; throws if out of tokens
  pop() {
    const t = this.peek();
    return lg(this, on)._++, t;
  }
  toString() {
    const t = [];
    for (let r = Xe(this, on); r < Xe(this, ji).length; r++) {
      const n = Xe(this, ji)[r];
      t.push(`${n.type}:${n.text}`);
    }
    return `<TokenString ${t.join(" ")}>`;
  }
};
on = new WeakMap(), ji = new WeakMap(), nd = new WeakSet(), cp = function(t = 0, r = 0) {
  return new Sh(Xe(this, ji).slice(t, r).map((n) => Object.freeze(Object.assign({}, n, {
    match: n.match - t,
    linkBack: n.linkBack - t,
    linkNext: n.linkNext - t
  }))));
};
let zi = Sh;
function Co(e) {
  const t = [], r = (a) => {
    const f = i < e.length ? JSON.stringify(e[i]) : "$EOI";
    throw new Error(`invalid token ${f} at ${i}: ${a}`);
  };
  let n = [], s = [], i = 0;
  for (; i < e.length; ) {
    let a = e.substring(i), f = a.match(yE);
    f && (i += f[1].length, a = e.substring(i));
    const d = { depth: n.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset: i, value: -1 };
    t.push(d);
    let c = mE[a[0]] || "";
    if (c) {
      if (d.type = c, d.text = a[0], i++, c === "OPEN_PAREN")
        n.push(t.length - 1), s.push(t.length - 1);
      else if (c == "CLOSE_PAREN")
        n.length === 0 && r("no matching open bracket"), d.match = n.pop(), t[d.match].match = t.length - 1, d.depth--, d.linkBack = s.pop(), t[d.linkBack].linkNext = t.length - 1;
      else if (c === "COMMA")
        d.linkBack = s.pop(), t[d.linkBack].linkNext = t.length - 1, s.push(t.length - 1);
      else if (c === "OPEN_BRACKET")
        d.type = "BRACKET";
      else if (c === "CLOSE_BRACKET") {
        let p = t.pop().text;
        if (t.length > 0 && t[t.length - 1].type === "NUMBER") {
          const g = t.pop().text;
          p = g + p, t[t.length - 1].value = Xs(g);
        }
        if (t.length === 0 || t[t.length - 1].type !== "BRACKET")
          throw new Error("missing opening bracket");
        t[t.length - 1].text += p;
      }
      continue;
    }
    if (f = a.match(wE), f) {
      if (d.text = f[1], i += d.text.length, gE.has(d.text)) {
        d.type = "KEYWORD";
        continue;
      }
      if (d.text.match(ev)) {
        d.type = "TYPE";
        continue;
      }
      d.type = "ID";
      continue;
    }
    if (f = a.match(bE), f) {
      d.text = f[1], d.type = "NUMBER", i += d.text.length;
      continue;
    }
    throw new Error(`unexpected token ${JSON.stringify(a[0])} at position ${i}`);
  }
  return new zi(t.map((a) => Object.freeze(a)));
}
function Ug(e, t) {
  let r = [];
  for (const n in t.keys())
    e.has(n) && r.push(n);
  if (r.length > 1)
    throw new Error(`conflicting types: ${r.join(", ")}`);
}
function Fh(e, t) {
  if (t.peekKeyword(Z4)) {
    const r = t.pop().text;
    if (r !== e)
      throw new Error(`expected ${e}, got ${r}`);
  }
  return t.popType("ID");
}
function Qs(e, t) {
  const r = /* @__PURE__ */ new Set();
  for (; ; ) {
    const n = e.peekType("KEYWORD");
    if (n == null || t && !t.has(n))
      break;
    if (e.pop(), r.has(n))
      throw new Error(`duplicate keywords: ${JSON.stringify(n)}`);
    r.add(n);
  }
  return Object.freeze(r);
}
function tv(e) {
  let t = Qs(e, dE);
  return Ug(t, xn("constant payable nonpayable".split(" "))), Ug(t, xn("pure view payable nonpayable".split(" "))), t.has("view") ? "view" : t.has("pure") ? "pure" : t.has("payable") ? "payable" : t.has("nonpayable") ? "nonpayable" : t.has("constant") ? "view" : "nonpayable";
}
function $s(e, t) {
  return e.popParams().map((r) => un.from(r, t));
}
function rv(e) {
  if (e.peekType("AT")) {
    if (e.pop(), e.peekType("NUMBER"))
      return Ro(e.pop().text);
    throw new Error("invalid gas");
  }
  return null;
}
function Ja(e) {
  if (e.length)
    throw new Error(`unexpected tokens at offset ${e.offset}: ${e.toString()}`);
}
const vE = new RegExp(/^(.*)\[([0-9]*)\]$/);
function Dg(e) {
  const t = e.match(ev);
  if (ct(t, "invalid type", "type", e), e === "uint")
    return "uint256";
  if (e === "int")
    return "int256";
  if (t[2]) {
    const r = parseInt(t[2]);
    ct(r !== 0 && r <= 32, "invalid bytes length", "type", e);
  } else if (t[3]) {
    const r = parseInt(t[3]);
    ct(r !== 0 && r <= 256 && r % 8 === 0, "invalid numeric width", "type", e);
  }
  return e;
}
const Ur = {}, Bn = Symbol.for("_ethers_internal"), jg = "_ParamTypeInternal", Lg = "_ErrorInternal", Hg = "_EventInternal", Wg = "_ConstructorInternal", Gg = "_FallbackInternal", zg = "_FunctionInternal", Vg = "_StructInternal";
var Fu, qd;
const ci = class ci {
  /**
   *  @private
   */
  constructor(t, r, n, s, i, a, f, d) {
    Ar(this, Fu);
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */
    ze(this, "name");
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */
    ze(this, "type");
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */
    ze(this, "baseType");
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */
    ze(this, "indexed");
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */
    ze(this, "components");
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */
    ze(this, "arrayLength");
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */
    ze(this, "arrayChildren");
    if (Zp(t, Ur, "ParamType"), Object.defineProperty(this, Bn, { value: jg }), a && (a = Object.freeze(a.slice())), s === "array") {
      if (f == null || d == null)
        throw new Error("");
    } else if (f != null || d != null)
      throw new Error("");
    if (s === "tuple") {
      if (a == null)
        throw new Error("");
    } else if (a != null)
      throw new Error("");
    lr(this, {
      name: r,
      type: n,
      baseType: s,
      indexed: i,
      components: a,
      arrayLength: f,
      arrayChildren: d
    });
  }
  /**
   *  Return a string representation of this type.
   *
   *  For example,
   *
   *  ``sighash" => "(uint256,address)"``
   *
   *  ``"minimal" => "tuple(uint256,address) indexed"``
   *
   *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
   */
  format(t) {
    if (t == null && (t = "sighash"), t === "json") {
      const n = this.name || "";
      if (this.isArray()) {
        const i = JSON.parse(this.arrayChildren.format("json"));
        return i.name = n, i.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(i);
      }
      const s = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: n
      };
      return typeof this.indexed == "boolean" && (s.indexed = this.indexed), this.isTuple() && (s.components = this.components.map((i) => JSON.parse(i.format(t)))), JSON.stringify(s);
    }
    let r = "";
    return this.isArray() ? (r += this.arrayChildren.format(t), r += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? r += "(" + this.components.map((n) => n.format(t)).join(t === "full" ? ", " : ",") + ")" : r += this.type, t !== "sighash" && (this.indexed === !0 && (r += " indexed"), t === "full" && this.name && (r += " " + this.name)), r;
  }
  /**
   *  Returns true if %%this%% is an Array type.
   *
   *  This provides a type gaurd ensuring that [[arrayChildren]]
   *  and [[arrayLength]] are non-null.
   */
  isArray() {
    return this.baseType === "array";
  }
  /**
   *  Returns true if %%this%% is a Tuple type.
   *
   *  This provides a type gaurd ensuring that [[components]]
   *  is non-null.
   */
  isTuple() {
    return this.baseType === "tuple";
  }
  /**
   *  Returns true if %%this%% is an Indexable type.
   *
   *  This provides a type gaurd ensuring that [[indexed]]
   *  is non-null.
   */
  isIndexable() {
    return this.indexed != null;
  }
  /**
   *  Walks the **ParamType** with %%value%%, calling %%process%%
   *  on each type, destructing the %%value%% recursively.
   */
  walk(t, r) {
    if (this.isArray()) {
      if (!Array.isArray(t))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && t.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const n = this;
      return t.map((s) => n.arrayChildren.walk(s, r));
    }
    if (this.isTuple()) {
      if (!Array.isArray(t))
        throw new Error("invalid tuple value");
      if (t.length !== this.components.length)
        throw new Error("array is wrong length");
      const n = this;
      return t.map((s, i) => n.components[i].walk(s, r));
    }
    return r(this.type, t);
  }
  /**
   *  Walks the **ParamType** with %%value%%, asynchronously calling
   *  %%process%% on each type, destructing the %%value%% recursively.
   *
   *  This can be used to resolve ENS names by walking and resolving each
   *  ``"address"`` type.
   */
  async walkAsync(t, r) {
    const n = [], s = [t];
    return Br(this, Fu, qd).call(this, n, t, r, (i) => {
      s[0] = i;
    }), n.length && await Promise.all(n), s[0];
  }
  /**
   *  Creates a new **ParamType** for %%obj%%.
   *
   *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
   *  otherwise the ``indexed`` keyword will throw an error.
   */
  static from(t, r) {
    if (ci.isParamType(t))
      return t;
    if (typeof t == "string")
      try {
        return ci.from(Co(t), r);
      } catch {
        ct(!1, "invalid param type", "obj", t);
      }
    else if (t instanceof zi) {
      let f = "", d = "", c = null;
      Qs(t, xn(["tuple"])).has("tuple") || t.peekType("OPEN_PAREN") ? (d = "tuple", c = t.popParams().map((S) => ci.from(S)), f = `tuple(${c.map((S) => S.format()).join(",")})`) : (f = Dg(t.popType("TYPE")), d = f);
      let p = null, g = null;
      for (; t.length && t.peekType("BRACKET"); ) {
        const S = t.pop();
        p = new ci(Ur, "", f, d, null, c, g, p), g = S.value, f += S.text, d = "array", c = null;
      }
      let v = null;
      if (Qs(t, hE).has("indexed")) {
        if (!r)
          throw new Error("");
        v = !0;
      }
      const N = t.peekType("ID") ? t.pop().text : "";
      if (t.length)
        throw new Error("leftover tokens");
      return new ci(Ur, N, f, d, v, c, g, p);
    }
    const n = t.name;
    ct(!n || typeof n == "string" && n.match(X4), "invalid name", "obj.name", n);
    let s = t.indexed;
    s != null && (ct(r, "parameter cannot be indexed", "obj.indexed", t.indexed), s = !!s);
    let i = t.type, a = i.match(vE);
    if (a) {
      const f = parseInt(a[2] || "-1"), d = ci.from({
        type: a[1],
        components: t.components
      });
      return new ci(Ur, n || "", i, "array", s, null, f, d);
    }
    if (i === "tuple" || i.startsWith(
      "tuple("
      /* fix: ) */
    ) || i.startsWith(
      "("
      /* fix: ) */
    )) {
      const f = t.components != null ? t.components.map((c) => ci.from(c)) : null;
      return new ci(Ur, n || "", i, "tuple", s, f, null, null);
    }
    return i = Dg(t.type), new ci(Ur, n || "", i, i, s, null, null, null);
  }
  /**
   *  Returns true if %%value%% is a **ParamType**.
   */
  static isParamType(t) {
    return t && t[Bn] === jg;
  }
};
Fu = new WeakSet(), qd = function(t, r, n, s) {
  if (this.isArray()) {
    if (!Array.isArray(r))
      throw new Error("invalid array value");
    if (this.arrayLength !== -1 && r.length !== this.arrayLength)
      throw new Error("array is wrong length");
    const a = this.arrayChildren, f = r.slice();
    f.forEach((d, c) => {
      var p;
      Br(p = a, Fu, qd).call(p, t, d, n, (g) => {
        f[c] = g;
      });
    }), s(f);
    return;
  }
  if (this.isTuple()) {
    const a = this.components;
    let f;
    if (Array.isArray(r))
      f = r.slice();
    else {
      if (r == null || typeof r != "object")
        throw new Error("invalid tuple value");
      f = a.map((d) => {
        if (!d.name)
          throw new Error("cannot use object value with unnamed components");
        if (!(d.name in r))
          throw new Error(`missing value for component ${d.name}`);
        return r[d.name];
      });
    }
    if (f.length !== this.components.length)
      throw new Error("array is wrong length");
    f.forEach((d, c) => {
      var p;
      Br(p = a[c], Fu, qd).call(p, t, d, n, (g) => {
        f[c] = g;
      });
    }), s(f);
    return;
  }
  const i = n(this.type, r);
  i.then ? t.push(async function() {
    s(await i);
  }()) : s(i);
};
let un = ci;
class Qa {
  /**
   *  @private
   */
  constructor(t, r, n) {
    /**
     *  The type of the fragment.
     */
    ze(this, "type");
    /**
     *  The inputs for the fragment.
     */
    ze(this, "inputs");
    Zp(t, Ur, "Fragment"), n = Object.freeze(n.slice()), lr(this, { type: r, inputs: n });
  }
  /**
   *  Creates a new **Fragment** for %%obj%%, wich can be any supported
   *  ABI frgament type.
   */
  static from(t) {
    if (typeof t == "string") {
      try {
        Qa.from(JSON.parse(t));
      } catch {
      }
      return Qa.from(Co(t));
    }
    if (t instanceof zi)
      switch (t.peekKeyword(Z4)) {
        case "constructor":
          return Vs.from(t);
        case "error":
          return Rn.from(t);
        case "event":
          return us.from(t);
        case "fallback":
        case "receive":
          return Hs.from(t);
        case "function":
          return cs.from(t);
        case "struct":
          return $a.from(t);
      }
    else if (typeof t == "object") {
      switch (t.type) {
        case "constructor":
          return Vs.from(t);
        case "error":
          return Rn.from(t);
        case "event":
          return us.from(t);
        case "fallback":
        case "receive":
          return Hs.from(t);
        case "function":
          return cs.from(t);
        case "struct":
          return $a.from(t);
      }
      Yt(!1, `unsupported type: ${t.type}`, "UNSUPPORTED_OPERATION", {
        operation: "Fragment.from"
      });
    }
    ct(!1, "unsupported frgament object", "obj", t);
  }
  /**
   *  Returns true if %%value%% is a [[ConstructorFragment]].
   */
  static isConstructor(t) {
    return Vs.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is an [[ErrorFragment]].
   */
  static isError(t) {
    return Rn.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is an [[EventFragment]].
   */
  static isEvent(t) {
    return us.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is a [[FunctionFragment]].
   */
  static isFunction(t) {
    return cs.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is a [[StructFragment]].
   */
  static isStruct(t) {
    return $a.isFragment(t);
  }
}
class Uh extends Qa {
  /**
   *  @private
   */
  constructor(r, n, s, i) {
    super(r, n, i);
    /**
     *  The name of the fragment.
     */
    ze(this, "name");
    ct(typeof s == "string" && s.match(X4), "invalid identifier", "name", s), i = Object.freeze(i.slice()), lr(this, { name: s });
  }
}
function V0(e, t) {
  return "(" + t.map((r) => r.format(e)).join(e === "full" ? ", " : ",") + ")";
}
class Rn extends Uh {
  /**
   *  @private
   */
  constructor(t, r, n) {
    super(t, "error", r, n), Object.defineProperty(this, Bn, { value: Lg });
  }
  /**
   *  The Custom Error selector.
   */
  get selector() {
    return z0(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this fragment as %%format%%.
   */
  format(t) {
    if (t == null && (t = "sighash"), t === "json")
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((n) => JSON.parse(n.format(t)))
      });
    const r = [];
    return t !== "sighash" && r.push("error"), r.push(this.name + V0(t, this.inputs)), r.join(" ");
  }
  /**
   *  Returns a new **ErrorFragment** for %%obj%%.
   */
  static from(t) {
    if (Rn.isFragment(t))
      return t;
    if (typeof t == "string")
      return Rn.from(Co(t));
    if (t instanceof zi) {
      const r = Fh("error", t), n = $s(t);
      return Ja(t), new Rn(Ur, r, n);
    }
    return new Rn(Ur, t.name, t.inputs ? t.inputs.map(un.from) : []);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **ErrorFragment**.
   */
  static isFragment(t) {
    return t && t[Bn] === Lg;
  }
}
class us extends Uh {
  /**
   *  @private
   */
  constructor(r, n, s, i) {
    super(r, "event", n, s);
    /**
     *  Whether this event is anonymous.
     */
    ze(this, "anonymous");
    Object.defineProperty(this, Bn, { value: Hg }), lr(this, { anonymous: i });
  }
  /**
   *  The Event topic hash.
   */
  get topicHash() {
    return z0(this.format("sighash"));
  }
  /**
   *  Returns a string representation of this event as %%format%%.
   */
  format(r) {
    if (r == null && (r = "sighash"), r === "json")
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((s) => JSON.parse(s.format(r)))
      });
    const n = [];
    return r !== "sighash" && n.push("event"), n.push(this.name + V0(r, this.inputs)), r !== "sighash" && this.anonymous && n.push("anonymous"), n.join(" ");
  }
  /**
   *  Return the topic hash for an event with %%name%% and %%params%%.
   */
  static getTopicHash(r, n) {
    return n = (n || []).map((i) => un.from(i)), new us(Ur, r, n, !1).topicHash;
  }
  /**
   *  Returns a new **EventFragment** for %%obj%%.
   */
  static from(r) {
    if (us.isFragment(r))
      return r;
    if (typeof r == "string")
      try {
        return us.from(Co(r));
      } catch {
        ct(!1, "invalid event fragment", "obj", r);
      }
    else if (r instanceof zi) {
      const n = Fh("event", r), s = $s(r, !0), i = !!Qs(r, xn(["anonymous"])).has("anonymous");
      return Ja(r), new us(Ur, n, s, i);
    }
    return new us(Ur, r.name, r.inputs ? r.inputs.map((n) => un.from(n, !0)) : [], !!r.anonymous);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **EventFragment**.
   */
  static isFragment(r) {
    return r && r[Bn] === Hg;
  }
}
class Vs extends Qa {
  /**
   *  @private
   */
  constructor(r, n, s, i, a) {
    super(r, n, s);
    /**
     *  Whether the constructor can receive an endowment.
     */
    ze(this, "payable");
    /**
     *  The recommended gas limit for deployment or ``null``.
     */
    ze(this, "gas");
    Object.defineProperty(this, Bn, { value: Wg }), lr(this, { payable: i, gas: a });
  }
  /**
   *  Returns a string representation of this constructor as %%format%%.
   */
  format(r) {
    if (Yt(r != null && r !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" }), r === "json")
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.payable ? "payable" : "undefined",
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((s) => JSON.parse(s.format(r)))
      });
    const n = [`constructor${V0(r, this.inputs)}`];
    return this.payable && n.push("payable"), this.gas != null && n.push(`@${this.gas.toString()}`), n.join(" ");
  }
  /**
   *  Returns a new **ConstructorFragment** for %%obj%%.
   */
  static from(r) {
    if (Vs.isFragment(r))
      return r;
    if (typeof r == "string")
      try {
        return Vs.from(Co(r));
      } catch {
        ct(!1, "invalid constuctor fragment", "obj", r);
      }
    else if (r instanceof zi) {
      Qs(r, xn(["constructor"]));
      const n = $s(r), s = !!Qs(r, lE).has("payable"), i = rv(r);
      return Ja(r), new Vs(Ur, "constructor", n, s, i);
    }
    return new Vs(Ur, "constructor", r.inputs ? r.inputs.map(un.from) : [], !!r.payable, r.gas != null ? r.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **ConstructorFragment**.
   */
  static isFragment(r) {
    return r && r[Bn] === Wg;
  }
}
class Hs extends Qa {
  constructor(r, n, s) {
    super(r, "fallback", n);
    /**
     *  If the function can be sent value during invocation.
     */
    ze(this, "payable");
    Object.defineProperty(this, Bn, { value: Gg }), lr(this, { payable: s });
  }
  /**
   *  Returns a string representation of this fallback as %%format%%.
   */
  format(r) {
    const n = this.inputs.length === 0 ? "receive" : "fallback";
    if (r === "json") {
      const s = this.payable ? "payable" : "nonpayable";
      return JSON.stringify({ type: n, stateMutability: s });
    }
    return `${n}()${this.payable ? " payable" : ""}`;
  }
  /**
   *  Returns a new **FallbackFragment** for %%obj%%.
   */
  static from(r) {
    if (Hs.isFragment(r))
      return r;
    if (typeof r == "string")
      try {
        return Hs.from(Co(r));
      } catch {
        ct(!1, "invalid fallback fragment", "obj", r);
      }
    else if (r instanceof zi) {
      const n = r.toString(), s = r.peekKeyword(xn(["fallback", "receive"]));
      if (ct(s, "type must be fallback or receive", "obj", n), r.popKeyword(xn(["fallback", "receive"])) === "receive") {
        const d = $s(r);
        return ct(d.length === 0, "receive cannot have arguments", "obj.inputs", d), Qs(r, xn(["payable"])), Ja(r), new Hs(Ur, [], !0);
      }
      let a = $s(r);
      a.length ? ct(a.length === 1 && a[0].type === "bytes", "invalid fallback inputs", "obj.inputs", a.map((d) => d.format("minimal")).join(", ")) : a = [un.from("bytes")];
      const f = tv(r);
      if (ct(f === "nonpayable" || f === "payable", "fallback cannot be constants", "obj.stateMutability", f), Qs(r, xn(["returns"])).has("returns")) {
        const d = $s(r);
        ct(d.length === 1 && d[0].type === "bytes", "invalid fallback outputs", "obj.outputs", d.map((c) => c.format("minimal")).join(", "));
      }
      return Ja(r), new Hs(Ur, a, f === "payable");
    }
    if (r.type === "receive")
      return new Hs(Ur, [], !0);
    if (r.type === "fallback") {
      const n = [un.from("bytes")], s = r.stateMutability === "payable";
      return new Hs(Ur, n, s);
    }
    ct(!1, "invalid fallback description", "obj", r);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FallbackFragment**.
   */
  static isFragment(r) {
    return r && r[Bn] === Gg;
  }
}
class cs extends Uh {
  /**
   *  @private
   */
  constructor(r, n, s, i, a, f) {
    super(r, "function", n, i);
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */
    ze(this, "constant");
    /**
     *  The returned types for the result of calling this function.
     */
    ze(this, "outputs");
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */
    ze(this, "stateMutability");
    /**
     *  If the function can be sent value during invocation.
     */
    ze(this, "payable");
    /**
     *  The recommended gas limit to send when calling this function.
     */
    ze(this, "gas");
    Object.defineProperty(this, Bn, { value: zg }), a = Object.freeze(a.slice()), lr(this, { constant: s === "view" || s === "pure", gas: f, outputs: a, payable: s === "payable", stateMutability: s });
  }
  /**
   *  The Function selector.
   */
  get selector() {
    return z0(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this function as %%format%%.
   */
  format(r) {
    if (r == null && (r = "sighash"), r === "json")
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((s) => JSON.parse(s.format(r))),
        outputs: this.outputs.map((s) => JSON.parse(s.format(r)))
      });
    const n = [];
    return r !== "sighash" && n.push("function"), n.push(this.name + V0(r, this.inputs)), r !== "sighash" && (this.stateMutability !== "nonpayable" && n.push(this.stateMutability), this.outputs && this.outputs.length && (n.push("returns"), n.push(V0(r, this.outputs))), this.gas != null && n.push(`@${this.gas.toString()}`)), n.join(" ");
  }
  /**
   *  Return the selector for a function with %%name%% and %%params%%.
   */
  static getSelector(r, n) {
    return n = (n || []).map((i) => un.from(i)), new cs(Ur, r, "view", n, [], null).selector;
  }
  /**
   *  Returns a new **FunctionFragment** for %%obj%%.
   */
  static from(r) {
    if (cs.isFragment(r))
      return r;
    if (typeof r == "string")
      try {
        return cs.from(Co(r));
      } catch {
        ct(!1, "invalid function fragment", "obj", r);
      }
    else if (r instanceof zi) {
      const s = Fh("function", r), i = $s(r), a = tv(r);
      let f = [];
      Qs(r, xn(["returns"])).has("returns") && (f = $s(r));
      const d = rv(r);
      return Ja(r), new cs(Ur, s, a, i, f, d);
    }
    let n = r.stateMutability;
    return n == null && (n = "payable", typeof r.constant == "boolean" ? (n = "view", r.constant || (n = "payable", typeof r.payable == "boolean" && !r.payable && (n = "nonpayable"))) : typeof r.payable == "boolean" && !r.payable && (n = "nonpayable")), new cs(Ur, r.name, n, r.inputs ? r.inputs.map(un.from) : [], r.outputs ? r.outputs.map(un.from) : [], r.gas != null ? r.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FunctionFragment**.
   */
  static isFragment(r) {
    return r && r[Bn] === zg;
  }
}
class $a extends Uh {
  /**
   *  @private
   */
  constructor(t, r, n) {
    super(t, "struct", r, n), Object.defineProperty(this, Bn, { value: Vg });
  }
  /**
   *  Returns a string representation of this struct as %%format%%.
   */
  format() {
    throw new Error("@TODO");
  }
  /**
   *  Returns a new **StructFragment** for %%obj%%.
   */
  static from(t) {
    if (typeof t == "string")
      try {
        return $a.from(Co(t));
      } catch {
        ct(!1, "invalid struct fragment", "obj", t);
      }
    else if (t instanceof zi) {
      const r = Fh("struct", t), n = $s(t);
      return Ja(t), new $a(Ur, r, n);
    }
    return new $a(Ur, t.name, t.inputs ? t.inputs.map(un.from) : []);
  }
  // @TODO: fix this return type
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **StructFragment**.
   */
  static isFragment(t) {
    return t && t[Bn] === Vg;
  }
}
const $i = /* @__PURE__ */ new Map();
$i.set(0, "GENERIC_PANIC");
$i.set(1, "ASSERT_FALSE");
$i.set(17, "OVERFLOW");
$i.set(18, "DIVIDE_BY_ZERO");
$i.set(33, "ENUM_RANGE_ERROR");
$i.set(34, "BAD_STORAGE_DATA");
$i.set(49, "STACK_UNDERFLOW");
$i.set(50, "ARRAY_RANGE_ERROR");
$i.set(65, "OUT_OF_MEMORY");
$i.set(81, "UNINITIALIZED_FUNCTION_CALL");
const AE = new RegExp(/^bytes([0-9]*)$/), EE = new RegExp(/^(u?int)([0-9]*)$/);
let Tf = null, qg = 1024;
function PE(e, t, r, n) {
  let s = "missing revert data", i = null;
  const a = null;
  let f = null;
  if (r) {
    s = "execution reverted";
    const c = Js(r);
    if (r = Zr(r), c.length === 0)
      s += " (no data present; likely require(false) occurred", i = "require(false)";
    else if (c.length % 32 !== 4)
      s += " (could not decode reason; invalid data length)";
    else if (Zr(c.slice(0, 4)) === "0x08c379a0")
      try {
        i = n.decode(["string"], c.slice(4))[0], f = {
          signature: "Error(string)",
          name: "Error",
          args: [i]
        }, s += `: ${JSON.stringify(i)}`;
      } catch {
        s += " (could not decode reason; invalid string data)";
      }
    else if (Zr(c.slice(0, 4)) === "0x4e487b71")
      try {
        const p = Number(n.decode(["uint256"], c.slice(4))[0]);
        f = {
          signature: "Panic(uint256)",
          name: "Panic",
          args: [p]
        }, i = `Panic due to ${$i.get(p) || "UNKNOWN"}(${p})`, s += `: ${i}`;
      } catch {
        s += " (could not decode panic code)";
      }
    else
      s += " (unknown custom error)";
  }
  const d = {
    to: t.to ? So(t.to) : null,
    data: t.data || "0x"
  };
  return t.from && (d.from = So(t.from)), oh(s, "CALL_EXCEPTION", {
    action: e,
    data: r,
    reason: i,
    transaction: d,
    invocation: a,
    revert: f
  });
}
var vo, hu;
const Mh = class Mh {
  constructor() {
    Ar(this, vo);
  }
  /**
   *  Get the default values for the given %%types%%.
   *
   *  For example, a ``uint`` is by default ``0`` and ``bool``
   *  is by default ``false``.
   */
  getDefaultValue(t) {
    const r = t.map((s) => Br(this, vo, hu).call(this, un.from(s)));
    return new kd(r, "_").defaultValue();
  }
  /**
   *  Encode the %%values%% as the %%types%% into ABI data.
   *
   *  @returns DataHexstring
   */
  encode(t, r) {
    l4(r.length, t.length, "types/values length mismatch");
    const n = t.map((a) => Br(this, vo, hu).call(this, un.from(a))), s = new kd(n, "_"), i = new op();
    return s.encode(i, r), i.data;
  }
  /**
   *  Decode the ABI %%data%% as the %%types%% into values.
   *
   *  If %%loose%% decoding is enabled, then strict padding is
   *  not enforced. Some older versions of Solidity incorrectly
   *  padded event data emitted from ``external`` functions.
   */
  decode(t, r, n) {
    const s = t.map((a) => Br(this, vo, hu).call(this, un.from(a)));
    return new kd(s, "_").decode(new ap(r, n, qg));
  }
  static _setDefaultMaxInflation(t) {
    ct(typeof t == "number" && Number.isInteger(t), "invalid defaultMaxInflation factor", "value", t), qg = t;
  }
  /**
   *  Returns the shared singleton instance of a default [[AbiCoder]].
   *
   *  On the first call, the instance is created internally.
   */
  static defaultAbiCoder() {
    return Tf == null && (Tf = new Mh()), Tf;
  }
  /**
   *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
   *  result %%data%% for the [[CallExceptionAction]] %%action%% against
   *  the Transaction %%tx%%.
   */
  static getBuiltinCallException(t, r, n) {
    return PE(t, r, n, Mh.defaultAbiCoder());
  }
};
vo = new WeakSet(), hu = function(t) {
  if (t.isArray())
    return new ZA(Br(this, vo, hu).call(this, t.arrayChildren), t.arrayLength, t.name);
  if (t.isTuple())
    return new kd(t.components.map((n) => Br(this, vo, hu).call(this, n)), t.name);
  switch (t.baseType) {
    case "address":
      return new JA(t.name);
    case "bool":
      return new YA(t.name);
    case "string":
      return new aE(t.name);
    case "bytes":
      return new XA(t.name);
    case "":
      return new rE(t.name);
  }
  let r = t.type.match(EE);
  if (r) {
    let n = parseInt(r[2] || "256");
    return ct(n !== 0 && n <= 256 && n % 8 === 0, "invalid " + r[1] + " bit length", "param", t), new oE(n / 8, r[1] === "int", t.name);
  }
  if (r = t.type.match(AE), r) {
    let n = parseInt(r[1]);
    return ct(n !== 0 && n <= 32, "invalid bytes length", "param", t), new eE(n, t.name);
  }
  ct(!1, "invalid type", "type", t.type);
};
let lh = Mh;
class OE {
  /**
   *  @_ignore:
   */
  constructor(t, r, n) {
    /**
     *  The matching fragment for the ``topic0``.
     */
    ze(this, "fragment");
    /**
     *  The name of the Event.
     */
    ze(this, "name");
    /**
     *  The full Event signature.
     */
    ze(this, "signature");
    /**
     *  The topic hash for the Event.
     */
    ze(this, "topic");
    /**
     *  The arguments passed into the Event with ``emit``.
     */
    ze(this, "args");
    const s = t.name, i = t.format();
    lr(this, {
      fragment: t,
      name: s,
      signature: i,
      topic: r,
      args: n
    });
  }
}
class NE {
  /**
   *  @_ignore:
   */
  constructor(t, r, n, s) {
    /**
     *  The matching fragment from the transaction ``data``.
     */
    ze(this, "fragment");
    /**
     *  The name of the Function from the transaction ``data``.
     */
    ze(this, "name");
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */
    ze(this, "args");
    /**
     *  The full Function signature from the transaction ``data``.
     */
    ze(this, "signature");
    /**
     *  The selector for the Function from the transaction ``data``.
     */
    ze(this, "selector");
    /**
     *  The ``value`` (in wei) from the transaction.
     */
    ze(this, "value");
    const i = t.name, a = t.format();
    lr(this, {
      fragment: t,
      name: i,
      args: n,
      signature: a,
      selector: r,
      value: s
    });
  }
}
class xE {
  /**
   *  @_ignore:
   */
  constructor(t, r, n) {
    /**
     *  The matching fragment.
     */
    ze(this, "fragment");
    /**
     *  The name of the Error.
     */
    ze(this, "name");
    /**
     *  The arguments passed to the Error with ``revert``.
     */
    ze(this, "args");
    /**
     *  The full Error signature.
     */
    ze(this, "signature");
    /**
     *  The selector for the Error.
     */
    ze(this, "selector");
    const s = t.name, i = t.format();
    lr(this, {
      fragment: t,
      name: s,
      args: n,
      signature: i,
      selector: r
    });
  }
}
class $g {
  /**
   *  @_ignore:
   */
  constructor(t) {
    /**
     *  The ``keccak256`` of the value logged.
     */
    ze(this, "hash");
    /**
     *  @_ignore:
     */
    ze(this, "_isIndexed");
    lr(this, { hash: t, _isIndexed: !0 });
  }
  /**
   *  Returns ``true`` if %%value%% is an **Indexed**.
   *
   *  This provides a Type Guard for property access.
   */
  static isIndexed(t) {
    return !!(t && t._isIndexed);
  }
}
const Kg = {
  0: "generic panic",
  1: "assert(false)",
  17: "arithmetic overflow",
  18: "division or modulo by zero",
  33: "enum overflow",
  34: "invalid encoded storage byte array accessed",
  49: "out-of-bounds array access; popping on an empty array",
  50: "out-of-bounds access of an array or bytesN",
  65: "out of memory",
  81: "uninitialized function"
}, Jg = {
  "0x08c379a0": {
    signature: "Error(string)",
    name: "Error",
    inputs: ["string"],
    reason: (e) => `reverted with reason string ${JSON.stringify(e)}`
  },
  "0x4e487b71": {
    signature: "Panic(uint256)",
    name: "Panic",
    inputs: ["uint256"],
    reason: (e) => {
      let t = "unknown panic code";
      return e >= 0 && e <= 255 && Kg[e.toString()] && (t = Kg[e.toString()]), `reverted with panic code 0x${e.toString(16)} (${t})`;
    }
  }
};
var ss, os, as, fn, gs, $d, Kd;
const La = class La {
  /**
   *  Create a new Interface for the %%fragments%%.
   */
  constructor(t) {
    Ar(this, gs);
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */
    ze(this, "fragments");
    /**
     *  The Contract constructor.
     */
    ze(this, "deploy");
    /**
     *  The Fallback method, if any.
     */
    ze(this, "fallback");
    /**
     *  If receiving ether is supported.
     */
    ze(this, "receive");
    Ar(this, ss);
    Ar(this, os);
    Ar(this, as);
    //    #structs: Map<string, StructFragment>;
    Ar(this, fn);
    let r = [];
    typeof t == "string" ? r = JSON.parse(t) : r = t, mr(this, as, /* @__PURE__ */ new Map()), mr(this, ss, /* @__PURE__ */ new Map()), mr(this, os, /* @__PURE__ */ new Map());
    const n = [];
    for (const a of r)
      try {
        n.push(Qa.from(a));
      } catch (f) {
        console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, f.message);
      }
    lr(this, {
      fragments: Object.freeze(n)
    });
    let s = null, i = !1;
    mr(this, fn, this.getAbiCoder()), this.fragments.forEach((a, f) => {
      let d;
      switch (a.type) {
        case "constructor":
          if (this.deploy) {
            console.log("duplicate definition - constructor");
            return;
          }
          lr(this, { deploy: a });
          return;
        case "fallback":
          a.inputs.length === 0 ? i = !0 : (ct(!s || a.payable !== s.payable, "conflicting fallback fragments", `fragments[${f}]`, a), s = a, i = s.payable);
          return;
        case "function":
          d = Xe(this, as);
          break;
        case "event":
          d = Xe(this, os);
          break;
        case "error":
          d = Xe(this, ss);
          break;
        default:
          return;
      }
      const c = a.format();
      d.has(c) || d.set(c, a);
    }), this.deploy || lr(this, {
      deploy: Vs.from("constructor()")
    }), lr(this, { fallback: s, receive: i });
  }
  /**
   *  Returns the entire Human-Readable ABI, as an array of
   *  signatures, optionally as %%minimal%% strings, which
   *  removes parameter names and unneceesary spaces.
   */
  format(t) {
    const r = t ? "minimal" : "full";
    return this.fragments.map((s) => s.format(r));
  }
  /**
   *  Return the JSON-encoded ABI. This is the format Solidiy
   *  returns.
   */
  formatJson() {
    const t = this.fragments.map((r) => r.format("json"));
    return JSON.stringify(t.map((r) => JSON.parse(r)));
  }
  /**
   *  The ABI coder that will be used to encode and decode binary
   *  data.
   */
  getAbiCoder() {
    return lh.defaultAbiCoder();
  }
  /**
   *  Get the function name for %%key%%, which may be a function selector,
   *  function name or function signature that belongs to the ABI.
   */
  getFunctionName(t) {
    const r = Br(this, gs, $d).call(this, t, null, !1);
    return ct(r, "no matching function", "key", t), r.name;
  }
  /**
   *  Returns true if %%key%% (a function selector, function name or
   *  function signature) is present in the ABI.
   *
   *  In the case of a function name, the name may be ambiguous, so
   *  accessing the [[FunctionFragment]] may require refinement.
   */
  hasFunction(t) {
    return !!Br(this, gs, $d).call(this, t, null, !1);
  }
  /**
   *  Get the [[FunctionFragment]] for %%key%%, which may be a function
   *  selector, function name or function signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple functions match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single function in
   *  the ABI, this will throw.
   */
  getFunction(t, r) {
    return Br(this, gs, $d).call(this, t, r || null, !0);
  }
  /**
   *  Iterate over all functions, calling %%callback%%, sorted by their name.
   */
  forEachFunction(t) {
    const r = Array.from(Xe(this, as).keys());
    r.sort((n, s) => n.localeCompare(s));
    for (let n = 0; n < r.length; n++) {
      const s = r[n];
      t(Xe(this, as).get(s), n);
    }
  }
  /**
   *  Get the event name for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   */
  getEventName(t) {
    const r = Br(this, gs, Kd).call(this, t, null, !1);
    return ct(r, "no matching event", "key", t), r.name;
  }
  /**
   *  Returns true if %%key%% (an event topic hash, event name or
   *  event signature) is present in the ABI.
   *
   *  In the case of an event name, the name may be ambiguous, so
   *  accessing the [[EventFragment]] may require refinement.
   */
  hasEvent(t) {
    return !!Br(this, gs, Kd).call(this, t, null, !1);
  }
  /**
   *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple events match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single event in
   *  the ABI, this will throw.
   */
  getEvent(t, r) {
    return Br(this, gs, Kd).call(this, t, r || null, !0);
  }
  /**
   *  Iterate over all events, calling %%callback%%, sorted by their name.
   */
  forEachEvent(t) {
    const r = Array.from(Xe(this, os).keys());
    r.sort((n, s) => n.localeCompare(s));
    for (let n = 0; n < r.length; n++) {
      const s = r[n];
      t(Xe(this, os).get(s), n);
    }
  }
  /**
   *  Get the [[ErrorFragment]] for %%key%%, which may be an error
   *  selector, error name or error signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple errors match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single error in
   *  the ABI, this will throw.
   */
  getError(t, r) {
    if (zs(t)) {
      const s = t.toLowerCase();
      if (Jg[s])
        return Rn.from(Jg[s].signature);
      for (const i of Xe(this, ss).values())
        if (s === i.selector)
          return i;
      return null;
    }
    if (t.indexOf("(") === -1) {
      const s = [];
      for (const [i, a] of Xe(this, ss))
        i.split(
          "("
          /* fix:) */
        )[0] === t && s.push(a);
      if (s.length === 0)
        return t === "Error" ? Rn.from("error Error(string)") : t === "Panic" ? Rn.from("error Panic(uint256)") : null;
      if (s.length > 1) {
        const i = s.map((a) => JSON.stringify(a.format())).join(", ");
        ct(!1, `ambiguous error description (i.e. ${i})`, "name", t);
      }
      return s[0];
    }
    if (t = Rn.from(t).format(), t === "Error(string)")
      return Rn.from("error Error(string)");
    if (t === "Panic(uint256)")
      return Rn.from("error Panic(uint256)");
    const n = Xe(this, ss).get(t);
    return n || null;
  }
  /**
   *  Iterate over all errors, calling %%callback%%, sorted by their name.
   */
  forEachError(t) {
    const r = Array.from(Xe(this, ss).keys());
    r.sort((n, s) => n.localeCompare(s));
    for (let n = 0; n < r.length; n++) {
      const s = r[n];
      t(Xe(this, ss).get(s), n);
    }
  }
  // Get the 4-byte selector used by Solidity to identify a function
  /*
  getSelector(fragment: ErrorFragment | FunctionFragment): string {
      if (typeof(fragment) === "string") {
          const matches: Array<Fragment> = [ ];
  
          try { matches.push(this.getFunction(fragment)); } catch (error) { }
          try { matches.push(this.getError(<string>fragment)); } catch (_) { }
  
          if (matches.length === 0) {
              logger.throwArgumentError("unknown fragment", "key", fragment);
          } else if (matches.length > 1) {
              logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
          }
  
          fragment = matches[0];
      }
  
      return dataSlice(id(fragment.format()), 0, 4);
  }
      */
  // Get the 32-byte topic hash used by Solidity to identify an event
  /*
  getEventTopic(fragment: EventFragment): string {
      //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
      return id(fragment.format());
  }
  */
  _decodeParams(t, r) {
    return Xe(this, fn).decode(t, r);
  }
  _encodeParams(t, r) {
    return Xe(this, fn).encode(t, r);
  }
  /**
   *  Encodes a ``tx.data`` object for deploying the Contract with
   *  the %%values%% as the constructor arguments.
   */
  encodeDeploy(t) {
    return this._encodeParams(this.deploy.inputs, t || []);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified error (see [[getError]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeErrorResult(t, r) {
    if (typeof t == "string") {
      const n = this.getError(t);
      ct(n, "unknown error", "fragment", t), t = n;
    }
    return ct(iu(r, 0, 4) === t.selector, `data signature does not match error ${t.name}.`, "data", r), this._decodeParams(t.inputs, iu(r, 4));
  }
  /**
   *  Encodes the transaction revert data for a call result that
   *  reverted from the the Contract with the sepcified %%error%%
   *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeErrorResult(t, r) {
    if (typeof t == "string") {
      const n = this.getError(t);
      ct(n, "unknown error", "fragment", t), t = n;
    }
    return ku([
      t.selector,
      this._encodeParams(t.inputs, r || [])
    ]);
  }
  /**
   *  Decodes the %%data%% from a transaction ``tx.data`` for
   *  the function specified (see [[getFunction]] for valid values
   *  for %%fragment%%).
   *
   *  Most developers should prefer the [[parseTransaction]] method
   *  instead, which will automatically detect the fragment.
   */
  decodeFunctionData(t, r) {
    if (typeof t == "string") {
      const n = this.getFunction(t);
      ct(n, "unknown function", "fragment", t), t = n;
    }
    return ct(iu(r, 0, 4) === t.selector, `data signature does not match function ${t.name}.`, "data", r), this._decodeParams(t.inputs, iu(r, 4));
  }
  /**
   *  Encodes the ``tx.data`` for a transaction that calls the function
   *  specified (see [[getFunction]] for valid values for %%fragment%%) with
   *  the %%values%%.
   */
  encodeFunctionData(t, r) {
    if (typeof t == "string") {
      const n = this.getFunction(t);
      ct(n, "unknown function", "fragment", t), t = n;
    }
    return ku([
      t.selector,
      this._encodeParams(t.inputs, r || [])
    ]);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeFunctionResult(t, r) {
    if (typeof t == "string") {
      const i = this.getFunction(t);
      ct(i, "unknown function", "fragment", t), t = i;
    }
    let n = "invalid length for result data";
    const s = fs(r);
    if (s.length % 32 === 0)
      try {
        return Xe(this, fn).decode(t.outputs, s);
      } catch {
        n = "could not decode result data";
      }
    Yt(!1, n, "BAD_DATA", {
      value: Zr(s),
      info: { method: t.name, signature: t.format() }
    });
  }
  makeError(t, r) {
    const n = Js(t, "data"), s = lh.getBuiltinCallException("call", r, n);
    if (s.message.startsWith("execution reverted (unknown custom error)")) {
      const f = Zr(n.slice(0, 4)), d = this.getError(f);
      if (d)
        try {
          const c = Xe(this, fn).decode(d.inputs, n.slice(4));
          s.revert = {
            name: d.name,
            signature: d.format(),
            args: c
          }, s.reason = s.revert.signature, s.message = `execution reverted: ${s.reason}`;
        } catch {
          s.message = "execution reverted (coult not decode custom error)";
        }
    }
    const a = this.parseTransaction(r);
    return a && (s.invocation = {
      method: a.name,
      signature: a.signature,
      args: a.args
    }), s;
  }
  /**
   *  Encodes the result data (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values
   *  for %%fragment%%) with %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeFunctionResult(t, r) {
    if (typeof t == "string") {
      const n = this.getFunction(t);
      ct(n, "unknown function", "fragment", t), t = n;
    }
    return Zr(Xe(this, fn).encode(t.outputs, r || []));
  }
  /*
      spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
          const promises: Array<Promise<>> = [ ];
          const process = function(type: ParamType, value: any): any {
              if (type.baseType === "array") {
                  return descend(type.child
              }
              if (type. === "address") {
              }
          };
  
          const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
              if (inputs.length !== values.length) { throw new Error("length mismatch"); }
              
          };
  
          const result: Array<any> = [ ];
          values.forEach((value, index) => {
              if (value == null) {
                  topics.push(null);
              } else if (param.baseType === "array" || param.baseType === "tuple") {
                  logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
              } else if (Array.isArray(value)) {
                  topics.push(value.map((value) => encodeTopic(param, value)));
              } else {
                  topics.push(encodeTopic(param, value));
              }
          });
      }
  */
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(t, r) {
    if (typeof t == "string") {
      const i = this.getEvent(t);
      ct(i, "unknown event", "eventFragment", t), t = i;
    }
    Yt(r.length <= t.inputs.length, `too many arguments for ${t.format()}`, "UNEXPECTED_ARGUMENT", { count: r.length, expectedCount: t.inputs.length });
    const n = [];
    t.anonymous || n.push(t.topicHash);
    const s = (i, a) => i.type === "string" ? z0(a) : i.type === "bytes" ? ko(Zr(a)) : (i.type === "bool" && typeof a == "boolean" ? a = a ? "0x01" : "0x00" : i.type.match(/^u?int/) ? a = R4(a) : i.type.match(/^bytes/) ? a = aA(a, 32) : i.type === "address" && Xe(this, fn).encode(["address"], [a]), oA(Zr(a), 32));
    for (r.forEach((i, a) => {
      const f = t.inputs[a];
      if (!f.indexed) {
        ct(i == null, "cannot filter non-indexed parameters; must be null", "contract." + f.name, i);
        return;
      }
      i == null ? n.push(null) : f.baseType === "array" || f.baseType === "tuple" ? ct(!1, "filtering with tuples or arrays not supported", "contract." + f.name, i) : Array.isArray(i) ? n.push(i.map((d) => s(f, d))) : n.push(s(f, i));
    }); n.length && n[n.length - 1] === null; )
      n.pop();
    return n;
  }
  encodeEventLog(t, r) {
    if (typeof t == "string") {
      const a = this.getEvent(t);
      ct(a, "unknown event", "eventFragment", t), t = a;
    }
    const n = [], s = [], i = [];
    return t.anonymous || n.push(t.topicHash), ct(r.length === t.inputs.length, "event arguments/values mismatch", "values", r), t.inputs.forEach((a, f) => {
      const d = r[f];
      if (a.indexed)
        if (a.type === "string")
          n.push(z0(d));
        else if (a.type === "bytes")
          n.push(ko(d));
        else {
          if (a.baseType === "tuple" || a.baseType === "array")
            throw new Error("not implemented");
          n.push(Xe(this, fn).encode([a.type], [d]));
        }
      else
        s.push(a), i.push(d);
    }), {
      data: Xe(this, fn).encode(s, i),
      topics: n
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(t, r, n) {
    if (typeof t == "string") {
      const O = this.getEvent(t);
      ct(O, "unknown event", "eventFragment", t), t = O;
    }
    if (n != null && !t.anonymous) {
      const O = t.topicHash;
      ct(zs(n[0], 32) && n[0].toLowerCase() === O, "fragment/topic mismatch", "topics[0]", n[0]), n = n.slice(1);
    }
    const s = [], i = [], a = [];
    t.inputs.forEach((O, N) => {
      O.indexed ? O.type === "string" || O.type === "bytes" || O.baseType === "tuple" || O.baseType === "array" ? (s.push(un.from({ type: "bytes32", name: O.name })), a.push(!0)) : (s.push(O), a.push(!1)) : (i.push(O), a.push(!1));
    });
    const f = n != null ? Xe(this, fn).decode(s, ku(n)) : null, d = Xe(this, fn).decode(i, r, !0), c = [], p = [];
    let g = 0, v = 0;
    return t.inputs.forEach((O, N) => {
      let S = null;
      if (O.indexed)
        if (f == null)
          S = new $g(null);
        else if (a[N])
          S = new $g(f[v++]);
        else
          try {
            S = f[v++];
          } catch (j) {
            S = j;
          }
      else
        try {
          S = d[g++];
        } catch (j) {
          S = j;
        }
      c.push(S), p.push(O.name || null);
    }), Hu.fromItems(c, p);
  }
  /**
   *  Parses a transaction, finding the matching function and extracts
   *  the parameter values along with other useful function details.
   *
   *  If the matching function cannot be found, return null.
   */
  parseTransaction(t) {
    const r = Js(t.data, "tx.data"), n = Ro(t.value != null ? t.value : 0, "tx.value"), s = this.getFunction(Zr(r.slice(0, 4)));
    if (!s)
      return null;
    const i = Xe(this, fn).decode(s.inputs, r.slice(4));
    return new NE(s, s.selector, i, n);
  }
  parseCallResult(t) {
    throw new Error("@TODO");
  }
  /**
   *  Parses a receipt log, finding the matching event and extracts
   *  the parameter values along with other useful event details.
   *
   *  If the matching event cannot be found, returns null.
   */
  parseLog(t) {
    const r = this.getEvent(t.topics[0]);
    return !r || r.anonymous ? null : new OE(r, r.topicHash, this.decodeEventLog(r, t.data, t.topics));
  }
  /**
   *  Parses a revert data, finding the matching error and extracts
   *  the parameter values along with other useful error details.
   *
   *  If the matching error cannot be found, returns null.
   */
  parseError(t) {
    const r = Zr(t), n = this.getError(iu(r, 0, 4));
    if (!n)
      return null;
    const s = Xe(this, fn).decode(n.inputs, iu(r, 4));
    return new xE(n, n.selector, s);
  }
  /**
   *  Creates a new [[Interface]] from the ABI %%value%%.
   *
   *  The %%value%% may be provided as an existing [[Interface]] object,
   *  a JSON-encoded ABI or any Human-Readable ABI format.
   */
  static from(t) {
    return t instanceof La ? t : typeof t == "string" ? new La(JSON.parse(t)) : typeof t.formatJson == "function" ? new La(t.formatJson()) : typeof t.format == "function" ? new La(t.format("json")) : new La(t);
  }
};
ss = new WeakMap(), os = new WeakMap(), as = new WeakMap(), fn = new WeakMap(), gs = new WeakSet(), // Find a function definition by any means necessary (unless it is ambiguous)
$d = function(t, r, n) {
  if (zs(t)) {
    const i = t.toLowerCase();
    for (const a of Xe(this, as).values())
      if (i === a.selector)
        return a;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const i = [];
    for (const [a, f] of Xe(this, as))
      a.split(
        "("
        /* fix:) */
      )[0] === t && i.push(f);
    if (r) {
      const a = r.length > 0 ? r[r.length - 1] : null;
      let f = r.length, d = !0;
      gn.isTyped(a) && a.type === "overrides" && (d = !1, f--);
      for (let c = i.length - 1; c >= 0; c--) {
        const p = i[c].inputs.length;
        p !== f && (!d || p !== f - 1) && i.splice(c, 1);
      }
      for (let c = i.length - 1; c >= 0; c--) {
        const p = i[c].inputs;
        for (let g = 0; g < r.length; g++)
          if (gn.isTyped(r[g])) {
            if (g >= p.length) {
              if (r[g].type === "overrides")
                continue;
              i.splice(c, 1);
              break;
            }
            if (r[g].type !== p[g].baseType) {
              i.splice(c, 1);
              break;
            }
          }
      }
    }
    if (i.length === 1 && r && r.length !== i[0].inputs.length) {
      const a = r[r.length - 1];
      (a == null || Array.isArray(a) || typeof a != "object") && i.splice(0, 1);
    }
    if (i.length === 0)
      return null;
    if (i.length > 1 && n) {
      const a = i.map((f) => JSON.stringify(f.format())).join(", ");
      ct(!1, `ambiguous function description (i.e. matches ${a})`, "key", t);
    }
    return i[0];
  }
  const s = Xe(this, as).get(cs.from(t).format());
  return s || null;
}, // Find an event definition by any means necessary (unless it is ambiguous)
Kd = function(t, r, n) {
  if (zs(t)) {
    const i = t.toLowerCase();
    for (const a of Xe(this, os).values())
      if (i === a.topicHash)
        return a;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const i = [];
    for (const [a, f] of Xe(this, os))
      a.split(
        "("
        /* fix:) */
      )[0] === t && i.push(f);
    if (r) {
      for (let a = i.length - 1; a >= 0; a--)
        i[a].inputs.length < r.length && i.splice(a, 1);
      for (let a = i.length - 1; a >= 0; a--) {
        const f = i[a].inputs;
        for (let d = 0; d < r.length; d++)
          if (gn.isTyped(r[d]) && r[d].type !== f[d].baseType) {
            i.splice(a, 1);
            break;
          }
      }
    }
    if (i.length === 0)
      return null;
    if (i.length > 1 && n) {
      const a = i.map((f) => JSON.stringify(f.format())).join(", ");
      ct(!1, `ambiguous event description (i.e. matches ${a})`, "key", t);
    }
    return i[0];
  }
  const s = Xe(this, os).get(us.from(t).format());
  return s || null;
};
let lp = La;
const nv = BigInt(0);
function li(e) {
  return e == null ? null : e.toString();
}
function TE(e) {
  const t = {};
  e.to && (t.to = e.to), e.from && (t.from = e.from), e.data && (t.data = Zr(e.data));
  const r = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
  for (const s of r)
    !(s in e) || e[s] == null || (t[s] = Ro(e[s], `request.${s}`));
  const n = "type,nonce".split(/,/);
  for (const s of n)
    !(s in e) || e[s] == null || (t[s] = Xs(e[s], `request.${s}`));
  return e.accessList && (t.accessList = uE(e.accessList)), "blockTag" in e && (t.blockTag = e.blockTag), "enableCcipRead" in e && (t.enableCcipRead = !!e.enableCcipRead), "customData" in e && (t.customData = e.customData), "blobVersionedHashes" in e && e.blobVersionedHashes && (t.blobVersionedHashes = e.blobVersionedHashes.slice()), "kzg" in e && (t.kzg = e.kzg), "blobs" in e && e.blobs && (t.blobs = e.blobs.map((s) => sA(s) ? Zr(s) : Object.assign({}, s))), t;
}
class Dh {
  /**
   *  @_ignore:
   */
  constructor(t, r) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    ze(this, "provider");
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */
    ze(this, "transactionHash");
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */
    ze(this, "blockHash");
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */
    ze(this, "blockNumber");
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */
    ze(this, "removed");
    /**
     *  The address of the contract that emitted this log.
     */
    ze(this, "address");
    /**
     *  The data included in this log when it was emitted.
     */
    ze(this, "data");
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */
    ze(this, "topics");
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */
    ze(this, "index");
    /**
     *  The index within the transaction of this log.
     */
    ze(this, "transactionIndex");
    this.provider = r;
    const n = Object.freeze(t.topics.slice());
    lr(this, {
      transactionHash: t.transactionHash,
      blockHash: t.blockHash,
      blockNumber: t.blockNumber,
      removed: t.removed,
      address: t.address,
      data: t.data,
      topics: n,
      index: t.index,
      transactionIndex: t.transactionIndex
    });
  }
  /**
   *  Returns a JSON-compatible object.
   */
  toJSON() {
    const { address: t, blockHash: r, blockNumber: n, data: s, index: i, removed: a, topics: f, transactionHash: d, transactionIndex: c } = this;
    return {
      _type: "log",
      address: t,
      blockHash: r,
      blockNumber: n,
      data: s,
      index: i,
      removed: a,
      topics: f,
      transactionHash: d,
      transactionIndex: c
    };
  }
  /**
   *  Returns the block that this log occurred in.
   */
  async getBlock() {
    const t = await this.provider.getBlock(this.blockHash);
    return Yt(!!t, "failed to find transaction", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  Returns the transaction that this log occurred in.
   */
  async getTransaction() {
    const t = await this.provider.getTransaction(this.transactionHash);
    return Yt(!!t, "failed to find transaction", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  Returns the transaction receipt fot the transaction that this
   *  log occurred in.
   */
  async getTransactionReceipt() {
    const t = await this.provider.getTransactionReceipt(this.transactionHash);
    return Yt(!!t, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return SE(this);
  }
}
var id;
class kE {
  /**
   *  @_ignore:
   */
  constructor(t, r) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    ze(this, "provider");
    /**
     *  The address the transaction was sent to.
     */
    ze(this, "to");
    /**
     *  The sender of the transaction.
     */
    ze(this, "from");
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */
    ze(this, "contractAddress");
    /**
     *  The transaction hash.
     */
    ze(this, "hash");
    /**
     *  The index of this transaction within the block transactions.
     */
    ze(this, "index");
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */
    ze(this, "blockHash");
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */
    ze(this, "blockNumber");
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */
    ze(this, "logsBloom");
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */
    ze(this, "gasUsed");
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */
    ze(this, "blobGasUsed");
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */
    ze(this, "cumulativeGasUsed");
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */
    ze(this, "gasPrice");
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */
    ze(this, "blobGasPrice");
    /**
     *  The [[link-eip-2718]] transaction type.
     */
    ze(this, "type");
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */
    ze(this, "status");
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */
    ze(this, "root");
    Ar(this, id);
    mr(this, id, Object.freeze(t.logs.map((s) => new Dh(s, r))));
    let n = nv;
    t.effectiveGasPrice != null ? n = t.effectiveGasPrice : t.gasPrice != null && (n = t.gasPrice), lr(this, {
      provider: r,
      to: t.to,
      from: t.from,
      contractAddress: t.contractAddress,
      hash: t.hash,
      index: t.index,
      blockHash: t.blockHash,
      blockNumber: t.blockNumber,
      logsBloom: t.logsBloom,
      gasUsed: t.gasUsed,
      cumulativeGasUsed: t.cumulativeGasUsed,
      blobGasUsed: t.blobGasUsed,
      gasPrice: n,
      blobGasPrice: t.blobGasPrice,
      type: t.type,
      //byzantium: tx.byzantium,
      status: t.status,
      root: t.root
    });
  }
  /**
   *  The logs for this transaction.
   */
  get logs() {
    return Xe(this, id);
  }
  /**
   *  Returns a JSON-compatible representation.
   */
  toJSON() {
    const {
      to: t,
      from: r,
      contractAddress: n,
      hash: s,
      index: i,
      blockHash: a,
      blockNumber: f,
      logsBloom: d,
      logs: c,
      //byzantium, 
      status: p,
      root: g
    } = this;
    return {
      _type: "TransactionReceipt",
      blockHash: a,
      blockNumber: f,
      //byzantium, 
      contractAddress: n,
      cumulativeGasUsed: li(this.cumulativeGasUsed),
      from: r,
      gasPrice: li(this.gasPrice),
      blobGasUsed: li(this.blobGasUsed),
      blobGasPrice: li(this.blobGasPrice),
      gasUsed: li(this.gasUsed),
      hash: s,
      index: i,
      logs: c,
      logsBloom: d,
      root: g,
      status: p,
      to: t
    };
  }
  /**
   *  @_ignore:
   */
  get length() {
    return this.logs.length;
  }
  [Symbol.iterator]() {
    let t = 0;
    return {
      next: () => t < this.length ? { value: this.logs[t++], done: !1 } : { value: void 0, done: !0 }
    };
  }
  /**
   *  The total fee for this transaction, in wei.
   */
  get fee() {
    return this.gasUsed * this.gasPrice;
  }
  /**
   *  Resolves to the block this transaction occurred in.
   */
  async getBlock() {
    const t = await this.provider.getBlock(this.blockHash);
    if (t == null)
      throw new Error("TODO");
    return t;
  }
  /**
   *  Resolves to the transaction this transaction occurred in.
   */
  async getTransaction() {
    const t = await this.provider.getTransaction(this.hash);
    if (t == null)
      throw new Error("TODO");
    return t;
  }
  /**
   *  Resolves to the return value of the execution of this transaction.
   *
   *  Support for this feature is limited, as it requires an archive node
   *  with the ``debug_`` or ``trace_`` API enabled.
   */
  async getResult() {
    return await this.provider.getTransactionResult(this.hash);
  }
  /**
   *  Resolves to the number of confirmations this transaction has.
   */
  async confirmations() {
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return sv(this);
  }
  /**
   *  @_ignore:
   */
  reorderedEvent(t) {
    return Yt(!t || t.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" }), iv(this, t);
  }
}
id = new WeakMap();
var Ao;
const ug = class ug {
  /**
   *  @_ignore:
   */
  constructor(t, r) {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */
    ze(this, "provider");
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    ze(this, "blockNumber");
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    ze(this, "blockHash");
    /**
     *  The index within the block that this transaction resides at.
     */
    ze(this, "index");
    /**
     *  The transaction hash.
     */
    ze(this, "hash");
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */
    ze(this, "type");
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */
    ze(this, "to");
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */
    ze(this, "from");
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */
    ze(this, "nonce");
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */
    ze(this, "gasLimit");
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */
    ze(this, "gasPrice");
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */
    ze(this, "maxPriorityFeePerGas");
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */
    ze(this, "maxFeePerGas");
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */
    ze(this, "maxFeePerBlobGas");
    /**
     *  The data.
     */
    ze(this, "data");
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */
    ze(this, "value");
    /**
     *  The chain ID.
     */
    ze(this, "chainId");
    /**
     *  The signature.
     */
    ze(this, "signature");
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */
    ze(this, "accessList");
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */
    ze(this, "blobVersionedHashes");
    Ar(this, Ao);
    this.provider = r, this.blockNumber = t.blockNumber != null ? t.blockNumber : null, this.blockHash = t.blockHash != null ? t.blockHash : null, this.hash = t.hash, this.index = t.index, this.type = t.type, this.from = t.from, this.to = t.to || null, this.gasLimit = t.gasLimit, this.nonce = t.nonce, this.data = t.data, this.value = t.value, this.gasPrice = t.gasPrice, this.maxPriorityFeePerGas = t.maxPriorityFeePerGas != null ? t.maxPriorityFeePerGas : null, this.maxFeePerGas = t.maxFeePerGas != null ? t.maxFeePerGas : null, this.maxFeePerBlobGas = t.maxFeePerBlobGas != null ? t.maxFeePerBlobGas : null, this.chainId = t.chainId, this.signature = t.signature, this.accessList = t.accessList != null ? t.accessList : null, this.blobVersionedHashes = t.blobVersionedHashes != null ? t.blobVersionedHashes : null, mr(this, Ao, -1);
  }
  /**
   *  Returns a JSON-compatible representation of this transaction.
   */
  toJSON() {
    const { blockNumber: t, blockHash: r, index: n, hash: s, type: i, to: a, from: f, nonce: d, data: c, signature: p, accessList: g, blobVersionedHashes: v } = this;
    return {
      _type: "TransactionResponse",
      accessList: g,
      blockNumber: t,
      blockHash: r,
      blobVersionedHashes: v,
      chainId: li(this.chainId),
      data: c,
      from: f,
      gasLimit: li(this.gasLimit),
      gasPrice: li(this.gasPrice),
      hash: s,
      maxFeePerGas: li(this.maxFeePerGas),
      maxPriorityFeePerGas: li(this.maxPriorityFeePerGas),
      maxFeePerBlobGas: li(this.maxFeePerBlobGas),
      nonce: d,
      signature: p,
      to: a,
      index: n,
      type: i,
      value: li(this.value)
    };
  }
  /**
   *  Resolves to the Block that this transaction was included in.
   *
   *  This will return null if the transaction has not been included yet.
   */
  async getBlock() {
    let t = this.blockNumber;
    if (t == null) {
      const n = await this.getTransaction();
      n && (t = n.blockNumber);
    }
    if (t == null)
      return null;
    const r = this.provider.getBlock(t);
    if (r == null)
      throw new Error("TODO");
    return r;
  }
  /**
   *  Resolves to this transaction being re-requested from the
   *  provider. This can be used if you have an unmined transaction
   *  and wish to get an up-to-date populated instance.
   */
  async getTransaction() {
    return this.provider.getTransaction(this.hash);
  }
  /**
   *  Resolve to the number of confirmations this transaction has.
   */
  async confirmations() {
    if (this.blockNumber == null) {
      const { tx: r, blockNumber: n } = await Qf({
        tx: this.getTransaction(),
        blockNumber: this.provider.getBlockNumber()
      });
      return r == null || r.blockNumber == null ? 0 : n - r.blockNumber + 1;
    }
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(t, r) {
    const n = t ?? 1, s = r ?? 0;
    let i = Xe(this, Ao), a = -1, f = i === -1;
    const d = async () => {
      if (f)
        return null;
      const { blockNumber: v, nonce: O } = await Qf({
        blockNumber: this.provider.getBlockNumber(),
        nonce: this.provider.getTransactionCount(this.from)
      });
      if (O < this.nonce) {
        i = v;
        return;
      }
      if (f)
        return null;
      const N = await this.getTransaction();
      if (!(N && N.blockNumber != null))
        for (a === -1 && (a = i - 3, a < Xe(this, Ao) && (a = Xe(this, Ao))); a <= v; ) {
          if (f)
            return null;
          const S = await this.provider.getBlock(a, !0);
          if (S == null)
            return;
          for (const j of S)
            if (j === this.hash)
              return;
          for (let j = 0; j < S.length; j++) {
            const B = await S.getTransaction(j);
            if (B.from === this.from && B.nonce === this.nonce) {
              if (f)
                return null;
              const M = await this.provider.getTransactionReceipt(B.hash);
              if (M == null || v - M.blockNumber + 1 < n)
                return;
              let I = "replaced";
              B.data === this.data && B.to === this.to && B.value === this.value ? I = "repriced" : B.data === "0x" && B.from === B.to && B.value === nv && (I = "cancelled"), Yt(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                cancelled: I === "replaced" || I === "cancelled",
                reason: I,
                replacement: B.replaceableTransaction(i),
                hash: B.hash,
                receipt: M
              });
            }
          }
          a++;
        }
    }, c = (v) => {
      if (v == null || v.status !== 0)
        return v;
      Yt(!1, "transaction execution reverted", "CALL_EXCEPTION", {
        action: "sendTransaction",
        data: null,
        reason: null,
        invocation: null,
        revert: null,
        transaction: {
          to: v.to,
          from: v.from,
          data: ""
          // @TODO: in v7, split out sendTransaction properties
        },
        receipt: v
      });
    }, p = await this.provider.getTransactionReceipt(this.hash);
    if (n === 0)
      return c(p);
    if (p) {
      if (await p.confirmations() >= n)
        return c(p);
    } else if (await d(), n === 0)
      return null;
    return await new Promise((v, O) => {
      const N = [], S = () => {
        N.forEach((B) => B());
      };
      if (N.push(() => {
        f = !0;
      }), s > 0) {
        const B = setTimeout(() => {
          S(), O(oh("wait for transaction timeout", "TIMEOUT"));
        }, s);
        N.push(() => {
          clearTimeout(B);
        });
      }
      const j = async (B) => {
        if (await B.confirmations() >= n) {
          S();
          try {
            v(c(B));
          } catch (M) {
            O(M);
          }
        }
      };
      if (N.push(() => {
        this.provider.off(this.hash, j);
      }), this.provider.on(this.hash, j), i >= 0) {
        const B = async () => {
          try {
            await d();
          } catch (M) {
            if (L0(M, "TRANSACTION_REPLACED")) {
              S(), O(M);
              return;
            }
          }
          f || this.provider.once("block", B);
        };
        N.push(() => {
          this.provider.off("block", B);
        }), this.provider.once("block", B);
      }
    });
  }
  /**
   *  Returns ``true`` if this transaction has been included.
   *
   *  This is effective only as of the time the TransactionResponse
   *  was instantiated. To get up-to-date information, use
   *  [[getTransaction]].
   *
   *  This provides a Type Guard that this transaction will have
   *  non-null property values for properties that are null for
   *  unmined transactions.
   */
  isMined() {
    return this.blockHash != null;
  }
  /**
   *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
   *  transaction.
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
   *  transaction. See [[link-eip-2070]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if the transaction is a London (i.e. ``type == 2``)
   *  transaction. See [[link-eip-1559]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
   *  transaction. See [[link-eip-4844]].
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that evict this transaction.
   */
  removedEvent() {
    return Yt(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), sv(this);
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that re-order this event against %%other%%.
   */
  reorderedEvent(t) {
    return Yt(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), Yt(!t || t.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), iv(this, t);
  }
  /**
   *  Returns a new TransactionResponse instance which has the ability to
   *  detect (and throw an error) if the transaction is replaced, which
   *  will begin scanning at %%startBlock%%.
   *
   *  This should generally not be used by developers and is intended
   *  primarily for internal use. Setting an incorrect %%startBlock%% can
   *  have devastating performance consequences if used incorrectly.
   */
  replaceableTransaction(t) {
    ct(Number.isInteger(t) && t >= 0, "invalid startBlock", "startBlock", t);
    const r = new ug(this, this.provider);
    return mr(r, Ao, t), r;
  }
};
Ao = new WeakMap();
let dp = ug;
function iv(e, t) {
  return { orphan: "reorder-transaction", tx: e, other: t };
}
function sv(e) {
  return { orphan: "drop-transaction", tx: e };
}
function SE(e) {
  return { orphan: "drop-log", log: {
    transactionHash: e.transactionHash,
    blockHash: e.blockHash,
    blockNumber: e.blockNumber,
    address: e.address,
    data: e.data,
    topics: Object.freeze(e.topics.slice()),
    index: e.index
  } };
}
class n1 extends Dh {
  /**
   * @_ignore:
   */
  constructor(r, n, s) {
    super(r, r.provider);
    /**
     *  The Contract Interface.
     */
    ze(this, "interface");
    /**
     *  The matching event.
     */
    ze(this, "fragment");
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */
    ze(this, "args");
    const i = n.decodeEventLog(s, r.data, r.topics);
    lr(this, { args: i, fragment: s, interface: n });
  }
  /**
   *  The name of the event.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The signature of the event.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
class ov extends Dh {
  /**
   * @_ignore:
   */
  constructor(r, n) {
    super(r, r.provider);
    /**
     *  The error encounted when trying to decode the log.
     */
    ze(this, "error");
    lr(this, { error: n });
  }
}
var Uu;
class ME extends kE {
  /**
   *  @_ignore:
   */
  constructor(r, n, s) {
    super(s, n);
    Ar(this, Uu);
    mr(this, Uu, r);
  }
  /**
   *  The parsed logs for any [[Log]] which has a matching event in the
   *  Contract ABI.
   */
  get logs() {
    return super.logs.map((r) => {
      const n = r.topics.length ? Xe(this, Uu).getEvent(r.topics[0]) : null;
      if (n)
        try {
          return new n1(r, Xe(this, Uu), n);
        } catch (s) {
          return new ov(r, s);
        }
      return r;
    });
  }
}
Uu = new WeakMap();
var sd;
class i1 extends dp {
  /**
   *  @_ignore:
   */
  constructor(r, n, s) {
    super(s, n);
    Ar(this, sd);
    mr(this, sd, r);
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(r, n) {
    const s = await super.wait(r, n);
    return s == null ? null : new ME(Xe(this, sd), this.provider, s);
  }
}
sd = new WeakMap();
class av extends hA {
  /**
   *  @_event:
   */
  constructor(r, n, s, i) {
    super(r, n, s);
    /**
     *  The log with no matching events.
     */
    ze(this, "log");
    lr(this, { log: i });
  }
  /**
   *  Resolves to the block the event occured in.
   */
  async getBlock() {
    return await this.log.getBlock();
  }
  /**
   *  Resolves to the transaction the event occured in.
   */
  async getTransaction() {
    return await this.log.getTransaction();
  }
  /**
   *  Resolves to the transaction receipt the event occured in.
   */
  async getTransactionReceipt() {
    return await this.log.getTransactionReceipt();
  }
}
class IE extends av {
  /**
   *  @_ignore:
   */
  constructor(t, r, n, s, i) {
    super(t, r, n, new n1(i, t.interface, s));
    const a = t.interface.decodeEventLog(s, this.log.data, this.log.topics);
    lr(this, { args: a, fragment: s });
  }
  /**
   *  The event name.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The event signature.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
const Qg = BigInt(0);
function uv(e) {
  return e && typeof e.call == "function";
}
function cv(e) {
  return e && typeof e.estimateGas == "function";
}
function jh(e) {
  return e && typeof e.resolveName == "function";
}
function lv(e) {
  return e && typeof e.sendTransaction == "function";
}
function dv(e) {
  if (e != null) {
    if (jh(e))
      return e;
    if (e.provider)
      return e.provider;
  }
}
var od;
class RE {
  constructor(t, r, n) {
    Ar(this, od);
    ze(this, "fragment");
    if (lr(this, { fragment: r }), r.inputs.length < n.length)
      throw new Error("too many arguments");
    const s = Za(t.runner, "resolveName"), i = jh(s) ? s : null;
    mr(this, od, async function() {
      const a = await Promise.all(r.inputs.map((f, d) => n[d] == null ? null : f.walkAsync(n[d], (p, g) => p === "address" ? Array.isArray(g) ? Promise.all(g.map((v) => G0(v, i))) : G0(g, i) : g)));
      return t.interface.encodeFilterTopics(r, a);
    }());
  }
  getTopicFilter() {
    return Xe(this, od);
  }
}
od = new WeakMap();
function Za(e, t) {
  return e == null ? null : typeof e[t] == "function" ? e : e.provider && typeof e.provider[t] == "function" ? e.provider : null;
}
function Ha(e) {
  return e == null ? null : e.provider || null;
}
async function hv(e, t) {
  const r = gn.dereference(e, "overrides");
  ct(typeof r == "object", "invalid overrides parameter", "overrides", e);
  const n = TE(r);
  return ct(n.to == null || (t || []).indexOf("to") >= 0, "cannot override to", "overrides.to", n.to), ct(n.data == null || (t || []).indexOf("data") >= 0, "cannot override data", "overrides.data", n.data), n.from && (n.from = n.from), n;
}
async function CE(e, t, r) {
  const n = Za(e, "resolveName"), s = jh(n) ? n : null;
  return await Promise.all(t.map((i, a) => i.walkAsync(r[a], (f, d) => (d = gn.dereference(d, f), f === "address" ? G0(d, s) : d))));
}
function BE(e) {
  const t = async function(a) {
    const f = await hv(a, ["data"]);
    f.to = await e.getAddress(), f.from && (f.from = await G0(f.from, dv(e.runner)));
    const d = e.interface, c = Ro(f.value || Qg, "overrides.value") === Qg, p = (f.data || "0x") === "0x";
    d.fallback && !d.fallback.payable && d.receive && !p && !c && ct(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", a), ct(d.fallback || p, "cannot send data to receive-only contract", "overrides.data", f.data);
    const g = d.receive || d.fallback && d.fallback.payable;
    return ct(g || c, "cannot send value to non-payable fallback", "overrides.value", f.value), ct(d.fallback || p, "cannot send data to receive-only contract", "overrides.data", f.data), f;
  }, r = async function(a) {
    const f = Za(e.runner, "call");
    Yt(uv(f), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const d = await t(a);
    try {
      return await f.call(d);
    } catch (c) {
      throw d4(c) && c.data ? e.interface.makeError(c.data, d) : c;
    }
  }, n = async function(a) {
    const f = e.runner;
    Yt(lv(f), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const d = await f.sendTransaction(await t(a)), c = Ha(e.runner);
    return new i1(e.interface, c, d);
  }, s = async function(a) {
    const f = Za(e.runner, "estimateGas");
    return Yt(cv(f), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await f.estimateGas(await t(a));
  }, i = async (a) => await n(a);
  return lr(i, {
    _contract: e,
    estimateGas: s,
    populateTransaction: t,
    send: n,
    staticCall: r
  }), i;
}
function _E(e, t) {
  const r = function(...c) {
    const p = e.interface.getFunction(t, c);
    return Yt(p, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: t, args: c }
    }), p;
  }, n = async function(...c) {
    const p = r(...c);
    let g = {};
    if (p.inputs.length + 1 === c.length && (g = await hv(c.pop()), g.from && (g.from = await G0(g.from, dv(e.runner)))), p.inputs.length !== c.length)
      throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
    const v = await CE(e.runner, p.inputs, c);
    return Object.assign({}, g, await Qf({
      to: e.getAddress(),
      data: e.interface.encodeFunctionData(p, v)
    }));
  }, s = async function(...c) {
    const p = await f(...c);
    return p.length === 1 ? p[0] : p;
  }, i = async function(...c) {
    const p = e.runner;
    Yt(lv(p), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const g = await p.sendTransaction(await n(...c)), v = Ha(e.runner);
    return new i1(e.interface, v, g);
  }, a = async function(...c) {
    const p = Za(e.runner, "estimateGas");
    return Yt(cv(p), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await p.estimateGas(await n(...c));
  }, f = async function(...c) {
    const p = Za(e.runner, "call");
    Yt(uv(p), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const g = await n(...c);
    let v = "0x";
    try {
      v = await p.call(g);
    } catch (N) {
      throw d4(N) && N.data ? e.interface.makeError(N.data, g) : N;
    }
    const O = r(...c);
    return e.interface.decodeFunctionResult(O, v);
  }, d = async (...c) => r(...c).constant ? await s(...c) : await i(...c);
  return lr(d, {
    name: e.interface.getFunctionName(t),
    _contract: e,
    _key: t,
    getFragment: r,
    estimateGas: a,
    populateTransaction: n,
    send: i,
    staticCall: s,
    staticCallResult: f
  }), Object.defineProperty(d, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const c = e.interface.getFunction(t);
      return Yt(c, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: t }
      }), c;
    }
  }), d;
}
function FE(e, t) {
  const r = function(...s) {
    const i = e.interface.getEvent(t, s);
    return Yt(i, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: t, args: s }
    }), i;
  }, n = function(...s) {
    return new RE(e, r(...s), s);
  };
  return lr(n, {
    name: e.interface.getEventName(t),
    _contract: e,
    _key: t,
    getFragment: r
  }), Object.defineProperty(n, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const s = e.interface.getEvent(t);
      return Yt(s, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: t }
      }), s;
    }
  }), n;
}
const dh = Symbol.for("_ethersInternal_contract"), fv = /* @__PURE__ */ new WeakMap();
function UE(e, t) {
  fv.set(e[dh], t);
}
function Jn(e) {
  return fv.get(e[dh]);
}
function DE(e) {
  return e && typeof e == "object" && "getTopicFilter" in e && typeof e.getTopicFilter == "function" && e.fragment;
}
async function s1(e, t) {
  let r, n = null;
  if (Array.isArray(t)) {
    const i = function(a) {
      if (zs(a, 32))
        return a;
      const f = e.interface.getEvent(a);
      return ct(f, "unknown fragment", "name", a), f.topicHash;
    };
    r = t.map((a) => a == null ? null : Array.isArray(a) ? a.map(i) : i(a));
  } else t === "*" ? r = [null] : typeof t == "string" ? zs(t, 32) ? r = [t] : (n = e.interface.getEvent(t), ct(n, "unknown fragment", "event", t), r = [n.topicHash]) : DE(t) ? r = await t.getTopicFilter() : "fragment" in t ? (n = t.fragment, r = [n.topicHash]) : ct(!1, "unknown event name", "event", t);
  r = r.map((i) => {
    if (i == null)
      return null;
    if (Array.isArray(i)) {
      const a = Array.from(new Set(i.map((f) => f.toLowerCase())).values());
      return a.length === 1 ? a[0] : (a.sort(), a);
    }
    return i.toLowerCase();
  });
  const s = r.map((i) => i == null ? "null" : Array.isArray(i) ? i.join("|") : i).join("&");
  return { fragment: n, tag: s, topics: r };
}
async function P0(e, t) {
  const { subs: r } = Jn(e);
  return r.get((await s1(e, t)).tag) || null;
}
async function Zg(e, t, r) {
  const n = Ha(e.runner);
  Yt(n, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation: t });
  const { fragment: s, tag: i, topics: a } = await s1(e, r), { addr: f, subs: d } = Jn(e);
  let c = d.get(i);
  if (!c) {
    const g = { address: f || e, topics: a }, v = (j) => {
      let B = s;
      if (B == null)
        try {
          B = e.interface.getEvent(j.topics[0]);
        } catch {
        }
      if (B) {
        const M = B, I = s ? e.interface.decodeEventLog(s, j.data, j.topics) : [];
        fp(e, r, I, (A) => new IE(e, A, r, M, j));
      } else
        fp(e, r, [], (M) => new av(e, M, r, j));
    };
    let O = [];
    c = { tag: i, listeners: [], start: () => {
      O.length || O.push(n.on(g, v));
    }, stop: async () => {
      if (O.length == 0)
        return;
      let j = O;
      O = [], await Promise.all(j), n.off(g, v);
    } }, d.set(i, c);
  }
  return c;
}
let hp = Promise.resolve();
async function jE(e, t, r, n) {
  await hp;
  const s = await P0(e, t);
  if (!s)
    return !1;
  const i = s.listeners.length;
  return s.listeners = s.listeners.filter(({ listener: a, once: f }) => {
    const d = Array.from(r);
    n && d.push(n(f ? null : a));
    try {
      a.call(e, ...d);
    } catch {
    }
    return !f;
  }), s.listeners.length === 0 && (s.stop(), Jn(e).subs.delete(s.tag)), i > 0;
}
async function fp(e, t, r, n) {
  try {
    await hp;
  } catch {
  }
  const s = jE(e, t, r, n);
  return hp = s, await s;
}
const Sd = ["then"];
var c4;
c4 = dh;
const j0 = class j0 {
  /**
   *  Creates a new contract connected to %%target%% with the %%abi%% and
   *  optionally connected to a %%runner%% to perform operations on behalf
   *  of.
   */
  constructor(t, r, n, s) {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */
    ze(this, "target");
    /**
     *  The contract Interface.
     */
    ze(this, "interface");
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */
    ze(this, "runner");
    /**
     *  All the Events available on this contract.
     */
    ze(this, "filters");
    /**
     *  @_ignore:
     */
    ze(this, c4);
    /**
     *  The fallback or receive function if any.
     */
    ze(this, "fallback");
    ct(typeof t == "string" || V4(t), "invalid value for Contract target", "target", t), n == null && (n = null);
    const i = lp.from(r);
    lr(this, { target: t, runner: n, interface: i }), Object.defineProperty(this, dh, { value: {} });
    let a, f = null, d = null;
    if (s) {
      const g = Ha(n);
      d = new i1(this.interface, g, s);
    }
    let c = /* @__PURE__ */ new Map();
    if (typeof t == "string")
      if (zs(t))
        f = t, a = Promise.resolve(t);
      else {
        const g = Za(n, "resolveName");
        if (!jh(g))
          throw oh("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
          });
        a = g.resolveName(t).then((v) => {
          if (v == null)
            throw oh("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
              value: t
            });
          return Jn(this).addr = v, v;
        });
      }
    else
      a = t.getAddress().then((g) => {
        if (g == null)
          throw new Error("TODO");
        return Jn(this).addr = g, g;
      });
    UE(this, { addrPromise: a, addr: f, deployTx: d, subs: c });
    const p = new Proxy({}, {
      get: (g, v, O) => {
        if (typeof v == "symbol" || Sd.indexOf(v) >= 0)
          return Reflect.get(g, v, O);
        try {
          return this.getEvent(v);
        } catch (N) {
          if (!L0(N, "INVALID_ARGUMENT") || N.argument !== "key")
            throw N;
        }
      },
      has: (g, v) => Sd.indexOf(v) >= 0 ? Reflect.has(g, v) : Reflect.has(g, v) || this.interface.hasEvent(String(v))
    });
    return lr(this, { filters: p }), lr(this, {
      fallback: i.receive || i.fallback ? BE(this) : null
    }), new Proxy(this, {
      get: (g, v, O) => {
        if (typeof v == "symbol" || v in g || Sd.indexOf(v) >= 0)
          return Reflect.get(g, v, O);
        try {
          return g.getFunction(v);
        } catch (N) {
          if (!L0(N, "INVALID_ARGUMENT") || N.argument !== "key")
            throw N;
        }
      },
      has: (g, v) => typeof v == "symbol" || v in g || Sd.indexOf(v) >= 0 ? Reflect.has(g, v) : g.interface.hasFunction(v)
    });
  }
  /**
   *  Return a new Contract instance with the same target and ABI, but
   *  a different %%runner%%.
   */
  connect(t) {
    return new j0(this.target, this.interface, t);
  }
  /**
   *  Return a new Contract instance with the same ABI and runner, but
   *  a different %%target%%.
   */
  attach(t) {
    return new j0(t, this.interface, this.runner);
  }
  /**
   *  Return the resolved address of this Contract.
   */
  async getAddress() {
    return await Jn(this).addrPromise;
  }
  /**
   *  Return the deployed bytecode or null if no bytecode is found.
   */
  async getDeployedCode() {
    const t = Ha(this.runner);
    Yt(t, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
    const r = await t.getCode(await this.getAddress());
    return r === "0x" ? null : r;
  }
  /**
   *  Resolve to this Contract once the bytecode has been deployed, or
   *  resolve immediately if already deployed.
   */
  async waitForDeployment() {
    const t = this.deploymentTransaction();
    if (t)
      return await t.wait(), this;
    if (await this.getDeployedCode() != null)
      return this;
    const n = Ha(this.runner);
    return Yt(n != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" }), new Promise((s, i) => {
      const a = async () => {
        try {
          if (await this.getDeployedCode() != null)
            return s(this);
          n.once("block", a);
        } catch (f) {
          i(f);
        }
      };
      a();
    });
  }
  /**
   *  Return the transaction used to deploy this contract.
   *
   *  This is only available if this instance was returned from a
   *  [[ContractFactory]].
   */
  deploymentTransaction() {
    return Jn(this).deployTx;
  }
  /**
   *  Return the function for a given name. This is useful when a contract
   *  method name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getFunction(t) {
    return typeof t != "string" && (t = t.format()), _E(this, t);
  }
  /**
   *  Return the event for a given name. This is useful when a contract
   *  event name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getEvent(t) {
    return typeof t != "string" && (t = t.format()), FE(this, t);
  }
  /**
   *  @_ignore:
   */
  async queryTransaction(t) {
    throw new Error("@TODO");
  }
  /*
      // @TODO: this is a non-backwards compatible change, but will be added
      //        in v7 and in a potential SmartContract class in an upcoming
      //        v6 release
      async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
          const provider = getProvider(this.runner);
          assert(provider, "contract runner does not have a provider",
              "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
  
          const receipt = await provider.getTransactionReceipt(hash);
          if (receipt == null) { return null; }
  
          return new ContractTransactionReceipt(this.interface, provider, receipt);
      }
      */
  /**
   *  Provide historic access to event data for %%event%% in the range
   *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
   *  inclusive.
   */
  async queryFilter(t, r, n) {
    r == null && (r = 0), n == null && (n = "latest");
    const { addr: s, addrPromise: i } = Jn(this), a = s || await i, { fragment: f, topics: d } = await s1(this, t), c = { address: a, topics: d, fromBlock: r, toBlock: n }, p = Ha(this.runner);
    return Yt(p, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" }), (await p.getLogs(c)).map((g) => {
      let v = f;
      if (v == null)
        try {
          v = this.interface.getEvent(g.topics[0]);
        } catch {
        }
      if (v)
        try {
          return new n1(g, this.interface, v);
        } catch (O) {
          return new ov(g, O);
        }
      return new Dh(g, p);
    });
  }
  /**
   *  Add an event %%listener%% for the %%event%%.
   */
  async on(t, r) {
    const n = await Zg(this, "on", t);
    return n.listeners.push({ listener: r, once: !1 }), n.start(), this;
  }
  /**
   *  Add an event %%listener%% for the %%event%%, but remove the listener
   *  after it is fired once.
   */
  async once(t, r) {
    const n = await Zg(this, "once", t);
    return n.listeners.push({ listener: r, once: !0 }), n.start(), this;
  }
  /**
   *  Emit an %%event%% calling all listeners with %%args%%.
   *
   *  Resolves to ``true`` if any listeners were called.
   */
  async emit(t, ...r) {
    return await fp(this, t, r, null);
  }
  /**
   *  Resolves to the number of listeners of %%event%% or the total number
   *  of listeners if unspecified.
   */
  async listenerCount(t) {
    if (t) {
      const s = await P0(this, t);
      return s ? s.listeners.length : 0;
    }
    const { subs: r } = Jn(this);
    let n = 0;
    for (const { listeners: s } of r.values())
      n += s.length;
    return n;
  }
  /**
   *  Resolves to the listeners subscribed to %%event%% or all listeners
   *  if unspecified.
   */
  async listeners(t) {
    if (t) {
      const s = await P0(this, t);
      return s ? s.listeners.map(({ listener: i }) => i) : [];
    }
    const { subs: r } = Jn(this);
    let n = [];
    for (const { listeners: s } of r.values())
      n = n.concat(s.map(({ listener: i }) => i));
    return n;
  }
  /**
   *  Remove the %%listener%% from the listeners for %%event%% or remove
   *  all listeners if unspecified.
   */
  async off(t, r) {
    const n = await P0(this, t);
    if (!n)
      return this;
    if (r) {
      const s = n.listeners.map(({ listener: i }) => i).indexOf(r);
      s >= 0 && n.listeners.splice(s, 1);
    }
    return (r == null || n.listeners.length === 0) && (n.stop(), Jn(this).subs.delete(n.tag)), this;
  }
  /**
   *  Remove all the listeners for %%event%% or remove all listeners if
   *  unspecified.
   */
  async removeAllListeners(t) {
    if (t) {
      const r = await P0(this, t);
      if (!r)
        return this;
      r.stop(), Jn(this).subs.delete(r.tag);
    } else {
      const { subs: r } = Jn(this);
      for (const { tag: n, stop: s } of r.values())
        s(), r.delete(n);
    }
    return this;
  }
  /**
   *  Alias for [on].
   */
  async addListener(t, r) {
    return await this.on(t, r);
  }
  /**
   *  Alias for [off].
   */
  async removeListener(t, r) {
    return await this.off(t, r);
  }
  /**
   *  Create a new Class for the %%abi%%.
   */
  static buildClass(t) {
    class r extends j0 {
      constructor(s, i = null) {
        super(s, t, i);
      }
    }
    return r;
  }
  /**
   *  Create a new BaseContract with a specified Interface.
   */
  static from(t, r, n) {
    return n == null && (n = null), new this(t, r, n);
  }
};
let pp = j0;
function LE() {
  return pp;
}
class HE extends LE() {
}
var pv = {};
const WE = [
  {
    constant: !0,
    inputs: [],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_spender",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_from",
        type: "address"
      },
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "_owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "balance",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "_owner",
        type: "address"
      },
      {
        name: "_spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    payable: !0,
    stateMutability: "payable",
    type: "fallback"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  }
], GE = {
  ERC20ABI: WE
}, zE = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], VE = {
  ERC721ABI: zE
}, qE = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "AdminApproved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "AdminRevoked",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "ApproveTransferUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "DefaultRoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "ExtensionApproveTransferUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionBlacklisted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionRegistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "ExtensionRoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionUnregistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "permissions",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "MintPermissionsUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "RoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "approveAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "blacklistExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "getAdmins",
    outputs: [
      {
        internalType: "address[]",
        name: "admins",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getApproveTransfer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getExtensions",
    outputs: [
      {
        internalType: "address[]",
        name: "extensions",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFeeBps",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFeeRecipients",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFees",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getRoyalties",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mintBase",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "mintBase",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "mintBaseBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "count",
        type: "uint16"
      }
    ],
    name: "mintBaseBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mintExtension",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "mintExtension",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "mintExtensionBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "count",
        type: "uint16"
      }
    ],
    name: "mintExtensionBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      }
    ],
    name: "registerExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      },
      {
        internalType: "bool",
        name: "baseURIIdentical",
        type: "bool"
      }
    ],
    name: "registerExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "revokeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "setApproveTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setApproveTransferExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setBaseTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setBaseTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      },
      {
        internalType: "bool",
        name: "identical",
        type: "bool"
      }
    ],
    name: "setBaseTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "address",
        name: "permissions",
        type: "address"
      }
    ],
    name: "setMintPermissions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyaltiesExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "setTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefixExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenExtension",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "unregisterExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], $E = {
  ERC721CreatorABI: qE
}, KE = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "URI",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], JE = {
  ERC1155ABI: KE
}, QE = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "AdminApproved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "AdminRevoked",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "ApproveTransferUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "DefaultRoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "ExtensionApproveTransferUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionBlacklisted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionRegistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "ExtensionRoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionUnregistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "permissions",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "MintPermissionsUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "RoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "URI",
    type: "event"
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "approveAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "blacklistExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "getAdmins",
    outputs: [
      {
        internalType: "address[]",
        name: "admins",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getApproveTransfer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getExtensions",
    outputs: [
      {
        internalType: "address[]",
        name: "extensions",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFeeBps",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFeeRecipients",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFees",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getRoyalties",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "mintBaseExisting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "mintBaseNew",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "mintExtensionExisting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "mintExtensionNew",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      }
    ],
    name: "registerExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      },
      {
        internalType: "bool",
        name: "baseURIIdentical",
        type: "bool"
      }
    ],
    name: "registerExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "revokeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "setApproveTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setApproveTransferExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    name: "setBaseTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    name: "setBaseTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      },
      {
        internalType: "bool",
        name: "identical",
        type: "bool"
      }
    ],
    name: "setBaseTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "address",
        name: "permissions",
        type: "address"
      }
    ],
    name: "setMintPermissions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyaltiesExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "setTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    name: "setTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefixExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenExtension",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "unregisterExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], ZE = {
  ERC1155CreatorABI: QE
}, YE = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "caller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "series",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      }
    ],
    name: "SeriesCreated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      }
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      }
    ],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "maxSupply_",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "createSeries",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      }
    ],
    name: "latestSeries",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "recipients",
        type: "address[]"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "count",
        type: "uint16"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], XE = {
  ManifoldERC721EditionABI: YE
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ERC1155CreatorABI = e.ERC721CreatorABI = e.ERC1155ABI = e.ManifoldERC721EditionABI = e.ERC721ABI = e.ERC20ABI = void 0;
  var t = GE;
  Object.defineProperty(e, "ERC20ABI", { enumerable: !0, get: function() {
    return t.ERC20ABI;
  } });
  var r = VE;
  Object.defineProperty(e, "ERC721ABI", { enumerable: !0, get: function() {
    return r.ERC721ABI;
  } });
  var n = $E;
  Object.defineProperty(e, "ERC721CreatorABI", { enumerable: !0, get: function() {
    return n.ERC721CreatorABI;
  } });
  var s = JE;
  Object.defineProperty(e, "ERC1155ABI", { enumerable: !0, get: function() {
    return s.ERC1155ABI;
  } });
  var i = ZE;
  Object.defineProperty(e, "ERC1155CreatorABI", { enumerable: !0, get: function() {
    return i.ERC1155CreatorABI;
  } });
  var a = XE;
  Object.defineProperty(e, "ManifoldERC721EditionABI", { enumerable: !0, get: function() {
    return a.ManifoldERC721EditionABI;
  } });
})(pv);
var eP = Object.defineProperty, tP = (e, t, r) => t in e ? eP(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Be = (e, t, r) => (tP(e, typeof t != "symbol" ? t + "" : t, r), r), o1 = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, oe = (e, t, r) => (o1(e, t, "read from private field"), r ? r.call(e) : t.get(e)), _e = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, Oe = (e, t, r, n) => (o1(e, t, "write to private field"), t.set(e, r), r), q0 = (e, t, r, n) => ({
  set _(s) {
    Oe(e, t, s);
  },
  get _() {
    return oe(e, t, n);
  }
}), Ve = (e, t, r) => (o1(e, t, "access private method"), r), Ze = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function gv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Lh(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var mv = { exports: {} };
const rP = {}, nP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rP
}, Symbol.toStringTag, { value: "Module" })), iP = /* @__PURE__ */ Lh(nP);
(function(e) {
  (function(t, r) {
    function n(o, u) {
      if (!o)
        throw new Error(u || "Assertion failed");
    }
    function s(o, u) {
      o.super_ = u;
      var h = function() {
      };
      h.prototype = u.prototype, o.prototype = new h(), o.prototype.constructor = o;
    }
    function i(o, u, h) {
      if (i.isBN(o))
        return o;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, o !== null && ((u === "le" || u === "be") && (h = u, u = 10), this._init(o || 0, u || 10, h || "be"));
    }
    typeof t == "object" ? t.exports = i : r.BN = i, i.BN = i, i.wordSize = 26;
    var a;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? a = window.Buffer : a = iP.Buffer;
    } catch {
    }
    i.isBN = function(o) {
      return o instanceof i ? !0 : o !== null && typeof o == "object" && o.constructor.wordSize === i.wordSize && Array.isArray(o.words);
    }, i.max = function(o, u) {
      return o.cmp(u) > 0 ? o : u;
    }, i.min = function(o, u) {
      return o.cmp(u) < 0 ? o : u;
    }, i.prototype._init = function(o, u, h) {
      if (typeof o == "number")
        return this._initNumber(o, u, h);
      if (typeof o == "object")
        return this._initArray(o, u, h);
      u === "hex" && (u = 16), n(u === (u | 0) && u >= 2 && u <= 36), o = o.toString().replace(/\s+/g, "");
      var y = 0;
      o[0] === "-" && (y++, this.negative = 1), y < o.length && (u === 16 ? this._parseHex(o, y, h) : (this._parseBase(o, u, y), h === "le" && this._initArray(this.toArray(), u, h)));
    }, i.prototype._initNumber = function(o, u, h) {
      o < 0 && (this.negative = 1, o = -o), o < 67108864 ? (this.words = [o & 67108863], this.length = 1) : o < 4503599627370496 ? (this.words = [
        o & 67108863,
        o / 67108864 & 67108863
      ], this.length = 2) : (n(o < 9007199254740992), this.words = [
        o & 67108863,
        o / 67108864 & 67108863,
        1
      ], this.length = 3), h === "le" && this._initArray(this.toArray(), u, h);
    }, i.prototype._initArray = function(o, u, h) {
      if (n(typeof o.length == "number"), o.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(o.length / 3), this.words = new Array(this.length);
      for (var y = 0; y < this.length; y++)
        this.words[y] = 0;
      var E, P, w = 0;
      if (h === "be")
        for (y = o.length - 1, E = 0; y >= 0; y -= 3)
          P = o[y] | o[y - 1] << 8 | o[y - 2] << 16, this.words[E] |= P << w & 67108863, this.words[E + 1] = P >>> 26 - w & 67108863, w += 24, w >= 26 && (w -= 26, E++);
      else if (h === "le")
        for (y = 0, E = 0; y < o.length; y += 3)
          P = o[y] | o[y + 1] << 8 | o[y + 2] << 16, this.words[E] |= P << w & 67108863, this.words[E + 1] = P >>> 26 - w & 67108863, w += 24, w >= 26 && (w -= 26, E++);
      return this._strip();
    };
    function f(o, u) {
      var h = o.charCodeAt(u);
      if (h >= 48 && h <= 57)
        return h - 48;
      if (h >= 65 && h <= 70)
        return h - 55;
      if (h >= 97 && h <= 102)
        return h - 87;
      n(!1, "Invalid character in " + o);
    }
    function d(o, u, h) {
      var y = f(o, h);
      return h - 1 >= u && (y |= f(o, h - 1) << 4), y;
    }
    i.prototype._parseHex = function(o, u, h) {
      this.length = Math.ceil((o.length - u) / 6), this.words = new Array(this.length);
      for (var y = 0; y < this.length; y++)
        this.words[y] = 0;
      var E = 0, P = 0, w;
      if (h === "be")
        for (y = o.length - 1; y >= u; y -= 2)
          w = d(o, u, y) << E, this.words[P] |= w & 67108863, E >= 18 ? (E -= 18, P += 1, this.words[P] |= w >>> 26) : E += 8;
      else {
        var m = o.length - u;
        for (y = m % 2 === 0 ? u + 1 : u; y < o.length; y += 2)
          w = d(o, u, y) << E, this.words[P] |= w & 67108863, E >= 18 ? (E -= 18, P += 1, this.words[P] |= w >>> 26) : E += 8;
      }
      this._strip();
    };
    function c(o, u, h, y) {
      for (var E = 0, P = 0, w = Math.min(o.length, h), m = u; m < w; m++) {
        var l = o.charCodeAt(m) - 48;
        E *= y, l >= 49 ? P = l - 49 + 10 : l >= 17 ? P = l - 17 + 10 : P = l, n(l >= 0 && P < y, "Invalid character"), E += P;
      }
      return E;
    }
    i.prototype._parseBase = function(o, u, h) {
      this.words = [0], this.length = 1;
      for (var y = 0, E = 1; E <= 67108863; E *= u)
        y++;
      y--, E = E / u | 0;
      for (var P = o.length - h, w = P % y, m = Math.min(P, P - w) + h, l = 0, b = h; b < m; b += y)
        l = c(o, b, b + y, u), this.imuln(E), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
      if (w !== 0) {
        var W = 1;
        for (l = c(o, b, o.length, u), b = 0; b < w; b++)
          W *= u;
        this.imuln(W), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
      }
      this._strip();
    }, i.prototype.copy = function(o) {
      o.words = new Array(this.length);
      for (var u = 0; u < this.length; u++)
        o.words[u] = this.words[u];
      o.length = this.length, o.negative = this.negative, o.red = this.red;
    };
    function p(o, u) {
      o.words = u.words, o.length = u.length, o.negative = u.negative, o.red = u.red;
    }
    if (i.prototype._move = function(o) {
      p(o, this);
    }, i.prototype.clone = function() {
      var o = new i(null);
      return this.copy(o), o;
    }, i.prototype._expand = function(o) {
      for (; this.length < o; )
        this.words[this.length++] = 0;
      return this;
    }, i.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, i.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        i.prototype[Symbol.for("nodejs.util.inspect.custom")] = g;
      } catch {
        i.prototype.inspect = g;
      }
    else
      i.prototype.inspect = g;
    function g() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var v = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], O = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], N = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    i.prototype.toString = function(o, u) {
      o = o || 10, u = u | 0 || 1;
      var h;
      if (o === 16 || o === "hex") {
        h = "";
        for (var y = 0, E = 0, P = 0; P < this.length; P++) {
          var w = this.words[P], m = ((w << y | E) & 16777215).toString(16);
          E = w >>> 24 - y & 16777215, y += 2, y >= 26 && (y -= 26, P--), E !== 0 || P !== this.length - 1 ? h = v[6 - m.length] + m + h : h = m + h;
        }
        for (E !== 0 && (h = E.toString(16) + h); h.length % u !== 0; )
          h = "0" + h;
        return this.negative !== 0 && (h = "-" + h), h;
      }
      if (o === (o | 0) && o >= 2 && o <= 36) {
        var l = O[o], b = N[o];
        h = "";
        var W = this.clone();
        for (W.negative = 0; !W.isZero(); ) {
          var X = W.modrn(b).toString(o);
          W = W.idivn(b), W.isZero() ? h = X + h : h = v[l - X.length] + X + h;
        }
        for (this.isZero() && (h = "0" + h); h.length % u !== 0; )
          h = "0" + h;
        return this.negative !== 0 && (h = "-" + h), h;
      }
      n(!1, "Base should be between 2 and 36");
    }, i.prototype.toNumber = function() {
      var o = this.words[0];
      return this.length === 2 ? o += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? o += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -o : o;
    }, i.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, a && (i.prototype.toBuffer = function(o, u) {
      return this.toArrayLike(a, o, u);
    }), i.prototype.toArray = function(o, u) {
      return this.toArrayLike(Array, o, u);
    };
    var S = function(o, u) {
      return o.allocUnsafe ? o.allocUnsafe(u) : new o(u);
    };
    i.prototype.toArrayLike = function(o, u, h) {
      this._strip();
      var y = this.byteLength(), E = h || Math.max(1, y);
      n(y <= E, "byte array longer than desired length"), n(E > 0, "Requested array length <= 0");
      var P = S(o, E), w = u === "le" ? "LE" : "BE";
      return this["_toArrayLike" + w](P, y), P;
    }, i.prototype._toArrayLikeLE = function(o, u) {
      for (var h = 0, y = 0, E = 0, P = 0; E < this.length; E++) {
        var w = this.words[E] << P | y;
        o[h++] = w & 255, h < o.length && (o[h++] = w >> 8 & 255), h < o.length && (o[h++] = w >> 16 & 255), P === 6 ? (h < o.length && (o[h++] = w >> 24 & 255), y = 0, P = 0) : (y = w >>> 24, P += 2);
      }
      if (h < o.length)
        for (o[h++] = y; h < o.length; )
          o[h++] = 0;
    }, i.prototype._toArrayLikeBE = function(o, u) {
      for (var h = o.length - 1, y = 0, E = 0, P = 0; E < this.length; E++) {
        var w = this.words[E] << P | y;
        o[h--] = w & 255, h >= 0 && (o[h--] = w >> 8 & 255), h >= 0 && (o[h--] = w >> 16 & 255), P === 6 ? (h >= 0 && (o[h--] = w >> 24 & 255), y = 0, P = 0) : (y = w >>> 24, P += 2);
      }
      if (h >= 0)
        for (o[h--] = y; h >= 0; )
          o[h--] = 0;
    }, Math.clz32 ? i.prototype._countBits = function(o) {
      return 32 - Math.clz32(o);
    } : i.prototype._countBits = function(o) {
      var u = o, h = 0;
      return u >= 4096 && (h += 13, u >>>= 13), u >= 64 && (h += 7, u >>>= 7), u >= 8 && (h += 4, u >>>= 4), u >= 2 && (h += 2, u >>>= 2), h + u;
    }, i.prototype._zeroBits = function(o) {
      if (o === 0)
        return 26;
      var u = o, h = 0;
      return u & 8191 || (h += 13, u >>>= 13), u & 127 || (h += 7, u >>>= 7), u & 15 || (h += 4, u >>>= 4), u & 3 || (h += 2, u >>>= 2), u & 1 || h++, h;
    }, i.prototype.bitLength = function() {
      var o = this.words[this.length - 1], u = this._countBits(o);
      return (this.length - 1) * 26 + u;
    };
    function j(o) {
      for (var u = new Array(o.bitLength()), h = 0; h < u.length; h++) {
        var y = h / 26 | 0, E = h % 26;
        u[h] = o.words[y] >>> E & 1;
      }
      return u;
    }
    i.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var o = 0, u = 0; u < this.length; u++) {
        var h = this._zeroBits(this.words[u]);
        if (o += h, h !== 26)
          break;
      }
      return o;
    }, i.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, i.prototype.toTwos = function(o) {
      return this.negative !== 0 ? this.abs().inotn(o).iaddn(1) : this.clone();
    }, i.prototype.fromTwos = function(o) {
      return this.testn(o - 1) ? this.notn(o).iaddn(1).ineg() : this.clone();
    }, i.prototype.isNeg = function() {
      return this.negative !== 0;
    }, i.prototype.neg = function() {
      return this.clone().ineg();
    }, i.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, i.prototype.iuor = function(o) {
      for (; this.length < o.length; )
        this.words[this.length++] = 0;
      for (var u = 0; u < o.length; u++)
        this.words[u] = this.words[u] | o.words[u];
      return this._strip();
    }, i.prototype.ior = function(o) {
      return n((this.negative | o.negative) === 0), this.iuor(o);
    }, i.prototype.or = function(o) {
      return this.length > o.length ? this.clone().ior(o) : o.clone().ior(this);
    }, i.prototype.uor = function(o) {
      return this.length > o.length ? this.clone().iuor(o) : o.clone().iuor(this);
    }, i.prototype.iuand = function(o) {
      var u;
      this.length > o.length ? u = o : u = this;
      for (var h = 0; h < u.length; h++)
        this.words[h] = this.words[h] & o.words[h];
      return this.length = u.length, this._strip();
    }, i.prototype.iand = function(o) {
      return n((this.negative | o.negative) === 0), this.iuand(o);
    }, i.prototype.and = function(o) {
      return this.length > o.length ? this.clone().iand(o) : o.clone().iand(this);
    }, i.prototype.uand = function(o) {
      return this.length > o.length ? this.clone().iuand(o) : o.clone().iuand(this);
    }, i.prototype.iuxor = function(o) {
      var u, h;
      this.length > o.length ? (u = this, h = o) : (u = o, h = this);
      for (var y = 0; y < h.length; y++)
        this.words[y] = u.words[y] ^ h.words[y];
      if (this !== u)
        for (; y < u.length; y++)
          this.words[y] = u.words[y];
      return this.length = u.length, this._strip();
    }, i.prototype.ixor = function(o) {
      return n((this.negative | o.negative) === 0), this.iuxor(o);
    }, i.prototype.xor = function(o) {
      return this.length > o.length ? this.clone().ixor(o) : o.clone().ixor(this);
    }, i.prototype.uxor = function(o) {
      return this.length > o.length ? this.clone().iuxor(o) : o.clone().iuxor(this);
    }, i.prototype.inotn = function(o) {
      n(typeof o == "number" && o >= 0);
      var u = Math.ceil(o / 26) | 0, h = o % 26;
      this._expand(u), h > 0 && u--;
      for (var y = 0; y < u; y++)
        this.words[y] = ~this.words[y] & 67108863;
      return h > 0 && (this.words[y] = ~this.words[y] & 67108863 >> 26 - h), this._strip();
    }, i.prototype.notn = function(o) {
      return this.clone().inotn(o);
    }, i.prototype.setn = function(o, u) {
      n(typeof o == "number" && o >= 0);
      var h = o / 26 | 0, y = o % 26;
      return this._expand(h + 1), u ? this.words[h] = this.words[h] | 1 << y : this.words[h] = this.words[h] & ~(1 << y), this._strip();
    }, i.prototype.iadd = function(o) {
      var u;
      if (this.negative !== 0 && o.negative === 0)
        return this.negative = 0, u = this.isub(o), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && o.negative !== 0)
        return o.negative = 0, u = this.isub(o), o.negative = 1, u._normSign();
      var h, y;
      this.length > o.length ? (h = this, y = o) : (h = o, y = this);
      for (var E = 0, P = 0; P < y.length; P++)
        u = (h.words[P] | 0) + (y.words[P] | 0) + E, this.words[P] = u & 67108863, E = u >>> 26;
      for (; E !== 0 && P < h.length; P++)
        u = (h.words[P] | 0) + E, this.words[P] = u & 67108863, E = u >>> 26;
      if (this.length = h.length, E !== 0)
        this.words[this.length] = E, this.length++;
      else if (h !== this)
        for (; P < h.length; P++)
          this.words[P] = h.words[P];
      return this;
    }, i.prototype.add = function(o) {
      var u;
      return o.negative !== 0 && this.negative === 0 ? (o.negative = 0, u = this.sub(o), o.negative ^= 1, u) : o.negative === 0 && this.negative !== 0 ? (this.negative = 0, u = o.sub(this), this.negative = 1, u) : this.length > o.length ? this.clone().iadd(o) : o.clone().iadd(this);
    }, i.prototype.isub = function(o) {
      if (o.negative !== 0) {
        o.negative = 0;
        var u = this.iadd(o);
        return o.negative = 1, u._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(o), this.negative = 1, this._normSign();
      var h = this.cmp(o);
      if (h === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var y, E;
      h > 0 ? (y = this, E = o) : (y = o, E = this);
      for (var P = 0, w = 0; w < E.length; w++)
        u = (y.words[w] | 0) - (E.words[w] | 0) + P, P = u >> 26, this.words[w] = u & 67108863;
      for (; P !== 0 && w < y.length; w++)
        u = (y.words[w] | 0) + P, P = u >> 26, this.words[w] = u & 67108863;
      if (P === 0 && w < y.length && y !== this)
        for (; w < y.length; w++)
          this.words[w] = y.words[w];
      return this.length = Math.max(this.length, w), y !== this && (this.negative = 1), this._strip();
    }, i.prototype.sub = function(o) {
      return this.clone().isub(o);
    };
    function B(o, u, h) {
      h.negative = u.negative ^ o.negative;
      var y = o.length + u.length | 0;
      h.length = y, y = y - 1 | 0;
      var E = o.words[0] | 0, P = u.words[0] | 0, w = E * P, m = w & 67108863, l = w / 67108864 | 0;
      h.words[0] = m;
      for (var b = 1; b < y; b++) {
        for (var W = l >>> 26, X = l & 67108863, G = Math.min(b, u.length - 1), re = Math.max(0, b - o.length + 1); re <= G; re++) {
          var ce = b - re | 0;
          E = o.words[ce] | 0, P = u.words[re] | 0, w = E * P + X, W += w / 67108864 | 0, X = w & 67108863;
        }
        h.words[b] = X | 0, l = W | 0;
      }
      return l !== 0 ? h.words[b] = l | 0 : h.length--, h._strip();
    }
    var M = function(o, u, h) {
      var y = o.words, E = u.words, P = h.words, w = 0, m, l, b, W = y[0] | 0, X = W & 8191, G = W >>> 13, re = y[1] | 0, ce = re & 8191, pe = re >>> 13, ve = y[2] | 0, Ee = ve & 8191, Pe = ve >>> 13, xe = y[3] | 0, me = xe & 8191, te = xe >>> 13, U = y[4] | 0, ue = U & 8191, we = U >>> 13, ke = y[5] | 0, Re = ke & 8191, fe = ke >>> 13, x = y[6] | 0, _ = x & 8191, q = x >>> 13, ne = y[7] | 0, de = ne & 8191, ye = ne >>> 13, ge = y[8] | 0, be = ge & 8191, Me = ge >>> 13, Ce = y[9] | 0, je = Ce & 8191, Ue = Ce >>> 13, Qe = E[0] | 0, Ye = Qe & 8191, et = Qe >>> 13, At = E[1] | 0, it = At & 8191, tt = At >>> 13, Pt = E[2] | 0, dt = Pt & 8191, st = Pt >>> 13, zt = E[3] | 0, xt = zt & 8191, lt = zt >>> 13, $t = E[4] | 0, Tt = $t & 8191, at = $t >>> 13, Ut = E[5] | 0, Ot = Ut & 8191, He = Ut >>> 13, Vt = E[6] | 0, yt = Vt & 8191, ut = Vt >>> 13, It = E[7] | 0, kt = It & 8191, ot = It >>> 13, Rt = E[8] | 0, Nt = Rt & 8191, rt = Rt >>> 13, Dt = E[9] | 0, St = Dt & 8191, T = Dt >>> 13;
      h.negative = o.negative ^ u.negative, h.length = 19, m = Math.imul(X, Ye), l = Math.imul(X, et), l = l + Math.imul(G, Ye) | 0, b = Math.imul(G, et);
      var F = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (F >>> 26) | 0, F &= 67108863, m = Math.imul(ce, Ye), l = Math.imul(ce, et), l = l + Math.imul(pe, Ye) | 0, b = Math.imul(pe, et), m = m + Math.imul(X, it) | 0, l = l + Math.imul(X, tt) | 0, l = l + Math.imul(G, it) | 0, b = b + Math.imul(G, tt) | 0;
      var H = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (H >>> 26) | 0, H &= 67108863, m = Math.imul(Ee, Ye), l = Math.imul(Ee, et), l = l + Math.imul(Pe, Ye) | 0, b = Math.imul(Pe, et), m = m + Math.imul(ce, it) | 0, l = l + Math.imul(ce, tt) | 0, l = l + Math.imul(pe, it) | 0, b = b + Math.imul(pe, tt) | 0, m = m + Math.imul(X, dt) | 0, l = l + Math.imul(X, st) | 0, l = l + Math.imul(G, dt) | 0, b = b + Math.imul(G, st) | 0;
      var z = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (z >>> 26) | 0, z &= 67108863, m = Math.imul(me, Ye), l = Math.imul(me, et), l = l + Math.imul(te, Ye) | 0, b = Math.imul(te, et), m = m + Math.imul(Ee, it) | 0, l = l + Math.imul(Ee, tt) | 0, l = l + Math.imul(Pe, it) | 0, b = b + Math.imul(Pe, tt) | 0, m = m + Math.imul(ce, dt) | 0, l = l + Math.imul(ce, st) | 0, l = l + Math.imul(pe, dt) | 0, b = b + Math.imul(pe, st) | 0, m = m + Math.imul(X, xt) | 0, l = l + Math.imul(X, lt) | 0, l = l + Math.imul(G, xt) | 0, b = b + Math.imul(G, lt) | 0;
      var Q = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Q >>> 26) | 0, Q &= 67108863, m = Math.imul(ue, Ye), l = Math.imul(ue, et), l = l + Math.imul(we, Ye) | 0, b = Math.imul(we, et), m = m + Math.imul(me, it) | 0, l = l + Math.imul(me, tt) | 0, l = l + Math.imul(te, it) | 0, b = b + Math.imul(te, tt) | 0, m = m + Math.imul(Ee, dt) | 0, l = l + Math.imul(Ee, st) | 0, l = l + Math.imul(Pe, dt) | 0, b = b + Math.imul(Pe, st) | 0, m = m + Math.imul(ce, xt) | 0, l = l + Math.imul(ce, lt) | 0, l = l + Math.imul(pe, xt) | 0, b = b + Math.imul(pe, lt) | 0, m = m + Math.imul(X, Tt) | 0, l = l + Math.imul(X, at) | 0, l = l + Math.imul(G, Tt) | 0, b = b + Math.imul(G, at) | 0;
      var Z = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Z >>> 26) | 0, Z &= 67108863, m = Math.imul(Re, Ye), l = Math.imul(Re, et), l = l + Math.imul(fe, Ye) | 0, b = Math.imul(fe, et), m = m + Math.imul(ue, it) | 0, l = l + Math.imul(ue, tt) | 0, l = l + Math.imul(we, it) | 0, b = b + Math.imul(we, tt) | 0, m = m + Math.imul(me, dt) | 0, l = l + Math.imul(me, st) | 0, l = l + Math.imul(te, dt) | 0, b = b + Math.imul(te, st) | 0, m = m + Math.imul(Ee, xt) | 0, l = l + Math.imul(Ee, lt) | 0, l = l + Math.imul(Pe, xt) | 0, b = b + Math.imul(Pe, lt) | 0, m = m + Math.imul(ce, Tt) | 0, l = l + Math.imul(ce, at) | 0, l = l + Math.imul(pe, Tt) | 0, b = b + Math.imul(pe, at) | 0, m = m + Math.imul(X, Ot) | 0, l = l + Math.imul(X, He) | 0, l = l + Math.imul(G, Ot) | 0, b = b + Math.imul(G, He) | 0;
      var ie = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (ie >>> 26) | 0, ie &= 67108863, m = Math.imul(_, Ye), l = Math.imul(_, et), l = l + Math.imul(q, Ye) | 0, b = Math.imul(q, et), m = m + Math.imul(Re, it) | 0, l = l + Math.imul(Re, tt) | 0, l = l + Math.imul(fe, it) | 0, b = b + Math.imul(fe, tt) | 0, m = m + Math.imul(ue, dt) | 0, l = l + Math.imul(ue, st) | 0, l = l + Math.imul(we, dt) | 0, b = b + Math.imul(we, st) | 0, m = m + Math.imul(me, xt) | 0, l = l + Math.imul(me, lt) | 0, l = l + Math.imul(te, xt) | 0, b = b + Math.imul(te, lt) | 0, m = m + Math.imul(Ee, Tt) | 0, l = l + Math.imul(Ee, at) | 0, l = l + Math.imul(Pe, Tt) | 0, b = b + Math.imul(Pe, at) | 0, m = m + Math.imul(ce, Ot) | 0, l = l + Math.imul(ce, He) | 0, l = l + Math.imul(pe, Ot) | 0, b = b + Math.imul(pe, He) | 0, m = m + Math.imul(X, yt) | 0, l = l + Math.imul(X, ut) | 0, l = l + Math.imul(G, yt) | 0, b = b + Math.imul(G, ut) | 0;
      var he = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, m = Math.imul(de, Ye), l = Math.imul(de, et), l = l + Math.imul(ye, Ye) | 0, b = Math.imul(ye, et), m = m + Math.imul(_, it) | 0, l = l + Math.imul(_, tt) | 0, l = l + Math.imul(q, it) | 0, b = b + Math.imul(q, tt) | 0, m = m + Math.imul(Re, dt) | 0, l = l + Math.imul(Re, st) | 0, l = l + Math.imul(fe, dt) | 0, b = b + Math.imul(fe, st) | 0, m = m + Math.imul(ue, xt) | 0, l = l + Math.imul(ue, lt) | 0, l = l + Math.imul(we, xt) | 0, b = b + Math.imul(we, lt) | 0, m = m + Math.imul(me, Tt) | 0, l = l + Math.imul(me, at) | 0, l = l + Math.imul(te, Tt) | 0, b = b + Math.imul(te, at) | 0, m = m + Math.imul(Ee, Ot) | 0, l = l + Math.imul(Ee, He) | 0, l = l + Math.imul(Pe, Ot) | 0, b = b + Math.imul(Pe, He) | 0, m = m + Math.imul(ce, yt) | 0, l = l + Math.imul(ce, ut) | 0, l = l + Math.imul(pe, yt) | 0, b = b + Math.imul(pe, ut) | 0, m = m + Math.imul(X, kt) | 0, l = l + Math.imul(X, ot) | 0, l = l + Math.imul(G, kt) | 0, b = b + Math.imul(G, ot) | 0;
      var J = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (J >>> 26) | 0, J &= 67108863, m = Math.imul(be, Ye), l = Math.imul(be, et), l = l + Math.imul(Me, Ye) | 0, b = Math.imul(Me, et), m = m + Math.imul(de, it) | 0, l = l + Math.imul(de, tt) | 0, l = l + Math.imul(ye, it) | 0, b = b + Math.imul(ye, tt) | 0, m = m + Math.imul(_, dt) | 0, l = l + Math.imul(_, st) | 0, l = l + Math.imul(q, dt) | 0, b = b + Math.imul(q, st) | 0, m = m + Math.imul(Re, xt) | 0, l = l + Math.imul(Re, lt) | 0, l = l + Math.imul(fe, xt) | 0, b = b + Math.imul(fe, lt) | 0, m = m + Math.imul(ue, Tt) | 0, l = l + Math.imul(ue, at) | 0, l = l + Math.imul(we, Tt) | 0, b = b + Math.imul(we, at) | 0, m = m + Math.imul(me, Ot) | 0, l = l + Math.imul(me, He) | 0, l = l + Math.imul(te, Ot) | 0, b = b + Math.imul(te, He) | 0, m = m + Math.imul(Ee, yt) | 0, l = l + Math.imul(Ee, ut) | 0, l = l + Math.imul(Pe, yt) | 0, b = b + Math.imul(Pe, ut) | 0, m = m + Math.imul(ce, kt) | 0, l = l + Math.imul(ce, ot) | 0, l = l + Math.imul(pe, kt) | 0, b = b + Math.imul(pe, ot) | 0, m = m + Math.imul(X, Nt) | 0, l = l + Math.imul(X, rt) | 0, l = l + Math.imul(G, Nt) | 0, b = b + Math.imul(G, rt) | 0;
      var Y = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, m = Math.imul(je, Ye), l = Math.imul(je, et), l = l + Math.imul(Ue, Ye) | 0, b = Math.imul(Ue, et), m = m + Math.imul(be, it) | 0, l = l + Math.imul(be, tt) | 0, l = l + Math.imul(Me, it) | 0, b = b + Math.imul(Me, tt) | 0, m = m + Math.imul(de, dt) | 0, l = l + Math.imul(de, st) | 0, l = l + Math.imul(ye, dt) | 0, b = b + Math.imul(ye, st) | 0, m = m + Math.imul(_, xt) | 0, l = l + Math.imul(_, lt) | 0, l = l + Math.imul(q, xt) | 0, b = b + Math.imul(q, lt) | 0, m = m + Math.imul(Re, Tt) | 0, l = l + Math.imul(Re, at) | 0, l = l + Math.imul(fe, Tt) | 0, b = b + Math.imul(fe, at) | 0, m = m + Math.imul(ue, Ot) | 0, l = l + Math.imul(ue, He) | 0, l = l + Math.imul(we, Ot) | 0, b = b + Math.imul(we, He) | 0, m = m + Math.imul(me, yt) | 0, l = l + Math.imul(me, ut) | 0, l = l + Math.imul(te, yt) | 0, b = b + Math.imul(te, ut) | 0, m = m + Math.imul(Ee, kt) | 0, l = l + Math.imul(Ee, ot) | 0, l = l + Math.imul(Pe, kt) | 0, b = b + Math.imul(Pe, ot) | 0, m = m + Math.imul(ce, Nt) | 0, l = l + Math.imul(ce, rt) | 0, l = l + Math.imul(pe, Nt) | 0, b = b + Math.imul(pe, rt) | 0, m = m + Math.imul(X, St) | 0, l = l + Math.imul(X, T) | 0, l = l + Math.imul(G, St) | 0, b = b + Math.imul(G, T) | 0;
      var ee = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (ee >>> 26) | 0, ee &= 67108863, m = Math.imul(je, it), l = Math.imul(je, tt), l = l + Math.imul(Ue, it) | 0, b = Math.imul(Ue, tt), m = m + Math.imul(be, dt) | 0, l = l + Math.imul(be, st) | 0, l = l + Math.imul(Me, dt) | 0, b = b + Math.imul(Me, st) | 0, m = m + Math.imul(de, xt) | 0, l = l + Math.imul(de, lt) | 0, l = l + Math.imul(ye, xt) | 0, b = b + Math.imul(ye, lt) | 0, m = m + Math.imul(_, Tt) | 0, l = l + Math.imul(_, at) | 0, l = l + Math.imul(q, Tt) | 0, b = b + Math.imul(q, at) | 0, m = m + Math.imul(Re, Ot) | 0, l = l + Math.imul(Re, He) | 0, l = l + Math.imul(fe, Ot) | 0, b = b + Math.imul(fe, He) | 0, m = m + Math.imul(ue, yt) | 0, l = l + Math.imul(ue, ut) | 0, l = l + Math.imul(we, yt) | 0, b = b + Math.imul(we, ut) | 0, m = m + Math.imul(me, kt) | 0, l = l + Math.imul(me, ot) | 0, l = l + Math.imul(te, kt) | 0, b = b + Math.imul(te, ot) | 0, m = m + Math.imul(Ee, Nt) | 0, l = l + Math.imul(Ee, rt) | 0, l = l + Math.imul(Pe, Nt) | 0, b = b + Math.imul(Pe, rt) | 0, m = m + Math.imul(ce, St) | 0, l = l + Math.imul(ce, T) | 0, l = l + Math.imul(pe, St) | 0, b = b + Math.imul(pe, T) | 0;
      var se = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (se >>> 26) | 0, se &= 67108863, m = Math.imul(je, dt), l = Math.imul(je, st), l = l + Math.imul(Ue, dt) | 0, b = Math.imul(Ue, st), m = m + Math.imul(be, xt) | 0, l = l + Math.imul(be, lt) | 0, l = l + Math.imul(Me, xt) | 0, b = b + Math.imul(Me, lt) | 0, m = m + Math.imul(de, Tt) | 0, l = l + Math.imul(de, at) | 0, l = l + Math.imul(ye, Tt) | 0, b = b + Math.imul(ye, at) | 0, m = m + Math.imul(_, Ot) | 0, l = l + Math.imul(_, He) | 0, l = l + Math.imul(q, Ot) | 0, b = b + Math.imul(q, He) | 0, m = m + Math.imul(Re, yt) | 0, l = l + Math.imul(Re, ut) | 0, l = l + Math.imul(fe, yt) | 0, b = b + Math.imul(fe, ut) | 0, m = m + Math.imul(ue, kt) | 0, l = l + Math.imul(ue, ot) | 0, l = l + Math.imul(we, kt) | 0, b = b + Math.imul(we, ot) | 0, m = m + Math.imul(me, Nt) | 0, l = l + Math.imul(me, rt) | 0, l = l + Math.imul(te, Nt) | 0, b = b + Math.imul(te, rt) | 0, m = m + Math.imul(Ee, St) | 0, l = l + Math.imul(Ee, T) | 0, l = l + Math.imul(Pe, St) | 0, b = b + Math.imul(Pe, T) | 0;
      var le = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (le >>> 26) | 0, le &= 67108863, m = Math.imul(je, xt), l = Math.imul(je, lt), l = l + Math.imul(Ue, xt) | 0, b = Math.imul(Ue, lt), m = m + Math.imul(be, Tt) | 0, l = l + Math.imul(be, at) | 0, l = l + Math.imul(Me, Tt) | 0, b = b + Math.imul(Me, at) | 0, m = m + Math.imul(de, Ot) | 0, l = l + Math.imul(de, He) | 0, l = l + Math.imul(ye, Ot) | 0, b = b + Math.imul(ye, He) | 0, m = m + Math.imul(_, yt) | 0, l = l + Math.imul(_, ut) | 0, l = l + Math.imul(q, yt) | 0, b = b + Math.imul(q, ut) | 0, m = m + Math.imul(Re, kt) | 0, l = l + Math.imul(Re, ot) | 0, l = l + Math.imul(fe, kt) | 0, b = b + Math.imul(fe, ot) | 0, m = m + Math.imul(ue, Nt) | 0, l = l + Math.imul(ue, rt) | 0, l = l + Math.imul(we, Nt) | 0, b = b + Math.imul(we, rt) | 0, m = m + Math.imul(me, St) | 0, l = l + Math.imul(me, T) | 0, l = l + Math.imul(te, St) | 0, b = b + Math.imul(te, T) | 0;
      var Ae = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, m = Math.imul(je, Tt), l = Math.imul(je, at), l = l + Math.imul(Ue, Tt) | 0, b = Math.imul(Ue, at), m = m + Math.imul(be, Ot) | 0, l = l + Math.imul(be, He) | 0, l = l + Math.imul(Me, Ot) | 0, b = b + Math.imul(Me, He) | 0, m = m + Math.imul(de, yt) | 0, l = l + Math.imul(de, ut) | 0, l = l + Math.imul(ye, yt) | 0, b = b + Math.imul(ye, ut) | 0, m = m + Math.imul(_, kt) | 0, l = l + Math.imul(_, ot) | 0, l = l + Math.imul(q, kt) | 0, b = b + Math.imul(q, ot) | 0, m = m + Math.imul(Re, Nt) | 0, l = l + Math.imul(Re, rt) | 0, l = l + Math.imul(fe, Nt) | 0, b = b + Math.imul(fe, rt) | 0, m = m + Math.imul(ue, St) | 0, l = l + Math.imul(ue, T) | 0, l = l + Math.imul(we, St) | 0, b = b + Math.imul(we, T) | 0;
      var Te = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, m = Math.imul(je, Ot), l = Math.imul(je, He), l = l + Math.imul(Ue, Ot) | 0, b = Math.imul(Ue, He), m = m + Math.imul(be, yt) | 0, l = l + Math.imul(be, ut) | 0, l = l + Math.imul(Me, yt) | 0, b = b + Math.imul(Me, ut) | 0, m = m + Math.imul(de, kt) | 0, l = l + Math.imul(de, ot) | 0, l = l + Math.imul(ye, kt) | 0, b = b + Math.imul(ye, ot) | 0, m = m + Math.imul(_, Nt) | 0, l = l + Math.imul(_, rt) | 0, l = l + Math.imul(q, Nt) | 0, b = b + Math.imul(q, rt) | 0, m = m + Math.imul(Re, St) | 0, l = l + Math.imul(Re, T) | 0, l = l + Math.imul(fe, St) | 0, b = b + Math.imul(fe, T) | 0;
      var Ie = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, m = Math.imul(je, yt), l = Math.imul(je, ut), l = l + Math.imul(Ue, yt) | 0, b = Math.imul(Ue, ut), m = m + Math.imul(be, kt) | 0, l = l + Math.imul(be, ot) | 0, l = l + Math.imul(Me, kt) | 0, b = b + Math.imul(Me, ot) | 0, m = m + Math.imul(de, Nt) | 0, l = l + Math.imul(de, rt) | 0, l = l + Math.imul(ye, Nt) | 0, b = b + Math.imul(ye, rt) | 0, m = m + Math.imul(_, St) | 0, l = l + Math.imul(_, T) | 0, l = l + Math.imul(q, St) | 0, b = b + Math.imul(q, T) | 0;
      var We = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, m = Math.imul(je, kt), l = Math.imul(je, ot), l = l + Math.imul(Ue, kt) | 0, b = Math.imul(Ue, ot), m = m + Math.imul(be, Nt) | 0, l = l + Math.imul(be, rt) | 0, l = l + Math.imul(Me, Nt) | 0, b = b + Math.imul(Me, rt) | 0, m = m + Math.imul(de, St) | 0, l = l + Math.imul(de, T) | 0, l = l + Math.imul(ye, St) | 0, b = b + Math.imul(ye, T) | 0;
      var Ke = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Ke >>> 26) | 0, Ke &= 67108863, m = Math.imul(je, Nt), l = Math.imul(je, rt), l = l + Math.imul(Ue, Nt) | 0, b = Math.imul(Ue, rt), m = m + Math.imul(be, St) | 0, l = l + Math.imul(be, T) | 0, l = l + Math.imul(Me, St) | 0, b = b + Math.imul(Me, T) | 0;
      var Le = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, m = Math.imul(je, St), l = Math.imul(je, T), l = l + Math.imul(Ue, St) | 0, b = Math.imul(Ue, T);
      var De = (w + m | 0) + ((l & 8191) << 13) | 0;
      return w = (b + (l >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, P[0] = F, P[1] = H, P[2] = z, P[3] = Q, P[4] = Z, P[5] = ie, P[6] = he, P[7] = J, P[8] = Y, P[9] = ee, P[10] = se, P[11] = le, P[12] = Ae, P[13] = Te, P[14] = Ie, P[15] = We, P[16] = Ke, P[17] = Le, P[18] = De, w !== 0 && (P[19] = w, h.length++), h;
    };
    Math.imul || (M = B);
    function I(o, u, h) {
      h.negative = u.negative ^ o.negative, h.length = o.length + u.length;
      for (var y = 0, E = 0, P = 0; P < h.length - 1; P++) {
        var w = E;
        E = 0;
        for (var m = y & 67108863, l = Math.min(P, u.length - 1), b = Math.max(0, P - o.length + 1); b <= l; b++) {
          var W = P - b, X = o.words[W] | 0, G = u.words[b] | 0, re = X * G, ce = re & 67108863;
          w = w + (re / 67108864 | 0) | 0, ce = ce + m | 0, m = ce & 67108863, w = w + (ce >>> 26) | 0, E += w >>> 26, w &= 67108863;
        }
        h.words[P] = m, y = w, w = E;
      }
      return y !== 0 ? h.words[P] = y : h.length--, h._strip();
    }
    function A(o, u, h) {
      return I(o, u, h);
    }
    i.prototype.mulTo = function(o, u) {
      var h, y = this.length + o.length;
      return this.length === 10 && o.length === 10 ? h = M(this, o, u) : y < 63 ? h = B(this, o, u) : y < 1024 ? h = I(this, o, u) : h = A(this, o, u), h;
    }, i.prototype.mul = function(o) {
      var u = new i(null);
      return u.words = new Array(this.length + o.length), this.mulTo(o, u);
    }, i.prototype.mulf = function(o) {
      var u = new i(null);
      return u.words = new Array(this.length + o.length), A(this, o, u);
    }, i.prototype.imul = function(o) {
      return this.clone().mulTo(o, this);
    }, i.prototype.imuln = function(o) {
      var u = o < 0;
      u && (o = -o), n(typeof o == "number"), n(o < 67108864);
      for (var h = 0, y = 0; y < this.length; y++) {
        var E = (this.words[y] | 0) * o, P = (E & 67108863) + (h & 67108863);
        h >>= 26, h += E / 67108864 | 0, h += P >>> 26, this.words[y] = P & 67108863;
      }
      return h !== 0 && (this.words[y] = h, this.length++), u ? this.ineg() : this;
    }, i.prototype.muln = function(o) {
      return this.clone().imuln(o);
    }, i.prototype.sqr = function() {
      return this.mul(this);
    }, i.prototype.isqr = function() {
      return this.imul(this.clone());
    }, i.prototype.pow = function(o) {
      var u = j(o);
      if (u.length === 0)
        return new i(1);
      for (var h = this, y = 0; y < u.length && u[y] === 0; y++, h = h.sqr())
        ;
      if (++y < u.length)
        for (var E = h.sqr(); y < u.length; y++, E = E.sqr())
          u[y] !== 0 && (h = h.mul(E));
      return h;
    }, i.prototype.iushln = function(o) {
      n(typeof o == "number" && o >= 0);
      var u = o % 26, h = (o - u) / 26, y = 67108863 >>> 26 - u << 26 - u, E;
      if (u !== 0) {
        var P = 0;
        for (E = 0; E < this.length; E++) {
          var w = this.words[E] & y, m = (this.words[E] | 0) - w << u;
          this.words[E] = m | P, P = w >>> 26 - u;
        }
        P && (this.words[E] = P, this.length++);
      }
      if (h !== 0) {
        for (E = this.length - 1; E >= 0; E--)
          this.words[E + h] = this.words[E];
        for (E = 0; E < h; E++)
          this.words[E] = 0;
        this.length += h;
      }
      return this._strip();
    }, i.prototype.ishln = function(o) {
      return n(this.negative === 0), this.iushln(o);
    }, i.prototype.iushrn = function(o, u, h) {
      n(typeof o == "number" && o >= 0);
      var y;
      u ? y = (u - u % 26) / 26 : y = 0;
      var E = o % 26, P = Math.min((o - E) / 26, this.length), w = 67108863 ^ 67108863 >>> E << E, m = h;
      if (y -= P, y = Math.max(0, y), m) {
        for (var l = 0; l < P; l++)
          m.words[l] = this.words[l];
        m.length = P;
      }
      if (P !== 0)
        if (this.length > P)
          for (this.length -= P, l = 0; l < this.length; l++)
            this.words[l] = this.words[l + P];
        else
          this.words[0] = 0, this.length = 1;
      var b = 0;
      for (l = this.length - 1; l >= 0 && (b !== 0 || l >= y); l--) {
        var W = this.words[l] | 0;
        this.words[l] = b << 26 - E | W >>> E, b = W & w;
      }
      return m && b !== 0 && (m.words[m.length++] = b), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, i.prototype.ishrn = function(o, u, h) {
      return n(this.negative === 0), this.iushrn(o, u, h);
    }, i.prototype.shln = function(o) {
      return this.clone().ishln(o);
    }, i.prototype.ushln = function(o) {
      return this.clone().iushln(o);
    }, i.prototype.shrn = function(o) {
      return this.clone().ishrn(o);
    }, i.prototype.ushrn = function(o) {
      return this.clone().iushrn(o);
    }, i.prototype.testn = function(o) {
      n(typeof o == "number" && o >= 0);
      var u = o % 26, h = (o - u) / 26, y = 1 << u;
      if (this.length <= h)
        return !1;
      var E = this.words[h];
      return !!(E & y);
    }, i.prototype.imaskn = function(o) {
      n(typeof o == "number" && o >= 0);
      var u = o % 26, h = (o - u) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= h)
        return this;
      if (u !== 0 && h++, this.length = Math.min(h, this.length), u !== 0) {
        var y = 67108863 ^ 67108863 >>> u << u;
        this.words[this.length - 1] &= y;
      }
      return this._strip();
    }, i.prototype.maskn = function(o) {
      return this.clone().imaskn(o);
    }, i.prototype.iaddn = function(o) {
      return n(typeof o == "number"), n(o < 67108864), o < 0 ? this.isubn(-o) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= o ? (this.words[0] = o - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(o), this.negative = 1, this) : this._iaddn(o);
    }, i.prototype._iaddn = function(o) {
      this.words[0] += o;
      for (var u = 0; u < this.length && this.words[u] >= 67108864; u++)
        this.words[u] -= 67108864, u === this.length - 1 ? this.words[u + 1] = 1 : this.words[u + 1]++;
      return this.length = Math.max(this.length, u + 1), this;
    }, i.prototype.isubn = function(o) {
      if (n(typeof o == "number"), n(o < 67108864), o < 0)
        return this.iaddn(-o);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(o), this.negative = 1, this;
      if (this.words[0] -= o, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var u = 0; u < this.length && this.words[u] < 0; u++)
          this.words[u] += 67108864, this.words[u + 1] -= 1;
      return this._strip();
    }, i.prototype.addn = function(o) {
      return this.clone().iaddn(o);
    }, i.prototype.subn = function(o) {
      return this.clone().isubn(o);
    }, i.prototype.iabs = function() {
      return this.negative = 0, this;
    }, i.prototype.abs = function() {
      return this.clone().iabs();
    }, i.prototype._ishlnsubmul = function(o, u, h) {
      var y = o.length + h, E;
      this._expand(y);
      var P, w = 0;
      for (E = 0; E < o.length; E++) {
        P = (this.words[E + h] | 0) + w;
        var m = (o.words[E] | 0) * u;
        P -= m & 67108863, w = (P >> 26) - (m / 67108864 | 0), this.words[E + h] = P & 67108863;
      }
      for (; E < this.length - h; E++)
        P = (this.words[E + h] | 0) + w, w = P >> 26, this.words[E + h] = P & 67108863;
      if (w === 0)
        return this._strip();
      for (n(w === -1), w = 0, E = 0; E < this.length; E++)
        P = -(this.words[E] | 0) + w, w = P >> 26, this.words[E] = P & 67108863;
      return this.negative = 1, this._strip();
    }, i.prototype._wordDiv = function(o, u) {
      var h = this.length - o.length, y = this.clone(), E = o, P = E.words[E.length - 1] | 0, w = this._countBits(P);
      h = 26 - w, h !== 0 && (E = E.ushln(h), y.iushln(h), P = E.words[E.length - 1] | 0);
      var m = y.length - E.length, l;
      if (u !== "mod") {
        l = new i(null), l.length = m + 1, l.words = new Array(l.length);
        for (var b = 0; b < l.length; b++)
          l.words[b] = 0;
      }
      var W = y.clone()._ishlnsubmul(E, 1, m);
      W.negative === 0 && (y = W, l && (l.words[m] = 1));
      for (var X = m - 1; X >= 0; X--) {
        var G = (y.words[E.length + X] | 0) * 67108864 + (y.words[E.length + X - 1] | 0);
        for (G = Math.min(G / P | 0, 67108863), y._ishlnsubmul(E, G, X); y.negative !== 0; )
          G--, y.negative = 0, y._ishlnsubmul(E, 1, X), y.isZero() || (y.negative ^= 1);
        l && (l.words[X] = G);
      }
      return l && l._strip(), y._strip(), u !== "div" && h !== 0 && y.iushrn(h), {
        div: l || null,
        mod: y
      };
    }, i.prototype.divmod = function(o, u, h) {
      if (n(!o.isZero()), this.isZero())
        return {
          div: new i(0),
          mod: new i(0)
        };
      var y, E, P;
      return this.negative !== 0 && o.negative === 0 ? (P = this.neg().divmod(o, u), u !== "mod" && (y = P.div.neg()), u !== "div" && (E = P.mod.neg(), h && E.negative !== 0 && E.iadd(o)), {
        div: y,
        mod: E
      }) : this.negative === 0 && o.negative !== 0 ? (P = this.divmod(o.neg(), u), u !== "mod" && (y = P.div.neg()), {
        div: y,
        mod: P.mod
      }) : this.negative & o.negative ? (P = this.neg().divmod(o.neg(), u), u !== "div" && (E = P.mod.neg(), h && E.negative !== 0 && E.isub(o)), {
        div: P.div,
        mod: E
      }) : o.length > this.length || this.cmp(o) < 0 ? {
        div: new i(0),
        mod: this
      } : o.length === 1 ? u === "div" ? {
        div: this.divn(o.words[0]),
        mod: null
      } : u === "mod" ? {
        div: null,
        mod: new i(this.modrn(o.words[0]))
      } : {
        div: this.divn(o.words[0]),
        mod: new i(this.modrn(o.words[0]))
      } : this._wordDiv(o, u);
    }, i.prototype.div = function(o) {
      return this.divmod(o, "div", !1).div;
    }, i.prototype.mod = function(o) {
      return this.divmod(o, "mod", !1).mod;
    }, i.prototype.umod = function(o) {
      return this.divmod(o, "mod", !0).mod;
    }, i.prototype.divRound = function(o) {
      var u = this.divmod(o);
      if (u.mod.isZero())
        return u.div;
      var h = u.div.negative !== 0 ? u.mod.isub(o) : u.mod, y = o.ushrn(1), E = o.andln(1), P = h.cmp(y);
      return P < 0 || E === 1 && P === 0 ? u.div : u.div.negative !== 0 ? u.div.isubn(1) : u.div.iaddn(1);
    }, i.prototype.modrn = function(o) {
      var u = o < 0;
      u && (o = -o), n(o <= 67108863);
      for (var h = (1 << 26) % o, y = 0, E = this.length - 1; E >= 0; E--)
        y = (h * y + (this.words[E] | 0)) % o;
      return u ? -y : y;
    }, i.prototype.modn = function(o) {
      return this.modrn(o);
    }, i.prototype.idivn = function(o) {
      var u = o < 0;
      u && (o = -o), n(o <= 67108863);
      for (var h = 0, y = this.length - 1; y >= 0; y--) {
        var E = (this.words[y] | 0) + h * 67108864;
        this.words[y] = E / o | 0, h = E % o;
      }
      return this._strip(), u ? this.ineg() : this;
    }, i.prototype.divn = function(o) {
      return this.clone().idivn(o);
    }, i.prototype.egcd = function(o) {
      n(o.negative === 0), n(!o.isZero());
      var u = this, h = o.clone();
      u.negative !== 0 ? u = u.umod(o) : u = u.clone();
      for (var y = new i(1), E = new i(0), P = new i(0), w = new i(1), m = 0; u.isEven() && h.isEven(); )
        u.iushrn(1), h.iushrn(1), ++m;
      for (var l = h.clone(), b = u.clone(); !u.isZero(); ) {
        for (var W = 0, X = 1; !(u.words[0] & X) && W < 26; ++W, X <<= 1)
          ;
        if (W > 0)
          for (u.iushrn(W); W-- > 0; )
            (y.isOdd() || E.isOdd()) && (y.iadd(l), E.isub(b)), y.iushrn(1), E.iushrn(1);
        for (var G = 0, re = 1; !(h.words[0] & re) && G < 26; ++G, re <<= 1)
          ;
        if (G > 0)
          for (h.iushrn(G); G-- > 0; )
            (P.isOdd() || w.isOdd()) && (P.iadd(l), w.isub(b)), P.iushrn(1), w.iushrn(1);
        u.cmp(h) >= 0 ? (u.isub(h), y.isub(P), E.isub(w)) : (h.isub(u), P.isub(y), w.isub(E));
      }
      return {
        a: P,
        b: w,
        gcd: h.iushln(m)
      };
    }, i.prototype._invmp = function(o) {
      n(o.negative === 0), n(!o.isZero());
      var u = this, h = o.clone();
      u.negative !== 0 ? u = u.umod(o) : u = u.clone();
      for (var y = new i(1), E = new i(0), P = h.clone(); u.cmpn(1) > 0 && h.cmpn(1) > 0; ) {
        for (var w = 0, m = 1; !(u.words[0] & m) && w < 26; ++w, m <<= 1)
          ;
        if (w > 0)
          for (u.iushrn(w); w-- > 0; )
            y.isOdd() && y.iadd(P), y.iushrn(1);
        for (var l = 0, b = 1; !(h.words[0] & b) && l < 26; ++l, b <<= 1)
          ;
        if (l > 0)
          for (h.iushrn(l); l-- > 0; )
            E.isOdd() && E.iadd(P), E.iushrn(1);
        u.cmp(h) >= 0 ? (u.isub(h), y.isub(E)) : (h.isub(u), E.isub(y));
      }
      var W;
      return u.cmpn(1) === 0 ? W = y : W = E, W.cmpn(0) < 0 && W.iadd(o), W;
    }, i.prototype.gcd = function(o) {
      if (this.isZero())
        return o.abs();
      if (o.isZero())
        return this.abs();
      var u = this.clone(), h = o.clone();
      u.negative = 0, h.negative = 0;
      for (var y = 0; u.isEven() && h.isEven(); y++)
        u.iushrn(1), h.iushrn(1);
      do {
        for (; u.isEven(); )
          u.iushrn(1);
        for (; h.isEven(); )
          h.iushrn(1);
        var E = u.cmp(h);
        if (E < 0) {
          var P = u;
          u = h, h = P;
        } else if (E === 0 || h.cmpn(1) === 0)
          break;
        u.isub(h);
      } while (!0);
      return h.iushln(y);
    }, i.prototype.invm = function(o) {
      return this.egcd(o).a.umod(o);
    }, i.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, i.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, i.prototype.andln = function(o) {
      return this.words[0] & o;
    }, i.prototype.bincn = function(o) {
      n(typeof o == "number");
      var u = o % 26, h = (o - u) / 26, y = 1 << u;
      if (this.length <= h)
        return this._expand(h + 1), this.words[h] |= y, this;
      for (var E = y, P = h; E !== 0 && P < this.length; P++) {
        var w = this.words[P] | 0;
        w += E, E = w >>> 26, w &= 67108863, this.words[P] = w;
      }
      return E !== 0 && (this.words[P] = E, this.length++), this;
    }, i.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, i.prototype.cmpn = function(o) {
      var u = o < 0;
      if (this.negative !== 0 && !u)
        return -1;
      if (this.negative === 0 && u)
        return 1;
      this._strip();
      var h;
      if (this.length > 1)
        h = 1;
      else {
        u && (o = -o), n(o <= 67108863, "Number is too big");
        var y = this.words[0] | 0;
        h = y === o ? 0 : y < o ? -1 : 1;
      }
      return this.negative !== 0 ? -h | 0 : h;
    }, i.prototype.cmp = function(o) {
      if (this.negative !== 0 && o.negative === 0)
        return -1;
      if (this.negative === 0 && o.negative !== 0)
        return 1;
      var u = this.ucmp(o);
      return this.negative !== 0 ? -u | 0 : u;
    }, i.prototype.ucmp = function(o) {
      if (this.length > o.length)
        return 1;
      if (this.length < o.length)
        return -1;
      for (var u = 0, h = this.length - 1; h >= 0; h--) {
        var y = this.words[h] | 0, E = o.words[h] | 0;
        if (y !== E) {
          y < E ? u = -1 : y > E && (u = 1);
          break;
        }
      }
      return u;
    }, i.prototype.gtn = function(o) {
      return this.cmpn(o) === 1;
    }, i.prototype.gt = function(o) {
      return this.cmp(o) === 1;
    }, i.prototype.gten = function(o) {
      return this.cmpn(o) >= 0;
    }, i.prototype.gte = function(o) {
      return this.cmp(o) >= 0;
    }, i.prototype.ltn = function(o) {
      return this.cmpn(o) === -1;
    }, i.prototype.lt = function(o) {
      return this.cmp(o) === -1;
    }, i.prototype.lten = function(o) {
      return this.cmpn(o) <= 0;
    }, i.prototype.lte = function(o) {
      return this.cmp(o) <= 0;
    }, i.prototype.eqn = function(o) {
      return this.cmpn(o) === 0;
    }, i.prototype.eq = function(o) {
      return this.cmp(o) === 0;
    }, i.red = function(o) {
      return new C(o);
    }, i.prototype.toRed = function(o) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), o.convertTo(this)._forceRed(o);
    }, i.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, i.prototype._forceRed = function(o) {
      return this.red = o, this;
    }, i.prototype.forceRed = function(o) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(o);
    }, i.prototype.redAdd = function(o) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, o);
    }, i.prototype.redIAdd = function(o) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, o);
    }, i.prototype.redSub = function(o) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, o);
    }, i.prototype.redISub = function(o) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, o);
    }, i.prototype.redShl = function(o) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, o);
    }, i.prototype.redMul = function(o) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, o), this.red.mul(this, o);
    }, i.prototype.redIMul = function(o) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, o), this.red.imul(this, o);
    }, i.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, i.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, i.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, i.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, i.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, i.prototype.redPow = function(o) {
      return n(this.red && !o.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, o);
    };
    var R = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function L(o, u) {
      this.name = o, this.p = new i(u, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    L.prototype._tmp = function() {
      var o = new i(null);
      return o.words = new Array(Math.ceil(this.n / 13)), o;
    }, L.prototype.ireduce = function(o) {
      var u = o, h;
      do
        this.split(u, this.tmp), u = this.imulK(u), u = u.iadd(this.tmp), h = u.bitLength();
      while (h > this.n);
      var y = h < this.n ? -1 : u.ucmp(this.p);
      return y === 0 ? (u.words[0] = 0, u.length = 1) : y > 0 ? u.isub(this.p) : u.strip !== void 0 ? u.strip() : u._strip(), u;
    }, L.prototype.split = function(o, u) {
      o.iushrn(this.n, 0, u);
    }, L.prototype.imulK = function(o) {
      return o.imul(this.k);
    };
    function K() {
      L.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(K, L), K.prototype.split = function(o, u) {
      for (var h = 4194303, y = Math.min(o.length, 9), E = 0; E < y; E++)
        u.words[E] = o.words[E];
      if (u.length = y, o.length <= 9) {
        o.words[0] = 0, o.length = 1;
        return;
      }
      var P = o.words[9];
      for (u.words[u.length++] = P & h, E = 10; E < o.length; E++) {
        var w = o.words[E] | 0;
        o.words[E - 10] = (w & h) << 4 | P >>> 22, P = w;
      }
      P >>>= 22, o.words[E - 10] = P, P === 0 && o.length > 10 ? o.length -= 10 : o.length -= 9;
    }, K.prototype.imulK = function(o) {
      o.words[o.length] = 0, o.words[o.length + 1] = 0, o.length += 2;
      for (var u = 0, h = 0; h < o.length; h++) {
        var y = o.words[h] | 0;
        u += y * 977, o.words[h] = u & 67108863, u = y * 64 + (u / 67108864 | 0);
      }
      return o.words[o.length - 1] === 0 && (o.length--, o.words[o.length - 1] === 0 && o.length--), o;
    };
    function $() {
      L.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s($, L);
    function k() {
      L.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(k, L);
    function V() {
      L.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(V, L), V.prototype.imulK = function(o) {
      for (var u = 0, h = 0; h < o.length; h++) {
        var y = (o.words[h] | 0) * 19 + u, E = y & 67108863;
        y >>>= 26, o.words[h] = E, u = y;
      }
      return u !== 0 && (o.words[o.length++] = u), o;
    }, i._prime = function(o) {
      if (R[o])
        return R[o];
      var u;
      if (o === "k256")
        u = new K();
      else if (o === "p224")
        u = new $();
      else if (o === "p192")
        u = new k();
      else if (o === "p25519")
        u = new V();
      else
        throw new Error("Unknown prime " + o);
      return R[o] = u, u;
    };
    function C(o) {
      if (typeof o == "string") {
        var u = i._prime(o);
        this.m = u.p, this.prime = u;
      } else
        n(o.gtn(1), "modulus must be greater than 1"), this.m = o, this.prime = null;
    }
    C.prototype._verify1 = function(o) {
      n(o.negative === 0, "red works only with positives"), n(o.red, "red works only with red numbers");
    }, C.prototype._verify2 = function(o, u) {
      n((o.negative | u.negative) === 0, "red works only with positives"), n(
        o.red && o.red === u.red,
        "red works only with red numbers"
      );
    }, C.prototype.imod = function(o) {
      return this.prime ? this.prime.ireduce(o)._forceRed(this) : (p(o, o.umod(this.m)._forceRed(this)), o);
    }, C.prototype.neg = function(o) {
      return o.isZero() ? o.clone() : this.m.sub(o)._forceRed(this);
    }, C.prototype.add = function(o, u) {
      this._verify2(o, u);
      var h = o.add(u);
      return h.cmp(this.m) >= 0 && h.isub(this.m), h._forceRed(this);
    }, C.prototype.iadd = function(o, u) {
      this._verify2(o, u);
      var h = o.iadd(u);
      return h.cmp(this.m) >= 0 && h.isub(this.m), h;
    }, C.prototype.sub = function(o, u) {
      this._verify2(o, u);
      var h = o.sub(u);
      return h.cmpn(0) < 0 && h.iadd(this.m), h._forceRed(this);
    }, C.prototype.isub = function(o, u) {
      this._verify2(o, u);
      var h = o.isub(u);
      return h.cmpn(0) < 0 && h.iadd(this.m), h;
    }, C.prototype.shl = function(o, u) {
      return this._verify1(o), this.imod(o.ushln(u));
    }, C.prototype.imul = function(o, u) {
      return this._verify2(o, u), this.imod(o.imul(u));
    }, C.prototype.mul = function(o, u) {
      return this._verify2(o, u), this.imod(o.mul(u));
    }, C.prototype.isqr = function(o) {
      return this.imul(o, o.clone());
    }, C.prototype.sqr = function(o) {
      return this.mul(o, o);
    }, C.prototype.sqrt = function(o) {
      if (o.isZero())
        return o.clone();
      var u = this.m.andln(3);
      if (n(u % 2 === 1), u === 3) {
        var h = this.m.add(new i(1)).iushrn(2);
        return this.pow(o, h);
      }
      for (var y = this.m.subn(1), E = 0; !y.isZero() && y.andln(1) === 0; )
        E++, y.iushrn(1);
      n(!y.isZero());
      var P = new i(1).toRed(this), w = P.redNeg(), m = this.m.subn(1).iushrn(1), l = this.m.bitLength();
      for (l = new i(2 * l * l).toRed(this); this.pow(l, m).cmp(w) !== 0; )
        l.redIAdd(w);
      for (var b = this.pow(l, y), W = this.pow(o, y.addn(1).iushrn(1)), X = this.pow(o, y), G = E; X.cmp(P) !== 0; ) {
        for (var re = X, ce = 0; re.cmp(P) !== 0; ce++)
          re = re.redSqr();
        n(ce < G);
        var pe = this.pow(b, new i(1).iushln(G - ce - 1));
        W = W.redMul(pe), b = pe.redSqr(), X = X.redMul(b), G = ce;
      }
      return W;
    }, C.prototype.invm = function(o) {
      var u = o._invmp(this.m);
      return u.negative !== 0 ? (u.negative = 0, this.imod(u).redNeg()) : this.imod(u);
    }, C.prototype.pow = function(o, u) {
      if (u.isZero())
        return new i(1).toRed(this);
      if (u.cmpn(1) === 0)
        return o.clone();
      var h = 4, y = new Array(1 << h);
      y[0] = new i(1).toRed(this), y[1] = o;
      for (var E = 2; E < y.length; E++)
        y[E] = this.mul(y[E - 1], o);
      var P = y[0], w = 0, m = 0, l = u.bitLength() % 26;
      for (l === 0 && (l = 26), E = u.length - 1; E >= 0; E--) {
        for (var b = u.words[E], W = l - 1; W >= 0; W--) {
          var X = b >> W & 1;
          if (P !== y[0] && (P = this.sqr(P)), X === 0 && w === 0) {
            m = 0;
            continue;
          }
          w <<= 1, w |= X, m++, !(m !== h && (E !== 0 || W !== 0)) && (P = this.mul(P, y[w]), m = 0, w = 0);
        }
        l = 26;
      }
      return P;
    }, C.prototype.convertTo = function(o) {
      var u = o.umod(this.m);
      return u === o ? u.clone() : u;
    }, C.prototype.convertFrom = function(o) {
      var u = o.clone();
      return u.red = null, u;
    }, i.mont = function(o) {
      return new D(o);
    };
    function D(o) {
      C.call(this, o), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(D, C), D.prototype.convertTo = function(o) {
      return this.imod(o.ushln(this.shift));
    }, D.prototype.convertFrom = function(o) {
      var u = this.imod(o.mul(this.rinv));
      return u.red = null, u;
    }, D.prototype.imul = function(o, u) {
      if (o.isZero() || u.isZero())
        return o.words[0] = 0, o.length = 1, o;
      var h = o.imul(u), y = h.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), E = h.isub(y).iushrn(this.shift), P = E;
      return E.cmp(this.m) >= 0 ? P = E.isub(this.m) : E.cmpn(0) < 0 && (P = E.iadd(this.m)), P._forceRed(this);
    }, D.prototype.mul = function(o, u) {
      if (o.isZero() || u.isZero())
        return new i(0)._forceRed(this);
      var h = o.mul(u), y = h.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), E = h.isub(y).iushrn(this.shift), P = E;
      return E.cmp(this.m) >= 0 ? P = E.isub(this.m) : E.cmpn(0) < 0 && (P = E.iadd(this.m)), P._forceRed(this);
    }, D.prototype.invm = function(o) {
      var u = this.imod(o._invmp(this.m).mul(this.r2));
      return u._forceRed(this);
    };
  })(e, Ze);
})(mv);
var sP = mv.exports;
const oP = /* @__PURE__ */ gv(sP), aP = "logger/5.7.0";
let Yg = !1, Xg = !1;
const Jd = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let em = Jd.default, kf = null;
function uP() {
  try {
    const e = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((t) => {
      try {
        if ("test".normalize(t) !== "test")
          throw new Error("bad normalize");
      } catch {
        e.push(t);
      }
    }), e.length)
      throw new Error("missing " + e.join(", "));
    if ("é".normalize("NFD") !== "é")
      throw new Error("broken implementation");
  } catch (e) {
    return e.message;
  }
  return null;
}
const tm = uP();
var gp;
(function(e) {
  e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})(gp || (gp = {}));
var Ui;
(function(e) {
  e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})(Ui || (Ui = {}));
const rm = "0123456789abcdef";
class Ft {
  constructor(t) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }
  _log(t, r) {
    const n = t.toLowerCase();
    Jd[n] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !(em > Jd[n]) && console.log.apply(console, r);
  }
  debug(...t) {
    this._log(Ft.levels.DEBUG, t);
  }
  info(...t) {
    this._log(Ft.levels.INFO, t);
  }
  warn(...t) {
    this._log(Ft.levels.WARNING, t);
  }
  makeError(t, r, n) {
    if (Xg)
      return this.makeError("censored error", r, {});
    r || (r = Ft.errors.UNKNOWN_ERROR), n || (n = {});
    const s = [];
    Object.keys(n).forEach((d) => {
      const c = n[d];
      try {
        if (c instanceof Uint8Array) {
          let p = "";
          for (let g = 0; g < c.length; g++)
            p += rm[c[g] >> 4], p += rm[c[g] & 15];
          s.push(d + "=Uint8Array(0x" + p + ")");
        } else
          s.push(d + "=" + JSON.stringify(c));
      } catch {
        s.push(d + "=" + JSON.stringify(n[d].toString()));
      }
    }), s.push(`code=${r}`), s.push(`version=${this.version}`);
    const i = t;
    let a = "";
    switch (r) {
      case Ui.NUMERIC_FAULT: {
        a = "NUMERIC_FAULT";
        const d = t;
        switch (d) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            a += "-" + d;
            break;
          case "negative-power":
          case "negative-width":
            a += "-unsupported";
            break;
          case "unbound-bitwise-result":
            a += "-unbound-result";
            break;
        }
        break;
      }
      case Ui.CALL_EXCEPTION:
      case Ui.INSUFFICIENT_FUNDS:
      case Ui.MISSING_NEW:
      case Ui.NONCE_EXPIRED:
      case Ui.REPLACEMENT_UNDERPRICED:
      case Ui.TRANSACTION_REPLACED:
      case Ui.UNPREDICTABLE_GAS_LIMIT:
        a = r;
        break;
    }
    a && (t += " [ See: https://links.ethers.org/v5-errors-" + a + " ]"), s.length && (t += " (" + s.join(", ") + ")");
    const f = new Error(t);
    return f.reason = i, f.code = r, Object.keys(n).forEach(function(d) {
      f[d] = n[d];
    }), f;
  }
  throwError(t, r, n) {
    throw this.makeError(t, r, n);
  }
  throwArgumentError(t, r, n) {
    return this.throwError(t, Ft.errors.INVALID_ARGUMENT, {
      argument: r,
      value: n
    });
  }
  assert(t, r, n, s) {
    t || this.throwError(r, n, s);
  }
  assertArgument(t, r, n, s) {
    t || this.throwArgumentError(r, n, s);
  }
  checkNormalize(t) {
    tm && this.throwError("platform missing String.prototype.normalize", Ft.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: tm
    });
  }
  checkSafeUint53(t, r) {
    typeof t == "number" && (r == null && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, Ft.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: t
    }), t % 1 && this.throwError(r, Ft.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: t
    }));
  }
  checkArgumentCount(t, r, n) {
    n ? n = ": " + n : n = "", t < r && this.throwError("missing argument" + n, Ft.errors.MISSING_ARGUMENT, {
      count: t,
      expectedCount: r
    }), t > r && this.throwError("too many arguments" + n, Ft.errors.UNEXPECTED_ARGUMENT, {
      count: t,
      expectedCount: r
    });
  }
  checkNew(t, r) {
    (t === Object || t == null) && this.throwError("missing new", Ft.errors.MISSING_NEW, { name: r.name });
  }
  checkAbstract(t, r) {
    t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", Ft.errors.UNSUPPORTED_OPERATION, { name: t.name, operation: "new" }) : (t === Object || t == null) && this.throwError("missing new", Ft.errors.MISSING_NEW, { name: r.name });
  }
  static globalLogger() {
    return kf || (kf = new Ft(aP)), kf;
  }
  static setCensorship(t, r) {
    if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", Ft.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), Yg) {
      if (!t)
        return;
      this.globalLogger().throwError("error censorship permanent", Ft.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    Xg = !!t, Yg = !!r;
  }
  static setLogLevel(t) {
    const r = Jd[t.toLowerCase()];
    if (r == null) {
      Ft.globalLogger().warn("invalid log level - " + t);
      return;
    }
    em = r;
  }
  static from(t) {
    return new Ft(t);
  }
}
Ft.errors = Ui;
Ft.levels = gp;
const cP = "bytes/5.7.0", Oo = new Ft(cP);
function yv(e) {
  return !!e.toHexString;
}
function R0(e) {
  return e.slice || (e.slice = function() {
    const t = Array.prototype.slice.call(arguments);
    return R0(new Uint8Array(Array.prototype.slice.apply(e, t)));
  }), e;
}
function nm(e) {
  return typeof e == "number" && e == e && e % 1 === 0;
}
function ud(e) {
  if (e == null)
    return !1;
  if (e.constructor === Uint8Array)
    return !0;
  if (typeof e == "string" || !nm(e.length) || e.length < 0)
    return !1;
  for (let t = 0; t < e.length; t++) {
    const r = e[t];
    if (!nm(r) || r < 0 || r >= 256)
      return !1;
  }
  return !0;
}
function bi(e, t) {
  if (t || (t = {}), typeof e == "number") {
    Oo.checkSafeUint53(e, "invalid arrayify value");
    const r = [];
    for (; e; )
      r.unshift(e & 255), e = parseInt(String(e / 256));
    return r.length === 0 && r.push(0), R0(new Uint8Array(r));
  }
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), yv(e) && (e = e.toHexString()), Ya(e)) {
    let r = e.substring(2);
    r.length % 2 && (t.hexPad === "left" ? r = "0" + r : t.hexPad === "right" ? r += "0" : Oo.throwArgumentError("hex data is odd-length", "value", e));
    const n = [];
    for (let s = 0; s < r.length; s += 2)
      n.push(parseInt(r.substring(s, s + 2), 16));
    return R0(new Uint8Array(n));
  }
  return ud(e) ? R0(new Uint8Array(e)) : Oo.throwArgumentError("invalid arrayify value", "value", e);
}
function Sf(e) {
  const t = e.map((s) => bi(s)), r = t.reduce((s, i) => s + i.length, 0), n = new Uint8Array(r);
  return t.reduce((s, i) => (n.set(i, s), s + i.length), 0), R0(n);
}
function Ya(e, t) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
}
const Mf = "0123456789abcdef";
function sc(e, t) {
  if (t || (t = {}), typeof e == "number") {
    Oo.checkSafeUint53(e, "invalid hexlify value");
    let r = "";
    for (; e; )
      r = Mf[e & 15] + r, e = Math.floor(e / 16);
    return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
  }
  if (typeof e == "bigint")
    return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), yv(e))
    return e.toHexString();
  if (Ya(e))
    return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : Oo.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
  if (ud(e)) {
    let r = "0x";
    for (let n = 0; n < e.length; n++) {
      let s = e[n];
      r += Mf[(s & 240) >> 4] + Mf[s & 15];
    }
    return r;
  }
  return Oo.throwArgumentError("invalid hexlify value", "value", e);
}
function lP(e) {
  let t = "0x";
  return e.forEach((r) => {
    t += sc(r).substring(2);
  }), t;
}
function mp(e, t) {
  for (typeof e != "string" ? e = sc(e) : Ya(e) || Oo.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && Oo.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2; )
    e = "0x0" + e.substring(2);
  return e;
}
const bv = "bignumber/5.7.0";
var hh = oP.BN;
const Ds = new Ft(bv), If = {}, im = 9007199254740991;
function dP(e) {
  return e != null && (vr.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || Ya(e) || typeof e == "bigint" || ud(e));
}
let sm = !1;
class vr {
  constructor(t, r) {
    t !== If && Ds.throwError("cannot call constructor directly; use BigNumber.from", Ft.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(t) {
    return Sn(or(this).fromTwos(t));
  }
  toTwos(t) {
    return Sn(or(this).toTwos(t));
  }
  abs() {
    return this._hex[0] === "-" ? vr.from(this._hex.substring(1)) : this;
  }
  add(t) {
    return Sn(or(this).add(or(t)));
  }
  sub(t) {
    return Sn(or(this).sub(or(t)));
  }
  div(t) {
    return vr.from(t).isZero() && ni("division-by-zero", "div"), Sn(or(this).div(or(t)));
  }
  mul(t) {
    return Sn(or(this).mul(or(t)));
  }
  mod(t) {
    const r = or(t);
    return r.isNeg() && ni("division-by-zero", "mod"), Sn(or(this).umod(r));
  }
  pow(t) {
    const r = or(t);
    return r.isNeg() && ni("negative-power", "pow"), Sn(or(this).pow(r));
  }
  and(t) {
    const r = or(t);
    return (this.isNegative() || r.isNeg()) && ni("unbound-bitwise-result", "and"), Sn(or(this).and(r));
  }
  or(t) {
    const r = or(t);
    return (this.isNegative() || r.isNeg()) && ni("unbound-bitwise-result", "or"), Sn(or(this).or(r));
  }
  xor(t) {
    const r = or(t);
    return (this.isNegative() || r.isNeg()) && ni("unbound-bitwise-result", "xor"), Sn(or(this).xor(r));
  }
  mask(t) {
    return (this.isNegative() || t < 0) && ni("negative-width", "mask"), Sn(or(this).maskn(t));
  }
  shl(t) {
    return (this.isNegative() || t < 0) && ni("negative-width", "shl"), Sn(or(this).shln(t));
  }
  shr(t) {
    return (this.isNegative() || t < 0) && ni("negative-width", "shr"), Sn(or(this).shrn(t));
  }
  eq(t) {
    return or(this).eq(or(t));
  }
  lt(t) {
    return or(this).lt(or(t));
  }
  lte(t) {
    return or(this).lte(or(t));
  }
  gt(t) {
    return or(this).gt(or(t));
  }
  gte(t) {
    return or(this).gte(or(t));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return or(this).isZero();
  }
  toNumber() {
    try {
      return or(this).toNumber();
    } catch {
      ni("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return Ds.throwError("this platform does not support BigInt", Ft.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? sm || (sm = !0, Ds.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? Ds.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Ft.errors.UNEXPECTED_ARGUMENT, {}) : Ds.throwError("BigNumber.toString does not accept parameters", Ft.errors.UNEXPECTED_ARGUMENT, {})), or(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(t) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(t) {
    if (t instanceof vr)
      return t;
    if (typeof t == "string")
      return t.match(/^-?0x[0-9a-f]+$/i) ? new vr(If, $0(t)) : t.match(/^-?[0-9]+$/) ? new vr(If, $0(new hh(t))) : Ds.throwArgumentError("invalid BigNumber string", "value", t);
    if (typeof t == "number")
      return t % 1 && ni("underflow", "BigNumber.from", t), (t >= im || t <= -im) && ni("overflow", "BigNumber.from", t), vr.from(String(t));
    const r = t;
    if (typeof r == "bigint")
      return vr.from(r.toString());
    if (ud(r))
      return vr.from(sc(r));
    if (r)
      if (r.toHexString) {
        const n = r.toHexString();
        if (typeof n == "string")
          return vr.from(n);
      } else {
        let n = r._hex;
        if (n == null && r.type === "BigNumber" && (n = r.hex), typeof n == "string" && (Ya(n) || n[0] === "-" && Ya(n.substring(1))))
          return vr.from(n);
      }
    return Ds.throwArgumentError("invalid BigNumber value", "value", t);
  }
  static isBigNumber(t) {
    return !!(t && t._isBigNumber);
  }
}
function $0(e) {
  if (typeof e != "string")
    return $0(e.toString(16));
  if (e[0] === "-")
    return e = e.substring(1), e[0] === "-" && Ds.throwArgumentError("invalid hex", "value", e), e = $0(e), e === "0x00" ? e : "-" + e;
  if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x")
    return "0x00";
  for (e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00"; )
    e = "0x" + e.substring(4);
  return e;
}
function Sn(e) {
  return vr.from($0(e));
}
function or(e) {
  const t = vr.from(e).toHexString();
  return t[0] === "-" ? new hh("-" + t.substring(3), 16) : new hh(t.substring(2), 16);
}
function ni(e, t, r) {
  const n = { fault: e, operation: t };
  return r != null && (n.value = r), Ds.throwError(e, Ft.errors.NUMERIC_FAULT, n);
}
function hP(e) {
  return new hh(e, 36).toString(16);
}
const Pn = new Ft(bv), C0 = {}, wv = vr.from(0), vv = vr.from(-1);
function Av(e, t, r, n) {
  const s = { fault: t, operation: r };
  return n !== void 0 && (s.value = n), Pn.throwError(e, Ft.errors.NUMERIC_FAULT, s);
}
let B0 = "0";
for (; B0.length < 256; )
  B0 += B0;
function a1(e) {
  if (typeof e != "number")
    try {
      e = vr.from(e).toNumber();
    } catch {
    }
  return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + B0.substring(0, e) : Pn.throwArgumentError("invalid decimal size", "decimals", e);
}
function Qd(e, t) {
  t == null && (t = 0);
  const r = a1(t);
  e = vr.from(e);
  const n = e.lt(wv);
  n && (e = e.mul(vv));
  let s = e.mod(r).toString();
  for (; s.length < r.length - 1; )
    s = "0" + s;
  s = s.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const i = e.div(r).toString();
  return r.length === 1 ? e = i : e = i + "." + s, n && (e = "-" + e), e;
}
function ts(e, t) {
  t == null && (t = 0);
  const r = a1(t);
  (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && Pn.throwArgumentError("invalid decimal value", "value", e);
  const n = e.substring(0, 1) === "-";
  n && (e = e.substring(1)), e === "." && Pn.throwArgumentError("missing value", "value", e);
  const s = e.split(".");
  s.length > 2 && Pn.throwArgumentError("too many decimal points", "value", e);
  let i = s[0], a = s[1];
  for (i || (i = "0"), a || (a = "0"); a[a.length - 1] === "0"; )
    a = a.substring(0, a.length - 1);
  for (a.length > r.length - 1 && Av("fractional component exceeds decimals", "underflow", "parseFixed"), a === "" && (a = "0"); a.length < r.length - 1; )
    a += "0";
  const f = vr.from(i), d = vr.from(a);
  let c = f.mul(r).add(d);
  return n && (c = c.mul(vv)), c;
}
class Su {
  constructor(t, r, n, s) {
    t !== C0 && Pn.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Ft.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = r, this.width = n, this.decimals = s, this.name = (r ? "" : "u") + "fixed" + String(n) + "x" + String(s), this._multiplier = a1(s), Object.freeze(this);
  }
  static from(t) {
    if (t instanceof Su)
      return t;
    typeof t == "number" && (t = `fixed128x${t}`);
    let r = !0, n = 128, s = 18;
    if (typeof t == "string") {
      if (t !== "fixed")
        if (t === "ufixed")
          r = !1;
        else {
          const i = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          i || Pn.throwArgumentError("invalid fixed format", "format", t), r = i[1] !== "u", n = parseInt(i[2]), s = parseInt(i[3]);
        }
    } else if (t) {
      const i = (a, f, d) => t[a] == null ? d : (typeof t[a] !== f && Pn.throwArgumentError("invalid fixed format (" + a + " not " + f + ")", "format." + a, t[a]), t[a]);
      r = i("signed", "boolean", r), n = i("width", "number", n), s = i("decimals", "number", s);
    }
    return n % 8 && Pn.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", n), s > 80 && Pn.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", s), new Su(C0, r, n, s);
  }
}
class nn {
  constructor(t, r, n, s) {
    t !== C0 && Pn.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Ft.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = s, this._hex = r, this._value = n, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(t) {
    this.format.name !== t.format.name && Pn.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
  }
  addUnsafe(t) {
    this._checkFormat(t);
    const r = ts(this._value, this.format.decimals), n = ts(t._value, t.format.decimals);
    return nn.fromValue(r.add(n), this.format.decimals, this.format);
  }
  subUnsafe(t) {
    this._checkFormat(t);
    const r = ts(this._value, this.format.decimals), n = ts(t._value, t.format.decimals);
    return nn.fromValue(r.sub(n), this.format.decimals, this.format);
  }
  mulUnsafe(t) {
    this._checkFormat(t);
    const r = ts(this._value, this.format.decimals), n = ts(t._value, t.format.decimals);
    return nn.fromValue(r.mul(n).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(t) {
    this._checkFormat(t);
    const r = ts(this._value, this.format.decimals), n = ts(t._value, t.format.decimals);
    return nn.fromValue(r.mul(this.format._multiplier).div(n), this.format.decimals, this.format);
  }
  floor() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let r = nn.from(t[0], this.format);
    const n = !t[1].match(/^(0*)$/);
    return this.isNegative() && n && (r = r.subUnsafe(om.toFormat(r.format))), r;
  }
  ceiling() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let r = nn.from(t[0], this.format);
    const n = !t[1].match(/^(0*)$/);
    return !this.isNegative() && n && (r = r.addUnsafe(om.toFormat(r.format))), r;
  }
  // @TODO: Support other rounding algorithms
  round(t) {
    t == null && (t = 0);
    const r = this.toString().split(".");
    if (r.length === 1 && r.push("0"), (t < 0 || t > 80 || t % 1) && Pn.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t)
      return this;
    const n = nn.from("1" + B0.substring(0, t), this.format), s = fP.toFormat(this.format);
    return this.mulUnsafe(n).addUnsafe(s).floor().divUnsafe(n);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(t) {
    if (t == null)
      return this._hex;
    t % 8 && Pn.throwArgumentError("invalid byte width", "width", t);
    const r = vr.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
    return mp(r, t / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(t) {
    return nn.fromString(this._value, t);
  }
  static fromValue(t, r, n) {
    return n == null && r != null && !dP(r) && (n = r, r = null), r == null && (r = 0), n == null && (n = "fixed"), nn.fromString(Qd(t, r), Su.from(n));
  }
  static fromString(t, r) {
    r == null && (r = "fixed");
    const n = Su.from(r), s = ts(t, n.decimals);
    !n.signed && s.lt(wv) && Av("unsigned value cannot be negative", "overflow", "value", t);
    let i = null;
    n.signed ? i = s.toTwos(n.width).toHexString() : (i = s.toHexString(), i = mp(i, n.width / 8));
    const a = Qd(s, n.decimals);
    return new nn(C0, i, a, n);
  }
  static fromBytes(t, r) {
    r == null && (r = "fixed");
    const n = Su.from(r);
    if (bi(t).length > n.width / 8)
      throw new Error("overflow");
    let s = vr.from(t);
    n.signed && (s = s.fromTwos(n.width));
    const i = s.toTwos((n.signed ? 0 : 1) + n.width).toHexString(), a = Qd(s, n.decimals);
    return new nn(C0, i, a, n);
  }
  static from(t, r) {
    if (typeof t == "string")
      return nn.fromString(t, r);
    if (ud(t))
      return nn.fromBytes(t, r);
    try {
      return nn.fromValue(t, 0, r);
    } catch (n) {
      if (n.code !== Ft.errors.INVALID_ARGUMENT)
        throw n;
    }
    return Pn.throwArgumentError("invalid FixedNumber value", "value", t);
  }
  static isFixedNumber(t) {
    return !!(t && t._isFixedNumber);
  }
}
const om = nn.from(1), fP = nn.from("0.5");
function Wa(e, t, r) {
  Object.defineProperty(e, t, {
    enumerable: !0,
    value: r,
    writable: !1
  });
}
const Hh = "abi/5.7.0", K0 = new Ft(Hh), am = {};
let um = { calldata: !0, memory: !0, storage: !0 }, pP = { calldata: !0, memory: !0 };
function Md(e, t) {
  if (e === "bytes" || e === "string") {
    if (um[t])
      return !0;
  } else if (e === "address") {
    if (t === "payable")
      return !0;
  } else if ((e.indexOf("[") >= 0 || e === "tuple") && pP[t])
    return !0;
  return (um[t] || t === "payable") && K0.throwArgumentError("invalid modifier", "name", t), !1;
}
function gP(e, t) {
  let r = e;
  function n(f) {
    K0.throwArgumentError(`unexpected character at position ${f}`, "param", e);
  }
  e = e.replace(/\s/g, " ");
  function s(f) {
    let d = { type: "", name: "", parent: f, state: { allowType: !0 } };
    return t && (d.indexed = !1), d;
  }
  let i = { type: "", name: "", state: { allowType: !0 } }, a = i;
  for (let f = 0; f < e.length; f++) {
    let d = e[f];
    switch (d) {
      case "(":
        a.state.allowType && a.type === "" ? a.type = "tuple" : a.state.allowParams || n(f), a.state.allowType = !1, a.type = fu(a.type), a.components = [s(a)], a = a.components[0];
        break;
      case ")":
        delete a.state, a.name === "indexed" && (t || n(f), a.indexed = !0, a.name = ""), Md(a.type, a.name) && (a.name = ""), a.type = fu(a.type);
        let c = a;
        a = a.parent, a || n(f), delete c.parent, a.state.allowParams = !1, a.state.allowName = !0, a.state.allowArray = !0;
        break;
      case ",":
        delete a.state, a.name === "indexed" && (t || n(f), a.indexed = !0, a.name = ""), Md(a.type, a.name) && (a.name = ""), a.type = fu(a.type);
        let p = s(a.parent);
        a.parent.components.push(p), delete a.parent, a = p;
        break;
      case " ":
        a.state.allowType && a.type !== "" && (a.type = fu(a.type), delete a.state.allowType, a.state.allowName = !0, a.state.allowParams = !0), a.state.allowName && a.name !== "" && (a.name === "indexed" ? (t || n(f), a.indexed && n(f), a.indexed = !0, a.name = "") : Md(a.type, a.name) ? a.name = "" : a.state.allowName = !1);
        break;
      case "[":
        a.state.allowArray || n(f), a.type += d, a.state.allowArray = !1, a.state.allowName = !1, a.state.readArray = !0;
        break;
      case "]":
        a.state.readArray || n(f), a.type += d, a.state.readArray = !1, a.state.allowArray = !0, a.state.allowName = !0;
        break;
      default:
        a.state.allowType ? (a.type += d, a.state.allowParams = !0, a.state.allowArray = !0) : a.state.allowName ? (a.name += d, delete a.state.allowArray) : a.state.readArray ? a.type += d : n(f);
    }
  }
  return a.parent && K0.throwArgumentError("unexpected eof", "param", e), delete i.state, a.name === "indexed" ? (t || n(r.length - 7), a.indexed && n(r.length - 7), a.indexed = !0, a.name = "") : Md(a.type, a.name) && (a.name = ""), i.type = fu(i.type), i;
}
function Rf(e, t) {
  for (let r in t)
    Wa(e, r, t[r]);
}
const Uo = Object.freeze({
  // Bare formatting, as is needed for computing a sighash of an event or function
  sighash: "sighash",
  // Human-Readable with Minimal spacing and without names (compact human-readable)
  minimal: "minimal",
  // Human-Readable with nice spacing, including all names
  full: "full",
  // JSON-format a la Solidity
  json: "json"
}), mP = new RegExp(/^(.*)\[([0-9]*)\]$/);
class Li {
  constructor(t, r) {
    t !== am && K0.throwError("use fromString", Ft.errors.UNSUPPORTED_OPERATION, {
      operation: "new ParamType()"
    }), Rf(this, r);
    let n = this.type.match(mP);
    n ? Rf(this, {
      arrayLength: parseInt(n[2] || "-1"),
      arrayChildren: Li.fromObject({
        type: n[1],
        components: this.components
      }),
      baseType: "array"
    }) : Rf(this, {
      arrayLength: null,
      arrayChildren: null,
      baseType: this.components != null ? "tuple" : this.type
    }), this._isParamType = !0, Object.freeze(this);
  }
  // Format the parameter fragment
  //   - sighash: "(uint256,address)"
  //   - minimal: "tuple(uint256,address) indexed"
  //   - full:    "tuple(uint256 foo, address bar) indexed baz"
  format(t) {
    if (t || (t = Uo.sighash), Uo[t] || K0.throwArgumentError("invalid format type", "format", t), t === Uo.json) {
      let n = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: this.name || void 0
      };
      return typeof this.indexed == "boolean" && (n.indexed = this.indexed), this.components && (n.components = this.components.map((s) => JSON.parse(s.format(t)))), JSON.stringify(n);
    }
    let r = "";
    return this.baseType === "array" ? (r += this.arrayChildren.format(t), r += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : this.baseType === "tuple" ? (t !== Uo.sighash && (r += this.type), r += "(" + this.components.map((n) => n.format(t)).join(t === Uo.full ? ", " : ",") + ")") : r += this.type, t !== Uo.sighash && (this.indexed === !0 && (r += " indexed"), t === Uo.full && this.name && (r += " " + this.name)), r;
  }
  static from(t, r) {
    return typeof t == "string" ? Li.fromString(t, r) : Li.fromObject(t);
  }
  static fromObject(t) {
    return Li.isParamType(t) ? t : new Li(am, {
      name: t.name || null,
      type: fu(t.type),
      indexed: t.indexed == null ? null : !!t.indexed,
      components: t.components ? t.components.map(Li.fromObject) : null
    });
  }
  static fromString(t, r) {
    function n(s) {
      return Li.fromObject({
        name: s.name,
        type: s.type,
        indexed: s.indexed,
        components: s.components
      });
    }
    return n(gP(t, !!r));
  }
  static isParamType(t) {
    return !!(t != null && t._isParamType);
  }
}
function fu(e) {
  return e.match(/^uint($|[^1-9])/) ? e = "uint256" + e.substring(4) : e.match(/^int($|[^1-9])/) && (e = "int256" + e.substring(3)), e;
}
const u1 = new Ft(Hh);
class to {
  constructor(t, r, n, s) {
    this.name = t, this.type = r, this.localName = n, this.dynamic = s;
  }
  _throwError(t, r) {
    u1.throwArgumentError(t, this.localName, r);
  }
}
class yp {
  constructor(t) {
    Wa(this, "wordSize", t || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(t);
  }
  get data() {
    return lP(this._data);
  }
  get length() {
    return this._dataLength;
  }
  _writeData(t) {
    return this._data.push(t), this._dataLength += t.length, t.length;
  }
  appendWriter(t) {
    return this._writeData(Sf(t._data));
  }
  // Arrayish items; padded on the right to wordSize
  writeBytes(t) {
    let r = bi(t);
    const n = r.length % this.wordSize;
    return n && (r = Sf([r, this._padding.slice(n)])), this._writeData(r);
  }
  _getValue(t) {
    let r = bi(vr.from(t));
    return r.length > this.wordSize && u1.throwError("value out-of-bounds", Ft.errors.BUFFER_OVERRUN, {
      length: this.wordSize,
      offset: r.length
    }), r.length % this.wordSize && (r = Sf([this._padding.slice(r.length % this.wordSize), r])), r;
  }
  // BigNumberish items; padded on the left to wordSize
  writeValue(t) {
    return this._writeData(this._getValue(t));
  }
  writeUpdatableValue() {
    const t = this._data.length;
    return this._data.push(this._padding), this._dataLength += this.wordSize, (r) => {
      this._data[t] = this._getValue(r);
    };
  }
}
class fh {
  constructor(t, r, n, s) {
    Wa(this, "_data", bi(t)), Wa(this, "wordSize", r || 32), Wa(this, "_coerceFunc", n), Wa(this, "allowLoose", s), this._offset = 0;
  }
  get data() {
    return sc(this._data);
  }
  get consumed() {
    return this._offset;
  }
  // The default Coerce function
  static coerce(t, r) {
    let n = t.match("^u?int([0-9]+)$");
    return n && parseInt(n[1]) <= 48 && (r = r.toNumber()), r;
  }
  coerce(t, r) {
    return this._coerceFunc ? this._coerceFunc(t, r) : fh.coerce(t, r);
  }
  _peekBytes(t, r, n) {
    let s = Math.ceil(r / this.wordSize) * this.wordSize;
    return this._offset + s > this._data.length && (this.allowLoose && n && this._offset + r <= this._data.length ? s = r : u1.throwError("data out-of-bounds", Ft.errors.BUFFER_OVERRUN, {
      length: this._data.length,
      offset: this._offset + s
    })), this._data.slice(this._offset, this._offset + s);
  }
  subReader(t) {
    return new fh(this._data.slice(this._offset + t), this.wordSize, this._coerceFunc, this.allowLoose);
  }
  readBytes(t, r) {
    let n = this._peekBytes(0, t, !!r);
    return this._offset += n.length, n.slice(0, t);
  }
  readValue() {
    return vr.from(this.readBytes(this.wordSize));
  }
}
var Ev = { exports: {} };
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
(function(e) {
  (function() {
    var t = "input is invalid type", r = "finalize already called", n = typeof window == "object", s = n ? window : {};
    s.JS_SHA3_NO_WINDOW && (n = !1);
    var i = !n && typeof self == "object", a = !s.JS_SHA3_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
    a ? s = Ze : i && (s = self);
    var f = !s.JS_SHA3_NO_COMMON_JS && !0 && e.exports, d = !s.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", c = "0123456789abcdef".split(""), p = [31, 7936, 2031616, 520093696], g = [4, 1024, 262144, 67108864], v = [1, 256, 65536, 16777216], O = [6, 1536, 393216, 100663296], N = [0, 8, 16, 24], S = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], j = [224, 256, 384, 512], B = [128, 256], M = ["hex", "buffer", "arrayBuffer", "array", "digest"], I = {
      128: 168,
      256: 136
    };
    (s.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(G) {
      return Object.prototype.toString.call(G) === "[object Array]";
    }), d && (s.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(G) {
      return typeof G == "object" && G.buffer && G.buffer.constructor === ArrayBuffer;
    });
    for (var A = function(G, re, ce) {
      return function(pe) {
        return new b(G, re, G).update(pe)[ce]();
      };
    }, R = function(G, re, ce) {
      return function(pe, ve) {
        return new b(G, re, ve).update(pe)[ce]();
      };
    }, L = function(G, re, ce) {
      return function(pe, ve, Ee, Pe) {
        return u["cshake" + G].update(pe, ve, Ee, Pe)[ce]();
      };
    }, K = function(G, re, ce) {
      return function(pe, ve, Ee, Pe) {
        return u["kmac" + G].update(pe, ve, Ee, Pe)[ce]();
      };
    }, $ = function(G, re, ce, pe) {
      for (var ve = 0; ve < M.length; ++ve) {
        var Ee = M[ve];
        G[Ee] = re(ce, pe, Ee);
      }
      return G;
    }, k = function(G, re) {
      var ce = A(G, re, "hex");
      return ce.create = function() {
        return new b(G, re, G);
      }, ce.update = function(pe) {
        return ce.create().update(pe);
      }, $(ce, A, G, re);
    }, V = function(G, re) {
      var ce = R(G, re, "hex");
      return ce.create = function(pe) {
        return new b(G, re, pe);
      }, ce.update = function(pe, ve) {
        return ce.create(ve).update(pe);
      }, $(ce, R, G, re);
    }, C = function(G, re) {
      var ce = I[G], pe = L(G, re, "hex");
      return pe.create = function(ve, Ee, Pe) {
        return !Ee && !Pe ? u["shake" + G].create(ve) : new b(G, re, ve).bytepad([Ee, Pe], ce);
      }, pe.update = function(ve, Ee, Pe, xe) {
        return pe.create(Ee, Pe, xe).update(ve);
      }, $(pe, L, G, re);
    }, D = function(G, re) {
      var ce = I[G], pe = K(G, re, "hex");
      return pe.create = function(ve, Ee, Pe) {
        return new W(G, re, Ee).bytepad(["KMAC", Pe], ce).bytepad([ve], ce);
      }, pe.update = function(ve, Ee, Pe, xe) {
        return pe.create(ve, Pe, xe).update(Ee);
      }, $(pe, K, G, re);
    }, o = [
      { name: "keccak", padding: v, bits: j, createMethod: k },
      { name: "sha3", padding: O, bits: j, createMethod: k },
      { name: "shake", padding: p, bits: B, createMethod: V },
      { name: "cshake", padding: g, bits: B, createMethod: C },
      { name: "kmac", padding: g, bits: B, createMethod: D }
    ], u = {}, h = [], y = 0; y < o.length; ++y)
      for (var E = o[y], P = E.bits, w = 0; w < P.length; ++w) {
        var m = E.name + "_" + P[w];
        if (h.push(m), u[m] = E.createMethod(P[w], E.padding), E.name !== "sha3") {
          var l = E.name + P[w];
          h.push(l), u[l] = u[m];
        }
      }
    function b(G, re, ce) {
      this.blocks = [], this.s = [], this.padding = re, this.outputBits = ce, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (G << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = ce >> 5, this.extraBytes = (ce & 31) >> 3;
      for (var pe = 0; pe < 50; ++pe)
        this.s[pe] = 0;
    }
    b.prototype.update = function(G) {
      if (this.finalized)
        throw new Error(r);
      var re, ce = typeof G;
      if (ce !== "string") {
        if (ce === "object") {
          if (G === null)
            throw new Error(t);
          if (d && G.constructor === ArrayBuffer)
            G = new Uint8Array(G);
          else if (!Array.isArray(G) && (!d || !ArrayBuffer.isView(G)))
            throw new Error(t);
        } else
          throw new Error(t);
        re = !0;
      }
      for (var pe = this.blocks, ve = this.byteCount, Ee = G.length, Pe = this.blockCount, xe = 0, me = this.s, te, U; xe < Ee; ) {
        if (this.reset)
          for (this.reset = !1, pe[0] = this.block, te = 1; te < Pe + 1; ++te)
            pe[te] = 0;
        if (re)
          for (te = this.start; xe < Ee && te < ve; ++xe)
            pe[te >> 2] |= G[xe] << N[te++ & 3];
        else
          for (te = this.start; xe < Ee && te < ve; ++xe)
            U = G.charCodeAt(xe), U < 128 ? pe[te >> 2] |= U << N[te++ & 3] : U < 2048 ? (pe[te >> 2] |= (192 | U >> 6) << N[te++ & 3], pe[te >> 2] |= (128 | U & 63) << N[te++ & 3]) : U < 55296 || U >= 57344 ? (pe[te >> 2] |= (224 | U >> 12) << N[te++ & 3], pe[te >> 2] |= (128 | U >> 6 & 63) << N[te++ & 3], pe[te >> 2] |= (128 | U & 63) << N[te++ & 3]) : (U = 65536 + ((U & 1023) << 10 | G.charCodeAt(++xe) & 1023), pe[te >> 2] |= (240 | U >> 18) << N[te++ & 3], pe[te >> 2] |= (128 | U >> 12 & 63) << N[te++ & 3], pe[te >> 2] |= (128 | U >> 6 & 63) << N[te++ & 3], pe[te >> 2] |= (128 | U & 63) << N[te++ & 3]);
        if (this.lastByteIndex = te, te >= ve) {
          for (this.start = te - ve, this.block = pe[Pe], te = 0; te < Pe; ++te)
            me[te] ^= pe[te];
          X(me), this.reset = !0;
        } else
          this.start = te;
      }
      return this;
    }, b.prototype.encode = function(G, re) {
      var ce = G & 255, pe = 1, ve = [ce];
      for (G = G >> 8, ce = G & 255; ce > 0; )
        ve.unshift(ce), G = G >> 8, ce = G & 255, ++pe;
      return re ? ve.push(pe) : ve.unshift(pe), this.update(ve), ve.length;
    }, b.prototype.encodeString = function(G) {
      var re, ce = typeof G;
      if (ce !== "string") {
        if (ce === "object") {
          if (G === null)
            throw new Error(t);
          if (d && G.constructor === ArrayBuffer)
            G = new Uint8Array(G);
          else if (!Array.isArray(G) && (!d || !ArrayBuffer.isView(G)))
            throw new Error(t);
        } else
          throw new Error(t);
        re = !0;
      }
      var pe = 0, ve = G.length;
      if (re)
        pe = ve;
      else
        for (var Ee = 0; Ee < G.length; ++Ee) {
          var Pe = G.charCodeAt(Ee);
          Pe < 128 ? pe += 1 : Pe < 2048 ? pe += 2 : Pe < 55296 || Pe >= 57344 ? pe += 3 : (Pe = 65536 + ((Pe & 1023) << 10 | G.charCodeAt(++Ee) & 1023), pe += 4);
        }
      return pe += this.encode(pe * 8), this.update(G), pe;
    }, b.prototype.bytepad = function(G, re) {
      for (var ce = this.encode(re), pe = 0; pe < G.length; ++pe)
        ce += this.encodeString(G[pe]);
      var ve = re - ce % re, Ee = [];
      return Ee.length = ve, this.update(Ee), this;
    }, b.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var G = this.blocks, re = this.lastByteIndex, ce = this.blockCount, pe = this.s;
        if (G[re >> 2] |= this.padding[re & 3], this.lastByteIndex === this.byteCount)
          for (G[0] = G[ce], re = 1; re < ce + 1; ++re)
            G[re] = 0;
        for (G[ce - 1] |= 2147483648, re = 0; re < ce; ++re)
          pe[re] ^= G[re];
        X(pe);
      }
    }, b.prototype.toString = b.prototype.hex = function() {
      this.finalize();
      for (var G = this.blockCount, re = this.s, ce = this.outputBlocks, pe = this.extraBytes, ve = 0, Ee = 0, Pe = "", xe; Ee < ce; ) {
        for (ve = 0; ve < G && Ee < ce; ++ve, ++Ee)
          xe = re[ve], Pe += c[xe >> 4 & 15] + c[xe & 15] + c[xe >> 12 & 15] + c[xe >> 8 & 15] + c[xe >> 20 & 15] + c[xe >> 16 & 15] + c[xe >> 28 & 15] + c[xe >> 24 & 15];
        Ee % G === 0 && (X(re), ve = 0);
      }
      return pe && (xe = re[ve], Pe += c[xe >> 4 & 15] + c[xe & 15], pe > 1 && (Pe += c[xe >> 12 & 15] + c[xe >> 8 & 15]), pe > 2 && (Pe += c[xe >> 20 & 15] + c[xe >> 16 & 15])), Pe;
    }, b.prototype.arrayBuffer = function() {
      this.finalize();
      var G = this.blockCount, re = this.s, ce = this.outputBlocks, pe = this.extraBytes, ve = 0, Ee = 0, Pe = this.outputBits >> 3, xe;
      pe ? xe = new ArrayBuffer(ce + 1 << 2) : xe = new ArrayBuffer(Pe);
      for (var me = new Uint32Array(xe); Ee < ce; ) {
        for (ve = 0; ve < G && Ee < ce; ++ve, ++Ee)
          me[Ee] = re[ve];
        Ee % G === 0 && X(re);
      }
      return pe && (me[ve] = re[ve], xe = xe.slice(0, Pe)), xe;
    }, b.prototype.buffer = b.prototype.arrayBuffer, b.prototype.digest = b.prototype.array = function() {
      this.finalize();
      for (var G = this.blockCount, re = this.s, ce = this.outputBlocks, pe = this.extraBytes, ve = 0, Ee = 0, Pe = [], xe, me; Ee < ce; ) {
        for (ve = 0; ve < G && Ee < ce; ++ve, ++Ee)
          xe = Ee << 2, me = re[ve], Pe[xe] = me & 255, Pe[xe + 1] = me >> 8 & 255, Pe[xe + 2] = me >> 16 & 255, Pe[xe + 3] = me >> 24 & 255;
        Ee % G === 0 && X(re);
      }
      return pe && (xe = Ee << 2, me = re[ve], Pe[xe] = me & 255, pe > 1 && (Pe[xe + 1] = me >> 8 & 255), pe > 2 && (Pe[xe + 2] = me >> 16 & 255)), Pe;
    };
    function W(G, re, ce) {
      b.call(this, G, re, ce);
    }
    W.prototype = new b(), W.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), b.prototype.finalize.call(this);
    };
    var X = function(G) {
      var re, ce, pe, ve, Ee, Pe, xe, me, te, U, ue, we, ke, Re, fe, x, _, q, ne, de, ye, ge, be, Me, Ce, je, Ue, Qe, Ye, et, At, it, tt, Pt, dt, st, zt, xt, lt, $t, Tt, at, Ut, Ot, He, Vt, yt, ut, It, kt, ot, Rt, Nt, rt, Dt, St, T, F, H, z, Q, Z, ie;
      for (pe = 0; pe < 48; pe += 2)
        ve = G[0] ^ G[10] ^ G[20] ^ G[30] ^ G[40], Ee = G[1] ^ G[11] ^ G[21] ^ G[31] ^ G[41], Pe = G[2] ^ G[12] ^ G[22] ^ G[32] ^ G[42], xe = G[3] ^ G[13] ^ G[23] ^ G[33] ^ G[43], me = G[4] ^ G[14] ^ G[24] ^ G[34] ^ G[44], te = G[5] ^ G[15] ^ G[25] ^ G[35] ^ G[45], U = G[6] ^ G[16] ^ G[26] ^ G[36] ^ G[46], ue = G[7] ^ G[17] ^ G[27] ^ G[37] ^ G[47], we = G[8] ^ G[18] ^ G[28] ^ G[38] ^ G[48], ke = G[9] ^ G[19] ^ G[29] ^ G[39] ^ G[49], re = we ^ (Pe << 1 | xe >>> 31), ce = ke ^ (xe << 1 | Pe >>> 31), G[0] ^= re, G[1] ^= ce, G[10] ^= re, G[11] ^= ce, G[20] ^= re, G[21] ^= ce, G[30] ^= re, G[31] ^= ce, G[40] ^= re, G[41] ^= ce, re = ve ^ (me << 1 | te >>> 31), ce = Ee ^ (te << 1 | me >>> 31), G[2] ^= re, G[3] ^= ce, G[12] ^= re, G[13] ^= ce, G[22] ^= re, G[23] ^= ce, G[32] ^= re, G[33] ^= ce, G[42] ^= re, G[43] ^= ce, re = Pe ^ (U << 1 | ue >>> 31), ce = xe ^ (ue << 1 | U >>> 31), G[4] ^= re, G[5] ^= ce, G[14] ^= re, G[15] ^= ce, G[24] ^= re, G[25] ^= ce, G[34] ^= re, G[35] ^= ce, G[44] ^= re, G[45] ^= ce, re = me ^ (we << 1 | ke >>> 31), ce = te ^ (ke << 1 | we >>> 31), G[6] ^= re, G[7] ^= ce, G[16] ^= re, G[17] ^= ce, G[26] ^= re, G[27] ^= ce, G[36] ^= re, G[37] ^= ce, G[46] ^= re, G[47] ^= ce, re = U ^ (ve << 1 | Ee >>> 31), ce = ue ^ (Ee << 1 | ve >>> 31), G[8] ^= re, G[9] ^= ce, G[18] ^= re, G[19] ^= ce, G[28] ^= re, G[29] ^= ce, G[38] ^= re, G[39] ^= ce, G[48] ^= re, G[49] ^= ce, Re = G[0], fe = G[1], Vt = G[11] << 4 | G[10] >>> 28, yt = G[10] << 4 | G[11] >>> 28, Qe = G[20] << 3 | G[21] >>> 29, Ye = G[21] << 3 | G[20] >>> 29, z = G[31] << 9 | G[30] >>> 23, Q = G[30] << 9 | G[31] >>> 23, at = G[40] << 18 | G[41] >>> 14, Ut = G[41] << 18 | G[40] >>> 14, Pt = G[2] << 1 | G[3] >>> 31, dt = G[3] << 1 | G[2] >>> 31, x = G[13] << 12 | G[12] >>> 20, _ = G[12] << 12 | G[13] >>> 20, ut = G[22] << 10 | G[23] >>> 22, It = G[23] << 10 | G[22] >>> 22, et = G[33] << 13 | G[32] >>> 19, At = G[32] << 13 | G[33] >>> 19, Z = G[42] << 2 | G[43] >>> 30, ie = G[43] << 2 | G[42] >>> 30, rt = G[5] << 30 | G[4] >>> 2, Dt = G[4] << 30 | G[5] >>> 2, st = G[14] << 6 | G[15] >>> 26, zt = G[15] << 6 | G[14] >>> 26, q = G[25] << 11 | G[24] >>> 21, ne = G[24] << 11 | G[25] >>> 21, kt = G[34] << 15 | G[35] >>> 17, ot = G[35] << 15 | G[34] >>> 17, it = G[45] << 29 | G[44] >>> 3, tt = G[44] << 29 | G[45] >>> 3, Me = G[6] << 28 | G[7] >>> 4, Ce = G[7] << 28 | G[6] >>> 4, St = G[17] << 23 | G[16] >>> 9, T = G[16] << 23 | G[17] >>> 9, xt = G[26] << 25 | G[27] >>> 7, lt = G[27] << 25 | G[26] >>> 7, de = G[36] << 21 | G[37] >>> 11, ye = G[37] << 21 | G[36] >>> 11, Rt = G[47] << 24 | G[46] >>> 8, Nt = G[46] << 24 | G[47] >>> 8, Ot = G[8] << 27 | G[9] >>> 5, He = G[9] << 27 | G[8] >>> 5, je = G[18] << 20 | G[19] >>> 12, Ue = G[19] << 20 | G[18] >>> 12, F = G[29] << 7 | G[28] >>> 25, H = G[28] << 7 | G[29] >>> 25, $t = G[38] << 8 | G[39] >>> 24, Tt = G[39] << 8 | G[38] >>> 24, ge = G[48] << 14 | G[49] >>> 18, be = G[49] << 14 | G[48] >>> 18, G[0] = Re ^ ~x & q, G[1] = fe ^ ~_ & ne, G[10] = Me ^ ~je & Qe, G[11] = Ce ^ ~Ue & Ye, G[20] = Pt ^ ~st & xt, G[21] = dt ^ ~zt & lt, G[30] = Ot ^ ~Vt & ut, G[31] = He ^ ~yt & It, G[40] = rt ^ ~St & F, G[41] = Dt ^ ~T & H, G[2] = x ^ ~q & de, G[3] = _ ^ ~ne & ye, G[12] = je ^ ~Qe & et, G[13] = Ue ^ ~Ye & At, G[22] = st ^ ~xt & $t, G[23] = zt ^ ~lt & Tt, G[32] = Vt ^ ~ut & kt, G[33] = yt ^ ~It & ot, G[42] = St ^ ~F & z, G[43] = T ^ ~H & Q, G[4] = q ^ ~de & ge, G[5] = ne ^ ~ye & be, G[14] = Qe ^ ~et & it, G[15] = Ye ^ ~At & tt, G[24] = xt ^ ~$t & at, G[25] = lt ^ ~Tt & Ut, G[34] = ut ^ ~kt & Rt, G[35] = It ^ ~ot & Nt, G[44] = F ^ ~z & Z, G[45] = H ^ ~Q & ie, G[6] = de ^ ~ge & Re, G[7] = ye ^ ~be & fe, G[16] = et ^ ~it & Me, G[17] = At ^ ~tt & Ce, G[26] = $t ^ ~at & Pt, G[27] = Tt ^ ~Ut & dt, G[36] = kt ^ ~Rt & Ot, G[37] = ot ^ ~Nt & He, G[46] = z ^ ~Z & rt, G[47] = Q ^ ~ie & Dt, G[8] = ge ^ ~Re & x, G[9] = be ^ ~fe & _, G[18] = it ^ ~Me & je, G[19] = tt ^ ~Ce & Ue, G[28] = at ^ ~Pt & st, G[29] = Ut ^ ~dt & zt, G[38] = Rt ^ ~Ot & Vt, G[39] = Nt ^ ~He & yt, G[48] = Z ^ ~rt & St, G[49] = ie ^ ~Dt & T, G[0] ^= S[pe], G[1] ^= S[pe + 1];
    };
    if (f)
      e.exports = u;
    else
      for (y = 0; y < h.length; ++y)
        s[h[y]] = u[h[y]];
  })();
})(Ev);
var yP = Ev.exports;
const bP = /* @__PURE__ */ gv(yP);
function wP(e) {
  return "0x" + bP.keccak_256(bi(e));
}
const vP = "address/5.7.0", O0 = new Ft(vP);
function cm(e) {
  Ya(e, 20) || O0.throwArgumentError("invalid address", "address", e), e = e.toLowerCase();
  const t = e.substring(2).split(""), r = new Uint8Array(40);
  for (let s = 0; s < 40; s++)
    r[s] = t[s].charCodeAt(0);
  const n = bi(wP(r));
  for (let s = 0; s < 40; s += 2)
    n[s >> 1] >> 4 >= 8 && (t[s] = t[s].toUpperCase()), (n[s >> 1] & 15) >= 8 && (t[s + 1] = t[s + 1].toUpperCase());
  return "0x" + t.join("");
}
const AP = 9007199254740991;
function EP(e) {
  return Math.log10 ? Math.log10(e) : Math.log(e) / Math.LN10;
}
const c1 = {};
for (let e = 0; e < 10; e++)
  c1[String(e)] = String(e);
for (let e = 0; e < 26; e++)
  c1[String.fromCharCode(65 + e)] = String(10 + e);
const lm = Math.floor(EP(AP));
function PP(e) {
  e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
  let t = e.split("").map((n) => c1[n]).join("");
  for (; t.length >= lm; ) {
    let n = t.substring(0, lm);
    t = parseInt(n, 10) % 97 + t.substring(n.length);
  }
  let r = String(98 - parseInt(t, 10) % 97);
  for (; r.length < 2; )
    r = "0" + r;
  return r;
}
function dm(e) {
  let t = null;
  if (typeof e != "string" && O0.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/))
    e.substring(0, 2) !== "0x" && (e = "0x" + e), t = cm(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && O0.throwArgumentError("bad address checksum", "address", e);
  else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    for (e.substring(2, 4) !== PP(e) && O0.throwArgumentError("bad icap checksum", "address", e), t = hP(e.substring(4)); t.length < 40; )
      t = "0" + t;
    t = cm("0x" + t);
  } else
    O0.throwArgumentError("invalid address", "address", e);
  return t;
}
class OP extends to {
  constructor(t) {
    super("address", "address", t, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(t, r) {
    try {
      r = dm(r);
    } catch (n) {
      this._throwError(n.message, r);
    }
    return t.writeValue(r);
  }
  decode(t) {
    return dm(mp(t.readValue().toHexString(), 20));
  }
}
class NP extends to {
  constructor(t) {
    super(t.name, t.type, void 0, t.dynamic), this.coder = t;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(t, r) {
    return this.coder.encode(t, r);
  }
  decode(t) {
    return this.coder.decode(t);
  }
}
const Nu = new Ft(Hh);
function Pv(e, t, r) {
  let n = null;
  if (Array.isArray(r))
    n = r;
  else if (r && typeof r == "object") {
    let d = {};
    n = t.map((c) => {
      const p = c.localName;
      return p || Nu.throwError("cannot encode object for signature with missing names", Ft.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: c,
        value: r
      }), d[p] && Nu.throwError("cannot encode object for signature with duplicate names", Ft.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: c,
        value: r
      }), d[p] = !0, r[p];
    });
  } else
    Nu.throwArgumentError("invalid tuple value", "tuple", r);
  t.length !== n.length && Nu.throwArgumentError("types/value length mismatch", "tuple", r);
  let s = new yp(e.wordSize), i = new yp(e.wordSize), a = [];
  t.forEach((d, c) => {
    let p = n[c];
    if (d.dynamic) {
      let g = i.length;
      d.encode(i, p);
      let v = s.writeUpdatableValue();
      a.push((O) => {
        v(O + g);
      });
    } else
      d.encode(s, p);
  }), a.forEach((d) => {
    d(s.length);
  });
  let f = e.appendWriter(s);
  return f += e.appendWriter(i), f;
}
function Ov(e, t) {
  let r = [], n = e.subReader(0);
  t.forEach((i) => {
    let a = null;
    if (i.dynamic) {
      let f = e.readValue(), d = n.subReader(f.toNumber());
      try {
        a = i.decode(d);
      } catch (c) {
        if (c.code === Ft.errors.BUFFER_OVERRUN)
          throw c;
        a = c, a.baseType = i.name, a.name = i.localName, a.type = i.type;
      }
    } else
      try {
        a = i.decode(e);
      } catch (f) {
        if (f.code === Ft.errors.BUFFER_OVERRUN)
          throw f;
        a = f, a.baseType = i.name, a.name = i.localName, a.type = i.type;
      }
    a != null && r.push(a);
  });
  const s = t.reduce((i, a) => {
    const f = a.localName;
    return f && (i[f] || (i[f] = 0), i[f]++), i;
  }, {});
  t.forEach((i, a) => {
    let f = i.localName;
    if (!f || s[f] !== 1 || (f === "length" && (f = "_length"), r[f] != null))
      return;
    const d = r[a];
    d instanceof Error ? Object.defineProperty(r, f, {
      enumerable: !0,
      get: () => {
        throw d;
      }
    }) : r[f] = d;
  });
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    a instanceof Error && Object.defineProperty(r, i, {
      enumerable: !0,
      get: () => {
        throw a;
      }
    });
  }
  return Object.freeze(r);
}
class xP extends to {
  constructor(t, r, n) {
    const s = t.type + "[" + (r >= 0 ? r : "") + "]", i = r === -1 || t.dynamic;
    super("array", s, n, i), this.coder = t, this.length = r;
  }
  defaultValue() {
    const t = this.coder.defaultValue(), r = [];
    for (let n = 0; n < this.length; n++)
      r.push(t);
    return r;
  }
  encode(t, r) {
    Array.isArray(r) || this._throwError("expected array value", r);
    let n = this.length;
    n === -1 && (n = r.length, t.writeValue(r.length)), Nu.checkArgumentCount(r.length, n, "coder array" + (this.localName ? " " + this.localName : ""));
    let s = [];
    for (let i = 0; i < r.length; i++)
      s.push(this.coder);
    return Pv(t, s, r);
  }
  decode(t) {
    let r = this.length;
    r === -1 && (r = t.readValue().toNumber(), r * 32 > t._data.length && Nu.throwError("insufficient data length", Ft.errors.BUFFER_OVERRUN, {
      length: t._data.length,
      count: r
    }));
    let n = [];
    for (let s = 0; s < r; s++)
      n.push(new NP(this.coder));
    return t.coerce(this.name, Ov(t, n));
  }
}
class TP extends to {
  constructor(t) {
    super("bool", "bool", t, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(t, r) {
    return t.writeValue(r ? 1 : 0);
  }
  decode(t) {
    return t.coerce(this.type, !t.readValue().isZero());
  }
}
class Nv extends to {
  constructor(t, r) {
    super(t, t, r, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(t, r) {
    r = bi(r);
    let n = t.writeValue(r.length);
    return n += t.writeBytes(r), n;
  }
  decode(t) {
    return t.readBytes(t.readValue().toNumber(), !0);
  }
}
class kP extends Nv {
  constructor(t) {
    super("bytes", t);
  }
  decode(t) {
    return t.coerce(this.name, sc(super.decode(t)));
  }
}
class SP extends to {
  constructor(t, r) {
    let n = "bytes" + String(t);
    super(n, n, r, !1), this.size = t;
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(t, r) {
    let n = bi(r);
    return n.length !== this.size && this._throwError("incorrect data length", r), t.writeBytes(n);
  }
  decode(t) {
    return t.coerce(this.name, sc(t.readBytes(this.size)));
  }
}
class MP extends to {
  constructor(t) {
    super("null", "", t, !1);
  }
  defaultValue() {
    return null;
  }
  encode(t, r) {
    return r != null && this._throwError("not null", r), t.writeBytes([]);
  }
  decode(t) {
    return t.readBytes(0), t.coerce(this.name, null);
  }
}
const IP = /* @__PURE__ */ vr.from(-1), RP = /* @__PURE__ */ vr.from(0), CP = /* @__PURE__ */ vr.from(1), BP = /* @__PURE__ */ vr.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class _P extends to {
  constructor(t, r, n) {
    const s = (r ? "int" : "uint") + t * 8;
    super(s, s, n, !1), this.size = t, this.signed = r;
  }
  defaultValue() {
    return 0;
  }
  encode(t, r) {
    let n = vr.from(r), s = BP.mask(t.wordSize * 8);
    if (this.signed) {
      let i = s.mask(this.size * 8 - 1);
      (n.gt(i) || n.lt(i.add(CP).mul(IP))) && this._throwError("value out-of-bounds", r);
    } else
      (n.lt(RP) || n.gt(s.mask(this.size * 8))) && this._throwError("value out-of-bounds", r);
    return n = n.toTwos(this.size * 8).mask(this.size * 8), this.signed && (n = n.fromTwos(this.size * 8).toTwos(8 * t.wordSize)), t.writeValue(n);
  }
  decode(t) {
    let r = t.readValue().mask(this.size * 8);
    return this.signed && (r = r.fromTwos(this.size * 8)), t.coerce(this.name, r);
  }
}
const FP = "strings/5.7.0", xv = new Ft(FP);
var ph;
(function(e) {
  e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})(ph || (ph = {}));
var Zn;
(function(e) {
  e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})(Zn || (Zn = {}));
function UP(e, t, r, n, s) {
  return xv.throwArgumentError(`invalid codepoint at offset ${t}; ${e}`, "bytes", r);
}
function Tv(e, t, r, n, s) {
  if (e === Zn.BAD_PREFIX || e === Zn.UNEXPECTED_CONTINUE) {
    let i = 0;
    for (let a = t + 1; a < r.length && r[a] >> 6 === 2; a++)
      i++;
    return i;
  }
  return e === Zn.OVERRUN ? r.length - t - 1 : 0;
}
function DP(e, t, r, n, s) {
  return e === Zn.OVERLONG ? (n.push(s), 0) : (n.push(65533), Tv(e, t, r));
}
const jP = Object.freeze({
  error: UP,
  ignore: Tv,
  replace: DP
});
function LP(e, t) {
  t == null && (t = jP.error), e = bi(e);
  const r = [];
  let n = 0;
  for (; n < e.length; ) {
    const s = e[n++];
    if (!(s >> 7)) {
      r.push(s);
      continue;
    }
    let i = null, a = null;
    if ((s & 224) === 192)
      i = 1, a = 127;
    else if ((s & 240) === 224)
      i = 2, a = 2047;
    else if ((s & 248) === 240)
      i = 3, a = 65535;
    else {
      (s & 192) === 128 ? n += t(Zn.UNEXPECTED_CONTINUE, n - 1, e, r) : n += t(Zn.BAD_PREFIX, n - 1, e, r);
      continue;
    }
    if (n - 1 + i >= e.length) {
      n += t(Zn.OVERRUN, n - 1, e, r);
      continue;
    }
    let f = s & (1 << 8 - i - 1) - 1;
    for (let d = 0; d < i; d++) {
      let c = e[n];
      if ((c & 192) != 128) {
        n += t(Zn.MISSING_CONTINUE, n, e, r), f = null;
        break;
      }
      f = f << 6 | c & 63, n++;
    }
    if (f !== null) {
      if (f > 1114111) {
        n += t(Zn.OUT_OF_RANGE, n - 1 - i, e, r, f);
        continue;
      }
      if (f >= 55296 && f <= 57343) {
        n += t(Zn.UTF16_SURROGATE, n - 1 - i, e, r, f);
        continue;
      }
      if (f <= a) {
        n += t(Zn.OVERLONG, n - 1 - i, e, r, f);
        continue;
      }
      r.push(f);
    }
  }
  return r;
}
function HP(e, t = ph.current) {
  t != ph.current && (xv.checkNormalize(), e = e.normalize(t));
  let r = [];
  for (let n = 0; n < e.length; n++) {
    const s = e.charCodeAt(n);
    if (s < 128)
      r.push(s);
    else if (s < 2048)
      r.push(s >> 6 | 192), r.push(s & 63 | 128);
    else if ((s & 64512) == 55296) {
      n++;
      const i = e.charCodeAt(n);
      if (n >= e.length || (i & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const a = 65536 + ((s & 1023) << 10) + (i & 1023);
      r.push(a >> 18 | 240), r.push(a >> 12 & 63 | 128), r.push(a >> 6 & 63 | 128), r.push(a & 63 | 128);
    } else
      r.push(s >> 12 | 224), r.push(s >> 6 & 63 | 128), r.push(s & 63 | 128);
  }
  return bi(r);
}
function WP(e) {
  return e.map((t) => t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10 & 1023) + 55296, (t & 1023) + 56320))).join("");
}
function GP(e, t) {
  return WP(LP(e, t));
}
class zP extends Nv {
  constructor(t) {
    super("string", t);
  }
  defaultValue() {
    return "";
  }
  encode(t, r) {
    return super.encode(t, HP(r));
  }
  decode(t) {
    return GP(super.decode(t));
  }
}
class Id extends to {
  constructor(t, r) {
    let n = !1;
    const s = [];
    t.forEach((a) => {
      a.dynamic && (n = !0), s.push(a.type);
    });
    const i = "tuple(" + s.join(",") + ")";
    super("tuple", i, r, n), this.coders = t;
  }
  defaultValue() {
    const t = [];
    this.coders.forEach((n) => {
      t.push(n.defaultValue());
    });
    const r = this.coders.reduce((n, s) => {
      const i = s.localName;
      return i && (n[i] || (n[i] = 0), n[i]++), n;
    }, {});
    return this.coders.forEach((n, s) => {
      let i = n.localName;
      !i || r[i] !== 1 || (i === "length" && (i = "_length"), t[i] == null && (t[i] = t[s]));
    }), Object.freeze(t);
  }
  encode(t, r) {
    return Pv(t, this.coders, r);
  }
  decode(t) {
    return t.coerce(this.name, Ov(t, this.coders));
  }
}
const Rd = new Ft(Hh), VP = new RegExp(/^bytes([0-9]*)$/), qP = new RegExp(/^(u?int)([0-9]*)$/);
class $P {
  constructor(t) {
    Wa(this, "coerceFunc", t || null);
  }
  _getCoder(t) {
    switch (t.baseType) {
      case "address":
        return new OP(t.name);
      case "bool":
        return new TP(t.name);
      case "string":
        return new zP(t.name);
      case "bytes":
        return new kP(t.name);
      case "array":
        return new xP(this._getCoder(t.arrayChildren), t.arrayLength, t.name);
      case "tuple":
        return new Id((t.components || []).map((n) => this._getCoder(n)), t.name);
      case "":
        return new MP(t.name);
    }
    let r = t.type.match(qP);
    if (r) {
      let n = parseInt(r[2] || "256");
      return (n === 0 || n > 256 || n % 8 !== 0) && Rd.throwArgumentError("invalid " + r[1] + " bit length", "param", t), new _P(n / 8, r[1] === "int", t.name);
    }
    if (r = t.type.match(VP), r) {
      let n = parseInt(r[1]);
      return (n === 0 || n > 32) && Rd.throwArgumentError("invalid bytes length", "param", t), new SP(n, t.name);
    }
    return Rd.throwArgumentError("invalid type", "type", t.type);
  }
  _getWordSize() {
    return 32;
  }
  _getReader(t, r) {
    return new fh(t, this._getWordSize(), this.coerceFunc, r);
  }
  _getWriter() {
    return new yp(this._getWordSize());
  }
  getDefaultValue(t) {
    const r = t.map((n) => this._getCoder(Li.from(n)));
    return new Id(r, "_").defaultValue();
  }
  encode(t, r) {
    t.length !== r.length && Rd.throwError("types/values length mismatch", Ft.errors.INVALID_ARGUMENT, {
      count: { types: t.length, values: r.length },
      value: { types: t, values: r }
    });
    const n = t.map((a) => this._getCoder(Li.from(a))), s = new Id(n, "_"), i = this._getWriter();
    return s.encode(i, r), i.data;
  }
  decode(t, r, n) {
    const s = t.map((i) => this._getCoder(Li.from(i)));
    return new Id(s, "_").decode(this._getReader(bi(r), n));
  }
}
new $P();
Ft.errors.INSUFFICIENT_FUNDS, Ft.errors.NONCE_EXPIRED, Ft.errors.REPLACEMENT_UNDERPRICED;
var hm;
(function(e) {
  e[e.legacy = 0] = "legacy", e[e.eip2930 = 1] = "eip2930", e[e.eip1559 = 2] = "eip1559";
})(hm || (hm = {}));
var KP = [];
for (var Cf = 0; Cf < 256; ++Cf)
  KP.push((Cf + 256).toString(16).substr(1));
var yr;
(function(e) {
  e.assertEqual = (s) => s;
  function t(s) {
  }
  e.assertIs = t;
  function r(s) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (s) => {
    const i = {};
    for (const a of s)
      i[a] = a;
    return i;
  }, e.getValidEnumValues = (s) => {
    const i = e.objectKeys(s).filter((f) => typeof s[s[f]] != "number"), a = {};
    for (const f of i)
      a[f] = s[f];
    return e.objectValues(a);
  }, e.objectValues = (s) => e.objectKeys(s).map(function(i) {
    return s[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const i = [];
    for (const a in s)
      Object.prototype.hasOwnProperty.call(s, a) && i.push(a);
    return i;
  }, e.find = (s, i) => {
    for (const a of s)
      if (i(a))
        return a;
  }, e.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function n(s, i = " | ") {
    return s.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (s, i) => typeof i == "bigint" ? i.toString() : i;
})(yr || (yr = {}));
var fm;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(fm || (fm = {}));
const bt = yr.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ja = (e) => {
  switch (typeof e) {
    case "undefined":
      return bt.undefined;
    case "string":
      return bt.string;
    case "number":
      return isNaN(e) ? bt.nan : bt.number;
    case "boolean":
      return bt.boolean;
    case "function":
      return bt.function;
    case "bigint":
      return bt.bigint;
    case "symbol":
      return bt.symbol;
    case "object":
      return Array.isArray(e) ? bt.array : e === null ? bt.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? bt.promise : typeof Map < "u" && e instanceof Map ? bt.map : typeof Set < "u" && e instanceof Set ? bt.set : typeof Date < "u" && e instanceof Date ? bt.date : bt.object;
    default:
      return bt.unknown;
  }
}, nt = yr.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class gi extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const r = t || function(i) {
      return i.message;
    }, n = { _errors: [] }, s = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(s);
        else if (a.code === "invalid_return_type")
          s(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          s(a.argumentsError);
        else if (a.path.length === 0)
          n._errors.push(r(a));
        else {
          let f = n, d = 0;
          for (; d < a.path.length; ) {
            const c = a.path[d];
            d === a.path.length - 1 ? (f[c] = f[c] || { _errors: [] }, f[c]._errors.push(r(a))) : f[c] = f[c] || { _errors: [] }, f = f[c], d++;
          }
        }
    };
    return s(this), n;
  }
  static assert(t) {
    if (!(t instanceof gi))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, yr.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(t(s))) : n.push(t(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
gi.create = (e) => new gi(e);
const J0 = (e, t) => {
  let r;
  switch (e.code) {
    case nt.invalid_type:
      e.received === bt.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case nt.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, yr.jsonStringifyReplacer)}`;
      break;
    case nt.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${yr.joinValues(e.keys, ", ")}`;
      break;
    case nt.invalid_union:
      r = "Invalid input";
      break;
    case nt.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${yr.joinValues(e.options)}`;
      break;
    case nt.invalid_enum_value:
      r = `Invalid enum value. Expected ${yr.joinValues(e.options)}, received '${e.received}'`;
      break;
    case nt.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case nt.invalid_return_type:
      r = "Invalid function return type";
      break;
    case nt.invalid_date:
      r = "Invalid date";
      break;
    case nt.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : yr.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case nt.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case nt.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case nt.custom:
      r = "Invalid input";
      break;
    case nt.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case nt.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case nt.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, yr.assertNever(e);
  }
  return { message: r };
};
let JP = J0;
function bp() {
  return JP;
}
const wp = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: s } = e, i = [...r, ...s.path || []], a = {
    ...s,
    path: i
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: i,
      message: s.message
    };
  let f = "";
  const d = n.filter((c) => !!c).slice().reverse();
  for (const c of d)
    f = c(a, { data: t, defaultError: f }).message;
  return {
    ...s,
    path: i,
    message: f
  };
};
function ft(e, t) {
  const r = bp(), n = wp({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      r,
      r === J0 ? void 0 : J0
      // then global default map
    ].filter((s) => !!s)
  });
  e.common.issues.push(n);
}
class Tn {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return Kt;
      s.status === "dirty" && t.dirty(), n.push(s.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const s of r) {
      const i = await s.key, a = await s.value;
      n.push({
        key: i,
        value: a
      });
    }
    return Tn.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const s of r) {
      const { key: i, value: a } = s;
      if (i.status === "aborted" || a.status === "aborted")
        return Kt;
      i.status === "dirty" && t.dirty(), a.status === "dirty" && t.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || s.alwaysSet) && (n[i.value] = a.value);
    }
    return { status: t.value, value: n };
  }
}
const Kt = Object.freeze({
  status: "aborted"
}), vp = (e) => ({ status: "dirty", value: e }), _n = (e) => ({ status: "valid", value: e }), pm = (e) => e.status === "aborted", gm = (e) => e.status === "dirty", gh = (e) => e.status === "valid", mh = (e) => typeof Promise < "u" && e instanceof Promise;
function yh(e, t, r, n) {
  if (typeof t == "function" ? e !== t || !n : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function kv(e, t, r, n, s) {
  if (typeof t == "function" ? e !== t || !s : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, r), r;
}
var Bt;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Bt || (Bt = {}));
var N0, x0;
class ys {
  constructor(t, r, n, s) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const mm = (e, t) => {
  if (gh(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new gi(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function Xt(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: s } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: s } : { errorMap: (i, a) => {
    var f, d;
    const { message: c } = e;
    return i.code === "invalid_enum_value" ? { message: c ?? a.defaultError } : typeof a.data > "u" ? { message: (f = c ?? n) !== null && f !== void 0 ? f : a.defaultError } : i.code !== "invalid_type" ? { message: a.defaultError } : { message: (d = c ?? r) !== null && d !== void 0 ? d : a.defaultError };
  }, description: s };
}
class ir {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return ja(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: ja(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Tn(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: ja(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (mh(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const s = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ja(t)
    }, i = this._parseSync({ data: t, path: s.path, parent: s });
    return mm(s, i);
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ja(t)
    }, s = this._parse({ data: t, path: n.path, parent: n }), i = await (mh(s) ? s : Promise.resolve(s));
    return mm(n, i);
  }
  refine(t, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, i) => {
      const a = t(s), f = () => i.addIssue({
        code: nt.custom,
        ...n(s)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((d) => d ? !0 : (f(), !1)) : a ? !0 : (f(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, s) => t(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(t) {
    return new Ys({
      schema: this,
      typeName: Gt.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return Ks.create(this, this._def);
  }
  nullable() {
    return eu.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ps.create(this, this._def);
  }
  promise() {
    return Z0.create(this, this._def);
  }
  or(t) {
    return vh.create([this, t], this._def);
  }
  and(t) {
    return Ah.create(this, t, this._def);
  }
  transform(t) {
    return new Ys({
      ...Xt(this._def),
      schema: this,
      typeName: Gt.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new xh({
      ...Xt(this._def),
      innerType: this,
      defaultValue: r,
      typeName: Gt.ZodDefault
    });
  }
  brand() {
    return new Rv({
      typeName: Gt.ZodBranded,
      type: this,
      ...Xt(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Th({
      ...Xt(this._def),
      innerType: this,
      catchValue: r,
      typeName: Gt.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Wh.create(this, t);
  }
  readonly() {
    return kh.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const QP = /^c[^\s-]{8,}$/i, ZP = /^[0-9a-z]+$/, YP = /^[0-9A-HJKMNP-TV-Z]{26}$/, XP = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, eO = /^[a-z0-9_-]{21}$/i, tO = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, rO = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, nO = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Bf;
const iO = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, sO = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, oO = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Sv = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", aO = new RegExp(`^${Sv}$`);
function Mv(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function uO(e) {
  return new RegExp(`^${Mv(e)}$`);
}
function cO(e) {
  let t = `${Sv}T${Mv(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function lO(e, t) {
  return !!((t === "v4" || !t) && iO.test(e) || (t === "v6" || !t) && sO.test(e));
}
class qs extends ir {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== bt.string) {
      const s = this._getOrReturnCtx(t);
      return ft(s, {
        code: nt.invalid_type,
        expected: bt.string,
        received: s.parsedType
      }), Kt;
    }
    const r = new Tn();
    let n;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (n = this._getOrReturnCtx(t, n), ft(n, {
          code: nt.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (n = this._getOrReturnCtx(t, n), ft(n, {
          code: nt.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, a = t.data.length < s.value;
        (i || a) && (n = this._getOrReturnCtx(t, n), i ? ft(n, {
          code: nt.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : a && ft(n, {
          code: nt.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), r.dirty());
      } else if (s.kind === "email")
        rO.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "email",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "emoji")
        Bf || (Bf = new RegExp(nO, "u")), Bf.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "emoji",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "uuid")
        XP.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "uuid",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "nanoid")
        eO.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "nanoid",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid")
        QP.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "cuid",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid2")
        ZP.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "cuid2",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "ulid")
        YP.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "ulid",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          n = this._getOrReturnCtx(t, n), ft(n, {
            validation: "url",
            code: nt.invalid_string,
            message: s.message
          }), r.dirty();
        }
      else
        s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "regex",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (n = this._getOrReturnCtx(t, n), ft(n, {
          code: nt.invalid_string,
          validation: { includes: s.value, position: s.position },
          message: s.message
        }), r.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (n = this._getOrReturnCtx(t, n), ft(n, {
          code: nt.invalid_string,
          validation: { startsWith: s.value },
          message: s.message
        }), r.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (n = this._getOrReturnCtx(t, n), ft(n, {
          code: nt.invalid_string,
          validation: { endsWith: s.value },
          message: s.message
        }), r.dirty()) : s.kind === "datetime" ? cO(s).test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          code: nt.invalid_string,
          validation: "datetime",
          message: s.message
        }), r.dirty()) : s.kind === "date" ? aO.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          code: nt.invalid_string,
          validation: "date",
          message: s.message
        }), r.dirty()) : s.kind === "time" ? uO(s).test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          code: nt.invalid_string,
          validation: "time",
          message: s.message
        }), r.dirty()) : s.kind === "duration" ? tO.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "duration",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty()) : s.kind === "ip" ? lO(t.data, s.version) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "ip",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty()) : s.kind === "base64" ? oO.test(t.data) || (n = this._getOrReturnCtx(t, n), ft(n, {
          validation: "base64",
          code: nt.invalid_string,
          message: s.message
        }), r.dirty()) : yr.assertNever(s);
    return { status: r.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((s) => t.test(s), {
      validation: r,
      code: nt.invalid_string,
      ...Bt.errToObj(n)
    });
  }
  _addCheck(t) {
    return new qs({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Bt.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Bt.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Bt.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Bt.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Bt.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Bt.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Bt.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Bt.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Bt.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Bt.errToObj(t) });
  }
  datetime(t) {
    var r, n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      local: (n = t == null ? void 0 : t.local) !== null && n !== void 0 ? n : !1,
      ...Bt.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...Bt.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Bt.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Bt.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...Bt.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Bt.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Bt.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Bt.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Bt.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Bt.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, Bt.errToObj(t));
  }
  trim() {
    return new qs({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new qs({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new qs({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
qs.create = (e) => {
  var t;
  return new qs({
    checks: [],
    typeName: Gt.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Xt(e)
  });
};
function dO(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, s = r > n ? r : n, i = parseInt(e.toFixed(s).replace(".", "")), a = parseInt(t.toFixed(s).replace(".", ""));
  return i % a / Math.pow(10, s);
}
class Wu extends ir {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== bt.number) {
      const s = this._getOrReturnCtx(t);
      return ft(s, {
        code: nt.invalid_type,
        expected: bt.number,
        received: s.parsedType
      }), Kt;
    }
    let r;
    const n = new Tn();
    for (const s of this._def.checks)
      s.kind === "int" ? yr.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), ft(r, {
        code: nt.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), n.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (r = this._getOrReturnCtx(t, r), ft(r, {
        code: nt.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), n.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (r = this._getOrReturnCtx(t, r), ft(r, {
        code: nt.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), n.dirty()) : s.kind === "multipleOf" ? dO(t.data, s.value) !== 0 && (r = this._getOrReturnCtx(t, r), ft(r, {
        code: nt.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), n.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), ft(r, {
        code: nt.not_finite,
        message: s.message
      }), n.dirty()) : yr.assertNever(s);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Bt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Bt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Bt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Bt.toString(r));
  }
  setLimit(t, r, n, s) {
    return new Wu({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Bt.toString(s)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Wu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Bt.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Bt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Bt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Bt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Bt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Bt.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Bt.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Bt.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Bt.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && yr.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
Wu.create = (e) => new Wu({
  checks: [],
  typeName: Gt.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Xt(e)
});
class Gu extends ir {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== bt.bigint) {
      const s = this._getOrReturnCtx(t);
      return ft(s, {
        code: nt.invalid_type,
        expected: bt.bigint,
        received: s.parsedType
      }), Kt;
    }
    let r;
    const n = new Tn();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (r = this._getOrReturnCtx(t, r), ft(r, {
        code: nt.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), n.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (r = this._getOrReturnCtx(t, r), ft(r, {
        code: nt.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), n.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), ft(r, {
        code: nt.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), n.dirty()) : yr.assertNever(s);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Bt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Bt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Bt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Bt.toString(r));
  }
  setLimit(t, r, n, s) {
    return new Gu({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Bt.toString(s)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Gu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Bt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Bt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Bt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Bt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Bt.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Gu.create = (e) => {
  var t;
  return new Gu({
    checks: [],
    typeName: Gt.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Xt(e)
  });
};
class Ap extends ir {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== bt.boolean) {
      const r = this._getOrReturnCtx(t);
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.boolean,
        received: r.parsedType
      }), Kt;
    }
    return _n(t.data);
  }
}
Ap.create = (e) => new Ap({
  typeName: Gt.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Xt(e)
});
class Q0 extends ir {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== bt.date) {
      const s = this._getOrReturnCtx(t);
      return ft(s, {
        code: nt.invalid_type,
        expected: bt.date,
        received: s.parsedType
      }), Kt;
    }
    if (isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return ft(s, {
        code: nt.invalid_date
      }), Kt;
    }
    const r = new Tn();
    let n;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (n = this._getOrReturnCtx(t, n), ft(n, {
        code: nt.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), r.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (n = this._getOrReturnCtx(t, n), ft(n, {
        code: nt.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), r.dirty()) : yr.assertNever(s);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Q0({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Bt.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Bt.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
Q0.create = (e) => new Q0({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Gt.ZodDate,
  ...Xt(e)
});
class Ep extends ir {
  _parse(t) {
    if (this._getType(t) !== bt.symbol) {
      const r = this._getOrReturnCtx(t);
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.symbol,
        received: r.parsedType
      }), Kt;
    }
    return _n(t.data);
  }
}
Ep.create = (e) => new Ep({
  typeName: Gt.ZodSymbol,
  ...Xt(e)
});
class bh extends ir {
  _parse(t) {
    if (this._getType(t) !== bt.undefined) {
      const r = this._getOrReturnCtx(t);
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.undefined,
        received: r.parsedType
      }), Kt;
    }
    return _n(t.data);
  }
}
bh.create = (e) => new bh({
  typeName: Gt.ZodUndefined,
  ...Xt(e)
});
class wh extends ir {
  _parse(t) {
    if (this._getType(t) !== bt.null) {
      const r = this._getOrReturnCtx(t);
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.null,
        received: r.parsedType
      }), Kt;
    }
    return _n(t.data);
  }
}
wh.create = (e) => new wh({
  typeName: Gt.ZodNull,
  ...Xt(e)
});
class Pp extends ir {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return _n(t.data);
  }
}
Pp.create = (e) => new Pp({
  typeName: Gt.ZodAny,
  ...Xt(e)
});
class Mu extends ir {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return _n(t.data);
  }
}
Mu.create = (e) => new Mu({
  typeName: Gt.ZodUnknown,
  ...Xt(e)
});
class Mo extends ir {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return ft(r, {
      code: nt.invalid_type,
      expected: bt.never,
      received: r.parsedType
    }), Kt;
  }
}
Mo.create = (e) => new Mo({
  typeName: Gt.ZodNever,
  ...Xt(e)
});
class Op extends ir {
  _parse(t) {
    if (this._getType(t) !== bt.undefined) {
      const r = this._getOrReturnCtx(t);
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.void,
        received: r.parsedType
      }), Kt;
    }
    return _n(t.data);
  }
}
Op.create = (e) => new Op({
  typeName: Gt.ZodVoid,
  ...Xt(e)
});
class ps extends ir {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), s = this._def;
    if (r.parsedType !== bt.array)
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.array,
        received: r.parsedType
      }), Kt;
    if (s.exactLength !== null) {
      const a = r.data.length > s.exactLength.value, f = r.data.length < s.exactLength.value;
      (a || f) && (ft(r, {
        code: a ? nt.too_big : nt.too_small,
        minimum: f ? s.exactLength.value : void 0,
        maximum: a ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (ft(r, {
      code: nt.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (ft(r, {
      code: nt.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((a, f) => s.type._parseAsync(new ys(r, a, r.path, f)))).then((a) => Tn.mergeArray(n, a));
    const i = [...r.data].map((a, f) => s.type._parseSync(new ys(r, a, r.path, f)));
    return Tn.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new ps({
      ...this._def,
      minLength: { value: t, message: Bt.toString(r) }
    });
  }
  max(t, r) {
    return new ps({
      ...this._def,
      maxLength: { value: t, message: Bt.toString(r) }
    });
  }
  length(t, r) {
    return new ps({
      ...this._def,
      exactLength: { value: t, message: Bt.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
ps.create = (e, t) => new ps({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Gt.ZodArray,
  ...Xt(t)
});
function pu(e) {
  if (e instanceof jr) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = Ks.create(pu(n));
    }
    return new jr({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof ps ? new ps({
      ...e._def,
      type: pu(e.element)
    }) : e instanceof Ks ? Ks.create(pu(e.unwrap())) : e instanceof eu ? eu.create(pu(e.unwrap())) : e instanceof Zs ? Zs.create(e.items.map((t) => pu(t))) : e;
}
class jr extends ir {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = yr.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== bt.object) {
      const d = this._getOrReturnCtx(t);
      return ft(d, {
        code: nt.invalid_type,
        expected: bt.object,
        received: d.parsedType
      }), Kt;
    }
    const { status: r, ctx: n } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof Mo && this._def.unknownKeys === "strip"))
      for (const d in n.data)
        i.includes(d) || a.push(d);
    const f = [];
    for (const d of i) {
      const c = s[d], p = n.data[d];
      f.push({
        key: { status: "valid", value: d },
        value: c._parse(new ys(n, p, n.path, d)),
        alwaysSet: d in n.data
      });
    }
    if (this._def.catchall instanceof Mo) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const c of a)
          f.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: n.data[c] }
          });
      else if (d === "strict")
        a.length > 0 && (ft(n, {
          code: nt.unrecognized_keys,
          keys: a
        }), r.dirty());
      else if (d !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const c of a) {
        const p = n.data[c];
        f.push({
          key: { status: "valid", value: c },
          value: d._parse(
            new ys(n, p, n.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const c of f) {
        const p = await c.key, g = await c.value;
        d.push({
          key: p,
          value: g,
          alwaysSet: c.alwaysSet
        });
      }
      return d;
    }).then((d) => Tn.mergeObjectSync(r, d)) : Tn.mergeObjectSync(r, f);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Bt.errToObj, new jr({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var s, i, a, f;
          const d = (a = (i = (s = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(s, r, n).message) !== null && a !== void 0 ? a : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (f = Bt.errToObj(t).message) !== null && f !== void 0 ? f : d
          } : {
            message: d
          };
        }
      } : {}
    });
  }
  strip() {
    return new jr({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new jr({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new jr({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new jr({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Gt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new jr({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return yr.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new jr({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return yr.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new jr({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return pu(this);
  }
  partial(t) {
    const r = {};
    return yr.objectKeys(this.shape).forEach((n) => {
      const s = this.shape[n];
      t && !t[n] ? r[n] = s : r[n] = s.optional();
    }), new jr({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return yr.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof Ks; )
          s = s._def.innerType;
        r[n] = s;
      }
    }), new jr({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Iv(yr.objectKeys(this.shape));
  }
}
jr.create = (e, t) => new jr({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Mo.create(),
  typeName: Gt.ZodObject,
  ...Xt(t)
});
jr.strictCreate = (e, t) => new jr({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Mo.create(),
  typeName: Gt.ZodObject,
  ...Xt(t)
});
jr.lazycreate = (e, t) => new jr({
  shape: e,
  unknownKeys: "strip",
  catchall: Mo.create(),
  typeName: Gt.ZodObject,
  ...Xt(t)
});
class vh extends ir {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function s(i) {
      for (const f of i)
        if (f.result.status === "valid")
          return f.result;
      for (const f of i)
        if (f.result.status === "dirty")
          return r.common.issues.push(...f.ctx.common.issues), f.result;
      const a = i.map((f) => new gi(f.ctx.common.issues));
      return ft(r, {
        code: nt.invalid_union,
        unionErrors: a
      }), Kt;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const a = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: a
          }),
          ctx: a
        };
      })).then(s);
    {
      let i;
      const a = [];
      for (const d of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, p = d._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (p.status === "valid")
          return p;
        p.status === "dirty" && !i && (i = { result: p, ctx: c }), c.common.issues.length && a.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const f = a.map((d) => new gi(d));
      return ft(r, {
        code: nt.invalid_union,
        unionErrors: f
      }), Kt;
    }
  }
  get options() {
    return this._def.options;
  }
}
vh.create = (e, t) => new vh({
  options: e,
  typeName: Gt.ZodUnion,
  ...Xt(t)
});
const ao = (e) => e instanceof Ph ? ao(e.schema) : e instanceof Ys ? ao(e.innerType()) : e instanceof Oh ? [e.value] : e instanceof Xa ? e.options : e instanceof Nh ? yr.objectValues(e.enum) : e instanceof xh ? ao(e._def.innerType) : e instanceof bh ? [void 0] : e instanceof wh ? [null] : e instanceof Ks ? [void 0, ...ao(e.unwrap())] : e instanceof eu ? [null, ...ao(e.unwrap())] : e instanceof Rv || e instanceof kh ? ao(e.unwrap()) : e instanceof Th ? ao(e._def.innerType) : [];
class l1 extends ir {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== bt.object)
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.object,
        received: r.parsedType
      }), Kt;
    const n = this.discriminator, s = r.data[n], i = this.optionsMap.get(s);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (ft(r, {
      code: nt.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Kt);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const s = /* @__PURE__ */ new Map();
    for (const i of r) {
      const a = ao(i.shape[t]);
      if (!a.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const f of a) {
        if (s.has(f))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(f)}`);
        s.set(f, i);
      }
    }
    return new l1({
      typeName: Gt.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: s,
      ...Xt(n)
    });
  }
}
function Np(e, t) {
  const r = ja(e), n = ja(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === bt.object && n === bt.object) {
    const s = yr.objectKeys(t), i = yr.objectKeys(e).filter((f) => s.indexOf(f) !== -1), a = { ...e, ...t };
    for (const f of i) {
      const d = Np(e[f], t[f]);
      if (!d.valid)
        return { valid: !1 };
      a[f] = d.data;
    }
    return { valid: !0, data: a };
  } else if (r === bt.array && n === bt.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const a = e[i], f = t[i], d = Np(a, f);
      if (!d.valid)
        return { valid: !1 };
      s.push(d.data);
    }
    return { valid: !0, data: s };
  } else
    return r === bt.date && n === bt.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Ah extends ir {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), s = (i, a) => {
      if (pm(i) || pm(a))
        return Kt;
      const f = Np(i.value, a.value);
      return f.valid ? ((gm(i) || gm(a)) && r.dirty(), { status: r.value, value: f.data }) : (ft(n, {
        code: nt.invalid_intersection_types
      }), Kt);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, a]) => s(i, a)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Ah.create = (e, t, r) => new Ah({
  left: e,
  right: t,
  typeName: Gt.ZodIntersection,
  ...Xt(r)
});
class Zs extends ir {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== bt.array)
      return ft(n, {
        code: nt.invalid_type,
        expected: bt.array,
        received: n.parsedType
      }), Kt;
    if (n.data.length < this._def.items.length)
      return ft(n, {
        code: nt.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Kt;
    !this._def.rest && n.data.length > this._def.items.length && (ft(n, {
      code: nt.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, a) => {
      const f = this._def.items[a] || this._def.rest;
      return f ? f._parse(new ys(n, i, n.path, a)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => Tn.mergeArray(r, i)) : Tn.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Zs({
      ...this._def,
      rest: t
    });
  }
}
Zs.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Zs({
    items: e,
    typeName: Gt.ZodTuple,
    rest: null,
    ...Xt(t)
  });
};
class Eh extends ir {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== bt.object)
      return ft(n, {
        code: nt.invalid_type,
        expected: bt.object,
        received: n.parsedType
      }), Kt;
    const s = [], i = this._def.keyType, a = this._def.valueType;
    for (const f in n.data)
      s.push({
        key: i._parse(new ys(n, f, n.path, f)),
        value: a._parse(new ys(n, n.data[f], n.path, f)),
        alwaysSet: f in n.data
      });
    return n.common.async ? Tn.mergeObjectAsync(r, s) : Tn.mergeObjectSync(r, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof ir ? new Eh({
      keyType: t,
      valueType: r,
      typeName: Gt.ZodRecord,
      ...Xt(n)
    }) : new Eh({
      keyType: qs.create(),
      valueType: t,
      typeName: Gt.ZodRecord,
      ...Xt(r)
    });
  }
}
class xp extends ir {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== bt.map)
      return ft(n, {
        code: nt.invalid_type,
        expected: bt.map,
        received: n.parsedType
      }), Kt;
    const s = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([f, d], c) => ({
      key: s._parse(new ys(n, f, n.path, [c, "key"])),
      value: i._parse(new ys(n, d, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const f = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of a) {
          const c = await d.key, p = await d.value;
          if (c.status === "aborted" || p.status === "aborted")
            return Kt;
          (c.status === "dirty" || p.status === "dirty") && r.dirty(), f.set(c.value, p.value);
        }
        return { status: r.value, value: f };
      });
    } else {
      const f = /* @__PURE__ */ new Map();
      for (const d of a) {
        const c = d.key, p = d.value;
        if (c.status === "aborted" || p.status === "aborted")
          return Kt;
        (c.status === "dirty" || p.status === "dirty") && r.dirty(), f.set(c.value, p.value);
      }
      return { status: r.value, value: f };
    }
  }
}
xp.create = (e, t, r) => new xp({
  valueType: t,
  keyType: e,
  typeName: Gt.ZodMap,
  ...Xt(r)
});
class zu extends ir {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== bt.set)
      return ft(n, {
        code: nt.invalid_type,
        expected: bt.set,
        received: n.parsedType
      }), Kt;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (ft(n, {
      code: nt.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (ft(n, {
      code: nt.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function a(d) {
      const c = /* @__PURE__ */ new Set();
      for (const p of d) {
        if (p.status === "aborted")
          return Kt;
        p.status === "dirty" && r.dirty(), c.add(p.value);
      }
      return { status: r.value, value: c };
    }
    const f = [...n.data.values()].map((d, c) => i._parse(new ys(n, d, n.path, c)));
    return n.common.async ? Promise.all(f).then((d) => a(d)) : a(f);
  }
  min(t, r) {
    return new zu({
      ...this._def,
      minSize: { value: t, message: Bt.toString(r) }
    });
  }
  max(t, r) {
    return new zu({
      ...this._def,
      maxSize: { value: t, message: Bt.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
zu.create = (e, t) => new zu({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Gt.ZodSet,
  ...Xt(t)
});
class _0 extends ir {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== bt.function)
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.function,
        received: r.parsedType
      }), Kt;
    function n(f, d) {
      return wp({
        data: f,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          bp(),
          J0
        ].filter((c) => !!c),
        issueData: {
          code: nt.invalid_arguments,
          argumentsError: d
        }
      });
    }
    function s(f, d) {
      return wp({
        data: f,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          bp(),
          J0
        ].filter((c) => !!c),
        issueData: {
          code: nt.invalid_return_type,
          returnTypeError: d
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, a = r.data;
    if (this._def.returns instanceof Z0) {
      const f = this;
      return _n(async function(...d) {
        const c = new gi([]), p = await f._def.args.parseAsync(d, i).catch((v) => {
          throw c.addIssue(n(d, v)), c;
        }), g = await Reflect.apply(a, this, p);
        return await f._def.returns._def.type.parseAsync(g, i).catch((v) => {
          throw c.addIssue(s(g, v)), c;
        });
      });
    } else {
      const f = this;
      return _n(function(...d) {
        const c = f._def.args.safeParse(d, i);
        if (!c.success)
          throw new gi([n(d, c.error)]);
        const p = Reflect.apply(a, this, c.data), g = f._def.returns.safeParse(p, i);
        if (!g.success)
          throw new gi([s(p, g.error)]);
        return g.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new _0({
      ...this._def,
      args: Zs.create(t).rest(Mu.create())
    });
  }
  returns(t) {
    return new _0({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, n) {
    return new _0({
      args: t || Zs.create([]).rest(Mu.create()),
      returns: r || Mu.create(),
      typeName: Gt.ZodFunction,
      ...Xt(n)
    });
  }
}
class Ph extends ir {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Ph.create = (e, t) => new Ph({
  getter: e,
  typeName: Gt.ZodLazy,
  ...Xt(t)
});
class Oh extends ir {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return ft(r, {
        received: r.data,
        code: nt.invalid_literal,
        expected: this._def.value
      }), Kt;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Oh.create = (e, t) => new Oh({
  value: e,
  typeName: Gt.ZodLiteral,
  ...Xt(t)
});
function Iv(e, t) {
  return new Xa({
    values: e,
    typeName: Gt.ZodEnum,
    ...Xt(t)
  });
}
class Xa extends ir {
  constructor() {
    super(...arguments), N0.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return ft(r, {
        expected: yr.joinValues(n),
        received: r.parsedType,
        code: nt.invalid_type
      }), Kt;
    }
    if (yh(this, N0) || kv(this, N0, new Set(this._def.values)), !yh(this, N0).has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return ft(r, {
        received: r.data,
        code: nt.invalid_enum_value,
        options: n
      }), Kt;
    }
    return _n(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Xa.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Xa.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
N0 = /* @__PURE__ */ new WeakMap();
Xa.create = Iv;
class Nh extends ir {
  constructor() {
    super(...arguments), x0.set(this, void 0);
  }
  _parse(t) {
    const r = yr.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== bt.string && n.parsedType !== bt.number) {
      const s = yr.objectValues(r);
      return ft(n, {
        expected: yr.joinValues(s),
        received: n.parsedType,
        code: nt.invalid_type
      }), Kt;
    }
    if (yh(this, x0) || kv(this, x0, new Set(yr.getValidEnumValues(this._def.values))), !yh(this, x0).has(t.data)) {
      const s = yr.objectValues(r);
      return ft(n, {
        received: n.data,
        code: nt.invalid_enum_value,
        options: s
      }), Kt;
    }
    return _n(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
x0 = /* @__PURE__ */ new WeakMap();
Nh.create = (e, t) => new Nh({
  values: e,
  typeName: Gt.ZodNativeEnum,
  ...Xt(t)
});
class Z0 extends ir {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== bt.promise && r.common.async === !1)
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.promise,
        received: r.parsedType
      }), Kt;
    const n = r.parsedType === bt.promise ? r.data : Promise.resolve(r.data);
    return _n(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
Z0.create = (e, t) => new Z0({
  type: e,
  typeName: Gt.ZodPromise,
  ...Xt(t)
});
class Ys extends ir {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Gt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), s = this._def.effect || null, i = {
      addIssue: (a) => {
        ft(n, a), a.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const a = s.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(a).then(async (f) => {
          if (r.value === "aborted")
            return Kt;
          const d = await this._def.schema._parseAsync({
            data: f,
            path: n.path,
            parent: n
          });
          return d.status === "aborted" ? Kt : d.status === "dirty" || r.value === "dirty" ? vp(d.value) : d;
        });
      {
        if (r.value === "aborted")
          return Kt;
        const f = this._def.schema._parseSync({
          data: a,
          path: n.path,
          parent: n
        });
        return f.status === "aborted" ? Kt : f.status === "dirty" || r.value === "dirty" ? vp(f.value) : f;
      }
    }
    if (s.type === "refinement") {
      const a = (f) => {
        const d = s.refinement(f, i);
        if (n.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return f;
      };
      if (n.common.async === !1) {
        const f = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return f.status === "aborted" ? Kt : (f.status === "dirty" && r.dirty(), a(f.value), { status: r.value, value: f.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((f) => f.status === "aborted" ? Kt : (f.status === "dirty" && r.dirty(), a(f.value).then(() => ({ status: r.value, value: f.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!gh(a))
          return a;
        const f = s.transform(a.value, i);
        if (f instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: f };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => gh(a) ? Promise.resolve(s.transform(a.value, i)).then((f) => ({ status: r.value, value: f })) : a);
    yr.assertNever(s);
  }
}
Ys.create = (e, t, r) => new Ys({
  schema: e,
  typeName: Gt.ZodEffects,
  effect: t,
  ...Xt(r)
});
Ys.createWithPreprocess = (e, t, r) => new Ys({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Gt.ZodEffects,
  ...Xt(r)
});
class Ks extends ir {
  _parse(t) {
    return this._getType(t) === bt.undefined ? _n(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ks.create = (e, t) => new Ks({
  innerType: e,
  typeName: Gt.ZodOptional,
  ...Xt(t)
});
class eu extends ir {
  _parse(t) {
    return this._getType(t) === bt.null ? _n(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
eu.create = (e, t) => new eu({
  innerType: e,
  typeName: Gt.ZodNullable,
  ...Xt(t)
});
class xh extends ir {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === bt.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
xh.create = (e, t) => new xh({
  innerType: e,
  typeName: Gt.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Xt(t)
});
class Th extends ir {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return mh(s) ? s.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new gi(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new gi(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Th.create = (e, t) => new Th({
  innerType: e,
  typeName: Gt.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Xt(t)
});
class Tp extends ir {
  _parse(t) {
    if (this._getType(t) !== bt.nan) {
      const r = this._getOrReturnCtx(t);
      return ft(r, {
        code: nt.invalid_type,
        expected: bt.nan,
        received: r.parsedType
      }), Kt;
    }
    return { status: "valid", value: t.data };
  }
}
Tp.create = (e) => new Tp({
  typeName: Gt.ZodNaN,
  ...Xt(e)
});
class Rv extends ir {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Wh extends ir {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Kt : s.status === "dirty" ? (r.dirty(), vp(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? Kt : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new Wh({
      in: t,
      out: r,
      typeName: Gt.ZodPipeline
    });
  }
}
class kh extends ir {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (s) => (gh(s) && (s.value = Object.freeze(s.value)), s);
    return mh(r) ? r.then((s) => n(s)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
kh.create = (e, t) => new kh({
  innerType: e,
  typeName: Gt.ZodReadonly,
  ...Xt(t)
});
jr.lazycreate;
var Gt;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Gt || (Gt = {}));
qs.create;
Wu.create;
Tp.create;
Gu.create;
Ap.create;
Q0.create;
Ep.create;
bh.create;
wh.create;
Pp.create;
Mu.create;
Mo.create;
Op.create;
ps.create;
jr.create;
jr.strictCreate;
vh.create;
l1.create;
Ah.create;
Zs.create;
Eh.create;
xp.create;
zu.create;
_0.create;
Ph.create;
Oh.create;
Xa.create;
Nh.create;
Z0.create;
Ys.create;
Ks.create;
eu.create;
Ys.createWithPreprocess;
Wh.create;
var hO = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function s(d, c, p) {
    this.fn = d, this.context = c, this.once = p || !1;
  }
  function i(d, c, p, g, v) {
    if (typeof p != "function")
      throw new TypeError("The listener must be a function");
    var O = new s(p, g || d, v), N = r ? r + c : c;
    return d._events[N] ? d._events[N].fn ? d._events[N] = [d._events[N], O] : d._events[N].push(O) : (d._events[N] = O, d._eventsCount++), d;
  }
  function a(d, c) {
    --d._eventsCount === 0 ? d._events = new n() : delete d._events[c];
  }
  function f() {
    this._events = new n(), this._eventsCount = 0;
  }
  f.prototype.eventNames = function() {
    var d = [], c, p;
    if (this._eventsCount === 0)
      return d;
    for (p in c = this._events)
      t.call(c, p) && d.push(r ? p.slice(1) : p);
    return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(c)) : d;
  }, f.prototype.listeners = function(d) {
    var c = r ? r + d : d, p = this._events[c];
    if (!p)
      return [];
    if (p.fn)
      return [p.fn];
    for (var g = 0, v = p.length, O = new Array(v); g < v; g++)
      O[g] = p[g].fn;
    return O;
  }, f.prototype.listenerCount = function(d) {
    var c = r ? r + d : d, p = this._events[c];
    return p ? p.fn ? 1 : p.length : 0;
  }, f.prototype.emit = function(d, c, p, g, v, O) {
    var N = r ? r + d : d;
    if (!this._events[N])
      return !1;
    var S = this._events[N], j = arguments.length, B, M;
    if (S.fn) {
      switch (S.once && this.removeListener(d, S.fn, void 0, !0), j) {
        case 1:
          return S.fn.call(S.context), !0;
        case 2:
          return S.fn.call(S.context, c), !0;
        case 3:
          return S.fn.call(S.context, c, p), !0;
        case 4:
          return S.fn.call(S.context, c, p, g), !0;
        case 5:
          return S.fn.call(S.context, c, p, g, v), !0;
        case 6:
          return S.fn.call(S.context, c, p, g, v, O), !0;
      }
      for (M = 1, B = new Array(j - 1); M < j; M++)
        B[M - 1] = arguments[M];
      S.fn.apply(S.context, B);
    } else {
      var I = S.length, A;
      for (M = 0; M < I; M++)
        switch (S[M].once && this.removeListener(d, S[M].fn, void 0, !0), j) {
          case 1:
            S[M].fn.call(S[M].context);
            break;
          case 2:
            S[M].fn.call(S[M].context, c);
            break;
          case 3:
            S[M].fn.call(S[M].context, c, p);
            break;
          case 4:
            S[M].fn.call(S[M].context, c, p, g);
            break;
          default:
            if (!B)
              for (A = 1, B = new Array(j - 1); A < j; A++)
                B[A - 1] = arguments[A];
            S[M].fn.apply(S[M].context, B);
        }
    }
    return !0;
  }, f.prototype.on = function(d, c, p) {
    return i(this, d, c, p, !1);
  }, f.prototype.once = function(d, c, p) {
    return i(this, d, c, p, !0);
  }, f.prototype.removeListener = function(d, c, p, g) {
    var v = r ? r + d : d;
    if (!this._events[v])
      return this;
    if (!c)
      return a(this, v), this;
    var O = this._events[v];
    if (O.fn)
      O.fn === c && (!g || O.once) && (!p || O.context === p) && a(this, v);
    else {
      for (var N = 0, S = [], j = O.length; N < j; N++)
        (O[N].fn !== c || g && !O[N].once || p && O[N].context !== p) && S.push(O[N]);
      S.length ? this._events[v] = S.length === 1 ? S[0] : S : a(this, v);
    }
    return this;
  }, f.prototype.removeAllListeners = function(d) {
    var c;
    return d ? (c = r ? r + d : d, this._events[c] && a(this, c)) : (this._events = new n(), this._eventsCount = 0), this;
  }, f.prototype.off = f.prototype.removeListener, f.prototype.addListener = f.prototype.on, f.prefixed = r, f.EventEmitter = f, e.exports = f;
})(hO);
function Cv(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: fO } = Object.prototype, { getPrototypeOf: d1 } = Object, Gh = /* @__PURE__ */ ((e) => (t) => {
  const r = fO.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), bs = (e) => (e = e.toLowerCase(), (t) => Gh(t) === e), zh = (e) => (t) => typeof t === e, { isArray: oc } = Array, Y0 = zh("undefined");
function pO(e) {
  return e !== null && !Y0(e) && e.constructor !== null && !Y0(e.constructor) && mi(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Bv = bs("ArrayBuffer");
function gO(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Bv(e.buffer), t;
}
const mO = zh("string"), mi = zh("function"), _v = zh("number"), Vh = (e) => e !== null && typeof e == "object", yO = (e) => e === !0 || e === !1, Zd = (e) => {
  if (Gh(e) !== "object")
    return !1;
  const t = d1(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, bO = bs("Date"), wO = bs("File"), vO = bs("Blob"), AO = bs("FileList"), EO = (e) => Vh(e) && mi(e.pipe), PO = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || mi(e.append) && ((t = Gh(e)) === "formdata" || // detect form-data instance
  t === "object" && mi(e.toString) && e.toString() === "[object FormData]"));
}, OO = bs("URLSearchParams"), NO = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function cd(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), oc(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let f;
    for (n = 0; n < a; n++)
      f = i[n], t.call(null, e[f], f, e);
  }
}
function Fv(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const Uv = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Dv = (e) => !Y0(e) && e !== Uv;
function kp() {
  const { caseless: e } = Dv(this) && this || {}, t = {}, r = (n, s) => {
    const i = e && Fv(t, s) || s;
    Zd(t[i]) && Zd(n) ? t[i] = kp(t[i], n) : Zd(n) ? t[i] = kp({}, n) : oc(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && cd(arguments[n], r);
  return t;
}
const xO = (e, t, r, { allOwnKeys: n } = {}) => (cd(t, (s, i) => {
  r && mi(s) ? e[i] = Cv(s, r) : e[i] = s;
}, { allOwnKeys: n }), e), TO = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), kO = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, SO = (e, t, r, n) => {
  let s, i, a;
  const f = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      a = s[i], (!n || n(a, e, t)) && !f[a] && (t[a] = e[a], f[a] = !0);
    e = r !== !1 && d1(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, MO = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, IO = (e) => {
  if (!e)
    return null;
  if (oc(e))
    return e;
  let t = e.length;
  if (!_v(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, RO = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && d1(Uint8Array)), CO = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let n;
  for (; (n = r.next()) && !n.done; ) {
    const s = n.value;
    t.call(e, s[0], s[1]);
  }
}, BO = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, _O = bs("HTMLFormElement"), FO = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, n) {
    return r.toUpperCase() + n;
  }
), ym = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), UO = bs("RegExp"), jv = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  cd(r, (s, i) => {
    let a;
    (a = t(s, i, e)) !== !1 && (n[i] = a || s);
  }), Object.defineProperties(e, n);
}, DO = (e) => {
  jv(e, (t, r) => {
    if (mi(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (mi(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, jO = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((i) => {
      r[i] = !0;
    });
  };
  return oc(e) ? n(e) : n(String(e).split(t)), r;
}, LO = () => {
}, HO = (e, t) => (e = +e, Number.isFinite(e) ? e : t), _f = "abcdefghijklmnopqrstuvwxyz", bm = "0123456789", Lv = {
  DIGIT: bm,
  ALPHA: _f,
  ALPHA_DIGIT: _f + _f.toUpperCase() + bm
}, WO = (e = 16, t = Lv.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function GO(e) {
  return !!(e && mi(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const zO = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (Vh(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[s] = n;
        const i = oc(n) ? [] : {};
        return cd(n, (a, f) => {
          const d = r(a, s + 1);
          !Y0(d) && (i[f] = d);
        }), t[s] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, VO = bs("AsyncFunction"), qO = (e) => e && (Vh(e) || mi(e)) && mi(e.then) && mi(e.catch), $e = {
  isArray: oc,
  isArrayBuffer: Bv,
  isBuffer: pO,
  isFormData: PO,
  isArrayBufferView: gO,
  isString: mO,
  isNumber: _v,
  isBoolean: yO,
  isObject: Vh,
  isPlainObject: Zd,
  isUndefined: Y0,
  isDate: bO,
  isFile: wO,
  isBlob: vO,
  isRegExp: UO,
  isFunction: mi,
  isStream: EO,
  isURLSearchParams: OO,
  isTypedArray: RO,
  isFileList: AO,
  forEach: cd,
  merge: kp,
  extend: xO,
  trim: NO,
  stripBOM: TO,
  inherits: kO,
  toFlatObject: SO,
  kindOf: Gh,
  kindOfTest: bs,
  endsWith: MO,
  toArray: IO,
  forEachEntry: CO,
  matchAll: BO,
  isHTMLForm: _O,
  hasOwnProperty: ym,
  hasOwnProp: ym,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: jv,
  freezeMethods: DO,
  toObjectSet: jO,
  toCamelCase: FO,
  noop: LO,
  toFiniteNumber: HO,
  findKey: Fv,
  global: Uv,
  isContextDefined: Dv,
  ALPHABET: Lv,
  generateString: WO,
  isSpecCompliantForm: GO,
  toJSONObject: zO,
  isAsyncFn: VO,
  isThenable: qO
};
function fr(e, t, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), s && (this.response = s);
}
$e.inherits(fr, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: $e.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Hv = fr.prototype, Wv = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Wv[e] = { value: e };
});
Object.defineProperties(fr, Wv);
Object.defineProperty(Hv, "isAxiosError", { value: !0 });
fr.from = (e, t, r, n, s, i) => {
  const a = Object.create(Hv);
  return $e.toFlatObject(e, a, function(f) {
    return f !== Error.prototype;
  }, (f) => f !== "isAxiosError"), fr.call(a, e.message, t, r, n, s), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const $O = null;
function Sp(e) {
  return $e.isPlainObject(e) || $e.isArray(e);
}
function Gv(e) {
  return $e.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function wm(e, t, r) {
  return e ? e.concat(t).map(function(n, s) {
    return n = Gv(n), !r && s ? "[" + n + "]" : n;
  }).join(r ? "." : "") : t;
}
function KO(e) {
  return $e.isArray(e) && !e.some(Sp);
}
const JO = $e.toFlatObject($e, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function qh(e, t, r) {
  if (!$e.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = $e.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(O, N) {
    return !$e.isUndefined(N[O]);
  });
  const n = r.metaTokens, s = r.visitor || c, i = r.dots, a = r.indexes, f = (r.Blob || typeof Blob < "u" && Blob) && $e.isSpecCompliantForm(t);
  if (!$e.isFunction(s))
    throw new TypeError("visitor must be a function");
  function d(O) {
    if (O === null)
      return "";
    if ($e.isDate(O))
      return O.toISOString();
    if (!f && $e.isBlob(O))
      throw new fr("Blob is not supported. Use a Buffer instead.");
    return $e.isArrayBuffer(O) || $e.isTypedArray(O) ? f && typeof Blob == "function" ? new Blob([O]) : Buffer.from(O) : O;
  }
  function c(O, N, S) {
    let j = O;
    if (O && !S && typeof O == "object") {
      if ($e.endsWith(N, "{}"))
        N = n ? N : N.slice(0, -2), O = JSON.stringify(O);
      else if ($e.isArray(O) && KO(O) || ($e.isFileList(O) || $e.endsWith(N, "[]")) && (j = $e.toArray(O)))
        return N = Gv(N), j.forEach(function(B, M) {
          !($e.isUndefined(B) || B === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? wm([N], M, i) : a === null ? N : N + "[]",
            d(B)
          );
        }), !1;
    }
    return Sp(O) ? !0 : (t.append(wm(S, N, i), d(O)), !1);
  }
  const p = [], g = Object.assign(JO, {
    defaultVisitor: c,
    convertValue: d,
    isVisitable: Sp
  });
  function v(O, N) {
    if (!$e.isUndefined(O)) {
      if (p.indexOf(O) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      p.push(O), $e.forEach(O, function(S, j) {
        (!($e.isUndefined(S) || S === null) && s.call(
          t,
          S,
          $e.isString(j) ? j.trim() : j,
          N,
          g
        )) === !0 && v(S, N ? N.concat(j) : [j]);
      }), p.pop();
    }
  }
  if (!$e.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), t;
}
function vm(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function h1(e, t) {
  this._pairs = [], e && qh(e, this, t);
}
const zv = h1.prototype;
zv.append = function(e, t) {
  this._pairs.push([e, t]);
};
zv.toString = function(e) {
  const t = e ? function(r) {
    return e.call(this, r, vm);
  } : vm;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
function QO(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Vv(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || QO, s = r && r.serialize;
  let i;
  if (s ? i = s(t, r) : i = $e.isURLSearchParams(t) ? t.toString() : new h1(t, r).toString(n), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Am {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    $e.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const qv = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, ZO = typeof URLSearchParams < "u" ? URLSearchParams : h1, YO = typeof FormData < "u" ? FormData : null, XO = typeof Blob < "u" ? Blob : null, eN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: ZO,
    FormData: YO,
    Blob: XO
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, $v = typeof window < "u" && typeof document < "u", tN = ((e) => $v && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), rN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", nN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: $v,
  hasStandardBrowserEnv: tN,
  hasStandardBrowserWebWorkerEnv: rN
}, Symbol.toStringTag, { value: "Module" })), ls = {
  ...nN,
  ...eN
};
function iN(e, t) {
  return qh(e, new ls.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, s, i) {
      return ls.isNode && $e.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function sN(e) {
  return $e.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function oN(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const s = r.length;
  let i;
  for (n = 0; n < s; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function Kv(e) {
  function t(r, n, s, i) {
    let a = r[i++];
    if (a === "__proto__")
      return !0;
    const f = Number.isFinite(+a), d = i >= r.length;
    return a = !a && $e.isArray(s) ? s.length : a, d ? ($e.hasOwnProp(s, a) ? s[a] = [s[a], n] : s[a] = n, !f) : ((!s[a] || !$e.isObject(s[a])) && (s[a] = []), t(r, n, s[a], i) && $e.isArray(s[a]) && (s[a] = oN(s[a])), !f);
  }
  if ($e.isFormData(e) && $e.isFunction(e.entries)) {
    const r = {};
    return $e.forEachEntry(e, (n, s) => {
      t(sN(n), s, r, 0);
    }), r;
  }
  return null;
}
function aN(e, t, r) {
  if ($e.isString(e))
    try {
      return (t || JSON.parse)(e), $e.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(e);
}
const ld = {
  transitional: qv,
  adapter: ["xhr", "http"],
  transformRequest: [function(e, t) {
    const r = t.getContentType() || "", n = r.indexOf("application/json") > -1, s = $e.isObject(e);
    if (s && $e.isHTMLForm(e) && (e = new FormData(e)), $e.isFormData(e))
      return n ? JSON.stringify(Kv(e)) : e;
    if ($e.isArrayBuffer(e) || $e.isBuffer(e) || $e.isStream(e) || $e.isFile(e) || $e.isBlob(e))
      return e;
    if ($e.isArrayBufferView(e))
      return e.buffer;
    if ($e.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return iN(e, this.formSerializer).toString();
      if ((i = $e.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return qh(
          i ? { "files[]": e } : e,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return s || n ? (t.setContentType("application/json", !1), aN(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || ld.transitional, r = t && t.forcedJSONParsing, n = this.responseType === "json";
    if (e && $e.isString(e) && (r && !this.responseType || n)) {
      const s = !(t && t.silentJSONParsing) && n;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (s)
          throw i.name === "SyntaxError" ? fr.from(i, fr.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ls.classes.FormData,
    Blob: ls.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
$e.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ld.headers[e] = {};
});
const uN = $e.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), cN = (e) => {
  const t = {};
  let r, n, s;
  return e && e.split(`
`).forEach(function(i) {
    s = i.indexOf(":"), r = i.substring(0, s).trim().toLowerCase(), n = i.substring(s + 1).trim(), !(!r || t[r] && uN[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Em = Symbol("internals");
function dc(e) {
  return e && String(e).trim().toLowerCase();
}
function Yd(e) {
  return e === !1 || e == null ? e : $e.isArray(e) ? e.map(Yd) : String(e);
}
function lN(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const dN = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ff(e, t, r, n, s) {
  if ($e.isFunction(n))
    return n.call(this, t, r);
  if (s && (t = r), !!$e.isString(t)) {
    if ($e.isString(n))
      return t.indexOf(n) !== -1;
    if ($e.isRegExp(n))
      return n.test(t);
  }
}
function hN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function fN(e, t) {
  const r = $e.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(s, i, a) {
        return this[n].call(this, t, s, i, a);
      },
      configurable: !0
    });
  });
}
let yi = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    const n = this;
    function s(a, f, d) {
      const c = dc(f);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const p = $e.findKey(n, c);
      (!p || n[p] === void 0 || d === !0 || d === void 0 && n[p] !== !1) && (n[p || f] = Yd(a));
    }
    const i = (a, f) => $e.forEach(a, (d, c) => s(d, c, f));
    return $e.isPlainObject(e) || e instanceof this.constructor ? i(e, t) : $e.isString(e) && (e = e.trim()) && !dN(e) ? i(cN(e), t) : e != null && s(t, e, r), this;
  }
  get(e, t) {
    if (e = dc(e), e) {
      const r = $e.findKey(this, e);
      if (r) {
        const n = this[r];
        if (!t)
          return n;
        if (t === !0)
          return lN(n);
        if ($e.isFunction(t))
          return t.call(this, n, r);
        if ($e.isRegExp(t))
          return t.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = dc(e), e) {
      const r = $e.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || Ff(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    const r = this;
    let n = !1;
    function s(i) {
      if (i = dc(i), i) {
        const a = $e.findKey(r, i);
        a && (!t || Ff(r, r[a], a, t)) && (delete r[a], n = !0);
      }
    }
    return $e.isArray(e) ? e.forEach(s) : s(e), n;
  }
  clear(e) {
    const t = Object.keys(this);
    let r = t.length, n = !1;
    for (; r--; ) {
      const s = t[r];
      (!e || Ff(this, this[s], s, e, !0)) && (delete this[s], n = !0);
    }
    return n;
  }
  normalize(e) {
    const t = this, r = {};
    return $e.forEach(this, (n, s) => {
      const i = $e.findKey(r, s);
      if (i) {
        t[i] = Yd(n), delete t[s];
        return;
      }
      const a = e ? hN(s) : String(s).trim();
      a !== s && delete t[s], t[a] = Yd(n), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return $e.forEach(this, (r, n) => {
      r != null && r !== !1 && (t[n] = e && $e.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const r = new this(e);
    return t.forEach((n) => r.set(n)), r;
  }
  static accessor(e) {
    const t = (this[Em] = this[Em] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function n(s) {
      const i = dc(s);
      t[i] || (fN(r, s), t[i] = !0);
    }
    return $e.isArray(e) ? e.forEach(n) : n(e), this;
  }
};
yi.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
$e.reduceDescriptors(yi.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
$e.freezeMethods(yi);
function Uf(e, t) {
  const r = this || ld, n = t || r, s = yi.from(n.headers);
  let i = n.data;
  return $e.forEach(e, function(a) {
    i = a.call(r, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function Jv(e) {
  return !!(e && e.__CANCEL__);
}
function dd(e, t, r) {
  fr.call(this, e ?? "canceled", fr.ERR_CANCELED, t, r), this.name = "CanceledError";
}
$e.inherits(dd, fr, {
  __CANCEL__: !0
});
function pN(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new fr(
    "Request failed with status code " + r.status,
    [fr.ERR_BAD_REQUEST, fr.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const gN = ls.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, s, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      $e.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), $e.isString(n) && a.push("path=" + n), $e.isString(s) && a.push("domain=" + s), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function mN(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function yN(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Qv(e, t) {
  return e && !mN(t) ? yN(e, t) : t;
}
const bN = ls.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let r;
    function n(s) {
      let i = s;
      return e && (t.setAttribute("href", i), i = t.href), t.setAttribute("href", i), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return r = n(window.location.href), function(s) {
      const i = $e.isString(s) ? n(s) : s;
      return i.protocol === r.protocol && i.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function wN(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function vN(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let s = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const d = Date.now(), c = n[i];
    a || (a = d), r[s] = f, n[s] = d;
    let p = i, g = 0;
    for (; p !== s; )
      g += r[p++], p = p % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), d - a < t)
      return;
    const v = c && d - c;
    return v ? Math.round(g * 1e3 / v) : void 0;
  };
}
function Pm(e, t) {
  let r = 0;
  const n = vN(50, 250);
  return (s) => {
    const i = s.loaded, a = s.lengthComputable ? s.total : void 0, f = i - r, d = n(f), c = i <= a;
    r = i;
    const p = {
      loaded: i,
      total: a,
      progress: a ? i / a : void 0,
      bytes: f,
      rate: d || void 0,
      estimated: d && a && c ? (a - i) / d : void 0,
      event: s
    };
    p[t ? "download" : "upload"] = !0, e(p);
  };
}
const AN = typeof XMLHttpRequest < "u", EN = AN && function(e) {
  return new Promise(function(t, r) {
    let n = e.data;
    const s = yi.from(e.headers).normalize();
    let { responseType: i, withXSRFToken: a } = e, f;
    function d() {
      e.cancelToken && e.cancelToken.unsubscribe(f), e.signal && e.signal.removeEventListener("abort", f);
    }
    let c;
    if ($e.isFormData(n)) {
      if (ls.hasStandardBrowserEnv || ls.hasStandardBrowserWebWorkerEnv)
        s.setContentType(!1);
      else if ((c = s.getContentType()) !== !1) {
        const [N, ...S] = c ? c.split(";").map((j) => j.trim()).filter(Boolean) : [];
        s.setContentType([N || "multipart/form-data", ...S].join("; "));
      }
    }
    let p = new XMLHttpRequest();
    if (e.auth) {
      const N = e.auth.username || "", S = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      s.set("Authorization", "Basic " + btoa(N + ":" + S));
    }
    const g = Qv(e.baseURL, e.url);
    p.open(e.method.toUpperCase(), Vv(g, e.params, e.paramsSerializer), !0), p.timeout = e.timeout;
    function v() {
      if (!p)
        return;
      const N = yi.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), S = {
        data: !i || i === "text" || i === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: N,
        config: e,
        request: p
      };
      pN(function(j) {
        t(j), d();
      }, function(j) {
        r(j), d();
      }, S), p = null;
    }
    if ("onloadend" in p ? p.onloadend = v : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, p.onabort = function() {
      p && (r(new fr("Request aborted", fr.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function() {
      r(new fr("Network Error", fr.ERR_NETWORK, e, p)), p = null;
    }, p.ontimeout = function() {
      let N = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const S = e.transitional || qv;
      e.timeoutErrorMessage && (N = e.timeoutErrorMessage), r(new fr(
        N,
        S.clarifyTimeoutError ? fr.ETIMEDOUT : fr.ECONNABORTED,
        e,
        p
      )), p = null;
    }, ls.hasStandardBrowserEnv && (a && $e.isFunction(a) && (a = a(e)), a || a !== !1 && bN(g))) {
      const N = e.xsrfHeaderName && e.xsrfCookieName && gN.read(e.xsrfCookieName);
      N && s.set(e.xsrfHeaderName, N);
    }
    n === void 0 && s.setContentType(null), "setRequestHeader" in p && $e.forEach(s.toJSON(), function(N, S) {
      p.setRequestHeader(S, N);
    }), $e.isUndefined(e.withCredentials) || (p.withCredentials = !!e.withCredentials), i && i !== "json" && (p.responseType = e.responseType), typeof e.onDownloadProgress == "function" && p.addEventListener("progress", Pm(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", Pm(e.onUploadProgress)), (e.cancelToken || e.signal) && (f = (N) => {
      p && (r(!N || N.type ? new dd(null, e, p) : N), p.abort(), p = null);
    }, e.cancelToken && e.cancelToken.subscribe(f), e.signal && (e.signal.aborted ? f() : e.signal.addEventListener("abort", f)));
    const O = wN(g);
    if (O && ls.protocols.indexOf(O) === -1) {
      r(new fr("Unsupported protocol " + O + ":", fr.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(n || null);
  });
}, Mp = {
  http: $O,
  xhr: EN
};
$e.forEach(Mp, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Om = (e) => `- ${e}`, PN = (e) => $e.isFunction(e) || e === null || e === !1, Zv = {
  getAdapter: (e) => {
    e = $e.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const s = {};
    for (let i = 0; i < t; i++) {
      r = e[i];
      let a;
      if (n = r, !PN(r) && (n = Mp[(a = String(r)).toLowerCase()], n === void 0))
        throw new fr(`Unknown adapter '${a}'`);
      if (n)
        break;
      s[a || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(s).map(
        ([f, d]) => `adapter ${f} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(Om).join(`
`) : " " + Om(i[0]) : "as no adapter specified";
      throw new fr(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Mp
};
function Df(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new dd(null, e);
}
function Nm(e) {
  return Df(e), e.headers = yi.from(e.headers), e.data = Uf.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Zv.getAdapter(e.adapter || ld.adapter)(e).then(function(t) {
    return Df(e), t.data = Uf.call(
      e,
      e.transformResponse,
      t
    ), t.headers = yi.from(t.headers), t;
  }, function(t) {
    return Jv(t) || (Df(e), t && t.response && (t.response.data = Uf.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = yi.from(t.response.headers))), Promise.reject(t);
  });
}
const xm = (e) => e instanceof yi ? { ...e } : e;
function Vu(e, t) {
  t = t || {};
  const r = {};
  function n(c, p, g) {
    return $e.isPlainObject(c) && $e.isPlainObject(p) ? $e.merge.call({ caseless: g }, c, p) : $e.isPlainObject(p) ? $e.merge({}, p) : $e.isArray(p) ? p.slice() : p;
  }
  function s(c, p, g) {
    if ($e.isUndefined(p)) {
      if (!$e.isUndefined(c))
        return n(void 0, c, g);
    } else
      return n(c, p, g);
  }
  function i(c, p) {
    if (!$e.isUndefined(p))
      return n(void 0, p);
  }
  function a(c, p) {
    if ($e.isUndefined(p)) {
      if (!$e.isUndefined(c))
        return n(void 0, c);
    } else
      return n(void 0, p);
  }
  function f(c, p, g) {
    if (g in t)
      return n(c, p);
    if (g in e)
      return n(void 0, c);
  }
  const d = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: f,
    headers: (c, p) => s(xm(c), xm(p), !0)
  };
  return $e.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const p = d[c] || s, g = p(e[c], t[c], c);
    $e.isUndefined(g) && p !== f || (r[c] = g);
  }), r;
}
const Yv = "1.6.8", f1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  f1[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Tm = {};
f1.transitional = function(e, t, r) {
  function n(s, i) {
    return "[Axios v" + Yv + "] Transitional option '" + s + "'" + i + (r ? ". " + r : "");
  }
  return (s, i, a) => {
    if (e === !1)
      throw new fr(
        n(i, " has been removed" + (t ? " in " + t : "")),
        fr.ERR_DEPRECATED
      );
    return t && !Tm[i] && (Tm[i] = !0, console.warn(
      n(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(s, i, a) : !0;
  };
};
function ON(e, t, r) {
  if (typeof e != "object")
    throw new fr("options must be an object", fr.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], a = t[i];
    if (a) {
      const f = e[i], d = f === void 0 || a(f, i, e);
      if (d !== !0)
        throw new fr("option " + i + " must be " + d, fr.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new fr("Unknown option " + i, fr.ERR_BAD_OPTION);
  }
}
const Ip = {
  assertOptions: ON,
  validators: f1
}, oo = Ip.validators;
let Ka = class {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new Am(),
      response: new Am()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (r) {
      if (r instanceof Error) {
        let n;
        Error.captureStackTrace ? Error.captureStackTrace(n = {}) : n = new Error();
        const s = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
      }
      throw r;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Vu(this.defaults, t);
    const { transitional: r, paramsSerializer: n, headers: s } = t;
    r !== void 0 && Ip.assertOptions(r, {
      silentJSONParsing: oo.transitional(oo.boolean),
      forcedJSONParsing: oo.transitional(oo.boolean),
      clarifyTimeoutError: oo.transitional(oo.boolean)
    }, !1), n != null && ($e.isFunction(n) ? t.paramsSerializer = {
      serialize: n
    } : Ip.assertOptions(n, {
      encode: oo.function,
      serialize: oo.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = s && $e.merge(
      s.common,
      s[t.method]
    );
    s && $e.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (O) => {
        delete s[O];
      }
    ), t.headers = yi.concat(i, s);
    const a = [];
    let f = !0;
    this.interceptors.request.forEach(function(O) {
      typeof O.runWhen == "function" && O.runWhen(t) === !1 || (f = f && O.synchronous, a.unshift(O.fulfilled, O.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(O) {
      d.push(O.fulfilled, O.rejected);
    });
    let c, p = 0, g;
    if (!f) {
      const O = [Nm.bind(this), void 0];
      for (O.unshift.apply(O, a), O.push.apply(O, d), g = O.length, c = Promise.resolve(t); p < g; )
        c = c.then(O[p++], O[p++]);
      return c;
    }
    g = a.length;
    let v = t;
    for (p = 0; p < g; ) {
      const O = a[p++], N = a[p++];
      try {
        v = O(v);
      } catch (S) {
        N.call(this, S);
        break;
      }
    }
    try {
      c = Nm.call(this, v);
    } catch (O) {
      return Promise.reject(O);
    }
    for (p = 0, g = d.length; p < g; )
      c = c.then(d[p++], d[p++]);
    return c;
  }
  getUri(e) {
    e = Vu(this.defaults, e);
    const t = Qv(e.baseURL, e.url);
    return Vv(t, e.params, e.paramsSerializer);
  }
};
$e.forEach(["delete", "get", "head", "options"], function(e) {
  Ka.prototype[e] = function(t, r) {
    return this.request(Vu(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
$e.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(n, s, i) {
      return this.request(Vu(i || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: n,
        data: s
      }));
    };
  }
  Ka.prototype[e] = t(), Ka.prototype[e + "Form"] = t(!0);
});
let NN = class Xv {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(s) {
      r = s;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const a = new Promise((f) => {
        n.subscribe(f), i = f;
      }).then(s);
      return a.cancel = function() {
        n.unsubscribe(i);
      }, a;
    }, t(function(s, i, a) {
      n.reason || (n.reason = new dd(s, i, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Xv(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function xN(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function TN(e) {
  return $e.isObject(e) && e.isAxiosError === !0;
}
const Rp = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Rp).forEach(([e, t]) => {
  Rp[t] = e;
});
function e5(e) {
  const t = new Ka(e), r = Cv(Ka.prototype.request, t);
  return $e.extend(r, Ka.prototype, t, { allOwnKeys: !0 }), $e.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(n) {
    return e5(Vu(e, n));
  }, r;
}
const Vr = e5(ld);
Vr.Axios = Ka;
Vr.CanceledError = dd;
Vr.CancelToken = NN;
Vr.isCancel = Jv;
Vr.VERSION = Yv;
Vr.toFormData = qh;
Vr.AxiosError = fr;
Vr.Cancel = Vr.CanceledError;
Vr.all = function(e) {
  return Promise.all(e);
};
Vr.spread = xN;
Vr.isAxiosError = TN;
Vr.mergeConfig = Vu;
Vr.AxiosHeaders = yi;
Vr.formToJSON = (e) => Kv($e.isHTMLForm(e) ? new FormData(e) : e);
Vr.getAdapter = Zv.getAdapter;
Vr.HttpStatusCode = Rp;
Vr.default = Vr;
const t5 = Vr, {
  Axios: kN,
  AxiosError: SN,
  CanceledError: MN,
  isCancel: IN,
  CancelToken: RN,
  VERSION: CN,
  all: BN,
  Cancel: _N,
  isAxiosError: FN,
  spread: UN,
  toFormData: DN,
  AxiosHeaders: jN,
  HttpStatusCode: LN,
  formToJSON: HN,
  getAdapter: WN,
  mergeConfig: GN
} = t5, zN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Axios: kN,
  AxiosError: SN,
  AxiosHeaders: jN,
  Cancel: _N,
  CancelToken: RN,
  CanceledError: MN,
  HttpStatusCode: LN,
  VERSION: CN,
  all: BN,
  default: t5,
  formToJSON: HN,
  getAdapter: WN,
  isAxiosError: FN,
  isCancel: IN,
  mergeConfig: GN,
  spread: UN,
  toFormData: DN
}, Symbol.toStringTag, { value: "Module" }));
var VN = {}, $h = {}, Ki = {}, r5 = {};
const qN = /* @__PURE__ */ Lh(zN);
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(c, p, g, v) {
    v === void 0 && (v = g);
    var O = Object.getOwnPropertyDescriptor(p, g);
    (!O || ("get" in O ? !p.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return p[g];
    } }), Object.defineProperty(c, v, O);
  } : function(c, p, g, v) {
    v === void 0 && (v = g), c[v] = p[g];
  }), r = Ze && Ze.__setModuleDefault || (Object.create ? function(c, p) {
    Object.defineProperty(c, "default", { enumerable: !0, value: p });
  } : function(c, p) {
    c.default = p;
  }), n = Ze && Ze.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var p = {};
    if (c != null)
      for (var g in c)
        g !== "default" && Object.prototype.hasOwnProperty.call(c, g) && t(p, c, g);
    return r(p, c), p;
  }, s = Ze && Ze.__awaiter || function(c, p, g, v) {
    function O(N) {
      return N instanceof g ? N : new g(function(S) {
        S(N);
      });
    }
    return new (g || (g = Promise))(function(N, S) {
      function j(I) {
        try {
          M(v.next(I));
        } catch (A) {
          S(A);
        }
      }
      function B(I) {
        try {
          M(v.throw(I));
        } catch (A) {
          S(A);
        }
      }
      function M(I) {
        I.done ? N(I.value) : O(I.value).then(j, B);
      }
      M((v = v.apply(c, p || [])).next());
    });
  }, i = Ze && Ze.__rest || function(c, p) {
    var g = {};
    for (var v in c)
      Object.prototype.hasOwnProperty.call(c, v) && p.indexOf(v) < 0 && (g[v] = c[v]);
    if (c != null && typeof Object.getOwnPropertySymbols == "function")
      for (var O = 0, v = Object.getOwnPropertySymbols(c); O < v.length; O++)
        p.indexOf(v[O]) < 0 && Object.prototype.propertyIsEnumerable.call(c, v[O]) && (g[v[O]] = c[v[O]]);
    return g;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BaseClient = e.typeParser = e.APIError = void 0;
  const a = n(qN);
  class f extends Error {
  }
  e.APIError = f, e.typeParser = {
    date: (c) => new Date(c)
  };
  class d {
    /**
     * @param baseUrl url for the service
     * @param getHeaders any custom headers to be sent with every request, using a function here to allow for dynamic headers
     * @param defaultTimeout default timeout for requests in milliseconds. If undefined no timeout
     * @param modules optional map of module names to module classes. This is used to automatically
     *                instantiate the modules and make them available on the client instance
     * @param getUrlSuffix optional function to auto-append a suffix to every request url, useful for case like god-mode in studio-client where we append ?god=<address> to every request
     * @param fieldsToParseMapping default optional map of fields to parse in the response.
     * @example { date: ['created_at', 'updated_at'] }
     */
    constructor({ baseUrl: p, getHeaders: g, defaultTimeout: v, modules: O = {}, getDefaultQueryParams: N, fieldsToParseMapping: S }) {
      this.baseUrl = p, this.getDefaultQueryParams = N, this._fieldsToParseMapping = S, g && (this.getHeaders = () => {
        const B = g(), M = new a.AxiosHeaders();
        for (const I of Object.keys(B))
          M.set(I, B[I]);
        return new a.AxiosHeaders(M);
      }), this.defaultTimeout = v;
      const j = {};
      Object.keys(O).forEach((B) => {
        const M = new O[B](this);
        j[B] = M, Object.defineProperty(this, B, {
          enumerable: !0,
          get() {
            return M;
          }
        });
      }), this.moduleInstances = j;
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    get(p, g = {}, v) {
      return s(this, void 0, void 0, function* () {
        return this.request(p, "get", g, v);
      });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    post(p, g = {}, v) {
      return s(this, void 0, void 0, function* () {
        return this.request(p, "post", g, v);
      });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    put(p, g = {}, v) {
      return s(this, void 0, void 0, function* () {
        return this.request(p, "put", g, v);
      });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    patch(p, g = {}, v) {
      return s(this, void 0, void 0, function* () {
        return this.request(p, "patch", g, v);
      });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    delete(p, g = {}, v) {
      return s(this, void 0, void 0, function* () {
        return this.request(p, "delete", g, v);
      });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    request(p, g, v, O) {
      var N, S;
      return s(this, void 0, void 0, function* () {
        const j = Object.assign({}, v);
        this.getHeaders && (j.headers = Object.assign(Object.assign({}, this.getHeaders()), v.headers)), this.getDefaultQueryParams && (j.params = Object.assign(Object.assign({}, this.getDefaultQueryParams()), v.params)), j.timeout = (N = v.timeout) !== null && N !== void 0 ? N : this.defaultTimeout;
        const B = a.default[g];
        let M;
        if (g === "post" || g === "put" || g === "patch") {
          const { data: A } = j, R = i(j, ["data"]);
          M = yield B(`${this.baseUrl}${p}`, A, Object.assign({}, R));
        } else
          M = yield B(`${this.baseUrl}${p}`, j);
        const I = M.data;
        if (M.status >= 300) {
          const A = new f(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (S = I.error) !== null && S !== void 0 ? S : `Received status '${M.status}' from server for '${p}'`
          );
          throw A.statusCode = M.status, console.error(A), A;
        }
        return this._processResponse(I, O || this._fieldsToParseMapping);
      });
    }
    _processResponse(p, g) {
      if (g)
        for (const v of Object.keys(g)) {
          const O = v;
          if (typeof p == "object") {
            if (Array.isArray(p)) {
              for (const S of p)
                typeof S == "object" && this._recursiveConverter(O, S, g[O]);
              return p;
            }
            const N = p;
            this._recursiveConverter(O, N, g[O]);
          }
        }
      return p;
    }
    _recursiveConverter(p, g, v) {
      for (const O of Object.keys(g))
        if (g[O]) {
          typeof g[O] == "object" && this._recursiveConverter(p, g[O], v);
          for (const N of v)
            if (O === N) {
              if (Array.isArray(g[O])) {
                g[O] = g[O].map((S) => typeof S == "string" || typeof S == "number" ? e.typeParser[p](S) : S);
                continue;
              }
              (typeof g[O] == "string" || typeof g[O] == "number") && (g[O] = e.typeParser[p](g[O]));
            }
        }
    }
  }
  e.BaseClient = d;
})(r5);
var Kh = {};
Object.defineProperty(Kh, "__esModule", { value: !0 });
Kh.BaseModule = void 0;
class $N {
  constructor(t) {
    this.baseClient = t;
  }
}
Kh.BaseModule = $N;
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(s, i, a, f) {
    f === void 0 && (f = a);
    var d = Object.getOwnPropertyDescriptor(i, a);
    (!d || ("get" in d ? !i.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return i[a];
    } }), Object.defineProperty(s, f, d);
  } : function(s, i, a, f) {
    f === void 0 && (f = a), s[f] = i[a];
  }), r = Ze && Ze.__exportStar || function(s, i) {
    for (var a in s)
      a !== "default" && !Object.prototype.hasOwnProperty.call(i, a) && t(i, s, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.APIError = e.BaseClient = void 0;
  var n = r5;
  Object.defineProperty(e, "BaseClient", { enumerable: !0, get: function() {
    return n.BaseClient;
  } }), Object.defineProperty(e, "APIError", { enumerable: !0, get: function() {
    return n.APIError;
  } }), r(Kh, e);
})(Ki);
var ar = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty($h, "__esModule", { value: !0 });
$h.AssetUploaderClient = void 0;
const KN = Ki;
class JN extends KN.BaseClient {
  constructor({ clientId: t, baseUrl: r, getHeaders: n, defaultTimeout: s, getDefaultQueryParams: i }) {
    super({
      baseUrl: r,
      getHeaders: n,
      defaultTimeout: s,
      getDefaultQueryParams: i,
      fieldsToParseMapping: {
        date: ["createdAt", "updatedAt"]
      }
    }), this.clientId = t;
  }
  /**
   * Get an upload token for direct file uploading to the asset uploader service
   * @returns UploadToken
   */
  getUploadToken() {
    return ar(this, void 0, void 0, function* () {
      return this.post("/upload/token");
    });
  }
  /**
   * Upload a file for an asset to the asset uploader service by providing a reference URI
   * The asset uploader service will download the file from the URI
   * @param assetId - Asset id to upload file for
   * @param uri     - URI to download file from
   * @returns Asset
   */
  uploadAssetFileByUri(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/asset/${t}/uri`, {
        data: {
          uri: r
        }
      });
    });
  }
  /**
   * Get all assets for a given instance
   * @param instanceId  - Instance id to get assets for
   * @returns Asset[]
   */
  getInstanceAssets(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/asset/all/${t}`);
    });
  }
  /**
   * Create an asset for a given instance
   * @param instanceId - Instance id to create asset for
   * @param metadata - any metadata that the Asset should be initialized with.
   * @returns Asset
   */
  createInstanceAsset(t, r, n, s) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/asset/new/${t}`, {
        data: { metadata: r, seriesId: n, editionCount: s }
      });
    });
  }
  /**
   * Get an asset by id
   * @param assetId - Asset id to get
   * @returns Asset
   */
  getAsset(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.get(r != null && r.maxWidth || r != null && r.imageOnly ? `/${this.clientId}/asset/${t}` : `/${this.clientId}/asset/${t}`, {
        params: r
      });
    });
  }
  /**
   * Copy an asset by id
   * @param assetId - Asset id to copy
   * @param instanceId - (Optional) instance id to copy asset for (defaults to the same instance as the original asset)
   * @returns Asset of new copy
   */
  copyAsset(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/asset/${t}/copy`, {
        data: {
          instanceId: r
        }
      });
    });
  }
  /**
   * Sync a series by id
   * @param sourceId - The series id to sync from
   * @returns Synced Asset
   */
  syncAsset(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/asset/${t}/sync`, {
        data: {
          sourceId: r
        }
      });
    });
  }
  /**
   * Get metadata for an asset
   * This is mainly use as the metadataUrl for minting to testnet
   */
  getAssetFullMetadata(t, r = !1, n) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/asset/${t}/metadata/full`, {
        params: {
          previewMaxWidth: n,
          includePreview: r
        }
      });
    });
  }
  /**
   * Get metadata for an asset by edition number
   * This is mainly use as the metadataUrl for minting to testnet
   */
  getAssetFullMetadataByEdition(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/asset/${t}/metadata/full/${r}`);
    });
  }
  /**
   * Delete an asset by id
   * @param assetId - Asset id to delete
   * @returns Asset
   */
  deleteAsset(t) {
    return ar(this, void 0, void 0, function* () {
      return this.delete(`/${this.clientId}/asset/${t}`);
    });
  }
  /**
   * Update asset metadata
   * @param assetId      - Asset id to update metadata for
   * @param metadata     - Metadata
   * @param editionCount - Edition count for the asset
   * @returns Asset
   */
  updateAssetMetadata(t, r, n) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/asset/${t}/metadata`, {
        data: {
          metadata: r,
          editionCount: n
        }
      });
    });
  }
  /**
   * Update the edition count for an asset.
   * Creates and assigns a series id to the asset if the `editionCount` > 1 and the asset does not have a series id.
   * @param assetId       - Asset id to update edition count for
   * @param editionCount  - Edition count for the asset
   * @returns Asset
   */
  updateAssetMetadataEditionCount(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/asset/${t}/metadata/edition`, {
        data: {
          editionCount: r
        }
      });
    });
  }
  /**
   * Delete a file for an asset
   * @param assetId - Asset id we are referencing
   * @param fileId  - File id to delete
   * @returns Asset
   */
  deleteAssetFile(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.delete(`/${this.clientId}/asset/${t}/file/${r}`);
    });
  }
  deleteBatchFile(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.delete(`/${this.clientId}/asset/${t}/uri`, {
        data: {
          uri: r
        }
      });
    });
  }
  /**
   * Upload file to arweave
   * @param fileId - File to upload to arweave
   * @returns ArweaveTransaction
   */
  postFileArweaveTransaction(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/arweave/file/${t}`);
    });
  }
  /**
   * Upload asset metadata to arweave
   * @param assetId - Asset to upload to arweave
   * @returns ArweaveTransaction
   */
  postAssetArweaveTransaction(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/arweave/metadata/${t}`);
    });
  }
  /**
   * Get a file's arweave transaction information
   * @param fileId - File id to get arweave transaction for
   * @returns ArweaveTransaction
   */
  getFileArweaveTransaction(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/arweave/file/transaction/${t}`);
    });
  }
  /**
   * Get an asset's arweave transaction information
   * @param assetId - Asset id to get arweave transaction for
   * @returns ArweaveTransaction
   */
  getAssetArweaveTransaction(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/arweave/asset/transaction/${t}`);
    });
  }
  /**
   * Upload assets for a series to the asset uploader service.
   *
   * @param seriesId - Series id to upload assets for
   * @param assets   - Array of {uri: string, seriesIndex: number} objects
   * @returns Series
   */
  uploadSeriesAssetsByUri(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/series/${t}/assets/uris`, {
        data: {
          assets: r
        }
      });
    });
  }
  /**
   * Get all series for an instance
   * @param instanceId - Instance id to get series for
   * @returns Series[]
   */
  getInstanceSeries(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/series/all/${t}`);
    });
  }
  /**
   * Get a series by id
   * @param seriesId - Series id to get
   * @returns Series
   */
  getSeries(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/series/${t}`, {
        params: Object.assign({}, r)
      });
    });
  }
  /**
   * Copy a series by id
   * @param seriesId - Asset id to copy
   * @param instanceId - (Optional) instance id to copy asset for (defaults to the same instance as the original asset)
   * @returns Series of new copy
   */
  copySeries(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/series/${t}/copy`, {
        data: {
          instanceId: r
        }
      });
    });
  }
  /**
   * Sync a series by id
   * @param sourceId - The series id to sync from
   * @returns Synced Series
   */
  syncSeries(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/series/${t}/sync`, {
        data: {
          sourceId: r
        }
      });
    });
  }
  /**
   * Get all assets for a series
   * @param seriesId - Series id to get assets for
   * @returns Asset[]
   */
  getSeriesAssets(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/series/${t}/assets`);
    });
  }
  /**
   * Get a specific asset for a series
   * @param seriesId     - Series id to get asset for
   * @param seriesIndex  - Series index to get asset for
   * @returns Asset
   */
  getSeriesAsset(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/series/${t}/asset/${r}`);
    });
  }
  /**
   * All metadata for all assets in a series.
   * @returns SeriesMetadata
   */
  getAllSeriesAssetMetadata(t, r, n) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/series/${t}/metadata/full/all`, {
        params: {
          page: r,
          pageSize: n
        }
      });
    });
  }
  /**
   * Delete a series by id
   * @param seriesId - Series id to delete
   * @returns Series
   */
  deleteSeries(t) {
    return ar(this, void 0, void 0, function* () {
      return this.delete(`/${this.clientId}/series/${t}`);
    });
  }
  /**
   * Update a series' manifest indices (used for collectibles to do assignment of series to a referenced manifest index)
   *
   * @param seriesId
   * @returns
   */
  updateSeriesManifestIndices(t, r, n, s) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/series/${t}/assets/manifest`, {
        data: {
          assets: r,
          namePrefix: n,
          baseMetadata: s
        }
      });
    });
  }
  /**
   * Create a series for a given instance
   * @param instanceId - Instance id to create series for
   * @returns Series
   */
  createInstanceSeries(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/series/new/${t}`, {
        data: r
      });
    });
  }
  /**
   * Update series metadata
   * @param seriesId - Series id to update metadata for
   * @param metadata - Metadata
   * @returns Series
   */
  updateSeriesMetadata(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/series/${t}/metadata`, {
        data: {
          metadata: r
        }
      });
    });
  }
  /**
   * Update metadata for assets in a series
   * @param seriesId  - Series id to update metadata for
   * @param assets    - Array of {seriesIndex: number, metadata: any} objects
   * @returns Series
   */
  updateSeriesAssetsMetadata(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/series/${t}/assets/metadata`, {
        data: {
          assets: r
        }
      });
    });
  }
  /**
   * Trigger series assets to be uploaded to arweave
   * @param seriesId - Series id to upload assets for
   * @returns ArweaveTransaction
   */
  postSeriesAssetsArweaveTransaction(t) {
    return ar(this, void 0, void 0, function* () {
      const r = yield this.get(`/${this.clientId}/arweave/file/series/${t}`);
      if (r.error)
        throw new Error(r.error);
      return {
        transactionId: "",
        complete: !0
      };
    });
  }
  /**
   * Trigger series metadata to be uploaded to arweave
   * @param seriesId - Series id to upload metadata for
   * @returns ArweaveTransaction
   */
  postSeriesArweaveTransaction(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/arweave/metadata/series/${t}`);
    });
  }
  /**
   * Get a series' arweave transaction information
   * @param seriesId - Series id to get arweave transaction for
   * @returns ArweaveTransaction
   */
  getSeriesArweaveTransaction(t) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/${this.clientId}/arweave/series/transaction/${t}`);
    });
  }
  /**
   * Delete a series' last transaction hash
   * @param seriesId  - Series id to delete transaction hash for
   * @param networkId - Network id to delete transaction hash for
   * @returns Series
   */
  deleteSeriesTransactionHash(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/deleteTransaction/series/${t}`, {
        data: {
          networkId: r
        }
      });
    });
  }
  /**
   * Get a file by id
   * @param fileId - File id to get
   * @param maxWidth - (Optional) Maximum width for image/animation files
   * @returns File
   */
  getFile(t, r) {
    return ar(this, void 0, void 0, function* () {
      return this.get(`/file/${t}${r ? `?maxWidth=${r}` : ""}`);
    });
  }
}
$h.AssetUploaderClient = JN;
var Jh = {}, jf = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(Jh, "__esModule", { value: !0 });
Jh.ExternalAssetUploaderClient = void 0;
const QN = Ki, Lf = {
  "Content-Type": "multipart/form-data",
  "X-Requested-With": "XMLHttpRequest"
};
function Hf(e) {
  const t = new FormData();
  return e.forEach((r) => {
    t.append("file", r);
  }), t;
}
function Wf(e) {
  if (!e)
    return {};
  const t = {};
  return e.abortControllerSignal && (t.signal = e.abortControllerSignal), e.onUploadProgress && (t.onUploadProgress = function(r) {
    var n;
    r.progress && ((n = e.onUploadProgress) === null || n === void 0 || n.call(e, Math.round(r.progress * 100)));
  }), t;
}
class ZN extends QN.BaseClient {
  constructor({ clientId: t, baseUrl: r, getHeaders: n, defaultTimeout: s }) {
    super({ baseUrl: r, getHeaders: n, defaultTimeout: s }), this.clientId = t;
  }
  /**
   * Upload a file to the asset uploader service
   * @param token     - Upload token from getUploadToken()
   * @param file      - File to upload
   * @returns Asset
   */
  uploadFile(t, r, n) {
    return jf(this, void 0, void 0, function* () {
      return this.post("/file/upload", Object.assign({ headers: Lf, data: Hf([r]), params: { token: t } }, Wf(n)));
    });
  }
  /**
   * Upload a file for an asset to the asset uploader service
   * @param token     - Upload token from getUploadToken()
   * @param assetId   - Asset id to upload file for
   * @param file      - File to upload
   * @returns Asset
   */
  uploadAssetFile(t, r, n, s) {
    return jf(this, void 0, void 0, function* () {
      return this.post(`/${this.clientId}/asset/${r}/upload`, Object.assign({ headers: Lf, data: Hf([n]), params: { token: t } }, Wf(s)));
    });
  }
  /**
   * Upload files for a series to the asset uploader service
   * @param token       - Upload token from getUploadToken()
   * @param seriesId    - Series id to upload file for
   * @param files       - Array of files / FileList to upload
   * @returns a message indicating that all files have been uploaded when the upload completes
   */
  uploadSeriesFiles(t, r, n, s) {
    return jf(this, void 0, void 0, function* () {
      const i = Array.from(n), a = Hf(i);
      return this.post(`/${this.clientId}/series/${r}/upload`, Object.assign({ headers: Lf, data: a, params: { token: t } }, Wf(s)));
    });
  }
}
Jh.ExternalAssetUploaderClient = ZN;
var n5 = {}, i5 = {};
Object.defineProperty(i5, "__esModule", { value: !0 });
var s5 = {};
Object.defineProperty(s5, "__esModule", { value: !0 });
var o5 = {};
Object.defineProperty(o5, "__esModule", { value: !0 });
var qu = {};
Object.defineProperty(qu, "__esModule", { value: !0 });
qu.SeriesManifestType = qu.SeriesCounterType = void 0;
var km;
(function(e) {
  e[e.UNIQUE = 0] = "UNIQUE", e[e.EDITION = 1] = "EDITION";
})(km || (qu.SeriesCounterType = km = {}));
var Sm;
(function(e) {
  e.DEFAULT = "default", e.DYNAMIC = "dynamic";
})(Sm || (qu.SeriesManifestType = Sm = {}));
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = Ze && Ze.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(i5, e), r(s5, e), r(o5, e), r(qu, e);
})(n5);
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = Ze && Ze.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r($h, e), r(Jh, e), r(n5, e);
})(VN);
var YN = {}, $u = {}, Fn = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty($u, "__esModule", { value: !0 });
$u.ContractDeployerClient = $u.ContractSpec = void 0;
const XN = Ki;
var Mm;
(function(e) {
  e.ERC721 = "ERC721", e.ERC1155 = "ERC1155";
})(Mm || ($u.ContractSpec = Mm = {}));
class ex extends XN.BaseClient {
  constructor({ app: t, baseUrl: r, getHeaders: n, defaultTimeout: s, getDefaultQueryParams: i }) {
    super({ baseUrl: r, getHeaders: n, defaultTimeout: s, getDefaultQueryParams: i }), this.app = t;
  }
  previewAscii(t) {
    return Fn(this, void 0, void 0, function* () {
      return this.post("/preview_ascii", {
        data: {
          ascii: t
        }
      });
    });
  }
  /**
   * Get all contracts
   * @returns Contract[]
   */
  getAllContracts() {
    return Fn(this, void 0, void 0, function* () {
      return this.get(`/${this.app}/all`);
    });
  }
  /**
   * Get a specific contract
   * @param contractId - The contract to retrieve
   * @returns Contract
   */
  getContract(t) {
    return Fn(this, void 0, void 0, function* () {
      return this.get(`/${this.app}/retrieve/${t}`);
    });
  }
  /**
   * Create a new contract
   * @returns Contract
   */
  createContract() {
    return Fn(this, void 0, void 0, function* () {
      return this.post(`/${this.app}/create`);
    });
  }
  updateContract(t, r, n, s, i) {
    return Fn(this, void 0, void 0, function* () {
      if (this.app !== "creator-core" && this.app !== "creator-core-proxy")
        throw new Error("Only creator-core and creator-core-proxy contracts can be updated");
      return this.patch(`/${this.app}/${t}`, {
        data: {
          spec: r,
          name: n,
          symbol: s,
          ascii: i
        }
      });
    });
  }
  deleteContract(t) {
    return Fn(this, void 0, void 0, function* () {
      if (this.app !== "creator-core" && this.app !== "creator-core-proxy")
        throw new Error("Only creator-core and creator-core-proxy contracts can be deleted");
      return this.delete(`/${this.app}/${t}`);
    });
  }
  /**
   * Compile a contract for a network with optional constructor arguments
   * @param contractId - The contract to compile
   * @param networkId  - The network to compile for
   * @param args       - Optional constructor arguments
   * @returns CompiledContract
   */
  compileContract(t, r, n) {
    return Fn(this, void 0, void 0, function* () {
      return this.get(`/${this.app}/${t}/compiled`, {
        params: {
          networkId: r,
          args: n
        }
      });
    });
  }
  /**
   * Record a transaction deployment for a contract
   * @param contractId      - The contract to record the deployment for
   * @param network         - The network to record the deployment for
   * @param transactionHash - The transaction hash of the deployment
   * @returns Contract
   */
  recordContractDeployment(t, r, n) {
    return Fn(this, void 0, void 0, function* () {
      return this.post(`/${this.app}/deploy_transaction`, {
        data: {
          id: t,
          network: r,
          transactionHash: n
        }
      });
    });
  }
  /**
   * Delete a contract deployment's transaction.  Used to clear the transaction hash for cases where we know
   * the transaction failed
   * @param contractId - The contract to delete
   * @param network    - The network to delete the deployment transaction for
   * @returns Contract
   */
  deleteContractDeployment(t, r) {
    return Fn(this, void 0, void 0, function* () {
      return this.delete(`/${this.app}/deploy_transaction/${r}/${t}`);
    });
  }
  /**
   * Use when to reset an already compiled contract so user can try again (Ex: User deployed a contract on mainnet, we stored the transaction hash, but cancelled the transaction. We need to reset by removing the previous hash as well as the compile_location so user can try again)
   * @param contractId
   * @param network
   * @returns Contract
   */
  resetContractDeployment(t, r) {
    return Fn(this, void 0, void 0, function* () {
      return this.delete(`/${this.app}/transaction/${t}/${r}/reset`);
    });
  }
  /**
   * Verify a deployed contract on a network
   * @param contractId      - The contract to verify
   * @param contractAddress - The contract address
   * @param network         - The network to verify on
   * @param transactionHash - The transaction hash of the deployment
   * @returns {status: string}
   */
  verifyContract(t, r, n, s) {
    return Fn(this, void 0, void 0, function* () {
      return this.post(`/${this.app}/verify`, {
        data: {
          id: t,
          contractAddress: r,
          network: n,
          transactionHash: s
        }
      });
    });
  }
  /**
   * Get a contract's default royalty configuration
   * @param contractId - The contract to retrieve the royalty configuration for
   * @param network    - The network to retrieve the royalty configuration for
   * @returns RoyaltyConfiguration
   */
  getContractRoyaltyConfiguration(t, r) {
    return Fn(this, void 0, void 0, function* () {
      return this.get(`/${this.app}/${r}/retrieve-royalty-configuration/${t}`);
    });
  }
  /**
   * Get a token's royalty configuration
   * @param contractId  - The contract to retrieve the royalty configuration for
   * @param network     - The network to retrieve the royalty configuration for
   * @param tokenId     - The token to retrieve the royalty configuration for
   * @returns RoyaltyConfiguration
   */
  getTokenRoyaltyConfiguration(t, r, n) {
    return Fn(this, void 0, void 0, function* () {
      return this.get(`/${this.app}/${r}/retrieve-royalty-configuration/${t}/${n}`);
    });
  }
}
$u.ContractDeployerClient = ex;
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = Ze && Ze.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r($u, e);
})(YN);
var tx = {}, Qh = {}, ur = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(Qh, "__esModule", { value: !0 });
Qh.InventoryClient = void 0;
const rx = Ki;
class nx extends rx.BaseClient {
  constructor({ baseUrl: t, getHeaders: r, defaultTimeout: n, getDefaultQueryParams: s }) {
    super({
      baseUrl: t,
      defaultTimeout: n,
      fieldsToParseMapping: {
        date: [
          "lastRefreshAt",
          "lastCollectedDate",
          "deployedTimestamp",
          "mintTimestamp",
          "updatedAt",
          "lastUpdated"
        ]
      },
      getDefaultQueryParams: s,
      getHeaders: r
    });
  }
  /**
   * Create a new inventory
   * @returns {inventoryId: string}
   */
  createInventory(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.post("/inventory", {
        data: { address: t, refresh: r }
      });
    });
  }
  getInventory(t) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}`);
    });
  }
  patchInventory(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.patch(`/inventory/${t}`, {
        data: { metadata: r, slug: n }
      });
    });
  }
  refreshInventory(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/refresh`, {
        data: { networkId: r }
      });
    });
  }
  /**
   * Add custom address to inventory
   */
  addCustomAddress(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/addresses/${r}`);
    });
  }
  /**
   * Add verified address, or promote custom address if it exists
   */
  addVerifiedAddress(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/addresses/${r}`, {
        data: { verification: n }
      });
    });
  }
  /**
   * Get challenge to verify address
   */
  getChallenge(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/addresses/${r}/challenge`);
    });
  }
  /**
   * Get challenge to verify address
   */
  removeAddress(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.delete(`/inventory/${t}/addresses/${r}`);
    });
  }
  /**
   * Get addresses for inventory
   */
  getAddresses(t) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/addresses`);
    });
  }
  /**
   * Get collectors of tokens for inventory, with filters, sort, and pagination
   */
  getCollectors(t, r) {
    var n, s, i, a;
    return ur(this, void 0, void 0, function* () {
      const f = new URLSearchParams();
      r && ((n = r.collectorAddresses) === null || n === void 0 || n.forEach((c) => f.append("collectorAddresses", c)), (s = r.contractAddresses) === null || s === void 0 || s.forEach((c) => f.append("contractAddresses", c)), (i = r.creatorAddresses) === null || i === void 0 || i.forEach((c) => f.append("creatorAddresses", c)), (a = r.tokenIds) === null || a === void 0 || a.forEach((c) => f.append("tokenIds", c)), r.fromCustom !== void 0 && f.set("fromCustom", r.fromCustom.toString()), r.limit !== void 0 && f.set("limit", r.limit.toString()), r.networkId !== void 0 && f.set("networkId", r.networkId.toString()), r.offset !== void 0 && f.set("offset", r.offset.toString()), r.sort !== void 0 && f.set("sort", r.sort));
      const d = Object.fromEntries(f);
      return this.get(`/inventory/${t}/collectors`, {
        params: d
      });
    });
  }
  /**
   * Add a custom contract to the inventory
   */
  addCustomContract(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/contracts`, {
        data: { contractAddress: n, networkId: r }
      });
    });
  }
  /**
   * Remove a custom contract from the inventory
   */
  removeCustomContract(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.delete(`/inventory/${t}/contracts/${r}/${n}`);
    });
  }
  /**
   * Get a single contract
   */
  getContract(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/contracts/${r}/${n}`);
    });
  }
  /**
   * Get contracts for inventory with filters
   */
  getContracts(t, r) {
    var n;
    return ur(this, void 0, void 0, function* () {
      const s = new URLSearchParams();
      r && ((n = r.creatorAddresses) === null || n === void 0 || n.forEach((a) => s.append("creatorAddresses", a)), r.isCustom !== void 0 && s.set("isCustom", r.isCustom.toString()), r.networkId !== void 0 && s.set("networkId", r.networkId.toString()), r.limit !== void 0 && s.set("limit", r.limit.toString()), r.offset !== void 0 && s.set("offset", r.offset.toString()), r.sort !== void 0 && s.set("sort", r.sort), r.visible !== void 0 && s.set("visible", r.visible.toString()));
      const i = Object.fromEntries(s);
      return this.get(`/inventory/${t}/contracts`, {
        params: i
      });
    });
  }
  /**
   * Update contract visibility
   */
  updateContractVisibility(t, r, n, s) {
    return ur(this, void 0, void 0, function* () {
      return this.put(`/inventory/${t}/contracts/${r}/${n}`, {
        data: { visible: s.toString() }
      });
    });
  }
  /**
   * Add custom token to inventory
   */
  addCustomToken(t, r, n, s, i) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/tokens`, {
        data: { contractAddress: n, networkId: r, noRefresh: i, tokenId: s }
      });
    });
  }
  /**
   * Remove custom token to inventory
   */
  removeCustomToken(t, r, n, s) {
    return ur(this, void 0, void 0, function* () {
      return this.delete(`/inventory/${t}/tokens/${r}/${n}/${s}`);
    });
  }
  /**
   * Get a single token
   */
  getToken(t, r, n, s) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/tokens/${r}/${n}/${s}`);
    });
  }
  /**
   * Get tokens for inventory that with visibility public, with filters
   * Filters: networkId, isCustom, creatorAddresses, contractAddresses
   */
  getTokens(t, r) {
    var n, s, i;
    return ur(this, void 0, void 0, function* () {
      const a = new URLSearchParams();
      r && ((n = r.creatorAddresses) === null || n === void 0 || n.forEach((d) => a.append("creatorAddresses", d)), (s = r.networkIds) === null || s === void 0 || s.forEach((d) => a.append("networkIds", d.toString())), (i = r.contractAddresses) === null || i === void 0 || i.forEach((d) => a.append("contractAddresses", d)), r.groupId !== void 0 && a.set("groupId", r.groupId), r.ownerAddress !== void 0 && a.set("ownerAddress", r.ownerAddress), r.isCustom !== void 0 && a.set("isCustom", r.isCustom.toString()), r.limit !== void 0 && a.set("limit", r.limit.toString()), r.offset !== void 0 && a.set("offset", r.offset.toString()), r.sort !== void 0 && a.set("sort", r.sort), r.visible !== void 0 && a.set("visible", r.visible.toString()), r.withCollectorInfo !== void 0 && a.set("withCollectorInfo", r.withCollectorInfo.toString()));
      const f = Object.fromEntries(a);
      return this.get(`/inventory/${t}/tokens`, {
        params: f
      });
    });
  }
  /**
   * Get token sources (contracts) for all tokens in an inventory
   */
  getTokenContracts(t, r) {
    var n;
    return ur(this, void 0, void 0, function* () {
      const s = new URLSearchParams();
      r && ((n = r.networkIds) === null || n === void 0 || n.forEach((a) => s.append("networkIds", a.toString())), r.limit !== void 0 && s.set("limit", r.limit.toString()), r.offset !== void 0 && s.set("offset", r.offset.toString()), r.sort !== void 0 && s.set("sort", r.sort), r.visible !== void 0 && s.set("visible", r.visible.toString()));
      const i = Object.fromEntries(s);
      return this.get(`/inventory/${t}/tokens/contracts`, {
        params: i
      });
    });
  }
  /**
   * Get token source (contract) for a single contractAddress and network pairing
   */
  getTokenContract(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/tokens/contracts/${r}/${n}`);
    });
  }
  /**
   * Update token visibility
   */
  updateTokenVisibility(t, r, n, s, i) {
    return ur(this, void 0, void 0, function* () {
      return this.put(`/inventory/${t}/tokens/${r}/${n}/${s}`, {
        data: { visible: i.toString() }
      });
    });
  }
  /**
   * Group Filters
   *
   * Convert groups to filter sets for app audiences.
   */
  getGroupFilters(t, r) {
    return ur(this, void 0, void 0, function* () {
      const n = new URLSearchParams();
      r && r.groupIds.forEach((i) => n.append("groupIds", i));
      const s = Object.fromEntries(n);
      return this.get(`/inventory/${t}/groups/groupFilters`, {
        params: s
      });
    });
  }
  /**
   * Group Filters
   *
   * Convert groups to filter sets for app audiences.
   */
  getGroupFiltersByGroupId(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/groups/groupFilters/${r}`);
    });
  }
  /**
   * Create a new group in the inventory
   */
  createGroup(t, r, n, s, i, a) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/groups`, {
        data: {
          contracts: i,
          metadata: r,
          slug: n,
          tokens: s,
          type: a
        }
      });
    });
  }
  /**
   * Get all groups in the inventory with filters
   */
  getGroups(t, r) {
    return ur(this, void 0, void 0, function* () {
      const n = new URLSearchParams();
      r && (r.limit !== void 0 && n.set("limit", r.limit.toString()), r.offset !== void 0 && n.set("offset", r.offset.toString()), r.slug !== void 0 && n.set("slug", r.slug), r.sort !== void 0 && n.set("sort", r.sort), r.type !== void 0 && n.set("type", r.type), r.visibility !== void 0 && n.set("visibility", r.visibility.toString()));
      const s = Object.fromEntries(n);
      return this.get(`/inventory/${t}/groups`, {
        params: s
      });
    });
  }
  /**
   * Get a specific group
   */
  getGroup(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/groups/${r}`);
    });
  }
  /**
   * Delete a group
   */
  deleteGroup(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.delete(`/inventory/${t}/groups/${r}`);
    });
  }
  /**
   *  Updates name or metadata or visibility of a group
   */
  updateGroup(t, r, n, s, i) {
    return ur(this, void 0, void 0, function* () {
      return this.put(`/inventory/${t}/groups/${r}`, {
        data: {
          metadata: s,
          slug: n,
          visibility: i == null ? void 0 : i.toString()
        }
      });
    });
  }
  /**
   * Add tokens to a group
   */
  addTokensToGroup(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/groups/${r}/tokens`, {
        data: { tokens: n }
      });
    });
  }
  /**
   * Remove tokens from a group
   */
  removeTokensFromGroup(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/groups/${r}/tokens/remove`, {
        data: { tokens: n }
      });
    });
  }
  /**
   * Get tokens in a group
   */
  getTokensInGroup(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/groups/${r}/tokens`);
    });
  }
  /**
   * Add contracts to a group
   */
  addContractsToGroup(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/groups/${r}/contracts`, {
        data: { contracts: n }
      });
    });
  }
  /**
   * Remove contracts from a group
   */
  removeContractsFromGroup(t, r, n) {
    return ur(this, void 0, void 0, function* () {
      return this.post(`/inventory/${t}/groups/${r}/contracts/remove`, {
        data: { contracts: n }
      });
    });
  }
  /**
   * Get contracts in a group
   */
  getContractsInGroup(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.get(`/inventory/${t}/groups/${r}/contracts`);
    });
  }
  addContractUpdate(t, r) {
    return ur(this, void 0, void 0, function* () {
      return this.post("/contractUpdates/", {
        data: { contractAddress: r, networkId: t }
      });
    });
  }
}
Qh.InventoryClient = nx;
var a5 = {}, Zh = {};
Object.defineProperty(Zh, "__esModule", { value: !0 });
Zh.InventoryDateSort = void 0;
var Im;
(function(e) {
  e.latest = "latest", e.oldest = "oldest";
})(Im || (Zh.InventoryDateSort = Im = {}));
var u5 = {};
Object.defineProperty(u5, "__esModule", { value: !0 });
var Ku = {};
Object.defineProperty(Ku, "__esModule", { value: !0 });
Ku.CONTRACT_QUERY_LIMIT = Ku.ContractSpec = void 0;
var Rm;
(function(e) {
  e.EIP721 = "eip721", e.EIP1155 = "eip1155";
})(Rm || (Ku.ContractSpec = Rm = {}));
Ku.CONTRACT_QUERY_LIMIT = 1e6;
var Yh = {};
Object.defineProperty(Yh, "__esModule", { value: !0 });
Yh.InventoryGroupTypeArray = void 0;
Yh.InventoryGroupTypeArray = [
  "custom",
  "manifold",
  "token_name",
  "token_fungibility",
  "platform"
];
var Xh = {};
Object.defineProperty(Xh, "__esModule", { value: !0 });
Xh.TOKEN_QUERY_LIMIT = void 0;
Xh.TOKEN_QUERY_LIMIT = 1e6;
var ef = {};
Object.defineProperty(ef, "__esModule", { value: !0 });
ef.CollectorSort = void 0;
var Cm;
(function(e) {
  e.top = "top", e.bottom = "bottom", e.recent = "recent", e.stale = "stale", e.tokens = "tokens";
})(Cm || (ef.CollectorSort = Cm = {}));
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = Ze && Ze.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(Zh, e), r(u5, e), r(Ku, e), r(Yh, e), r(Xh, e), r(ef, e);
})(a5);
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = Ze && Ze.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(Qh, e), r(a5, e);
})(tx);
var _r = {}, Ju = {};
Object.defineProperty(Ju, "__esModule", { value: !0 });
Ju.NULL_BYTES32 = Ju.NULL_ADDRESS = void 0;
Ju.NULL_ADDRESS = "0x0000000000000000000000000000000000000000";
Ju.NULL_BYTES32 = "0x0000000000000000000000000000000000000000000000000000000000000000";
var c5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.removeCookie = e.getCookie = e.setCookie = void 0;
  const t = (s, i, a) => {
    const f = /* @__PURE__ */ new Date();
    f.setTime(f.getTime() + a * 24 * 60 * 60 * 1e3);
    const d = "expires=" + f.toUTCString();
    document.cookie = s + "=" + i + ";" + d + ";path=/";
  };
  e.setCookie = t;
  const r = (s) => {
    const i = s + "=", a = document.cookie.split(";");
    for (let f = 0; f < a.length; f++) {
      let d = a[f];
      for (; d.charAt(0) === " "; )
        d = d.substring(1);
      if (d.indexOf(i) === 0)
        return d.substring(i.length, d.length);
    }
    return "";
  };
  e.getCookie = r;
  const n = (s) => {
    (0, e.setCookie)(s, "", -1);
  };
  e.removeCookie = n;
})(c5);
var Qu = {};
Object.defineProperty(Qu, "__esModule", { value: !0 });
Qu.getCountdownFromTimestamp = Qu.getCountdownFromDuration = void 0;
function l5(e, t = !0, r = !0) {
  const n = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }, s = {
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00"
  };
  if (e > 0) {
    t && (n.days = Math.floor(e / (1e3 * 60 * 60 * 24)), e -= n.days * (1e3 * 60 * 60 * 24)), n.hours = Math.floor(e / (1e3 * 60 * 60)), e -= n.hours * (1e3 * 60 * 60), n.minutes = Math.floor(e / (1e3 * 60)), e -= n.minutes * (1e3 * 60), n.seconds = Math.floor(e / 1e3), e -= n.seconds * 1e3;
    for (const i in n)
      n[i] < 10 ? s[i] = `0${n[i]}` : s[i] = n[i].toString();
  }
  return r ? t ? `${s.days}D : ${s.hours}H : ${s.minutes}M : ${s.seconds}S` : `${s.hours}H : ${s.minutes}M : ${s.seconds}S` : n;
}
Qu.getCountdownFromDuration = l5;
function ix(e, t = !0, r = !0, n = 0) {
  e instanceof Date && (e = e.getTime());
  const s = Math.max(e - (Date.now() + n), 0);
  return l5(s, t, r);
}
Qu.getCountdownFromTimestamp = ix;
var di = {};
const sx = "units/5.7.0", d5 = new Ft(sx), h5 = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function ox(e) {
  const t = String(e).split(".");
  (t.length > 2 || !t[0].match(/^-?[0-9]*$/) || t[1] && !t[1].match(/^[0-9]*$/) || e === "." || e === "-.") && d5.throwArgumentError("invalid value", "value", e);
  let r = t[0], n = "";
  for (r.substring(0, 1) === "-" && (n = "-", r = r.substring(1)); r.substring(0, 1) === "0"; )
    r = r.substring(1);
  r === "" && (r = "0");
  let s = "";
  for (t.length === 2 && (s = "." + (t[1] || "0")); s.length > 2 && s[s.length - 1] === "0"; )
    s = s.substring(0, s.length - 1);
  const i = [];
  for (; r.length; )
    if (r.length <= 3) {
      i.unshift(r);
      break;
    } else {
      const a = r.length - 3;
      i.unshift(r.substring(a)), r = r.substring(0, a);
    }
  return n + i.join(",") + s;
}
function f5(e, t) {
  if (typeof t == "string") {
    const r = h5.indexOf(t);
    r !== -1 && (t = 3 * r);
  }
  return Qd(e, t ?? 18);
}
function p5(e, t) {
  if (typeof e != "string" && d5.throwArgumentError("value must be a string", "value", e), typeof t == "string") {
    const r = h5.indexOf(t);
    r !== -1 && (t = 3 * r);
  }
  return ts(e, t ?? 18);
}
function ax(e) {
  return f5(e, 18);
}
function ux(e) {
  return p5(e, 18);
}
const cx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  commify: ox,
  formatEther: ax,
  formatUnits: f5,
  parseEther: ux,
  parseUnits: p5
}, Symbol.toStringTag, { value: "Module" })), lx = /* @__PURE__ */ Lh(cx);
var g5 = { exports: {} };
(function(e) {
  (function(t) {
    /*!
     *  decimal.js v10.4.3
     *  An arbitrary-precision Decimal type for JavaScript.
     *  https://github.com/MikeMcl/decimal.js
     *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
     *  MIT Licence
     */
    var r = 9e15, n = 1e9, s = "0123456789abcdef", i = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", a = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", f = {
      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed at run-time using the `Decimal.config` method.
      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,
      // 1 to MAX_DIGITS
      // The rounding mode used when rounding to `precision`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,
      // 0 to 8
      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP         0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN  6 The IEEE 754 remainder function.
      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
      //
      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
      // division (9) are commonly used for the modulus operation. The other rounding modes can also
      // be used, but they may not give useful results.
      modulo: 1,
      // 0 to 9
      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,
      // 0 to -EXP_LIMIT
      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos: 21,
      // 0 to EXP_LIMIT
      // The minimum exponent value, beneath which underflow to zero occurs.
      // JavaScript numbers: -324  (5e-324)
      minE: -r,
      // -1 to -EXP_LIMIT
      // The maximum exponent value, above which overflow to Infinity occurs.
      // JavaScript numbers: 308  (1.7976931348623157e+308)
      maxE: r,
      // 1 to EXP_LIMIT
      // Whether to use cryptographically-secure random number generation, if available.
      crypto: !1
      // true/false
    }, d, c, p, g, v = !0, O = "[DecimalError] ", N = O + "Invalid argument: ", S = O + "Precision limit exceeded", j = O + "crypto unavailable", B = "[object Decimal]", M = Math.floor, I = Math.pow, A = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, R = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, L = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, K = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, $ = 1e7, k = 7, V = 9007199254740991, C = i.length - 1, D = a.length - 1, o = { toStringTag: B };
    o.absoluteValue = o.abs = function() {
      var T = new this.constructor(this);
      return T.s < 0 && (T.s = 1), m(T);
    }, o.ceil = function() {
      return m(new this.constructor(this), this.e + 1, 2);
    }, o.clampedTo = o.clamp = function(T, F) {
      var H, z = this, Q = z.constructor;
      if (T = new Q(T), F = new Q(F), !T.s || !F.s)
        return new Q(NaN);
      if (T.gt(F))
        throw Error(N + F);
      return H = z.cmp(T), H < 0 ? T : z.cmp(F) > 0 ? F : new Q(z);
    }, o.comparedTo = o.cmp = function(T) {
      var F, H, z, Q, Z = this, ie = Z.d, he = (T = new Z.constructor(T)).d, J = Z.s, Y = T.s;
      if (!ie || !he)
        return !J || !Y ? NaN : J !== Y ? J : ie === he ? 0 : !ie ^ J < 0 ? 1 : -1;
      if (!ie[0] || !he[0])
        return ie[0] ? J : he[0] ? -Y : 0;
      if (J !== Y)
        return J;
      if (Z.e !== T.e)
        return Z.e > T.e ^ J < 0 ? 1 : -1;
      for (z = ie.length, Q = he.length, F = 0, H = z < Q ? z : Q; F < H; ++F)
        if (ie[F] !== he[F])
          return ie[F] > he[F] ^ J < 0 ? 1 : -1;
      return z === Q ? 0 : z > Q ^ J < 0 ? 1 : -1;
    }, o.cosine = o.cos = function() {
      var T, F, H = this, z = H.constructor;
      return H.d ? H.d[0] ? (T = z.precision, F = z.rounding, z.precision = T + Math.max(H.e, H.sd()) + k, z.rounding = 1, H = P(z, ke(z, H)), z.precision = T, z.rounding = F, m(g == 2 || g == 3 ? H.neg() : H, T, F, !0)) : new z(1) : new z(NaN);
    }, o.cubeRoot = o.cbrt = function() {
      var T, F, H, z, Q, Z, ie, he, J, Y, ee = this, se = ee.constructor;
      if (!ee.isFinite() || ee.isZero())
        return new se(ee);
      for (v = !1, Z = ee.s * I(ee.s * ee, 1 / 3), !Z || Math.abs(Z) == 1 / 0 ? (H = u(ee.d), T = ee.e, (Z = (T - H.length + 1) % 3) && (H += Z == 1 || Z == -2 ? "0" : "00"), Z = I(H, 1 / 3), T = M((T + 1) / 3) - (T % 3 == (T < 0 ? -1 : 2)), Z == 1 / 0 ? H = "5e" + T : (H = Z.toExponential(), H = H.slice(0, H.indexOf("e") + 1) + T), z = new se(H), z.s = ee.s) : z = new se(Z.toString()), ie = (T = se.precision) + 3; ; )
        if (he = z, J = he.times(he).times(he), Y = J.plus(ee), z = w(Y.plus(ee).times(he), Y.plus(J), ie + 2, 1), u(he.d).slice(0, ie) === (H = u(z.d)).slice(0, ie))
          if (H = H.slice(ie - 3, ie + 1), H == "9999" || !Q && H == "4999") {
            if (!Q && (m(he, T + 1, 0), he.times(he).times(he).eq(ee))) {
              z = he;
              break;
            }
            ie += 4, Q = 1;
          } else {
            (!+H || !+H.slice(1) && H.charAt(0) == "5") && (m(z, T + 1, 1), F = !z.times(z).times(z).eq(ee));
            break;
          }
      return v = !0, m(z, T, se.rounding, F);
    }, o.decimalPlaces = o.dp = function() {
      var T, F = this.d, H = NaN;
      if (F) {
        if (T = F.length - 1, H = (T - M(this.e / k)) * k, T = F[T], T)
          for (; T % 10 == 0; T /= 10)
            H--;
        H < 0 && (H = 0);
      }
      return H;
    }, o.dividedBy = o.div = function(T) {
      return w(this, new this.constructor(T));
    }, o.dividedToIntegerBy = o.divToInt = function(T) {
      var F = this, H = F.constructor;
      return m(w(F, new H(T), 0, 1, 1), H.precision, H.rounding);
    }, o.equals = o.eq = function(T) {
      return this.cmp(T) === 0;
    }, o.floor = function() {
      return m(new this.constructor(this), this.e + 1, 3);
    }, o.greaterThan = o.gt = function(T) {
      return this.cmp(T) > 0;
    }, o.greaterThanOrEqualTo = o.gte = function(T) {
      var F = this.cmp(T);
      return F == 1 || F === 0;
    }, o.hyperbolicCosine = o.cosh = function() {
      var T, F, H, z, Q, Z = this, ie = Z.constructor, he = new ie(1);
      if (!Z.isFinite())
        return new ie(Z.s ? 1 / 0 : NaN);
      if (Z.isZero())
        return he;
      H = ie.precision, z = ie.rounding, ie.precision = H + Math.max(Z.e, Z.sd()) + 4, ie.rounding = 1, Q = Z.d.length, Q < 32 ? (T = Math.ceil(Q / 3), F = (1 / we(4, T)).toString()) : (T = 16, F = "2.3283064365386962890625e-10"), Z = ue(ie, 1, Z.times(F), new ie(1), !0);
      for (var J, Y = T, ee = new ie(8); Y--; )
        J = Z.times(Z), Z = he.minus(J.times(ee.minus(J.times(ee))));
      return m(Z, ie.precision = H, ie.rounding = z, !0);
    }, o.hyperbolicSine = o.sinh = function() {
      var T, F, H, z, Q = this, Z = Q.constructor;
      if (!Q.isFinite() || Q.isZero())
        return new Z(Q);
      if (F = Z.precision, H = Z.rounding, Z.precision = F + Math.max(Q.e, Q.sd()) + 4, Z.rounding = 1, z = Q.d.length, z < 3)
        Q = ue(Z, 2, Q, Q, !0);
      else {
        T = 1.4 * Math.sqrt(z), T = T > 16 ? 16 : T | 0, Q = Q.times(1 / we(5, T)), Q = ue(Z, 2, Q, Q, !0);
        for (var ie, he = new Z(5), J = new Z(16), Y = new Z(20); T--; )
          ie = Q.times(Q), Q = Q.times(he.plus(ie.times(J.times(ie).plus(Y))));
      }
      return Z.precision = F, Z.rounding = H, m(Q, F, H, !0);
    }, o.hyperbolicTangent = o.tanh = function() {
      var T, F, H = this, z = H.constructor;
      return H.isFinite() ? H.isZero() ? new z(H) : (T = z.precision, F = z.rounding, z.precision = T + 7, z.rounding = 1, w(H.sinh(), H.cosh(), z.precision = T, z.rounding = F)) : new z(H.s);
    }, o.inverseCosine = o.acos = function() {
      var T, F = this, H = F.constructor, z = F.abs().cmp(1), Q = H.precision, Z = H.rounding;
      return z !== -1 ? z === 0 ? F.isNeg() ? X(H, Q, Z) : new H(0) : new H(NaN) : F.isZero() ? X(H, Q + 4, Z).times(0.5) : (H.precision = Q + 6, H.rounding = 1, F = F.asin(), T = X(H, Q + 4, Z).times(0.5), H.precision = Q, H.rounding = Z, T.minus(F));
    }, o.inverseHyperbolicCosine = o.acosh = function() {
      var T, F, H = this, z = H.constructor;
      return H.lte(1) ? new z(H.eq(1) ? 0 : NaN) : H.isFinite() ? (T = z.precision, F = z.rounding, z.precision = T + Math.max(Math.abs(H.e), H.sd()) + 4, z.rounding = 1, v = !1, H = H.times(H).minus(1).sqrt().plus(H), v = !0, z.precision = T, z.rounding = F, H.ln()) : new z(H);
    }, o.inverseHyperbolicSine = o.asinh = function() {
      var T, F, H = this, z = H.constructor;
      return !H.isFinite() || H.isZero() ? new z(H) : (T = z.precision, F = z.rounding, z.precision = T + 2 * Math.max(Math.abs(H.e), H.sd()) + 6, z.rounding = 1, v = !1, H = H.times(H).plus(1).sqrt().plus(H), v = !0, z.precision = T, z.rounding = F, H.ln());
    }, o.inverseHyperbolicTangent = o.atanh = function() {
      var T, F, H, z, Q = this, Z = Q.constructor;
      return Q.isFinite() ? Q.e >= 0 ? new Z(Q.abs().eq(1) ? Q.s / 0 : Q.isZero() ? Q : NaN) : (T = Z.precision, F = Z.rounding, z = Q.sd(), Math.max(z, T) < 2 * -Q.e - 1 ? m(new Z(Q), T, F, !0) : (Z.precision = H = z - Q.e, Q = w(Q.plus(1), new Z(1).minus(Q), H + T, 1), Z.precision = T + 4, Z.rounding = 1, Q = Q.ln(), Z.precision = T, Z.rounding = F, Q.times(0.5))) : new Z(NaN);
    }, o.inverseSine = o.asin = function() {
      var T, F, H, z, Q = this, Z = Q.constructor;
      return Q.isZero() ? new Z(Q) : (F = Q.abs().cmp(1), H = Z.precision, z = Z.rounding, F !== -1 ? F === 0 ? (T = X(Z, H + 4, z).times(0.5), T.s = Q.s, T) : new Z(NaN) : (Z.precision = H + 6, Z.rounding = 1, Q = Q.div(new Z(1).minus(Q.times(Q)).sqrt().plus(1)).atan(), Z.precision = H, Z.rounding = z, Q.times(2)));
    }, o.inverseTangent = o.atan = function() {
      var T, F, H, z, Q, Z, ie, he, J, Y = this, ee = Y.constructor, se = ee.precision, le = ee.rounding;
      if (Y.isFinite()) {
        if (Y.isZero())
          return new ee(Y);
        if (Y.abs().eq(1) && se + 4 <= D)
          return ie = X(ee, se + 4, le).times(0.25), ie.s = Y.s, ie;
      } else {
        if (!Y.s)
          return new ee(NaN);
        if (se + 4 <= D)
          return ie = X(ee, se + 4, le).times(0.5), ie.s = Y.s, ie;
      }
      for (ee.precision = he = se + 10, ee.rounding = 1, H = Math.min(28, he / k + 2 | 0), T = H; T; --T)
        Y = Y.div(Y.times(Y).plus(1).sqrt().plus(1));
      for (v = !1, F = Math.ceil(he / k), z = 1, J = Y.times(Y), ie = new ee(Y), Q = Y; T !== -1; )
        if (Q = Q.times(J), Z = ie.minus(Q.div(z += 2)), Q = Q.times(J), ie = Z.plus(Q.div(z += 2)), ie.d[F] !== void 0)
          for (T = F; ie.d[T] === Z.d[T] && T--; )
            ;
      return H && (ie = ie.times(2 << H - 1)), v = !0, m(ie, ee.precision = se, ee.rounding = le, !0);
    }, o.isFinite = function() {
      return !!this.d;
    }, o.isInteger = o.isInt = function() {
      return !!this.d && M(this.e / k) > this.d.length - 2;
    }, o.isNaN = function() {
      return !this.s;
    }, o.isNegative = o.isNeg = function() {
      return this.s < 0;
    }, o.isPositive = o.isPos = function() {
      return this.s > 0;
    }, o.isZero = function() {
      return !!this.d && this.d[0] === 0;
    }, o.lessThan = o.lt = function(T) {
      return this.cmp(T) < 0;
    }, o.lessThanOrEqualTo = o.lte = function(T) {
      return this.cmp(T) < 1;
    }, o.logarithm = o.log = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y = this, ee = Y.constructor, se = ee.precision, le = ee.rounding, Ae = 5;
      if (T == null)
        T = new ee(10), F = !0;
      else {
        if (T = new ee(T), H = T.d, T.s < 0 || !H || !H[0] || T.eq(1))
          return new ee(NaN);
        F = T.eq(10);
      }
      if (H = Y.d, Y.s < 0 || !H || !H[0] || Y.eq(1))
        return new ee(H && !H[0] ? -1 / 0 : Y.s != 1 ? NaN : H ? 0 : 1 / 0);
      if (F)
        if (H.length > 1)
          Z = !0;
        else {
          for (Q = H[0]; Q % 10 === 0; )
            Q /= 10;
          Z = Q !== 1;
        }
      if (v = !1, he = se + Ae, ie = Pe(Y, he), z = F ? W(ee, he + 10) : Pe(T, he), J = w(ie, z, he, 1), y(J.d, Q = se, le))
        do
          if (he += 10, ie = Pe(Y, he), z = F ? W(ee, he + 10) : Pe(T, he), J = w(ie, z, he, 1), !Z) {
            +u(J.d).slice(Q + 1, Q + 15) + 1 == 1e14 && (J = m(J, se + 1, 0));
            break;
          }
        while (y(J.d, Q += 10, le));
      return v = !0, m(J, se, le);
    }, o.minus = o.sub = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y, ee, se, le, Ae = this, Te = Ae.constructor;
      if (T = new Te(T), !Ae.d || !T.d)
        return !Ae.s || !T.s ? T = new Te(NaN) : Ae.d ? T.s = -T.s : T = new Te(T.d || Ae.s !== T.s ? Ae : NaN), T;
      if (Ae.s != T.s)
        return T.s = -T.s, Ae.plus(T);
      if (Y = Ae.d, le = T.d, he = Te.precision, J = Te.rounding, !Y[0] || !le[0]) {
        if (le[0])
          T.s = -T.s;
        else if (Y[0])
          T = new Te(Ae);
        else
          return new Te(J === 3 ? -0 : 0);
        return v ? m(T, he, J) : T;
      }
      if (H = M(T.e / k), ee = M(Ae.e / k), Y = Y.slice(), Z = ee - H, Z) {
        for (se = Z < 0, se ? (F = Y, Z = -Z, ie = le.length) : (F = le, H = ee, ie = Y.length), z = Math.max(Math.ceil(he / k), ie) + 2, Z > z && (Z = z, F.length = 1), F.reverse(), z = Z; z--; )
          F.push(0);
        F.reverse();
      } else {
        for (z = Y.length, ie = le.length, se = z < ie, se && (ie = z), z = 0; z < ie; z++)
          if (Y[z] != le[z]) {
            se = Y[z] < le[z];
            break;
          }
        Z = 0;
      }
      for (se && (F = Y, Y = le, le = F, T.s = -T.s), ie = Y.length, z = le.length - ie; z > 0; --z)
        Y[ie++] = 0;
      for (z = le.length; z > Z; ) {
        if (Y[--z] < le[z]) {
          for (Q = z; Q && Y[--Q] === 0; )
            Y[Q] = $ - 1;
          --Y[Q], Y[z] += $;
        }
        Y[z] -= le[z];
      }
      for (; Y[--ie] === 0; )
        Y.pop();
      for (; Y[0] === 0; Y.shift())
        --H;
      return Y[0] ? (T.d = Y, T.e = b(Y, H), v ? m(T, he, J) : T) : new Te(J === 3 ? -0 : 0);
    }, o.modulo = o.mod = function(T) {
      var F, H = this, z = H.constructor;
      return T = new z(T), !H.d || !T.s || T.d && !T.d[0] ? new z(NaN) : !T.d || H.d && !H.d[0] ? m(new z(H), z.precision, z.rounding) : (v = !1, z.modulo == 9 ? (F = w(H, T.abs(), 0, 3, 1), F.s *= T.s) : F = w(H, T, 0, z.modulo, 1), F = F.times(T), v = !0, H.minus(F));
    }, o.naturalExponential = o.exp = function() {
      return Ee(this);
    }, o.naturalLogarithm = o.ln = function() {
      return Pe(this);
    }, o.negated = o.neg = function() {
      var T = new this.constructor(this);
      return T.s = -T.s, m(T);
    }, o.plus = o.add = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y, ee, se = this, le = se.constructor;
      if (T = new le(T), !se.d || !T.d)
        return !se.s || !T.s ? T = new le(NaN) : se.d || (T = new le(T.d || se.s === T.s ? se : NaN)), T;
      if (se.s != T.s)
        return T.s = -T.s, se.minus(T);
      if (Y = se.d, ee = T.d, he = le.precision, J = le.rounding, !Y[0] || !ee[0])
        return ee[0] || (T = new le(se)), v ? m(T, he, J) : T;
      if (Z = M(se.e / k), z = M(T.e / k), Y = Y.slice(), Q = Z - z, Q) {
        for (Q < 0 ? (H = Y, Q = -Q, ie = ee.length) : (H = ee, z = Z, ie = Y.length), Z = Math.ceil(he / k), ie = Z > ie ? Z + 1 : ie + 1, Q > ie && (Q = ie, H.length = 1), H.reverse(); Q--; )
          H.push(0);
        H.reverse();
      }
      for (ie = Y.length, Q = ee.length, ie - Q < 0 && (Q = ie, H = ee, ee = Y, Y = H), F = 0; Q; )
        F = (Y[--Q] = Y[Q] + ee[Q] + F) / $ | 0, Y[Q] %= $;
      for (F && (Y.unshift(F), ++z), ie = Y.length; Y[--ie] == 0; )
        Y.pop();
      return T.d = Y, T.e = b(Y, z), v ? m(T, he, J) : T;
    }, o.precision = o.sd = function(T) {
      var F, H = this;
      if (T !== void 0 && T !== !!T && T !== 1 && T !== 0)
        throw Error(N + T);
      return H.d ? (F = G(H.d), T && H.e + 1 > F && (F = H.e + 1)) : F = NaN, F;
    }, o.round = function() {
      var T = this, F = T.constructor;
      return m(new F(T), T.e + 1, F.rounding);
    }, o.sine = o.sin = function() {
      var T, F, H = this, z = H.constructor;
      return H.isFinite() ? H.isZero() ? new z(H) : (T = z.precision, F = z.rounding, z.precision = T + Math.max(H.e, H.sd()) + k, z.rounding = 1, H = U(z, ke(z, H)), z.precision = T, z.rounding = F, m(g > 2 ? H.neg() : H, T, F, !0)) : new z(NaN);
    }, o.squareRoot = o.sqrt = function() {
      var T, F, H, z, Q, Z, ie = this, he = ie.d, J = ie.e, Y = ie.s, ee = ie.constructor;
      if (Y !== 1 || !he || !he[0])
        return new ee(!Y || Y < 0 && (!he || he[0]) ? NaN : he ? ie : 1 / 0);
      for (v = !1, Y = Math.sqrt(+ie), Y == 0 || Y == 1 / 0 ? (F = u(he), (F.length + J) % 2 == 0 && (F += "0"), Y = Math.sqrt(F), J = M((J + 1) / 2) - (J < 0 || J % 2), Y == 1 / 0 ? F = "5e" + J : (F = Y.toExponential(), F = F.slice(0, F.indexOf("e") + 1) + J), z = new ee(F)) : z = new ee(Y.toString()), H = (J = ee.precision) + 3; ; )
        if (Z = z, z = Z.plus(w(ie, Z, H + 2, 1)).times(0.5), u(Z.d).slice(0, H) === (F = u(z.d)).slice(0, H))
          if (F = F.slice(H - 3, H + 1), F == "9999" || !Q && F == "4999") {
            if (!Q && (m(Z, J + 1, 0), Z.times(Z).eq(ie))) {
              z = Z;
              break;
            }
            H += 4, Q = 1;
          } else {
            (!+F || !+F.slice(1) && F.charAt(0) == "5") && (m(z, J + 1, 1), T = !z.times(z).eq(ie));
            break;
          }
      return v = !0, m(z, J, ee.rounding, T);
    }, o.tangent = o.tan = function() {
      var T, F, H = this, z = H.constructor;
      return H.isFinite() ? H.isZero() ? new z(H) : (T = z.precision, F = z.rounding, z.precision = T + 10, z.rounding = 1, H = H.sin(), H.s = 1, H = w(H, new z(1).minus(H.times(H)).sqrt(), T + 10, 0), z.precision = T, z.rounding = F, m(g == 2 || g == 4 ? H.neg() : H, T, F, !0)) : new z(NaN);
    }, o.times = o.mul = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y, ee = this, se = ee.constructor, le = ee.d, Ae = (T = new se(T)).d;
      if (T.s *= ee.s, !le || !le[0] || !Ae || !Ae[0])
        return new se(!T.s || le && !le[0] && !Ae || Ae && !Ae[0] && !le ? NaN : !le || !Ae ? T.s / 0 : T.s * 0);
      for (H = M(ee.e / k) + M(T.e / k), J = le.length, Y = Ae.length, J < Y && (Z = le, le = Ae, Ae = Z, ie = J, J = Y, Y = ie), Z = [], ie = J + Y, z = ie; z--; )
        Z.push(0);
      for (z = Y; --z >= 0; ) {
        for (F = 0, Q = J + z; Q > z; )
          he = Z[Q] + Ae[z] * le[Q - z - 1] + F, Z[Q--] = he % $ | 0, F = he / $ | 0;
        Z[Q] = (Z[Q] + F) % $ | 0;
      }
      for (; !Z[--ie]; )
        Z.pop();
      return F ? ++H : Z.shift(), T.d = Z, T.e = b(Z, H), v ? m(T, se.precision, se.rounding) : T;
    }, o.toBinary = function(T, F) {
      return Re(this, 2, T, F);
    }, o.toDecimalPlaces = o.toDP = function(T, F) {
      var H = this, z = H.constructor;
      return H = new z(H), T === void 0 ? H : (h(T, 0, n), F === void 0 ? F = z.rounding : h(F, 0, 8), m(H, T + H.e + 1, F));
    }, o.toExponential = function(T, F) {
      var H, z = this, Q = z.constructor;
      return T === void 0 ? H = l(z, !0) : (h(T, 0, n), F === void 0 ? F = Q.rounding : h(F, 0, 8), z = m(new Q(z), T + 1, F), H = l(z, !0, T + 1)), z.isNeg() && !z.isZero() ? "-" + H : H;
    }, o.toFixed = function(T, F) {
      var H, z, Q = this, Z = Q.constructor;
      return T === void 0 ? H = l(Q) : (h(T, 0, n), F === void 0 ? F = Z.rounding : h(F, 0, 8), z = m(new Z(Q), T + Q.e + 1, F), H = l(z, !1, T + z.e + 1)), Q.isNeg() && !Q.isZero() ? "-" + H : H;
    }, o.toFraction = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y, ee, se, le, Ae = this, Te = Ae.d, Ie = Ae.constructor;
      if (!Te)
        return new Ie(Ae);
      if (Y = H = new Ie(1), z = J = new Ie(0), F = new Ie(z), Z = F.e = G(Te) - Ae.e - 1, ie = Z % k, F.d[0] = I(10, ie < 0 ? k + ie : ie), T == null)
        T = Z > 0 ? F : Y;
      else {
        if (he = new Ie(T), !he.isInt() || he.lt(Y))
          throw Error(N + he);
        T = he.gt(F) ? Z > 0 ? F : Y : he;
      }
      for (v = !1, he = new Ie(u(Te)), ee = Ie.precision, Ie.precision = Z = Te.length * k * 2; se = w(he, F, 0, 1, 1), Q = H.plus(se.times(z)), Q.cmp(T) != 1; )
        H = z, z = Q, Q = Y, Y = J.plus(se.times(Q)), J = Q, Q = F, F = he.minus(se.times(Q)), he = Q;
      return Q = w(T.minus(H), z, 0, 1, 1), J = J.plus(Q.times(Y)), H = H.plus(Q.times(z)), J.s = Y.s = Ae.s, le = w(Y, z, Z, 1).minus(Ae).abs().cmp(w(J, H, Z, 1).minus(Ae).abs()) < 1 ? [Y, z] : [J, H], Ie.precision = ee, v = !0, le;
    }, o.toHexadecimal = o.toHex = function(T, F) {
      return Re(this, 16, T, F);
    }, o.toNearest = function(T, F) {
      var H = this, z = H.constructor;
      if (H = new z(H), T == null) {
        if (!H.d)
          return H;
        T = new z(1), F = z.rounding;
      } else {
        if (T = new z(T), F === void 0 ? F = z.rounding : h(F, 0, 8), !H.d)
          return T.s ? H : T;
        if (!T.d)
          return T.s && (T.s = H.s), T;
      }
      return T.d[0] ? (v = !1, H = w(H, T, 0, F, 1).times(T), v = !0, m(H)) : (T.s = H.s, H = T), H;
    }, o.toNumber = function() {
      return +this;
    }, o.toOctal = function(T, F) {
      return Re(this, 8, T, F);
    }, o.toPower = o.pow = function(T) {
      var F, H, z, Q, Z, ie, he = this, J = he.constructor, Y = +(T = new J(T));
      if (!he.d || !T.d || !he.d[0] || !T.d[0])
        return new J(I(+he, Y));
      if (he = new J(he), he.eq(1))
        return he;
      if (z = J.precision, Z = J.rounding, T.eq(1))
        return m(he, z, Z);
      if (F = M(T.e / k), F >= T.d.length - 1 && (H = Y < 0 ? -Y : Y) <= V)
        return Q = ce(J, he, H, z), T.s < 0 ? new J(1).div(Q) : m(Q, z, Z);
      if (ie = he.s, ie < 0) {
        if (F < T.d.length - 1)
          return new J(NaN);
        if (T.d[F] & 1 || (ie = 1), he.e == 0 && he.d[0] == 1 && he.d.length == 1)
          return he.s = ie, he;
      }
      return H = I(+he, Y), F = H == 0 || !isFinite(H) ? M(Y * (Math.log("0." + u(he.d)) / Math.LN10 + he.e + 1)) : new J(H + "").e, F > J.maxE + 1 || F < J.minE - 1 ? new J(F > 0 ? ie / 0 : 0) : (v = !1, J.rounding = he.s = 1, H = Math.min(12, (F + "").length), Q = Ee(T.times(Pe(he, z + H)), z), Q.d && (Q = m(Q, z + 5, 1), y(Q.d, z, Z) && (F = z + 10, Q = m(Ee(T.times(Pe(he, F + H)), F), F + 5, 1), +u(Q.d).slice(z + 1, z + 15) + 1 == 1e14 && (Q = m(Q, z + 1, 0)))), Q.s = ie, v = !0, J.rounding = Z, m(Q, z, Z));
    }, o.toPrecision = function(T, F) {
      var H, z = this, Q = z.constructor;
      return T === void 0 ? H = l(z, z.e <= Q.toExpNeg || z.e >= Q.toExpPos) : (h(T, 1, n), F === void 0 ? F = Q.rounding : h(F, 0, 8), z = m(new Q(z), T, F), H = l(z, T <= z.e || z.e <= Q.toExpNeg, T)), z.isNeg() && !z.isZero() ? "-" + H : H;
    }, o.toSignificantDigits = o.toSD = function(T, F) {
      var H = this, z = H.constructor;
      return T === void 0 ? (T = z.precision, F = z.rounding) : (h(T, 1, n), F === void 0 ? F = z.rounding : h(F, 0, 8)), m(new z(H), T, F);
    }, o.toString = function() {
      var T = this, F = T.constructor, H = l(T, T.e <= F.toExpNeg || T.e >= F.toExpPos);
      return T.isNeg() && !T.isZero() ? "-" + H : H;
    }, o.truncated = o.trunc = function() {
      return m(new this.constructor(this), this.e + 1, 1);
    }, o.valueOf = o.toJSON = function() {
      var T = this, F = T.constructor, H = l(T, T.e <= F.toExpNeg || T.e >= F.toExpPos);
      return T.isNeg() ? "-" + H : H;
    };
    function u(T) {
      var F, H, z, Q = T.length - 1, Z = "", ie = T[0];
      if (Q > 0) {
        for (Z += ie, F = 1; F < Q; F++)
          z = T[F] + "", H = k - z.length, H && (Z += re(H)), Z += z;
        ie = T[F], z = ie + "", H = k - z.length, H && (Z += re(H));
      } else if (ie === 0)
        return "0";
      for (; ie % 10 === 0; )
        ie /= 10;
      return Z + ie;
    }
    function h(T, F, H) {
      if (T !== ~~T || T < F || T > H)
        throw Error(N + T);
    }
    function y(T, F, H, z) {
      var Q, Z, ie, he;
      for (Z = T[0]; Z >= 10; Z /= 10)
        --F;
      return --F < 0 ? (F += k, Q = 0) : (Q = Math.ceil((F + 1) / k), F %= k), Z = I(10, k - F), he = T[Q] % Z | 0, z == null ? F < 3 ? (F == 0 ? he = he / 100 | 0 : F == 1 && (he = he / 10 | 0), ie = H < 4 && he == 99999 || H > 3 && he == 49999 || he == 5e4 || he == 0) : ie = (H < 4 && he + 1 == Z || H > 3 && he + 1 == Z / 2) && (T[Q + 1] / Z / 100 | 0) == I(10, F - 2) - 1 || (he == Z / 2 || he == 0) && (T[Q + 1] / Z / 100 | 0) == 0 : F < 4 ? (F == 0 ? he = he / 1e3 | 0 : F == 1 ? he = he / 100 | 0 : F == 2 && (he = he / 10 | 0), ie = (z || H < 4) && he == 9999 || !z && H > 3 && he == 4999) : ie = ((z || H < 4) && he + 1 == Z || !z && H > 3 && he + 1 == Z / 2) && (T[Q + 1] / Z / 1e3 | 0) == I(10, F - 3) - 1, ie;
    }
    function E(T, F, H) {
      for (var z, Q = [0], Z, ie = 0, he = T.length; ie < he; ) {
        for (Z = Q.length; Z--; )
          Q[Z] *= F;
        for (Q[0] += s.indexOf(T.charAt(ie++)), z = 0; z < Q.length; z++)
          Q[z] > H - 1 && (Q[z + 1] === void 0 && (Q[z + 1] = 0), Q[z + 1] += Q[z] / H | 0, Q[z] %= H);
      }
      return Q.reverse();
    }
    function P(T, F) {
      var H, z, Q;
      if (F.isZero())
        return F;
      z = F.d.length, z < 32 ? (H = Math.ceil(z / 3), Q = (1 / we(4, H)).toString()) : (H = 16, Q = "2.3283064365386962890625e-10"), T.precision += H, F = ue(T, 1, F.times(Q), new T(1));
      for (var Z = H; Z--; ) {
        var ie = F.times(F);
        F = ie.times(ie).minus(ie).times(8).plus(1);
      }
      return T.precision -= H, F;
    }
    var w = /* @__PURE__ */ function() {
      function T(z, Q, Z) {
        var ie, he = 0, J = z.length;
        for (z = z.slice(); J--; )
          ie = z[J] * Q + he, z[J] = ie % Z | 0, he = ie / Z | 0;
        return he && z.unshift(he), z;
      }
      function F(z, Q, Z, ie) {
        var he, J;
        if (Z != ie)
          J = Z > ie ? 1 : -1;
        else
          for (he = J = 0; he < Z; he++)
            if (z[he] != Q[he]) {
              J = z[he] > Q[he] ? 1 : -1;
              break;
            }
        return J;
      }
      function H(z, Q, Z, ie) {
        for (var he = 0; Z--; )
          z[Z] -= he, he = z[Z] < Q[Z] ? 1 : 0, z[Z] = he * ie + z[Z] - Q[Z];
        for (; !z[0] && z.length > 1; )
          z.shift();
      }
      return function(z, Q, Z, ie, he, J) {
        var Y, ee, se, le, Ae, Te, Ie, We, Ke, Le, De, Ge, Ct, Mt, Lt, Jt, pr, Hr, gr, $r, wr = z.constructor, Cr = z.s == Q.s ? 1 : -1, er = z.d, ht = Q.d;
        if (!er || !er[0] || !ht || !ht[0])
          return new wr(
            // Return NaN if either NaN, or both Infinity or 0.
            !z.s || !Q.s || (er ? ht && er[0] == ht[0] : !ht) ? NaN : (
              // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
              er && er[0] == 0 || !ht ? Cr * 0 : Cr / 0
            )
          );
        for (J ? (Ae = 1, ee = z.e - Q.e) : (J = $, Ae = k, ee = M(z.e / Ae) - M(Q.e / Ae)), gr = ht.length, pr = er.length, Ke = new wr(Cr), Le = Ke.d = [], se = 0; ht[se] == (er[se] || 0); se++)
          ;
        if (ht[se] > (er[se] || 0) && ee--, Z == null ? (Mt = Z = wr.precision, ie = wr.rounding) : he ? Mt = Z + (z.e - Q.e) + 1 : Mt = Z, Mt < 0)
          Le.push(1), Te = !0;
        else {
          if (Mt = Mt / Ae + 2 | 0, se = 0, gr == 1) {
            for (le = 0, ht = ht[0], Mt++; (se < pr || le) && Mt--; se++)
              Lt = le * J + (er[se] || 0), Le[se] = Lt / ht | 0, le = Lt % ht | 0;
            Te = le || se < pr;
          } else {
            for (le = J / (ht[0] + 1) | 0, le > 1 && (ht = T(ht, le, J), er = T(er, le, J), gr = ht.length, pr = er.length), Jt = gr, De = er.slice(0, gr), Ge = De.length; Ge < gr; )
              De[Ge++] = 0;
            $r = ht.slice(), $r.unshift(0), Hr = ht[0], ht[1] >= J / 2 && ++Hr;
            do
              le = 0, Y = F(ht, De, gr, Ge), Y < 0 ? (Ct = De[0], gr != Ge && (Ct = Ct * J + (De[1] || 0)), le = Ct / Hr | 0, le > 1 ? (le >= J && (le = J - 1), Ie = T(ht, le, J), We = Ie.length, Ge = De.length, Y = F(Ie, De, We, Ge), Y == 1 && (le--, H(Ie, gr < We ? $r : ht, We, J))) : (le == 0 && (Y = le = 1), Ie = ht.slice()), We = Ie.length, We < Ge && Ie.unshift(0), H(De, Ie, Ge, J), Y == -1 && (Ge = De.length, Y = F(ht, De, gr, Ge), Y < 1 && (le++, H(De, gr < Ge ? $r : ht, Ge, J))), Ge = De.length) : Y === 0 && (le++, De = [0]), Le[se++] = le, Y && De[0] ? De[Ge++] = er[Jt] || 0 : (De = [er[Jt]], Ge = 1);
            while ((Jt++ < pr || De[0] !== void 0) && Mt--);
            Te = De[0] !== void 0;
          }
          Le[0] || Le.shift();
        }
        if (Ae == 1)
          Ke.e = ee, c = Te;
        else {
          for (se = 1, le = Le[0]; le >= 10; le /= 10)
            se++;
          Ke.e = se + ee * Ae - 1, m(Ke, he ? Z + Ke.e + 1 : Z, ie, Te);
        }
        return Ke;
      };
    }();
    function m(T, F, H, z) {
      var Q, Z, ie, he, J, Y, ee, se, le, Ae = T.constructor;
      e:
        if (F != null) {
          if (se = T.d, !se)
            return T;
          for (Q = 1, he = se[0]; he >= 10; he /= 10)
            Q++;
          if (Z = F - Q, Z < 0)
            Z += k, ie = F, ee = se[le = 0], J = ee / I(10, Q - ie - 1) % 10 | 0;
          else if (le = Math.ceil((Z + 1) / k), he = se.length, le >= he)
            if (z) {
              for (; he++ <= le; )
                se.push(0);
              ee = J = 0, Q = 1, Z %= k, ie = Z - k + 1;
            } else
              break e;
          else {
            for (ee = he = se[le], Q = 1; he >= 10; he /= 10)
              Q++;
            Z %= k, ie = Z - k + Q, J = ie < 0 ? 0 : ee / I(10, Q - ie - 1) % 10 | 0;
          }
          if (z = z || F < 0 || se[le + 1] !== void 0 || (ie < 0 ? ee : ee % I(10, Q - ie - 1)), Y = H < 4 ? (J || z) && (H == 0 || H == (T.s < 0 ? 3 : 2)) : J > 5 || J == 5 && (H == 4 || z || H == 6 && // Check whether the digit to the left of the rounding digit is odd.
          (Z > 0 ? ie > 0 ? ee / I(10, Q - ie) : 0 : se[le - 1]) % 10 & 1 || H == (T.s < 0 ? 8 : 7)), F < 1 || !se[0])
            return se.length = 0, Y ? (F -= T.e + 1, se[0] = I(10, (k - F % k) % k), T.e = -F || 0) : se[0] = T.e = 0, T;
          if (Z == 0 ? (se.length = le, he = 1, le--) : (se.length = le + 1, he = I(10, k - Z), se[le] = ie > 0 ? (ee / I(10, Q - ie) % I(10, ie) | 0) * he : 0), Y)
            for (; ; )
              if (le == 0) {
                for (Z = 1, ie = se[0]; ie >= 10; ie /= 10)
                  Z++;
                for (ie = se[0] += he, he = 1; ie >= 10; ie /= 10)
                  he++;
                Z != he && (T.e++, se[0] == $ && (se[0] = 1));
                break;
              } else {
                if (se[le] += he, se[le] != $)
                  break;
                se[le--] = 0, he = 1;
              }
          for (Z = se.length; se[--Z] === 0; )
            se.pop();
        }
      return v && (T.e > Ae.maxE ? (T.d = null, T.e = NaN) : T.e < Ae.minE && (T.e = 0, T.d = [0])), T;
    }
    function l(T, F, H) {
      if (!T.isFinite())
        return xe(T);
      var z, Q = T.e, Z = u(T.d), ie = Z.length;
      return F ? (H && (z = H - ie) > 0 ? Z = Z.charAt(0) + "." + Z.slice(1) + re(z) : ie > 1 && (Z = Z.charAt(0) + "." + Z.slice(1)), Z = Z + (T.e < 0 ? "e" : "e+") + T.e) : Q < 0 ? (Z = "0." + re(-Q - 1) + Z, H && (z = H - ie) > 0 && (Z += re(z))) : Q >= ie ? (Z += re(Q + 1 - ie), H && (z = H - Q - 1) > 0 && (Z = Z + "." + re(z))) : ((z = Q + 1) < ie && (Z = Z.slice(0, z) + "." + Z.slice(z)), H && (z = H - ie) > 0 && (Q + 1 === ie && (Z += "."), Z += re(z))), Z;
    }
    function b(T, F) {
      var H = T[0];
      for (F *= k; H >= 10; H /= 10)
        F++;
      return F;
    }
    function W(T, F, H) {
      if (F > C)
        throw v = !0, H && (T.precision = H), Error(S);
      return m(new T(i), F, 1, !0);
    }
    function X(T, F, H) {
      if (F > D)
        throw Error(S);
      return m(new T(a), F, H, !0);
    }
    function G(T) {
      var F = T.length - 1, H = F * k + 1;
      if (F = T[F], F) {
        for (; F % 10 == 0; F /= 10)
          H--;
        for (F = T[0]; F >= 10; F /= 10)
          H++;
      }
      return H;
    }
    function re(T) {
      for (var F = ""; T--; )
        F += "0";
      return F;
    }
    function ce(T, F, H, z) {
      var Q, Z = new T(1), ie = Math.ceil(z / k + 4);
      for (v = !1; ; ) {
        if (H % 2 && (Z = Z.times(F), fe(Z.d, ie) && (Q = !0)), H = M(H / 2), H === 0) {
          H = Z.d.length - 1, Q && Z.d[H] === 0 && ++Z.d[H];
          break;
        }
        F = F.times(F), fe(F.d, ie);
      }
      return v = !0, Z;
    }
    function pe(T) {
      return T.d[T.d.length - 1] & 1;
    }
    function ve(T, F, H) {
      for (var z, Q = new T(F[0]), Z = 0; ++Z < F.length; )
        if (z = new T(F[Z]), z.s)
          Q[H](z) && (Q = z);
        else {
          Q = z;
          break;
        }
      return Q;
    }
    function Ee(T, F) {
      var H, z, Q, Z, ie, he, J, Y = 0, ee = 0, se = 0, le = T.constructor, Ae = le.rounding, Te = le.precision;
      if (!T.d || !T.d[0] || T.e > 17)
        return new le(T.d ? T.d[0] ? T.s < 0 ? 0 : 1 / 0 : 1 : T.s ? T.s < 0 ? 0 : T : NaN);
      for (F == null ? (v = !1, J = Te) : J = F, he = new le(0.03125); T.e > -2; )
        T = T.times(he), se += 5;
      for (z = Math.log(I(2, se)) / Math.LN10 * 2 + 5 | 0, J += z, H = Z = ie = new le(1), le.precision = J; ; ) {
        if (Z = m(Z.times(T), J, 1), H = H.times(++ee), he = ie.plus(w(Z, H, J, 1)), u(he.d).slice(0, J) === u(ie.d).slice(0, J)) {
          for (Q = se; Q--; )
            ie = m(ie.times(ie), J, 1);
          if (F == null)
            if (Y < 3 && y(ie.d, J - z, Ae, Y))
              le.precision = J += 10, H = Z = he = new le(1), ee = 0, Y++;
            else
              return m(ie, le.precision = Te, Ae, v = !0);
          else
            return le.precision = Te, ie;
        }
        ie = he;
      }
    }
    function Pe(T, F) {
      var H, z, Q, Z, ie, he, J, Y, ee, se, le, Ae = 1, Te = 10, Ie = T, We = Ie.d, Ke = Ie.constructor, Le = Ke.rounding, De = Ke.precision;
      if (Ie.s < 0 || !We || !We[0] || !Ie.e && We[0] == 1 && We.length == 1)
        return new Ke(We && !We[0] ? -1 / 0 : Ie.s != 1 ? NaN : We ? 0 : Ie);
      if (F == null ? (v = !1, ee = De) : ee = F, Ke.precision = ee += Te, H = u(We), z = H.charAt(0), Math.abs(Z = Ie.e) < 15e14) {
        for (; z < 7 && z != 1 || z == 1 && H.charAt(1) > 3; )
          Ie = Ie.times(T), H = u(Ie.d), z = H.charAt(0), Ae++;
        Z = Ie.e, z > 1 ? (Ie = new Ke("0." + H), Z++) : Ie = new Ke(z + "." + H.slice(1));
      } else
        return Y = W(Ke, ee + 2, De).times(Z + ""), Ie = Pe(new Ke(z + "." + H.slice(1)), ee - Te).plus(Y), Ke.precision = De, F == null ? m(Ie, De, Le, v = !0) : Ie;
      for (se = Ie, J = ie = Ie = w(Ie.minus(1), Ie.plus(1), ee, 1), le = m(Ie.times(Ie), ee, 1), Q = 3; ; ) {
        if (ie = m(ie.times(le), ee, 1), Y = J.plus(w(ie, new Ke(Q), ee, 1)), u(Y.d).slice(0, ee) === u(J.d).slice(0, ee))
          if (J = J.times(2), Z !== 0 && (J = J.plus(W(Ke, ee + 2, De).times(Z + ""))), J = w(J, new Ke(Ae), ee, 1), F == null)
            if (y(J.d, ee - Te, Le, he))
              Ke.precision = ee += Te, Y = ie = Ie = w(se.minus(1), se.plus(1), ee, 1), le = m(Ie.times(Ie), ee, 1), Q = he = 1;
            else
              return m(J, Ke.precision = De, Le, v = !0);
          else
            return Ke.precision = De, J;
        J = Y, Q += 2;
      }
    }
    function xe(T) {
      return String(T.s * T.s / 0);
    }
    function me(T, F) {
      var H, z, Q;
      for ((H = F.indexOf(".")) > -1 && (F = F.replace(".", "")), (z = F.search(/e/i)) > 0 ? (H < 0 && (H = z), H += +F.slice(z + 1), F = F.substring(0, z)) : H < 0 && (H = F.length), z = 0; F.charCodeAt(z) === 48; z++)
        ;
      for (Q = F.length; F.charCodeAt(Q - 1) === 48; --Q)
        ;
      if (F = F.slice(z, Q), F) {
        if (Q -= z, T.e = H = H - z - 1, T.d = [], z = (H + 1) % k, H < 0 && (z += k), z < Q) {
          for (z && T.d.push(+F.slice(0, z)), Q -= k; z < Q; )
            T.d.push(+F.slice(z, z += k));
          F = F.slice(z), z = k - F.length;
        } else
          z -= Q;
        for (; z--; )
          F += "0";
        T.d.push(+F), v && (T.e > T.constructor.maxE ? (T.d = null, T.e = NaN) : T.e < T.constructor.minE && (T.e = 0, T.d = [0]));
      } else
        T.e = 0, T.d = [0];
      return T;
    }
    function te(T, F) {
      var H, z, Q, Z, ie, he, J, Y, ee;
      if (F.indexOf("_") > -1) {
        if (F = F.replace(/(\d)_(?=\d)/g, "$1"), K.test(F))
          return me(T, F);
      } else if (F === "Infinity" || F === "NaN")
        return +F || (T.s = NaN), T.e = NaN, T.d = null, T;
      if (R.test(F))
        H = 16, F = F.toLowerCase();
      else if (A.test(F))
        H = 2;
      else if (L.test(F))
        H = 8;
      else
        throw Error(N + F);
      for (Z = F.search(/p/i), Z > 0 ? (J = +F.slice(Z + 1), F = F.substring(2, Z)) : F = F.slice(2), Z = F.indexOf("."), ie = Z >= 0, z = T.constructor, ie && (F = F.replace(".", ""), he = F.length, Z = he - Z, Q = ce(z, new z(H), Z, Z * 2)), Y = E(F, H, $), ee = Y.length - 1, Z = ee; Y[Z] === 0; --Z)
        Y.pop();
      return Z < 0 ? new z(T.s * 0) : (T.e = b(Y, ee), T.d = Y, v = !1, ie && (T = w(T, Q, he * 4)), J && (T = T.times(Math.abs(J) < 54 ? I(2, J) : d.pow(2, J))), v = !0, T);
    }
    function U(T, F) {
      var H, z = F.d.length;
      if (z < 3)
        return F.isZero() ? F : ue(T, 2, F, F);
      H = 1.4 * Math.sqrt(z), H = H > 16 ? 16 : H | 0, F = F.times(1 / we(5, H)), F = ue(T, 2, F, F);
      for (var Q, Z = new T(5), ie = new T(16), he = new T(20); H--; )
        Q = F.times(F), F = F.times(Z.plus(Q.times(ie.times(Q).minus(he))));
      return F;
    }
    function ue(T, F, H, z, Q) {
      var Z, ie, he, J, Y = T.precision, ee = Math.ceil(Y / k);
      for (v = !1, J = H.times(H), he = new T(z); ; ) {
        if (ie = w(he.times(J), new T(F++ * F++), Y, 1), he = Q ? z.plus(ie) : z.minus(ie), z = w(ie.times(J), new T(F++ * F++), Y, 1), ie = he.plus(z), ie.d[ee] !== void 0) {
          for (Z = ee; ie.d[Z] === he.d[Z] && Z--; )
            ;
          if (Z == -1)
            break;
        }
        Z = he, he = z, z = ie, ie = Z;
      }
      return v = !0, ie.d.length = ee + 1, ie;
    }
    function we(T, F) {
      for (var H = T; --F; )
        H *= T;
      return H;
    }
    function ke(T, F) {
      var H, z = F.s < 0, Q = X(T, T.precision, 1), Z = Q.times(0.5);
      if (F = F.abs(), F.lte(Z))
        return g = z ? 4 : 1, F;
      if (H = F.divToInt(Q), H.isZero())
        g = z ? 3 : 2;
      else {
        if (F = F.minus(H.times(Q)), F.lte(Z))
          return g = pe(H) ? z ? 2 : 3 : z ? 4 : 1, F;
        g = pe(H) ? z ? 1 : 4 : z ? 3 : 2;
      }
      return F.minus(Q).abs();
    }
    function Re(T, F, H, z) {
      var Q, Z, ie, he, J, Y, ee, se, le, Ae = T.constructor, Te = H !== void 0;
      if (Te ? (h(H, 1, n), z === void 0 ? z = Ae.rounding : h(z, 0, 8)) : (H = Ae.precision, z = Ae.rounding), !T.isFinite())
        ee = xe(T);
      else {
        for (ee = l(T), ie = ee.indexOf("."), Te ? (Q = 2, F == 16 ? H = H * 4 - 3 : F == 8 && (H = H * 3 - 2)) : Q = F, ie >= 0 && (ee = ee.replace(".", ""), le = new Ae(1), le.e = ee.length - ie, le.d = E(l(le), 10, Q), le.e = le.d.length), se = E(ee, 10, Q), Z = J = se.length; se[--J] == 0; )
          se.pop();
        if (!se[0])
          ee = Te ? "0p+0" : "0";
        else {
          if (ie < 0 ? Z-- : (T = new Ae(T), T.d = se, T.e = Z, T = w(T, le, H, z, 0, Q), se = T.d, Z = T.e, Y = c), ie = se[H], he = Q / 2, Y = Y || se[H + 1] !== void 0, Y = z < 4 ? (ie !== void 0 || Y) && (z === 0 || z === (T.s < 0 ? 3 : 2)) : ie > he || ie === he && (z === 4 || Y || z === 6 && se[H - 1] & 1 || z === (T.s < 0 ? 8 : 7)), se.length = H, Y)
            for (; ++se[--H] > Q - 1; )
              se[H] = 0, H || (++Z, se.unshift(1));
          for (J = se.length; !se[J - 1]; --J)
            ;
          for (ie = 0, ee = ""; ie < J; ie++)
            ee += s.charAt(se[ie]);
          if (Te) {
            if (J > 1)
              if (F == 16 || F == 8) {
                for (ie = F == 16 ? 4 : 3, --J; J % ie; J++)
                  ee += "0";
                for (se = E(ee, Q, F), J = se.length; !se[J - 1]; --J)
                  ;
                for (ie = 1, ee = "1."; ie < J; ie++)
                  ee += s.charAt(se[ie]);
              } else
                ee = ee.charAt(0) + "." + ee.slice(1);
            ee = ee + (Z < 0 ? "p" : "p+") + Z;
          } else if (Z < 0) {
            for (; ++Z; )
              ee = "0" + ee;
            ee = "0." + ee;
          } else if (++Z > J)
            for (Z -= J; Z--; )
              ee += "0";
          else
            Z < J && (ee = ee.slice(0, Z) + "." + ee.slice(Z));
        }
        ee = (F == 16 ? "0x" : F == 2 ? "0b" : F == 8 ? "0o" : "") + ee;
      }
      return T.s < 0 ? "-" + ee : ee;
    }
    function fe(T, F) {
      if (T.length > F)
        return T.length = F, !0;
    }
    function x(T) {
      return new this(T).abs();
    }
    function _(T) {
      return new this(T).acos();
    }
    function q(T) {
      return new this(T).acosh();
    }
    function ne(T, F) {
      return new this(T).plus(F);
    }
    function de(T) {
      return new this(T).asin();
    }
    function ye(T) {
      return new this(T).asinh();
    }
    function ge(T) {
      return new this(T).atan();
    }
    function be(T) {
      return new this(T).atanh();
    }
    function Me(T, F) {
      T = new this(T), F = new this(F);
      var H, z = this.precision, Q = this.rounding, Z = z + 4;
      return !T.s || !F.s ? H = new this(NaN) : !T.d && !F.d ? (H = X(this, Z, 1).times(F.s > 0 ? 0.25 : 0.75), H.s = T.s) : !F.d || T.isZero() ? (H = F.s < 0 ? X(this, z, Q) : new this(0), H.s = T.s) : !T.d || F.isZero() ? (H = X(this, Z, 1).times(0.5), H.s = T.s) : F.s < 0 ? (this.precision = Z, this.rounding = 1, H = this.atan(w(T, F, Z, 1)), F = X(this, Z, 1), this.precision = z, this.rounding = Q, H = T.s < 0 ? H.minus(F) : H.plus(F)) : H = this.atan(w(T, F, Z, 1)), H;
    }
    function Ce(T) {
      return new this(T).cbrt();
    }
    function je(T) {
      return m(T = new this(T), T.e + 1, 2);
    }
    function Ue(T, F, H) {
      return new this(T).clamp(F, H);
    }
    function Qe(T) {
      if (!T || typeof T != "object")
        throw Error(O + "Object expected");
      var F, H, z, Q = T.defaults === !0, Z = [
        "precision",
        1,
        n,
        "rounding",
        0,
        8,
        "toExpNeg",
        -r,
        0,
        "toExpPos",
        0,
        r,
        "maxE",
        0,
        r,
        "minE",
        -r,
        0,
        "modulo",
        0,
        9
      ];
      for (F = 0; F < Z.length; F += 3)
        if (H = Z[F], Q && (this[H] = f[H]), (z = T[H]) !== void 0)
          if (M(z) === z && z >= Z[F + 1] && z <= Z[F + 2])
            this[H] = z;
          else
            throw Error(N + H + ": " + z);
      if (H = "crypto", Q && (this[H] = f[H]), (z = T[H]) !== void 0)
        if (z === !0 || z === !1 || z === 0 || z === 1)
          if (z)
            if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
              this[H] = !0;
            else
              throw Error(j);
          else
            this[H] = !1;
        else
          throw Error(N + H + ": " + z);
      return this;
    }
    function Ye(T) {
      return new this(T).cos();
    }
    function et(T) {
      return new this(T).cosh();
    }
    function At(T) {
      var F, H, z;
      function Q(Z) {
        var ie, he, J, Y = this;
        if (!(Y instanceof Q))
          return new Q(Z);
        if (Y.constructor = Q, st(Z)) {
          Y.s = Z.s, v ? !Z.d || Z.e > Q.maxE ? (Y.e = NaN, Y.d = null) : Z.e < Q.minE ? (Y.e = 0, Y.d = [0]) : (Y.e = Z.e, Y.d = Z.d.slice()) : (Y.e = Z.e, Y.d = Z.d ? Z.d.slice() : Z.d);
          return;
        }
        if (J = typeof Z, J === "number") {
          if (Z === 0) {
            Y.s = 1 / Z < 0 ? -1 : 1, Y.e = 0, Y.d = [0];
            return;
          }
          if (Z < 0 ? (Z = -Z, Y.s = -1) : Y.s = 1, Z === ~~Z && Z < 1e7) {
            for (ie = 0, he = Z; he >= 10; he /= 10)
              ie++;
            v ? ie > Q.maxE ? (Y.e = NaN, Y.d = null) : ie < Q.minE ? (Y.e = 0, Y.d = [0]) : (Y.e = ie, Y.d = [Z]) : (Y.e = ie, Y.d = [Z]);
            return;
          } else if (Z * 0 !== 0) {
            Z || (Y.s = NaN), Y.e = NaN, Y.d = null;
            return;
          }
          return me(Y, Z.toString());
        } else if (J !== "string")
          throw Error(N + Z);
        return (he = Z.charCodeAt(0)) === 45 ? (Z = Z.slice(1), Y.s = -1) : (he === 43 && (Z = Z.slice(1)), Y.s = 1), K.test(Z) ? me(Y, Z) : te(Y, Z);
      }
      if (Q.prototype = o, Q.ROUND_UP = 0, Q.ROUND_DOWN = 1, Q.ROUND_CEIL = 2, Q.ROUND_FLOOR = 3, Q.ROUND_HALF_UP = 4, Q.ROUND_HALF_DOWN = 5, Q.ROUND_HALF_EVEN = 6, Q.ROUND_HALF_CEIL = 7, Q.ROUND_HALF_FLOOR = 8, Q.EUCLID = 9, Q.config = Q.set = Qe, Q.clone = At, Q.isDecimal = st, Q.abs = x, Q.acos = _, Q.acosh = q, Q.add = ne, Q.asin = de, Q.asinh = ye, Q.atan = ge, Q.atanh = be, Q.atan2 = Me, Q.cbrt = Ce, Q.ceil = je, Q.clamp = Ue, Q.cos = Ye, Q.cosh = et, Q.div = it, Q.exp = tt, Q.floor = Pt, Q.hypot = dt, Q.ln = zt, Q.log = xt, Q.log10 = $t, Q.log2 = lt, Q.max = Tt, Q.min = at, Q.mod = Ut, Q.mul = Ot, Q.pow = He, Q.random = Vt, Q.round = yt, Q.sign = ut, Q.sin = It, Q.sinh = kt, Q.sqrt = ot, Q.sub = Rt, Q.sum = Nt, Q.tan = rt, Q.tanh = Dt, Q.trunc = St, T === void 0 && (T = {}), T && T.defaults !== !0)
        for (z = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], F = 0; F < z.length; )
          T.hasOwnProperty(H = z[F++]) || (T[H] = this[H]);
      return Q.config(T), Q;
    }
    function it(T, F) {
      return new this(T).div(F);
    }
    function tt(T) {
      return new this(T).exp();
    }
    function Pt(T) {
      return m(T = new this(T), T.e + 1, 3);
    }
    function dt() {
      var T, F, H = new this(0);
      for (v = !1, T = 0; T < arguments.length; )
        if (F = new this(arguments[T++]), F.d)
          H.d && (H = H.plus(F.times(F)));
        else {
          if (F.s)
            return v = !0, new this(1 / 0);
          H = F;
        }
      return v = !0, H.sqrt();
    }
    function st(T) {
      return T instanceof d || T && T.toStringTag === B || !1;
    }
    function zt(T) {
      return new this(T).ln();
    }
    function xt(T, F) {
      return new this(T).log(F);
    }
    function lt(T) {
      return new this(T).log(2);
    }
    function $t(T) {
      return new this(T).log(10);
    }
    function Tt() {
      return ve(this, arguments, "lt");
    }
    function at() {
      return ve(this, arguments, "gt");
    }
    function Ut(T, F) {
      return new this(T).mod(F);
    }
    function Ot(T, F) {
      return new this(T).mul(F);
    }
    function He(T, F) {
      return new this(T).pow(F);
    }
    function Vt(T) {
      var F, H, z, Q, Z = 0, ie = new this(1), he = [];
      if (T === void 0 ? T = this.precision : h(T, 1, n), z = Math.ceil(T / k), this.crypto)
        if (crypto.getRandomValues)
          for (F = crypto.getRandomValues(new Uint32Array(z)); Z < z; )
            Q = F[Z], Q >= 429e7 ? F[Z] = crypto.getRandomValues(new Uint32Array(1))[0] : he[Z++] = Q % 1e7;
        else if (crypto.randomBytes) {
          for (F = crypto.randomBytes(z *= 4); Z < z; )
            Q = F[Z] + (F[Z + 1] << 8) + (F[Z + 2] << 16) + ((F[Z + 3] & 127) << 24), Q >= 214e7 ? crypto.randomBytes(4).copy(F, Z) : (he.push(Q % 1e7), Z += 4);
          Z = z / 4;
        } else
          throw Error(j);
      else
        for (; Z < z; )
          he[Z++] = Math.random() * 1e7 | 0;
      for (z = he[--Z], T %= k, z && T && (Q = I(10, k - T), he[Z] = (z / Q | 0) * Q); he[Z] === 0; Z--)
        he.pop();
      if (Z < 0)
        H = 0, he = [0];
      else {
        for (H = -1; he[0] === 0; H -= k)
          he.shift();
        for (z = 1, Q = he[0]; Q >= 10; Q /= 10)
          z++;
        z < k && (H -= k - z);
      }
      return ie.e = H, ie.d = he, ie;
    }
    function yt(T) {
      return m(T = new this(T), T.e + 1, this.rounding);
    }
    function ut(T) {
      return T = new this(T), T.d ? T.d[0] ? T.s : 0 * T.s : T.s || NaN;
    }
    function It(T) {
      return new this(T).sin();
    }
    function kt(T) {
      return new this(T).sinh();
    }
    function ot(T) {
      return new this(T).sqrt();
    }
    function Rt(T, F) {
      return new this(T).sub(F);
    }
    function Nt() {
      var T = 0, F = arguments, H = new this(F[T]);
      for (v = !1; H.s && ++T < F.length; )
        H = H.plus(F[T]);
      return v = !0, m(H, this.precision, this.rounding);
    }
    function rt(T) {
      return new this(T).tan();
    }
    function Dt(T) {
      return new this(T).tanh();
    }
    function St(T) {
      return m(T = new this(T), T.e + 1, 1);
    }
    d = At(f), d.prototype.constructor = d, d.default = d.Decimal = d, i = new d(i), a = new d(a), e.exports ? (typeof Symbol == "function" && typeof Symbol.iterator == "symbol" && (o[Symbol.for("nodejs.util.inspect.custom")] = o.toString, o[Symbol.toStringTag] = "Decimal"), e.exports = d) : (t || (t = typeof self < "u" && self && self.self == self ? self : window), p = t.Decimal, d.noConflict = function() {
      return t.Decimal = p, d;
    }, t.Decimal = d);
  })(Ze);
})(g5);
var dx = g5.exports, tf = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isTestnet = e.getNetworkNameforNetworkId = e.isSupportedNetwork = e.NETWORK_IDS = e.NETWORK_NAMES = e.SUPPORTED_NETWORKS_ARRAY = void 0, e.SUPPORTED_NETWORKS_ARRAY = [1, 10, 137, 8453, 11155111];
  var t;
  (function(a) {
    a.MAINNET = "mainnet", a.GOERLI = "goerli", a.OPTIMISM = "optimism", a.BASE = "base", a.SEPOLIA = "sepolia", a.MATIC = "matic";
  })(t || (e.NETWORK_NAMES = t = {}));
  var r;
  (function(a) {
    a[a.MAINNET = 1] = "MAINNET", a[a.GOERLI = 5] = "GOERLI", a[a.OPTIMISM = 10] = "OPTIMISM", a[a.BASE = 8453] = "BASE", a[a.SEPOLIA = 11155111] = "SEPOLIA", a[a.MATIC = 137] = "MATIC";
  })(r || (e.NETWORK_IDS = r = {}));
  const n = (a) => e.SUPPORTED_NETWORKS_ARRAY.includes(a);
  e.isSupportedNetwork = n;
  function s(a) {
    switch (a) {
      case r.GOERLI:
        return t.GOERLI;
      case r.SEPOLIA:
        return t.SEPOLIA;
      case r.OPTIMISM:
        return t.OPTIMISM;
      case r.BASE:
        return t.BASE;
      case r.MAINNET:
        return t.MAINNET;
      case r.MATIC:
        return t.MATIC;
      default:
        throw new Error("Unsupported Network");
    }
  }
  e.getNetworkNameforNetworkId = s;
  function i(a) {
    return a !== 1 && a !== 10 && a !== 8453 && a !== 137;
  }
  e.isTestnet = i;
})(tf);
Object.defineProperty(di, "__esModule", { value: !0 });
di.getCurrenciesOnNetwork = di.getCurrencyInfo = di.ethCurrencyNameForNetwork = di.commifiedRoundedNumberString = di.numberStringRound = void 0;
const hx = lx, Bm = dx, gt = tf, su = "0x0000000000000000000000000000000000000000", m5 = {
  APE: {
    coinGeckoId: "apecoin",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "APE"
  },
  ASH: {
    coinGeckoId: "ash",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0x64d91f12ece7362f91a6f8e7940cd55f05060b92",
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "ASH"
  },
  DAI: {
    coinGeckoId: "dai",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0x6b175474e89094c44da98b954eedeac495271d0f",
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "DAI"
  },
  ETH: {
    coinGeckoId: "ethereum",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: su,
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: su,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: su,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: su,
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: su,
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: su,
        decimals: 18
      }
    },
    name: "ETH"
  },
  LOOKS: {
    coinGeckoId: "looksrare",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "LOOKS"
  },
  PEPE: {
    coinGeckoId: "pepe",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "PEPE"
  },
  RARE: {
    coinGeckoId: "superrare",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0xba5bde662c17e2adff1075610382b9b691296350",
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "RARE"
  },
  TURBO: {
    coinGeckoId: "turbo",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "TURBO"
  },
  USDC: {
    coinGeckoId: "usd-coin",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        decimals: 6
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 6
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 6
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 6
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
        decimals: 6
      },
      [gt.NETWORK_IDS.BASE]: {
        address: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
        decimals: 6
      }
    },
    name: "USDC"
  },
  USDT: {
    coinGeckoId: "tether",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        decimals: 6
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 6
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 6
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 6
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
        decimals: 6
      },
      [gt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 6
      }
    },
    name: "USDT"
  },
  WETH: {
    coinGeckoId: "weth",
    erc20: {
      [gt.NETWORK_IDS.MAINNET]: {
        address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
        decimals: 18
      },
      [gt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      },
      [gt.NETWORK_IDS.OPTIMISM]: {
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18
      },
      [gt.NETWORK_IDS.BASE]: {
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18
      }
    },
    name: "WETH"
  }
};
function y5(e, t) {
  return new Bm.Decimal(e).toFixed(t, Bm.Decimal.ROUND_UP);
}
di.numberStringRound = y5;
function fx(e, t) {
  return (0, hx.commify)(y5(e, t));
}
di.commifiedRoundedNumberString = fx;
function px(e) {
  switch (e) {
    case gt.NETWORK_IDS.MAINNET:
      return "ETH";
    case gt.NETWORK_IDS.GOERLI:
      return "GoETH";
    case gt.NETWORK_IDS.OPTIMISM:
      return "OETH";
    case gt.NETWORK_IDS.BASE:
      return "BETH";
    default:
      return "ETH";
  }
}
di.ethCurrencyNameForNetwork = px;
const gx = (e) => {
  const t = m5[e];
  if (!t)
    throw new Error(`Currency ${e} not supported`);
  return t;
};
di.getCurrencyInfo = gx;
const mx = (e) => {
  const t = e;
  return Object.entries(m5).filter(([, r]) => r.erc20[t].address).map(([r]) => r);
};
di.getCurrenciesOnNetwork = mx;
var b5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isAudio = e.isHTML = e.isImage = e.is3DModel = e.isVideo = e.encodeSVGDataString = e.SVGDataPrefix = e.mediaIsLandscape = void 0;
  const t = (s) => {
    const i = new Image();
    i.src = s;
    const a = i.width;
    let f = i.height;
    return f = f + f, a > f;
  };
  e.mediaIsLandscape = t;
  const r = /[\r\n%#()<>?[\\\]^`{|}]/g;
  e.SVGDataPrefix = "data:image/svg+xml";
  function n(s) {
    let i = s;
    const a = s.substring(0, e.SVGDataPrefix.length) === e.SVGDataPrefix;
    return a && (i = i.substring(e.SVGDataPrefix.length)), i = i.replace(/>\s{1,}</g, "><"), i = i.replace(/\s{2,}/g, " "), `${a ? e.SVGDataPrefix : ""}${i.replace(r, encodeURIComponent)}`;
  }
  e.encodeSVGDataString = n, e.isVideo = new RegExp(/(mp4|mov|avi|webm|flv|wmv)/, "i"), e.is3DModel = new RegExp(/(obj|fbx|glb|gltf|gltf+json)/, "i"), e.isImage = new RegExp(/(gif|png|jpg|jpeg|svg|bmp|tif|tiff|raw)/, "i"), e.isHTML = new RegExp(/(html)/, "i"), e.isAudio = new RegExp(/(mp3|wav|aac|ogg|m4a|flac)/, "i");
})(b5);
var ds = {}, yx = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(ds, "__esModule", { value: !0 });
ds.poll = ds.isJSON = ds.noop = ds.sleep = void 0;
const bx = (e) => new Promise((t) => setTimeout(t, e));
ds.sleep = bx;
const wx = () => {
};
ds.noop = wx;
function vx(e) {
  try {
    JSON.parse(e);
  } catch {
    return !1;
  }
  return !0;
}
ds.isJSON = vx;
const Ax = (e) => {
  let t = 0;
  const r = (n, s) => yx(void 0, void 0, void 0, function* () {
    let i;
    try {
      i = yield e.fetch();
    } catch {
      return s(new Error(e.errorMessage));
    }
    if (t++, e.validate(i))
      return n(i);
    if (e.maxAttempts && t === e.maxAttempts)
      return s(new Error(e.errorMessage));
    setTimeout(r, e.interval, n, s);
  });
  return new Promise(r);
};
ds.poll = Ax;
var p1 = {}, w5 = {}, v5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CHAIN_CHANGED = e.PROVIDER_CHANGED = e.ADDRESS_CHANGED = e.MANIFOLD_ETHEREUM_EXISTS = e.MANIFOLD_ETHEREUM_INITIALIZED = e.EthereumProviderErrorName = void 0, function(t) {
    t.EthereumProviderMultipleChains = "EthereumProviderMultipleChains", t.WindowEthereumConnectionError = "WindowEthereumConnectionError";
  }(e.EthereumProviderErrorName || (e.EthereumProviderErrorName = {})), e.MANIFOLD_ETHEREUM_INITIALIZED = "manifold-ethereum-initialized", e.MANIFOLD_ETHEREUM_EXISTS = "manifold-ethereum-exists", e.ADDRESS_CHANGED = "ethereum-address-changed", e.PROVIDER_CHANGED = "frontend-provider-changed", e.CHAIN_CHANGED = "frontend-provider-chain-changed";
})(v5);
var A5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EthereumNetwork = void 0, function(t) {
    t[t.MAINNET = 1] = "MAINNET", t[t.GOERLI = 5] = "GOERLI", t[t.OPTIMISM = 10] = "OPTIMISM", t[t.BSC = 56] = "BSC", t[t.MATIC = 137] = "MATIC", t[t.OPTIMISM_GOERLI = 420] = "OPTIMISM_GOERLI", t[t.BASE = 8453] = "BASE", t[t.ARBITRUM = 42161] = "ARBITRUM", t[t.AVALANCHE_FUJI = 43113] = "AVALANCHE_FUJI", t[t.AVALANCHE = 43114] = "AVALANCHE", t[t.ARBITRUM_GOERLI = 421613] = "ARBITRUM_GOERLI", t[t.MUMBAI = 80001] = "MUMBAI", t[t.BASE_GOERLI = 84531] = "BASE_GOERLI", t[t.SEPOLIA = 11155111] = "SEPOLIA";
  }(e.EthereumNetwork || (e.EthereumNetwork = {}));
})(A5);
var E5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.OAuthGrantType = void 0, function(t) {
    t.TOKEN = "token", t.SIGNATURE = "signature";
  }(e.OAuthGrantType || (e.OAuthGrantType = {}));
})(E5);
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = Ze && Ze.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(v5, e), r(A5, e), r(E5, e);
})(w5);
var Gf = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(p1, "__esModule", { value: !0 });
const zf = w5;
function Ex(e) {
  let t;
  function r() {
    t = setTimeout(() => {
      t = void 0;
    }, 1e3);
  }
  function n(s) {
    s === "address" ? (t && (clearTimeout(t), r()), e()) : t || (t = setTimeout(() => {
      r(), e();
    }, 1e3));
  }
  window.addEventListener(zf.ADDRESS_CHANGED, () => Gf(this, void 0, void 0, function* () {
    n("address");
  })), window.addEventListener(zf.CHAIN_CHANGED, () => Gf(this, void 0, void 0, function* () {
    n("chain");
  })), window.addEventListener(zf.PROVIDER_CHANGED, () => Gf(this, void 0, void 0, function* () {
    n("provider");
  }));
}
p1.default = Ex;
var hi = {}, Cp = { exports: {} };
function P5(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var s = e.length;
      for (t = 0; t < s; t++)
        e[t] && (r = P5(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function _m() {
  for (var e, t, r = 0, n = "", s = arguments.length; r < s; r++)
    (e = arguments[r]) && (t = P5(e)) && (n && (n += " "), n += t);
  return n;
}
Cp.exports = _m, Cp.exports.clsx = _m;
var Px = Cp.exports, O5 = {};
(function(e) {
  Object.defineProperty(e, Symbol.toStringTag, {
    value: "Module"
  });
  const t = "-";
  function r(_) {
    const q = a(_), {
      conflictingClassGroups: ne,
      conflictingClassGroupModifiers: de
    } = _;
    function ye(be) {
      const Me = be.split(t);
      return Me[0] === "" && Me.length !== 1 && Me.shift(), n(Me, q) || i(be);
    }
    function ge(be, Me) {
      const Ce = ne[be] || [];
      return Me && de[be] ? [...Ce, ...de[be]] : Ce;
    }
    return {
      getClassGroupId: ye,
      getConflictingClassGroupIds: ge
    };
  }
  function n(_, q) {
    var ne;
    if (_.length === 0)
      return q.classGroupId;
    const de = _[0], ye = q.nextPart.get(de), ge = ye ? n(_.slice(1), ye) : void 0;
    if (ge)
      return ge;
    if (q.validators.length === 0)
      return;
    const be = _.join(t);
    return (ne = q.validators.find(({
      validator: Me
    }) => Me(be))) == null ? void 0 : ne.classGroupId;
  }
  const s = /^\[(.+)\]$/;
  function i(_) {
    if (s.test(_)) {
      const q = s.exec(_)[1], ne = q == null ? void 0 : q.substring(0, q.indexOf(":"));
      if (ne)
        return "arbitrary.." + ne;
    }
  }
  function a(_) {
    const {
      theme: q,
      prefix: ne
    } = _, de = {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    };
    return p(Object.entries(_.classGroups), ne).forEach(([ye, ge]) => {
      f(ge, de, ye, q);
    }), de;
  }
  function f(_, q, ne, de) {
    _.forEach((ye) => {
      if (typeof ye == "string") {
        const ge = ye === "" ? q : d(q, ye);
        ge.classGroupId = ne;
        return;
      }
      if (typeof ye == "function") {
        if (c(ye)) {
          f(ye(de), q, ne, de);
          return;
        }
        q.validators.push({
          validator: ye,
          classGroupId: ne
        });
        return;
      }
      Object.entries(ye).forEach(([ge, be]) => {
        f(be, d(q, ge), ne, de);
      });
    });
  }
  function d(_, q) {
    let ne = _;
    return q.split(t).forEach((de) => {
      ne.nextPart.has(de) || ne.nextPart.set(de, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      }), ne = ne.nextPart.get(de);
    }), ne;
  }
  function c(_) {
    return _.isThemeGetter;
  }
  function p(_, q) {
    return q ? _.map(([ne, de]) => {
      const ye = de.map((ge) => typeof ge == "string" ? q + ge : typeof ge == "object" ? Object.fromEntries(Object.entries(ge).map(([be, Me]) => [q + be, Me])) : ge);
      return [ne, ye];
    }) : _;
  }
  function g(_) {
    if (_ < 1)
      return {
        get: () => {
        },
        set: () => {
        }
      };
    let q = 0, ne = /* @__PURE__ */ new Map(), de = /* @__PURE__ */ new Map();
    function ye(ge, be) {
      ne.set(ge, be), q++, q > _ && (q = 0, de = ne, ne = /* @__PURE__ */ new Map());
    }
    return {
      get(ge) {
        let be = ne.get(ge);
        if (be !== void 0)
          return be;
        if ((be = de.get(ge)) !== void 0)
          return ye(ge, be), be;
      },
      set(ge, be) {
        ne.has(ge) ? ne.set(ge, be) : ye(ge, be);
      }
    };
  }
  const v = "!";
  function O(_) {
    const q = _.separator, ne = q.length === 1, de = q[0], ye = q.length;
    return function(ge) {
      const be = [];
      let Me = 0, Ce = 0, je;
      for (let At = 0; At < ge.length; At++) {
        let it = ge[At];
        if (Me === 0) {
          if (it === de && (ne || ge.slice(At, At + ye) === q)) {
            be.push(ge.slice(Ce, At)), Ce = At + ye;
            continue;
          }
          if (it === "/") {
            je = At;
            continue;
          }
        }
        it === "[" ? Me++ : it === "]" && Me--;
      }
      const Ue = be.length === 0 ? ge : ge.substring(Ce), Qe = Ue.startsWith(v), Ye = Qe ? Ue.substring(1) : Ue, et = je && je > Ce ? je - Ce : void 0;
      return {
        modifiers: be,
        hasImportantModifier: Qe,
        baseClassName: Ye,
        maybePostfixModifierPosition: et
      };
    };
  }
  function N(_) {
    if (_.length <= 1)
      return _;
    const q = [];
    let ne = [];
    return _.forEach((de) => {
      de[0] === "[" ? (q.push(...ne.sort(), de), ne = []) : ne.push(de);
    }), q.push(...ne.sort()), q;
  }
  function S(_) {
    return {
      cache: g(_.cacheSize),
      splitModifiers: O(_),
      ...r(_)
    };
  }
  const j = /\s+/;
  function B(_, q) {
    const {
      splitModifiers: ne,
      getClassGroupId: de,
      getConflictingClassGroupIds: ye
    } = q, ge = /* @__PURE__ */ new Set();
    return _.trim().split(j).map((be) => {
      const {
        modifiers: Me,
        hasImportantModifier: Ce,
        baseClassName: je,
        maybePostfixModifierPosition: Ue
      } = ne(be);
      let Qe = de(Ue ? je.substring(0, Ue) : je), Ye = !!Ue;
      if (!Qe) {
        if (!Ue)
          return {
            isTailwindClass: !1,
            originalClassName: be
          };
        if (Qe = de(je), !Qe)
          return {
            isTailwindClass: !1,
            originalClassName: be
          };
        Ye = !1;
      }
      const et = N(Me).join(":");
      return {
        isTailwindClass: !0,
        modifierId: Ce ? et + v : et,
        classGroupId: Qe,
        originalClassName: be,
        hasPostfixModifier: Ye
      };
    }).reverse().filter((be) => {
      if (!be.isTailwindClass)
        return !0;
      const {
        modifierId: Me,
        classGroupId: Ce,
        hasPostfixModifier: je
      } = be, Ue = Me + Ce;
      return ge.has(Ue) ? !1 : (ge.add(Ue), ye(Ce, je).forEach((Qe) => ge.add(Me + Qe)), !0);
    }).reverse().map((be) => be.originalClassName).join(" ");
  }
  function M() {
    let _ = 0, q, ne, de = "";
    for (; _ < arguments.length; )
      (q = arguments[_++]) && (ne = I(q)) && (de && (de += " "), de += ne);
    return de;
  }
  function I(_) {
    if (typeof _ == "string")
      return _;
    let q, ne = "";
    for (let de = 0; de < _.length; de++)
      _[de] && (q = I(_[de])) && (ne && (ne += " "), ne += q);
    return ne;
  }
  function A(_, ...q) {
    let ne, de, ye, ge = be;
    function be(Ce) {
      const je = q.reduce((Ue, Qe) => Qe(Ue), _());
      return ne = S(je), de = ne.cache.get, ye = ne.cache.set, ge = Me, Me(Ce);
    }
    function Me(Ce) {
      const je = de(Ce);
      if (je)
        return je;
      const Ue = B(Ce, ne);
      return ye(Ce, Ue), Ue;
    }
    return function() {
      return ge(M.apply(null, arguments));
    };
  }
  function R(_) {
    const q = (ne) => ne[_] || [];
    return q.isThemeGetter = !0, q;
  }
  const L = /^\[(?:([a-z-]+):)?(.+)\]$/i, K = /^\d+\/\d+$/, $ = /* @__PURE__ */ new Set(["px", "full", "screen"]), k = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, V = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, C = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, D = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, o = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
  function u(_) {
    return y(_) || $.has(_) || K.test(_);
  }
  function h(_) {
    return ve(_, "length", Ee);
  }
  function y(_) {
    return !!_ && !Number.isNaN(Number(_));
  }
  function E(_) {
    return ve(_, "number", y);
  }
  function P(_) {
    return !!_ && Number.isInteger(Number(_));
  }
  function w(_) {
    return _.endsWith("%") && y(_.slice(0, -1));
  }
  function m(_) {
    return L.test(_);
  }
  function l(_) {
    return k.test(_);
  }
  const b = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
  function W(_) {
    return ve(_, b, Pe);
  }
  function X(_) {
    return ve(_, "position", Pe);
  }
  const G = /* @__PURE__ */ new Set(["image", "url"]);
  function re(_) {
    return ve(_, G, me);
  }
  function ce(_) {
    return ve(_, "", xe);
  }
  function pe() {
    return !0;
  }
  function ve(_, q, ne) {
    const de = L.exec(_);
    return de ? de[1] ? typeof q == "string" ? de[1] === q : q.has(de[1]) : ne(de[2]) : !1;
  }
  function Ee(_) {
    return V.test(_) && !C.test(_);
  }
  function Pe() {
    return !1;
  }
  function xe(_) {
    return D.test(_);
  }
  function me(_) {
    return o.test(_);
  }
  const te = /* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    isAny: pe,
    isArbitraryImage: re,
    isArbitraryLength: h,
    isArbitraryNumber: E,
    isArbitraryPosition: X,
    isArbitraryShadow: ce,
    isArbitrarySize: W,
    isArbitraryValue: m,
    isInteger: P,
    isLength: u,
    isNumber: y,
    isPercent: w,
    isTshirtSize: l
  }, Symbol.toStringTag, {
    value: "Module"
  });
  function U() {
    const _ = R("colors"), q = R("spacing"), ne = R("blur"), de = R("brightness"), ye = R("borderColor"), ge = R("borderRadius"), be = R("borderSpacing"), Me = R("borderWidth"), Ce = R("contrast"), je = R("grayscale"), Ue = R("hueRotate"), Qe = R("invert"), Ye = R("gap"), et = R("gradientColorStops"), At = R("gradientColorStopPositions"), it = R("inset"), tt = R("margin"), Pt = R("opacity"), dt = R("padding"), st = R("saturate"), zt = R("scale"), xt = R("sepia"), lt = R("skew"), $t = R("space"), Tt = R("translate"), at = () => ["auto", "contain", "none"], Ut = () => ["auto", "hidden", "clip", "visible", "scroll"], Ot = () => ["auto", m, q], He = () => [m, q], Vt = () => ["", u, h], yt = () => ["auto", y, m], ut = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], It = () => ["solid", "dashed", "dotted", "double", "none"], kt = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], ot = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Rt = () => ["", "0", m], Nt = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], rt = () => [y, E], Dt = () => [y, m];
    return {
      cacheSize: 500,
      separator: ":",
      theme: {
        colors: [pe],
        spacing: [u, h],
        blur: ["none", "", l, m],
        brightness: rt(),
        borderColor: [_],
        borderRadius: ["none", "", "full", l, m],
        borderSpacing: He(),
        borderWidth: Vt(),
        contrast: rt(),
        grayscale: Rt(),
        hueRotate: Dt(),
        invert: Rt(),
        gap: He(),
        gradientColorStops: [_],
        gradientColorStopPositions: [w, h],
        inset: Ot(),
        margin: Ot(),
        opacity: rt(),
        padding: He(),
        saturate: rt(),
        scale: rt(),
        sepia: Rt(),
        skew: Dt(),
        space: He(),
        translate: He()
      },
      classGroups: {
        // Layout
        /**
         * Aspect Ratio
         * @see https://tailwindcss.com/docs/aspect-ratio
         */
        aspect: [{
          aspect: ["auto", "square", "video", m]
        }],
        /**
         * Container
         * @see https://tailwindcss.com/docs/container
         */
        container: ["container"],
        /**
         * Columns
         * @see https://tailwindcss.com/docs/columns
         */
        columns: [{
          columns: [l]
        }],
        /**
         * Break After
         * @see https://tailwindcss.com/docs/break-after
         */
        "break-after": [{
          "break-after": Nt()
        }],
        /**
         * Break Before
         * @see https://tailwindcss.com/docs/break-before
         */
        "break-before": [{
          "break-before": Nt()
        }],
        /**
         * Break Inside
         * @see https://tailwindcss.com/docs/break-inside
         */
        "break-inside": [{
          "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
        }],
        /**
         * Box Decoration Break
         * @see https://tailwindcss.com/docs/box-decoration-break
         */
        "box-decoration": [{
          "box-decoration": ["slice", "clone"]
        }],
        /**
         * Box Sizing
         * @see https://tailwindcss.com/docs/box-sizing
         */
        box: [{
          box: ["border", "content"]
        }],
        /**
         * Display
         * @see https://tailwindcss.com/docs/display
         */
        display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
        /**
         * Floats
         * @see https://tailwindcss.com/docs/float
         */
        float: [{
          float: ["right", "left", "none", "start", "end"]
        }],
        /**
         * Clear
         * @see https://tailwindcss.com/docs/clear
         */
        clear: [{
          clear: ["left", "right", "both", "none", "start", "end"]
        }],
        /**
         * Isolation
         * @see https://tailwindcss.com/docs/isolation
         */
        isolation: ["isolate", "isolation-auto"],
        /**
         * Object Fit
         * @see https://tailwindcss.com/docs/object-fit
         */
        "object-fit": [{
          object: ["contain", "cover", "fill", "none", "scale-down"]
        }],
        /**
         * Object Position
         * @see https://tailwindcss.com/docs/object-position
         */
        "object-position": [{
          object: [...ut(), m]
        }],
        /**
         * Overflow
         * @see https://tailwindcss.com/docs/overflow
         */
        overflow: [{
          overflow: Ut()
        }],
        /**
         * Overflow X
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-x": [{
          "overflow-x": Ut()
        }],
        /**
         * Overflow Y
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-y": [{
          "overflow-y": Ut()
        }],
        /**
         * Overscroll Behavior
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        overscroll: [{
          overscroll: at()
        }],
        /**
         * Overscroll Behavior X
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-x": [{
          "overscroll-x": at()
        }],
        /**
         * Overscroll Behavior Y
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-y": [{
          "overscroll-y": at()
        }],
        /**
         * Position
         * @see https://tailwindcss.com/docs/position
         */
        position: ["static", "fixed", "absolute", "relative", "sticky"],
        /**
         * Top / Right / Bottom / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        inset: [{
          inset: [it]
        }],
        /**
         * Right / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-x": [{
          "inset-x": [it]
        }],
        /**
         * Top / Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-y": [{
          "inset-y": [it]
        }],
        /**
         * Start
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        start: [{
          start: [it]
        }],
        /**
         * End
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        end: [{
          end: [it]
        }],
        /**
         * Top
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        top: [{
          top: [it]
        }],
        /**
         * Right
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        right: [{
          right: [it]
        }],
        /**
         * Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        bottom: [{
          bottom: [it]
        }],
        /**
         * Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        left: [{
          left: [it]
        }],
        /**
         * Visibility
         * @see https://tailwindcss.com/docs/visibility
         */
        visibility: ["visible", "invisible", "collapse"],
        /**
         * Z-Index
         * @see https://tailwindcss.com/docs/z-index
         */
        z: [{
          z: ["auto", P, m]
        }],
        // Flexbox and Grid
        /**
         * Flex Basis
         * @see https://tailwindcss.com/docs/flex-basis
         */
        basis: [{
          basis: Ot()
        }],
        /**
         * Flex Direction
         * @see https://tailwindcss.com/docs/flex-direction
         */
        "flex-direction": [{
          flex: ["row", "row-reverse", "col", "col-reverse"]
        }],
        /**
         * Flex Wrap
         * @see https://tailwindcss.com/docs/flex-wrap
         */
        "flex-wrap": [{
          flex: ["wrap", "wrap-reverse", "nowrap"]
        }],
        /**
         * Flex
         * @see https://tailwindcss.com/docs/flex
         */
        flex: [{
          flex: ["1", "auto", "initial", "none", m]
        }],
        /**
         * Flex Grow
         * @see https://tailwindcss.com/docs/flex-grow
         */
        grow: [{
          grow: Rt()
        }],
        /**
         * Flex Shrink
         * @see https://tailwindcss.com/docs/flex-shrink
         */
        shrink: [{
          shrink: Rt()
        }],
        /**
         * Order
         * @see https://tailwindcss.com/docs/order
         */
        order: [{
          order: ["first", "last", "none", P, m]
        }],
        /**
         * Grid Template Columns
         * @see https://tailwindcss.com/docs/grid-template-columns
         */
        "grid-cols": [{
          "grid-cols": [pe]
        }],
        /**
         * Grid Column Start / End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start-end": [{
          col: ["auto", {
            span: ["full", P, m]
          }, m]
        }],
        /**
         * Grid Column Start
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start": [{
          "col-start": yt()
        }],
        /**
         * Grid Column End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-end": [{
          "col-end": yt()
        }],
        /**
         * Grid Template Rows
         * @see https://tailwindcss.com/docs/grid-template-rows
         */
        "grid-rows": [{
          "grid-rows": [pe]
        }],
        /**
         * Grid Row Start / End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start-end": [{
          row: ["auto", {
            span: [P, m]
          }, m]
        }],
        /**
         * Grid Row Start
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start": [{
          "row-start": yt()
        }],
        /**
         * Grid Row End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-end": [{
          "row-end": yt()
        }],
        /**
         * Grid Auto Flow
         * @see https://tailwindcss.com/docs/grid-auto-flow
         */
        "grid-flow": [{
          "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
        }],
        /**
         * Grid Auto Columns
         * @see https://tailwindcss.com/docs/grid-auto-columns
         */
        "auto-cols": [{
          "auto-cols": ["auto", "min", "max", "fr", m]
        }],
        /**
         * Grid Auto Rows
         * @see https://tailwindcss.com/docs/grid-auto-rows
         */
        "auto-rows": [{
          "auto-rows": ["auto", "min", "max", "fr", m]
        }],
        /**
         * Gap
         * @see https://tailwindcss.com/docs/gap
         */
        gap: [{
          gap: [Ye]
        }],
        /**
         * Gap X
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-x": [{
          "gap-x": [Ye]
        }],
        /**
         * Gap Y
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-y": [{
          "gap-y": [Ye]
        }],
        /**
         * Justify Content
         * @see https://tailwindcss.com/docs/justify-content
         */
        "justify-content": [{
          justify: ["normal", ...ot()]
        }],
        /**
         * Justify Items
         * @see https://tailwindcss.com/docs/justify-items
         */
        "justify-items": [{
          "justify-items": ["start", "end", "center", "stretch"]
        }],
        /**
         * Justify Self
         * @see https://tailwindcss.com/docs/justify-self
         */
        "justify-self": [{
          "justify-self": ["auto", "start", "end", "center", "stretch"]
        }],
        /**
         * Align Content
         * @see https://tailwindcss.com/docs/align-content
         */
        "align-content": [{
          content: ["normal", ...ot(), "baseline"]
        }],
        /**
         * Align Items
         * @see https://tailwindcss.com/docs/align-items
         */
        "align-items": [{
          items: ["start", "end", "center", "baseline", "stretch"]
        }],
        /**
         * Align Self
         * @see https://tailwindcss.com/docs/align-self
         */
        "align-self": [{
          self: ["auto", "start", "end", "center", "stretch", "baseline"]
        }],
        /**
         * Place Content
         * @see https://tailwindcss.com/docs/place-content
         */
        "place-content": [{
          "place-content": [...ot(), "baseline"]
        }],
        /**
         * Place Items
         * @see https://tailwindcss.com/docs/place-items
         */
        "place-items": [{
          "place-items": ["start", "end", "center", "baseline", "stretch"]
        }],
        /**
         * Place Self
         * @see https://tailwindcss.com/docs/place-self
         */
        "place-self": [{
          "place-self": ["auto", "start", "end", "center", "stretch"]
        }],
        // Spacing
        /**
         * Padding
         * @see https://tailwindcss.com/docs/padding
         */
        p: [{
          p: [dt]
        }],
        /**
         * Padding X
         * @see https://tailwindcss.com/docs/padding
         */
        px: [{
          px: [dt]
        }],
        /**
         * Padding Y
         * @see https://tailwindcss.com/docs/padding
         */
        py: [{
          py: [dt]
        }],
        /**
         * Padding Start
         * @see https://tailwindcss.com/docs/padding
         */
        ps: [{
          ps: [dt]
        }],
        /**
         * Padding End
         * @see https://tailwindcss.com/docs/padding
         */
        pe: [{
          pe: [dt]
        }],
        /**
         * Padding Top
         * @see https://tailwindcss.com/docs/padding
         */
        pt: [{
          pt: [dt]
        }],
        /**
         * Padding Right
         * @see https://tailwindcss.com/docs/padding
         */
        pr: [{
          pr: [dt]
        }],
        /**
         * Padding Bottom
         * @see https://tailwindcss.com/docs/padding
         */
        pb: [{
          pb: [dt]
        }],
        /**
         * Padding Left
         * @see https://tailwindcss.com/docs/padding
         */
        pl: [{
          pl: [dt]
        }],
        /**
         * Margin
         * @see https://tailwindcss.com/docs/margin
         */
        m: [{
          m: [tt]
        }],
        /**
         * Margin X
         * @see https://tailwindcss.com/docs/margin
         */
        mx: [{
          mx: [tt]
        }],
        /**
         * Margin Y
         * @see https://tailwindcss.com/docs/margin
         */
        my: [{
          my: [tt]
        }],
        /**
         * Margin Start
         * @see https://tailwindcss.com/docs/margin
         */
        ms: [{
          ms: [tt]
        }],
        /**
         * Margin End
         * @see https://tailwindcss.com/docs/margin
         */
        me: [{
          me: [tt]
        }],
        /**
         * Margin Top
         * @see https://tailwindcss.com/docs/margin
         */
        mt: [{
          mt: [tt]
        }],
        /**
         * Margin Right
         * @see https://tailwindcss.com/docs/margin
         */
        mr: [{
          mr: [tt]
        }],
        /**
         * Margin Bottom
         * @see https://tailwindcss.com/docs/margin
         */
        mb: [{
          mb: [tt]
        }],
        /**
         * Margin Left
         * @see https://tailwindcss.com/docs/margin
         */
        ml: [{
          ml: [tt]
        }],
        /**
         * Space Between X
         * @see https://tailwindcss.com/docs/space
         */
        "space-x": [{
          "space-x": [$t]
        }],
        /**
         * Space Between X Reverse
         * @see https://tailwindcss.com/docs/space
         */
        "space-x-reverse": ["space-x-reverse"],
        /**
         * Space Between Y
         * @see https://tailwindcss.com/docs/space
         */
        "space-y": [{
          "space-y": [$t]
        }],
        /**
         * Space Between Y Reverse
         * @see https://tailwindcss.com/docs/space
         */
        "space-y-reverse": ["space-y-reverse"],
        // Sizing
        /**
         * Width
         * @see https://tailwindcss.com/docs/width
         */
        w: [{
          w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", m, q]
        }],
        /**
         * Min-Width
         * @see https://tailwindcss.com/docs/min-width
         */
        "min-w": [{
          "min-w": [m, q, "min", "max", "fit"]
        }],
        /**
         * Max-Width
         * @see https://tailwindcss.com/docs/max-width
         */
        "max-w": [{
          "max-w": [m, q, "none", "full", "min", "max", "fit", "prose", {
            screen: [l]
          }, l]
        }],
        /**
         * Height
         * @see https://tailwindcss.com/docs/height
         */
        h: [{
          h: [m, q, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Min-Height
         * @see https://tailwindcss.com/docs/min-height
         */
        "min-h": [{
          "min-h": [m, q, "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Max-Height
         * @see https://tailwindcss.com/docs/max-height
         */
        "max-h": [{
          "max-h": [m, q, "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Size
         * @see https://tailwindcss.com/docs/size
         */
        size: [{
          size: [m, q, "auto", "min", "max", "fit"]
        }],
        // Typography
        /**
         * Font Size
         * @see https://tailwindcss.com/docs/font-size
         */
        "font-size": [{
          text: ["base", l, h]
        }],
        /**
         * Font Smoothing
         * @see https://tailwindcss.com/docs/font-smoothing
         */
        "font-smoothing": ["antialiased", "subpixel-antialiased"],
        /**
         * Font Style
         * @see https://tailwindcss.com/docs/font-style
         */
        "font-style": ["italic", "not-italic"],
        /**
         * Font Weight
         * @see https://tailwindcss.com/docs/font-weight
         */
        "font-weight": [{
          font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", E]
        }],
        /**
         * Font Family
         * @see https://tailwindcss.com/docs/font-family
         */
        "font-family": [{
          font: [pe]
        }],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-normal": ["normal-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-ordinal": ["ordinal"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-slashed-zero": ["slashed-zero"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-figure": ["lining-nums", "oldstyle-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-spacing": ["proportional-nums", "tabular-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
        /**
         * Letter Spacing
         * @see https://tailwindcss.com/docs/letter-spacing
         */
        tracking: [{
          tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", m]
        }],
        /**
         * Line Clamp
         * @see https://tailwindcss.com/docs/line-clamp
         */
        "line-clamp": [{
          "line-clamp": ["none", y, E]
        }],
        /**
         * Line Height
         * @see https://tailwindcss.com/docs/line-height
         */
        leading: [{
          leading: ["none", "tight", "snug", "normal", "relaxed", "loose", u, m]
        }],
        /**
         * List Style Image
         * @see https://tailwindcss.com/docs/list-style-image
         */
        "list-image": [{
          "list-image": ["none", m]
        }],
        /**
         * List Style Type
         * @see https://tailwindcss.com/docs/list-style-type
         */
        "list-style-type": [{
          list: ["none", "disc", "decimal", m]
        }],
        /**
         * List Style Position
         * @see https://tailwindcss.com/docs/list-style-position
         */
        "list-style-position": [{
          list: ["inside", "outside"]
        }],
        /**
         * Placeholder Color
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/placeholder-color
         */
        "placeholder-color": [{
          placeholder: [_]
        }],
        /**
         * Placeholder Opacity
         * @see https://tailwindcss.com/docs/placeholder-opacity
         */
        "placeholder-opacity": [{
          "placeholder-opacity": [Pt]
        }],
        /**
         * Text Alignment
         * @see https://tailwindcss.com/docs/text-align
         */
        "text-alignment": [{
          text: ["left", "center", "right", "justify", "start", "end"]
        }],
        /**
         * Text Color
         * @see https://tailwindcss.com/docs/text-color
         */
        "text-color": [{
          text: [_]
        }],
        /**
         * Text Opacity
         * @see https://tailwindcss.com/docs/text-opacity
         */
        "text-opacity": [{
          "text-opacity": [Pt]
        }],
        /**
         * Text Decoration
         * @see https://tailwindcss.com/docs/text-decoration
         */
        "text-decoration": ["underline", "overline", "line-through", "no-underline"],
        /**
         * Text Decoration Style
         * @see https://tailwindcss.com/docs/text-decoration-style
         */
        "text-decoration-style": [{
          decoration: [...It(), "wavy"]
        }],
        /**
         * Text Decoration Thickness
         * @see https://tailwindcss.com/docs/text-decoration-thickness
         */
        "text-decoration-thickness": [{
          decoration: ["auto", "from-font", u, h]
        }],
        /**
         * Text Underline Offset
         * @see https://tailwindcss.com/docs/text-underline-offset
         */
        "underline-offset": [{
          "underline-offset": ["auto", u, m]
        }],
        /**
         * Text Decoration Color
         * @see https://tailwindcss.com/docs/text-decoration-color
         */
        "text-decoration-color": [{
          decoration: [_]
        }],
        /**
         * Text Transform
         * @see https://tailwindcss.com/docs/text-transform
         */
        "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
        /**
         * Text Overflow
         * @see https://tailwindcss.com/docs/text-overflow
         */
        "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
        /**
         * Text Wrap
         * @see https://tailwindcss.com/docs/text-wrap
         */
        "text-wrap": [{
          text: ["wrap", "nowrap", "balance", "pretty"]
        }],
        /**
         * Text Indent
         * @see https://tailwindcss.com/docs/text-indent
         */
        indent: [{
          indent: He()
        }],
        /**
         * Vertical Alignment
         * @see https://tailwindcss.com/docs/vertical-align
         */
        "vertical-align": [{
          align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", m]
        }],
        /**
         * Whitespace
         * @see https://tailwindcss.com/docs/whitespace
         */
        whitespace: [{
          whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
        }],
        /**
         * Word Break
         * @see https://tailwindcss.com/docs/word-break
         */
        break: [{
          break: ["normal", "words", "all", "keep"]
        }],
        /**
         * Hyphens
         * @see https://tailwindcss.com/docs/hyphens
         */
        hyphens: [{
          hyphens: ["none", "manual", "auto"]
        }],
        /**
         * Content
         * @see https://tailwindcss.com/docs/content
         */
        content: [{
          content: ["none", m]
        }],
        // Backgrounds
        /**
         * Background Attachment
         * @see https://tailwindcss.com/docs/background-attachment
         */
        "bg-attachment": [{
          bg: ["fixed", "local", "scroll"]
        }],
        /**
         * Background Clip
         * @see https://tailwindcss.com/docs/background-clip
         */
        "bg-clip": [{
          "bg-clip": ["border", "padding", "content", "text"]
        }],
        /**
         * Background Opacity
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/background-opacity
         */
        "bg-opacity": [{
          "bg-opacity": [Pt]
        }],
        /**
         * Background Origin
         * @see https://tailwindcss.com/docs/background-origin
         */
        "bg-origin": [{
          "bg-origin": ["border", "padding", "content"]
        }],
        /**
         * Background Position
         * @see https://tailwindcss.com/docs/background-position
         */
        "bg-position": [{
          bg: [...ut(), X]
        }],
        /**
         * Background Repeat
         * @see https://tailwindcss.com/docs/background-repeat
         */
        "bg-repeat": [{
          bg: ["no-repeat", {
            repeat: ["", "x", "y", "round", "space"]
          }]
        }],
        /**
         * Background Size
         * @see https://tailwindcss.com/docs/background-size
         */
        "bg-size": [{
          bg: ["auto", "cover", "contain", W]
        }],
        /**
         * Background Image
         * @see https://tailwindcss.com/docs/background-image
         */
        "bg-image": [{
          bg: ["none", {
            "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, re]
        }],
        /**
         * Background Color
         * @see https://tailwindcss.com/docs/background-color
         */
        "bg-color": [{
          bg: [_]
        }],
        /**
         * Gradient Color Stops From Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from-pos": [{
          from: [At]
        }],
        /**
         * Gradient Color Stops Via Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via-pos": [{
          via: [At]
        }],
        /**
         * Gradient Color Stops To Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to-pos": [{
          to: [At]
        }],
        /**
         * Gradient Color Stops From
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from": [{
          from: [et]
        }],
        /**
         * Gradient Color Stops Via
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via": [{
          via: [et]
        }],
        /**
         * Gradient Color Stops To
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to": [{
          to: [et]
        }],
        // Borders
        /**
         * Border Radius
         * @see https://tailwindcss.com/docs/border-radius
         */
        rounded: [{
          rounded: [ge]
        }],
        /**
         * Border Radius Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-s": [{
          "rounded-s": [ge]
        }],
        /**
         * Border Radius End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-e": [{
          "rounded-e": [ge]
        }],
        /**
         * Border Radius Top
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-t": [{
          "rounded-t": [ge]
        }],
        /**
         * Border Radius Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-r": [{
          "rounded-r": [ge]
        }],
        /**
         * Border Radius Bottom
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-b": [{
          "rounded-b": [ge]
        }],
        /**
         * Border Radius Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-l": [{
          "rounded-l": [ge]
        }],
        /**
         * Border Radius Start Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ss": [{
          "rounded-ss": [ge]
        }],
        /**
         * Border Radius Start End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-se": [{
          "rounded-se": [ge]
        }],
        /**
         * Border Radius End End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ee": [{
          "rounded-ee": [ge]
        }],
        /**
         * Border Radius End Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-es": [{
          "rounded-es": [ge]
        }],
        /**
         * Border Radius Top Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tl": [{
          "rounded-tl": [ge]
        }],
        /**
         * Border Radius Top Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tr": [{
          "rounded-tr": [ge]
        }],
        /**
         * Border Radius Bottom Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-br": [{
          "rounded-br": [ge]
        }],
        /**
         * Border Radius Bottom Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-bl": [{
          "rounded-bl": [ge]
        }],
        /**
         * Border Width
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w": [{
          border: [Me]
        }],
        /**
         * Border Width X
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-x": [{
          "border-x": [Me]
        }],
        /**
         * Border Width Y
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-y": [{
          "border-y": [Me]
        }],
        /**
         * Border Width Start
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-s": [{
          "border-s": [Me]
        }],
        /**
         * Border Width End
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-e": [{
          "border-e": [Me]
        }],
        /**
         * Border Width Top
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-t": [{
          "border-t": [Me]
        }],
        /**
         * Border Width Right
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-r": [{
          "border-r": [Me]
        }],
        /**
         * Border Width Bottom
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-b": [{
          "border-b": [Me]
        }],
        /**
         * Border Width Left
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-l": [{
          "border-l": [Me]
        }],
        /**
         * Border Opacity
         * @see https://tailwindcss.com/docs/border-opacity
         */
        "border-opacity": [{
          "border-opacity": [Pt]
        }],
        /**
         * Border Style
         * @see https://tailwindcss.com/docs/border-style
         */
        "border-style": [{
          border: [...It(), "hidden"]
        }],
        /**
         * Divide Width X
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-x": [{
          "divide-x": [Me]
        }],
        /**
         * Divide Width X Reverse
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-x-reverse": ["divide-x-reverse"],
        /**
         * Divide Width Y
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-y": [{
          "divide-y": [Me]
        }],
        /**
         * Divide Width Y Reverse
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-y-reverse": ["divide-y-reverse"],
        /**
         * Divide Opacity
         * @see https://tailwindcss.com/docs/divide-opacity
         */
        "divide-opacity": [{
          "divide-opacity": [Pt]
        }],
        /**
         * Divide Style
         * @see https://tailwindcss.com/docs/divide-style
         */
        "divide-style": [{
          divide: It()
        }],
        /**
         * Border Color
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color": [{
          border: [ye]
        }],
        /**
         * Border Color X
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-x": [{
          "border-x": [ye]
        }],
        /**
         * Border Color Y
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-y": [{
          "border-y": [ye]
        }],
        /**
         * Border Color Top
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-t": [{
          "border-t": [ye]
        }],
        /**
         * Border Color Right
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-r": [{
          "border-r": [ye]
        }],
        /**
         * Border Color Bottom
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-b": [{
          "border-b": [ye]
        }],
        /**
         * Border Color Left
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-l": [{
          "border-l": [ye]
        }],
        /**
         * Divide Color
         * @see https://tailwindcss.com/docs/divide-color
         */
        "divide-color": [{
          divide: [ye]
        }],
        /**
         * Outline Style
         * @see https://tailwindcss.com/docs/outline-style
         */
        "outline-style": [{
          outline: ["", ...It()]
        }],
        /**
         * Outline Offset
         * @see https://tailwindcss.com/docs/outline-offset
         */
        "outline-offset": [{
          "outline-offset": [u, m]
        }],
        /**
         * Outline Width
         * @see https://tailwindcss.com/docs/outline-width
         */
        "outline-w": [{
          outline: [u, h]
        }],
        /**
         * Outline Color
         * @see https://tailwindcss.com/docs/outline-color
         */
        "outline-color": [{
          outline: [_]
        }],
        /**
         * Ring Width
         * @see https://tailwindcss.com/docs/ring-width
         */
        "ring-w": [{
          ring: Vt()
        }],
        /**
         * Ring Width Inset
         * @see https://tailwindcss.com/docs/ring-width
         */
        "ring-w-inset": ["ring-inset"],
        /**
         * Ring Color
         * @see https://tailwindcss.com/docs/ring-color
         */
        "ring-color": [{
          ring: [_]
        }],
        /**
         * Ring Opacity
         * @see https://tailwindcss.com/docs/ring-opacity
         */
        "ring-opacity": [{
          "ring-opacity": [Pt]
        }],
        /**
         * Ring Offset Width
         * @see https://tailwindcss.com/docs/ring-offset-width
         */
        "ring-offset-w": [{
          "ring-offset": [u, h]
        }],
        /**
         * Ring Offset Color
         * @see https://tailwindcss.com/docs/ring-offset-color
         */
        "ring-offset-color": [{
          "ring-offset": [_]
        }],
        // Effects
        /**
         * Box Shadow
         * @see https://tailwindcss.com/docs/box-shadow
         */
        shadow: [{
          shadow: ["", "inner", "none", l, ce]
        }],
        /**
         * Box Shadow Color
         * @see https://tailwindcss.com/docs/box-shadow-color
         */
        "shadow-color": [{
          shadow: [pe]
        }],
        /**
         * Opacity
         * @see https://tailwindcss.com/docs/opacity
         */
        opacity: [{
          opacity: [Pt]
        }],
        /**
         * Mix Blend Mode
         * @see https://tailwindcss.com/docs/mix-blend-mode
         */
        "mix-blend": [{
          "mix-blend": [...kt(), "plus-lighter", "plus-darker"]
        }],
        /**
         * Background Blend Mode
         * @see https://tailwindcss.com/docs/background-blend-mode
         */
        "bg-blend": [{
          "bg-blend": kt()
        }],
        // Filters
        /**
         * Filter
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/filter
         */
        filter: [{
          filter: ["", "none"]
        }],
        /**
         * Blur
         * @see https://tailwindcss.com/docs/blur
         */
        blur: [{
          blur: [ne]
        }],
        /**
         * Brightness
         * @see https://tailwindcss.com/docs/brightness
         */
        brightness: [{
          brightness: [de]
        }],
        /**
         * Contrast
         * @see https://tailwindcss.com/docs/contrast
         */
        contrast: [{
          contrast: [Ce]
        }],
        /**
         * Drop Shadow
         * @see https://tailwindcss.com/docs/drop-shadow
         */
        "drop-shadow": [{
          "drop-shadow": ["", "none", l, m]
        }],
        /**
         * Grayscale
         * @see https://tailwindcss.com/docs/grayscale
         */
        grayscale: [{
          grayscale: [je]
        }],
        /**
         * Hue Rotate
         * @see https://tailwindcss.com/docs/hue-rotate
         */
        "hue-rotate": [{
          "hue-rotate": [Ue]
        }],
        /**
         * Invert
         * @see https://tailwindcss.com/docs/invert
         */
        invert: [{
          invert: [Qe]
        }],
        /**
         * Saturate
         * @see https://tailwindcss.com/docs/saturate
         */
        saturate: [{
          saturate: [st]
        }],
        /**
         * Sepia
         * @see https://tailwindcss.com/docs/sepia
         */
        sepia: [{
          sepia: [xt]
        }],
        /**
         * Backdrop Filter
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/backdrop-filter
         */
        "backdrop-filter": [{
          "backdrop-filter": ["", "none"]
        }],
        /**
         * Backdrop Blur
         * @see https://tailwindcss.com/docs/backdrop-blur
         */
        "backdrop-blur": [{
          "backdrop-blur": [ne]
        }],
        /**
         * Backdrop Brightness
         * @see https://tailwindcss.com/docs/backdrop-brightness
         */
        "backdrop-brightness": [{
          "backdrop-brightness": [de]
        }],
        /**
         * Backdrop Contrast
         * @see https://tailwindcss.com/docs/backdrop-contrast
         */
        "backdrop-contrast": [{
          "backdrop-contrast": [Ce]
        }],
        /**
         * Backdrop Grayscale
         * @see https://tailwindcss.com/docs/backdrop-grayscale
         */
        "backdrop-grayscale": [{
          "backdrop-grayscale": [je]
        }],
        /**
         * Backdrop Hue Rotate
         * @see https://tailwindcss.com/docs/backdrop-hue-rotate
         */
        "backdrop-hue-rotate": [{
          "backdrop-hue-rotate": [Ue]
        }],
        /**
         * Backdrop Invert
         * @see https://tailwindcss.com/docs/backdrop-invert
         */
        "backdrop-invert": [{
          "backdrop-invert": [Qe]
        }],
        /**
         * Backdrop Opacity
         * @see https://tailwindcss.com/docs/backdrop-opacity
         */
        "backdrop-opacity": [{
          "backdrop-opacity": [Pt]
        }],
        /**
         * Backdrop Saturate
         * @see https://tailwindcss.com/docs/backdrop-saturate
         */
        "backdrop-saturate": [{
          "backdrop-saturate": [st]
        }],
        /**
         * Backdrop Sepia
         * @see https://tailwindcss.com/docs/backdrop-sepia
         */
        "backdrop-sepia": [{
          "backdrop-sepia": [xt]
        }],
        // Tables
        /**
         * Border Collapse
         * @see https://tailwindcss.com/docs/border-collapse
         */
        "border-collapse": [{
          border: ["collapse", "separate"]
        }],
        /**
         * Border Spacing
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing": [{
          "border-spacing": [be]
        }],
        /**
         * Border Spacing X
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-x": [{
          "border-spacing-x": [be]
        }],
        /**
         * Border Spacing Y
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-y": [{
          "border-spacing-y": [be]
        }],
        /**
         * Table Layout
         * @see https://tailwindcss.com/docs/table-layout
         */
        "table-layout": [{
          table: ["auto", "fixed"]
        }],
        /**
         * Caption Side
         * @see https://tailwindcss.com/docs/caption-side
         */
        caption: [{
          caption: ["top", "bottom"]
        }],
        // Transitions and Animation
        /**
         * Tranisition Property
         * @see https://tailwindcss.com/docs/transition-property
         */
        transition: [{
          transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", m]
        }],
        /**
         * Transition Duration
         * @see https://tailwindcss.com/docs/transition-duration
         */
        duration: [{
          duration: Dt()
        }],
        /**
         * Transition Timing Function
         * @see https://tailwindcss.com/docs/transition-timing-function
         */
        ease: [{
          ease: ["linear", "in", "out", "in-out", m]
        }],
        /**
         * Transition Delay
         * @see https://tailwindcss.com/docs/transition-delay
         */
        delay: [{
          delay: Dt()
        }],
        /**
         * Animation
         * @see https://tailwindcss.com/docs/animation
         */
        animate: [{
          animate: ["none", "spin", "ping", "pulse", "bounce", m]
        }],
        // Transforms
        /**
         * Transform
         * @see https://tailwindcss.com/docs/transform
         */
        transform: [{
          transform: ["", "gpu", "none"]
        }],
        /**
         * Scale
         * @see https://tailwindcss.com/docs/scale
         */
        scale: [{
          scale: [zt]
        }],
        /**
         * Scale X
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-x": [{
          "scale-x": [zt]
        }],
        /**
         * Scale Y
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-y": [{
          "scale-y": [zt]
        }],
        /**
         * Rotate
         * @see https://tailwindcss.com/docs/rotate
         */
        rotate: [{
          rotate: [P, m]
        }],
        /**
         * Translate X
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-x": [{
          "translate-x": [Tt]
        }],
        /**
         * Translate Y
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-y": [{
          "translate-y": [Tt]
        }],
        /**
         * Skew X
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-x": [{
          "skew-x": [lt]
        }],
        /**
         * Skew Y
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-y": [{
          "skew-y": [lt]
        }],
        /**
         * Transform Origin
         * @see https://tailwindcss.com/docs/transform-origin
         */
        "transform-origin": [{
          origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", m]
        }],
        // Interactivity
        /**
         * Accent Color
         * @see https://tailwindcss.com/docs/accent-color
         */
        accent: [{
          accent: ["auto", _]
        }],
        /**
         * Appearance
         * @see https://tailwindcss.com/docs/appearance
         */
        appearance: [{
          appearance: ["none", "auto"]
        }],
        /**
         * Cursor
         * @see https://tailwindcss.com/docs/cursor
         */
        cursor: [{
          cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", m]
        }],
        /**
         * Caret Color
         * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
         */
        "caret-color": [{
          caret: [_]
        }],
        /**
         * Pointer Events
         * @see https://tailwindcss.com/docs/pointer-events
         */
        "pointer-events": [{
          "pointer-events": ["none", "auto"]
        }],
        /**
         * Resize
         * @see https://tailwindcss.com/docs/resize
         */
        resize: [{
          resize: ["none", "y", "x", ""]
        }],
        /**
         * Scroll Behavior
         * @see https://tailwindcss.com/docs/scroll-behavior
         */
        "scroll-behavior": [{
          scroll: ["auto", "smooth"]
        }],
        /**
         * Scroll Margin
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-m": [{
          "scroll-m": He()
        }],
        /**
         * Scroll Margin X
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mx": [{
          "scroll-mx": He()
        }],
        /**
         * Scroll Margin Y
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-my": [{
          "scroll-my": He()
        }],
        /**
         * Scroll Margin Start
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ms": [{
          "scroll-ms": He()
        }],
        /**
         * Scroll Margin End
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-me": [{
          "scroll-me": He()
        }],
        /**
         * Scroll Margin Top
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mt": [{
          "scroll-mt": He()
        }],
        /**
         * Scroll Margin Right
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mr": [{
          "scroll-mr": He()
        }],
        /**
         * Scroll Margin Bottom
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mb": [{
          "scroll-mb": He()
        }],
        /**
         * Scroll Margin Left
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ml": [{
          "scroll-ml": He()
        }],
        /**
         * Scroll Padding
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-p": [{
          "scroll-p": He()
        }],
        /**
         * Scroll Padding X
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-px": [{
          "scroll-px": He()
        }],
        /**
         * Scroll Padding Y
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-py": [{
          "scroll-py": He()
        }],
        /**
         * Scroll Padding Start
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-ps": [{
          "scroll-ps": He()
        }],
        /**
         * Scroll Padding End
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pe": [{
          "scroll-pe": He()
        }],
        /**
         * Scroll Padding Top
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pt": [{
          "scroll-pt": He()
        }],
        /**
         * Scroll Padding Right
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pr": [{
          "scroll-pr": He()
        }],
        /**
         * Scroll Padding Bottom
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pb": [{
          "scroll-pb": He()
        }],
        /**
         * Scroll Padding Left
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pl": [{
          "scroll-pl": He()
        }],
        /**
         * Scroll Snap Align
         * @see https://tailwindcss.com/docs/scroll-snap-align
         */
        "snap-align": [{
          snap: ["start", "end", "center", "align-none"]
        }],
        /**
         * Scroll Snap Stop
         * @see https://tailwindcss.com/docs/scroll-snap-stop
         */
        "snap-stop": [{
          snap: ["normal", "always"]
        }],
        /**
         * Scroll Snap Type
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-type": [{
          snap: ["none", "x", "y", "both"]
        }],
        /**
         * Scroll Snap Type Strictness
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-strictness": [{
          snap: ["mandatory", "proximity"]
        }],
        /**
         * Touch Action
         * @see https://tailwindcss.com/docs/touch-action
         */
        touch: [{
          touch: ["auto", "none", "manipulation"]
        }],
        /**
         * Touch Action X
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-x": [{
          "touch-pan": ["x", "left", "right"]
        }],
        /**
         * Touch Action Y
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-y": [{
          "touch-pan": ["y", "up", "down"]
        }],
        /**
         * Touch Action Pinch Zoom
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-pz": ["touch-pinch-zoom"],
        /**
         * User Select
         * @see https://tailwindcss.com/docs/user-select
         */
        select: [{
          select: ["none", "text", "all", "auto"]
        }],
        /**
         * Will Change
         * @see https://tailwindcss.com/docs/will-change
         */
        "will-change": [{
          "will-change": ["auto", "scroll", "contents", "transform", m]
        }],
        // SVG
        /**
         * Fill
         * @see https://tailwindcss.com/docs/fill
         */
        fill: [{
          fill: [_, "none"]
        }],
        /**
         * Stroke Width
         * @see https://tailwindcss.com/docs/stroke-width
         */
        "stroke-w": [{
          stroke: [u, h, E]
        }],
        /**
         * Stroke
         * @see https://tailwindcss.com/docs/stroke
         */
        stroke: [{
          stroke: [_, "none"]
        }],
        // Accessibility
        /**
         * Screen Readers
         * @see https://tailwindcss.com/docs/screen-readers
         */
        sr: ["sr-only", "not-sr-only"],
        /**
         * Forced Color Adjust
         * @see https://tailwindcss.com/docs/forced-color-adjust
         */
        "forced-color-adjust": [{
          "forced-color-adjust": ["auto", "none"]
        }]
      },
      conflictingClassGroups: {
        overflow: ["overflow-x", "overflow-y"],
        overscroll: ["overscroll-x", "overscroll-y"],
        inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
        "inset-x": ["right", "left"],
        "inset-y": ["top", "bottom"],
        flex: ["basis", "grow", "shrink"],
        gap: ["gap-x", "gap-y"],
        p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
        px: ["pr", "pl"],
        py: ["pt", "pb"],
        m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
        mx: ["mr", "ml"],
        my: ["mt", "mb"],
        size: ["w", "h"],
        "font-size": ["leading"],
        "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
        "fvn-ordinal": ["fvn-normal"],
        "fvn-slashed-zero": ["fvn-normal"],
        "fvn-figure": ["fvn-normal"],
        "fvn-spacing": ["fvn-normal"],
        "fvn-fraction": ["fvn-normal"],
        "line-clamp": ["display", "overflow"],
        rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
        "rounded-s": ["rounded-ss", "rounded-es"],
        "rounded-e": ["rounded-se", "rounded-ee"],
        "rounded-t": ["rounded-tl", "rounded-tr"],
        "rounded-r": ["rounded-tr", "rounded-br"],
        "rounded-b": ["rounded-br", "rounded-bl"],
        "rounded-l": ["rounded-tl", "rounded-bl"],
        "border-spacing": ["border-spacing-x", "border-spacing-y"],
        "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
        "border-w-x": ["border-w-r", "border-w-l"],
        "border-w-y": ["border-w-t", "border-w-b"],
        "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
        "border-color-x": ["border-color-r", "border-color-l"],
        "border-color-y": ["border-color-t", "border-color-b"],
        "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
        "scroll-mx": ["scroll-mr", "scroll-ml"],
        "scroll-my": ["scroll-mt", "scroll-mb"],
        "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
        "scroll-px": ["scroll-pr", "scroll-pl"],
        "scroll-py": ["scroll-pt", "scroll-pb"],
        touch: ["touch-x", "touch-y", "touch-pz"],
        "touch-x": ["touch"],
        "touch-y": ["touch"],
        "touch-pz": ["touch"]
      },
      conflictingClassGroupModifiers: {
        "font-size": ["leading"]
      }
    };
  }
  function ue(_, {
    cacheSize: q,
    prefix: ne,
    separator: de,
    extend: ye = {},
    override: ge = {}
  }) {
    we(_, "cacheSize", q), we(_, "prefix", ne), we(_, "separator", de);
    for (const be in ge)
      ke(_[be], ge[be]);
    for (const be in ye)
      Re(_[be], ye[be]);
    return _;
  }
  function we(_, q, ne) {
    ne !== void 0 && (_[q] = ne);
  }
  function ke(_, q) {
    if (q)
      for (const ne in q)
        we(_, ne, q[ne]);
  }
  function Re(_, q) {
    if (q)
      for (const ne in q) {
        const de = q[ne];
        de !== void 0 && (_[ne] = (_[ne] || []).concat(de));
      }
  }
  function fe(_, ...q) {
    return typeof _ == "function" ? A(U, _, ...q) : A(() => ue(U(), _), ...q);
  }
  const x = /* @__PURE__ */ A(U);
  e.createTailwindMerge = A, e.extendTailwindMerge = fe, e.fromTheme = R, e.getDefaultConfig = U, e.mergeConfigs = ue, e.twJoin = M, e.twMerge = x, e.validators = te;
})(O5);
Object.defineProperty(hi, "__esModule", { value: !0 });
hi.classnames = hi.capitalizeFirstLetter = hi.ultraAbbreviateAddress = hi.abbreviateAddress = hi.abbreviate = void 0;
const Ox = Px, Nx = O5;
function g1(e, t = 4, r = 4) {
  return !e || e.length <= t + r ? e : e.substring(0, t) + "..." + e.substring(e.length - r);
}
hi.abbreviate = g1;
function xx(e) {
  return g1(e, 6, 4);
}
hi.abbreviateAddress = xx;
function Tx(e) {
  return g1(e, 2, 4);
}
hi.ultraAbbreviateAddress = Tx;
const kx = (e) => e.charAt(0).toUpperCase() + e.slice(1);
hi.capitalizeFirstLetter = kx;
function Sx(...e) {
  return (0, Nx.twMerge)((0, Ox.clsx)(e));
}
hi.classnames = Sx;
var Tr = {};
Object.defineProperty(Tr, "__esModule", { value: !0 });
Tr.convertPotentialWeb3ProtocolURLToWeb2URL = Tr.isYoutubeVideoURL = Tr.getManifoldGalleryBaseURL = Tr.getEtherscanURLForWallet = Tr.getEtherscanURLForContract = Tr.getEtherscanURLForAddress = Tr.getEtherscanURLForTransactionHash = Tr.getEtherscanURLForToken = Tr.getEtherscanBaseURL = Tr.getOpenSeaTokenURL = Tr.getOpenSeaCollectionURL = Tr.getOpenSeaBaseURL = void 0;
const yo = tf;
function m1(e) {
  return `${(0, yo.isTestnet)(e) ? "https://testnets.opensea.io" : "https://opensea.io"}/assets/${(0, yo.getNetworkNameforNetworkId)(e)}`;
}
Tr.getOpenSeaBaseURL = m1;
function Mx(e, t) {
  return `${m1(e)}/${t}`;
}
Tr.getOpenSeaCollectionURL = Mx;
function Ix(e, t, r) {
  return `${m1(e)}/${t}/${r}`;
}
Tr.getOpenSeaTokenURL = Ix;
function rf(e) {
  switch (e) {
    case yo.NETWORK_IDS.OPTIMISM:
      return "https://optimistic.etherscan.io";
    case yo.NETWORK_IDS.GOERLI:
      return "https://goerli.etherscan.io";
    case yo.NETWORK_IDS.SEPOLIA:
      return "https://sepolia.etherscan.io";
    case yo.NETWORK_IDS.BASE:
      return "https://basescan.org";
    case yo.NETWORK_IDS.MAINNET:
      return "https://etherscan.io";
    default:
      throw new Error("Unsupported Network passed to getEtherscanBaseURL");
  }
}
Tr.getEtherscanBaseURL = rf;
function Rx(e, t, r) {
  return `${rf(e)}/nft/${t}/${r}`;
}
Tr.getEtherscanURLForToken = Rx;
function Cx(e, t) {
  return `${rf(e)}/tx/${t}`;
}
Tr.getEtherscanURLForTransactionHash = Cx;
function y1(e, t) {
  return `${rf(e)}/address/${t}`;
}
Tr.getEtherscanURLForAddress = y1;
function Bx(e, t) {
  return y1(e, t);
}
Tr.getEtherscanURLForContract = Bx;
function _x(e, t) {
  return y1(e, t);
}
Tr.getEtherscanURLForWallet = _x;
function Fx(e) {
  return e === 1 ? "https://gallery.manifold.xyz" : `https://gallery.manifold.xyz/${(0, yo.getNetworkNameforNetworkId)(e)}`;
}
Tr.getManifoldGalleryBaseURL = Fx;
function Ux(e) {
  return e.includes("https://www.youtube.com") || e.includes("https://youtu.be") || e.includes("https://youtube.com") || e.includes("https://www.youtube-nocookie.com");
}
Tr.isYoutubeVideoURL = Ux;
const Dx = (e, t) => {
  let r = e;
  if (r.includes("ipfs://ipfs/"))
    r = r.replace("ipfs://ipfs/", "https://ipfs.io/ipfs/");
  else if (r.includes("ipfs://"))
    r = r.replace("ipfs://", "https://ipfs.io/ipfs/");
  else if (r.includes("ar://"))
    r = r.replace("ar://", "https://arweave.net/");
  else if (t && r.includes("api.opensea.io/api/v1/metadata/") && r.includes("{id}")) {
    let n = t.toHexString();
    n = n.replace("0x", ""), r = r.replace("{id}", n);
  }
  return r;
};
Tr.convertPotentialWeb3ProtocolURLToWeb2URL = Dx;
var Zu = {}, N5 = {}, Bp = function(e, t) {
  return Bp = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var s in n)
      Object.prototype.hasOwnProperty.call(n, s) && (r[s] = n[s]);
  }, Bp(e, t);
};
function jx(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Bp(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var _p = function() {
  return _p = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, _p.apply(this, arguments);
};
function Lx(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
      t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (r[n[s]] = e[n[s]]);
  return r;
}
function Hx(e, t, r, n) {
  var s = arguments.length, i = s < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, r, n);
  else
    for (var f = e.length - 1; f >= 0; f--)
      (a = e[f]) && (i = (s < 3 ? a(i) : s > 3 ? a(t, r, i) : a(t, r)) || i);
  return s > 3 && i && Object.defineProperty(t, r, i), i;
}
function Wx(e, t) {
  return function(r, n) {
    t(r, n, e);
  };
}
function Gx(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
}
function zx(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function Vx(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, s, i, a;
  return a = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function f(c) {
    return function(p) {
      return d([c, p]);
    };
  }
  function d(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, s && (i = c[0] & 2 ? s.return : c[0] ? s.throw || ((i = s.return) && i.call(s), 0) : s.next) && !(i = i.call(s, c[1])).done)
          return i;
        switch (s = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
          case 0:
          case 1:
            i = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, s = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < i[1]) {
              r.label = i[1], i = c;
              break;
            }
            if (i && r.label < i[2]) {
              r.label = i[2], r.ops.push(c);
              break;
            }
            i[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (p) {
        c = [6, p], s = 0;
      } finally {
        n = i = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var b1 = Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var s = Object.getOwnPropertyDescriptor(t, r);
  (!s || ("get" in s ? !t.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, s);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
};
function qx(e, t) {
  for (var r in e)
    r !== "default" && !Object.prototype.hasOwnProperty.call(t, r) && b1(t, e, r);
}
function Fp(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function x5(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), s, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(s = n.next()).done; )
      i.push(s.value);
  } catch (f) {
    a = { error: f };
  } finally {
    try {
      s && !s.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
function $x() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(x5(arguments[t]));
  return e;
}
function Kx() {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++)
    e += arguments[t].length;
  for (var n = Array(e), s = 0, t = 0; t < r; t++)
    for (var i = arguments[t], a = 0, f = i.length; a < f; a++, s++)
      n[s] = i[a];
  return n;
}
function Jx(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, s = t.length, i; n < s; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function X0(e) {
  return this instanceof X0 ? (this.v = e, this) : new X0(e);
}
function Qx(e, t, r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(e, t || []), s, i = [];
  return s = {}, a("next"), a("throw"), a("return"), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function a(v) {
    n[v] && (s[v] = function(O) {
      return new Promise(function(N, S) {
        i.push([v, O, N, S]) > 1 || f(v, O);
      });
    });
  }
  function f(v, O) {
    try {
      d(n[v](O));
    } catch (N) {
      g(i[0][3], N);
    }
  }
  function d(v) {
    v.value instanceof X0 ? Promise.resolve(v.value.v).then(c, p) : g(i[0][2], v);
  }
  function c(v) {
    f("next", v);
  }
  function p(v) {
    f("throw", v);
  }
  function g(v, O) {
    v(O), i.shift(), i.length && f(i[0][0], i[0][1]);
  }
}
function Zx(e) {
  var t, r;
  return t = {}, n("next"), n("throw", function(s) {
    throw s;
  }), n("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function n(s, i) {
    t[s] = e[s] ? function(a) {
      return (r = !r) ? { value: X0(e[s](a)), done: s === "return" } : i ? i(a) : a;
    } : i;
  }
}
function Yx(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], r;
  return t ? t.call(e) : (e = typeof Fp == "function" ? Fp(e) : e[Symbol.iterator](), r = {}, n("next"), n("throw"), n("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function n(i) {
    r[i] = e[i] && function(a) {
      return new Promise(function(f, d) {
        a = e[i](a), s(f, d, a.done, a.value);
      });
    };
  }
  function s(i, a, f, d) {
    Promise.resolve(d).then(function(c) {
      i({ value: c, done: f });
    }, a);
  }
}
function Xx(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
var eT = Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
};
function tT(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && b1(t, e, r);
  return eT(t, e), t;
}
function rT(e) {
  return e && e.__esModule ? e : { default: e };
}
function nT(e, t, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}
function iT(e, t, r, n, s) {
  if (n === "m")
    throw new TypeError("Private method is not writable");
  if (n === "a" && !s)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !s : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}
function sT(e, t) {
  if (t === null || typeof t != "object" && typeof t != "function")
    throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof e == "function" ? t === e : e.has(t);
}
const oT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return _p;
  },
  __asyncDelegator: Zx,
  __asyncGenerator: Qx,
  __asyncValues: Yx,
  __await: X0,
  __awaiter: zx,
  __classPrivateFieldGet: nT,
  __classPrivateFieldIn: sT,
  __classPrivateFieldSet: iT,
  __createBinding: b1,
  __decorate: Hx,
  __exportStar: qx,
  __extends: jx,
  __generator: Vx,
  __importDefault: rT,
  __importStar: tT,
  __makeTemplateObject: Xx,
  __metadata: Gx,
  __param: Wx,
  __read: x5,
  __rest: Lx,
  __spread: $x,
  __spreadArray: Jx,
  __spreadArrays: Kx,
  __values: Fp
}, Symbol.toStringTag, { value: "Module" })), aT = /* @__PURE__ */ Lh(oT);
var Fm = {}, Cd = {}, Um;
function w1() {
  return Um || (Um = 1, Object.defineProperty(Cd, "__esModule", { value: !0 }), Cd.version = void 0, Cd.version = "6.12.1"), Cd;
}
var Dm = {}, hc = {}, jm = {}, Do = {}, Sr = {}, Kr = {}, jo = {}, Lm;
function ru() {
  if (Lm)
    return jo;
  Lm = 1, Object.defineProperty(jo, "__esModule", { value: !0 }), jo.defineProperties = jo.resolveProperties = void 0;
  function e(n, s, i) {
    const a = s.split("|").map((d) => d.trim());
    for (let d = 0; d < a.length; d++)
      switch (s) {
        case "any":
          return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
          if (typeof n === s)
            return;
      }
    const f = new Error(`invalid value for type ${s}`);
    throw f.code = "INVALID_ARGUMENT", f.argument = `value.${i}`, f.value = n, f;
  }
  async function t(n) {
    const s = Object.keys(n);
    return (await Promise.all(s.map((i) => Promise.resolve(n[i])))).reduce((i, a, f) => (i[s[f]] = a, i), {});
  }
  jo.resolveProperties = t;
  function r(n, s, i) {
    for (let a in s) {
      let f = s[a];
      const d = i ? i[a] : null;
      d && e(f, d, a), Object.defineProperty(n, a, { enumerable: !0, value: f, writable: !1 });
    }
  }
  return jo.defineProperties = r, jo;
}
var Hm;
function ws() {
  if (Hm)
    return Kr;
  Hm = 1, Object.defineProperty(Kr, "__esModule", { value: !0 }), Kr.assertPrivate = Kr.assertNormalize = Kr.assertArgumentCount = Kr.assertArgument = Kr.assert = Kr.makeError = Kr.isCallException = Kr.isError = void 0;
  const e = w1(), t = ru();
  function r(v) {
    if (v == null)
      return "null";
    if (Array.isArray(v))
      return "[ " + v.map(r).join(", ") + " ]";
    if (v instanceof Uint8Array) {
      const O = "0123456789abcdef";
      let N = "0x";
      for (let S = 0; S < v.length; S++)
        N += O[v[S] >> 4], N += O[v[S] & 15];
      return N;
    }
    if (typeof v == "object" && typeof v.toJSON == "function")
      return r(v.toJSON());
    switch (typeof v) {
      case "boolean":
      case "symbol":
        return v.toString();
      case "bigint":
        return BigInt(v).toString();
      case "number":
        return v.toString();
      case "string":
        return JSON.stringify(v);
      case "object": {
        const O = Object.keys(v);
        return O.sort(), "{ " + O.map((N) => `${r(N)}: ${r(v[N])}`).join(", ") + " }";
      }
    }
    return "[ COULD NOT SERIALIZE ]";
  }
  function n(v, O) {
    return v && v.code === O;
  }
  Kr.isError = n;
  function s(v) {
    return n(v, "CALL_EXCEPTION");
  }
  Kr.isCallException = s;
  function i(v, O, N) {
    let S = v;
    {
      const B = [];
      if (N) {
        if ("message" in N || "code" in N || "name" in N)
          throw new Error(`value will overwrite populated values: ${r(N)}`);
        for (const M in N) {
          if (M === "shortMessage")
            continue;
          const I = N[M];
          B.push(M + "=" + r(I));
        }
      }
      B.push(`code=${O}`), B.push(`version=${e.version}`), B.length && (v += " (" + B.join(", ") + ")");
    }
    let j;
    switch (O) {
      case "INVALID_ARGUMENT":
        j = new TypeError(v);
        break;
      case "NUMERIC_FAULT":
      case "BUFFER_OVERRUN":
        j = new RangeError(v);
        break;
      default:
        j = new Error(v);
    }
    return (0, t.defineProperties)(j, { code: O }), N && Object.assign(j, N), j.shortMessage == null && (0, t.defineProperties)(j, { shortMessage: S }), j;
  }
  Kr.makeError = i;
  function a(v, O, N, S) {
    if (!v)
      throw i(O, N, S);
  }
  Kr.assert = a;
  function f(v, O, N, S) {
    a(v, O, "INVALID_ARGUMENT", { argument: N, value: S });
  }
  Kr.assertArgument = f;
  function d(v, O, N) {
    N == null && (N = ""), N && (N = ": " + N), a(v >= O, "missing arguemnt" + N, "MISSING_ARGUMENT", {
      count: v,
      expectedCount: O
    }), a(v <= O, "too many arguments" + N, "UNEXPECTED_ARGUMENT", {
      count: v,
      expectedCount: O
    });
  }
  Kr.assertArgumentCount = d;
  const c = ["NFD", "NFC", "NFKD", "NFKC"].reduce((v, O) => {
    try {
      if ("test".normalize(O) !== "test")
        throw new Error("bad");
      if (O === "NFD" && "é".normalize("NFD") !== "é")
        throw new Error("broken");
      v.push(O);
    } catch {
    }
    return v;
  }, []);
  function p(v) {
    a(c.indexOf(v) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
      operation: "String.prototype.normalize",
      info: { form: v }
    });
  }
  Kr.assertNormalize = p;
  function g(v, O, N) {
    if (N == null && (N = ""), v !== O) {
      let S = N, j = "new";
      N && (S += ".", j += " " + N), a(!1, `private constructor; use ${S}from* methods`, "UNSUPPORTED_OPERATION", {
        operation: j
      });
    }
  }
  return Kr.assertPrivate = g, Kr;
}
var Wm;
function Vi() {
  if (Wm)
    return Sr;
  Wm = 1, Object.defineProperty(Sr, "__esModule", { value: !0 }), Sr.zeroPadBytes = Sr.zeroPadValue = Sr.stripZerosLeft = Sr.dataSlice = Sr.dataLength = Sr.concat = Sr.hexlify = Sr.isBytesLike = Sr.isHexString = Sr.getBytesCopy = Sr.getBytes = void 0;
  const e = ws();
  function t(S, j, B) {
    if (S instanceof Uint8Array)
      return B ? new Uint8Array(S) : S;
    if (typeof S == "string" && S.match(/^0x([0-9a-f][0-9a-f])*$/i)) {
      const M = new Uint8Array((S.length - 2) / 2);
      let I = 2;
      for (let A = 0; A < M.length; A++)
        M[A] = parseInt(S.substring(I, I + 2), 16), I += 2;
      return M;
    }
    (0, e.assertArgument)(!1, "invalid BytesLike value", j || "value", S);
  }
  function r(S, j) {
    return t(S, j, !1);
  }
  Sr.getBytes = r;
  function n(S, j) {
    return t(S, j, !0);
  }
  Sr.getBytesCopy = n;
  function s(S, j) {
    return !(typeof S != "string" || !S.match(/^0x[0-9A-Fa-f]*$/) || typeof j == "number" && S.length !== 2 + 2 * j || j === !0 && S.length % 2 !== 0);
  }
  Sr.isHexString = s;
  function i(S) {
    return s(S, !0) || S instanceof Uint8Array;
  }
  Sr.isBytesLike = i;
  const a = "0123456789abcdef";
  function f(S) {
    const j = r(S);
    let B = "0x";
    for (let M = 0; M < j.length; M++) {
      const I = j[M];
      B += a[(I & 240) >> 4] + a[I & 15];
    }
    return B;
  }
  Sr.hexlify = f;
  function d(S) {
    return "0x" + S.map((j) => f(j).substring(2)).join("");
  }
  Sr.concat = d;
  function c(S) {
    return s(S, !0) ? (S.length - 2) / 2 : r(S).length;
  }
  Sr.dataLength = c;
  function p(S, j, B) {
    const M = r(S);
    return B != null && B > M.length && (0, e.assert)(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
      buffer: M,
      length: M.length,
      offset: B
    }), f(M.slice(j ?? 0, B ?? M.length));
  }
  Sr.dataSlice = p;
  function g(S) {
    let j = f(S).substring(2);
    for (; j.startsWith("00"); )
      j = j.substring(2);
    return "0x" + j;
  }
  Sr.stripZerosLeft = g;
  function v(S, j, B) {
    const M = r(S);
    (0, e.assert)(j >= M.length, "padding exceeds data length", "BUFFER_OVERRUN", {
      buffer: new Uint8Array(M),
      length: j,
      offset: j + 1
    });
    const I = new Uint8Array(j);
    return I.fill(0), B ? I.set(M, j - M.length) : I.set(M, 0), f(I);
  }
  function O(S, j) {
    return v(S, j, !0);
  }
  Sr.zeroPadValue = O;
  function N(S, j) {
    return v(S, j, !1);
  }
  return Sr.zeroPadBytes = N, Sr;
}
var Mr = {}, Gm;
function hd() {
  if (Gm)
    return Mr;
  Gm = 1, Object.defineProperty(Mr, "__esModule", { value: !0 }), Mr.toQuantity = Mr.toBeArray = Mr.toBeHex = Mr.toNumber = Mr.getNumber = Mr.toBigInt = Mr.getUint = Mr.getBigInt = Mr.mask = Mr.toTwos = Mr.fromTwos = void 0;
  const e = Vi(), t = ws(), r = BigInt(0), n = BigInt(1), s = 9007199254740991;
  function i(B, M) {
    const I = c(B, "value"), A = BigInt(v(M, "width"));
    if ((0, t.assert)(I >> A === r, "overflow", "NUMERIC_FAULT", {
      operation: "fromTwos",
      fault: "overflow",
      value: B
    }), I >> A - n) {
      const R = (n << A) - n;
      return -((~I & R) + n);
    }
    return I;
  }
  Mr.fromTwos = i;
  function a(B, M) {
    let I = d(B, "value");
    const A = BigInt(v(M, "width")), R = n << A - n;
    if (I < r) {
      I = -I, (0, t.assert)(I <= R, "too low", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: B
      });
      const L = (n << A) - n;
      return (~I & L) + n;
    } else
      (0, t.assert)(I < R, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: B
      });
    return I;
  }
  Mr.toTwos = a;
  function f(B, M) {
    const I = c(B, "value"), A = BigInt(v(M, "bits"));
    return I & (n << A) - n;
  }
  Mr.mask = f;
  function d(B, M) {
    switch (typeof B) {
      case "bigint":
        return B;
      case "number":
        return (0, t.assertArgument)(Number.isInteger(B), "underflow", M || "value", B), (0, t.assertArgument)(B >= -s && B <= s, "overflow", M || "value", B), BigInt(B);
      case "string":
        try {
          if (B === "")
            throw new Error("empty string");
          return B[0] === "-" && B[1] !== "-" ? -BigInt(B.substring(1)) : BigInt(B);
        } catch (I) {
          (0, t.assertArgument)(!1, `invalid BigNumberish string: ${I.message}`, M || "value", B);
        }
    }
    (0, t.assertArgument)(!1, "invalid BigNumberish value", M || "value", B);
  }
  Mr.getBigInt = d;
  function c(B, M) {
    const I = d(B, M);
    return (0, t.assert)(I >= r, "unsigned value cannot be negative", "NUMERIC_FAULT", {
      fault: "overflow",
      operation: "getUint",
      value: B
    }), I;
  }
  Mr.getUint = c;
  const p = "0123456789abcdef";
  function g(B) {
    if (B instanceof Uint8Array) {
      let M = "0x0";
      for (const I of B)
        M += p[I >> 4], M += p[I & 15];
      return BigInt(M);
    }
    return d(B);
  }
  Mr.toBigInt = g;
  function v(B, M) {
    switch (typeof B) {
      case "bigint":
        return (0, t.assertArgument)(B >= -s && B <= s, "overflow", M || "value", B), Number(B);
      case "number":
        return (0, t.assertArgument)(Number.isInteger(B), "underflow", M || "value", B), (0, t.assertArgument)(B >= -s && B <= s, "overflow", M || "value", B), B;
      case "string":
        try {
          if (B === "")
            throw new Error("empty string");
          return v(BigInt(B), M);
        } catch (I) {
          (0, t.assertArgument)(!1, `invalid numeric string: ${I.message}`, M || "value", B);
        }
    }
    (0, t.assertArgument)(!1, "invalid numeric value", M || "value", B);
  }
  Mr.getNumber = v;
  function O(B) {
    return v(g(B));
  }
  Mr.toNumber = O;
  function N(B, M) {
    let I = c(B, "value").toString(16);
    if (M == null)
      I.length % 2 && (I = "0" + I);
    else {
      const A = v(M, "width");
      for ((0, t.assert)(A * 2 >= I.length, `value exceeds width (${A} bytes)`, "NUMERIC_FAULT", {
        operation: "toBeHex",
        fault: "overflow",
        value: B
      }); I.length < A * 2; )
        I = "0" + I;
    }
    return "0x" + I;
  }
  Mr.toBeHex = N;
  function S(B) {
    const M = c(B, "value");
    if (M === r)
      return new Uint8Array([]);
    let I = M.toString(16);
    I.length % 2 && (I = "0" + I);
    const A = new Uint8Array(I.length / 2);
    for (let R = 0; R < A.length; R++) {
      const L = R * 2;
      A[R] = parseInt(I.substring(L, L + 2), 16);
    }
    return A;
  }
  Mr.toBeArray = S;
  function j(B) {
    let M = (0, e.hexlify)((0, e.isBytesLike)(B) ? B : S(B)).substring(2);
    for (; M.startsWith("0"); )
      M = M.substring(1);
    return M === "" && (M = "0"), "0x" + M;
  }
  return Mr.toQuantity = j, Mr;
}
var zm;
function uT() {
  if (zm)
    return Do;
  zm = 1, Object.defineProperty(Do, "__esModule", { value: !0 }), Do.decodeBase58 = Do.encodeBase58 = void 0;
  const e = Vi(), t = ws(), r = hd(), n = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  let s = null;
  function i(p) {
    if (s == null) {
      s = {};
      for (let v = 0; v < n.length; v++)
        s[n[v]] = BigInt(v);
    }
    const g = s[p];
    return (0, t.assertArgument)(g != null, "invalid base58 value", "letter", p), g;
  }
  const a = BigInt(0), f = BigInt(58);
  function d(p) {
    const g = (0, e.getBytes)(p);
    let v = (0, r.toBigInt)(g), O = "";
    for (; v; )
      O = n[Number(v % f)] + O, v /= f;
    for (let N = 0; N < g.length && !g[N]; N++)
      O = n[0] + O;
    return O;
  }
  Do.encodeBase58 = d;
  function c(p) {
    let g = a;
    for (let v = 0; v < p.length; v++)
      g *= f, g += i(p[v]);
    return g;
  }
  return Do.decodeBase58 = c, Do;
}
var Lo = {}, Vm;
function T5() {
  if (Vm)
    return Lo;
  Vm = 1, Object.defineProperty(Lo, "__esModule", { value: !0 }), Lo.encodeBase64 = Lo.decodeBase64 = void 0;
  const e = Vi();
  function t(n) {
    n = atob(n);
    const s = new Uint8Array(n.length);
    for (let i = 0; i < n.length; i++)
      s[i] = n.charCodeAt(i);
    return (0, e.getBytes)(s);
  }
  Lo.decodeBase64 = t;
  function r(n) {
    const s = (0, e.getBytes)(n);
    let i = "";
    for (let a = 0; a < s.length; a++)
      i += String.fromCharCode(s[a]);
    return btoa(i);
  }
  return Lo.encodeBase64 = r, Lo;
}
var fc = {}, qm;
function cT() {
  var e;
  if (qm)
    return fc;
  qm = 1, Object.defineProperty(fc, "__esModule", { value: !0 }), fc.EventPayload = void 0;
  const t = ru();
  class r {
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */
    constructor(s, i, a) {
      Be(this, "filter"), Be(this, "emitter"), _e(this, e, void 0), Oe(this, e, i), (0, t.defineProperties)(this, { emitter: s, filter: a });
    }
    /**
     *  Unregister the triggered listener for future events.
     */
    async removeListener() {
      oe(this, e) != null && await this.emitter.off(this.filter, oe(this, e));
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), fc.EventPayload = r, fc;
}
var Os = {}, $m = {}, Km;
function v1() {
  return Km || (Km = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8CodePoints = e.toUtf8String = e.toUtf8Bytes = e.Utf8ErrorFuncs = void 0;
    const t = Vi(), r = ws();
    function n(g, v, O, N, S) {
      (0, r.assertArgument)(!1, `invalid codepoint at offset ${v}; ${g}`, "bytes", O);
    }
    function s(g, v, O, N, S) {
      if (g === "BAD_PREFIX" || g === "UNEXPECTED_CONTINUE") {
        let j = 0;
        for (let B = v + 1; B < O.length && O[B] >> 6 === 2; B++)
          j++;
        return j;
      }
      return g === "OVERRUN" ? O.length - v - 1 : 0;
    }
    function i(g, v, O, N, S) {
      return g === "OVERLONG" ? ((0, r.assertArgument)(typeof S == "number", "invalid bad code point for replacement", "badCodepoint", S), N.push(S), 0) : (N.push(65533), s(g, v, O));
    }
    e.Utf8ErrorFuncs = Object.freeze({
      error: n,
      ignore: s,
      replace: i
    });
    function a(g, v) {
      v == null && (v = e.Utf8ErrorFuncs.error);
      const O = (0, t.getBytes)(g, "bytes"), N = [];
      let S = 0;
      for (; S < O.length; ) {
        const j = O[S++];
        if (!(j >> 7)) {
          N.push(j);
          continue;
        }
        let B = null, M = null;
        if ((j & 224) === 192)
          B = 1, M = 127;
        else if ((j & 240) === 224)
          B = 2, M = 2047;
        else if ((j & 248) === 240)
          B = 3, M = 65535;
        else {
          (j & 192) === 128 ? S += v("UNEXPECTED_CONTINUE", S - 1, O, N) : S += v("BAD_PREFIX", S - 1, O, N);
          continue;
        }
        if (S - 1 + B >= O.length) {
          S += v("OVERRUN", S - 1, O, N);
          continue;
        }
        let I = j & (1 << 8 - B - 1) - 1;
        for (let A = 0; A < B; A++) {
          let R = O[S];
          if ((R & 192) != 128) {
            S += v("MISSING_CONTINUE", S, O, N), I = null;
            break;
          }
          I = I << 6 | R & 63, S++;
        }
        if (I !== null) {
          if (I > 1114111) {
            S += v("OUT_OF_RANGE", S - 1 - B, O, N, I);
            continue;
          }
          if (I >= 55296 && I <= 57343) {
            S += v("UTF16_SURROGATE", S - 1 - B, O, N, I);
            continue;
          }
          if (I <= M) {
            S += v("OVERLONG", S - 1 - B, O, N, I);
            continue;
          }
          N.push(I);
        }
      }
      return N;
    }
    function f(g, v) {
      (0, r.assertArgument)(typeof g == "string", "invalid string value", "str", g), v != null && ((0, r.assertNormalize)(v), g = g.normalize(v));
      let O = [];
      for (let N = 0; N < g.length; N++) {
        const S = g.charCodeAt(N);
        if (S < 128)
          O.push(S);
        else if (S < 2048)
          O.push(S >> 6 | 192), O.push(S & 63 | 128);
        else if ((S & 64512) == 55296) {
          N++;
          const j = g.charCodeAt(N);
          (0, r.assertArgument)(N < g.length && (j & 64512) === 56320, "invalid surrogate pair", "str", g);
          const B = 65536 + ((S & 1023) << 10) + (j & 1023);
          O.push(B >> 18 | 240), O.push(B >> 12 & 63 | 128), O.push(B >> 6 & 63 | 128), O.push(B & 63 | 128);
        } else
          O.push(S >> 12 | 224), O.push(S >> 6 & 63 | 128), O.push(S & 63 | 128);
      }
      return new Uint8Array(O);
    }
    e.toUtf8Bytes = f;
    function d(g) {
      return g.map((v) => v <= 65535 ? String.fromCharCode(v) : (v -= 65536, String.fromCharCode((v >> 10 & 1023) + 55296, (v & 1023) + 56320))).join("");
    }
    function c(g, v) {
      return d(a(g, v));
    }
    e.toUtf8String = c;
    function p(g, v) {
      return a(f(g, v));
    }
    e.toUtf8CodePoints = p;
  }($m)), $m;
}
var Ho = {}, Jm;
function lT() {
  if (Jm)
    return Ho;
  Jm = 1, Object.defineProperty(Ho, "__esModule", { value: !0 }), Ho.getUrl = Ho.createGetUrl = void 0;
  const e = ws();
  function t(s) {
    async function i(a, f) {
      const d = a.url.split(":")[0].toLowerCase();
      (0, e.assert)(d === "http" || d === "https", `unsupported protocol ${d}`, "UNSUPPORTED_OPERATION", {
        info: { protocol: d },
        operation: "request"
      }), (0, e.assert)(d === "https" || !a.credentials || a.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
        operation: "request"
      });
      let c;
      if (f) {
        const S = new AbortController();
        c = S.signal, f.addListener(() => {
          S.abort();
        });
      }
      const p = {
        method: a.method,
        headers: new Headers(Array.from(a)),
        body: a.body || void 0,
        signal: c
      }, g = await fetch(a.url, p), v = {};
      g.headers.forEach((S, j) => {
        v[j.toLowerCase()] = S;
      });
      const O = await g.arrayBuffer(), N = O == null ? null : new Uint8Array(O);
      return {
        statusCode: g.status,
        statusMessage: g.statusText,
        headers: v,
        body: N
      };
    }
    return i;
  }
  Ho.createGetUrl = t;
  const r = t();
  async function n(s, i) {
    return r(s, i);
  }
  return Ho.getUrl = n, Ho;
}
var Qm;
function dT() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N, S, j, B, M, I, A, R, L, K, $;
  if (Qm)
    return Os;
  Qm = 1, Object.defineProperty(Os, "__esModule", { value: !0 }), Os.FetchResponse = Os.FetchRequest = Os.FetchCancelSignal = void 0;
  const k = T5(), V = Vi(), C = ws(), D = ru(), o = v1(), u = lT(), h = 12, y = 250;
  let E = (0, u.createGetUrl)();
  const P = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), w = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
  let m = !1;
  async function l(te, U) {
    try {
      const ue = te.match(P);
      if (!ue)
        throw new Error("invalid data");
      return new Ee(200, "OK", {
        "content-type": ue[1] || "text/plain"
      }, ue[2] ? (0, k.decodeBase64)(ue[3]) : xe(ue[3]));
    } catch {
      return new Ee(599, "BAD REQUEST (invalid data: URI)", {}, null, new pe(te));
    }
  }
  function b(te) {
    async function U(ue, we) {
      try {
        const ke = ue.match(w);
        if (!ke)
          throw new Error("invalid link");
        return new pe(`${te}${ke[2]}`);
      } catch {
        return new Ee(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new pe(ue));
      }
    }
    return U;
  }
  const W = {
    data: l,
    ipfs: b("https://gateway.ipfs.io/ipfs/")
  }, X = /* @__PURE__ */ new WeakMap();
  class G {
    constructor(U) {
      _e(this, e, void 0), _e(this, t, void 0), Oe(this, e, []), Oe(this, t, !1), X.set(U, () => {
        if (!oe(this, t)) {
          Oe(this, t, !0);
          for (const ue of oe(this, e))
            setTimeout(() => {
              ue();
            }, 0);
          Oe(this, e, []);
        }
      });
    }
    addListener(U) {
      (0, C.assert)(!oe(this, t), "singal already cancelled", "UNSUPPORTED_OPERATION", {
        operation: "fetchCancelSignal.addCancelListener"
      }), oe(this, e).push(U);
    }
    get cancelled() {
      return oe(this, t);
    }
    checkSignal() {
      (0, C.assert)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), Os.FetchCancelSignal = G;
  function re(te) {
    if (te == null)
      throw new Error("missing signal; should not happen");
    return te.checkSignal(), te;
  }
  const ce = class Up {
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */
    constructor(U) {
      _e(this, B), _e(this, r, void 0), _e(this, n, void 0), _e(this, s, void 0), _e(this, i, void 0), _e(this, a, void 0), _e(this, f, void 0), _e(this, d, void 0), _e(this, c, void 0), _e(this, p, void 0), _e(this, g, void 0), _e(this, v, void 0), _e(this, O, void 0), _e(this, N, void 0), _e(this, S, void 0), _e(this, j, void 0), Oe(this, f, String(U)), Oe(this, r, !1), Oe(this, n, !0), Oe(this, s, {}), Oe(this, i, ""), Oe(this, a, 3e5), Oe(this, S, {
        slotInterval: y,
        maxAttempts: h
      }), Oe(this, j, null);
    }
    /**
     *  The fetch URL to request.
     */
    get url() {
      return oe(this, f);
    }
    set url(U) {
      Oe(this, f, String(U));
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */
    get body() {
      return oe(this, d) == null ? null : new Uint8Array(oe(this, d));
    }
    set body(U) {
      if (U == null)
        Oe(this, d, void 0), Oe(this, c, void 0);
      else if (typeof U == "string")
        Oe(this, d, (0, o.toUtf8Bytes)(U)), Oe(this, c, "text/plain");
      else if (U instanceof Uint8Array)
        Oe(this, d, U), Oe(this, c, "application/octet-stream");
      else if (typeof U == "object")
        Oe(this, d, (0, o.toUtf8Bytes)(JSON.stringify(U))), Oe(this, c, "application/json");
      else
        throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */
    hasBody() {
      return oe(this, d) != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */
    get method() {
      return oe(this, i) ? oe(this, i) : this.hasBody() ? "POST" : "GET";
    }
    set method(U) {
      U == null && (U = ""), Oe(this, i, String(U).toUpperCase());
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */
    get headers() {
      const U = Object.assign({}, oe(this, s));
      return oe(this, p) && (U.authorization = `Basic ${(0, k.encodeBase64)((0, o.toUtf8Bytes)(oe(this, p)))}`), this.allowGzip && (U["accept-encoding"] = "gzip"), U["content-type"] == null && oe(this, c) && (U["content-type"] = oe(this, c)), this.body && (U["content-length"] = String(this.body.length)), U;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */
    getHeader(U) {
      return this.headers[U.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */
    setHeader(U, ue) {
      oe(this, s)[String(U).toLowerCase()] = String(ue);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */
    clearHeaders() {
      Oe(this, s, {});
    }
    [Symbol.iterator]() {
      const U = this.headers, ue = Object.keys(U);
      let we = 0;
      return {
        next: () => {
          if (we < ue.length) {
            const ke = ue[we++];
            return {
              value: [ke, U[ke]],
              done: !1
            };
          }
          return { value: void 0, done: !0 };
        }
      };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */
    get credentials() {
      return oe(this, p) || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */
    setCredentials(U, ue) {
      (0, C.assertArgument)(!U.match(/:/), "invalid basic authentication username", "username", "[REDACTED]"), Oe(this, p, `${U}:${ue}`);
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */
    get allowGzip() {
      return oe(this, n);
    }
    set allowGzip(U) {
      Oe(this, n, !!U);
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */
    get allowInsecureAuthentication() {
      return !!oe(this, r);
    }
    set allowInsecureAuthentication(U) {
      Oe(this, r, !!U);
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */
    get timeout() {
      return oe(this, a);
    }
    set timeout(U) {
      (0, C.assertArgument)(U >= 0, "timeout must be non-zero", "timeout", U), Oe(this, a, U);
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */
    get preflightFunc() {
      return oe(this, g) || null;
    }
    set preflightFunc(U) {
      Oe(this, g, U);
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */
    get processFunc() {
      return oe(this, v) || null;
    }
    set processFunc(U) {
      Oe(this, v, U);
    }
    /**
     *  This function is called on each retry attempt.
     */
    get retryFunc() {
      return oe(this, O) || null;
    }
    set retryFunc(U) {
      Oe(this, O, U);
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */
    get getUrlFunc() {
      return oe(this, j) || E;
    }
    set getUrlFunc(U) {
      Oe(this, j, U);
    }
    toString() {
      return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${oe(this, d) ? (0, V.hexlify)(oe(this, d)) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */
    setThrottleParams(U) {
      U.slotInterval != null && (oe(this, S).slotInterval = U.slotInterval), U.maxAttempts != null && (oe(this, S).maxAttempts = U.maxAttempts);
    }
    /**
     *  Resolves to the response by sending the request.
     */
    send() {
      return (0, C.assert)(oe(this, N) == null, "request already sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.send" }), Oe(this, N, new G(this)), Ve(this, B, M).call(this, 0, Pe() + this.timeout, 0, this, new Ee(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */
    cancel() {
      (0, C.assert)(oe(this, N) != null, "request has not been sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.cancel" });
      const U = X.get(this);
      if (!U)
        throw new Error("missing signal; should not happen");
      U();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */
    redirect(U) {
      const ue = this.url.split(":")[0].toLowerCase(), we = U.split(":")[0].toLowerCase();
      (0, C.assert)(this.method === "GET" && (ue !== "https" || we !== "http") && U.match(/^https?:/), "unsupported redirect", "UNSUPPORTED_OPERATION", {
        operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(U)})`
      });
      const ke = new Up(U);
      return ke.method = "GET", ke.allowGzip = this.allowGzip, ke.timeout = this.timeout, Oe(ke, s, Object.assign({}, oe(this, s))), oe(this, d) && Oe(ke, d, new Uint8Array(oe(this, d))), Oe(ke, c, oe(this, c)), ke;
    }
    /**
     *  Create a new copy of this request.
     */
    clone() {
      const U = new Up(this.url);
      return Oe(U, i, oe(this, i)), oe(this, d) && Oe(U, d, oe(this, d)), Oe(U, c, oe(this, c)), Oe(U, s, Object.assign({}, oe(this, s))), Oe(U, p, oe(this, p)), this.allowGzip && (U.allowGzip = !0), U.timeout = this.timeout, this.allowInsecureAuthentication && (U.allowInsecureAuthentication = !0), Oe(U, g, oe(this, g)), Oe(U, v, oe(this, v)), Oe(U, O, oe(this, O)), Oe(U, S, Object.assign({}, oe(this, S))), Oe(U, j, oe(this, j)), U;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */
    static lockConfig() {
      m = !0;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */
    static getGateway(U) {
      return W[U.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */
    static registerGateway(U, ue) {
      if (U = U.toLowerCase(), U === "http" || U === "https")
        throw new Error(`cannot intercept ${U}; use registerGetUrl`);
      if (m)
        throw new Error("gateways locked");
      W[U] = ue;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */
    static registerGetUrl(U) {
      if (m)
        throw new Error("gateways locked");
      E = U;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */
    static createGetUrlFunc(U) {
      return (0, u.createGetUrl)(U);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */
    static createDataGateway() {
      return l;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */
    static createIpfsGatewayFunc(U) {
      return b(U);
    }
  };
  r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakSet(), M = async function(te, U, ue, we, ke) {
    var Re, fe, x;
    if (te >= oe(this, S).maxAttempts)
      return ke.makeServerError("exceeded maximum retry limit");
    (0, C.assert)(Pe() <= U, "timeout", "TIMEOUT", {
      operation: "request.send",
      reason: "timeout",
      request: we
    }), ue > 0 && await me(ue);
    let _ = this.clone();
    const q = (_.url.split(":")[0] || "").toLowerCase();
    if (q in W) {
      const ye = await W[q](_.url, re(oe(we, N)));
      if (ye instanceof Ee) {
        let ge = ye;
        if (this.processFunc) {
          re(oe(we, N));
          try {
            ge = await this.processFunc(_, ge);
          } catch (be) {
            (be.throttle == null || typeof be.stall != "number") && ge.makeServerError("error in post-processing function", be).assertOk();
          }
        }
        return ge;
      }
      _ = ye;
    }
    this.preflightFunc && (_ = await this.preflightFunc(_));
    const ne = await this.getUrlFunc(_, re(oe(we, N)));
    let de = new Ee(ne.statusCode, ne.statusMessage, ne.headers, ne.body, we);
    if (de.statusCode === 301 || de.statusCode === 302) {
      try {
        const ye = de.headers.location || "";
        return Ve(Re = _.redirect(ye), B, M).call(Re, te + 1, U, 0, we, de);
      } catch {
      }
      return de;
    } else if (de.statusCode === 429 && (this.retryFunc == null || await this.retryFunc(_, de, te))) {
      const ye = de.headers["retry-after"];
      let ge = oe(this, S).slotInterval * Math.trunc(Math.random() * Math.pow(2, te));
      return typeof ye == "string" && ye.match(/^[1-9][0-9]*$/) && (ge = parseInt(ye)), Ve(fe = _.clone(), B, M).call(fe, te + 1, U, ge, we, de);
    }
    if (this.processFunc) {
      re(oe(we, N));
      try {
        de = await this.processFunc(_, de);
      } catch (ye) {
        (ye.throttle == null || typeof ye.stall != "number") && de.makeServerError("error in post-processing function", ye).assertOk();
        let ge = oe(this, S).slotInterval * Math.trunc(Math.random() * Math.pow(2, te));
        return ye.stall >= 0 && (ge = ye.stall), Ve(x = _.clone(), B, M).call(x, te + 1, U, ge, we, de);
      }
    }
    return de;
  };
  let pe = ce;
  Os.FetchRequest = pe;
  const ve = class k5 {
    constructor(U, ue, we, ke, Re) {
      _e(this, I, void 0), _e(this, A, void 0), _e(this, R, void 0), _e(this, L, void 0), _e(this, K, void 0), _e(this, $, void 0), Oe(this, I, U), Oe(this, A, ue), Oe(this, R, Object.keys(we).reduce((fe, x) => (fe[x.toLowerCase()] = String(we[x]), fe), {})), Oe(this, L, ke == null ? null : new Uint8Array(ke)), Oe(this, K, Re || null), Oe(this, $, { message: "" });
    }
    toString() {
      return `<FetchResponse status=${this.statusCode} body=${oe(this, L) ? (0, V.hexlify)(oe(this, L)) : "null"}>`;
    }
    /**
     *  The response status code.
     */
    get statusCode() {
      return oe(this, I);
    }
    /**
     *  The response status message.
     */
    get statusMessage() {
      return oe(this, A);
    }
    /**
     *  The response headers. All keys are lower-case.
     */
    get headers() {
      return Object.assign({}, oe(this, R));
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */
    get body() {
      return oe(this, L) == null ? null : new Uint8Array(oe(this, L));
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */
    get bodyText() {
      try {
        return oe(this, L) == null ? "" : (0, o.toUtf8String)(oe(this, L));
      } catch {
        (0, C.assert)(!1, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
          operation: "bodyText",
          info: { response: this }
        });
      }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */
    get bodyJson() {
      try {
        return JSON.parse(this.bodyText);
      } catch {
        (0, C.assert)(!1, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
          operation: "bodyJson",
          info: { response: this }
        });
      }
    }
    [Symbol.iterator]() {
      const U = this.headers, ue = Object.keys(U);
      let we = 0;
      return {
        next: () => {
          if (we < ue.length) {
            const ke = ue[we++];
            return {
              value: [ke, U[ke]],
              done: !1
            };
          }
          return { value: void 0, done: !0 };
        }
      };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */
    makeServerError(U, ue) {
      let we;
      U ? we = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${U})` : (U = `${this.statusCode} ${this.statusMessage}`, we = `CLIENT ESCALATED SERVER ERROR (${U})`);
      const ke = new k5(599, we, this.headers, this.body, oe(this, K) || void 0);
      return Oe(ke, $, { message: U, error: ue }), ke;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */
    throwThrottleError(U, ue) {
      ue == null ? ue = -1 : (0, C.assertArgument)(Number.isInteger(ue) && ue >= 0, "invalid stall timeout", "stall", ue);
      const we = new Error(U || "throttling requests");
      throw (0, D.defineProperties)(we, { stall: ue, throttle: !0 }), we;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */
    getHeader(U) {
      return this.headers[U.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */
    hasBody() {
      return oe(this, L) != null;
    }
    /**
     *  The request made for this response.
     */
    get request() {
      return oe(this, K);
    }
    /**
     *  Returns true if this response was a success statusCode.
     */
    ok() {
      return oe(this, $).message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */
    assertOk() {
      if (this.ok())
        return;
      let { message: U, error: ue } = oe(this, $);
      U === "" && (U = `server response ${this.statusCode} ${this.statusMessage}`);
      let we = null;
      this.request && (we = this.request.url);
      let ke = null;
      try {
        oe(this, L) && (ke = (0, o.toUtf8String)(oe(this, L)));
      } catch {
      }
      (0, C.assert)(!1, U, "SERVER_ERROR", {
        request: this.request || "unknown request",
        response: this,
        error: ue,
        info: {
          requestUrl: we,
          responseBody: ke,
          responseStatus: `${this.statusCode} ${this.statusMessage}`
        }
      });
    }
  };
  I = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), K = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  let Ee = ve;
  Os.FetchResponse = Ee;
  function Pe() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  function xe(te) {
    return (0, o.toUtf8Bytes)(te.replace(/%([0-9a-f][0-9a-f])/gi, (U, ue) => String.fromCharCode(parseInt(ue, 16))));
  }
  function me(te) {
    return new Promise((U) => setTimeout(U, te));
  }
  return Os;
}
var pc = {}, Zm;
function S5() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N;
  if (Zm)
    return pc;
  Zm = 1, Object.defineProperty(pc, "__esModule", { value: !0 }), pc.FixedNumber = void 0;
  const S = Vi(), j = ws(), B = hd(), M = ru(), I = BigInt(-1), A = BigInt(0), R = BigInt(1), L = BigInt(5), K = {};
  let $ = "0000";
  for (; $.length < 80; )
    $ += $;
  function k(h) {
    let y = $;
    for (; y.length < h; )
      y += y;
    return BigInt("1" + y.substring(0, h));
  }
  function V(h, y, E) {
    const P = BigInt(y.width);
    if (y.signed) {
      const w = R << P - R;
      (0, j.assert)(E == null || h >= -w && h < w, "overflow", "NUMERIC_FAULT", {
        operation: E,
        fault: "overflow",
        value: h
      }), h > A ? h = (0, B.fromTwos)((0, B.mask)(h, P), P) : h = -(0, B.fromTwos)((0, B.mask)(-h, P), P);
    } else {
      const w = R << P;
      (0, j.assert)(E == null || h >= 0 && h < w, "overflow", "NUMERIC_FAULT", {
        operation: E,
        fault: "overflow",
        value: h
      }), h = (h % w + w) % w & w - R;
    }
    return h;
  }
  function C(h) {
    typeof h == "number" && (h = `fixed128x${h}`);
    let y = !0, E = 128, P = 18;
    if (typeof h == "string") {
      if (h !== "fixed")
        if (h === "ufixed")
          y = !1;
        else {
          const m = h.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          (0, j.assertArgument)(m, "invalid fixed format", "format", h), y = m[1] !== "u", E = parseInt(m[2]), P = parseInt(m[3]);
        }
    } else if (h) {
      const m = h, l = (b, W, X) => m[b] == null ? X : ((0, j.assertArgument)(typeof m[b] === W, "invalid fixed format (" + b + " not " + W + ")", "format." + b, m[b]), m[b]);
      y = l("signed", "boolean", y), E = l("width", "number", E), P = l("decimals", "number", P);
    }
    (0, j.assertArgument)(E % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", E), (0, j.assertArgument)(P <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", P);
    const w = (y ? "" : "u") + "fixed" + String(E) + "x" + String(P);
    return { signed: y, width: E, decimals: P, name: w };
  }
  function D(h, y) {
    let E = "";
    h < A && (E = "-", h *= I);
    let P = h.toString();
    if (y === 0)
      return E + P;
    for (; P.length <= y; )
      P = $ + P;
    const w = P.length - y;
    for (P = P.substring(0, w) + "." + P.substring(w); P[0] === "0" && P[1] !== "."; )
      P = P.substring(1);
    for (; P[P.length - 1] === "0" && P[P.length - 2] !== "."; )
      P = P.substring(0, P.length - 1);
    return E + P;
  }
  const o = class gu {
    // Use this when changing this file to get some typing info,
    // but then switch to any to mask the internal type
    //constructor(guard: any, value: bigint, format: _FixedFormat) {
    /**
     *  @private
     */
    constructor(y, E, P) {
      _e(this, n), _e(this, i), _e(this, f), _e(this, c), _e(this, g), _e(this, O), Be(this, "format"), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), Be(this, "_value"), (0, j.assertPrivate)(y, K, "FixedNumber"), Oe(this, t, E), Oe(this, e, P);
      const w = D(E, P.decimals);
      (0, M.defineProperties)(this, { format: P.name, _value: w }), Oe(this, r, k(P.decimals));
    }
    /**
     *  If true, negative values are permitted, otherwise only
     *  positive values and zero are allowed.
     */
    get signed() {
      return oe(this, e).signed;
    }
    /**
     *  The number of bits available to store the value.
     */
    get width() {
      return oe(this, e).width;
    }
    /**
     *  The number of decimal places in the fixed-point arithment field.
     */
    get decimals() {
      return oe(this, e).decimals;
    }
    /**
     *  The value as an integer, based on the smallest unit the
     *  [[decimals]] allow.
     */
    get value() {
      return oe(this, t);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%, ignoring overflow.
     */
    addUnsafe(y) {
      return Ve(this, f, d).call(this, y);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    add(y) {
      return Ve(this, f, d).call(this, y, "add");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%, ignoring overflow.
     */
    subUnsafe(y) {
      return Ve(this, c, p).call(this, y);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    sub(y) {
      return Ve(this, c, p).call(this, y, "sub");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%, ignoring overflow and underflow (precision loss).
     */
    mulUnsafe(y) {
      return Ve(this, g, v).call(this, y);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    mul(y) {
      return Ve(this, g, v).call(this, y, "mul");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs or if underflow (precision loss) occurs.
     */
    mulSignal(y) {
      Ve(this, n, s).call(this, y);
      const E = oe(this, t) * oe(y, t);
      return (0, j.assert)(E % oe(this, r) === A, "precision lost during signalling mul", "NUMERIC_FAULT", {
        operation: "mulSignal",
        fault: "underflow",
        value: this
      }), Ve(this, i, a).call(this, E / oe(this, r), "mulSignal");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */
    divUnsafe(y) {
      return Ve(this, O, N).call(this, y);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */
    div(y) {
      return Ve(this, O, N).call(this, y, "div");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
     *  (precision loss) occurs.
     */
    divSignal(y) {
      (0, j.assert)(oe(y, t) !== A, "division by zero", "NUMERIC_FAULT", {
        operation: "div",
        fault: "divide-by-zero",
        value: this
      }), Ve(this, n, s).call(this, y);
      const E = oe(this, t) * oe(this, r);
      return (0, j.assert)(E % oe(y, t) === A, "precision lost during signalling div", "NUMERIC_FAULT", {
        operation: "divSignal",
        fault: "underflow",
        value: this
      }), Ve(this, i, a).call(this, E / oe(y, t), "divSignal");
    }
    /**
     *  Returns a comparison result between %%this%% and %%other%%.
     *
     *  This is suitable for use in sorting, where ``-1`` implies %%this%%
     *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
     *  both are equal.
     */
    cmp(y) {
      let E = this.value, P = y.value;
      const w = this.decimals - y.decimals;
      return w > 0 ? P *= k(w) : w < 0 && (E *= k(-w)), E < P ? -1 : E > P ? 1 : 0;
    }
    /**
     *  Returns true if %%other%% is equal to %%this%%.
     */
    eq(y) {
      return this.cmp(y) === 0;
    }
    /**
     *  Returns true if %%other%% is less than to %%this%%.
     */
    lt(y) {
      return this.cmp(y) < 0;
    }
    /**
     *  Returns true if %%other%% is less than or equal to %%this%%.
     */
    lte(y) {
      return this.cmp(y) <= 0;
    }
    /**
     *  Returns true if %%other%% is greater than to %%this%%.
     */
    gt(y) {
      return this.cmp(y) > 0;
    }
    /**
     *  Returns true if %%other%% is greater than or equal to %%this%%.
     */
    gte(y) {
      return this.cmp(y) >= 0;
    }
    /**
     *  Returns a new [[FixedNumber]] which is the largest **integer**
     *  that is less than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */
    floor() {
      let y = oe(this, t);
      return oe(this, t) < A && (y -= oe(this, r) - R), y = oe(this, t) / oe(this, r) * oe(this, r), Ve(this, i, a).call(this, y, "floor");
    }
    /**
     *  Returns a new [[FixedNumber]] which is the smallest **integer**
     *  that is greater than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */
    ceiling() {
      let y = oe(this, t);
      return oe(this, t) > A && (y += oe(this, r) - R), y = oe(this, t) / oe(this, r) * oe(this, r), Ve(this, i, a).call(this, y, "ceiling");
    }
    /**
     *  Returns a new [[FixedNumber]] with the decimal component
     *  rounded up on ties at %%decimals%% places.
     */
    round(y) {
      if (y == null && (y = 0), y >= this.decimals)
        return this;
      const E = this.decimals - y, P = L * k(E - 1);
      let w = this.value + P;
      const m = k(E);
      return w = w / m * m, V(w, oe(this, e), "round"), new gu(K, w, oe(this, e));
    }
    /**
     *  Returns true if %%this%% is equal to ``0``.
     */
    isZero() {
      return oe(this, t) === A;
    }
    /**
     *  Returns true if %%this%% is less than ``0``.
     */
    isNegative() {
      return oe(this, t) < A;
    }
    /**
     *  Returns the string representation of %%this%%.
     */
    toString() {
      return this._value;
    }
    /**
     *  Returns a float approximation.
     *
     *  Due to IEEE 754 precission (or lack thereof), this function
     *  can only return an approximation and most values will contain
     *  rounding errors.
     */
    toUnsafeFloat() {
      return parseFloat(this.toString());
    }
    /**
     *  Return a new [[FixedNumber]] with the same value but has had
     *  its field set to %%format%%.
     *
     *  This will throw if the value cannot fit into %%format%%.
     */
    toFormat(y) {
      return gu.fromString(this.toString(), y);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% divided by
     *  %%decimal%% places with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
     *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
     *  or underflow (precision loss).
     */
    static fromValue(y, E, P) {
      const w = E == null ? 0 : (0, B.getNumber)(E), m = C(P);
      let l = (0, B.getBigInt)(y, "value");
      const b = w - m.decimals;
      if (b > 0) {
        const W = k(b);
        (0, j.assert)(l % W === A, "value loses precision for format", "NUMERIC_FAULT", {
          operation: "fromValue",
          fault: "underflow",
          value: y
        }), l /= W;
      } else
        b < 0 && (l *= k(-b));
      return V(l, m, "fromValue"), new gu(K, l, m);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%%, either due to overflow or underflow (precision loss).
     */
    static fromString(y, E) {
      const P = y.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
      (0, j.assertArgument)(P && P[2].length + P[3].length > 0, "invalid FixedNumber string value", "value", y);
      const w = C(E);
      let m = P[2] || "0", l = P[3] || "";
      for (; l.length < w.decimals; )
        l += $;
      (0, j.assert)(l.substring(w.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
        operation: "fromString",
        fault: "underflow",
        value: y
      }), l = l.substring(0, w.decimals);
      const b = BigInt(P[1] + m + l);
      return V(b, w, "fromString"), new gu(K, b, w);
    }
    /**
     *  Creates a new [[FixedNumber]] with the big-endian representation
     *  %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%% due to overflow.
     */
    static fromBytes(y, E) {
      let P = (0, B.toBigInt)((0, S.getBytes)(y, "value"));
      const w = C(E);
      return w.signed && (P = (0, B.fromTwos)(P, w.width)), V(P, w, "fromBytes"), new gu(K, P, w);
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakSet(), s = function(h) {
    (0, j.assertArgument)(this.format === h.format, "incompatible format; use fixedNumber.toFormat", "other", h);
  }, i = /* @__PURE__ */ new WeakSet(), a = function(h, y) {
    return h = V(h, oe(this, e), y), new o(K, h, oe(this, e));
  }, f = /* @__PURE__ */ new WeakSet(), d = function(h, y) {
    return Ve(this, n, s).call(this, h), Ve(this, i, a).call(this, oe(this, t) + oe(h, t), y);
  }, c = /* @__PURE__ */ new WeakSet(), p = function(h, y) {
    return Ve(this, n, s).call(this, h), Ve(this, i, a).call(this, oe(this, t) - oe(h, t), y);
  }, g = /* @__PURE__ */ new WeakSet(), v = function(h, y) {
    return Ve(this, n, s).call(this, h), Ve(this, i, a).call(this, oe(this, t) * oe(h, t) / oe(this, r), y);
  }, O = /* @__PURE__ */ new WeakSet(), N = function(h, y) {
    return (0, j.assert)(oe(h, t) !== A, "division by zero", "NUMERIC_FAULT", {
      operation: "div",
      fault: "divide-by-zero",
      value: this
    }), Ve(this, n, s).call(this, h), Ve(this, i, a).call(this, oe(this, t) * oe(this, r) / oe(h, t), y);
  };
  let u = o;
  return pc.FixedNumber = u, pc;
}
var gc = {}, Ym;
function hT() {
  if (Ym)
    return gc;
  Ym = 1, Object.defineProperty(gc, "__esModule", { value: !0 }), gc.decodeRlp = void 0;
  const e = Vi(), t = ws(), r = Vi();
  function n(d) {
    let c = d.toString(16);
    for (; c.length < 2; )
      c = "0" + c;
    return "0x" + c;
  }
  function s(d, c, p) {
    let g = 0;
    for (let v = 0; v < p; v++)
      g = g * 256 + d[c + v];
    return g;
  }
  function i(d, c, p, g) {
    const v = [];
    for (; p < c + 1 + g; ) {
      const O = a(d, p);
      v.push(O.result), p += O.consumed, (0, t.assert)(p <= c + 1 + g, "child data too short", "BUFFER_OVERRUN", {
        buffer: d,
        length: g,
        offset: c
      });
    }
    return { consumed: 1 + g, result: v };
  }
  function a(d, c) {
    (0, t.assert)(d.length !== 0, "data too short", "BUFFER_OVERRUN", {
      buffer: d,
      length: 0,
      offset: 1
    });
    const p = (g) => {
      (0, t.assert)(g <= d.length, "data short segment too short", "BUFFER_OVERRUN", {
        buffer: d,
        length: d.length,
        offset: g
      });
    };
    if (d[c] >= 248) {
      const g = d[c] - 247;
      p(c + 1 + g);
      const v = s(d, c + 1, g);
      return p(c + 1 + g + v), i(d, c, c + 1 + g, g + v);
    } else if (d[c] >= 192) {
      const g = d[c] - 192;
      return p(c + 1 + g), i(d, c, c + 1, g);
    } else if (d[c] >= 184) {
      const g = d[c] - 183;
      p(c + 1 + g);
      const v = s(d, c + 1, g);
      p(c + 1 + g + v);
      const O = (0, e.hexlify)(d.slice(c + 1 + g, c + 1 + g + v));
      return { consumed: 1 + g + v, result: O };
    } else if (d[c] >= 128) {
      const g = d[c] - 128;
      p(c + 1 + g);
      const v = (0, e.hexlify)(d.slice(c + 1, c + 1 + g));
      return { consumed: 1 + g, result: v };
    }
    return { consumed: 1, result: n(d[c]) };
  }
  function f(d) {
    const c = (0, r.getBytes)(d, "data"), p = a(c, 0);
    return (0, t.assertArgument)(p.consumed === c.length, "unexpected junk after rlp payload", "data", d), p.result;
  }
  return gc.decodeRlp = f, gc;
}
var mc = {}, Xm;
function fT() {
  if (Xm)
    return mc;
  Xm = 1, Object.defineProperty(mc, "__esModule", { value: !0 }), mc.encodeRlp = void 0;
  const e = Vi();
  function t(i) {
    const a = [];
    for (; i; )
      a.unshift(i & 255), i >>= 8;
    return a;
  }
  function r(i) {
    if (Array.isArray(i)) {
      let d = [];
      if (i.forEach(function(p) {
        d = d.concat(r(p));
      }), d.length <= 55)
        return d.unshift(192 + d.length), d;
      const c = t(d.length);
      return c.unshift(247 + c.length), c.concat(d);
    }
    const a = Array.prototype.slice.call((0, e.getBytes)(i, "object"));
    if (a.length === 1 && a[0] <= 127)
      return a;
    if (a.length <= 55)
      return a.unshift(128 + a.length), a;
    const f = t(a.length);
    return f.unshift(183 + f.length), f.concat(a);
  }
  const n = "0123456789abcdef";
  function s(i) {
    let a = "0x";
    for (const f of r(i))
      a += n[f >> 4], a += n[f & 15];
    return a;
  }
  return mc.encodeRlp = s, mc;
}
var wi = {}, ey;
function pT() {
  if (ey)
    return wi;
  ey = 1, Object.defineProperty(wi, "__esModule", { value: !0 }), wi.parseEther = wi.formatEther = wi.parseUnits = wi.formatUnits = void 0;
  const e = ws(), t = S5(), r = hd(), n = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
  ];
  function s(d, c) {
    let p = 18;
    if (typeof c == "string") {
      const g = n.indexOf(c);
      (0, e.assertArgument)(g >= 0, "invalid unit", "unit", c), p = 3 * g;
    } else
      c != null && (p = (0, r.getNumber)(c, "unit"));
    return t.FixedNumber.fromValue(d, p, { decimals: p, width: 512 }).toString();
  }
  wi.formatUnits = s;
  function i(d, c) {
    (0, e.assertArgument)(typeof d == "string", "value must be a string", "value", d);
    let p = 18;
    if (typeof c == "string") {
      const g = n.indexOf(c);
      (0, e.assertArgument)(g >= 0, "invalid unit", "unit", c), p = 3 * g;
    } else
      c != null && (p = (0, r.getNumber)(c, "unit"));
    return t.FixedNumber.fromString(d, { decimals: p, width: 512 }).value;
  }
  wi.parseUnits = i;
  function a(d) {
    return s(d, 18);
  }
  wi.formatEther = a;
  function f(d) {
    return i(d, 18);
  }
  return wi.parseEther = f, wi;
}
var yc = {}, ty;
function gT() {
  if (ty)
    return yc;
  ty = 1, Object.defineProperty(yc, "__esModule", { value: !0 }), yc.uuidV4 = void 0;
  const e = Vi();
  function t(r) {
    const n = (0, e.getBytes)(r, "randomBytes");
    n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128;
    const s = (0, e.hexlify)(n);
    return [
      s.substring(2, 10),
      s.substring(10, 14),
      s.substring(14, 18),
      s.substring(18, 22),
      s.substring(22, 34)
    ].join("-");
  }
  return yc.uuidV4 = t, yc;
}
var ry;
function wt() {
  return ry || (ry = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8String = e.toUtf8CodePoints = e.toUtf8Bytes = e.parseUnits = e.formatUnits = e.parseEther = e.formatEther = e.encodeRlp = e.decodeRlp = e.defineProperties = e.resolveProperties = e.toQuantity = e.toBeArray = e.toBeHex = e.toNumber = e.toBigInt = e.getUint = e.getNumber = e.getBigInt = e.mask = e.toTwos = e.fromTwos = e.FixedNumber = e.FetchCancelSignal = e.FetchResponse = e.FetchRequest = e.EventPayload = e.makeError = e.assertNormalize = e.assertPrivate = e.assertArgumentCount = e.assertArgument = e.assert = e.isError = e.isCallException = e.zeroPadBytes = e.zeroPadValue = e.stripZerosLeft = e.dataSlice = e.dataLength = e.concat = e.hexlify = e.isBytesLike = e.isHexString = e.getBytesCopy = e.getBytes = e.encodeBase64 = e.decodeBase64 = e.encodeBase58 = e.decodeBase58 = void 0, e.uuidV4 = e.Utf8ErrorFuncs = void 0;
    var t = uT();
    Object.defineProperty(e, "decodeBase58", { enumerable: !0, get: function() {
      return t.decodeBase58;
    } }), Object.defineProperty(e, "encodeBase58", { enumerable: !0, get: function() {
      return t.encodeBase58;
    } });
    var r = T5();
    Object.defineProperty(e, "decodeBase64", { enumerable: !0, get: function() {
      return r.decodeBase64;
    } }), Object.defineProperty(e, "encodeBase64", { enumerable: !0, get: function() {
      return r.encodeBase64;
    } });
    var n = Vi();
    Object.defineProperty(e, "getBytes", { enumerable: !0, get: function() {
      return n.getBytes;
    } }), Object.defineProperty(e, "getBytesCopy", { enumerable: !0, get: function() {
      return n.getBytesCopy;
    } }), Object.defineProperty(e, "isHexString", { enumerable: !0, get: function() {
      return n.isHexString;
    } }), Object.defineProperty(e, "isBytesLike", { enumerable: !0, get: function() {
      return n.isBytesLike;
    } }), Object.defineProperty(e, "hexlify", { enumerable: !0, get: function() {
      return n.hexlify;
    } }), Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
      return n.concat;
    } }), Object.defineProperty(e, "dataLength", { enumerable: !0, get: function() {
      return n.dataLength;
    } }), Object.defineProperty(e, "dataSlice", { enumerable: !0, get: function() {
      return n.dataSlice;
    } }), Object.defineProperty(e, "stripZerosLeft", { enumerable: !0, get: function() {
      return n.stripZerosLeft;
    } }), Object.defineProperty(e, "zeroPadValue", { enumerable: !0, get: function() {
      return n.zeroPadValue;
    } }), Object.defineProperty(e, "zeroPadBytes", { enumerable: !0, get: function() {
      return n.zeroPadBytes;
    } });
    var s = ws();
    Object.defineProperty(e, "isCallException", { enumerable: !0, get: function() {
      return s.isCallException;
    } }), Object.defineProperty(e, "isError", { enumerable: !0, get: function() {
      return s.isError;
    } }), Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
      return s.assert;
    } }), Object.defineProperty(e, "assertArgument", { enumerable: !0, get: function() {
      return s.assertArgument;
    } }), Object.defineProperty(e, "assertArgumentCount", { enumerable: !0, get: function() {
      return s.assertArgumentCount;
    } }), Object.defineProperty(e, "assertPrivate", { enumerable: !0, get: function() {
      return s.assertPrivate;
    } }), Object.defineProperty(e, "assertNormalize", { enumerable: !0, get: function() {
      return s.assertNormalize;
    } }), Object.defineProperty(e, "makeError", { enumerable: !0, get: function() {
      return s.makeError;
    } });
    var i = cT();
    Object.defineProperty(e, "EventPayload", { enumerable: !0, get: function() {
      return i.EventPayload;
    } });
    var a = dT();
    Object.defineProperty(e, "FetchRequest", { enumerable: !0, get: function() {
      return a.FetchRequest;
    } }), Object.defineProperty(e, "FetchResponse", { enumerable: !0, get: function() {
      return a.FetchResponse;
    } }), Object.defineProperty(e, "FetchCancelSignal", { enumerable: !0, get: function() {
      return a.FetchCancelSignal;
    } });
    var f = S5();
    Object.defineProperty(e, "FixedNumber", { enumerable: !0, get: function() {
      return f.FixedNumber;
    } });
    var d = hd();
    Object.defineProperty(e, "fromTwos", { enumerable: !0, get: function() {
      return d.fromTwos;
    } }), Object.defineProperty(e, "toTwos", { enumerable: !0, get: function() {
      return d.toTwos;
    } }), Object.defineProperty(e, "mask", { enumerable: !0, get: function() {
      return d.mask;
    } }), Object.defineProperty(e, "getBigInt", { enumerable: !0, get: function() {
      return d.getBigInt;
    } }), Object.defineProperty(e, "getNumber", { enumerable: !0, get: function() {
      return d.getNumber;
    } }), Object.defineProperty(e, "getUint", { enumerable: !0, get: function() {
      return d.getUint;
    } }), Object.defineProperty(e, "toBigInt", { enumerable: !0, get: function() {
      return d.toBigInt;
    } }), Object.defineProperty(e, "toNumber", { enumerable: !0, get: function() {
      return d.toNumber;
    } }), Object.defineProperty(e, "toBeHex", { enumerable: !0, get: function() {
      return d.toBeHex;
    } }), Object.defineProperty(e, "toBeArray", { enumerable: !0, get: function() {
      return d.toBeArray;
    } }), Object.defineProperty(e, "toQuantity", { enumerable: !0, get: function() {
      return d.toQuantity;
    } });
    var c = ru();
    Object.defineProperty(e, "resolveProperties", { enumerable: !0, get: function() {
      return c.resolveProperties;
    } }), Object.defineProperty(e, "defineProperties", { enumerable: !0, get: function() {
      return c.defineProperties;
    } });
    var p = hT();
    Object.defineProperty(e, "decodeRlp", { enumerable: !0, get: function() {
      return p.decodeRlp;
    } });
    var g = fT();
    Object.defineProperty(e, "encodeRlp", { enumerable: !0, get: function() {
      return g.encodeRlp;
    } });
    var v = pT();
    Object.defineProperty(e, "formatEther", { enumerable: !0, get: function() {
      return v.formatEther;
    } }), Object.defineProperty(e, "parseEther", { enumerable: !0, get: function() {
      return v.parseEther;
    } }), Object.defineProperty(e, "formatUnits", { enumerable: !0, get: function() {
      return v.formatUnits;
    } }), Object.defineProperty(e, "parseUnits", { enumerable: !0, get: function() {
      return v.parseUnits;
    } });
    var O = v1();
    Object.defineProperty(e, "toUtf8Bytes", { enumerable: !0, get: function() {
      return O.toUtf8Bytes;
    } }), Object.defineProperty(e, "toUtf8CodePoints", { enumerable: !0, get: function() {
      return O.toUtf8CodePoints;
    } }), Object.defineProperty(e, "toUtf8String", { enumerable: !0, get: function() {
      return O.toUtf8String;
    } }), Object.defineProperty(e, "Utf8ErrorFuncs", { enumerable: !0, get: function() {
      return O.Utf8ErrorFuncs;
    } });
    var N = gT();
    Object.defineProperty(e, "uuidV4", { enumerable: !0, get: function() {
      return N.uuidV4;
    } });
  }(jm)), jm;
}
var ny = {}, iy;
function Ji() {
  return iy || (iy = 1, function(e) {
    var t, r, n, s, i, a, f, d, c, p, g, v, O, N;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Reader = e.Writer = e.Coder = e.checkResultErrors = e.Result = e.WordSize = void 0;
    const S = wt();
    e.WordSize = 32;
    const j = new Uint8Array(e.WordSize), B = ["then"], M = {};
    function I(D, o) {
      const u = new Error(`deferred error during ABI decoding triggered accessing ${D}`);
      throw u.error = o, u;
    }
    const A = class mu extends Array {
      /**
       *  @private
       */
      constructor(...o) {
        const u = o[0];
        let h = o[1], y = (o[2] || []).slice(), E = !0;
        u !== M && (h = o, y = [], E = !1), super(h.length), _e(this, t, void 0), h.forEach((w, m) => {
          this[m] = w;
        });
        const P = y.reduce((w, m) => (typeof m == "string" && w.set(m, (w.get(m) || 0) + 1), w), /* @__PURE__ */ new Map());
        if (Oe(this, t, Object.freeze(h.map((w, m) => {
          const l = y[m];
          return l != null && P.get(l) === 1 ? l : null;
        }))), !!E)
          return Object.freeze(this), new Proxy(this, {
            get: (w, m, l) => {
              if (typeof m == "string") {
                if (m.match(/^[0-9]+$/)) {
                  const W = (0, S.getNumber)(m, "%index");
                  if (W < 0 || W >= this.length)
                    throw new RangeError("out of result range");
                  const X = w[W];
                  return X instanceof Error && I(`index ${W}`, X), X;
                }
                if (B.indexOf(m) >= 0)
                  return Reflect.get(w, m, l);
                const b = w[m];
                if (b instanceof Function)
                  return function(...W) {
                    return b.apply(this === l ? w : this, W);
                  };
                if (!(m in w))
                  return w.getValue.apply(this === l ? w : this, [m]);
              }
              return Reflect.get(w, m, l);
            }
          });
      }
      /**
       *  Returns the Result as a normal Array. If %%deep%%, any children
       *  which are Result objects are also converted to a normal Array.
       *
       *  This will throw if there are any outstanding deferred
       *  errors.
       */
      toArray(o) {
        const u = [];
        return this.forEach((h, y) => {
          h instanceof Error && I(`index ${y}`, h), o && h instanceof mu && (h = h.toArray(o)), u.push(h);
        }), u;
      }
      /**
       *  Returns the Result as an Object with each name-value pair. If
       *  %%deep%%, any children which are Result objects are also
       *  converted to an Object.
       *
       *  This will throw if any value is unnamed, or if there are
       *  any outstanding deferred errors.
       */
      toObject(o) {
        return oe(this, t).reduce((u, h, y) => {
          if ((0, S.assert)(h != null, "value at index ${ index } unnamed", "UNSUPPORTED_OPERATION", {
            operation: "toObject()"
          }), !(h in u)) {
            let E = this.getValue(h);
            o && E instanceof mu && (E = E.toObject(o)), u[h] = E;
          }
          return u;
        }, {});
      }
      /**
       *  @_ignore
       */
      slice(o, u) {
        o == null && (o = 0), o < 0 && (o += this.length, o < 0 && (o = 0)), u == null && (u = this.length), u < 0 && (u += this.length, u < 0 && (u = 0)), u > this.length && (u = this.length);
        const h = [], y = [];
        for (let E = o; E < u; E++)
          h.push(this[E]), y.push(oe(this, t)[E]);
        return new mu(M, h, y);
      }
      /**
       *  @_ignore
       */
      filter(o, u) {
        const h = [], y = [];
        for (let E = 0; E < this.length; E++) {
          const P = this[E];
          P instanceof Error && I(`index ${E}`, P), o.call(u, P, E, this) && (h.push(P), y.push(oe(this, t)[E]));
        }
        return new mu(M, h, y);
      }
      /**
       *  @_ignore
       */
      map(o, u) {
        const h = [];
        for (let y = 0; y < this.length; y++) {
          const E = this[y];
          E instanceof Error && I(`index ${y}`, E), h.push(o.call(u, E, y, this));
        }
        return h;
      }
      /**
       *  Returns the value for %%name%%.
       *
       *  Since it is possible to have a key whose name conflicts with
       *  a method on a [[Result]] or its superclass Array, or any
       *  JavaScript keyword, this ensures all named values are still
       *  accessible by name.
       */
      getValue(o) {
        const u = oe(this, t).indexOf(o);
        if (u === -1)
          return;
        const h = this[u];
        return h instanceof Error && I(`property ${JSON.stringify(o)}`, h.error), h;
      }
      /**
       *  Creates a new [[Result]] for %%items%% with each entry
       *  also accessible by its corresponding name in %%keys%%.
       */
      static fromItems(o, u) {
        return new mu(M, o, u);
      }
    };
    t = /* @__PURE__ */ new WeakMap();
    let R = A;
    e.Result = R;
    function L(D) {
      const o = [], u = function(h, y) {
        if (Array.isArray(y))
          for (let E in y) {
            const P = h.slice();
            P.push(E);
            try {
              u(P, y[E]);
            } catch (w) {
              o.push({ path: P, error: w });
            }
          }
      };
      return u([], D), o;
    }
    e.checkResultErrors = L;
    function K(D) {
      let o = (0, S.toBeArray)(D);
      return (0, S.assert)(o.length <= e.WordSize, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: o, length: e.WordSize, offset: o.length }), o.length !== e.WordSize && (o = (0, S.getBytesCopy)((0, S.concat)([j.slice(o.length % e.WordSize), o]))), o;
    }
    class $ {
      constructor(o, u, h, y) {
        Be(this, "name"), Be(this, "type"), Be(this, "localName"), Be(this, "dynamic"), (0, S.defineProperties)(this, { name: o, type: u, localName: h, dynamic: y }, {
          name: "string",
          type: "string",
          localName: "string",
          dynamic: "boolean"
        });
      }
      _throwError(o, u) {
        (0, S.assertArgument)(!1, o, this.localName, u);
      }
    }
    e.Coder = $;
    class k {
      constructor() {
        _e(this, s), _e(this, r, void 0), _e(this, n, void 0), Oe(this, r, []), Oe(this, n, 0);
      }
      get data() {
        return (0, S.concat)(oe(this, r));
      }
      get length() {
        return oe(this, n);
      }
      appendWriter(o) {
        return Ve(this, s, i).call(this, (0, S.getBytesCopy)(o.data));
      }
      // Arrayish item; pad on the right to *nearest* WordSize
      writeBytes(o) {
        let u = (0, S.getBytesCopy)(o);
        const h = u.length % e.WordSize;
        return h && (u = (0, S.getBytesCopy)((0, S.concat)([u, j.slice(h)]))), Ve(this, s, i).call(this, u);
      }
      // Numeric item; pad on the left *to* WordSize
      writeValue(o) {
        return Ve(this, s, i).call(this, K(o));
      }
      // Inserts a numeric place-holder, returning a callback that can
      // be used to asjust the value later
      writeUpdatableValue() {
        const o = oe(this, r).length;
        return oe(this, r).push(j), Oe(this, n, oe(this, n) + e.WordSize), (u) => {
          oe(this, r)[o] = K(u);
        };
      }
    }
    r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakSet(), i = function(D) {
      return oe(this, r).push(D), Oe(this, n, oe(this, n) + D.length), D.length;
    }, e.Writer = k;
    const V = class M5 {
      constructor(o, u, h) {
        _e(this, g), _e(this, O), Be(this, "allowLoose"), _e(this, a, void 0), _e(this, f, void 0), _e(this, d, void 0), _e(this, c, void 0), _e(this, p, void 0), (0, S.defineProperties)(this, { allowLoose: !!u }), Oe(this, a, (0, S.getBytesCopy)(o)), Oe(this, d, 0), Oe(this, c, null), Oe(this, p, h ?? 1024), Oe(this, f, 0);
      }
      get data() {
        return (0, S.hexlify)(oe(this, a));
      }
      get dataLength() {
        return oe(this, a).length;
      }
      get consumed() {
        return oe(this, f);
      }
      get bytes() {
        return new Uint8Array(oe(this, a));
      }
      // Create a sub-reader with the same underlying data, but offset
      subReader(o) {
        const u = new M5(oe(this, a).slice(oe(this, f) + o), this.allowLoose, oe(this, p));
        return Oe(u, c, this), u;
      }
      // Read bytes
      readBytes(o, u) {
        let h = Ve(this, O, N).call(this, 0, o, !!u);
        return Ve(this, g, v).call(this, o), Oe(this, f, oe(this, f) + h.length), h.slice(0, o);
      }
      // Read a numeric values
      readValue() {
        return (0, S.toBigInt)(this.readBytes(e.WordSize));
      }
      readIndex() {
        return (0, S.toNumber)(this.readBytes(e.WordSize));
      }
    };
    a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakSet(), v = function(D) {
      var o;
      if (oe(this, c))
        return Ve(o = oe(this, c), g, v).call(o, D);
      Oe(this, d, oe(this, d) + D), (0, S.assert)(oe(this, p) < 1 || oe(this, d) <= oe(this, p) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${oe(this, p)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
        buffer: (0, S.getBytesCopy)(oe(this, a)),
        offset: oe(this, f),
        length: D,
        info: {
          bytesRead: oe(this, d),
          dataLength: this.dataLength
        }
      });
    }, O = /* @__PURE__ */ new WeakSet(), N = function(D, o, u) {
      let h = Math.ceil(o / e.WordSize) * e.WordSize;
      return oe(this, f) + h > oe(this, a).length && (this.allowLoose && u && oe(this, f) + o <= oe(this, a).length ? h = o : (0, S.assert)(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
        buffer: (0, S.getBytesCopy)(oe(this, a)),
        length: oe(this, a).length,
        offset: oe(this, f) + h
      })), oe(this, a).slice(oe(this, f), oe(this, f) + h);
    };
    let C = V;
    e.Reader = C;
  }(ny)), ny;
}
var bc = {}, sy = {}, Wo = {}, oy = {}, wc = {}, vi = {}, ay = {}, dn = {}, uy;
function fd() {
  if (uy)
    return dn;
  uy = 1, Object.defineProperty(dn, "__esModule", { value: !0 }), dn.output = dn.exists = dn.hash = dn.bytes = dn.bool = dn.number = void 0;
  function e(f) {
    if (!Number.isSafeInteger(f) || f < 0)
      throw new Error(`Wrong positive integer: ${f}`);
  }
  dn.number = e;
  function t(f) {
    if (typeof f != "boolean")
      throw new Error(`Expected boolean, not ${f}`);
  }
  dn.bool = t;
  function r(f, ...d) {
    if (!(f instanceof Uint8Array))
      throw new Error("Expected Uint8Array");
    if (d.length > 0 && !d.includes(f.length))
      throw new Error(`Expected Uint8Array of length ${d}, not of length=${f.length}`);
  }
  dn.bytes = r;
  function n(f) {
    if (typeof f != "function" || typeof f.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    e(f.outputLen), e(f.blockLen);
  }
  dn.hash = n;
  function s(f, d = !0) {
    if (f.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (d && f.finished)
      throw new Error("Hash#digest() has already been called");
  }
  dn.exists = s;
  function i(f, d) {
    r(f);
    const c = d.outputLen;
    if (f.length < c)
      throw new Error(`digestInto() expects output buffer of length at least ${c}`);
  }
  dn.output = i;
  const a = { number: e, bool: t, bytes: r, hash: n, exists: s, output: i };
  return dn.default = a, dn;
}
var cy = {}, Bd = {}, ly;
function mT() {
  return ly || (ly = 1, Object.defineProperty(Bd, "__esModule", { value: !0 }), Bd.crypto = void 0, Bd.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0), Bd;
}
var dy;
function vs() {
  return dy || (dy = 1, function(e) {
    /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    Object.defineProperty(e, "__esModule", { value: !0 }), e.randomBytes = e.wrapXOFConstructorWithOpts = e.wrapConstructorWithOpts = e.wrapConstructor = e.checkOpts = e.Hash = e.concatBytes = e.toBytes = e.utf8ToBytes = e.asyncLoop = e.nextTick = e.hexToBytes = e.bytesToHex = e.isLE = e.rotr = e.createView = e.u32 = e.u8 = void 0;
    const t = mT(), r = (L) => L instanceof Uint8Array, n = (L) => new Uint8Array(L.buffer, L.byteOffset, L.byteLength);
    e.u8 = n;
    const s = (L) => new Uint32Array(L.buffer, L.byteOffset, Math.floor(L.byteLength / 4));
    e.u32 = s;
    const i = (L) => new DataView(L.buffer, L.byteOffset, L.byteLength);
    e.createView = i;
    const a = (L, K) => L << 32 - K | L >>> K;
    if (e.rotr = a, e.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, !e.isLE)
      throw new Error("Non little-endian hardware is not supported");
    const f = /* @__PURE__ */ Array.from({ length: 256 }, (L, K) => K.toString(16).padStart(2, "0"));
    function d(L) {
      if (!r(L))
        throw new Error("Uint8Array expected");
      let K = "";
      for (let $ = 0; $ < L.length; $++)
        K += f[L[$]];
      return K;
    }
    e.bytesToHex = d;
    function c(L) {
      if (typeof L != "string")
        throw new Error("hex string expected, got " + typeof L);
      const K = L.length;
      if (K % 2)
        throw new Error("padded hex string expected, got unpadded hex of length " + K);
      const $ = new Uint8Array(K / 2);
      for (let k = 0; k < $.length; k++) {
        const V = k * 2, C = L.slice(V, V + 2), D = Number.parseInt(C, 16);
        if (Number.isNaN(D) || D < 0)
          throw new Error("Invalid byte sequence");
        $[k] = D;
      }
      return $;
    }
    e.hexToBytes = c;
    const p = async () => {
    };
    e.nextTick = p;
    async function g(L, K, $) {
      let k = Date.now();
      for (let V = 0; V < L; V++) {
        $(V);
        const C = Date.now() - k;
        C >= 0 && C < K || (await (0, e.nextTick)(), k += C);
      }
    }
    e.asyncLoop = g;
    function v(L) {
      if (typeof L != "string")
        throw new Error(`utf8ToBytes expected string, got ${typeof L}`);
      return new Uint8Array(new TextEncoder().encode(L));
    }
    e.utf8ToBytes = v;
    function O(L) {
      if (typeof L == "string" && (L = v(L)), !r(L))
        throw new Error(`expected Uint8Array, got ${typeof L}`);
      return L;
    }
    e.toBytes = O;
    function N(...L) {
      const K = new Uint8Array(L.reduce((k, V) => k + V.length, 0));
      let $ = 0;
      return L.forEach((k) => {
        if (!r(k))
          throw new Error("Uint8Array expected");
        K.set(k, $), $ += k.length;
      }), K;
    }
    e.concatBytes = N;
    class S {
      // Safe version that clones internal state
      clone() {
        return this._cloneInto();
      }
    }
    e.Hash = S;
    const j = {}.toString;
    function B(L, K) {
      if (K !== void 0 && j.call(K) !== "[object Object]")
        throw new Error("Options should be object or undefined");
      return Object.assign(L, K);
    }
    e.checkOpts = B;
    function M(L) {
      const K = (k) => L().update(O(k)).digest(), $ = L();
      return K.outputLen = $.outputLen, K.blockLen = $.blockLen, K.create = () => L(), K;
    }
    e.wrapConstructor = M;
    function I(L) {
      const K = (k, V) => L(V).update(O(k)).digest(), $ = L({});
      return K.outputLen = $.outputLen, K.blockLen = $.blockLen, K.create = (k) => L(k), K;
    }
    e.wrapConstructorWithOpts = I;
    function A(L) {
      const K = (k, V) => L(V).update(O(k)).digest(), $ = L({});
      return K.outputLen = $.outputLen, K.blockLen = $.blockLen, K.create = (k) => L(k), K;
    }
    e.wrapXOFConstructorWithOpts = A;
    function R(L = 32) {
      if (t.crypto && typeof t.crypto.getRandomValues == "function")
        return t.crypto.getRandomValues(new Uint8Array(L));
      throw new Error("crypto.getRandomValues must be defined");
    }
    e.randomBytes = R;
  }(cy)), cy;
}
var hy;
function A1() {
  return hy || (hy = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hmac = e.HMAC = void 0;
    const t = fd(), r = vs();
    class n extends r.Hash {
      constructor(a, f) {
        super(), this.finished = !1, this.destroyed = !1, (0, t.hash)(a);
        const d = (0, r.toBytes)(f);
        if (this.iHash = a.create(), typeof this.iHash.update != "function")
          throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const c = this.blockLen, p = new Uint8Array(c);
        p.set(d.length > c ? a.create().update(d).digest() : d);
        for (let g = 0; g < p.length; g++)
          p[g] ^= 54;
        this.iHash.update(p), this.oHash = a.create();
        for (let g = 0; g < p.length; g++)
          p[g] ^= 106;
        this.oHash.update(p), p.fill(0);
      }
      update(a) {
        return (0, t.exists)(this), this.iHash.update(a), this;
      }
      digestInto(a) {
        (0, t.exists)(this), (0, t.bytes)(a, this.outputLen), this.finished = !0, this.iHash.digestInto(a), this.oHash.update(a), this.oHash.digestInto(a), this.destroy();
      }
      digest() {
        const a = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(a), a;
      }
      _cloneInto(a) {
        a || (a = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: f, iHash: d, finished: c, destroyed: p, blockLen: g, outputLen: v } = this;
        return a = a, a.finished = c, a.destroyed = p, a.blockLen = g, a.outputLen = v, a.oHash = f._cloneInto(a.oHash), a.iHash = d._cloneInto(a.iHash), a;
      }
      destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
      }
    }
    e.HMAC = n;
    const s = (i, a, f) => new n(i, a).update(f).digest();
    e.hmac = s, e.hmac.create = (i, a) => new n(i, a);
  }(ay)), ay;
}
var Go = {}, fy;
function I5() {
  if (fy)
    return Go;
  fy = 1, Object.defineProperty(Go, "__esModule", { value: !0 }), Go.pbkdf2Async = Go.pbkdf2 = void 0;
  const e = fd(), t = A1(), r = vs();
  function n(f, d, c, p) {
    (0, e.hash)(f);
    const g = (0, r.checkOpts)({ dkLen: 32, asyncTick: 10 }, p), { c: v, dkLen: O, asyncTick: N } = g;
    if ((0, e.number)(v), (0, e.number)(O), (0, e.number)(N), v < 1)
      throw new Error("PBKDF2: iterations (c) should be >= 1");
    const S = (0, r.toBytes)(d), j = (0, r.toBytes)(c), B = new Uint8Array(O), M = t.hmac.create(f, S), I = M._cloneInto().update(j);
    return { c: v, dkLen: O, asyncTick: N, DK: B, PRF: M, PRFSalt: I };
  }
  function s(f, d, c, p, g) {
    return f.destroy(), d.destroy(), p && p.destroy(), g.fill(0), c;
  }
  function i(f, d, c, p) {
    const { c: g, dkLen: v, DK: O, PRF: N, PRFSalt: S } = n(f, d, c, p);
    let j;
    const B = new Uint8Array(4), M = (0, r.createView)(B), I = new Uint8Array(N.outputLen);
    for (let A = 1, R = 0; R < v; A++, R += N.outputLen) {
      const L = O.subarray(R, R + N.outputLen);
      M.setInt32(0, A, !1), (j = S._cloneInto(j)).update(B).digestInto(I), L.set(I.subarray(0, L.length));
      for (let K = 1; K < g; K++) {
        N._cloneInto(j).update(I).digestInto(I);
        for (let $ = 0; $ < L.length; $++)
          L[$] ^= I[$];
      }
    }
    return s(N, S, O, j, I);
  }
  Go.pbkdf2 = i;
  async function a(f, d, c, p) {
    const { c: g, dkLen: v, asyncTick: O, DK: N, PRF: S, PRFSalt: j } = n(f, d, c, p);
    let B;
    const M = new Uint8Array(4), I = (0, r.createView)(M), A = new Uint8Array(S.outputLen);
    for (let R = 1, L = 0; L < v; R++, L += S.outputLen) {
      const K = N.subarray(L, L + S.outputLen);
      I.setInt32(0, R, !1), (B = j._cloneInto(B)).update(M).digestInto(A), K.set(A.subarray(0, K.length)), await (0, r.asyncLoop)(g - 1, O, () => {
        S._cloneInto(B).update(A).digestInto(A);
        for (let $ = 0; $ < K.length; $++)
          K[$] ^= A[$];
      });
    }
    return s(S, j, N, B, A);
  }
  return Go.pbkdf2Async = a, Go;
}
var zo = {}, vc = {}, py;
function E1() {
  if (py)
    return vc;
  py = 1, Object.defineProperty(vc, "__esModule", { value: !0 }), vc.SHA2 = void 0;
  const e = fd(), t = vs();
  function r(s, i, a, f) {
    if (typeof s.setBigUint64 == "function")
      return s.setBigUint64(i, a, f);
    const d = BigInt(32), c = BigInt(4294967295), p = Number(a >> d & c), g = Number(a & c), v = f ? 4 : 0, O = f ? 0 : 4;
    s.setUint32(i + v, p, f), s.setUint32(i + O, g, f);
  }
  class n extends t.Hash {
    constructor(i, a, f, d) {
      super(), this.blockLen = i, this.outputLen = a, this.padOffset = f, this.isLE = d, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(i), this.view = (0, t.createView)(this.buffer);
    }
    update(i) {
      (0, e.exists)(this);
      const { view: a, buffer: f, blockLen: d } = this;
      i = (0, t.toBytes)(i);
      const c = i.length;
      for (let p = 0; p < c; ) {
        const g = Math.min(d - this.pos, c - p);
        if (g === d) {
          const v = (0, t.createView)(i);
          for (; d <= c - p; p += d)
            this.process(v, p);
          continue;
        }
        f.set(i.subarray(p, p + g), this.pos), this.pos += g, p += g, this.pos === d && (this.process(a, 0), this.pos = 0);
      }
      return this.length += i.length, this.roundClean(), this;
    }
    digestInto(i) {
      (0, e.exists)(this), (0, e.output)(i, this), this.finished = !0;
      const { buffer: a, view: f, blockLen: d, isLE: c } = this;
      let { pos: p } = this;
      a[p++] = 128, this.buffer.subarray(p).fill(0), this.padOffset > d - p && (this.process(f, 0), p = 0);
      for (let S = p; S < d; S++)
        a[S] = 0;
      r(f, d - 8, BigInt(this.length * 8), c), this.process(f, 0);
      const g = (0, t.createView)(i), v = this.outputLen;
      if (v % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const O = v / 4, N = this.get();
      if (O > N.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let S = 0; S < O; S++)
        g.setUint32(4 * S, N[S], c);
    }
    digest() {
      const { buffer: i, outputLen: a } = this;
      this.digestInto(i);
      const f = i.slice(0, a);
      return this.destroy(), f;
    }
    _cloneInto(i) {
      i || (i = new this.constructor()), i.set(...this.get());
      const { blockLen: a, buffer: f, length: d, finished: c, destroyed: p, pos: g } = this;
      return i.length = d, i.pos = g, i.finished = c, i.destroyed = p, d % a && i.buffer.set(f), i;
    }
  }
  return vc.SHA2 = n, vc;
}
var gy;
function P1() {
  if (gy)
    return zo;
  gy = 1, Object.defineProperty(zo, "__esModule", { value: !0 }), zo.sha224 = zo.sha256 = void 0;
  const e = E1(), t = vs(), r = (c, p, g) => c & p ^ ~c & g, n = (c, p, g) => c & p ^ c & g ^ p & g, s = /* @__PURE__ */ new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), i = /* @__PURE__ */ new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), a = /* @__PURE__ */ new Uint32Array(64);
  class f extends e.SHA2 {
    constructor() {
      super(64, 32, 8, !1), this.A = i[0] | 0, this.B = i[1] | 0, this.C = i[2] | 0, this.D = i[3] | 0, this.E = i[4] | 0, this.F = i[5] | 0, this.G = i[6] | 0, this.H = i[7] | 0;
    }
    get() {
      const { A: p, B: g, C: v, D: O, E: N, F: S, G: j, H: B } = this;
      return [p, g, v, O, N, S, j, B];
    }
    // prettier-ignore
    set(p, g, v, O, N, S, j, B) {
      this.A = p | 0, this.B = g | 0, this.C = v | 0, this.D = O | 0, this.E = N | 0, this.F = S | 0, this.G = j | 0, this.H = B | 0;
    }
    process(p, g) {
      for (let A = 0; A < 16; A++, g += 4)
        a[A] = p.getUint32(g, !1);
      for (let A = 16; A < 64; A++) {
        const R = a[A - 15], L = a[A - 2], K = (0, t.rotr)(R, 7) ^ (0, t.rotr)(R, 18) ^ R >>> 3, $ = (0, t.rotr)(L, 17) ^ (0, t.rotr)(L, 19) ^ L >>> 10;
        a[A] = $ + a[A - 7] + K + a[A - 16] | 0;
      }
      let { A: v, B: O, C: N, D: S, E: j, F: B, G: M, H: I } = this;
      for (let A = 0; A < 64; A++) {
        const R = (0, t.rotr)(j, 6) ^ (0, t.rotr)(j, 11) ^ (0, t.rotr)(j, 25), L = I + R + r(j, B, M) + s[A] + a[A] | 0, K = ((0, t.rotr)(v, 2) ^ (0, t.rotr)(v, 13) ^ (0, t.rotr)(v, 22)) + n(v, O, N) | 0;
        I = M, M = B, B = j, j = S + L | 0, S = N, N = O, O = v, v = L + K | 0;
      }
      v = v + this.A | 0, O = O + this.B | 0, N = N + this.C | 0, S = S + this.D | 0, j = j + this.E | 0, B = B + this.F | 0, M = M + this.G | 0, I = I + this.H | 0, this.set(v, O, N, S, j, B, M, I);
    }
    roundClean() {
      a.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }
  class d extends f {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  }
  return zo.sha256 = (0, t.wrapConstructor)(() => new f()), zo.sha224 = (0, t.wrapConstructor)(() => new d()), zo;
}
var Un = {}, Ht = {}, my;
function R5() {
  if (my)
    return Ht;
  my = 1, Object.defineProperty(Ht, "__esModule", { value: !0 }), Ht.add5L = Ht.add5H = Ht.add4H = Ht.add4L = Ht.add3H = Ht.add3L = Ht.add = Ht.rotlBL = Ht.rotlBH = Ht.rotlSL = Ht.rotlSH = Ht.rotr32L = Ht.rotr32H = Ht.rotrBL = Ht.rotrBH = Ht.rotrSL = Ht.rotrSH = Ht.shrSL = Ht.shrSH = Ht.toBig = Ht.split = Ht.fromBig = void 0;
  const e = /* @__PURE__ */ BigInt(2 ** 32 - 1), t = /* @__PURE__ */ BigInt(32);
  function r(k, V = !1) {
    return V ? { h: Number(k & e), l: Number(k >> t & e) } : { h: Number(k >> t & e) | 0, l: Number(k & e) | 0 };
  }
  Ht.fromBig = r;
  function n(k, V = !1) {
    let C = new Uint32Array(k.length), D = new Uint32Array(k.length);
    for (let o = 0; o < k.length; o++) {
      const { h: u, l: h } = r(k[o], V);
      [C[o], D[o]] = [u, h];
    }
    return [C, D];
  }
  Ht.split = n;
  const s = (k, V) => BigInt(k >>> 0) << t | BigInt(V >>> 0);
  Ht.toBig = s;
  const i = (k, V, C) => k >>> C;
  Ht.shrSH = i;
  const a = (k, V, C) => k << 32 - C | V >>> C;
  Ht.shrSL = a;
  const f = (k, V, C) => k >>> C | V << 32 - C;
  Ht.rotrSH = f;
  const d = (k, V, C) => k << 32 - C | V >>> C;
  Ht.rotrSL = d;
  const c = (k, V, C) => k << 64 - C | V >>> C - 32;
  Ht.rotrBH = c;
  const p = (k, V, C) => k >>> C - 32 | V << 64 - C;
  Ht.rotrBL = p;
  const g = (k, V) => V;
  Ht.rotr32H = g;
  const v = (k, V) => k;
  Ht.rotr32L = v;
  const O = (k, V, C) => k << C | V >>> 32 - C;
  Ht.rotlSH = O;
  const N = (k, V, C) => V << C | k >>> 32 - C;
  Ht.rotlSL = N;
  const S = (k, V, C) => V << C - 32 | k >>> 64 - C;
  Ht.rotlBH = S;
  const j = (k, V, C) => k << C - 32 | V >>> 64 - C;
  Ht.rotlBL = j;
  function B(k, V, C, D) {
    const o = (V >>> 0) + (D >>> 0);
    return { h: k + C + (o / 2 ** 32 | 0) | 0, l: o | 0 };
  }
  Ht.add = B;
  const M = (k, V, C) => (k >>> 0) + (V >>> 0) + (C >>> 0);
  Ht.add3L = M;
  const I = (k, V, C, D) => V + C + D + (k / 2 ** 32 | 0) | 0;
  Ht.add3H = I;
  const A = (k, V, C, D) => (k >>> 0) + (V >>> 0) + (C >>> 0) + (D >>> 0);
  Ht.add4L = A;
  const R = (k, V, C, D, o) => V + C + D + o + (k / 2 ** 32 | 0) | 0;
  Ht.add4H = R;
  const L = (k, V, C, D, o) => (k >>> 0) + (V >>> 0) + (C >>> 0) + (D >>> 0) + (o >>> 0);
  Ht.add5L = L;
  const K = (k, V, C, D, o, u) => V + C + D + o + u + (k / 2 ** 32 | 0) | 0;
  Ht.add5H = K;
  const $ = {
    fromBig: r,
    split: n,
    toBig: s,
    shrSH: i,
    shrSL: a,
    rotrSH: f,
    rotrSL: d,
    rotrBH: c,
    rotrBL: p,
    rotr32H: g,
    rotr32L: v,
    rotlSH: O,
    rotlSL: N,
    rotlBH: S,
    rotlBL: j,
    add: B,
    add3L: M,
    add3H: I,
    add4L: A,
    add4H: R,
    add5H: K,
    add5L: L
  };
  return Ht.default = $, Ht;
}
var yy;
function yT() {
  if (yy)
    return Un;
  yy = 1, Object.defineProperty(Un, "__esModule", { value: !0 }), Un.sha384 = Un.sha512_256 = Un.sha512_224 = Un.sha512 = Un.SHA512 = void 0;
  const e = E1(), t = R5(), r = vs(), [n, s] = t.default.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
  ].map((g) => BigInt(g))), i = /* @__PURE__ */ new Uint32Array(80), a = /* @__PURE__ */ new Uint32Array(80);
  class f extends e.SHA2 {
    constructor() {
      super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
      const { Ah: v, Al: O, Bh: N, Bl: S, Ch: j, Cl: B, Dh: M, Dl: I, Eh: A, El: R, Fh: L, Fl: K, Gh: $, Gl: k, Hh: V, Hl: C } = this;
      return [v, O, N, S, j, B, M, I, A, R, L, K, $, k, V, C];
    }
    // prettier-ignore
    set(v, O, N, S, j, B, M, I, A, R, L, K, $, k, V, C) {
      this.Ah = v | 0, this.Al = O | 0, this.Bh = N | 0, this.Bl = S | 0, this.Ch = j | 0, this.Cl = B | 0, this.Dh = M | 0, this.Dl = I | 0, this.Eh = A | 0, this.El = R | 0, this.Fh = L | 0, this.Fl = K | 0, this.Gh = $ | 0, this.Gl = k | 0, this.Hh = V | 0, this.Hl = C | 0;
    }
    process(v, O) {
      for (let u = 0; u < 16; u++, O += 4)
        i[u] = v.getUint32(O), a[u] = v.getUint32(O += 4);
      for (let u = 16; u < 80; u++) {
        const h = i[u - 15] | 0, y = a[u - 15] | 0, E = t.default.rotrSH(h, y, 1) ^ t.default.rotrSH(h, y, 8) ^ t.default.shrSH(h, y, 7), P = t.default.rotrSL(h, y, 1) ^ t.default.rotrSL(h, y, 8) ^ t.default.shrSL(h, y, 7), w = i[u - 2] | 0, m = a[u - 2] | 0, l = t.default.rotrSH(w, m, 19) ^ t.default.rotrBH(w, m, 61) ^ t.default.shrSH(w, m, 6), b = t.default.rotrSL(w, m, 19) ^ t.default.rotrBL(w, m, 61) ^ t.default.shrSL(w, m, 6), W = t.default.add4L(P, b, a[u - 7], a[u - 16]), X = t.default.add4H(W, E, l, i[u - 7], i[u - 16]);
        i[u] = X | 0, a[u] = W | 0;
      }
      let { Ah: N, Al: S, Bh: j, Bl: B, Ch: M, Cl: I, Dh: A, Dl: R, Eh: L, El: K, Fh: $, Fl: k, Gh: V, Gl: C, Hh: D, Hl: o } = this;
      for (let u = 0; u < 80; u++) {
        const h = t.default.rotrSH(L, K, 14) ^ t.default.rotrSH(L, K, 18) ^ t.default.rotrBH(L, K, 41), y = t.default.rotrSL(L, K, 14) ^ t.default.rotrSL(L, K, 18) ^ t.default.rotrBL(L, K, 41), E = L & $ ^ ~L & V, P = K & k ^ ~K & C, w = t.default.add5L(o, y, P, s[u], a[u]), m = t.default.add5H(w, D, h, E, n[u], i[u]), l = w | 0, b = t.default.rotrSH(N, S, 28) ^ t.default.rotrBH(N, S, 34) ^ t.default.rotrBH(N, S, 39), W = t.default.rotrSL(N, S, 28) ^ t.default.rotrBL(N, S, 34) ^ t.default.rotrBL(N, S, 39), X = N & j ^ N & M ^ j & M, G = S & B ^ S & I ^ B & I;
        D = V | 0, o = C | 0, V = $ | 0, C = k | 0, $ = L | 0, k = K | 0, { h: L, l: K } = t.default.add(A | 0, R | 0, m | 0, l | 0), A = M | 0, R = I | 0, M = j | 0, I = B | 0, j = N | 0, B = S | 0;
        const re = t.default.add3L(l, W, G);
        N = t.default.add3H(re, m, b, X), S = re | 0;
      }
      ({ h: N, l: S } = t.default.add(this.Ah | 0, this.Al | 0, N | 0, S | 0)), { h: j, l: B } = t.default.add(this.Bh | 0, this.Bl | 0, j | 0, B | 0), { h: M, l: I } = t.default.add(this.Ch | 0, this.Cl | 0, M | 0, I | 0), { h: A, l: R } = t.default.add(this.Dh | 0, this.Dl | 0, A | 0, R | 0), { h: L, l: K } = t.default.add(this.Eh | 0, this.El | 0, L | 0, K | 0), { h: $, l: k } = t.default.add(this.Fh | 0, this.Fl | 0, $ | 0, k | 0), { h: V, l: C } = t.default.add(this.Gh | 0, this.Gl | 0, V | 0, C | 0), { h: D, l: o } = t.default.add(this.Hh | 0, this.Hl | 0, D | 0, o | 0), this.set(N, S, j, B, M, I, A, R, L, K, $, k, V, C, D, o);
    }
    roundClean() {
      i.fill(0), a.fill(0);
    }
    destroy() {
      this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  Un.SHA512 = f;
  class d extends f {
    constructor() {
      super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
    }
  }
  class c extends f {
    constructor() {
      super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
    }
  }
  class p extends f {
    constructor() {
      super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
    }
  }
  return Un.sha512 = (0, r.wrapConstructor)(() => new f()), Un.sha512_224 = (0, r.wrapConstructor)(() => new d()), Un.sha512_256 = (0, r.wrapConstructor)(() => new c()), Un.sha384 = (0, r.wrapConstructor)(() => new p()), Un;
}
var by;
function nf() {
  if (by)
    return vi;
  by = 1, Object.defineProperty(vi, "__esModule", { value: !0 }), vi.randomBytes = vi.pbkdf2Sync = vi.createHmac = vi.createHash = void 0;
  const e = A1(), t = I5(), r = P1(), n = yT(), s = wt();
  function i() {
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof Ze < "u")
      return Ze;
    throw new Error("unable to locate global object");
  }
  const a = i(), f = a.crypto || a.msCrypto;
  function d(v) {
    switch (v) {
      case "sha256":
        return r.sha256.create();
      case "sha512":
        return n.sha512.create();
    }
    (0, s.assertArgument)(!1, "invalid hashing algorithm name", "algorithm", v);
  }
  vi.createHash = d;
  function c(v, O) {
    const N = { sha256: r.sha256, sha512: n.sha512 }[v];
    return (0, s.assertArgument)(N != null, "invalid hmac algorithm", "algorithm", v), e.hmac.create(N, O);
  }
  vi.createHmac = c;
  function p(v, O, N, S, j) {
    const B = { sha256: r.sha256, sha512: n.sha512 }[j];
    return (0, s.assertArgument)(B != null, "invalid pbkdf2 algorithm", "algorithm", j), (0, t.pbkdf2)(B, v, O, { c: N, dkLen: S });
  }
  vi.pbkdf2Sync = p;
  function g(v) {
    (0, s.assert)(f != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
      operation: "randomBytes"
    }), (0, s.assertArgument)(Number.isInteger(v) && v > 0 && v <= 1024, "invalid length", "length", v);
    const O = new Uint8Array(v);
    return f.getRandomValues(O), O;
  }
  return vi.randomBytes = g, vi;
}
var wy;
function bT() {
  if (wy)
    return wc;
  wy = 1, Object.defineProperty(wc, "__esModule", { value: !0 }), wc.computeHmac = void 0;
  const e = nf(), t = wt();
  let r = !1;
  const n = function(a, f, d) {
    return (0, e.createHmac)(a, f).update(d).digest();
  };
  let s = n;
  function i(a, f, d) {
    const c = (0, t.getBytes)(f, "key"), p = (0, t.getBytes)(d, "data");
    return (0, t.hexlify)(s(a, c, p));
  }
  return wc.computeHmac = i, i._ = n, i.lock = function() {
    r = !0;
  }, i.register = function(a) {
    if (r)
      throw new Error("computeHmac is locked");
    s = a;
  }, Object.freeze(i), wc;
}
var Ac = {}, Er = {}, vy;
function wT() {
  if (vy)
    return Er;
  vy = 1, Object.defineProperty(Er, "__esModule", { value: !0 }), Er.shake256 = Er.shake128 = Er.keccak_512 = Er.keccak_384 = Er.keccak_256 = Er.keccak_224 = Er.sha3_512 = Er.sha3_384 = Er.sha3_256 = Er.sha3_224 = Er.Keccak = Er.keccakP = void 0;
  const e = fd(), t = R5(), r = vs(), [n, s, i] = [[], [], []], a = /* @__PURE__ */ BigInt(0), f = /* @__PURE__ */ BigInt(1), d = /* @__PURE__ */ BigInt(2), c = /* @__PURE__ */ BigInt(7), p = /* @__PURE__ */ BigInt(256), g = /* @__PURE__ */ BigInt(113);
  for (let A = 0, R = f, L = 1, K = 0; A < 24; A++) {
    [L, K] = [K, (2 * L + 3 * K) % 5], n.push(2 * (5 * K + L)), s.push((A + 1) * (A + 2) / 2 % 64);
    let $ = a;
    for (let k = 0; k < 7; k++)
      R = (R << f ^ (R >> c) * g) % p, R & d && ($ ^= f << (f << /* @__PURE__ */ BigInt(k)) - f);
    i.push($);
  }
  const [v, O] = /* @__PURE__ */ (0, t.split)(i, !0), N = (A, R, L) => L > 32 ? (0, t.rotlBH)(A, R, L) : (0, t.rotlSH)(A, R, L), S = (A, R, L) => L > 32 ? (0, t.rotlBL)(A, R, L) : (0, t.rotlSL)(A, R, L);
  function j(A, R = 24) {
    const L = new Uint32Array(10);
    for (let K = 24 - R; K < 24; K++) {
      for (let V = 0; V < 10; V++)
        L[V] = A[V] ^ A[V + 10] ^ A[V + 20] ^ A[V + 30] ^ A[V + 40];
      for (let V = 0; V < 10; V += 2) {
        const C = (V + 8) % 10, D = (V + 2) % 10, o = L[D], u = L[D + 1], h = N(o, u, 1) ^ L[C], y = S(o, u, 1) ^ L[C + 1];
        for (let E = 0; E < 50; E += 10)
          A[V + E] ^= h, A[V + E + 1] ^= y;
      }
      let $ = A[2], k = A[3];
      for (let V = 0; V < 24; V++) {
        const C = s[V], D = N($, k, C), o = S($, k, C), u = n[V];
        $ = A[u], k = A[u + 1], A[u] = D, A[u + 1] = o;
      }
      for (let V = 0; V < 50; V += 10) {
        for (let C = 0; C < 10; C++)
          L[C] = A[V + C];
        for (let C = 0; C < 10; C++)
          A[V + C] ^= ~L[(C + 2) % 10] & L[(C + 4) % 10];
      }
      A[0] ^= v[K], A[1] ^= O[K];
    }
    L.fill(0);
  }
  Er.keccakP = j;
  class B extends r.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(R, L, K, $ = !1, k = 24) {
      if (super(), this.blockLen = R, this.suffix = L, this.outputLen = K, this.enableXOF = $, this.rounds = k, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, e.number)(K), 0 >= this.blockLen || this.blockLen >= 200)
        throw new Error("Sha3 supports only keccak-f1600 function");
      this.state = new Uint8Array(200), this.state32 = (0, r.u32)(this.state);
    }
    keccak() {
      j(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
    }
    update(R) {
      (0, e.exists)(this);
      const { blockLen: L, state: K } = this;
      R = (0, r.toBytes)(R);
      const $ = R.length;
      for (let k = 0; k < $; ) {
        const V = Math.min(L - this.pos, $ - k);
        for (let C = 0; C < V; C++)
          K[this.pos++] ^= R[k++];
        this.pos === L && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = !0;
      const { state: R, suffix: L, pos: K, blockLen: $ } = this;
      R[K] ^= L, L & 128 && K === $ - 1 && this.keccak(), R[$ - 1] ^= 128, this.keccak();
    }
    writeInto(R) {
      (0, e.exists)(this, !1), (0, e.bytes)(R), this.finish();
      const L = this.state, { blockLen: K } = this;
      for (let $ = 0, k = R.length; $ < k; ) {
        this.posOut >= K && this.keccak();
        const V = Math.min(K - this.posOut, k - $);
        R.set(L.subarray(this.posOut, this.posOut + V), $), this.posOut += V, $ += V;
      }
      return R;
    }
    xofInto(R) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(R);
    }
    xof(R) {
      return (0, e.number)(R), this.xofInto(new Uint8Array(R));
    }
    digestInto(R) {
      if ((0, e.output)(R, this), this.finished)
        throw new Error("digest() was already called");
      return this.writeInto(R), this.destroy(), R;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(R) {
      const { blockLen: L, suffix: K, outputLen: $, rounds: k, enableXOF: V } = this;
      return R || (R = new B(L, K, $, V, k)), R.state32.set(this.state32), R.pos = this.pos, R.posOut = this.posOut, R.finished = this.finished, R.rounds = k, R.suffix = K, R.outputLen = $, R.enableXOF = V, R.destroyed = this.destroyed, R;
    }
  }
  Er.Keccak = B;
  const M = (A, R, L) => (0, r.wrapConstructor)(() => new B(R, A, L));
  Er.sha3_224 = M(6, 144, 224 / 8), Er.sha3_256 = M(6, 136, 256 / 8), Er.sha3_384 = M(6, 104, 384 / 8), Er.sha3_512 = M(6, 72, 512 / 8), Er.keccak_224 = M(1, 144, 224 / 8), Er.keccak_256 = M(1, 136, 256 / 8), Er.keccak_384 = M(1, 104, 384 / 8), Er.keccak_512 = M(1, 72, 512 / 8);
  const I = (A, R, L) => (0, r.wrapXOFConstructorWithOpts)((K = {}) => new B(R, A, K.dkLen === void 0 ? L : K.dkLen, !0));
  return Er.shake128 = I(31, 168, 128 / 8), Er.shake256 = I(31, 136, 256 / 8), Er;
}
var Ay;
function vT() {
  if (Ay)
    return Ac;
  Ay = 1, Object.defineProperty(Ac, "__esModule", { value: !0 }), Ac.keccak256 = void 0;
  const e = wT(), t = wt();
  let r = !1;
  const n = function(a) {
    return (0, e.keccak_256)(a);
  };
  let s = n;
  function i(a) {
    const f = (0, t.getBytes)(a, "data");
    return (0, t.hexlify)(s(f));
  }
  return Ac.keccak256 = i, i._ = n, i.lock = function() {
    r = !0;
  }, i.register = function(a) {
    if (r)
      throw new TypeError("keccak256 is locked");
    s = a;
  }, Object.freeze(i), Ac;
}
var Ec = {}, Vo = {}, Ey;
function AT() {
  if (Ey)
    return Vo;
  Ey = 1, Object.defineProperty(Vo, "__esModule", { value: !0 }), Vo.ripemd160 = Vo.RIPEMD160 = void 0;
  const e = E1(), t = vs(), r = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), n = /* @__PURE__ */ Uint8Array.from({ length: 16 }, (j, B) => B), s = /* @__PURE__ */ n.map((j) => (9 * j + 5) % 16);
  let i = [n], a = [s];
  for (let j = 0; j < 4; j++)
    for (let B of [i, a])
      B.push(B[j].map((M) => r[M]));
  const f = /* @__PURE__ */ [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
  ].map((j) => new Uint8Array(j)), d = /* @__PURE__ */ i.map((j, B) => j.map((M) => f[B][M])), c = /* @__PURE__ */ a.map((j, B) => j.map((M) => f[B][M])), p = /* @__PURE__ */ new Uint32Array([
    0,
    1518500249,
    1859775393,
    2400959708,
    2840853838
  ]), g = /* @__PURE__ */ new Uint32Array([
    1352829926,
    1548603684,
    1836072691,
    2053994217,
    0
  ]), v = (j, B) => j << B | j >>> 32 - B;
  function O(j, B, M, I) {
    return j === 0 ? B ^ M ^ I : j === 1 ? B & M | ~B & I : j === 2 ? (B | ~M) ^ I : j === 3 ? B & I | M & ~I : B ^ (M | ~I);
  }
  const N = /* @__PURE__ */ new Uint32Array(16);
  class S extends e.SHA2 {
    constructor() {
      super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
    }
    get() {
      const { h0: B, h1: M, h2: I, h3: A, h4: R } = this;
      return [B, M, I, A, R];
    }
    set(B, M, I, A, R) {
      this.h0 = B | 0, this.h1 = M | 0, this.h2 = I | 0, this.h3 = A | 0, this.h4 = R | 0;
    }
    process(B, M) {
      for (let o = 0; o < 16; o++, M += 4)
        N[o] = B.getUint32(M, !0);
      let I = this.h0 | 0, A = I, R = this.h1 | 0, L = R, K = this.h2 | 0, $ = K, k = this.h3 | 0, V = k, C = this.h4 | 0, D = C;
      for (let o = 0; o < 5; o++) {
        const u = 4 - o, h = p[o], y = g[o], E = i[o], P = a[o], w = d[o], m = c[o];
        for (let l = 0; l < 16; l++) {
          const b = v(I + O(o, R, K, k) + N[E[l]] + h, w[l]) + C | 0;
          I = C, C = k, k = v(K, 10) | 0, K = R, R = b;
        }
        for (let l = 0; l < 16; l++) {
          const b = v(A + O(u, L, $, V) + N[P[l]] + y, m[l]) + D | 0;
          A = D, D = V, V = v($, 10) | 0, $ = L, L = b;
        }
      }
      this.set(this.h1 + K + V | 0, this.h2 + k + D | 0, this.h3 + C + A | 0, this.h4 + I + L | 0, this.h0 + R + $ | 0);
    }
    roundClean() {
      N.fill(0);
    }
    destroy() {
      this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
    }
  }
  return Vo.RIPEMD160 = S, Vo.ripemd160 = (0, t.wrapConstructor)(() => new S()), Vo;
}
var Py;
function ET() {
  if (Py)
    return Ec;
  Py = 1, Object.defineProperty(Ec, "__esModule", { value: !0 }), Ec.ripemd160 = void 0;
  const e = AT(), t = wt();
  let r = !1;
  const n = function(a) {
    return (0, e.ripemd160)(a);
  };
  let s = n;
  function i(a) {
    const f = (0, t.getBytes)(a, "data");
    return (0, t.hexlify)(s(f));
  }
  return Ec.ripemd160 = i, i._ = n, i.lock = function() {
    r = !0;
  }, i.register = function(a) {
    if (r)
      throw new TypeError("ripemd160 is locked");
    s = a;
  }, Object.freeze(i), Ec;
}
var Pc = {}, Oy;
function PT() {
  if (Oy)
    return Pc;
  Oy = 1, Object.defineProperty(Pc, "__esModule", { value: !0 }), Pc.pbkdf2 = void 0;
  const e = nf(), t = wt();
  let r = !1;
  const n = function(a, f, d, c, p) {
    return (0, e.pbkdf2Sync)(a, f, d, c, p);
  };
  let s = n;
  function i(a, f, d, c, p) {
    const g = (0, t.getBytes)(a, "password"), v = (0, t.getBytes)(f, "salt");
    return (0, t.hexlify)(s(g, v, d, c, p));
  }
  return Pc.pbkdf2 = i, i._ = n, i.lock = function() {
    r = !0;
  }, i.register = function(a) {
    if (r)
      throw new Error("pbkdf2 is locked");
    s = a;
  }, Object.freeze(i), Pc;
}
var Oc = {}, Ny;
function OT() {
  if (Ny)
    return Oc;
  Ny = 1, Object.defineProperty(Oc, "__esModule", { value: !0 }), Oc.randomBytes = void 0;
  const e = nf();
  let t = !1;
  const r = function(i) {
    return new Uint8Array((0, e.randomBytes)(i));
  };
  let n = r;
  function s(i) {
    return n(i);
  }
  return Oc.randomBytes = s, s._ = r, s.lock = function() {
    t = !0;
  }, s.register = function(i) {
    if (t)
      throw new Error("randomBytes is locked");
    n = i;
  }, Object.freeze(s), Oc;
}
var qo = {}, $o = {}, xy;
function NT() {
  if (xy)
    return $o;
  xy = 1, Object.defineProperty($o, "__esModule", { value: !0 }), $o.scryptAsync = $o.scrypt = void 0;
  const e = fd(), t = P1(), r = I5(), n = vs(), s = (g, v) => g << v | g >>> 32 - v;
  function i(g, v, O, N, S, j) {
    let B = g[v++] ^ O[N++], M = g[v++] ^ O[N++], I = g[v++] ^ O[N++], A = g[v++] ^ O[N++], R = g[v++] ^ O[N++], L = g[v++] ^ O[N++], K = g[v++] ^ O[N++], $ = g[v++] ^ O[N++], k = g[v++] ^ O[N++], V = g[v++] ^ O[N++], C = g[v++] ^ O[N++], D = g[v++] ^ O[N++], o = g[v++] ^ O[N++], u = g[v++] ^ O[N++], h = g[v++] ^ O[N++], y = g[v++] ^ O[N++], E = B, P = M, w = I, m = A, l = R, b = L, W = K, X = $, G = k, re = V, ce = C, pe = D, ve = o, Ee = u, Pe = h, xe = y;
    for (let me = 0; me < 8; me += 2)
      l ^= s(E + ve | 0, 7), G ^= s(l + E | 0, 9), ve ^= s(G + l | 0, 13), E ^= s(ve + G | 0, 18), re ^= s(b + P | 0, 7), Ee ^= s(re + b | 0, 9), P ^= s(Ee + re | 0, 13), b ^= s(P + Ee | 0, 18), Pe ^= s(ce + W | 0, 7), w ^= s(Pe + ce | 0, 9), W ^= s(w + Pe | 0, 13), ce ^= s(W + w | 0, 18), m ^= s(xe + pe | 0, 7), X ^= s(m + xe | 0, 9), pe ^= s(X + m | 0, 13), xe ^= s(pe + X | 0, 18), P ^= s(E + m | 0, 7), w ^= s(P + E | 0, 9), m ^= s(w + P | 0, 13), E ^= s(m + w | 0, 18), W ^= s(b + l | 0, 7), X ^= s(W + b | 0, 9), l ^= s(X + W | 0, 13), b ^= s(l + X | 0, 18), pe ^= s(ce + re | 0, 7), G ^= s(pe + ce | 0, 9), re ^= s(G + pe | 0, 13), ce ^= s(re + G | 0, 18), ve ^= s(xe + Pe | 0, 7), Ee ^= s(ve + xe | 0, 9), Pe ^= s(Ee + ve | 0, 13), xe ^= s(Pe + Ee | 0, 18);
    S[j++] = B + E | 0, S[j++] = M + P | 0, S[j++] = I + w | 0, S[j++] = A + m | 0, S[j++] = R + l | 0, S[j++] = L + b | 0, S[j++] = K + W | 0, S[j++] = $ + X | 0, S[j++] = k + G | 0, S[j++] = V + re | 0, S[j++] = C + ce | 0, S[j++] = D + pe | 0, S[j++] = o + ve | 0, S[j++] = u + Ee | 0, S[j++] = h + Pe | 0, S[j++] = y + xe | 0;
  }
  function a(g, v, O, N, S) {
    let j = N + 0, B = N + 16 * S;
    for (let M = 0; M < 16; M++)
      O[B + M] = g[v + (2 * S - 1) * 16 + M];
    for (let M = 0; M < S; M++, j += 16, v += 16)
      i(O, B, g, v, O, j), M > 0 && (B += 16), i(O, j, g, v += 16, O, B);
  }
  function f(g, v, O) {
    const N = (0, n.checkOpts)({
      dkLen: 32,
      asyncTick: 10,
      maxmem: 1073742848
    }, O), { N: S, r: j, p: B, dkLen: M, asyncTick: I, maxmem: A, onProgress: R } = N;
    if ((0, e.number)(S), (0, e.number)(j), (0, e.number)(B), (0, e.number)(M), (0, e.number)(I), (0, e.number)(A), R !== void 0 && typeof R != "function")
      throw new Error("progressCb should be function");
    const L = 128 * j, K = L / 4;
    if (S <= 1 || S & S - 1 || S >= 2 ** (L / 8) || S > 2 ** 32)
      throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (B < 0 || B > (2 ** 32 - 1) * 32 / L)
      throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (M < 0 || M > (2 ** 32 - 1) * 32)
      throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const $ = L * (S + B);
    if ($ > A)
      throw new Error(`Scrypt: parameters too large, ${$} (128 * r * (N + p)) > ${A} (maxmem)`);
    const k = (0, r.pbkdf2)(t.sha256, g, v, { c: 1, dkLen: L * B }), V = (0, n.u32)(k), C = (0, n.u32)(new Uint8Array(L * S)), D = (0, n.u32)(new Uint8Array(L));
    let o = () => {
    };
    if (R) {
      const u = 2 * S * B, h = Math.max(Math.floor(u / 1e4), 1);
      let y = 0;
      o = () => {
        y++, R && (!(y % h) || y === u) && R(y / u);
      };
    }
    return { N: S, r: j, p: B, dkLen: M, blockSize32: K, V: C, B32: V, B: k, tmp: D, blockMixCb: o, asyncTick: I };
  }
  function d(g, v, O, N, S) {
    const j = (0, r.pbkdf2)(t.sha256, g, O, { c: 1, dkLen: v });
    return O.fill(0), N.fill(0), S.fill(0), j;
  }
  function c(g, v, O) {
    const { N, r: S, p: j, dkLen: B, blockSize32: M, V: I, B32: A, B: R, tmp: L, blockMixCb: K } = f(g, v, O);
    for (let $ = 0; $ < j; $++) {
      const k = M * $;
      for (let V = 0; V < M; V++)
        I[V] = A[k + V];
      for (let V = 0, C = 0; V < N - 1; V++)
        a(I, C, I, C += M, S), K();
      a(I, (N - 1) * M, A, k, S), K();
      for (let V = 0; V < N; V++) {
        const C = A[k + M - 16] % N;
        for (let D = 0; D < M; D++)
          L[D] = A[k + D] ^ I[C * M + D];
        a(L, 0, A, k, S), K();
      }
    }
    return d(g, B, R, I, L);
  }
  $o.scrypt = c;
  async function p(g, v, O) {
    const { N, r: S, p: j, dkLen: B, blockSize32: M, V: I, B32: A, B: R, tmp: L, blockMixCb: K, asyncTick: $ } = f(g, v, O);
    for (let k = 0; k < j; k++) {
      const V = M * k;
      for (let D = 0; D < M; D++)
        I[D] = A[V + D];
      let C = 0;
      await (0, n.asyncLoop)(N - 1, $, () => {
        a(I, C, I, C += M, S), K();
      }), a(I, (N - 1) * M, A, V, S), K(), await (0, n.asyncLoop)(N, $, () => {
        const D = A[V + M - 16] % N;
        for (let o = 0; o < M; o++)
          L[o] = A[V + o] ^ I[D * M + o];
        a(L, 0, A, V, S), K();
      });
    }
    return d(g, B, R, I, L);
  }
  return $o.scryptAsync = p, $o;
}
var Ty;
function xT() {
  if (Ty)
    return qo;
  Ty = 1, Object.defineProperty(qo, "__esModule", { value: !0 }), qo.scryptSync = qo.scrypt = void 0;
  const e = NT(), t = wt();
  let r = !1, n = !1;
  const s = async function(p, g, v, O, N, S, j) {
    return await (0, e.scryptAsync)(p, g, { N: v, r: O, p: N, dkLen: S, onProgress: j });
  }, i = function(p, g, v, O, N, S) {
    return (0, e.scrypt)(p, g, { N: v, r: O, p: N, dkLen: S });
  };
  let a = s, f = i;
  async function d(p, g, v, O, N, S, j) {
    const B = (0, t.getBytes)(p, "passwd"), M = (0, t.getBytes)(g, "salt");
    return (0, t.hexlify)(await a(B, M, v, O, N, S, j));
  }
  qo.scrypt = d, d._ = s, d.lock = function() {
    n = !0;
  }, d.register = function(p) {
    if (n)
      throw new Error("scrypt is locked");
    a = p;
  }, Object.freeze(d);
  function c(p, g, v, O, N, S) {
    const j = (0, t.getBytes)(p, "passwd"), B = (0, t.getBytes)(g, "salt");
    return (0, t.hexlify)(f(j, B, v, O, N, S));
  }
  return qo.scryptSync = c, c._ = i, c.lock = function() {
    r = !0;
  }, c.register = function(p) {
    if (r)
      throw new Error("scryptSync is locked");
    f = p;
  }, Object.freeze(c), qo;
}
var Ko = {}, ky;
function TT() {
  if (ky)
    return Ko;
  ky = 1, Object.defineProperty(Ko, "__esModule", { value: !0 }), Ko.sha512 = Ko.sha256 = void 0;
  const e = nf(), t = wt(), r = function(p) {
    return (0, e.createHash)("sha256").update(p).digest();
  }, n = function(p) {
    return (0, e.createHash)("sha512").update(p).digest();
  };
  let s = r, i = n, a = !1, f = !1;
  function d(p) {
    const g = (0, t.getBytes)(p, "data");
    return (0, t.hexlify)(s(g));
  }
  Ko.sha256 = d, d._ = r, d.lock = function() {
    a = !0;
  }, d.register = function(p) {
    if (a)
      throw new Error("sha256 is locked");
    s = p;
  }, Object.freeze(d);
  function c(p) {
    const g = (0, t.getBytes)(p, "data");
    return (0, t.hexlify)(i(g));
  }
  return Ko.sha512 = c, c._ = n, c.lock = function() {
    f = !0;
  }, c.register = function(p) {
    if (f)
      throw new Error("sha512 is locked");
    i = p;
  }, Object.freeze(d), Ko;
}
var Nc = {}, Sy = {}, Qt = {}, tr = {}, My;
function Yu() {
  if (My)
    return tr;
  My = 1, Object.defineProperty(tr, "__esModule", { value: !0 }), tr.validateObject = tr.createHmacDrbg = tr.bitMask = tr.bitSet = tr.bitGet = tr.bitLen = tr.utf8ToBytes = tr.equalBytes = tr.concatBytes = tr.ensureBytes = tr.numberToVarBytesBE = tr.numberToBytesLE = tr.numberToBytesBE = tr.bytesToNumberLE = tr.bytesToNumberBE = tr.hexToBytes = tr.hexToNumber = tr.numberToHexUnpadded = tr.bytesToHex = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const e = BigInt(0), t = BigInt(1), r = BigInt(2), n = (C) => C instanceof Uint8Array, s = /* @__PURE__ */ Array.from({ length: 256 }, (C, D) => D.toString(16).padStart(2, "0"));
  function i(C) {
    if (!n(C))
      throw new Error("Uint8Array expected");
    let D = "";
    for (let o = 0; o < C.length; o++)
      D += s[C[o]];
    return D;
  }
  tr.bytesToHex = i;
  function a(C) {
    const D = C.toString(16);
    return D.length & 1 ? `0${D}` : D;
  }
  tr.numberToHexUnpadded = a;
  function f(C) {
    if (typeof C != "string")
      throw new Error("hex string expected, got " + typeof C);
    return BigInt(C === "" ? "0" : `0x${C}`);
  }
  tr.hexToNumber = f;
  function d(C) {
    if (typeof C != "string")
      throw new Error("hex string expected, got " + typeof C);
    const D = C.length;
    if (D % 2)
      throw new Error("padded hex string expected, got unpadded hex of length " + D);
    const o = new Uint8Array(D / 2);
    for (let u = 0; u < o.length; u++) {
      const h = u * 2, y = C.slice(h, h + 2), E = Number.parseInt(y, 16);
      if (Number.isNaN(E) || E < 0)
        throw new Error("Invalid byte sequence");
      o[u] = E;
    }
    return o;
  }
  tr.hexToBytes = d;
  function c(C) {
    return f(i(C));
  }
  tr.bytesToNumberBE = c;
  function p(C) {
    if (!n(C))
      throw new Error("Uint8Array expected");
    return f(i(Uint8Array.from(C).reverse()));
  }
  tr.bytesToNumberLE = p;
  function g(C, D) {
    return d(C.toString(16).padStart(D * 2, "0"));
  }
  tr.numberToBytesBE = g;
  function v(C, D) {
    return g(C, D).reverse();
  }
  tr.numberToBytesLE = v;
  function O(C) {
    return d(a(C));
  }
  tr.numberToVarBytesBE = O;
  function N(C, D, o) {
    let u;
    if (typeof D == "string")
      try {
        u = d(D);
      } catch (y) {
        throw new Error(`${C} must be valid hex string, got "${D}". Cause: ${y}`);
      }
    else if (n(D))
      u = Uint8Array.from(D);
    else
      throw new Error(`${C} must be hex string or Uint8Array`);
    const h = u.length;
    if (typeof o == "number" && h !== o)
      throw new Error(`${C} expected ${o} bytes, got ${h}`);
    return u;
  }
  tr.ensureBytes = N;
  function S(...C) {
    const D = new Uint8Array(C.reduce((u, h) => u + h.length, 0));
    let o = 0;
    return C.forEach((u) => {
      if (!n(u))
        throw new Error("Uint8Array expected");
      D.set(u, o), o += u.length;
    }), D;
  }
  tr.concatBytes = S;
  function j(C, D) {
    if (C.length !== D.length)
      return !1;
    for (let o = 0; o < C.length; o++)
      if (C[o] !== D[o])
        return !1;
    return !0;
  }
  tr.equalBytes = j;
  function B(C) {
    if (typeof C != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof C}`);
    return new Uint8Array(new TextEncoder().encode(C));
  }
  tr.utf8ToBytes = B;
  function M(C) {
    let D;
    for (D = 0; C > e; C >>= t, D += 1)
      ;
    return D;
  }
  tr.bitLen = M;
  function I(C, D) {
    return C >> BigInt(D) & t;
  }
  tr.bitGet = I;
  const A = (C, D, o) => C | (o ? t : e) << BigInt(D);
  tr.bitSet = A;
  const R = (C) => (r << BigInt(C - 1)) - t;
  tr.bitMask = R;
  const L = (C) => new Uint8Array(C), K = (C) => Uint8Array.from(C);
  function $(C, D, o) {
    if (typeof C != "number" || C < 2)
      throw new Error("hashLen must be a number");
    if (typeof D != "number" || D < 2)
      throw new Error("qByteLen must be a number");
    if (typeof o != "function")
      throw new Error("hmacFn must be a function");
    let u = L(C), h = L(C), y = 0;
    const E = () => {
      u.fill(1), h.fill(0), y = 0;
    }, P = (...l) => o(h, u, ...l), w = (l = L()) => {
      h = P(K([0]), l), u = P(), l.length !== 0 && (h = P(K([1]), l), u = P());
    }, m = () => {
      if (y++ >= 1e3)
        throw new Error("drbg: tried 1000 values");
      let l = 0;
      const b = [];
      for (; l < D; ) {
        u = P();
        const W = u.slice();
        b.push(W), l += u.length;
      }
      return S(...b);
    };
    return (l, b) => {
      E(), w(l);
      let W;
      for (; !(W = b(m())); )
        w();
      return E(), W;
    };
  }
  tr.createHmacDrbg = $;
  const k = {
    bigint: (C) => typeof C == "bigint",
    function: (C) => typeof C == "function",
    boolean: (C) => typeof C == "boolean",
    string: (C) => typeof C == "string",
    stringOrUint8Array: (C) => typeof C == "string" || C instanceof Uint8Array,
    isSafeInteger: (C) => Number.isSafeInteger(C),
    array: (C) => Array.isArray(C),
    field: (C, D) => D.Fp.isValid(C),
    hash: (C) => typeof C == "function" && Number.isSafeInteger(C.outputLen)
  };
  function V(C, D, o = {}) {
    const u = (h, y, E) => {
      const P = k[y];
      if (typeof P != "function")
        throw new Error(`Invalid validator "${y}", expected function`);
      const w = C[h];
      if (!(E && w === void 0) && !P(w, C))
        throw new Error(`Invalid param ${String(h)}=${w} (${typeof w}), expected ${y}`);
    };
    for (const [h, y] of Object.entries(D))
      u(h, y, !1);
    for (const [h, y] of Object.entries(o))
      u(h, y, !0);
    return C;
  }
  return tr.validateObject = V, tr;
}
var Iy;
function sf() {
  if (Iy)
    return Qt;
  Iy = 1, Object.defineProperty(Qt, "__esModule", { value: !0 }), Qt.mapHashToField = Qt.getMinHashLength = Qt.getFieldBytesLength = Qt.hashToPrivateScalar = Qt.FpSqrtEven = Qt.FpSqrtOdd = Qt.Field = Qt.nLength = Qt.FpIsSquare = Qt.FpDiv = Qt.FpInvertBatch = Qt.FpPow = Qt.validateField = Qt.isNegativeLE = Qt.FpSqrt = Qt.tonelliShanks = Qt.invert = Qt.pow2 = Qt.pow = Qt.mod = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const e = Yu(), t = BigInt(0), r = BigInt(1), n = BigInt(2), s = BigInt(3), i = BigInt(4), a = BigInt(5), f = BigInt(8);
  BigInt(9), BigInt(16);
  function d(o, u) {
    const h = o % u;
    return h >= t ? h : u + h;
  }
  Qt.mod = d;
  function c(o, u, h) {
    if (h <= t || u < t)
      throw new Error("Expected power/modulo > 0");
    if (h === r)
      return t;
    let y = r;
    for (; u > t; )
      u & r && (y = y * o % h), o = o * o % h, u >>= r;
    return y;
  }
  Qt.pow = c;
  function p(o, u, h) {
    let y = o;
    for (; u-- > t; )
      y *= y, y %= h;
    return y;
  }
  Qt.pow2 = p;
  function g(o, u) {
    if (o === t || u <= t)
      throw new Error(`invert: expected positive integers, got n=${o} mod=${u}`);
    let h = d(o, u), y = u, E = t, P = r;
    for (; h !== t; ) {
      const w = y / h, m = y % h, l = E - P * w;
      y = h, h = m, E = P, P = l;
    }
    if (y !== r)
      throw new Error("invert: does not exist");
    return d(E, u);
  }
  Qt.invert = g;
  function v(o) {
    const u = (o - r) / n;
    let h, y, E;
    for (h = o - r, y = 0; h % n === t; h /= n, y++)
      ;
    for (E = n; E < o && c(E, u, o) !== o - r; E++)
      ;
    if (y === 1) {
      const w = (o + r) / i;
      return function(m, l) {
        const b = m.pow(l, w);
        if (!m.eql(m.sqr(b), l))
          throw new Error("Cannot find square root");
        return b;
      };
    }
    const P = (h + r) / n;
    return function(w, m) {
      if (w.pow(m, u) === w.neg(w.ONE))
        throw new Error("Cannot find square root");
      let l = y, b = w.pow(w.mul(w.ONE, E), h), W = w.pow(m, P), X = w.pow(m, h);
      for (; !w.eql(X, w.ONE); ) {
        if (w.eql(X, w.ZERO))
          return w.ZERO;
        let G = 1;
        for (let ce = w.sqr(X); G < l && !w.eql(ce, w.ONE); G++)
          ce = w.sqr(ce);
        const re = w.pow(b, r << BigInt(l - G - 1));
        b = w.sqr(re), W = w.mul(W, re), X = w.mul(X, b), l = G;
      }
      return W;
    };
  }
  Qt.tonelliShanks = v;
  function O(o) {
    if (o % i === s) {
      const u = (o + r) / i;
      return function(h, y) {
        const E = h.pow(y, u);
        if (!h.eql(h.sqr(E), y))
          throw new Error("Cannot find square root");
        return E;
      };
    }
    if (o % f === a) {
      const u = (o - a) / f;
      return function(h, y) {
        const E = h.mul(y, n), P = h.pow(E, u), w = h.mul(y, P), m = h.mul(h.mul(w, n), P), l = h.mul(w, h.sub(m, h.ONE));
        if (!h.eql(h.sqr(l), y))
          throw new Error("Cannot find square root");
        return l;
      };
    }
    return v(o);
  }
  Qt.FpSqrt = O;
  const N = (o, u) => (d(o, u) & r) === r;
  Qt.isNegativeLE = N;
  const S = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function j(o) {
    const u = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "isSafeInteger",
      BITS: "isSafeInteger"
    }, h = S.reduce((y, E) => (y[E] = "function", y), u);
    return (0, e.validateObject)(o, h);
  }
  Qt.validateField = j;
  function B(o, u, h) {
    if (h < t)
      throw new Error("Expected power > 0");
    if (h === t)
      return o.ONE;
    if (h === r)
      return u;
    let y = o.ONE, E = u;
    for (; h > t; )
      h & r && (y = o.mul(y, E)), E = o.sqr(E), h >>= r;
    return y;
  }
  Qt.FpPow = B;
  function M(o, u) {
    const h = new Array(u.length), y = u.reduce((P, w, m) => o.is0(w) ? P : (h[m] = P, o.mul(P, w)), o.ONE), E = o.inv(y);
    return u.reduceRight((P, w, m) => o.is0(w) ? P : (h[m] = o.mul(P, h[m]), o.mul(P, w)), E), h;
  }
  Qt.FpInvertBatch = M;
  function I(o, u, h) {
    return o.mul(u, typeof h == "bigint" ? g(h, o.ORDER) : o.inv(h));
  }
  Qt.FpDiv = I;
  function A(o) {
    const u = (o.ORDER - r) / n;
    return (h) => {
      const y = o.pow(h, u);
      return o.eql(y, o.ZERO) || o.eql(y, o.ONE);
    };
  }
  Qt.FpIsSquare = A;
  function R(o, u) {
    const h = u !== void 0 ? u : o.toString(2).length, y = Math.ceil(h / 8);
    return { nBitLength: h, nByteLength: y };
  }
  Qt.nLength = R;
  function L(o, u, h = !1, y = {}) {
    if (o <= t)
      throw new Error(`Expected Field ORDER > 0, got ${o}`);
    const { nBitLength: E, nByteLength: P } = R(o, u);
    if (P > 2048)
      throw new Error("Field lengths over 2048 bytes are not supported");
    const w = O(o), m = Object.freeze({
      ORDER: o,
      BITS: E,
      BYTES: P,
      MASK: (0, e.bitMask)(E),
      ZERO: t,
      ONE: r,
      create: (l) => d(l, o),
      isValid: (l) => {
        if (typeof l != "bigint")
          throw new Error(`Invalid field element: expected bigint, got ${typeof l}`);
        return t <= l && l < o;
      },
      is0: (l) => l === t,
      isOdd: (l) => (l & r) === r,
      neg: (l) => d(-l, o),
      eql: (l, b) => l === b,
      sqr: (l) => d(l * l, o),
      add: (l, b) => d(l + b, o),
      sub: (l, b) => d(l - b, o),
      mul: (l, b) => d(l * b, o),
      pow: (l, b) => B(m, l, b),
      div: (l, b) => d(l * g(b, o), o),
      // Same as above, but doesn't normalize
      sqrN: (l) => l * l,
      addN: (l, b) => l + b,
      subN: (l, b) => l - b,
      mulN: (l, b) => l * b,
      inv: (l) => g(l, o),
      sqrt: y.sqrt || ((l) => w(m, l)),
      invertBatch: (l) => M(m, l),
      // TODO: do we really need constant cmov?
      // We don't have const-time bigints anyway, so probably will be not very useful
      cmov: (l, b, W) => W ? b : l,
      toBytes: (l) => h ? (0, e.numberToBytesLE)(l, P) : (0, e.numberToBytesBE)(l, P),
      fromBytes: (l) => {
        if (l.length !== P)
          throw new Error(`Fp.fromBytes: expected ${P}, got ${l.length}`);
        return h ? (0, e.bytesToNumberLE)(l) : (0, e.bytesToNumberBE)(l);
      }
    });
    return Object.freeze(m);
  }
  Qt.Field = L;
  function K(o, u) {
    if (!o.isOdd)
      throw new Error("Field doesn't have isOdd");
    const h = o.sqrt(u);
    return o.isOdd(h) ? h : o.neg(h);
  }
  Qt.FpSqrtOdd = K;
  function $(o, u) {
    if (!o.isOdd)
      throw new Error("Field doesn't have isOdd");
    const h = o.sqrt(u);
    return o.isOdd(h) ? o.neg(h) : h;
  }
  Qt.FpSqrtEven = $;
  function k(o, u, h = !1) {
    o = (0, e.ensureBytes)("privateHash", o);
    const y = o.length, E = R(u).nByteLength + 8;
    if (E < 24 || y < E || y > 1024)
      throw new Error(`hashToPrivateScalar: expected ${E}-1024 bytes of input, got ${y}`);
    const P = h ? (0, e.bytesToNumberLE)(o) : (0, e.bytesToNumberBE)(o);
    return d(P, u - r) + r;
  }
  Qt.hashToPrivateScalar = k;
  function V(o) {
    if (typeof o != "bigint")
      throw new Error("field order must be bigint");
    const u = o.toString(2).length;
    return Math.ceil(u / 8);
  }
  Qt.getFieldBytesLength = V;
  function C(o) {
    const u = V(o);
    return u + Math.ceil(u / 2);
  }
  Qt.getMinHashLength = C;
  function D(o, u, h = !1) {
    const y = o.length, E = V(u), P = C(u);
    if (y < 16 || y < P || y > 1024)
      throw new Error(`expected ${P}-1024 bytes of input, got ${y}`);
    const w = h ? (0, e.bytesToNumberBE)(o) : (0, e.bytesToNumberLE)(o), m = d(w, u - r) + r;
    return h ? (0, e.numberToBytesLE)(m, E) : (0, e.numberToBytesBE)(m, E);
  }
  return Qt.mapHashToField = D, Qt;
}
var Ry = {}, Jo = {}, Cy;
function kT() {
  if (Cy)
    return Jo;
  Cy = 1, Object.defineProperty(Jo, "__esModule", { value: !0 }), Jo.validateBasic = Jo.wNAF = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const e = sf(), t = Yu(), r = BigInt(0), n = BigInt(1);
  function s(a, f) {
    const d = (p, g) => {
      const v = g.negate();
      return p ? v : g;
    }, c = (p) => {
      const g = Math.ceil(f / p) + 1, v = 2 ** (p - 1);
      return { windows: g, windowSize: v };
    };
    return {
      constTimeNegate: d,
      // non-const time multiplication ladder
      unsafeLadder(p, g) {
        let v = a.ZERO, O = p;
        for (; g > r; )
          g & n && (v = v.add(O)), O = O.double(), g >>= n;
        return v;
      },
      /**
       * Creates a wNAF precomputation window. Used for caching.
       * Default window size is set by `utils.precompute()` and is equal to 8.
       * Number of precomputed points depends on the curve size:
       * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
       * - 𝑊 is the window size
       * - 𝑛 is the bitlength of the curve order.
       * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
       * @returns precomputed point tables flattened to a single array
       */
      precomputeWindow(p, g) {
        const { windows: v, windowSize: O } = c(g), N = [];
        let S = p, j = S;
        for (let B = 0; B < v; B++) {
          j = S, N.push(j);
          for (let M = 1; M < O; M++)
            j = j.add(S), N.push(j);
          S = j.double();
        }
        return N;
      },
      /**
       * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
       * @param W window size
       * @param precomputes precomputed tables
       * @param n scalar (we don't check here, but should be less than curve order)
       * @returns real and fake (for const-time) points
       */
      wNAF(p, g, v) {
        const { windows: O, windowSize: N } = c(p);
        let S = a.ZERO, j = a.BASE;
        const B = BigInt(2 ** p - 1), M = 2 ** p, I = BigInt(p);
        for (let A = 0; A < O; A++) {
          const R = A * N;
          let L = Number(v & B);
          v >>= I, L > N && (L -= M, v += n);
          const K = R, $ = R + Math.abs(L) - 1, k = A % 2 !== 0, V = L < 0;
          L === 0 ? j = j.add(d(k, g[K])) : S = S.add(d(V, g[$]));
        }
        return { p: S, f: j };
      },
      wNAFCached(p, g, v, O) {
        const N = p._WINDOW_SIZE || 1;
        let S = g.get(p);
        return S || (S = this.precomputeWindow(p, N), N !== 1 && g.set(p, O(S))), this.wNAF(N, S, v);
      }
    };
  }
  Jo.wNAF = s;
  function i(a) {
    return (0, e.validateField)(a.Fp), (0, t.validateObject)(a, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...(0, e.nLength)(a.n, a.nBitLength),
      ...a,
      p: a.Fp.ORDER
    });
  }
  return Jo.validateBasic = i, Jo;
}
var By;
function C5() {
  return By || (By = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.mapToCurveSimpleSWU = e.SWUFpSqrtRatio = e.weierstrass = e.weierstrassPoints = e.DER = void 0;
    /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    const t = sf(), r = Yu(), n = Yu(), s = kT();
    function i(M) {
      const I = (0, s.validateBasic)(M);
      r.validateObject(I, {
        a: "field",
        b: "field"
      }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
      });
      const { endo: A, Fp: R, a: L } = I;
      if (A) {
        if (!R.eql(L, R.ZERO))
          throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof A != "object" || typeof A.beta != "bigint" || typeof A.splitScalar != "function")
          throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
      }
      return Object.freeze({ ...I });
    }
    const { bytesToNumberBE: a, hexToBytes: f } = r;
    e.DER = {
      // asn.1 DER encoding utils
      Err: class extends Error {
        constructor(M = "") {
          super(M);
        }
      },
      _parseInt(M) {
        const { Err: I } = e.DER;
        if (M.length < 2 || M[0] !== 2)
          throw new I("Invalid signature integer tag");
        const A = M[1], R = M.subarray(2, A + 2);
        if (!A || R.length !== A)
          throw new I("Invalid signature integer: wrong length");
        if (R[0] & 128)
          throw new I("Invalid signature integer: negative");
        if (R[0] === 0 && !(R[1] & 128))
          throw new I("Invalid signature integer: unnecessary leading zero");
        return { d: a(R), l: M.subarray(A + 2) };
      },
      toSig(M) {
        const { Err: I } = e.DER, A = typeof M == "string" ? f(M) : M;
        if (!(A instanceof Uint8Array))
          throw new Error("ui8a expected");
        let R = A.length;
        if (R < 2 || A[0] != 48)
          throw new I("Invalid signature tag");
        if (A[1] !== R - 2)
          throw new I("Invalid signature: incorrect length");
        const { d: L, l: K } = e.DER._parseInt(A.subarray(2)), { d: $, l: k } = e.DER._parseInt(K);
        if (k.length)
          throw new I("Invalid signature: left bytes after parsing");
        return { r: L, s: $ };
      },
      hexFromSig(M) {
        const I = (C) => Number.parseInt(C[0], 16) & 8 ? "00" + C : C, A = (C) => {
          const D = C.toString(16);
          return D.length & 1 ? `0${D}` : D;
        }, R = I(A(M.s)), L = I(A(M.r)), K = R.length / 2, $ = L.length / 2, k = A(K), V = A($);
        return `30${A($ + K + 4)}02${V}${L}02${k}${R}`;
      }
    };
    const d = BigInt(0), c = BigInt(1), p = BigInt(2), g = BigInt(3), v = BigInt(4);
    function O(M) {
      const I = i(M), { Fp: A } = I, R = I.toBytes || ((y, E, P) => {
        const w = E.toAffine();
        return r.concatBytes(Uint8Array.from([4]), A.toBytes(w.x), A.toBytes(w.y));
      }), L = I.fromBytes || ((y) => {
        const E = y.subarray(1), P = A.fromBytes(E.subarray(0, A.BYTES)), w = A.fromBytes(E.subarray(A.BYTES, 2 * A.BYTES));
        return { x: P, y: w };
      });
      function K(y) {
        const { a: E, b: P } = I, w = A.sqr(y), m = A.mul(w, y);
        return A.add(A.add(m, A.mul(y, E)), P);
      }
      if (!A.eql(A.sqr(I.Gy), K(I.Gx)))
        throw new Error("bad generator point: equation left != right");
      function $(y) {
        return typeof y == "bigint" && d < y && y < I.n;
      }
      function k(y) {
        if (!$(y))
          throw new Error("Expected valid bigint: 0 < bigint < curve.n");
      }
      function V(y) {
        const { allowedPrivateKeyLengths: E, nByteLength: P, wrapPrivateKey: w, n: m } = I;
        if (E && typeof y != "bigint") {
          if (y instanceof Uint8Array && (y = r.bytesToHex(y)), typeof y != "string" || !E.includes(y.length))
            throw new Error("Invalid key");
          y = y.padStart(P * 2, "0");
        }
        let l;
        try {
          l = typeof y == "bigint" ? y : r.bytesToNumberBE((0, n.ensureBytes)("private key", y, P));
        } catch {
          throw new Error(`private key must be ${P} bytes, hex or bigint, not ${typeof y}`);
        }
        return w && (l = t.mod(l, m)), k(l), l;
      }
      const C = /* @__PURE__ */ new Map();
      function D(y) {
        if (!(y instanceof o))
          throw new Error("ProjectivePoint expected");
      }
      class o {
        constructor(E, P, w) {
          if (this.px = E, this.py = P, this.pz = w, E == null || !A.isValid(E))
            throw new Error("x required");
          if (P == null || !A.isValid(P))
            throw new Error("y required");
          if (w == null || !A.isValid(w))
            throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(E) {
          const { x: P, y: w } = E || {};
          if (!E || !A.isValid(P) || !A.isValid(w))
            throw new Error("invalid affine point");
          if (E instanceof o)
            throw new Error("projective point not allowed");
          const m = (l) => A.eql(l, A.ZERO);
          return m(P) && m(w) ? o.ZERO : new o(P, w, A.ONE);
        }
        get x() {
          return this.toAffine().x;
        }
        get y() {
          return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */
        static normalizeZ(E) {
          const P = A.invertBatch(E.map((w) => w.pz));
          return E.map((w, m) => w.toAffine(P[m])).map(o.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */
        static fromHex(E) {
          const P = o.fromAffine(L((0, n.ensureBytes)("pointHex", E)));
          return P.assertValidity(), P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(E) {
          return o.BASE.multiply(V(E));
        }
        // "Private method", don't use it directly
        _setWindowSize(E) {
          this._WINDOW_SIZE = E, C.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
          if (this.is0()) {
            if (I.allowInfinityPoint && !A.is0(this.py))
              return;
            throw new Error("bad point: ZERO");
          }
          const { x: E, y: P } = this.toAffine();
          if (!A.isValid(E) || !A.isValid(P))
            throw new Error("bad point: x or y not FE");
          const w = A.sqr(P), m = K(E);
          if (!A.eql(w, m))
            throw new Error("bad point: equation left != right");
          if (!this.isTorsionFree())
            throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
          const { y: E } = this.toAffine();
          if (A.isOdd)
            return !A.isOdd(E);
          throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */
        equals(E) {
          D(E);
          const { px: P, py: w, pz: m } = this, { px: l, py: b, pz: W } = E, X = A.eql(A.mul(P, W), A.mul(l, m)), G = A.eql(A.mul(w, W), A.mul(b, m));
          return X && G;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */
        negate() {
          return new o(this.px, A.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
          const { a: E, b: P } = I, w = A.mul(P, g), { px: m, py: l, pz: b } = this;
          let W = A.ZERO, X = A.ZERO, G = A.ZERO, re = A.mul(m, m), ce = A.mul(l, l), pe = A.mul(b, b), ve = A.mul(m, l);
          return ve = A.add(ve, ve), G = A.mul(m, b), G = A.add(G, G), W = A.mul(E, G), X = A.mul(w, pe), X = A.add(W, X), W = A.sub(ce, X), X = A.add(ce, X), X = A.mul(W, X), W = A.mul(ve, W), G = A.mul(w, G), pe = A.mul(E, pe), ve = A.sub(re, pe), ve = A.mul(E, ve), ve = A.add(ve, G), G = A.add(re, re), re = A.add(G, re), re = A.add(re, pe), re = A.mul(re, ve), X = A.add(X, re), pe = A.mul(l, b), pe = A.add(pe, pe), re = A.mul(pe, ve), W = A.sub(W, re), G = A.mul(pe, ce), G = A.add(G, G), G = A.add(G, G), new o(W, X, G);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(E) {
          D(E);
          const { px: P, py: w, pz: m } = this, { px: l, py: b, pz: W } = E;
          let X = A.ZERO, G = A.ZERO, re = A.ZERO;
          const ce = I.a, pe = A.mul(I.b, g);
          let ve = A.mul(P, l), Ee = A.mul(w, b), Pe = A.mul(m, W), xe = A.add(P, w), me = A.add(l, b);
          xe = A.mul(xe, me), me = A.add(ve, Ee), xe = A.sub(xe, me), me = A.add(P, m);
          let te = A.add(l, W);
          return me = A.mul(me, te), te = A.add(ve, Pe), me = A.sub(me, te), te = A.add(w, m), X = A.add(b, W), te = A.mul(te, X), X = A.add(Ee, Pe), te = A.sub(te, X), re = A.mul(ce, me), X = A.mul(pe, Pe), re = A.add(X, re), X = A.sub(Ee, re), re = A.add(Ee, re), G = A.mul(X, re), Ee = A.add(ve, ve), Ee = A.add(Ee, ve), Pe = A.mul(ce, Pe), me = A.mul(pe, me), Ee = A.add(Ee, Pe), Pe = A.sub(ve, Pe), Pe = A.mul(ce, Pe), me = A.add(me, Pe), ve = A.mul(Ee, me), G = A.add(G, ve), ve = A.mul(te, me), X = A.mul(xe, X), X = A.sub(X, ve), ve = A.mul(xe, Ee), re = A.mul(te, re), re = A.add(re, ve), new o(X, G, re);
        }
        subtract(E) {
          return this.add(E.negate());
        }
        is0() {
          return this.equals(o.ZERO);
        }
        wNAF(E) {
          return h.wNAFCached(this, C, E, (P) => {
            const w = A.invertBatch(P.map((m) => m.pz));
            return P.map((m, l) => m.toAffine(w[l])).map(o.fromAffine);
          });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(E) {
          const P = o.ZERO;
          if (E === d)
            return P;
          if (k(E), E === c)
            return this;
          const { endo: w } = I;
          if (!w)
            return h.unsafeLadder(this, E);
          let { k1neg: m, k1: l, k2neg: b, k2: W } = w.splitScalar(E), X = P, G = P, re = this;
          for (; l > d || W > d; )
            l & c && (X = X.add(re)), W & c && (G = G.add(re)), re = re.double(), l >>= c, W >>= c;
          return m && (X = X.negate()), b && (G = G.negate()), G = new o(A.mul(G.px, w.beta), G.py, G.pz), X.add(G);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(E) {
          k(E);
          let P = E, w, m;
          const { endo: l } = I;
          if (l) {
            const { k1neg: b, k1: W, k2neg: X, k2: G } = l.splitScalar(P);
            let { p: re, f: ce } = this.wNAF(W), { p: pe, f: ve } = this.wNAF(G);
            re = h.constTimeNegate(b, re), pe = h.constTimeNegate(X, pe), pe = new o(A.mul(pe.px, l.beta), pe.py, pe.pz), w = re.add(pe), m = ce.add(ve);
          } else {
            const { p: b, f: W } = this.wNAF(P);
            w = b, m = W;
          }
          return o.normalizeZ([w, m])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */
        multiplyAndAddUnsafe(E, P, w) {
          const m = o.BASE, l = (W, X) => X === d || X === c || !W.equals(m) ? W.multiplyUnsafe(X) : W.multiply(X), b = l(this, P).add(l(E, w));
          return b.is0() ? void 0 : b;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(E) {
          const { px: P, py: w, pz: m } = this, l = this.is0();
          E == null && (E = l ? A.ONE : A.inv(m));
          const b = A.mul(P, E), W = A.mul(w, E), X = A.mul(m, E);
          if (l)
            return { x: A.ZERO, y: A.ZERO };
          if (!A.eql(X, A.ONE))
            throw new Error("invZ was invalid");
          return { x: b, y: W };
        }
        isTorsionFree() {
          const { h: E, isTorsionFree: P } = I;
          if (E === c)
            return !0;
          if (P)
            return P(o, this);
          throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
          const { h: E, clearCofactor: P } = I;
          return E === c ? this : P ? P(o, this) : this.multiplyUnsafe(I.h);
        }
        toRawBytes(E = !0) {
          return this.assertValidity(), R(o, this, E);
        }
        toHex(E = !0) {
          return r.bytesToHex(this.toRawBytes(E));
        }
      }
      o.BASE = new o(I.Gx, I.Gy, A.ONE), o.ZERO = new o(A.ZERO, A.ONE, A.ZERO);
      const u = I.nBitLength, h = (0, s.wNAF)(o, I.endo ? Math.ceil(u / 2) : u);
      return {
        CURVE: I,
        ProjectivePoint: o,
        normPrivateKeyToScalar: V,
        weierstrassEquation: K,
        isWithinCurveOrder: $
      };
    }
    e.weierstrassPoints = O;
    function N(M) {
      const I = (0, s.validateBasic)(M);
      return r.validateObject(I, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
      }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
      }), Object.freeze({ lowS: !0, ...I });
    }
    function S(M) {
      const I = N(M), { Fp: A, n: R } = I, L = A.BYTES + 1, K = 2 * A.BYTES + 1;
      function $(me) {
        return d < me && me < A.ORDER;
      }
      function k(me) {
        return t.mod(me, R);
      }
      function V(me) {
        return t.invert(me, R);
      }
      const { ProjectivePoint: C, normPrivateKeyToScalar: D, weierstrassEquation: o, isWithinCurveOrder: u } = O({
        ...I,
        toBytes(me, te, U) {
          const ue = te.toAffine(), we = A.toBytes(ue.x), ke = r.concatBytes;
          return U ? ke(Uint8Array.from([te.hasEvenY() ? 2 : 3]), we) : ke(Uint8Array.from([4]), we, A.toBytes(ue.y));
        },
        fromBytes(me) {
          const te = me.length, U = me[0], ue = me.subarray(1);
          if (te === L && (U === 2 || U === 3)) {
            const we = r.bytesToNumberBE(ue);
            if (!$(we))
              throw new Error("Point is not on curve");
            const ke = o(we);
            let Re = A.sqrt(ke);
            const fe = (Re & c) === c;
            return (U & 1) === 1 !== fe && (Re = A.neg(Re)), { x: we, y: Re };
          } else if (te === K && U === 4) {
            const we = A.fromBytes(ue.subarray(0, A.BYTES)), ke = A.fromBytes(ue.subarray(A.BYTES, 2 * A.BYTES));
            return { x: we, y: ke };
          } else
            throw new Error(`Point of length ${te} was invalid. Expected ${L} compressed bytes or ${K} uncompressed bytes`);
        }
      }), h = (me) => r.bytesToHex(r.numberToBytesBE(me, I.nByteLength));
      function y(me) {
        const te = R >> c;
        return me > te;
      }
      function E(me) {
        return y(me) ? k(-me) : me;
      }
      const P = (me, te, U) => r.bytesToNumberBE(me.slice(te, U));
      class w {
        constructor(te, U, ue) {
          this.r = te, this.s = U, this.recovery = ue, this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(te) {
          const U = I.nByteLength;
          return te = (0, n.ensureBytes)("compactSignature", te, U * 2), new w(P(te, 0, U), P(te, U, 2 * U));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(te) {
          const { r: U, s: ue } = e.DER.toSig((0, n.ensureBytes)("DER", te));
          return new w(U, ue);
        }
        assertValidity() {
          if (!u(this.r))
            throw new Error("r must be 0 < r < CURVE.n");
          if (!u(this.s))
            throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(te) {
          return new w(this.r, this.s, te);
        }
        recoverPublicKey(te) {
          const { r: U, s: ue, recovery: we } = this, ke = G((0, n.ensureBytes)("msgHash", te));
          if (we == null || ![0, 1, 2, 3].includes(we))
            throw new Error("recovery id invalid");
          const Re = we === 2 || we === 3 ? U + I.n : U;
          if (Re >= A.ORDER)
            throw new Error("recovery id 2 or 3 invalid");
          const fe = we & 1 ? "03" : "02", x = C.fromHex(fe + h(Re)), _ = V(Re), q = k(-ke * _), ne = k(ue * _), de = C.BASE.multiplyAndAddUnsafe(x, q, ne);
          if (!de)
            throw new Error("point at infinify");
          return de.assertValidity(), de;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
          return y(this.s);
        }
        normalizeS() {
          return this.hasHighS() ? new w(this.r, k(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
          return r.hexToBytes(this.toDERHex());
        }
        toDERHex() {
          return e.DER.hexFromSig({ r: this.r, s: this.s });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
          return r.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
          return h(this.r) + h(this.s);
        }
      }
      const m = {
        isValidPrivateKey(me) {
          try {
            return D(me), !0;
          } catch {
            return !1;
          }
        },
        normPrivateKeyToScalar: D,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */
        randomPrivateKey: () => {
          const me = t.getMinHashLength(I.n);
          return t.mapHashToField(I.randomBytes(me), I.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */
        precompute(me = 8, te = C.BASE) {
          return te._setWindowSize(me), te.multiply(BigInt(3)), te;
        }
      };
      function l(me, te = !0) {
        return C.fromPrivateKey(me).toRawBytes(te);
      }
      function b(me) {
        const te = me instanceof Uint8Array, U = typeof me == "string", ue = (te || U) && me.length;
        return te ? ue === L || ue === K : U ? ue === 2 * L || ue === 2 * K : me instanceof C;
      }
      function W(me, te, U = !0) {
        if (b(me))
          throw new Error("first arg must be private key");
        if (!b(te))
          throw new Error("second arg must be public key");
        return C.fromHex(te).multiply(D(me)).toRawBytes(U);
      }
      const X = I.bits2int || function(me) {
        const te = r.bytesToNumberBE(me), U = me.length * 8 - I.nBitLength;
        return U > 0 ? te >> BigInt(U) : te;
      }, G = I.bits2int_modN || function(me) {
        return k(X(me));
      }, re = r.bitMask(I.nBitLength);
      function ce(me) {
        if (typeof me != "bigint")
          throw new Error("bigint expected");
        if (!(d <= me && me < re))
          throw new Error(`bigint expected < 2^${I.nBitLength}`);
        return r.numberToBytesBE(me, I.nByteLength);
      }
      function pe(me, te, U = ve) {
        if (["recovered", "canonical"].some((ge) => ge in U))
          throw new Error("sign() legacy options not supported");
        const { hash: ue, randomBytes: we } = I;
        let { lowS: ke, prehash: Re, extraEntropy: fe } = U;
        ke == null && (ke = !0), me = (0, n.ensureBytes)("msgHash", me), Re && (me = (0, n.ensureBytes)("prehashed msgHash", ue(me)));
        const x = G(me), _ = D(te), q = [ce(_), ce(x)];
        if (fe != null) {
          const ge = fe === !0 ? we(A.BYTES) : fe;
          q.push((0, n.ensureBytes)("extraEntropy", ge));
        }
        const ne = r.concatBytes(...q), de = x;
        function ye(ge) {
          const be = X(ge);
          if (!u(be))
            return;
          const Me = V(be), Ce = C.BASE.multiply(be).toAffine(), je = k(Ce.x);
          if (je === d)
            return;
          const Ue = k(Me * k(de + je * _));
          if (Ue === d)
            return;
          let Qe = (Ce.x === je ? 0 : 2) | Number(Ce.y & c), Ye = Ue;
          return ke && y(Ue) && (Ye = E(Ue), Qe ^= 1), new w(je, Ye, Qe);
        }
        return { seed: ne, k2sig: ye };
      }
      const ve = { lowS: I.lowS, prehash: !1 }, Ee = { lowS: I.lowS, prehash: !1 };
      function Pe(me, te, U = ve) {
        const { seed: ue, k2sig: we } = pe(me, te, U), ke = I;
        return r.createHmacDrbg(ke.hash.outputLen, ke.nByteLength, ke.hmac)(ue, we);
      }
      C.BASE._setWindowSize(8);
      function xe(me, te, U, ue = Ee) {
        var we;
        const ke = me;
        if (te = (0, n.ensureBytes)("msgHash", te), U = (0, n.ensureBytes)("publicKey", U), "strict" in ue)
          throw new Error("options.strict was renamed to lowS");
        const { lowS: Re, prehash: fe } = ue;
        let x, _;
        try {
          if (typeof ke == "string" || ke instanceof Uint8Array)
            try {
              x = w.fromDER(ke);
            } catch (Ce) {
              if (!(Ce instanceof e.DER.Err))
                throw Ce;
              x = w.fromCompact(ke);
            }
          else if (typeof ke == "object" && typeof ke.r == "bigint" && typeof ke.s == "bigint") {
            const { r: Ce, s: je } = ke;
            x = new w(Ce, je);
          } else
            throw new Error("PARSE");
          _ = C.fromHex(U);
        } catch (Ce) {
          if (Ce.message === "PARSE")
            throw new Error("signature must be Signature instance, Uint8Array or hex string");
          return !1;
        }
        if (Re && x.hasHighS())
          return !1;
        fe && (te = I.hash(te));
        const { r: q, s: ne } = x, de = G(te), ye = V(ne), ge = k(de * ye), be = k(q * ye), Me = (we = C.BASE.multiplyAndAddUnsafe(_, ge, be)) == null ? void 0 : we.toAffine();
        return Me ? k(Me.x) === q : !1;
      }
      return {
        CURVE: I,
        getPublicKey: l,
        getSharedSecret: W,
        sign: Pe,
        verify: xe,
        ProjectivePoint: C,
        Signature: w,
        utils: m
      };
    }
    e.weierstrass = S;
    function j(M, I) {
      const A = M.ORDER;
      let R = d;
      for (let y = A - c; y % p === d; y /= p)
        R += c;
      const L = R, K = p << L - c - c, $ = K * p, k = (A - c) / $, V = (k - c) / p, C = $ - c, D = K, o = M.pow(I, k), u = M.pow(I, (k + c) / p);
      let h = (y, E) => {
        let P = o, w = M.pow(E, C), m = M.sqr(w);
        m = M.mul(m, E);
        let l = M.mul(y, m);
        l = M.pow(l, V), l = M.mul(l, w), w = M.mul(l, E), m = M.mul(l, y);
        let b = M.mul(m, w);
        l = M.pow(b, D);
        let W = M.eql(l, M.ONE);
        w = M.mul(m, u), l = M.mul(b, P), m = M.cmov(w, m, W), b = M.cmov(l, b, W);
        for (let X = L; X > c; X--) {
          let G = X - p;
          G = p << G - c;
          let re = M.pow(b, G);
          const ce = M.eql(re, M.ONE);
          w = M.mul(m, P), P = M.mul(P, P), re = M.mul(b, P), m = M.cmov(w, m, ce), b = M.cmov(re, b, ce);
        }
        return { isValid: W, value: m };
      };
      if (M.ORDER % v === g) {
        const y = (M.ORDER - g) / v, E = M.sqrt(M.neg(I));
        h = (P, w) => {
          let m = M.sqr(w);
          const l = M.mul(P, w);
          m = M.mul(m, l);
          let b = M.pow(m, y);
          b = M.mul(b, l);
          const W = M.mul(b, E), X = M.mul(M.sqr(b), w), G = M.eql(X, P);
          let re = M.cmov(W, b, G);
          return { isValid: G, value: re };
        };
      }
      return h;
    }
    e.SWUFpSqrtRatio = j;
    function B(M, I) {
      if (t.validateField(M), !M.isValid(I.A) || !M.isValid(I.B) || !M.isValid(I.Z))
        throw new Error("mapToCurveSimpleSWU: invalid opts");
      const A = j(M, I.Z);
      if (!M.isOdd)
        throw new Error("Fp.isOdd is not implemented!");
      return (R) => {
        let L, K, $, k, V, C, D, o;
        L = M.sqr(R), L = M.mul(L, I.Z), K = M.sqr(L), K = M.add(K, L), $ = M.add(K, M.ONE), $ = M.mul($, I.B), k = M.cmov(I.Z, M.neg(K), !M.eql(K, M.ZERO)), k = M.mul(k, I.A), K = M.sqr($), C = M.sqr(k), V = M.mul(C, I.A), K = M.add(K, V), K = M.mul(K, $), C = M.mul(C, k), V = M.mul(C, I.B), K = M.add(K, V), D = M.mul(L, $);
        const { isValid: u, value: h } = A(K, C);
        o = M.mul(L, R), o = M.mul(o, h), D = M.cmov(D, $, u), o = M.cmov(o, h, u);
        const y = M.isOdd(R) === M.isOdd(o);
        return o = M.cmov(M.neg(o), o, y), D = M.div(D, k), { x: D, y: o };
      };
    }
    e.mapToCurveSimpleSWU = B;
  }(Ry)), Ry;
}
var Dn = {}, _y;
function ST() {
  if (_y)
    return Dn;
  _y = 1, Object.defineProperty(Dn, "__esModule", { value: !0 }), Dn.createHasher = Dn.isogenyMap = Dn.hash_to_field = Dn.expand_message_xof = Dn.expand_message_xmd = void 0;
  const e = sf(), t = Yu();
  function r(O) {
    if (O instanceof Uint8Array)
      return O;
    if (typeof O == "string")
      return (0, t.utf8ToBytes)(O);
    throw new Error("DST must be Uint8Array or string");
  }
  const n = t.bytesToNumberBE;
  function s(O, N) {
    if (O < 0 || O >= 1 << 8 * N)
      throw new Error(`bad I2OSP call: value=${O} length=${N}`);
    const S = Array.from({ length: N }).fill(0);
    for (let j = N - 1; j >= 0; j--)
      S[j] = O & 255, O >>>= 8;
    return new Uint8Array(S);
  }
  function i(O, N) {
    const S = new Uint8Array(O.length);
    for (let j = 0; j < O.length; j++)
      S[j] = O[j] ^ N[j];
    return S;
  }
  function a(O) {
    if (!(O instanceof Uint8Array))
      throw new Error("Uint8Array expected");
  }
  function f(O) {
    if (!Number.isSafeInteger(O))
      throw new Error("number expected");
  }
  function d(O, N, S, j) {
    a(O), a(N), f(S), N.length > 255 && (N = j((0, t.concatBytes)((0, t.utf8ToBytes)("H2C-OVERSIZE-DST-"), N)));
    const { outputLen: B, blockLen: M } = j, I = Math.ceil(S / B);
    if (I > 255)
      throw new Error("Invalid xmd length");
    const A = (0, t.concatBytes)(N, s(N.length, 1)), R = s(0, M), L = s(S, 2), K = new Array(I), $ = j((0, t.concatBytes)(R, O, L, s(0, 1), A));
    K[0] = j((0, t.concatBytes)($, s(1, 1), A));
    for (let k = 1; k <= I; k++) {
      const V = [i($, K[k - 1]), s(k + 1, 1), A];
      K[k] = j((0, t.concatBytes)(...V));
    }
    return (0, t.concatBytes)(...K).slice(0, S);
  }
  Dn.expand_message_xmd = d;
  function c(O, N, S, j, B) {
    if (a(O), a(N), f(S), N.length > 255) {
      const M = Math.ceil(2 * j / 8);
      N = B.create({ dkLen: M }).update((0, t.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(N).digest();
    }
    if (S > 65535 || N.length > 255)
      throw new Error("expand_message_xof: invalid lenInBytes");
    return B.create({ dkLen: S }).update(O).update(s(S, 2)).update(N).update(s(N.length, 1)).digest();
  }
  Dn.expand_message_xof = c;
  function p(O, N, S) {
    (0, t.validateObject)(S, {
      DST: "stringOrUint8Array",
      p: "bigint",
      m: "isSafeInteger",
      k: "isSafeInteger",
      hash: "hash"
    });
    const { p: j, k: B, m: M, hash: I, expand: A, DST: R } = S;
    a(O), f(N);
    const L = r(R), K = j.toString(2).length, $ = Math.ceil((K + B) / 8), k = N * M * $;
    let V;
    if (A === "xmd")
      V = d(O, L, k, I);
    else if (A === "xof")
      V = c(O, L, k, B, I);
    else if (A === "_internal_pass")
      V = O;
    else
      throw new Error('expand must be "xmd" or "xof"');
    const C = new Array(N);
    for (let D = 0; D < N; D++) {
      const o = new Array(M);
      for (let u = 0; u < M; u++) {
        const h = $ * (u + D * M), y = V.subarray(h, h + $);
        o[u] = (0, e.mod)(n(y), j);
      }
      C[D] = o;
    }
    return C;
  }
  Dn.hash_to_field = p;
  function g(O, N) {
    const S = N.map((j) => Array.from(j).reverse());
    return (j, B) => {
      const [M, I, A, R] = S.map((L) => L.reduce((K, $) => O.add(O.mul(K, j), $)));
      return j = O.div(M, I), B = O.mul(B, O.div(A, R)), { x: j, y: B };
    };
  }
  Dn.isogenyMap = g;
  function v(O, N, S) {
    if (typeof N != "function")
      throw new Error("mapToCurve() must be defined");
    return {
      // Encodes byte string to elliptic curve.
      // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      hashToCurve(j, B) {
        const M = p(j, 2, { ...S, DST: S.DST, ...B }), I = O.fromAffine(N(M[0])), A = O.fromAffine(N(M[1])), R = I.add(A).clearCofactor();
        return R.assertValidity(), R;
      },
      // Encodes byte string to elliptic curve.
      // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      encodeToCurve(j, B) {
        const M = p(j, 1, { ...S, DST: S.encodeDST, ...B }), I = O.fromAffine(N(M[0])).clearCofactor();
        return I.assertValidity(), I;
      }
    };
  }
  return Dn.createHasher = v, Dn;
}
var Qo = {}, Fy;
function MT() {
  if (Fy)
    return Qo;
  Fy = 1, Object.defineProperty(Qo, "__esModule", { value: !0 }), Qo.createCurve = Qo.getHash = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const e = A1(), t = vs(), r = C5();
  function n(i) {
    return {
      hash: i,
      hmac: (a, ...f) => (0, e.hmac)(i, a, (0, t.concatBytes)(...f)),
      randomBytes: t.randomBytes
    };
  }
  Qo.getHash = n;
  function s(i, a) {
    const f = (d) => (0, r.weierstrass)({ ...i, ...n(d) });
    return Object.freeze({ ...f(a), create: f });
  }
  return Qo.createCurve = s, Qo;
}
var Uy;
function IT() {
  return Uy || (Uy = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.encodeToCurve = e.hashToCurve = e.schnorr = e.secp256k1 = void 0;
    /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    const t = P1(), r = vs(), n = sf(), s = C5(), i = Yu(), a = ST(), f = MT(), d = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), c = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), p = BigInt(1), g = BigInt(2), v = (w, m) => (w + m / g) / m;
    function O(w) {
      const m = d, l = BigInt(3), b = BigInt(6), W = BigInt(11), X = BigInt(22), G = BigInt(23), re = BigInt(44), ce = BigInt(88), pe = w * w * w % m, ve = pe * pe * w % m, Ee = (0, n.pow2)(ve, l, m) * ve % m, Pe = (0, n.pow2)(Ee, l, m) * ve % m, xe = (0, n.pow2)(Pe, g, m) * pe % m, me = (0, n.pow2)(xe, W, m) * xe % m, te = (0, n.pow2)(me, X, m) * me % m, U = (0, n.pow2)(te, re, m) * te % m, ue = (0, n.pow2)(U, ce, m) * U % m, we = (0, n.pow2)(ue, re, m) * te % m, ke = (0, n.pow2)(we, l, m) * ve % m, Re = (0, n.pow2)(ke, G, m) * me % m, fe = (0, n.pow2)(Re, b, m) * pe % m, x = (0, n.pow2)(fe, g, m);
      if (!N.eql(N.sqr(x), w))
        throw new Error("Cannot find square root");
      return x;
    }
    const N = (0, n.Field)(d, void 0, void 0, { sqrt: O });
    e.secp256k1 = (0, f.createCurve)({
      a: BigInt(0),
      b: BigInt(7),
      Fp: N,
      n: c,
      // Base point (x, y) aka generator point
      Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
      Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
      h: BigInt(1),
      lowS: !0,
      /**
       * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
       * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
       * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
       * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
       */
      endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (w) => {
          const m = c, l = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), b = -p * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), W = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), X = l, G = BigInt("0x100000000000000000000000000000000"), re = v(X * w, m), ce = v(-b * w, m);
          let pe = (0, n.mod)(w - re * l - ce * W, m), ve = (0, n.mod)(-re * b - ce * X, m);
          const Ee = pe > G, Pe = ve > G;
          if (Ee && (pe = m - pe), Pe && (ve = m - ve), pe > G || ve > G)
            throw new Error("splitScalar: Endomorphism failed, k=" + w);
          return { k1neg: Ee, k1: pe, k2neg: Pe, k2: ve };
        }
      }
    }, t.sha256);
    const S = BigInt(0), j = (w) => typeof w == "bigint" && S < w && w < d, B = (w) => typeof w == "bigint" && S < w && w < c, M = {};
    function I(w, ...m) {
      let l = M[w];
      if (l === void 0) {
        const b = (0, t.sha256)(Uint8Array.from(w, (W) => W.charCodeAt(0)));
        l = (0, i.concatBytes)(b, b), M[w] = l;
      }
      return (0, t.sha256)((0, i.concatBytes)(l, ...m));
    }
    const A = (w) => w.toRawBytes(!0).slice(1), R = (w) => (0, i.numberToBytesBE)(w, 32), L = (w) => (0, n.mod)(w, d), K = (w) => (0, n.mod)(w, c), $ = e.secp256k1.ProjectivePoint, k = (w, m, l) => $.BASE.multiplyAndAddUnsafe(w, m, l);
    function V(w) {
      let m = e.secp256k1.utils.normPrivateKeyToScalar(w), l = $.fromPrivateKey(m);
      return { scalar: l.hasEvenY() ? m : K(-m), bytes: A(l) };
    }
    function C(w) {
      if (!j(w))
        throw new Error("bad x: need 0 < x < p");
      const m = L(w * w), l = L(m * w + BigInt(7));
      let b = O(l);
      b % g !== S && (b = L(-b));
      const W = new $(w, b, p);
      return W.assertValidity(), W;
    }
    function D(...w) {
      return K((0, i.bytesToNumberBE)(I("BIP0340/challenge", ...w)));
    }
    function o(w) {
      return V(w).bytes;
    }
    function u(w, m, l = (0, r.randomBytes)(32)) {
      const b = (0, i.ensureBytes)("message", w), { bytes: W, scalar: X } = V(m), G = (0, i.ensureBytes)("auxRand", l, 32), re = R(X ^ (0, i.bytesToNumberBE)(I("BIP0340/aux", G))), ce = I("BIP0340/nonce", re, W, b), pe = K((0, i.bytesToNumberBE)(ce));
      if (pe === S)
        throw new Error("sign failed: k is zero");
      const { bytes: ve, scalar: Ee } = V(pe), Pe = D(ve, W, b), xe = new Uint8Array(64);
      if (xe.set(ve, 0), xe.set(R(K(Ee + Pe * X)), 32), !h(xe, b, W))
        throw new Error("sign: Invalid signature produced");
      return xe;
    }
    function h(w, m, l) {
      const b = (0, i.ensureBytes)("signature", w, 64), W = (0, i.ensureBytes)("message", m), X = (0, i.ensureBytes)("publicKey", l, 32);
      try {
        const G = C((0, i.bytesToNumberBE)(X)), re = (0, i.bytesToNumberBE)(b.subarray(0, 32));
        if (!j(re))
          return !1;
        const ce = (0, i.bytesToNumberBE)(b.subarray(32, 64));
        if (!B(ce))
          return !1;
        const pe = D(R(re), A(G), W), ve = k(G, ce, K(-pe));
        return !(!ve || !ve.hasEvenY() || ve.toAffine().x !== re);
      } catch {
        return !1;
      }
    }
    e.schnorr = {
      getPublicKey: o,
      sign: u,
      verify: h,
      utils: {
        randomPrivateKey: e.secp256k1.utils.randomPrivateKey,
        lift_x: C,
        pointToBytes: A,
        numberToBytesBE: i.numberToBytesBE,
        bytesToNumberBE: i.bytesToNumberBE,
        taggedHash: I,
        mod: n.mod
      }
    };
    const y = (0, a.isogenyMap)(N, [
      // xNum
      [
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
      ],
      // xDen
      [
        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ],
      // yNum
      [
        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
      ],
      // yDen
      [
        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ]
    ].map((w) => w.map((m) => BigInt(m)))), E = (0, s.mapToCurveSimpleSWU)(N, {
      A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
      B: BigInt("1771"),
      Z: N.create(BigInt("-11"))
    }), P = (0, a.createHasher)(e.secp256k1.ProjectivePoint, (w) => {
      const { x: m, y: l } = E(N.create(w[0]));
      return y(m, l);
    }, {
      DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
      encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
      p: N.ORDER,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: t.sha256
    });
    e.hashToCurve = P.hashToCurve, e.encodeToCurve = P.encodeToCurve;
  }(Sy)), Sy;
}
var xc = {}, Dy = {}, _d = {}, jy;
function B5() {
  return jy || (jy = 1, Object.defineProperty(_d, "__esModule", { value: !0 }), _d.ZeroAddress = void 0, _d.ZeroAddress = "0x0000000000000000000000000000000000000000"), _d;
}
var Fd = {}, Ly;
function RT() {
  return Ly || (Ly = 1, Object.defineProperty(Fd, "__esModule", { value: !0 }), Fd.ZeroHash = void 0, Fd.ZeroHash = "0x0000000000000000000000000000000000000000000000000000000000000000"), Fd;
}
var ii = {}, Hy;
function CT() {
  return Hy || (Hy = 1, Object.defineProperty(ii, "__esModule", { value: !0 }), ii.MaxInt256 = ii.MinInt256 = ii.MaxUint256 = ii.WeiPerEther = ii.N = void 0, ii.N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), ii.WeiPerEther = BigInt("1000000000000000000"), ii.MaxUint256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), ii.MinInt256 = BigInt("0x8000000000000000000000000000000000000000000000000000000000000000") * BigInt(-1), ii.MaxInt256 = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")), ii;
}
var ou = {}, Wy;
function BT() {
  return Wy || (Wy = 1, Object.defineProperty(ou, "__esModule", { value: !0 }), ou.MessagePrefix = ou.EtherSymbol = void 0, ou.EtherSymbol = "Ξ", ou.MessagePrefix = `Ethereum Signed Message:
`), ou;
}
var Gy;
function pd() {
  return Gy || (Gy = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.MessagePrefix = e.EtherSymbol = e.MaxInt256 = e.MinInt256 = e.MaxUint256 = e.WeiPerEther = e.N = e.ZeroHash = e.ZeroAddress = void 0;
    var t = B5();
    Object.defineProperty(e, "ZeroAddress", { enumerable: !0, get: function() {
      return t.ZeroAddress;
    } });
    var r = RT();
    Object.defineProperty(e, "ZeroHash", { enumerable: !0, get: function() {
      return r.ZeroHash;
    } });
    var n = CT();
    Object.defineProperty(e, "N", { enumerable: !0, get: function() {
      return n.N;
    } }), Object.defineProperty(e, "WeiPerEther", { enumerable: !0, get: function() {
      return n.WeiPerEther;
    } }), Object.defineProperty(e, "MaxUint256", { enumerable: !0, get: function() {
      return n.MaxUint256;
    } }), Object.defineProperty(e, "MinInt256", { enumerable: !0, get: function() {
      return n.MinInt256;
    } }), Object.defineProperty(e, "MaxInt256", { enumerable: !0, get: function() {
      return n.MaxInt256;
    } });
    var s = BT();
    Object.defineProperty(e, "EtherSymbol", { enumerable: !0, get: function() {
      return s.EtherSymbol;
    } }), Object.defineProperty(e, "MessagePrefix", { enumerable: !0, get: function() {
      return s.MessagePrefix;
    } });
  }(Dy)), Dy;
}
var zy;
function _5() {
  var e, t, r, n;
  if (zy)
    return xc;
  zy = 1, Object.defineProperty(xc, "__esModule", { value: !0 }), xc.Signature = void 0;
  const s = pd(), i = wt(), a = BigInt(0), f = BigInt(1), d = BigInt(2), c = BigInt(27), p = BigInt(28), g = BigInt(35), v = {};
  function O(j) {
    return (0, i.zeroPadValue)((0, i.toBeArray)(j), 32);
  }
  const N = class rs {
    /**
     *  @private
     */
    constructor(B, M, I, A) {
      _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), _e(this, n, void 0), (0, i.assertPrivate)(B, v, "Signature"), Oe(this, e, M), Oe(this, t, I), Oe(this, r, A), Oe(this, n, null);
    }
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */
    get r() {
      return oe(this, e);
    }
    set r(B) {
      (0, i.assertArgument)((0, i.dataLength)(B) === 32, "invalid r", "value", B), Oe(this, e, (0, i.hexlify)(B));
    }
    /**
     *  The ``s`` value for a signature.
     */
    get s() {
      return oe(this, t);
    }
    set s(B) {
      (0, i.assertArgument)((0, i.dataLength)(B) === 32, "invalid s", "value", B);
      const M = (0, i.hexlify)(B);
      (0, i.assertArgument)(parseInt(M.substring(0, 3)) < 8, "non-canonical s", "value", M), Oe(this, t, M);
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */
    get v() {
      return oe(this, r);
    }
    set v(B) {
      const M = (0, i.getNumber)(B, "value");
      (0, i.assertArgument)(M === 27 || M === 28, "invalid v", "v", B), Oe(this, r, M);
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */
    get networkV() {
      return oe(this, n);
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */
    get legacyChainId() {
      const B = this.networkV;
      return B == null ? null : rs.getChainId(B);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */
    get yParity() {
      return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */
    get yParityAndS() {
      const B = (0, i.getBytes)(this.s);
      return this.yParity && (B[0] |= 128), (0, i.hexlify)(B);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */
    get compactSerialized() {
      return (0, i.concat)([this.r, this.yParityAndS]);
    }
    /**
     *  The serialized representation.
     */
    get serialized() {
      return (0, i.concat)([this.r, this.s, this.yParity ? "0x1c" : "0x1b"]);
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
      return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */
    clone() {
      const B = new rs(v, this.r, this.s, this.v);
      return this.networkV && Oe(B, n, this.networkV), B;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */
    toJSON() {
      const B = this.networkV;
      return {
        _type: "signature",
        networkV: B != null ? B.toString() : null,
        r: this.r,
        s: this.s,
        v: this.v
      };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */
    static getChainId(B) {
      const M = (0, i.getBigInt)(B, "v");
      return M == c || M == p ? a : ((0, i.assertArgument)(M >= g, "invalid EIP-155 v", "v", B), (M - g) / d);
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */
    static getChainIdV(B, M) {
      return (0, i.getBigInt)(B) * d + BigInt(35 + M - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */
    static getNormalizedV(B) {
      const M = (0, i.getBigInt)(B);
      return M === a || M === c ? 27 : M === f || M === p ? 28 : ((0, i.assertArgument)(M >= g, "invalid v", "v", B), M & f ? 27 : 28);
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */
    static from(B) {
      function M(k, V) {
        (0, i.assertArgument)(k, V, "signature", B);
      }
      if (B == null)
        return new rs(v, s.ZeroHash, s.ZeroHash, 27);
      if (typeof B == "string") {
        const k = (0, i.getBytes)(B, "signature");
        if (k.length === 64) {
          const V = (0, i.hexlify)(k.slice(0, 32)), C = k.slice(32, 64), D = C[0] & 128 ? 28 : 27;
          return C[0] &= 127, new rs(v, V, (0, i.hexlify)(C), D);
        }
        if (k.length === 65) {
          const V = (0, i.hexlify)(k.slice(0, 32)), C = k.slice(32, 64);
          M((C[0] & 128) === 0, "non-canonical s");
          const D = rs.getNormalizedV(k[64]);
          return new rs(v, V, (0, i.hexlify)(C), D);
        }
        M(!1, "invalid raw signature length");
      }
      if (B instanceof rs)
        return B.clone();
      const I = B.r;
      M(I != null, "missing r");
      const A = O(I), R = function(k, V) {
        if (k != null)
          return O(k);
        if (V != null) {
          M((0, i.isHexString)(V, 32), "invalid yParityAndS");
          const C = (0, i.getBytes)(V);
          return C[0] &= 127, (0, i.hexlify)(C);
        }
        M(!1, "missing s");
      }(B.s, B.yParityAndS);
      M(((0, i.getBytes)(R)[0] & 128) == 0, "non-canonical s");
      const { networkV: L, v: K } = function(k, V, C) {
        if (k != null) {
          const D = (0, i.getBigInt)(k);
          return {
            networkV: D >= g ? D : void 0,
            v: rs.getNormalizedV(D)
          };
        }
        if (V != null)
          return M((0, i.isHexString)(V, 32), "invalid yParityAndS"), { v: (0, i.getBytes)(V)[0] & 128 ? 28 : 27 };
        if (C != null) {
          switch ((0, i.getNumber)(C, "sig.yParity")) {
            case 0:
              return { v: 27 };
            case 1:
              return { v: 28 };
          }
          M(!1, "invalid yParity");
        }
        M(!1, "missing v");
      }(B.v, B.yParityAndS, B.yParity), $ = new rs(v, A, R, K);
      return L && Oe($, n, L), M(B.yParity == null || (0, i.getNumber)(B.yParity, "sig.yParity") === $.yParity, "yParity mismatch"), M(B.yParityAndS == null || B.yParityAndS === $.yParityAndS, "yParityAndS mismatch"), $;
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  let S = N;
  return xc.Signature = S, xc;
}
var Vy;
function _T() {
  var e;
  if (Vy)
    return Nc;
  Vy = 1, Object.defineProperty(Nc, "__esModule", { value: !0 }), Nc.SigningKey = void 0;
  const t = IT(), r = wt(), n = _5(), s = class yu {
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */
    constructor(f) {
      _e(this, e, void 0), (0, r.assertArgument)((0, r.dataLength)(f) === 32, "invalid private key", "privateKey", "[REDACTED]"), Oe(this, e, (0, r.hexlify)(f));
    }
    /**
     *  The private key.
     */
    get privateKey() {
      return oe(this, e);
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */
    get publicKey() {
      return yu.computePublicKey(oe(this, e));
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */
    get compressedPublicKey() {
      return yu.computePublicKey(oe(this, e), !0);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */
    sign(f) {
      (0, r.assertArgument)((0, r.dataLength)(f) === 32, "invalid digest length", "digest", f);
      const d = t.secp256k1.sign((0, r.getBytesCopy)(f), (0, r.getBytesCopy)(oe(this, e)), {
        lowS: !0
      });
      return n.Signature.from({
        r: (0, r.toBeHex)(d.r, 32),
        s: (0, r.toBeHex)(d.s, 32),
        v: d.recovery ? 28 : 27
      });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */
    computeSharedSecret(f) {
      const d = yu.computePublicKey(f);
      return (0, r.hexlify)(t.secp256k1.getSharedSecret((0, r.getBytesCopy)(oe(this, e)), (0, r.getBytes)(d), !1));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */
    static computePublicKey(f, d) {
      let c = (0, r.getBytes)(f, "key");
      if (c.length === 32) {
        const g = t.secp256k1.getPublicKey(c, !!d);
        return (0, r.hexlify)(g);
      }
      if (c.length === 64) {
        const g = new Uint8Array(65);
        g[0] = 4, g.set(c, 1), c = g;
      }
      const p = t.secp256k1.ProjectivePoint.fromHex(c);
      return (0, r.hexlify)(p.toRawBytes(d));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */
    static recoverPublicKey(f, d) {
      (0, r.assertArgument)((0, r.dataLength)(f) === 32, "invalid digest length", "digest", f);
      const c = n.Signature.from(d);
      let p = t.secp256k1.Signature.fromCompact((0, r.getBytesCopy)((0, r.concat)([c.r, c.s])));
      p = p.addRecoveryBit(c.yParity);
      const g = p.recoverPublicKey((0, r.getBytesCopy)(f));
      return (0, r.assertArgument)(g != null, "invalid signautre for digest", "signature", d), "0x" + g.toHex(!1);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */
    static addPoints(f, d, c) {
      const p = t.secp256k1.ProjectivePoint.fromHex(yu.computePublicKey(f).substring(2)), g = t.secp256k1.ProjectivePoint.fromHex(yu.computePublicKey(d).substring(2));
      return "0x" + p.add(g).toHex(!!c);
    }
  };
  e = /* @__PURE__ */ new WeakMap();
  let i = s;
  return Nc.SigningKey = i, Nc;
}
var qy;
function cn() {
  return qy || (qy = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.lock = e.Signature = e.SigningKey = e.scryptSync = e.scrypt = e.pbkdf2 = e.sha512 = e.sha256 = e.ripemd160 = e.keccak256 = e.randomBytes = e.computeHmac = void 0;
    const t = bT();
    Object.defineProperty(e, "computeHmac", { enumerable: !0, get: function() {
      return t.computeHmac;
    } });
    const r = vT();
    Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
      return r.keccak256;
    } });
    const n = ET();
    Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
      return n.ripemd160;
    } });
    const s = PT();
    Object.defineProperty(e, "pbkdf2", { enumerable: !0, get: function() {
      return s.pbkdf2;
    } });
    const i = OT();
    Object.defineProperty(e, "randomBytes", { enumerable: !0, get: function() {
      return i.randomBytes;
    } });
    const a = xT();
    Object.defineProperty(e, "scrypt", { enumerable: !0, get: function() {
      return a.scrypt;
    } }), Object.defineProperty(e, "scryptSync", { enumerable: !0, get: function() {
      return a.scryptSync;
    } });
    const f = TT();
    Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
      return f.sha256;
    } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
      return f.sha512;
    } });
    var d = _T();
    Object.defineProperty(e, "SigningKey", { enumerable: !0, get: function() {
      return d.SigningKey;
    } });
    var c = _5();
    Object.defineProperty(e, "Signature", { enumerable: !0, get: function() {
      return c.Signature;
    } });
    function p() {
      t.computeHmac.lock(), r.keccak256.lock(), s.pbkdf2.lock(), i.randomBytes.lock(), n.ripemd160.lock(), a.scrypt.lock(), a.scryptSync.lock(), f.sha256.lock(), f.sha512.lock(), i.randomBytes.lock();
    }
    e.lock = p;
  }(oy)), oy;
}
var $y;
function O1() {
  if ($y)
    return Wo;
  $y = 1, Object.defineProperty(Wo, "__esModule", { value: !0 }), Wo.getIcapAddress = Wo.getAddress = void 0;
  const e = cn(), t = wt(), r = BigInt(0), n = BigInt(36);
  function s(v) {
    v = v.toLowerCase();
    const O = v.substring(2).split(""), N = new Uint8Array(40);
    for (let j = 0; j < 40; j++)
      N[j] = O[j].charCodeAt(0);
    const S = (0, t.getBytes)((0, e.keccak256)(N));
    for (let j = 0; j < 40; j += 2)
      S[j >> 1] >> 4 >= 8 && (O[j] = O[j].toUpperCase()), (S[j >> 1] & 15) >= 8 && (O[j + 1] = O[j + 1].toUpperCase());
    return "0x" + O.join("");
  }
  const i = {};
  for (let v = 0; v < 10; v++)
    i[String(v)] = String(v);
  for (let v = 0; v < 26; v++)
    i[String.fromCharCode(65 + v)] = String(10 + v);
  const a = 15;
  function f(v) {
    v = v.toUpperCase(), v = v.substring(4) + v.substring(0, 2) + "00";
    let O = v.split("").map((S) => i[S]).join("");
    for (; O.length >= a; ) {
      let S = O.substring(0, a);
      O = parseInt(S, 10) % 97 + O.substring(S.length);
    }
    let N = String(98 - parseInt(O, 10) % 97);
    for (; N.length < 2; )
      N = "0" + N;
    return N;
  }
  const d = function() {
    const v = {};
    for (let O = 0; O < 36; O++) {
      const N = "0123456789abcdefghijklmnopqrstuvwxyz"[O];
      v[N] = BigInt(O);
    }
    return v;
  }();
  function c(v) {
    v = v.toLowerCase();
    let O = r;
    for (let N = 0; N < v.length; N++)
      O = O * n + d[v[N]];
    return O;
  }
  function p(v) {
    if ((0, t.assertArgument)(typeof v == "string", "invalid address", "address", v), v.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
      v.startsWith("0x") || (v = "0x" + v);
      const O = s(v);
      return (0, t.assertArgument)(!v.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || O === v, "bad address checksum", "address", v), O;
    }
    if (v.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
      (0, t.assertArgument)(v.substring(2, 4) === f(v), "bad icap checksum", "address", v);
      let O = c(v.substring(4)).toString(16);
      for (; O.length < 40; )
        O = "0" + O;
      return s("0x" + O);
    }
    (0, t.assertArgument)(!1, "invalid address", "address", v);
  }
  Wo.getAddress = p;
  function g(v) {
    let O = BigInt(p(v)).toString(36).toUpperCase();
    for (; O.length < 30; )
      O = "0" + O;
    return "XE" + f("XE00" + O) + O;
  }
  return Wo.getIcapAddress = g, Wo;
}
var Zo = {}, Ky;
function FT() {
  if (Ky)
    return Zo;
  Ky = 1, Object.defineProperty(Zo, "__esModule", { value: !0 }), Zo.getCreate2Address = Zo.getCreateAddress = void 0;
  const e = cn(), t = wt(), r = O1();
  function n(i) {
    const a = (0, r.getAddress)(i.from);
    let f = (0, t.getBigInt)(i.nonce, "tx.nonce").toString(16);
    return f === "0" ? f = "0x" : f.length % 2 ? f = "0x0" + f : f = "0x" + f, (0, r.getAddress)((0, t.dataSlice)((0, e.keccak256)((0, t.encodeRlp)([a, f])), 12));
  }
  Zo.getCreateAddress = n;
  function s(i, a, f) {
    const d = (0, r.getAddress)(i), c = (0, t.getBytes)(a, "salt"), p = (0, t.getBytes)(f, "initCodeHash");
    return (0, t.assertArgument)(c.length === 32, "salt must be 32 bytes", "salt", a), (0, t.assertArgument)(p.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", f), (0, r.getAddress)((0, t.dataSlice)((0, e.keccak256)((0, t.concat)(["0xff", d, c, p])), 12));
  }
  return Zo.getCreate2Address = s, Zo;
}
var Ns = {}, Jy;
function UT() {
  if (Jy)
    return Ns;
  Jy = 1, Object.defineProperty(Ns, "__esModule", { value: !0 }), Ns.resolveAddress = Ns.isAddress = Ns.isAddressable = void 0;
  const e = wt(), t = O1();
  function r(a) {
    return a && typeof a.getAddress == "function";
  }
  Ns.isAddressable = r;
  function n(a) {
    try {
      return (0, t.getAddress)(a), !0;
    } catch {
    }
    return !1;
  }
  Ns.isAddress = n;
  async function s(a, f) {
    const d = await f;
    return (d == null || d === "0x0000000000000000000000000000000000000000") && ((0, e.assert)(typeof a != "string", "unconfigured name", "UNCONFIGURED_NAME", { value: a }), (0, e.assertArgument)(!1, "invalid AddressLike value; did not resolve to a value address", "target", a)), (0, t.getAddress)(d);
  }
  function i(a, f) {
    if (typeof a == "string")
      return a.match(/^0x[0-9a-f]{40}$/i) ? (0, t.getAddress)(a) : ((0, e.assert)(f != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" }), s(a, f.resolveName(a)));
    if (r(a))
      return s(a, a.getAddress());
    if (a && typeof a.then == "function")
      return s(a, a);
    (0, e.assertArgument)(!1, "unsupported addressable value", "target", a);
  }
  return Ns.resolveAddress = i, Ns;
}
var Qy;
function Yr() {
  return Qy || (Qy = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.resolveAddress = e.isAddress = e.isAddressable = e.getCreate2Address = e.getCreateAddress = e.getIcapAddress = e.getAddress = void 0;
    var t = O1();
    Object.defineProperty(e, "getAddress", { enumerable: !0, get: function() {
      return t.getAddress;
    } }), Object.defineProperty(e, "getIcapAddress", { enumerable: !0, get: function() {
      return t.getIcapAddress;
    } });
    var r = FT();
    Object.defineProperty(e, "getCreateAddress", { enumerable: !0, get: function() {
      return r.getCreateAddress;
    } }), Object.defineProperty(e, "getCreate2Address", { enumerable: !0, get: function() {
      return r.getCreate2Address;
    } });
    var n = UT();
    Object.defineProperty(e, "isAddressable", { enumerable: !0, get: function() {
      return n.isAddressable;
    } }), Object.defineProperty(e, "isAddress", { enumerable: !0, get: function() {
      return n.isAddress;
    } }), Object.defineProperty(e, "resolveAddress", { enumerable: !0, get: function() {
      return n.resolveAddress;
    } });
  }(sy)), sy;
}
var Tc = {}, Zy;
function ro() {
  var e;
  if (Zy)
    return Tc;
  Zy = 1, Object.defineProperty(Tc, "__esModule", { value: !0 }), Tc.Typed = void 0;
  const t = wt(), r = {};
  function n(d, c) {
    let p = !1;
    return c < 0 && (p = !0, c *= -1), new f(r, `${p ? "" : "u"}int${c}`, d, { signed: p, width: c });
  }
  function s(d, c) {
    return new f(r, `bytes${c || ""}`, d, { size: c });
  }
  const i = Symbol.for("_ethers_typed"), a = class uo {
    /**
     *  @_ignore:
     */
    constructor(c, p, g, v) {
      Be(this, "type"), Be(this, "value"), _e(this, e, void 0), Be(this, "_typedSymbol"), v == null && (v = null), (0, t.assertPrivate)(r, c, "Typed"), (0, t.defineProperties)(this, { _typedSymbol: i, type: p, value: g }), Oe(this, e, v), this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */
    format() {
      if (this.type === "array")
        throw new Error("");
      if (this.type === "dynamicArray")
        throw new Error("");
      return this.type === "tuple" ? `tuple(${this.value.map((c) => c.format()).join(",")})` : this.type;
    }
    /**
     *  The default value returned by this type.
     */
    defaultValue() {
      return 0;
    }
    /**
     *  The minimum value for numeric types.
     */
    minValue() {
      return 0;
    }
    /**
     *  The maximum value for numeric types.
     */
    maxValue() {
      return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */
    isBigInt() {
      return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */
    isData() {
      return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */
    isString() {
      return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */
    get tupleName() {
      if (this.type !== "tuple")
        throw TypeError("not a tuple");
      return oe(this, e);
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */
    get arrayLength() {
      if (this.type !== "array")
        throw TypeError("not an array");
      return oe(this, e) === !0 ? -1 : oe(this, e) === !1 ? this.value.length : null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */
    static from(c, p) {
      return new uo(r, c, p);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
    static uint8(c) {
      return n(c, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */
    static uint16(c) {
      return n(c, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */
    static uint24(c) {
      return n(c, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */
    static uint32(c) {
      return n(c, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */
    static uint40(c) {
      return n(c, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */
    static uint48(c) {
      return n(c, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */
    static uint56(c) {
      return n(c, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */
    static uint64(c) {
      return n(c, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */
    static uint72(c) {
      return n(c, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */
    static uint80(c) {
      return n(c, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */
    static uint88(c) {
      return n(c, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */
    static uint96(c) {
      return n(c, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */
    static uint104(c) {
      return n(c, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */
    static uint112(c) {
      return n(c, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */
    static uint120(c) {
      return n(c, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */
    static uint128(c) {
      return n(c, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */
    static uint136(c) {
      return n(c, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */
    static uint144(c) {
      return n(c, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */
    static uint152(c) {
      return n(c, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */
    static uint160(c) {
      return n(c, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */
    static uint168(c) {
      return n(c, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */
    static uint176(c) {
      return n(c, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */
    static uint184(c) {
      return n(c, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */
    static uint192(c) {
      return n(c, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */
    static uint200(c) {
      return n(c, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */
    static uint208(c) {
      return n(c, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */
    static uint216(c) {
      return n(c, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */
    static uint224(c) {
      return n(c, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */
    static uint232(c) {
      return n(c, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */
    static uint240(c) {
      return n(c, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */
    static uint248(c) {
      return n(c, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
    static uint256(c) {
      return n(c, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
    static uint(c) {
      return n(c, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */
    static int8(c) {
      return n(c, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */
    static int16(c) {
      return n(c, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */
    static int24(c) {
      return n(c, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */
    static int32(c) {
      return n(c, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */
    static int40(c) {
      return n(c, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */
    static int48(c) {
      return n(c, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */
    static int56(c) {
      return n(c, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */
    static int64(c) {
      return n(c, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */
    static int72(c) {
      return n(c, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */
    static int80(c) {
      return n(c, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */
    static int88(c) {
      return n(c, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */
    static int96(c) {
      return n(c, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */
    static int104(c) {
      return n(c, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */
    static int112(c) {
      return n(c, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */
    static int120(c) {
      return n(c, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */
    static int128(c) {
      return n(c, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */
    static int136(c) {
      return n(c, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */
    static int144(c) {
      return n(c, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */
    static int152(c) {
      return n(c, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */
    static int160(c) {
      return n(c, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */
    static int168(c) {
      return n(c, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */
    static int176(c) {
      return n(c, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */
    static int184(c) {
      return n(c, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */
    static int192(c) {
      return n(c, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */
    static int200(c) {
      return n(c, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */
    static int208(c) {
      return n(c, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */
    static int216(c) {
      return n(c, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */
    static int224(c) {
      return n(c, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */
    static int232(c) {
      return n(c, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */
    static int240(c) {
      return n(c, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */
    static int248(c) {
      return n(c, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
    static int256(c) {
      return n(c, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
    static int(c) {
      return n(c, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */
    static bytes1(c) {
      return s(c, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */
    static bytes2(c) {
      return s(c, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */
    static bytes3(c) {
      return s(c, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */
    static bytes4(c) {
      return s(c, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */
    static bytes5(c) {
      return s(c, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */
    static bytes6(c) {
      return s(c, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */
    static bytes7(c) {
      return s(c, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */
    static bytes8(c) {
      return s(c, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */
    static bytes9(c) {
      return s(c, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */
    static bytes10(c) {
      return s(c, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */
    static bytes11(c) {
      return s(c, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */
    static bytes12(c) {
      return s(c, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */
    static bytes13(c) {
      return s(c, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */
    static bytes14(c) {
      return s(c, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */
    static bytes15(c) {
      return s(c, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */
    static bytes16(c) {
      return s(c, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */
    static bytes17(c) {
      return s(c, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */
    static bytes18(c) {
      return s(c, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */
    static bytes19(c) {
      return s(c, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */
    static bytes20(c) {
      return s(c, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */
    static bytes21(c) {
      return s(c, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */
    static bytes22(c) {
      return s(c, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */
    static bytes23(c) {
      return s(c, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */
    static bytes24(c) {
      return s(c, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */
    static bytes25(c) {
      return s(c, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */
    static bytes26(c) {
      return s(c, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */
    static bytes27(c) {
      return s(c, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */
    static bytes28(c) {
      return s(c, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */
    static bytes29(c) {
      return s(c, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */
    static bytes30(c) {
      return s(c, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */
    static bytes31(c) {
      return s(c, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */
    static bytes32(c) {
      return s(c, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */
    static address(c) {
      return new uo(r, "address", c);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */
    static bool(c) {
      return new uo(r, "bool", !!c);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */
    static bytes(c) {
      return new uo(r, "bytes", c);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */
    static string(c) {
      return new uo(r, "string", c);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */
    static array(c, p) {
      throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */
    static tuple(c, p) {
      throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
    static overrides(c) {
      return new uo(r, "overrides", Object.assign({}, c));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */
    static isTyped(c) {
      return c && typeof c == "object" && "_typedSymbol" in c && c._typedSymbol === i;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */
    static dereference(c, p) {
      if (uo.isTyped(c)) {
        if (c.type !== p)
          throw new Error(`invalid type: expecetd ${p}, got ${c.type}`);
        return c.value;
      }
      return c;
    }
  };
  e = /* @__PURE__ */ new WeakMap();
  let f = a;
  return Tc.Typed = f, Tc;
}
var Yy;
function DT() {
  if (Yy)
    return bc;
  Yy = 1, Object.defineProperty(bc, "__esModule", { value: !0 }), bc.AddressCoder = void 0;
  const e = Yr(), t = hd(), r = ro(), n = Ji();
  class s extends n.Coder {
    constructor(a) {
      super("address", "address", a, !1);
    }
    defaultValue() {
      return "0x0000000000000000000000000000000000000000";
    }
    encode(a, f) {
      let d = r.Typed.dereference(f, "string");
      try {
        d = (0, e.getAddress)(d);
      } catch (c) {
        return this._throwError(c.message, f);
      }
      return a.writeValue(d);
    }
    decode(a) {
      return (0, e.getAddress)((0, t.toBeHex)(a.readValue(), 20));
    }
  }
  return bc.AddressCoder = s, bc;
}
var xs = {}, kc = {}, Xy;
function jT() {
  if (Xy)
    return kc;
  Xy = 1, Object.defineProperty(kc, "__esModule", { value: !0 }), kc.AnonymousCoder = void 0;
  const e = Ji();
  class t extends e.Coder {
    constructor(n) {
      super(n.name, n.type, "_", n.dynamic), Be(this, "coder"), this.coder = n;
    }
    defaultValue() {
      return this.coder.defaultValue();
    }
    encode(n, s) {
      return this.coder.encode(n, s);
    }
    decode(n) {
      return this.coder.decode(n);
    }
  }
  return kc.AnonymousCoder = t, kc;
}
var e2;
function F5() {
  if (e2)
    return xs;
  e2 = 1, Object.defineProperty(xs, "__esModule", { value: !0 }), xs.ArrayCoder = xs.unpack = xs.pack = void 0;
  const e = wt(), t = ro(), r = Ji(), n = jT();
  function s(f, d, c) {
    let p = [];
    if (Array.isArray(c))
      p = c;
    else if (c && typeof c == "object") {
      let S = {};
      p = d.map((j) => {
        const B = j.localName;
        return (0, e.assert)(B, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder: j }, value: c }), (0, e.assert)(!S[B], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder: j }, value: c }), S[B] = !0, c[B];
      });
    } else
      (0, e.assertArgument)(!1, "invalid tuple value", "tuple", c);
    (0, e.assertArgument)(d.length === p.length, "types/value length mismatch", "tuple", c);
    let g = new r.Writer(), v = new r.Writer(), O = [];
    d.forEach((S, j) => {
      let B = p[j];
      if (S.dynamic) {
        let M = v.length;
        S.encode(v, B);
        let I = g.writeUpdatableValue();
        O.push((A) => {
          I(A + M);
        });
      } else
        S.encode(g, B);
    }), O.forEach((S) => {
      S(g.length);
    });
    let N = f.appendWriter(g);
    return N += f.appendWriter(v), N;
  }
  xs.pack = s;
  function i(f, d) {
    let c = [], p = [], g = f.subReader(0);
    return d.forEach((v) => {
      let O = null;
      if (v.dynamic) {
        let N = f.readIndex(), S = g.subReader(N);
        try {
          O = v.decode(S);
        } catch (j) {
          if ((0, e.isError)(j, "BUFFER_OVERRUN"))
            throw j;
          O = j, O.baseType = v.name, O.name = v.localName, O.type = v.type;
        }
      } else
        try {
          O = v.decode(f);
        } catch (N) {
          if ((0, e.isError)(N, "BUFFER_OVERRUN"))
            throw N;
          O = N, O.baseType = v.name, O.name = v.localName, O.type = v.type;
        }
      if (O == null)
        throw new Error("investigate");
      c.push(O), p.push(v.localName || null);
    }), r.Result.fromItems(c, p);
  }
  xs.unpack = i;
  class a extends r.Coder {
    constructor(d, c, p) {
      const g = d.type + "[" + (c >= 0 ? c : "") + "]", v = c === -1 || d.dynamic;
      super("array", g, p, v), Be(this, "coder"), Be(this, "length"), (0, e.defineProperties)(this, { coder: d, length: c });
    }
    defaultValue() {
      const d = this.coder.defaultValue(), c = [];
      for (let p = 0; p < this.length; p++)
        c.push(d);
      return c;
    }
    encode(d, c) {
      const p = t.Typed.dereference(c, "array");
      Array.isArray(p) || this._throwError("expected array value", p);
      let g = this.length;
      g === -1 && (g = p.length, d.writeValue(p.length)), (0, e.assertArgumentCount)(p.length, g, "coder array" + (this.localName ? " " + this.localName : ""));
      let v = [];
      for (let O = 0; O < p.length; O++)
        v.push(this.coder);
      return s(d, v, p);
    }
    decode(d) {
      let c = this.length;
      c === -1 && (c = d.readIndex(), (0, e.assert)(c * r.WordSize <= d.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: d.bytes, offset: c * r.WordSize, length: d.dataLength }));
      let p = [];
      for (let g = 0; g < c; g++)
        p.push(new n.AnonymousCoder(this.coder));
      return i(d, p);
    }
  }
  return xs.ArrayCoder = a, xs;
}
var Sc = {}, t2;
function LT() {
  if (t2)
    return Sc;
  t2 = 1, Object.defineProperty(Sc, "__esModule", { value: !0 }), Sc.BooleanCoder = void 0;
  const e = ro(), t = Ji();
  class r extends t.Coder {
    constructor(s) {
      super("bool", "bool", s, !1);
    }
    defaultValue() {
      return !1;
    }
    encode(s, i) {
      const a = e.Typed.dereference(i, "bool");
      return s.writeValue(a ? 1 : 0);
    }
    decode(s) {
      return !!s.readValue();
    }
  }
  return Sc.BooleanCoder = r, Sc;
}
var Yo = {}, r2;
function U5() {
  if (r2)
    return Yo;
  r2 = 1, Object.defineProperty(Yo, "__esModule", { value: !0 }), Yo.BytesCoder = Yo.DynamicBytesCoder = void 0;
  const e = wt(), t = Ji();
  class r extends t.Coder {
    constructor(i, a) {
      super(i, i, a, !0);
    }
    defaultValue() {
      return "0x";
    }
    encode(i, a) {
      a = (0, e.getBytesCopy)(a);
      let f = i.writeValue(a.length);
      return f += i.writeBytes(a), f;
    }
    decode(i) {
      return i.readBytes(i.readIndex(), !0);
    }
  }
  Yo.DynamicBytesCoder = r;
  class n extends r {
    constructor(i) {
      super("bytes", i);
    }
    decode(i) {
      return (0, e.hexlify)(super.decode(i));
    }
  }
  return Yo.BytesCoder = n, Yo;
}
var Mc = {}, n2;
function HT() {
  if (n2)
    return Mc;
  n2 = 1, Object.defineProperty(Mc, "__esModule", { value: !0 }), Mc.FixedBytesCoder = void 0;
  const e = wt(), t = ro(), r = Ji();
  class n extends r.Coder {
    constructor(i, a) {
      let f = "bytes" + String(i);
      super(f, f, a, !1), Be(this, "size"), (0, e.defineProperties)(this, { size: i }, { size: "number" });
    }
    defaultValue() {
      return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(i, a) {
      let f = (0, e.getBytesCopy)(t.Typed.dereference(a, this.type));
      return f.length !== this.size && this._throwError("incorrect data length", a), i.writeBytes(f);
    }
    decode(i) {
      return (0, e.hexlify)(i.readBytes(this.size));
    }
  }
  return Mc.FixedBytesCoder = n, Mc;
}
var Ic = {}, i2;
function WT() {
  if (i2)
    return Ic;
  i2 = 1, Object.defineProperty(Ic, "__esModule", { value: !0 }), Ic.NullCoder = void 0;
  const e = Ji(), t = new Uint8Array([]);
  class r extends e.Coder {
    constructor(s) {
      super("null", "", s, !1);
    }
    defaultValue() {
      return null;
    }
    encode(s, i) {
      return i != null && this._throwError("not null", i), s.writeBytes(t);
    }
    decode(s) {
      return s.readBytes(0), null;
    }
  }
  return Ic.NullCoder = r, Ic;
}
var Rc = {}, s2;
function GT() {
  if (s2)
    return Rc;
  s2 = 1, Object.defineProperty(Rc, "__esModule", { value: !0 }), Rc.NumberCoder = void 0;
  const e = wt(), t = ro(), r = Ji(), n = BigInt(0), s = BigInt(1), i = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
  class a extends r.Coder {
    constructor(d, c, p) {
      const g = (c ? "int" : "uint") + d * 8;
      super(g, g, p, !1), Be(this, "size"), Be(this, "signed"), (0, e.defineProperties)(this, { size: d, signed: c }, { size: "number", signed: "boolean" });
    }
    defaultValue() {
      return 0;
    }
    encode(d, c) {
      let p = (0, e.getBigInt)(t.Typed.dereference(c, this.type)), g = (0, e.mask)(i, r.WordSize * 8);
      if (this.signed) {
        let v = (0, e.mask)(g, this.size * 8 - 1);
        (p > v || p < -(v + s)) && this._throwError("value out-of-bounds", c), p = (0, e.toTwos)(p, 8 * r.WordSize);
      } else
        (p < n || p > (0, e.mask)(g, this.size * 8)) && this._throwError("value out-of-bounds", c);
      return d.writeValue(p);
    }
    decode(d) {
      let c = (0, e.mask)(d.readValue(), this.size * 8);
      return this.signed && (c = (0, e.fromTwos)(c, this.size * 8)), c;
    }
  }
  return Rc.NumberCoder = a, Rc;
}
var Cc = {}, o2;
function zT() {
  if (o2)
    return Cc;
  o2 = 1, Object.defineProperty(Cc, "__esModule", { value: !0 }), Cc.StringCoder = void 0;
  const e = v1(), t = ro(), r = U5();
  class n extends r.DynamicBytesCoder {
    constructor(i) {
      super("string", i);
    }
    defaultValue() {
      return "";
    }
    encode(i, a) {
      return super.encode(i, (0, e.toUtf8Bytes)(t.Typed.dereference(a, "string")));
    }
    decode(i) {
      return (0, e.toUtf8String)(super.decode(i));
    }
  }
  return Cc.StringCoder = n, Cc;
}
var Bc = {}, a2;
function VT() {
  if (a2)
    return Bc;
  a2 = 1, Object.defineProperty(Bc, "__esModule", { value: !0 }), Bc.TupleCoder = void 0;
  const e = ru(), t = ro(), r = Ji(), n = F5();
  class s extends r.Coder {
    constructor(a, f) {
      let d = !1;
      const c = [];
      a.forEach((g) => {
        g.dynamic && (d = !0), c.push(g.type);
      });
      const p = "tuple(" + c.join(",") + ")";
      super("tuple", p, f, d), Be(this, "coders"), (0, e.defineProperties)(this, { coders: Object.freeze(a.slice()) });
    }
    defaultValue() {
      const a = [];
      this.coders.forEach((d) => {
        a.push(d.defaultValue());
      });
      const f = this.coders.reduce((d, c) => {
        const p = c.localName;
        return p && (d[p] || (d[p] = 0), d[p]++), d;
      }, {});
      return this.coders.forEach((d, c) => {
        let p = d.localName;
        !p || f[p] !== 1 || (p === "length" && (p = "_length"), a[p] == null && (a[p] = a[c]));
      }), Object.freeze(a);
    }
    encode(a, f) {
      const d = t.Typed.dereference(f, "tuple");
      return (0, n.pack)(a, this.coders, d);
    }
    decode(a) {
      return (0, n.unpack)(a, this.coders);
    }
  }
  return Bc.TupleCoder = s, Bc;
}
var Wr = {}, u2 = {}, _c = {}, c2;
function D5() {
  if (c2)
    return _c;
  c2 = 1, Object.defineProperty(_c, "__esModule", { value: !0 }), _c.id = void 0;
  const e = cn(), t = wt();
  function r(n) {
    return (0, e.keccak256)((0, t.toUtf8Bytes)(n));
  }
  return _c.id = r, _c;
}
var Ai = {}, jn = {}, l2;
function qT() {
  if (l2)
    return jn;
  l2 = 1;
  var e = "AEEUdwmgDS8BxQKKAP4BOgDjATAAngDUAIMAoABoAOAAagCOAEQAhABMAHIAOwA9ACsANgAmAGIAHgAuACgAJwAXAC0AGgAjAB8ALwAUACkAEgAeAAkAGwARABkAFgA5ACgALQArADcAFQApABAAHgAiABAAGgAeABMAGAUhBe8BFxREN8sF2wC5AK5HAW8ArQkDzQCuhzc3NzcBP68NEfMABQdHBuw5BV8FYAA9MzkI9r4ZBg7QyQAWA9CeOwLNCjcCjqkChuA/lm+RAsXTAoP6ASfnEQDytQFJAjWVCkeXAOsA6godAB/cwdAUE0WlBCN/AQUCQRjFD/MRBjHxDQSJbw0jBzUAswBxme+tnIcAYwabAysG8QAjAEMMmxcDqgPKQyDXCMMxA7kUQwD3NXOrAKmFIAAfBC0D3x4BJQDBGdUFAhEgVD8JnwmQJiNWYUzrg0oAGwAUAB0AFnNcACkAFgBP9h3gPfsDOWDKneY2ChglX1UDYD30ABsAFAAdABZzIGRAnwDD8wAjAEEMzRbDqgMB2sAFYwXqAtCnAsS4AwpUJKRtFHsadUz9AMMVbwLpABM1NJEX0ZkCgYMBEyMAxRVvAukAEzUBUFAtmUwSAy4DBTER33EftQHfSwB5MxJ/AjkWKQLzL8E/cwBB6QH9LQDPDtO9ASNriQC5DQANAwCK21EFI91zHwCoL9kBqQcHBwcHKzUDowBvAQohPvU3fAQgHwCyAc8CKQMA5zMSezr7ULgFmDp/LzVQBgEGAi8FYQVgt8AFcTtlQhpCWEmfe5tmZ6IAExsDzQ8t+X8rBKtTAltbAn0jsy8Bl6utPWMDTR8Ei2kRANkDBrNHNysDBzECQWUAcwFpJ3kAiyUhAJ0BUb8AL3EfAbfNAz81KUsFWwF3YQZtAm0A+VEfAzEJDQBRSQCzAQBlAHsAM70GD/v3IZWHBwARKQAxALsjTwHZAeMPEzmXgIHwABIAGQA8AEUAQDt3gdvIEGcQZAkGTRFMdEIVEwK0D64L7REdDNkq09PgADSxB/MDWwfzA1sDWwfzB/MDWwfzA1sDWwNbA1scEvAi28gQZw9QBHUFlgWTBN4IiyZREYkHMAjaVBV0JhxPA00BBCMtSSQ7mzMTJUpMFE0LCAQ2SmyvfUADTzGzVP2QqgPTMlc5dAkGHnkSqAAyD3skNb1OhnpPcagKU0+2tYdJak5vAsY6sEAACikJm2/Dd1YGRRAfJ6kQ+ww3AbkBPw3xS9wE9QY/BM0fgRkdD9GVoAipLeEM8SbnLqWAXiP5KocF8Uv4POELUVFsD10LaQnnOmeBUgMlAREijwrhDT0IcRD3Cs1vDekRSQc9A9lJngCpBwULFR05FbkmFGKwCw05ewb/GvoLkyazEy17AAXXGiUGUQEtGwMA0y7rhbRaNVwgT2MGBwspI8sUrFAkDSlAu3hMGh8HGSWtApVDdEqLUToelyH6PEENai4XUYAH+TwJGVMLhTyiRq9FEhHWPpE9TCJNTDAEOYMsMyePCdMPiQy9fHYBXQklCbUMdRM1ERs3yQg9Bx0xlygnGQglRplgngT7owP3E9UDDwVDCUUHFwO5HDETMhUtBRGBKNsC9zbZLrcCk1aEARsFzw8pH+MQVEfkDu0InwJpA4cl7wAxFSUAGyKfCEdnAGOP3FMJLs8Iy2pwI3gDaxTrZRF3B5UOWwerHDcVwxzlcMxeD4YMKKezCV8BeQmdAWME5wgNNV+MpCBFZ1eLXBifIGVBQ14AAjUMaRWjRMGHfAKPD28SHwE5AXcHPQ0FAnsR8RFvEJkI74YINbkz/DopBFMhhyAVCisDU2zSCysm/Qz8bQGnEmYDEDRBd/Jnr2C6KBgBBx0yyUFkIfULlk/RDKAaxRhGVDIZ6AfDA/ca9yfuQVsGAwOnBxc6UTPyBMELbQiPCUMATQ6nGwfbGG4KdYzUATWPAbudA1uVhwJzkwY7Bw8Aaw+LBX3pACECqwinAAkA0wNbAD0CsQehAB0AiUUBQQMrMwEl6QKTA5cINc8BmTMB9y0EH8cMGQD7O25OAsO1AoBuZqYF4VwCkgJNOQFRKQQJUktVA7N15QDfAE8GF+NLARmvTs8e50cB43MvAMsA/wAJOQcJRQHRAfdxALsBYws1Caa3uQFR7S0AhwAZbwHbAo0A4QA5AIP1AVcAUQVd/QXXAlNNARU1HC9bZQG/AyMBNwERAH0Gz5GpzQsjBHEH1wIQHxXlAu8yB7kFAyLjE9FCyQK94lkAMhoKPAqrCqpgX2Q3CjV2PVQAEh+sPss/UgVVO1c7XDtXO1w7VztcO1c7XDtXO1wDm8Pmw+YKcF9JYe8Mqg3YRMw6TRPfYFVgNhPMLbsUxRXSJVoZQRrAJwkl6FUNDwgt12Y0CDA0eRfAAEMpbINFY4oeNApPHOtTlVT8LR8AtUumM7MNsBsZREQFS3XxYi4WEgomAmSFAmJGX1GzAV83JAKh+wJonAJmDQKfiDgfDwJmPwJmKgRyBIMDfxcDfpY5Cjl7GzmGOicnAmwhAjI6OA4CbcsCbbLzjgM3a0kvAWsA4gDlAE4JB5wMkQECD8YAEbkCdzMCdqZDAnlPRwJ4viFg30WyRvcCfEMCeswCfQ0CfPRIBEiBZygALxlJXEpfGRtK0ALRBQLQ0EsrA4hTA4fqRMmRNgLypV0HAwOyS9JMMSkH001QTbMCi0MCitzFHwshR2sJuwKOOwKOYESbhQKO3QKOYHxRuFM5AQ5S2FSJApP/ApMQAO0AIFUiVbNV1AosHymZijLleGpFPz0Cl6MC77ZYJawAXSkClpMCloCgAK1ZsFoNhVEAPwKWuQKWUlxIXNUCmc8CmWhczl0LHQKcnznGOqECnBoCn58CnryOACETNS4TAp31Ap6WALlBYThh8wKe1wKgcgGtAp6jIwKeUqljzGQrKS8CJ7MCJoICoP8CoFDbAqYzAqXSAqgDAIECp/ZogGi1AAdNaiBq1QKs5wKssgKtawKtBgJXIQJV4AKx5dsDH1JsmwKywRECsuwbbORtZ21MYwMl0QK2YD9DbpQDKUkCuGICuUsZArkue3A6cOUCvR0DLbYDMhUCvoxyBgMzdQK+HnMmc1MCw88CwwhzhnRPOUl05AM8qwEDPJ4DPcMCxYACxksCxhSNAshtVQLISALJUwLJMgJkoQLd1nh9ZXiyeSlL1AMYp2cGAmH4GfeVKHsPXpZevxUCz28Cz3AzT1fW9xejAMqxAs93AS3uA04Wfk8JAtwrAtuOAtJTA1JgA1NjAQUDVZCAjUMEzxrxZEl5A4LSg5EC2ssC2eKEFIRNp0ADhqkAMwNkEoZ1Xf0AWQLfaQLevHd7AuIz7RgB8zQrAfSfAfLWiwLr9wLpdH0DAur9AuroAP1LAb0C7o0C66CWrpcHAu5DA4XkmH1w5HGlAvMHAG0DjhqZlwL3FwORcgOSiwL3nAL53QL4apogmq+/O5siA52HAv7+AR8APZ8gAZ+3AwWRA6ZuA6bdANXJAwZuoYyiCQ0DDE0BEwEjB3EGZb1rCQC/BG/DFY8etxEAG3k9ACcDNxJRA42DAWcrJQCM8wAlAOanC6OVCLsGI6fJBgCvBRnDBvElRUYFFoAFcD9GSDNCKUK8X3kZX8QAls0FOgCQVCGbwTsuYDoZutcONxjOGJHJ/gVfBWAFXwVgBWsFYAVfBWAFXwVgBV8FYAVfBWBOHQjfjW8KCgoKbF7xMwTRA7kGN8PDAMMEr8MA70gxFroFTj5xPnhCR0K+X30/X/AAWBkzswCNBsxzzASm70aCRS4rDDMeLz49fnXfcsH5GcoscQFz13Y4HwVnBXLJycnACNdRYwgICAqEXoWTxgA7P4kACxbZBu21Kw0AjMsTAwkVAOVtJUUsJ1JCuULESUArXy9gPi9AKwnJRQYKTD9LPoA+iT54PnkCkULEUUpDX9NWV3JVEjQAc1w3A3IBE3YnX+g7QiMJb6MKaiszRCUuQrNCxDPMCcwEX9EWJzYREBEEBwIHKn6l33JCNVIfybPJtAltydPUCmhBZw/tEKsZAJOVJU1CLRuxbUHOQAo7P0s+eEJHHA8SJVRPdGM0NVrpvBoKhfUlM0JHHGUQUhEWO1xLSj8MO0ucNAqJIzVCRxv9EFsqKyA4OQgNj2nwZgp5ZNFgE2A1K3YHS2AhQQojJmC7DgpzGG1WYFUZCQYHZO9gHWCdYIVgu2BTYJlwFh8GvRbcXbG8YgtDHrMBwzPVyQonHQgkCyYBgQJ0Ajc4nVqIAwGSCsBPIgDsK3SWEtIVBa5N8gGjAo+kVwVIZwD/AEUSCDweX4ITrRQsJ8K3TwBXFDwEAB0TvzVcAtoTS20RIwDgVgZ9BBImYgA5AL4Coi8LFnezOkCnIQFjAY4KBAPh9RcGsgZSBsEAJctdsWIRu2kTkQstRw7DAcMBKgpPBGIGMDAwKCYnKTQaLg4AKRSVAFwCdl+YUZ0JdicFD3lPAdt1F9ZZKCGxuE3yBxkFVGcA/wBFEgiCBwAOLHQSjxOtQDg1z7deFRMAZ8QTAGtKb1ApIiPHADkAvgKiLy1DFtYCmBiDAlDDWNB0eo7fpaMO/aEVRRv0ATEQZBIODyMEAc8JQhCbDRgzFD4TAEMAu9YBCgCsAOkAm5I3ABwAYxvONnR+MhXJAxgKQyxL2+kkJhMbhQKDBMkSsvF0AD9BNQ6uQC7WqSQHwxEAEEIu1hkhAH2z4iQPwyJPHNWpdyYBRSpnJALzoBAEVPPsH20MxA0CCEQKRgAFyAtFAlMNwwjEDUQJRArELtapMg7DDZgJIw+TGukEIwvDFkMAqAtDEMMMBhioe+QAO3MMRAACrgnEBSPY9Q0FDnbSBoMAB8MSYxkSxAEJAPIJAAB8FWMOFtMc/HcXwxhDAC7DAvOowwAewwJdKDKHAAHDAALrFUQVwwAbwyvzpWMWv8wA/ABpAy++bcYDUKPD0KhDCwKmJ1MAAmMA5+UZwxAagwipBRL/eADfw6fDGOMCGsOjk3l6BwOpo4sAEsMOGxMAA5sAbcMOAAvDp0MJGkMDwgipnNIPAwfIqUMGAOGDAAPzABXDAAcDAAnDAGmTABrDAA7DChjDjnEWAwABYwAOcwAuUyYABsMAF8MIKQANUgC6wy4AA8MADqMq8wCyYgAcIwAB8wqpAAXOCx0V4wAHowBCwwEKAGnDAAuDAB3DAAjDCakABdIAbqcZ3QCZCCkABdIAAAFDAAfjAB2jCCkABqIACYMAGzMAbSMA5sOIAAhjAAhDABTDBAkpAAbSAOOTAAlDC6kOzPtnAAdDAG6kQFAATwAKwwwAA0MACbUDPwAHIwAZgwACE6cDAAojAApDAAoDp/MGwwAJIwADEwAQQwgAFEMAEXMAD5MADfMADcMAGRMOFiMAFUMAbqMWuwHDAMIAE0MLAGkzEgDhUwACQwAEWgAXgwUjAAbYABjDBSYBgzBaAEFNALcQBxUMegAwMngBrA0IZgJ0KxQHBREPd1N0ZzKRJwaIHAZqNT4DqQq8BwngAB4DAwt2AX56T1ocKQNXAh1GATQGC3tOxYNagkgAMQA5CQADAQEAWxLjAIOYNAEzAH7tFRk6TglSAF8NAAlYAQ+S1ACAQwQorQBiAN4dAJ1wPyeTANVzuQDX3AIeEMp9eyMgXiUAEdkBkJizKltbVVAaRMqRAAEAhyQ/SDEz6BmfVwB6ATEsOClKIRcDOF0E/832AFNt5AByAnkCRxGCOs94NjXdAwINGBonDBwPALW2AwICAgAAAAAAAAYDBQMDARrUAwAtAAAAAgEGBgYGBgYFBQUFBQUEBQYHCAkEBQUFBQQAAAICAAAAIgCNAJAAlT0A6gC7ANwApEQAwgCyAK0AqADuAKYA2gCjAOcBCAEDAMcAgQBiANIA1AEDAN4A8gCQAKkBMQDqAN8A3AsBCQ8yO9ra2tq8xuLT1tRJOB0BUgFcNU0BWgFpAWgBWwFMUUlLbhMBUxsNEAs6PhMOACcUKy0vMj5AQENDQ0RFFEYGJFdXV1dZWVhZL1pbXVxcI2NnZ2ZoZypsbnZ1eHh4eHh4enp6enp6enp6enp8fH18e2IARPIASQCaAHgAMgBm+ACOAFcAVwA3AnbvAIsABfj4AGQAk/IAnwBPAGIAZP//sACFAIUAaQBWALEAJAC2AIMCQAJDAPwA5wD+AP4A6AD/AOkA6QDoAOYALwJ7AVEBQAE+AVQBPgE+AT4BOQE4ATgBOAEcAVgXADEQCAEAUx8SHgsdHhYAjgCWAKYAUQBqIAIxAHYAbwCXAxUDJzIDIUlGTzEAkQJPAMcCVwKkAMAClgKWApYClgKWApYCiwKWApYClgKWApYClgKVApUCmAKgApcClgKWApQClAKUApQCkgKVAnUB1AKXAp8ClgKWApUeAIETBQD+DQOfAmECOh8BVBg9AuIZEjMbAU4/G1WZAXusRAFpYQEFA0FPAQYAmTEeIJdyADFoAHEANgCRA5zMk/C2jGINwjMWygIZCaXdfDILBCs5dAE7YnQBugDlhoiHhoiGiYqKhouOjIaNkI6Ij4qQipGGkoaThpSSlYaWhpeKmIaZhpqGm4aci52QnoqfhuIC4XTpAt90AIp0LHSoAIsAdHQEQwRABEIERQRDBEkERgRBBEcESQRIBEQERgRJAJ5udACrA490ALxuAQ10ANFZdHQA13QCFHQA/mJ0AP4BIQD+APwA/AD9APwDhGZ03ASMK23HAP4A/AD8AP0A/CR0dACRYnQA/gCRASEA/gCRAvQA/gCRA4RmdNwEjCttxyR0AP9idAEhAP4A/gD8APwA/QD8AP8A/AD8AP0A/AOEZnTcBIwrbcckdHQAkWJ0ASEA/gCRAP4AkQL0AP4AkQOEZnTcBIwrbcckdAJLAT50AlIBQXQCU8l0dAJfdHQDpgL0A6YDpgOnA6cDpwOnA4RmdNwEjCttxyR0dACRYnQBIQOmAJEDpgCRAvQDpgCRA4RmdNwEjCttxyR0BDh0AJEEOQCRDpU5dSgCADR03gV2CwArdAEFAM5iCnR0AF1iAAYcOgp0dACRCnQAXAEIwWZ0CnRmdHQAkWZ0CnRmdEXgAFF03gp0dEY0tlT2u3SOAQTwscwhjZZKrhYcBSfFp9XNbKiVDOD2b+cpe4/Z17mQnbtzzhaeQtE2GGj0IDNTjRUSyTxxw/RPHW/+vS7d1NfRt9z9QPZg4X7QFfhCnkvgNPIItOsC2eV6hPannZNHlZ9xrwZXIMOlu3jSoQSq78WEjwLjw1ELSlF1aBvfzwk5ZX7AUvQzjPQKbDuQ+sm4wNOp4A6AdVuRS0t1y/DZpg4R6m7FNjM9HgvW7Bi88zaMjOo6lM8wtBBdj8LP4ylv3zCXPhebMKJc066o9sF71oFW/8JXu86HJbwDID5lzw5GWLR/LhT0Qqnp2JQxNZNfcbLIzPy+YypqRm/lBmGmex+82+PisxUumSeJkALIT6rJezxMH+CTJmQtt5uwTVbL3ptmjDUQzlSIvWi8Tl7ng1NpuRn1Ng4n14Qc+3Iil7OwkvNWogLSPkn3pihIFytyIGmMhOe3n1tWsuMy9BdKyqF4Z3v2SgggTL9KVvMXPnCbRe+oOuFFP3HejBG/w9gvmfNYvg6JuWia2lcSSN1uIjBktzoIazOHPJZ7kKHPz8mRWVdW3lA8WGF9dQF6Bm673boov3BUWDU2JNcahR23GtfHKLOz/viZ+rYnZFaIznXO67CYEJ1fXuTRpZhYZkKe54xeoagkNGLs+NTZHE0rX45/XvQ2RGADX6vcAvdxIUBV27wxGm2zjZo4X3ILgAlrOFheuZ6wtsvaIj4yLY7qqawlliaIcrz2G+c3vscAnCkCuMzMmZvMfu9lLwTvfX+3cVSyPdN9ZwgDZhfjRgNJcLiJ67b9xx8JHswprbiE3v9UphotAPIgnXVIN5KmMc0piXhc6cChPnN+MRhG9adtdttQTTwSIpl8I4/j//d3sz1326qTBTpPRM/Hgh3kzqEXs8ZAk4ErQhNO8hzrQ0DLkWMA/N+91tn2MdOJnWC2FCZehkQrwzwbKOjhvZsbM95QoeL9skYyMf4srVPVJSgg7pOLUtr/n9eT99oe9nLtFRpjA9okV2Kj8h9k5HaC0oivRD8VyXkJ81tcd4fHNXPCfloIQasxsuO18/46dR2jgul/UIet2G0kRvnyONMKhHs6J26FEoqSqd+rfYjeEGwHWVDpX1fh1jBBcKGMqRepju9Y00mDVHC+Xdij/j44rKfvfjGinNs1jO/0F3jB83XCDINN/HB84axlP+3E/klktRo+vl3U/aiyMJbIodE1XSsDn6UAzIoMtUObY2+k/4gY/l+AkZJ5Sj2vQrkyLm3FoxjhDX+31UXBFf9XrAH31fFqoBmDEZvhvvpnZ87N+oZEu7U9O/nnk+QWj3x8uyoRbEnf+O5UMr9i0nHP38IF5AvzrBW8YWBUR0mIAzIvndQq9N3v/Jto3aPjPXUPl8ASdPPyAp7jENf8bk7VMM9ol9XGmlBmeDMuGqt+WzuL6CXAxXjIhCPM5vACchgMJ/8XBGLO/D1isVvGhwwHHr1DLaI5mn2Jr/b1pUD90uciDaS8cXNDzCWvNmT/PhQe5e8nTnnnkt8Ds/SIjibcum/fqDhKopxAY8AkSrPn+IGDEKOO+U3XOP6djFs2H5N9+orhOahiQk5KnEUWa+CzkVzhp8bMHRbg81qhjjXuIKbHjSLSIBKWqockGtKinY+z4/RdBUF6pcc3JmnlxVcNgrI4SEzKUZSwcD2QCyxzKve+gAmg6ZuSRkpPFa6mfThu7LJNu3H5K42uCpNvPAsoedolKV/LHe/eJ+BbaG5MG0NaSGVPRUmNFMFFSSpXEcXwbVh7UETOZZtoVNRGOIbbkig3McEtR68cG0RZAoJevWYo7Dg/lZ1CQzblWeUvVHmr8fY4Nqd9JJiH/zEX24mJviH60fAyFr0A3c4bC1j3yZU60VgJxXn8JgJXLUIsiBnmKmMYz+7yBQFBvqb2eYnuW59joZBf56/wXvWIR4R8wTmV80i1mZy+S4+BUES+hzjk0uXpC///z/IlqHZ1monzlXp8aCfhGKMti73FI1KbL1q6IKO4fuBuZ59gagjn5xU79muMpHXg6S+e+gDM/U9BKLHbl9l6o8czQKl4RUkJJiqftQG2i3BMg/TQlUYFkJDYBOOvAugYuzYSDnZbDDd/aSd9x0Oe6F+bJcHfl9+gp6L5/TgA+BdFFovbfCrQ40s5vMPw8866pNX8zyFGeFWdxIpPVp9Rg1UPOVFbFZrvaFq/YAzHQgqMWpahMYfqHpmwXfHL1/kpYmGuHFwT55mQu0dylfNuq2Oq0hTMCPwqfxnuBIPLXfci4Y1ANy+1CUipQxld/izVh16WyG2Q0CQQ9NqtAnx1HCHwDj7sYxOSB0wopZSnOzxQOcExmxrVTF2BkOthVpGfuhaGECfCJpJKpjnihY+xOT2QJxN61+9K6QSqtv2Shr82I3jgJrqBg0wELFZPjvHpvzTtaJnLK6Vb97Yn933koO/saN7fsjwNKzp4l2lJVx2orjCGzC/4ZL4zCver6aQYtC5sdoychuFE6ufOiog+VWi5UDkbmvmtah/3aArEBIi39s5ILUnlFLgilcGuz9CQshEY7fw2ouoILAYPVT/gyAIq3TFAIwVsl+ktkRz/qGfnCDGrm5gsl/l9QdvCWGsjPz3dU7XuqKfdUrr/6XIgjp4rey6AJBmCmUJMjITHVdFb5m1p+dLMCL8t55zD42cmftmLEJC0Da04YiRCVUBLLa8D071/N5UBNBXDh0LFsmhV/5B5ExOB4j3WVG/S3lfK5o+V6ELHvy6RR9n4ac+VsK4VE4yphPvV+kG9FegTBH4ZRXL2HytUHCduJazB/KykjfetYxOXTLws267aGOd+I+JhKP//+VnXmS90OD/jvLcVu0asyqcuYN1mSb6XTlCkqv1vigZPIYwNF/zpWcT1GR/6aEIRjkh0yhg4LXJfaGobYJTY4JI58KiAKgmmgAKWdl5nYCeLqavRJGQNuYuZtZFGx+IkI4w4NS2xwbetNMunOjBu/hmKCI/w7tfiiyUd//4rbTeWt4izBY8YvGIN6vyKYmP/8X8wHKCeN+WRcKM70+tXKNGyevU9H2Dg5BsljnTf8YbsJ1TmMs74Ce2XlHisleguhyeg44rQOHZuw/6HTkhnnurK2d62q6yS7210SsAIaR+jXMQA+svkrLpsUY+F30Uw89uOdGAR6vo4FIME0EfVVeHTu6eKicfhSqOeXJhbftcd08sWEnNUL1C9fnprTgd83IMut8onVUF0hvqzZfHduPjbjwEXIcoYmy+P6tcJZHmeOv6VrvEdkHDJecjHuHeWANe79VG662qTjA/HCvumVv3qL+LrOcpqGps2ZGwQdFJ7PU4iuyRlBrwfO+xnPyr47s2cXVbWzAyznDiBGjCM3ksxjjqM62GE9C8f5U38kB3VjtabKp/nRdvMESPGDG90bWRLAt1Qk5DyLuazRR1YzdC1c+hZXvAWV8xA72S4A8B67vjVhbba3MMop293FeEXpe7zItMWrJG/LOH9ByOXmYnNJfjmfuX9KbrpgLOba4nZ+fl8Gbdv/ihv+6wFGKHCYrVwmhFC0J3V2bn2tIB1wCc1CST3d3X2OyxhguXcs4sm679UngzofuSeBewMFJboIQHbUh/m2JhW2hG9DIvG2t7yZIzKBTz9wBtnNC+2pCRYhSIuQ1j8xsz5VvqnyUIthvuoyyu7fNIrg/KQUVmGQaqkqZk/Vx5b33/gsEs8yX7SC1J+NV4icz6bvIE7C5G6McBaI8rVg56q5QBJWxn/87Q1sPK4+sQa8fLU5gXo4paaq4cOcQ4wR0VBHPGjKh+UlPCbA1nLXyEUX45qZ8J7/Ln4FPJE2TdzD0Z8MLSNQiykMMmSyOCiFfy84Rq60emYB2vD09KjYwsoIpeDcBDTElBbXxND72yhd9pC/1CMid/5HUMvAL27OtcIJDzNKpRPNqPOpyt2aPGz9QWIs9hQ9LiX5s8m9hjTUu/f7MyIatjjd+tSfQ3ufZxPpmJhTaBtZtKLUcfOCUqADuO+QoH8B9v6U+P0HV1GLQmtoNFTb3s74ivZgjES0qfK+8RdGgBbcCMSy8eBvh98+et1KIFqSe1KQPyXULBMTsIYnysIwiZBJYdI20vseV+wuJkcqGemehKjaAb9L57xZm3g2zX0bZ2xk/fU+bCo7TlnbW7JuF1YdURo/2Gw7VclDG1W7LOtas2LX4upifZ/23rzpsnY/ALfRgrcWP5hYmV9VxVOQA1fZvp9F2UNU+7d7xRyVm5wiLp3/0dlV7vdw1PMiZrbDAYzIVqEjRY2YU03sJhPnlwIPcZUG5ltL6S8XCxU1eYS5cjr34veBmXAvy7yN4ZjArIG0dfD/5UpBNlX1ZPoxJOwyqRi3wQWtOzd4oNKh0LkoTm8cwqgIfKhqqGOhwo71I+zXnMemTv2B2AUzABWyFztGgGULjDDzWYwJUVBTjKCn5K2QGMK1CQT7SzziOjo+BhAmqBjzuc3xYym2eedGeOIRJVyTwDw37iCMe4g5Vbnsb5ZBdxOAnMT7HU4DHpxWGuQ7GeiY30Cpbvzss55+5Km1YsbD5ea3NI9QNYIXol5apgSu9dZ8f8xS5dtHpido5BclDuLWY4lhik0tbJa07yJhH0BOyEut/GRbYTS6RfiTYWGMCkNpfSHi7HvdiTglEVHKZXaVhezH4kkXiIvKopYAlPusftpE4a5IZwvw1x/eLvoDIh/zpo9FiQInsTb2SAkKHV42XYBjpJDg4374XiVb3ws4qM0s9eSQ5HzsMU4OZJKuopFjBM+dAZEl8RUMx5uU2N486Kr141tVsGQfGjORYMCJAMsxELeNT4RmWjRcpdTGBwcx6XN9drWqPmJzcrGrH4+DRc7+n1w3kPZwu0BkNr6hQrqgo7JTB9A5kdJ/H7P4cWBMwsmuixAzJB3yrQpnGIq90lxAXLzDCdn1LPibsRt7rHNjgQBklRgPZ8vTbjXdgXrTWQsK5MdrXXQVPp0Rinq3frzZKJ0qD6Qhc40VzAraUXlob1gvkhK3vpmHgI6FRlQZNx6eRqkp0zy4AQlX813fAPtL3jMRaitGFFjo0zmErloC+h+YYdVQ6k4F/epxAoF0BmqEoKNTt6j4vQZNQ2BoqF9Vj53TOIoNmDiu9Xp15RkIgQIGcoLpfoIbenzpGUAtqFJp5W+LLnx38jHeECTJ/navKY1NWfN0sY1T8/pB8kIH3DU3DX+u6W3YwpypBMYOhbSxGjq84RZ84fWJow8pyHqn4S/9J15EcCMsXqrfwyd9mhiu3+rEo9pPpoJkdZqHjra4NvzFwuThNKy6hao/SlLw3ZADUcUp3w3SRVfW2rhl80zOgTYnKE0Hs2qp1J6H3xqPqIkvUDRMFDYyRbsFI3M9MEyovPk8rlw7/0a81cDVLmBsR2ze2pBuKb23fbeZC0uXoIvDppfTwIDxk1Oq2dGesGc+oJXWJLGkOha3CX+DUnzgAp9HGH9RsPZN63Hn4RMA5eSVhPHO+9RcRb/IOgtW31V1Q5IPGtoxPjC+MEJbVlIMYADd9aHYWUIQKopuPOHmoqSkubnAKnzgKHqgIOfW5RdAgotN6BN+O2ZYHkuemLnvQ8U9THVrS1RtLmKbcC7PeeDsYznvqzeg6VCNwmr0Yyx1wnLjyT84BZz3EJyCptD3yeueAyDWIs0L2qs/VQ3HUyqfrja0V1LdDzqAikeWuV4sc7RLIB69jEIBjCkyZedoUHqCrOvShVzyd73OdrJW0hPOuQv2qOoHDc9xVb6Yu6uq3Xqp2ZaH46A7lzevbxQEmfrzvAYSJuZ4WDk1Hz3QX1LVdiUK0EvlAGAYlG3Md30r7dcPN63yqBCIj25prpvZP0nI4+EgWoFG95V596CurXpKRBGRjQlHCvy5Ib/iW8nZJWwrET3mgd6mEhfP4KCuaLjopWs7h+MdXFdIv8dHQJgg1xi1eYqB0uDYjxwVmri0Sv5XKut/onqapC+FQiC2C1lvYJ9MVco6yDYsS3AANUfMtvtbYI2hfwZatiSsnoUeMZd34GVjkMMKA+XnjJpXgRW2SHTZplVowPmJsvXy6w3cfO1AK2dvtZEKTkC/TY9LFiKHCG0DnrMQdGm2lzlBHM9iEYynH2UcVMhUEjsc0oDBTgo2ZSQ1gzkAHeWeBXYFjYLuuf8yzTCy7/RFR81WDjXMbq2BOH5dURnxo6oivmxL3cKzKInlZkD31nvpHB9Kk7GfcfE1t+1V64b9LtgeJGlpRFxQCAqWJ5DoY77ski8gsOEOr2uywZaoO/NGa0X0y1pNQHBi3b2SUGNpcZxDT7rLbBf1FSnQ8guxGW3W+36BW0gBje4DOz6Ba6SVk0xiKgt+q2JOFyr4SYfnu+Ic1QZYIuwHBrgzr6UvOcSCzPTOo7D6IC4ISeS7zkl4h+2VoeHpnG/uWR3+ysNgPcOIXQbv0n4mr3BwQcdKJxgPSeyuP/z1Jjg4e9nUvoXegqQVIE30EHx5GHv+FAVUNTowYDJgyFhf5IvlYmEqRif6+WN1MkEJmDcQITx9FX23a4mxy1AQRsOHO/+eImX9l8EMJI3oPWzVXxSOeHU1dUWYr2uAA7AMb+vAEZSbU3qob9ibCyXeypEMpZ6863o6QPqlqGHZkuWABSTVNd4cOh9hv3qEpSx2Zy/DJMP6cItEmiBJ5PFqQnDEIt3NrA3COlOSgz43D7gpNFNJ5MBh4oFzhDPiglC2ypsNU4ISywY2erkyb1NC3Qh/IfWj0eDgZI4/ln8WPfBsT3meTjq1Uqt1E7Zl/qftqkx6aM9KueMCekSnMrcHj1CqTWWzEzPsZGcDe3Ue4Ws+XFYVxNbOFF8ezkvQGR6ZOtOLU2lQEnMBStx47vE6Pb7AYMBRj2OOfZXfisjJnpTfSNjo6sZ6qSvNxZNmDeS7Gk3yYyCk1HtKN2UnhMIjOXUzAqDv90lx9O/q/AT1ZMnit5XQe9wmQxnE/WSH0CqZ9/2Hy+Sfmpeg8RwsHI5Z8kC8H293m/LHVVM/BA7HaTJYg5Enk7M/xWpq0192ACfBai2LA/qrCjCr6Dh1BIMzMXINBmX96MJ5Hn2nxln/RXPFhwHxUmSV0EV2V0jm86/dxxuYSU1W7sVkEbN9EzkG0QFwPhyHKyb3t+Fj5WoUUTErcazE/N6EW6Lvp0d//SDPj7EV9UdJN+Amnf3Wwk3A0SlJ9Z00yvXZ7n3z70G47Hfsow8Wq1JXcfwnA+Yxa5mFsgV464KKP4T31wqIgzFPd3eCe3j5ory5fBF2hgCFyVFrLzI9eetNXvM7oQqyFgDo4CTp/hDV9NMX9JDHQ/nyHTLvZLNLF6ftn2OxjGm8+PqOwhxnPHWipkE/8wbtyri80Sr7pMNkQGMfo4ZYK9OcCC4ESVFFbLMIvlxSoRqWie0wxqnLfcLSXMSpMMQEJYDVObYsXIQNv4TGNwjq1kvT1UOkicTrG3IaBZ3XdScS3u8sgeZPVpOLkbiF940FjbCeNRINNvDbd01EPBrTCPpm12m43ze1bBB59Ia6Ovhnur/Nvx3IxwSWol+3H2qfCJR8df6aQf4v6WiONxkK+IqT4pKQrZK/LplgDI/PJZbOep8dtbV7oCr6CgfpWa8NczOkPx81iSHbsNhVSJBOtrLIMrL31LK9TqHqAbAHe0RLmmV806kRLDLNEhUEJfm9u0sxpkL93Zgd6rw+tqBfTMi59xqXHLXSHwSbSBl0EK0+loECOPtrl+/nsaFe197di4yUgoe4jKoAJDXc6DGDjrQOoFDWZJ9HXwt8xDrQP+7aRwWKWI1GF8s8O4KzxWBBcwnl3vnl1Oez3oh6Ea1vjR7/z7DDTrFtqU2W/KAEzAuXDNZ7MY73MF216dzdSbWmUp4lcm7keJfWaMHgut9x5C9mj66Z0lJ+yhsjVvyiWrfk1lzPOTdhG15Y7gQlXtacvI7qv/XNSscDwqkgwHT/gUsD5yB7LdRRvJxQGYINn9hTpodKFVSTPrtGvyQw+HlRFXIkodErAGu9Iy1YpfSPc3jkFh5CX3lPxv7aqjE/JAfTIpEjGb/H7MO0e2vsViSW1qa/Lmi4/n4DEI3g7lYrcanspDfEpKkdV1OjSLOy0BCUqVoECaB55vs06rXl4jqmLsPsFM/7vYJ0vrBhDCm/00A/H81l1uekJ/6Lml3Hb9+NKiLqATJmDpyzfYZFHumEjC662L0Bwkxi7E9U4cQA0XMVDuMYAIeLMPgQaMVOd8fmt5SflFIfuBoszeAw7ow5gXPE2Y/yBc/7jExARUf/BxIHQBF5Sn3i61w4z5xJdCyO1F1X3+3ax+JSvMeZ7S6QSKp1Fp/sjYz6Z+VgCZzibGeEoujryfMulH7Rai5kAft9ebcW50DyJr2uo2z97mTWIu45YsSnNSMrrNUuG1XsYBtD9TDYzQffKB87vWbkM4EbPAFgoBV4GQS+vtFDUqOFAoi1nTtmIOvg38N4hT2Sn8r8clmBCXspBlMBYTnrqFJGBT3wZOzAyJDre9dHH7+x7qaaKDOB4UQALD5ecS0DE4obubQEiuJZ0EpBVpLuYcce8Aa4PYd/V4DLDAJBYKQPCWTcrEaZ5HYbJi11Gd6hjGom1ii18VHYnG28NKpkz2UKVPxlhYSp8uZr367iOmoy7zsxehW9wzcy2zG0a80PBMCRQMb32hnaHeOR8fnNDzZhaNYhkOdDsBUZ3loDMa1YP0uS0cjUP3b/6DBlqmZOeNABDsLl5BI5QJups8uxAuWJdkUB/pO6Zax6tsg7fN5mjjDgMGngO+DPcKqiHIDbFIGudxtPTIyDi9SFMKBDcfdGQRv41q1AqmxgkVfJMnP8w/Bc7N9/TR6C7mGObFqFkIEom8sKi2xYqJLTCHK7cxzaZvqODo22c3wisBCP4HeAgcRbNPAsBkNRhSmD48dHupdBRw4mIvtS5oeF6zeT1KMCyhMnmhpkFAGWnGscoNkwvQ8ZM5lE/vgTHFYL99OuNxdFBxTEDd5v2qLR8y9WkXsWgG6kZNndFG+pO/UAkOCipqIhL3hq7cRSdrCq7YhUsTocEcnaFa6nVkhnSeRYUA1YO0z5itF9Sly3VlxYDw239TJJH6f3EUfYO5lb7bcFcz8Bp7Oo8QmnsUHOz/fagVUBtKEw1iT88j+aKkv8cscKNkMxjYr8344D1kFoZ7/td1W6LCNYN594301tUGRmFjAzeRg5vyoM1F6+bJZ/Q54jN/k8SFd3DxPTYaAUsivsBfgTn7Mx8H2SpPt4GOdYRnEJOH6jHM2p6SgB0gzIRq6fHxGMmSmqaPCmlfwxiuloaVIitLGN8wie2CDWhkzLoCJcODh7KIOAqbHEvXdUxaS4TTTs07Clzj/6GmVs9kiZDerMxEnhUB6QQPlcfqkG9882RqHoLiHGBoHfQuXIsAG8GTAtao2KVwRnvvam8jo1e312GQAKWEa4sUVEAMG4G6ckcONDwRcg1e2D3+ohXgY4UAWF8wHKQMrSnzCgfFpsxh+aHXMGtPQroQasRY4U6UdG0rz1Vjbka0MekOGRZQEvqQFlxseFor8zWFgHek3v29+WqN6gaK5gZOTOMZzpQIC1201LkMCXild3vWXSc5UX9xcFYfbRPzGFa1FDcPfPB/jUEq/FeGt419CI3YmBlVoHsa4KdcwQP5ZSwHHhFJ7/Ph/Rap/4vmG91eDwPP0lDfCDRCLszTqfzM71xpmiKi2HwS4WlqvGNwtvwF5Dqpn6KTq8ax00UMPkxDcZrEEEsIvHiUXXEphdb4GB4FymlPwBz4Gperqq5pW7TQ6/yNRhW8VT5NhuP0udlxo4gILq5ZxAZk8ZGh3g4CqxJlPKY7AQxupfUcVpWT5VItp1+30UqoyP4wWsRo3olRRgkWZZ2ZN6VC3OZFeXB8NbnUrSdikNptD1QiGuKkr8EmSR/AK9Rw+FF3s5uwuPbvHGiPeFOViltMK7AUaOsq9+x9cndk3iJEE5LKZRlWJbKOZweROzmPNVPkjE3K/TyA57Rs68TkZ3MR8akKpm7cFjnjPd/DdkWjgYoKHSr5Wu5ssoBYU4acRs5g2DHxUmdq8VXOXRbunD8QN0LhgkssgahcdoYsNvuXGUK/KXD/7oFb+VGdhqIn02veuM5bLudJOc2Ky0GMaG4W/xWBxIJcL7yliJOXOpx0AkBqUgzlDczmLT4iILXDxxtRR1oZa2JWFgiAb43obrJnG/TZC2KSK2wqOzRZTXavZZFMb1f3bXvVaNaK828w9TO610gk8JNf3gMfETzXXsbcvRGCG9JWQZ6+cDPqc4466Yo2RcKH+PILeKOqtnlbInR3MmBeGG3FH10yzkybuqEC2HSQwpA0An7d9+73BkDUTm30bZmoP/RGbgFN+GrCOfADgqr0WbI1a1okpFms8iHYw9hm0zUvlEMivBRxModrbJJ+9/p3jUdQQ9BCtQdxnOGrT5dzRUmw0593/mbRSdBg0nRvRZM5/E16m7ZHmDEtWhwvfdZCZ8J8M12W0yRMszXamWfQTwIZ4ayYktrnscQuWr8idp3PjT2eF/jmtdhIfcpMnb+IfZY2FebW6UY/AK3jP4u3Tu4zE4qlnQgLFbM19EBIsNf7KhjdbqQ/D6yiDb+NlEi2SKD+ivXVUK8ib0oBo366gXkR8ZxGjpJIDcEgZPa9TcYe0TIbiPl/rPUQDu3XBJ9X/GNq3FAUsKsll57DzaGMrjcT+gctp+9MLYXCq+sqP81eVQ0r9lt+gcQfZbACRbEjvlMskztZG8gbC8Qn9tt26Q7y7nDrbZq/LEz7kR6Jc6pg3N9rVX8Y5MJrGlML9p9lU4jbTkKqCveeZUJjHB03m2KRKR2TytoFkTXOLg7keU1s1lrPMQJpoOKLuAAC+y1HlJucU6ysB5hsXhvSPPLq5J7JtnqHKZ4vYjC4Vy8153QY+6780xDuGARsGbOs1WqzH0QS765rnSKEbbKlkO8oI/VDwUd0is13tKpqILu1mDJFNy/iJAWcvDgjxvusIT+PGz3ST/J9r9Mtfd0jpaGeiLYIqXc7DiHSS8TcjFVksi66PEkxW1z6ujbLLUGNNYnzOWpH8BZGK4bCK7iR+MbIv8ncDAz1u4StN3vTTzewr9IQjk9wxFxn+6N1ddKs0vffJiS08N3a4G1SVrlZ97Q/M+8G9fe5AP6d9/Qq4WRnORVhofPIKEdCr3llspUfE0oKIIYoByBRPh+bX1HLS3JWGJRhIvE1aW4NTd8ePi4Z+kXb+Z8snYfSNcqijhAgVsx4RCM54cXUiYkjeBmmC4ajOHrChoELscJJC7+9jjMjw5BagZKlgRMiSNYz7h7vvZIoQqbtQmspc0cUk1G/73iXtSpROl5wtLgQi0mW2Ex8i3WULhcggx6E1LMVHUsdc9GHI1PH3U2Ko0PyGdn9KdVOLm7FPBui0i9a0HpA60MsewVE4z8CAt5d401Gv6zXlIT5Ybit1VIA0FCs7wtvYreru1fUyW3oLAZ/+aTnZrOcYRNVA8spoRtlRoWflsRClFcgzkqiHOrf0/SVw+EpVaFlJ0g4Kxq1MMOmiQdpMNpte8lMMQqm6cIFXlnGbfJllysKDi+0JJMotkqgIxOSQgU9dn/lWkeVf8nUm3iwX2Nl3WDw9i6AUK3vBAbZZrcJpDQ/N64AVwjT07Jef30GSSmtNu2WlW7YoyW2FlWfZFQUwk867EdLYKk9VG6JgEnBiBxkY7LMo4YLQJJlAo9l/oTvJkSARDF/XtyAzM8O2t3eT/iXa6wDN3WewNmQHdPfsxChU/KtLG2Mn8i4ZqKdSlIaBZadxJmRzVS/o4yA65RTSViq60oa395Lqw0pzY4SipwE0SXXsKV+GZraGSkr/RW08wPRvqvSUkYBMA9lPx4m24az+IHmCbXA+0faxTRE9wuGeO06DIXa6QlKJ3puIyiuAVfPr736vzo2pBirS+Vxel3TMm3JKhz9o2ZoRvaFVpIkykb0Hcm4oHFBMcNSNj7/4GJt43ogonY2Vg4nsDQIWxAcorpXACzgBqQPjYsE/VUpXpwNManEru4NwMCFPkXvMoqvoeLN3qyu/N1eWEHttMD65v19l/0kH2mR35iv/FI+yjoHJ9gPMz67af3Mq/BoWXqu3rphiWMXVkmnPSEkpGpUI2h1MThideGFEOK6YZHPwYzMBvpNC7+ZHxPb7epfefGyIB4JzO9DTNEYnDLVVHdQyvOEVefrk6Uv5kTQYVYWWdqrdcIl7yljwwIWdfQ/y+2QB3eR/qxYObuYyB4gTbo2in4PzarU1sO9nETkmj9/AoxDA+JM3GMqQtJR4jtduHtnoCLxd1gQUscHRB/MoRYIEsP2pDZ9KvHgtlk1iTbWWbHhohwFEYX7y51fUV2nuUmnoUcqnWIQAAgl9LTVX+Bc0QGNEhChxHR4YjfE51PUdGfsSFE6ck7BL3/hTf9jLq4G1IafINxOLKeAtO7quulYvH5YOBc+zX7CrMgWnW47/jfRsWnJjYYoE7xMfWV2HN2iyIqLI";
  const t = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]), r = 4;
  function n(J) {
    let Y = 0;
    function ee() {
      return J[Y++] << 8 | J[Y++];
    }
    let se = ee(), le = 1, Ae = [0, 1];
    for (let wr = 1; wr < se; wr++)
      Ae.push(le += ee());
    let Te = ee(), Ie = Y;
    Y += Te;
    let We = 0, Ke = 0;
    function Le() {
      return We == 0 && (Ke = Ke << 8 | J[Y++], We = 8), Ke >> --We & 1;
    }
    const De = 31, Ge = 2 ** De, Ct = Ge >>> 1, Mt = Ct >> 1, Lt = Ge - 1;
    let Jt = 0;
    for (let wr = 0; wr < De; wr++)
      Jt = Jt << 1 | Le();
    let pr = [], Hr = 0, gr = Ge;
    for (; ; ) {
      let wr = Math.floor(((Jt - Hr + 1) * le - 1) / gr), Cr = 0, er = se;
      for (; er - Cr > 1; ) {
        let Fo = Cr + er >>> 1;
        wr < Ae[Fo] ? er = Fo : Cr = Fo;
      }
      if (Cr == 0)
        break;
      pr.push(Cr);
      let ht = Hr + Math.floor(gr * Ae[Cr] / le), yn = Hr + Math.floor(gr * Ae[Cr + 1] / le) - 1;
      for (; !((ht ^ yn) & Ct); )
        Jt = Jt << 1 & Lt | Le(), ht = ht << 1 & Lt, yn = yn << 1 & Lt | 1;
      for (; ht & ~yn & Mt; )
        Jt = Jt & Ct | Jt << 1 & Lt >>> 1 | Le(), ht = ht << 1 ^ Ct, yn = (yn ^ Ct) << 1 | Ct | 1;
      Hr = ht, gr = 1 + yn - ht;
    }
    let $r = se - 4;
    return pr.map((wr) => {
      switch (wr - $r) {
        case 3:
          return $r + 65792 + (J[Ie++] << 16 | J[Ie++] << 8 | J[Ie++]);
        case 2:
          return $r + 256 + (J[Ie++] << 8 | J[Ie++]);
        case 1:
          return $r + J[Ie++];
        default:
          return wr - 1;
      }
    });
  }
  function s(J) {
    let Y = 0;
    return () => J[Y++];
  }
  function i(J) {
    return s(n(a(J)));
  }
  function a(J) {
    let Y = [];
    [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((le, Ae) => Y[le.charCodeAt(0)] = Ae);
    let ee = J.length, se = new Uint8Array(6 * ee >> 3);
    for (let le = 0, Ae = 0, Te = 0, Ie = 0; le < ee; le++)
      Ie = Ie << 6 | Y[J.charCodeAt(le)], Te += 6, Te >= 8 && (se[Ae++] = Ie >> (Te -= 8));
    return se;
  }
  function f(J) {
    return J & 1 ? ~J >> 1 : J >> 1;
  }
  function d(J, Y) {
    let ee = Array(J);
    for (let se = 0, le = 0; se < J; se++)
      ee[se] = le += f(Y());
    return ee;
  }
  function c(J, Y = 0) {
    let ee = [];
    for (; ; ) {
      let se = J(), le = J();
      if (!le)
        break;
      Y += se;
      for (let Ae = 0; Ae < le; Ae++)
        ee.push(Y + Ae);
      Y += le + 1;
    }
    return ee;
  }
  function p(J) {
    return v(() => {
      let Y = c(J);
      if (Y.length)
        return Y;
    });
  }
  function g(J) {
    let Y = [];
    for (; ; ) {
      let ee = J();
      if (ee == 0)
        break;
      Y.push(N(ee, J));
    }
    for (; ; ) {
      let ee = J() - 1;
      if (ee < 0)
        break;
      Y.push(S(ee, J));
    }
    return Y.flat();
  }
  function v(J) {
    let Y = [];
    for (; ; ) {
      let ee = J(Y.length);
      if (!ee)
        break;
      Y.push(ee);
    }
    return Y;
  }
  function O(J, Y, ee) {
    let se = Array(J).fill().map(() => []);
    for (let le = 0; le < Y; le++)
      d(J, ee).forEach((Ae, Te) => se[Te].push(Ae));
    return se;
  }
  function N(J, Y) {
    let ee = 1 + Y(), se = Y(), le = v(Y);
    return O(le.length, 1 + J, Y).flatMap((Ae, Te) => {
      let [Ie, ...We] = Ae;
      return Array(le[Te]).fill().map((Ke, Le) => {
        let De = Le * se;
        return [Ie + Le * ee, We.map((Ge) => Ge + De)];
      });
    });
  }
  function S(J, Y) {
    let ee = 1 + Y();
    return O(ee, 1 + J, Y).map((se) => [se[0], se.slice(1)]);
  }
  function j(J) {
    let Y = [], ee = c(J);
    return le(se([]), []), Y;
    function se(Ae) {
      let Te = J(), Ie = v(() => {
        let We = c(J).map((Ke) => ee[Ke]);
        if (We.length)
          return se(We);
      });
      return { S: Te, B: Ie, Q: Ae };
    }
    function le({ S: Ae, B: Te }, Ie, We) {
      if (!(Ae & 4 && We === Ie[Ie.length - 1])) {
        Ae & 2 && (We = Ie[Ie.length - 1]), Ae & 1 && Y.push(Ie);
        for (let Ke of Te)
          for (let Le of Ke.Q)
            le(Ke, [...Ie, Le], We);
      }
    }
  }
  function B(J) {
    return J.toString(16).toUpperCase().padStart(2, "0");
  }
  function M(J) {
    return `{${B(J)}}`;
  }
  function I(J) {
    let Y = [];
    for (let ee = 0, se = J.length; ee < se; ) {
      let le = J.codePointAt(ee);
      ee += le < 65536 ? 1 : 2, Y.push(le);
    }
    return Y;
  }
  function A(J) {
    let Y = J.length;
    if (Y < 4096)
      return String.fromCodePoint(...J);
    let ee = [];
    for (let se = 0; se < Y; )
      ee.push(String.fromCodePoint(...J.slice(se, se += 4096)));
    return ee.join("");
  }
  function R(J, Y) {
    let ee = J.length, se = ee - Y.length;
    for (let le = 0; se == 0 && le < ee; le++)
      se = J[le] - Y[le];
    return se;
  }
  var L = "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";
  const K = 44032, $ = 4352, k = 4449, V = 4519, C = 19, D = 21, o = 28, u = D * o, h = C * u, y = K + h, E = $ + C, P = k + D, w = V + o;
  function m(J) {
    return J >> 24 & 255;
  }
  function l(J) {
    return J & 16777215;
  }
  let b, W, X, G;
  function re() {
    let J = i(L);
    b = new Map(p(J).flatMap((Y, ee) => Y.map((se) => [se, ee + 1 << 24]))), W = new Set(c(J)), X = /* @__PURE__ */ new Map(), G = /* @__PURE__ */ new Map();
    for (let [Y, ee] of g(J)) {
      if (!W.has(Y) && ee.length == 2) {
        let [se, le] = ee, Ae = G.get(se);
        Ae || (Ae = /* @__PURE__ */ new Map(), G.set(se, Ae)), Ae.set(le, Y);
      }
      X.set(Y, ee.reverse());
    }
  }
  function ce(J) {
    return J >= K && J < y;
  }
  function pe(J, Y) {
    if (J >= $ && J < E && Y >= k && Y < P)
      return K + (J - $) * u + (Y - k) * o;
    if (ce(J) && Y > V && Y < w && (J - K) % o == 0)
      return J + (Y - V);
    {
      let ee = G.get(J);
      return ee && (ee = ee.get(Y), ee) ? ee : -1;
    }
  }
  function ve(J) {
    b || re();
    let Y = [], ee = [], se = !1;
    function le(Ae) {
      let Te = b.get(Ae);
      Te && (se = !0, Ae |= Te), Y.push(Ae);
    }
    for (let Ae of J)
      for (; ; ) {
        if (Ae < 128)
          Y.push(Ae);
        else if (ce(Ae)) {
          let Te = Ae - K, Ie = Te / u | 0, We = Te % u / o | 0, Ke = Te % o;
          le($ + Ie), le(k + We), Ke > 0 && le(V + Ke);
        } else {
          let Te = X.get(Ae);
          Te ? ee.push(...Te) : le(Ae);
        }
        if (!ee.length)
          break;
        Ae = ee.pop();
      }
    if (se && Y.length > 1) {
      let Ae = m(Y[0]);
      for (let Te = 1; Te < Y.length; Te++) {
        let Ie = m(Y[Te]);
        if (Ie == 0 || Ae <= Ie) {
          Ae = Ie;
          continue;
        }
        let We = Te - 1;
        for (; ; ) {
          let Ke = Y[We + 1];
          if (Y[We + 1] = Y[We], Y[We] = Ke, !We || (Ae = m(Y[--We]), Ae <= Ie))
            break;
        }
        Ae = m(Y[Te]);
      }
    }
    return Y;
  }
  function Ee(J) {
    let Y = [], ee = [], se = -1, le = 0;
    for (let Ae of J) {
      let Te = m(Ae), Ie = l(Ae);
      if (se == -1)
        Te == 0 ? se = Ie : Y.push(Ie);
      else if (le > 0 && le >= Te)
        Te == 0 ? (Y.push(se, ...ee), ee.length = 0, se = Ie) : ee.push(Ie), le = Te;
      else {
        let We = pe(se, Ie);
        We >= 0 ? se = We : le == 0 && Te == 0 ? (Y.push(se), se = Ie) : (ee.push(Ie), le = Te);
      }
    }
    return se >= 0 && Y.push(se, ...ee), Y;
  }
  function Pe(J) {
    return ve(J).map(l);
  }
  function xe(J) {
    return Ee(ve(J));
  }
  const me = 45, te = 46, U = ".", ue = 65039, we = 1, ke = (J) => Array.from(J);
  function Re(J, Y) {
    return J.P.has(Y) || J.Q.has(Y);
  }
  class fe extends Array {
    get is_emoji() {
      return !0;
    }
    // free tagging system
  }
  let x, _, q, ne, de, ye, ge, be, Me, Ce, je, Ue;
  function Qe() {
    if (x)
      return;
    let J = i(e);
    const Y = () => c(J), ee = () => new Set(Y()), se = (Le, De) => De.forEach((Ge) => Le.add(Ge));
    x = new Map(g(J)), _ = ee(), q = Y(), ne = new Set(Y().map((Le) => q[Le])), q = new Set(q), de = ee(), ye = ee();
    let le = p(J), Ae = J();
    const Te = () => {
      let Le = /* @__PURE__ */ new Set();
      return Y().forEach((De) => se(Le, le[De])), se(Le, Y()), Le;
    };
    ge = v((Le) => {
      let De = v(J).map((Ge) => Ge + 96);
      if (De.length) {
        let Ge = Le >= Ae;
        De[0] -= 32, De = A(De), Ge && (De = `Restricted[${De}]`);
        let Ct = Te(), Mt = Te(), Lt = !J();
        return { N: De, P: Ct, Q: Mt, M: Lt, R: Ge };
      }
    }), be = ee(), Me = /* @__PURE__ */ new Map();
    let Ie = Y().concat(ke(be)).sort((Le, De) => Le - De);
    Ie.forEach((Le, De) => {
      let Ge = J(), Ct = Ie[De] = Ge ? Ie[De - Ge] : { V: [], M: /* @__PURE__ */ new Map() };
      Ct.V.push(Le), be.has(Le) || Me.set(Le, Ct);
    });
    for (let { V: Le, M: De } of new Set(Me.values())) {
      let Ge = [];
      for (let Mt of Le) {
        let Lt = ge.filter((pr) => Re(pr, Mt)), Jt = Ge.find(({ G: pr }) => Lt.some((Hr) => pr.has(Hr)));
        Jt || (Jt = { G: /* @__PURE__ */ new Set(), V: [] }, Ge.push(Jt)), Jt.V.push(Mt), se(Jt.G, Lt);
      }
      let Ct = Ge.flatMap((Mt) => ke(Mt.G));
      for (let { G: Mt, V: Lt } of Ge) {
        let Jt = new Set(Ct.filter((pr) => !Mt.has(pr)));
        for (let pr of Lt)
          De.set(pr, Jt);
      }
    }
    Ce = /* @__PURE__ */ new Set();
    let We = /* @__PURE__ */ new Set();
    const Ke = (Le) => Ce.has(Le) ? We.add(Le) : Ce.add(Le);
    for (let Le of ge) {
      for (let De of Le.P)
        Ke(De);
      for (let De of Le.Q)
        Ke(De);
    }
    for (let Le of Ce)
      !Me.has(Le) && !We.has(Le) && Me.set(Le, we);
    se(Ce, Pe(Ce)), je = j(J).map((Le) => fe.from(Le)).sort(R), Ue = /* @__PURE__ */ new Map();
    for (let Le of je) {
      let De = [Ue];
      for (let Ge of Le) {
        let Ct = De.map((Mt) => {
          let Lt = Mt.get(Ge);
          return Lt || (Lt = /* @__PURE__ */ new Map(), Mt.set(Ge, Lt)), Lt;
        });
        Ge === ue ? De.push(...Ct) : De = Ct;
      }
      for (let Ge of De)
        Ge.V = Le;
    }
  }
  function Ye(J) {
    return (st(J) ? "" : `${et(Pt([J]))} `) + M(J);
  }
  function et(J) {
    return `"${J}"‎`;
  }
  function At(J) {
    if (J.length >= 4 && J[2] == me && J[3] == me)
      throw new Error(`invalid label extension: "${A(J.slice(0, 4))}"`);
  }
  function it(J) {
    for (let Y = J.lastIndexOf(95); Y > 0; )
      if (J[--Y] !== 95)
        throw new Error("underscore allowed only at start");
  }
  function tt(J) {
    let Y = J[0], ee = t.get(Y);
    if (ee)
      throw It(`leading ${ee}`);
    let se = J.length, le = -1;
    for (let Ae = 1; Ae < se; Ae++) {
      Y = J[Ae];
      let Te = t.get(Y);
      if (Te) {
        if (le == Ae)
          throw It(`${ee} + ${Te}`);
        le = Ae + 1, ee = Te;
      }
    }
    if (le == se)
      throw It(`trailing ${ee}`);
  }
  function Pt(J, Y = 1 / 0, ee = M) {
    let se = [];
    dt(J[0]) && se.push("◌"), J.length > Y && (Y >>= 1, J = [...J.slice(0, Y), 8230, ...J.slice(-Y)]);
    let le = 0, Ae = J.length;
    for (let Te = 0; Te < Ae; Te++) {
      let Ie = J[Te];
      st(Ie) && (se.push(A(J.slice(le, Te))), se.push(ee(Ie)), le = Te + 1);
    }
    return se.push(A(J.slice(le, Ae))), se.join("");
  }
  function dt(J) {
    return Qe(), q.has(J);
  }
  function st(J) {
    return Qe(), de.has(J);
  }
  function zt() {
    return Qe(), je.map((J) => J.slice());
  }
  function xt(J, Y) {
    Qe();
    let ee = Y ? Pe : xe;
    return J.split(U).map((se) => A(ot(I(se), ee, Rt).flat())).join(U);
  }
  function lt(J) {
    return Vt(Ut(J, xe, Rt));
  }
  function $t(J) {
    let Y = Ut(J, xe, (ee) => ee);
    for (let { type: ee, output: se, error: le } of Y) {
      if (le)
        break;
      ee !== "Greek" && Tt(se, 958, 926);
    }
    return Vt(Y);
  }
  function Tt(J, Y, ee) {
    let se = 0;
    for (; ; ) {
      let le = J.indexOf(Y, se);
      if (le < 0)
        break;
      J[le] = ee, se = le + 1;
    }
  }
  function at(J, Y) {
    return Ut(J, xe, Y ? (ee) => ee.slice() : Rt);
  }
  function Ut(J, Y, ee) {
    if (!J)
      return [];
    Qe();
    let se = 0;
    return J.split(U).map((le) => {
      let Ae = I(le), Te = {
        input: Ae,
        offset: se
        // codepoint, not substring!
      };
      se += Ae.length + 1;
      try {
        let Ie = Te.tokens = ot(Ae, Y, ee), We = Ie.length, Ke;
        if (!We)
          throw new Error("empty label");
        let Le = Te.output = Ie.flat();
        if (it(Le), !(Te.emoji = We > 1 || Ie[0].is_emoji) && Le.every((De) => De < 128))
          At(Le), Ke = "ASCII";
        else {
          let De = Ie.flatMap((Ge) => Ge.is_emoji ? [] : Ge);
          if (!De.length)
            Ke = "Emoji";
          else {
            if (q.has(Le[0]))
              throw It("leading combining mark");
            for (let Mt = 1; Mt < We; Mt++) {
              let Lt = Ie[Mt];
              if (!Lt.is_emoji && q.has(Lt[0]))
                throw It(`emoji + combining mark: "${A(Ie[Mt - 1])} + ${Pt([Lt[0]])}"`);
            }
            tt(Le);
            let Ge = ke(new Set(De)), [Ct] = He(Ge);
            kt(Ct, De), Ot(Ct, Ge), Ke = Ct.N;
          }
        }
        Te.type = Ke;
      } catch (Ie) {
        Te.error = Ie;
      }
      return Te;
    });
  }
  function Ot(J, Y) {
    let ee, se = [];
    for (let le of Y) {
      let Ae = Me.get(le);
      if (Ae === we)
        return;
      if (Ae) {
        let Te = Ae.M.get(le);
        if (ee = ee ? ee.filter((Ie) => Te.has(Ie)) : ke(Te), !ee.length)
          return;
      } else
        se.push(le);
    }
    if (ee) {
      for (let le of ee)
        if (se.every((Ae) => Re(le, Ae)))
          throw new Error(`whole-script confusable: ${J.N}/${le.N}`);
    }
  }
  function He(J) {
    let Y = ge;
    for (let ee of J) {
      let se = Y.filter((le) => Re(le, ee));
      if (!se.length)
        throw ge.some((le) => Re(le, ee)) ? ut(Y[0], ee) : yt(ee);
      if (Y = se, se.length == 1)
        break;
    }
    return Y;
  }
  function Vt(J) {
    return J.map(({ input: Y, error: ee, output: se }) => {
      if (ee) {
        let le = ee.message;
        throw new Error(J.length == 1 ? le : `Invalid label ${et(Pt(Y, 63))}: ${le}`);
      }
      return A(se);
    }).join(U);
  }
  function yt(J) {
    return new Error(`disallowed character: ${Ye(J)}`);
  }
  function ut(J, Y) {
    let ee = Ye(Y), se = ge.find((le) => le.P.has(Y));
    return se && (ee = `${se.N} ${ee}`), new Error(`illegal mixture: ${J.N} + ${ee}`);
  }
  function It(J) {
    return new Error(`illegal placement: ${J}`);
  }
  function kt(J, Y) {
    for (let ee of Y)
      if (!Re(J, ee))
        throw ut(J, ee);
    if (J.M) {
      let ee = Pe(Y);
      for (let se = 1, le = ee.length; se < le; se++)
        if (ne.has(ee[se])) {
          let Ae = se + 1;
          for (let Te; Ae < le && ne.has(Te = ee[Ae]); Ae++)
            for (let Ie = se; Ie < Ae; Ie++)
              if (ee[Ie] == Te)
                throw new Error(`duplicate non-spacing marks: ${Ye(Te)}`);
          if (Ae - se > r)
            throw new Error(`excessive non-spacing marks: ${et(Pt(ee.slice(se - 1, Ae)))} (${Ae - se}/${r})`);
          se = Ae;
        }
    }
  }
  function ot(J, Y, ee) {
    let se = [], le = [];
    for (J = J.slice().reverse(); J.length; ) {
      let Ae = Nt(J);
      if (Ae)
        le.length && (se.push(Y(le)), le = []), se.push(ee(Ae));
      else {
        let Te = J.pop();
        if (Ce.has(Te))
          le.push(Te);
        else {
          let Ie = x.get(Te);
          if (Ie)
            le.push(...Ie);
          else if (!_.has(Te))
            throw yt(Te);
        }
      }
    }
    return le.length && se.push(Y(le)), se;
  }
  function Rt(J) {
    return J.filter((Y) => Y != ue);
  }
  function Nt(J, Y) {
    let ee = Ue, se, le = J.length;
    for (; le && (ee = ee.get(J[--le]), !!ee); ) {
      let { V: Ae } = ee;
      Ae && (se = Ae, Y && Y.push(...J.slice(le).reverse()), J.length = le);
    }
    return se;
  }
  const rt = "valid", Dt = "mapped", St = "ignored", T = "disallowed", F = "emoji", H = "nfc", z = "stop";
  function Q(J, {
    nf: Y = !0
    // collapse unnormalized runs into a single token
  } = {}) {
    Qe();
    let ee = I(J).reverse(), se = [], le = [];
    for (; ee.length; ) {
      let Ae = Nt(ee, se);
      if (Ae)
        le.push({
          type: F,
          emoji: Ae.slice(),
          // copy emoji
          input: se,
          cps: Rt(Ae)
        }), se = [];
      else {
        let Te = ee.pop();
        if (Te == te)
          le.push({ type: z, cp: Te });
        else if (Ce.has(Te))
          le.push({ type: rt, cps: [Te] });
        else if (_.has(Te))
          le.push({ type: St, cp: Te });
        else {
          let Ie = x.get(Te);
          Ie ? le.push({ type: Dt, cp: Te, cps: Ie.slice() }) : le.push({ type: T, cp: Te });
        }
      }
    }
    if (Y)
      for (let Ae = 0, Te = -1; Ae < le.length; Ae++) {
        let Ie = le[Ae];
        if (Z(Ie.type))
          if (ie(Ie.cps)) {
            let We = Ae + 1;
            for (let Ge = We; Ge < le.length; Ge++) {
              let { type: Ct, cps: Mt } = le[Ge];
              if (Z(Ct)) {
                if (!ie(Mt))
                  break;
                We = Ge + 1;
              } else if (Ct !== St)
                break;
            }
            Te < 0 && (Te = Ae);
            let Ke = le.slice(Te, We), Le = Ke.flatMap((Ge) => Z(Ge.type) ? Ge.cps : []), De = xe(Le);
            R(De, Le) ? (le.splice(Te, We - Te, {
              type: H,
              input: Le,
              // there are 3 states: tokens0 ==(process)=> input ==(nfc)=> tokens/cps
              cps: De,
              tokens0: he(Ke),
              tokens: Q(A(De), { nf: !1 })
            }), Ae = Te) : Ae = We - 1, Te = -1;
          } else
            Te = Ae;
        else
          Ie.type !== St && (Te = -1);
      }
    return he(le);
  }
  function Z(J) {
    return J == rt || J == Dt;
  }
  function ie(J) {
    return J.some((Y) => ye.has(Y));
  }
  function he(J) {
    for (let Y = 0; Y < J.length; Y++)
      if (J[Y].type == rt) {
        let ee = Y + 1;
        for (; ee < J.length && J[ee].type == rt; )
          ee++;
        J.splice(Y, ee - Y, { type: rt, cps: J.slice(Y, ee).flatMap((se) => se.cps) });
      }
    return J;
  }
  return jn.ens_beautify = $t, jn.ens_emoji = zt, jn.ens_normalize = lt, jn.ens_normalize_fragment = xt, jn.ens_split = at, jn.ens_tokenize = Q, jn.is_combining_mark = dt, jn.nfc = xe, jn.nfd = Pe, jn.safe_str_from_cps = Pt, jn.should_escape = st, jn;
}
var d2;
function $T() {
  if (d2)
    return Ai;
  d2 = 1, Object.defineProperty(Ai, "__esModule", { value: !0 }), Ai.dnsEncode = Ai.namehash = Ai.isValidName = Ai.ensNormalize = void 0;
  const e = cn(), t = wt(), r = qT(), n = new Uint8Array(32);
  n.fill(0);
  function s(p) {
    return (0, t.assertArgument)(p.length !== 0, "invalid ENS name; empty component", "comp", p), p;
  }
  function i(p) {
    const g = (0, t.toUtf8Bytes)(a(p)), v = [];
    if (p.length === 0)
      return v;
    let O = 0;
    for (let N = 0; N < g.length; N++)
      g[N] === 46 && (v.push(s(g.slice(O, N))), O = N + 1);
    return (0, t.assertArgument)(O < g.length, "invalid ENS name; empty component", "name", p), v.push(s(g.slice(O))), v;
  }
  function a(p) {
    try {
      if (p.length === 0)
        throw new Error("empty label");
      return (0, r.ens_normalize)(p);
    } catch (g) {
      (0, t.assertArgument)(!1, `invalid ENS name (${g.message})`, "name", p);
    }
  }
  Ai.ensNormalize = a;
  function f(p) {
    try {
      return i(p).length !== 0;
    } catch {
    }
    return !1;
  }
  Ai.isValidName = f;
  function d(p) {
    (0, t.assertArgument)(typeof p == "string", "invalid ENS name; not a string", "name", p), (0, t.assertArgument)(p.length, "invalid ENS name (empty label)", "name", p);
    let g = n;
    const v = i(p);
    for (; v.length; )
      g = (0, e.keccak256)((0, t.concat)([g, (0, e.keccak256)(v.pop())]));
    return (0, t.hexlify)(g);
  }
  Ai.namehash = d;
  function c(p, g) {
    const v = g ?? 63;
    return (0, t.assertArgument)(v <= 255, "DNS encoded label cannot exceed 255", "length", v), (0, t.hexlify)((0, t.concat)(i(p).map((O) => {
      (0, t.assertArgument)(O.length <= v, `label ${JSON.stringify(p)} exceeds ${v} bytes`, "name", p);
      const N = new Uint8Array(O.length + 1);
      return N.set(O, 1), N[0] = N.length - 1, N;
    }))) + "00";
  }
  return Ai.dnsEncode = c, Ai;
}
var Xo = {}, h2 = {}, Fc = {}, f2;
function j5() {
  if (f2)
    return Fc;
  f2 = 1, Object.defineProperty(Fc, "__esModule", { value: !0 }), Fc.accessListify = void 0;
  const e = Yr(), t = wt();
  function r(s, i) {
    return {
      address: (0, e.getAddress)(s),
      storageKeys: i.map((a, f) => ((0, t.assertArgument)((0, t.isHexString)(a, 32), "invalid slot", `storageKeys[${f}]`, a), a.toLowerCase()))
    };
  }
  function n(s) {
    if (Array.isArray(s))
      return s.map((a, f) => Array.isArray(a) ? ((0, t.assertArgument)(a.length === 2, "invalid slot set", `value[${f}]`, a), r(a[0], a[1])) : ((0, t.assertArgument)(a != null && typeof a == "object", "invalid address-slot set", "value", s), r(a.address, a.storageKeys)));
    (0, t.assertArgument)(s != null && typeof s == "object", "invalid access list", "value", s);
    const i = Object.keys(s).map((a) => {
      const f = s[a].reduce((d, c) => (d[c] = !0, d), {});
      return r(a, Object.keys(f).sort());
    });
    return i.sort((a, f) => a.address.localeCompare(f.address)), i;
  }
  return Fc.accessListify = n, Fc;
}
var ea = {}, p2;
function L5() {
  if (p2)
    return ea;
  p2 = 1, Object.defineProperty(ea, "__esModule", { value: !0 }), ea.recoverAddress = ea.computeAddress = void 0;
  const e = Yr(), t = cn();
  function r(s) {
    let i;
    return typeof s == "string" ? i = t.SigningKey.computePublicKey(s, !1) : i = s.publicKey, (0, e.getAddress)((0, t.keccak256)("0x" + i.substring(4)).substring(26));
  }
  ea.computeAddress = r;
  function n(s, i) {
    return r(t.SigningKey.recoverPublicKey(s, i));
  }
  return ea.recoverAddress = n, ea;
}
var Uc = {}, g2;
function KT() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N, S, j, B;
  if (g2)
    return Uc;
  g2 = 1, Object.defineProperty(Uc, "__esModule", { value: !0 }), Uc.Transaction = void 0;
  const M = Yr(), I = B5(), A = cn(), R = wt(), L = j5(), K = L5(), $ = BigInt(0), k = BigInt(2), V = BigInt(27), C = BigInt(28), D = BigInt(35), o = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), u = 4096 * 32;
  function h(te, U) {
    let ue = te.toString(16);
    for (; ue.length < 2; )
      ue = "0" + ue;
    return ue += (0, A.sha256)(U).substring(4), "0x" + ue;
  }
  function y(te) {
    return te === "0x" ? null : (0, M.getAddress)(te);
  }
  function E(te, U) {
    try {
      return (0, L.accessListify)(te);
    } catch (ue) {
      (0, R.assertArgument)(!1, ue.message, U, te);
    }
  }
  function P(te, U) {
    return te === "0x" ? 0 : (0, R.getNumber)(te, U);
  }
  function w(te, U) {
    if (te === "0x")
      return $;
    const ue = (0, R.getBigInt)(te, U);
    return (0, R.assertArgument)(ue <= o, "value exceeds uint size", U, ue), ue;
  }
  function m(te, U) {
    const ue = (0, R.getBigInt)(te, "value"), we = (0, R.toBeArray)(ue);
    return (0, R.assertArgument)(we.length <= 32, "value too large", `tx.${U}`, ue), we;
  }
  function l(te) {
    return (0, L.accessListify)(te).map((U) => [U.address, U.storageKeys]);
  }
  function b(te, U) {
    (0, R.assertArgument)(Array.isArray(te), `invalid ${U}`, "value", te);
    for (let ue = 0; ue < te.length; ue++)
      (0, R.assertArgument)((0, R.isHexString)(te[ue], 32), "invalid ${ param } hash", `value[${ue}]`, te[ue]);
    return te;
  }
  function W(te) {
    const U = (0, R.decodeRlp)(te);
    (0, R.assertArgument)(Array.isArray(U) && (U.length === 9 || U.length === 6), "invalid field count for legacy transaction", "data", te);
    const ue = {
      type: 0,
      nonce: P(U[0], "nonce"),
      gasPrice: w(U[1], "gasPrice"),
      gasLimit: w(U[2], "gasLimit"),
      to: y(U[3]),
      value: w(U[4], "value"),
      data: (0, R.hexlify)(U[5]),
      chainId: $
    };
    if (U.length === 6)
      return ue;
    const we = w(U[6], "v"), ke = w(U[7], "r"), Re = w(U[8], "s");
    if (ke === $ && Re === $)
      ue.chainId = we;
    else {
      let fe = (we - D) / k;
      fe < $ && (fe = $), ue.chainId = fe, (0, R.assertArgument)(fe !== $ || we === V || we === C, "non-canonical legacy v", "v", U[6]), ue.signature = A.Signature.from({
        r: (0, R.zeroPadValue)(U[7], 32),
        s: (0, R.zeroPadValue)(U[8], 32),
        v: we
      });
    }
    return ue;
  }
  function X(te, U) {
    const ue = [
      m(te.nonce, "nonce"),
      m(te.gasPrice || 0, "gasPrice"),
      m(te.gasLimit, "gasLimit"),
      te.to || "0x",
      m(te.value, "value"),
      te.data
    ];
    let we = $;
    if (te.chainId != $)
      we = (0, R.getBigInt)(te.chainId, "tx.chainId"), (0, R.assertArgument)(!U || U.networkV == null || U.legacyChainId === we, "tx.chainId/sig.v mismatch", "sig", U);
    else if (te.signature) {
      const Re = te.signature.legacyChainId;
      Re != null && (we = Re);
    }
    if (!U)
      return we !== $ && (ue.push((0, R.toBeArray)(we)), ue.push("0x"), ue.push("0x")), (0, R.encodeRlp)(ue);
    let ke = BigInt(27 + U.yParity);
    return we !== $ ? ke = A.Signature.getChainIdV(we, U.v) : BigInt(U.v) !== ke && (0, R.assertArgument)(!1, "tx.chainId/sig.v mismatch", "sig", U), ue.push((0, R.toBeArray)(ke)), ue.push((0, R.toBeArray)(U.r)), ue.push((0, R.toBeArray)(U.s)), (0, R.encodeRlp)(ue);
  }
  function G(te, U) {
    let ue;
    try {
      if (ue = P(U[0], "yParity"), ue !== 0 && ue !== 1)
        throw new Error("bad yParity");
    } catch {
      (0, R.assertArgument)(!1, "invalid yParity", "yParity", U[0]);
    }
    const we = (0, R.zeroPadValue)(U[1], 32), ke = (0, R.zeroPadValue)(U[2], 32), Re = A.Signature.from({ r: we, s: ke, yParity: ue });
    te.signature = Re;
  }
  function re(te) {
    const U = (0, R.decodeRlp)((0, R.getBytes)(te).slice(1));
    (0, R.assertArgument)(Array.isArray(U) && (U.length === 9 || U.length === 12), "invalid field count for transaction type: 2", "data", (0, R.hexlify)(te));
    const ue = {
      type: 2,
      chainId: w(U[0], "chainId"),
      nonce: P(U[1], "nonce"),
      maxPriorityFeePerGas: w(U[2], "maxPriorityFeePerGas"),
      maxFeePerGas: w(U[3], "maxFeePerGas"),
      gasPrice: null,
      gasLimit: w(U[4], "gasLimit"),
      to: y(U[5]),
      value: w(U[6], "value"),
      data: (0, R.hexlify)(U[7]),
      accessList: E(U[8], "accessList")
    };
    return U.length === 9 || G(ue, U.slice(9)), ue;
  }
  function ce(te, U) {
    const ue = [
      m(te.chainId, "chainId"),
      m(te.nonce, "nonce"),
      m(te.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
      m(te.maxFeePerGas || 0, "maxFeePerGas"),
      m(te.gasLimit, "gasLimit"),
      te.to || "0x",
      m(te.value, "value"),
      te.data,
      l(te.accessList || [])
    ];
    return U && (ue.push(m(U.yParity, "yParity")), ue.push((0, R.toBeArray)(U.r)), ue.push((0, R.toBeArray)(U.s))), (0, R.concat)(["0x02", (0, R.encodeRlp)(ue)]);
  }
  function pe(te) {
    const U = (0, R.decodeRlp)((0, R.getBytes)(te).slice(1));
    (0, R.assertArgument)(Array.isArray(U) && (U.length === 8 || U.length === 11), "invalid field count for transaction type: 1", "data", (0, R.hexlify)(te));
    const ue = {
      type: 1,
      chainId: w(U[0], "chainId"),
      nonce: P(U[1], "nonce"),
      gasPrice: w(U[2], "gasPrice"),
      gasLimit: w(U[3], "gasLimit"),
      to: y(U[4]),
      value: w(U[5], "value"),
      data: (0, R.hexlify)(U[6]),
      accessList: E(U[7], "accessList")
    };
    return U.length === 8 || G(ue, U.slice(8)), ue;
  }
  function ve(te, U) {
    const ue = [
      m(te.chainId, "chainId"),
      m(te.nonce, "nonce"),
      m(te.gasPrice || 0, "gasPrice"),
      m(te.gasLimit, "gasLimit"),
      te.to || "0x",
      m(te.value, "value"),
      te.data,
      l(te.accessList || [])
    ];
    return U && (ue.push(m(U.yParity, "recoveryParam")), ue.push((0, R.toBeArray)(U.r)), ue.push((0, R.toBeArray)(U.s))), (0, R.concat)(["0x01", (0, R.encodeRlp)(ue)]);
  }
  function Ee(te) {
    let U = (0, R.decodeRlp)((0, R.getBytes)(te).slice(1)), ue = "3", we = null;
    if (U.length === 4 && Array.isArray(U[0])) {
      ue = "3 (network format)";
      const Re = U[1], fe = U[2], x = U[3];
      (0, R.assertArgument)(Array.isArray(Re), "invalid network format: blobs not an array", "fields[1]", Re), (0, R.assertArgument)(Array.isArray(fe), "invalid network format: commitments not an array", "fields[2]", fe), (0, R.assertArgument)(Array.isArray(x), "invalid network format: proofs not an array", "fields[3]", x), (0, R.assertArgument)(Re.length === fe.length, "invalid network format: blobs/commitments length mismatch", "fields", U), (0, R.assertArgument)(Re.length === x.length, "invalid network format: blobs/proofs length mismatch", "fields", U), we = [];
      for (let _ = 0; _ < U[1].length; _++)
        we.push({
          data: Re[_],
          commitment: fe[_],
          proof: x[_]
        });
      U = U[0];
    }
    (0, R.assertArgument)(Array.isArray(U) && (U.length === 11 || U.length === 14), `invalid field count for transaction type: ${ue}`, "data", (0, R.hexlify)(te));
    const ke = {
      type: 3,
      chainId: w(U[0], "chainId"),
      nonce: P(U[1], "nonce"),
      maxPriorityFeePerGas: w(U[2], "maxPriorityFeePerGas"),
      maxFeePerGas: w(U[3], "maxFeePerGas"),
      gasPrice: null,
      gasLimit: w(U[4], "gasLimit"),
      to: y(U[5]),
      value: w(U[6], "value"),
      data: (0, R.hexlify)(U[7]),
      accessList: E(U[8], "accessList"),
      maxFeePerBlobGas: w(U[9], "maxFeePerBlobGas"),
      blobVersionedHashes: U[10]
    };
    we && (ke.blobs = we), (0, R.assertArgument)(ke.to != null, `invalid address for transaction type: ${ue}`, "data", te), (0, R.assertArgument)(Array.isArray(ke.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", te);
    for (let Re = 0; Re < ke.blobVersionedHashes.length; Re++)
      (0, R.assertArgument)((0, R.isHexString)(ke.blobVersionedHashes[Re], 32), `invalid blobVersionedHash at index ${Re}: must be length 32`, "data", te);
    return U.length === 11 || G(ke, U.slice(11)), ke;
  }
  function Pe(te, U, ue) {
    const we = [
      m(te.chainId, "chainId"),
      m(te.nonce, "nonce"),
      m(te.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
      m(te.maxFeePerGas || 0, "maxFeePerGas"),
      m(te.gasLimit, "gasLimit"),
      te.to || I.ZeroAddress,
      m(te.value, "value"),
      te.data,
      l(te.accessList || []),
      m(te.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
      b(te.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    return U && (we.push(m(U.yParity, "yParity")), we.push((0, R.toBeArray)(U.r)), we.push((0, R.toBeArray)(U.s)), ue) ? (0, R.concat)([
      "0x03",
      (0, R.encodeRlp)([
        we,
        ue.map((ke) => ke.data),
        ue.map((ke) => ke.commitment),
        ue.map((ke) => ke.proof)
      ])
    ]) : (0, R.concat)(["0x03", (0, R.encodeRlp)(we)]);
  }
  const xe = class co {
    /**
     *  Creates a new Transaction with default values.
     */
    constructor() {
      _e(this, j), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), _e(this, n, void 0), _e(this, s, void 0), _e(this, i, void 0), _e(this, a, void 0), _e(this, f, void 0), _e(this, d, void 0), _e(this, c, void 0), _e(this, p, void 0), _e(this, g, void 0), _e(this, v, void 0), _e(this, O, void 0), _e(this, N, void 0), _e(this, S, void 0), Oe(this, e, null), Oe(this, t, null), Oe(this, n, 0), Oe(this, s, $), Oe(this, i, null), Oe(this, a, null), Oe(this, f, null), Oe(this, r, "0x"), Oe(this, d, $), Oe(this, c, $), Oe(this, p, null), Oe(this, g, null), Oe(this, v, null), Oe(this, O, null), Oe(this, S, null), Oe(this, N, null);
    }
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */
    get type() {
      return oe(this, e);
    }
    set type(U) {
      switch (U) {
        case null:
          Oe(this, e, null);
          break;
        case 0:
        case "legacy":
          Oe(this, e, 0);
          break;
        case 1:
        case "berlin":
        case "eip-2930":
          Oe(this, e, 1);
          break;
        case 2:
        case "london":
        case "eip-1559":
          Oe(this, e, 2);
          break;
        case 3:
        case "cancun":
        case "eip-4844":
          Oe(this, e, 3);
          break;
        default:
          (0, R.assertArgument)(!1, "unsupported transaction type", "type", U);
      }
    }
    /**
     *  The name of the transaction type.
     */
    get typeName() {
      switch (this.type) {
        case 0:
          return "legacy";
        case 1:
          return "eip-2930";
        case 2:
          return "eip-1559";
        case 3:
          return "eip-4844";
      }
      return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */
    get to() {
      const U = oe(this, t);
      return U == null && this.type === 3 ? I.ZeroAddress : U;
    }
    set to(U) {
      Oe(this, t, U == null ? null : (0, M.getAddress)(U));
    }
    /**
     *  The transaction nonce.
     */
    get nonce() {
      return oe(this, n);
    }
    set nonce(U) {
      Oe(this, n, (0, R.getNumber)(U, "value"));
    }
    /**
     *  The gas limit.
     */
    get gasLimit() {
      return oe(this, s);
    }
    set gasLimit(U) {
      Oe(this, s, (0, R.getBigInt)(U));
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */
    get gasPrice() {
      const U = oe(this, i);
      return U == null && (this.type === 0 || this.type === 1) ? $ : U;
    }
    set gasPrice(U) {
      Oe(this, i, U == null ? null : (0, R.getBigInt)(U, "gasPrice"));
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */
    get maxPriorityFeePerGas() {
      return oe(this, a) ?? (this.type === 2 || this.type === 3 ? $ : null);
    }
    set maxPriorityFeePerGas(U) {
      Oe(this, a, U == null ? null : (0, R.getBigInt)(U, "maxPriorityFeePerGas"));
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */
    get maxFeePerGas() {
      return oe(this, f) ?? (this.type === 2 || this.type === 3 ? $ : null);
    }
    set maxFeePerGas(U) {
      Oe(this, f, U == null ? null : (0, R.getBigInt)(U, "maxFeePerGas"));
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */
    get data() {
      return oe(this, r);
    }
    set data(U) {
      Oe(this, r, (0, R.hexlify)(U));
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */
    get value() {
      return oe(this, d);
    }
    set value(U) {
      Oe(this, d, (0, R.getBigInt)(U, "value"));
    }
    /**
     *  The chain ID this transaction is valid on.
     */
    get chainId() {
      return oe(this, c);
    }
    set chainId(U) {
      Oe(this, c, (0, R.getBigInt)(U));
    }
    /**
     *  If signed, the signature for this transaction.
     */
    get signature() {
      return oe(this, p) || null;
    }
    set signature(U) {
      Oe(this, p, U == null ? null : A.Signature.from(U));
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */
    get accessList() {
      return (oe(this, g) || null) ?? (this.type === 1 || this.type === 2 || this.type === 3 ? [] : null);
    }
    set accessList(U) {
      Oe(this, g, U == null ? null : (0, L.accessListify)(U));
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */
    get maxFeePerBlobGas() {
      const U = oe(this, v);
      return U == null && this.type === 3 ? $ : U;
    }
    set maxFeePerBlobGas(U) {
      Oe(this, v, U == null ? null : (0, R.getBigInt)(U, "maxFeePerBlobGas"));
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */
    get blobVersionedHashes() {
      let U = oe(this, O);
      return U == null && this.type === 3 ? [] : U;
    }
    set blobVersionedHashes(U) {
      if (U != null) {
        (0, R.assertArgument)(Array.isArray(U), "blobVersionedHashes must be an Array", "value", U), U = U.slice();
        for (let ue = 0; ue < U.length; ue++)
          (0, R.assertArgument)((0, R.isHexString)(U[ue], 32), "invalid blobVersionedHash", `value[${ue}]`, U[ue]);
      }
      Oe(this, O, U);
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */
    get blobs() {
      return oe(this, S) == null ? null : oe(this, S).map((U) => Object.assign({}, U));
    }
    set blobs(U) {
      if (U == null) {
        Oe(this, S, null);
        return;
      }
      const ue = [], we = [];
      for (let ke = 0; ke < U.length; ke++) {
        const Re = U[ke];
        if ((0, R.isBytesLike)(Re)) {
          (0, R.assert)(oe(this, N), "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
            operation: "set blobs()"
          });
          let fe = (0, R.getBytes)(Re);
          if ((0, R.assertArgument)(fe.length <= u, "blob is too large", `blobs[${ke}]`, Re), fe.length !== u) {
            const q = new Uint8Array(u);
            q.set(fe), fe = q;
          }
          const x = oe(this, N).blobToKzgCommitment(fe), _ = (0, R.hexlify)(oe(this, N).computeBlobKzgProof(fe, x));
          ue.push({
            data: (0, R.hexlify)(fe),
            commitment: (0, R.hexlify)(x),
            proof: _
          }), we.push(h(1, x));
        } else {
          const fe = (0, R.hexlify)(Re.commitment);
          ue.push({
            data: (0, R.hexlify)(Re.data),
            commitment: fe,
            proof: (0, R.hexlify)(Re.proof)
          }), we.push(h(1, fe));
        }
      }
      Oe(this, S, ue), Oe(this, O, we);
    }
    get kzg() {
      return oe(this, N);
    }
    set kzg(U) {
      Oe(this, N, U);
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */
    get hash() {
      return this.signature == null ? null : (0, A.keccak256)(Ve(this, j, B).call(this, !0, !1));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */
    get unsignedHash() {
      return (0, A.keccak256)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */
    get from() {
      return this.signature == null ? null : (0, K.recoverAddress)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */
    get fromPublicKey() {
      return this.signature == null ? null : A.SigningKey.recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */
    isSigned() {
      return this.signature != null;
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */
    get serialized() {
      return Ve(this, j, B).call(this, !0, !0);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */
    get unsignedSerialized() {
      return Ve(this, j, B).call(this, !1, !1);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */
    inferType() {
      const U = this.inferTypes();
      return U.indexOf(2) >= 0 ? 2 : U.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */
    inferTypes() {
      const U = this.gasPrice != null, ue = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null, we = this.accessList != null, ke = oe(this, v) != null || oe(this, O);
      this.maxFeePerGas != null && this.maxPriorityFeePerGas != null && (0, R.assert)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", { value: this }), (0, R.assert)(!ue || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", { value: this }), (0, R.assert)(this.type !== 0 || !we, "legacy transaction cannot have accessList", "BAD_DATA", { value: this });
      const Re = [];
      return this.type != null ? Re.push(this.type) : ue ? Re.push(2) : U ? (Re.push(1), we || Re.push(0)) : we ? (Re.push(1), Re.push(2)) : (ke && this.to || (Re.push(0), Re.push(1), Re.push(2)), Re.push(3)), Re.sort(), Re;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isLegacy() {
      return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isBerlin() {
      return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isLondon() {
      return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isCancun() {
      return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */
    clone() {
      return co.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */
    toJSON() {
      const U = (ue) => ue == null ? null : ue.toString();
      return {
        type: this.type,
        to: this.to,
        //            from: this.from,
        data: this.data,
        nonce: this.nonce,
        gasLimit: U(this.gasLimit),
        gasPrice: U(this.gasPrice),
        maxPriorityFeePerGas: U(this.maxPriorityFeePerGas),
        maxFeePerGas: U(this.maxFeePerGas),
        value: U(this.value),
        chainId: U(this.chainId),
        sig: this.signature ? this.signature.toJSON() : null,
        accessList: this.accessList
      };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */
    static from(U) {
      if (U == null)
        return new co();
      if (typeof U == "string") {
        const we = (0, R.getBytes)(U);
        if (we[0] >= 127)
          return co.from(W(we));
        switch (we[0]) {
          case 1:
            return co.from(pe(we));
          case 2:
            return co.from(re(we));
          case 3:
            return co.from(Ee(we));
        }
        (0, R.assert)(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: "from" });
      }
      const ue = new co();
      return U.type != null && (ue.type = U.type), U.to != null && (ue.to = U.to), U.nonce != null && (ue.nonce = U.nonce), U.gasLimit != null && (ue.gasLimit = U.gasLimit), U.gasPrice != null && (ue.gasPrice = U.gasPrice), U.maxPriorityFeePerGas != null && (ue.maxPriorityFeePerGas = U.maxPriorityFeePerGas), U.maxFeePerGas != null && (ue.maxFeePerGas = U.maxFeePerGas), U.maxFeePerBlobGas != null && (ue.maxFeePerBlobGas = U.maxFeePerBlobGas), U.data != null && (ue.data = U.data), U.value != null && (ue.value = U.value), U.chainId != null && (ue.chainId = U.chainId), U.signature != null && (ue.signature = A.Signature.from(U.signature)), U.accessList != null && (ue.accessList = U.accessList), U.blobVersionedHashes != null && (ue.blobVersionedHashes = U.blobVersionedHashes), U.kzg != null && (ue.kzg = U.kzg), U.blobs != null && (ue.blobs = U.blobs), U.hash != null && ((0, R.assertArgument)(ue.isSigned(), "unsigned transaction cannot define '.hash'", "tx", U), (0, R.assertArgument)(ue.hash === U.hash, "hash mismatch", "tx", U)), U.from != null && ((0, R.assertArgument)(ue.isSigned(), "unsigned transaction cannot define '.from'", "tx", U), (0, R.assertArgument)(ue.from.toLowerCase() === (U.from || "").toLowerCase(), "from mismatch", "tx", U)), ue;
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakSet(), B = function(te, U) {
    (0, R.assert)(!te || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
    const ue = te ? this.signature : null;
    switch (this.inferType()) {
      case 0:
        return X(this, ue);
      case 1:
        return ve(this, ue);
      case 2:
        return ce(this, ue);
      case 3:
        return Pe(this, ue, U ? this.blobs : null);
    }
    (0, R.assert)(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
  };
  let me = xe;
  return Uc.Transaction = me, Uc;
}
var m2;
function Yn() {
  return m2 || (m2 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Transaction = e.recoverAddress = e.computeAddress = e.accessListify = void 0;
    var t = j5();
    Object.defineProperty(e, "accessListify", { enumerable: !0, get: function() {
      return t.accessListify;
    } });
    var r = L5();
    Object.defineProperty(e, "computeAddress", { enumerable: !0, get: function() {
      return r.computeAddress;
    } }), Object.defineProperty(e, "recoverAddress", { enumerable: !0, get: function() {
      return r.recoverAddress;
    } });
    var n = KT();
    Object.defineProperty(e, "Transaction", { enumerable: !0, get: function() {
      return n.Transaction;
    } });
  }(h2)), h2;
}
var y2;
function JT() {
  if (y2)
    return Xo;
  y2 = 1, Object.defineProperty(Xo, "__esModule", { value: !0 }), Xo.verifyMessage = Xo.hashMessage = void 0;
  const e = cn(), t = pd(), r = Yn(), n = wt();
  function s(a) {
    return typeof a == "string" && (a = (0, n.toUtf8Bytes)(a)), (0, e.keccak256)((0, n.concat)([
      (0, n.toUtf8Bytes)(t.MessagePrefix),
      (0, n.toUtf8Bytes)(String(a.length)),
      a
    ]));
  }
  Xo.hashMessage = s;
  function i(a, f) {
    const d = s(a);
    return (0, r.recoverAddress)(d, f);
  }
  return Xo.verifyMessage = i, Xo;
}
var Ts = {}, b2;
function QT() {
  if (b2)
    return Ts;
  b2 = 1, Object.defineProperty(Ts, "__esModule", { value: !0 }), Ts.solidityPackedSha256 = Ts.solidityPackedKeccak256 = Ts.solidityPacked = void 0;
  const e = Yr(), t = cn(), r = wt(), n = new RegExp("^bytes([0-9]+)$"), s = new RegExp("^(u?int)([0-9]*)$"), i = new RegExp("^(.*)\\[([0-9]*)\\]$");
  function a(p, g, v) {
    switch (p) {
      case "address":
        return v ? (0, r.getBytes)((0, r.zeroPadValue)(g, 32)) : (0, r.getBytes)((0, e.getAddress)(g));
      case "string":
        return (0, r.toUtf8Bytes)(g);
      case "bytes":
        return (0, r.getBytes)(g);
      case "bool":
        return g = g ? "0x01" : "0x00", v ? (0, r.getBytes)((0, r.zeroPadValue)(g, 32)) : (0, r.getBytes)(g);
    }
    let O = p.match(s);
    if (O) {
      let N = O[1] === "int", S = parseInt(O[2] || "256");
      return (0, r.assertArgument)((!O[2] || O[2] === String(S)) && S % 8 === 0 && S !== 0 && S <= 256, "invalid number type", "type", p), v && (S = 256), N && (g = (0, r.toTwos)(g, S)), (0, r.getBytes)((0, r.zeroPadValue)((0, r.toBeArray)(g), S / 8));
    }
    if (O = p.match(n), O) {
      const N = parseInt(O[1]);
      return (0, r.assertArgument)(String(N) === O[1] && N !== 0 && N <= 32, "invalid bytes type", "type", p), (0, r.assertArgument)((0, r.dataLength)(g) === N, `invalid value for ${p}`, "value", g), v ? (0, r.getBytes)((0, r.zeroPadBytes)(g, 32)) : g;
    }
    if (O = p.match(i), O && Array.isArray(g)) {
      const N = O[1], S = parseInt(O[2] || String(g.length));
      (0, r.assertArgument)(S === g.length, `invalid array length for ${p}`, "value", g);
      const j = [];
      return g.forEach(function(B) {
        j.push(a(N, B, !0));
      }), (0, r.getBytes)((0, r.concat)(j));
    }
    (0, r.assertArgument)(!1, "invalid type", "type", p);
  }
  function f(p, g) {
    (0, r.assertArgument)(p.length === g.length, "wrong number of values; expected ${ types.length }", "values", g);
    const v = [];
    return p.forEach(function(O, N) {
      v.push(a(O, g[N]));
    }), (0, r.hexlify)((0, r.concat)(v));
  }
  Ts.solidityPacked = f;
  function d(p, g) {
    return (0, t.keccak256)(f(p, g));
  }
  Ts.solidityPackedKeccak256 = d;
  function c(p, g) {
    return (0, t.sha256)(f(p, g));
  }
  return Ts.solidityPackedSha256 = c, Ts;
}
var ta = {}, w2;
function ZT() {
  var e, t, r, n, s;
  if (w2)
    return ta;
  w2 = 1, Object.defineProperty(ta, "__esModule", { value: !0 }), ta.verifyTypedData = ta.TypedDataEncoder = void 0;
  const i = Yr(), a = cn(), f = Yn(), d = wt(), c = D5(), p = new Uint8Array(32);
  p.fill(0);
  const g = BigInt(-1), v = BigInt(0), O = BigInt(1), N = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
  function S(D) {
    const o = (0, d.getBytes)(D), u = o.length % 32;
    return u ? (0, d.concat)([o, p.slice(u)]) : (0, d.hexlify)(o);
  }
  const j = (0, d.toBeHex)(O, 32), B = (0, d.toBeHex)(v, 32), M = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
  }, I = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
  ];
  function A(D) {
    return function(o) {
      return (0, d.assertArgument)(typeof o == "string", `invalid domain value for ${JSON.stringify(D)}`, `domain.${D}`, o), o;
    };
  }
  const R = {
    name: A("name"),
    version: A("version"),
    chainId: function(D) {
      const o = (0, d.getBigInt)(D, "domain.chainId");
      return (0, d.assertArgument)(o >= 0, "invalid chain ID", "domain.chainId", D), Number.isSafeInteger(o) ? Number(o) : (0, d.toQuantity)(o);
    },
    verifyingContract: function(D) {
      try {
        return (0, i.getAddress)(D).toLowerCase();
      } catch {
      }
      (0, d.assertArgument)(!1, 'invalid domain value "verifyingContract"', "domain.verifyingContract", D);
    },
    salt: function(D) {
      const o = (0, d.getBytes)(D, "domain.salt");
      return (0, d.assertArgument)(o.length === 32, 'invalid domain value "salt"', "domain.salt", D), (0, d.hexlify)(o);
    }
  };
  function L(D) {
    {
      const o = D.match(/^(u?)int(\d+)$/);
      if (o) {
        const u = o[1] === "", h = parseInt(o[2]);
        (0, d.assertArgument)(h % 8 === 0 && h !== 0 && h <= 256 && o[2] === String(h), "invalid numeric width", "type", D);
        const y = (0, d.mask)(N, u ? h - 1 : h), E = u ? (y + O) * g : v;
        return function(P) {
          const w = (0, d.getBigInt)(P, "value");
          return (0, d.assertArgument)(w >= E && w <= y, `value out-of-bounds for ${D}`, "value", w), (0, d.toBeHex)(u ? (0, d.toTwos)(w, 256) : w, 32);
        };
      }
    }
    {
      const o = D.match(/^bytes(\d+)$/);
      if (o) {
        const u = parseInt(o[1]);
        return (0, d.assertArgument)(u !== 0 && u <= 32 && o[1] === String(u), "invalid bytes width", "type", D), function(h) {
          const y = (0, d.getBytes)(h);
          return (0, d.assertArgument)(y.length === u, `invalid length for ${D}`, "value", h), S(h);
        };
      }
    }
    switch (D) {
      case "address":
        return function(o) {
          return (0, d.zeroPadValue)((0, i.getAddress)(o), 32);
        };
      case "bool":
        return function(o) {
          return o ? j : B;
        };
      case "bytes":
        return function(o) {
          return (0, a.keccak256)(o);
        };
      case "string":
        return function(o) {
          return (0, c.id)(o);
        };
    }
    return null;
  }
  function K(D, o) {
    return `${D}(${o.map(({ name: u, type: h }) => h + " " + u).join(",")})`;
  }
  function $(D) {
    const o = D.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    return o ? {
      base: o[1],
      index: o[2] + o[4],
      array: {
        base: o[1],
        prefix: o[1] + o[2],
        count: o[5] ? parseInt(o[5]) : -1
      }
    } : { base: D };
  }
  const k = class Ri {
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */
    constructor(o) {
      _e(this, n), Be(this, "primaryType"), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), Oe(this, t, /* @__PURE__ */ new Map()), Oe(this, r, /* @__PURE__ */ new Map());
      const u = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), E = {};
      Object.keys(o).forEach((m) => {
        E[m] = o[m].map(({ name: l, type: b }) => {
          let { base: W, index: X } = $(b);
          return W === "int" && !o.int && (W = "int256"), W === "uint" && !o.uint && (W = "uint256"), { name: l, type: W + (X || "") };
        }), u.set(m, /* @__PURE__ */ new Set()), h.set(m, []), y.set(m, /* @__PURE__ */ new Set());
      }), Oe(this, e, JSON.stringify(E));
      for (const m in E) {
        const l = /* @__PURE__ */ new Set();
        for (const b of E[m]) {
          (0, d.assertArgument)(!l.has(b.name), `duplicate variable name ${JSON.stringify(b.name)} in ${JSON.stringify(m)}`, "types", o), l.add(b.name);
          const W = $(b.type).base;
          (0, d.assertArgument)(W !== m, `circular type reference to ${JSON.stringify(W)}`, "types", o), !L(W) && ((0, d.assertArgument)(h.has(W), `unknown type ${JSON.stringify(W)}`, "types", o), h.get(W).push(m), u.get(m).add(W));
        }
      }
      const P = Array.from(h.keys()).filter((m) => h.get(m).length === 0);
      (0, d.assertArgument)(P.length !== 0, "missing primary type", "types", o), (0, d.assertArgument)(P.length === 1, `ambiguous primary types or unused types: ${P.map((m) => JSON.stringify(m)).join(", ")}`, "types", o), (0, d.defineProperties)(this, { primaryType: P[0] });
      function w(m, l) {
        (0, d.assertArgument)(!l.has(m), `circular type reference to ${JSON.stringify(m)}`, "types", o), l.add(m);
        for (const b of u.get(m))
          if (h.has(b)) {
            w(b, l);
            for (const W of l)
              y.get(W).add(b);
          }
        l.delete(m);
      }
      w(this.primaryType, /* @__PURE__ */ new Set());
      for (const [m, l] of y) {
        const b = Array.from(l);
        b.sort(), oe(this, t).set(m, K(m, E[m]) + b.map((W) => K(W, E[W])).join(""));
      }
    }
    /**
     *  The types.
     */
    get types() {
      return JSON.parse(oe(this, e));
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */
    getEncoder(o) {
      let u = oe(this, r).get(o);
      return u || (u = Ve(this, n, s).call(this, o), oe(this, r).set(o, u)), u;
    }
    /**
     *  Return the full type for %%name%%.
     */
    encodeType(o) {
      const u = oe(this, t).get(o);
      return (0, d.assertArgument)(u, `unknown type: ${JSON.stringify(o)}`, "name", o), u;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */
    encodeData(o, u) {
      return this.getEncoder(o)(u);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */
    hashStruct(o, u) {
      return (0, a.keccak256)(this.encodeData(o, u));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */
    encode(o) {
      return this.encodeData(this.primaryType, o);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */
    hash(o) {
      return this.hashStruct(this.primaryType, o);
    }
    /**
     *  @_ignore:
     */
    _visit(o, u, h) {
      if (L(o))
        return h(o, u);
      const y = $(o).array;
      if (y)
        return (0, d.assertArgument)(y.count === -1 || y.count === u.length, `array length mismatch; expected length ${y.count}`, "value", u), u.map((P) => this._visit(y.prefix, P, h));
      const E = this.types[o];
      if (E)
        return E.reduce((P, { name: w, type: m }) => (P[w] = this._visit(m, u[w], h), P), {});
      (0, d.assertArgument)(!1, `unknown type: ${o}`, "type", o);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */
    visit(o, u) {
      return this._visit(this.primaryType, o, u);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */
    static from(o) {
      return new Ri(o);
    }
    /**
     *  Return the primary type for %%types%%.
     */
    static getPrimaryType(o) {
      return Ri.from(o).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */
    static hashStruct(o, u, h) {
      return Ri.from(u).hashStruct(o, h);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */
    static hashDomain(o) {
      const u = [];
      for (const h in o) {
        if (o[h] == null)
          continue;
        const y = M[h];
        (0, d.assertArgument)(y, `invalid typed-data domain key: ${JSON.stringify(h)}`, "domain", o), u.push({ name: h, type: y });
      }
      return u.sort((h, y) => I.indexOf(h.name) - I.indexOf(y.name)), Ri.hashStruct("EIP712Domain", { EIP712Domain: u }, o);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */
    static encode(o, u, h) {
      return (0, d.concat)([
        "0x1901",
        Ri.hashDomain(o),
        Ri.from(u).hash(h)
      ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */
    static hash(o, u, h) {
      return (0, a.keccak256)(Ri.encode(o, u, h));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */
    static async resolveNames(o, u, h, y) {
      o = Object.assign({}, o);
      for (const w in o)
        o[w] == null && delete o[w];
      const E = {};
      o.verifyingContract && !(0, d.isHexString)(o.verifyingContract, 20) && (E[o.verifyingContract] = "0x");
      const P = Ri.from(u);
      P.visit(h, (w, m) => (w === "address" && !(0, d.isHexString)(m, 20) && (E[m] = "0x"), m));
      for (const w in E)
        E[w] = await y(w);
      return o.verifyingContract && E[o.verifyingContract] && (o.verifyingContract = E[o.verifyingContract]), h = P.visit(h, (w, m) => w === "address" && E[m] ? E[m] : m), { domain: o, value: h };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */
    static getPayload(o, u, h) {
      Ri.hashDomain(o);
      const y = {}, E = [];
      I.forEach((m) => {
        const l = o[m];
        l != null && (y[m] = R[m](l), E.push({ name: m, type: M[m] }));
      });
      const P = Ri.from(u);
      u = P.types;
      const w = Object.assign({}, u);
      return (0, d.assertArgument)(w.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", u), w.EIP712Domain = E, P.encode(h), {
        types: w,
        domain: y,
        primaryType: P.primaryType,
        message: P.visit(h, (m, l) => {
          if (m.match(/^bytes(\d*)/))
            return (0, d.hexlify)((0, d.getBytes)(l));
          if (m.match(/^u?int/))
            return (0, d.getBigInt)(l).toString();
          switch (m) {
            case "address":
              return l.toLowerCase();
            case "bool":
              return !!l;
            case "string":
              return (0, d.assertArgument)(typeof l == "string", "invalid string", "value", l), l;
          }
          (0, d.assertArgument)(!1, "unsupported type", "type", m);
        })
      };
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakSet(), s = function(D) {
    {
      const h = L(D);
      if (h)
        return h;
    }
    const o = $(D).array;
    if (o) {
      const h = o.prefix, y = this.getEncoder(h);
      return (E) => {
        (0, d.assertArgument)(o.count === -1 || o.count === E.length, `array length mismatch; expected length ${o.count}`, "value", E);
        let P = E.map(y);
        return oe(this, t).has(h) && (P = P.map(a.keccak256)), (0, a.keccak256)((0, d.concat)(P));
      };
    }
    const u = this.types[D];
    if (u) {
      const h = (0, c.id)(oe(this, t).get(D));
      return (y) => {
        const E = u.map(({ name: P, type: w }) => {
          const m = this.getEncoder(w)(y[P]);
          return oe(this, t).has(w) ? (0, a.keccak256)(m) : m;
        });
        return E.unshift(h), (0, d.concat)(E);
      };
    }
    (0, d.assertArgument)(!1, `unknown type: ${D}`, "type", D);
  };
  let V = k;
  ta.TypedDataEncoder = V;
  function C(D, o, u, h) {
    return (0, f.recoverAddress)(V.hash(D, o, u), h);
  }
  return ta.verifyTypedData = C, ta;
}
var v2;
function no() {
  return v2 || (v2 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.verifyTypedData = e.TypedDataEncoder = e.solidityPackedSha256 = e.solidityPackedKeccak256 = e.solidityPacked = e.verifyMessage = e.hashMessage = e.dnsEncode = e.namehash = e.isValidName = e.ensNormalize = e.id = void 0;
    var t = D5();
    Object.defineProperty(e, "id", { enumerable: !0, get: function() {
      return t.id;
    } });
    var r = $T();
    Object.defineProperty(e, "ensNormalize", { enumerable: !0, get: function() {
      return r.ensNormalize;
    } }), Object.defineProperty(e, "isValidName", { enumerable: !0, get: function() {
      return r.isValidName;
    } }), Object.defineProperty(e, "namehash", { enumerable: !0, get: function() {
      return r.namehash;
    } }), Object.defineProperty(e, "dnsEncode", { enumerable: !0, get: function() {
      return r.dnsEncode;
    } });
    var n = JT();
    Object.defineProperty(e, "hashMessage", { enumerable: !0, get: function() {
      return n.hashMessage;
    } }), Object.defineProperty(e, "verifyMessage", { enumerable: !0, get: function() {
      return n.verifyMessage;
    } });
    var s = QT();
    Object.defineProperty(e, "solidityPacked", { enumerable: !0, get: function() {
      return s.solidityPacked;
    } }), Object.defineProperty(e, "solidityPackedKeccak256", { enumerable: !0, get: function() {
      return s.solidityPackedKeccak256;
    } }), Object.defineProperty(e, "solidityPackedSha256", { enumerable: !0, get: function() {
      return s.solidityPackedSha256;
    } });
    var i = ZT();
    Object.defineProperty(e, "TypedDataEncoder", { enumerable: !0, get: function() {
      return i.TypedDataEncoder;
    } }), Object.defineProperty(e, "verifyTypedData", { enumerable: !0, get: function() {
      return i.verifyTypedData;
    } });
  }(u2)), u2;
}
var A2;
function N1() {
  var e, t, r, n, s, i;
  if (A2)
    return Wr;
  A2 = 1, Object.defineProperty(Wr, "__esModule", { value: !0 }), Wr.StructFragment = Wr.FunctionFragment = Wr.FallbackFragment = Wr.ConstructorFragment = Wr.EventFragment = Wr.ErrorFragment = Wr.NamedFragment = Wr.Fragment = Wr.ParamType = void 0;
  const a = wt(), f = no();
  function d(fe) {
    const x = /* @__PURE__ */ new Set();
    return fe.forEach((_) => x.add(_)), Object.freeze(x);
  }
  const c = d("external public payable override".split(" ")), p = "constant external internal payable private public pure view override", g = d(p.split(" ")), v = "constructor error event fallback function receive struct", O = d(v.split(" ")), N = "calldata memory storage payable indexed", S = d(N.split(" ")), j = [v, N, "tuple returns", p].join(" "), B = d(j.split(" ")), M = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
  }, I = new RegExp("^(\\s*)"), A = new RegExp("^([0-9]+)"), R = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), L = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), K = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$"), $ = class H5 {
    constructor(x) {
      _e(this, r), _e(this, e, void 0), _e(this, t, void 0), Oe(this, e, 0), Oe(this, t, x.slice());
    }
    get offset() {
      return oe(this, e);
    }
    get length() {
      return oe(this, t).length - oe(this, e);
    }
    clone() {
      return new H5(oe(this, t));
    }
    reset() {
      Oe(this, e, 0);
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(x) {
      const _ = this.peek();
      if (_.type !== "KEYWORD" || !x.has(_.text))
        throw new Error(`expected keyword ${_.text}`);
      return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(x) {
      if (this.peek().type !== x) {
        const _ = this.peek();
        throw new Error(`expected ${x}; got ${_.type} ${JSON.stringify(_.text)}`);
      }
      return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
      const x = this.peek();
      if (x.type !== "OPEN_PAREN")
        throw new Error("bad start");
      const _ = Ve(this, r, n).call(this, oe(this, e) + 1, x.match + 1);
      return Oe(this, e, x.match + 1), _;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
      const x = this.peek();
      if (x.type !== "OPEN_PAREN")
        throw new Error("bad start");
      const _ = [];
      for (; oe(this, e) < x.match - 1; ) {
        const q = this.peek().linkNext;
        _.push(Ve(this, r, n).call(this, oe(this, e) + 1, q)), Oe(this, e, q);
      }
      return Oe(this, e, x.match + 1), _;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
      if (oe(this, e) >= oe(this, t).length)
        throw new Error("out-of-bounds");
      return oe(this, t)[oe(this, e)];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(x) {
      const _ = this.peekType("KEYWORD");
      return _ != null && x.has(_) ? _ : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(x) {
      if (this.length === 0)
        return null;
      const _ = this.peek();
      return _.type === x ? _.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
      const x = this.peek();
      return q0(this, e)._++, x;
    }
    toString() {
      const x = [];
      for (let _ = oe(this, e); _ < oe(this, t).length; _++) {
        const q = oe(this, t)[_];
        x.push(`${q.type}:${q.text}`);
      }
      return `<TokenString ${x.join(" ")}>`;
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakSet(), n = function(fe = 0, x = 0) {
    return new $(oe(this, t).slice(fe, x).map((_) => Object.freeze(Object.assign({}, _, {
      match: _.match - fe,
      linkBack: _.linkBack - fe,
      linkNext: _.linkNext - fe
    }))));
  };
  let k = $;
  function V(fe) {
    const x = [], _ = (ye) => {
      const ge = de < fe.length ? JSON.stringify(fe[de]) : "$EOI";
      throw new Error(`invalid token ${ge} at ${de}: ${ye}`);
    };
    let q = [], ne = [], de = 0;
    for (; de < fe.length; ) {
      let ye = fe.substring(de), ge = ye.match(I);
      ge && (de += ge[1].length, ye = fe.substring(de));
      const be = { depth: q.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset: de, value: -1 };
      x.push(be);
      let Me = M[ye[0]] || "";
      if (Me) {
        if (be.type = Me, be.text = ye[0], de++, Me === "OPEN_PAREN")
          q.push(x.length - 1), ne.push(x.length - 1);
        else if (Me == "CLOSE_PAREN")
          q.length === 0 && _("no matching open bracket"), be.match = q.pop(), x[be.match].match = x.length - 1, be.depth--, be.linkBack = ne.pop(), x[be.linkBack].linkNext = x.length - 1;
        else if (Me === "COMMA")
          be.linkBack = ne.pop(), x[be.linkBack].linkNext = x.length - 1, ne.push(x.length - 1);
        else if (Me === "OPEN_BRACKET")
          be.type = "BRACKET";
        else if (Me === "CLOSE_BRACKET") {
          let Ce = x.pop().text;
          if (x.length > 0 && x[x.length - 1].type === "NUMBER") {
            const je = x.pop().text;
            Ce = je + Ce, x[x.length - 1].value = (0, a.getNumber)(je);
          }
          if (x.length === 0 || x[x.length - 1].type !== "BRACKET")
            throw new Error("missing opening bracket");
          x[x.length - 1].text += Ce;
        }
        continue;
      }
      if (ge = ye.match(R), ge) {
        if (be.text = ge[1], de += be.text.length, B.has(be.text)) {
          be.type = "KEYWORD";
          continue;
        }
        if (be.text.match(K)) {
          be.type = "TYPE";
          continue;
        }
        be.type = "ID";
        continue;
      }
      if (ge = ye.match(A), ge) {
        be.text = ge[1], be.type = "NUMBER", de += be.text.length;
        continue;
      }
      throw new Error(`unexpected token ${JSON.stringify(ye[0])} at position ${de}`);
    }
    return new k(x.map((ye) => Object.freeze(ye)));
  }
  function C(fe, x) {
    let _ = [];
    for (const q in x.keys())
      fe.has(q) && _.push(q);
    if (_.length > 1)
      throw new Error(`conflicting types: ${_.join(", ")}`);
  }
  function D(fe, x) {
    if (x.peekKeyword(O)) {
      const _ = x.pop().text;
      if (_ !== fe)
        throw new Error(`expected ${fe}, got ${_}`);
    }
    return x.popType("ID");
  }
  function o(fe, x) {
    const _ = /* @__PURE__ */ new Set();
    for (; ; ) {
      const q = fe.peekType("KEYWORD");
      if (q == null || x && !x.has(q))
        break;
      if (fe.pop(), _.has(q))
        throw new Error(`duplicate keywords: ${JSON.stringify(q)}`);
      _.add(q);
    }
    return Object.freeze(_);
  }
  function u(fe) {
    let x = o(fe, g);
    return C(x, d("constant payable nonpayable".split(" "))), C(x, d("pure view payable nonpayable".split(" "))), x.has("view") ? "view" : x.has("pure") ? "pure" : x.has("payable") ? "payable" : x.has("nonpayable") ? "nonpayable" : x.has("constant") ? "view" : "nonpayable";
  }
  function h(fe, x) {
    return fe.popParams().map((_) => Ee.from(_, x));
  }
  function y(fe) {
    if (fe.peekType("AT")) {
      if (fe.pop(), fe.peekType("NUMBER"))
        return (0, a.getBigInt)(fe.pop().text);
      throw new Error("invalid gas");
    }
    return null;
  }
  function E(fe) {
    if (fe.length)
      throw new Error(`unexpected tokens at offset ${fe.offset}: ${fe.toString()}`);
  }
  const P = new RegExp(/^(.*)\[([0-9]*)\]$/);
  function w(fe) {
    const x = fe.match(K);
    if ((0, a.assertArgument)(x, "invalid type", "type", fe), fe === "uint")
      return "uint256";
    if (fe === "int")
      return "int256";
    if (x[2]) {
      const _ = parseInt(x[2]);
      (0, a.assertArgument)(_ !== 0 && _ <= 32, "invalid bytes length", "type", fe);
    } else if (x[3]) {
      const _ = parseInt(x[3]);
      (0, a.assertArgument)(_ !== 0 && _ <= 256 && _ % 8 === 0, "invalid numeric width", "type", fe);
    }
    return fe;
  }
  const m = {}, l = Symbol.for("_ethers_internal"), b = "_ParamTypeInternal", W = "_ErrorInternal", X = "_EventInternal", G = "_ConstructorInternal", re = "_FallbackInternal", ce = "_FunctionInternal", pe = "_StructInternal", ve = class Ci {
    /**
     *  @private
     */
    constructor(x, _, q, ne, de, ye, ge, be) {
      if (_e(this, s), Be(this, "name"), Be(this, "type"), Be(this, "baseType"), Be(this, "indexed"), Be(this, "components"), Be(this, "arrayLength"), Be(this, "arrayChildren"), (0, a.assertPrivate)(x, m, "ParamType"), Object.defineProperty(this, l, { value: b }), ye && (ye = Object.freeze(ye.slice())), ne === "array") {
        if (ge == null || be == null)
          throw new Error("");
      } else if (ge != null || be != null)
        throw new Error("");
      if (ne === "tuple") {
        if (ye == null)
          throw new Error("");
      } else if (ye != null)
        throw new Error("");
      (0, a.defineProperties)(this, {
        name: _,
        type: q,
        baseType: ne,
        indexed: de,
        components: ye,
        arrayLength: ge,
        arrayChildren: be
      });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */
    format(x) {
      if (x == null && (x = "sighash"), x === "json") {
        const q = this.name || "";
        if (this.isArray()) {
          const de = JSON.parse(this.arrayChildren.format("json"));
          return de.name = q, de.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(de);
        }
        const ne = {
          type: this.baseType === "tuple" ? "tuple" : this.type,
          name: q
        };
        return typeof this.indexed == "boolean" && (ne.indexed = this.indexed), this.isTuple() && (ne.components = this.components.map((de) => JSON.parse(de.format(x)))), JSON.stringify(ne);
      }
      let _ = "";
      return this.isArray() ? (_ += this.arrayChildren.format(x), _ += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? _ += "(" + this.components.map((q) => q.format(x)).join(x === "full" ? ", " : ",") + ")" : _ += this.type, x !== "sighash" && (this.indexed === !0 && (_ += " indexed"), x === "full" && this.name && (_ += " " + this.name)), _;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */
    isArray() {
      return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */
    isTuple() {
      return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */
    isIndexable() {
      return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */
    walk(x, _) {
      if (this.isArray()) {
        if (!Array.isArray(x))
          throw new Error("invalid array value");
        if (this.arrayLength !== -1 && x.length !== this.arrayLength)
          throw new Error("array is wrong length");
        const q = this;
        return x.map((ne) => q.arrayChildren.walk(ne, _));
      }
      if (this.isTuple()) {
        if (!Array.isArray(x))
          throw new Error("invalid tuple value");
        if (x.length !== this.components.length)
          throw new Error("array is wrong length");
        const q = this;
        return x.map((ne, de) => q.components[de].walk(ne, _));
      }
      return _(this.type, x);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS naes by walking and resolving each
     *  ``"address"`` type.
     */
    async walkAsync(x, _) {
      const q = [], ne = [x];
      return Ve(this, s, i).call(this, q, x, _, (de) => {
        ne[0] = de;
      }), q.length && await Promise.all(q), ne[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */
    static from(x, _) {
      if (Ci.isParamType(x))
        return x;
      if (typeof x == "string")
        try {
          return Ci.from(V(x), _);
        } catch {
          (0, a.assertArgument)(!1, "invalid param type", "obj", x);
        }
      else if (x instanceof k) {
        let ge = "", be = "", Me = null;
        o(x, d(["tuple"])).has("tuple") || x.peekType("OPEN_PAREN") ? (be = "tuple", Me = x.popParams().map((Ye) => Ci.from(Ye)), ge = `tuple(${Me.map((Ye) => Ye.format()).join(",")})`) : (ge = w(x.popType("TYPE")), be = ge);
        let Ce = null, je = null;
        for (; x.length && x.peekType("BRACKET"); ) {
          const Ye = x.pop();
          Ce = new Ci(m, "", ge, be, null, Me, je, Ce), je = Ye.value, ge += Ye.text, be = "array", Me = null;
        }
        let Ue = null;
        if (o(x, S).has("indexed")) {
          if (!_)
            throw new Error("");
          Ue = !0;
        }
        const Qe = x.peekType("ID") ? x.pop().text : "";
        if (x.length)
          throw new Error("leftover tokens");
        return new Ci(m, Qe, ge, be, Ue, Me, je, Ce);
      }
      const q = x.name;
      (0, a.assertArgument)(!q || typeof q == "string" && q.match(L), "invalid name", "obj.name", q);
      let ne = x.indexed;
      ne != null && ((0, a.assertArgument)(_, "parameter cannot be indexed", "obj.indexed", x.indexed), ne = !!ne);
      let de = x.type, ye = de.match(P);
      if (ye) {
        const ge = parseInt(ye[2] || "-1"), be = Ci.from({
          type: ye[1],
          components: x.components
        });
        return new Ci(m, q || "", de, "array", ne, null, ge, be);
      }
      if (de === "tuple" || de.startsWith(
        "tuple("
        /* fix: ) */
      ) || de.startsWith(
        "("
        /* fix: ) */
      )) {
        const ge = x.components != null ? x.components.map((be) => Ci.from(be)) : null;
        return new Ci(m, q || "", de, "tuple", ne, ge, null, null);
      }
      return de = w(x.type), new Ci(m, q || "", de, de, ne, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */
    static isParamType(x) {
      return x && x[l] === b;
    }
  };
  s = /* @__PURE__ */ new WeakSet(), i = function(fe, x, _, q) {
    if (this.isArray()) {
      if (!Array.isArray(x))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && x.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const de = this.arrayChildren, ye = x.slice();
      ye.forEach((ge, be) => {
        var Me;
        Ve(Me = de, s, i).call(Me, fe, ge, _, (Ce) => {
          ye[be] = Ce;
        });
      }), q(ye);
      return;
    }
    if (this.isTuple()) {
      const de = this.components;
      let ye;
      if (Array.isArray(x))
        ye = x.slice();
      else {
        if (x == null || typeof x != "object")
          throw new Error("invalid tuple value");
        ye = de.map((ge) => {
          if (!ge.name)
            throw new Error("cannot use object value with unnamed components");
          if (!(ge.name in x))
            throw new Error(`missing value for component ${ge.name}`);
          return x[ge.name];
        });
      }
      if (ye.length !== this.components.length)
        throw new Error("array is wrong length");
      ye.forEach((ge, be) => {
        var Me;
        Ve(Me = de[be], s, i).call(Me, fe, ge, _, (Ce) => {
          ye[be] = Ce;
        });
      }), q(ye);
      return;
    }
    const ne = _(this.type, x);
    ne.then ? fe.push(async function() {
      q(await ne);
    }()) : q(ne);
  };
  let Ee = ve;
  Wr.ParamType = Ee;
  class Pe {
    /**
     *  @private
     */
    constructor(x, _, q) {
      Be(this, "type"), Be(this, "inputs"), (0, a.assertPrivate)(x, m, "Fragment"), q = Object.freeze(q.slice()), (0, a.defineProperties)(this, { type: _, inputs: q });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */
    static from(x) {
      if (typeof x == "string") {
        try {
          Pe.from(JSON.parse(x));
        } catch {
        }
        return Pe.from(V(x));
      }
      if (x instanceof k)
        switch (x.peekKeyword(O)) {
          case "constructor":
            return ue.from(x);
          case "error":
            return te.from(x);
          case "event":
            return U.from(x);
          case "fallback":
          case "receive":
            return we.from(x);
          case "function":
            return ke.from(x);
          case "struct":
            return Re.from(x);
        }
      else if (typeof x == "object") {
        switch (x.type) {
          case "constructor":
            return ue.from(x);
          case "error":
            return te.from(x);
          case "event":
            return U.from(x);
          case "fallback":
          case "receive":
            return we.from(x);
          case "function":
            return ke.from(x);
          case "struct":
            return Re.from(x);
        }
        (0, a.assert)(!1, `unsupported type: ${x.type}`, "UNSUPPORTED_OPERATION", {
          operation: "Fragment.from"
        });
      }
      (0, a.assertArgument)(!1, "unsupported frgament object", "obj", x);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */
    static isConstructor(x) {
      return ue.isFragment(x);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */
    static isError(x) {
      return te.isFragment(x);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */
    static isEvent(x) {
      return U.isFragment(x);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */
    static isFunction(x) {
      return ke.isFragment(x);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */
    static isStruct(x) {
      return Re.isFragment(x);
    }
  }
  Wr.Fragment = Pe;
  class xe extends Pe {
    /**
     *  @private
     */
    constructor(x, _, q, ne) {
      super(x, _, ne), Be(this, "name"), (0, a.assertArgument)(typeof q == "string" && q.match(L), "invalid identifier", "name", q), ne = Object.freeze(ne.slice()), (0, a.defineProperties)(this, { name: q });
    }
  }
  Wr.NamedFragment = xe;
  function me(fe, x) {
    return "(" + x.map((_) => _.format(fe)).join(fe === "full" ? ", " : ",") + ")";
  }
  class te extends xe {
    /**
     *  @private
     */
    constructor(x, _, q) {
      super(x, "error", _, q), Object.defineProperty(this, l, { value: W });
    }
    /**
     *  The Custom Error selector.
     */
    get selector() {
      return (0, f.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */
    format(x) {
      if (x == null && (x = "sighash"), x === "json")
        return JSON.stringify({
          type: "error",
          name: this.name,
          inputs: this.inputs.map((q) => JSON.parse(q.format(x)))
        });
      const _ = [];
      return x !== "sighash" && _.push("error"), _.push(this.name + me(x, this.inputs)), _.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */
    static from(x) {
      if (te.isFragment(x))
        return x;
      if (typeof x == "string")
        return te.from(V(x));
      if (x instanceof k) {
        const _ = D("error", x), q = h(x);
        return E(x), new te(m, _, q);
      }
      return new te(m, x.name, x.inputs ? x.inputs.map(Ee.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */
    static isFragment(x) {
      return x && x[l] === W;
    }
  }
  Wr.ErrorFragment = te;
  class U extends xe {
    /**
     *  @private
     */
    constructor(x, _, q, ne) {
      super(x, "event", _, q), Be(this, "anonymous"), Object.defineProperty(this, l, { value: X }), (0, a.defineProperties)(this, { anonymous: ne });
    }
    /**
     *  The Event topic hash.
     */
    get topicHash() {
      return (0, f.id)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */
    format(x) {
      if (x == null && (x = "sighash"), x === "json")
        return JSON.stringify({
          type: "event",
          anonymous: this.anonymous,
          name: this.name,
          inputs: this.inputs.map((q) => JSON.parse(q.format(x)))
        });
      const _ = [];
      return x !== "sighash" && _.push("event"), _.push(this.name + me(x, this.inputs)), x !== "sighash" && this.anonymous && _.push("anonymous"), _.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */
    static getTopicHash(x, _) {
      return _ = (_ || []).map((q) => Ee.from(q)), new U(m, x, _, !1).topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */
    static from(x) {
      if (U.isFragment(x))
        return x;
      if (typeof x == "string")
        try {
          return U.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid event fragment", "obj", x);
        }
      else if (x instanceof k) {
        const _ = D("event", x), q = h(x, !0), ne = !!o(x, d(["anonymous"])).has("anonymous");
        return E(x), new U(m, _, q, ne);
      }
      return new U(m, x.name, x.inputs ? x.inputs.map((_) => Ee.from(_, !0)) : [], !!x.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */
    static isFragment(x) {
      return x && x[l] === X;
    }
  }
  Wr.EventFragment = U;
  class ue extends Pe {
    /**
     *  @private
     */
    constructor(x, _, q, ne, de) {
      super(x, _, q), Be(this, "payable"), Be(this, "gas"), Object.defineProperty(this, l, { value: G }), (0, a.defineProperties)(this, { payable: ne, gas: de });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */
    format(x) {
      if ((0, a.assert)(x != null && x !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" }), x === "json")
        return JSON.stringify({
          type: "constructor",
          stateMutability: this.payable ? "payable" : "undefined",
          payable: this.payable,
          gas: this.gas != null ? this.gas : void 0,
          inputs: this.inputs.map((q) => JSON.parse(q.format(x)))
        });
      const _ = [`constructor${me(x, this.inputs)}`];
      return this.payable && _.push("payable"), this.gas != null && _.push(`@${this.gas.toString()}`), _.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */
    static from(x) {
      if (ue.isFragment(x))
        return x;
      if (typeof x == "string")
        try {
          return ue.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid constuctor fragment", "obj", x);
        }
      else if (x instanceof k) {
        o(x, d(["constructor"]));
        const _ = h(x), q = !!o(x, c).has("payable"), ne = y(x);
        return E(x), new ue(m, "constructor", _, q, ne);
      }
      return new ue(m, "constructor", x.inputs ? x.inputs.map(Ee.from) : [], !!x.payable, x.gas != null ? x.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */
    static isFragment(x) {
      return x && x[l] === G;
    }
  }
  Wr.ConstructorFragment = ue;
  class we extends Pe {
    constructor(x, _, q) {
      super(x, "fallback", _), Be(this, "payable"), Object.defineProperty(this, l, { value: re }), (0, a.defineProperties)(this, { payable: q });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */
    format(x) {
      const _ = this.inputs.length === 0 ? "receive" : "fallback";
      if (x === "json") {
        const q = this.payable ? "payable" : "nonpayable";
        return JSON.stringify({ type: _, stateMutability: q });
      }
      return `${_}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */
    static from(x) {
      if (we.isFragment(x))
        return x;
      if (typeof x == "string")
        try {
          return we.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid fallback fragment", "obj", x);
        }
      else if (x instanceof k) {
        const _ = x.toString(), q = x.peekKeyword(d(["fallback", "receive"]));
        if ((0, a.assertArgument)(q, "type must be fallback or receive", "obj", _), x.popKeyword(d(["fallback", "receive"])) === "receive") {
          const ye = h(x);
          return (0, a.assertArgument)(ye.length === 0, "receive cannot have arguments", "obj.inputs", ye), o(x, d(["payable"])), E(x), new we(m, [], !0);
        }
        let ne = h(x);
        ne.length ? (0, a.assertArgument)(ne.length === 1 && ne[0].type === "bytes", "invalid fallback inputs", "obj.inputs", ne.map((ye) => ye.format("minimal")).join(", ")) : ne = [Ee.from("bytes")];
        const de = u(x);
        if ((0, a.assertArgument)(de === "nonpayable" || de === "payable", "fallback cannot be constants", "obj.stateMutability", de), o(x, d(["returns"])).has("returns")) {
          const ye = h(x);
          (0, a.assertArgument)(ye.length === 1 && ye[0].type === "bytes", "invalid fallback outputs", "obj.outputs", ye.map((ge) => ge.format("minimal")).join(", "));
        }
        return E(x), new we(m, ne, de === "payable");
      }
      if (x.type === "receive")
        return new we(m, [], !0);
      if (x.type === "fallback") {
        const _ = [Ee.from("bytes")], q = x.stateMutability === "payable";
        return new we(m, _, q);
      }
      (0, a.assertArgument)(!1, "invalid fallback description", "obj", x);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */
    static isFragment(x) {
      return x && x[l] === re;
    }
  }
  Wr.FallbackFragment = we;
  class ke extends xe {
    /**
     *  @private
     */
    constructor(x, _, q, ne, de, ye) {
      super(x, "function", _, ne), Be(this, "constant"), Be(this, "outputs"), Be(this, "stateMutability"), Be(this, "payable"), Be(this, "gas"), Object.defineProperty(this, l, { value: ce }), de = Object.freeze(de.slice());
      const ge = q === "view" || q === "pure", be = q === "payable";
      (0, a.defineProperties)(this, { constant: ge, gas: ye, outputs: de, payable: be, stateMutability: q });
    }
    /**
     *  The Function selector.
     */
    get selector() {
      return (0, f.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */
    format(x) {
      if (x == null && (x = "sighash"), x === "json")
        return JSON.stringify({
          type: "function",
          name: this.name,
          constant: this.constant,
          stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
          payable: this.payable,
          gas: this.gas != null ? this.gas : void 0,
          inputs: this.inputs.map((q) => JSON.parse(q.format(x))),
          outputs: this.outputs.map((q) => JSON.parse(q.format(x)))
        });
      const _ = [];
      return x !== "sighash" && _.push("function"), _.push(this.name + me(x, this.inputs)), x !== "sighash" && (this.stateMutability !== "nonpayable" && _.push(this.stateMutability), this.outputs && this.outputs.length && (_.push("returns"), _.push(me(x, this.outputs))), this.gas != null && _.push(`@${this.gas.toString()}`)), _.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */
    static getSelector(x, _) {
      return _ = (_ || []).map((q) => Ee.from(q)), new ke(m, x, "view", _, [], null).selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */
    static from(x) {
      if (ke.isFragment(x))
        return x;
      if (typeof x == "string")
        try {
          return ke.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid function fragment", "obj", x);
        }
      else if (x instanceof k) {
        const q = D("function", x), ne = h(x), de = u(x);
        let ye = [];
        o(x, d(["returns"])).has("returns") && (ye = h(x));
        const ge = y(x);
        return E(x), new ke(m, q, de, ne, ye, ge);
      }
      let _ = x.stateMutability;
      return _ == null && (_ = "payable", typeof x.constant == "boolean" ? (_ = "view", x.constant || (_ = "payable", typeof x.payable == "boolean" && !x.payable && (_ = "nonpayable"))) : typeof x.payable == "boolean" && !x.payable && (_ = "nonpayable")), new ke(m, x.name, _, x.inputs ? x.inputs.map(Ee.from) : [], x.outputs ? x.outputs.map(Ee.from) : [], x.gas != null ? x.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */
    static isFragment(x) {
      return x && x[l] === ce;
    }
  }
  Wr.FunctionFragment = ke;
  class Re extends xe {
    /**
     *  @private
     */
    constructor(x, _, q) {
      super(x, "struct", _, q), Object.defineProperty(this, l, { value: pe });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */
    format() {
      throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */
    static from(x) {
      if (typeof x == "string")
        try {
          return Re.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid struct fragment", "obj", x);
        }
      else if (x instanceof k) {
        const _ = D("struct", x), q = h(x);
        return E(x), new Re(m, _, q);
      }
      return new Re(m, x.name, x.inputs ? x.inputs.map(Ee.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */
    static isFragment(x) {
      return x && x[l] === pe;
    }
  }
  return Wr.StructFragment = Re, Wr;
}
var E2;
function W5() {
  var e, t;
  if (E2)
    return hc;
  E2 = 1, Object.defineProperty(hc, "__esModule", { value: !0 }), hc.AbiCoder = void 0;
  const r = wt(), n = Ji(), s = DT(), i = F5(), a = LT(), f = U5(), d = HT(), c = WT(), p = GT(), g = zT(), v = VT(), O = N1(), N = Yr(), S = wt(), j = /* @__PURE__ */ new Map();
  j.set(0, "GENERIC_PANIC"), j.set(1, "ASSERT_FALSE"), j.set(17, "OVERFLOW"), j.set(18, "DIVIDE_BY_ZERO"), j.set(33, "ENUM_RANGE_ERROR"), j.set(34, "BAD_STORAGE_DATA"), j.set(49, "STACK_UNDERFLOW"), j.set(50, "ARRAY_RANGE_ERROR"), j.set(65, "OUT_OF_MEMORY"), j.set(81, "UNINITIALIZED_FUNCTION_CALL");
  const B = new RegExp(/^bytes([0-9]*)$/), M = new RegExp(/^(u?int)([0-9]*)$/);
  let I = null, A = 1024;
  function R($, k, V, C) {
    let D = "missing revert data", o = null;
    const u = null;
    let h = null;
    if (V) {
      D = "execution reverted";
      const E = (0, S.getBytes)(V);
      if (V = (0, S.hexlify)(V), E.length === 0)
        D += " (no data present; likely require(false) occurred", o = "require(false)";
      else if (E.length % 32 !== 4)
        D += " (could not decode reason; invalid data length)";
      else if ((0, S.hexlify)(E.slice(0, 4)) === "0x08c379a0")
        try {
          o = C.decode(["string"], E.slice(4))[0], h = {
            signature: "Error(string)",
            name: "Error",
            args: [o]
          }, D += `: ${JSON.stringify(o)}`;
        } catch {
          D += " (could not decode reason; invalid string data)";
        }
      else if ((0, S.hexlify)(E.slice(0, 4)) === "0x4e487b71")
        try {
          const P = Number(C.decode(["uint256"], E.slice(4))[0]);
          h = {
            signature: "Panic(uint256)",
            name: "Panic",
            args: [P]
          }, o = `Panic due to ${j.get(P) || "UNKNOWN"}(${P})`, D += `: ${o}`;
        } catch {
          D += " (could not decode panic code)";
        }
      else
        D += " (unknown custom error)";
    }
    const y = {
      to: k.to ? (0, N.getAddress)(k.to) : null,
      data: k.data || "0x"
    };
    return k.from && (y.from = (0, N.getAddress)(k.from)), (0, S.makeError)(D, "CALL_EXCEPTION", {
      action: $,
      data: V,
      reason: o,
      transaction: y,
      invocation: u,
      revert: h
    });
  }
  const L = class Dp {
    constructor() {
      _e(this, e);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */
    getDefaultValue(k) {
      const V = k.map((C) => Ve(this, e, t).call(this, O.ParamType.from(C)));
      return new v.TupleCoder(V, "_").defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */
    encode(k, V) {
      (0, r.assertArgumentCount)(V.length, k.length, "types/values length mismatch");
      const C = k.map((u) => Ve(this, e, t).call(this, O.ParamType.from(u))), D = new v.TupleCoder(C, "_"), o = new n.Writer();
      return D.encode(o, V), o.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */
    decode(k, V, C) {
      const D = k.map((o) => Ve(this, e, t).call(this, O.ParamType.from(o)));
      return new v.TupleCoder(D, "_").decode(new n.Reader(V, C, A));
    }
    static _setDefaultMaxInflation(k) {
      (0, r.assertArgument)(typeof k == "number" && Number.isInteger(k), "invalid defaultMaxInflation factor", "value", k), A = k;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */
    static defaultAbiCoder() {
      return I == null && (I = new Dp()), I;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */
    static getBuiltinCallException(k, V, C) {
      return R(k, V, C, Dp.defaultAbiCoder());
    }
  };
  e = /* @__PURE__ */ new WeakSet(), t = function($) {
    if ($.isArray())
      return new i.ArrayCoder(Ve(this, e, t).call(this, $.arrayChildren), $.arrayLength, $.name);
    if ($.isTuple())
      return new v.TupleCoder($.components.map((V) => Ve(this, e, t).call(this, V)), $.name);
    switch ($.baseType) {
      case "address":
        return new s.AddressCoder($.name);
      case "bool":
        return new a.BooleanCoder($.name);
      case "string":
        return new g.StringCoder($.name);
      case "bytes":
        return new f.BytesCoder($.name);
      case "":
        return new c.NullCoder($.name);
    }
    let k = $.type.match(M);
    if (k) {
      let V = parseInt(k[2] || "256");
      return (0, r.assertArgument)(V !== 0 && V <= 256 && V % 8 === 0, "invalid " + k[1] + " bit length", "param", $), new p.NumberCoder(V / 8, k[1] === "int", $.name);
    }
    if (k = $.type.match(B), k) {
      let V = parseInt(k[1]);
      return (0, r.assertArgument)(V !== 0 && V <= 32, "invalid bytes length", "param", $), new d.FixedBytesCoder(V, $.name);
    }
    (0, r.assertArgument)(!1, "invalid type", "type", $.type);
  };
  let K = L;
  return hc.AbiCoder = K, hc;
}
var ra = {}, P2;
function YT() {
  if (P2)
    return ra;
  P2 = 1, Object.defineProperty(ra, "__esModule", { value: !0 }), ra.decodeBytes32String = ra.encodeBytes32String = void 0;
  const e = wt();
  function t(n) {
    const s = (0, e.toUtf8Bytes)(n);
    if (s.length > 31)
      throw new Error("bytes32 string must be less than 32 bytes");
    return (0, e.zeroPadBytes)(s, 32);
  }
  ra.encodeBytes32String = t;
  function r(n) {
    const s = (0, e.getBytes)(n, "bytes");
    if (s.length !== 32)
      throw new Error("invalid bytes32 - not 32 bytes long");
    if (s[31] !== 0)
      throw new Error("invalid bytes32 string - no null terminator");
    let i = 31;
    for (; s[i - 1] === 0; )
      i--;
    return (0, e.toUtf8String)(s.slice(0, i));
  }
  return ra.decodeBytes32String = r, ra;
}
var O2 = {}, N2;
function XT() {
  return N2 || (N2 = 1, function(e) {
    var t, r, n, s, i, a, f, d;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Interface = e.Indexed = e.ErrorDescription = e.TransactionDescription = e.LogDescription = e.Result = e.checkResultErrors = void 0;
    const c = cn(), p = no(), g = wt(), v = W5(), O = Ji();
    Object.defineProperty(e, "checkResultErrors", { enumerable: !0, get: function() {
      return O.checkResultErrors;
    } }), Object.defineProperty(e, "Result", { enumerable: !0, get: function() {
      return O.Result;
    } });
    const N = N1(), S = ro();
    class j {
      /**
       *  @_ignore:
       */
      constructor(k, V, C) {
        Be(this, "fragment"), Be(this, "name"), Be(this, "signature"), Be(this, "topic"), Be(this, "args");
        const D = k.name, o = k.format();
        (0, g.defineProperties)(this, {
          fragment: k,
          name: D,
          signature: o,
          topic: V,
          args: C
        });
      }
    }
    e.LogDescription = j;
    class B {
      /**
       *  @_ignore:
       */
      constructor(k, V, C, D) {
        Be(this, "fragment"), Be(this, "name"), Be(this, "args"), Be(this, "signature"), Be(this, "selector"), Be(this, "value");
        const o = k.name, u = k.format();
        (0, g.defineProperties)(this, {
          fragment: k,
          name: o,
          args: C,
          signature: u,
          selector: V,
          value: D
        });
      }
    }
    e.TransactionDescription = B;
    class M {
      /**
       *  @_ignore:
       */
      constructor(k, V, C) {
        Be(this, "fragment"), Be(this, "name"), Be(this, "args"), Be(this, "signature"), Be(this, "selector");
        const D = k.name, o = k.format();
        (0, g.defineProperties)(this, {
          fragment: k,
          name: D,
          args: C,
          signature: o,
          selector: V
        });
      }
    }
    e.ErrorDescription = M;
    class I {
      /**
       *  @_ignore:
       */
      constructor(k) {
        Be(this, "hash"), Be(this, "_isIndexed"), (0, g.defineProperties)(this, { hash: k, _isIndexed: !0 });
      }
      /**
       *  Returns ``true`` if %%value%% is an **Indexed**.
       *
       *  This provides a Type Guard for property access.
       */
      static isIndexed(k) {
        return !!(k && k._isIndexed);
      }
    }
    e.Indexed = I;
    const A = {
      0: "generic panic",
      1: "assert(false)",
      17: "arithmetic overflow",
      18: "division or modulo by zero",
      33: "enum overflow",
      34: "invalid encoded storage byte array accessed",
      49: "out-of-bounds array access; popping on an empty array",
      50: "out-of-bounds access of an array or bytesN",
      65: "out of memory",
      81: "uninitialized function"
    }, R = {
      "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: ["string"],
        reason: ($) => `reverted with reason string ${JSON.stringify($)}`
      },
      "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: ["uint256"],
        reason: ($) => {
          let k = "unknown panic code";
          return $ >= 0 && $ <= 255 && A[$.toString()] && (k = A[$.toString()]), `reverted with panic code 0x${$.toString(16)} (${k})`;
        }
      }
    }, L = class bu {
      /**
       *  Create a new Interface for the %%fragments%%.
       */
      constructor(k) {
        _e(this, i), _e(this, f), Be(this, "fragments"), Be(this, "deploy"), Be(this, "fallback"), Be(this, "receive"), _e(this, t, void 0), _e(this, r, void 0), _e(this, n, void 0), _e(this, s, void 0);
        let V = [];
        typeof k == "string" ? V = JSON.parse(k) : V = k, Oe(this, n, /* @__PURE__ */ new Map()), Oe(this, t, /* @__PURE__ */ new Map()), Oe(this, r, /* @__PURE__ */ new Map());
        const C = [];
        for (const u of V)
          try {
            C.push(N.Fragment.from(u));
          } catch (h) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(u)}:`, h.message);
          }
        (0, g.defineProperties)(this, {
          fragments: Object.freeze(C)
        });
        let D = null, o = !1;
        Oe(this, s, this.getAbiCoder()), this.fragments.forEach((u, h) => {
          let y;
          switch (u.type) {
            case "constructor":
              if (this.deploy) {
                console.log("duplicate definition - constructor");
                return;
              }
              (0, g.defineProperties)(this, { deploy: u });
              return;
            case "fallback":
              u.inputs.length === 0 ? o = !0 : ((0, g.assertArgument)(!D || u.payable !== D.payable, "conflicting fallback fragments", `fragments[${h}]`, u), D = u, o = D.payable);
              return;
            case "function":
              y = oe(this, n);
              break;
            case "event":
              y = oe(this, r);
              break;
            case "error":
              y = oe(this, t);
              break;
            default:
              return;
          }
          const E = u.format();
          y.has(E) || y.set(E, u);
        }), this.deploy || (0, g.defineProperties)(this, {
          deploy: N.ConstructorFragment.from("constructor()")
        }), (0, g.defineProperties)(this, { fallback: D, receive: o });
      }
      /**
       *  Returns the entire Human-Readable ABI, as an array of
       *  signatures, optionally as %%minimal%% strings, which
       *  removes parameter names and unneceesary spaces.
       */
      format(k) {
        const V = k ? "minimal" : "full";
        return this.fragments.map((C) => C.format(V));
      }
      /**
       *  Return the JSON-encoded ABI. This is the format Solidiy
       *  returns.
       */
      formatJson() {
        const k = this.fragments.map((V) => V.format("json"));
        return JSON.stringify(k.map((V) => JSON.parse(V)));
      }
      /**
       *  The ABI coder that will be used to encode and decode binary
       *  data.
       */
      getAbiCoder() {
        return v.AbiCoder.defaultAbiCoder();
      }
      /**
       *  Get the function name for %%key%%, which may be a function selector,
       *  function name or function signature that belongs to the ABI.
       */
      getFunctionName(k) {
        const V = Ve(this, i, a).call(this, k, null, !1);
        return (0, g.assertArgument)(V, "no matching function", "key", k), V.name;
      }
      /**
       *  Returns true if %%key%% (a function selector, function name or
       *  function signature) is present in the ABI.
       *
       *  In the case of a function name, the name may be ambiguous, so
       *  accessing the [[FunctionFragment]] may require refinement.
       */
      hasFunction(k) {
        return !!Ve(this, i, a).call(this, k, null, !1);
      }
      /**
       *  Get the [[FunctionFragment]] for %%key%%, which may be a function
       *  selector, function name or function signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple functions match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single function in
       *  the ABI, this will throw.
       */
      getFunction(k, V) {
        return Ve(this, i, a).call(this, k, V || null, !0);
      }
      /**
       *  Iterate over all functions, calling %%callback%%, sorted by their name.
       */
      forEachFunction(k) {
        const V = Array.from(oe(this, n).keys());
        V.sort((C, D) => C.localeCompare(D));
        for (let C = 0; C < V.length; C++) {
          const D = V[C];
          k(oe(this, n).get(D), C);
        }
      }
      /**
       *  Get the event name for %%key%%, which may be a topic hash,
       *  event name or event signature that belongs to the ABI.
       */
      getEventName(k) {
        const V = Ve(this, f, d).call(this, k, null, !1);
        return (0, g.assertArgument)(V, "no matching event", "key", k), V.name;
      }
      /**
       *  Returns true if %%key%% (an event topic hash, event name or
       *  event signature) is present in the ABI.
       *
       *  In the case of an event name, the name may be ambiguous, so
       *  accessing the [[EventFragment]] may require refinement.
       */
      hasEvent(k) {
        return !!Ve(this, f, d).call(this, k, null, !1);
      }
      /**
       *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
       *  event name or event signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple events match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single event in
       *  the ABI, this will throw.
       */
      getEvent(k, V) {
        return Ve(this, f, d).call(this, k, V || null, !0);
      }
      /**
       *  Iterate over all events, calling %%callback%%, sorted by their name.
       */
      forEachEvent(k) {
        const V = Array.from(oe(this, r).keys());
        V.sort((C, D) => C.localeCompare(D));
        for (let C = 0; C < V.length; C++) {
          const D = V[C];
          k(oe(this, r).get(D), C);
        }
      }
      /**
       *  Get the [[ErrorFragment]] for %%key%%, which may be an error
       *  selector, error name or error signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple errors match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single error in
       *  the ABI, this will throw.
       */
      getError(k, V) {
        if ((0, g.isHexString)(k)) {
          const D = k.toLowerCase();
          if (R[D])
            return N.ErrorFragment.from(R[D].signature);
          for (const o of oe(this, t).values())
            if (D === o.selector)
              return o;
          return null;
        }
        if (k.indexOf("(") === -1) {
          const D = [];
          for (const [o, u] of oe(this, t))
            o.split(
              "("
              /* fix:) */
            )[0] === k && D.push(u);
          if (D.length === 0)
            return k === "Error" ? N.ErrorFragment.from("error Error(string)") : k === "Panic" ? N.ErrorFragment.from("error Panic(uint256)") : null;
          if (D.length > 1) {
            const o = D.map((u) => JSON.stringify(u.format())).join(", ");
            (0, g.assertArgument)(!1, `ambiguous error description (i.e. ${o})`, "name", k);
          }
          return D[0];
        }
        return k = N.ErrorFragment.from(k).format(), k === "Error(string)" ? N.ErrorFragment.from("error Error(string)") : k === "Panic(uint256)" ? N.ErrorFragment.from("error Panic(uint256)") : oe(this, t).get(k) || null;
      }
      /**
       *  Iterate over all errors, calling %%callback%%, sorted by their name.
       */
      forEachError(k) {
        const V = Array.from(oe(this, t).keys());
        V.sort((C, D) => C.localeCompare(D));
        for (let C = 0; C < V.length; C++) {
          const D = V[C];
          k(oe(this, t).get(D), C);
        }
      }
      // Get the 4-byte selector used by Solidity to identify a function
      /*
      		getSelector(fragment: ErrorFragment | FunctionFragment): string {
      		    if (typeof(fragment) === "string") {
      		        const matches: Array<Fragment> = [ ];
      
      		        try { matches.push(this.getFunction(fragment)); } catch (error) { }
      		        try { matches.push(this.getError(<string>fragment)); } catch (_) { }
      
      		        if (matches.length === 0) {
      		            logger.throwArgumentError("unknown fragment", "key", fragment);
      		        } else if (matches.length > 1) {
      		            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
      		        }
      
      		        fragment = matches[0];
      		    }
      
      		    return dataSlice(id(fragment.format()), 0, 4);
      		}
      		    */
      // Get the 32-byte topic hash used by Solidity to identify an event
      /*
      getEventTopic(fragment: EventFragment): string {
          //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
          return id(fragment.format());
      }
      */
      _decodeParams(k, V) {
        return oe(this, s).decode(k, V);
      }
      _encodeParams(k, V) {
        return oe(this, s).encode(k, V);
      }
      /**
       *  Encodes a ``tx.data`` object for deploying the Contract with
       *  the %%values%% as the constructor arguments.
       */
      encodeDeploy(k) {
        return this._encodeParams(this.deploy.inputs, k || []);
      }
      /**
       *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
       *  specified error (see [[getError]] for valid values for
       *  %%key%%).
       *
       *  Most developers should prefer the [[parseCallResult]] method instead,
       *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
       *  corresponding error.
       */
      decodeErrorResult(k, V) {
        if (typeof k == "string") {
          const C = this.getError(k);
          (0, g.assertArgument)(C, "unknown error", "fragment", k), k = C;
        }
        return (0, g.assertArgument)((0, g.dataSlice)(V, 0, 4) === k.selector, `data signature does not match error ${k.name}.`, "data", V), this._decodeParams(k.inputs, (0, g.dataSlice)(V, 4));
      }
      /**
       *  Encodes the transaction revert data for a call result that
       *  reverted from the the Contract with the sepcified %%error%%
       *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
       *
       *  This is generally not used by most developers, unless trying to mock
       *  a result from a Contract.
       */
      encodeErrorResult(k, V) {
        if (typeof k == "string") {
          const C = this.getError(k);
          (0, g.assertArgument)(C, "unknown error", "fragment", k), k = C;
        }
        return (0, g.concat)([
          k.selector,
          this._encodeParams(k.inputs, V || [])
        ]);
      }
      /**
       *  Decodes the %%data%% from a transaction ``tx.data`` for
       *  the function specified (see [[getFunction]] for valid values
       *  for %%fragment%%).
       *
       *  Most developers should prefer the [[parseTransaction]] method
       *  instead, which will automatically detect the fragment.
       */
      decodeFunctionData(k, V) {
        if (typeof k == "string") {
          const C = this.getFunction(k);
          (0, g.assertArgument)(C, "unknown function", "fragment", k), k = C;
        }
        return (0, g.assertArgument)((0, g.dataSlice)(V, 0, 4) === k.selector, `data signature does not match function ${k.name}.`, "data", V), this._decodeParams(k.inputs, (0, g.dataSlice)(V, 4));
      }
      /**
       *  Encodes the ``tx.data`` for a transaction that calls the function
       *  specified (see [[getFunction]] for valid values for %%fragment%%) with
       *  the %%values%%.
       */
      encodeFunctionData(k, V) {
        if (typeof k == "string") {
          const C = this.getFunction(k);
          (0, g.assertArgument)(C, "unknown function", "fragment", k), k = C;
        }
        return (0, g.concat)([
          k.selector,
          this._encodeParams(k.inputs, V || [])
        ]);
      }
      /**
       *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
       *  specified function (see [[getFunction]] for valid values for
       *  %%key%%).
       *
       *  Most developers should prefer the [[parseCallResult]] method instead,
       *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
       *  corresponding error.
       */
      decodeFunctionResult(k, V) {
        if (typeof k == "string") {
          const o = this.getFunction(k);
          (0, g.assertArgument)(o, "unknown function", "fragment", k), k = o;
        }
        let C = "invalid length for result data";
        const D = (0, g.getBytesCopy)(V);
        if (D.length % 32 === 0)
          try {
            return oe(this, s).decode(k.outputs, D);
          } catch {
            C = "could not decode result data";
          }
        (0, g.assert)(!1, C, "BAD_DATA", {
          value: (0, g.hexlify)(D),
          info: { method: k.name, signature: k.format() }
        });
      }
      makeError(k, V) {
        const C = (0, g.getBytes)(k, "data"), D = v.AbiCoder.getBuiltinCallException("call", V, C);
        if (D.message.startsWith("execution reverted (unknown custom error)")) {
          const u = (0, g.hexlify)(C.slice(0, 4)), h = this.getError(u);
          if (h)
            try {
              const y = oe(this, s).decode(h.inputs, C.slice(4));
              D.revert = {
                name: h.name,
                signature: h.format(),
                args: y
              }, D.reason = D.revert.signature, D.message = `execution reverted: ${D.reason}`;
            } catch {
              D.message = "execution reverted (coult not decode custom error)";
            }
        }
        const o = this.parseTransaction(V);
        return o && (D.invocation = {
          method: o.name,
          signature: o.signature,
          args: o.args
        }), D;
      }
      /**
       *  Encodes the result data (e.g. from an ``eth_call``) for the
       *  specified function (see [[getFunction]] for valid values
       *  for %%fragment%%) with %%values%%.
       *
       *  This is generally not used by most developers, unless trying to mock
       *  a result from a Contract.
       */
      encodeFunctionResult(k, V) {
        if (typeof k == "string") {
          const C = this.getFunction(k);
          (0, g.assertArgument)(C, "unknown function", "fragment", k), k = C;
        }
        return (0, g.hexlify)(oe(this, s).encode(k.outputs, V || []));
      }
      /*
          spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
              const promises: Array<Promise<>> = [ ];
              const process = function(type: ParamType, value: any): any {
                  if (type.baseType === "array") {
                      return descend(type.child
                  }
                  if (type. === "address") {
                  }
              };
      
              const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                  if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                  
              };
      
              const result: Array<any> = [ ];
              values.forEach((value, index) => {
                  if (value == null) {
                      topics.push(null);
                  } else if (param.baseType === "array" || param.baseType === "tuple") {
                      logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                  } else if (Array.isArray(value)) {
                      topics.push(value.map((value) => encodeTopic(param, value)));
                  } else {
                      topics.push(encodeTopic(param, value));
                  }
              });
          }
      */
      // Create the filter for the event with search criteria (e.g. for eth_filterLog)
      encodeFilterTopics(k, V) {
        if (typeof k == "string") {
          const o = this.getEvent(k);
          (0, g.assertArgument)(o, "unknown event", "eventFragment", k), k = o;
        }
        (0, g.assert)(V.length <= k.inputs.length, `too many arguments for ${k.format()}`, "UNEXPECTED_ARGUMENT", { count: V.length, expectedCount: k.inputs.length });
        const C = [];
        k.anonymous || C.push(k.topicHash);
        const D = (o, u) => o.type === "string" ? (0, p.id)(u) : o.type === "bytes" ? (0, c.keccak256)((0, g.hexlify)(u)) : (o.type === "bool" && typeof u == "boolean" ? u = u ? "0x01" : "0x00" : o.type.match(/^u?int/) ? u = (0, g.toBeHex)(u) : o.type.match(/^bytes/) ? u = (0, g.zeroPadBytes)(u, 32) : o.type === "address" && oe(this, s).encode(["address"], [u]), (0, g.zeroPadValue)((0, g.hexlify)(u), 32));
        for (V.forEach((o, u) => {
          const h = k.inputs[u];
          if (!h.indexed) {
            (0, g.assertArgument)(o == null, "cannot filter non-indexed parameters; must be null", "contract." + h.name, o);
            return;
          }
          o == null ? C.push(null) : h.baseType === "array" || h.baseType === "tuple" ? (0, g.assertArgument)(!1, "filtering with tuples or arrays not supported", "contract." + h.name, o) : Array.isArray(o) ? C.push(o.map((y) => D(h, y))) : C.push(D(h, o));
        }); C.length && C[C.length - 1] === null; )
          C.pop();
        return C;
      }
      encodeEventLog(k, V) {
        if (typeof k == "string") {
          const u = this.getEvent(k);
          (0, g.assertArgument)(u, "unknown event", "eventFragment", k), k = u;
        }
        const C = [], D = [], o = [];
        return k.anonymous || C.push(k.topicHash), (0, g.assertArgument)(V.length === k.inputs.length, "event arguments/values mismatch", "values", V), k.inputs.forEach((u, h) => {
          const y = V[h];
          if (u.indexed)
            if (u.type === "string")
              C.push((0, p.id)(y));
            else if (u.type === "bytes")
              C.push((0, c.keccak256)(y));
            else {
              if (u.baseType === "tuple" || u.baseType === "array")
                throw new Error("not implemented");
              C.push(oe(this, s).encode([u.type], [y]));
            }
          else
            D.push(u), o.push(y);
        }), {
          data: oe(this, s).encode(D, o),
          topics: C
        };
      }
      // Decode a filter for the event and the search criteria
      decodeEventLog(k, V, C) {
        if (typeof k == "string") {
          const l = this.getEvent(k);
          (0, g.assertArgument)(l, "unknown event", "eventFragment", k), k = l;
        }
        if (C != null && !k.anonymous) {
          const l = k.topicHash;
          (0, g.assertArgument)((0, g.isHexString)(C[0], 32) && C[0].toLowerCase() === l, "fragment/topic mismatch", "topics[0]", C[0]), C = C.slice(1);
        }
        const D = [], o = [], u = [];
        k.inputs.forEach((l, b) => {
          l.indexed ? l.type === "string" || l.type === "bytes" || l.baseType === "tuple" || l.baseType === "array" ? (D.push(N.ParamType.from({ type: "bytes32", name: l.name })), u.push(!0)) : (D.push(l), u.push(!1)) : (o.push(l), u.push(!1));
        });
        const h = C != null ? oe(this, s).decode(D, (0, g.concat)(C)) : null, y = oe(this, s).decode(o, V, !0), E = [], P = [];
        let w = 0, m = 0;
        return k.inputs.forEach((l, b) => {
          let W = null;
          if (l.indexed)
            if (h == null)
              W = new I(null);
            else if (u[b])
              W = new I(h[m++]);
            else
              try {
                W = h[m++];
              } catch (X) {
                W = X;
              }
          else
            try {
              W = y[w++];
            } catch (X) {
              W = X;
            }
          E.push(W), P.push(l.name || null);
        }), O.Result.fromItems(E, P);
      }
      /**
       *  Parses a transaction, finding the matching function and extracts
       *  the parameter values along with other useful function details.
       *
       *  If the matching function cannot be found, return null.
       */
      parseTransaction(k) {
        const V = (0, g.getBytes)(k.data, "tx.data"), C = (0, g.getBigInt)(k.value != null ? k.value : 0, "tx.value"), D = this.getFunction((0, g.hexlify)(V.slice(0, 4)));
        if (!D)
          return null;
        const o = oe(this, s).decode(D.inputs, V.slice(4));
        return new B(D, D.selector, o, C);
      }
      parseCallResult(k) {
        throw new Error("@TODO");
      }
      /**
       *  Parses a receipt log, finding the matching event and extracts
       *  the parameter values along with other useful event details.
       *
       *  If the matching event cannot be found, returns null.
       */
      parseLog(k) {
        const V = this.getEvent(k.topics[0]);
        return !V || V.anonymous ? null : new j(V, V.topicHash, this.decodeEventLog(V, k.data, k.topics));
      }
      /**
       *  Parses a revert data, finding the matching error and extracts
       *  the parameter values along with other useful error details.
       *
       *  If the matching error cannot be found, returns null.
       */
      parseError(k) {
        const V = (0, g.hexlify)(k), C = this.getError((0, g.dataSlice)(V, 0, 4));
        if (!C)
          return null;
        const D = oe(this, s).decode(C.inputs, (0, g.dataSlice)(V, 4));
        return new M(C, C.selector, D);
      }
      /**
       *  Creates a new [[Interface]] from the ABI %%value%%.
       *
       *  The %%value%% may be provided as an existing [[Interface]] object,
       *  a JSON-encoded ABI or any Human-Readable ABI format.
       */
      static from(k) {
        return k instanceof bu ? k : typeof k == "string" ? new bu(JSON.parse(k)) : typeof k.formatJson == "function" ? new bu(k.formatJson()) : typeof k.format == "function" ? new bu(k.format("json")) : new bu(k);
      }
    };
    t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakSet(), a = function($, k, V) {
      if ((0, g.isHexString)($)) {
        const D = $.toLowerCase();
        for (const o of oe(this, n).values())
          if (D === o.selector)
            return o;
        return null;
      }
      if ($.indexOf("(") === -1) {
        const D = [];
        for (const [o, u] of oe(this, n))
          o.split(
            "("
            /* fix:) */
          )[0] === $ && D.push(u);
        if (k) {
          const o = k.length > 0 ? k[k.length - 1] : null;
          let u = k.length, h = !0;
          S.Typed.isTyped(o) && o.type === "overrides" && (h = !1, u--);
          for (let y = D.length - 1; y >= 0; y--) {
            const E = D[y].inputs.length;
            E !== u && (!h || E !== u - 1) && D.splice(y, 1);
          }
          for (let y = D.length - 1; y >= 0; y--) {
            const E = D[y].inputs;
            for (let P = 0; P < k.length; P++)
              if (S.Typed.isTyped(k[P])) {
                if (P >= E.length) {
                  if (k[P].type === "overrides")
                    continue;
                  D.splice(y, 1);
                  break;
                }
                if (k[P].type !== E[P].baseType) {
                  D.splice(y, 1);
                  break;
                }
              }
          }
        }
        if (D.length === 1 && k && k.length !== D[0].inputs.length) {
          const o = k[k.length - 1];
          (o == null || Array.isArray(o) || typeof o != "object") && D.splice(0, 1);
        }
        if (D.length === 0)
          return null;
        if (D.length > 1 && V) {
          const o = D.map((u) => JSON.stringify(u.format())).join(", ");
          (0, g.assertArgument)(!1, `ambiguous function description (i.e. matches ${o})`, "key", $);
        }
        return D[0];
      }
      return oe(this, n).get(N.FunctionFragment.from($).format()) || null;
    }, f = /* @__PURE__ */ new WeakSet(), d = function($, k, V) {
      if ((0, g.isHexString)($)) {
        const D = $.toLowerCase();
        for (const o of oe(this, r).values())
          if (D === o.topicHash)
            return o;
        return null;
      }
      if ($.indexOf("(") === -1) {
        const D = [];
        for (const [o, u] of oe(this, r))
          o.split(
            "("
            /* fix:) */
          )[0] === $ && D.push(u);
        if (k) {
          for (let o = D.length - 1; o >= 0; o--)
            D[o].inputs.length < k.length && D.splice(o, 1);
          for (let o = D.length - 1; o >= 0; o--) {
            const u = D[o].inputs;
            for (let h = 0; h < k.length; h++)
              if (S.Typed.isTyped(k[h]) && k[h].type !== u[h].baseType) {
                D.splice(o, 1);
                break;
              }
          }
        }
        if (D.length === 0)
          return null;
        if (D.length > 1 && V) {
          const o = D.map((u) => JSON.stringify(u.format())).join(", ");
          (0, g.assertArgument)(!1, `ambiguous event description (i.e. matches ${o})`, "key", $);
        }
        return D[0];
      }
      return oe(this, r).get(N.EventFragment.from($).format()) || null;
    };
    let K = L;
    e.Interface = K;
  }(O2)), O2;
}
var x2;
function gd() {
  return x2 || (x2 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Typed = e.Result = e.TransactionDescription = e.LogDescription = e.ErrorDescription = e.Interface = e.Indexed = e.checkResultErrors = e.StructFragment = e.ParamType = e.NamedFragment = e.FunctionFragment = e.Fragment = e.FallbackFragment = e.EventFragment = e.ErrorFragment = e.ConstructorFragment = e.encodeBytes32String = e.decodeBytes32String = e.AbiCoder = void 0;
    var t = W5();
    Object.defineProperty(e, "AbiCoder", { enumerable: !0, get: function() {
      return t.AbiCoder;
    } });
    var r = YT();
    Object.defineProperty(e, "decodeBytes32String", { enumerable: !0, get: function() {
      return r.decodeBytes32String;
    } }), Object.defineProperty(e, "encodeBytes32String", { enumerable: !0, get: function() {
      return r.encodeBytes32String;
    } });
    var n = N1();
    Object.defineProperty(e, "ConstructorFragment", { enumerable: !0, get: function() {
      return n.ConstructorFragment;
    } }), Object.defineProperty(e, "ErrorFragment", { enumerable: !0, get: function() {
      return n.ErrorFragment;
    } }), Object.defineProperty(e, "EventFragment", { enumerable: !0, get: function() {
      return n.EventFragment;
    } }), Object.defineProperty(e, "FallbackFragment", { enumerable: !0, get: function() {
      return n.FallbackFragment;
    } }), Object.defineProperty(e, "Fragment", { enumerable: !0, get: function() {
      return n.Fragment;
    } }), Object.defineProperty(e, "FunctionFragment", { enumerable: !0, get: function() {
      return n.FunctionFragment;
    } }), Object.defineProperty(e, "NamedFragment", { enumerable: !0, get: function() {
      return n.NamedFragment;
    } }), Object.defineProperty(e, "ParamType", { enumerable: !0, get: function() {
      return n.ParamType;
    } }), Object.defineProperty(e, "StructFragment", { enumerable: !0, get: function() {
      return n.StructFragment;
    } });
    var s = XT();
    Object.defineProperty(e, "checkResultErrors", { enumerable: !0, get: function() {
      return s.checkResultErrors;
    } }), Object.defineProperty(e, "Indexed", { enumerable: !0, get: function() {
      return s.Indexed;
    } }), Object.defineProperty(e, "Interface", { enumerable: !0, get: function() {
      return s.Interface;
    } }), Object.defineProperty(e, "ErrorDescription", { enumerable: !0, get: function() {
      return s.ErrorDescription;
    } }), Object.defineProperty(e, "LogDescription", { enumerable: !0, get: function() {
      return s.LogDescription;
    } }), Object.defineProperty(e, "TransactionDescription", { enumerable: !0, get: function() {
      return s.TransactionDescription;
    } }), Object.defineProperty(e, "Result", { enumerable: !0, get: function() {
      return s.Result;
    } });
    var i = ro();
    Object.defineProperty(e, "Typed", { enumerable: !0, get: function() {
      return i.Typed;
    } });
  }(Dm)), Dm;
}
var T2 = {}, Ei = {}, bn = {}, k2;
function md() {
  var e, t, r;
  if (k2)
    return bn;
  k2 = 1, Object.defineProperty(bn, "__esModule", { value: !0 }), bn.TransactionResponse = bn.TransactionReceipt = bn.Log = bn.Block = bn.copyRequest = bn.FeeData = void 0;
  const n = wt(), s = Yn(), i = BigInt(0);
  function a(I) {
    return I ?? null;
  }
  function f(I) {
    return I == null ? null : I.toString();
  }
  class d {
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */
    constructor(A, R, L) {
      Be(this, "gasPrice"), Be(this, "maxFeePerGas"), Be(this, "maxPriorityFeePerGas"), (0, n.defineProperties)(this, {
        gasPrice: a(A),
        maxFeePerGas: a(R),
        maxPriorityFeePerGas: a(L)
      });
    }
    /**
     *  Returns a JSON-friendly value.
     */
    toJSON() {
      const { gasPrice: A, maxFeePerGas: R, maxPriorityFeePerGas: L } = this;
      return {
        _type: "FeeData",
        gasPrice: f(A),
        maxFeePerGas: f(R),
        maxPriorityFeePerGas: f(L)
      };
    }
  }
  bn.FeeData = d;
  function c(I) {
    const A = {};
    I.to && (A.to = I.to), I.from && (A.from = I.from), I.data && (A.data = (0, n.hexlify)(I.data));
    const R = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const K of R)
      !(K in I) || I[K] == null || (A[K] = (0, n.getBigInt)(I[K], `request.${K}`));
    const L = "type,nonce".split(/,/);
    for (const K of L)
      !(K in I) || I[K] == null || (A[K] = (0, n.getNumber)(I[K], `request.${K}`));
    return I.accessList && (A.accessList = (0, s.accessListify)(I.accessList)), "blockTag" in I && (A.blockTag = I.blockTag), "enableCcipRead" in I && (A.enableCcipRead = !!I.enableCcipRead), "customData" in I && (A.customData = I.customData), "blobVersionedHashes" in I && I.blobVersionedHashes && (A.blobVersionedHashes = I.blobVersionedHashes.slice()), "kzg" in I && (A.kzg = I.kzg), "blobs" in I && I.blobs && (A.blobs = I.blobs.map((K) => (0, n.isBytesLike)(K) ? (0, n.hexlify)(K) : Object.assign({}, K))), A;
  }
  bn.copyRequest = c;
  class p {
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */
    constructor(A, R) {
      Be(this, "provider"), Be(this, "number"), Be(this, "hash"), Be(this, "timestamp"), Be(this, "parentHash"), Be(this, "parentBeaconBlockRoot"), Be(this, "nonce"), Be(this, "difficulty"), Be(this, "gasLimit"), Be(this, "gasUsed"), Be(this, "stateRoot"), Be(this, "receiptsRoot"), Be(this, "blobGasUsed"), Be(this, "excessBlobGas"), Be(this, "miner"), Be(this, "prevRandao"), Be(this, "extraData"), Be(this, "baseFeePerGas"), _e(this, e, void 0), Oe(this, e, A.transactions.map((L) => typeof L != "string" ? new N(L, R) : L)), (0, n.defineProperties)(this, {
        provider: R,
        hash: a(A.hash),
        number: A.number,
        timestamp: A.timestamp,
        parentHash: A.parentHash,
        parentBeaconBlockRoot: A.parentBeaconBlockRoot,
        nonce: A.nonce,
        difficulty: A.difficulty,
        gasLimit: A.gasLimit,
        gasUsed: A.gasUsed,
        blobGasUsed: A.blobGasUsed,
        excessBlobGas: A.excessBlobGas,
        miner: A.miner,
        prevRandao: a(A.prevRandao),
        extraData: A.extraData,
        baseFeePerGas: a(A.baseFeePerGas),
        stateRoot: A.stateRoot,
        receiptsRoot: A.receiptsRoot
      });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */
    get transactions() {
      return oe(this, e).map((A) => typeof A == "string" ? A : A.hash);
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */
    get prefetchedTransactions() {
      const A = oe(this, e).slice();
      return A.length === 0 ? [] : ((0, n.assert)(typeof A[0] == "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
        operation: "transactionResponses()"
      }), A);
    }
    /**
     *  Returns a JSON-friendly value.
     */
    toJSON() {
      const { baseFeePerGas: A, difficulty: R, extraData: L, gasLimit: K, gasUsed: $, hash: k, miner: V, prevRandao: C, nonce: D, number: o, parentHash: u, parentBeaconBlockRoot: h, stateRoot: y, receiptsRoot: E, timestamp: P, transactions: w } = this;
      return {
        _type: "Block",
        baseFeePerGas: f(A),
        difficulty: f(R),
        extraData: L,
        gasLimit: f(K),
        gasUsed: f($),
        blobGasUsed: f(this.blobGasUsed),
        excessBlobGas: f(this.excessBlobGas),
        hash: k,
        miner: V,
        prevRandao: C,
        nonce: D,
        number: o,
        parentHash: u,
        timestamp: P,
        parentBeaconBlockRoot: h,
        stateRoot: y,
        receiptsRoot: E,
        transactions: w
      };
    }
    [Symbol.iterator]() {
      let A = 0;
      const R = this.transactions;
      return {
        next: () => A < this.length ? {
          value: R[A++],
          done: !1
        } : { value: void 0, done: !0 }
      };
    }
    /**
     *  The number of transactions in this block.
     */
    get length() {
      return oe(this, e).length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */
    get date() {
      return this.timestamp == null ? null : new Date(this.timestamp * 1e3);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */
    async getTransaction(A) {
      let R;
      if (typeof A == "number")
        R = oe(this, e)[A];
      else {
        const L = A.toLowerCase();
        for (const K of oe(this, e))
          if (typeof K == "string") {
            if (K !== L)
              continue;
            R = K;
            break;
          } else {
            if (K.hash === L)
              continue;
            R = K;
            break;
          }
      }
      if (R == null)
        throw new Error("no such tx");
      return typeof R == "string" ? await this.provider.getTransaction(R) : R;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */
    getPrefetchedTransaction(A) {
      const R = this.prefetchedTransactions;
      if (typeof A == "number")
        return R[A];
      A = A.toLowerCase();
      for (const L of R)
        if (L.hash === A)
          return L;
      (0, n.assertArgument)(!1, "no matching transaction", "indexOrHash", A);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */
    isMined() {
      return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */
    isLondon() {
      return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */
    orphanedEvent() {
      if (!this.isMined())
        throw new Error("");
      return S(this);
    }
  }
  e = /* @__PURE__ */ new WeakMap(), bn.Block = p;
  class g {
    /**
     *  @_ignore:
     */
    constructor(A, R) {
      Be(this, "provider"), Be(this, "transactionHash"), Be(this, "blockHash"), Be(this, "blockNumber"), Be(this, "removed"), Be(this, "address"), Be(this, "data"), Be(this, "topics"), Be(this, "index"), Be(this, "transactionIndex"), this.provider = R;
      const L = Object.freeze(A.topics.slice());
      (0, n.defineProperties)(this, {
        transactionHash: A.transactionHash,
        blockHash: A.blockHash,
        blockNumber: A.blockNumber,
        removed: A.removed,
        address: A.address,
        data: A.data,
        topics: L,
        index: A.index,
        transactionIndex: A.transactionIndex
      });
    }
    /**
     *  Returns a JSON-compatible object.
     */
    toJSON() {
      const { address: A, blockHash: R, blockNumber: L, data: K, index: $, removed: k, topics: V, transactionHash: C, transactionIndex: D } = this;
      return {
        _type: "log",
        address: A,
        blockHash: R,
        blockNumber: L,
        data: K,
        index: $,
        removed: k,
        topics: V,
        transactionHash: C,
        transactionIndex: D
      };
    }
    /**
     *  Returns the block that this log occurred in.
     */
    async getBlock() {
      const A = await this.provider.getBlock(this.blockHash);
      return (0, n.assert)(!!A, "failed to find transaction", "UNKNOWN_ERROR", {}), A;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */
    async getTransaction() {
      const A = await this.provider.getTransaction(this.transactionHash);
      return (0, n.assert)(!!A, "failed to find transaction", "UNKNOWN_ERROR", {}), A;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */
    async getTransactionReceipt() {
      const A = await this.provider.getTransactionReceipt(this.transactionHash);
      return (0, n.assert)(!!A, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), A;
    }
    /**
     *  @_ignore:
     */
    removedEvent() {
      return M(this);
    }
  }
  bn.Log = g;
  class v {
    /**
     *  @_ignore:
     */
    constructor(A, R) {
      Be(this, "provider"), Be(this, "to"), Be(this, "from"), Be(this, "contractAddress"), Be(this, "hash"), Be(this, "index"), Be(this, "blockHash"), Be(this, "blockNumber"), Be(this, "logsBloom"), Be(this, "gasUsed"), Be(this, "blobGasUsed"), Be(this, "cumulativeGasUsed"), Be(this, "gasPrice"), Be(this, "blobGasPrice"), Be(this, "type"), Be(this, "status"), Be(this, "root"), _e(this, t, void 0), Oe(this, t, Object.freeze(A.logs.map((K) => new g(K, R))));
      let L = i;
      A.effectiveGasPrice != null ? L = A.effectiveGasPrice : A.gasPrice != null && (L = A.gasPrice), (0, n.defineProperties)(this, {
        provider: R,
        to: A.to,
        from: A.from,
        contractAddress: A.contractAddress,
        hash: A.hash,
        index: A.index,
        blockHash: A.blockHash,
        blockNumber: A.blockNumber,
        logsBloom: A.logsBloom,
        gasUsed: A.gasUsed,
        cumulativeGasUsed: A.cumulativeGasUsed,
        blobGasUsed: A.blobGasUsed,
        gasPrice: L,
        blobGasPrice: A.blobGasPrice,
        type: A.type,
        //byzantium: tx.byzantium,
        status: A.status,
        root: A.root
      });
    }
    /**
     *  The logs for this transaction.
     */
    get logs() {
      return oe(this, t);
    }
    /**
     *  Returns a JSON-compatible representation.
     */
    toJSON() {
      const {
        to: A,
        from: R,
        contractAddress: L,
        hash: K,
        index: $,
        blockHash: k,
        blockNumber: V,
        logsBloom: C,
        logs: D,
        //byzantium, 
        status: o,
        root: u
      } = this;
      return {
        _type: "TransactionReceipt",
        blockHash: k,
        blockNumber: V,
        //byzantium, 
        contractAddress: L,
        cumulativeGasUsed: f(this.cumulativeGasUsed),
        from: R,
        gasPrice: f(this.gasPrice),
        blobGasUsed: f(this.blobGasUsed),
        blobGasPrice: f(this.blobGasPrice),
        gasUsed: f(this.gasUsed),
        hash: K,
        index: $,
        logs: D,
        logsBloom: C,
        root: u,
        status: o,
        to: A
      };
    }
    /**
     *  @_ignore:
     */
    get length() {
      return this.logs.length;
    }
    [Symbol.iterator]() {
      let A = 0;
      return {
        next: () => A < this.length ? { value: this.logs[A++], done: !1 } : { value: void 0, done: !0 }
      };
    }
    /**
     *  The total fee for this transaction, in wei.
     */
    get fee() {
      return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */
    async getBlock() {
      const A = await this.provider.getBlock(this.blockHash);
      if (A == null)
        throw new Error("TODO");
      return A;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */
    async getTransaction() {
      const A = await this.provider.getTransaction(this.hash);
      if (A == null)
        throw new Error("TODO");
      return A;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */
    async getResult() {
      return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */
    async confirmations() {
      return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */
    removedEvent() {
      return B(this);
    }
    /**
     *  @_ignore:
     */
    reorderedEvent(A) {
      return (0, n.assert)(!A || A.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" }), j(this, A);
    }
  }
  t = /* @__PURE__ */ new WeakMap(), bn.TransactionReceipt = v;
  const O = class G5 {
    /**
     *  @_ignore:
     */
    constructor(A, R) {
      Be(this, "provider"), Be(this, "blockNumber"), Be(this, "blockHash"), Be(this, "index"), Be(this, "hash"), Be(this, "type"), Be(this, "to"), Be(this, "from"), Be(this, "nonce"), Be(this, "gasLimit"), Be(this, "gasPrice"), Be(this, "maxPriorityFeePerGas"), Be(this, "maxFeePerGas"), Be(this, "maxFeePerBlobGas"), Be(this, "data"), Be(this, "value"), Be(this, "chainId"), Be(this, "signature"), Be(this, "accessList"), Be(this, "blobVersionedHashes"), _e(this, r, void 0), this.provider = R, this.blockNumber = A.blockNumber != null ? A.blockNumber : null, this.blockHash = A.blockHash != null ? A.blockHash : null, this.hash = A.hash, this.index = A.index, this.type = A.type, this.from = A.from, this.to = A.to || null, this.gasLimit = A.gasLimit, this.nonce = A.nonce, this.data = A.data, this.value = A.value, this.gasPrice = A.gasPrice, this.maxPriorityFeePerGas = A.maxPriorityFeePerGas != null ? A.maxPriorityFeePerGas : null, this.maxFeePerGas = A.maxFeePerGas != null ? A.maxFeePerGas : null, this.maxFeePerBlobGas = A.maxFeePerBlobGas != null ? A.maxFeePerBlobGas : null, this.chainId = A.chainId, this.signature = A.signature, this.accessList = A.accessList != null ? A.accessList : null, this.blobVersionedHashes = A.blobVersionedHashes != null ? A.blobVersionedHashes : null, Oe(this, r, -1);
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */
    toJSON() {
      const { blockNumber: A, blockHash: R, index: L, hash: K, type: $, to: k, from: V, nonce: C, data: D, signature: o, accessList: u, blobVersionedHashes: h } = this;
      return {
        _type: "TransactionResponse",
        accessList: u,
        blockNumber: A,
        blockHash: R,
        blobVersionedHashes: h,
        chainId: f(this.chainId),
        data: D,
        from: V,
        gasLimit: f(this.gasLimit),
        gasPrice: f(this.gasPrice),
        hash: K,
        maxFeePerGas: f(this.maxFeePerGas),
        maxPriorityFeePerGas: f(this.maxPriorityFeePerGas),
        maxFeePerBlobGas: f(this.maxFeePerBlobGas),
        nonce: C,
        signature: o,
        to: k,
        index: L,
        type: $,
        value: f(this.value)
      };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */
    async getBlock() {
      let A = this.blockNumber;
      if (A == null) {
        const L = await this.getTransaction();
        L && (A = L.blockNumber);
      }
      if (A == null)
        return null;
      const R = this.provider.getBlock(A);
      if (R == null)
        throw new Error("TODO");
      return R;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */
    async getTransaction() {
      return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */
    async confirmations() {
      if (this.blockNumber == null) {
        const { tx: A, blockNumber: R } = await (0, n.resolveProperties)({
          tx: this.getTransaction(),
          blockNumber: this.provider.getBlockNumber()
        });
        return A == null || A.blockNumber == null ? 0 : R - A.blockNumber + 1;
      }
      return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */
    async wait(A, R) {
      const L = A ?? 1, K = R ?? 0;
      let $ = oe(this, r), k = -1, V = $ === -1;
      const C = async () => {
        if (V)
          return null;
        const { blockNumber: u, nonce: h } = await (0, n.resolveProperties)({
          blockNumber: this.provider.getBlockNumber(),
          nonce: this.provider.getTransactionCount(this.from)
        });
        if (h < this.nonce) {
          $ = u;
          return;
        }
        if (V)
          return null;
        const y = await this.getTransaction();
        if (!(y && y.blockNumber != null))
          for (k === -1 && (k = $ - 3, k < oe(this, r) && (k = oe(this, r))); k <= u; ) {
            if (V)
              return null;
            const E = await this.provider.getBlock(k, !0);
            if (E == null)
              return;
            for (const P of E)
              if (P === this.hash)
                return;
            for (let P = 0; P < E.length; P++) {
              const w = await E.getTransaction(P);
              if (w.from === this.from && w.nonce === this.nonce) {
                if (V)
                  return null;
                const m = await this.provider.getTransactionReceipt(w.hash);
                if (m == null || u - m.blockNumber + 1 < L)
                  return;
                let l = "replaced";
                w.data === this.data && w.to === this.to && w.value === this.value ? l = "repriced" : w.data === "0x" && w.from === w.to && w.value === i && (l = "cancelled"), (0, n.assert)(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                  cancelled: l === "replaced" || l === "cancelled",
                  reason: l,
                  replacement: w.replaceableTransaction($),
                  hash: w.hash,
                  receipt: m
                });
              }
            }
            k++;
          }
      }, D = (u) => {
        if (u == null || u.status !== 0)
          return u;
        (0, n.assert)(!1, "transaction execution reverted", "CALL_EXCEPTION", {
          action: "sendTransaction",
          data: null,
          reason: null,
          invocation: null,
          revert: null,
          transaction: {
            to: u.to,
            from: u.from,
            data: ""
            // @TODO: in v7, split out sendTransaction properties
          },
          receipt: u
        });
      }, o = await this.provider.getTransactionReceipt(this.hash);
      if (L === 0)
        return D(o);
      if (o) {
        if (await o.confirmations() >= L)
          return D(o);
      } else if (await C(), L === 0)
        return null;
      return await new Promise((u, h) => {
        const y = [], E = () => {
          y.forEach((w) => w());
        };
        if (y.push(() => {
          V = !0;
        }), K > 0) {
          const w = setTimeout(() => {
            E(), h((0, n.makeError)("wait for transaction timeout", "TIMEOUT"));
          }, K);
          y.push(() => {
            clearTimeout(w);
          });
        }
        const P = async (w) => {
          if (await w.confirmations() >= L) {
            E();
            try {
              u(D(w));
            } catch (m) {
              h(m);
            }
          }
        };
        if (y.push(() => {
          this.provider.off(this.hash, P);
        }), this.provider.on(this.hash, P), $ >= 0) {
          const w = async () => {
            try {
              await C();
            } catch (m) {
              if ((0, n.isError)(m, "TRANSACTION_REPLACED")) {
                E(), h(m);
                return;
              }
            }
            V || this.provider.once("block", w);
          };
          y.push(() => {
            this.provider.off("block", w);
          }), this.provider.once("block", w);
        }
      });
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */
    isMined() {
      return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isLegacy() {
      return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isBerlin() {
      return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isLondon() {
      return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */
    isCancun() {
      return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */
    removedEvent() {
      return (0, n.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), B(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */
    reorderedEvent(A) {
      return (0, n.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), (0, n.assert)(!A || A.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), j(this, A);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */
    replaceableTransaction(A) {
      (0, n.assertArgument)(Number.isInteger(A) && A >= 0, "invalid startBlock", "startBlock", A);
      const R = new G5(this, this.provider);
      return Oe(R, r, A), R;
    }
  };
  r = /* @__PURE__ */ new WeakMap();
  let N = O;
  bn.TransactionResponse = N;
  function S(I) {
    return { orphan: "drop-block", hash: I.hash, number: I.number };
  }
  function j(I, A) {
    return { orphan: "reorder-transaction", tx: I, other: A };
  }
  function B(I) {
    return { orphan: "drop-transaction", tx: I };
  }
  function M(I) {
    return { orphan: "drop-log", log: {
      transactionHash: I.transactionHash,
      blockHash: I.blockHash,
      blockNumber: I.blockNumber,
      address: I.address,
      data: I.data,
      topics: Object.freeze(I.topics.slice()),
      index: I.index
    } };
  }
  return bn;
}
var wn = {}, S2;
function z5() {
  var e, t;
  if (S2)
    return wn;
  S2 = 1, Object.defineProperty(wn, "__esModule", { value: !0 }), wn.ContractEventPayload = wn.ContractUnknownEventPayload = wn.ContractTransactionResponse = wn.ContractTransactionReceipt = wn.UndecodedEventLog = wn.EventLog = void 0;
  const r = md(), n = wt();
  class s extends r.Log {
    /**
     * @_ignore:
     */
    constructor(g, v, O) {
      super(g, g.provider), Be(this, "interface"), Be(this, "fragment"), Be(this, "args");
      const N = v.decodeEventLog(O, g.data, g.topics);
      (0, n.defineProperties)(this, { args: N, fragment: O, interface: v });
    }
    /**
     *  The name of the event.
     */
    get eventName() {
      return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */
    get eventSignature() {
      return this.fragment.format();
    }
  }
  wn.EventLog = s;
  class i extends r.Log {
    /**
     * @_ignore:
     */
    constructor(g, v) {
      super(g, g.provider), Be(this, "error"), (0, n.defineProperties)(this, { error: v });
    }
  }
  wn.UndecodedEventLog = i;
  class a extends r.TransactionReceipt {
    /**
     *  @_ignore:
     */
    constructor(g, v, O) {
      super(O, v), _e(this, e, void 0), Oe(this, e, g);
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */
    get logs() {
      return super.logs.map((g) => {
        const v = g.topics.length ? oe(this, e).getEvent(g.topics[0]) : null;
        if (v)
          try {
            return new s(g, oe(this, e), v);
          } catch (O) {
            return new i(g, O);
          }
        return g;
      });
    }
  }
  e = /* @__PURE__ */ new WeakMap(), wn.ContractTransactionReceipt = a;
  class f extends r.TransactionResponse {
    /**
     *  @_ignore:
     */
    constructor(g, v, O) {
      super(O, v), _e(this, t, void 0), Oe(this, t, g);
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */
    async wait(g, v) {
      const O = await super.wait(g, v);
      return O == null ? null : new a(oe(this, t), this.provider, O);
    }
  }
  t = /* @__PURE__ */ new WeakMap(), wn.ContractTransactionResponse = f;
  class d extends n.EventPayload {
    /**
     *  @_event:
     */
    constructor(g, v, O, N) {
      super(g, v, O), Be(this, "log"), (0, n.defineProperties)(this, { log: N });
    }
    /**
     *  Resolves to the block the event occured in.
     */
    async getBlock() {
      return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */
    async getTransaction() {
      return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */
    async getTransactionReceipt() {
      return await this.log.getTransactionReceipt();
    }
  }
  wn.ContractUnknownEventPayload = d;
  class c extends d {
    /**
     *  @_ignore:
     */
    constructor(g, v, O, N, S) {
      super(g, v, O, new s(S, g.interface, N));
      const j = g.interface.decodeEventLog(N, this.log.data, this.log.topics);
      (0, n.defineProperties)(this, { args: j, fragment: N });
    }
    /**
     *  The event name.
     */
    get eventName() {
      return this.fragment.name;
    }
    /**
     *  The event signature.
     */
    get eventSignature() {
      return this.fragment.format();
    }
  }
  return wn.ContractEventPayload = c, wn;
}
var M2;
function V5() {
  var e, t;
  if (M2)
    return Ei;
  M2 = 1, Object.defineProperty(Ei, "__esModule", { value: !0 }), Ei.Contract = Ei.BaseContract = Ei.resolveArgs = Ei.copyOverrides = void 0;
  const r = gd(), n = Yr(), s = md(), i = wt(), a = z5(), f = BigInt(0);
  function d(l) {
    return l && typeof l.call == "function";
  }
  function c(l) {
    return l && typeof l.estimateGas == "function";
  }
  function p(l) {
    return l && typeof l.resolveName == "function";
  }
  function g(l) {
    return l && typeof l.sendTransaction == "function";
  }
  function v(l) {
    if (l != null) {
      if (p(l))
        return l;
      if (l.provider)
        return l.provider;
    }
  }
  class O {
    constructor(b, W, X) {
      if (_e(this, e, void 0), Be(this, "fragment"), (0, i.defineProperties)(this, { fragment: W }), W.inputs.length < X.length)
        throw new Error("too many arguments");
      const G = N(b.runner, "resolveName"), re = p(G) ? G : null;
      Oe(this, e, async function() {
        const ce = await Promise.all(W.inputs.map((pe, ve) => X[ve] == null ? null : pe.walkAsync(X[ve], (Ee, Pe) => Ee === "address" ? Array.isArray(Pe) ? Promise.all(Pe.map((xe) => (0, n.resolveAddress)(xe, re))) : (0, n.resolveAddress)(Pe, re) : Pe)));
        return b.interface.encodeFilterTopics(W, ce);
      }());
    }
    getTopicFilter() {
      return oe(this, e);
    }
  }
  e = /* @__PURE__ */ new WeakMap();
  function N(l, b) {
    return l == null ? null : typeof l[b] == "function" ? l : l.provider && typeof l.provider[b] == "function" ? l.provider : null;
  }
  function S(l) {
    return l == null ? null : l.provider || null;
  }
  async function j(l, b) {
    const W = r.Typed.dereference(l, "overrides");
    (0, i.assertArgument)(typeof W == "object", "invalid overrides parameter", "overrides", l);
    const X = (0, s.copyRequest)(W);
    return (0, i.assertArgument)(X.to == null || (b || []).indexOf("to") >= 0, "cannot override to", "overrides.to", X.to), (0, i.assertArgument)(X.data == null || (b || []).indexOf("data") >= 0, "cannot override data", "overrides.data", X.data), X.from && (X.from = X.from), X;
  }
  Ei.copyOverrides = j;
  async function B(l, b, W) {
    const X = N(l, "resolveName"), G = p(X) ? X : null;
    return await Promise.all(b.map((re, ce) => re.walkAsync(W[ce], (pe, ve) => (ve = r.Typed.dereference(ve, pe), pe === "address" ? (0, n.resolveAddress)(ve, G) : ve))));
  }
  Ei.resolveArgs = B;
  function M(l) {
    const b = async function(ce) {
      const pe = await j(ce, ["data"]);
      pe.to = await l.getAddress(), pe.from && (pe.from = await (0, n.resolveAddress)(pe.from, v(l.runner)));
      const ve = l.interface, Ee = (0, i.getBigInt)(pe.value || f, "overrides.value") === f, Pe = (pe.data || "0x") === "0x";
      ve.fallback && !ve.fallback.payable && ve.receive && !Pe && !Ee && (0, i.assertArgument)(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", ce), (0, i.assertArgument)(ve.fallback || Pe, "cannot send data to receive-only contract", "overrides.data", pe.data);
      const xe = ve.receive || ve.fallback && ve.fallback.payable;
      return (0, i.assertArgument)(xe || Ee, "cannot send value to non-payable fallback", "overrides.value", pe.value), (0, i.assertArgument)(ve.fallback || Pe, "cannot send data to receive-only contract", "overrides.data", pe.data), pe;
    }, W = async function(ce) {
      const pe = N(l.runner, "call");
      (0, i.assert)(d(pe), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
      const ve = await b(ce);
      try {
        return await pe.call(ve);
      } catch (Ee) {
        throw (0, i.isCallException)(Ee) && Ee.data ? l.interface.makeError(Ee.data, ve) : Ee;
      }
    }, X = async function(ce) {
      const pe = l.runner;
      (0, i.assert)(g(pe), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
      const ve = await pe.sendTransaction(await b(ce)), Ee = S(l.runner);
      return new a.ContractTransactionResponse(l.interface, Ee, ve);
    }, G = async function(ce) {
      const pe = N(l.runner, "estimateGas");
      return (0, i.assert)(c(pe), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await pe.estimateGas(await b(ce));
    }, re = async (ce) => await X(ce);
    return (0, i.defineProperties)(re, {
      _contract: l,
      estimateGas: G,
      populateTransaction: b,
      send: X,
      staticCall: W
    }), re;
  }
  function I(l, b) {
    const W = function(...Ee) {
      const Pe = l.interface.getFunction(b, Ee);
      return (0, i.assert)(Pe, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: b, args: Ee }
      }), Pe;
    }, X = async function(...Ee) {
      const Pe = W(...Ee);
      let xe = {};
      if (Pe.inputs.length + 1 === Ee.length && (xe = await j(Ee.pop()), xe.from && (xe.from = await (0, n.resolveAddress)(xe.from, v(l.runner)))), Pe.inputs.length !== Ee.length)
        throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
      const me = await B(l.runner, Pe.inputs, Ee);
      return Object.assign({}, xe, await (0, i.resolveProperties)({
        to: l.getAddress(),
        data: l.interface.encodeFunctionData(Pe, me)
      }));
    }, G = async function(...Ee) {
      const Pe = await pe(...Ee);
      return Pe.length === 1 ? Pe[0] : Pe;
    }, re = async function(...Ee) {
      const Pe = l.runner;
      (0, i.assert)(g(Pe), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
      const xe = await Pe.sendTransaction(await X(...Ee)), me = S(l.runner);
      return new a.ContractTransactionResponse(l.interface, me, xe);
    }, ce = async function(...Ee) {
      const Pe = N(l.runner, "estimateGas");
      return (0, i.assert)(c(Pe), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await Pe.estimateGas(await X(...Ee));
    }, pe = async function(...Ee) {
      const Pe = N(l.runner, "call");
      (0, i.assert)(d(Pe), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
      const xe = await X(...Ee);
      let me = "0x";
      try {
        me = await Pe.call(xe);
      } catch (U) {
        throw (0, i.isCallException)(U) && U.data ? l.interface.makeError(U.data, xe) : U;
      }
      const te = W(...Ee);
      return l.interface.decodeFunctionResult(te, me);
    }, ve = async (...Ee) => W(...Ee).constant ? await G(...Ee) : await re(...Ee);
    return (0, i.defineProperties)(ve, {
      name: l.interface.getFunctionName(b),
      _contract: l,
      _key: b,
      getFragment: W,
      estimateGas: ce,
      populateTransaction: X,
      send: re,
      staticCall: G,
      staticCallResult: pe
    }), Object.defineProperty(ve, "fragment", {
      configurable: !1,
      enumerable: !0,
      get: () => {
        const Ee = l.interface.getFunction(b);
        return (0, i.assert)(Ee, "no matching fragment", "UNSUPPORTED_OPERATION", {
          operation: "fragment",
          info: { key: b }
        }), Ee;
      }
    }), ve;
  }
  function A(l, b) {
    const W = function(...G) {
      const re = l.interface.getEvent(b, G);
      return (0, i.assert)(re, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: b, args: G }
      }), re;
    }, X = function(...G) {
      return new O(l, W(...G), G);
    };
    return (0, i.defineProperties)(X, {
      name: l.interface.getEventName(b),
      _contract: l,
      _key: b,
      getFragment: W
    }), Object.defineProperty(X, "fragment", {
      configurable: !1,
      enumerable: !0,
      get: () => {
        const G = l.interface.getEvent(b);
        return (0, i.assert)(G, "no matching fragment", "UNSUPPORTED_OPERATION", {
          operation: "fragment",
          info: { key: b }
        }), G;
      }
    }), X;
  }
  const R = Symbol.for("_ethersInternal_contract"), L = /* @__PURE__ */ new WeakMap();
  function K(l, b) {
    L.set(l[R], b);
  }
  function $(l) {
    return L.get(l[R]);
  }
  function k(l) {
    return l && typeof l == "object" && "getTopicFilter" in l && typeof l.getTopicFilter == "function" && l.fragment;
  }
  async function V(l, b) {
    let W, X = null;
    if (Array.isArray(b)) {
      const re = function(ce) {
        if ((0, i.isHexString)(ce, 32))
          return ce;
        const pe = l.interface.getEvent(ce);
        return (0, i.assertArgument)(pe, "unknown fragment", "name", ce), pe.topicHash;
      };
      W = b.map((ce) => ce == null ? null : Array.isArray(ce) ? ce.map(re) : re(ce));
    } else
      b === "*" ? W = [null] : typeof b == "string" ? (0, i.isHexString)(b, 32) ? W = [b] : (X = l.interface.getEvent(b), (0, i.assertArgument)(X, "unknown fragment", "event", b), W = [X.topicHash]) : k(b) ? W = await b.getTopicFilter() : "fragment" in b ? (X = b.fragment, W = [X.topicHash]) : (0, i.assertArgument)(!1, "unknown event name", "event", b);
    W = W.map((re) => {
      if (re == null)
        return null;
      if (Array.isArray(re)) {
        const ce = Array.from(new Set(re.map((pe) => pe.toLowerCase())).values());
        return ce.length === 1 ? ce[0] : (ce.sort(), ce);
      }
      return re.toLowerCase();
    });
    const G = W.map((re) => re == null ? "null" : Array.isArray(re) ? re.join("|") : re).join("&");
    return { fragment: X, tag: G, topics: W };
  }
  async function C(l, b) {
    const { subs: W } = $(l);
    return W.get((await V(l, b)).tag) || null;
  }
  async function D(l, b, W) {
    const X = S(l.runner);
    (0, i.assert)(X, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation: b });
    const { fragment: G, tag: re, topics: ce } = await V(l, W), { addr: pe, subs: ve } = $(l);
    let Ee = ve.get(re);
    if (!Ee) {
      const Pe = { address: pe || l, topics: ce }, xe = (te) => {
        let U = G;
        if (U == null)
          try {
            U = l.interface.getEvent(te.topics[0]);
          } catch {
          }
        if (U) {
          const ue = U, we = G ? l.interface.decodeEventLog(G, te.data, te.topics) : [];
          h(l, W, we, (ke) => new a.ContractEventPayload(l, ke, W, ue, te));
        } else
          h(l, W, [], (ue) => new a.ContractUnknownEventPayload(l, ue, W, te));
      };
      let me = [];
      Ee = { tag: re, listeners: [], start: () => {
        me.length || me.push(X.on(Pe, xe));
      }, stop: async () => {
        if (me.length == 0)
          return;
        let te = me;
        me = [], await Promise.all(te), X.off(Pe, xe);
      } }, ve.set(re, Ee);
    }
    return Ee;
  }
  let o = Promise.resolve();
  async function u(l, b, W, X) {
    await o;
    const G = await C(l, b);
    if (!G)
      return !1;
    const re = G.listeners.length;
    return G.listeners = G.listeners.filter(({ listener: ce, once: pe }) => {
      const ve = Array.from(W);
      X && ve.push(X(pe ? null : ce));
      try {
        ce.call(l, ...ve);
      } catch {
      }
      return !pe;
    }), G.listeners.length === 0 && (G.stop(), $(l).subs.delete(G.tag)), re > 0;
  }
  async function h(l, b, W, X) {
    try {
      await o;
    } catch {
    }
    const G = u(l, b, W, X);
    return o = G, await G;
  }
  const y = ["then"], E = class Xd {
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */
    constructor(b, W, X, G) {
      Be(this, "target"), Be(this, "interface"), Be(this, "runner"), Be(this, "filters"), Be(this, t), Be(this, "fallback"), (0, i.assertArgument)(typeof b == "string" || (0, n.isAddressable)(b), "invalid value for Contract target", "target", b), X == null && (X = null);
      const re = r.Interface.from(W);
      (0, i.defineProperties)(this, { target: b, runner: X, interface: re }), Object.defineProperty(this, R, { value: {} });
      let ce, pe = null, ve = null;
      if (G) {
        const xe = S(X);
        ve = new a.ContractTransactionResponse(this.interface, xe, G);
      }
      let Ee = /* @__PURE__ */ new Map();
      if (typeof b == "string")
        if ((0, i.isHexString)(b))
          pe = b, ce = Promise.resolve(b);
        else {
          const xe = N(X, "resolveName");
          if (!p(xe))
            throw (0, i.makeError)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
              operation: "resolveName"
            });
          ce = xe.resolveName(b).then((me) => {
            if (me == null)
              throw (0, i.makeError)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                value: b
              });
            return $(this).addr = me, me;
          });
        }
      else
        ce = b.getAddress().then((xe) => {
          if (xe == null)
            throw new Error("TODO");
          return $(this).addr = xe, xe;
        });
      K(this, { addrPromise: ce, addr: pe, deployTx: ve, subs: Ee });
      const Pe = new Proxy({}, {
        get: (xe, me, te) => {
          if (typeof me == "symbol" || y.indexOf(me) >= 0)
            return Reflect.get(xe, me, te);
          try {
            return this.getEvent(me);
          } catch (U) {
            if (!(0, i.isError)(U, "INVALID_ARGUMENT") || U.argument !== "key")
              throw U;
          }
        },
        has: (xe, me) => y.indexOf(me) >= 0 ? Reflect.has(xe, me) : Reflect.has(xe, me) || this.interface.hasEvent(String(me))
      });
      return (0, i.defineProperties)(this, { filters: Pe }), (0, i.defineProperties)(this, {
        fallback: re.receive || re.fallback ? M(this) : null
      }), new Proxy(this, {
        get: (xe, me, te) => {
          if (typeof me == "symbol" || me in xe || y.indexOf(me) >= 0)
            return Reflect.get(xe, me, te);
          try {
            return xe.getFunction(me);
          } catch (U) {
            if (!(0, i.isError)(U, "INVALID_ARGUMENT") || U.argument !== "key")
              throw U;
          }
        },
        has: (xe, me) => typeof me == "symbol" || me in xe || y.indexOf(me) >= 0 ? Reflect.has(xe, me) : xe.interface.hasFunction(me)
      });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */
    connect(b) {
      return new Xd(this.target, this.interface, b);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */
    attach(b) {
      return new Xd(b, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */
    async getAddress() {
      return await $(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */
    async getDeployedCode() {
      const b = S(this.runner);
      (0, i.assert)(b, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
      const W = await b.getCode(await this.getAddress());
      return W === "0x" ? null : W;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */
    async waitForDeployment() {
      const b = this.deploymentTransaction();
      if (b)
        return await b.wait(), this;
      if (await this.getDeployedCode() != null)
        return this;
      const W = S(this.runner);
      return (0, i.assert)(W != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" }), new Promise((X, G) => {
        const re = async () => {
          try {
            if (await this.getDeployedCode() != null)
              return X(this);
            W.once("block", re);
          } catch (ce) {
            G(ce);
          }
        };
        re();
      });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */
    deploymentTransaction() {
      return $(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */
    getFunction(b) {
      return typeof b != "string" && (b = b.format()), I(this, b);
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */
    getEvent(b) {
      return typeof b != "string" && (b = b.format()), A(this, b);
    }
    /**
     *  @_ignore:
     */
    async queryTransaction(b) {
      throw new Error("@TODO");
    }
    /*
    	    // @TODO: this is a non-backwards compatible change, but will be added
    	    //        in v7 and in a potential SmartContract class in an upcoming
    	    //        v6 release
    	    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
    	        const provider = getProvider(this.runner);
    	        assert(provider, "contract runner does not have a provider",
    	            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
    
    	        const receipt = await provider.getTransactionReceipt(hash);
    	        if (receipt == null) { return null; }
    
    	        return new ContractTransactionReceipt(this.interface, provider, receipt);
    	    }
    	    */
    /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */
    async queryFilter(b, W, X) {
      W == null && (W = 0), X == null && (X = "latest");
      const { addr: G, addrPromise: re } = $(this), ce = G || await re, { fragment: pe, topics: ve } = await V(this, b), Ee = { address: ce, topics: ve, fromBlock: W, toBlock: X }, Pe = S(this.runner);
      return (0, i.assert)(Pe, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" }), (await Pe.getLogs(Ee)).map((xe) => {
        let me = pe;
        if (me == null)
          try {
            me = this.interface.getEvent(xe.topics[0]);
          } catch {
          }
        if (me)
          try {
            return new a.EventLog(xe, this.interface, me);
          } catch (te) {
            return new a.UndecodedEventLog(xe, te);
          }
        return new s.Log(xe, Pe);
      });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */
    async on(b, W) {
      const X = await D(this, "on", b);
      return X.listeners.push({ listener: W, once: !1 }), X.start(), this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */
    async once(b, W) {
      const X = await D(this, "once", b);
      return X.listeners.push({ listener: W, once: !0 }), X.start(), this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */
    async emit(b, ...W) {
      return await h(this, b, W, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */
    async listenerCount(b) {
      if (b) {
        const G = await C(this, b);
        return G ? G.listeners.length : 0;
      }
      const { subs: W } = $(this);
      let X = 0;
      for (const { listeners: G } of W.values())
        X += G.length;
      return X;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */
    async listeners(b) {
      if (b) {
        const G = await C(this, b);
        return G ? G.listeners.map(({ listener: re }) => re) : [];
      }
      const { subs: W } = $(this);
      let X = [];
      for (const { listeners: G } of W.values())
        X = X.concat(G.map(({ listener: re }) => re));
      return X;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */
    async off(b, W) {
      const X = await C(this, b);
      if (!X)
        return this;
      if (W) {
        const G = X.listeners.map(({ listener: re }) => re).indexOf(W);
        G >= 0 && X.listeners.splice(G, 1);
      }
      return (W == null || X.listeners.length === 0) && (X.stop(), $(this).subs.delete(X.tag)), this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */
    async removeAllListeners(b) {
      if (b) {
        const W = await C(this, b);
        if (!W)
          return this;
        W.stop(), $(this).subs.delete(W.tag);
      } else {
        const { subs: W } = $(this);
        for (const { tag: X, stop: G } of W.values())
          G(), W.delete(X);
      }
      return this;
    }
    /**
     *  Alias for [on].
     */
    async addListener(b, W) {
      return await this.on(b, W);
    }
    /**
     *  Alias for [off].
     */
    async removeListener(b, W) {
      return await this.off(b, W);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */
    static buildClass(b) {
      class W extends Xd {
        constructor(G, re = null) {
          super(G, b, re);
        }
      }
      return W;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */
    static from(b, W, X) {
      return X == null && (X = null), new this(b, W, X);
    }
  };
  t = R;
  let P = E;
  Ei.BaseContract = P;
  function w() {
    return P;
  }
  class m extends w() {
  }
  return Ei.Contract = m, Ei;
}
var Dc = {}, I2;
function ek() {
  if (I2)
    return Dc;
  I2 = 1, Object.defineProperty(Dc, "__esModule", { value: !0 }), Dc.ContractFactory = void 0;
  const e = gd(), t = Yr(), r = wt(), n = V5();
  class s {
    /**
     *  Create a new **ContractFactory** with %%abi%% and %%bytecode%%,
     *  optionally connected to %%runner%%.
     *
     *  The %%bytecode%% may be the ``bytecode`` property within the
     *  standard Solidity JSON output.
     */
    constructor(a, f, d) {
      Be(this, "interface"), Be(this, "bytecode"), Be(this, "runner");
      const c = e.Interface.from(a);
      f instanceof Uint8Array || (typeof f == "object" && (f = f.object), f.startsWith("0x") || (f = "0x" + f)), f = (0, r.hexlify)((0, r.getBytes)(f)), (0, r.defineProperties)(this, {
        bytecode: f,
        interface: c,
        runner: d || null
      });
    }
    attach(a) {
      return new n.BaseContract(a, this.interface, this.runner);
    }
    /**
     *  Resolves to the transaction to deploy the contract, passing %%args%%
     *  into the constructor.
     */
    async getDeployTransaction(...a) {
      let f = {};
      const d = this.interface.deploy;
      if (d.inputs.length + 1 === a.length && (f = await (0, n.copyOverrides)(a.pop())), d.inputs.length !== a.length)
        throw new Error("incorrect number of arguments to constructor");
      const c = await (0, n.resolveArgs)(this.runner, d.inputs, a), p = (0, r.concat)([this.bytecode, this.interface.encodeDeploy(c)]);
      return Object.assign({}, f, { data: p });
    }
    /**
     *  Resolves to the Contract deployed by passing %%args%% into the
     *  constructor.
     *
     *  This will resolve to the Contract before it has been deployed to the
     *  network, so the [[BaseContract-waitForDeployment]] should be used before
     *  sending any transactions to it.
     */
    async deploy(...a) {
      const f = await this.getDeployTransaction(...a);
      (0, r.assert)(this.runner && typeof this.runner.sendTransaction == "function", "factory runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
        operation: "sendTransaction"
      });
      const d = await this.runner.sendTransaction(f), c = (0, t.getCreateAddress)(d);
      return new n.BaseContract(c, this.interface, this.runner, d);
    }
    /**
     *  Return a new **ContractFactory** with the same ABI and bytecode,
     *  but connected to %%runner%%.
     */
    connect(a) {
      return new s(this.interface, this.bytecode, a);
    }
    /**
     *  Create a new **ContractFactory** from the standard Solidity JSON output.
     */
    static fromSolidity(a, f) {
      (0, r.assertArgument)(a != null, "bad compiler output", "output", a), typeof a == "string" && (a = JSON.parse(a));
      const d = a.abi;
      let c = "";
      return a.bytecode ? c = a.bytecode : a.evm && a.evm.bytecode && (c = a.evm.bytecode), new this(d, c, f);
    }
  }
  return Dc.ContractFactory = s, Dc;
}
var R2;
function of() {
  return R2 || (R2 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.UndecodedEventLog = e.EventLog = e.ContractTransactionResponse = e.ContractTransactionReceipt = e.ContractUnknownEventPayload = e.ContractEventPayload = e.ContractFactory = e.Contract = e.BaseContract = void 0;
    var t = V5();
    Object.defineProperty(e, "BaseContract", { enumerable: !0, get: function() {
      return t.BaseContract;
    } }), Object.defineProperty(e, "Contract", { enumerable: !0, get: function() {
      return t.Contract;
    } });
    var r = ek();
    Object.defineProperty(e, "ContractFactory", { enumerable: !0, get: function() {
      return r.ContractFactory;
    } });
    var n = z5();
    Object.defineProperty(e, "ContractEventPayload", { enumerable: !0, get: function() {
      return n.ContractEventPayload;
    } }), Object.defineProperty(e, "ContractUnknownEventPayload", { enumerable: !0, get: function() {
      return n.ContractUnknownEventPayload;
    } }), Object.defineProperty(e, "ContractTransactionReceipt", { enumerable: !0, get: function() {
      return n.ContractTransactionReceipt;
    } }), Object.defineProperty(e, "ContractTransactionResponse", { enumerable: !0, get: function() {
      return n.ContractTransactionResponse;
    } }), Object.defineProperty(e, "EventLog", { enumerable: !0, get: function() {
      return n.EventLog;
    } }), Object.defineProperty(e, "UndecodedEventLog", { enumerable: !0, get: function() {
      return n.UndecodedEventLog;
    } });
  }(T2)), T2;
}
var C2 = {}, na = {}, ks = {}, B2;
function q5() {
  var e, t, r, n, s, i;
  if (B2)
    return ks;
  B2 = 1, Object.defineProperty(ks, "__esModule", { value: !0 }), ks.EnsResolver = ks.BasicMulticoinProviderPlugin = ks.MulticoinProviderPlugin = void 0;
  const a = Yr(), f = pd(), d = of(), c = no(), p = wt();
  function g(I) {
    return I.match(/^ipfs:\/\/ipfs\//i) ? I = I.substring(12) : I.match(/^ipfs:\/\//i) ? I = I.substring(7) : (0, p.assertArgument)(!1, "unsupported IPFS format", "link", I), `https://gateway.ipfs.io/ipfs/${I}`;
  }
  class v {
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */
    constructor(A) {
      Be(this, "name"), (0, p.defineProperties)(this, { name: A });
    }
    connect(A) {
      return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */
    supportsCoinType(A) {
      return !1;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */
    async encodeAddress(A, R) {
      throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */
    async decodeAddress(A, R) {
      throw new Error("unsupported coin");
    }
  }
  ks.MulticoinProviderPlugin = v;
  const O = "org.ethers.plugins.provider.BasicMulticoin";
  class N extends v {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */
    constructor() {
      super(O);
    }
  }
  ks.BasicMulticoinProviderPlugin = N;
  const S = new RegExp("^(ipfs)://(.*)$", "i"), j = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    S,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
  ], B = class jp {
    constructor(A, R, L) {
      _e(this, r), Be(this, "provider"), Be(this, "address"), Be(this, "name"), _e(this, e, void 0), _e(this, t, void 0), (0, p.defineProperties)(this, { provider: A, address: R, name: L }), Oe(this, e, null), Oe(this, t, new d.Contract(R, [
        "function supportsInterface(bytes4) view returns (bool)",
        "function resolve(bytes, bytes) view returns (bytes)",
        "function addr(bytes32) view returns (address)",
        "function addr(bytes32, uint) view returns (bytes)",
        "function text(bytes32, string) view returns (string)",
        "function contenthash(bytes32) view returns (bytes)"
      ], A));
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */
    async supportsWildcard() {
      return oe(this, e) == null && Oe(this, e, (async () => {
        try {
          return await oe(this, t).supportsInterface("0x9061b923");
        } catch (A) {
          if ((0, p.isError)(A, "CALL_EXCEPTION"))
            return !1;
          throw Oe(this, e, null), A;
        }
      })()), await oe(this, e);
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */
    async getAddress(A) {
      if (A == null && (A = 60), A === 60)
        try {
          const $ = await Ve(this, r, n).call(this, "addr(bytes32)");
          return $ == null || $ === f.ZeroAddress ? null : $;
        } catch ($) {
          if ((0, p.isError)($, "CALL_EXCEPTION"))
            return null;
          throw $;
        }
      if (A >= 0 && A < 2147483648) {
        let $ = A + 2147483648;
        const k = await Ve(this, r, n).call(this, "addr(bytes32,uint)", [$]);
        if ((0, p.isHexString)(k, 20))
          return (0, a.getAddress)(k);
      }
      let R = null;
      for (const $ of this.provider.plugins)
        if ($ instanceof v && $.supportsCoinType(A)) {
          R = $;
          break;
        }
      if (R == null)
        return null;
      const L = await Ve(this, r, n).call(this, "addr(bytes32,uint)", [A]);
      if (L == null || L === "0x")
        return null;
      const K = await R.decodeAddress(A, L);
      if (K != null)
        return K;
      (0, p.assert)(!1, "invalid coin data", "UNSUPPORTED_OPERATION", {
        operation: `getAddress(${A})`,
        info: { coinType: A, data: L }
      });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */
    async getText(A) {
      const R = await Ve(this, r, n).call(this, "text(bytes32,string)", [A]);
      return R == null || R === "0x" ? null : R;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */
    async getContentHash() {
      const A = await Ve(this, r, n).call(this, "contenthash(bytes32)");
      if (A == null || A === "0x")
        return null;
      const R = A.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (R) {
        const K = R[1] === "e3010170" ? "ipfs" : "ipns", $ = parseInt(R[4], 16);
        if (R[5].length === $ * 2)
          return `${K}://${(0, p.encodeBase58)("0x" + R[2])}`;
      }
      const L = A.match(/^0xe40101fa011b20([0-9a-f]*)$/);
      if (L && L[1].length === 64)
        return `bzz://${L[1]}`;
      (0, p.assert)(!1, "invalid or unsupported content hash data", "UNSUPPORTED_OPERATION", {
        operation: "getContentHash()",
        info: { data: A }
      });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */
    async getAvatar() {
      return (await this._getAvatar()).url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */
    async _getAvatar() {
      const A = [{ type: "name", value: this.name }];
      try {
        const R = await this.getText("avatar");
        if (R == null)
          return A.push({ type: "!avatar", value: "" }), { url: null, linkage: A };
        A.push({ type: "avatar", value: R });
        for (let L = 0; L < j.length; L++) {
          const K = R.match(j[L]);
          if (K == null)
            continue;
          const $ = K[1].toLowerCase();
          switch ($) {
            case "https":
            case "data":
              return A.push({ type: "url", value: R }), { linkage: A, url: R };
            case "ipfs": {
              const k = g(R);
              return A.push({ type: "ipfs", value: R }), A.push({ type: "url", value: k }), { linkage: A, url: k };
            }
            case "erc721":
            case "erc1155": {
              const k = $ === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
              A.push({ type: $, value: R });
              const V = await this.getAddress();
              if (V == null)
                return A.push({ type: "!owner", value: "" }), { url: null, linkage: A };
              const C = (K[2] || "").split("/");
              if (C.length !== 2)
                return A.push({ type: `!${$}caip`, value: K[2] || "" }), { url: null, linkage: A };
              const D = C[1], o = new d.Contract(C[0], [
                // ERC-721
                "function tokenURI(uint) view returns (string)",
                "function ownerOf(uint) view returns (address)",
                // ERC-1155
                "function uri(uint) view returns (string)",
                "function balanceOf(address, uint256) view returns (uint)"
              ], this.provider);
              if ($ === "erc721") {
                const P = await o.ownerOf(D);
                if (V !== P)
                  return A.push({ type: "!owner", value: P }), { url: null, linkage: A };
                A.push({ type: "owner", value: P });
              } else if ($ === "erc1155") {
                const P = await o.balanceOf(V, D);
                if (!P)
                  return A.push({ type: "!balance", value: "0" }), { url: null, linkage: A };
                A.push({ type: "balance", value: P.toString() });
              }
              let u = await o[k](D);
              if (u == null || u === "0x")
                return A.push({ type: "!metadata-url", value: "" }), { url: null, linkage: A };
              A.push({ type: "metadata-url-base", value: u }), $ === "erc1155" && (u = u.replace("{id}", (0, p.toBeHex)(D, 32).substring(2)), A.push({ type: "metadata-url-expanded", value: u })), u.match(/^ipfs:/i) && (u = g(u)), A.push({ type: "metadata-url", value: u });
              let h = {};
              const y = await new p.FetchRequest(u).send();
              y.assertOk();
              try {
                h = y.bodyJson;
              } catch {
                try {
                  A.push({ type: "!metadata", value: y.bodyText });
                } catch {
                  const P = y.body;
                  return P && A.push({ type: "!metadata", value: (0, p.hexlify)(P) }), { url: null, linkage: A };
                }
                return { url: null, linkage: A };
              }
              if (!h)
                return A.push({ type: "!metadata", value: "" }), { url: null, linkage: A };
              A.push({ type: "metadata", value: JSON.stringify(h) });
              let E = h.image;
              if (typeof E != "string")
                return A.push({ type: "!imageUrl", value: "" }), { url: null, linkage: A };
              if (!E.match(/^(https:\/\/|data:)/i)) {
                if (E.match(S) == null)
                  return A.push({ type: "!imageUrl-ipfs", value: E }), { url: null, linkage: A };
                A.push({ type: "imageUrl-ipfs", value: E }), E = g(E);
              }
              return A.push({ type: "url", value: E }), { linkage: A, url: E };
            }
          }
        }
      } catch {
      }
      return { linkage: A, url: null };
    }
    static async getEnsAddress(A) {
      const R = await A.getNetwork(), L = R.getPlugin("org.ethers.plugins.network.Ens");
      return (0, p.assert)(L, "network does not support ENS", "UNSUPPORTED_OPERATION", {
        operation: "getEnsAddress",
        info: { network: R }
      }), L.address;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */
    static async fromName(A, R) {
      var L;
      let K = R;
      for (; ; ) {
        if (K === "" || K === "." || R !== "eth" && K === "eth")
          return null;
        const $ = await Ve(L = jp, s, i).call(L, A, K);
        if ($ != null) {
          const k = new jp(A, $, R);
          return K !== R && !await k.supportsWildcard() ? null : k;
        }
        K = K.split(".").slice(1).join(".");
      }
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakSet(), n = async function(I, A) {
    A = (A || []).slice();
    const R = oe(this, t).interface;
    A.unshift((0, c.namehash)(this.name));
    let L = null;
    await this.supportsWildcard() && (L = R.getFunction(I), (0, p.assert)(L, "missing fragment", "UNKNOWN_ERROR", {
      info: { funcName: I }
    }), A = [
      (0, c.dnsEncode)(this.name, 255),
      R.encodeFunctionData(L, A)
    ], I = "resolve(bytes,bytes)"), A.push({
      enableCcipRead: !0
    });
    try {
      const K = await oe(this, t)[I](...A);
      return L ? R.decodeFunctionResult(L, K)[0] : K;
    } catch (K) {
      if (!(0, p.isError)(K, "CALL_EXCEPTION"))
        throw K;
    }
    return null;
  }, s = /* @__PURE__ */ new WeakSet(), i = async function(I, A) {
    const R = await B.getEnsAddress(I);
    try {
      const L = await new d.Contract(R, [
        "function resolver(bytes32) view returns (address)"
      ], I).resolver((0, c.namehash)(A), {
        enableCcipRead: !0
      });
      return L === f.ZeroAddress ? null : L;
    } catch (L) {
      throw L;
    }
    return null;
  }, _e(B, s);
  let M = B;
  return ks.EnsResolver = M, ks;
}
var Pr = {}, _2;
function tk() {
  if (_2)
    return Pr;
  _2 = 1, Object.defineProperty(Pr, "__esModule", { value: !0 }), Pr.formatTransactionResponse = Pr.formatTransactionReceipt = Pr.formatReceiptLog = Pr.formatBlock = Pr.formatLog = Pr.formatUint256 = Pr.formatHash = Pr.formatData = Pr.formatBoolean = Pr.object = Pr.arrayOf = Pr.allowNull = void 0;
  const e = Yr(), t = cn(), r = Yn(), n = wt(), s = BigInt(0);
  function i(R, L) {
    return function(K) {
      return K == null ? L : R(K);
    };
  }
  Pr.allowNull = i;
  function a(R, L) {
    return (K) => {
      if (L && K == null)
        return null;
      if (!Array.isArray(K))
        throw new Error("not an array");
      return K.map(($) => R($));
    };
  }
  Pr.arrayOf = a;
  function f(R, L) {
    return (K) => {
      const $ = {};
      for (const k in R) {
        let V = k;
        if (L && k in L && !(V in K)) {
          for (const C of L[k])
            if (C in K) {
              V = C;
              break;
            }
        }
        try {
          const C = R[k](K[V]);
          C !== void 0 && ($[k] = C);
        } catch (C) {
          const D = C instanceof Error ? C.message : "not-an-error";
          (0, n.assert)(!1, `invalid value for value.${k} (${D})`, "BAD_DATA", { value: K });
        }
      }
      return $;
    };
  }
  Pr.object = f;
  function d(R) {
    switch (R) {
      case !0:
      case "true":
        return !0;
      case !1:
      case "false":
        return !1;
    }
    (0, n.assertArgument)(!1, `invalid boolean; ${JSON.stringify(R)}`, "value", R);
  }
  Pr.formatBoolean = d;
  function c(R) {
    return (0, n.assertArgument)((0, n.isHexString)(R, !0), "invalid data", "value", R), R;
  }
  Pr.formatData = c;
  function p(R) {
    return (0, n.assertArgument)((0, n.isHexString)(R, 32), "invalid hash", "value", R), R;
  }
  Pr.formatHash = p;
  function g(R) {
    if (!(0, n.isHexString)(R))
      throw new Error("invalid uint256");
    return (0, n.zeroPadValue)(R, 32);
  }
  Pr.formatUint256 = g;
  const v = f({
    address: e.getAddress,
    blockHash: p,
    blockNumber: n.getNumber,
    data: c,
    index: n.getNumber,
    removed: i(d, !1),
    topics: a(p),
    transactionHash: p,
    transactionIndex: n.getNumber
  }, {
    index: ["logIndex"]
  });
  function O(R) {
    return v(R);
  }
  Pr.formatLog = O;
  const N = f({
    hash: i(p),
    parentHash: p,
    parentBeaconBlockRoot: i(p, null),
    number: n.getNumber,
    timestamp: n.getNumber,
    nonce: i(c),
    difficulty: n.getBigInt,
    gasLimit: n.getBigInt,
    gasUsed: n.getBigInt,
    stateRoot: i(p, null),
    receiptsRoot: i(p, null),
    blobGasUsed: i(n.getBigInt, null),
    excessBlobGas: i(n.getBigInt, null),
    miner: i(e.getAddress),
    prevRandao: i(p, null),
    extraData: c,
    baseFeePerGas: i(n.getBigInt)
  }, {
    prevRandao: ["mixHash"]
  });
  function S(R) {
    const L = N(R);
    return L.transactions = R.transactions.map((K) => typeof K == "string" ? K : A(K)), L;
  }
  Pr.formatBlock = S;
  const j = f({
    transactionIndex: n.getNumber,
    blockNumber: n.getNumber,
    transactionHash: p,
    address: e.getAddress,
    topics: a(p),
    data: c,
    index: n.getNumber,
    blockHash: p
  }, {
    index: ["logIndex"]
  });
  function B(R) {
    return j(R);
  }
  Pr.formatReceiptLog = B;
  const M = f({
    to: i(e.getAddress, null),
    from: i(e.getAddress, null),
    contractAddress: i(e.getAddress, null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: n.getNumber,
    root: i(n.hexlify),
    gasUsed: n.getBigInt,
    blobGasUsed: i(n.getBigInt, null),
    logsBloom: i(c),
    blockHash: p,
    hash: p,
    logs: a(B),
    blockNumber: n.getNumber,
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: n.getBigInt,
    effectiveGasPrice: i(n.getBigInt),
    blobGasPrice: i(n.getBigInt, null),
    status: i(n.getNumber),
    type: i(n.getNumber, 0)
  }, {
    effectiveGasPrice: ["gasPrice"],
    hash: ["transactionHash"],
    index: ["transactionIndex"]
  });
  function I(R) {
    return M(R);
  }
  Pr.formatTransactionReceipt = I;
  function A(R) {
    R.to && (0, n.getBigInt)(R.to) === s && (R.to = "0x0000000000000000000000000000000000000000");
    const L = f({
      hash: p,
      // Some nodes do not return this, usually test nodes (like Ganache)
      index: i(n.getNumber, void 0),
      type: (K) => K === "0x" || K == null ? 0 : (0, n.getNumber)(K),
      accessList: i(r.accessListify, null),
      blobVersionedHashes: i(a(p, !0), null),
      blockHash: i(p, null),
      blockNumber: i(n.getNumber, null),
      transactionIndex: i(n.getNumber, null),
      from: e.getAddress,
      // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
      gasPrice: i(n.getBigInt),
      maxPriorityFeePerGas: i(n.getBigInt),
      maxFeePerGas: i(n.getBigInt),
      maxFeePerBlobGas: i(n.getBigInt, null),
      gasLimit: n.getBigInt,
      to: i(e.getAddress, null),
      value: n.getBigInt,
      nonce: n.getNumber,
      data: c,
      creates: i(e.getAddress, null),
      chainId: i(n.getBigInt, null)
    }, {
      data: ["input"],
      gasLimit: ["gas"],
      index: ["transactionIndex"]
    })(R);
    if (L.to == null && L.creates == null && (L.creates = (0, e.getCreateAddress)(L)), (R.type === 1 || R.type === 2) && R.accessList == null && (L.accessList = []), R.signature ? L.signature = t.Signature.from(R.signature) : L.signature = t.Signature.from(R), L.chainId == null) {
      const K = L.signature.legacyChainId;
      K != null && (L.chainId = K);
    }
    return L.blockHash && (0, n.getBigInt)(L.blockHash) === s && (L.blockHash = null), L;
  }
  return Pr.formatTransactionResponse = A, Pr;
}
var jc = {}, Ln = {}, F2;
function x1() {
  var e, t, r;
  if (F2)
    return Ln;
  F2 = 1, Object.defineProperty(Ln, "__esModule", { value: !0 }), Ln.FetchUrlFeeDataNetworkPlugin = Ln.FeeDataNetworkPlugin = Ln.EnsPlugin = Ln.GasCostPlugin = Ln.NetworkPlugin = void 0;
  const n = ru(), s = wt(), i = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
  class a {
    /**
     *  Creates a new **NetworkPlugin**.
     */
    constructor(O) {
      Be(this, "name"), (0, n.defineProperties)(this, { name: O });
    }
    /**
     *  Creates a copy of this plugin.
     */
    clone() {
      return new a(this.name);
    }
  }
  Ln.NetworkPlugin = a;
  class f extends a {
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */
    constructor(O, N) {
      O == null && (O = 0), super(`org.ethers.network.plugins.GasCost#${O || 0}`), Be(this, "effectiveBlock"), Be(this, "txBase"), Be(this, "txCreate"), Be(this, "txDataZero"), Be(this, "txDataNonzero"), Be(this, "txAccessListStorageKey"), Be(this, "txAccessListAddress");
      const S = { effectiveBlock: O };
      function j(B, M) {
        let I = (N || {})[B];
        I == null && (I = M), (0, s.assertArgument)(typeof I == "number", `invalud value for ${B}`, "costs", N), S[B] = I;
      }
      j("txBase", 21e3), j("txCreate", 32e3), j("txDataZero", 4), j("txDataNonzero", 16), j("txAccessListStorageKey", 1900), j("txAccessListAddress", 2400), (0, n.defineProperties)(this, S);
    }
    clone() {
      return new f(this.effectiveBlock, this);
    }
  }
  Ln.GasCostPlugin = f;
  class d extends a {
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */
    constructor(O, N) {
      super("org.ethers.plugins.network.Ens"), Be(this, "address"), Be(this, "targetNetwork"), (0, n.defineProperties)(this, {
        address: O || i,
        targetNetwork: N ?? 1
      });
    }
    clone() {
      return new d(this.address, this.targetNetwork);
    }
  }
  Ln.EnsPlugin = d;
  const c = class $5 extends a {
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */
    constructor(O) {
      super("org.ethers.plugins.network.FeeData"), _e(this, e, void 0), Oe(this, e, O);
    }
    /**
     *  The fee data function provided to the constructor.
     */
    get feeDataFunc() {
      return oe(this, e);
    }
    /**
     *  Resolves to the fee data.
     */
    async getFeeData(O) {
      return await oe(this, e).call(this, O);
    }
    clone() {
      return new $5(oe(this, e));
    }
  };
  e = /* @__PURE__ */ new WeakMap();
  let p = c;
  Ln.FeeDataNetworkPlugin = p;
  class g extends a {
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */
    constructor(O, N) {
      super("org.ethers.plugins.network.FetchUrlFeeDataPlugin"), _e(this, t, void 0), _e(this, r, void 0), Oe(this, t, O), Oe(this, r, N);
    }
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */
    get url() {
      return oe(this, t);
    }
    /**
     *  The callback to use when computing the FeeData.
     */
    get processFunc() {
      return oe(this, r);
    }
    // We are immutable, so we can serve as our own clone
    clone() {
      return this;
    }
  }
  return t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), Ln.FetchUrlFeeDataNetworkPlugin = g, Ln;
}
var U2;
function Xn() {
  var e, t, r;
  if (U2)
    return jc;
  U2 = 1, Object.defineProperty(jc, "__esModule", { value: !0 }), jc.Network = void 0;
  const n = Yn(), s = wt(), i = x1(), a = /* @__PURE__ */ new Map(), f = class T0 {
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */
    constructor(N, S) {
      _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), Oe(this, e, N), Oe(this, t, (0, s.getBigInt)(S)), Oe(this, r, /* @__PURE__ */ new Map());
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */
    toJSON() {
      return { name: this.name, chainId: String(this.chainId) };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */
    get name() {
      return oe(this, e);
    }
    set name(N) {
      Oe(this, e, N);
    }
    /**
     *  The network chain ID.
     */
    get chainId() {
      return oe(this, t);
    }
    set chainId(N) {
      Oe(this, t, (0, s.getBigInt)(N, "chainId"));
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */
    matches(N) {
      if (N == null)
        return !1;
      if (typeof N == "string") {
        try {
          return this.chainId === (0, s.getBigInt)(N);
        } catch {
        }
        return this.name === N;
      }
      if (typeof N == "number" || typeof N == "bigint") {
        try {
          return this.chainId === (0, s.getBigInt)(N);
        } catch {
        }
        return !1;
      }
      if (typeof N == "object") {
        if (N.chainId != null) {
          try {
            return this.chainId === (0, s.getBigInt)(N.chainId);
          } catch {
          }
          return !1;
        }
        return N.name != null ? this.name === N.name : !1;
      }
      return !1;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */
    get plugins() {
      return Array.from(oe(this, r).values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */
    attachPlugin(N) {
      if (oe(this, r).get(N.name))
        throw new Error(`cannot replace existing plugin: ${N.name} `);
      return oe(this, r).set(N.name, N.clone()), this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */
    getPlugin(N) {
      return oe(this, r).get(N) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */
    getPlugins(N) {
      return this.plugins.filter((S) => S.name.split("#")[0] === N);
    }
    /**
     *  Create a copy of this Network.
     */
    clone() {
      const N = new T0(this.name, this.chainId);
      return this.plugins.forEach((S) => {
        N.attachPlugin(S.clone());
      }), N;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */
    computeIntrinsicGas(N) {
      const S = this.getPlugin("org.ethers.plugins.network.GasCost") || new i.GasCostPlugin();
      let j = S.txBase;
      if (N.to == null && (j += S.txCreate), N.data)
        for (let B = 2; B < N.data.length; B += 2)
          N.data.substring(B, B + 2) === "00" ? j += S.txDataZero : j += S.txDataNonzero;
      if (N.accessList) {
        const B = (0, n.accessListify)(N.accessList);
        for (const M in B)
          j += S.txAccessListAddress + S.txAccessListStorageKey * B[M].storageKeys.length;
      }
      return j;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */
    static from(N) {
      if (v(), N == null)
        return T0.from("mainnet");
      if (typeof N == "number" && (N = BigInt(N)), typeof N == "string" || typeof N == "bigint") {
        const S = a.get(N);
        if (S)
          return S();
        if (typeof N == "bigint")
          return new T0("unknown", N);
        (0, s.assertArgument)(!1, "unknown network", "network", N);
      }
      if (typeof N.clone == "function")
        return N.clone();
      if (typeof N == "object") {
        (0, s.assertArgument)(typeof N.name == "string" && typeof N.chainId == "number", "invalid network object name or chainId", "network", N);
        const S = new T0(N.name, N.chainId);
        return (N.ensAddress || N.ensNetwork != null) && S.attachPlugin(new i.EnsPlugin(N.ensAddress, N.ensNetwork)), S;
      }
      (0, s.assertArgument)(!1, "invalid network", "network", N);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */
    static register(N, S) {
      typeof N == "number" && (N = BigInt(N));
      const j = a.get(N);
      j && (0, s.assertArgument)(!1, `conflicting network for ${JSON.stringify(j.name)}`, "nameOrChainId", N), a.set(N, S);
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  let d = f;
  jc.Network = d;
  function c(O, N) {
    const S = String(O);
    if (!S.match(/^[0-9.]+$/))
      throw new Error(`invalid gwei value: ${O}`);
    const j = S.split(".");
    if (j.length === 1 && j.push(""), j.length !== 2)
      throw new Error(`invalid gwei value: ${O}`);
    for (; j[1].length < N; )
      j[1] += "0";
    if (j[1].length > 9) {
      let B = BigInt(j[1].substring(0, 9));
      j[1].substring(9).match(/^0+$/) || B++, j[1] = B.toString();
    }
    return BigInt(j[0] + j[1]);
  }
  function p(O) {
    return new i.FetchUrlFeeDataNetworkPlugin(O, async (N, S, j) => {
      j.setHeader("User-Agent", "ethers");
      let B;
      try {
        const [M, I] = await Promise.all([
          j.send(),
          N()
        ]);
        B = M;
        const A = B.bodyJson.standard;
        return {
          gasPrice: I.gasPrice,
          maxFeePerGas: c(A.maxFee, 9),
          maxPriorityFeePerGas: c(A.maxPriorityFee, 9)
        };
      } catch (M) {
        (0, s.assert)(!1, `error encountered with polygon gas station (${JSON.stringify(j.url)})`, "SERVER_ERROR", { request: j, response: B, error: M });
      }
    });
  }
  let g = !1;
  function v() {
    if (g)
      return;
    g = !0;
    function O(N, S, j) {
      const B = function() {
        const M = new d(N, S);
        return j.ensNetwork != null && M.attachPlugin(new i.EnsPlugin(null, j.ensNetwork)), M.attachPlugin(new i.GasCostPlugin()), (j.plugins || []).forEach((I) => {
          M.attachPlugin(I);
        }), M;
      };
      d.register(N, B), d.register(S, B), j.altNames && j.altNames.forEach((M) => {
        d.register(M, B);
      });
    }
    O("mainnet", 1, { ensNetwork: 1, altNames: ["homestead"] }), O("ropsten", 3, { ensNetwork: 3 }), O("rinkeby", 4, { ensNetwork: 4 }), O("goerli", 5, { ensNetwork: 5 }), O("kovan", 42, { ensNetwork: 42 }), O("sepolia", 11155111, { ensNetwork: 11155111 }), O("holesky", 17e3, { ensNetwork: 17e3 }), O("classic", 61, {}), O("classicKotti", 6, {}), O("arbitrum", 42161, {
      ensNetwork: 1
    }), O("arbitrum-goerli", 421613, {}), O("arbitrum-sepolia", 421614, {}), O("base", 8453, { ensNetwork: 1 }), O("base-goerli", 84531, {}), O("base-sepolia", 84532, {}), O("bnb", 56, { ensNetwork: 1 }), O("bnbt", 97, {}), O("linea", 59144, { ensNetwork: 1 }), O("linea-goerli", 59140, {}), O("linea-sepolia", 59141, {}), O("matic", 137, {
      ensNetwork: 1,
      plugins: [
        p("https://gasstation.polygon.technology/v2")
      ]
    }), O("matic-amoy", 80002, {}), O("matic-mumbai", 80001, {
      altNames: ["maticMumbai", "maticmum"],
      plugins: [
        p("https://gasstation-testnet.polygon.technology/v2")
      ]
    }), O("optimism", 10, {
      ensNetwork: 1,
      plugins: []
    }), O("optimism-goerli", 420, {}), O("optimism-sepolia", 11155420, {}), O("xdai", 100, { ensNetwork: 1 });
  }
  return jc;
}
var en = {}, D2;
function T1() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N, S, j, B, M, I;
  if (D2)
    return en;
  D2 = 1, Object.defineProperty(en, "__esModule", { value: !0 }), en.PollingEventSubscriber = en.PollingTransactionSubscriber = en.PollingOrphanSubscriber = en.PollingBlockTagSubscriber = en.OnBlockSubscriber = en.PollingBlockSubscriber = en.getPollingSubscriber = void 0;
  const A = wt();
  function R(o) {
    return JSON.parse(JSON.stringify(o));
  }
  function L(o, u) {
    if (u === "block")
      return new K(o);
    if ((0, A.isHexString)(u, 32))
      return new C(o, u);
    (0, A.assert)(!1, "unsupported polling event", "UNSUPPORTED_OPERATION", {
      operation: "getPollingSubscriber",
      info: { event: u }
    });
  }
  en.getPollingSubscriber = L;
  class K {
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */
    constructor(u) {
      _e(this, s), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), _e(this, n, void 0), Oe(this, e, u), Oe(this, t, null), Oe(this, r, 4e3), Oe(this, n, -2);
    }
    /**
     *  The polling interval.
     */
    get pollingInterval() {
      return oe(this, r);
    }
    set pollingInterval(u) {
      Oe(this, r, u);
    }
    start() {
      oe(this, t) || (Oe(this, t, oe(this, e)._setTimeout(Ve(this, s, i).bind(this), oe(this, r))), Ve(this, s, i).call(this));
    }
    stop() {
      oe(this, t) && (oe(this, e)._clearTimeout(oe(this, t)), Oe(this, t, null));
    }
    pause(u) {
      this.stop(), u && Oe(this, n, -2);
    }
    resume() {
      this.start();
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakSet(), i = async function() {
    try {
      const o = await oe(this, e).getBlockNumber();
      if (oe(this, n) === -2) {
        Oe(this, n, o);
        return;
      }
      if (o !== oe(this, n)) {
        for (let u = oe(this, n) + 1; u <= o; u++) {
          if (oe(this, t) == null)
            return;
          await oe(this, e).emit("block", u);
        }
        Oe(this, n, o);
      }
    } catch {
    }
    oe(this, t) != null && Oe(this, t, oe(this, e)._setTimeout(Ve(this, s, i).bind(this), oe(this, r)));
  }, en.PollingBlockSubscriber = K;
  class $ {
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */
    constructor(u) {
      _e(this, a, void 0), _e(this, f, void 0), _e(this, d, void 0), Oe(this, a, u), Oe(this, d, !1), Oe(this, f, (h) => {
        this._poll(h, oe(this, a));
      });
    }
    /**
     *  Called on every new block.
     */
    async _poll(u, h) {
      throw new Error("sub-classes must override this");
    }
    start() {
      oe(this, d) || (Oe(this, d, !0), oe(this, f).call(this, -2), oe(this, a).on("block", oe(this, f)));
    }
    stop() {
      oe(this, d) && (Oe(this, d, !1), oe(this, a).off("block", oe(this, f)));
    }
    pause(u) {
      this.stop();
    }
    resume() {
      this.start();
    }
  }
  a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), en.OnBlockSubscriber = $;
  class k extends $ {
    constructor(u, h) {
      super(u), _e(this, c, void 0), _e(this, p, void 0), Oe(this, c, h), Oe(this, p, -2);
    }
    pause(u) {
      u && Oe(this, p, -2), super.pause(u);
    }
    async _poll(u, h) {
      const y = await h.getBlock(oe(this, c));
      y != null && (oe(this, p) === -2 ? Oe(this, p, y.number) : y.number > oe(this, p) && (h.emit(oe(this, c), y.number), Oe(this, p, y.number)));
    }
  }
  c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), en.PollingBlockTagSubscriber = k;
  class V extends $ {
    constructor(u, h) {
      super(u), _e(this, g, void 0), Oe(this, g, R(h));
    }
    async _poll(u, h) {
      throw new Error("@TODO");
    }
  }
  g = /* @__PURE__ */ new WeakMap(), en.PollingOrphanSubscriber = V;
  class C extends $ {
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */
    constructor(u, h) {
      super(u), _e(this, v, void 0), Oe(this, v, h);
    }
    async _poll(u, h) {
      const y = await h.getTransactionReceipt(oe(this, v));
      y && h.emit(oe(this, v), y);
    }
  }
  v = /* @__PURE__ */ new WeakMap(), en.PollingTransactionSubscriber = C;
  class D {
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */
    constructor(u, h) {
      _e(this, M), _e(this, O, void 0), _e(this, N, void 0), _e(this, S, void 0), _e(this, j, void 0), _e(this, B, void 0), Oe(this, O, u), Oe(this, N, R(h)), Oe(this, S, Ve(this, M, I).bind(this)), Oe(this, j, !1), Oe(this, B, -2);
    }
    start() {
      oe(this, j) || (Oe(this, j, !0), oe(this, B) === -2 && oe(this, O).getBlockNumber().then((u) => {
        Oe(this, B, u);
      }), oe(this, O).on("block", oe(this, S)));
    }
    stop() {
      oe(this, j) && (Oe(this, j, !1), oe(this, O).off("block", oe(this, S)));
    }
    pause(u) {
      this.stop(), u && Oe(this, B, -2);
    }
    resume() {
      this.start();
    }
  }
  return O = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakSet(), I = async function(o) {
    if (oe(this, B) === -2)
      return;
    const u = R(oe(this, N));
    u.fromBlock = oe(this, B) + 1, u.toBlock = o;
    const h = await oe(this, O).getLogs(u);
    if (h.length === 0) {
      oe(this, B) < o - 60 && Oe(this, B, o - 60);
      return;
    }
    for (const y of h)
      oe(this, O).emit(oe(this, N), y), Oe(this, B, y.blockNumber);
  }, en.PollingEventSubscriber = D, en;
}
var j2;
function yd() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N, S, j, B, M, I, A, R, L, K, $, k;
  if (j2)
    return na;
  j2 = 1, Object.defineProperty(na, "__esModule", { value: !0 }), na.AbstractProvider = na.UnmanagedSubscriber = void 0;
  const V = Yr(), C = pd(), D = of(), o = no(), u = Yn(), h = wt(), y = q5(), E = tk(), P = Xn(), w = md(), m = T1(), l = BigInt(2), b = 10;
  function W(fe) {
    return fe && typeof fe.then == "function";
  }
  function X(fe, x) {
    return fe + ":" + JSON.stringify(x, (_, q) => {
      if (q == null)
        return "null";
      if (typeof q == "bigint")
        return `bigint:${q.toString()}`;
      if (typeof q == "string")
        return q.toLowerCase();
      if (typeof q == "object" && !Array.isArray(q)) {
        const ne = Object.keys(q);
        return ne.sort(), ne.reduce((de, ye) => (de[ye] = q[ye], de), {});
      }
      return q;
    });
  }
  class G {
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */
    constructor(x) {
      Be(this, "name"), (0, h.defineProperties)(this, { name: x });
    }
    start() {
    }
    stop() {
    }
    pause(x) {
    }
    resume() {
    }
  }
  na.UnmanagedSubscriber = G;
  function re(fe) {
    return JSON.parse(JSON.stringify(fe));
  }
  function ce(fe) {
    return fe = Array.from(new Set(fe).values()), fe.sort(), fe;
  }
  async function pe(fe, x) {
    if (fe == null)
      throw new Error("invalid event");
    if (Array.isArray(fe) && (fe = { topics: fe }), typeof fe == "string")
      switch (fe) {
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
          return { type: fe, tag: fe };
      }
    if ((0, h.isHexString)(fe, 32)) {
      const _ = fe.toLowerCase();
      return { type: "transaction", tag: X("tx", { hash: _ }), hash: _ };
    }
    if (fe.orphan) {
      const _ = fe;
      return { type: "orphan", tag: X("orphan", _), filter: re(_) };
    }
    if (fe.address || fe.topics) {
      const _ = fe, q = {
        topics: (_.topics || []).map((ne) => ne == null ? null : Array.isArray(ne) ? ce(ne.map((de) => de.toLowerCase())) : ne.toLowerCase())
      };
      if (_.address) {
        const ne = [], de = [], ye = (ge) => {
          (0, h.isHexString)(ge) ? ne.push(ge) : de.push((async () => {
            ne.push(await (0, V.resolveAddress)(ge, x));
          })());
        };
        Array.isArray(_.address) ? _.address.forEach(ye) : ye(_.address), de.length && await Promise.all(de), q.address = ce(ne.map((ge) => ge.toLowerCase()));
      }
      return { filter: q, tag: X("event", q), type: "event" };
    }
    (0, h.assertArgument)(!1, "unknown ProviderEvent", "event", fe);
  }
  function ve() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  const Ee = {
    cacheTimeout: 250,
    pollingInterval: 4e3
  };
  class Pe {
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */
    constructor(x, _) {
      if (_e(this, v), _e(this, N), _e(this, j), _e(this, M), _e(this, A), _e(this, L), _e(this, $), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), _e(this, n, void 0), _e(this, s, void 0), _e(this, i, void 0), _e(this, a, void 0), _e(this, f, void 0), _e(this, d, void 0), _e(this, c, void 0), _e(this, p, void 0), _e(this, g, void 0), Oe(this, g, Object.assign({}, Ee, _ || {})), x === "any")
        Oe(this, i, !0), Oe(this, s, null);
      else if (x) {
        const q = P.Network.from(x);
        Oe(this, i, !1), Oe(this, s, Promise.resolve(q)), setTimeout(() => {
          this.emit("network", q, null);
        }, 0);
      } else
        Oe(this, i, !1), Oe(this, s, null);
      Oe(this, f, -1), Oe(this, a, /* @__PURE__ */ new Map()), Oe(this, e, /* @__PURE__ */ new Map()), Oe(this, t, /* @__PURE__ */ new Map()), Oe(this, r, null), Oe(this, n, !1), Oe(this, d, 1), Oe(this, c, /* @__PURE__ */ new Map()), Oe(this, p, !1);
    }
    get pollingInterval() {
      return oe(this, g).pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */
    get provider() {
      return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */
    get plugins() {
      return Array.from(oe(this, t).values());
    }
    /**
     *  Attach a new plug-in.
     */
    attachPlugin(x) {
      if (oe(this, t).get(x.name))
        throw new Error(`cannot replace existing plugin: ${x.name} `);
      return oe(this, t).set(x.name, x.connect(this)), this;
    }
    /**
     *  Get a plugin by name.
     */
    getPlugin(x) {
      return oe(this, t).get(x) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */
    get disableCcipRead() {
      return oe(this, p);
    }
    set disableCcipRead(x) {
      Oe(this, p, !!x);
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */
    async ccipReadFetch(x, _, q) {
      if (this.disableCcipRead || q.length === 0 || x.to == null)
        return null;
      const ne = x.to.toLowerCase(), de = _.toLowerCase(), ye = [];
      for (let ge = 0; ge < q.length; ge++) {
        const be = q[ge], Me = be.replace("{sender}", ne).replace("{data}", de), Ce = new h.FetchRequest(Me);
        be.indexOf("{data}") === -1 && (Ce.body = { data: de, sender: ne }), this.emit("debug", { action: "sendCcipReadFetchRequest", request: Ce, index: ge, urls: q });
        let je = "unknown error";
        const Ue = await Ce.send();
        try {
          const Qe = Ue.bodyJson;
          if (Qe.data)
            return this.emit("debug", { action: "receiveCcipReadFetchResult", request: Ce, result: Qe }), Qe.data;
          Qe.message && (je = Qe.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: Ce, result: Qe });
        } catch {
        }
        (0, h.assert)(Ue.statusCode < 400 || Ue.statusCode >= 500, `response not found during CCIP fetch: ${je}`, "OFFCHAIN_FAULT", { reason: "404_MISSING_RESOURCE", transaction: x, info: { url: be, errorMessage: je } }), ye.push(je);
      }
      (0, h.assert)(!1, `error encountered during CCIP fetch: ${ye.map((ge) => JSON.stringify(ge)).join(", ")}`, "OFFCHAIN_FAULT", {
        reason: "500_SERVER_ERROR",
        transaction: x,
        info: { urls: q, errorMessages: ye }
      });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */
    _wrapBlock(x, _) {
      return new w.Block((0, E.formatBlock)(x), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */
    _wrapLog(x, _) {
      return new w.Log((0, E.formatLog)(x), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */
    _wrapTransactionReceipt(x, _) {
      return new w.TransactionReceipt((0, E.formatTransactionReceipt)(x), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */
    _wrapTransactionResponse(x, _) {
      return new w.TransactionResponse((0, E.formatTransactionResponse)(x), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */
    _detectNetwork() {
      (0, h.assert)(!1, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
        operation: "_detectNetwork"
      });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */
    async _perform(x) {
      (0, h.assert)(!1, `unsupported method: ${x.method}`, "UNSUPPORTED_OPERATION", {
        operation: x.method,
        info: x
      });
    }
    // State
    async getBlockNumber() {
      const x = (0, h.getNumber)(await Ve(this, v, O).call(this, { method: "getBlockNumber" }), "%response");
      return oe(this, f) >= 0 && Oe(this, f, x), x;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */
    _getAddress(x) {
      return (0, V.resolveAddress)(x, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */
    _getBlockTag(x) {
      if (x == null)
        return "latest";
      switch (x) {
        case "earliest":
          return "0x0";
        case "finalized":
        case "latest":
        case "pending":
        case "safe":
          return x;
      }
      if ((0, h.isHexString)(x))
        return (0, h.isHexString)(x, 32) ? x : (0, h.toQuantity)(x);
      if (typeof x == "bigint" && (x = (0, h.getNumber)(x, "blockTag")), typeof x == "number")
        return x >= 0 ? (0, h.toQuantity)(x) : oe(this, f) >= 0 ? (0, h.toQuantity)(oe(this, f) + x) : this.getBlockNumber().then((_) => (0, h.toQuantity)(_ + x));
      (0, h.assertArgument)(!1, "invalid blockTag", "blockTag", x);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */
    _getFilter(x) {
      const _ = (x.topics || []).map((be) => be == null ? null : Array.isArray(be) ? ce(be.map((Me) => Me.toLowerCase())) : be.toLowerCase()), q = "blockHash" in x ? x.blockHash : void 0, ne = (be, Me, Ce) => {
        let je;
        switch (be.length) {
          case 0:
            break;
          case 1:
            je = be[0];
            break;
          default:
            be.sort(), je = be;
        }
        if (q && (Me != null || Ce != null))
          throw new Error("invalid filter");
        const Ue = {};
        return je && (Ue.address = je), _.length && (Ue.topics = _), Me && (Ue.fromBlock = Me), Ce && (Ue.toBlock = Ce), q && (Ue.blockHash = q), Ue;
      };
      let de = [];
      if (x.address)
        if (Array.isArray(x.address))
          for (const be of x.address)
            de.push(this._getAddress(be));
        else
          de.push(this._getAddress(x.address));
      let ye;
      "fromBlock" in x && (ye = this._getBlockTag(x.fromBlock));
      let ge;
      return "toBlock" in x && (ge = this._getBlockTag(x.toBlock)), de.filter((be) => typeof be != "string").length || ye != null && typeof ye != "string" || ge != null && typeof ge != "string" ? Promise.all([Promise.all(de), ye, ge]).then((be) => ne(be[0], be[1], be[2])) : ne(de, ye, ge);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */
    _getTransactionRequest(x) {
      const _ = (0, w.copyRequest)(x), q = [];
      if (["to", "from"].forEach((ne) => {
        if (_[ne] == null)
          return;
        const de = (0, V.resolveAddress)(_[ne], this);
        W(de) ? q.push(async function() {
          _[ne] = await de;
        }()) : _[ne] = de;
      }), _.blockTag != null) {
        const ne = this._getBlockTag(_.blockTag);
        W(ne) ? q.push(async function() {
          _.blockTag = await ne;
        }()) : _.blockTag = ne;
      }
      return q.length ? async function() {
        return await Promise.all(q), _;
      }() : _;
    }
    async getNetwork() {
      if (oe(this, s) == null) {
        const ne = (async () => {
          try {
            const de = await this._detectNetwork();
            return this.emit("network", de, null), de;
          } catch (de) {
            throw oe(this, s) === ne && Oe(this, s, null), de;
          }
        })();
        return Oe(this, s, ne), (await ne).clone();
      }
      const x = oe(this, s), [_, q] = await Promise.all([
        x,
        this._detectNetwork()
        // The actual connected network
      ]);
      return _.chainId !== q.chainId && (oe(this, i) ? (this.emit("network", q, _), oe(this, s) === x && Oe(this, s, Promise.resolve(q))) : (0, h.assert)(!1, `network changed: ${_.chainId} => ${q.chainId} `, "NETWORK_ERROR", {
        event: "changed"
      })), _.clone();
    }
    async getFeeData() {
      const x = await this.getNetwork(), _ = async () => {
        const { _block: ne, gasPrice: de, priorityFee: ye } = await (0, h.resolveProperties)({
          _block: Ve(this, A, R).call(this, "latest", !1),
          gasPrice: (async () => {
            try {
              const Ce = await Ve(this, v, O).call(this, { method: "getGasPrice" });
              return (0, h.getBigInt)(Ce, "%response");
            } catch {
            }
            return null;
          })(),
          priorityFee: (async () => {
            try {
              const Ce = await Ve(this, v, O).call(this, { method: "getPriorityFee" });
              return (0, h.getBigInt)(Ce, "%response");
            } catch {
            }
            return null;
          })()
        });
        let ge = null, be = null;
        const Me = this._wrapBlock(ne, x);
        return Me && Me.baseFeePerGas && (be = ye ?? BigInt("1000000000"), ge = Me.baseFeePerGas * l + be), new w.FeeData(de, ge, be);
      }, q = x.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
      if (q) {
        const ne = new h.FetchRequest(q.url), de = await q.processFunc(_, this, ne);
        return new w.FeeData(de.gasPrice, de.maxFeePerGas, de.maxPriorityFeePerGas);
      }
      return await _();
    }
    async estimateGas(x) {
      let _ = this._getTransactionRequest(x);
      return W(_) && (_ = await _), (0, h.getBigInt)(await Ve(this, v, O).call(this, {
        method: "estimateGas",
        transaction: _
      }), "%response");
    }
    async call(x) {
      const { tx: _, blockTag: q } = await (0, h.resolveProperties)({
        tx: this._getTransactionRequest(x),
        blockTag: this._getBlockTag(x.blockTag)
      });
      return await Ve(this, j, B).call(this, Ve(this, N, S).call(this, _, q, x.enableCcipRead ? 0 : -1));
    }
    async getBalance(x, _) {
      return (0, h.getBigInt)(await Ve(this, M, I).call(this, { method: "getBalance" }, x, _), "%response");
    }
    async getTransactionCount(x, _) {
      return (0, h.getNumber)(await Ve(this, M, I).call(this, { method: "getTransactionCount" }, x, _), "%response");
    }
    async getCode(x, _) {
      return (0, h.hexlify)(await Ve(this, M, I).call(this, { method: "getCode" }, x, _));
    }
    async getStorage(x, _, q) {
      const ne = (0, h.getBigInt)(_, "position");
      return (0, h.hexlify)(await Ve(this, M, I).call(this, { method: "getStorage", position: ne }, x, q));
    }
    // Write
    async broadcastTransaction(x) {
      const { blockNumber: _, hash: q, network: ne } = await (0, h.resolveProperties)({
        blockNumber: this.getBlockNumber(),
        hash: this._perform({
          method: "broadcastTransaction",
          signedTransaction: x
        }),
        network: this.getNetwork()
      }), de = u.Transaction.from(x);
      if (de.hash !== q)
        throw new Error("@TODO: the returned hash did not match");
      return this._wrapTransactionResponse(de, ne).replaceableTransaction(_);
    }
    // Queries
    async getBlock(x, _) {
      const { network: q, params: ne } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        params: Ve(this, A, R).call(this, x, !!_)
      });
      return ne == null ? null : this._wrapBlock(ne, q);
    }
    async getTransaction(x) {
      const { network: _, params: q } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        params: Ve(this, v, O).call(this, { method: "getTransaction", hash: x })
      });
      return q == null ? null : this._wrapTransactionResponse(q, _);
    }
    async getTransactionReceipt(x) {
      const { network: _, params: q } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        params: Ve(this, v, O).call(this, { method: "getTransactionReceipt", hash: x })
      });
      if (q == null)
        return null;
      if (q.gasPrice == null && q.effectiveGasPrice == null) {
        const ne = await Ve(this, v, O).call(this, { method: "getTransaction", hash: x });
        if (ne == null)
          throw new Error("report this; could not find tx or effectiveGasPrice");
        q.effectiveGasPrice = ne.gasPrice;
      }
      return this._wrapTransactionReceipt(q, _);
    }
    async getTransactionResult(x) {
      const { result: _ } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        result: Ve(this, v, O).call(this, { method: "getTransactionResult", hash: x })
      });
      return _ == null ? null : (0, h.hexlify)(_);
    }
    // Bloom-filter Queries
    async getLogs(x) {
      let _ = this._getFilter(x);
      W(_) && (_ = await _);
      const { network: q, params: ne } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        params: Ve(this, v, O).call(this, { method: "getLogs", filter: _ })
      });
      return ne.map((de) => this._wrapLog(de, q));
    }
    // ENS
    _getProvider(x) {
      (0, h.assert)(!1, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
        operation: "_getProvider()"
      });
    }
    async getResolver(x) {
      return await y.EnsResolver.fromName(this, x);
    }
    async getAvatar(x) {
      const _ = await this.getResolver(x);
      return _ ? await _.getAvatar() : null;
    }
    async resolveName(x) {
      const _ = await this.getResolver(x);
      return _ ? await _.getAddress() : null;
    }
    async lookupAddress(x) {
      x = (0, V.getAddress)(x);
      const _ = (0, o.namehash)(x.substring(2).toLowerCase() + ".addr.reverse");
      try {
        const q = await y.EnsResolver.getEnsAddress(this), ne = await new D.Contract(q, [
          "function resolver(bytes32) view returns (address)"
        ], this).resolver(_);
        if (ne == null || ne === C.ZeroAddress)
          return null;
        const de = await new D.Contract(ne, [
          "function name(bytes32) view returns (string)"
        ], this).name(_);
        return await this.resolveName(de) !== x ? null : de;
      } catch (q) {
        if ((0, h.isError)(q, "BAD_DATA") && q.value === "0x" || (0, h.isError)(q, "CALL_EXCEPTION"))
          return null;
        throw q;
      }
      return null;
    }
    async waitForTransaction(x, _, q) {
      const ne = _ ?? 1;
      return ne === 0 ? this.getTransactionReceipt(x) : new Promise(async (de, ye) => {
        let ge = null;
        const be = async (Me) => {
          try {
            const Ce = await this.getTransactionReceipt(x);
            if (Ce != null && Me - Ce.blockNumber + 1 >= ne) {
              de(Ce), ge && (clearTimeout(ge), ge = null);
              return;
            }
          } catch (Ce) {
            console.log("EEE", Ce);
          }
          this.once("block", be);
        };
        q != null && (ge = setTimeout(() => {
          ge != null && (ge = null, this.off("block", be), ye((0, h.makeError)("timeout", "TIMEOUT", { reason: "timeout" })));
        }, q)), be(await this.getBlockNumber());
      });
    }
    async waitForBlock(x) {
      (0, h.assert)(!1, "not implemented yet", "NOT_IMPLEMENTED", {
        operation: "waitForBlock"
      });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */
    _clearTimeout(x) {
      const _ = oe(this, c).get(x);
      _ && (_.timer && clearTimeout(_.timer), oe(this, c).delete(x));
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */
    _setTimeout(x, _) {
      _ == null && (_ = 0);
      const q = q0(this, d)._++, ne = () => {
        oe(this, c).delete(q), x();
      };
      if (this.paused)
        oe(this, c).set(q, { timer: null, func: ne, time: _ });
      else {
        const de = setTimeout(ne, _);
        oe(this, c).set(q, { timer: de, func: ne, time: ve() });
      }
      return q;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */
    _forEachSubscriber(x) {
      for (const _ of oe(this, e).values())
        x(_.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */
    _getSubscriber(x) {
      switch (x.type) {
        case "debug":
        case "error":
        case "network":
          return new G(x.type);
        case "block": {
          const _ = new m.PollingBlockSubscriber(this);
          return _.pollingInterval = this.pollingInterval, _;
        }
        case "safe":
        case "finalized":
          return new m.PollingBlockTagSubscriber(this, x.type);
        case "event":
          return new m.PollingEventSubscriber(this, x.filter);
        case "transaction":
          return new m.PollingTransactionSubscriber(this, x.hash);
        case "orphan":
          return new m.PollingOrphanSubscriber(this, x.filter);
      }
      throw new Error(`unsupported event: ${x.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */
    _recoverSubscriber(x, _) {
      for (const q of oe(this, e).values())
        if (q.subscriber === x) {
          q.started && q.subscriber.stop(), q.subscriber = _, q.started && _.start(), oe(this, r) != null && _.pause(oe(this, r));
          break;
        }
    }
    async on(x, _) {
      const q = await Ve(this, $, k).call(this, x);
      return q.listeners.push({ listener: _, once: !1 }), q.started || (q.subscriber.start(), q.started = !0, oe(this, r) != null && q.subscriber.pause(oe(this, r))), this;
    }
    async once(x, _) {
      const q = await Ve(this, $, k).call(this, x);
      return q.listeners.push({ listener: _, once: !0 }), q.started || (q.subscriber.start(), q.started = !0, oe(this, r) != null && q.subscriber.pause(oe(this, r))), this;
    }
    async emit(x, ..._) {
      const q = await Ve(this, L, K).call(this, x, _);
      if (!q || q.listeners.length === 0)
        return !1;
      const ne = q.listeners.length;
      return q.listeners = q.listeners.filter(({ listener: de, once: ye }) => {
        const ge = new h.EventPayload(this, ye ? null : de, x);
        try {
          de.call(this, ..._, ge);
        } catch {
        }
        return !ye;
      }), q.listeners.length === 0 && (q.started && q.subscriber.stop(), oe(this, e).delete(q.tag)), ne > 0;
    }
    async listenerCount(x) {
      if (x) {
        const q = await Ve(this, L, K).call(this, x);
        return q ? q.listeners.length : 0;
      }
      let _ = 0;
      for (const { listeners: q } of oe(this, e).values())
        _ += q.length;
      return _;
    }
    async listeners(x) {
      if (x) {
        const q = await Ve(this, L, K).call(this, x);
        return q ? q.listeners.map(({ listener: ne }) => ne) : [];
      }
      let _ = [];
      for (const { listeners: q } of oe(this, e).values())
        _ = _.concat(q.map(({ listener: ne }) => ne));
      return _;
    }
    async off(x, _) {
      const q = await Ve(this, L, K).call(this, x);
      if (!q)
        return this;
      if (_) {
        const ne = q.listeners.map(({ listener: de }) => de).indexOf(_);
        ne >= 0 && q.listeners.splice(ne, 1);
      }
      return (!_ || q.listeners.length === 0) && (q.started && q.subscriber.stop(), oe(this, e).delete(q.tag)), this;
    }
    async removeAllListeners(x) {
      if (x) {
        const { tag: _, started: q, subscriber: ne } = await Ve(this, $, k).call(this, x);
        q && ne.stop(), oe(this, e).delete(_);
      } else
        for (const [_, { started: q, subscriber: ne }] of oe(this, e))
          q && ne.stop(), oe(this, e).delete(_);
      return this;
    }
    // Alias for "on"
    async addListener(x, _) {
      return await this.on(x, _);
    }
    // Alias for "off"
    async removeListener(x, _) {
      return this.off(x, _);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */
    get destroyed() {
      return oe(this, n);
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */
    destroy() {
      this.removeAllListeners();
      for (const x of oe(this, c).keys())
        this._clearTimeout(x);
      Oe(this, n, !0);
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */
    get paused() {
      return oe(this, r) != null;
    }
    set paused(x) {
      !!x !== this.paused && (this.paused ? this.resume() : this.pause(!1));
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */
    pause(x) {
      if (Oe(this, f, -1), oe(this, r) != null) {
        if (oe(this, r) == !!x)
          return;
        (0, h.assert)(!1, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
          operation: "pause"
        });
      }
      this._forEachSubscriber((_) => _.pause(x)), Oe(this, r, !!x);
      for (const _ of oe(this, c).values())
        _.timer && clearTimeout(_.timer), _.time = ve() - _.time;
    }
    /**
     *  Resume the provider.
     */
    resume() {
      if (oe(this, r) != null) {
        this._forEachSubscriber((x) => x.resume()), Oe(this, r, null);
        for (const x of oe(this, c).values()) {
          let _ = x.time;
          _ < 0 && (_ = 0), x.time = ve(), setTimeout(x.func, _);
        }
      }
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakSet(), O = async function(fe) {
    const x = oe(this, g).cacheTimeout;
    if (x < 0)
      return await this._perform(fe);
    const _ = X(fe.method, fe);
    let q = oe(this, a).get(_);
    return q || (q = this._perform(fe), oe(this, a).set(_, q), setTimeout(() => {
      oe(this, a).get(_) === q && oe(this, a).delete(_);
    }, x)), await q;
  }, N = /* @__PURE__ */ new WeakSet(), S = async function(fe, x, _) {
    (0, h.assert)(_ < b, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
      reason: "TOO_MANY_REDIRECTS",
      transaction: Object.assign({}, fe, { blockTag: x, enableCcipRead: !0 })
    });
    const q = (0, w.copyRequest)(fe);
    try {
      return (0, h.hexlify)(await this._perform({ method: "call", transaction: q, blockTag: x }));
    } catch (ne) {
      if (!this.disableCcipRead && (0, h.isCallException)(ne) && ne.data && _ >= 0 && x === "latest" && q.to != null && (0, h.dataSlice)(ne.data, 0, 4) === "0x556f1830") {
        const de = ne.data, ye = await (0, V.resolveAddress)(q.to, this);
        let ge;
        try {
          ge = Re((0, h.dataSlice)(ne.data, 4));
        } catch (Ce) {
          (0, h.assert)(!1, Ce.message, "OFFCHAIN_FAULT", {
            reason: "BAD_DATA",
            transaction: q,
            info: { data: de }
          });
        }
        (0, h.assert)(ge.sender.toLowerCase() === ye.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
          action: "call",
          data: de,
          reason: "OffchainLookup",
          transaction: q,
          invocation: null,
          revert: {
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            name: "OffchainLookup",
            args: ge.errorArgs
          }
        });
        const be = await this.ccipReadFetch(q, ge.calldata, ge.urls);
        (0, h.assert)(be != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
          reason: "FETCH_FAILED",
          transaction: q,
          info: { data: ne.data, errorArgs: ge.errorArgs }
        });
        const Me = {
          to: ye,
          data: (0, h.concat)([ge.selector, we([be, ge.extraData])])
        };
        this.emit("debug", { action: "sendCcipReadCall", transaction: Me });
        try {
          const Ce = await Ve(this, N, S).call(this, Me, x, _ + 1);
          return this.emit("debug", { action: "receiveCcipReadCallResult", transaction: Object.assign({}, Me), result: Ce }), Ce;
        } catch (Ce) {
          throw this.emit("debug", { action: "receiveCcipReadCallError", transaction: Object.assign({}, Me), error: Ce }), Ce;
        }
      }
      throw ne;
    }
  }, j = /* @__PURE__ */ new WeakSet(), B = async function(fe) {
    const { value: x } = await (0, h.resolveProperties)({
      network: this.getNetwork(),
      value: fe
    });
    return x;
  }, M = /* @__PURE__ */ new WeakSet(), I = async function(fe, x, _) {
    let q = this._getAddress(x), ne = this._getBlockTag(_);
    return (typeof q != "string" || typeof ne != "string") && ([q, ne] = await Promise.all([q, ne])), await Ve(this, j, B).call(this, Ve(this, v, O).call(this, Object.assign(fe, { address: q, blockTag: ne })));
  }, A = /* @__PURE__ */ new WeakSet(), R = async function(fe, x) {
    if ((0, h.isHexString)(fe, 32))
      return await Ve(this, v, O).call(this, {
        method: "getBlock",
        blockHash: fe,
        includeTransactions: x
      });
    let _ = this._getBlockTag(fe);
    return typeof _ != "string" && (_ = await _), await Ve(this, v, O).call(this, {
      method: "getBlock",
      blockTag: _,
      includeTransactions: x
    });
  }, L = /* @__PURE__ */ new WeakSet(), K = async function(fe, x) {
    let _ = await pe(fe, this);
    return _.type === "event" && x && x.length > 0 && x[0].removed === !0 && (_ = await pe({ orphan: "drop-log", log: x[0] }, this)), oe(this, e).get(_.tag) || null;
  }, $ = /* @__PURE__ */ new WeakSet(), k = async function(fe) {
    const x = await pe(fe, this), _ = x.tag;
    let q = oe(this, e).get(_);
    return q || (q = { subscriber: this._getSubscriber(x), tag: _, addressableMap: /* @__PURE__ */ new WeakMap(), nameMap: /* @__PURE__ */ new Map(), started: !1, listeners: [] }, oe(this, e).set(_, q)), q;
  }, na.AbstractProvider = Pe;
  function xe(fe, x) {
    try {
      const _ = me(fe, x);
      if (_)
        return (0, h.toUtf8String)(_);
    } catch {
    }
    return null;
  }
  function me(fe, x) {
    if (fe === "0x")
      return null;
    try {
      const _ = (0, h.getNumber)((0, h.dataSlice)(fe, x, x + 32)), q = (0, h.getNumber)((0, h.dataSlice)(fe, _, _ + 32));
      return (0, h.dataSlice)(fe, _ + 32, _ + 32 + q);
    } catch {
    }
    return null;
  }
  function te(fe) {
    const x = (0, h.toBeArray)(fe);
    if (x.length > 32)
      throw new Error("internal; should not happen");
    const _ = new Uint8Array(32);
    return _.set(x, 32 - x.length), _;
  }
  function U(fe) {
    if (fe.length % 32 === 0)
      return fe;
    const x = new Uint8Array(Math.ceil(fe.length / 32) * 32);
    return x.set(fe), x;
  }
  const ue = new Uint8Array([]);
  function we(fe) {
    const x = [];
    let _ = 0;
    for (let q = 0; q < fe.length; q++)
      x.push(ue), _ += 32;
    for (let q = 0; q < fe.length; q++) {
      const ne = (0, h.getBytes)(fe[q]);
      x[q] = te(_), x.push(te(ne.length)), x.push(U(ne)), _ += 32 + Math.ceil(ne.length / 32) * 32;
    }
    return (0, h.concat)(x);
  }
  const ke = "0x0000000000000000000000000000000000000000000000000000000000000000";
  function Re(fe) {
    const x = {
      sender: "",
      urls: [],
      calldata: "",
      selector: "",
      extraData: "",
      errorArgs: []
    };
    (0, h.assert)((0, h.dataLength)(fe) >= 5 * 32, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
      reason: "insufficient OffchainLookup data"
    });
    const _ = (0, h.dataSlice)(fe, 0, 32);
    (0, h.assert)((0, h.dataSlice)(_, 0, 12) === (0, h.dataSlice)(ke, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup sender"
    }), x.sender = (0, h.dataSlice)(_, 12);
    try {
      const q = [], ne = (0, h.getNumber)((0, h.dataSlice)(fe, 32, 64)), de = (0, h.getNumber)((0, h.dataSlice)(fe, ne, ne + 32)), ye = (0, h.dataSlice)(fe, ne + 32);
      for (let ge = 0; ge < de; ge++) {
        const be = xe(ye, ge * 32);
        if (be == null)
          throw new Error("abort");
        q.push(be);
      }
      x.urls = q;
    } catch {
      (0, h.assert)(!1, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup urls"
      });
    }
    try {
      const q = me(fe, 64);
      if (q == null)
        throw new Error("abort");
      x.calldata = q;
    } catch {
      (0, h.assert)(!1, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup calldata"
      });
    }
    (0, h.assert)((0, h.dataSlice)(fe, 100, 128) === (0, h.dataSlice)(ke, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup callbaackSelector"
    }), x.selector = (0, h.dataSlice)(fe, 96, 100);
    try {
      const q = me(fe, 128);
      if (q == null)
        throw new Error("abort");
      x.extraData = q;
    } catch {
      (0, h.assert)(!1, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup extraData"
      });
    }
    return x.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((q) => x[q]), x;
  }
  return na;
}
var ia = {}, L2;
function k1() {
  var e, t;
  if (L2)
    return ia;
  L2 = 1, Object.defineProperty(ia, "__esModule", { value: !0 }), ia.VoidSigner = ia.AbstractSigner = void 0;
  const r = Yr(), n = Yn(), s = wt(), i = md();
  function a(g, v) {
    if (g.provider)
      return g.provider;
    (0, s.assert)(!1, "missing provider", "UNSUPPORTED_OPERATION", { operation: v });
  }
  async function f(g, v) {
    let O = (0, i.copyRequest)(v);
    if (O.to != null && (O.to = (0, r.resolveAddress)(O.to, g)), O.from != null) {
      const N = O.from;
      O.from = Promise.all([
        g.getAddress(),
        (0, r.resolveAddress)(N, g)
      ]).then(([S, j]) => ((0, s.assertArgument)(S.toLowerCase() === j.toLowerCase(), "transaction from mismatch", "tx.from", j), S));
    } else
      O.from = g.getAddress();
    return await (0, s.resolveProperties)(O);
  }
  class d {
    /**
     *  Creates a new Signer connected to %%provider%%.
     */
    constructor(v) {
      Be(this, "provider"), (0, s.defineProperties)(this, { provider: v || null });
    }
    async getNonce(v) {
      return a(this, "getTransactionCount").getTransactionCount(await this.getAddress(), v);
    }
    async populateCall(v) {
      return await f(this, v);
    }
    async populateTransaction(v) {
      const O = a(this, "populateTransaction"), N = await f(this, v);
      N.nonce == null && (N.nonce = await this.getNonce("pending")), N.gasLimit == null && (N.gasLimit = await this.estimateGas(N));
      const S = await this.provider.getNetwork();
      if (N.chainId != null) {
        const B = (0, s.getBigInt)(N.chainId);
        (0, s.assertArgument)(B === S.chainId, "transaction chainId mismatch", "tx.chainId", v.chainId);
      } else
        N.chainId = S.chainId;
      const j = N.maxFeePerGas != null || N.maxPriorityFeePerGas != null;
      if (N.gasPrice != null && (N.type === 2 || j) ? (0, s.assertArgument)(!1, "eip-1559 transaction do not support gasPrice", "tx", v) : (N.type === 0 || N.type === 1) && j && (0, s.assertArgument)(!1, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", v), (N.type === 2 || N.type == null) && N.maxFeePerGas != null && N.maxPriorityFeePerGas != null)
        N.type = 2;
      else if (N.type === 0 || N.type === 1) {
        const B = await O.getFeeData();
        (0, s.assert)(B.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
          operation: "getGasPrice"
        }), N.gasPrice == null && (N.gasPrice = B.gasPrice);
      } else {
        const B = await O.getFeeData();
        if (N.type == null)
          if (B.maxFeePerGas != null && B.maxPriorityFeePerGas != null)
            if (N.type = 2, N.gasPrice != null) {
              const M = N.gasPrice;
              delete N.gasPrice, N.maxFeePerGas = M, N.maxPriorityFeePerGas = M;
            } else
              N.maxFeePerGas == null && (N.maxFeePerGas = B.maxFeePerGas), N.maxPriorityFeePerGas == null && (N.maxPriorityFeePerGas = B.maxPriorityFeePerGas);
          else
            B.gasPrice != null ? ((0, s.assert)(!j, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
              operation: "populateTransaction"
            }), N.gasPrice == null && (N.gasPrice = B.gasPrice), N.type = 0) : (0, s.assert)(!1, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
              operation: "signer.getFeeData"
            });
        else
          (N.type === 2 || N.type === 3) && (N.maxFeePerGas == null && (N.maxFeePerGas = B.maxFeePerGas), N.maxPriorityFeePerGas == null && (N.maxPriorityFeePerGas = B.maxPriorityFeePerGas));
      }
      return await (0, s.resolveProperties)(N);
    }
    async estimateGas(v) {
      return a(this, "estimateGas").estimateGas(await this.populateCall(v));
    }
    async call(v) {
      return a(this, "call").call(await this.populateCall(v));
    }
    async resolveName(v) {
      return await a(this, "resolveName").resolveName(v);
    }
    async sendTransaction(v) {
      const O = a(this, "sendTransaction"), N = await this.populateTransaction(v);
      delete N.from;
      const S = n.Transaction.from(N);
      return await O.broadcastTransaction(await this.signTransaction(S));
    }
  }
  ia.AbstractSigner = d;
  const c = class K5 extends d {
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */
    constructor(v, O) {
      super(O), _e(this, e), Be(this, "address"), (0, s.defineProperties)(this, { address: v });
    }
    async getAddress() {
      return this.address;
    }
    connect(v) {
      return new K5(this.address, v);
    }
    async signTransaction(v) {
      Ve(this, e, t).call(this, "transactions", "signTransaction");
    }
    async signMessage(v) {
      Ve(this, e, t).call(this, "messages", "signMessage");
    }
    async signTypedData(v, O, N) {
      Ve(this, e, t).call(this, "typed-data", "signTypedData");
    }
  };
  e = /* @__PURE__ */ new WeakSet(), t = function(g, v) {
    (0, s.assert)(!1, `VoidSigner cannot sign ${g}`, "UNSUPPORTED_OPERATION", { operation: v });
  };
  let p = c;
  return ia.VoidSigner = p, ia;
}
var Lc = {}, H2;
function Bo() {
  if (H2)
    return Lc;
  H2 = 1, Object.defineProperty(Lc, "__esModule", { value: !0 }), Lc.showThrottleMessage = void 0;
  const e = /* @__PURE__ */ new Set();
  function t(r) {
    e.has(r) || (e.add(r), console.log("========= NOTICE ========="), console.log(`Request-Rate Exceeded for ${r} (this message will not be repeated)`), console.log(""), console.log("The default API keys for each service are provided as a highly-throttled,"), console.log("community resource for low-traffic projects and early prototyping."), console.log(""), console.log("While your application will continue to function, we highly recommended"), console.log("signing up for your own API keys to improve performance, increase your"), console.log("request rate/limit and enable other perks, such as metrics and advanced APIs."), console.log(""), console.log("For more details: https://docs.ethers.org/api-keys/"), console.log("=========================="));
  }
  return Lc.showThrottleMessage = t, Lc;
}
var Hc = {}, Wc = {}, Pi = {}, Ss = {}, W2;
function rk() {
  var e, t, r, n, s, i, a, f, d, c, p;
  if (W2)
    return Ss;
  W2 = 1, Object.defineProperty(Ss, "__esModule", { value: !0 }), Ss.FilterIdPendingSubscriber = Ss.FilterIdEventSubscriber = Ss.FilterIdSubscriber = void 0;
  const g = wt(), v = T1();
  function O(B) {
    return JSON.parse(JSON.stringify(B));
  }
  class N {
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */
    constructor(M) {
      _e(this, a), _e(this, d), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), _e(this, n, void 0), _e(this, s, void 0), _e(this, i, void 0), Oe(this, e, M), Oe(this, t, null), Oe(this, r, Ve(this, a, f).bind(this)), Oe(this, n, !1), Oe(this, s, null), Oe(this, i, !1);
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */
    _subscribe(M) {
      throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */
    _emitResults(M, I) {
      throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */
    _recover(M) {
      throw new Error("subclasses must override this");
    }
    start() {
      oe(this, n) || (Oe(this, n, !0), Ve(this, a, f).call(this, -2));
    }
    stop() {
      oe(this, n) && (Oe(this, n, !1), Oe(this, i, !0), Ve(this, d, c).call(this), oe(this, e).off("block", oe(this, r)));
    }
    pause(M) {
      M && Ve(this, d, c).call(this), oe(this, e).off("block", oe(this, r));
    }
    resume() {
      this.start();
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakSet(), f = async function(B) {
    try {
      oe(this, t) == null && Oe(this, t, this._subscribe(oe(this, e)));
      let M = null;
      try {
        M = await oe(this, t);
      } catch (R) {
        if (!(0, g.isError)(R, "UNSUPPORTED_OPERATION") || R.operation !== "eth_newFilter")
          throw R;
      }
      if (M == null) {
        Oe(this, t, null), oe(this, e)._recoverSubscriber(this, this._recover(oe(this, e)));
        return;
      }
      const I = await oe(this, e).getNetwork();
      if (oe(this, s) || Oe(this, s, I), oe(this, s).chainId !== I.chainId)
        throw new Error("chaid changed");
      if (oe(this, i))
        return;
      const A = await oe(this, e).send("eth_getFilterChanges", [M]);
      await this._emitResults(oe(this, e), A);
    } catch (M) {
      console.log("@TODO", M);
    }
    oe(this, e).once("block", oe(this, r));
  }, d = /* @__PURE__ */ new WeakSet(), c = function() {
    const B = oe(this, t);
    B && (Oe(this, t, null), B.then((M) => {
      oe(this, e).destroyed || oe(this, e).send("eth_uninstallFilter", [M]);
    }));
  }, Ss.FilterIdSubscriber = N;
  class S extends N {
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */
    constructor(M, I) {
      super(M), _e(this, p, void 0), Oe(this, p, O(I));
    }
    _recover(M) {
      return new v.PollingEventSubscriber(M, oe(this, p));
    }
    async _subscribe(M) {
      return await M.send("eth_newFilter", [oe(this, p)]);
    }
    async _emitResults(M, I) {
      for (const A of I)
        M.emit(oe(this, p), M._wrapLog(A, M._network));
    }
  }
  p = /* @__PURE__ */ new WeakMap(), Ss.FilterIdEventSubscriber = S;
  class j extends N {
    async _subscribe(M) {
      return await M.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(M, I) {
      for (const A of I)
        M.emit("pending", A);
    }
  }
  return Ss.FilterIdPendingSubscriber = j, Ss;
}
var G2;
function Qi() {
  var e, t, r, n, s, i, a, f, d, c, p;
  if (G2)
    return Pi;
  G2 = 1, Object.defineProperty(Pi, "__esModule", { value: !0 }), Pi.JsonRpcProvider = Pi.JsonRpcApiPollingProvider = Pi.JsonRpcApiProvider = Pi.JsonRpcSigner = void 0;
  const g = gd(), v = Yr(), O = no(), N = Yn(), S = wt(), j = yd(), B = k1(), M = Xn(), I = rk(), A = T1(), R = "bigint,boolean,function,number,string,symbol".split(/,/g);
  function L(P) {
    if (P == null || R.indexOf(typeof P) >= 0 || typeof P.getAddress == "function")
      return P;
    if (Array.isArray(P))
      return P.map(L);
    if (typeof P == "object")
      return Object.keys(P).reduce((w, m) => (w[m] = P[m], w), {});
    throw new Error(`should not happen: ${P} (${typeof P})`);
  }
  function K(P) {
    return new Promise((w) => {
      setTimeout(w, P);
    });
  }
  function $(P) {
    return P && P.toLowerCase();
  }
  function k(P) {
    return P && typeof P.pollingInterval == "number";
  }
  const V = {
    polling: !1,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1 << 20,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4e3
  };
  class C extends B.AbstractSigner {
    constructor(w, m) {
      super(w), Be(this, "address"), m = (0, v.getAddress)(m), (0, S.defineProperties)(this, { address: m });
    }
    connect(w) {
      (0, S.assert)(!1, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
        operation: "signer.connect"
      });
    }
    async getAddress() {
      return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(w) {
      return await this.populateCall(w);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(w) {
      const m = L(w), l = [];
      if (m.from) {
        const W = m.from;
        l.push((async () => {
          const X = await (0, v.resolveAddress)(W, this.provider);
          (0, S.assertArgument)(X != null && X.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", w), m.from = X;
        })());
      } else
        m.from = this.address;
      if (m.gasLimit == null && l.push((async () => {
        m.gasLimit = await this.provider.estimateGas({ ...m, from: this.address });
      })()), m.to != null) {
        const W = m.to;
        l.push((async () => {
          m.to = await (0, v.resolveAddress)(W, this.provider);
        })());
      }
      l.length && await Promise.all(l);
      const b = this.provider.getRpcTransaction(m);
      return this.provider.send("eth_sendTransaction", [b]);
    }
    async sendTransaction(w) {
      const m = await this.provider.getBlockNumber(), l = await this.sendUncheckedTransaction(w);
      return await new Promise((b, W) => {
        const X = [1e3, 100];
        let G = 0;
        const re = async () => {
          try {
            const ce = await this.provider.getTransaction(l);
            if (ce != null) {
              b(ce.replaceableTransaction(m));
              return;
            }
          } catch (ce) {
            if ((0, S.isError)(ce, "CANCELLED") || (0, S.isError)(ce, "BAD_DATA") || (0, S.isError)(ce, "NETWORK_ERROR")) {
              ce.info == null && (ce.info = {}), ce.info.sendTransactionHash = l, W(ce);
              return;
            }
            if ((0, S.isError)(ce, "INVALID_ARGUMENT") && (G++, ce.info == null && (ce.info = {}), ce.info.sendTransactionHash = l, G > 10)) {
              W(ce);
              return;
            }
            this.provider.emit("error", (0, S.makeError)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", { error: ce }));
          }
          this.provider._setTimeout(() => {
            re();
          }, X.pop() || 4e3);
        };
        re();
      });
    }
    async signTransaction(w) {
      const m = L(w);
      if (m.from) {
        const b = await (0, v.resolveAddress)(m.from, this.provider);
        (0, S.assertArgument)(b != null && b.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", w), m.from = b;
      } else
        m.from = this.address;
      const l = this.provider.getRpcTransaction(m);
      return await this.provider.send("eth_signTransaction", [l]);
    }
    async signMessage(w) {
      const m = typeof w == "string" ? (0, S.toUtf8Bytes)(w) : w;
      return await this.provider.send("personal_sign", [
        (0, S.hexlify)(m),
        this.address.toLowerCase()
      ]);
    }
    async signTypedData(w, m, l) {
      const b = L(l), W = await O.TypedDataEncoder.resolveNames(w, m, b, async (X) => {
        const G = await (0, v.resolveAddress)(X);
        return (0, S.assertArgument)(G != null, "TypedData does not support null address", "value", X), G;
      });
      return await this.provider.send("eth_signTypedData_v4", [
        this.address.toLowerCase(),
        JSON.stringify(O.TypedDataEncoder.getPayload(W.domain, m, W.value))
      ]);
    }
    async unlock(w) {
      return this.provider.send("personal_unlockAccount", [
        this.address.toLowerCase(),
        w,
        null
      ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(w) {
      const m = typeof w == "string" ? (0, S.toUtf8Bytes)(w) : w;
      return await this.provider.send("eth_sign", [
        this.address.toLowerCase(),
        (0, S.hexlify)(m)
      ]);
    }
  }
  Pi.JsonRpcSigner = C;
  class D extends j.AbstractProvider {
    constructor(w, m) {
      super(w, m), _e(this, f), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), _e(this, n, void 0), _e(this, s, void 0), _e(this, i, void 0), _e(this, a, void 0), Oe(this, t, 1), Oe(this, e, Object.assign({}, V, m || {})), Oe(this, r, []), Oe(this, n, null), Oe(this, i, null), Oe(this, a, null);
      {
        let b = null;
        const W = new Promise((X) => {
          b = X;
        });
        Oe(this, s, { promise: W, resolve: b });
      }
      const l = this._getOption("staticNetwork");
      typeof l == "boolean" ? ((0, S.assertArgument)(!l || w !== "any", "staticNetwork cannot be used on special network 'any'", "options", m), l && w != null && Oe(this, i, M.Network.from(w))) : l && ((0, S.assertArgument)(w == null || l.matches(w), "staticNetwork MUST match network object", "options", m), Oe(this, i, l));
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */
    _getOption(w) {
      return oe(this, e)[w];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */
    get _network() {
      return (0, S.assert)(oe(this, i), "network is not available yet", "NETWORK_ERROR"), oe(this, i);
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */
    async _perform(w) {
      if (w.method === "call" || w.method === "estimateGas") {
        let l = w.transaction;
        if (l && l.type != null && (0, S.getBigInt)(l.type) && l.maxFeePerGas == null && l.maxPriorityFeePerGas == null) {
          const b = await this.getFeeData();
          b.maxFeePerGas == null && b.maxPriorityFeePerGas == null && (w = Object.assign({}, w, {
            transaction: Object.assign({}, l, { type: void 0 })
          }));
        }
      }
      const m = this.getRpcRequest(w);
      return m != null ? await this.send(m.method, m.args) : super._perform(w);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */
    async _detectNetwork() {
      const w = this._getOption("staticNetwork");
      if (w)
        if (w === !0) {
          if (oe(this, i))
            return oe(this, i);
        } else
          return w;
      return oe(this, a) ? await oe(this, a) : this.ready ? (Oe(this, a, (async () => {
        try {
          const m = M.Network.from((0, S.getBigInt)(await this.send("eth_chainId", [])));
          return Oe(this, a, null), m;
        } catch (m) {
          throw Oe(this, a, null), m;
        }
      })()), await oe(this, a)) : (Oe(this, a, (async () => {
        const m = {
          id: q0(this, t)._++,
          method: "eth_chainId",
          params: [],
          jsonrpc: "2.0"
        };
        this.emit("debug", { action: "sendRpcPayload", payload: m });
        let l;
        try {
          l = (await this._send(m))[0], Oe(this, a, null);
        } catch (b) {
          throw Oe(this, a, null), this.emit("debug", { action: "receiveRpcError", error: b }), b;
        }
        if (this.emit("debug", { action: "receiveRpcResult", result: l }), "result" in l)
          return M.Network.from((0, S.getBigInt)(l.result));
        throw this.getRpcError(m, l);
      })()), await oe(this, a));
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */
    _start() {
      oe(this, s) == null || oe(this, s).resolve == null || (oe(this, s).resolve(), Oe(this, s, null), (async () => {
        for (; oe(this, i) == null && !this.destroyed; )
          try {
            Oe(this, i, await this._detectNetwork());
          } catch (w) {
            if (this.destroyed)
              break;
            console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)"), this.emit("error", (0, S.makeError)("failed to bootstrap network detection", "NETWORK_ERROR", { event: "initial-network-discovery", info: { error: w } })), await K(1e3);
          }
        Ve(this, f, d).call(this);
      })());
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */
    async _waitUntilReady() {
      if (oe(this, s) != null)
        return await oe(this, s).promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */
    _getSubscriber(w) {
      return w.type === "pending" ? new I.FilterIdPendingSubscriber(this) : w.type === "event" ? this._getOption("polling") ? new A.PollingEventSubscriber(this, w.filter) : new I.FilterIdEventSubscriber(this, w.filter) : w.type === "orphan" && w.filter.orphan === "drop-log" ? new j.UnmanagedSubscriber("orphan") : super._getSubscriber(w);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */
    get ready() {
      return oe(this, s) == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */
    getRpcTransaction(w) {
      const m = {};
      return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach((l) => {
        if (w[l] == null)
          return;
        let b = l;
        l === "gasLimit" && (b = "gas"), m[b] = (0, S.toQuantity)((0, S.getBigInt)(w[l], `tx.${l}`));
      }), ["from", "to", "data"].forEach((l) => {
        w[l] != null && (m[l] = (0, S.hexlify)(w[l]));
      }), w.accessList && (m.accessList = (0, N.accessListify)(w.accessList)), m;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */
    getRpcRequest(w) {
      switch (w.method) {
        case "chainId":
          return { method: "eth_chainId", args: [] };
        case "getBlockNumber":
          return { method: "eth_blockNumber", args: [] };
        case "getGasPrice":
          return { method: "eth_gasPrice", args: [] };
        case "getPriorityFee":
          return { method: "eth_maxPriorityFeePerGas", args: [] };
        case "getBalance":
          return {
            method: "eth_getBalance",
            args: [$(w.address), w.blockTag]
          };
        case "getTransactionCount":
          return {
            method: "eth_getTransactionCount",
            args: [$(w.address), w.blockTag]
          };
        case "getCode":
          return {
            method: "eth_getCode",
            args: [$(w.address), w.blockTag]
          };
        case "getStorage":
          return {
            method: "eth_getStorageAt",
            args: [
              $(w.address),
              "0x" + w.position.toString(16),
              w.blockTag
            ]
          };
        case "broadcastTransaction":
          return {
            method: "eth_sendRawTransaction",
            args: [w.signedTransaction]
          };
        case "getBlock":
          if ("blockTag" in w)
            return {
              method: "eth_getBlockByNumber",
              args: [w.blockTag, !!w.includeTransactions]
            };
          if ("blockHash" in w)
            return {
              method: "eth_getBlockByHash",
              args: [w.blockHash, !!w.includeTransactions]
            };
          break;
        case "getTransaction":
          return {
            method: "eth_getTransactionByHash",
            args: [w.hash]
          };
        case "getTransactionReceipt":
          return {
            method: "eth_getTransactionReceipt",
            args: [w.hash]
          };
        case "call":
          return {
            method: "eth_call",
            args: [this.getRpcTransaction(w.transaction), w.blockTag]
          };
        case "estimateGas":
          return {
            method: "eth_estimateGas",
            args: [this.getRpcTransaction(w.transaction)]
          };
        case "getLogs":
          return w.filter && w.filter.address != null && (Array.isArray(w.filter.address) ? w.filter.address = w.filter.address.map($) : w.filter.address = $(w.filter.address)), { method: "eth_getLogs", args: [w.filter] };
      }
      return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */
    getRpcError(w, m) {
      const { method: l } = w, { error: b } = m;
      if (l === "eth_estimateGas" && b.message) {
        const G = b.message;
        if (!G.match(/revert/i) && G.match(/insufficient funds/i))
          return (0, S.makeError)("insufficient funds", "INSUFFICIENT_FUNDS", {
            transaction: w.params[0],
            info: { payload: w, error: b }
          });
      }
      if (l === "eth_call" || l === "eth_estimateGas") {
        const G = h(b), re = g.AbiCoder.getBuiltinCallException(l === "eth_call" ? "call" : "estimateGas", w.params[0], G ? G.data : null);
        return re.info = { error: b, payload: w }, re;
      }
      const W = JSON.stringify(E(b));
      if (typeof b.message == "string" && b.message.match(/user denied|ethers-user-denied/i)) {
        const G = {
          eth_sign: "signMessage",
          personal_sign: "signMessage",
          eth_signTypedData_v4: "signTypedData",
          eth_signTransaction: "signTransaction",
          eth_sendTransaction: "sendTransaction",
          eth_requestAccounts: "requestAccess",
          wallet_requestAccounts: "requestAccess"
        };
        return (0, S.makeError)("user rejected action", "ACTION_REJECTED", {
          action: G[l] || "unknown",
          reason: "rejected",
          info: { payload: w, error: b }
        });
      }
      if (l === "eth_sendRawTransaction" || l === "eth_sendTransaction") {
        const G = w.params[0];
        if (W.match(/insufficient funds|base fee exceeds gas limit/i))
          return (0, S.makeError)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
            transaction: G,
            info: { error: b }
          });
        if (W.match(/nonce/i) && W.match(/too low/i))
          return (0, S.makeError)("nonce has already been used", "NONCE_EXPIRED", { transaction: G, info: { error: b } });
        if (W.match(/replacement transaction/i) && W.match(/underpriced/i))
          return (0, S.makeError)("replacement fee too low", "REPLACEMENT_UNDERPRICED", { transaction: G, info: { error: b } });
        if (W.match(/only replay-protected/i))
          return (0, S.makeError)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
            operation: l,
            info: { transaction: G, info: { error: b } }
          });
      }
      let X = !!W.match(/the method .* does not exist/i);
      return X || b && b.details && b.details.startsWith("Unauthorized method:") && (X = !0), X ? (0, S.makeError)("unsupported operation", "UNSUPPORTED_OPERATION", {
        operation: w.method,
        info: { error: b, payload: w }
      }) : (0, S.makeError)("could not coalesce error", "UNKNOWN_ERROR", { error: b, payload: w });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */
    send(w, m) {
      if (this.destroyed)
        return Promise.reject((0, S.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: w }));
      const l = q0(this, t)._++, b = new Promise((W, X) => {
        oe(this, r).push({
          resolve: W,
          reject: X,
          payload: { method: w, params: m, id: l, jsonrpc: "2.0" }
        });
      });
      return Ve(this, f, d).call(this), b;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */
    async getSigner(w) {
      w == null && (w = 0);
      const m = this.send("eth_accounts", []);
      if (typeof w == "number") {
        const b = await m;
        if (w >= b.length)
          throw new Error("no such account");
        return new C(this, b[w]);
      }
      const { accounts: l } = await (0, S.resolveProperties)({
        network: this.getNetwork(),
        accounts: m
      });
      w = (0, v.getAddress)(w);
      for (const b of l)
        if ((0, v.getAddress)(b) === w)
          return new C(this, w);
      throw new Error("invalid account");
    }
    async listAccounts() {
      return (await this.send("eth_accounts", [])).map((w) => new C(this, w));
    }
    destroy() {
      oe(this, n) && (clearTimeout(oe(this, n)), Oe(this, n, null));
      for (const { payload: w, reject: m } of oe(this, r))
        m((0, S.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: w.method }));
      Oe(this, r, []), super.destroy();
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakSet(), d = function() {
    if (oe(this, n))
      return;
    const P = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
    Oe(this, n, setTimeout(() => {
      Oe(this, n, null);
      const w = oe(this, r);
      for (Oe(this, r, []); w.length; ) {
        const m = [w.shift()];
        for (; w.length && m.length !== oe(this, e).batchMaxCount; )
          if (m.push(w.shift()), JSON.stringify(m.map((l) => l.payload)).length > oe(this, e).batchMaxSize) {
            w.unshift(m.pop());
            break;
          }
        (async () => {
          const l = m.length === 1 ? m[0].payload : m.map((b) => b.payload);
          this.emit("debug", { action: "sendRpcPayload", payload: l });
          try {
            const b = await this._send(l);
            this.emit("debug", { action: "receiveRpcResult", result: b });
            for (const { resolve: W, reject: X, payload: G } of m) {
              if (this.destroyed) {
                X((0, S.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: G.method }));
                continue;
              }
              const re = b.filter((ce) => ce.id === G.id)[0];
              if (re == null) {
                const ce = (0, S.makeError)("missing response for request", "BAD_DATA", {
                  value: b,
                  info: { payload: G }
                });
                this.emit("error", ce), X(ce);
                continue;
              }
              if ("error" in re) {
                X(this.getRpcError(G, re));
                continue;
              }
              W(re.result);
            }
          } catch (b) {
            this.emit("debug", { action: "receiveRpcError", error: b });
            for (const { reject: W } of m)
              W(b);
          }
        })();
      }
    }, P));
  }, Pi.JsonRpcApiProvider = D;
  class o extends D {
    constructor(w, m) {
      super(w, m), _e(this, c, void 0);
      let l = this._getOption("pollingInterval");
      l == null && (l = V.pollingInterval), Oe(this, c, l);
    }
    _getSubscriber(w) {
      const m = super._getSubscriber(w);
      return k(m) && (m.pollingInterval = oe(this, c)), m;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */
    get pollingInterval() {
      return oe(this, c);
    }
    set pollingInterval(w) {
      if (!Number.isInteger(w) || w < 0)
        throw new Error("invalid interval");
      Oe(this, c, w), this._forEachSubscriber((m) => {
        k(m) && (m.pollingInterval = oe(this, c));
      });
    }
  }
  c = /* @__PURE__ */ new WeakMap(), Pi.JsonRpcApiPollingProvider = o;
  class u extends o {
    constructor(w, m, l) {
      w == null && (w = "http://localhost:8545"), super(m, l), _e(this, p, void 0), typeof w == "string" ? Oe(this, p, new S.FetchRequest(w)) : Oe(this, p, w.clone());
    }
    _getConnection() {
      return oe(this, p).clone();
    }
    async send(w, m) {
      return await this._start(), await super.send(w, m);
    }
    async _send(w) {
      const m = this._getConnection();
      m.body = JSON.stringify(w), m.setHeader("content-type", "application/json");
      const l = await m.send();
      l.assertOk();
      let b = l.bodyJson;
      return Array.isArray(b) || (b = [b]), b;
    }
  }
  p = /* @__PURE__ */ new WeakMap(), Pi.JsonRpcProvider = u;
  function h(P) {
    if (P == null)
      return null;
    if (typeof P.message == "string" && P.message.match(/revert/i) && (0, S.isHexString)(P.data))
      return { message: P.message, data: P.data };
    if (typeof P == "object") {
      for (const w in P) {
        const m = h(P[w]);
        if (m)
          return m;
      }
      return null;
    }
    if (typeof P == "string")
      try {
        return h(JSON.parse(P));
      } catch {
      }
    return null;
  }
  function y(P, w) {
    if (P != null) {
      if (typeof P.message == "string" && w.push(P.message), typeof P == "object")
        for (const m in P)
          y(P[m], w);
      if (typeof P == "string")
        try {
          return y(JSON.parse(P), w);
        } catch {
        }
    }
  }
  function E(P) {
    const w = [];
    return y(P, w), w;
  }
  return Pi;
}
var z2;
function J5() {
  if (z2)
    return Wc;
  z2 = 1, Object.defineProperty(Wc, "__esModule", { value: !0 }), Wc.AnkrProvider = void 0;
  const e = wt(), t = Bo(), r = Xn(), n = Qi(), s = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
  function i(f) {
    switch (f) {
      case "mainnet":
        return "rpc.ankr.com/eth";
      case "goerli":
        return "rpc.ankr.com/eth_goerli";
      case "sepolia":
        return "rpc.ankr.com/eth_sepolia";
      case "arbitrum":
        return "rpc.ankr.com/arbitrum";
      case "base":
        return "rpc.ankr.com/base";
      case "base-goerli":
        return "rpc.ankr.com/base_goerli";
      case "base-sepolia":
        return "rpc.ankr.com/base_sepolia";
      case "bnb":
        return "rpc.ankr.com/bsc";
      case "bnbt":
        return "rpc.ankr.com/bsc_testnet_chapel";
      case "matic":
        return "rpc.ankr.com/polygon";
      case "matic-mumbai":
        return "rpc.ankr.com/polygon_mumbai";
      case "optimism":
        return "rpc.ankr.com/optimism";
      case "optimism-goerli":
        return "rpc.ankr.com/optimism_testnet";
      case "optimism-sepolia":
        return "rpc.ankr.com/optimism_sepolia";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Create a new **AnkrProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */
    constructor(d, c) {
      d == null && (d = "mainnet");
      const p = r.Network.from(d);
      c == null && (c = s);
      const g = { polling: !0, staticNetwork: p }, v = a.getRequest(p, c);
      super(v, p, g), Be(this, "apiKey"), (0, e.defineProperties)(this, { apiKey: c });
    }
    _getProvider(d) {
      try {
        return new a(d, this.apiKey);
      } catch {
      }
      return super._getProvider(d);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%apiKey%%.
     */
    static getRequest(d, c) {
      c == null && (c = s);
      const p = new e.FetchRequest(`https://${i(d.name)}/${c}`);
      return p.allowGzip = !0, c === s && (p.retryFunc = async (g, v, O) => ((0, t.showThrottleMessage)("AnkrProvider"), !0)), p;
    }
    getRpcError(d, c) {
      return d.method === "eth_sendRawTransaction" && c && c.error && c.error.message === "INTERNAL_ERROR: could not replace existing tx" && (c.error.message = "replacement transaction underpriced"), super.getRpcError(d, c);
    }
    isCommunityResource() {
      return this.apiKey === s;
    }
  }
  return Wc.AnkrProvider = a, Wc;
}
var Gc = {}, V2;
function Q5() {
  if (V2)
    return Gc;
  V2 = 1, Object.defineProperty(Gc, "__esModule", { value: !0 }), Gc.AlchemyProvider = void 0;
  const e = wt(), t = Bo(), r = Xn(), n = Qi(), s = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
  function i(f) {
    switch (f) {
      case "mainnet":
        return "eth-mainnet.alchemyapi.io";
      case "goerli":
        return "eth-goerli.g.alchemy.com";
      case "sepolia":
        return "eth-sepolia.g.alchemy.com";
      case "arbitrum":
        return "arb-mainnet.g.alchemy.com";
      case "arbitrum-goerli":
        return "arb-goerli.g.alchemy.com";
      case "arbitrum-sepolia":
        return "arb-sepolia.g.alchemy.com";
      case "base":
        return "base-mainnet.g.alchemy.com";
      case "base-goerli":
        return "base-goerli.g.alchemy.com";
      case "base-sepolia":
        return "base-sepolia.g.alchemy.com";
      case "matic":
        return "polygon-mainnet.g.alchemy.com";
      case "matic-amoy":
        return "polygon-amoy.g.alchemy.com";
      case "matic-mumbai":
        return "polygon-mumbai.g.alchemy.com";
      case "optimism":
        return "opt-mainnet.g.alchemy.com";
      case "optimism-goerli":
        return "opt-goerli.g.alchemy.com";
      case "optimism-sepolia":
        return "opt-sepolia.g.alchemy.com";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    constructor(d, c) {
      d == null && (d = "mainnet");
      const p = r.Network.from(d);
      c == null && (c = s);
      const g = a.getRequest(p, c);
      super(g, p, { staticNetwork: p }), Be(this, "apiKey"), (0, e.defineProperties)(this, { apiKey: c });
    }
    _getProvider(d) {
      try {
        return new a(d, this.apiKey);
      } catch {
      }
      return super._getProvider(d);
    }
    async _perform(d) {
      if (d.method === "getTransactionResult") {
        const { trace: c, tx: p } = await (0, e.resolveProperties)({
          trace: this.send("trace_transaction", [d.hash]),
          tx: this.getTransaction(d.hash)
        });
        if (c == null || p == null)
          return null;
        let g, v = !1;
        try {
          g = c[0].result.output, v = c[0].error === "Reverted";
        } catch {
        }
        if (g)
          return (0, e.assert)(!v, "an error occurred during transaction executions", "CALL_EXCEPTION", {
            action: "getTransactionResult",
            data: g,
            reason: null,
            transaction: p,
            invocation: null,
            revert: null
            // @TODO
          }), g;
        (0, e.assert)(!1, "could not parse trace result", "BAD_DATA", { value: c });
      }
      return await super._perform(d);
    }
    isCommunityResource() {
      return this.apiKey === s;
    }
    static getRequest(d, c) {
      c == null && (c = s);
      const p = new e.FetchRequest(`https://${i(d.name)}/v2/${c}`);
      return p.allowGzip = !0, c === s && (p.retryFunc = async (g, v, O) => ((0, t.showThrottleMessage)("alchemy"), !0)), p;
    }
  }
  return Gc.AlchemyProvider = a, Gc;
}
var zc = {}, q2;
function Z5() {
  if (q2)
    return zc;
  q2 = 1, Object.defineProperty(zc, "__esModule", { value: !0 }), zc.ChainstackProvider = void 0;
  const e = wt(), t = Bo(), r = Xn(), n = Qi();
  function s(f) {
    switch (f) {
      case "mainnet":
        return "39f1d67cedf8b7831010a665328c9197";
      case "arbitrum":
        return "0550c209db33c3abf4cc927e1e18cea1";
      case "bnb":
        return "98b5a77e531614387366f6fc5da097f8";
      case "matic":
        return "cd9d4d70377471aa7c142ec4a4205249";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  function i(f) {
    switch (f) {
      case "mainnet":
        return "ethereum-mainnet.core.chainstack.com";
      case "arbitrum":
        return "arbitrum-mainnet.core.chainstack.com";
      case "bnb":
        return "bsc-mainnet.core.chainstack.com";
      case "matic":
        return "polygon-mainnet.core.chainstack.com";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Creates a new **ChainstackProvider**.
     */
    constructor(d, c) {
      d == null && (d = "mainnet");
      const p = r.Network.from(d);
      c == null && (c = s(p.name));
      const g = a.getRequest(p, c);
      super(g, p, { staticNetwork: p }), Be(this, "apiKey"), (0, e.defineProperties)(this, { apiKey: c });
    }
    _getProvider(d) {
      try {
        return new a(d, this.apiKey);
      } catch {
      }
      return super._getProvider(d);
    }
    isCommunityResource() {
      return this.apiKey === s(this._network.name);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%apiKey%% and %%projectSecret%%.
     */
    static getRequest(d, c) {
      c == null && (c = s(d.name));
      const p = new e.FetchRequest(`https://${i(d.name)}/${c}`);
      return p.allowGzip = !0, c === s(d.name) && (p.retryFunc = async (g, v, O) => ((0, t.showThrottleMessage)("ChainstackProvider"), !0)), p;
    }
  }
  return zc.ChainstackProvider = a, zc;
}
var Vc = {}, $2;
function Y5() {
  if ($2)
    return Vc;
  $2 = 1, Object.defineProperty(Vc, "__esModule", { value: !0 }), Vc.CloudflareProvider = void 0;
  const e = wt(), t = Xn(), r = Qi();
  class n extends r.JsonRpcProvider {
    constructor(i) {
      i == null && (i = "mainnet");
      const a = t.Network.from(i);
      (0, e.assertArgument)(a.name === "mainnet", "unsupported network", "network", i), super("https://cloudflare-eth.com/", a, { staticNetwork: a });
    }
  }
  return Vc.CloudflareProvider = n, Vc;
}
var sa = {}, K2;
function X5() {
  var e;
  if (K2)
    return sa;
  K2 = 1, Object.defineProperty(sa, "__esModule", { value: !0 }), sa.EtherscanProvider = sa.EtherscanPlugin = void 0;
  const t = gd(), r = of(), n = Yn(), s = wt(), i = yd(), a = Xn(), f = x1(), d = Bo(), c = 2e3;
  function p(j) {
    return j && typeof j.then == "function";
  }
  const g = "org.ethers.plugins.provider.Etherscan";
  class v extends f.NetworkPlugin {
    /**
     *  Creates a new **EtherscanProvider** which will use
     *  %%baseUrl%%.
     */
    constructor(B) {
      super(g), Be(this, "baseUrl"), (0, s.defineProperties)(this, { baseUrl: B });
    }
    clone() {
      return new v(this.baseUrl);
    }
  }
  sa.EtherscanPlugin = v;
  const O = ["enableCcipRead"];
  let N = 1;
  class S extends i.AbstractProvider {
    /**
     *  Creates a new **EtherscanBaseProvider**.
     */
    constructor(B, M) {
      const I = M ?? null;
      super(), Be(this, "network"), Be(this, "apiKey"), _e(this, e, void 0);
      const A = a.Network.from(B);
      Oe(this, e, A.getPlugin(g)), (0, s.defineProperties)(this, { apiKey: I, network: A }), this.getBaseUrl();
    }
    /**
     *  Returns the base URL.
     *
     *  If an [[EtherscanPlugin]] is configured on the
     *  [[EtherscanBaseProvider_network]], returns the plugin's
     *  baseUrl.
     */
    getBaseUrl() {
      if (oe(this, e))
        return oe(this, e).baseUrl;
      switch (this.network.name) {
        case "mainnet":
          return "https://api.etherscan.io";
        case "goerli":
          return "https://api-goerli.etherscan.io";
        case "sepolia":
          return "https://api-sepolia.etherscan.io";
        case "holesky":
          return "https://api-holesky.etherscan.io";
        case "arbitrum":
          return "https://api.arbiscan.io";
        case "arbitrum-goerli":
          return "https://api-goerli.arbiscan.io";
        case "bnb":
          return "https://api.bscscan.com";
        case "bnbt":
          return "https://api-testnet.bscscan.com";
        case "matic":
          return "https://api.polygonscan.com";
        case "matic-amoy":
          return "https://api-amoy.polygonscan.com";
        case "matic-mumbai":
          return "https://api-testnet.polygonscan.com";
        case "optimism":
          return "https://api-optimistic.etherscan.io";
        case "optimism-goerli":
          return "https://api-goerli-optimistic.etherscan.io";
      }
      (0, s.assertArgument)(!1, "unsupported network", "network", this.network);
    }
    /**
     *  Returns the URL for the %%module%% and %%params%%.
     */
    getUrl(B, M) {
      const I = Object.keys(M).reduce((R, L) => {
        const K = M[L];
        return K != null && (R += `&${L}=${K}`), R;
      }, ""), A = this.apiKey ? `&apikey=${this.apiKey}` : "";
      return `${this.getBaseUrl()}/api?module=${B}${I}${A}`;
    }
    /**
     *  Returns the URL for using POST requests.
     */
    getPostUrl() {
      return `${this.getBaseUrl()}/api`;
    }
    /**
     *  Returns the parameters for using POST requests.
     */
    getPostData(B, M) {
      return M.module = B, M.apikey = this.apiKey, M;
    }
    async detectNetwork() {
      return this.network;
    }
    /**
     *  Resolves to the result of calling %%module%% with %%params%%.
     *
     *  If %%post%%, the request is made as a POST request.
     */
    async fetch(B, M, I) {
      const A = N++, R = I ? this.getPostUrl() : this.getUrl(B, M), L = I ? this.getPostData(B, M) : null;
      this.emit("debug", { action: "sendRequest", id: A, url: R, payload: L });
      const K = new s.FetchRequest(R);
      K.setThrottleParams({ slotInterval: 1e3 }), K.retryFunc = (V, C, D) => (this.isCommunityResource() && (0, d.showThrottleMessage)("Etherscan"), Promise.resolve(!0)), K.processFunc = async (V, C) => {
        const D = C.hasBody() ? JSON.parse((0, s.toUtf8String)(C.body)) : {}, o = (typeof D.result == "string" ? D.result : "").toLowerCase().indexOf("rate limit") >= 0;
        return B === "proxy" ? D && D.status == 0 && D.message == "NOTOK" && o && (this.emit("debug", { action: "receiveError", id: A, reason: "proxy-NOTOK", error: D }), C.throwThrottleError(D.result, c)) : o && (this.emit("debug", { action: "receiveError", id: A, reason: "null result", error: D.result }), C.throwThrottleError(D.result, c)), C;
      }, L && (K.setHeader("content-type", "application/x-www-form-urlencoded; charset=UTF-8"), K.body = Object.keys(L).map((V) => `${V}=${L[V]}`).join("&"));
      const $ = await K.send();
      try {
        $.assertOk();
      } catch (V) {
        this.emit("debug", { action: "receiveError", id: A, error: V, reason: "assertOk" }), (0, s.assert)(!1, "response error", "SERVER_ERROR", { request: K, response: $ });
      }
      $.hasBody() || (this.emit("debug", { action: "receiveError", id: A, error: "missing body", reason: "null body" }), (0, s.assert)(!1, "missing response", "SERVER_ERROR", { request: K, response: $ }));
      const k = JSON.parse((0, s.toUtf8String)($.body));
      return B === "proxy" ? (k.jsonrpc != "2.0" && (this.emit("debug", { action: "receiveError", id: A, result: k, reason: "invalid JSON-RPC" }), (0, s.assert)(!1, "invalid JSON-RPC response (missing jsonrpc='2.0')", "SERVER_ERROR", { request: K, response: $, info: { result: k } })), k.error && (this.emit("debug", { action: "receiveError", id: A, result: k, reason: "JSON-RPC error" }), (0, s.assert)(!1, "error response", "SERVER_ERROR", { request: K, response: $, info: { result: k } })), this.emit("debug", { action: "receiveRequest", id: A, result: k }), k.result) : k.status == 0 && (k.message === "No records found" || k.message === "No transactions found") ? (this.emit("debug", { action: "receiveRequest", id: A, result: k }), k.result) : ((k.status != 1 || typeof k.message == "string" && !k.message.match(/^OK/)) && (this.emit("debug", { action: "receiveError", id: A, result: k }), (0, s.assert)(!1, "error response", "SERVER_ERROR", { request: K, response: $, info: { result: k } })), this.emit("debug", { action: "receiveRequest", id: A, result: k }), k.result);
    }
    /**
     *  Returns %%transaction%% normalized for the Etherscan API.
     */
    _getTransactionPostData(B) {
      const M = {};
      for (let I in B) {
        if (O.indexOf(I) >= 0 || B[I] == null)
          continue;
        let A = B[I];
        I === "type" && A === 0 || I === "blockTag" && A === "latest" || ({ type: !0, gasLimit: !0, gasPrice: !0, maxFeePerGs: !0, maxPriorityFeePerGas: !0, nonce: !0, value: !0 }[I] ? A = (0, s.toQuantity)(A) : I === "accessList" ? A = "[" + (0, n.accessListify)(A).map((R) => `{address:"${R.address}",storageKeys:["${R.storageKeys.join('","')}"]}`).join(",") + "]" : A = (0, s.hexlify)(A), M[I] = A);
      }
      return M;
    }
    /**
     *  Throws the normalized Etherscan error.
     */
    _checkError(B, M, I) {
      let A = "";
      if ((0, s.isError)(M, "SERVER_ERROR")) {
        try {
          A = M.info.result.error.message;
        } catch {
        }
        if (!A)
          try {
            A = M.info.message;
          } catch {
          }
      }
      if (B.method === "estimateGas" && !A.match(/revert/i) && A.match(/insufficient funds/i) && (0, s.assert)(!1, "insufficient funds", "INSUFFICIENT_FUNDS", {
        transaction: B.transaction
      }), (B.method === "call" || B.method === "estimateGas") && A.match(/execution reverted/i)) {
        let R = "";
        try {
          R = M.info.result.error.data;
        } catch {
        }
        const L = t.AbiCoder.getBuiltinCallException(B.method, B.transaction, R);
        throw L.info = { request: B, error: M }, L;
      }
      if (A && B.method === "broadcastTransaction") {
        const R = n.Transaction.from(B.signedTransaction);
        A.match(/replacement/i) && A.match(/underpriced/i) && (0, s.assert)(!1, "replacement fee too low", "REPLACEMENT_UNDERPRICED", {
          transaction: R
        }), A.match(/insufficient funds/) && (0, s.assert)(!1, "insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
          transaction: R
        }), A.match(/same hash was already imported|transaction nonce is too low|nonce too low/) && (0, s.assert)(!1, "nonce has already been used", "NONCE_EXPIRED", {
          transaction: R
        });
      }
      throw M;
    }
    async _detectNetwork() {
      return this.network;
    }
    async _perform(B) {
      switch (B.method) {
        case "chainId":
          return this.network.chainId;
        case "getBlockNumber":
          return this.fetch("proxy", { action: "eth_blockNumber" });
        case "getGasPrice":
          return this.fetch("proxy", { action: "eth_gasPrice" });
        case "getPriorityFee":
          if (this.network.name === "mainnet")
            return "1000000000";
          if (this.network.name === "optimism")
            return "1000000";
          throw new Error("fallback onto the AbstractProvider default");
        case "getBalance":
          return this.fetch("account", {
            action: "balance",
            address: B.address,
            tag: B.blockTag
          });
        case "getTransactionCount":
          return this.fetch("proxy", {
            action: "eth_getTransactionCount",
            address: B.address,
            tag: B.blockTag
          });
        case "getCode":
          return this.fetch("proxy", {
            action: "eth_getCode",
            address: B.address,
            tag: B.blockTag
          });
        case "getStorage":
          return this.fetch("proxy", {
            action: "eth_getStorageAt",
            address: B.address,
            position: B.position,
            tag: B.blockTag
          });
        case "broadcastTransaction":
          return this.fetch("proxy", {
            action: "eth_sendRawTransaction",
            hex: B.signedTransaction
          }, !0).catch((M) => this._checkError(B, M, B.signedTransaction));
        case "getBlock":
          if ("blockTag" in B)
            return this.fetch("proxy", {
              action: "eth_getBlockByNumber",
              tag: B.blockTag,
              boolean: B.includeTransactions ? "true" : "false"
            });
          (0, s.assert)(!1, "getBlock by blockHash not supported by Etherscan", "UNSUPPORTED_OPERATION", {
            operation: "getBlock(blockHash)"
          });
        case "getTransaction":
          return this.fetch("proxy", {
            action: "eth_getTransactionByHash",
            txhash: B.hash
          });
        case "getTransactionReceipt":
          return this.fetch("proxy", {
            action: "eth_getTransactionReceipt",
            txhash: B.hash
          });
        case "call": {
          if (B.blockTag !== "latest")
            throw new Error("EtherscanProvider does not support blockTag for call");
          const M = this._getTransactionPostData(B.transaction);
          M.module = "proxy", M.action = "eth_call";
          try {
            return await this.fetch("proxy", M, !0);
          } catch (I) {
            return this._checkError(B, I, B.transaction);
          }
        }
        case "estimateGas": {
          const M = this._getTransactionPostData(B.transaction);
          M.module = "proxy", M.action = "eth_estimateGas";
          try {
            return await this.fetch("proxy", M, !0);
          } catch (I) {
            return this._checkError(B, I, B.transaction);
          }
        }
      }
      return super._perform(B);
    }
    async getNetwork() {
      return this.network;
    }
    /**
     *  Resolves to the current price of ether.
     *
     *  This returns ``0`` on any network other than ``mainnet``.
     */
    async getEtherPrice() {
      return this.network.name !== "mainnet" ? 0 : parseFloat((await this.fetch("stats", { action: "ethprice" })).ethusd);
    }
    /**
     *  Resolves to a [Contract]] for %%address%%, using the
     *  Etherscan API to retreive the Contract ABI.
     */
    async getContract(B) {
      let M = this._getAddress(B);
      p(M) && (M = await M);
      try {
        const I = await this.fetch("contract", {
          action: "getabi",
          address: M
        }), A = JSON.parse(I);
        return new r.Contract(M, A, this);
      } catch {
        return null;
      }
    }
    isCommunityResource() {
      return this.apiKey == null;
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), sa.EtherscanProvider = S, sa;
}
var oa = {}, qc = {}, $c = {}, J2;
function nk() {
  if (J2)
    return $c;
  J2 = 1, Object.defineProperty($c, "__esModule", { value: !0 }), $c.WebSocket = void 0;
  function e() {
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof Ze < "u")
      return Ze;
    throw new Error("unable to locate global object");
  }
  const t = e().WebSocket;
  return $c.WebSocket = t, $c;
}
var Hn = {}, Q2;
function Lp() {
  var e, t, r, n, s, i, a, f, d;
  if (Q2)
    return Hn;
  Q2 = 1, Object.defineProperty(Hn, "__esModule", { value: !0 }), Hn.SocketProvider = Hn.SocketEventSubscriber = Hn.SocketPendingSubscriber = Hn.SocketBlockSubscriber = Hn.SocketSubscriber = void 0;
  const c = yd(), p = wt(), g = Qi();
  class v {
    /**
     *  Creates a new **SocketSubscriber** attached to %%provider%% listening
     *  to %%filter%%.
     */
    constructor(M, I) {
      _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), _e(this, n, void 0), _e(this, s, void 0), Oe(this, e, M), Oe(this, t, JSON.stringify(I)), Oe(this, r, null), Oe(this, n, null), Oe(this, s, null);
    }
    /**
     *  The filter.
     */
    get filter() {
      return JSON.parse(oe(this, t));
    }
    start() {
      Oe(this, r, oe(this, e).send("eth_subscribe", this.filter).then((M) => (oe(this, e)._register(M, this), M)));
    }
    stop() {
      oe(this, r).then((M) => {
        oe(this, e).destroyed || oe(this, e).send("eth_unsubscribe", [M]);
      }), Oe(this, r, null);
    }
    // @TODO: pause should trap the current blockNumber, unsub, and on resume use getLogs
    //        and resume
    pause(M) {
      (0, p.assert)(M, "preserve logs while paused not supported by SocketSubscriber yet", "UNSUPPORTED_OPERATION", { operation: "pause(false)" }), Oe(this, n, !!M);
    }
    resume() {
      Oe(this, n, null);
    }
    /**
     *  @_ignore:
     */
    _handleMessage(M) {
      if (oe(this, r) != null && oe(this, n) === null) {
        let I = oe(this, s);
        I == null ? I = this._emit(oe(this, e), M) : I = I.then(async () => {
          await this._emit(oe(this, e), M);
        }), Oe(this, s, I.then(() => {
          oe(this, s) === I && Oe(this, s, null);
        }));
      }
    }
    /**
     *  Sub-classes **must** override this to emit the events on the
     *  provider.
     */
    async _emit(M, I) {
      throw new Error("sub-classes must implemente this; _emit");
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), Hn.SocketSubscriber = v;
  class O extends v {
    /**
     *  @_ignore:
     */
    constructor(M) {
      super(M, ["newHeads"]);
    }
    async _emit(M, I) {
      M.emit("block", parseInt(I.number));
    }
  }
  Hn.SocketBlockSubscriber = O;
  class N extends v {
    /**
     *  @_ignore:
     */
    constructor(M) {
      super(M, ["newPendingTransactions"]);
    }
    async _emit(M, I) {
      M.emit("pending", I);
    }
  }
  Hn.SocketPendingSubscriber = N;
  class S extends v {
    /**
     *  @_ignore:
     */
    constructor(M, I) {
      super(M, ["logs", I]), _e(this, i, void 0), Oe(this, i, JSON.stringify(I));
    }
    /**
     *  The filter.
     */
    get logFilter() {
      return JSON.parse(oe(this, i));
    }
    async _emit(M, I) {
      M.emit(this.logFilter, M._wrapLog(I, M._network));
    }
  }
  i = /* @__PURE__ */ new WeakMap(), Hn.SocketEventSubscriber = S;
  class j extends g.JsonRpcApiProvider {
    /**
     *  Creates a new **SocketProvider** connected to %%network%%.
     *
     *  If unspecified, the network will be discovered.
     */
    constructor(M, I) {
      const A = Object.assign({}, I ?? {});
      (0, p.assertArgument)(A.batchMaxCount == null || A.batchMaxCount === 1, "sockets-based providers do not support batches", "options.batchMaxCount", I), A.batchMaxCount = 1, A.staticNetwork == null && (A.staticNetwork = !0), super(M, A), _e(this, a, void 0), _e(this, f, void 0), _e(this, d, void 0), Oe(this, a, /* @__PURE__ */ new Map()), Oe(this, f, /* @__PURE__ */ new Map()), Oe(this, d, /* @__PURE__ */ new Map());
    }
    // This value is only valid after _start has been called
    /*
    get _network(): Network {
        if (this.#network == null) {
            throw new Error("this shouldn't happen");
        }
        return this.#network.clone();
    }
    */
    _getSubscriber(M) {
      switch (M.type) {
        case "close":
          return new c.UnmanagedSubscriber("close");
        case "block":
          return new O(this);
        case "pending":
          return new N(this);
        case "event":
          return new S(this, M.filter);
        case "orphan":
          if (M.filter.orphan === "drop-log")
            return new c.UnmanagedSubscriber("drop-log");
      }
      return super._getSubscriber(M);
    }
    /**
     *  Register a new subscriber. This is used internalled by Subscribers
     *  and generally is unecessary unless extending capabilities.
     */
    _register(M, I) {
      oe(this, f).set(M, I);
      const A = oe(this, d).get(M);
      if (A) {
        for (const R of A)
          I._handleMessage(R);
        oe(this, d).delete(M);
      }
    }
    async _send(M) {
      (0, p.assertArgument)(!Array.isArray(M), "WebSocket does not support batch send", "payload", M);
      const I = new Promise((A, R) => {
        oe(this, a).set(M.id, { payload: M, resolve: A, reject: R });
      });
      return await this._waitUntilReady(), await this._write(JSON.stringify(M)), [await I];
    }
    // Sub-classes must call this once they are connected
    /*
    	    async _start(): Promise<void> {
    	        if (this.#ready) { return; }
    
    	        for (const { payload } of this.#callbacks.values()) {
    	            await this._write(JSON.stringify(payload));
    	        }
    
    	        this.#ready = (async function() {
    	            await super._start();
    	        })();
    	    }
    	    */
    /**
     *  Sub-classes **must** call this with messages received over their
     *  transport to be processed and dispatched.
     */
    async _processMessage(M) {
      const I = JSON.parse(M);
      if (I && typeof I == "object" && "id" in I) {
        const A = oe(this, a).get(I.id);
        if (A == null) {
          this.emit("error", (0, p.makeError)("received result for unknown id", "UNKNOWN_ERROR", {
            reasonCode: "UNKNOWN_ID",
            result: I
          }));
          return;
        }
        oe(this, a).delete(I.id), A.resolve(I);
      } else if (I && I.method === "eth_subscription") {
        const A = I.params.subscription, R = oe(this, f).get(A);
        if (R)
          R._handleMessage(I.params.result);
        else {
          let L = oe(this, d).get(A);
          L == null && (L = [], oe(this, d).set(A, L)), L.push(I.params.result);
        }
      } else {
        this.emit("error", (0, p.makeError)("received unexpected message", "UNKNOWN_ERROR", {
          reasonCode: "UNEXPECTED_MESSAGE",
          result: I
        }));
        return;
      }
    }
    /**
     *  Sub-classes **must** override this to send %%message%% over their
     *  transport.
     */
    async _write(M) {
      throw new Error("sub-classes must override this");
    }
  }
  return a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), Hn.SocketProvider = j, Hn;
}
var Z2;
function S1() {
  var e, t;
  if (Z2)
    return qc;
  Z2 = 1, Object.defineProperty(qc, "__esModule", { value: !0 }), qc.WebSocketProvider = void 0;
  const r = nk(), n = Lp();
  class s extends n.SocketProvider {
    constructor(a, f, d) {
      super(f, d), _e(this, e, void 0), _e(this, t, void 0), typeof a == "string" ? (Oe(this, e, () => new r.WebSocket(a)), Oe(this, t, oe(this, e).call(this))) : typeof a == "function" ? (Oe(this, e, a), Oe(this, t, a())) : (Oe(this, e, null), Oe(this, t, a)), this.websocket.onopen = async () => {
        try {
          await this._start(), this.resume();
        } catch (c) {
          console.log("failed to start WebsocketProvider", c);
        }
      }, this.websocket.onmessage = (c) => {
        this._processMessage(c.data);
      };
    }
    get websocket() {
      if (oe(this, t) == null)
        throw new Error("websocket closed");
      return oe(this, t);
    }
    async _write(a) {
      this.websocket.send(a);
    }
    async destroy() {
      oe(this, t) != null && (oe(this, t).close(), Oe(this, t, null)), super.destroy();
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), qc.WebSocketProvider = s, qc;
}
var Y2;
function e8() {
  if (Y2)
    return oa;
  Y2 = 1, Object.defineProperty(oa, "__esModule", { value: !0 }), oa.InfuraProvider = oa.InfuraWebSocketProvider = void 0;
  const e = wt(), t = Bo(), r = Xn(), n = Qi(), s = S1(), i = "84842078b09946638c03157f83405213";
  function a(c) {
    switch (c) {
      case "mainnet":
        return "mainnet.infura.io";
      case "goerli":
        return "goerli.infura.io";
      case "sepolia":
        return "sepolia.infura.io";
      case "arbitrum":
        return "arbitrum-mainnet.infura.io";
      case "arbitrum-goerli":
        return "arbitrum-goerli.infura.io";
      case "arbitrum-sepolia":
        return "arbitrum-sepolia.infura.io";
      case "base":
        return "base-mainnet.infura.io";
      case "base-goerlia":
        return "base-goerli.infura.io";
      case "base-sepolia":
        return "base-sepolia.infura.io";
      case "bnb":
        return "bnbsmartchain-mainnet.infura.io";
      case "bnbt":
        return "bnbsmartchain-testnet.infura.io";
      case "linea":
        return "linea-mainnet.infura.io";
      case "linea-goerli":
        return "linea-goerli.infura.io";
      case "linea-sepolia":
        return "linea-sepolia.infura.io";
      case "matic":
        return "polygon-mainnet.infura.io";
      case "matic-amoy":
        return "polygon-amoy.infura.io";
      case "matic-mumbai":
        return "polygon-mumbai.infura.io";
      case "optimism":
        return "optimism-mainnet.infura.io";
      case "optimism-goerli":
        return "optimism-goerli.infura.io";
      case "optimism-sepolia":
        return "optimism-sepolia.infura.io";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", c);
  }
  class f extends s.WebSocketProvider {
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */
    constructor(p, g) {
      const v = new d(p, g), O = v._getConnection();
      (0, e.assert)(!O.credentials, "INFURA WebSocket project secrets unsupported", "UNSUPPORTED_OPERATION", { operation: "InfuraProvider.getWebSocketProvider()" });
      const N = O.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
      super(N, v._network), Be(this, "projectId"), Be(this, "projectSecret"), (0, e.defineProperties)(this, {
        projectId: v.projectId,
        projectSecret: v.projectSecret
      });
    }
    isCommunityResource() {
      return this.projectId === i;
    }
  }
  oa.InfuraWebSocketProvider = f;
  class d extends n.JsonRpcProvider {
    /**
     *  Creates a new **InfuraProvider**.
     */
    constructor(p, g, v) {
      p == null && (p = "mainnet");
      const O = r.Network.from(p);
      g == null && (g = i), v == null && (v = null);
      const N = d.getRequest(O, g, v);
      super(N, O, { staticNetwork: O }), Be(this, "projectId"), Be(this, "projectSecret"), (0, e.defineProperties)(this, { projectId: g, projectSecret: v });
    }
    _getProvider(p) {
      try {
        return new d(p, this.projectId, this.projectSecret);
      } catch {
      }
      return super._getProvider(p);
    }
    isCommunityResource() {
      return this.projectId === i;
    }
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */
    static getWebSocketProvider(p, g) {
      return new f(p, g);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%projectId%% and %%projectSecret%%.
     */
    static getRequest(p, g, v) {
      g == null && (g = i), v == null && (v = null);
      const O = new e.FetchRequest(`https://${a(p.name)}/v3/${g}`);
      return O.allowGzip = !0, v && O.setCredentials("", v), g === i && (O.retryFunc = async (N, S, j) => ((0, t.showThrottleMessage)("InfuraProvider"), !0)), O;
    }
  }
  return oa.InfuraProvider = d, oa;
}
var Kc = {}, X2;
function t8() {
  if (X2)
    return Kc;
  X2 = 1, Object.defineProperty(Kc, "__esModule", { value: !0 }), Kc.QuickNodeProvider = void 0;
  const e = wt(), t = Bo(), r = Xn(), n = Qi(), s = "919b412a057b5e9c9b6dce193c5a60242d6efadb";
  function i(f) {
    switch (f) {
      case "mainnet":
        return "ethers.quiknode.pro";
      case "goerli":
        return "ethers.ethereum-goerli.quiknode.pro";
      case "sepolia":
        return "ethers.ethereum-sepolia.quiknode.pro";
      case "holesky":
        return "ethers.ethereum-holesky.quiknode.pro";
      case "arbitrum":
        return "ethers.arbitrum-mainnet.quiknode.pro";
      case "arbitrum-goerli":
        return "ethers.arbitrum-goerli.quiknode.pro";
      case "arbitrum-sepolia":
        return "ethers.arbitrum-sepolia.quiknode.pro";
      case "base":
        return "ethers.base-mainnet.quiknode.pro";
      case "base-goerli":
        return "ethers.base-goerli.quiknode.pro";
      case "base-spolia":
        return "ethers.base-sepolia.quiknode.pro";
      case "bnb":
        return "ethers.bsc.quiknode.pro";
      case "bnbt":
        return "ethers.bsc-testnet.quiknode.pro";
      case "matic":
        return "ethers.matic.quiknode.pro";
      case "matic-mumbai":
        return "ethers.matic-testnet.quiknode.pro";
      case "optimism":
        return "ethers.optimism.quiknode.pro";
      case "optimism-goerli":
        return "ethers.optimism-goerli.quiknode.pro";
      case "optimism-sepolia":
        return "ethers.optimism-sepolia.quiknode.pro";
      case "xdai":
        return "ethers.xdai.quiknode.pro";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Creates a new **QuickNodeProvider**.
     */
    constructor(d, c) {
      d == null && (d = "mainnet");
      const p = r.Network.from(d);
      c == null && (c = s);
      const g = a.getRequest(p, c);
      super(g, p, { staticNetwork: p }), Be(this, "token"), (0, e.defineProperties)(this, { token: c });
    }
    _getProvider(d) {
      try {
        return new a(d, this.token);
      } catch {
      }
      return super._getProvider(d);
    }
    isCommunityResource() {
      return this.token === s;
    }
    /**
     *  Returns a new request prepared for %%network%% and the
     *  %%token%%.
     */
    static getRequest(d, c) {
      c == null && (c = s);
      const p = new e.FetchRequest(`https://${i(d.name)}/${c}`);
      return p.allowGzip = !0, c === s && (p.retryFunc = async (g, v, O) => ((0, t.showThrottleMessage)("QuickNodeProvider"), !0)), p;
    }
  }
  return Kc.QuickNodeProvider = a, Kc;
}
var Jc = {}, e3;
function r8() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v;
  if (e3)
    return Jc;
  e3 = 1, Object.defineProperty(Jc, "__esModule", { value: !0 }), Jc.FallbackProvider = void 0;
  const O = wt(), N = yd(), S = Xn(), j = BigInt("1"), B = BigInt("2");
  function M(y) {
    for (let E = y.length - 1; E > 0; E--) {
      const P = Math.floor(Math.random() * (E + 1)), w = y[E];
      y[E] = y[P], y[P] = w;
    }
  }
  function I(y) {
    return new Promise((E) => {
      setTimeout(E, y);
    });
  }
  function A() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  function R(y) {
    return JSON.stringify(y, (E, P) => typeof P == "bigint" ? { type: "bigint", value: P.toString() } : P);
  }
  const L = { stallTimeout: 400, priority: 1, weight: 1 }, K = {
    blockNumber: -2,
    requests: 0,
    lateResponses: 0,
    errorResponses: 0,
    outOfSync: -1,
    unsupportedEvents: 0,
    rollingDuration: 0,
    score: 0,
    _network: null,
    _updateNumber: null,
    _totalTime: 0,
    _lastFatalError: null,
    _lastFatalErrorTimestamp: 0
  };
  async function $(y, E) {
    for (; (y.blockNumber < 0 || y.blockNumber < E) && (y._updateNumber || (y._updateNumber = (async () => {
      try {
        const P = await y.provider.getBlockNumber();
        P > y.blockNumber && (y.blockNumber = P);
      } catch (P) {
        y.blockNumber = -2, y._lastFatalError = P, y._lastFatalErrorTimestamp = A();
      }
      y._updateNumber = null;
    })()), await y._updateNumber, y.outOfSync++, !y._lastFatalError); )
      ;
  }
  function k(y) {
    if (y == null)
      return "null";
    if (Array.isArray(y))
      return "[" + y.map(k).join(",") + "]";
    if (typeof y == "object" && typeof y.toJSON == "function")
      return k(y.toJSON());
    switch (typeof y) {
      case "boolean":
      case "symbol":
        return y.toString();
      case "bigint":
      case "number":
        return BigInt(y).toString();
      case "string":
        return JSON.stringify(y);
      case "object": {
        const E = Object.keys(y);
        return E.sort(), "{" + E.map((P) => `${JSON.stringify(P)}:${k(y[P])}`).join(",") + "}";
      }
    }
    throw console.log("Could not serialize", y), new Error("Hmm...");
  }
  function V(y) {
    if ("error" in y) {
      const P = y.error;
      return { tag: k(P), value: P };
    }
    const E = y.result;
    return { tag: k(E), value: E };
  }
  function C(y, E) {
    const P = /* @__PURE__ */ new Map();
    for (const { value: m, tag: l, weight: b } of E) {
      const W = P.get(l) || { value: m, weight: 0 };
      W.weight += b, P.set(l, W);
    }
    let w = null;
    for (const m of P.values())
      m.weight >= y && (!w || m.weight > w.weight) && (w = m);
    if (w)
      return w.value;
  }
  function D(y, E) {
    let P = 0;
    const w = /* @__PURE__ */ new Map();
    let m = null;
    const l = [];
    for (const { value: W, tag: X, weight: G } of E)
      if (W instanceof Error) {
        const re = w.get(X) || { value: W, weight: 0 };
        re.weight += G, w.set(X, re), (m == null || re.weight > m.weight) && (m = re);
      } else
        l.push(BigInt(W)), P += G;
    if (P < y)
      return m && m.weight >= y ? m.value : void 0;
    l.sort((W, X) => W < X ? -1 : X > W ? 1 : 0);
    const b = Math.floor(l.length / 2);
    return l.length % 2 ? l[b] : (l[b - 1] + l[b] + j) / B;
  }
  function o(y, E) {
    const P = C(y, E);
    if (P !== void 0)
      return P;
    for (const w of E)
      if (w.value)
        return w.value;
  }
  function u(y, E) {
    if (y === 1)
      return (0, O.getNumber)(D(y, E), "%internal");
    const P = /* @__PURE__ */ new Map(), w = (b, W) => {
      const X = P.get(b) || { result: b, weight: 0 };
      X.weight += W, P.set(b, X);
    };
    for (const { weight: b, value: W } of E) {
      const X = (0, O.getNumber)(W);
      w(X - 1, b), w(X, b), w(X + 1, b);
    }
    let m = 0, l;
    for (const { weight: b, result: W } of P.values())
      b >= y && (b > m || l != null && b === m && W > l) && (m = b, l = W);
    return l;
  }
  class h extends N.AbstractProvider {
    /**
     *  Creates a new **FallbackProvider** with %%providers%% connected to
     *  %%network%%.
     *
     *  If a [[Provider]] is included in %%providers%%, defaults are used
     *  for the configuration.
     */
    constructor(E, P, w) {
      super(P, w), _e(this, n), _e(this, i), _e(this, f), _e(this, c), _e(this, g), Be(this, "quorum"), Be(this, "eventQuorum"), Be(this, "eventWorkers"), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), Oe(this, e, E.map((m) => m instanceof N.AbstractProvider ? Object.assign({ provider: m }, L, K) : Object.assign({}, L, m, K))), Oe(this, t, -2), Oe(this, r, null), w && w.quorum != null ? this.quorum = w.quorum : this.quorum = Math.ceil(oe(this, e).reduce((m, l) => (m += l.weight, m), 0) / 2), this.eventQuorum = 1, this.eventWorkers = 1, (0, O.assertArgument)(this.quorum <= oe(this, e).reduce((m, l) => m + l.weight, 0), "quorum exceed provider weight", "quorum", this.quorum);
    }
    get providerConfigs() {
      return oe(this, e).map((E) => {
        const P = Object.assign({}, E);
        for (const w in P)
          w[0] === "_" && delete P[w];
        return P;
      });
    }
    async _detectNetwork() {
      return S.Network.from((0, O.getBigInt)(await this._perform({ method: "chainId" })));
    }
    // @TODO: Add support to select providers to be the event subscriber
    //_getSubscriber(sub: Subscription): Subscriber {
    //    throw new Error("@TODO");
    //}
    /**
     *  Transforms a %%req%% into the correct method call on %%provider%%.
     */
    async _translatePerform(E, P) {
      switch (P.method) {
        case "broadcastTransaction":
          return await E.broadcastTransaction(P.signedTransaction);
        case "call":
          return await E.call(Object.assign({}, P.transaction, { blockTag: P.blockTag }));
        case "chainId":
          return (await E.getNetwork()).chainId;
        case "estimateGas":
          return await E.estimateGas(P.transaction);
        case "getBalance":
          return await E.getBalance(P.address, P.blockTag);
        case "getBlock": {
          const w = "blockHash" in P ? P.blockHash : P.blockTag;
          return await E.getBlock(w, P.includeTransactions);
        }
        case "getBlockNumber":
          return await E.getBlockNumber();
        case "getCode":
          return await E.getCode(P.address, P.blockTag);
        case "getGasPrice":
          return (await E.getFeeData()).gasPrice;
        case "getPriorityFee":
          return (await E.getFeeData()).maxPriorityFeePerGas;
        case "getLogs":
          return await E.getLogs(P.filter);
        case "getStorage":
          return await E.getStorage(P.address, P.position, P.blockTag);
        case "getTransaction":
          return await E.getTransaction(P.hash);
        case "getTransactionCount":
          return await E.getTransactionCount(P.address, P.blockTag);
        case "getTransactionReceipt":
          return await E.getTransactionReceipt(P.hash);
        case "getTransactionResult":
          return await E.getTransactionResult(P.hash);
      }
    }
    async _perform(E) {
      if (E.method === "broadcastTransaction") {
        const l = oe(this, e).map((X) => null), b = oe(this, e).map(async ({ provider: X, weight: G }, re) => {
          try {
            const ce = await X._perform(E);
            l[re] = Object.assign(V({ result: ce }), { weight: G });
          } catch (ce) {
            l[re] = Object.assign(V({ error: ce }), { weight: G });
          }
        });
        for (; ; ) {
          const X = l.filter((ce) => ce != null);
          for (const { value: ce } of X)
            if (!(ce instanceof Error))
              return ce;
          const G = C(this.quorum, l.filter((ce) => ce != null));
          if ((0, O.isError)(G, "INSUFFICIENT_FUNDS"))
            throw G;
          const re = b.filter((ce, pe) => l[pe] == null);
          if (re.length === 0)
            break;
          await Promise.race(re);
        }
        const W = o(this.quorum, l);
        if ((0, O.assert)(W !== void 0, "problem multi-broadcasting", "SERVER_ERROR", {
          request: "%sub-requests",
          info: { request: E, results: l.map(R) }
        }), W instanceof Error)
          throw W;
        return W;
      }
      await Ve(this, f, d).call(this);
      const P = /* @__PURE__ */ new Set();
      let w = 0;
      for (; ; ) {
        const l = Ve(this, i, a).call(this, P, E);
        if (l == null || (w += l.config.weight, w >= this.quorum))
          break;
      }
      const m = await Ve(this, g, v).call(this, P, E);
      for (const l of P)
        l.perform && l.result == null && l.config.lateResponses++;
      return m;
    }
    async destroy() {
      for (const { provider: E } of oe(this, e))
        E.destroy();
      super.destroy();
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakSet(), s = function(y) {
    const E = Array.from(y).map((w) => w.config), P = oe(this, e).slice();
    M(P), P.sort((w, m) => w.priority - m.priority);
    for (const w of P)
      if (!w._lastFatalError && E.indexOf(w) === -1)
        return w;
    return null;
  }, i = /* @__PURE__ */ new WeakSet(), a = function(y, E) {
    const P = Ve(this, n, s).call(this, y);
    if (P == null)
      return null;
    const w = {
      config: P,
      result: null,
      didBump: !1,
      perform: null,
      staller: null
    }, m = A();
    return w.perform = (async () => {
      try {
        P.requests++;
        const b = await this._translatePerform(P.provider, E);
        w.result = { result: b };
      } catch (b) {
        P.errorResponses++, w.result = { error: b };
      }
      const l = A() - m;
      P._totalTime += l, P.rollingDuration = 0.95 * P.rollingDuration + 0.05 * l, w.perform = null;
    })(), w.staller = (async () => {
      await I(P.stallTimeout), w.staller = null;
    })(), y.add(w), w;
  }, f = /* @__PURE__ */ new WeakSet(), d = async function() {
    let y = oe(this, r);
    if (!y) {
      const E = [];
      oe(this, e).forEach((P) => {
        E.push((async () => {
          await $(P, 0), P._lastFatalError || (P._network = await P.provider.getNetwork());
        })());
      }), Oe(this, r, y = (async () => {
        await Promise.all(E);
        let P = null;
        for (const w of oe(this, e)) {
          if (w._lastFatalError)
            continue;
          const m = w._network;
          P == null ? P = m.chainId : m.chainId !== P && (0, O.assert)(!1, "cannot mix providers on different networks", "UNSUPPORTED_OPERATION", {
            operation: "new FallbackProvider"
          });
        }
      })());
    }
    await y;
  }, c = /* @__PURE__ */ new WeakSet(), p = async function(y, E) {
    const P = [];
    for (const w of y)
      if (w.result != null) {
        const { tag: m, value: l } = V(w.result);
        P.push({ tag: m, value: l, weight: w.config.weight });
      }
    if (!(P.reduce((w, m) => w + m.weight, 0) < this.quorum)) {
      switch (E.method) {
        case "getBlockNumber": {
          oe(this, t) === -2 && Oe(this, t, Math.ceil((0, O.getNumber)(D(this.quorum, oe(this, e).filter((m) => !m._lastFatalError).map((m) => ({
            value: m.blockNumber,
            tag: (0, O.getNumber)(m.blockNumber).toString(),
            weight: m.weight
          }))))));
          const w = u(this.quorum, P);
          return w === void 0 ? void 0 : (w > oe(this, t) && Oe(this, t, w), oe(this, t));
        }
        case "getGasPrice":
        case "getPriorityFee":
        case "estimateGas":
          return D(this.quorum, P);
        case "getBlock":
          return "blockTag" in E && E.blockTag === "pending" ? o(this.quorum, P) : C(this.quorum, P);
        case "call":
        case "chainId":
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorage":
        case "getTransaction":
        case "getTransactionReceipt":
        case "getLogs":
          return C(this.quorum, P);
        case "broadcastTransaction":
          return o(this.quorum, P);
      }
      (0, O.assert)(!1, "unsupported method", "UNSUPPORTED_OPERATION", {
        operation: `_perform(${R(E.method)})`
      });
    }
  }, g = /* @__PURE__ */ new WeakSet(), v = async function(y, E) {
    if (y.size === 0)
      throw new Error("no runners?!");
    const P = [];
    let w = 0;
    for (const l of y) {
      if (l.perform && P.push(l.perform), l.staller) {
        P.push(l.staller);
        continue;
      }
      l.didBump || (l.didBump = !0, w++);
    }
    const m = await Ve(this, c, p).call(this, y, E);
    if (m !== void 0) {
      if (m instanceof Error)
        throw m;
      return m;
    }
    for (let l = 0; l < w; l++)
      Ve(this, i, a).call(this, y, E);
    return (0, O.assert)(P.length > 0, "quorum not met", "SERVER_ERROR", {
      request: "%sub-requests",
      info: { request: E, results: Array.from(y).map((l) => R(l.result)) }
    }), await Promise.race(P), await Ve(this, g, v).call(this, y, E);
  }, Jc.FallbackProvider = h, Jc;
}
var t3;
function ik() {
  if (t3)
    return Hc;
  t3 = 1, Object.defineProperty(Hc, "__esModule", { value: !0 }), Hc.getDefaultProvider = void 0;
  const e = wt(), t = J5(), r = Q5(), n = Z5(), s = Y5(), i = X5(), a = e8(), f = t8(), d = r8(), c = Qi(), p = Xn(), g = S1();
  function v(S) {
    return S && typeof S.send == "function" && typeof S.close == "function";
  }
  const O = "goerli kovan sepolia classicKotti optimism-goerli arbitrum-goerli matic-mumbai bnbt".split(" ");
  function N(S, j) {
    j == null && (j = {});
    const B = (R) => j[R] === "-" ? !1 : typeof j.exclusive == "string" ? R === j.exclusive : Array.isArray(j.exclusive) ? j.exclusive.indexOf(R) !== -1 : !0;
    if (typeof S == "string" && S.match(/^https?:/))
      return new c.JsonRpcProvider(S);
    if (typeof S == "string" && S.match(/^wss?:/) || v(S))
      return new g.WebSocketProvider(S);
    let M = null;
    try {
      M = p.Network.from(S);
    } catch {
    }
    const I = [];
    if (B("publicPolygon") && M && (M.name === "matic" ? I.push(new c.JsonRpcProvider("https://polygon-rpc.com/", M, { staticNetwork: M })) : M.name === "matic-amoy" && I.push(new c.JsonRpcProvider("https://rpc-amoy.polygon.technology/", M, { staticNetwork: M }))), B("alchemy"))
      try {
        I.push(new r.AlchemyProvider(S, j.alchemy));
      } catch {
      }
    if (B("ankr") && j.ankr != null)
      try {
        I.push(new t.AnkrProvider(S, j.ankr));
      } catch {
      }
    if (B("chainstack"))
      try {
        I.push(new n.ChainstackProvider(S, j.chainstack));
      } catch {
      }
    if (B("cloudflare"))
      try {
        I.push(new s.CloudflareProvider(S));
      } catch {
      }
    if (B("etherscan"))
      try {
        I.push(new i.EtherscanProvider(S, j.etherscan));
      } catch {
      }
    if (B("infura"))
      try {
        let R = j.infura, L;
        typeof R == "object" && (L = R.projectSecret, R = R.projectId), I.push(new a.InfuraProvider(S, R, L));
      } catch {
      }
    if (B("quicknode"))
      try {
        let R = j.quicknode;
        I.push(new f.QuickNodeProvider(S, R));
      } catch {
      }
    if ((0, e.assert)(I.length, "unsupported default network", "UNSUPPORTED_OPERATION", {
      operation: "getDefaultProvider"
    }), I.length === 1)
      return I[0];
    let A = Math.floor(I.length / 2);
    return A > 2 && (A = 2), M && O.indexOf(M.name) !== -1 && (A = 1), j && j.quorum && (A = j.quorum), new d.FallbackProvider(I, void 0, { quorum: A });
  }
  return Hc.getDefaultProvider = N, Hc;
}
var Qc = {}, r3;
function sk() {
  var e, t;
  if (r3)
    return Qc;
  r3 = 1, Object.defineProperty(Qc, "__esModule", { value: !0 }), Qc.NonceManager = void 0;
  const r = wt(), n = k1(), s = class n8 extends n.AbstractSigner {
    /**
     *  Creates a new **NonceManager** to manage %%signer%%.
     */
    constructor(f) {
      super(f.provider), Be(this, "signer"), _e(this, e, void 0), _e(this, t, void 0), (0, r.defineProperties)(this, { signer: f }), Oe(this, e, null), Oe(this, t, 0);
    }
    async getAddress() {
      return this.signer.getAddress();
    }
    connect(f) {
      return new n8(this.signer.connect(f));
    }
    async getNonce(f) {
      if (f === "pending") {
        oe(this, e) == null && Oe(this, e, super.getNonce("pending"));
        const d = oe(this, t);
        return await oe(this, e) + d;
      }
      return super.getNonce(f);
    }
    /**
     *  Manually increment the nonce. This may be useful when managng
     *  offline transactions.
     */
    increment() {
      q0(this, t)._++;
    }
    /**
     *  Resets the nonce, causing the **NonceManager** to reload the current
     *  nonce from the blockchain on the next transaction.
     */
    reset() {
      Oe(this, t, 0), Oe(this, e, null);
    }
    async sendTransaction(f) {
      const d = this.getNonce("pending");
      return this.increment(), f = await this.signer.populateTransaction(f), f.nonce = await d, await this.signer.sendTransaction(f);
    }
    signTransaction(f) {
      return this.signer.signTransaction(f);
    }
    signMessage(f) {
      return this.signer.signMessage(f);
    }
    signTypedData(f, d, c) {
      return this.signer.signTypedData(f, d, c);
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  let i = s;
  return Qc.NonceManager = i, Qc;
}
var Zc = {}, n3;
function ok() {
  var e;
  if (n3)
    return Zc;
  n3 = 1, Object.defineProperty(Zc, "__esModule", { value: !0 }), Zc.BrowserProvider = void 0;
  const t = wt(), r = Qi();
  class n extends r.JsonRpcApiPollingProvider {
    /**
     *  Connnect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */
    constructor(i, a) {
      (0, t.assertArgument)(i && i.request, "invalid EIP-1193 provider", "ethereum", i), super(a, { batchMaxCount: 1 }), _e(this, e, void 0), Oe(this, e, async (f, d) => {
        const c = { method: f, params: d };
        this.emit("debug", { action: "sendEip1193Request", payload: c });
        try {
          const p = await i.request(c);
          return this.emit("debug", { action: "receiveEip1193Result", result: p }), p;
        } catch (p) {
          const g = new Error(p.message);
          throw g.code = p.code, g.data = p.data, g.payload = c, this.emit("debug", { action: "receiveEip1193Error", error: g }), g;
        }
      });
    }
    async send(i, a) {
      return await this._start(), await super.send(i, a);
    }
    async _send(i) {
      (0, t.assertArgument)(!Array.isArray(i), "EIP-1193 does not support batch request", "payload", i);
      try {
        const a = await oe(this, e).call(this, i.method, i.params || []);
        return [{ id: i.id, result: a }];
      } catch (a) {
        return [{
          id: i.id,
          error: { code: a.code, data: a.data, message: a.message }
        }];
      }
    }
    getRpcError(i, a) {
      switch (a = JSON.parse(JSON.stringify(a)), a.error.code || -1) {
        case 4001:
          a.error.message = `ethers-user-denied: ${a.error.message}`;
          break;
        case 4200:
          a.error.message = `ethers-unsupported: ${a.error.message}`;
          break;
      }
      return super.getRpcError(i, a);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */
    async hasSigner(i) {
      i == null && (i = 0);
      const a = await this.send("eth_accounts", []);
      return typeof i == "number" ? a.length > i : (i = i.toLowerCase(), a.filter((f) => f.toLowerCase() === i).length !== 0);
    }
    async getSigner(i) {
      if (i == null && (i = 0), !await this.hasSigner(i))
        try {
          await oe(this, e).call(this, "eth_requestAccounts", []);
        } catch (a) {
          const f = a.payload;
          throw this.getRpcError(f, { id: f.id, error: a });
        }
      return await super.getSigner(i);
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), Zc.BrowserProvider = n, Zc;
}
var Yc = {}, i3;
function ak() {
  if (i3)
    return Yc;
  i3 = 1, Object.defineProperty(Yc, "__esModule", { value: !0 }), Yc.PocketProvider = void 0;
  const e = wt(), t = Bo(), r = Xn(), n = Qi(), s = "62e1ad51b37b8e00394bda3b";
  function i(f) {
    switch (f) {
      case "mainnet":
        return "eth-mainnet.gateway.pokt.network";
      case "goerli":
        return "eth-goerli.gateway.pokt.network";
      case "matic":
        return "poly-mainnet.gateway.pokt.network";
      case "matic-mumbai":
        return "polygon-mumbai-rpc.gateway.pokt.network";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Create a new **PocketProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */
    constructor(d, c, p) {
      d == null && (d = "mainnet");
      const g = r.Network.from(d);
      c == null && (c = s), p == null && (p = null);
      const v = { staticNetwork: g }, O = a.getRequest(g, c, p);
      super(O, g, v), Be(this, "applicationId"), Be(this, "applicationSecret"), (0, e.defineProperties)(this, { applicationId: c, applicationSecret: p });
    }
    _getProvider(d) {
      try {
        return new a(d, this.applicationId, this.applicationSecret);
      } catch {
      }
      return super._getProvider(d);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%applicationId%%.
     */
    static getRequest(d, c, p) {
      c == null && (c = s);
      const g = new e.FetchRequest(`https://${i(d.name)}/v1/lb/${c}`);
      return g.allowGzip = !0, p && g.setCredentials("", p), c === s && (g.retryFunc = async (v, O, N) => ((0, t.showThrottleMessage)("PocketProvider"), !0)), g;
    }
    isCommunityResource() {
      return this.applicationId === s;
    }
  }
  return Yc.PocketProvider = a, Yc;
}
var Xc = {}, s3;
function uk() {
  if (s3)
    return Xc;
  s3 = 1, Object.defineProperty(Xc, "__esModule", { value: !0 }), Xc.IpcSocketProvider = void 0;
  const e = void 0;
  return Xc.IpcSocketProvider = e, Xc;
}
var o3;
function M1() {
  return o3 || (o3 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SocketEventSubscriber = e.SocketPendingSubscriber = e.SocketBlockSubscriber = e.SocketSubscriber = e.WebSocketProvider = e.SocketProvider = e.IpcSocketProvider = e.QuickNodeProvider = e.PocketProvider = e.InfuraWebSocketProvider = e.InfuraProvider = e.EtherscanPlugin = e.EtherscanProvider = e.ChainstackProvider = e.CloudflareProvider = e.AnkrProvider = e.AlchemyProvider = e.BrowserProvider = e.JsonRpcSigner = e.JsonRpcProvider = e.JsonRpcApiProvider = e.FallbackProvider = e.copyRequest = e.TransactionResponse = e.TransactionReceipt = e.Log = e.FeeData = e.Block = e.FetchUrlFeeDataNetworkPlugin = e.FeeDataNetworkPlugin = e.EnsPlugin = e.GasCostPlugin = e.NetworkPlugin = e.NonceManager = e.Network = e.MulticoinProviderPlugin = e.EnsResolver = e.getDefaultProvider = e.showThrottleMessage = e.VoidSigner = e.AbstractSigner = e.UnmanagedSubscriber = e.AbstractProvider = void 0;
    var t = yd();
    Object.defineProperty(e, "AbstractProvider", { enumerable: !0, get: function() {
      return t.AbstractProvider;
    } }), Object.defineProperty(e, "UnmanagedSubscriber", { enumerable: !0, get: function() {
      return t.UnmanagedSubscriber;
    } });
    var r = k1();
    Object.defineProperty(e, "AbstractSigner", { enumerable: !0, get: function() {
      return r.AbstractSigner;
    } }), Object.defineProperty(e, "VoidSigner", { enumerable: !0, get: function() {
      return r.VoidSigner;
    } });
    var n = Bo();
    Object.defineProperty(e, "showThrottleMessage", { enumerable: !0, get: function() {
      return n.showThrottleMessage;
    } });
    var s = ik();
    Object.defineProperty(e, "getDefaultProvider", { enumerable: !0, get: function() {
      return s.getDefaultProvider;
    } });
    var i = q5();
    Object.defineProperty(e, "EnsResolver", { enumerable: !0, get: function() {
      return i.EnsResolver;
    } }), Object.defineProperty(e, "MulticoinProviderPlugin", { enumerable: !0, get: function() {
      return i.MulticoinProviderPlugin;
    } });
    var a = Xn();
    Object.defineProperty(e, "Network", { enumerable: !0, get: function() {
      return a.Network;
    } });
    var f = sk();
    Object.defineProperty(e, "NonceManager", { enumerable: !0, get: function() {
      return f.NonceManager;
    } });
    var d = x1();
    Object.defineProperty(e, "NetworkPlugin", { enumerable: !0, get: function() {
      return d.NetworkPlugin;
    } }), Object.defineProperty(e, "GasCostPlugin", { enumerable: !0, get: function() {
      return d.GasCostPlugin;
    } }), Object.defineProperty(e, "EnsPlugin", { enumerable: !0, get: function() {
      return d.EnsPlugin;
    } }), Object.defineProperty(e, "FeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return d.FeeDataNetworkPlugin;
    } }), Object.defineProperty(e, "FetchUrlFeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return d.FetchUrlFeeDataNetworkPlugin;
    } });
    var c = md();
    Object.defineProperty(e, "Block", { enumerable: !0, get: function() {
      return c.Block;
    } }), Object.defineProperty(e, "FeeData", { enumerable: !0, get: function() {
      return c.FeeData;
    } }), Object.defineProperty(e, "Log", { enumerable: !0, get: function() {
      return c.Log;
    } }), Object.defineProperty(e, "TransactionReceipt", { enumerable: !0, get: function() {
      return c.TransactionReceipt;
    } }), Object.defineProperty(e, "TransactionResponse", { enumerable: !0, get: function() {
      return c.TransactionResponse;
    } }), Object.defineProperty(e, "copyRequest", { enumerable: !0, get: function() {
      return c.copyRequest;
    } });
    var p = r8();
    Object.defineProperty(e, "FallbackProvider", { enumerable: !0, get: function() {
      return p.FallbackProvider;
    } });
    var g = Qi();
    Object.defineProperty(e, "JsonRpcApiProvider", { enumerable: !0, get: function() {
      return g.JsonRpcApiProvider;
    } }), Object.defineProperty(e, "JsonRpcProvider", { enumerable: !0, get: function() {
      return g.JsonRpcProvider;
    } }), Object.defineProperty(e, "JsonRpcSigner", { enumerable: !0, get: function() {
      return g.JsonRpcSigner;
    } });
    var v = ok();
    Object.defineProperty(e, "BrowserProvider", { enumerable: !0, get: function() {
      return v.BrowserProvider;
    } });
    var O = Q5();
    Object.defineProperty(e, "AlchemyProvider", { enumerable: !0, get: function() {
      return O.AlchemyProvider;
    } });
    var N = J5();
    Object.defineProperty(e, "AnkrProvider", { enumerable: !0, get: function() {
      return N.AnkrProvider;
    } });
    var S = Y5();
    Object.defineProperty(e, "CloudflareProvider", { enumerable: !0, get: function() {
      return S.CloudflareProvider;
    } });
    var j = Z5();
    Object.defineProperty(e, "ChainstackProvider", { enumerable: !0, get: function() {
      return j.ChainstackProvider;
    } });
    var B = X5();
    Object.defineProperty(e, "EtherscanProvider", { enumerable: !0, get: function() {
      return B.EtherscanProvider;
    } }), Object.defineProperty(e, "EtherscanPlugin", { enumerable: !0, get: function() {
      return B.EtherscanPlugin;
    } });
    var M = e8();
    Object.defineProperty(e, "InfuraProvider", { enumerable: !0, get: function() {
      return M.InfuraProvider;
    } }), Object.defineProperty(e, "InfuraWebSocketProvider", { enumerable: !0, get: function() {
      return M.InfuraWebSocketProvider;
    } });
    var I = ak();
    Object.defineProperty(e, "PocketProvider", { enumerable: !0, get: function() {
      return I.PocketProvider;
    } });
    var A = t8();
    Object.defineProperty(e, "QuickNodeProvider", { enumerable: !0, get: function() {
      return A.QuickNodeProvider;
    } });
    const R = uk();
    Object.defineProperty(e, "IpcSocketProvider", { enumerable: !0, get: function() {
      return R.IpcSocketProvider;
    } });
    var L = Lp();
    Object.defineProperty(e, "SocketProvider", { enumerable: !0, get: function() {
      return L.SocketProvider;
    } });
    var K = S1();
    Object.defineProperty(e, "WebSocketProvider", { enumerable: !0, get: function() {
      return K.WebSocketProvider;
    } });
    var $ = Lp();
    Object.defineProperty(e, "SocketSubscriber", { enumerable: !0, get: function() {
      return $.SocketSubscriber;
    } }), Object.defineProperty(e, "SocketBlockSubscriber", { enumerable: !0, get: function() {
      return $.SocketBlockSubscriber;
    } }), Object.defineProperty(e, "SocketPendingSubscriber", { enumerable: !0, get: function() {
      return $.SocketPendingSubscriber;
    } }), Object.defineProperty(e, "SocketEventSubscriber", { enumerable: !0, get: function() {
      return $.SocketEventSubscriber;
    } });
  }(C2)), C2;
}
var a3 = {}, el = {}, u3;
function I1() {
  var e;
  if (u3)
    return el;
  u3 = 1, Object.defineProperty(el, "__esModule", { value: !0 }), el.BaseWallet = void 0;
  const t = Yr(), r = no(), n = M1(), s = Yn(), i = wt(), a = class i8 extends n.AbstractSigner {
    /**
     *  Creates a new BaseWallet for %%privateKey%%, optionally
     *  connected to %%provider%%.
     *
     *  If %%provider%% is not specified, only offline methods can
     *  be used.
     */
    constructor(c, p) {
      super(p), Be(this, "address"), _e(this, e, void 0), (0, i.assertArgument)(c && typeof c.sign == "function", "invalid private key", "privateKey", "[ REDACTED ]"), Oe(this, e, c);
      const g = (0, s.computeAddress)(this.signingKey.publicKey);
      (0, i.defineProperties)(this, { address: g });
    }
    // Store private values behind getters to reduce visibility
    // in console.log
    /**
     *  The [[SigningKey]] used for signing payloads.
     */
    get signingKey() {
      return oe(this, e);
    }
    /**
     *  The private key for this wallet.
     */
    get privateKey() {
      return this.signingKey.privateKey;
    }
    async getAddress() {
      return this.address;
    }
    connect(c) {
      return new i8(oe(this, e), c);
    }
    async signTransaction(c) {
      const { to: p, from: g } = await (0, i.resolveProperties)({
        to: c.to ? (0, t.resolveAddress)(c.to, this.provider) : void 0,
        from: c.from ? (0, t.resolveAddress)(c.from, this.provider) : void 0
      });
      p != null && (c.to = p), g != null && (c.from = g), c.from != null && ((0, i.assertArgument)((0, t.getAddress)(c.from) === this.address, "transaction from address mismatch", "tx.from", c.from), delete c.from);
      const v = s.Transaction.from(c);
      return v.signature = this.signingKey.sign(v.unsignedHash), v.serialized;
    }
    async signMessage(c) {
      return this.signMessageSync(c);
    }
    // @TODO: Add a secialized signTx and signTyped sync that enforces
    // all parameters are known?
    /**
     *  Returns the signature for %%message%% signed with this wallet.
     */
    signMessageSync(c) {
      return this.signingKey.sign((0, r.hashMessage)(c)).serialized;
    }
    async signTypedData(c, p, g) {
      const v = await r.TypedDataEncoder.resolveNames(c, p, g, async (O) => {
        (0, i.assert)(this.provider != null, "cannot resolve ENS names without a provider", "UNSUPPORTED_OPERATION", {
          operation: "resolveName",
          info: { name: O }
        });
        const N = await this.provider.resolveName(O);
        return (0, i.assert)(N != null, "unconfigured ENS name", "UNCONFIGURED_NAME", {
          value: O
        }), N;
      });
      return this.signingKey.sign(r.TypedDataEncoder.hash(v.domain, p, v.value)).serialized;
    }
  };
  e = /* @__PURE__ */ new WeakMap();
  let f = a;
  return el.BaseWallet = f, el;
}
var c3 = {}, tl = {}, rl = {}, aa = {}, l3;
function s8() {
  if (l3)
    return aa;
  l3 = 1, Object.defineProperty(aa, "__esModule", { value: !0 }), aa.decodeOwl = aa.decode = void 0;
  const e = wt(), t = " !#$%&'()*+,-./<=>?@[]^_`{|}~", r = /^[a-z]*$/i;
  function n(a, f) {
    let d = 97;
    return a.reduce((c, p) => (p === f ? d++ : p.match(r) ? c.push(String.fromCharCode(d) + p) : (d = 97, c.push(p)), c), []);
  }
  function s(a, f) {
    for (let p = t.length - 1; p >= 0; p--)
      a = a.split(t[p]).join(f.substring(2 * p, 2 * p + 2));
    const d = [], c = a.replace(/(:|([0-9])|([A-Z][a-z]*))/g, (p, g, v, O) => {
      if (v)
        for (let N = parseInt(v); N >= 0; N--)
          d.push(";");
      else
        d.push(g.toLowerCase());
      return "";
    });
    if (c)
      throw new Error(`leftovers: ${JSON.stringify(c)}`);
    return n(n(d, ";"), ":");
  }
  aa.decode = s;
  function i(a) {
    return (0, e.assertArgument)(a[0] === "0", "unsupported auwl data", "data", a), s(a.substring(1 + 2 * t.length), a.substring(1, 1 + 2 * t.length));
  }
  return aa.decodeOwl = i, aa;
}
var nl = {}, d3;
function o8() {
  if (d3)
    return nl;
  d3 = 1, Object.defineProperty(nl, "__esModule", { value: !0 }), nl.Wordlist = void 0;
  const e = wt();
  class t {
    /**
     *  Creates a new Wordlist instance.
     *
     *  Sub-classes MUST call this if they provide their own constructor,
     *  passing in the locale string of the language.
     *
     *  Generally there is no need to create instances of a Wordlist,
     *  since each language-specific Wordlist creates an instance and
     *  there is no state kept internally, so they are safe to share.
     */
    constructor(n) {
      Be(this, "locale"), (0, e.defineProperties)(this, { locale: n });
    }
    /**
     *  Sub-classes may override this to provide a language-specific
     *  method for spliting %%phrase%% into individual words.
     *
     *  By default, %%phrase%% is split using any sequences of
     *  white-space as defined by regular expressions (i.e. ``/\s+/``).
     */
    split(n) {
      return n.toLowerCase().split(/\s+/g);
    }
    /**
     *  Sub-classes may override this to provider a language-specific
     *  method for joining %%words%% into a phrase.
     *
     *  By default, %%words%% are joined by a single space.
     */
    join(n) {
      return n.join(" ");
    }
  }
  return nl.Wordlist = t, nl;
}
var h3;
function R1() {
  var e, t, r, n, s;
  if (h3)
    return rl;
  h3 = 1, Object.defineProperty(rl, "__esModule", { value: !0 }), rl.WordlistOwl = void 0;
  const i = no(), a = wt(), f = s8(), d = o8();
  class c extends d.Wordlist {
    /**
     *  Creates a new Wordlist for %%locale%% using the OWL %%data%%
     *  and validated against the %%checksum%%.
     */
    constructor(g, v, O) {
      super(g), _e(this, n), _e(this, e, void 0), _e(this, t, void 0), _e(this, r, void 0), Oe(this, e, v), Oe(this, t, O), Oe(this, r, null);
    }
    /**
     *  The OWL-encoded data.
     */
    get _data() {
      return oe(this, e);
    }
    /**
     *  Decode all the words for the wordlist.
     */
    _decodeWords() {
      return (0, f.decodeOwl)(oe(this, e));
    }
    getWord(g) {
      const v = Ve(this, n, s).call(this);
      return (0, a.assertArgument)(g >= 0 && g < v.length, `invalid word index: ${g}`, "index", g), v[g];
    }
    getWordIndex(g) {
      return Ve(this, n, s).call(this).indexOf(g);
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakSet(), s = function() {
    if (oe(this, r) == null) {
      const p = this._decodeWords();
      if ((0, i.id)(p.join(`
`) + `
`) !== oe(this, t))
        throw new Error(`BIP39 Wordlist for ${this.locale} FAILED`);
      Oe(this, r, p);
    }
    return oe(this, r);
  }, rl.WordlistOwl = c, rl;
}
var f3;
function af() {
  if (f3)
    return tl;
  f3 = 1, Object.defineProperty(tl, "__esModule", { value: !0 }), tl.LangEn = void 0;
  const e = R1(), t = "0erleonalorenseinceregesticitStanvetearctssi#ch2Athck&tneLl0And#Il.yLeOutO=S|S%b/ra@SurdU'0Ce[Cid|CountCu'Hie=IdOu,-Qui*Ro[TT]T%T*[Tu$0AptDD-tD*[Ju,M.UltV<)Vi)0Rob-0FairF%dRaid0A(EEntRee0Ead0MRRp%tS!_rmBumCoholErtI&LLeyLowMo,O}PhaReadySoT Ways0A>urAz(gOngOuntU'd0Aly,Ch%Ci|G G!GryIm$K!Noun)Nu$O` Sw T&naTiqueXietyY1ArtOlogyPe?P!Pro=Ril1ChCt-EaEnaGueMMedM%MyOundR<+Re,Ri=RowTTefa@Ti,Tw%k0KPe@SaultSetSi,SumeThma0H!>OmTa{T&dT.udeTra@0Ct]D.Gu,NtTh%ToTumn0Era+OcadoOid0AkeA*AyEsomeFulKw?d0Is:ByChel%C#D+GL<)Lc#y~MbooN<aNn RRelyRga(R*lSeS-SketTt!3A^AnAutyCau'ComeEfF%eG(Ha=H(dLie=LowLtN^Nef./TrayTt Twe&Y#d3Cyc!DKeNdOlogyRdR`Tt _{AdeAmeAnketA,EakE[IndOodO[omOu'UeUrUsh_rdAtDyIlMbNeNusOkO,Rd R(gRrowSsTtomUn)XY_{etA(AndA[A=EadEezeI{Id+IefIghtIngIskOccoliOk&OnzeOomO` OwnUsh2Bb!DdyD+tFf$oIldLbLkL!tNd!Nk Rd&Rg R,SS(e[SyTt Y Zz:Bba+B(B!CtusGeKe~LmM aMpNN$N)lNdyNn#NoeNvasNy#Pab!P.$Pta(RRb#RdRgoRpetRryRtSeShS(o/!Su$TT$ogT^Teg%yTt!UghtU'Ut]Ve3Il(gL yM|NsusNturyRe$Rta(_irAlkAmp]An+AosApt Ar+A'AtEapE{Ee'EfErryE,I{&IefIldIm}yOi)Oo'R#-U{!UnkUrn0G?Nnam#Rc!Tiz&TyVil_imApArifyAwAyE<ErkEv I{I|IffImbIn-IpO{OgO'O`OudOwnUbUmpU, Ut^_^A,C#utDeFfeeIlInL!@L%LumnMb(eMeMf%tM-Mm#Mp<yNc tNdu@NfirmNg*[N}@Nsid NtrolNv()OkOlPp PyR$ReRnR*@/Tt#U^UntryUp!Ur'Us(V Yo>_{Ad!AftAmA}AshAt AwlAzyEamEd.EekEwI{etImeIspIt-OpO[Ou^OwdUci$UelUi'Umb!Un^UshYY,$2BeLtu*PPbo?dRiousRr|Rta(R=Sh]/omTe3C!:DMa+MpN)Ng R(gShUght WnY3AlBa>BrisCadeCemb CideCl(eC%a>C*a'ErF&'F(eFyG*eLayLiv M<dMi'Ni$Nti,NyP?tP&dPos.P`PutyRi=ScribeS tSignSkSpair/royTailTe@VelopVi)Vo>3AgramAlAm#dAryCeE'lEtFf G.$Gn.yLemmaNn NosaurRe@RtSag*eScov Sea'ShSmi[S%d Splay/<)V tVideV%)Zzy5Ct%Cum|G~Lph(Ma(Na>NkeyN%OrSeUb!Ve_ftAg#AmaA,-AwEamE[IftIllInkIpI=OpUmY2CkMbNeR(g/T^Ty1Arf1Nam-:G G!RlyRnR`Sily/Sy1HoOlogyOnomy0GeItUca>1F%t0G1GhtTh 2BowD E@r-Eg<tEm|Eph<tEvat%I>Se0B?kBodyBra)Er+Ot]PloyPow Pty0Ab!A@DD![D%'EmyErgyF%)Ga+G(eH<)JoyLi,OughR-hRollSu*T Ti*TryVelope1Isode0U$Uip0AA'OdeOs]R%Upt0CapeSayS&)Ta>0Ern$H-s1Id&)IlOkeOl=1A@Amp!Ce[Ch<+C.eCludeCu'Ecu>Erci'Hau,Hib.I!I,ItOt-P<dPe@Pi*Pla(Po'P*[T&dTra0EEbrow:Br-CeCultyDeIntI`~L'MeMilyMousNNcyNtasyRmSh]TT$Th TigueUltV%.e3Atu*Bru?yD $EEdElMa!N)/iv$T^V W3B Ct]EldGu*LeLmLt N$NdNeNg NishReRmR,Sc$ShTT}[X_gAmeAshAtAv%EeIghtIpOatO{O%Ow UidUshY_mCusGIlLd~owOdOtR)Re,R+tRkRtu}RumRw?dSsil/ UndX_gi!AmeEqu|EshI&dIn+OgOntO,OwnOz&U.2ElNNnyRna)RyTu*:D+tInLaxy~ yMePRa+Rba+Rd&Rl-Rm|SSpTeTh U+Ze3N $NiusN*Nt!Nu(e/u*2O,0AntFtGg!Ng RaffeRlVe_dAn)A*A[IdeImp'ObeOomOryO=OwUe_tDde[LdOdO'RillaSpelSsipV nWn_bA)A(AntApeA[Av.yEatE&IdIefItOc yOupOwUnt_rdE[IdeIltIt?N3M:B.IrLfMm M, NdPpyRb%RdRshR=,TVeWkZ?d3AdAl`ArtAvyD+hogIght~oLmetLpNRo3Dd&Gh~NtPRe/%y5BbyCkeyLdLeLiday~owMeNeyOdPeRnRr%R'Sp.$/TelUrV 5BGeM<Mb!M%Nd*dNgryNtRd!RryRtSb<d3Brid:1EOn0EaEntifyLe2N%e4LLeg$L}[0A+Ita>M&'Mu}Pa@Po'Pro=Pul'0ChCludeComeC*a'DexD-a>Do%Du,ryF<tFl-tF%mHa!H .Iti$Je@JuryMa>N Noc|PutQuiryS<eSe@SideSpi*/$lTa@T e,ToVe,V.eVol=3On0L<dOla>Sue0Em1Ory:CketGu?RZz3AlousAns~yWel9BInKeUr}yY5D+I)MpNg!Ni%Nk/:Ng?oo3EnEpT^upY3CkDD}yNdNgdomSsTT^&TeTt&Wi4EeIfeO{Ow:BBelB%Dd DyKeMpNgua+PtopR+T T(UghUndryVaWWnWsu.Y Zy3Ad AfArnA=Ctu*FtGG$G&dIsu*M#NdNg`NsOp?dSs#Tt Vel3ArB tyBr?yC&'FeFtGhtKeMbM.NkOnQuid/Tt!VeZ?d5AdAnB, C$CkG-NelyNgOpTt yUdUn+VeY$5CkyGga+Mb N?N^Xury3R-s:Ch(eDG-G}tIdIlInJ%KeMm$NNa+Nda>NgoNs]Nu$P!Rb!R^Rg(R(eRketRria+SkSs/ T^T i$ThTrixTt XimumZe3AdowAnAsu*AtCh<-D$DiaLodyLtMb M%yNt]NuRcyR+R.RryShSsa+T$Thod3Dd!DnightLk~]M-NdNimumN%Nu>Rac!Rr%S ySs/akeXXedXtu*5Bi!DelDifyMM|N.%NkeyN, N`OnR$ReRn(gSqu.oTh T]T%Unta(U'VeVie5ChFf(LeLtiplySc!SeumShroomS-/Tu$3Self/ yTh:I=MePk(Rrow/yT]Tu*3ArCkEdGati=G!@I` PhewR=/TTw%kUtr$V WsXt3CeGht5B!I'M(eeOd!Rm$R`SeTab!TeTh(gTi)VelW5C!?Mb R'T:K0EyJe@Li+Scu*S =Ta(Vious0CurE<Tob 0Or1FF Fi)T&2L1Ay0DI=Ymp-0It0CeEI#L(eLy1EnEraIn]Po'T]1An+B.Ch?dD D(?yG<I|Ig($Ph<0Tr-h0H 0Tdo%T TputTside0AlEnEr0NN 0Yg&0/ 0O}:CtDd!GeIrLa)LmNdaNelN-N` P RadeR|RkRrotRtySsT^ThTi|TrolTt nU'VeYm|3A)AnutArAs<tL-<NN$tyNcilOp!Pp Rfe@Rm.Rs#T2O}OtoRa'Ys-$0AnoCn-Ctu*E)GGe#~LotNkO} Pe/olT^Zza_)A}tA,-A>AyEa'Ed+U{UgUn+2EmEtIntL?LeLi)NdNyOlPul?Rt]S.]Ssib!/TatoTt yV tyWd W _@i)Ai'Ed-tEf Epa*Es|EttyEv|I)IdeIm?yIntI%.yIs#Iva>IzeOb!mO)[Odu)Of.OgramOje@Omo>OofOp tyOsp O>@OudOvide2Bl-Dd(g~LpL'Mpk(N^PilPpyR^a'R.yRpo'R'ShTZz!3Ramid:99Al.yAntumArt E,]I{ItIzO>:Bb.Cco#CeCkD?DioIlInI'~yMpN^NdomN+PidReTeTh V&WZ%3AdyAlAs#BelBuildC$lCei=CipeC%dCyc!Du)F!@F%mFu'G]G*tGul?Je@LaxLea'LiefLyMa(Memb M(dMo=Nd NewNtOp&PairPeatPla)P%tQui*ScueSemb!Si,Sour)Sp#'SultTi*T*atTurnUn]Ve$ViewW?d2Y`m0BBb#CeChDeD+F!GhtGidNgOtPp!SkTu$V$V 5AdA,BotBu,CketM<)OfOkieOmSeTa>UghUndU>Y$5Bb DeGLeNNwayR$:DDd!D}[FeIlLadLm#L#LtLu>MeMp!NdTisfyToshiU)Usa+VeY1A!AnA*Att E}HemeHoolI&)I[%sOrp]OutRapRe&RiptRub1AAr^As#AtC#dC*tCt]Cur.yEdEkGm|Le@~M(?Ni%N'Nt&)RiesRvi)Ss]Tt!TupV&_dowAftAllowA*EdEllEriffIeldIftI}IpIv O{OeOotOpOrtOuld O=RimpRugUff!Y0Bl(gCkDeE+GhtGnL|Lk~yLv Mil?Mp!N)NgR&/ Tua>XZe1A>Et^IIllInIrtUll0AbAmEepEnd I)IdeIghtImOg<OtOwUsh0AllArtI!OkeOo`0A{AkeApIffOw0ApCc Ci$CkDaFtL?Ldi LidLut]L=Me#eNgOnRryRtUlUndUpUr)U`0A)A*Ati$AwnEakEci$EedEllEndH eI)Id IkeInIr.L.OilOns%O#OrtOtRayReadR(gY0Ua*UeezeUir*l_b!AdiumAffA+AirsAmpAndArtA>AyEakEelEmEpE*oI{IllIngO{Oma^O}OolOryO=Ra>gyReetRikeR#gRugg!Ud|UffUmb!Y!0Bje@Bm.BwayC)[ChDd&Ff G?G+,ItMm NNnyN'tP PplyP*meReRfa)R+Rpri'RroundR=ySpe@/a(1AllowAmpApArmE?EetIftImIngIt^Ord1MbolMptomRup/em:B!Ck!GIlL|LkNkPeR+tSk/eTtooXi3A^Am~NN<tNnisNtRm/Xt_nkAtEmeEnE%yE*EyIngIsOughtReeRi=RowUmbUnd 0CketDeG LtMb MeNyPRedSsueT!5A,BaccoDayDdl EGe` I!tK&MatoM%rowNeNgueNightOlO`PP-Pp!R^RnadoRtoi'SsT$Uri,W?dW WnY_{AdeAff-Ag-A(Ansf ApAshA=lAyEatEeEndI$IbeI{Igg ImIpOphyOub!U{UeUlyUmpetU,U`Y2BeIt]Mb!NaN}lRkeyRnRt!1El=EntyI)InI,O1PeP-$:5Ly5B*lla0Ab!Awa*C!Cov D DoFairFoldHappyIf%mIqueItIv 'KnownLo{TilUsu$Veil1Da>GradeHoldOnP Set1B<Ge0A+EEdEfulE![U$0Il.y:C<tCuumGueLidL!yL=NNishP%Rious/Ult3H-!L=tNd%Ntu*NueRbRifyRs]RyS'lT <3Ab!Br<tCiousCt%yDeoEw~a+Nta+Ol(Rtu$RusSaS.Su$T$Vid5C$I)IdLc<oLumeTeYa+:GeG#ItLk~LnutNtRfa*RmRri%ShSp/eT VeY3Al`Ap#ArA'lA` BDd(gEk&dIrdLcome/T_!AtEatEelEnE*IpIsp 0DeD`FeLd~NNdowNeNgNkNn Nt ReSdomSeShT}[5LfM<Nd OdOlRdRkRldRryR`_pE{E,!I,I>Ong::Rd3Ar~ow9UUngU`:3BraRo9NeO", r = "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60";
  let n = null;
  class s extends e.WordlistOwl {
    /**
     *  Creates a new instance of the English language Wordlist.
     *
     *  This should be unnecessary most of the time as the exported
     *  [[langEn]] should suffice.
     *
     *  @_ignore:
     */
    constructor() {
      super("en", t, r);
    }
    /**
     *  Returns a singleton instance of a ``LangEn``, creating it
     *  if this is the first time being called.
     */
    static wordlist() {
      return n == null && (n = new s()), n;
    }
  }
  return tl.LangEn = s, tl;
}
var il = {}, p3;
function C1() {
  if (p3)
    return il;
  p3 = 1, Object.defineProperty(il, "__esModule", { value: !0 }), il.Mnemonic = void 0;
  const e = cn(), t = wt(), r = af();
  function n(c) {
    return (1 << c) - 1 << 8 - c & 255;
  }
  function s(c) {
    return (1 << c) - 1 & 255;
  }
  function i(c, p) {
    (0, t.assertNormalize)("NFKD"), p == null && (p = r.LangEn.wordlist());
    const g = p.split(c);
    (0, t.assertArgument)(g.length % 3 === 0 && g.length >= 12 && g.length <= 24, "invalid mnemonic length", "mnemonic", "[ REDACTED ]");
    const v = new Uint8Array(Math.ceil(11 * g.length / 8));
    let O = 0;
    for (let M = 0; M < g.length; M++) {
      let I = p.getWordIndex(g[M].normalize("NFKD"));
      (0, t.assertArgument)(I >= 0, `invalid mnemonic word at index ${M}`, "mnemonic", "[ REDACTED ]");
      for (let A = 0; A < 11; A++)
        I & 1 << 10 - A && (v[O >> 3] |= 1 << 7 - O % 8), O++;
    }
    const N = 32 * g.length / 3, S = g.length / 3, j = n(S), B = (0, t.getBytes)((0, e.sha256)(v.slice(0, N / 8)))[0] & j;
    return (0, t.assertArgument)(B === (v[v.length - 1] & j), "invalid mnemonic checksum", "mnemonic", "[ REDACTED ]"), (0, t.hexlify)(v.slice(0, N / 8));
  }
  function a(c, p) {
    (0, t.assertArgument)(c.length % 4 === 0 && c.length >= 16 && c.length <= 32, "invalid entropy size", "entropy", "[ REDACTED ]"), p == null && (p = r.LangEn.wordlist());
    const g = [0];
    let v = 11;
    for (let S = 0; S < c.length; S++)
      v > 8 ? (g[g.length - 1] <<= 8, g[g.length - 1] |= c[S], v -= 8) : (g[g.length - 1] <<= v, g[g.length - 1] |= c[S] >> 8 - v, g.push(c[S] & s(8 - v)), v += 3);
    const O = c.length / 4, N = parseInt((0, e.sha256)(c).substring(2, 4), 16) & n(O);
    return g[g.length - 1] <<= O, g[g.length - 1] |= N >> 8 - O, p.join(g.map((S) => p.getWord(S)));
  }
  const f = {};
  class d {
    /**
     *  @private
     */
    constructor(p, g, v, O, N) {
      Be(this, "phrase"), Be(this, "password"), Be(this, "wordlist"), Be(this, "entropy"), O == null && (O = ""), N == null && (N = r.LangEn.wordlist()), (0, t.assertPrivate)(p, f, "Mnemonic"), (0, t.defineProperties)(this, { phrase: v, password: O, wordlist: N, entropy: g });
    }
    /**
     *  Returns the seed for the mnemonic.
     */
    computeSeed() {
      const p = (0, t.toUtf8Bytes)("mnemonic" + this.password, "NFKD");
      return (0, e.pbkdf2)((0, t.toUtf8Bytes)(this.phrase, "NFKD"), p, 2048, 64, "sha512");
    }
    /**
     *  Creates a new Mnemonic for the %%phrase%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */
    static fromPhrase(p, g, v) {
      const O = i(p, v);
      return p = a((0, t.getBytes)(O), v), new d(f, O, p, g, v);
    }
    /**
     *  Create a new **Mnemonic** from the %%entropy%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */
    static fromEntropy(p, g, v) {
      const O = (0, t.getBytes)(p, "entropy"), N = a(O, v);
      return new d(f, (0, t.hexlify)(O), N, g, v);
    }
    /**
     *  Returns the phrase for %%mnemonic%%.
     */
    static entropyToPhrase(p, g) {
      const v = (0, t.getBytes)(p, "entropy");
      return a(v, g);
    }
    /**
     *  Returns the entropy for %%phrase%%.
     */
    static phraseToEntropy(p, g) {
      return i(p, g);
    }
    /**
     *  Returns true if %%phrase%% is a valid [[link-bip-39]] phrase.
     *
     *  This checks all the provided words belong to the %%wordlist%%,
     *  that the length is valid and the checksum is correct.
     */
    static isValidMnemonic(p, g) {
      try {
        return i(p, g), !0;
      } catch {
      }
      return !1;
    }
  }
  return il.Mnemonic = d, il;
}
var Wn = {}, g3 = {}, sl = {}, m3;
function a8() {
  if (m3)
    return sl;
  m3 = 1;
  /*! MIT License. Copyright 2015-2022 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */
  var e = Ze && Ze.__classPrivateFieldGet || function(K, $, k, V) {
    if (k === "a" && !V)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof $ == "function" ? K !== $ || !V : !$.has(K))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return k === "m" ? V : k === "a" ? V.call(K) : V ? V.value : $.get(K);
  }, t = Ze && Ze.__classPrivateFieldSet || function(K, $, k, V, C) {
    if (V === "m")
      throw new TypeError("Private method is not writable");
    if (V === "a" && !C)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof $ == "function" ? K !== $ || !C : !$.has(K))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return V === "a" ? C.call(K, k) : C ? C.value = k : $.set(K, k), k;
  }, r, n, s;
  Object.defineProperty(sl, "__esModule", { value: !0 }), sl.AES = void 0;
  const i = { 16: 10, 24: 12, 32: 14 }, a = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], f = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], d = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], c = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], p = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], g = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], v = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], O = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], N = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], S = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], j = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], B = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], M = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], I = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], A = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
  function R(K) {
    const $ = [];
    for (let k = 0; k < K.length; k += 4)
      $.push(K[k] << 24 | K[k + 1] << 16 | K[k + 2] << 8 | K[k + 3]);
    return $;
  }
  class L {
    get key() {
      return e(this, r, "f").slice();
    }
    constructor($) {
      if (r.set(this, void 0), n.set(this, void 0), s.set(this, void 0), !(this instanceof L))
        throw Error("AES must be instanitated with `new`");
      t(this, r, new Uint8Array($), "f");
      const k = i[this.key.length];
      if (k == null)
        throw new TypeError("invalid key size (must be 16, 24 or 32 bytes)");
      t(this, s, [], "f"), t(this, n, [], "f");
      for (let E = 0; E <= k; E++)
        e(this, s, "f").push([0, 0, 0, 0]), e(this, n, "f").push([0, 0, 0, 0]);
      const V = (k + 1) * 4, C = this.key.length / 4, D = R(this.key);
      let o;
      for (let E = 0; E < C; E++)
        o = E >> 2, e(this, s, "f")[o][E % 4] = D[E], e(this, n, "f")[k - o][E % 4] = D[E];
      let u = 0, h = C, y;
      for (; h < V; ) {
        if (y = D[C - 1], D[0] ^= f[y >> 16 & 255] << 24 ^ f[y >> 8 & 255] << 16 ^ f[y & 255] << 8 ^ f[y >> 24 & 255] ^ a[u] << 24, u += 1, C != 8)
          for (let m = 1; m < C; m++)
            D[m] ^= D[m - 1];
        else {
          for (let m = 1; m < C / 2; m++)
            D[m] ^= D[m - 1];
          y = D[C / 2 - 1], D[C / 2] ^= f[y & 255] ^ f[y >> 8 & 255] << 8 ^ f[y >> 16 & 255] << 16 ^ f[y >> 24 & 255] << 24;
          for (let m = C / 2 + 1; m < C; m++)
            D[m] ^= D[m - 1];
        }
        let E = 0, P, w;
        for (; E < C && h < V; )
          P = h >> 2, w = h % 4, e(this, s, "f")[P][w] = D[E], e(this, n, "f")[k - P][w] = D[E++], h++;
      }
      for (let E = 1; E < k; E++)
        for (let P = 0; P < 4; P++)
          y = e(this, n, "f")[E][P], e(this, n, "f")[E][P] = B[y >> 24 & 255] ^ M[y >> 16 & 255] ^ I[y >> 8 & 255] ^ A[y & 255];
    }
    encrypt($) {
      if ($.length != 16)
        throw new TypeError("invalid plaintext size (must be 16 bytes)");
      const k = e(this, s, "f").length - 1, V = [0, 0, 0, 0];
      let C = R($);
      for (let u = 0; u < 4; u++)
        C[u] ^= e(this, s, "f")[0][u];
      for (let u = 1; u < k; u++) {
        for (let h = 0; h < 4; h++)
          V[h] = c[C[h] >> 24 & 255] ^ p[C[(h + 1) % 4] >> 16 & 255] ^ g[C[(h + 2) % 4] >> 8 & 255] ^ v[C[(h + 3) % 4] & 255] ^ e(this, s, "f")[u][h];
        C = V.slice();
      }
      const D = new Uint8Array(16);
      let o = 0;
      for (let u = 0; u < 4; u++)
        o = e(this, s, "f")[k][u], D[4 * u] = (f[C[u] >> 24 & 255] ^ o >> 24) & 255, D[4 * u + 1] = (f[C[(u + 1) % 4] >> 16 & 255] ^ o >> 16) & 255, D[4 * u + 2] = (f[C[(u + 2) % 4] >> 8 & 255] ^ o >> 8) & 255, D[4 * u + 3] = (f[C[(u + 3) % 4] & 255] ^ o) & 255;
      return D;
    }
    decrypt($) {
      if ($.length != 16)
        throw new TypeError("invalid ciphertext size (must be 16 bytes)");
      const k = e(this, n, "f").length - 1, V = [0, 0, 0, 0];
      let C = R($);
      for (let u = 0; u < 4; u++)
        C[u] ^= e(this, n, "f")[0][u];
      for (let u = 1; u < k; u++) {
        for (let h = 0; h < 4; h++)
          V[h] = O[C[h] >> 24 & 255] ^ N[C[(h + 3) % 4] >> 16 & 255] ^ S[C[(h + 2) % 4] >> 8 & 255] ^ j[C[(h + 1) % 4] & 255] ^ e(this, n, "f")[u][h];
        C = V.slice();
      }
      const D = new Uint8Array(16);
      let o = 0;
      for (let u = 0; u < 4; u++)
        o = e(this, n, "f")[k][u], D[4 * u] = (d[C[u] >> 24 & 255] ^ o >> 24) & 255, D[4 * u + 1] = (d[C[(u + 3) % 4] >> 16 & 255] ^ o >> 16) & 255, D[4 * u + 2] = (d[C[(u + 2) % 4] >> 8 & 255] ^ o >> 8) & 255, D[4 * u + 3] = (d[C[(u + 1) % 4] & 255] ^ o) & 255;
      return D;
    }
  }
  return sl.AES = L, r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), sl;
}
var ol = {}, y3;
function ac() {
  if (y3)
    return ol;
  y3 = 1, Object.defineProperty(ol, "__esModule", { value: !0 }), ol.ModeOfOperation = void 0;
  const e = a8();
  class t {
    constructor(n, s, i) {
      if (i && !(this instanceof i))
        throw new Error(`${n} must be instantiated with "new"`);
      Object.defineProperties(this, {
        aes: { enumerable: !0, value: new e.AES(s) },
        name: { enumerable: !0, value: n }
      });
    }
  }
  return ol.ModeOfOperation = t, ol;
}
var al = {}, b3;
function ck() {
  if (b3)
    return al;
  b3 = 1;
  var e = Ze && Ze.__classPrivateFieldSet || function(a, f, d, c, p) {
    if (c === "m")
      throw new TypeError("Private method is not writable");
    if (c === "a" && !p)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof f == "function" ? a !== f || !p : !f.has(a))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return c === "a" ? p.call(a, d) : p ? p.value = d : f.set(a, d), d;
  }, t = Ze && Ze.__classPrivateFieldGet || function(a, f, d, c) {
    if (d === "a" && !c)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof f == "function" ? a !== f || !c : !f.has(a))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return d === "m" ? c : d === "a" ? c.call(a) : c ? c.value : f.get(a);
  }, r, n;
  Object.defineProperty(al, "__esModule", { value: !0 }), al.CBC = void 0;
  const s = ac();
  class i extends s.ModeOfOperation {
    constructor(f, d) {
      if (super("ECC", f, i), r.set(this, void 0), n.set(this, void 0), d) {
        if (d.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        e(this, r, new Uint8Array(d), "f");
      } else
        e(this, r, new Uint8Array(16), "f");
      e(this, n, this.iv, "f");
    }
    get iv() {
      return new Uint8Array(t(this, r, "f"));
    }
    encrypt(f) {
      if (f.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const d = new Uint8Array(f.length);
      for (let c = 0; c < f.length; c += 16) {
        for (let p = 0; p < 16; p++)
          t(this, n, "f")[p] ^= f[c + p];
        e(this, n, this.aes.encrypt(t(this, n, "f")), "f"), d.set(t(this, n, "f"), c);
      }
      return d;
    }
    decrypt(f) {
      if (f.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      const d = new Uint8Array(f.length);
      for (let c = 0; c < f.length; c += 16) {
        const p = this.aes.decrypt(f.subarray(c, c + 16));
        for (let g = 0; g < 16; g++)
          d[c + g] = p[g] ^ t(this, n, "f")[g], t(this, n, "f")[g] = f[c + g];
      }
      return d;
    }
  }
  return al.CBC = i, r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), al;
}
var ul = {}, w3;
function lk() {
  if (w3)
    return ul;
  w3 = 1;
  var e = Ze && Ze.__classPrivateFieldSet || function(d, c, p, g, v) {
    if (g === "m")
      throw new TypeError("Private method is not writable");
    if (g === "a" && !v)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof c == "function" ? d !== c || !v : !c.has(d))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return g === "a" ? v.call(d, p) : v ? v.value = p : c.set(d, p), p;
  }, t = Ze && Ze.__classPrivateFieldGet || function(d, c, p, g) {
    if (p === "a" && !g)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof c == "function" ? d !== c || !g : !c.has(d))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return p === "m" ? g : p === "a" ? g.call(d) : g ? g.value : c.get(d);
  }, r, n, s, i;
  Object.defineProperty(ul, "__esModule", { value: !0 }), ul.CFB = void 0;
  const a = ac();
  class f extends a.ModeOfOperation {
    constructor(c, p, g = 8) {
      if (super("CFB", c, f), r.add(this), n.set(this, void 0), s.set(this, void 0), !Number.isInteger(g) || g % 8)
        throw new TypeError("invalid segmentSize");
      if (Object.defineProperties(this, {
        segmentSize: { enumerable: !0, value: g }
      }), p) {
        if (p.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        e(this, n, new Uint8Array(p), "f");
      } else
        e(this, n, new Uint8Array(16), "f");
      e(this, s, this.iv, "f");
    }
    get iv() {
      return new Uint8Array(t(this, n, "f"));
    }
    encrypt(c) {
      if (8 * c.length % this.segmentSize)
        throw new TypeError("invalid plaintext size (must be multiple of segmentSize bytes)");
      const p = this.segmentSize / 8, g = new Uint8Array(c);
      for (let v = 0; v < g.length; v += p) {
        const O = this.aes.encrypt(t(this, s, "f"));
        for (let N = 0; N < p; N++)
          g[v + N] ^= O[N];
        t(this, r, "m", i).call(this, g.subarray(v));
      }
      return g;
    }
    decrypt(c) {
      if (8 * c.length % this.segmentSize)
        throw new TypeError("invalid ciphertext size (must be multiple of segmentSize bytes)");
      const p = this.segmentSize / 8, g = new Uint8Array(c);
      for (let v = 0; v < g.length; v += p) {
        const O = this.aes.encrypt(t(this, s, "f"));
        for (let N = 0; N < p; N++)
          g[v + N] ^= O[N];
        t(this, r, "m", i).call(this, c.subarray(v));
      }
      return g;
    }
  }
  return ul.CFB = f, n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakSet(), i = function(d) {
    const c = this.segmentSize / 8;
    t(this, s, "f").set(t(this, s, "f").subarray(c)), t(this, s, "f").set(d.subarray(0, c), 16 - c);
  }, ul;
}
var cl = {}, v3;
function dk() {
  if (v3)
    return cl;
  v3 = 1;
  var e = Ze && Ze.__classPrivateFieldSet || function(f, d, c, p, g) {
    if (p === "m")
      throw new TypeError("Private method is not writable");
    if (p === "a" && !g)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof d == "function" ? f !== d || !g : !d.has(f))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return p === "a" ? g.call(f, c) : g ? g.value = c : d.set(f, c), c;
  }, t = Ze && Ze.__classPrivateFieldGet || function(f, d, c, p) {
    if (c === "a" && !p)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof d == "function" ? f !== d || !p : !d.has(f))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return c === "m" ? p : c === "a" ? p.call(f) : p ? p.value : d.get(f);
  }, r, n, s;
  Object.defineProperty(cl, "__esModule", { value: !0 }), cl.CTR = void 0;
  const i = ac();
  class a extends i.ModeOfOperation {
    constructor(d, c) {
      super("CTR", d, a), r.set(this, void 0), n.set(this, void 0), s.set(this, void 0), e(this, s, new Uint8Array(16), "f"), t(this, s, "f").fill(0), e(this, r, t(this, s, "f"), "f"), e(this, n, 16, "f"), c == null && (c = 1), typeof c == "number" ? this.setCounterValue(c) : this.setCounterBytes(c);
    }
    get counter() {
      return new Uint8Array(t(this, s, "f"));
    }
    setCounterValue(d) {
      if (!Number.isInteger(d) || d < 0 || d > Number.MAX_SAFE_INTEGER)
        throw new TypeError("invalid counter initial integer value");
      for (let c = 15; c >= 0; --c)
        t(this, s, "f")[c] = d % 256, d = Math.floor(d / 256);
    }
    setCounterBytes(d) {
      if (d.length !== 16)
        throw new TypeError("invalid counter initial Uint8Array value length");
      t(this, s, "f").set(d);
    }
    increment() {
      for (let d = 15; d >= 0; d--)
        if (t(this, s, "f")[d] === 255)
          t(this, s, "f")[d] = 0;
        else {
          t(this, s, "f")[d]++;
          break;
        }
    }
    encrypt(d) {
      var c, p;
      const g = new Uint8Array(d);
      for (let v = 0; v < g.length; v++)
        t(this, n, "f") === 16 && (e(this, r, this.aes.encrypt(t(this, s, "f")), "f"), e(this, n, 0, "f"), this.increment()), g[v] ^= t(this, r, "f")[e(this, n, (p = t(this, n, "f"), c = p++, p), "f"), c];
      return g;
    }
    decrypt(d) {
      return this.encrypt(d);
    }
  }
  return cl.CTR = a, r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), cl;
}
var ll = {}, A3;
function hk() {
  if (A3)
    return ll;
  A3 = 1, Object.defineProperty(ll, "__esModule", { value: !0 }), ll.ECB = void 0;
  const e = ac();
  class t extends e.ModeOfOperation {
    constructor(n) {
      super("ECB", n, t);
    }
    encrypt(n) {
      if (n.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const s = new Uint8Array(n.length);
      for (let i = 0; i < n.length; i += 16)
        s.set(this.aes.encrypt(n.subarray(i, i + 16)), i);
      return s;
    }
    decrypt(n) {
      if (n.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      const s = new Uint8Array(n.length);
      for (let i = 0; i < n.length; i += 16)
        s.set(this.aes.decrypt(n.subarray(i, i + 16)), i);
      return s;
    }
  }
  return ll.ECB = t, ll;
}
var dl = {}, E3;
function fk() {
  if (E3)
    return dl;
  E3 = 1;
  var e = Ze && Ze.__classPrivateFieldSet || function(f, d, c, p, g) {
    if (p === "m")
      throw new TypeError("Private method is not writable");
    if (p === "a" && !g)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof d == "function" ? f !== d || !g : !d.has(f))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return p === "a" ? g.call(f, c) : g ? g.value = c : d.set(f, c), c;
  }, t = Ze && Ze.__classPrivateFieldGet || function(f, d, c, p) {
    if (c === "a" && !p)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof d == "function" ? f !== d || !p : !d.has(f))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return c === "m" ? p : c === "a" ? p.call(f) : p ? p.value : d.get(f);
  }, r, n, s;
  Object.defineProperty(dl, "__esModule", { value: !0 }), dl.OFB = void 0;
  const i = ac();
  class a extends i.ModeOfOperation {
    constructor(d, c) {
      if (super("OFB", d, a), r.set(this, void 0), n.set(this, void 0), s.set(this, void 0), c) {
        if (c.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        e(this, r, new Uint8Array(c), "f");
      } else
        e(this, r, new Uint8Array(16), "f");
      e(this, n, this.iv, "f"), e(this, s, 16, "f");
    }
    get iv() {
      return new Uint8Array(t(this, r, "f"));
    }
    encrypt(d) {
      var c, p;
      if (d.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const g = new Uint8Array(d);
      for (let v = 0; v < g.length; v++)
        t(this, s, "f") === 16 && (e(this, n, this.aes.encrypt(t(this, n, "f")), "f"), e(this, s, 0, "f")), g[v] ^= t(this, n, "f")[e(this, s, (p = t(this, s, "f"), c = p++, p), "f"), c];
      return g;
    }
    decrypt(d) {
      if (d.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      return this.encrypt(d);
    }
  }
  return dl.OFB = a, r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), dl;
}
var ua = {}, P3;
function pk() {
  if (P3)
    return ua;
  P3 = 1, Object.defineProperty(ua, "__esModule", { value: !0 }), ua.pkcs7Strip = ua.pkcs7Pad = void 0;
  function e(r) {
    const n = 16 - r.length % 16, s = new Uint8Array(r.length + n);
    s.set(r);
    for (let i = r.length; i < s.length; i++)
      s[i] = n;
    return s;
  }
  ua.pkcs7Pad = e;
  function t(r) {
    if (r.length < 16)
      throw new TypeError("PKCS#7 invalid length");
    const n = r[r.length - 1];
    if (n > 16)
      throw new TypeError("PKCS#7 padding byte out of range");
    const s = r.length - n;
    for (let i = 0; i < n; i++)
      if (r[s + i] !== n)
        throw new TypeError("PKCS#7 invalid padding byte");
    return new Uint8Array(r.subarray(0, s));
  }
  return ua.pkcs7Strip = t, ua;
}
var O3;
function u8() {
  return O3 || (O3 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.pkcs7Strip = e.pkcs7Pad = e.OFB = e.ECB = e.CTR = e.CFB = e.CBC = e.ModeOfOperation = e.AES = void 0;
    var t = a8();
    Object.defineProperty(e, "AES", { enumerable: !0, get: function() {
      return t.AES;
    } });
    var r = ac();
    Object.defineProperty(e, "ModeOfOperation", { enumerable: !0, get: function() {
      return r.ModeOfOperation;
    } });
    var n = ck();
    Object.defineProperty(e, "CBC", { enumerable: !0, get: function() {
      return n.CBC;
    } });
    var s = lk();
    Object.defineProperty(e, "CFB", { enumerable: !0, get: function() {
      return s.CFB;
    } });
    var i = dk();
    Object.defineProperty(e, "CTR", { enumerable: !0, get: function() {
      return i.CTR;
    } });
    var a = hk();
    Object.defineProperty(e, "ECB", { enumerable: !0, get: function() {
      return a.ECB;
    } });
    var f = fk();
    Object.defineProperty(e, "OFB", { enumerable: !0, get: function() {
      return f.OFB;
    } });
    var d = pk();
    Object.defineProperty(e, "pkcs7Pad", { enumerable: !0, get: function() {
      return d.pkcs7Pad;
    } }), Object.defineProperty(e, "pkcs7Strip", { enumerable: !0, get: function() {
      return d.pkcs7Strip;
    } });
  }(g3)), g3;
}
var Oi = {}, N3;
function c8() {
  if (N3)
    return Oi;
  N3 = 1, Object.defineProperty(Oi, "__esModule", { value: !0 }), Oi.spelunk = Oi.getPassword = Oi.zpad = Oi.looseArrayify = void 0;
  const e = wt();
  function t(i) {
    return typeof i == "string" && !i.startsWith("0x") && (i = "0x" + i), (0, e.getBytesCopy)(i);
  }
  Oi.looseArrayify = t;
  function r(i, a) {
    for (i = String(i); i.length < a; )
      i = "0" + i;
    return i;
  }
  Oi.zpad = r;
  function n(i) {
    return typeof i == "string" ? (0, e.toUtf8Bytes)(i, "NFKC") : (0, e.getBytesCopy)(i);
  }
  Oi.getPassword = n;
  function s(i, a) {
    const f = a.match(/^([a-z0-9$_.-]*)(:([a-z]+))?(!)?$/i);
    (0, e.assertArgument)(f != null, "invalid path", "path", a);
    const d = f[1], c = f[3], p = f[4] === "!";
    let g = i;
    for (const v of d.toLowerCase().split(".")) {
      if (Array.isArray(g)) {
        if (!v.match(/^[0-9]+$/))
          break;
        g = g[parseInt(v)];
      } else if (typeof g == "object") {
        let O = null;
        for (const N in g)
          if (N.toLowerCase() === v) {
            O = g[N];
            break;
          }
        g = O;
      } else
        g = null;
      if (g == null)
        break;
    }
    if ((0, e.assertArgument)(!p || g != null, "missing required value", "path", d), c && g != null) {
      if (c === "int") {
        if (typeof g == "string" && g.match(/^-?[0-9]+$/))
          return parseInt(g);
        if (Number.isSafeInteger(g))
          return g;
      }
      if (c === "number" && typeof g == "string" && g.match(/^-?[0-9.]*$/))
        return parseFloat(g);
      if (c === "data" && typeof g == "string")
        return t(g);
      if (c === "array" && Array.isArray(g) || c === typeof g)
        return g;
      (0, e.assertArgument)(!1, `wrong type found for ${c} `, "path", d);
    }
    return g;
  }
  return Oi.spelunk = s, Oi;
}
var x3;
function B1() {
  if (x3)
    return Wn;
  x3 = 1, Object.defineProperty(Wn, "__esModule", { value: !0 }), Wn.encryptKeystoreJson = Wn.encryptKeystoreJsonSync = Wn.decryptKeystoreJson = Wn.decryptKeystoreJsonSync = Wn.isKeystoreJson = void 0;
  const e = u8(), t = Yr(), r = cn(), n = Yn(), s = wt(), i = c8(), a = w1(), f = "m/44'/60'/0'/0/0";
  function d(I) {
    try {
      const A = JSON.parse(I);
      if ((A.version != null ? parseInt(A.version) : 0) === 3)
        return !0;
    } catch {
    }
    return !1;
  }
  Wn.isKeystoreJson = d;
  function c(I, A, R) {
    if ((0, i.spelunk)(I, "crypto.cipher:string") === "aes-128-ctr") {
      const L = (0, i.spelunk)(I, "crypto.cipherparams.iv:data!"), K = new e.CTR(A, L);
      return (0, s.hexlify)(K.decrypt(R));
    }
    (0, s.assert)(!1, "unsupported cipher", "UNSUPPORTED_OPERATION", {
      operation: "decrypt"
    });
  }
  function p(I, A) {
    const R = (0, s.getBytes)(A), L = (0, i.spelunk)(I, "crypto.ciphertext:data!"), K = (0, s.hexlify)((0, r.keccak256)((0, s.concat)([R.slice(16, 32), L]))).substring(2);
    (0, s.assertArgument)(K === (0, i.spelunk)(I, "crypto.mac:string!").toLowerCase(), "incorrect password", "password", "[ REDACTED ]");
    const $ = c(I, R.slice(0, 16), L), k = (0, n.computeAddress)($);
    if (I.address) {
      let C = I.address.toLowerCase();
      C.startsWith("0x") || (C = "0x" + C), (0, s.assertArgument)((0, t.getAddress)(C) === k, "keystore address/privateKey mismatch", "address", I.address);
    }
    const V = { address: k, privateKey: $ };
    if ((0, i.spelunk)(I, "x-ethers.version:string") === "0.1") {
      const C = R.slice(32, 64), D = (0, i.spelunk)(I, "x-ethers.mnemonicCiphertext:data!"), o = (0, i.spelunk)(I, "x-ethers.mnemonicCounter:data!"), u = new e.CTR(C, o);
      V.mnemonic = {
        path: (0, i.spelunk)(I, "x-ethers.path:string") || f,
        locale: (0, i.spelunk)(I, "x-ethers.locale:string") || "en",
        entropy: (0, s.hexlify)((0, s.getBytes)(u.decrypt(D)))
      };
    }
    return V;
  }
  function g(I) {
    const A = (0, i.spelunk)(I, "crypto.kdf:string");
    if (A && typeof A == "string") {
      if (A.toLowerCase() === "scrypt") {
        const R = (0, i.spelunk)(I, "crypto.kdfparams.salt:data!"), L = (0, i.spelunk)(I, "crypto.kdfparams.n:int!"), K = (0, i.spelunk)(I, "crypto.kdfparams.r:int!"), $ = (0, i.spelunk)(I, "crypto.kdfparams.p:int!");
        (0, s.assertArgument)(L > 0 && (L & L - 1) === 0, "invalid kdf.N", "kdf.N", L), (0, s.assertArgument)(K > 0 && $ > 0, "invalid kdf", "kdf", A);
        const k = (0, i.spelunk)(I, "crypto.kdfparams.dklen:int!");
        return (0, s.assertArgument)(k === 32, "invalid kdf.dklen", "kdf.dflen", k), { name: "scrypt", salt: R, N: L, r: K, p: $, dkLen: 64 };
      } else if (A.toLowerCase() === "pbkdf2") {
        const R = (0, i.spelunk)(I, "crypto.kdfparams.salt:data!"), L = (0, i.spelunk)(I, "crypto.kdfparams.prf:string!"), K = L.split("-").pop();
        (0, s.assertArgument)(K === "sha256" || K === "sha512", "invalid kdf.pdf", "kdf.pdf", L);
        const $ = (0, i.spelunk)(I, "crypto.kdfparams.c:int!"), k = (0, i.spelunk)(I, "crypto.kdfparams.dklen:int!");
        return (0, s.assertArgument)(k === 32, "invalid kdf.dklen", "kdf.dklen", k), { name: "pbkdf2", salt: R, count: $, dkLen: k, algorithm: K };
      }
    }
    (0, s.assertArgument)(!1, "unsupported key-derivation function", "kdf", A);
  }
  function v(I, A) {
    const R = JSON.parse(I), L = (0, i.getPassword)(A), K = g(R);
    if (K.name === "pbkdf2") {
      const { salt: u, count: h, dkLen: y, algorithm: E } = K, P = (0, r.pbkdf2)(L, u, h, y, E);
      return p(R, P);
    }
    (0, s.assert)(K.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: K });
    const { salt: $, N: k, r: V, p: C, dkLen: D } = K, o = (0, r.scryptSync)(L, $, k, V, C, D);
    return p(R, o);
  }
  Wn.decryptKeystoreJsonSync = v;
  function O(I) {
    return new Promise((A) => {
      setTimeout(() => {
        A();
      }, I);
    });
  }
  async function N(I, A, R) {
    const L = JSON.parse(I), K = (0, i.getPassword)(A), $ = g(L);
    if ($.name === "pbkdf2") {
      R && (R(0), await O(0));
      const { salt: h, count: y, dkLen: E, algorithm: P } = $, w = (0, r.pbkdf2)(K, h, y, E, P);
      return R && (R(1), await O(0)), p(L, w);
    }
    (0, s.assert)($.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: $ });
    const { salt: k, N: V, r: C, p: D, dkLen: o } = $, u = await (0, r.scrypt)(K, k, V, C, D, o, R);
    return p(L, u);
  }
  Wn.decryptKeystoreJson = N;
  function S(I) {
    const A = I.salt != null ? (0, s.getBytes)(I.salt, "options.salt") : (0, r.randomBytes)(32);
    let R = 1 << 17, L = 8, K = 1;
    return I.scrypt && (I.scrypt.N && (R = I.scrypt.N), I.scrypt.r && (L = I.scrypt.r), I.scrypt.p && (K = I.scrypt.p)), (0, s.assertArgument)(typeof R == "number" && R > 0 && Number.isSafeInteger(R) && (BigInt(R) & BigInt(R - 1)) === BigInt(0), "invalid scrypt N parameter", "options.N", R), (0, s.assertArgument)(typeof L == "number" && L > 0 && Number.isSafeInteger(L), "invalid scrypt r parameter", "options.r", L), (0, s.assertArgument)(typeof K == "number" && K > 0 && Number.isSafeInteger(K), "invalid scrypt p parameter", "options.p", K), { name: "scrypt", dkLen: 32, salt: A, N: R, r: L, p: K };
  }
  function j(I, A, R, L) {
    const K = (0, s.getBytes)(R.privateKey, "privateKey"), $ = L.iv != null ? (0, s.getBytes)(L.iv, "options.iv") : (0, r.randomBytes)(16);
    (0, s.assertArgument)($.length === 16, "invalid options.iv length", "options.iv", L.iv);
    const k = L.uuid != null ? (0, s.getBytes)(L.uuid, "options.uuid") : (0, r.randomBytes)(16);
    (0, s.assertArgument)(k.length === 16, "invalid options.uuid length", "options.uuid", L.iv);
    const V = I.slice(0, 16), C = I.slice(16, 32), D = new e.CTR(V, $), o = (0, s.getBytes)(D.encrypt(K)), u = (0, r.keccak256)((0, s.concat)([C, o])), h = {
      address: R.address.substring(2).toLowerCase(),
      id: (0, s.uuidV4)(k),
      version: 3,
      Crypto: {
        cipher: "aes-128-ctr",
        cipherparams: {
          iv: (0, s.hexlify)($).substring(2)
        },
        ciphertext: (0, s.hexlify)(o).substring(2),
        kdf: "scrypt",
        kdfparams: {
          salt: (0, s.hexlify)(A.salt).substring(2),
          n: A.N,
          dklen: 32,
          p: A.p,
          r: A.r
        },
        mac: u.substring(2)
      }
    };
    if (R.mnemonic) {
      const y = L.client != null ? L.client : `ethers/${a.version}`, E = R.mnemonic.path || f, P = R.mnemonic.locale || "en", w = I.slice(32, 64), m = (0, s.getBytes)(R.mnemonic.entropy, "account.mnemonic.entropy"), l = (0, r.randomBytes)(16), b = new e.CTR(w, l), W = (0, s.getBytes)(b.encrypt(m)), X = /* @__PURE__ */ new Date(), G = "UTC--" + (X.getUTCFullYear() + "-" + (0, i.zpad)(X.getUTCMonth() + 1, 2) + "-" + (0, i.zpad)(X.getUTCDate(), 2) + "T" + (0, i.zpad)(X.getUTCHours(), 2) + "-" + (0, i.zpad)(X.getUTCMinutes(), 2) + "-" + (0, i.zpad)(X.getUTCSeconds(), 2) + ".0Z") + "--" + h.address;
      h["x-ethers"] = {
        client: y,
        gethFilename: G,
        path: E,
        locale: P,
        mnemonicCounter: (0, s.hexlify)(l).substring(2),
        mnemonicCiphertext: (0, s.hexlify)(W).substring(2),
        version: "0.1"
      };
    }
    return JSON.stringify(h);
  }
  function B(I, A, R) {
    R == null && (R = {});
    const L = (0, i.getPassword)(A), K = S(R), $ = (0, r.scryptSync)(L, K.salt, K.N, K.r, K.p, 64);
    return j((0, s.getBytes)($), K, I, R);
  }
  Wn.encryptKeystoreJsonSync = B;
  async function M(I, A, R) {
    R == null && (R = {});
    const L = (0, i.getPassword)(A), K = S(R), $ = await (0, r.scrypt)(L, K.salt, K.N, K.r, K.p, 64, R.progressCallback);
    return j((0, s.getBytes)($), K, I, R);
  }
  return Wn.encryptKeystoreJson = M, Wn;
}
var T3;
function l8() {
  return T3 || (T3 = 1, function(e) {
    var t, r, n, s;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getIndexedAccountPath = e.getAccountPath = e.HDNodeVoidWallet = e.HDNodeWallet = e.defaultPath = void 0;
    const i = cn(), a = M1(), f = Yn(), d = wt(), c = af(), p = I1(), g = C1(), v = B1();
    e.defaultPath = "m/44'/60'/0'/0/0";
    const O = new Uint8Array([66, 105, 116, 99, 111, 105, 110, 32, 115, 101, 101, 100]), N = 2147483648, S = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), j = "0123456789abcdef";
    function B(C, D) {
      let o = "";
      for (; C; )
        o = j[C % 16] + o, C = Math.trunc(C / 16);
      for (; o.length < D * 2; )
        o = "0" + o;
      return "0x" + o;
    }
    function M(C) {
      const D = (0, d.getBytes)(C), o = (0, d.dataSlice)((0, i.sha256)((0, i.sha256)(D)), 0, 4), u = (0, d.concat)([D, o]);
      return (0, d.encodeBase58)(u);
    }
    const I = {};
    function A(C, D, o, u) {
      const h = new Uint8Array(37);
      C & N ? ((0, d.assert)(u != null, "cannot derive child of neutered node", "UNSUPPORTED_OPERATION", {
        operation: "deriveChild"
      }), h.set((0, d.getBytes)(u), 1)) : h.set((0, d.getBytes)(o));
      for (let E = 24; E >= 0; E -= 8)
        h[33 + (E >> 3)] = C >> 24 - E & 255;
      const y = (0, d.getBytes)((0, i.computeHmac)("sha512", D, h));
      return { IL: y.slice(0, 32), IR: y.slice(32) };
    }
    function R(C, D) {
      const o = D.split("/");
      (0, d.assertArgument)(o.length > 0, "invalid path", "path", D), o[0] === "m" && ((0, d.assertArgument)(C.depth === 0, `cannot derive root path (i.e. path starting with "m/") for a node at non-zero depth ${C.depth}`, "path", D), o.shift());
      let u = C;
      for (let h = 0; h < o.length; h++) {
        const y = o[h];
        if (y.match(/^[0-9]+'$/)) {
          const E = parseInt(y.substring(0, y.length - 1));
          (0, d.assertArgument)(E < N, "invalid path index", `path[${h}]`, y), u = u.deriveChild(N + E);
        } else if (y.match(/^[0-9]+$/)) {
          const E = parseInt(y);
          (0, d.assertArgument)(E < N, "invalid path index", `path[${h}]`, y), u = u.deriveChild(E);
        } else
          (0, d.assertArgument)(!1, "invalid path component", `path[${h}]`, y);
      }
      return u;
    }
    const L = class lo extends p.BaseWallet {
      /**
       *  @private
       */
      constructor(D, o, u, h, y, E, P, w, m) {
        super(o, m), _e(this, t), Be(this, "publicKey"), Be(this, "fingerprint"), Be(this, "parentFingerprint"), Be(this, "mnemonic"), Be(this, "chainCode"), Be(this, "path"), Be(this, "index"), Be(this, "depth"), (0, d.assertPrivate)(D, I, "HDNodeWallet"), (0, d.defineProperties)(this, { publicKey: o.compressedPublicKey });
        const l = (0, d.dataSlice)((0, i.ripemd160)((0, i.sha256)(this.publicKey)), 0, 4);
        (0, d.defineProperties)(this, {
          parentFingerprint: u,
          fingerprint: l,
          chainCode: h,
          path: y,
          index: E,
          depth: P
        }), (0, d.defineProperties)(this, { mnemonic: w });
      }
      connect(D) {
        return new lo(I, this.signingKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.mnemonic, D);
      }
      /**
       *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
       *  %%password%%.
       *
       *  If %%progressCallback%% is specified, it will receive periodic
       *  updates as the encryption process progreses.
       */
      async encrypt(D, o) {
        return await (0, v.encryptKeystoreJson)(Ve(this, t, r).call(this), D, { progressCallback: o });
      }
      /**
       *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
       *  %%password%%.
       *
       *  It is preferred to use the [async version](encrypt) instead,
       *  which allows a [[ProgressCallback]] to keep the user informed.
       *
       *  This method will block the event loop (freezing all UI) until
       *  it is complete, which may be a non-trivial duration.
       */
      encryptSync(D) {
        return (0, v.encryptKeystoreJsonSync)(Ve(this, t, r).call(this), D);
      }
      /**
       *  The extended key.
       *
       *  This key will begin with the prefix ``xpriv`` and can be used to
       *  reconstruct this HD Node to derive its children.
       */
      get extendedKey() {
        return (0, d.assert)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), M((0, d.concat)([
          "0x0488ADE4",
          B(this.depth, 1),
          this.parentFingerprint,
          B(this.index, 4),
          this.chainCode,
          (0, d.concat)(["0x00", this.privateKey])
        ]));
      }
      /**
       *  Returns true if this wallet has a path, providing a Type Guard
       *  that the path is non-null.
       */
      hasPath() {
        return this.path != null;
      }
      /**
       *  Returns a neutered HD Node, which removes the private details
       *  of an HD Node.
       *
       *  A neutered node has no private key, but can be used to derive
       *  child addresses and other public data about the HD Node.
       */
      neuter() {
        return new $(I, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.provider);
      }
      /**
       *  Return the child for %%index%%.
       */
      deriveChild(D) {
        const o = (0, d.getNumber)(D, "index");
        (0, d.assertArgument)(o <= 4294967295, "invalid index", "index", o);
        let u = this.path;
        u && (u += "/" + (o & ~N), o & N && (u += "'"));
        const { IR: h, IL: y } = A(o, this.chainCode, this.publicKey, this.privateKey), E = new i.SigningKey((0, d.toBeHex)(((0, d.toBigInt)(y) + BigInt(this.privateKey)) % S, 32));
        return new lo(I, E, this.fingerprint, (0, d.hexlify)(h), u, o, this.depth + 1, this.mnemonic, this.provider);
      }
      /**
       *  Return the HDNode for %%path%% from this node.
       */
      derivePath(D) {
        return R(this, D);
      }
      /**
       *  Creates a new HD Node from %%extendedKey%%.
       *
       *  If the %%extendedKey%% will either have a prefix or ``xpub`` or
       *  ``xpriv``, returning a neutered HD Node ([[HDNodeVoidWallet]])
       *  or full HD Node ([[HDNodeWallet) respectively.
       */
      static fromExtendedKey(D) {
        const o = (0, d.toBeArray)((0, d.decodeBase58)(D));
        (0, d.assertArgument)(o.length === 82 || M(o.slice(0, 78)) === D, "invalid extended key", "extendedKey", "[ REDACTED ]");
        const u = o[4], h = (0, d.hexlify)(o.slice(5, 9)), y = parseInt((0, d.hexlify)(o.slice(9, 13)).substring(2), 16), E = (0, d.hexlify)(o.slice(13, 45)), P = o.slice(45, 78);
        switch ((0, d.hexlify)(o.slice(0, 4))) {
          case "0x0488b21e":
          case "0x043587cf": {
            const w = (0, d.hexlify)(P);
            return new $(I, (0, f.computeAddress)(w), w, h, E, null, y, u, null);
          }
          case "0x0488ade4":
          case "0x04358394 ":
            if (P[0] !== 0)
              break;
            return new lo(I, new i.SigningKey(P.slice(1)), h, E, null, y, u, null, null);
        }
        (0, d.assertArgument)(!1, "invalid extended key prefix", "extendedKey", "[ REDACTED ]");
      }
      /**
       *  Creates a new random HDNode.
       */
      static createRandom(D, o, u) {
        var h;
        D == null && (D = ""), o == null && (o = e.defaultPath), u == null && (u = c.LangEn.wordlist());
        const y = g.Mnemonic.fromEntropy((0, i.randomBytes)(16), D, u);
        return Ve(h = lo, n, s).call(h, y.computeSeed(), y).derivePath(o);
      }
      /**
       *  Create an HD Node from %%mnemonic%%.
       */
      static fromMnemonic(D, o) {
        var u;
        return o || (o = e.defaultPath), Ve(u = lo, n, s).call(u, D.computeSeed(), D).derivePath(o);
      }
      /**
       *  Creates an HD Node from a mnemonic %%phrase%%.
       */
      static fromPhrase(D, o, u, h) {
        var y;
        o == null && (o = ""), u == null && (u = e.defaultPath), h == null && (h = c.LangEn.wordlist());
        const E = g.Mnemonic.fromPhrase(D, o, h);
        return Ve(y = lo, n, s).call(y, E.computeSeed(), E).derivePath(u);
      }
      /**
       *  Creates an HD Node from a %%seed%%.
       */
      static fromSeed(D) {
        var o;
        return Ve(o = lo, n, s).call(o, D, null);
      }
    };
    t = /* @__PURE__ */ new WeakSet(), r = function() {
      const C = { address: this.address, privateKey: this.privateKey }, D = this.mnemonic;
      return this.path && D && D.wordlist.locale === "en" && D.password === "" && (C.mnemonic = {
        path: this.path,
        locale: "en",
        entropy: D.entropy
      }), C;
    }, n = /* @__PURE__ */ new WeakSet(), s = function(C, D) {
      (0, d.assertArgument)((0, d.isBytesLike)(C), "invalid seed", "seed", "[REDACTED]");
      const o = (0, d.getBytes)(C, "seed");
      (0, d.assertArgument)(o.length >= 16 && o.length <= 64, "invalid seed", "seed", "[REDACTED]");
      const u = (0, d.getBytes)((0, i.computeHmac)("sha512", O, o)), h = new i.SigningKey((0, d.hexlify)(u.slice(0, 32)));
      return new L(I, h, "0x00000000", (0, d.hexlify)(u.slice(32)), "m", 0, 0, D, null);
    }, _e(L, n);
    let K = L;
    e.HDNodeWallet = K;
    class $ extends a.VoidSigner {
      /**
       *  @private
       */
      constructor(D, o, u, h, y, E, P, w, m) {
        super(o, m), Be(this, "publicKey"), Be(this, "fingerprint"), Be(this, "parentFingerprint"), Be(this, "chainCode"), Be(this, "path"), Be(this, "index"), Be(this, "depth"), (0, d.assertPrivate)(D, I, "HDNodeVoidWallet"), (0, d.defineProperties)(this, { publicKey: u });
        const l = (0, d.dataSlice)((0, i.ripemd160)((0, i.sha256)(u)), 0, 4);
        (0, d.defineProperties)(this, {
          publicKey: u,
          fingerprint: l,
          parentFingerprint: h,
          chainCode: y,
          path: E,
          index: P,
          depth: w
        });
      }
      connect(D) {
        return new $(I, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, D);
      }
      /**
       *  The extended key.
       *
       *  This key will begin with the prefix ``xpub`` and can be used to
       *  reconstruct this neutered key to derive its children addresses.
       */
      get extendedKey() {
        return (0, d.assert)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), M((0, d.concat)([
          "0x0488B21E",
          B(this.depth, 1),
          this.parentFingerprint,
          B(this.index, 4),
          this.chainCode,
          this.publicKey
        ]));
      }
      /**
       *  Returns true if this wallet has a path, providing a Type Guard
       *  that the path is non-null.
       */
      hasPath() {
        return this.path != null;
      }
      /**
       *  Return the child for %%index%%.
       */
      deriveChild(D) {
        const o = (0, d.getNumber)(D, "index");
        (0, d.assertArgument)(o <= 4294967295, "invalid index", "index", o);
        let u = this.path;
        u && (u += "/" + (o & ~N), o & N && (u += "'"));
        const { IR: h, IL: y } = A(o, this.chainCode, this.publicKey, null), E = i.SigningKey.addPoints(y, this.publicKey, !0), P = (0, f.computeAddress)(E);
        return new $(I, P, E, this.fingerprint, (0, d.hexlify)(h), u, o, this.depth + 1, this.provider);
      }
      /**
       *  Return the signer for %%path%% from this node.
       */
      derivePath(D) {
        return R(this, D);
      }
    }
    e.HDNodeVoidWallet = $;
    function k(C) {
      const D = (0, d.getNumber)(C, "index");
      return (0, d.assertArgument)(D >= 0 && D < N, "invalid account index", "index", D), `m/44'/60'/${D}'/0/0`;
    }
    e.getAccountPath = k;
    function V(C) {
      const D = (0, d.getNumber)(C, "index");
      return (0, d.assertArgument)(D >= 0 && D < N, "invalid account index", "index", D), `m/44'/60'/0'/0/${D}`;
    }
    e.getIndexedAccountPath = V;
  }(c3)), c3;
}
var ca = {}, k3;
function d8() {
  if (k3)
    return ca;
  k3 = 1, Object.defineProperty(ca, "__esModule", { value: !0 }), ca.decryptCrowdsaleJson = ca.isCrowdsaleJson = void 0;
  const e = u8(), t = Yr(), r = cn(), n = no(), s = wt(), i = c8();
  function a(d) {
    try {
      if (JSON.parse(d).encseed)
        return !0;
    } catch {
    }
    return !1;
  }
  ca.isCrowdsaleJson = a;
  function f(d, c) {
    const p = JSON.parse(d), g = (0, i.getPassword)(c), v = (0, t.getAddress)((0, i.spelunk)(p, "ethaddr:string!")), O = (0, i.looseArrayify)((0, i.spelunk)(p, "encseed:string!"));
    (0, s.assertArgument)(O && O.length % 16 === 0, "invalid encseed", "json", d);
    const N = (0, s.getBytes)((0, r.pbkdf2)(g, g, 2e3, 32, "sha256")).slice(0, 16), S = O.slice(0, 16), j = O.slice(16), B = new e.CBC(N, S), M = (0, e.pkcs7Strip)((0, s.getBytes)(B.decrypt(j)));
    let I = "";
    for (let A = 0; A < M.length; A++)
      I += String.fromCharCode(M[A]);
    return { address: v, privateKey: (0, n.id)(I) };
  }
  return ca.decryptCrowdsaleJson = f, ca;
}
var hl = {}, S3;
function gk() {
  var e, t;
  if (S3)
    return hl;
  S3 = 1, Object.defineProperty(hl, "__esModule", { value: !0 }), hl.Wallet = void 0;
  const r = cn(), n = wt(), s = I1(), i = l8(), a = d8(), f = B1(), d = C1();
  function c(v) {
    return new Promise((O) => {
      setTimeout(() => {
        O();
      }, v);
    });
  }
  const p = class eh extends s.BaseWallet {
    /**
     *  Create a new wallet for the private %%key%%, optionally connected
     *  to %%provider%%.
     */
    constructor(O, N) {
      typeof O == "string" && !O.startsWith("0x") && (O = "0x" + O);
      let S = typeof O == "string" ? new r.SigningKey(O) : O;
      super(S, N);
    }
    connect(O) {
      return new eh(this.signingKey, O);
    }
    /**
     *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
     *  %%password%%.
     *
     *  If %%progressCallback%% is specified, it will receive periodic
     *  updates as the encryption process progreses.
     */
    async encrypt(O, N) {
      const S = { address: this.address, privateKey: this.privateKey };
      return await (0, f.encryptKeystoreJson)(S, O, { progressCallback: N });
    }
    /**
     *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
     *  %%password%%.
     *
     *  It is preferred to use the [async version](encrypt) instead,
     *  which allows a [[ProgressCallback]] to keep the user informed.
     *
     *  This method will block the event loop (freezing all UI) until
     *  it is complete, which may be a non-trivial duration.
     */
    encryptSync(O) {
      const N = { address: this.address, privateKey: this.privateKey };
      return (0, f.encryptKeystoreJsonSync)(N, O);
    }
    /**
     *  Creates (asynchronously) a **Wallet** by decrypting the %%json%%
     *  with %%password%%.
     *
     *  If %%progress%% is provided, it is called periodically during
     *  decryption so that any UI can be updated.
     */
    static async fromEncryptedJson(O, N, S) {
      var j;
      let B = null;
      return (0, f.isKeystoreJson)(O) ? B = await (0, f.decryptKeystoreJson)(O, N, S) : (0, a.isCrowdsaleJson)(O) && (S && (S(0), await c(0)), B = (0, a.decryptCrowdsaleJson)(O, N), S && (S(1), await c(0))), Ve(j = eh, e, t).call(j, B);
    }
    /**
     *  Creates a **Wallet** by decrypting the %%json%% with %%password%%.
     *
     *  The [[fromEncryptedJson]] method is preferred, as this method
     *  will lock up and freeze the UI during decryption, which may take
     *  some time.
     */
    static fromEncryptedJsonSync(O, N) {
      var S;
      let j = null;
      return (0, f.isKeystoreJson)(O) ? j = (0, f.decryptKeystoreJsonSync)(O, N) : (0, a.isCrowdsaleJson)(O) ? j = (0, a.decryptCrowdsaleJson)(O, N) : (0, n.assertArgument)(!1, "invalid JSON wallet", "json", "[ REDACTED ]"), Ve(S = eh, e, t).call(S, j);
    }
    /**
     *  Creates a new random [[HDNodeWallet]] using the available
     *  [cryptographic random source](randomBytes).
     *
     *  If there is no crytographic random source, this will throw.
     */
    static createRandom(O) {
      const N = i.HDNodeWallet.createRandom();
      return O ? N.connect(O) : N;
    }
    /**
     *  Creates a [[HDNodeWallet]] for %%phrase%%.
     */
    static fromPhrase(O, N) {
      const S = i.HDNodeWallet.fromPhrase(O);
      return N ? S.connect(N) : S;
    }
  };
  e = /* @__PURE__ */ new WeakSet(), t = function(v) {
    if ((0, n.assertArgument)(v, "invalid JSON wallet", "json", "[ REDACTED ]"), "mnemonic" in v && v.mnemonic && v.mnemonic.locale === "en") {
      const N = d.Mnemonic.fromEntropy(v.mnemonic.entropy), S = i.HDNodeWallet.fromMnemonic(N, v.mnemonic.path);
      if (S.address === v.address && S.privateKey === v.privateKey)
        return S;
      console.log("WARNING: JSON mismatch address/privateKey != mnemonic; fallback onto private key");
    }
    const O = new p(v.privateKey);
    return (0, n.assertArgument)(O.address === v.address, "address/privateKey mismatch", "json", "[ REDACTED ]"), O;
  }, _e(p, e);
  let g = p;
  return hl.Wallet = g, hl;
}
var M3;
function mk() {
  return M3 || (M3 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Wallet = e.Mnemonic = e.encryptKeystoreJsonSync = e.encryptKeystoreJson = e.decryptKeystoreJson = e.decryptKeystoreJsonSync = e.isKeystoreJson = e.decryptCrowdsaleJson = e.isCrowdsaleJson = e.HDNodeVoidWallet = e.HDNodeWallet = e.getIndexedAccountPath = e.getAccountPath = e.defaultPath = e.BaseWallet = void 0;
    var t = I1();
    Object.defineProperty(e, "BaseWallet", { enumerable: !0, get: function() {
      return t.BaseWallet;
    } });
    var r = l8();
    Object.defineProperty(e, "defaultPath", { enumerable: !0, get: function() {
      return r.defaultPath;
    } }), Object.defineProperty(e, "getAccountPath", { enumerable: !0, get: function() {
      return r.getAccountPath;
    } }), Object.defineProperty(e, "getIndexedAccountPath", { enumerable: !0, get: function() {
      return r.getIndexedAccountPath;
    } }), Object.defineProperty(e, "HDNodeWallet", { enumerable: !0, get: function() {
      return r.HDNodeWallet;
    } }), Object.defineProperty(e, "HDNodeVoidWallet", { enumerable: !0, get: function() {
      return r.HDNodeVoidWallet;
    } });
    var n = d8();
    Object.defineProperty(e, "isCrowdsaleJson", { enumerable: !0, get: function() {
      return n.isCrowdsaleJson;
    } }), Object.defineProperty(e, "decryptCrowdsaleJson", { enumerable: !0, get: function() {
      return n.decryptCrowdsaleJson;
    } });
    var s = B1();
    Object.defineProperty(e, "isKeystoreJson", { enumerable: !0, get: function() {
      return s.isKeystoreJson;
    } }), Object.defineProperty(e, "decryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return s.decryptKeystoreJsonSync;
    } }), Object.defineProperty(e, "decryptKeystoreJson", { enumerable: !0, get: function() {
      return s.decryptKeystoreJson;
    } }), Object.defineProperty(e, "encryptKeystoreJson", { enumerable: !0, get: function() {
      return s.encryptKeystoreJson;
    } }), Object.defineProperty(e, "encryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return s.encryptKeystoreJsonSync;
    } });
    var i = C1();
    Object.defineProperty(e, "Mnemonic", { enumerable: !0, get: function() {
      return i.Mnemonic;
    } });
    var a = gk();
    Object.defineProperty(e, "Wallet", { enumerable: !0, get: function() {
      return a.Wallet;
    } });
  }(a3)), a3;
}
var I3 = {}, fl = {}, pl = {}, gl = {}, R3;
function yk() {
  if (R3)
    return gl;
  R3 = 1, Object.defineProperty(gl, "__esModule", { value: !0 }), gl.decodeBits = void 0;
  const e = ")!@#$%^&*(ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_";
  function t(r, n) {
    const s = (1 << r) - 1, i = [];
    let a = 0, f = 0, d = 0;
    for (let c = 0; c < n.length; c++)
      for (a = a << 6 | e.indexOf(n[c]), f += 6; f >= r; ) {
        const p = a >> f - r;
        a &= (1 << f - r) - 1, f -= r, p === 0 ? d += s : (i.push(p + d), d = 0);
      }
    return i;
  }
  return gl.decodeBits = t, gl;
}
var C3;
function bk() {
  if (C3)
    return pl;
  C3 = 1, Object.defineProperty(pl, "__esModule", { value: !0 }), pl.decodeOwlA = void 0;
  const e = wt(), t = yk(), r = s8();
  function n(s, i) {
    let a = (0, r.decodeOwl)(s).join(",");
    return i.split(/,/g).forEach((f) => {
      const d = f.match(/^([a-z]*)([0-9]+)([0-9])(.*)$/);
      (0, e.assertArgument)(d !== null, "internal error parsing accents", "accents", i);
      let c = 0;
      const p = (0, t.decodeBits)(parseInt(d[3]), d[4]), g = parseInt(d[2]), v = new RegExp(`([${d[1]}])`, "g");
      a = a.replace(v, (O, N) => (--p[c] === 0 && (N = String.fromCharCode(N.charCodeAt(0), g), c++), N));
    }), a.split(",");
  }
  return pl.decodeOwlA = n, pl;
}
var B3;
function wk() {
  var e;
  if (B3)
    return fl;
  B3 = 1, Object.defineProperty(fl, "__esModule", { value: !0 }), fl.WordlistOwlA = void 0;
  const t = R1(), r = bk();
  class n extends t.WordlistOwl {
    /**
     *  Creates a new Wordlist for %%locale%% using the OWLA %%data%%
     *  and %%accent%% data and validated against the %%checksum%%.
     */
    constructor(i, a, f, d) {
      super(i, a, d), _e(this, e, void 0), Oe(this, e, f);
    }
    /**
     *  The OWLA-encoded accent data.
     */
    get _accent() {
      return oe(this, e);
    }
    /**
     *  Decode all the words for the wordlist.
     */
    _decodeWords() {
      return (0, r.decodeOwlA)(this._data, this._accent);
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), fl.WordlistOwlA = n, fl;
}
var ml = {}, _3;
function vk() {
  if (_3)
    return ml;
  _3 = 1, Object.defineProperty(ml, "__esModule", { value: !0 }), ml.wordlists = void 0;
  const e = af();
  return ml.wordlists = {
    en: e.LangEn.wordlist()
  }, ml;
}
var F3;
function Ak() {
  return F3 || (F3 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.wordlists = e.WordlistOwlA = e.WordlistOwl = e.LangEn = e.Wordlist = void 0;
    var t = o8();
    Object.defineProperty(e, "Wordlist", { enumerable: !0, get: function() {
      return t.Wordlist;
    } });
    var r = af();
    Object.defineProperty(e, "LangEn", { enumerable: !0, get: function() {
      return r.LangEn;
    } });
    var n = R1();
    Object.defineProperty(e, "WordlistOwl", { enumerable: !0, get: function() {
      return n.WordlistOwl;
    } });
    var s = wk();
    Object.defineProperty(e, "WordlistOwlA", { enumerable: !0, get: function() {
      return s.WordlistOwlA;
    } });
    var i = vk();
    Object.defineProperty(e, "wordlists", { enumerable: !0, get: function() {
      return i.wordlists;
    } });
  }(I3)), I3;
}
var U3;
function D3() {
  return U3 || (U3 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ripemd160 = e.keccak256 = e.randomBytes = e.computeHmac = e.UndecodedEventLog = e.EventLog = e.ContractUnknownEventPayload = e.ContractTransactionResponse = e.ContractTransactionReceipt = e.ContractEventPayload = e.ContractFactory = e.Contract = e.BaseContract = e.MessagePrefix = e.EtherSymbol = e.ZeroHash = e.N = e.MaxInt256 = e.MinInt256 = e.MaxUint256 = e.WeiPerEther = e.ZeroAddress = e.resolveAddress = e.isAddress = e.isAddressable = e.getCreate2Address = e.getCreateAddress = e.getIcapAddress = e.getAddress = e.Typed = e.TransactionDescription = e.Result = e.LogDescription = e.Interface = e.Indexed = e.ErrorDescription = e.checkResultErrors = e.StructFragment = e.ParamType = e.NamedFragment = e.FunctionFragment = e.FallbackFragment = e.Fragment = e.EventFragment = e.ErrorFragment = e.ConstructorFragment = e.AbiCoder = e.encodeBytes32String = e.decodeBytes32String = e.version = void 0, e.EnsPlugin = e.Network = e.EnsResolver = e.WebSocketProvider = e.SocketProvider = e.IpcSocketProvider = e.QuickNodeProvider = e.PocketProvider = e.InfuraWebSocketProvider = e.InfuraProvider = e.EtherscanProvider = e.CloudflareProvider = e.ChainstackProvider = e.AnkrProvider = e.AlchemyProvider = e.BrowserProvider = e.JsonRpcSigner = e.JsonRpcProvider = e.JsonRpcApiProvider = e.FallbackProvider = e.AbstractProvider = e.VoidSigner = e.NonceManager = e.AbstractSigner = e.TransactionResponse = e.TransactionReceipt = e.Log = e.FeeData = e.Block = e.getDefaultProvider = e.verifyTypedData = e.TypedDataEncoder = e.solidityPackedSha256 = e.solidityPackedKeccak256 = e.solidityPacked = e.verifyMessage = e.hashMessage = e.dnsEncode = e.namehash = e.isValidName = e.ensNormalize = e.id = e.SigningKey = e.Signature = e.lock = e.scryptSync = e.scrypt = e.pbkdf2 = e.sha512 = e.sha256 = void 0, e.getUint = e.getNumber = e.getBigInt = e.FixedNumber = e.FetchCancelSignal = e.FetchResponse = e.FetchRequest = e.EventPayload = e.isError = e.isCallException = e.makeError = e.assertPrivate = e.assertNormalize = e.assertArgumentCount = e.assertArgument = e.assert = e.resolveProperties = e.defineProperties = e.zeroPadValue = e.zeroPadBytes = e.stripZerosLeft = e.isBytesLike = e.isHexString = e.hexlify = e.getBytesCopy = e.getBytes = e.dataSlice = e.dataLength = e.concat = e.encodeBase64 = e.decodeBase64 = e.encodeBase58 = e.decodeBase58 = e.Transaction = e.recoverAddress = e.computeAddress = e.accessListify = e.showThrottleMessage = e.copyRequest = e.UnmanagedSubscriber = e.SocketSubscriber = e.SocketPendingSubscriber = e.SocketEventSubscriber = e.SocketBlockSubscriber = e.MulticoinProviderPlugin = e.NetworkPlugin = e.GasCostPlugin = e.FetchUrlFeeDataNetworkPlugin = e.FeeDataNetworkPlugin = e.EtherscanPlugin = void 0, e.wordlists = e.WordlistOwlA = e.WordlistOwl = e.LangEn = e.Wordlist = e.encryptKeystoreJsonSync = e.encryptKeystoreJson = e.decryptKeystoreJson = e.decryptKeystoreJsonSync = e.decryptCrowdsaleJson = e.isKeystoreJson = e.isCrowdsaleJson = e.getIndexedAccountPath = e.getAccountPath = e.defaultPath = e.Wallet = e.HDNodeVoidWallet = e.HDNodeWallet = e.BaseWallet = e.Mnemonic = e.uuidV4 = e.encodeRlp = e.decodeRlp = e.Utf8ErrorFuncs = e.toUtf8String = e.toUtf8CodePoints = e.toUtf8Bytes = e.parseUnits = e.formatUnits = e.parseEther = e.formatEther = e.mask = e.toTwos = e.fromTwos = e.toQuantity = e.toNumber = e.toBeHex = e.toBigInt = e.toBeArray = void 0;
    var t = w1();
    Object.defineProperty(e, "version", { enumerable: !0, get: function() {
      return t.version;
    } });
    var r = gd();
    Object.defineProperty(e, "decodeBytes32String", { enumerable: !0, get: function() {
      return r.decodeBytes32String;
    } }), Object.defineProperty(e, "encodeBytes32String", { enumerable: !0, get: function() {
      return r.encodeBytes32String;
    } }), Object.defineProperty(e, "AbiCoder", { enumerable: !0, get: function() {
      return r.AbiCoder;
    } }), Object.defineProperty(e, "ConstructorFragment", { enumerable: !0, get: function() {
      return r.ConstructorFragment;
    } }), Object.defineProperty(e, "ErrorFragment", { enumerable: !0, get: function() {
      return r.ErrorFragment;
    } }), Object.defineProperty(e, "EventFragment", { enumerable: !0, get: function() {
      return r.EventFragment;
    } }), Object.defineProperty(e, "Fragment", { enumerable: !0, get: function() {
      return r.Fragment;
    } }), Object.defineProperty(e, "FallbackFragment", { enumerable: !0, get: function() {
      return r.FallbackFragment;
    } }), Object.defineProperty(e, "FunctionFragment", { enumerable: !0, get: function() {
      return r.FunctionFragment;
    } }), Object.defineProperty(e, "NamedFragment", { enumerable: !0, get: function() {
      return r.NamedFragment;
    } }), Object.defineProperty(e, "ParamType", { enumerable: !0, get: function() {
      return r.ParamType;
    } }), Object.defineProperty(e, "StructFragment", { enumerable: !0, get: function() {
      return r.StructFragment;
    } }), Object.defineProperty(e, "checkResultErrors", { enumerable: !0, get: function() {
      return r.checkResultErrors;
    } }), Object.defineProperty(e, "ErrorDescription", { enumerable: !0, get: function() {
      return r.ErrorDescription;
    } }), Object.defineProperty(e, "Indexed", { enumerable: !0, get: function() {
      return r.Indexed;
    } }), Object.defineProperty(e, "Interface", { enumerable: !0, get: function() {
      return r.Interface;
    } }), Object.defineProperty(e, "LogDescription", { enumerable: !0, get: function() {
      return r.LogDescription;
    } }), Object.defineProperty(e, "Result", { enumerable: !0, get: function() {
      return r.Result;
    } }), Object.defineProperty(e, "TransactionDescription", { enumerable: !0, get: function() {
      return r.TransactionDescription;
    } }), Object.defineProperty(e, "Typed", { enumerable: !0, get: function() {
      return r.Typed;
    } });
    var n = Yr();
    Object.defineProperty(e, "getAddress", { enumerable: !0, get: function() {
      return n.getAddress;
    } }), Object.defineProperty(e, "getIcapAddress", { enumerable: !0, get: function() {
      return n.getIcapAddress;
    } }), Object.defineProperty(e, "getCreateAddress", { enumerable: !0, get: function() {
      return n.getCreateAddress;
    } }), Object.defineProperty(e, "getCreate2Address", { enumerable: !0, get: function() {
      return n.getCreate2Address;
    } }), Object.defineProperty(e, "isAddressable", { enumerable: !0, get: function() {
      return n.isAddressable;
    } }), Object.defineProperty(e, "isAddress", { enumerable: !0, get: function() {
      return n.isAddress;
    } }), Object.defineProperty(e, "resolveAddress", { enumerable: !0, get: function() {
      return n.resolveAddress;
    } });
    var s = pd();
    Object.defineProperty(e, "ZeroAddress", { enumerable: !0, get: function() {
      return s.ZeroAddress;
    } }), Object.defineProperty(e, "WeiPerEther", { enumerable: !0, get: function() {
      return s.WeiPerEther;
    } }), Object.defineProperty(e, "MaxUint256", { enumerable: !0, get: function() {
      return s.MaxUint256;
    } }), Object.defineProperty(e, "MinInt256", { enumerable: !0, get: function() {
      return s.MinInt256;
    } }), Object.defineProperty(e, "MaxInt256", { enumerable: !0, get: function() {
      return s.MaxInt256;
    } }), Object.defineProperty(e, "N", { enumerable: !0, get: function() {
      return s.N;
    } }), Object.defineProperty(e, "ZeroHash", { enumerable: !0, get: function() {
      return s.ZeroHash;
    } }), Object.defineProperty(e, "EtherSymbol", { enumerable: !0, get: function() {
      return s.EtherSymbol;
    } }), Object.defineProperty(e, "MessagePrefix", { enumerable: !0, get: function() {
      return s.MessagePrefix;
    } });
    var i = of();
    Object.defineProperty(e, "BaseContract", { enumerable: !0, get: function() {
      return i.BaseContract;
    } }), Object.defineProperty(e, "Contract", { enumerable: !0, get: function() {
      return i.Contract;
    } }), Object.defineProperty(e, "ContractFactory", { enumerable: !0, get: function() {
      return i.ContractFactory;
    } }), Object.defineProperty(e, "ContractEventPayload", { enumerable: !0, get: function() {
      return i.ContractEventPayload;
    } }), Object.defineProperty(e, "ContractTransactionReceipt", { enumerable: !0, get: function() {
      return i.ContractTransactionReceipt;
    } }), Object.defineProperty(e, "ContractTransactionResponse", { enumerable: !0, get: function() {
      return i.ContractTransactionResponse;
    } }), Object.defineProperty(e, "ContractUnknownEventPayload", { enumerable: !0, get: function() {
      return i.ContractUnknownEventPayload;
    } }), Object.defineProperty(e, "EventLog", { enumerable: !0, get: function() {
      return i.EventLog;
    } }), Object.defineProperty(e, "UndecodedEventLog", { enumerable: !0, get: function() {
      return i.UndecodedEventLog;
    } });
    var a = cn();
    Object.defineProperty(e, "computeHmac", { enumerable: !0, get: function() {
      return a.computeHmac;
    } }), Object.defineProperty(e, "randomBytes", { enumerable: !0, get: function() {
      return a.randomBytes;
    } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
      return a.keccak256;
    } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
      return a.ripemd160;
    } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
      return a.sha256;
    } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
      return a.sha512;
    } }), Object.defineProperty(e, "pbkdf2", { enumerable: !0, get: function() {
      return a.pbkdf2;
    } }), Object.defineProperty(e, "scrypt", { enumerable: !0, get: function() {
      return a.scrypt;
    } }), Object.defineProperty(e, "scryptSync", { enumerable: !0, get: function() {
      return a.scryptSync;
    } }), Object.defineProperty(e, "lock", { enumerable: !0, get: function() {
      return a.lock;
    } }), Object.defineProperty(e, "Signature", { enumerable: !0, get: function() {
      return a.Signature;
    } }), Object.defineProperty(e, "SigningKey", { enumerable: !0, get: function() {
      return a.SigningKey;
    } });
    var f = no();
    Object.defineProperty(e, "id", { enumerable: !0, get: function() {
      return f.id;
    } }), Object.defineProperty(e, "ensNormalize", { enumerable: !0, get: function() {
      return f.ensNormalize;
    } }), Object.defineProperty(e, "isValidName", { enumerable: !0, get: function() {
      return f.isValidName;
    } }), Object.defineProperty(e, "namehash", { enumerable: !0, get: function() {
      return f.namehash;
    } }), Object.defineProperty(e, "dnsEncode", { enumerable: !0, get: function() {
      return f.dnsEncode;
    } }), Object.defineProperty(e, "hashMessage", { enumerable: !0, get: function() {
      return f.hashMessage;
    } }), Object.defineProperty(e, "verifyMessage", { enumerable: !0, get: function() {
      return f.verifyMessage;
    } }), Object.defineProperty(e, "solidityPacked", { enumerable: !0, get: function() {
      return f.solidityPacked;
    } }), Object.defineProperty(e, "solidityPackedKeccak256", { enumerable: !0, get: function() {
      return f.solidityPackedKeccak256;
    } }), Object.defineProperty(e, "solidityPackedSha256", { enumerable: !0, get: function() {
      return f.solidityPackedSha256;
    } }), Object.defineProperty(e, "TypedDataEncoder", { enumerable: !0, get: function() {
      return f.TypedDataEncoder;
    } }), Object.defineProperty(e, "verifyTypedData", { enumerable: !0, get: function() {
      return f.verifyTypedData;
    } });
    var d = M1();
    Object.defineProperty(e, "getDefaultProvider", { enumerable: !0, get: function() {
      return d.getDefaultProvider;
    } }), Object.defineProperty(e, "Block", { enumerable: !0, get: function() {
      return d.Block;
    } }), Object.defineProperty(e, "FeeData", { enumerable: !0, get: function() {
      return d.FeeData;
    } }), Object.defineProperty(e, "Log", { enumerable: !0, get: function() {
      return d.Log;
    } }), Object.defineProperty(e, "TransactionReceipt", { enumerable: !0, get: function() {
      return d.TransactionReceipt;
    } }), Object.defineProperty(e, "TransactionResponse", { enumerable: !0, get: function() {
      return d.TransactionResponse;
    } }), Object.defineProperty(e, "AbstractSigner", { enumerable: !0, get: function() {
      return d.AbstractSigner;
    } }), Object.defineProperty(e, "NonceManager", { enumerable: !0, get: function() {
      return d.NonceManager;
    } }), Object.defineProperty(e, "VoidSigner", { enumerable: !0, get: function() {
      return d.VoidSigner;
    } }), Object.defineProperty(e, "AbstractProvider", { enumerable: !0, get: function() {
      return d.AbstractProvider;
    } }), Object.defineProperty(e, "FallbackProvider", { enumerable: !0, get: function() {
      return d.FallbackProvider;
    } }), Object.defineProperty(e, "JsonRpcApiProvider", { enumerable: !0, get: function() {
      return d.JsonRpcApiProvider;
    } }), Object.defineProperty(e, "JsonRpcProvider", { enumerable: !0, get: function() {
      return d.JsonRpcProvider;
    } }), Object.defineProperty(e, "JsonRpcSigner", { enumerable: !0, get: function() {
      return d.JsonRpcSigner;
    } }), Object.defineProperty(e, "BrowserProvider", { enumerable: !0, get: function() {
      return d.BrowserProvider;
    } }), Object.defineProperty(e, "AlchemyProvider", { enumerable: !0, get: function() {
      return d.AlchemyProvider;
    } }), Object.defineProperty(e, "AnkrProvider", { enumerable: !0, get: function() {
      return d.AnkrProvider;
    } }), Object.defineProperty(e, "ChainstackProvider", { enumerable: !0, get: function() {
      return d.ChainstackProvider;
    } }), Object.defineProperty(e, "CloudflareProvider", { enumerable: !0, get: function() {
      return d.CloudflareProvider;
    } }), Object.defineProperty(e, "EtherscanProvider", { enumerable: !0, get: function() {
      return d.EtherscanProvider;
    } }), Object.defineProperty(e, "InfuraProvider", { enumerable: !0, get: function() {
      return d.InfuraProvider;
    } }), Object.defineProperty(e, "InfuraWebSocketProvider", { enumerable: !0, get: function() {
      return d.InfuraWebSocketProvider;
    } }), Object.defineProperty(e, "PocketProvider", { enumerable: !0, get: function() {
      return d.PocketProvider;
    } }), Object.defineProperty(e, "QuickNodeProvider", { enumerable: !0, get: function() {
      return d.QuickNodeProvider;
    } }), Object.defineProperty(e, "IpcSocketProvider", { enumerable: !0, get: function() {
      return d.IpcSocketProvider;
    } }), Object.defineProperty(e, "SocketProvider", { enumerable: !0, get: function() {
      return d.SocketProvider;
    } }), Object.defineProperty(e, "WebSocketProvider", { enumerable: !0, get: function() {
      return d.WebSocketProvider;
    } }), Object.defineProperty(e, "EnsResolver", { enumerable: !0, get: function() {
      return d.EnsResolver;
    } }), Object.defineProperty(e, "Network", { enumerable: !0, get: function() {
      return d.Network;
    } }), Object.defineProperty(e, "EnsPlugin", { enumerable: !0, get: function() {
      return d.EnsPlugin;
    } }), Object.defineProperty(e, "EtherscanPlugin", { enumerable: !0, get: function() {
      return d.EtherscanPlugin;
    } }), Object.defineProperty(e, "FeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return d.FeeDataNetworkPlugin;
    } }), Object.defineProperty(e, "FetchUrlFeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return d.FetchUrlFeeDataNetworkPlugin;
    } }), Object.defineProperty(e, "GasCostPlugin", { enumerable: !0, get: function() {
      return d.GasCostPlugin;
    } }), Object.defineProperty(e, "NetworkPlugin", { enumerable: !0, get: function() {
      return d.NetworkPlugin;
    } }), Object.defineProperty(e, "MulticoinProviderPlugin", { enumerable: !0, get: function() {
      return d.MulticoinProviderPlugin;
    } }), Object.defineProperty(e, "SocketBlockSubscriber", { enumerable: !0, get: function() {
      return d.SocketBlockSubscriber;
    } }), Object.defineProperty(e, "SocketEventSubscriber", { enumerable: !0, get: function() {
      return d.SocketEventSubscriber;
    } }), Object.defineProperty(e, "SocketPendingSubscriber", { enumerable: !0, get: function() {
      return d.SocketPendingSubscriber;
    } }), Object.defineProperty(e, "SocketSubscriber", { enumerable: !0, get: function() {
      return d.SocketSubscriber;
    } }), Object.defineProperty(e, "UnmanagedSubscriber", { enumerable: !0, get: function() {
      return d.UnmanagedSubscriber;
    } }), Object.defineProperty(e, "copyRequest", { enumerable: !0, get: function() {
      return d.copyRequest;
    } }), Object.defineProperty(e, "showThrottleMessage", { enumerable: !0, get: function() {
      return d.showThrottleMessage;
    } });
    var c = Yn();
    Object.defineProperty(e, "accessListify", { enumerable: !0, get: function() {
      return c.accessListify;
    } }), Object.defineProperty(e, "computeAddress", { enumerable: !0, get: function() {
      return c.computeAddress;
    } }), Object.defineProperty(e, "recoverAddress", { enumerable: !0, get: function() {
      return c.recoverAddress;
    } }), Object.defineProperty(e, "Transaction", { enumerable: !0, get: function() {
      return c.Transaction;
    } });
    var p = wt();
    Object.defineProperty(e, "decodeBase58", { enumerable: !0, get: function() {
      return p.decodeBase58;
    } }), Object.defineProperty(e, "encodeBase58", { enumerable: !0, get: function() {
      return p.encodeBase58;
    } }), Object.defineProperty(e, "decodeBase64", { enumerable: !0, get: function() {
      return p.decodeBase64;
    } }), Object.defineProperty(e, "encodeBase64", { enumerable: !0, get: function() {
      return p.encodeBase64;
    } }), Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
      return p.concat;
    } }), Object.defineProperty(e, "dataLength", { enumerable: !0, get: function() {
      return p.dataLength;
    } }), Object.defineProperty(e, "dataSlice", { enumerable: !0, get: function() {
      return p.dataSlice;
    } }), Object.defineProperty(e, "getBytes", { enumerable: !0, get: function() {
      return p.getBytes;
    } }), Object.defineProperty(e, "getBytesCopy", { enumerable: !0, get: function() {
      return p.getBytesCopy;
    } }), Object.defineProperty(e, "hexlify", { enumerable: !0, get: function() {
      return p.hexlify;
    } }), Object.defineProperty(e, "isHexString", { enumerable: !0, get: function() {
      return p.isHexString;
    } }), Object.defineProperty(e, "isBytesLike", { enumerable: !0, get: function() {
      return p.isBytesLike;
    } }), Object.defineProperty(e, "stripZerosLeft", { enumerable: !0, get: function() {
      return p.stripZerosLeft;
    } }), Object.defineProperty(e, "zeroPadBytes", { enumerable: !0, get: function() {
      return p.zeroPadBytes;
    } }), Object.defineProperty(e, "zeroPadValue", { enumerable: !0, get: function() {
      return p.zeroPadValue;
    } }), Object.defineProperty(e, "defineProperties", { enumerable: !0, get: function() {
      return p.defineProperties;
    } }), Object.defineProperty(e, "resolveProperties", { enumerable: !0, get: function() {
      return p.resolveProperties;
    } }), Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
      return p.assert;
    } }), Object.defineProperty(e, "assertArgument", { enumerable: !0, get: function() {
      return p.assertArgument;
    } }), Object.defineProperty(e, "assertArgumentCount", { enumerable: !0, get: function() {
      return p.assertArgumentCount;
    } }), Object.defineProperty(e, "assertNormalize", { enumerable: !0, get: function() {
      return p.assertNormalize;
    } }), Object.defineProperty(e, "assertPrivate", { enumerable: !0, get: function() {
      return p.assertPrivate;
    } }), Object.defineProperty(e, "makeError", { enumerable: !0, get: function() {
      return p.makeError;
    } }), Object.defineProperty(e, "isCallException", { enumerable: !0, get: function() {
      return p.isCallException;
    } }), Object.defineProperty(e, "isError", { enumerable: !0, get: function() {
      return p.isError;
    } }), Object.defineProperty(e, "EventPayload", { enumerable: !0, get: function() {
      return p.EventPayload;
    } }), Object.defineProperty(e, "FetchRequest", { enumerable: !0, get: function() {
      return p.FetchRequest;
    } }), Object.defineProperty(e, "FetchResponse", { enumerable: !0, get: function() {
      return p.FetchResponse;
    } }), Object.defineProperty(e, "FetchCancelSignal", { enumerable: !0, get: function() {
      return p.FetchCancelSignal;
    } }), Object.defineProperty(e, "FixedNumber", { enumerable: !0, get: function() {
      return p.FixedNumber;
    } }), Object.defineProperty(e, "getBigInt", { enumerable: !0, get: function() {
      return p.getBigInt;
    } }), Object.defineProperty(e, "getNumber", { enumerable: !0, get: function() {
      return p.getNumber;
    } }), Object.defineProperty(e, "getUint", { enumerable: !0, get: function() {
      return p.getUint;
    } }), Object.defineProperty(e, "toBeArray", { enumerable: !0, get: function() {
      return p.toBeArray;
    } }), Object.defineProperty(e, "toBigInt", { enumerable: !0, get: function() {
      return p.toBigInt;
    } }), Object.defineProperty(e, "toBeHex", { enumerable: !0, get: function() {
      return p.toBeHex;
    } }), Object.defineProperty(e, "toNumber", { enumerable: !0, get: function() {
      return p.toNumber;
    } }), Object.defineProperty(e, "toQuantity", { enumerable: !0, get: function() {
      return p.toQuantity;
    } }), Object.defineProperty(e, "fromTwos", { enumerable: !0, get: function() {
      return p.fromTwos;
    } }), Object.defineProperty(e, "toTwos", { enumerable: !0, get: function() {
      return p.toTwos;
    } }), Object.defineProperty(e, "mask", { enumerable: !0, get: function() {
      return p.mask;
    } }), Object.defineProperty(e, "formatEther", { enumerable: !0, get: function() {
      return p.formatEther;
    } }), Object.defineProperty(e, "parseEther", { enumerable: !0, get: function() {
      return p.parseEther;
    } }), Object.defineProperty(e, "formatUnits", { enumerable: !0, get: function() {
      return p.formatUnits;
    } }), Object.defineProperty(e, "parseUnits", { enumerable: !0, get: function() {
      return p.parseUnits;
    } }), Object.defineProperty(e, "toUtf8Bytes", { enumerable: !0, get: function() {
      return p.toUtf8Bytes;
    } }), Object.defineProperty(e, "toUtf8CodePoints", { enumerable: !0, get: function() {
      return p.toUtf8CodePoints;
    } }), Object.defineProperty(e, "toUtf8String", { enumerable: !0, get: function() {
      return p.toUtf8String;
    } }), Object.defineProperty(e, "Utf8ErrorFuncs", { enumerable: !0, get: function() {
      return p.Utf8ErrorFuncs;
    } }), Object.defineProperty(e, "decodeRlp", { enumerable: !0, get: function() {
      return p.decodeRlp;
    } }), Object.defineProperty(e, "encodeRlp", { enumerable: !0, get: function() {
      return p.encodeRlp;
    } }), Object.defineProperty(e, "uuidV4", { enumerable: !0, get: function() {
      return p.uuidV4;
    } });
    var g = mk();
    Object.defineProperty(e, "Mnemonic", { enumerable: !0, get: function() {
      return g.Mnemonic;
    } }), Object.defineProperty(e, "BaseWallet", { enumerable: !0, get: function() {
      return g.BaseWallet;
    } }), Object.defineProperty(e, "HDNodeWallet", { enumerable: !0, get: function() {
      return g.HDNodeWallet;
    } }), Object.defineProperty(e, "HDNodeVoidWallet", { enumerable: !0, get: function() {
      return g.HDNodeVoidWallet;
    } }), Object.defineProperty(e, "Wallet", { enumerable: !0, get: function() {
      return g.Wallet;
    } }), Object.defineProperty(e, "defaultPath", { enumerable: !0, get: function() {
      return g.defaultPath;
    } }), Object.defineProperty(e, "getAccountPath", { enumerable: !0, get: function() {
      return g.getAccountPath;
    } }), Object.defineProperty(e, "getIndexedAccountPath", { enumerable: !0, get: function() {
      return g.getIndexedAccountPath;
    } }), Object.defineProperty(e, "isCrowdsaleJson", { enumerable: !0, get: function() {
      return g.isCrowdsaleJson;
    } }), Object.defineProperty(e, "isKeystoreJson", { enumerable: !0, get: function() {
      return g.isKeystoreJson;
    } }), Object.defineProperty(e, "decryptCrowdsaleJson", { enumerable: !0, get: function() {
      return g.decryptCrowdsaleJson;
    } }), Object.defineProperty(e, "decryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return g.decryptKeystoreJsonSync;
    } }), Object.defineProperty(e, "decryptKeystoreJson", { enumerable: !0, get: function() {
      return g.decryptKeystoreJson;
    } }), Object.defineProperty(e, "encryptKeystoreJson", { enumerable: !0, get: function() {
      return g.encryptKeystoreJson;
    } }), Object.defineProperty(e, "encryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return g.encryptKeystoreJsonSync;
    } });
    var v = Ak();
    Object.defineProperty(e, "Wordlist", { enumerable: !0, get: function() {
      return v.Wordlist;
    } }), Object.defineProperty(e, "LangEn", { enumerable: !0, get: function() {
      return v.LangEn;
    } }), Object.defineProperty(e, "WordlistOwl", { enumerable: !0, get: function() {
      return v.WordlistOwl;
    } }), Object.defineProperty(e, "WordlistOwlA", { enumerable: !0, get: function() {
      return v.WordlistOwlA;
    } }), Object.defineProperty(e, "wordlists", { enumerable: !0, get: function() {
      return v.wordlists;
    } });
  }(Fm)), Fm;
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ethers = void 0;
  const t = aT, r = t.__importStar(D3());
  e.ethers = r, t.__exportStar(D3(), e);
})(N5);
Object.defineProperty(Zu, "__esModule", { value: !0 });
Zu.parseEthersError = Zu.TransactionErrors = void 0;
const au = N5;
var ai;
(function(e) {
  e[e.REJECTED = 0] = "REJECTED", e[e.REPLACED = 1] = "REPLACED", e[e.CANCELLED = 2] = "CANCELLED", e[e.EXCEPTION = 3] = "EXCEPTION", e[e.LEDGER_ERROR = 4] = "LEDGER_ERROR", e[e.INSUFFICIENT_FUNDS = 5] = "INSUFFICIENT_FUNDS", e[e.PENDING = 6] = "PENDING", e[e.OTHER = 7] = "OTHER";
})(ai || (Zu.TransactionErrors = ai = {}));
const Ek = (e) => (0, au.isError)(e, "ACTION_REJECTED") ? ai.REJECTED : (0, au.isError)(e, "TRANSACTION_REPLACED") ? ai.REPLACED : (0, au.isError)(e, "INSUFFICIENT_FUNDS") ? ai.INSUFFICIENT_FUNDS : e.message.includes("Ledger") ? ai.LEDGER_ERROR : e.message.includes("UserRefusedOnDevice") ? ai.REJECTED : parseInt(e.code) === -32002 && e.message && e.message.includes("pending") ? (console.warn("Transaction pending in wallet error"), ai.PENDING) : e.message.includes("cancelled") && !(e != null && e.cancelled) ? ai.REJECTED : (0, au.isError)(e, "CANCELLED") ? ai.CANCELLED : (0, au.isError)(e, "CALL_EXCEPTION") ? ai.EXCEPTION : ((0, au.isError)(e, "UNKNOWN_ERROR"), ai.OTHER);
Zu.parseEthersError = Ek;
var Pk = Ze && Ze.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var s = Object.getOwnPropertyDescriptor(t, r);
  (!s || ("get" in s ? !t.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, s);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), Ok = Ze && Ze.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Zi = Ze && Ze.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && Pk(t, e, r);
  return Ok(t, e), t;
};
Object.defineProperty(_r, "__esModule", { value: !0 });
_r.Misc = _r.StringUtils = _r.Web3TransactionError = _r.Cookies = _r.Media = _r.URLs = _r.Network = _r.Constants = _r.Currency = _r.ProviderEvents = _r.Countdown = void 0;
const Nk = Zi(Ju);
_r.Constants = Nk;
const xk = Zi(c5);
_r.Cookies = xk;
const Tk = Zi(Qu);
_r.Countdown = Tk;
const kk = Zi(di);
_r.Currency = kk;
const Sk = Zi(b5);
_r.Media = Sk;
const Mk = Zi(ds);
_r.Misc = Mk;
const Ik = Zi(tf);
_r.Network = Ik;
const Rk = Zi(p1);
_r.ProviderEvents = Rk;
const Ck = Zi(hi);
_r.StringUtils = Ck;
const Bk = Zi(Tr);
_r.URLs = Bk;
const _k = Zi(Zu);
_r.Web3TransactionError = _k;
var Fk = {}, No = {}, uf = {}, Ni = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(uf, "__esModule", { value: !0 });
uf.StudioAppsAudienceClient = void 0;
const Uk = Ki;
class Dk extends Uk.BaseModule {
  fetchAudienceBlueprints() {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.get("/audience/blueprint/all");
    });
  }
  fetchAudienceBlueprint(t) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.get(`/audience/blueprint/${t}`);
    });
  }
  updateAudienceBlueprint(t, r, n) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.get(`audience/blueprint/${t}`, {
        data: {
          name: r,
          filters: n
        }
      });
    });
  }
  deleteAudienceBlueprint(t) {
    return this.baseClient.delete(`/audience/blueprint/${t}`);
  }
  createSnapshot(t) {
    const { name: r, blueprintIds: n, filters: s, timestamp: i, notificationData: a } = t;
    return this.baseClient.post("/audience/snapshot", {
      data: { blueprintIds: n, filters: s, name: r, notificationData: a, timestamp: i }
    });
  }
  fetchSnapshots() {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.get("/audience/snapshot/all");
    });
  }
  fetchSnapshot(t) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.get(`/audience/snapshot/${t}`);
    });
  }
  deleteSnapshot(t) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.delete(`/audience/snapshot/${t}`);
    });
  }
  createAllowlist(t) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.post("/audience/allowlist", {
        data: { snapshotId: t }
      });
    });
  }
  fetchAllowlist(t) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.get(`/audience/allowlist/${t}`);
    });
  }
  updateAllowlist(t, r, n) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.put(`/audience/allowlist/${t}`, {
        data: { active: n, snapshotId: r }
      });
    });
  }
  updateAllowlistOverrideEntries(t, r) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.put(`/audience/allowlist/${t}/overrideEntries`, {
        data: { overrideEntries: r }
      });
    });
  }
  deleteAllowlist(t) {
    return Ni(this, void 0, void 0, function* () {
      return this.baseClient.delete(`/audience/allowlist/${t}`);
    });
  }
}
uf.StudioAppsAudienceClient = Dk;
var cf = {}, la = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(cf, "__esModule", { value: !0 });
cf.StudioAppsDataClient = void 0;
const jk = Ki;
class Lk extends jk.BaseModule {
  /**
   * Get contract details
   */
  getContract(t, r) {
    return la(this, void 0, void 0, function* () {
      return this.baseClient.get(`/data/chain/${t}/contract/${r}`);
    });
  }
  /**
   * Get contract burn specifications
   */
  getContractBurnSpec(t, r) {
    return la(this, void 0, void 0, function* () {
      return this.baseClient.get(`/data/chain/${t}/contract/${r}/burn-spec`);
    });
  }
  /**
   * Refresh NFT metadata
   */
  refreshNFTMetadata(t, r) {
    return la(this, void 0, void 0, function* () {
      return this.baseClient.post(`/data/chain/${t}/contract/${r}/nfts/refresh`);
    });
  }
  /**
   * Refresh external NFT metadata
   */
  refreshExternalNFTMetadata(t, r, n) {
    return la(this, void 0, void 0, function* () {
      return this.baseClient.post(`/data/chain/${t}/contract/${r}/nfts/external/refresh`, {
        data: { tokenId: n }
      });
    });
  }
  /**
   * Get NFTs according to the filters specified in the body. If no filters are specified, the request fails (see nft-analytics-api).
   * NOTE: using POST because filters can be larger than the suggested URL length (2048 characters).
   */
  getNFTs(t, r) {
    return la(this, void 0, void 0, function* () {
      return this.baseClient.post(`/data/chain/${t}/nfts`, {
        data: r
      });
    });
  }
  /**
   * Get NFTs of req.address according to the filters specified in the body.
   * NOTE: using POST because filters can be larger than the suggested URL length (2048 characters).
   */
  getNFTsOfOwner(t, r, n) {
    return la(this, void 0, void 0, function* () {
      return this.baseClient.post(`/data/chain/${t}/owner/nfts`, {
        data: Object.assign({ ownerAddress: r }, n)
      });
    });
  }
  getContractAttributes(t, r) {
    return la(this, void 0, void 0, function* () {
      return this.baseClient.get(`/data/chain/${t}/contractAttributes/${r}`);
    });
  }
}
cf.StudioAppsDataClient = Lk;
var lf = {}, da = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(lf, "__esModule", { value: !0 });
lf.StudioAppsDeveloperClient = void 0;
const Hk = Ki;
class Wk extends Hk.BaseModule {
  getAllAppDefinitions() {
    return da(this, void 0, void 0, function* () {
      return this.baseClient.get("/developer/apps");
    });
  }
  getAppDefinition(t) {
    return da(this, void 0, void 0, function* () {
      return this.baseClient.get(`/developer/apps/${t}`);
    });
  }
  /** creates an app with schemaSupport = true */
  createApp(t) {
    return da(this, void 0, void 0, function* () {
      return this.baseClient.post("/developer/apps", {
        data: Object.assign(Object.assign({}, t), { schemaSupport: !0 })
      });
    });
  }
  updateApp(t, r) {
    return da(this, void 0, void 0, function* () {
      return this.baseClient.put(`/developer/apps/${t}`, {
        data: r
      });
    });
  }
  patchApp(t, r) {
    return da(this, void 0, void 0, function* () {
      return this.baseClient.patch(`/developer/apps/${t}`, {
        data: r
      });
    });
  }
  updateAppSchema(t, r) {
    return da(this, void 0, void 0, function* () {
      return this.baseClient.put(`/developer/apps/${t}/schema`, {
        data: r
      });
    });
  }
  patchAppSchema(t, r) {
    return da(this, void 0, void 0, function* () {
      return this.baseClient.patch(`/developer/apps/${t}/schema`, {
        data: r
      });
    });
  }
}
lf.StudioAppsDeveloperClient = Wk;
var df = {}, yl = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(df, "__esModule", { value: !0 });
df.StudioAppsDomainClient = void 0;
const Gk = Ki;
class zk extends Gk.BaseModule {
  /**
   * Get all app instances for the current application
   */
  getCertificate() {
    return yl(this, void 0, void 0, function* () {
      return this.baseClient.get("/app/domain/certificate/all");
    });
  }
  create(t) {
    return yl(this, void 0, void 0, function* () {
      return this.baseClient.post("/app/domain/create", {
        data: t
      });
    });
  }
  getAll(t) {
    return yl(this, void 0, void 0, function* () {
      return this.baseClient.post("/app/domain/all", {
        data: t
      });
    });
  }
  delete(t, r) {
    return yl(this, void 0, void 0, function* () {
      return this.baseClient.delete(`/app/domain?domain=${t}&path=${r}`);
    });
  }
  put(t, r, n) {
    return yl(this, void 0, void 0, function* () {
      return this.baseClient.put("/app/domain", {
        data: {
          domain: t,
          path: r,
          newPath: n
        }
      });
    });
  }
}
df.StudioAppsDomainClient = zk;
var Xu = {}, mo = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(Xu, "__esModule", { value: !0 });
Xu.StudioAppsInstanceClient = Xu.StudioInstanceClient = void 0;
const h8 = Ki;
class Vk extends h8.BaseModule {
  /**
   * Get instances for the current workspace (dependent on the JWT token)
   * @param options optional parameters
   * @param options.appId filter for a specific app
   * @param options.contractId filter for a specific contract
   * @param options.published whether to get published instances
   * @param options.limit the number of instances to get
   * @param options.offset the offset to start from
   * @param options.sort the sort order base on updatedAt of the instance
   * @returns a list of instances
   *
   */
  getAllPreviews(t) {
    return mo(this, void 0, void 0, function* () {
      const r = new URLSearchParams();
      t && (t.appId !== void 0 && r.set("appId", t.appId.toString()), typeof t.published < "u" && r.set("published", t.published.toString()), t.limit !== void 0 && r.set("limit", t.limit.toString()), t.offset !== void 0 && r.set("offset", t.offset.toString()), t.sort !== void 0 && r.set("sort", t.sort), t.contractId !== void 0 && r.set("contractId", t.contractId.toString()), t.instanceIds !== void 0 && r.set("instanceIds", t.instanceIds.toString()));
      const n = Object.fromEntries(r), s = yield this.baseClient.get("/instance/previews", {
        params: n
      });
      return {
        instancePreviews: s.instancePreviews,
        total: s.count,
        appCounts: s.appCounts
      };
    });
  }
  /**
   * Delete an app instance with veifyStudioRequest middleware
   */
  delete(t) {
    return mo(this, void 0, void 0, function* () {
      return this.baseClient.delete(`/instance/${t}`);
    });
  }
}
Xu.StudioInstanceClient = Vk;
class qk extends h8.BaseModule {
  /**
   * Create a new app instance
   */
  create(t) {
    return mo(this, void 0, void 0, function* () {
      return this.baseClient.post("/app/instance", {
        // @dev: we expect the body (outer `data` of the config object) to have a `data` key representing the instanceData
        data: {
          data: t
        }
      });
    });
  }
  /**
   * Get all app instances for the current application
   */
  getAll() {
    return mo(this, void 0, void 0, function* () {
      return this.baseClient.get("/app/instance/all");
    });
  }
  /**
   * Delete an app instance with verifyStudioRequestWithApplication middleware
   */
  delete(t) {
    return mo(this, void 0, void 0, function* () {
      return this.baseClient.delete(`/app/instance/${t}`);
    });
  }
  /**
   * Get a specific app instance by its ID
   */
  get(t) {
    return mo(this, void 0, void 0, function* () {
      return this.baseClient.get(`/app/instance/${t}`);
    });
  }
  /**
   * Updates an app instance partially with the given data using the instanceId parameter.
   * Requires JWT authentication and instance permission checks.
   */
  patch(t, r, n, s, i) {
    return mo(this, void 0, void 0, function* () {
      return this.baseClient.patch(`/app/instance/${t}`, {
        data: { data: r, publish: s, slug: n, skipNotifications: i }
      });
    });
  }
  /**
   * Updates an app instance completely with the given data using the instanceId parameter.
   * Requires JWT authentication and instance permission checks.
   */
  update(t, r, n, s, i) {
    return mo(this, void 0, void 0, function* () {
      return this.baseClient.put(`/app/instance/${t}`, {
        data: {
          data: r,
          publish: s,
          skipNotifications: i,
          slug: n
        }
      });
    });
  }
}
Xu.StudioAppsInstanceClient = qk;
var F0 = Ze && Ze.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(No, "__esModule", { value: !0 });
No.StudioAppsClientForCLI = No.StudioAppsClientForStudio = No.StudioAppsClientForSDK = void 0;
const $k = Ki, Kk = uf, f8 = cf, p8 = lf, Jk = df, g8 = Xu;
class _1 extends $k.BaseClient {
  // Get data for all apps
  getAllAppsData() {
    return F0(this, void 0, void 0, function* () {
      return this.get("/apps/all");
    });
  }
  getApp(t) {
    return F0(this, void 0, void 0, function* () {
      return this.get(`/apps/${t}`);
    });
  }
}
const Qk = {
  instance: g8.StudioAppsInstanceClient,
  audience: Kk.StudioAppsAudienceClient,
  domain: Jk.StudioAppsDomainClient,
  data: f8.StudioAppsDataClient
};
class Zk extends _1 {
  constructor({ baseUrl: t, getHeaders: r, defaultTimeout: n, getDefaultQueryParams: s }) {
    super({
      baseUrl: t,
      getHeaders: r,
      defaultTimeout: n,
      modules: Qk,
      getDefaultQueryParams: s,
      fieldsToParseMapping: {
        date: ["createdAt", "updatedAt", "timestamp", "lastUpdated"]
      }
    });
  }
  checkAppSlug(t, r, n) {
    return F0(this, void 0, void 0, function* () {
      return this.get(`/app/apps/${t}/checkSlug`, {
        params: {
          slug: r,
          instanceId: n
        }
      });
    });
  }
  getUser() {
    return F0(this, void 0, void 0, function* () {
      return this.get("/app/creator");
    });
  }
  getWorkspace() {
    return F0(this, void 0, void 0, function* () {
      return this.get("/app/workspace");
    });
  }
}
No.StudioAppsClientForSDK = Zk;
const Yk = {
  developer: p8.StudioAppsDeveloperClient,
  instance: g8.StudioInstanceClient,
  data: f8.StudioAppsDataClient
};
class Xk extends _1 {
  constructor({ baseUrl: t, getHeaders: r, defaultTimeout: n, getDefaultQueryParams: s }) {
    super({
      baseUrl: t,
      getHeaders: r,
      defaultTimeout: n,
      modules: Yk,
      getDefaultQueryParams: s,
      fieldsToParseMapping: {
        date: ["createdAt", "updatedAt", "timestamp", "lastUpdated"]
      }
    });
  }
}
No.StudioAppsClientForStudio = Xk;
const eS = {
  developer: p8.StudioAppsDeveloperClient
};
class tS extends _1 {
  constructor({ baseUrl: t, getHeaders: r, defaultTimeout: n, getDefaultQueryParams: s }) {
    super({
      baseUrl: t,
      getHeaders: r,
      defaultTimeout: n,
      modules: eS,
      getDefaultQueryParams: s,
      fieldsToParseMapping: {
        date: ["createdAt", "updatedAt", "timestamp", "lastUpdated"]
      }
    });
  }
}
No.StudioAppsClientForCLI = tS;
var m8 = {}, pn = {};
Object.defineProperty(pn, "__esModule", { value: !0 });
pn.NotificationParamTransformation = pn.NotificationTrigger = pn.NotificationChannel = pn.StudioParams = pn.NotificationTarget = pn.TriggerType = pn.AppStatus = void 0;
var j3;
(function(e) {
  e.Draft = "draft", e.Pending = "pending", e.Approved = "approved", e.Published = "published";
})(j3 || (pn.AppStatus = j3 = {}));
var L3;
(function(e) {
  e[e.IMMEDIATE = 0] = "IMMEDIATE", e[e.SCHEDULED = 1] = "SCHEDULED";
})(L3 || (pn.TriggerType = L3 = {}));
var H3;
(function(e) {
  e[e.CREATOR = 0] = "CREATOR", e[e.COLLECTOR = 1] = "COLLECTOR";
})(H3 || (pn.NotificationTarget = H3 = {}));
var W3;
(function(e) {
  e[e.NAME = 0] = "NAME", e[e.WALLET = 1] = "WALLET", e[e.EMAIL = 2] = "EMAIL", e[e.TWITTER = 3] = "TWITTER";
})(W3 || (pn.StudioParams = W3 = {}));
var G3;
(function(e) {
  e[e.EMAIL = 0] = "EMAIL", e[e.SMS = 1] = "SMS";
})(G3 || (pn.NotificationChannel = G3 = {}));
var z3;
(function(e) {
  e.CREATE = "create", e.UPDATE = "update", e.ALL = "all";
})(z3 || (pn.NotificationTrigger = z3 = {}));
var V3;
(function(e) {
  e.TRUTHY = "truthy", e.FALSY = "falsy", e.PRICE = "price", e.DATE = "date", e.TITLE_CASE = "title_case", e.NETWORK_NAME = "network_name", e.SHORT_ADDRESS = "short_address";
})(V3 || (pn.NotificationParamTransformation = V3 = {}));
var y8 = {};
Object.defineProperty(y8, "__esModule", { value: !0 });
var b8 = {};
Object.defineProperty(b8, "__esModule", { value: !0 });
var hf = {};
Object.defineProperty(hf, "__esModule", { value: !0 });
hf.InstancePreviewSort = void 0;
var q3;
(function(e) {
  e.latest = "latest", e.oldest = "oldest";
})(q3 || (hf.InstancePreviewSort = q3 = {}));
var w8 = {};
Object.defineProperty(w8, "__esModule", { value: !0 });
var v8 = {};
Object.defineProperty(v8, "__esModule", { value: !0 });
var A8 = {};
Object.defineProperty(A8, "__esModule", { value: !0 });
var ff = {};
Object.defineProperty(ff, "__esModule", { value: !0 });
ff.IDENTIFIER_TYPES = void 0;
var $3;
(function(e) {
  e[e.WALLET = 1] = "WALLET", e[e.EMAIL = 2] = "EMAIL", e[e.TWITTER = 4] = "TWITTER";
})($3 || (ff.IDENTIFIER_TYPES = $3 = {}));
var E8 = {};
Object.defineProperty(E8, "__esModule", { value: !0 });
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = Ze && Ze.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(pn, e), r(y8, e), r(b8, e), r(hf, e), r(w8, e), r(v8, e), r(A8, e), r(ff, e), r(E8, e);
})(m8);
(function(e) {
  var t = Ze && Ze.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = Ze && Ze.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(No, e), r(m8, e);
})(Fk);
var rS = Object.defineProperty, nS = (e, t, r) => t in e ? rS(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Se = (e, t, r) => (nS(e, typeof t != "symbol" ? t + "" : t, r), r), F1 = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, ae = (e, t, r) => (F1(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Fe = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, Ne = (e, t, r, n) => (F1(e, t, "write to private field"), t.set(e, r), r), ed = (e, t, r, n) => ({
  set _(s) {
    Ne(e, t, s);
  },
  get _() {
    return ae(e, t, n);
  }
}), qe = (e, t, r) => (F1(e, t, "access private method"), r), zr = /* @__PURE__ */ ((e) => (e.Address = "address", e.Array = "array", e.Asset = "asset", e.InstanceAllowlist = "instanceAllowlist", e.AudienceBlueprint = "audienceBlueprint", e.Boolean = "boolean", e.Contract = "contract", e.Date = "date", e.Enum = "enum", e.File = "file", e.InstanceBlueprint = "instanceBlueprint", e.Network = "network", e.Integer = "integer", e.Price = "price", e.Struct = "struct", e.AssetSeries = "assetSeries", e.String = "string", e.StudioContract = "studioContract", e.Url = "url", e))(zr || {});
class P8 {
  constructor({ version: t, value: r }) {
    Se(this, "type", "constant"), Se(this, "version"), Se(this, "value"), Se(this, "_output"), this.version = t, this.value = r;
  }
}
var nr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function iS(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function U1(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Fr = {}, ec = {};
Object.defineProperty(ec, "__esModule", { value: !0 });
ec.NULL_BYTES32 = ec.NULL_ADDRESS = void 0;
ec.NULL_ADDRESS = "0x0000000000000000000000000000000000000000";
ec.NULL_BYTES32 = "0x0000000000000000000000000000000000000000000000000000000000000000";
var O8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.removeCookie = e.getCookie = e.setCookie = void 0;
  const t = (s, i, a) => {
    const f = /* @__PURE__ */ new Date();
    f.setTime(f.getTime() + a * 24 * 60 * 60 * 1e3);
    const d = "expires=" + f.toUTCString();
    document.cookie = s + "=" + i + ";" + d + ";path=/";
  };
  e.setCookie = t;
  const r = (s) => {
    const i = s + "=", a = document.cookie.split(";");
    for (let f = 0; f < a.length; f++) {
      let d = a[f];
      for (; d.charAt(0) === " "; )
        d = d.substring(1);
      if (d.indexOf(i) === 0)
        return d.substring(i.length, d.length);
    }
    return "";
  };
  e.getCookie = r;
  const n = (s) => {
    (0, e.setCookie)(s, "", -1);
  };
  e.removeCookie = n;
})(O8);
var tc = {};
Object.defineProperty(tc, "__esModule", { value: !0 });
tc.getCountdownFromTimestamp = tc.getCountdownFromDuration = void 0;
function N8(e, t = !0, r = !0) {
  const n = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }, s = {
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00"
  };
  if (e > 0) {
    t && (n.days = Math.floor(e / (1e3 * 60 * 60 * 24)), e -= n.days * (1e3 * 60 * 60 * 24)), n.hours = Math.floor(e / (1e3 * 60 * 60)), e -= n.hours * (1e3 * 60 * 60), n.minutes = Math.floor(e / (1e3 * 60)), e -= n.minutes * (1e3 * 60), n.seconds = Math.floor(e / 1e3), e -= n.seconds * 1e3;
    for (const i in n)
      n[i] < 10 ? s[i] = `0${n[i]}` : s[i] = n[i].toString();
  }
  return r ? t ? `${s.days}D : ${s.hours}H : ${s.minutes}M : ${s.seconds}S` : `${s.hours}H : ${s.minutes}M : ${s.seconds}S` : n;
}
tc.getCountdownFromDuration = N8;
function sS(e, t = !0, r = !0, n = 0) {
  e instanceof Date && (e = e.getTime());
  const s = Math.max(e - (Date.now() + n), 0);
  return N8(s, t, r);
}
tc.getCountdownFromTimestamp = sS;
var fi = {}, x8 = { exports: {} };
const oS = {}, aS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: oS
}, Symbol.toStringTag, { value: "Module" })), uS = /* @__PURE__ */ U1(aS);
(function(e) {
  (function(t, r) {
    function n(o, u) {
      if (!o)
        throw new Error(u || "Assertion failed");
    }
    function s(o, u) {
      o.super_ = u;
      var h = function() {
      };
      h.prototype = u.prototype, o.prototype = new h(), o.prototype.constructor = o;
    }
    function i(o, u, h) {
      if (i.isBN(o))
        return o;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, o !== null && ((u === "le" || u === "be") && (h = u, u = 10), this._init(o || 0, u || 10, h || "be"));
    }
    typeof t == "object" ? t.exports = i : r.BN = i, i.BN = i, i.wordSize = 26;
    var a;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? a = window.Buffer : a = uS.Buffer;
    } catch {
    }
    i.isBN = function(o) {
      return o instanceof i ? !0 : o !== null && typeof o == "object" && o.constructor.wordSize === i.wordSize && Array.isArray(o.words);
    }, i.max = function(o, u) {
      return o.cmp(u) > 0 ? o : u;
    }, i.min = function(o, u) {
      return o.cmp(u) < 0 ? o : u;
    }, i.prototype._init = function(o, u, h) {
      if (typeof o == "number")
        return this._initNumber(o, u, h);
      if (typeof o == "object")
        return this._initArray(o, u, h);
      u === "hex" && (u = 16), n(u === (u | 0) && u >= 2 && u <= 36), o = o.toString().replace(/\s+/g, "");
      var y = 0;
      o[0] === "-" && (y++, this.negative = 1), y < o.length && (u === 16 ? this._parseHex(o, y, h) : (this._parseBase(o, u, y), h === "le" && this._initArray(this.toArray(), u, h)));
    }, i.prototype._initNumber = function(o, u, h) {
      o < 0 && (this.negative = 1, o = -o), o < 67108864 ? (this.words = [o & 67108863], this.length = 1) : o < 4503599627370496 ? (this.words = [
        o & 67108863,
        o / 67108864 & 67108863
      ], this.length = 2) : (n(o < 9007199254740992), this.words = [
        o & 67108863,
        o / 67108864 & 67108863,
        1
      ], this.length = 3), h === "le" && this._initArray(this.toArray(), u, h);
    }, i.prototype._initArray = function(o, u, h) {
      if (n(typeof o.length == "number"), o.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(o.length / 3), this.words = new Array(this.length);
      for (var y = 0; y < this.length; y++)
        this.words[y] = 0;
      var E, P, w = 0;
      if (h === "be")
        for (y = o.length - 1, E = 0; y >= 0; y -= 3)
          P = o[y] | o[y - 1] << 8 | o[y - 2] << 16, this.words[E] |= P << w & 67108863, this.words[E + 1] = P >>> 26 - w & 67108863, w += 24, w >= 26 && (w -= 26, E++);
      else if (h === "le")
        for (y = 0, E = 0; y < o.length; y += 3)
          P = o[y] | o[y + 1] << 8 | o[y + 2] << 16, this.words[E] |= P << w & 67108863, this.words[E + 1] = P >>> 26 - w & 67108863, w += 24, w >= 26 && (w -= 26, E++);
      return this._strip();
    };
    function f(o, u) {
      var h = o.charCodeAt(u);
      if (h >= 48 && h <= 57)
        return h - 48;
      if (h >= 65 && h <= 70)
        return h - 55;
      if (h >= 97 && h <= 102)
        return h - 87;
      n(!1, "Invalid character in " + o);
    }
    function d(o, u, h) {
      var y = f(o, h);
      return h - 1 >= u && (y |= f(o, h - 1) << 4), y;
    }
    i.prototype._parseHex = function(o, u, h) {
      this.length = Math.ceil((o.length - u) / 6), this.words = new Array(this.length);
      for (var y = 0; y < this.length; y++)
        this.words[y] = 0;
      var E = 0, P = 0, w;
      if (h === "be")
        for (y = o.length - 1; y >= u; y -= 2)
          w = d(o, u, y) << E, this.words[P] |= w & 67108863, E >= 18 ? (E -= 18, P += 1, this.words[P] |= w >>> 26) : E += 8;
      else {
        var m = o.length - u;
        for (y = m % 2 === 0 ? u + 1 : u; y < o.length; y += 2)
          w = d(o, u, y) << E, this.words[P] |= w & 67108863, E >= 18 ? (E -= 18, P += 1, this.words[P] |= w >>> 26) : E += 8;
      }
      this._strip();
    };
    function c(o, u, h, y) {
      for (var E = 0, P = 0, w = Math.min(o.length, h), m = u; m < w; m++) {
        var l = o.charCodeAt(m) - 48;
        E *= y, l >= 49 ? P = l - 49 + 10 : l >= 17 ? P = l - 17 + 10 : P = l, n(l >= 0 && P < y, "Invalid character"), E += P;
      }
      return E;
    }
    i.prototype._parseBase = function(o, u, h) {
      this.words = [0], this.length = 1;
      for (var y = 0, E = 1; E <= 67108863; E *= u)
        y++;
      y--, E = E / u | 0;
      for (var P = o.length - h, w = P % y, m = Math.min(P, P - w) + h, l = 0, b = h; b < m; b += y)
        l = c(o, b, b + y, u), this.imuln(E), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
      if (w !== 0) {
        var W = 1;
        for (l = c(o, b, o.length, u), b = 0; b < w; b++)
          W *= u;
        this.imuln(W), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
      }
      this._strip();
    }, i.prototype.copy = function(o) {
      o.words = new Array(this.length);
      for (var u = 0; u < this.length; u++)
        o.words[u] = this.words[u];
      o.length = this.length, o.negative = this.negative, o.red = this.red;
    };
    function p(o, u) {
      o.words = u.words, o.length = u.length, o.negative = u.negative, o.red = u.red;
    }
    if (i.prototype._move = function(o) {
      p(o, this);
    }, i.prototype.clone = function() {
      var o = new i(null);
      return this.copy(o), o;
    }, i.prototype._expand = function(o) {
      for (; this.length < o; )
        this.words[this.length++] = 0;
      return this;
    }, i.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, i.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        i.prototype[Symbol.for("nodejs.util.inspect.custom")] = g;
      } catch {
        i.prototype.inspect = g;
      }
    else
      i.prototype.inspect = g;
    function g() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var v = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], O = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], N = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    i.prototype.toString = function(o, u) {
      o = o || 10, u = u | 0 || 1;
      var h;
      if (o === 16 || o === "hex") {
        h = "";
        for (var y = 0, E = 0, P = 0; P < this.length; P++) {
          var w = this.words[P], m = ((w << y | E) & 16777215).toString(16);
          E = w >>> 24 - y & 16777215, y += 2, y >= 26 && (y -= 26, P--), E !== 0 || P !== this.length - 1 ? h = v[6 - m.length] + m + h : h = m + h;
        }
        for (E !== 0 && (h = E.toString(16) + h); h.length % u !== 0; )
          h = "0" + h;
        return this.negative !== 0 && (h = "-" + h), h;
      }
      if (o === (o | 0) && o >= 2 && o <= 36) {
        var l = O[o], b = N[o];
        h = "";
        var W = this.clone();
        for (W.negative = 0; !W.isZero(); ) {
          var X = W.modrn(b).toString(o);
          W = W.idivn(b), W.isZero() ? h = X + h : h = v[l - X.length] + X + h;
        }
        for (this.isZero() && (h = "0" + h); h.length % u !== 0; )
          h = "0" + h;
        return this.negative !== 0 && (h = "-" + h), h;
      }
      n(!1, "Base should be between 2 and 36");
    }, i.prototype.toNumber = function() {
      var o = this.words[0];
      return this.length === 2 ? o += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? o += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -o : o;
    }, i.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, a && (i.prototype.toBuffer = function(o, u) {
      return this.toArrayLike(a, o, u);
    }), i.prototype.toArray = function(o, u) {
      return this.toArrayLike(Array, o, u);
    };
    var S = function(o, u) {
      return o.allocUnsafe ? o.allocUnsafe(u) : new o(u);
    };
    i.prototype.toArrayLike = function(o, u, h) {
      this._strip();
      var y = this.byteLength(), E = h || Math.max(1, y);
      n(y <= E, "byte array longer than desired length"), n(E > 0, "Requested array length <= 0");
      var P = S(o, E), w = u === "le" ? "LE" : "BE";
      return this["_toArrayLike" + w](P, y), P;
    }, i.prototype._toArrayLikeLE = function(o, u) {
      for (var h = 0, y = 0, E = 0, P = 0; E < this.length; E++) {
        var w = this.words[E] << P | y;
        o[h++] = w & 255, h < o.length && (o[h++] = w >> 8 & 255), h < o.length && (o[h++] = w >> 16 & 255), P === 6 ? (h < o.length && (o[h++] = w >> 24 & 255), y = 0, P = 0) : (y = w >>> 24, P += 2);
      }
      if (h < o.length)
        for (o[h++] = y; h < o.length; )
          o[h++] = 0;
    }, i.prototype._toArrayLikeBE = function(o, u) {
      for (var h = o.length - 1, y = 0, E = 0, P = 0; E < this.length; E++) {
        var w = this.words[E] << P | y;
        o[h--] = w & 255, h >= 0 && (o[h--] = w >> 8 & 255), h >= 0 && (o[h--] = w >> 16 & 255), P === 6 ? (h >= 0 && (o[h--] = w >> 24 & 255), y = 0, P = 0) : (y = w >>> 24, P += 2);
      }
      if (h >= 0)
        for (o[h--] = y; h >= 0; )
          o[h--] = 0;
    }, Math.clz32 ? i.prototype._countBits = function(o) {
      return 32 - Math.clz32(o);
    } : i.prototype._countBits = function(o) {
      var u = o, h = 0;
      return u >= 4096 && (h += 13, u >>>= 13), u >= 64 && (h += 7, u >>>= 7), u >= 8 && (h += 4, u >>>= 4), u >= 2 && (h += 2, u >>>= 2), h + u;
    }, i.prototype._zeroBits = function(o) {
      if (o === 0)
        return 26;
      var u = o, h = 0;
      return u & 8191 || (h += 13, u >>>= 13), u & 127 || (h += 7, u >>>= 7), u & 15 || (h += 4, u >>>= 4), u & 3 || (h += 2, u >>>= 2), u & 1 || h++, h;
    }, i.prototype.bitLength = function() {
      var o = this.words[this.length - 1], u = this._countBits(o);
      return (this.length - 1) * 26 + u;
    };
    function j(o) {
      for (var u = new Array(o.bitLength()), h = 0; h < u.length; h++) {
        var y = h / 26 | 0, E = h % 26;
        u[h] = o.words[y] >>> E & 1;
      }
      return u;
    }
    i.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var o = 0, u = 0; u < this.length; u++) {
        var h = this._zeroBits(this.words[u]);
        if (o += h, h !== 26)
          break;
      }
      return o;
    }, i.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, i.prototype.toTwos = function(o) {
      return this.negative !== 0 ? this.abs().inotn(o).iaddn(1) : this.clone();
    }, i.prototype.fromTwos = function(o) {
      return this.testn(o - 1) ? this.notn(o).iaddn(1).ineg() : this.clone();
    }, i.prototype.isNeg = function() {
      return this.negative !== 0;
    }, i.prototype.neg = function() {
      return this.clone().ineg();
    }, i.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, i.prototype.iuor = function(o) {
      for (; this.length < o.length; )
        this.words[this.length++] = 0;
      for (var u = 0; u < o.length; u++)
        this.words[u] = this.words[u] | o.words[u];
      return this._strip();
    }, i.prototype.ior = function(o) {
      return n((this.negative | o.negative) === 0), this.iuor(o);
    }, i.prototype.or = function(o) {
      return this.length > o.length ? this.clone().ior(o) : o.clone().ior(this);
    }, i.prototype.uor = function(o) {
      return this.length > o.length ? this.clone().iuor(o) : o.clone().iuor(this);
    }, i.prototype.iuand = function(o) {
      var u;
      this.length > o.length ? u = o : u = this;
      for (var h = 0; h < u.length; h++)
        this.words[h] = this.words[h] & o.words[h];
      return this.length = u.length, this._strip();
    }, i.prototype.iand = function(o) {
      return n((this.negative | o.negative) === 0), this.iuand(o);
    }, i.prototype.and = function(o) {
      return this.length > o.length ? this.clone().iand(o) : o.clone().iand(this);
    }, i.prototype.uand = function(o) {
      return this.length > o.length ? this.clone().iuand(o) : o.clone().iuand(this);
    }, i.prototype.iuxor = function(o) {
      var u, h;
      this.length > o.length ? (u = this, h = o) : (u = o, h = this);
      for (var y = 0; y < h.length; y++)
        this.words[y] = u.words[y] ^ h.words[y];
      if (this !== u)
        for (; y < u.length; y++)
          this.words[y] = u.words[y];
      return this.length = u.length, this._strip();
    }, i.prototype.ixor = function(o) {
      return n((this.negative | o.negative) === 0), this.iuxor(o);
    }, i.prototype.xor = function(o) {
      return this.length > o.length ? this.clone().ixor(o) : o.clone().ixor(this);
    }, i.prototype.uxor = function(o) {
      return this.length > o.length ? this.clone().iuxor(o) : o.clone().iuxor(this);
    }, i.prototype.inotn = function(o) {
      n(typeof o == "number" && o >= 0);
      var u = Math.ceil(o / 26) | 0, h = o % 26;
      this._expand(u), h > 0 && u--;
      for (var y = 0; y < u; y++)
        this.words[y] = ~this.words[y] & 67108863;
      return h > 0 && (this.words[y] = ~this.words[y] & 67108863 >> 26 - h), this._strip();
    }, i.prototype.notn = function(o) {
      return this.clone().inotn(o);
    }, i.prototype.setn = function(o, u) {
      n(typeof o == "number" && o >= 0);
      var h = o / 26 | 0, y = o % 26;
      return this._expand(h + 1), u ? this.words[h] = this.words[h] | 1 << y : this.words[h] = this.words[h] & ~(1 << y), this._strip();
    }, i.prototype.iadd = function(o) {
      var u;
      if (this.negative !== 0 && o.negative === 0)
        return this.negative = 0, u = this.isub(o), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && o.negative !== 0)
        return o.negative = 0, u = this.isub(o), o.negative = 1, u._normSign();
      var h, y;
      this.length > o.length ? (h = this, y = o) : (h = o, y = this);
      for (var E = 0, P = 0; P < y.length; P++)
        u = (h.words[P] | 0) + (y.words[P] | 0) + E, this.words[P] = u & 67108863, E = u >>> 26;
      for (; E !== 0 && P < h.length; P++)
        u = (h.words[P] | 0) + E, this.words[P] = u & 67108863, E = u >>> 26;
      if (this.length = h.length, E !== 0)
        this.words[this.length] = E, this.length++;
      else if (h !== this)
        for (; P < h.length; P++)
          this.words[P] = h.words[P];
      return this;
    }, i.prototype.add = function(o) {
      var u;
      return o.negative !== 0 && this.negative === 0 ? (o.negative = 0, u = this.sub(o), o.negative ^= 1, u) : o.negative === 0 && this.negative !== 0 ? (this.negative = 0, u = o.sub(this), this.negative = 1, u) : this.length > o.length ? this.clone().iadd(o) : o.clone().iadd(this);
    }, i.prototype.isub = function(o) {
      if (o.negative !== 0) {
        o.negative = 0;
        var u = this.iadd(o);
        return o.negative = 1, u._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(o), this.negative = 1, this._normSign();
      var h = this.cmp(o);
      if (h === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var y, E;
      h > 0 ? (y = this, E = o) : (y = o, E = this);
      for (var P = 0, w = 0; w < E.length; w++)
        u = (y.words[w] | 0) - (E.words[w] | 0) + P, P = u >> 26, this.words[w] = u & 67108863;
      for (; P !== 0 && w < y.length; w++)
        u = (y.words[w] | 0) + P, P = u >> 26, this.words[w] = u & 67108863;
      if (P === 0 && w < y.length && y !== this)
        for (; w < y.length; w++)
          this.words[w] = y.words[w];
      return this.length = Math.max(this.length, w), y !== this && (this.negative = 1), this._strip();
    }, i.prototype.sub = function(o) {
      return this.clone().isub(o);
    };
    function B(o, u, h) {
      h.negative = u.negative ^ o.negative;
      var y = o.length + u.length | 0;
      h.length = y, y = y - 1 | 0;
      var E = o.words[0] | 0, P = u.words[0] | 0, w = E * P, m = w & 67108863, l = w / 67108864 | 0;
      h.words[0] = m;
      for (var b = 1; b < y; b++) {
        for (var W = l >>> 26, X = l & 67108863, G = Math.min(b, u.length - 1), re = Math.max(0, b - o.length + 1); re <= G; re++) {
          var ce = b - re | 0;
          E = o.words[ce] | 0, P = u.words[re] | 0, w = E * P + X, W += w / 67108864 | 0, X = w & 67108863;
        }
        h.words[b] = X | 0, l = W | 0;
      }
      return l !== 0 ? h.words[b] = l | 0 : h.length--, h._strip();
    }
    var M = function(o, u, h) {
      var y = o.words, E = u.words, P = h.words, w = 0, m, l, b, W = y[0] | 0, X = W & 8191, G = W >>> 13, re = y[1] | 0, ce = re & 8191, pe = re >>> 13, ve = y[2] | 0, Ee = ve & 8191, Pe = ve >>> 13, xe = y[3] | 0, me = xe & 8191, te = xe >>> 13, U = y[4] | 0, ue = U & 8191, we = U >>> 13, ke = y[5] | 0, Re = ke & 8191, fe = ke >>> 13, x = y[6] | 0, _ = x & 8191, q = x >>> 13, ne = y[7] | 0, de = ne & 8191, ye = ne >>> 13, ge = y[8] | 0, be = ge & 8191, Me = ge >>> 13, Ce = y[9] | 0, je = Ce & 8191, Ue = Ce >>> 13, Qe = E[0] | 0, Ye = Qe & 8191, et = Qe >>> 13, At = E[1] | 0, it = At & 8191, tt = At >>> 13, Pt = E[2] | 0, dt = Pt & 8191, st = Pt >>> 13, zt = E[3] | 0, xt = zt & 8191, lt = zt >>> 13, $t = E[4] | 0, Tt = $t & 8191, at = $t >>> 13, Ut = E[5] | 0, Ot = Ut & 8191, He = Ut >>> 13, Vt = E[6] | 0, yt = Vt & 8191, ut = Vt >>> 13, It = E[7] | 0, kt = It & 8191, ot = It >>> 13, Rt = E[8] | 0, Nt = Rt & 8191, rt = Rt >>> 13, Dt = E[9] | 0, St = Dt & 8191, T = Dt >>> 13;
      h.negative = o.negative ^ u.negative, h.length = 19, m = Math.imul(X, Ye), l = Math.imul(X, et), l = l + Math.imul(G, Ye) | 0, b = Math.imul(G, et);
      var F = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (F >>> 26) | 0, F &= 67108863, m = Math.imul(ce, Ye), l = Math.imul(ce, et), l = l + Math.imul(pe, Ye) | 0, b = Math.imul(pe, et), m = m + Math.imul(X, it) | 0, l = l + Math.imul(X, tt) | 0, l = l + Math.imul(G, it) | 0, b = b + Math.imul(G, tt) | 0;
      var H = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (H >>> 26) | 0, H &= 67108863, m = Math.imul(Ee, Ye), l = Math.imul(Ee, et), l = l + Math.imul(Pe, Ye) | 0, b = Math.imul(Pe, et), m = m + Math.imul(ce, it) | 0, l = l + Math.imul(ce, tt) | 0, l = l + Math.imul(pe, it) | 0, b = b + Math.imul(pe, tt) | 0, m = m + Math.imul(X, dt) | 0, l = l + Math.imul(X, st) | 0, l = l + Math.imul(G, dt) | 0, b = b + Math.imul(G, st) | 0;
      var z = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (z >>> 26) | 0, z &= 67108863, m = Math.imul(me, Ye), l = Math.imul(me, et), l = l + Math.imul(te, Ye) | 0, b = Math.imul(te, et), m = m + Math.imul(Ee, it) | 0, l = l + Math.imul(Ee, tt) | 0, l = l + Math.imul(Pe, it) | 0, b = b + Math.imul(Pe, tt) | 0, m = m + Math.imul(ce, dt) | 0, l = l + Math.imul(ce, st) | 0, l = l + Math.imul(pe, dt) | 0, b = b + Math.imul(pe, st) | 0, m = m + Math.imul(X, xt) | 0, l = l + Math.imul(X, lt) | 0, l = l + Math.imul(G, xt) | 0, b = b + Math.imul(G, lt) | 0;
      var Q = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Q >>> 26) | 0, Q &= 67108863, m = Math.imul(ue, Ye), l = Math.imul(ue, et), l = l + Math.imul(we, Ye) | 0, b = Math.imul(we, et), m = m + Math.imul(me, it) | 0, l = l + Math.imul(me, tt) | 0, l = l + Math.imul(te, it) | 0, b = b + Math.imul(te, tt) | 0, m = m + Math.imul(Ee, dt) | 0, l = l + Math.imul(Ee, st) | 0, l = l + Math.imul(Pe, dt) | 0, b = b + Math.imul(Pe, st) | 0, m = m + Math.imul(ce, xt) | 0, l = l + Math.imul(ce, lt) | 0, l = l + Math.imul(pe, xt) | 0, b = b + Math.imul(pe, lt) | 0, m = m + Math.imul(X, Tt) | 0, l = l + Math.imul(X, at) | 0, l = l + Math.imul(G, Tt) | 0, b = b + Math.imul(G, at) | 0;
      var Z = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Z >>> 26) | 0, Z &= 67108863, m = Math.imul(Re, Ye), l = Math.imul(Re, et), l = l + Math.imul(fe, Ye) | 0, b = Math.imul(fe, et), m = m + Math.imul(ue, it) | 0, l = l + Math.imul(ue, tt) | 0, l = l + Math.imul(we, it) | 0, b = b + Math.imul(we, tt) | 0, m = m + Math.imul(me, dt) | 0, l = l + Math.imul(me, st) | 0, l = l + Math.imul(te, dt) | 0, b = b + Math.imul(te, st) | 0, m = m + Math.imul(Ee, xt) | 0, l = l + Math.imul(Ee, lt) | 0, l = l + Math.imul(Pe, xt) | 0, b = b + Math.imul(Pe, lt) | 0, m = m + Math.imul(ce, Tt) | 0, l = l + Math.imul(ce, at) | 0, l = l + Math.imul(pe, Tt) | 0, b = b + Math.imul(pe, at) | 0, m = m + Math.imul(X, Ot) | 0, l = l + Math.imul(X, He) | 0, l = l + Math.imul(G, Ot) | 0, b = b + Math.imul(G, He) | 0;
      var ie = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (ie >>> 26) | 0, ie &= 67108863, m = Math.imul(_, Ye), l = Math.imul(_, et), l = l + Math.imul(q, Ye) | 0, b = Math.imul(q, et), m = m + Math.imul(Re, it) | 0, l = l + Math.imul(Re, tt) | 0, l = l + Math.imul(fe, it) | 0, b = b + Math.imul(fe, tt) | 0, m = m + Math.imul(ue, dt) | 0, l = l + Math.imul(ue, st) | 0, l = l + Math.imul(we, dt) | 0, b = b + Math.imul(we, st) | 0, m = m + Math.imul(me, xt) | 0, l = l + Math.imul(me, lt) | 0, l = l + Math.imul(te, xt) | 0, b = b + Math.imul(te, lt) | 0, m = m + Math.imul(Ee, Tt) | 0, l = l + Math.imul(Ee, at) | 0, l = l + Math.imul(Pe, Tt) | 0, b = b + Math.imul(Pe, at) | 0, m = m + Math.imul(ce, Ot) | 0, l = l + Math.imul(ce, He) | 0, l = l + Math.imul(pe, Ot) | 0, b = b + Math.imul(pe, He) | 0, m = m + Math.imul(X, yt) | 0, l = l + Math.imul(X, ut) | 0, l = l + Math.imul(G, yt) | 0, b = b + Math.imul(G, ut) | 0;
      var he = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, m = Math.imul(de, Ye), l = Math.imul(de, et), l = l + Math.imul(ye, Ye) | 0, b = Math.imul(ye, et), m = m + Math.imul(_, it) | 0, l = l + Math.imul(_, tt) | 0, l = l + Math.imul(q, it) | 0, b = b + Math.imul(q, tt) | 0, m = m + Math.imul(Re, dt) | 0, l = l + Math.imul(Re, st) | 0, l = l + Math.imul(fe, dt) | 0, b = b + Math.imul(fe, st) | 0, m = m + Math.imul(ue, xt) | 0, l = l + Math.imul(ue, lt) | 0, l = l + Math.imul(we, xt) | 0, b = b + Math.imul(we, lt) | 0, m = m + Math.imul(me, Tt) | 0, l = l + Math.imul(me, at) | 0, l = l + Math.imul(te, Tt) | 0, b = b + Math.imul(te, at) | 0, m = m + Math.imul(Ee, Ot) | 0, l = l + Math.imul(Ee, He) | 0, l = l + Math.imul(Pe, Ot) | 0, b = b + Math.imul(Pe, He) | 0, m = m + Math.imul(ce, yt) | 0, l = l + Math.imul(ce, ut) | 0, l = l + Math.imul(pe, yt) | 0, b = b + Math.imul(pe, ut) | 0, m = m + Math.imul(X, kt) | 0, l = l + Math.imul(X, ot) | 0, l = l + Math.imul(G, kt) | 0, b = b + Math.imul(G, ot) | 0;
      var J = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (J >>> 26) | 0, J &= 67108863, m = Math.imul(be, Ye), l = Math.imul(be, et), l = l + Math.imul(Me, Ye) | 0, b = Math.imul(Me, et), m = m + Math.imul(de, it) | 0, l = l + Math.imul(de, tt) | 0, l = l + Math.imul(ye, it) | 0, b = b + Math.imul(ye, tt) | 0, m = m + Math.imul(_, dt) | 0, l = l + Math.imul(_, st) | 0, l = l + Math.imul(q, dt) | 0, b = b + Math.imul(q, st) | 0, m = m + Math.imul(Re, xt) | 0, l = l + Math.imul(Re, lt) | 0, l = l + Math.imul(fe, xt) | 0, b = b + Math.imul(fe, lt) | 0, m = m + Math.imul(ue, Tt) | 0, l = l + Math.imul(ue, at) | 0, l = l + Math.imul(we, Tt) | 0, b = b + Math.imul(we, at) | 0, m = m + Math.imul(me, Ot) | 0, l = l + Math.imul(me, He) | 0, l = l + Math.imul(te, Ot) | 0, b = b + Math.imul(te, He) | 0, m = m + Math.imul(Ee, yt) | 0, l = l + Math.imul(Ee, ut) | 0, l = l + Math.imul(Pe, yt) | 0, b = b + Math.imul(Pe, ut) | 0, m = m + Math.imul(ce, kt) | 0, l = l + Math.imul(ce, ot) | 0, l = l + Math.imul(pe, kt) | 0, b = b + Math.imul(pe, ot) | 0, m = m + Math.imul(X, Nt) | 0, l = l + Math.imul(X, rt) | 0, l = l + Math.imul(G, Nt) | 0, b = b + Math.imul(G, rt) | 0;
      var Y = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, m = Math.imul(je, Ye), l = Math.imul(je, et), l = l + Math.imul(Ue, Ye) | 0, b = Math.imul(Ue, et), m = m + Math.imul(be, it) | 0, l = l + Math.imul(be, tt) | 0, l = l + Math.imul(Me, it) | 0, b = b + Math.imul(Me, tt) | 0, m = m + Math.imul(de, dt) | 0, l = l + Math.imul(de, st) | 0, l = l + Math.imul(ye, dt) | 0, b = b + Math.imul(ye, st) | 0, m = m + Math.imul(_, xt) | 0, l = l + Math.imul(_, lt) | 0, l = l + Math.imul(q, xt) | 0, b = b + Math.imul(q, lt) | 0, m = m + Math.imul(Re, Tt) | 0, l = l + Math.imul(Re, at) | 0, l = l + Math.imul(fe, Tt) | 0, b = b + Math.imul(fe, at) | 0, m = m + Math.imul(ue, Ot) | 0, l = l + Math.imul(ue, He) | 0, l = l + Math.imul(we, Ot) | 0, b = b + Math.imul(we, He) | 0, m = m + Math.imul(me, yt) | 0, l = l + Math.imul(me, ut) | 0, l = l + Math.imul(te, yt) | 0, b = b + Math.imul(te, ut) | 0, m = m + Math.imul(Ee, kt) | 0, l = l + Math.imul(Ee, ot) | 0, l = l + Math.imul(Pe, kt) | 0, b = b + Math.imul(Pe, ot) | 0, m = m + Math.imul(ce, Nt) | 0, l = l + Math.imul(ce, rt) | 0, l = l + Math.imul(pe, Nt) | 0, b = b + Math.imul(pe, rt) | 0, m = m + Math.imul(X, St) | 0, l = l + Math.imul(X, T) | 0, l = l + Math.imul(G, St) | 0, b = b + Math.imul(G, T) | 0;
      var ee = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (ee >>> 26) | 0, ee &= 67108863, m = Math.imul(je, it), l = Math.imul(je, tt), l = l + Math.imul(Ue, it) | 0, b = Math.imul(Ue, tt), m = m + Math.imul(be, dt) | 0, l = l + Math.imul(be, st) | 0, l = l + Math.imul(Me, dt) | 0, b = b + Math.imul(Me, st) | 0, m = m + Math.imul(de, xt) | 0, l = l + Math.imul(de, lt) | 0, l = l + Math.imul(ye, xt) | 0, b = b + Math.imul(ye, lt) | 0, m = m + Math.imul(_, Tt) | 0, l = l + Math.imul(_, at) | 0, l = l + Math.imul(q, Tt) | 0, b = b + Math.imul(q, at) | 0, m = m + Math.imul(Re, Ot) | 0, l = l + Math.imul(Re, He) | 0, l = l + Math.imul(fe, Ot) | 0, b = b + Math.imul(fe, He) | 0, m = m + Math.imul(ue, yt) | 0, l = l + Math.imul(ue, ut) | 0, l = l + Math.imul(we, yt) | 0, b = b + Math.imul(we, ut) | 0, m = m + Math.imul(me, kt) | 0, l = l + Math.imul(me, ot) | 0, l = l + Math.imul(te, kt) | 0, b = b + Math.imul(te, ot) | 0, m = m + Math.imul(Ee, Nt) | 0, l = l + Math.imul(Ee, rt) | 0, l = l + Math.imul(Pe, Nt) | 0, b = b + Math.imul(Pe, rt) | 0, m = m + Math.imul(ce, St) | 0, l = l + Math.imul(ce, T) | 0, l = l + Math.imul(pe, St) | 0, b = b + Math.imul(pe, T) | 0;
      var se = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (se >>> 26) | 0, se &= 67108863, m = Math.imul(je, dt), l = Math.imul(je, st), l = l + Math.imul(Ue, dt) | 0, b = Math.imul(Ue, st), m = m + Math.imul(be, xt) | 0, l = l + Math.imul(be, lt) | 0, l = l + Math.imul(Me, xt) | 0, b = b + Math.imul(Me, lt) | 0, m = m + Math.imul(de, Tt) | 0, l = l + Math.imul(de, at) | 0, l = l + Math.imul(ye, Tt) | 0, b = b + Math.imul(ye, at) | 0, m = m + Math.imul(_, Ot) | 0, l = l + Math.imul(_, He) | 0, l = l + Math.imul(q, Ot) | 0, b = b + Math.imul(q, He) | 0, m = m + Math.imul(Re, yt) | 0, l = l + Math.imul(Re, ut) | 0, l = l + Math.imul(fe, yt) | 0, b = b + Math.imul(fe, ut) | 0, m = m + Math.imul(ue, kt) | 0, l = l + Math.imul(ue, ot) | 0, l = l + Math.imul(we, kt) | 0, b = b + Math.imul(we, ot) | 0, m = m + Math.imul(me, Nt) | 0, l = l + Math.imul(me, rt) | 0, l = l + Math.imul(te, Nt) | 0, b = b + Math.imul(te, rt) | 0, m = m + Math.imul(Ee, St) | 0, l = l + Math.imul(Ee, T) | 0, l = l + Math.imul(Pe, St) | 0, b = b + Math.imul(Pe, T) | 0;
      var le = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (le >>> 26) | 0, le &= 67108863, m = Math.imul(je, xt), l = Math.imul(je, lt), l = l + Math.imul(Ue, xt) | 0, b = Math.imul(Ue, lt), m = m + Math.imul(be, Tt) | 0, l = l + Math.imul(be, at) | 0, l = l + Math.imul(Me, Tt) | 0, b = b + Math.imul(Me, at) | 0, m = m + Math.imul(de, Ot) | 0, l = l + Math.imul(de, He) | 0, l = l + Math.imul(ye, Ot) | 0, b = b + Math.imul(ye, He) | 0, m = m + Math.imul(_, yt) | 0, l = l + Math.imul(_, ut) | 0, l = l + Math.imul(q, yt) | 0, b = b + Math.imul(q, ut) | 0, m = m + Math.imul(Re, kt) | 0, l = l + Math.imul(Re, ot) | 0, l = l + Math.imul(fe, kt) | 0, b = b + Math.imul(fe, ot) | 0, m = m + Math.imul(ue, Nt) | 0, l = l + Math.imul(ue, rt) | 0, l = l + Math.imul(we, Nt) | 0, b = b + Math.imul(we, rt) | 0, m = m + Math.imul(me, St) | 0, l = l + Math.imul(me, T) | 0, l = l + Math.imul(te, St) | 0, b = b + Math.imul(te, T) | 0;
      var Ae = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, m = Math.imul(je, Tt), l = Math.imul(je, at), l = l + Math.imul(Ue, Tt) | 0, b = Math.imul(Ue, at), m = m + Math.imul(be, Ot) | 0, l = l + Math.imul(be, He) | 0, l = l + Math.imul(Me, Ot) | 0, b = b + Math.imul(Me, He) | 0, m = m + Math.imul(de, yt) | 0, l = l + Math.imul(de, ut) | 0, l = l + Math.imul(ye, yt) | 0, b = b + Math.imul(ye, ut) | 0, m = m + Math.imul(_, kt) | 0, l = l + Math.imul(_, ot) | 0, l = l + Math.imul(q, kt) | 0, b = b + Math.imul(q, ot) | 0, m = m + Math.imul(Re, Nt) | 0, l = l + Math.imul(Re, rt) | 0, l = l + Math.imul(fe, Nt) | 0, b = b + Math.imul(fe, rt) | 0, m = m + Math.imul(ue, St) | 0, l = l + Math.imul(ue, T) | 0, l = l + Math.imul(we, St) | 0, b = b + Math.imul(we, T) | 0;
      var Te = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, m = Math.imul(je, Ot), l = Math.imul(je, He), l = l + Math.imul(Ue, Ot) | 0, b = Math.imul(Ue, He), m = m + Math.imul(be, yt) | 0, l = l + Math.imul(be, ut) | 0, l = l + Math.imul(Me, yt) | 0, b = b + Math.imul(Me, ut) | 0, m = m + Math.imul(de, kt) | 0, l = l + Math.imul(de, ot) | 0, l = l + Math.imul(ye, kt) | 0, b = b + Math.imul(ye, ot) | 0, m = m + Math.imul(_, Nt) | 0, l = l + Math.imul(_, rt) | 0, l = l + Math.imul(q, Nt) | 0, b = b + Math.imul(q, rt) | 0, m = m + Math.imul(Re, St) | 0, l = l + Math.imul(Re, T) | 0, l = l + Math.imul(fe, St) | 0, b = b + Math.imul(fe, T) | 0;
      var Ie = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, m = Math.imul(je, yt), l = Math.imul(je, ut), l = l + Math.imul(Ue, yt) | 0, b = Math.imul(Ue, ut), m = m + Math.imul(be, kt) | 0, l = l + Math.imul(be, ot) | 0, l = l + Math.imul(Me, kt) | 0, b = b + Math.imul(Me, ot) | 0, m = m + Math.imul(de, Nt) | 0, l = l + Math.imul(de, rt) | 0, l = l + Math.imul(ye, Nt) | 0, b = b + Math.imul(ye, rt) | 0, m = m + Math.imul(_, St) | 0, l = l + Math.imul(_, T) | 0, l = l + Math.imul(q, St) | 0, b = b + Math.imul(q, T) | 0;
      var We = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, m = Math.imul(je, kt), l = Math.imul(je, ot), l = l + Math.imul(Ue, kt) | 0, b = Math.imul(Ue, ot), m = m + Math.imul(be, Nt) | 0, l = l + Math.imul(be, rt) | 0, l = l + Math.imul(Me, Nt) | 0, b = b + Math.imul(Me, rt) | 0, m = m + Math.imul(de, St) | 0, l = l + Math.imul(de, T) | 0, l = l + Math.imul(ye, St) | 0, b = b + Math.imul(ye, T) | 0;
      var Ke = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Ke >>> 26) | 0, Ke &= 67108863, m = Math.imul(je, Nt), l = Math.imul(je, rt), l = l + Math.imul(Ue, Nt) | 0, b = Math.imul(Ue, rt), m = m + Math.imul(be, St) | 0, l = l + Math.imul(be, T) | 0, l = l + Math.imul(Me, St) | 0, b = b + Math.imul(Me, T) | 0;
      var Le = (w + m | 0) + ((l & 8191) << 13) | 0;
      w = (b + (l >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, m = Math.imul(je, St), l = Math.imul(je, T), l = l + Math.imul(Ue, St) | 0, b = Math.imul(Ue, T);
      var De = (w + m | 0) + ((l & 8191) << 13) | 0;
      return w = (b + (l >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, P[0] = F, P[1] = H, P[2] = z, P[3] = Q, P[4] = Z, P[5] = ie, P[6] = he, P[7] = J, P[8] = Y, P[9] = ee, P[10] = se, P[11] = le, P[12] = Ae, P[13] = Te, P[14] = Ie, P[15] = We, P[16] = Ke, P[17] = Le, P[18] = De, w !== 0 && (P[19] = w, h.length++), h;
    };
    Math.imul || (M = B);
    function I(o, u, h) {
      h.negative = u.negative ^ o.negative, h.length = o.length + u.length;
      for (var y = 0, E = 0, P = 0; P < h.length - 1; P++) {
        var w = E;
        E = 0;
        for (var m = y & 67108863, l = Math.min(P, u.length - 1), b = Math.max(0, P - o.length + 1); b <= l; b++) {
          var W = P - b, X = o.words[W] | 0, G = u.words[b] | 0, re = X * G, ce = re & 67108863;
          w = w + (re / 67108864 | 0) | 0, ce = ce + m | 0, m = ce & 67108863, w = w + (ce >>> 26) | 0, E += w >>> 26, w &= 67108863;
        }
        h.words[P] = m, y = w, w = E;
      }
      return y !== 0 ? h.words[P] = y : h.length--, h._strip();
    }
    function A(o, u, h) {
      return I(o, u, h);
    }
    i.prototype.mulTo = function(o, u) {
      var h, y = this.length + o.length;
      return this.length === 10 && o.length === 10 ? h = M(this, o, u) : y < 63 ? h = B(this, o, u) : y < 1024 ? h = I(this, o, u) : h = A(this, o, u), h;
    }, i.prototype.mul = function(o) {
      var u = new i(null);
      return u.words = new Array(this.length + o.length), this.mulTo(o, u);
    }, i.prototype.mulf = function(o) {
      var u = new i(null);
      return u.words = new Array(this.length + o.length), A(this, o, u);
    }, i.prototype.imul = function(o) {
      return this.clone().mulTo(o, this);
    }, i.prototype.imuln = function(o) {
      var u = o < 0;
      u && (o = -o), n(typeof o == "number"), n(o < 67108864);
      for (var h = 0, y = 0; y < this.length; y++) {
        var E = (this.words[y] | 0) * o, P = (E & 67108863) + (h & 67108863);
        h >>= 26, h += E / 67108864 | 0, h += P >>> 26, this.words[y] = P & 67108863;
      }
      return h !== 0 && (this.words[y] = h, this.length++), u ? this.ineg() : this;
    }, i.prototype.muln = function(o) {
      return this.clone().imuln(o);
    }, i.prototype.sqr = function() {
      return this.mul(this);
    }, i.prototype.isqr = function() {
      return this.imul(this.clone());
    }, i.prototype.pow = function(o) {
      var u = j(o);
      if (u.length === 0)
        return new i(1);
      for (var h = this, y = 0; y < u.length && u[y] === 0; y++, h = h.sqr())
        ;
      if (++y < u.length)
        for (var E = h.sqr(); y < u.length; y++, E = E.sqr())
          u[y] !== 0 && (h = h.mul(E));
      return h;
    }, i.prototype.iushln = function(o) {
      n(typeof o == "number" && o >= 0);
      var u = o % 26, h = (o - u) / 26, y = 67108863 >>> 26 - u << 26 - u, E;
      if (u !== 0) {
        var P = 0;
        for (E = 0; E < this.length; E++) {
          var w = this.words[E] & y, m = (this.words[E] | 0) - w << u;
          this.words[E] = m | P, P = w >>> 26 - u;
        }
        P && (this.words[E] = P, this.length++);
      }
      if (h !== 0) {
        for (E = this.length - 1; E >= 0; E--)
          this.words[E + h] = this.words[E];
        for (E = 0; E < h; E++)
          this.words[E] = 0;
        this.length += h;
      }
      return this._strip();
    }, i.prototype.ishln = function(o) {
      return n(this.negative === 0), this.iushln(o);
    }, i.prototype.iushrn = function(o, u, h) {
      n(typeof o == "number" && o >= 0);
      var y;
      u ? y = (u - u % 26) / 26 : y = 0;
      var E = o % 26, P = Math.min((o - E) / 26, this.length), w = 67108863 ^ 67108863 >>> E << E, m = h;
      if (y -= P, y = Math.max(0, y), m) {
        for (var l = 0; l < P; l++)
          m.words[l] = this.words[l];
        m.length = P;
      }
      if (P !== 0)
        if (this.length > P)
          for (this.length -= P, l = 0; l < this.length; l++)
            this.words[l] = this.words[l + P];
        else
          this.words[0] = 0, this.length = 1;
      var b = 0;
      for (l = this.length - 1; l >= 0 && (b !== 0 || l >= y); l--) {
        var W = this.words[l] | 0;
        this.words[l] = b << 26 - E | W >>> E, b = W & w;
      }
      return m && b !== 0 && (m.words[m.length++] = b), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, i.prototype.ishrn = function(o, u, h) {
      return n(this.negative === 0), this.iushrn(o, u, h);
    }, i.prototype.shln = function(o) {
      return this.clone().ishln(o);
    }, i.prototype.ushln = function(o) {
      return this.clone().iushln(o);
    }, i.prototype.shrn = function(o) {
      return this.clone().ishrn(o);
    }, i.prototype.ushrn = function(o) {
      return this.clone().iushrn(o);
    }, i.prototype.testn = function(o) {
      n(typeof o == "number" && o >= 0);
      var u = o % 26, h = (o - u) / 26, y = 1 << u;
      if (this.length <= h)
        return !1;
      var E = this.words[h];
      return !!(E & y);
    }, i.prototype.imaskn = function(o) {
      n(typeof o == "number" && o >= 0);
      var u = o % 26, h = (o - u) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= h)
        return this;
      if (u !== 0 && h++, this.length = Math.min(h, this.length), u !== 0) {
        var y = 67108863 ^ 67108863 >>> u << u;
        this.words[this.length - 1] &= y;
      }
      return this._strip();
    }, i.prototype.maskn = function(o) {
      return this.clone().imaskn(o);
    }, i.prototype.iaddn = function(o) {
      return n(typeof o == "number"), n(o < 67108864), o < 0 ? this.isubn(-o) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= o ? (this.words[0] = o - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(o), this.negative = 1, this) : this._iaddn(o);
    }, i.prototype._iaddn = function(o) {
      this.words[0] += o;
      for (var u = 0; u < this.length && this.words[u] >= 67108864; u++)
        this.words[u] -= 67108864, u === this.length - 1 ? this.words[u + 1] = 1 : this.words[u + 1]++;
      return this.length = Math.max(this.length, u + 1), this;
    }, i.prototype.isubn = function(o) {
      if (n(typeof o == "number"), n(o < 67108864), o < 0)
        return this.iaddn(-o);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(o), this.negative = 1, this;
      if (this.words[0] -= o, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var u = 0; u < this.length && this.words[u] < 0; u++)
          this.words[u] += 67108864, this.words[u + 1] -= 1;
      return this._strip();
    }, i.prototype.addn = function(o) {
      return this.clone().iaddn(o);
    }, i.prototype.subn = function(o) {
      return this.clone().isubn(o);
    }, i.prototype.iabs = function() {
      return this.negative = 0, this;
    }, i.prototype.abs = function() {
      return this.clone().iabs();
    }, i.prototype._ishlnsubmul = function(o, u, h) {
      var y = o.length + h, E;
      this._expand(y);
      var P, w = 0;
      for (E = 0; E < o.length; E++) {
        P = (this.words[E + h] | 0) + w;
        var m = (o.words[E] | 0) * u;
        P -= m & 67108863, w = (P >> 26) - (m / 67108864 | 0), this.words[E + h] = P & 67108863;
      }
      for (; E < this.length - h; E++)
        P = (this.words[E + h] | 0) + w, w = P >> 26, this.words[E + h] = P & 67108863;
      if (w === 0)
        return this._strip();
      for (n(w === -1), w = 0, E = 0; E < this.length; E++)
        P = -(this.words[E] | 0) + w, w = P >> 26, this.words[E] = P & 67108863;
      return this.negative = 1, this._strip();
    }, i.prototype._wordDiv = function(o, u) {
      var h = this.length - o.length, y = this.clone(), E = o, P = E.words[E.length - 1] | 0, w = this._countBits(P);
      h = 26 - w, h !== 0 && (E = E.ushln(h), y.iushln(h), P = E.words[E.length - 1] | 0);
      var m = y.length - E.length, l;
      if (u !== "mod") {
        l = new i(null), l.length = m + 1, l.words = new Array(l.length);
        for (var b = 0; b < l.length; b++)
          l.words[b] = 0;
      }
      var W = y.clone()._ishlnsubmul(E, 1, m);
      W.negative === 0 && (y = W, l && (l.words[m] = 1));
      for (var X = m - 1; X >= 0; X--) {
        var G = (y.words[E.length + X] | 0) * 67108864 + (y.words[E.length + X - 1] | 0);
        for (G = Math.min(G / P | 0, 67108863), y._ishlnsubmul(E, G, X); y.negative !== 0; )
          G--, y.negative = 0, y._ishlnsubmul(E, 1, X), y.isZero() || (y.negative ^= 1);
        l && (l.words[X] = G);
      }
      return l && l._strip(), y._strip(), u !== "div" && h !== 0 && y.iushrn(h), {
        div: l || null,
        mod: y
      };
    }, i.prototype.divmod = function(o, u, h) {
      if (n(!o.isZero()), this.isZero())
        return {
          div: new i(0),
          mod: new i(0)
        };
      var y, E, P;
      return this.negative !== 0 && o.negative === 0 ? (P = this.neg().divmod(o, u), u !== "mod" && (y = P.div.neg()), u !== "div" && (E = P.mod.neg(), h && E.negative !== 0 && E.iadd(o)), {
        div: y,
        mod: E
      }) : this.negative === 0 && o.negative !== 0 ? (P = this.divmod(o.neg(), u), u !== "mod" && (y = P.div.neg()), {
        div: y,
        mod: P.mod
      }) : this.negative & o.negative ? (P = this.neg().divmod(o.neg(), u), u !== "div" && (E = P.mod.neg(), h && E.negative !== 0 && E.isub(o)), {
        div: P.div,
        mod: E
      }) : o.length > this.length || this.cmp(o) < 0 ? {
        div: new i(0),
        mod: this
      } : o.length === 1 ? u === "div" ? {
        div: this.divn(o.words[0]),
        mod: null
      } : u === "mod" ? {
        div: null,
        mod: new i(this.modrn(o.words[0]))
      } : {
        div: this.divn(o.words[0]),
        mod: new i(this.modrn(o.words[0]))
      } : this._wordDiv(o, u);
    }, i.prototype.div = function(o) {
      return this.divmod(o, "div", !1).div;
    }, i.prototype.mod = function(o) {
      return this.divmod(o, "mod", !1).mod;
    }, i.prototype.umod = function(o) {
      return this.divmod(o, "mod", !0).mod;
    }, i.prototype.divRound = function(o) {
      var u = this.divmod(o);
      if (u.mod.isZero())
        return u.div;
      var h = u.div.negative !== 0 ? u.mod.isub(o) : u.mod, y = o.ushrn(1), E = o.andln(1), P = h.cmp(y);
      return P < 0 || E === 1 && P === 0 ? u.div : u.div.negative !== 0 ? u.div.isubn(1) : u.div.iaddn(1);
    }, i.prototype.modrn = function(o) {
      var u = o < 0;
      u && (o = -o), n(o <= 67108863);
      for (var h = (1 << 26) % o, y = 0, E = this.length - 1; E >= 0; E--)
        y = (h * y + (this.words[E] | 0)) % o;
      return u ? -y : y;
    }, i.prototype.modn = function(o) {
      return this.modrn(o);
    }, i.prototype.idivn = function(o) {
      var u = o < 0;
      u && (o = -o), n(o <= 67108863);
      for (var h = 0, y = this.length - 1; y >= 0; y--) {
        var E = (this.words[y] | 0) + h * 67108864;
        this.words[y] = E / o | 0, h = E % o;
      }
      return this._strip(), u ? this.ineg() : this;
    }, i.prototype.divn = function(o) {
      return this.clone().idivn(o);
    }, i.prototype.egcd = function(o) {
      n(o.negative === 0), n(!o.isZero());
      var u = this, h = o.clone();
      u.negative !== 0 ? u = u.umod(o) : u = u.clone();
      for (var y = new i(1), E = new i(0), P = new i(0), w = new i(1), m = 0; u.isEven() && h.isEven(); )
        u.iushrn(1), h.iushrn(1), ++m;
      for (var l = h.clone(), b = u.clone(); !u.isZero(); ) {
        for (var W = 0, X = 1; !(u.words[0] & X) && W < 26; ++W, X <<= 1)
          ;
        if (W > 0)
          for (u.iushrn(W); W-- > 0; )
            (y.isOdd() || E.isOdd()) && (y.iadd(l), E.isub(b)), y.iushrn(1), E.iushrn(1);
        for (var G = 0, re = 1; !(h.words[0] & re) && G < 26; ++G, re <<= 1)
          ;
        if (G > 0)
          for (h.iushrn(G); G-- > 0; )
            (P.isOdd() || w.isOdd()) && (P.iadd(l), w.isub(b)), P.iushrn(1), w.iushrn(1);
        u.cmp(h) >= 0 ? (u.isub(h), y.isub(P), E.isub(w)) : (h.isub(u), P.isub(y), w.isub(E));
      }
      return {
        a: P,
        b: w,
        gcd: h.iushln(m)
      };
    }, i.prototype._invmp = function(o) {
      n(o.negative === 0), n(!o.isZero());
      var u = this, h = o.clone();
      u.negative !== 0 ? u = u.umod(o) : u = u.clone();
      for (var y = new i(1), E = new i(0), P = h.clone(); u.cmpn(1) > 0 && h.cmpn(1) > 0; ) {
        for (var w = 0, m = 1; !(u.words[0] & m) && w < 26; ++w, m <<= 1)
          ;
        if (w > 0)
          for (u.iushrn(w); w-- > 0; )
            y.isOdd() && y.iadd(P), y.iushrn(1);
        for (var l = 0, b = 1; !(h.words[0] & b) && l < 26; ++l, b <<= 1)
          ;
        if (l > 0)
          for (h.iushrn(l); l-- > 0; )
            E.isOdd() && E.iadd(P), E.iushrn(1);
        u.cmp(h) >= 0 ? (u.isub(h), y.isub(E)) : (h.isub(u), E.isub(y));
      }
      var W;
      return u.cmpn(1) === 0 ? W = y : W = E, W.cmpn(0) < 0 && W.iadd(o), W;
    }, i.prototype.gcd = function(o) {
      if (this.isZero())
        return o.abs();
      if (o.isZero())
        return this.abs();
      var u = this.clone(), h = o.clone();
      u.negative = 0, h.negative = 0;
      for (var y = 0; u.isEven() && h.isEven(); y++)
        u.iushrn(1), h.iushrn(1);
      do {
        for (; u.isEven(); )
          u.iushrn(1);
        for (; h.isEven(); )
          h.iushrn(1);
        var E = u.cmp(h);
        if (E < 0) {
          var P = u;
          u = h, h = P;
        } else if (E === 0 || h.cmpn(1) === 0)
          break;
        u.isub(h);
      } while (!0);
      return h.iushln(y);
    }, i.prototype.invm = function(o) {
      return this.egcd(o).a.umod(o);
    }, i.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, i.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, i.prototype.andln = function(o) {
      return this.words[0] & o;
    }, i.prototype.bincn = function(o) {
      n(typeof o == "number");
      var u = o % 26, h = (o - u) / 26, y = 1 << u;
      if (this.length <= h)
        return this._expand(h + 1), this.words[h] |= y, this;
      for (var E = y, P = h; E !== 0 && P < this.length; P++) {
        var w = this.words[P] | 0;
        w += E, E = w >>> 26, w &= 67108863, this.words[P] = w;
      }
      return E !== 0 && (this.words[P] = E, this.length++), this;
    }, i.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, i.prototype.cmpn = function(o) {
      var u = o < 0;
      if (this.negative !== 0 && !u)
        return -1;
      if (this.negative === 0 && u)
        return 1;
      this._strip();
      var h;
      if (this.length > 1)
        h = 1;
      else {
        u && (o = -o), n(o <= 67108863, "Number is too big");
        var y = this.words[0] | 0;
        h = y === o ? 0 : y < o ? -1 : 1;
      }
      return this.negative !== 0 ? -h | 0 : h;
    }, i.prototype.cmp = function(o) {
      if (this.negative !== 0 && o.negative === 0)
        return -1;
      if (this.negative === 0 && o.negative !== 0)
        return 1;
      var u = this.ucmp(o);
      return this.negative !== 0 ? -u | 0 : u;
    }, i.prototype.ucmp = function(o) {
      if (this.length > o.length)
        return 1;
      if (this.length < o.length)
        return -1;
      for (var u = 0, h = this.length - 1; h >= 0; h--) {
        var y = this.words[h] | 0, E = o.words[h] | 0;
        if (y !== E) {
          y < E ? u = -1 : y > E && (u = 1);
          break;
        }
      }
      return u;
    }, i.prototype.gtn = function(o) {
      return this.cmpn(o) === 1;
    }, i.prototype.gt = function(o) {
      return this.cmp(o) === 1;
    }, i.prototype.gten = function(o) {
      return this.cmpn(o) >= 0;
    }, i.prototype.gte = function(o) {
      return this.cmp(o) >= 0;
    }, i.prototype.ltn = function(o) {
      return this.cmpn(o) === -1;
    }, i.prototype.lt = function(o) {
      return this.cmp(o) === -1;
    }, i.prototype.lten = function(o) {
      return this.cmpn(o) <= 0;
    }, i.prototype.lte = function(o) {
      return this.cmp(o) <= 0;
    }, i.prototype.eqn = function(o) {
      return this.cmpn(o) === 0;
    }, i.prototype.eq = function(o) {
      return this.cmp(o) === 0;
    }, i.red = function(o) {
      return new C(o);
    }, i.prototype.toRed = function(o) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), o.convertTo(this)._forceRed(o);
    }, i.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, i.prototype._forceRed = function(o) {
      return this.red = o, this;
    }, i.prototype.forceRed = function(o) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(o);
    }, i.prototype.redAdd = function(o) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, o);
    }, i.prototype.redIAdd = function(o) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, o);
    }, i.prototype.redSub = function(o) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, o);
    }, i.prototype.redISub = function(o) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, o);
    }, i.prototype.redShl = function(o) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, o);
    }, i.prototype.redMul = function(o) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, o), this.red.mul(this, o);
    }, i.prototype.redIMul = function(o) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, o), this.red.imul(this, o);
    }, i.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, i.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, i.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, i.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, i.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, i.prototype.redPow = function(o) {
      return n(this.red && !o.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, o);
    };
    var R = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function L(o, u) {
      this.name = o, this.p = new i(u, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    L.prototype._tmp = function() {
      var o = new i(null);
      return o.words = new Array(Math.ceil(this.n / 13)), o;
    }, L.prototype.ireduce = function(o) {
      var u = o, h;
      do
        this.split(u, this.tmp), u = this.imulK(u), u = u.iadd(this.tmp), h = u.bitLength();
      while (h > this.n);
      var y = h < this.n ? -1 : u.ucmp(this.p);
      return y === 0 ? (u.words[0] = 0, u.length = 1) : y > 0 ? u.isub(this.p) : u.strip !== void 0 ? u.strip() : u._strip(), u;
    }, L.prototype.split = function(o, u) {
      o.iushrn(this.n, 0, u);
    }, L.prototype.imulK = function(o) {
      return o.imul(this.k);
    };
    function K() {
      L.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(K, L), K.prototype.split = function(o, u) {
      for (var h = 4194303, y = Math.min(o.length, 9), E = 0; E < y; E++)
        u.words[E] = o.words[E];
      if (u.length = y, o.length <= 9) {
        o.words[0] = 0, o.length = 1;
        return;
      }
      var P = o.words[9];
      for (u.words[u.length++] = P & h, E = 10; E < o.length; E++) {
        var w = o.words[E] | 0;
        o.words[E - 10] = (w & h) << 4 | P >>> 22, P = w;
      }
      P >>>= 22, o.words[E - 10] = P, P === 0 && o.length > 10 ? o.length -= 10 : o.length -= 9;
    }, K.prototype.imulK = function(o) {
      o.words[o.length] = 0, o.words[o.length + 1] = 0, o.length += 2;
      for (var u = 0, h = 0; h < o.length; h++) {
        var y = o.words[h] | 0;
        u += y * 977, o.words[h] = u & 67108863, u = y * 64 + (u / 67108864 | 0);
      }
      return o.words[o.length - 1] === 0 && (o.length--, o.words[o.length - 1] === 0 && o.length--), o;
    };
    function $() {
      L.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s($, L);
    function k() {
      L.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(k, L);
    function V() {
      L.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(V, L), V.prototype.imulK = function(o) {
      for (var u = 0, h = 0; h < o.length; h++) {
        var y = (o.words[h] | 0) * 19 + u, E = y & 67108863;
        y >>>= 26, o.words[h] = E, u = y;
      }
      return u !== 0 && (o.words[o.length++] = u), o;
    }, i._prime = function(o) {
      if (R[o])
        return R[o];
      var u;
      if (o === "k256")
        u = new K();
      else if (o === "p224")
        u = new $();
      else if (o === "p192")
        u = new k();
      else if (o === "p25519")
        u = new V();
      else
        throw new Error("Unknown prime " + o);
      return R[o] = u, u;
    };
    function C(o) {
      if (typeof o == "string") {
        var u = i._prime(o);
        this.m = u.p, this.prime = u;
      } else
        n(o.gtn(1), "modulus must be greater than 1"), this.m = o, this.prime = null;
    }
    C.prototype._verify1 = function(o) {
      n(o.negative === 0, "red works only with positives"), n(o.red, "red works only with red numbers");
    }, C.prototype._verify2 = function(o, u) {
      n((o.negative | u.negative) === 0, "red works only with positives"), n(
        o.red && o.red === u.red,
        "red works only with red numbers"
      );
    }, C.prototype.imod = function(o) {
      return this.prime ? this.prime.ireduce(o)._forceRed(this) : (p(o, o.umod(this.m)._forceRed(this)), o);
    }, C.prototype.neg = function(o) {
      return o.isZero() ? o.clone() : this.m.sub(o)._forceRed(this);
    }, C.prototype.add = function(o, u) {
      this._verify2(o, u);
      var h = o.add(u);
      return h.cmp(this.m) >= 0 && h.isub(this.m), h._forceRed(this);
    }, C.prototype.iadd = function(o, u) {
      this._verify2(o, u);
      var h = o.iadd(u);
      return h.cmp(this.m) >= 0 && h.isub(this.m), h;
    }, C.prototype.sub = function(o, u) {
      this._verify2(o, u);
      var h = o.sub(u);
      return h.cmpn(0) < 0 && h.iadd(this.m), h._forceRed(this);
    }, C.prototype.isub = function(o, u) {
      this._verify2(o, u);
      var h = o.isub(u);
      return h.cmpn(0) < 0 && h.iadd(this.m), h;
    }, C.prototype.shl = function(o, u) {
      return this._verify1(o), this.imod(o.ushln(u));
    }, C.prototype.imul = function(o, u) {
      return this._verify2(o, u), this.imod(o.imul(u));
    }, C.prototype.mul = function(o, u) {
      return this._verify2(o, u), this.imod(o.mul(u));
    }, C.prototype.isqr = function(o) {
      return this.imul(o, o.clone());
    }, C.prototype.sqr = function(o) {
      return this.mul(o, o);
    }, C.prototype.sqrt = function(o) {
      if (o.isZero())
        return o.clone();
      var u = this.m.andln(3);
      if (n(u % 2 === 1), u === 3) {
        var h = this.m.add(new i(1)).iushrn(2);
        return this.pow(o, h);
      }
      for (var y = this.m.subn(1), E = 0; !y.isZero() && y.andln(1) === 0; )
        E++, y.iushrn(1);
      n(!y.isZero());
      var P = new i(1).toRed(this), w = P.redNeg(), m = this.m.subn(1).iushrn(1), l = this.m.bitLength();
      for (l = new i(2 * l * l).toRed(this); this.pow(l, m).cmp(w) !== 0; )
        l.redIAdd(w);
      for (var b = this.pow(l, y), W = this.pow(o, y.addn(1).iushrn(1)), X = this.pow(o, y), G = E; X.cmp(P) !== 0; ) {
        for (var re = X, ce = 0; re.cmp(P) !== 0; ce++)
          re = re.redSqr();
        n(ce < G);
        var pe = this.pow(b, new i(1).iushln(G - ce - 1));
        W = W.redMul(pe), b = pe.redSqr(), X = X.redMul(b), G = ce;
      }
      return W;
    }, C.prototype.invm = function(o) {
      var u = o._invmp(this.m);
      return u.negative !== 0 ? (u.negative = 0, this.imod(u).redNeg()) : this.imod(u);
    }, C.prototype.pow = function(o, u) {
      if (u.isZero())
        return new i(1).toRed(this);
      if (u.cmpn(1) === 0)
        return o.clone();
      var h = 4, y = new Array(1 << h);
      y[0] = new i(1).toRed(this), y[1] = o;
      for (var E = 2; E < y.length; E++)
        y[E] = this.mul(y[E - 1], o);
      var P = y[0], w = 0, m = 0, l = u.bitLength() % 26;
      for (l === 0 && (l = 26), E = u.length - 1; E >= 0; E--) {
        for (var b = u.words[E], W = l - 1; W >= 0; W--) {
          var X = b >> W & 1;
          if (P !== y[0] && (P = this.sqr(P)), X === 0 && w === 0) {
            m = 0;
            continue;
          }
          w <<= 1, w |= X, m++, !(m !== h && (E !== 0 || W !== 0)) && (P = this.mul(P, y[w]), m = 0, w = 0);
        }
        l = 26;
      }
      return P;
    }, C.prototype.convertTo = function(o) {
      var u = o.umod(this.m);
      return u === o ? u.clone() : u;
    }, C.prototype.convertFrom = function(o) {
      var u = o.clone();
      return u.red = null, u;
    }, i.mont = function(o) {
      return new D(o);
    };
    function D(o) {
      C.call(this, o), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(D, C), D.prototype.convertTo = function(o) {
      return this.imod(o.ushln(this.shift));
    }, D.prototype.convertFrom = function(o) {
      var u = this.imod(o.mul(this.rinv));
      return u.red = null, u;
    }, D.prototype.imul = function(o, u) {
      if (o.isZero() || u.isZero())
        return o.words[0] = 0, o.length = 1, o;
      var h = o.imul(u), y = h.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), E = h.isub(y).iushrn(this.shift), P = E;
      return E.cmp(this.m) >= 0 ? P = E.isub(this.m) : E.cmpn(0) < 0 && (P = E.iadd(this.m)), P._forceRed(this);
    }, D.prototype.mul = function(o, u) {
      if (o.isZero() || u.isZero())
        return new i(0)._forceRed(this);
      var h = o.mul(u), y = h.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), E = h.isub(y).iushrn(this.shift), P = E;
      return E.cmp(this.m) >= 0 ? P = E.isub(this.m) : E.cmpn(0) < 0 && (P = E.iadd(this.m)), P._forceRed(this);
    }, D.prototype.invm = function(o) {
      var u = this.imod(o._invmp(this.m).mul(this.r2));
      return u._forceRed(this);
    };
  })(e, nr);
})(x8);
var cS = x8.exports;
const lS = /* @__PURE__ */ iS(cS), dS = "logger/5.7.0";
let K3 = !1, J3 = !1;
const th = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let Q3 = th.default, Vf = null;
function hS() {
  try {
    const e = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((t) => {
      try {
        if ("test".normalize(t) !== "test")
          throw new Error("bad normalize");
      } catch {
        e.push(t);
      }
    }), e.length)
      throw new Error("missing " + e.join(", "));
    if ("é".normalize("NFD") !== "é")
      throw new Error("broken implementation");
  } catch (e) {
    return e.message;
  }
  return null;
}
const Z3 = hS();
var Hp;
(function(e) {
  e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})(Hp || (Hp = {}));
var Di;
(function(e) {
  e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})(Di || (Di = {}));
const Y3 = "0123456789abcdef";
class hr {
  constructor(t) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }
  _log(t, r) {
    const n = t.toLowerCase();
    th[n] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !(Q3 > th[n]) && console.log.apply(console, r);
  }
  debug(...t) {
    this._log(hr.levels.DEBUG, t);
  }
  info(...t) {
    this._log(hr.levels.INFO, t);
  }
  warn(...t) {
    this._log(hr.levels.WARNING, t);
  }
  makeError(t, r, n) {
    if (J3)
      return this.makeError("censored error", r, {});
    r || (r = hr.errors.UNKNOWN_ERROR), n || (n = {});
    const s = [];
    Object.keys(n).forEach((d) => {
      const c = n[d];
      try {
        if (c instanceof Uint8Array) {
          let p = "";
          for (let g = 0; g < c.length; g++)
            p += Y3[c[g] >> 4], p += Y3[c[g] & 15];
          s.push(d + "=Uint8Array(0x" + p + ")");
        } else
          s.push(d + "=" + JSON.stringify(c));
      } catch {
        s.push(d + "=" + JSON.stringify(n[d].toString()));
      }
    }), s.push(`code=${r}`), s.push(`version=${this.version}`);
    const i = t;
    let a = "";
    switch (r) {
      case Di.NUMERIC_FAULT: {
        a = "NUMERIC_FAULT";
        const d = t;
        switch (d) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            a += "-" + d;
            break;
          case "negative-power":
          case "negative-width":
            a += "-unsupported";
            break;
          case "unbound-bitwise-result":
            a += "-unbound-result";
            break;
        }
        break;
      }
      case Di.CALL_EXCEPTION:
      case Di.INSUFFICIENT_FUNDS:
      case Di.MISSING_NEW:
      case Di.NONCE_EXPIRED:
      case Di.REPLACEMENT_UNDERPRICED:
      case Di.TRANSACTION_REPLACED:
      case Di.UNPREDICTABLE_GAS_LIMIT:
        a = r;
        break;
    }
    a && (t += " [ See: https://links.ethers.org/v5-errors-" + a + " ]"), s.length && (t += " (" + s.join(", ") + ")");
    const f = new Error(t);
    return f.reason = i, f.code = r, Object.keys(n).forEach(function(d) {
      f[d] = n[d];
    }), f;
  }
  throwError(t, r, n) {
    throw this.makeError(t, r, n);
  }
  throwArgumentError(t, r, n) {
    return this.throwError(t, hr.errors.INVALID_ARGUMENT, {
      argument: r,
      value: n
    });
  }
  assert(t, r, n, s) {
    t || this.throwError(r, n, s);
  }
  assertArgument(t, r, n, s) {
    t || this.throwArgumentError(r, n, s);
  }
  checkNormalize(t) {
    Z3 && this.throwError("platform missing String.prototype.normalize", hr.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: Z3
    });
  }
  checkSafeUint53(t, r) {
    typeof t == "number" && (r == null && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, hr.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: t
    }), t % 1 && this.throwError(r, hr.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: t
    }));
  }
  checkArgumentCount(t, r, n) {
    n ? n = ": " + n : n = "", t < r && this.throwError("missing argument" + n, hr.errors.MISSING_ARGUMENT, {
      count: t,
      expectedCount: r
    }), t > r && this.throwError("too many arguments" + n, hr.errors.UNEXPECTED_ARGUMENT, {
      count: t,
      expectedCount: r
    });
  }
  checkNew(t, r) {
    (t === Object || t == null) && this.throwError("missing new", hr.errors.MISSING_NEW, { name: r.name });
  }
  checkAbstract(t, r) {
    t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", hr.errors.UNSUPPORTED_OPERATION, { name: t.name, operation: "new" }) : (t === Object || t == null) && this.throwError("missing new", hr.errors.MISSING_NEW, { name: r.name });
  }
  static globalLogger() {
    return Vf || (Vf = new hr(dS)), Vf;
  }
  static setCensorship(t, r) {
    if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", hr.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), K3) {
      if (!t)
        return;
      this.globalLogger().throwError("error censorship permanent", hr.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    J3 = !!t, K3 = !!r;
  }
  static setLogLevel(t) {
    const r = th[t.toLowerCase()];
    if (r == null) {
      hr.globalLogger().warn("invalid log level - " + t);
      return;
    }
    Q3 = r;
  }
  static from(t) {
    return new hr(t);
  }
}
hr.errors = Di;
hr.levels = Hp;
const fS = "bytes/5.7.0", xo = new hr(fS);
function T8(e) {
  return !!e.toHexString;
}
function rh(e) {
  return e.slice || (e.slice = function() {
    const t = Array.prototype.slice.call(arguments);
    return rh(new Uint8Array(Array.prototype.slice.apply(e, t)));
  }), e;
}
function X3(e) {
  return typeof e == "number" && e == e && e % 1 === 0;
}
function bd(e) {
  if (e == null)
    return !1;
  if (e.constructor === Uint8Array)
    return !0;
  if (typeof e == "string" || !X3(e.length) || e.length < 0)
    return !1;
  for (let t = 0; t < e.length; t++) {
    const r = e[t];
    if (!X3(r) || r < 0 || r >= 256)
      return !1;
  }
  return !0;
}
function pS(e, t) {
  if (t || (t = {}), typeof e == "number") {
    xo.checkSafeUint53(e, "invalid arrayify value");
    const r = [];
    for (; e; )
      r.unshift(e & 255), e = parseInt(String(e / 256));
    return r.length === 0 && r.push(0), rh(new Uint8Array(r));
  }
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), T8(e) && (e = e.toHexString()), rc(e)) {
    let r = e.substring(2);
    r.length % 2 && (t.hexPad === "left" ? r = "0" + r : t.hexPad === "right" ? r += "0" : xo.throwArgumentError("hex data is odd-length", "value", e));
    const n = [];
    for (let s = 0; s < r.length; s += 2)
      n.push(parseInt(r.substring(s, s + 2), 16));
    return rh(new Uint8Array(n));
  }
  return bd(e) ? rh(new Uint8Array(e)) : xo.throwArgumentError("invalid arrayify value", "value", e);
}
function rc(e, t) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/));
}
const qf = "0123456789abcdef";
function k8(e, t) {
  if (t || (t = {}), typeof e == "number") {
    xo.checkSafeUint53(e, "invalid hexlify value");
    let r = "";
    for (; e; )
      r = qf[e & 15] + r, e = Math.floor(e / 16);
    return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
  }
  if (typeof e == "bigint")
    return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), T8(e))
    return e.toHexString();
  if (rc(e))
    return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : xo.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
  if (bd(e)) {
    let r = "0x";
    for (let n = 0; n < e.length; n++) {
      let s = e[n];
      r += qf[(s & 240) >> 4] + qf[s & 15];
    }
    return r;
  }
  return xo.throwArgumentError("invalid hexlify value", "value", e);
}
function eb(e, t) {
  for (typeof e != "string" ? e = k8(e) : rc(e) || xo.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && xo.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2; )
    e = "0x0" + e.substring(2);
  return e;
}
const S8 = "bignumber/5.7.0";
var Wp = lS.BN;
const js = new hr(S8), $f = {}, tb = 9007199254740991;
function gS(e) {
  return e != null && (Lr.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || rc(e) || typeof e == "bigint" || bd(e));
}
let rb = !1;
class Lr {
  constructor(t, r) {
    t !== $f && js.throwError("cannot call constructor directly; use BigNumber.from", hr.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(t) {
    return Mn(cr(this).fromTwos(t));
  }
  toTwos(t) {
    return Mn(cr(this).toTwos(t));
  }
  abs() {
    return this._hex[0] === "-" ? Lr.from(this._hex.substring(1)) : this;
  }
  add(t) {
    return Mn(cr(this).add(cr(t)));
  }
  sub(t) {
    return Mn(cr(this).sub(cr(t)));
  }
  div(t) {
    return Lr.from(t).isZero() && si("division-by-zero", "div"), Mn(cr(this).div(cr(t)));
  }
  mul(t) {
    return Mn(cr(this).mul(cr(t)));
  }
  mod(t) {
    const r = cr(t);
    return r.isNeg() && si("division-by-zero", "mod"), Mn(cr(this).umod(r));
  }
  pow(t) {
    const r = cr(t);
    return r.isNeg() && si("negative-power", "pow"), Mn(cr(this).pow(r));
  }
  and(t) {
    const r = cr(t);
    return (this.isNegative() || r.isNeg()) && si("unbound-bitwise-result", "and"), Mn(cr(this).and(r));
  }
  or(t) {
    const r = cr(t);
    return (this.isNegative() || r.isNeg()) && si("unbound-bitwise-result", "or"), Mn(cr(this).or(r));
  }
  xor(t) {
    const r = cr(t);
    return (this.isNegative() || r.isNeg()) && si("unbound-bitwise-result", "xor"), Mn(cr(this).xor(r));
  }
  mask(t) {
    return (this.isNegative() || t < 0) && si("negative-width", "mask"), Mn(cr(this).maskn(t));
  }
  shl(t) {
    return (this.isNegative() || t < 0) && si("negative-width", "shl"), Mn(cr(this).shln(t));
  }
  shr(t) {
    return (this.isNegative() || t < 0) && si("negative-width", "shr"), Mn(cr(this).shrn(t));
  }
  eq(t) {
    return cr(this).eq(cr(t));
  }
  lt(t) {
    return cr(this).lt(cr(t));
  }
  lte(t) {
    return cr(this).lte(cr(t));
  }
  gt(t) {
    return cr(this).gt(cr(t));
  }
  gte(t) {
    return cr(this).gte(cr(t));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return cr(this).isZero();
  }
  toNumber() {
    try {
      return cr(this).toNumber();
    } catch {
      si("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return js.throwError("this platform does not support BigInt", hr.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? rb || (rb = !0, js.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? js.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", hr.errors.UNEXPECTED_ARGUMENT, {}) : js.throwError("BigNumber.toString does not accept parameters", hr.errors.UNEXPECTED_ARGUMENT, {})), cr(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(t) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(t) {
    if (t instanceof Lr)
      return t;
    if (typeof t == "string")
      return t.match(/^-?0x[0-9a-f]+$/i) ? new Lr($f, td(t)) : t.match(/^-?[0-9]+$/) ? new Lr($f, td(new Wp(t))) : js.throwArgumentError("invalid BigNumber string", "value", t);
    if (typeof t == "number")
      return t % 1 && si("underflow", "BigNumber.from", t), (t >= tb || t <= -tb) && si("overflow", "BigNumber.from", t), Lr.from(String(t));
    const r = t;
    if (typeof r == "bigint")
      return Lr.from(r.toString());
    if (bd(r))
      return Lr.from(k8(r));
    if (r)
      if (r.toHexString) {
        const n = r.toHexString();
        if (typeof n == "string")
          return Lr.from(n);
      } else {
        let n = r._hex;
        if (n == null && r.type === "BigNumber" && (n = r.hex), typeof n == "string" && (rc(n) || n[0] === "-" && rc(n.substring(1))))
          return Lr.from(n);
      }
    return js.throwArgumentError("invalid BigNumber value", "value", t);
  }
  static isBigNumber(t) {
    return !!(t && t._isBigNumber);
  }
}
function td(e) {
  if (typeof e != "string")
    return td(e.toString(16));
  if (e[0] === "-")
    return e = e.substring(1), e[0] === "-" && js.throwArgumentError("invalid hex", "value", e), e = td(e), e === "0x00" ? e : "-" + e;
  if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x")
    return "0x00";
  for (e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00"; )
    e = "0x" + e.substring(4);
  return e;
}
function Mn(e) {
  return Lr.from(td(e));
}
function cr(e) {
  const t = Lr.from(e).toHexString();
  return t[0] === "-" ? new Wp("-" + t.substring(3), 16) : new Wp(t.substring(2), 16);
}
function si(e, t, r) {
  const n = { fault: e, operation: t };
  return r != null && (n.value = r), js.throwError(e, hr.errors.NUMERIC_FAULT, n);
}
const On = new hr(S8), U0 = {}, M8 = Lr.from(0), I8 = Lr.from(-1);
function R8(e, t, r, n) {
  const s = { fault: t, operation: r };
  return n !== void 0 && (s.value = n), On.throwError(e, hr.errors.NUMERIC_FAULT, s);
}
let D0 = "0";
for (; D0.length < 256; )
  D0 += D0;
function D1(e) {
  if (typeof e != "number")
    try {
      e = Lr.from(e).toNumber();
    } catch {
    }
  return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + D0.substring(0, e) : On.throwArgumentError("invalid decimal size", "decimals", e);
}
function nh(e, t) {
  t == null && (t = 0);
  const r = D1(t);
  e = Lr.from(e);
  const n = e.lt(M8);
  n && (e = e.mul(I8));
  let s = e.mod(r).toString();
  for (; s.length < r.length - 1; )
    s = "0" + s;
  s = s.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const i = e.div(r).toString();
  return r.length === 1 ? e = i : e = i + "." + s, n && (e = "-" + e), e;
}
function ns(e, t) {
  t == null && (t = 0);
  const r = D1(t);
  (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && On.throwArgumentError("invalid decimal value", "value", e);
  const n = e.substring(0, 1) === "-";
  n && (e = e.substring(1)), e === "." && On.throwArgumentError("missing value", "value", e);
  const s = e.split(".");
  s.length > 2 && On.throwArgumentError("too many decimal points", "value", e);
  let i = s[0], a = s[1];
  for (i || (i = "0"), a || (a = "0"); a[a.length - 1] === "0"; )
    a = a.substring(0, a.length - 1);
  for (a.length > r.length - 1 && R8("fractional component exceeds decimals", "underflow", "parseFixed"), a === "" && (a = "0"); a.length < r.length - 1; )
    a += "0";
  const f = Lr.from(i), d = Lr.from(a);
  let c = f.mul(r).add(d);
  return n && (c = c.mul(I8)), c;
}
class Iu {
  constructor(t, r, n, s) {
    t !== U0 && On.throwError("cannot use FixedFormat constructor; use FixedFormat.from", hr.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = r, this.width = n, this.decimals = s, this.name = (r ? "" : "u") + "fixed" + String(n) + "x" + String(s), this._multiplier = D1(s), Object.freeze(this);
  }
  static from(t) {
    if (t instanceof Iu)
      return t;
    typeof t == "number" && (t = `fixed128x${t}`);
    let r = !0, n = 128, s = 18;
    if (typeof t == "string") {
      if (t !== "fixed")
        if (t === "ufixed")
          r = !1;
        else {
          const i = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          i || On.throwArgumentError("invalid fixed format", "format", t), r = i[1] !== "u", n = parseInt(i[2]), s = parseInt(i[3]);
        }
    } else if (t) {
      const i = (a, f, d) => t[a] == null ? d : (typeof t[a] !== f && On.throwArgumentError("invalid fixed format (" + a + " not " + f + ")", "format." + a, t[a]), t[a]);
      r = i("signed", "boolean", r), n = i("width", "number", n), s = i("decimals", "number", s);
    }
    return n % 8 && On.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", n), s > 80 && On.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", s), new Iu(U0, r, n, s);
  }
}
class sn {
  constructor(t, r, n, s) {
    t !== U0 && On.throwError("cannot use FixedNumber constructor; use FixedNumber.from", hr.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = s, this._hex = r, this._value = n, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(t) {
    this.format.name !== t.format.name && On.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
  }
  addUnsafe(t) {
    this._checkFormat(t);
    const r = ns(this._value, this.format.decimals), n = ns(t._value, t.format.decimals);
    return sn.fromValue(r.add(n), this.format.decimals, this.format);
  }
  subUnsafe(t) {
    this._checkFormat(t);
    const r = ns(this._value, this.format.decimals), n = ns(t._value, t.format.decimals);
    return sn.fromValue(r.sub(n), this.format.decimals, this.format);
  }
  mulUnsafe(t) {
    this._checkFormat(t);
    const r = ns(this._value, this.format.decimals), n = ns(t._value, t.format.decimals);
    return sn.fromValue(r.mul(n).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(t) {
    this._checkFormat(t);
    const r = ns(this._value, this.format.decimals), n = ns(t._value, t.format.decimals);
    return sn.fromValue(r.mul(this.format._multiplier).div(n), this.format.decimals, this.format);
  }
  floor() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let r = sn.from(t[0], this.format);
    const n = !t[1].match(/^(0*)$/);
    return this.isNegative() && n && (r = r.subUnsafe(nb.toFormat(r.format))), r;
  }
  ceiling() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let r = sn.from(t[0], this.format);
    const n = !t[1].match(/^(0*)$/);
    return !this.isNegative() && n && (r = r.addUnsafe(nb.toFormat(r.format))), r;
  }
  // @TODO: Support other rounding algorithms
  round(t) {
    t == null && (t = 0);
    const r = this.toString().split(".");
    if (r.length === 1 && r.push("0"), (t < 0 || t > 80 || t % 1) && On.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t)
      return this;
    const n = sn.from("1" + D0.substring(0, t), this.format), s = mS.toFormat(this.format);
    return this.mulUnsafe(n).addUnsafe(s).floor().divUnsafe(n);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(t) {
    if (t == null)
      return this._hex;
    t % 8 && On.throwArgumentError("invalid byte width", "width", t);
    const r = Lr.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
    return eb(r, t / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(t) {
    return sn.fromString(this._value, t);
  }
  static fromValue(t, r, n) {
    return n == null && r != null && !gS(r) && (n = r, r = null), r == null && (r = 0), n == null && (n = "fixed"), sn.fromString(nh(t, r), Iu.from(n));
  }
  static fromString(t, r) {
    r == null && (r = "fixed");
    const n = Iu.from(r), s = ns(t, n.decimals);
    !n.signed && s.lt(M8) && R8("unsigned value cannot be negative", "overflow", "value", t);
    let i = null;
    n.signed ? i = s.toTwos(n.width).toHexString() : (i = s.toHexString(), i = eb(i, n.width / 8));
    const a = nh(s, n.decimals);
    return new sn(U0, i, a, n);
  }
  static fromBytes(t, r) {
    r == null && (r = "fixed");
    const n = Iu.from(r);
    if (pS(t).length > n.width / 8)
      throw new Error("overflow");
    let s = Lr.from(t);
    n.signed && (s = s.fromTwos(n.width));
    const i = s.toTwos((n.signed ? 0 : 1) + n.width).toHexString(), a = nh(s, n.decimals);
    return new sn(U0, i, a, n);
  }
  static from(t, r) {
    if (typeof t == "string")
      return sn.fromString(t, r);
    if (bd(t))
      return sn.fromBytes(t, r);
    try {
      return sn.fromValue(t, 0, r);
    } catch (n) {
      if (n.code !== hr.errors.INVALID_ARGUMENT)
        throw n;
    }
    return On.throwArgumentError("invalid FixedNumber value", "value", t);
  }
  static isFixedNumber(t) {
    return !!(t && t._isFixedNumber);
  }
}
const nb = sn.from(1), mS = sn.from("0.5"), yS = "units/5.7.0", C8 = new hr(yS), B8 = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function bS(e) {
  const t = String(e).split(".");
  (t.length > 2 || !t[0].match(/^-?[0-9]*$/) || t[1] && !t[1].match(/^[0-9]*$/) || e === "." || e === "-.") && C8.throwArgumentError("invalid value", "value", e);
  let r = t[0], n = "";
  for (r.substring(0, 1) === "-" && (n = "-", r = r.substring(1)); r.substring(0, 1) === "0"; )
    r = r.substring(1);
  r === "" && (r = "0");
  let s = "";
  for (t.length === 2 && (s = "." + (t[1] || "0")); s.length > 2 && s[s.length - 1] === "0"; )
    s = s.substring(0, s.length - 1);
  const i = [];
  for (; r.length; )
    if (r.length <= 3) {
      i.unshift(r);
      break;
    } else {
      const a = r.length - 3;
      i.unshift(r.substring(a)), r = r.substring(0, a);
    }
  return n + i.join(",") + s;
}
function _8(e, t) {
  if (typeof t == "string") {
    const r = B8.indexOf(t);
    r !== -1 && (t = 3 * r);
  }
  return nh(e, t ?? 18);
}
function F8(e, t) {
  if (typeof e != "string" && C8.throwArgumentError("value must be a string", "value", e), typeof t == "string") {
    const r = B8.indexOf(t);
    r !== -1 && (t = 3 * r);
  }
  return ns(e, t ?? 18);
}
function wS(e) {
  return _8(e, 18);
}
function vS(e) {
  return F8(e, 18);
}
const AS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  commify: bS,
  formatEther: wS,
  formatUnits: _8,
  parseEther: vS,
  parseUnits: F8
}, Symbol.toStringTag, { value: "Module" })), ES = /* @__PURE__ */ U1(AS);
var U8 = { exports: {} };
(function(e) {
  (function(t) {
    /*!
     *  decimal.js v10.4.3
     *  An arbitrary-precision Decimal type for JavaScript.
     *  https://github.com/MikeMcl/decimal.js
     *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
     *  MIT Licence
     */
    var r = 9e15, n = 1e9, s = "0123456789abcdef", i = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", a = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", f = {
      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed at run-time using the `Decimal.config` method.
      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,
      // 1 to MAX_DIGITS
      // The rounding mode used when rounding to `precision`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,
      // 0 to 8
      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP         0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN  6 The IEEE 754 remainder function.
      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
      //
      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
      // division (9) are commonly used for the modulus operation. The other rounding modes can also
      // be used, but they may not give useful results.
      modulo: 1,
      // 0 to 9
      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,
      // 0 to -EXP_LIMIT
      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos: 21,
      // 0 to EXP_LIMIT
      // The minimum exponent value, beneath which underflow to zero occurs.
      // JavaScript numbers: -324  (5e-324)
      minE: -r,
      // -1 to -EXP_LIMIT
      // The maximum exponent value, above which overflow to Infinity occurs.
      // JavaScript numbers: 308  (1.7976931348623157e+308)
      maxE: r,
      // 1 to EXP_LIMIT
      // Whether to use cryptographically-secure random number generation, if available.
      crypto: !1
      // true/false
    }, d, c, p, g, v = !0, O = "[DecimalError] ", N = O + "Invalid argument: ", S = O + "Precision limit exceeded", j = O + "crypto unavailable", B = "[object Decimal]", M = Math.floor, I = Math.pow, A = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, R = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, L = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, K = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, $ = 1e7, k = 7, V = 9007199254740991, C = i.length - 1, D = a.length - 1, o = { toStringTag: B };
    o.absoluteValue = o.abs = function() {
      var T = new this.constructor(this);
      return T.s < 0 && (T.s = 1), m(T);
    }, o.ceil = function() {
      return m(new this.constructor(this), this.e + 1, 2);
    }, o.clampedTo = o.clamp = function(T, F) {
      var H, z = this, Q = z.constructor;
      if (T = new Q(T), F = new Q(F), !T.s || !F.s)
        return new Q(NaN);
      if (T.gt(F))
        throw Error(N + F);
      return H = z.cmp(T), H < 0 ? T : z.cmp(F) > 0 ? F : new Q(z);
    }, o.comparedTo = o.cmp = function(T) {
      var F, H, z, Q, Z = this, ie = Z.d, he = (T = new Z.constructor(T)).d, J = Z.s, Y = T.s;
      if (!ie || !he)
        return !J || !Y ? NaN : J !== Y ? J : ie === he ? 0 : !ie ^ J < 0 ? 1 : -1;
      if (!ie[0] || !he[0])
        return ie[0] ? J : he[0] ? -Y : 0;
      if (J !== Y)
        return J;
      if (Z.e !== T.e)
        return Z.e > T.e ^ J < 0 ? 1 : -1;
      for (z = ie.length, Q = he.length, F = 0, H = z < Q ? z : Q; F < H; ++F)
        if (ie[F] !== he[F])
          return ie[F] > he[F] ^ J < 0 ? 1 : -1;
      return z === Q ? 0 : z > Q ^ J < 0 ? 1 : -1;
    }, o.cosine = o.cos = function() {
      var T, F, H = this, z = H.constructor;
      return H.d ? H.d[0] ? (T = z.precision, F = z.rounding, z.precision = T + Math.max(H.e, H.sd()) + k, z.rounding = 1, H = P(z, ke(z, H)), z.precision = T, z.rounding = F, m(g == 2 || g == 3 ? H.neg() : H, T, F, !0)) : new z(1) : new z(NaN);
    }, o.cubeRoot = o.cbrt = function() {
      var T, F, H, z, Q, Z, ie, he, J, Y, ee = this, se = ee.constructor;
      if (!ee.isFinite() || ee.isZero())
        return new se(ee);
      for (v = !1, Z = ee.s * I(ee.s * ee, 1 / 3), !Z || Math.abs(Z) == 1 / 0 ? (H = u(ee.d), T = ee.e, (Z = (T - H.length + 1) % 3) && (H += Z == 1 || Z == -2 ? "0" : "00"), Z = I(H, 1 / 3), T = M((T + 1) / 3) - (T % 3 == (T < 0 ? -1 : 2)), Z == 1 / 0 ? H = "5e" + T : (H = Z.toExponential(), H = H.slice(0, H.indexOf("e") + 1) + T), z = new se(H), z.s = ee.s) : z = new se(Z.toString()), ie = (T = se.precision) + 3; ; )
        if (he = z, J = he.times(he).times(he), Y = J.plus(ee), z = w(Y.plus(ee).times(he), Y.plus(J), ie + 2, 1), u(he.d).slice(0, ie) === (H = u(z.d)).slice(0, ie))
          if (H = H.slice(ie - 3, ie + 1), H == "9999" || !Q && H == "4999") {
            if (!Q && (m(he, T + 1, 0), he.times(he).times(he).eq(ee))) {
              z = he;
              break;
            }
            ie += 4, Q = 1;
          } else {
            (!+H || !+H.slice(1) && H.charAt(0) == "5") && (m(z, T + 1, 1), F = !z.times(z).times(z).eq(ee));
            break;
          }
      return v = !0, m(z, T, se.rounding, F);
    }, o.decimalPlaces = o.dp = function() {
      var T, F = this.d, H = NaN;
      if (F) {
        if (T = F.length - 1, H = (T - M(this.e / k)) * k, T = F[T], T)
          for (; T % 10 == 0; T /= 10)
            H--;
        H < 0 && (H = 0);
      }
      return H;
    }, o.dividedBy = o.div = function(T) {
      return w(this, new this.constructor(T));
    }, o.dividedToIntegerBy = o.divToInt = function(T) {
      var F = this, H = F.constructor;
      return m(w(F, new H(T), 0, 1, 1), H.precision, H.rounding);
    }, o.equals = o.eq = function(T) {
      return this.cmp(T) === 0;
    }, o.floor = function() {
      return m(new this.constructor(this), this.e + 1, 3);
    }, o.greaterThan = o.gt = function(T) {
      return this.cmp(T) > 0;
    }, o.greaterThanOrEqualTo = o.gte = function(T) {
      var F = this.cmp(T);
      return F == 1 || F === 0;
    }, o.hyperbolicCosine = o.cosh = function() {
      var T, F, H, z, Q, Z = this, ie = Z.constructor, he = new ie(1);
      if (!Z.isFinite())
        return new ie(Z.s ? 1 / 0 : NaN);
      if (Z.isZero())
        return he;
      H = ie.precision, z = ie.rounding, ie.precision = H + Math.max(Z.e, Z.sd()) + 4, ie.rounding = 1, Q = Z.d.length, Q < 32 ? (T = Math.ceil(Q / 3), F = (1 / we(4, T)).toString()) : (T = 16, F = "2.3283064365386962890625e-10"), Z = ue(ie, 1, Z.times(F), new ie(1), !0);
      for (var J, Y = T, ee = new ie(8); Y--; )
        J = Z.times(Z), Z = he.minus(J.times(ee.minus(J.times(ee))));
      return m(Z, ie.precision = H, ie.rounding = z, !0);
    }, o.hyperbolicSine = o.sinh = function() {
      var T, F, H, z, Q = this, Z = Q.constructor;
      if (!Q.isFinite() || Q.isZero())
        return new Z(Q);
      if (F = Z.precision, H = Z.rounding, Z.precision = F + Math.max(Q.e, Q.sd()) + 4, Z.rounding = 1, z = Q.d.length, z < 3)
        Q = ue(Z, 2, Q, Q, !0);
      else {
        T = 1.4 * Math.sqrt(z), T = T > 16 ? 16 : T | 0, Q = Q.times(1 / we(5, T)), Q = ue(Z, 2, Q, Q, !0);
        for (var ie, he = new Z(5), J = new Z(16), Y = new Z(20); T--; )
          ie = Q.times(Q), Q = Q.times(he.plus(ie.times(J.times(ie).plus(Y))));
      }
      return Z.precision = F, Z.rounding = H, m(Q, F, H, !0);
    }, o.hyperbolicTangent = o.tanh = function() {
      var T, F, H = this, z = H.constructor;
      return H.isFinite() ? H.isZero() ? new z(H) : (T = z.precision, F = z.rounding, z.precision = T + 7, z.rounding = 1, w(H.sinh(), H.cosh(), z.precision = T, z.rounding = F)) : new z(H.s);
    }, o.inverseCosine = o.acos = function() {
      var T, F = this, H = F.constructor, z = F.abs().cmp(1), Q = H.precision, Z = H.rounding;
      return z !== -1 ? z === 0 ? F.isNeg() ? X(H, Q, Z) : new H(0) : new H(NaN) : F.isZero() ? X(H, Q + 4, Z).times(0.5) : (H.precision = Q + 6, H.rounding = 1, F = F.asin(), T = X(H, Q + 4, Z).times(0.5), H.precision = Q, H.rounding = Z, T.minus(F));
    }, o.inverseHyperbolicCosine = o.acosh = function() {
      var T, F, H = this, z = H.constructor;
      return H.lte(1) ? new z(H.eq(1) ? 0 : NaN) : H.isFinite() ? (T = z.precision, F = z.rounding, z.precision = T + Math.max(Math.abs(H.e), H.sd()) + 4, z.rounding = 1, v = !1, H = H.times(H).minus(1).sqrt().plus(H), v = !0, z.precision = T, z.rounding = F, H.ln()) : new z(H);
    }, o.inverseHyperbolicSine = o.asinh = function() {
      var T, F, H = this, z = H.constructor;
      return !H.isFinite() || H.isZero() ? new z(H) : (T = z.precision, F = z.rounding, z.precision = T + 2 * Math.max(Math.abs(H.e), H.sd()) + 6, z.rounding = 1, v = !1, H = H.times(H).plus(1).sqrt().plus(H), v = !0, z.precision = T, z.rounding = F, H.ln());
    }, o.inverseHyperbolicTangent = o.atanh = function() {
      var T, F, H, z, Q = this, Z = Q.constructor;
      return Q.isFinite() ? Q.e >= 0 ? new Z(Q.abs().eq(1) ? Q.s / 0 : Q.isZero() ? Q : NaN) : (T = Z.precision, F = Z.rounding, z = Q.sd(), Math.max(z, T) < 2 * -Q.e - 1 ? m(new Z(Q), T, F, !0) : (Z.precision = H = z - Q.e, Q = w(Q.plus(1), new Z(1).minus(Q), H + T, 1), Z.precision = T + 4, Z.rounding = 1, Q = Q.ln(), Z.precision = T, Z.rounding = F, Q.times(0.5))) : new Z(NaN);
    }, o.inverseSine = o.asin = function() {
      var T, F, H, z, Q = this, Z = Q.constructor;
      return Q.isZero() ? new Z(Q) : (F = Q.abs().cmp(1), H = Z.precision, z = Z.rounding, F !== -1 ? F === 0 ? (T = X(Z, H + 4, z).times(0.5), T.s = Q.s, T) : new Z(NaN) : (Z.precision = H + 6, Z.rounding = 1, Q = Q.div(new Z(1).minus(Q.times(Q)).sqrt().plus(1)).atan(), Z.precision = H, Z.rounding = z, Q.times(2)));
    }, o.inverseTangent = o.atan = function() {
      var T, F, H, z, Q, Z, ie, he, J, Y = this, ee = Y.constructor, se = ee.precision, le = ee.rounding;
      if (Y.isFinite()) {
        if (Y.isZero())
          return new ee(Y);
        if (Y.abs().eq(1) && se + 4 <= D)
          return ie = X(ee, se + 4, le).times(0.25), ie.s = Y.s, ie;
      } else {
        if (!Y.s)
          return new ee(NaN);
        if (se + 4 <= D)
          return ie = X(ee, se + 4, le).times(0.5), ie.s = Y.s, ie;
      }
      for (ee.precision = he = se + 10, ee.rounding = 1, H = Math.min(28, he / k + 2 | 0), T = H; T; --T)
        Y = Y.div(Y.times(Y).plus(1).sqrt().plus(1));
      for (v = !1, F = Math.ceil(he / k), z = 1, J = Y.times(Y), ie = new ee(Y), Q = Y; T !== -1; )
        if (Q = Q.times(J), Z = ie.minus(Q.div(z += 2)), Q = Q.times(J), ie = Z.plus(Q.div(z += 2)), ie.d[F] !== void 0)
          for (T = F; ie.d[T] === Z.d[T] && T--; )
            ;
      return H && (ie = ie.times(2 << H - 1)), v = !0, m(ie, ee.precision = se, ee.rounding = le, !0);
    }, o.isFinite = function() {
      return !!this.d;
    }, o.isInteger = o.isInt = function() {
      return !!this.d && M(this.e / k) > this.d.length - 2;
    }, o.isNaN = function() {
      return !this.s;
    }, o.isNegative = o.isNeg = function() {
      return this.s < 0;
    }, o.isPositive = o.isPos = function() {
      return this.s > 0;
    }, o.isZero = function() {
      return !!this.d && this.d[0] === 0;
    }, o.lessThan = o.lt = function(T) {
      return this.cmp(T) < 0;
    }, o.lessThanOrEqualTo = o.lte = function(T) {
      return this.cmp(T) < 1;
    }, o.logarithm = o.log = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y = this, ee = Y.constructor, se = ee.precision, le = ee.rounding, Ae = 5;
      if (T == null)
        T = new ee(10), F = !0;
      else {
        if (T = new ee(T), H = T.d, T.s < 0 || !H || !H[0] || T.eq(1))
          return new ee(NaN);
        F = T.eq(10);
      }
      if (H = Y.d, Y.s < 0 || !H || !H[0] || Y.eq(1))
        return new ee(H && !H[0] ? -1 / 0 : Y.s != 1 ? NaN : H ? 0 : 1 / 0);
      if (F)
        if (H.length > 1)
          Z = !0;
        else {
          for (Q = H[0]; Q % 10 === 0; )
            Q /= 10;
          Z = Q !== 1;
        }
      if (v = !1, he = se + Ae, ie = Pe(Y, he), z = F ? W(ee, he + 10) : Pe(T, he), J = w(ie, z, he, 1), y(J.d, Q = se, le))
        do
          if (he += 10, ie = Pe(Y, he), z = F ? W(ee, he + 10) : Pe(T, he), J = w(ie, z, he, 1), !Z) {
            +u(J.d).slice(Q + 1, Q + 15) + 1 == 1e14 && (J = m(J, se + 1, 0));
            break;
          }
        while (y(J.d, Q += 10, le));
      return v = !0, m(J, se, le);
    }, o.minus = o.sub = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y, ee, se, le, Ae = this, Te = Ae.constructor;
      if (T = new Te(T), !Ae.d || !T.d)
        return !Ae.s || !T.s ? T = new Te(NaN) : Ae.d ? T.s = -T.s : T = new Te(T.d || Ae.s !== T.s ? Ae : NaN), T;
      if (Ae.s != T.s)
        return T.s = -T.s, Ae.plus(T);
      if (Y = Ae.d, le = T.d, he = Te.precision, J = Te.rounding, !Y[0] || !le[0]) {
        if (le[0])
          T.s = -T.s;
        else if (Y[0])
          T = new Te(Ae);
        else
          return new Te(J === 3 ? -0 : 0);
        return v ? m(T, he, J) : T;
      }
      if (H = M(T.e / k), ee = M(Ae.e / k), Y = Y.slice(), Z = ee - H, Z) {
        for (se = Z < 0, se ? (F = Y, Z = -Z, ie = le.length) : (F = le, H = ee, ie = Y.length), z = Math.max(Math.ceil(he / k), ie) + 2, Z > z && (Z = z, F.length = 1), F.reverse(), z = Z; z--; )
          F.push(0);
        F.reverse();
      } else {
        for (z = Y.length, ie = le.length, se = z < ie, se && (ie = z), z = 0; z < ie; z++)
          if (Y[z] != le[z]) {
            se = Y[z] < le[z];
            break;
          }
        Z = 0;
      }
      for (se && (F = Y, Y = le, le = F, T.s = -T.s), ie = Y.length, z = le.length - ie; z > 0; --z)
        Y[ie++] = 0;
      for (z = le.length; z > Z; ) {
        if (Y[--z] < le[z]) {
          for (Q = z; Q && Y[--Q] === 0; )
            Y[Q] = $ - 1;
          --Y[Q], Y[z] += $;
        }
        Y[z] -= le[z];
      }
      for (; Y[--ie] === 0; )
        Y.pop();
      for (; Y[0] === 0; Y.shift())
        --H;
      return Y[0] ? (T.d = Y, T.e = b(Y, H), v ? m(T, he, J) : T) : new Te(J === 3 ? -0 : 0);
    }, o.modulo = o.mod = function(T) {
      var F, H = this, z = H.constructor;
      return T = new z(T), !H.d || !T.s || T.d && !T.d[0] ? new z(NaN) : !T.d || H.d && !H.d[0] ? m(new z(H), z.precision, z.rounding) : (v = !1, z.modulo == 9 ? (F = w(H, T.abs(), 0, 3, 1), F.s *= T.s) : F = w(H, T, 0, z.modulo, 1), F = F.times(T), v = !0, H.minus(F));
    }, o.naturalExponential = o.exp = function() {
      return Ee(this);
    }, o.naturalLogarithm = o.ln = function() {
      return Pe(this);
    }, o.negated = o.neg = function() {
      var T = new this.constructor(this);
      return T.s = -T.s, m(T);
    }, o.plus = o.add = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y, ee, se = this, le = se.constructor;
      if (T = new le(T), !se.d || !T.d)
        return !se.s || !T.s ? T = new le(NaN) : se.d || (T = new le(T.d || se.s === T.s ? se : NaN)), T;
      if (se.s != T.s)
        return T.s = -T.s, se.minus(T);
      if (Y = se.d, ee = T.d, he = le.precision, J = le.rounding, !Y[0] || !ee[0])
        return ee[0] || (T = new le(se)), v ? m(T, he, J) : T;
      if (Z = M(se.e / k), z = M(T.e / k), Y = Y.slice(), Q = Z - z, Q) {
        for (Q < 0 ? (H = Y, Q = -Q, ie = ee.length) : (H = ee, z = Z, ie = Y.length), Z = Math.ceil(he / k), ie = Z > ie ? Z + 1 : ie + 1, Q > ie && (Q = ie, H.length = 1), H.reverse(); Q--; )
          H.push(0);
        H.reverse();
      }
      for (ie = Y.length, Q = ee.length, ie - Q < 0 && (Q = ie, H = ee, ee = Y, Y = H), F = 0; Q; )
        F = (Y[--Q] = Y[Q] + ee[Q] + F) / $ | 0, Y[Q] %= $;
      for (F && (Y.unshift(F), ++z), ie = Y.length; Y[--ie] == 0; )
        Y.pop();
      return T.d = Y, T.e = b(Y, z), v ? m(T, he, J) : T;
    }, o.precision = o.sd = function(T) {
      var F, H = this;
      if (T !== void 0 && T !== !!T && T !== 1 && T !== 0)
        throw Error(N + T);
      return H.d ? (F = G(H.d), T && H.e + 1 > F && (F = H.e + 1)) : F = NaN, F;
    }, o.round = function() {
      var T = this, F = T.constructor;
      return m(new F(T), T.e + 1, F.rounding);
    }, o.sine = o.sin = function() {
      var T, F, H = this, z = H.constructor;
      return H.isFinite() ? H.isZero() ? new z(H) : (T = z.precision, F = z.rounding, z.precision = T + Math.max(H.e, H.sd()) + k, z.rounding = 1, H = U(z, ke(z, H)), z.precision = T, z.rounding = F, m(g > 2 ? H.neg() : H, T, F, !0)) : new z(NaN);
    }, o.squareRoot = o.sqrt = function() {
      var T, F, H, z, Q, Z, ie = this, he = ie.d, J = ie.e, Y = ie.s, ee = ie.constructor;
      if (Y !== 1 || !he || !he[0])
        return new ee(!Y || Y < 0 && (!he || he[0]) ? NaN : he ? ie : 1 / 0);
      for (v = !1, Y = Math.sqrt(+ie), Y == 0 || Y == 1 / 0 ? (F = u(he), (F.length + J) % 2 == 0 && (F += "0"), Y = Math.sqrt(F), J = M((J + 1) / 2) - (J < 0 || J % 2), Y == 1 / 0 ? F = "5e" + J : (F = Y.toExponential(), F = F.slice(0, F.indexOf("e") + 1) + J), z = new ee(F)) : z = new ee(Y.toString()), H = (J = ee.precision) + 3; ; )
        if (Z = z, z = Z.plus(w(ie, Z, H + 2, 1)).times(0.5), u(Z.d).slice(0, H) === (F = u(z.d)).slice(0, H))
          if (F = F.slice(H - 3, H + 1), F == "9999" || !Q && F == "4999") {
            if (!Q && (m(Z, J + 1, 0), Z.times(Z).eq(ie))) {
              z = Z;
              break;
            }
            H += 4, Q = 1;
          } else {
            (!+F || !+F.slice(1) && F.charAt(0) == "5") && (m(z, J + 1, 1), T = !z.times(z).eq(ie));
            break;
          }
      return v = !0, m(z, J, ee.rounding, T);
    }, o.tangent = o.tan = function() {
      var T, F, H = this, z = H.constructor;
      return H.isFinite() ? H.isZero() ? new z(H) : (T = z.precision, F = z.rounding, z.precision = T + 10, z.rounding = 1, H = H.sin(), H.s = 1, H = w(H, new z(1).minus(H.times(H)).sqrt(), T + 10, 0), z.precision = T, z.rounding = F, m(g == 2 || g == 4 ? H.neg() : H, T, F, !0)) : new z(NaN);
    }, o.times = o.mul = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y, ee = this, se = ee.constructor, le = ee.d, Ae = (T = new se(T)).d;
      if (T.s *= ee.s, !le || !le[0] || !Ae || !Ae[0])
        return new se(!T.s || le && !le[0] && !Ae || Ae && !Ae[0] && !le ? NaN : !le || !Ae ? T.s / 0 : T.s * 0);
      for (H = M(ee.e / k) + M(T.e / k), J = le.length, Y = Ae.length, J < Y && (Z = le, le = Ae, Ae = Z, ie = J, J = Y, Y = ie), Z = [], ie = J + Y, z = ie; z--; )
        Z.push(0);
      for (z = Y; --z >= 0; ) {
        for (F = 0, Q = J + z; Q > z; )
          he = Z[Q] + Ae[z] * le[Q - z - 1] + F, Z[Q--] = he % $ | 0, F = he / $ | 0;
        Z[Q] = (Z[Q] + F) % $ | 0;
      }
      for (; !Z[--ie]; )
        Z.pop();
      return F ? ++H : Z.shift(), T.d = Z, T.e = b(Z, H), v ? m(T, se.precision, se.rounding) : T;
    }, o.toBinary = function(T, F) {
      return Re(this, 2, T, F);
    }, o.toDecimalPlaces = o.toDP = function(T, F) {
      var H = this, z = H.constructor;
      return H = new z(H), T === void 0 ? H : (h(T, 0, n), F === void 0 ? F = z.rounding : h(F, 0, 8), m(H, T + H.e + 1, F));
    }, o.toExponential = function(T, F) {
      var H, z = this, Q = z.constructor;
      return T === void 0 ? H = l(z, !0) : (h(T, 0, n), F === void 0 ? F = Q.rounding : h(F, 0, 8), z = m(new Q(z), T + 1, F), H = l(z, !0, T + 1)), z.isNeg() && !z.isZero() ? "-" + H : H;
    }, o.toFixed = function(T, F) {
      var H, z, Q = this, Z = Q.constructor;
      return T === void 0 ? H = l(Q) : (h(T, 0, n), F === void 0 ? F = Z.rounding : h(F, 0, 8), z = m(new Z(Q), T + Q.e + 1, F), H = l(z, !1, T + z.e + 1)), Q.isNeg() && !Q.isZero() ? "-" + H : H;
    }, o.toFraction = function(T) {
      var F, H, z, Q, Z, ie, he, J, Y, ee, se, le, Ae = this, Te = Ae.d, Ie = Ae.constructor;
      if (!Te)
        return new Ie(Ae);
      if (Y = H = new Ie(1), z = J = new Ie(0), F = new Ie(z), Z = F.e = G(Te) - Ae.e - 1, ie = Z % k, F.d[0] = I(10, ie < 0 ? k + ie : ie), T == null)
        T = Z > 0 ? F : Y;
      else {
        if (he = new Ie(T), !he.isInt() || he.lt(Y))
          throw Error(N + he);
        T = he.gt(F) ? Z > 0 ? F : Y : he;
      }
      for (v = !1, he = new Ie(u(Te)), ee = Ie.precision, Ie.precision = Z = Te.length * k * 2; se = w(he, F, 0, 1, 1), Q = H.plus(se.times(z)), Q.cmp(T) != 1; )
        H = z, z = Q, Q = Y, Y = J.plus(se.times(Q)), J = Q, Q = F, F = he.minus(se.times(Q)), he = Q;
      return Q = w(T.minus(H), z, 0, 1, 1), J = J.plus(Q.times(Y)), H = H.plus(Q.times(z)), J.s = Y.s = Ae.s, le = w(Y, z, Z, 1).minus(Ae).abs().cmp(w(J, H, Z, 1).minus(Ae).abs()) < 1 ? [Y, z] : [J, H], Ie.precision = ee, v = !0, le;
    }, o.toHexadecimal = o.toHex = function(T, F) {
      return Re(this, 16, T, F);
    }, o.toNearest = function(T, F) {
      var H = this, z = H.constructor;
      if (H = new z(H), T == null) {
        if (!H.d)
          return H;
        T = new z(1), F = z.rounding;
      } else {
        if (T = new z(T), F === void 0 ? F = z.rounding : h(F, 0, 8), !H.d)
          return T.s ? H : T;
        if (!T.d)
          return T.s && (T.s = H.s), T;
      }
      return T.d[0] ? (v = !1, H = w(H, T, 0, F, 1).times(T), v = !0, m(H)) : (T.s = H.s, H = T), H;
    }, o.toNumber = function() {
      return +this;
    }, o.toOctal = function(T, F) {
      return Re(this, 8, T, F);
    }, o.toPower = o.pow = function(T) {
      var F, H, z, Q, Z, ie, he = this, J = he.constructor, Y = +(T = new J(T));
      if (!he.d || !T.d || !he.d[0] || !T.d[0])
        return new J(I(+he, Y));
      if (he = new J(he), he.eq(1))
        return he;
      if (z = J.precision, Z = J.rounding, T.eq(1))
        return m(he, z, Z);
      if (F = M(T.e / k), F >= T.d.length - 1 && (H = Y < 0 ? -Y : Y) <= V)
        return Q = ce(J, he, H, z), T.s < 0 ? new J(1).div(Q) : m(Q, z, Z);
      if (ie = he.s, ie < 0) {
        if (F < T.d.length - 1)
          return new J(NaN);
        if (T.d[F] & 1 || (ie = 1), he.e == 0 && he.d[0] == 1 && he.d.length == 1)
          return he.s = ie, he;
      }
      return H = I(+he, Y), F = H == 0 || !isFinite(H) ? M(Y * (Math.log("0." + u(he.d)) / Math.LN10 + he.e + 1)) : new J(H + "").e, F > J.maxE + 1 || F < J.minE - 1 ? new J(F > 0 ? ie / 0 : 0) : (v = !1, J.rounding = he.s = 1, H = Math.min(12, (F + "").length), Q = Ee(T.times(Pe(he, z + H)), z), Q.d && (Q = m(Q, z + 5, 1), y(Q.d, z, Z) && (F = z + 10, Q = m(Ee(T.times(Pe(he, F + H)), F), F + 5, 1), +u(Q.d).slice(z + 1, z + 15) + 1 == 1e14 && (Q = m(Q, z + 1, 0)))), Q.s = ie, v = !0, J.rounding = Z, m(Q, z, Z));
    }, o.toPrecision = function(T, F) {
      var H, z = this, Q = z.constructor;
      return T === void 0 ? H = l(z, z.e <= Q.toExpNeg || z.e >= Q.toExpPos) : (h(T, 1, n), F === void 0 ? F = Q.rounding : h(F, 0, 8), z = m(new Q(z), T, F), H = l(z, T <= z.e || z.e <= Q.toExpNeg, T)), z.isNeg() && !z.isZero() ? "-" + H : H;
    }, o.toSignificantDigits = o.toSD = function(T, F) {
      var H = this, z = H.constructor;
      return T === void 0 ? (T = z.precision, F = z.rounding) : (h(T, 1, n), F === void 0 ? F = z.rounding : h(F, 0, 8)), m(new z(H), T, F);
    }, o.toString = function() {
      var T = this, F = T.constructor, H = l(T, T.e <= F.toExpNeg || T.e >= F.toExpPos);
      return T.isNeg() && !T.isZero() ? "-" + H : H;
    }, o.truncated = o.trunc = function() {
      return m(new this.constructor(this), this.e + 1, 1);
    }, o.valueOf = o.toJSON = function() {
      var T = this, F = T.constructor, H = l(T, T.e <= F.toExpNeg || T.e >= F.toExpPos);
      return T.isNeg() ? "-" + H : H;
    };
    function u(T) {
      var F, H, z, Q = T.length - 1, Z = "", ie = T[0];
      if (Q > 0) {
        for (Z += ie, F = 1; F < Q; F++)
          z = T[F] + "", H = k - z.length, H && (Z += re(H)), Z += z;
        ie = T[F], z = ie + "", H = k - z.length, H && (Z += re(H));
      } else if (ie === 0)
        return "0";
      for (; ie % 10 === 0; )
        ie /= 10;
      return Z + ie;
    }
    function h(T, F, H) {
      if (T !== ~~T || T < F || T > H)
        throw Error(N + T);
    }
    function y(T, F, H, z) {
      var Q, Z, ie, he;
      for (Z = T[0]; Z >= 10; Z /= 10)
        --F;
      return --F < 0 ? (F += k, Q = 0) : (Q = Math.ceil((F + 1) / k), F %= k), Z = I(10, k - F), he = T[Q] % Z | 0, z == null ? F < 3 ? (F == 0 ? he = he / 100 | 0 : F == 1 && (he = he / 10 | 0), ie = H < 4 && he == 99999 || H > 3 && he == 49999 || he == 5e4 || he == 0) : ie = (H < 4 && he + 1 == Z || H > 3 && he + 1 == Z / 2) && (T[Q + 1] / Z / 100 | 0) == I(10, F - 2) - 1 || (he == Z / 2 || he == 0) && (T[Q + 1] / Z / 100 | 0) == 0 : F < 4 ? (F == 0 ? he = he / 1e3 | 0 : F == 1 ? he = he / 100 | 0 : F == 2 && (he = he / 10 | 0), ie = (z || H < 4) && he == 9999 || !z && H > 3 && he == 4999) : ie = ((z || H < 4) && he + 1 == Z || !z && H > 3 && he + 1 == Z / 2) && (T[Q + 1] / Z / 1e3 | 0) == I(10, F - 3) - 1, ie;
    }
    function E(T, F, H) {
      for (var z, Q = [0], Z, ie = 0, he = T.length; ie < he; ) {
        for (Z = Q.length; Z--; )
          Q[Z] *= F;
        for (Q[0] += s.indexOf(T.charAt(ie++)), z = 0; z < Q.length; z++)
          Q[z] > H - 1 && (Q[z + 1] === void 0 && (Q[z + 1] = 0), Q[z + 1] += Q[z] / H | 0, Q[z] %= H);
      }
      return Q.reverse();
    }
    function P(T, F) {
      var H, z, Q;
      if (F.isZero())
        return F;
      z = F.d.length, z < 32 ? (H = Math.ceil(z / 3), Q = (1 / we(4, H)).toString()) : (H = 16, Q = "2.3283064365386962890625e-10"), T.precision += H, F = ue(T, 1, F.times(Q), new T(1));
      for (var Z = H; Z--; ) {
        var ie = F.times(F);
        F = ie.times(ie).minus(ie).times(8).plus(1);
      }
      return T.precision -= H, F;
    }
    var w = /* @__PURE__ */ function() {
      function T(z, Q, Z) {
        var ie, he = 0, J = z.length;
        for (z = z.slice(); J--; )
          ie = z[J] * Q + he, z[J] = ie % Z | 0, he = ie / Z | 0;
        return he && z.unshift(he), z;
      }
      function F(z, Q, Z, ie) {
        var he, J;
        if (Z != ie)
          J = Z > ie ? 1 : -1;
        else
          for (he = J = 0; he < Z; he++)
            if (z[he] != Q[he]) {
              J = z[he] > Q[he] ? 1 : -1;
              break;
            }
        return J;
      }
      function H(z, Q, Z, ie) {
        for (var he = 0; Z--; )
          z[Z] -= he, he = z[Z] < Q[Z] ? 1 : 0, z[Z] = he * ie + z[Z] - Q[Z];
        for (; !z[0] && z.length > 1; )
          z.shift();
      }
      return function(z, Q, Z, ie, he, J) {
        var Y, ee, se, le, Ae, Te, Ie, We, Ke, Le, De, Ge, Ct, Mt, Lt, Jt, pr, Hr, gr, $r, wr = z.constructor, Cr = z.s == Q.s ? 1 : -1, er = z.d, ht = Q.d;
        if (!er || !er[0] || !ht || !ht[0])
          return new wr(
            // Return NaN if either NaN, or both Infinity or 0.
            !z.s || !Q.s || (er ? ht && er[0] == ht[0] : !ht) ? NaN : (
              // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
              er && er[0] == 0 || !ht ? Cr * 0 : Cr / 0
            )
          );
        for (J ? (Ae = 1, ee = z.e - Q.e) : (J = $, Ae = k, ee = M(z.e / Ae) - M(Q.e / Ae)), gr = ht.length, pr = er.length, Ke = new wr(Cr), Le = Ke.d = [], se = 0; ht[se] == (er[se] || 0); se++)
          ;
        if (ht[se] > (er[se] || 0) && ee--, Z == null ? (Mt = Z = wr.precision, ie = wr.rounding) : he ? Mt = Z + (z.e - Q.e) + 1 : Mt = Z, Mt < 0)
          Le.push(1), Te = !0;
        else {
          if (Mt = Mt / Ae + 2 | 0, se = 0, gr == 1) {
            for (le = 0, ht = ht[0], Mt++; (se < pr || le) && Mt--; se++)
              Lt = le * J + (er[se] || 0), Le[se] = Lt / ht | 0, le = Lt % ht | 0;
            Te = le || se < pr;
          } else {
            for (le = J / (ht[0] + 1) | 0, le > 1 && (ht = T(ht, le, J), er = T(er, le, J), gr = ht.length, pr = er.length), Jt = gr, De = er.slice(0, gr), Ge = De.length; Ge < gr; )
              De[Ge++] = 0;
            $r = ht.slice(), $r.unshift(0), Hr = ht[0], ht[1] >= J / 2 && ++Hr;
            do
              le = 0, Y = F(ht, De, gr, Ge), Y < 0 ? (Ct = De[0], gr != Ge && (Ct = Ct * J + (De[1] || 0)), le = Ct / Hr | 0, le > 1 ? (le >= J && (le = J - 1), Ie = T(ht, le, J), We = Ie.length, Ge = De.length, Y = F(Ie, De, We, Ge), Y == 1 && (le--, H(Ie, gr < We ? $r : ht, We, J))) : (le == 0 && (Y = le = 1), Ie = ht.slice()), We = Ie.length, We < Ge && Ie.unshift(0), H(De, Ie, Ge, J), Y == -1 && (Ge = De.length, Y = F(ht, De, gr, Ge), Y < 1 && (le++, H(De, gr < Ge ? $r : ht, Ge, J))), Ge = De.length) : Y === 0 && (le++, De = [0]), Le[se++] = le, Y && De[0] ? De[Ge++] = er[Jt] || 0 : (De = [er[Jt]], Ge = 1);
            while ((Jt++ < pr || De[0] !== void 0) && Mt--);
            Te = De[0] !== void 0;
          }
          Le[0] || Le.shift();
        }
        if (Ae == 1)
          Ke.e = ee, c = Te;
        else {
          for (se = 1, le = Le[0]; le >= 10; le /= 10)
            se++;
          Ke.e = se + ee * Ae - 1, m(Ke, he ? Z + Ke.e + 1 : Z, ie, Te);
        }
        return Ke;
      };
    }();
    function m(T, F, H, z) {
      var Q, Z, ie, he, J, Y, ee, se, le, Ae = T.constructor;
      e:
        if (F != null) {
          if (se = T.d, !se)
            return T;
          for (Q = 1, he = se[0]; he >= 10; he /= 10)
            Q++;
          if (Z = F - Q, Z < 0)
            Z += k, ie = F, ee = se[le = 0], J = ee / I(10, Q - ie - 1) % 10 | 0;
          else if (le = Math.ceil((Z + 1) / k), he = se.length, le >= he)
            if (z) {
              for (; he++ <= le; )
                se.push(0);
              ee = J = 0, Q = 1, Z %= k, ie = Z - k + 1;
            } else
              break e;
          else {
            for (ee = he = se[le], Q = 1; he >= 10; he /= 10)
              Q++;
            Z %= k, ie = Z - k + Q, J = ie < 0 ? 0 : ee / I(10, Q - ie - 1) % 10 | 0;
          }
          if (z = z || F < 0 || se[le + 1] !== void 0 || (ie < 0 ? ee : ee % I(10, Q - ie - 1)), Y = H < 4 ? (J || z) && (H == 0 || H == (T.s < 0 ? 3 : 2)) : J > 5 || J == 5 && (H == 4 || z || H == 6 && // Check whether the digit to the left of the rounding digit is odd.
          (Z > 0 ? ie > 0 ? ee / I(10, Q - ie) : 0 : se[le - 1]) % 10 & 1 || H == (T.s < 0 ? 8 : 7)), F < 1 || !se[0])
            return se.length = 0, Y ? (F -= T.e + 1, se[0] = I(10, (k - F % k) % k), T.e = -F || 0) : se[0] = T.e = 0, T;
          if (Z == 0 ? (se.length = le, he = 1, le--) : (se.length = le + 1, he = I(10, k - Z), se[le] = ie > 0 ? (ee / I(10, Q - ie) % I(10, ie) | 0) * he : 0), Y)
            for (; ; )
              if (le == 0) {
                for (Z = 1, ie = se[0]; ie >= 10; ie /= 10)
                  Z++;
                for (ie = se[0] += he, he = 1; ie >= 10; ie /= 10)
                  he++;
                Z != he && (T.e++, se[0] == $ && (se[0] = 1));
                break;
              } else {
                if (se[le] += he, se[le] != $)
                  break;
                se[le--] = 0, he = 1;
              }
          for (Z = se.length; se[--Z] === 0; )
            se.pop();
        }
      return v && (T.e > Ae.maxE ? (T.d = null, T.e = NaN) : T.e < Ae.minE && (T.e = 0, T.d = [0])), T;
    }
    function l(T, F, H) {
      if (!T.isFinite())
        return xe(T);
      var z, Q = T.e, Z = u(T.d), ie = Z.length;
      return F ? (H && (z = H - ie) > 0 ? Z = Z.charAt(0) + "." + Z.slice(1) + re(z) : ie > 1 && (Z = Z.charAt(0) + "." + Z.slice(1)), Z = Z + (T.e < 0 ? "e" : "e+") + T.e) : Q < 0 ? (Z = "0." + re(-Q - 1) + Z, H && (z = H - ie) > 0 && (Z += re(z))) : Q >= ie ? (Z += re(Q + 1 - ie), H && (z = H - Q - 1) > 0 && (Z = Z + "." + re(z))) : ((z = Q + 1) < ie && (Z = Z.slice(0, z) + "." + Z.slice(z)), H && (z = H - ie) > 0 && (Q + 1 === ie && (Z += "."), Z += re(z))), Z;
    }
    function b(T, F) {
      var H = T[0];
      for (F *= k; H >= 10; H /= 10)
        F++;
      return F;
    }
    function W(T, F, H) {
      if (F > C)
        throw v = !0, H && (T.precision = H), Error(S);
      return m(new T(i), F, 1, !0);
    }
    function X(T, F, H) {
      if (F > D)
        throw Error(S);
      return m(new T(a), F, H, !0);
    }
    function G(T) {
      var F = T.length - 1, H = F * k + 1;
      if (F = T[F], F) {
        for (; F % 10 == 0; F /= 10)
          H--;
        for (F = T[0]; F >= 10; F /= 10)
          H++;
      }
      return H;
    }
    function re(T) {
      for (var F = ""; T--; )
        F += "0";
      return F;
    }
    function ce(T, F, H, z) {
      var Q, Z = new T(1), ie = Math.ceil(z / k + 4);
      for (v = !1; ; ) {
        if (H % 2 && (Z = Z.times(F), fe(Z.d, ie) && (Q = !0)), H = M(H / 2), H === 0) {
          H = Z.d.length - 1, Q && Z.d[H] === 0 && ++Z.d[H];
          break;
        }
        F = F.times(F), fe(F.d, ie);
      }
      return v = !0, Z;
    }
    function pe(T) {
      return T.d[T.d.length - 1] & 1;
    }
    function ve(T, F, H) {
      for (var z, Q = new T(F[0]), Z = 0; ++Z < F.length; )
        if (z = new T(F[Z]), z.s)
          Q[H](z) && (Q = z);
        else {
          Q = z;
          break;
        }
      return Q;
    }
    function Ee(T, F) {
      var H, z, Q, Z, ie, he, J, Y = 0, ee = 0, se = 0, le = T.constructor, Ae = le.rounding, Te = le.precision;
      if (!T.d || !T.d[0] || T.e > 17)
        return new le(T.d ? T.d[0] ? T.s < 0 ? 0 : 1 / 0 : 1 : T.s ? T.s < 0 ? 0 : T : NaN);
      for (F == null ? (v = !1, J = Te) : J = F, he = new le(0.03125); T.e > -2; )
        T = T.times(he), se += 5;
      for (z = Math.log(I(2, se)) / Math.LN10 * 2 + 5 | 0, J += z, H = Z = ie = new le(1), le.precision = J; ; ) {
        if (Z = m(Z.times(T), J, 1), H = H.times(++ee), he = ie.plus(w(Z, H, J, 1)), u(he.d).slice(0, J) === u(ie.d).slice(0, J)) {
          for (Q = se; Q--; )
            ie = m(ie.times(ie), J, 1);
          if (F == null)
            if (Y < 3 && y(ie.d, J - z, Ae, Y))
              le.precision = J += 10, H = Z = he = new le(1), ee = 0, Y++;
            else
              return m(ie, le.precision = Te, Ae, v = !0);
          else
            return le.precision = Te, ie;
        }
        ie = he;
      }
    }
    function Pe(T, F) {
      var H, z, Q, Z, ie, he, J, Y, ee, se, le, Ae = 1, Te = 10, Ie = T, We = Ie.d, Ke = Ie.constructor, Le = Ke.rounding, De = Ke.precision;
      if (Ie.s < 0 || !We || !We[0] || !Ie.e && We[0] == 1 && We.length == 1)
        return new Ke(We && !We[0] ? -1 / 0 : Ie.s != 1 ? NaN : We ? 0 : Ie);
      if (F == null ? (v = !1, ee = De) : ee = F, Ke.precision = ee += Te, H = u(We), z = H.charAt(0), Math.abs(Z = Ie.e) < 15e14) {
        for (; z < 7 && z != 1 || z == 1 && H.charAt(1) > 3; )
          Ie = Ie.times(T), H = u(Ie.d), z = H.charAt(0), Ae++;
        Z = Ie.e, z > 1 ? (Ie = new Ke("0." + H), Z++) : Ie = new Ke(z + "." + H.slice(1));
      } else
        return Y = W(Ke, ee + 2, De).times(Z + ""), Ie = Pe(new Ke(z + "." + H.slice(1)), ee - Te).plus(Y), Ke.precision = De, F == null ? m(Ie, De, Le, v = !0) : Ie;
      for (se = Ie, J = ie = Ie = w(Ie.minus(1), Ie.plus(1), ee, 1), le = m(Ie.times(Ie), ee, 1), Q = 3; ; ) {
        if (ie = m(ie.times(le), ee, 1), Y = J.plus(w(ie, new Ke(Q), ee, 1)), u(Y.d).slice(0, ee) === u(J.d).slice(0, ee))
          if (J = J.times(2), Z !== 0 && (J = J.plus(W(Ke, ee + 2, De).times(Z + ""))), J = w(J, new Ke(Ae), ee, 1), F == null)
            if (y(J.d, ee - Te, Le, he))
              Ke.precision = ee += Te, Y = ie = Ie = w(se.minus(1), se.plus(1), ee, 1), le = m(Ie.times(Ie), ee, 1), Q = he = 1;
            else
              return m(J, Ke.precision = De, Le, v = !0);
          else
            return Ke.precision = De, J;
        J = Y, Q += 2;
      }
    }
    function xe(T) {
      return String(T.s * T.s / 0);
    }
    function me(T, F) {
      var H, z, Q;
      for ((H = F.indexOf(".")) > -1 && (F = F.replace(".", "")), (z = F.search(/e/i)) > 0 ? (H < 0 && (H = z), H += +F.slice(z + 1), F = F.substring(0, z)) : H < 0 && (H = F.length), z = 0; F.charCodeAt(z) === 48; z++)
        ;
      for (Q = F.length; F.charCodeAt(Q - 1) === 48; --Q)
        ;
      if (F = F.slice(z, Q), F) {
        if (Q -= z, T.e = H = H - z - 1, T.d = [], z = (H + 1) % k, H < 0 && (z += k), z < Q) {
          for (z && T.d.push(+F.slice(0, z)), Q -= k; z < Q; )
            T.d.push(+F.slice(z, z += k));
          F = F.slice(z), z = k - F.length;
        } else
          z -= Q;
        for (; z--; )
          F += "0";
        T.d.push(+F), v && (T.e > T.constructor.maxE ? (T.d = null, T.e = NaN) : T.e < T.constructor.minE && (T.e = 0, T.d = [0]));
      } else
        T.e = 0, T.d = [0];
      return T;
    }
    function te(T, F) {
      var H, z, Q, Z, ie, he, J, Y, ee;
      if (F.indexOf("_") > -1) {
        if (F = F.replace(/(\d)_(?=\d)/g, "$1"), K.test(F))
          return me(T, F);
      } else if (F === "Infinity" || F === "NaN")
        return +F || (T.s = NaN), T.e = NaN, T.d = null, T;
      if (R.test(F))
        H = 16, F = F.toLowerCase();
      else if (A.test(F))
        H = 2;
      else if (L.test(F))
        H = 8;
      else
        throw Error(N + F);
      for (Z = F.search(/p/i), Z > 0 ? (J = +F.slice(Z + 1), F = F.substring(2, Z)) : F = F.slice(2), Z = F.indexOf("."), ie = Z >= 0, z = T.constructor, ie && (F = F.replace(".", ""), he = F.length, Z = he - Z, Q = ce(z, new z(H), Z, Z * 2)), Y = E(F, H, $), ee = Y.length - 1, Z = ee; Y[Z] === 0; --Z)
        Y.pop();
      return Z < 0 ? new z(T.s * 0) : (T.e = b(Y, ee), T.d = Y, v = !1, ie && (T = w(T, Q, he * 4)), J && (T = T.times(Math.abs(J) < 54 ? I(2, J) : d.pow(2, J))), v = !0, T);
    }
    function U(T, F) {
      var H, z = F.d.length;
      if (z < 3)
        return F.isZero() ? F : ue(T, 2, F, F);
      H = 1.4 * Math.sqrt(z), H = H > 16 ? 16 : H | 0, F = F.times(1 / we(5, H)), F = ue(T, 2, F, F);
      for (var Q, Z = new T(5), ie = new T(16), he = new T(20); H--; )
        Q = F.times(F), F = F.times(Z.plus(Q.times(ie.times(Q).minus(he))));
      return F;
    }
    function ue(T, F, H, z, Q) {
      var Z, ie, he, J, Y = T.precision, ee = Math.ceil(Y / k);
      for (v = !1, J = H.times(H), he = new T(z); ; ) {
        if (ie = w(he.times(J), new T(F++ * F++), Y, 1), he = Q ? z.plus(ie) : z.minus(ie), z = w(ie.times(J), new T(F++ * F++), Y, 1), ie = he.plus(z), ie.d[ee] !== void 0) {
          for (Z = ee; ie.d[Z] === he.d[Z] && Z--; )
            ;
          if (Z == -1)
            break;
        }
        Z = he, he = z, z = ie, ie = Z;
      }
      return v = !0, ie.d.length = ee + 1, ie;
    }
    function we(T, F) {
      for (var H = T; --F; )
        H *= T;
      return H;
    }
    function ke(T, F) {
      var H, z = F.s < 0, Q = X(T, T.precision, 1), Z = Q.times(0.5);
      if (F = F.abs(), F.lte(Z))
        return g = z ? 4 : 1, F;
      if (H = F.divToInt(Q), H.isZero())
        g = z ? 3 : 2;
      else {
        if (F = F.minus(H.times(Q)), F.lte(Z))
          return g = pe(H) ? z ? 2 : 3 : z ? 4 : 1, F;
        g = pe(H) ? z ? 1 : 4 : z ? 3 : 2;
      }
      return F.minus(Q).abs();
    }
    function Re(T, F, H, z) {
      var Q, Z, ie, he, J, Y, ee, se, le, Ae = T.constructor, Te = H !== void 0;
      if (Te ? (h(H, 1, n), z === void 0 ? z = Ae.rounding : h(z, 0, 8)) : (H = Ae.precision, z = Ae.rounding), !T.isFinite())
        ee = xe(T);
      else {
        for (ee = l(T), ie = ee.indexOf("."), Te ? (Q = 2, F == 16 ? H = H * 4 - 3 : F == 8 && (H = H * 3 - 2)) : Q = F, ie >= 0 && (ee = ee.replace(".", ""), le = new Ae(1), le.e = ee.length - ie, le.d = E(l(le), 10, Q), le.e = le.d.length), se = E(ee, 10, Q), Z = J = se.length; se[--J] == 0; )
          se.pop();
        if (!se[0])
          ee = Te ? "0p+0" : "0";
        else {
          if (ie < 0 ? Z-- : (T = new Ae(T), T.d = se, T.e = Z, T = w(T, le, H, z, 0, Q), se = T.d, Z = T.e, Y = c), ie = se[H], he = Q / 2, Y = Y || se[H + 1] !== void 0, Y = z < 4 ? (ie !== void 0 || Y) && (z === 0 || z === (T.s < 0 ? 3 : 2)) : ie > he || ie === he && (z === 4 || Y || z === 6 && se[H - 1] & 1 || z === (T.s < 0 ? 8 : 7)), se.length = H, Y)
            for (; ++se[--H] > Q - 1; )
              se[H] = 0, H || (++Z, se.unshift(1));
          for (J = se.length; !se[J - 1]; --J)
            ;
          for (ie = 0, ee = ""; ie < J; ie++)
            ee += s.charAt(se[ie]);
          if (Te) {
            if (J > 1)
              if (F == 16 || F == 8) {
                for (ie = F == 16 ? 4 : 3, --J; J % ie; J++)
                  ee += "0";
                for (se = E(ee, Q, F), J = se.length; !se[J - 1]; --J)
                  ;
                for (ie = 1, ee = "1."; ie < J; ie++)
                  ee += s.charAt(se[ie]);
              } else
                ee = ee.charAt(0) + "." + ee.slice(1);
            ee = ee + (Z < 0 ? "p" : "p+") + Z;
          } else if (Z < 0) {
            for (; ++Z; )
              ee = "0" + ee;
            ee = "0." + ee;
          } else if (++Z > J)
            for (Z -= J; Z--; )
              ee += "0";
          else
            Z < J && (ee = ee.slice(0, Z) + "." + ee.slice(Z));
        }
        ee = (F == 16 ? "0x" : F == 2 ? "0b" : F == 8 ? "0o" : "") + ee;
      }
      return T.s < 0 ? "-" + ee : ee;
    }
    function fe(T, F) {
      if (T.length > F)
        return T.length = F, !0;
    }
    function x(T) {
      return new this(T).abs();
    }
    function _(T) {
      return new this(T).acos();
    }
    function q(T) {
      return new this(T).acosh();
    }
    function ne(T, F) {
      return new this(T).plus(F);
    }
    function de(T) {
      return new this(T).asin();
    }
    function ye(T) {
      return new this(T).asinh();
    }
    function ge(T) {
      return new this(T).atan();
    }
    function be(T) {
      return new this(T).atanh();
    }
    function Me(T, F) {
      T = new this(T), F = new this(F);
      var H, z = this.precision, Q = this.rounding, Z = z + 4;
      return !T.s || !F.s ? H = new this(NaN) : !T.d && !F.d ? (H = X(this, Z, 1).times(F.s > 0 ? 0.25 : 0.75), H.s = T.s) : !F.d || T.isZero() ? (H = F.s < 0 ? X(this, z, Q) : new this(0), H.s = T.s) : !T.d || F.isZero() ? (H = X(this, Z, 1).times(0.5), H.s = T.s) : F.s < 0 ? (this.precision = Z, this.rounding = 1, H = this.atan(w(T, F, Z, 1)), F = X(this, Z, 1), this.precision = z, this.rounding = Q, H = T.s < 0 ? H.minus(F) : H.plus(F)) : H = this.atan(w(T, F, Z, 1)), H;
    }
    function Ce(T) {
      return new this(T).cbrt();
    }
    function je(T) {
      return m(T = new this(T), T.e + 1, 2);
    }
    function Ue(T, F, H) {
      return new this(T).clamp(F, H);
    }
    function Qe(T) {
      if (!T || typeof T != "object")
        throw Error(O + "Object expected");
      var F, H, z, Q = T.defaults === !0, Z = [
        "precision",
        1,
        n,
        "rounding",
        0,
        8,
        "toExpNeg",
        -r,
        0,
        "toExpPos",
        0,
        r,
        "maxE",
        0,
        r,
        "minE",
        -r,
        0,
        "modulo",
        0,
        9
      ];
      for (F = 0; F < Z.length; F += 3)
        if (H = Z[F], Q && (this[H] = f[H]), (z = T[H]) !== void 0)
          if (M(z) === z && z >= Z[F + 1] && z <= Z[F + 2])
            this[H] = z;
          else
            throw Error(N + H + ": " + z);
      if (H = "crypto", Q && (this[H] = f[H]), (z = T[H]) !== void 0)
        if (z === !0 || z === !1 || z === 0 || z === 1)
          if (z)
            if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
              this[H] = !0;
            else
              throw Error(j);
          else
            this[H] = !1;
        else
          throw Error(N + H + ": " + z);
      return this;
    }
    function Ye(T) {
      return new this(T).cos();
    }
    function et(T) {
      return new this(T).cosh();
    }
    function At(T) {
      var F, H, z;
      function Q(Z) {
        var ie, he, J, Y = this;
        if (!(Y instanceof Q))
          return new Q(Z);
        if (Y.constructor = Q, st(Z)) {
          Y.s = Z.s, v ? !Z.d || Z.e > Q.maxE ? (Y.e = NaN, Y.d = null) : Z.e < Q.minE ? (Y.e = 0, Y.d = [0]) : (Y.e = Z.e, Y.d = Z.d.slice()) : (Y.e = Z.e, Y.d = Z.d ? Z.d.slice() : Z.d);
          return;
        }
        if (J = typeof Z, J === "number") {
          if (Z === 0) {
            Y.s = 1 / Z < 0 ? -1 : 1, Y.e = 0, Y.d = [0];
            return;
          }
          if (Z < 0 ? (Z = -Z, Y.s = -1) : Y.s = 1, Z === ~~Z && Z < 1e7) {
            for (ie = 0, he = Z; he >= 10; he /= 10)
              ie++;
            v ? ie > Q.maxE ? (Y.e = NaN, Y.d = null) : ie < Q.minE ? (Y.e = 0, Y.d = [0]) : (Y.e = ie, Y.d = [Z]) : (Y.e = ie, Y.d = [Z]);
            return;
          } else if (Z * 0 !== 0) {
            Z || (Y.s = NaN), Y.e = NaN, Y.d = null;
            return;
          }
          return me(Y, Z.toString());
        } else if (J !== "string")
          throw Error(N + Z);
        return (he = Z.charCodeAt(0)) === 45 ? (Z = Z.slice(1), Y.s = -1) : (he === 43 && (Z = Z.slice(1)), Y.s = 1), K.test(Z) ? me(Y, Z) : te(Y, Z);
      }
      if (Q.prototype = o, Q.ROUND_UP = 0, Q.ROUND_DOWN = 1, Q.ROUND_CEIL = 2, Q.ROUND_FLOOR = 3, Q.ROUND_HALF_UP = 4, Q.ROUND_HALF_DOWN = 5, Q.ROUND_HALF_EVEN = 6, Q.ROUND_HALF_CEIL = 7, Q.ROUND_HALF_FLOOR = 8, Q.EUCLID = 9, Q.config = Q.set = Qe, Q.clone = At, Q.isDecimal = st, Q.abs = x, Q.acos = _, Q.acosh = q, Q.add = ne, Q.asin = de, Q.asinh = ye, Q.atan = ge, Q.atanh = be, Q.atan2 = Me, Q.cbrt = Ce, Q.ceil = je, Q.clamp = Ue, Q.cos = Ye, Q.cosh = et, Q.div = it, Q.exp = tt, Q.floor = Pt, Q.hypot = dt, Q.ln = zt, Q.log = xt, Q.log10 = $t, Q.log2 = lt, Q.max = Tt, Q.min = at, Q.mod = Ut, Q.mul = Ot, Q.pow = He, Q.random = Vt, Q.round = yt, Q.sign = ut, Q.sin = It, Q.sinh = kt, Q.sqrt = ot, Q.sub = Rt, Q.sum = Nt, Q.tan = rt, Q.tanh = Dt, Q.trunc = St, T === void 0 && (T = {}), T && T.defaults !== !0)
        for (z = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], F = 0; F < z.length; )
          T.hasOwnProperty(H = z[F++]) || (T[H] = this[H]);
      return Q.config(T), Q;
    }
    function it(T, F) {
      return new this(T).div(F);
    }
    function tt(T) {
      return new this(T).exp();
    }
    function Pt(T) {
      return m(T = new this(T), T.e + 1, 3);
    }
    function dt() {
      var T, F, H = new this(0);
      for (v = !1, T = 0; T < arguments.length; )
        if (F = new this(arguments[T++]), F.d)
          H.d && (H = H.plus(F.times(F)));
        else {
          if (F.s)
            return v = !0, new this(1 / 0);
          H = F;
        }
      return v = !0, H.sqrt();
    }
    function st(T) {
      return T instanceof d || T && T.toStringTag === B || !1;
    }
    function zt(T) {
      return new this(T).ln();
    }
    function xt(T, F) {
      return new this(T).log(F);
    }
    function lt(T) {
      return new this(T).log(2);
    }
    function $t(T) {
      return new this(T).log(10);
    }
    function Tt() {
      return ve(this, arguments, "lt");
    }
    function at() {
      return ve(this, arguments, "gt");
    }
    function Ut(T, F) {
      return new this(T).mod(F);
    }
    function Ot(T, F) {
      return new this(T).mul(F);
    }
    function He(T, F) {
      return new this(T).pow(F);
    }
    function Vt(T) {
      var F, H, z, Q, Z = 0, ie = new this(1), he = [];
      if (T === void 0 ? T = this.precision : h(T, 1, n), z = Math.ceil(T / k), this.crypto)
        if (crypto.getRandomValues)
          for (F = crypto.getRandomValues(new Uint32Array(z)); Z < z; )
            Q = F[Z], Q >= 429e7 ? F[Z] = crypto.getRandomValues(new Uint32Array(1))[0] : he[Z++] = Q % 1e7;
        else if (crypto.randomBytes) {
          for (F = crypto.randomBytes(z *= 4); Z < z; )
            Q = F[Z] + (F[Z + 1] << 8) + (F[Z + 2] << 16) + ((F[Z + 3] & 127) << 24), Q >= 214e7 ? crypto.randomBytes(4).copy(F, Z) : (he.push(Q % 1e7), Z += 4);
          Z = z / 4;
        } else
          throw Error(j);
      else
        for (; Z < z; )
          he[Z++] = Math.random() * 1e7 | 0;
      for (z = he[--Z], T %= k, z && T && (Q = I(10, k - T), he[Z] = (z / Q | 0) * Q); he[Z] === 0; Z--)
        he.pop();
      if (Z < 0)
        H = 0, he = [0];
      else {
        for (H = -1; he[0] === 0; H -= k)
          he.shift();
        for (z = 1, Q = he[0]; Q >= 10; Q /= 10)
          z++;
        z < k && (H -= k - z);
      }
      return ie.e = H, ie.d = he, ie;
    }
    function yt(T) {
      return m(T = new this(T), T.e + 1, this.rounding);
    }
    function ut(T) {
      return T = new this(T), T.d ? T.d[0] ? T.s : 0 * T.s : T.s || NaN;
    }
    function It(T) {
      return new this(T).sin();
    }
    function kt(T) {
      return new this(T).sinh();
    }
    function ot(T) {
      return new this(T).sqrt();
    }
    function Rt(T, F) {
      return new this(T).sub(F);
    }
    function Nt() {
      var T = 0, F = arguments, H = new this(F[T]);
      for (v = !1; H.s && ++T < F.length; )
        H = H.plus(F[T]);
      return v = !0, m(H, this.precision, this.rounding);
    }
    function rt(T) {
      return new this(T).tan();
    }
    function Dt(T) {
      return new this(T).tanh();
    }
    function St(T) {
      return m(T = new this(T), T.e + 1, 1);
    }
    d = At(f), d.prototype.constructor = d, d.default = d.Decimal = d, i = new d(i), a = new d(a), e.exports ? (typeof Symbol == "function" && typeof Symbol.iterator == "symbol" && (o[Symbol.for("nodejs.util.inspect.custom")] = o.toString, o[Symbol.toStringTag] = "Decimal"), e.exports = d) : (t || (t = typeof self < "u" && self && self.self == self ? self : window), p = t.Decimal, d.noConflict = function() {
      return t.Decimal = p, d;
    }, t.Decimal = d);
  })(nr);
})(U8);
var PS = U8.exports, pf = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isTestnet = e.getNetworkNameforNetworkId = e.isSupportedNetwork = e.NETWORK_IDS = e.NETWORK_NAMES = e.SUPPORTED_NETWORKS_ARRAY = void 0, e.SUPPORTED_NETWORKS_ARRAY = [1, 10, 137, 8453, 11155111];
  var t;
  (function(a) {
    a.MAINNET = "mainnet", a.GOERLI = "goerli", a.OPTIMISM = "optimism", a.BASE = "base", a.SEPOLIA = "sepolia", a.MATIC = "matic";
  })(t || (e.NETWORK_NAMES = t = {}));
  var r;
  (function(a) {
    a[a.MAINNET = 1] = "MAINNET", a[a.GOERLI = 5] = "GOERLI", a[a.OPTIMISM = 10] = "OPTIMISM", a[a.BASE = 8453] = "BASE", a[a.SEPOLIA = 11155111] = "SEPOLIA", a[a.MATIC = 137] = "MATIC";
  })(r || (e.NETWORK_IDS = r = {}));
  const n = (a) => e.SUPPORTED_NETWORKS_ARRAY.includes(a);
  e.isSupportedNetwork = n;
  function s(a) {
    switch (a) {
      case r.GOERLI:
        return t.GOERLI;
      case r.SEPOLIA:
        return t.SEPOLIA;
      case r.OPTIMISM:
        return t.OPTIMISM;
      case r.BASE:
        return t.BASE;
      case r.MAINNET:
        return t.MAINNET;
      case r.MATIC:
        return t.MATIC;
      default:
        throw new Error("Unsupported Network");
    }
  }
  e.getNetworkNameforNetworkId = s;
  function i(a) {
    return a !== 1 && a !== 10 && a !== 8453 && a !== 137;
  }
  e.isTestnet = i;
})(pf);
Object.defineProperty(fi, "__esModule", { value: !0 });
fi.getCurrenciesOnNetwork = fi.getCurrencyInfo = fi.ethCurrencyNameForNetwork = fi.commifiedRoundedNumberString = fi.numberStringRound = void 0;
const OS = ES, ib = PS, mt = pf, uu = "0x0000000000000000000000000000000000000000", D8 = {
  APE: {
    coinGeckoId: "apecoin",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "APE"
  },
  ASH: {
    coinGeckoId: "ash",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0x64d91f12ece7362f91a6f8e7940cd55f05060b92",
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "ASH"
  },
  DAI: {
    coinGeckoId: "dai",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0x6b175474e89094c44da98b954eedeac495271d0f",
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "DAI"
  },
  ETH: {
    coinGeckoId: "ethereum",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: uu,
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: uu,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: uu,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: uu,
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: uu,
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: uu,
        decimals: 18
      }
    },
    name: "ETH"
  },
  LOOKS: {
    coinGeckoId: "looksrare",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "LOOKS"
  },
  PEPE: {
    coinGeckoId: "pepe",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "PEPE"
  },
  RARE: {
    coinGeckoId: "superrare",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0xba5bde662c17e2adff1075610382b9b691296350",
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "RARE"
  },
  TURBO: {
    coinGeckoId: "turbo",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "TURBO"
  },
  USDC: {
    coinGeckoId: "usd-coin",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        decimals: 6
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 6
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 6
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 6
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
        decimals: 6
      },
      [mt.NETWORK_IDS.BASE]: {
        address: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
        decimals: 6
      }
    },
    name: "USDC"
  },
  USDT: {
    coinGeckoId: "tether",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        decimals: 6
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 6
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 6
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 6
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
        decimals: 6
      },
      [mt.NETWORK_IDS.BASE]: {
        address: void 0,
        decimals: 6
      }
    },
    name: "USDT"
  },
  WETH: {
    coinGeckoId: "weth",
    erc20: {
      [mt.NETWORK_IDS.MAINNET]: {
        address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
        decimals: 18
      },
      [mt.NETWORK_IDS.GOERLI]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.SEPOLIA]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.MATIC]: {
        address: void 0,
        decimals: 18
      },
      [mt.NETWORK_IDS.OPTIMISM]: {
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18
      },
      [mt.NETWORK_IDS.BASE]: {
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18
      }
    },
    name: "WETH"
  }
};
function j8(e, t) {
  return new ib.Decimal(e).toFixed(t, ib.Decimal.ROUND_UP);
}
fi.numberStringRound = j8;
function NS(e, t) {
  return (0, OS.commify)(j8(e, t));
}
fi.commifiedRoundedNumberString = NS;
function xS(e) {
  switch (e) {
    case mt.NETWORK_IDS.MAINNET:
      return "ETH";
    case mt.NETWORK_IDS.GOERLI:
      return "GoETH";
    case mt.NETWORK_IDS.OPTIMISM:
      return "OETH";
    case mt.NETWORK_IDS.BASE:
      return "BETH";
    default:
      return "ETH";
  }
}
fi.ethCurrencyNameForNetwork = xS;
const TS = (e) => {
  const t = D8[e];
  if (!t)
    throw new Error(`Currency ${e} not supported`);
  return t;
};
fi.getCurrencyInfo = TS;
const kS = (e) => {
  const t = e;
  return Object.entries(D8).filter(([, r]) => r.erc20[t].address).map(([r]) => r);
};
fi.getCurrenciesOnNetwork = kS;
var L8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isAudio = e.isHTML = e.isImage = e.is3DModel = e.isVideo = e.encodeSVGDataString = e.SVGDataPrefix = e.mediaIsLandscape = void 0;
  const t = (s) => {
    const i = new Image();
    i.src = s;
    const a = i.width;
    let f = i.height;
    return f = f + f, a > f;
  };
  e.mediaIsLandscape = t;
  const r = /[\r\n%#()<>?[\\\]^`{|}]/g;
  e.SVGDataPrefix = "data:image/svg+xml";
  function n(s) {
    let i = s;
    const a = s.substring(0, e.SVGDataPrefix.length) === e.SVGDataPrefix;
    return a && (i = i.substring(e.SVGDataPrefix.length)), i = i.replace(/>\s{1,}</g, "><"), i = i.replace(/\s{2,}/g, " "), `${a ? e.SVGDataPrefix : ""}${i.replace(r, encodeURIComponent)}`;
  }
  e.encodeSVGDataString = n, e.isVideo = new RegExp(/(mp4|mov|avi|webm|flv|wmv)/, "i"), e.is3DModel = new RegExp(/(obj|fbx|glb|gltf|gltf+json)/, "i"), e.isImage = new RegExp(/(gif|png|jpg|jpeg|svg|bmp|tif|tiff|raw)/, "i"), e.isHTML = new RegExp(/(html)/, "i"), e.isAudio = new RegExp(/(mp3|wav|aac|ogg|m4a|flac)/, "i");
})(L8);
var hs = {}, SS = nr && nr.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(hs, "__esModule", { value: !0 });
hs.poll = hs.isJSON = hs.noop = hs.sleep = void 0;
const MS = (e) => new Promise((t) => setTimeout(t, e));
hs.sleep = MS;
const IS = () => {
};
hs.noop = IS;
function RS(e) {
  try {
    JSON.parse(e);
  } catch {
    return !1;
  }
  return !0;
}
hs.isJSON = RS;
const CS = (e) => {
  let t = 0;
  const r = (n, s) => SS(void 0, void 0, void 0, function* () {
    let i;
    try {
      i = yield e.fetch();
    } catch {
      return s(new Error(e.errorMessage));
    }
    if (t++, e.validate(i))
      return n(i);
    if (e.maxAttempts && t === e.maxAttempts)
      return s(new Error(e.errorMessage));
    setTimeout(r, e.interval, n, s);
  });
  return new Promise(r);
};
hs.poll = CS;
var j1 = {}, H8 = {}, W8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CHAIN_CHANGED = e.PROVIDER_CHANGED = e.ADDRESS_CHANGED = e.MANIFOLD_ETHEREUM_EXISTS = e.MANIFOLD_ETHEREUM_INITIALIZED = e.EthereumProviderErrorName = void 0, function(t) {
    t.EthereumProviderMultipleChains = "EthereumProviderMultipleChains", t.WindowEthereumConnectionError = "WindowEthereumConnectionError";
  }(e.EthereumProviderErrorName || (e.EthereumProviderErrorName = {})), e.MANIFOLD_ETHEREUM_INITIALIZED = "manifold-ethereum-initialized", e.MANIFOLD_ETHEREUM_EXISTS = "manifold-ethereum-exists", e.ADDRESS_CHANGED = "ethereum-address-changed", e.PROVIDER_CHANGED = "frontend-provider-changed", e.CHAIN_CHANGED = "frontend-provider-chain-changed";
})(W8);
var G8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EthereumNetwork = void 0, function(t) {
    t[t.MAINNET = 1] = "MAINNET", t[t.GOERLI = 5] = "GOERLI", t[t.OPTIMISM = 10] = "OPTIMISM", t[t.BSC = 56] = "BSC", t[t.MATIC = 137] = "MATIC", t[t.OPTIMISM_GOERLI = 420] = "OPTIMISM_GOERLI", t[t.BASE = 8453] = "BASE", t[t.ARBITRUM = 42161] = "ARBITRUM", t[t.AVALANCHE_FUJI = 43113] = "AVALANCHE_FUJI", t[t.AVALANCHE = 43114] = "AVALANCHE", t[t.ARBITRUM_GOERLI = 421613] = "ARBITRUM_GOERLI", t[t.MUMBAI = 80001] = "MUMBAI", t[t.BASE_GOERLI = 84531] = "BASE_GOERLI", t[t.SEPOLIA = 11155111] = "SEPOLIA";
  }(e.EthereumNetwork || (e.EthereumNetwork = {}));
})(G8);
var z8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.OAuthGrantType = void 0, function(t) {
    t.TOKEN = "token", t.SIGNATURE = "signature";
  }(e.OAuthGrantType || (e.OAuthGrantType = {}));
})(z8);
(function(e) {
  var t = nr && nr.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var f = Object.getOwnPropertyDescriptor(s, i);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, f);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), r = nr && nr.__exportStar || function(n, s) {
    for (var i in n)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(W8, e), r(G8, e), r(z8, e);
})(H8);
var Kf = nr && nr.__awaiter || function(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(j1, "__esModule", { value: !0 });
const Jf = H8;
function BS(e) {
  let t;
  function r() {
    t = setTimeout(() => {
      t = void 0;
    }, 1e3);
  }
  function n(s) {
    s === "address" ? (t && (clearTimeout(t), r()), e()) : t || (t = setTimeout(() => {
      r(), e();
    }, 1e3));
  }
  window.addEventListener(Jf.ADDRESS_CHANGED, () => Kf(this, void 0, void 0, function* () {
    n("address");
  })), window.addEventListener(Jf.CHAIN_CHANGED, () => Kf(this, void 0, void 0, function* () {
    n("chain");
  })), window.addEventListener(Jf.PROVIDER_CHANGED, () => Kf(this, void 0, void 0, function* () {
    n("provider");
  }));
}
j1.default = BS;
var pi = {}, Gp = { exports: {} };
function V8(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var s = e.length;
      for (t = 0; t < s; t++)
        e[t] && (r = V8(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function sb() {
  for (var e, t, r = 0, n = "", s = arguments.length; r < s; r++)
    (e = arguments[r]) && (t = V8(e)) && (n && (n += " "), n += t);
  return n;
}
Gp.exports = sb, Gp.exports.clsx = sb;
var _S = Gp.exports, q8 = {};
(function(e) {
  Object.defineProperty(e, Symbol.toStringTag, {
    value: "Module"
  });
  const t = "-";
  function r(_) {
    const q = a(_), {
      conflictingClassGroups: ne,
      conflictingClassGroupModifiers: de
    } = _;
    function ye(be) {
      const Me = be.split(t);
      return Me[0] === "" && Me.length !== 1 && Me.shift(), n(Me, q) || i(be);
    }
    function ge(be, Me) {
      const Ce = ne[be] || [];
      return Me && de[be] ? [...Ce, ...de[be]] : Ce;
    }
    return {
      getClassGroupId: ye,
      getConflictingClassGroupIds: ge
    };
  }
  function n(_, q) {
    var ne;
    if (_.length === 0)
      return q.classGroupId;
    const de = _[0], ye = q.nextPart.get(de), ge = ye ? n(_.slice(1), ye) : void 0;
    if (ge)
      return ge;
    if (q.validators.length === 0)
      return;
    const be = _.join(t);
    return (ne = q.validators.find(({
      validator: Me
    }) => Me(be))) == null ? void 0 : ne.classGroupId;
  }
  const s = /^\[(.+)\]$/;
  function i(_) {
    if (s.test(_)) {
      const q = s.exec(_)[1], ne = q == null ? void 0 : q.substring(0, q.indexOf(":"));
      if (ne)
        return "arbitrary.." + ne;
    }
  }
  function a(_) {
    const {
      theme: q,
      prefix: ne
    } = _, de = {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    };
    return p(Object.entries(_.classGroups), ne).forEach(([ye, ge]) => {
      f(ge, de, ye, q);
    }), de;
  }
  function f(_, q, ne, de) {
    _.forEach((ye) => {
      if (typeof ye == "string") {
        const ge = ye === "" ? q : d(q, ye);
        ge.classGroupId = ne;
        return;
      }
      if (typeof ye == "function") {
        if (c(ye)) {
          f(ye(de), q, ne, de);
          return;
        }
        q.validators.push({
          validator: ye,
          classGroupId: ne
        });
        return;
      }
      Object.entries(ye).forEach(([ge, be]) => {
        f(be, d(q, ge), ne, de);
      });
    });
  }
  function d(_, q) {
    let ne = _;
    return q.split(t).forEach((de) => {
      ne.nextPart.has(de) || ne.nextPart.set(de, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      }), ne = ne.nextPart.get(de);
    }), ne;
  }
  function c(_) {
    return _.isThemeGetter;
  }
  function p(_, q) {
    return q ? _.map(([ne, de]) => {
      const ye = de.map((ge) => typeof ge == "string" ? q + ge : typeof ge == "object" ? Object.fromEntries(Object.entries(ge).map(([be, Me]) => [q + be, Me])) : ge);
      return [ne, ye];
    }) : _;
  }
  function g(_) {
    if (_ < 1)
      return {
        get: () => {
        },
        set: () => {
        }
      };
    let q = 0, ne = /* @__PURE__ */ new Map(), de = /* @__PURE__ */ new Map();
    function ye(ge, be) {
      ne.set(ge, be), q++, q > _ && (q = 0, de = ne, ne = /* @__PURE__ */ new Map());
    }
    return {
      get(ge) {
        let be = ne.get(ge);
        if (be !== void 0)
          return be;
        if ((be = de.get(ge)) !== void 0)
          return ye(ge, be), be;
      },
      set(ge, be) {
        ne.has(ge) ? ne.set(ge, be) : ye(ge, be);
      }
    };
  }
  const v = "!";
  function O(_) {
    const q = _.separator, ne = q.length === 1, de = q[0], ye = q.length;
    return function(ge) {
      const be = [];
      let Me = 0, Ce = 0, je;
      for (let At = 0; At < ge.length; At++) {
        let it = ge[At];
        if (Me === 0) {
          if (it === de && (ne || ge.slice(At, At + ye) === q)) {
            be.push(ge.slice(Ce, At)), Ce = At + ye;
            continue;
          }
          if (it === "/") {
            je = At;
            continue;
          }
        }
        it === "[" ? Me++ : it === "]" && Me--;
      }
      const Ue = be.length === 0 ? ge : ge.substring(Ce), Qe = Ue.startsWith(v), Ye = Qe ? Ue.substring(1) : Ue, et = je && je > Ce ? je - Ce : void 0;
      return {
        modifiers: be,
        hasImportantModifier: Qe,
        baseClassName: Ye,
        maybePostfixModifierPosition: et
      };
    };
  }
  function N(_) {
    if (_.length <= 1)
      return _;
    const q = [];
    let ne = [];
    return _.forEach((de) => {
      de[0] === "[" ? (q.push(...ne.sort(), de), ne = []) : ne.push(de);
    }), q.push(...ne.sort()), q;
  }
  function S(_) {
    return {
      cache: g(_.cacheSize),
      splitModifiers: O(_),
      ...r(_)
    };
  }
  const j = /\s+/;
  function B(_, q) {
    const {
      splitModifiers: ne,
      getClassGroupId: de,
      getConflictingClassGroupIds: ye
    } = q, ge = /* @__PURE__ */ new Set();
    return _.trim().split(j).map((be) => {
      const {
        modifiers: Me,
        hasImportantModifier: Ce,
        baseClassName: je,
        maybePostfixModifierPosition: Ue
      } = ne(be);
      let Qe = de(Ue ? je.substring(0, Ue) : je), Ye = !!Ue;
      if (!Qe) {
        if (!Ue)
          return {
            isTailwindClass: !1,
            originalClassName: be
          };
        if (Qe = de(je), !Qe)
          return {
            isTailwindClass: !1,
            originalClassName: be
          };
        Ye = !1;
      }
      const et = N(Me).join(":");
      return {
        isTailwindClass: !0,
        modifierId: Ce ? et + v : et,
        classGroupId: Qe,
        originalClassName: be,
        hasPostfixModifier: Ye
      };
    }).reverse().filter((be) => {
      if (!be.isTailwindClass)
        return !0;
      const {
        modifierId: Me,
        classGroupId: Ce,
        hasPostfixModifier: je
      } = be, Ue = Me + Ce;
      return ge.has(Ue) ? !1 : (ge.add(Ue), ye(Ce, je).forEach((Qe) => ge.add(Me + Qe)), !0);
    }).reverse().map((be) => be.originalClassName).join(" ");
  }
  function M() {
    let _ = 0, q, ne, de = "";
    for (; _ < arguments.length; )
      (q = arguments[_++]) && (ne = I(q)) && (de && (de += " "), de += ne);
    return de;
  }
  function I(_) {
    if (typeof _ == "string")
      return _;
    let q, ne = "";
    for (let de = 0; de < _.length; de++)
      _[de] && (q = I(_[de])) && (ne && (ne += " "), ne += q);
    return ne;
  }
  function A(_, ...q) {
    let ne, de, ye, ge = be;
    function be(Ce) {
      const je = q.reduce((Ue, Qe) => Qe(Ue), _());
      return ne = S(je), de = ne.cache.get, ye = ne.cache.set, ge = Me, Me(Ce);
    }
    function Me(Ce) {
      const je = de(Ce);
      if (je)
        return je;
      const Ue = B(Ce, ne);
      return ye(Ce, Ue), Ue;
    }
    return function() {
      return ge(M.apply(null, arguments));
    };
  }
  function R(_) {
    const q = (ne) => ne[_] || [];
    return q.isThemeGetter = !0, q;
  }
  const L = /^\[(?:([a-z-]+):)?(.+)\]$/i, K = /^\d+\/\d+$/, $ = /* @__PURE__ */ new Set(["px", "full", "screen"]), k = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, V = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, C = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, D = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, o = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
  function u(_) {
    return y(_) || $.has(_) || K.test(_);
  }
  function h(_) {
    return ve(_, "length", Ee);
  }
  function y(_) {
    return !!_ && !Number.isNaN(Number(_));
  }
  function E(_) {
    return ve(_, "number", y);
  }
  function P(_) {
    return !!_ && Number.isInteger(Number(_));
  }
  function w(_) {
    return _.endsWith("%") && y(_.slice(0, -1));
  }
  function m(_) {
    return L.test(_);
  }
  function l(_) {
    return k.test(_);
  }
  const b = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
  function W(_) {
    return ve(_, b, Pe);
  }
  function X(_) {
    return ve(_, "position", Pe);
  }
  const G = /* @__PURE__ */ new Set(["image", "url"]);
  function re(_) {
    return ve(_, G, me);
  }
  function ce(_) {
    return ve(_, "", xe);
  }
  function pe() {
    return !0;
  }
  function ve(_, q, ne) {
    const de = L.exec(_);
    return de ? de[1] ? typeof q == "string" ? de[1] === q : q.has(de[1]) : ne(de[2]) : !1;
  }
  function Ee(_) {
    return V.test(_) && !C.test(_);
  }
  function Pe() {
    return !1;
  }
  function xe(_) {
    return D.test(_);
  }
  function me(_) {
    return o.test(_);
  }
  const te = /* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    isAny: pe,
    isArbitraryImage: re,
    isArbitraryLength: h,
    isArbitraryNumber: E,
    isArbitraryPosition: X,
    isArbitraryShadow: ce,
    isArbitrarySize: W,
    isArbitraryValue: m,
    isInteger: P,
    isLength: u,
    isNumber: y,
    isPercent: w,
    isTshirtSize: l
  }, Symbol.toStringTag, {
    value: "Module"
  });
  function U() {
    const _ = R("colors"), q = R("spacing"), ne = R("blur"), de = R("brightness"), ye = R("borderColor"), ge = R("borderRadius"), be = R("borderSpacing"), Me = R("borderWidth"), Ce = R("contrast"), je = R("grayscale"), Ue = R("hueRotate"), Qe = R("invert"), Ye = R("gap"), et = R("gradientColorStops"), At = R("gradientColorStopPositions"), it = R("inset"), tt = R("margin"), Pt = R("opacity"), dt = R("padding"), st = R("saturate"), zt = R("scale"), xt = R("sepia"), lt = R("skew"), $t = R("space"), Tt = R("translate"), at = () => ["auto", "contain", "none"], Ut = () => ["auto", "hidden", "clip", "visible", "scroll"], Ot = () => ["auto", m, q], He = () => [m, q], Vt = () => ["", u, h], yt = () => ["auto", y, m], ut = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], It = () => ["solid", "dashed", "dotted", "double", "none"], kt = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], ot = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Rt = () => ["", "0", m], Nt = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], rt = () => [y, E], Dt = () => [y, m];
    return {
      cacheSize: 500,
      separator: ":",
      theme: {
        colors: [pe],
        spacing: [u, h],
        blur: ["none", "", l, m],
        brightness: rt(),
        borderColor: [_],
        borderRadius: ["none", "", "full", l, m],
        borderSpacing: He(),
        borderWidth: Vt(),
        contrast: rt(),
        grayscale: Rt(),
        hueRotate: Dt(),
        invert: Rt(),
        gap: He(),
        gradientColorStops: [_],
        gradientColorStopPositions: [w, h],
        inset: Ot(),
        margin: Ot(),
        opacity: rt(),
        padding: He(),
        saturate: rt(),
        scale: rt(),
        sepia: Rt(),
        skew: Dt(),
        space: He(),
        translate: He()
      },
      classGroups: {
        // Layout
        /**
         * Aspect Ratio
         * @see https://tailwindcss.com/docs/aspect-ratio
         */
        aspect: [{
          aspect: ["auto", "square", "video", m]
        }],
        /**
         * Container
         * @see https://tailwindcss.com/docs/container
         */
        container: ["container"],
        /**
         * Columns
         * @see https://tailwindcss.com/docs/columns
         */
        columns: [{
          columns: [l]
        }],
        /**
         * Break After
         * @see https://tailwindcss.com/docs/break-after
         */
        "break-after": [{
          "break-after": Nt()
        }],
        /**
         * Break Before
         * @see https://tailwindcss.com/docs/break-before
         */
        "break-before": [{
          "break-before": Nt()
        }],
        /**
         * Break Inside
         * @see https://tailwindcss.com/docs/break-inside
         */
        "break-inside": [{
          "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
        }],
        /**
         * Box Decoration Break
         * @see https://tailwindcss.com/docs/box-decoration-break
         */
        "box-decoration": [{
          "box-decoration": ["slice", "clone"]
        }],
        /**
         * Box Sizing
         * @see https://tailwindcss.com/docs/box-sizing
         */
        box: [{
          box: ["border", "content"]
        }],
        /**
         * Display
         * @see https://tailwindcss.com/docs/display
         */
        display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
        /**
         * Floats
         * @see https://tailwindcss.com/docs/float
         */
        float: [{
          float: ["right", "left", "none", "start", "end"]
        }],
        /**
         * Clear
         * @see https://tailwindcss.com/docs/clear
         */
        clear: [{
          clear: ["left", "right", "both", "none", "start", "end"]
        }],
        /**
         * Isolation
         * @see https://tailwindcss.com/docs/isolation
         */
        isolation: ["isolate", "isolation-auto"],
        /**
         * Object Fit
         * @see https://tailwindcss.com/docs/object-fit
         */
        "object-fit": [{
          object: ["contain", "cover", "fill", "none", "scale-down"]
        }],
        /**
         * Object Position
         * @see https://tailwindcss.com/docs/object-position
         */
        "object-position": [{
          object: [...ut(), m]
        }],
        /**
         * Overflow
         * @see https://tailwindcss.com/docs/overflow
         */
        overflow: [{
          overflow: Ut()
        }],
        /**
         * Overflow X
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-x": [{
          "overflow-x": Ut()
        }],
        /**
         * Overflow Y
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-y": [{
          "overflow-y": Ut()
        }],
        /**
         * Overscroll Behavior
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        overscroll: [{
          overscroll: at()
        }],
        /**
         * Overscroll Behavior X
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-x": [{
          "overscroll-x": at()
        }],
        /**
         * Overscroll Behavior Y
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-y": [{
          "overscroll-y": at()
        }],
        /**
         * Position
         * @see https://tailwindcss.com/docs/position
         */
        position: ["static", "fixed", "absolute", "relative", "sticky"],
        /**
         * Top / Right / Bottom / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        inset: [{
          inset: [it]
        }],
        /**
         * Right / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-x": [{
          "inset-x": [it]
        }],
        /**
         * Top / Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-y": [{
          "inset-y": [it]
        }],
        /**
         * Start
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        start: [{
          start: [it]
        }],
        /**
         * End
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        end: [{
          end: [it]
        }],
        /**
         * Top
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        top: [{
          top: [it]
        }],
        /**
         * Right
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        right: [{
          right: [it]
        }],
        /**
         * Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        bottom: [{
          bottom: [it]
        }],
        /**
         * Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        left: [{
          left: [it]
        }],
        /**
         * Visibility
         * @see https://tailwindcss.com/docs/visibility
         */
        visibility: ["visible", "invisible", "collapse"],
        /**
         * Z-Index
         * @see https://tailwindcss.com/docs/z-index
         */
        z: [{
          z: ["auto", P, m]
        }],
        // Flexbox and Grid
        /**
         * Flex Basis
         * @see https://tailwindcss.com/docs/flex-basis
         */
        basis: [{
          basis: Ot()
        }],
        /**
         * Flex Direction
         * @see https://tailwindcss.com/docs/flex-direction
         */
        "flex-direction": [{
          flex: ["row", "row-reverse", "col", "col-reverse"]
        }],
        /**
         * Flex Wrap
         * @see https://tailwindcss.com/docs/flex-wrap
         */
        "flex-wrap": [{
          flex: ["wrap", "wrap-reverse", "nowrap"]
        }],
        /**
         * Flex
         * @see https://tailwindcss.com/docs/flex
         */
        flex: [{
          flex: ["1", "auto", "initial", "none", m]
        }],
        /**
         * Flex Grow
         * @see https://tailwindcss.com/docs/flex-grow
         */
        grow: [{
          grow: Rt()
        }],
        /**
         * Flex Shrink
         * @see https://tailwindcss.com/docs/flex-shrink
         */
        shrink: [{
          shrink: Rt()
        }],
        /**
         * Order
         * @see https://tailwindcss.com/docs/order
         */
        order: [{
          order: ["first", "last", "none", P, m]
        }],
        /**
         * Grid Template Columns
         * @see https://tailwindcss.com/docs/grid-template-columns
         */
        "grid-cols": [{
          "grid-cols": [pe]
        }],
        /**
         * Grid Column Start / End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start-end": [{
          col: ["auto", {
            span: ["full", P, m]
          }, m]
        }],
        /**
         * Grid Column Start
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start": [{
          "col-start": yt()
        }],
        /**
         * Grid Column End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-end": [{
          "col-end": yt()
        }],
        /**
         * Grid Template Rows
         * @see https://tailwindcss.com/docs/grid-template-rows
         */
        "grid-rows": [{
          "grid-rows": [pe]
        }],
        /**
         * Grid Row Start / End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start-end": [{
          row: ["auto", {
            span: [P, m]
          }, m]
        }],
        /**
         * Grid Row Start
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start": [{
          "row-start": yt()
        }],
        /**
         * Grid Row End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-end": [{
          "row-end": yt()
        }],
        /**
         * Grid Auto Flow
         * @see https://tailwindcss.com/docs/grid-auto-flow
         */
        "grid-flow": [{
          "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
        }],
        /**
         * Grid Auto Columns
         * @see https://tailwindcss.com/docs/grid-auto-columns
         */
        "auto-cols": [{
          "auto-cols": ["auto", "min", "max", "fr", m]
        }],
        /**
         * Grid Auto Rows
         * @see https://tailwindcss.com/docs/grid-auto-rows
         */
        "auto-rows": [{
          "auto-rows": ["auto", "min", "max", "fr", m]
        }],
        /**
         * Gap
         * @see https://tailwindcss.com/docs/gap
         */
        gap: [{
          gap: [Ye]
        }],
        /**
         * Gap X
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-x": [{
          "gap-x": [Ye]
        }],
        /**
         * Gap Y
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-y": [{
          "gap-y": [Ye]
        }],
        /**
         * Justify Content
         * @see https://tailwindcss.com/docs/justify-content
         */
        "justify-content": [{
          justify: ["normal", ...ot()]
        }],
        /**
         * Justify Items
         * @see https://tailwindcss.com/docs/justify-items
         */
        "justify-items": [{
          "justify-items": ["start", "end", "center", "stretch"]
        }],
        /**
         * Justify Self
         * @see https://tailwindcss.com/docs/justify-self
         */
        "justify-self": [{
          "justify-self": ["auto", "start", "end", "center", "stretch"]
        }],
        /**
         * Align Content
         * @see https://tailwindcss.com/docs/align-content
         */
        "align-content": [{
          content: ["normal", ...ot(), "baseline"]
        }],
        /**
         * Align Items
         * @see https://tailwindcss.com/docs/align-items
         */
        "align-items": [{
          items: ["start", "end", "center", "baseline", "stretch"]
        }],
        /**
         * Align Self
         * @see https://tailwindcss.com/docs/align-self
         */
        "align-self": [{
          self: ["auto", "start", "end", "center", "stretch", "baseline"]
        }],
        /**
         * Place Content
         * @see https://tailwindcss.com/docs/place-content
         */
        "place-content": [{
          "place-content": [...ot(), "baseline"]
        }],
        /**
         * Place Items
         * @see https://tailwindcss.com/docs/place-items
         */
        "place-items": [{
          "place-items": ["start", "end", "center", "baseline", "stretch"]
        }],
        /**
         * Place Self
         * @see https://tailwindcss.com/docs/place-self
         */
        "place-self": [{
          "place-self": ["auto", "start", "end", "center", "stretch"]
        }],
        // Spacing
        /**
         * Padding
         * @see https://tailwindcss.com/docs/padding
         */
        p: [{
          p: [dt]
        }],
        /**
         * Padding X
         * @see https://tailwindcss.com/docs/padding
         */
        px: [{
          px: [dt]
        }],
        /**
         * Padding Y
         * @see https://tailwindcss.com/docs/padding
         */
        py: [{
          py: [dt]
        }],
        /**
         * Padding Start
         * @see https://tailwindcss.com/docs/padding
         */
        ps: [{
          ps: [dt]
        }],
        /**
         * Padding End
         * @see https://tailwindcss.com/docs/padding
         */
        pe: [{
          pe: [dt]
        }],
        /**
         * Padding Top
         * @see https://tailwindcss.com/docs/padding
         */
        pt: [{
          pt: [dt]
        }],
        /**
         * Padding Right
         * @see https://tailwindcss.com/docs/padding
         */
        pr: [{
          pr: [dt]
        }],
        /**
         * Padding Bottom
         * @see https://tailwindcss.com/docs/padding
         */
        pb: [{
          pb: [dt]
        }],
        /**
         * Padding Left
         * @see https://tailwindcss.com/docs/padding
         */
        pl: [{
          pl: [dt]
        }],
        /**
         * Margin
         * @see https://tailwindcss.com/docs/margin
         */
        m: [{
          m: [tt]
        }],
        /**
         * Margin X
         * @see https://tailwindcss.com/docs/margin
         */
        mx: [{
          mx: [tt]
        }],
        /**
         * Margin Y
         * @see https://tailwindcss.com/docs/margin
         */
        my: [{
          my: [tt]
        }],
        /**
         * Margin Start
         * @see https://tailwindcss.com/docs/margin
         */
        ms: [{
          ms: [tt]
        }],
        /**
         * Margin End
         * @see https://tailwindcss.com/docs/margin
         */
        me: [{
          me: [tt]
        }],
        /**
         * Margin Top
         * @see https://tailwindcss.com/docs/margin
         */
        mt: [{
          mt: [tt]
        }],
        /**
         * Margin Right
         * @see https://tailwindcss.com/docs/margin
         */
        mr: [{
          mr: [tt]
        }],
        /**
         * Margin Bottom
         * @see https://tailwindcss.com/docs/margin
         */
        mb: [{
          mb: [tt]
        }],
        /**
         * Margin Left
         * @see https://tailwindcss.com/docs/margin
         */
        ml: [{
          ml: [tt]
        }],
        /**
         * Space Between X
         * @see https://tailwindcss.com/docs/space
         */
        "space-x": [{
          "space-x": [$t]
        }],
        /**
         * Space Between X Reverse
         * @see https://tailwindcss.com/docs/space
         */
        "space-x-reverse": ["space-x-reverse"],
        /**
         * Space Between Y
         * @see https://tailwindcss.com/docs/space
         */
        "space-y": [{
          "space-y": [$t]
        }],
        /**
         * Space Between Y Reverse
         * @see https://tailwindcss.com/docs/space
         */
        "space-y-reverse": ["space-y-reverse"],
        // Sizing
        /**
         * Width
         * @see https://tailwindcss.com/docs/width
         */
        w: [{
          w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", m, q]
        }],
        /**
         * Min-Width
         * @see https://tailwindcss.com/docs/min-width
         */
        "min-w": [{
          "min-w": [m, q, "min", "max", "fit"]
        }],
        /**
         * Max-Width
         * @see https://tailwindcss.com/docs/max-width
         */
        "max-w": [{
          "max-w": [m, q, "none", "full", "min", "max", "fit", "prose", {
            screen: [l]
          }, l]
        }],
        /**
         * Height
         * @see https://tailwindcss.com/docs/height
         */
        h: [{
          h: [m, q, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Min-Height
         * @see https://tailwindcss.com/docs/min-height
         */
        "min-h": [{
          "min-h": [m, q, "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Max-Height
         * @see https://tailwindcss.com/docs/max-height
         */
        "max-h": [{
          "max-h": [m, q, "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Size
         * @see https://tailwindcss.com/docs/size
         */
        size: [{
          size: [m, q, "auto", "min", "max", "fit"]
        }],
        // Typography
        /**
         * Font Size
         * @see https://tailwindcss.com/docs/font-size
         */
        "font-size": [{
          text: ["base", l, h]
        }],
        /**
         * Font Smoothing
         * @see https://tailwindcss.com/docs/font-smoothing
         */
        "font-smoothing": ["antialiased", "subpixel-antialiased"],
        /**
         * Font Style
         * @see https://tailwindcss.com/docs/font-style
         */
        "font-style": ["italic", "not-italic"],
        /**
         * Font Weight
         * @see https://tailwindcss.com/docs/font-weight
         */
        "font-weight": [{
          font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", E]
        }],
        /**
         * Font Family
         * @see https://tailwindcss.com/docs/font-family
         */
        "font-family": [{
          font: [pe]
        }],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-normal": ["normal-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-ordinal": ["ordinal"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-slashed-zero": ["slashed-zero"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-figure": ["lining-nums", "oldstyle-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-spacing": ["proportional-nums", "tabular-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
        /**
         * Letter Spacing
         * @see https://tailwindcss.com/docs/letter-spacing
         */
        tracking: [{
          tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", m]
        }],
        /**
         * Line Clamp
         * @see https://tailwindcss.com/docs/line-clamp
         */
        "line-clamp": [{
          "line-clamp": ["none", y, E]
        }],
        /**
         * Line Height
         * @see https://tailwindcss.com/docs/line-height
         */
        leading: [{
          leading: ["none", "tight", "snug", "normal", "relaxed", "loose", u, m]
        }],
        /**
         * List Style Image
         * @see https://tailwindcss.com/docs/list-style-image
         */
        "list-image": [{
          "list-image": ["none", m]
        }],
        /**
         * List Style Type
         * @see https://tailwindcss.com/docs/list-style-type
         */
        "list-style-type": [{
          list: ["none", "disc", "decimal", m]
        }],
        /**
         * List Style Position
         * @see https://tailwindcss.com/docs/list-style-position
         */
        "list-style-position": [{
          list: ["inside", "outside"]
        }],
        /**
         * Placeholder Color
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/placeholder-color
         */
        "placeholder-color": [{
          placeholder: [_]
        }],
        /**
         * Placeholder Opacity
         * @see https://tailwindcss.com/docs/placeholder-opacity
         */
        "placeholder-opacity": [{
          "placeholder-opacity": [Pt]
        }],
        /**
         * Text Alignment
         * @see https://tailwindcss.com/docs/text-align
         */
        "text-alignment": [{
          text: ["left", "center", "right", "justify", "start", "end"]
        }],
        /**
         * Text Color
         * @see https://tailwindcss.com/docs/text-color
         */
        "text-color": [{
          text: [_]
        }],
        /**
         * Text Opacity
         * @see https://tailwindcss.com/docs/text-opacity
         */
        "text-opacity": [{
          "text-opacity": [Pt]
        }],
        /**
         * Text Decoration
         * @see https://tailwindcss.com/docs/text-decoration
         */
        "text-decoration": ["underline", "overline", "line-through", "no-underline"],
        /**
         * Text Decoration Style
         * @see https://tailwindcss.com/docs/text-decoration-style
         */
        "text-decoration-style": [{
          decoration: [...It(), "wavy"]
        }],
        /**
         * Text Decoration Thickness
         * @see https://tailwindcss.com/docs/text-decoration-thickness
         */
        "text-decoration-thickness": [{
          decoration: ["auto", "from-font", u, h]
        }],
        /**
         * Text Underline Offset
         * @see https://tailwindcss.com/docs/text-underline-offset
         */
        "underline-offset": [{
          "underline-offset": ["auto", u, m]
        }],
        /**
         * Text Decoration Color
         * @see https://tailwindcss.com/docs/text-decoration-color
         */
        "text-decoration-color": [{
          decoration: [_]
        }],
        /**
         * Text Transform
         * @see https://tailwindcss.com/docs/text-transform
         */
        "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
        /**
         * Text Overflow
         * @see https://tailwindcss.com/docs/text-overflow
         */
        "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
        /**
         * Text Wrap
         * @see https://tailwindcss.com/docs/text-wrap
         */
        "text-wrap": [{
          text: ["wrap", "nowrap", "balance", "pretty"]
        }],
        /**
         * Text Indent
         * @see https://tailwindcss.com/docs/text-indent
         */
        indent: [{
          indent: He()
        }],
        /**
         * Vertical Alignment
         * @see https://tailwindcss.com/docs/vertical-align
         */
        "vertical-align": [{
          align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", m]
        }],
        /**
         * Whitespace
         * @see https://tailwindcss.com/docs/whitespace
         */
        whitespace: [{
          whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
        }],
        /**
         * Word Break
         * @see https://tailwindcss.com/docs/word-break
         */
        break: [{
          break: ["normal", "words", "all", "keep"]
        }],
        /**
         * Hyphens
         * @see https://tailwindcss.com/docs/hyphens
         */
        hyphens: [{
          hyphens: ["none", "manual", "auto"]
        }],
        /**
         * Content
         * @see https://tailwindcss.com/docs/content
         */
        content: [{
          content: ["none", m]
        }],
        // Backgrounds
        /**
         * Background Attachment
         * @see https://tailwindcss.com/docs/background-attachment
         */
        "bg-attachment": [{
          bg: ["fixed", "local", "scroll"]
        }],
        /**
         * Background Clip
         * @see https://tailwindcss.com/docs/background-clip
         */
        "bg-clip": [{
          "bg-clip": ["border", "padding", "content", "text"]
        }],
        /**
         * Background Opacity
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/background-opacity
         */
        "bg-opacity": [{
          "bg-opacity": [Pt]
        }],
        /**
         * Background Origin
         * @see https://tailwindcss.com/docs/background-origin
         */
        "bg-origin": [{
          "bg-origin": ["border", "padding", "content"]
        }],
        /**
         * Background Position
         * @see https://tailwindcss.com/docs/background-position
         */
        "bg-position": [{
          bg: [...ut(), X]
        }],
        /**
         * Background Repeat
         * @see https://tailwindcss.com/docs/background-repeat
         */
        "bg-repeat": [{
          bg: ["no-repeat", {
            repeat: ["", "x", "y", "round", "space"]
          }]
        }],
        /**
         * Background Size
         * @see https://tailwindcss.com/docs/background-size
         */
        "bg-size": [{
          bg: ["auto", "cover", "contain", W]
        }],
        /**
         * Background Image
         * @see https://tailwindcss.com/docs/background-image
         */
        "bg-image": [{
          bg: ["none", {
            "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, re]
        }],
        /**
         * Background Color
         * @see https://tailwindcss.com/docs/background-color
         */
        "bg-color": [{
          bg: [_]
        }],
        /**
         * Gradient Color Stops From Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from-pos": [{
          from: [At]
        }],
        /**
         * Gradient Color Stops Via Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via-pos": [{
          via: [At]
        }],
        /**
         * Gradient Color Stops To Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to-pos": [{
          to: [At]
        }],
        /**
         * Gradient Color Stops From
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from": [{
          from: [et]
        }],
        /**
         * Gradient Color Stops Via
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via": [{
          via: [et]
        }],
        /**
         * Gradient Color Stops To
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to": [{
          to: [et]
        }],
        // Borders
        /**
         * Border Radius
         * @see https://tailwindcss.com/docs/border-radius
         */
        rounded: [{
          rounded: [ge]
        }],
        /**
         * Border Radius Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-s": [{
          "rounded-s": [ge]
        }],
        /**
         * Border Radius End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-e": [{
          "rounded-e": [ge]
        }],
        /**
         * Border Radius Top
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-t": [{
          "rounded-t": [ge]
        }],
        /**
         * Border Radius Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-r": [{
          "rounded-r": [ge]
        }],
        /**
         * Border Radius Bottom
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-b": [{
          "rounded-b": [ge]
        }],
        /**
         * Border Radius Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-l": [{
          "rounded-l": [ge]
        }],
        /**
         * Border Radius Start Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ss": [{
          "rounded-ss": [ge]
        }],
        /**
         * Border Radius Start End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-se": [{
          "rounded-se": [ge]
        }],
        /**
         * Border Radius End End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ee": [{
          "rounded-ee": [ge]
        }],
        /**
         * Border Radius End Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-es": [{
          "rounded-es": [ge]
        }],
        /**
         * Border Radius Top Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tl": [{
          "rounded-tl": [ge]
        }],
        /**
         * Border Radius Top Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tr": [{
          "rounded-tr": [ge]
        }],
        /**
         * Border Radius Bottom Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-br": [{
          "rounded-br": [ge]
        }],
        /**
         * Border Radius Bottom Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-bl": [{
          "rounded-bl": [ge]
        }],
        /**
         * Border Width
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w": [{
          border: [Me]
        }],
        /**
         * Border Width X
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-x": [{
          "border-x": [Me]
        }],
        /**
         * Border Width Y
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-y": [{
          "border-y": [Me]
        }],
        /**
         * Border Width Start
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-s": [{
          "border-s": [Me]
        }],
        /**
         * Border Width End
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-e": [{
          "border-e": [Me]
        }],
        /**
         * Border Width Top
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-t": [{
          "border-t": [Me]
        }],
        /**
         * Border Width Right
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-r": [{
          "border-r": [Me]
        }],
        /**
         * Border Width Bottom
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-b": [{
          "border-b": [Me]
        }],
        /**
         * Border Width Left
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-l": [{
          "border-l": [Me]
        }],
        /**
         * Border Opacity
         * @see https://tailwindcss.com/docs/border-opacity
         */
        "border-opacity": [{
          "border-opacity": [Pt]
        }],
        /**
         * Border Style
         * @see https://tailwindcss.com/docs/border-style
         */
        "border-style": [{
          border: [...It(), "hidden"]
        }],
        /**
         * Divide Width X
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-x": [{
          "divide-x": [Me]
        }],
        /**
         * Divide Width X Reverse
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-x-reverse": ["divide-x-reverse"],
        /**
         * Divide Width Y
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-y": [{
          "divide-y": [Me]
        }],
        /**
         * Divide Width Y Reverse
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-y-reverse": ["divide-y-reverse"],
        /**
         * Divide Opacity
         * @see https://tailwindcss.com/docs/divide-opacity
         */
        "divide-opacity": [{
          "divide-opacity": [Pt]
        }],
        /**
         * Divide Style
         * @see https://tailwindcss.com/docs/divide-style
         */
        "divide-style": [{
          divide: It()
        }],
        /**
         * Border Color
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color": [{
          border: [ye]
        }],
        /**
         * Border Color X
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-x": [{
          "border-x": [ye]
        }],
        /**
         * Border Color Y
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-y": [{
          "border-y": [ye]
        }],
        /**
         * Border Color Top
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-t": [{
          "border-t": [ye]
        }],
        /**
         * Border Color Right
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-r": [{
          "border-r": [ye]
        }],
        /**
         * Border Color Bottom
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-b": [{
          "border-b": [ye]
        }],
        /**
         * Border Color Left
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-l": [{
          "border-l": [ye]
        }],
        /**
         * Divide Color
         * @see https://tailwindcss.com/docs/divide-color
         */
        "divide-color": [{
          divide: [ye]
        }],
        /**
         * Outline Style
         * @see https://tailwindcss.com/docs/outline-style
         */
        "outline-style": [{
          outline: ["", ...It()]
        }],
        /**
         * Outline Offset
         * @see https://tailwindcss.com/docs/outline-offset
         */
        "outline-offset": [{
          "outline-offset": [u, m]
        }],
        /**
         * Outline Width
         * @see https://tailwindcss.com/docs/outline-width
         */
        "outline-w": [{
          outline: [u, h]
        }],
        /**
         * Outline Color
         * @see https://tailwindcss.com/docs/outline-color
         */
        "outline-color": [{
          outline: [_]
        }],
        /**
         * Ring Width
         * @see https://tailwindcss.com/docs/ring-width
         */
        "ring-w": [{
          ring: Vt()
        }],
        /**
         * Ring Width Inset
         * @see https://tailwindcss.com/docs/ring-width
         */
        "ring-w-inset": ["ring-inset"],
        /**
         * Ring Color
         * @see https://tailwindcss.com/docs/ring-color
         */
        "ring-color": [{
          ring: [_]
        }],
        /**
         * Ring Opacity
         * @see https://tailwindcss.com/docs/ring-opacity
         */
        "ring-opacity": [{
          "ring-opacity": [Pt]
        }],
        /**
         * Ring Offset Width
         * @see https://tailwindcss.com/docs/ring-offset-width
         */
        "ring-offset-w": [{
          "ring-offset": [u, h]
        }],
        /**
         * Ring Offset Color
         * @see https://tailwindcss.com/docs/ring-offset-color
         */
        "ring-offset-color": [{
          "ring-offset": [_]
        }],
        // Effects
        /**
         * Box Shadow
         * @see https://tailwindcss.com/docs/box-shadow
         */
        shadow: [{
          shadow: ["", "inner", "none", l, ce]
        }],
        /**
         * Box Shadow Color
         * @see https://tailwindcss.com/docs/box-shadow-color
         */
        "shadow-color": [{
          shadow: [pe]
        }],
        /**
         * Opacity
         * @see https://tailwindcss.com/docs/opacity
         */
        opacity: [{
          opacity: [Pt]
        }],
        /**
         * Mix Blend Mode
         * @see https://tailwindcss.com/docs/mix-blend-mode
         */
        "mix-blend": [{
          "mix-blend": [...kt(), "plus-lighter", "plus-darker"]
        }],
        /**
         * Background Blend Mode
         * @see https://tailwindcss.com/docs/background-blend-mode
         */
        "bg-blend": [{
          "bg-blend": kt()
        }],
        // Filters
        /**
         * Filter
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/filter
         */
        filter: [{
          filter: ["", "none"]
        }],
        /**
         * Blur
         * @see https://tailwindcss.com/docs/blur
         */
        blur: [{
          blur: [ne]
        }],
        /**
         * Brightness
         * @see https://tailwindcss.com/docs/brightness
         */
        brightness: [{
          brightness: [de]
        }],
        /**
         * Contrast
         * @see https://tailwindcss.com/docs/contrast
         */
        contrast: [{
          contrast: [Ce]
        }],
        /**
         * Drop Shadow
         * @see https://tailwindcss.com/docs/drop-shadow
         */
        "drop-shadow": [{
          "drop-shadow": ["", "none", l, m]
        }],
        /**
         * Grayscale
         * @see https://tailwindcss.com/docs/grayscale
         */
        grayscale: [{
          grayscale: [je]
        }],
        /**
         * Hue Rotate
         * @see https://tailwindcss.com/docs/hue-rotate
         */
        "hue-rotate": [{
          "hue-rotate": [Ue]
        }],
        /**
         * Invert
         * @see https://tailwindcss.com/docs/invert
         */
        invert: [{
          invert: [Qe]
        }],
        /**
         * Saturate
         * @see https://tailwindcss.com/docs/saturate
         */
        saturate: [{
          saturate: [st]
        }],
        /**
         * Sepia
         * @see https://tailwindcss.com/docs/sepia
         */
        sepia: [{
          sepia: [xt]
        }],
        /**
         * Backdrop Filter
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/backdrop-filter
         */
        "backdrop-filter": [{
          "backdrop-filter": ["", "none"]
        }],
        /**
         * Backdrop Blur
         * @see https://tailwindcss.com/docs/backdrop-blur
         */
        "backdrop-blur": [{
          "backdrop-blur": [ne]
        }],
        /**
         * Backdrop Brightness
         * @see https://tailwindcss.com/docs/backdrop-brightness
         */
        "backdrop-brightness": [{
          "backdrop-brightness": [de]
        }],
        /**
         * Backdrop Contrast
         * @see https://tailwindcss.com/docs/backdrop-contrast
         */
        "backdrop-contrast": [{
          "backdrop-contrast": [Ce]
        }],
        /**
         * Backdrop Grayscale
         * @see https://tailwindcss.com/docs/backdrop-grayscale
         */
        "backdrop-grayscale": [{
          "backdrop-grayscale": [je]
        }],
        /**
         * Backdrop Hue Rotate
         * @see https://tailwindcss.com/docs/backdrop-hue-rotate
         */
        "backdrop-hue-rotate": [{
          "backdrop-hue-rotate": [Ue]
        }],
        /**
         * Backdrop Invert
         * @see https://tailwindcss.com/docs/backdrop-invert
         */
        "backdrop-invert": [{
          "backdrop-invert": [Qe]
        }],
        /**
         * Backdrop Opacity
         * @see https://tailwindcss.com/docs/backdrop-opacity
         */
        "backdrop-opacity": [{
          "backdrop-opacity": [Pt]
        }],
        /**
         * Backdrop Saturate
         * @see https://tailwindcss.com/docs/backdrop-saturate
         */
        "backdrop-saturate": [{
          "backdrop-saturate": [st]
        }],
        /**
         * Backdrop Sepia
         * @see https://tailwindcss.com/docs/backdrop-sepia
         */
        "backdrop-sepia": [{
          "backdrop-sepia": [xt]
        }],
        // Tables
        /**
         * Border Collapse
         * @see https://tailwindcss.com/docs/border-collapse
         */
        "border-collapse": [{
          border: ["collapse", "separate"]
        }],
        /**
         * Border Spacing
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing": [{
          "border-spacing": [be]
        }],
        /**
         * Border Spacing X
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-x": [{
          "border-spacing-x": [be]
        }],
        /**
         * Border Spacing Y
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-y": [{
          "border-spacing-y": [be]
        }],
        /**
         * Table Layout
         * @see https://tailwindcss.com/docs/table-layout
         */
        "table-layout": [{
          table: ["auto", "fixed"]
        }],
        /**
         * Caption Side
         * @see https://tailwindcss.com/docs/caption-side
         */
        caption: [{
          caption: ["top", "bottom"]
        }],
        // Transitions and Animation
        /**
         * Tranisition Property
         * @see https://tailwindcss.com/docs/transition-property
         */
        transition: [{
          transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", m]
        }],
        /**
         * Transition Duration
         * @see https://tailwindcss.com/docs/transition-duration
         */
        duration: [{
          duration: Dt()
        }],
        /**
         * Transition Timing Function
         * @see https://tailwindcss.com/docs/transition-timing-function
         */
        ease: [{
          ease: ["linear", "in", "out", "in-out", m]
        }],
        /**
         * Transition Delay
         * @see https://tailwindcss.com/docs/transition-delay
         */
        delay: [{
          delay: Dt()
        }],
        /**
         * Animation
         * @see https://tailwindcss.com/docs/animation
         */
        animate: [{
          animate: ["none", "spin", "ping", "pulse", "bounce", m]
        }],
        // Transforms
        /**
         * Transform
         * @see https://tailwindcss.com/docs/transform
         */
        transform: [{
          transform: ["", "gpu", "none"]
        }],
        /**
         * Scale
         * @see https://tailwindcss.com/docs/scale
         */
        scale: [{
          scale: [zt]
        }],
        /**
         * Scale X
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-x": [{
          "scale-x": [zt]
        }],
        /**
         * Scale Y
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-y": [{
          "scale-y": [zt]
        }],
        /**
         * Rotate
         * @see https://tailwindcss.com/docs/rotate
         */
        rotate: [{
          rotate: [P, m]
        }],
        /**
         * Translate X
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-x": [{
          "translate-x": [Tt]
        }],
        /**
         * Translate Y
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-y": [{
          "translate-y": [Tt]
        }],
        /**
         * Skew X
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-x": [{
          "skew-x": [lt]
        }],
        /**
         * Skew Y
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-y": [{
          "skew-y": [lt]
        }],
        /**
         * Transform Origin
         * @see https://tailwindcss.com/docs/transform-origin
         */
        "transform-origin": [{
          origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", m]
        }],
        // Interactivity
        /**
         * Accent Color
         * @see https://tailwindcss.com/docs/accent-color
         */
        accent: [{
          accent: ["auto", _]
        }],
        /**
         * Appearance
         * @see https://tailwindcss.com/docs/appearance
         */
        appearance: [{
          appearance: ["none", "auto"]
        }],
        /**
         * Cursor
         * @see https://tailwindcss.com/docs/cursor
         */
        cursor: [{
          cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", m]
        }],
        /**
         * Caret Color
         * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
         */
        "caret-color": [{
          caret: [_]
        }],
        /**
         * Pointer Events
         * @see https://tailwindcss.com/docs/pointer-events
         */
        "pointer-events": [{
          "pointer-events": ["none", "auto"]
        }],
        /**
         * Resize
         * @see https://tailwindcss.com/docs/resize
         */
        resize: [{
          resize: ["none", "y", "x", ""]
        }],
        /**
         * Scroll Behavior
         * @see https://tailwindcss.com/docs/scroll-behavior
         */
        "scroll-behavior": [{
          scroll: ["auto", "smooth"]
        }],
        /**
         * Scroll Margin
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-m": [{
          "scroll-m": He()
        }],
        /**
         * Scroll Margin X
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mx": [{
          "scroll-mx": He()
        }],
        /**
         * Scroll Margin Y
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-my": [{
          "scroll-my": He()
        }],
        /**
         * Scroll Margin Start
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ms": [{
          "scroll-ms": He()
        }],
        /**
         * Scroll Margin End
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-me": [{
          "scroll-me": He()
        }],
        /**
         * Scroll Margin Top
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mt": [{
          "scroll-mt": He()
        }],
        /**
         * Scroll Margin Right
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mr": [{
          "scroll-mr": He()
        }],
        /**
         * Scroll Margin Bottom
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mb": [{
          "scroll-mb": He()
        }],
        /**
         * Scroll Margin Left
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ml": [{
          "scroll-ml": He()
        }],
        /**
         * Scroll Padding
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-p": [{
          "scroll-p": He()
        }],
        /**
         * Scroll Padding X
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-px": [{
          "scroll-px": He()
        }],
        /**
         * Scroll Padding Y
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-py": [{
          "scroll-py": He()
        }],
        /**
         * Scroll Padding Start
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-ps": [{
          "scroll-ps": He()
        }],
        /**
         * Scroll Padding End
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pe": [{
          "scroll-pe": He()
        }],
        /**
         * Scroll Padding Top
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pt": [{
          "scroll-pt": He()
        }],
        /**
         * Scroll Padding Right
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pr": [{
          "scroll-pr": He()
        }],
        /**
         * Scroll Padding Bottom
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pb": [{
          "scroll-pb": He()
        }],
        /**
         * Scroll Padding Left
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pl": [{
          "scroll-pl": He()
        }],
        /**
         * Scroll Snap Align
         * @see https://tailwindcss.com/docs/scroll-snap-align
         */
        "snap-align": [{
          snap: ["start", "end", "center", "align-none"]
        }],
        /**
         * Scroll Snap Stop
         * @see https://tailwindcss.com/docs/scroll-snap-stop
         */
        "snap-stop": [{
          snap: ["normal", "always"]
        }],
        /**
         * Scroll Snap Type
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-type": [{
          snap: ["none", "x", "y", "both"]
        }],
        /**
         * Scroll Snap Type Strictness
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-strictness": [{
          snap: ["mandatory", "proximity"]
        }],
        /**
         * Touch Action
         * @see https://tailwindcss.com/docs/touch-action
         */
        touch: [{
          touch: ["auto", "none", "manipulation"]
        }],
        /**
         * Touch Action X
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-x": [{
          "touch-pan": ["x", "left", "right"]
        }],
        /**
         * Touch Action Y
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-y": [{
          "touch-pan": ["y", "up", "down"]
        }],
        /**
         * Touch Action Pinch Zoom
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-pz": ["touch-pinch-zoom"],
        /**
         * User Select
         * @see https://tailwindcss.com/docs/user-select
         */
        select: [{
          select: ["none", "text", "all", "auto"]
        }],
        /**
         * Will Change
         * @see https://tailwindcss.com/docs/will-change
         */
        "will-change": [{
          "will-change": ["auto", "scroll", "contents", "transform", m]
        }],
        // SVG
        /**
         * Fill
         * @see https://tailwindcss.com/docs/fill
         */
        fill: [{
          fill: [_, "none"]
        }],
        /**
         * Stroke Width
         * @see https://tailwindcss.com/docs/stroke-width
         */
        "stroke-w": [{
          stroke: [u, h, E]
        }],
        /**
         * Stroke
         * @see https://tailwindcss.com/docs/stroke
         */
        stroke: [{
          stroke: [_, "none"]
        }],
        // Accessibility
        /**
         * Screen Readers
         * @see https://tailwindcss.com/docs/screen-readers
         */
        sr: ["sr-only", "not-sr-only"],
        /**
         * Forced Color Adjust
         * @see https://tailwindcss.com/docs/forced-color-adjust
         */
        "forced-color-adjust": [{
          "forced-color-adjust": ["auto", "none"]
        }]
      },
      conflictingClassGroups: {
        overflow: ["overflow-x", "overflow-y"],
        overscroll: ["overscroll-x", "overscroll-y"],
        inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
        "inset-x": ["right", "left"],
        "inset-y": ["top", "bottom"],
        flex: ["basis", "grow", "shrink"],
        gap: ["gap-x", "gap-y"],
        p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
        px: ["pr", "pl"],
        py: ["pt", "pb"],
        m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
        mx: ["mr", "ml"],
        my: ["mt", "mb"],
        size: ["w", "h"],
        "font-size": ["leading"],
        "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
        "fvn-ordinal": ["fvn-normal"],
        "fvn-slashed-zero": ["fvn-normal"],
        "fvn-figure": ["fvn-normal"],
        "fvn-spacing": ["fvn-normal"],
        "fvn-fraction": ["fvn-normal"],
        "line-clamp": ["display", "overflow"],
        rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
        "rounded-s": ["rounded-ss", "rounded-es"],
        "rounded-e": ["rounded-se", "rounded-ee"],
        "rounded-t": ["rounded-tl", "rounded-tr"],
        "rounded-r": ["rounded-tr", "rounded-br"],
        "rounded-b": ["rounded-br", "rounded-bl"],
        "rounded-l": ["rounded-tl", "rounded-bl"],
        "border-spacing": ["border-spacing-x", "border-spacing-y"],
        "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
        "border-w-x": ["border-w-r", "border-w-l"],
        "border-w-y": ["border-w-t", "border-w-b"],
        "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
        "border-color-x": ["border-color-r", "border-color-l"],
        "border-color-y": ["border-color-t", "border-color-b"],
        "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
        "scroll-mx": ["scroll-mr", "scroll-ml"],
        "scroll-my": ["scroll-mt", "scroll-mb"],
        "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
        "scroll-px": ["scroll-pr", "scroll-pl"],
        "scroll-py": ["scroll-pt", "scroll-pb"],
        touch: ["touch-x", "touch-y", "touch-pz"],
        "touch-x": ["touch"],
        "touch-y": ["touch"],
        "touch-pz": ["touch"]
      },
      conflictingClassGroupModifiers: {
        "font-size": ["leading"]
      }
    };
  }
  function ue(_, {
    cacheSize: q,
    prefix: ne,
    separator: de,
    extend: ye = {},
    override: ge = {}
  }) {
    we(_, "cacheSize", q), we(_, "prefix", ne), we(_, "separator", de);
    for (const be in ge)
      ke(_[be], ge[be]);
    for (const be in ye)
      Re(_[be], ye[be]);
    return _;
  }
  function we(_, q, ne) {
    ne !== void 0 && (_[q] = ne);
  }
  function ke(_, q) {
    if (q)
      for (const ne in q)
        we(_, ne, q[ne]);
  }
  function Re(_, q) {
    if (q)
      for (const ne in q) {
        const de = q[ne];
        de !== void 0 && (_[ne] = (_[ne] || []).concat(de));
      }
  }
  function fe(_, ...q) {
    return typeof _ == "function" ? A(U, _, ...q) : A(() => ue(U(), _), ...q);
  }
  const x = /* @__PURE__ */ A(U);
  e.createTailwindMerge = A, e.extendTailwindMerge = fe, e.fromTheme = R, e.getDefaultConfig = U, e.mergeConfigs = ue, e.twJoin = M, e.twMerge = x, e.validators = te;
})(q8);
Object.defineProperty(pi, "__esModule", { value: !0 });
pi.classnames = pi.capitalizeFirstLetter = pi.ultraAbbreviateAddress = pi.abbreviateAddress = pi.abbreviate = void 0;
const FS = _S, US = q8;
function L1(e, t = 4, r = 4) {
  return !e || e.length <= t + r ? e : e.substring(0, t) + "..." + e.substring(e.length - r);
}
pi.abbreviate = L1;
function DS(e) {
  return L1(e, 6, 4);
}
pi.abbreviateAddress = DS;
function jS(e) {
  return L1(e, 2, 4);
}
pi.ultraAbbreviateAddress = jS;
const LS = (e) => e.charAt(0).toUpperCase() + e.slice(1);
pi.capitalizeFirstLetter = LS;
function HS(...e) {
  return (0, US.twMerge)((0, FS.clsx)(e));
}
pi.classnames = HS;
var kr = {};
Object.defineProperty(kr, "__esModule", { value: !0 });
kr.convertPotentialWeb3ProtocolURLToWeb2URL = kr.isYoutubeVideoURL = kr.getManifoldGalleryBaseURL = kr.getEtherscanURLForWallet = kr.getEtherscanURLForContract = kr.getEtherscanURLForAddress = kr.getEtherscanURLForTransactionHash = kr.getEtherscanURLForToken = kr.getEtherscanBaseURL = kr.getOpenSeaTokenURL = kr.getOpenSeaCollectionURL = kr.getOpenSeaBaseURL = void 0;
const bo = pf;
function H1(e) {
  return `${(0, bo.isTestnet)(e) ? "https://testnets.opensea.io" : "https://opensea.io"}/assets/${(0, bo.getNetworkNameforNetworkId)(e)}`;
}
kr.getOpenSeaBaseURL = H1;
function WS(e, t) {
  return `${H1(e)}/${t}`;
}
kr.getOpenSeaCollectionURL = WS;
function GS(e, t, r) {
  return `${H1(e)}/${t}/${r}`;
}
kr.getOpenSeaTokenURL = GS;
function gf(e) {
  switch (e) {
    case bo.NETWORK_IDS.OPTIMISM:
      return "https://optimistic.etherscan.io";
    case bo.NETWORK_IDS.GOERLI:
      return "https://goerli.etherscan.io";
    case bo.NETWORK_IDS.SEPOLIA:
      return "https://sepolia.etherscan.io";
    case bo.NETWORK_IDS.BASE:
      return "https://basescan.org";
    case bo.NETWORK_IDS.MAINNET:
      return "https://etherscan.io";
    default:
      throw new Error("Unsupported Network passed to getEtherscanBaseURL");
  }
}
kr.getEtherscanBaseURL = gf;
function zS(e, t, r) {
  return `${gf(e)}/nft/${t}/${r}`;
}
kr.getEtherscanURLForToken = zS;
function VS(e, t) {
  return `${gf(e)}/tx/${t}`;
}
kr.getEtherscanURLForTransactionHash = VS;
function W1(e, t) {
  return `${gf(e)}/address/${t}`;
}
kr.getEtherscanURLForAddress = W1;
function qS(e, t) {
  return W1(e, t);
}
kr.getEtherscanURLForContract = qS;
function $S(e, t) {
  return W1(e, t);
}
kr.getEtherscanURLForWallet = $S;
function KS(e) {
  return e === 1 ? "https://gallery.manifold.xyz" : `https://gallery.manifold.xyz/${(0, bo.getNetworkNameforNetworkId)(e)}`;
}
kr.getManifoldGalleryBaseURL = KS;
function JS(e) {
  return e.includes("https://www.youtube.com") || e.includes("https://youtu.be") || e.includes("https://youtube.com") || e.includes("https://www.youtube-nocookie.com");
}
kr.isYoutubeVideoURL = JS;
const QS = (e, t) => {
  let r = e;
  if (r.includes("ipfs://ipfs/"))
    r = r.replace("ipfs://ipfs/", "https://ipfs.io/ipfs/");
  else if (r.includes("ipfs://"))
    r = r.replace("ipfs://", "https://ipfs.io/ipfs/");
  else if (r.includes("ar://"))
    r = r.replace("ar://", "https://arweave.net/");
  else if (t && r.includes("api.opensea.io/api/v1/metadata/") && r.includes("{id}")) {
    let n = t.toHexString();
    n = n.replace("0x", ""), r = r.replace("{id}", n);
  }
  return r;
};
kr.convertPotentialWeb3ProtocolURLToWeb2URL = QS;
var nc = {}, $8 = {}, zp = function(e, t) {
  return zp = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var s in n)
      Object.prototype.hasOwnProperty.call(n, s) && (r[s] = n[s]);
  }, zp(e, t);
};
function ZS(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  zp(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var Vp = function() {
  return Vp = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, Vp.apply(this, arguments);
};
function YS(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
      t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (r[n[s]] = e[n[s]]);
  return r;
}
function XS(e, t, r, n) {
  var s = arguments.length, i = s < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, r, n);
  else
    for (var f = e.length - 1; f >= 0; f--)
      (a = e[f]) && (i = (s < 3 ? a(i) : s > 3 ? a(t, r, i) : a(t, r)) || i);
  return s > 3 && i && Object.defineProperty(t, r, i), i;
}
function eM(e, t) {
  return function(r, n) {
    t(r, n, e);
  };
}
function tM(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
}
function rM(e, t, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function f(p) {
      try {
        c(n.next(p));
      } catch (g) {
        a(g);
      }
    }
    function d(p) {
      try {
        c(n.throw(p));
      } catch (g) {
        a(g);
      }
    }
    function c(p) {
      p.done ? i(p.value) : s(p.value).then(f, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function nM(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, s, i, a;
  return a = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function f(c) {
    return function(p) {
      return d([c, p]);
    };
  }
  function d(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, s && (i = c[0] & 2 ? s.return : c[0] ? s.throw || ((i = s.return) && i.call(s), 0) : s.next) && !(i = i.call(s, c[1])).done)
          return i;
        switch (s = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
          case 0:
          case 1:
            i = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, s = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < i[1]) {
              r.label = i[1], i = c;
              break;
            }
            if (i && r.label < i[2]) {
              r.label = i[2], r.ops.push(c);
              break;
            }
            i[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (p) {
        c = [6, p], s = 0;
      } finally {
        n = i = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var G1 = Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var s = Object.getOwnPropertyDescriptor(t, r);
  (!s || ("get" in s ? !t.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, s);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
};
function iM(e, t) {
  for (var r in e)
    r !== "default" && !Object.prototype.hasOwnProperty.call(t, r) && G1(t, e, r);
}
function qp(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function K8(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), s, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(s = n.next()).done; )
      i.push(s.value);
  } catch (f) {
    a = { error: f };
  } finally {
    try {
      s && !s.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
function sM() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(K8(arguments[t]));
  return e;
}
function oM() {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++)
    e += arguments[t].length;
  for (var n = Array(e), s = 0, t = 0; t < r; t++)
    for (var i = arguments[t], a = 0, f = i.length; a < f; a++, s++)
      n[s] = i[a];
  return n;
}
function aM(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, s = t.length, i; n < s; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function rd(e) {
  return this instanceof rd ? (this.v = e, this) : new rd(e);
}
function uM(e, t, r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(e, t || []), s, i = [];
  return s = {}, a("next"), a("throw"), a("return"), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function a(v) {
    n[v] && (s[v] = function(O) {
      return new Promise(function(N, S) {
        i.push([v, O, N, S]) > 1 || f(v, O);
      });
    });
  }
  function f(v, O) {
    try {
      d(n[v](O));
    } catch (N) {
      g(i[0][3], N);
    }
  }
  function d(v) {
    v.value instanceof rd ? Promise.resolve(v.value.v).then(c, p) : g(i[0][2], v);
  }
  function c(v) {
    f("next", v);
  }
  function p(v) {
    f("throw", v);
  }
  function g(v, O) {
    v(O), i.shift(), i.length && f(i[0][0], i[0][1]);
  }
}
function cM(e) {
  var t, r;
  return t = {}, n("next"), n("throw", function(s) {
    throw s;
  }), n("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function n(s, i) {
    t[s] = e[s] ? function(a) {
      return (r = !r) ? { value: rd(e[s](a)), done: s === "return" } : i ? i(a) : a;
    } : i;
  }
}
function lM(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], r;
  return t ? t.call(e) : (e = typeof qp == "function" ? qp(e) : e[Symbol.iterator](), r = {}, n("next"), n("throw"), n("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function n(i) {
    r[i] = e[i] && function(a) {
      return new Promise(function(f, d) {
        a = e[i](a), s(f, d, a.done, a.value);
      });
    };
  }
  function s(i, a, f, d) {
    Promise.resolve(d).then(function(c) {
      i({ value: c, done: f });
    }, a);
  }
}
function dM(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
var hM = Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
};
function fM(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && G1(t, e, r);
  return hM(t, e), t;
}
function pM(e) {
  return e && e.__esModule ? e : { default: e };
}
function gM(e, t, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}
function mM(e, t, r, n, s) {
  if (n === "m")
    throw new TypeError("Private method is not writable");
  if (n === "a" && !s)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !s : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}
function yM(e, t) {
  if (t === null || typeof t != "object" && typeof t != "function")
    throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof e == "function" ? t === e : e.has(t);
}
const bM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return Vp;
  },
  __asyncDelegator: cM,
  __asyncGenerator: uM,
  __asyncValues: lM,
  __await: rd,
  __awaiter: rM,
  __classPrivateFieldGet: gM,
  __classPrivateFieldIn: yM,
  __classPrivateFieldSet: mM,
  __createBinding: G1,
  __decorate: XS,
  __exportStar: iM,
  __extends: ZS,
  __generator: nM,
  __importDefault: pM,
  __importStar: fM,
  __makeTemplateObject: dM,
  __metadata: tM,
  __param: eM,
  __read: K8,
  __rest: YS,
  __spread: sM,
  __spreadArray: aM,
  __spreadArrays: oM,
  __values: qp
}, Symbol.toStringTag, { value: "Module" })), wM = /* @__PURE__ */ U1(bM);
var ob = {}, Ud = {}, ab;
function z1() {
  return ab || (ab = 1, Object.defineProperty(Ud, "__esModule", { value: !0 }), Ud.version = void 0, Ud.version = "6.12.1"), Ud;
}
var ub = {}, bl = {}, cb = {}, ha = {}, Ir = {}, Jr = {}, fa = {}, lb;
function nu() {
  if (lb)
    return fa;
  lb = 1, Object.defineProperty(fa, "__esModule", { value: !0 }), fa.defineProperties = fa.resolveProperties = void 0;
  function e(n, s, i) {
    const a = s.split("|").map((d) => d.trim());
    for (let d = 0; d < a.length; d++)
      switch (s) {
        case "any":
          return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
          if (typeof n === s)
            return;
      }
    const f = new Error(`invalid value for type ${s}`);
    throw f.code = "INVALID_ARGUMENT", f.argument = `value.${i}`, f.value = n, f;
  }
  async function t(n) {
    const s = Object.keys(n);
    return (await Promise.all(s.map((i) => Promise.resolve(n[i])))).reduce((i, a, f) => (i[s[f]] = a, i), {});
  }
  fa.resolveProperties = t;
  function r(n, s, i) {
    for (let a in s) {
      let f = s[a];
      const d = i ? i[a] : null;
      d && e(f, d, a), Object.defineProperty(n, a, { enumerable: !0, value: f, writable: !1 });
    }
  }
  return fa.defineProperties = r, fa;
}
var db;
function As() {
  if (db)
    return Jr;
  db = 1, Object.defineProperty(Jr, "__esModule", { value: !0 }), Jr.assertPrivate = Jr.assertNormalize = Jr.assertArgumentCount = Jr.assertArgument = Jr.assert = Jr.makeError = Jr.isCallException = Jr.isError = void 0;
  const e = z1(), t = nu();
  function r(v) {
    if (v == null)
      return "null";
    if (Array.isArray(v))
      return "[ " + v.map(r).join(", ") + " ]";
    if (v instanceof Uint8Array) {
      const O = "0123456789abcdef";
      let N = "0x";
      for (let S = 0; S < v.length; S++)
        N += O[v[S] >> 4], N += O[v[S] & 15];
      return N;
    }
    if (typeof v == "object" && typeof v.toJSON == "function")
      return r(v.toJSON());
    switch (typeof v) {
      case "boolean":
      case "symbol":
        return v.toString();
      case "bigint":
        return BigInt(v).toString();
      case "number":
        return v.toString();
      case "string":
        return JSON.stringify(v);
      case "object": {
        const O = Object.keys(v);
        return O.sort(), "{ " + O.map((N) => `${r(N)}: ${r(v[N])}`).join(", ") + " }";
      }
    }
    return "[ COULD NOT SERIALIZE ]";
  }
  function n(v, O) {
    return v && v.code === O;
  }
  Jr.isError = n;
  function s(v) {
    return n(v, "CALL_EXCEPTION");
  }
  Jr.isCallException = s;
  function i(v, O, N) {
    let S = v;
    {
      const B = [];
      if (N) {
        if ("message" in N || "code" in N || "name" in N)
          throw new Error(`value will overwrite populated values: ${r(N)}`);
        for (const M in N) {
          if (M === "shortMessage")
            continue;
          const I = N[M];
          B.push(M + "=" + r(I));
        }
      }
      B.push(`code=${O}`), B.push(`version=${e.version}`), B.length && (v += " (" + B.join(", ") + ")");
    }
    let j;
    switch (O) {
      case "INVALID_ARGUMENT":
        j = new TypeError(v);
        break;
      case "NUMERIC_FAULT":
      case "BUFFER_OVERRUN":
        j = new RangeError(v);
        break;
      default:
        j = new Error(v);
    }
    return (0, t.defineProperties)(j, { code: O }), N && Object.assign(j, N), j.shortMessage == null && (0, t.defineProperties)(j, { shortMessage: S }), j;
  }
  Jr.makeError = i;
  function a(v, O, N, S) {
    if (!v)
      throw i(O, N, S);
  }
  Jr.assert = a;
  function f(v, O, N, S) {
    a(v, O, "INVALID_ARGUMENT", { argument: N, value: S });
  }
  Jr.assertArgument = f;
  function d(v, O, N) {
    N == null && (N = ""), N && (N = ": " + N), a(v >= O, "missing arguemnt" + N, "MISSING_ARGUMENT", {
      count: v,
      expectedCount: O
    }), a(v <= O, "too many arguments" + N, "UNEXPECTED_ARGUMENT", {
      count: v,
      expectedCount: O
    });
  }
  Jr.assertArgumentCount = d;
  const c = ["NFD", "NFC", "NFKD", "NFKC"].reduce((v, O) => {
    try {
      if ("test".normalize(O) !== "test")
        throw new Error("bad");
      if (O === "NFD" && "é".normalize("NFD") !== "é")
        throw new Error("broken");
      v.push(O);
    } catch {
    }
    return v;
  }, []);
  function p(v) {
    a(c.indexOf(v) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
      operation: "String.prototype.normalize",
      info: { form: v }
    });
  }
  Jr.assertNormalize = p;
  function g(v, O, N) {
    if (N == null && (N = ""), v !== O) {
      let S = N, j = "new";
      N && (S += ".", j += " " + N), a(!1, `private constructor; use ${S}from* methods`, "UNSUPPORTED_OPERATION", {
        operation: j
      });
    }
  }
  return Jr.assertPrivate = g, Jr;
}
var hb;
function qi() {
  if (hb)
    return Ir;
  hb = 1, Object.defineProperty(Ir, "__esModule", { value: !0 }), Ir.zeroPadBytes = Ir.zeroPadValue = Ir.stripZerosLeft = Ir.dataSlice = Ir.dataLength = Ir.concat = Ir.hexlify = Ir.isBytesLike = Ir.isHexString = Ir.getBytesCopy = Ir.getBytes = void 0;
  const e = As();
  function t(S, j, B) {
    if (S instanceof Uint8Array)
      return B ? new Uint8Array(S) : S;
    if (typeof S == "string" && S.match(/^0x([0-9a-f][0-9a-f])*$/i)) {
      const M = new Uint8Array((S.length - 2) / 2);
      let I = 2;
      for (let A = 0; A < M.length; A++)
        M[A] = parseInt(S.substring(I, I + 2), 16), I += 2;
      return M;
    }
    (0, e.assertArgument)(!1, "invalid BytesLike value", j || "value", S);
  }
  function r(S, j) {
    return t(S, j, !1);
  }
  Ir.getBytes = r;
  function n(S, j) {
    return t(S, j, !0);
  }
  Ir.getBytesCopy = n;
  function s(S, j) {
    return !(typeof S != "string" || !S.match(/^0x[0-9A-Fa-f]*$/) || typeof j == "number" && S.length !== 2 + 2 * j || j === !0 && S.length % 2 !== 0);
  }
  Ir.isHexString = s;
  function i(S) {
    return s(S, !0) || S instanceof Uint8Array;
  }
  Ir.isBytesLike = i;
  const a = "0123456789abcdef";
  function f(S) {
    const j = r(S);
    let B = "0x";
    for (let M = 0; M < j.length; M++) {
      const I = j[M];
      B += a[(I & 240) >> 4] + a[I & 15];
    }
    return B;
  }
  Ir.hexlify = f;
  function d(S) {
    return "0x" + S.map((j) => f(j).substring(2)).join("");
  }
  Ir.concat = d;
  function c(S) {
    return s(S, !0) ? (S.length - 2) / 2 : r(S).length;
  }
  Ir.dataLength = c;
  function p(S, j, B) {
    const M = r(S);
    return B != null && B > M.length && (0, e.assert)(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
      buffer: M,
      length: M.length,
      offset: B
    }), f(M.slice(j ?? 0, B ?? M.length));
  }
  Ir.dataSlice = p;
  function g(S) {
    let j = f(S).substring(2);
    for (; j.startsWith("00"); )
      j = j.substring(2);
    return "0x" + j;
  }
  Ir.stripZerosLeft = g;
  function v(S, j, B) {
    const M = r(S);
    (0, e.assert)(j >= M.length, "padding exceeds data length", "BUFFER_OVERRUN", {
      buffer: new Uint8Array(M),
      length: j,
      offset: j + 1
    });
    const I = new Uint8Array(j);
    return I.fill(0), B ? I.set(M, j - M.length) : I.set(M, 0), f(I);
  }
  function O(S, j) {
    return v(S, j, !0);
  }
  Ir.zeroPadValue = O;
  function N(S, j) {
    return v(S, j, !1);
  }
  return Ir.zeroPadBytes = N, Ir;
}
var Rr = {}, fb;
function wd() {
  if (fb)
    return Rr;
  fb = 1, Object.defineProperty(Rr, "__esModule", { value: !0 }), Rr.toQuantity = Rr.toBeArray = Rr.toBeHex = Rr.toNumber = Rr.getNumber = Rr.toBigInt = Rr.getUint = Rr.getBigInt = Rr.mask = Rr.toTwos = Rr.fromTwos = void 0;
  const e = qi(), t = As(), r = BigInt(0), n = BigInt(1), s = 9007199254740991;
  function i(B, M) {
    const I = c(B, "value"), A = BigInt(v(M, "width"));
    if ((0, t.assert)(I >> A === r, "overflow", "NUMERIC_FAULT", {
      operation: "fromTwos",
      fault: "overflow",
      value: B
    }), I >> A - n) {
      const R = (n << A) - n;
      return -((~I & R) + n);
    }
    return I;
  }
  Rr.fromTwos = i;
  function a(B, M) {
    let I = d(B, "value");
    const A = BigInt(v(M, "width")), R = n << A - n;
    if (I < r) {
      I = -I, (0, t.assert)(I <= R, "too low", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: B
      });
      const L = (n << A) - n;
      return (~I & L) + n;
    } else
      (0, t.assert)(I < R, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: B
      });
    return I;
  }
  Rr.toTwos = a;
  function f(B, M) {
    const I = c(B, "value"), A = BigInt(v(M, "bits"));
    return I & (n << A) - n;
  }
  Rr.mask = f;
  function d(B, M) {
    switch (typeof B) {
      case "bigint":
        return B;
      case "number":
        return (0, t.assertArgument)(Number.isInteger(B), "underflow", M || "value", B), (0, t.assertArgument)(B >= -s && B <= s, "overflow", M || "value", B), BigInt(B);
      case "string":
        try {
          if (B === "")
            throw new Error("empty string");
          return B[0] === "-" && B[1] !== "-" ? -BigInt(B.substring(1)) : BigInt(B);
        } catch (I) {
          (0, t.assertArgument)(!1, `invalid BigNumberish string: ${I.message}`, M || "value", B);
        }
    }
    (0, t.assertArgument)(!1, "invalid BigNumberish value", M || "value", B);
  }
  Rr.getBigInt = d;
  function c(B, M) {
    const I = d(B, M);
    return (0, t.assert)(I >= r, "unsigned value cannot be negative", "NUMERIC_FAULT", {
      fault: "overflow",
      operation: "getUint",
      value: B
    }), I;
  }
  Rr.getUint = c;
  const p = "0123456789abcdef";
  function g(B) {
    if (B instanceof Uint8Array) {
      let M = "0x0";
      for (const I of B)
        M += p[I >> 4], M += p[I & 15];
      return BigInt(M);
    }
    return d(B);
  }
  Rr.toBigInt = g;
  function v(B, M) {
    switch (typeof B) {
      case "bigint":
        return (0, t.assertArgument)(B >= -s && B <= s, "overflow", M || "value", B), Number(B);
      case "number":
        return (0, t.assertArgument)(Number.isInteger(B), "underflow", M || "value", B), (0, t.assertArgument)(B >= -s && B <= s, "overflow", M || "value", B), B;
      case "string":
        try {
          if (B === "")
            throw new Error("empty string");
          return v(BigInt(B), M);
        } catch (I) {
          (0, t.assertArgument)(!1, `invalid numeric string: ${I.message}`, M || "value", B);
        }
    }
    (0, t.assertArgument)(!1, "invalid numeric value", M || "value", B);
  }
  Rr.getNumber = v;
  function O(B) {
    return v(g(B));
  }
  Rr.toNumber = O;
  function N(B, M) {
    let I = c(B, "value").toString(16);
    if (M == null)
      I.length % 2 && (I = "0" + I);
    else {
      const A = v(M, "width");
      for ((0, t.assert)(A * 2 >= I.length, `value exceeds width (${A} bytes)`, "NUMERIC_FAULT", {
        operation: "toBeHex",
        fault: "overflow",
        value: B
      }); I.length < A * 2; )
        I = "0" + I;
    }
    return "0x" + I;
  }
  Rr.toBeHex = N;
  function S(B) {
    const M = c(B, "value");
    if (M === r)
      return new Uint8Array([]);
    let I = M.toString(16);
    I.length % 2 && (I = "0" + I);
    const A = new Uint8Array(I.length / 2);
    for (let R = 0; R < A.length; R++) {
      const L = R * 2;
      A[R] = parseInt(I.substring(L, L + 2), 16);
    }
    return A;
  }
  Rr.toBeArray = S;
  function j(B) {
    let M = (0, e.hexlify)((0, e.isBytesLike)(B) ? B : S(B)).substring(2);
    for (; M.startsWith("0"); )
      M = M.substring(1);
    return M === "" && (M = "0"), "0x" + M;
  }
  return Rr.toQuantity = j, Rr;
}
var pb;
function vM() {
  if (pb)
    return ha;
  pb = 1, Object.defineProperty(ha, "__esModule", { value: !0 }), ha.decodeBase58 = ha.encodeBase58 = void 0;
  const e = qi(), t = As(), r = wd(), n = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  let s = null;
  function i(p) {
    if (s == null) {
      s = {};
      for (let v = 0; v < n.length; v++)
        s[n[v]] = BigInt(v);
    }
    const g = s[p];
    return (0, t.assertArgument)(g != null, "invalid base58 value", "letter", p), g;
  }
  const a = BigInt(0), f = BigInt(58);
  function d(p) {
    const g = (0, e.getBytes)(p);
    let v = (0, r.toBigInt)(g), O = "";
    for (; v; )
      O = n[Number(v % f)] + O, v /= f;
    for (let N = 0; N < g.length && !g[N]; N++)
      O = n[0] + O;
    return O;
  }
  ha.encodeBase58 = d;
  function c(p) {
    let g = a;
    for (let v = 0; v < p.length; v++)
      g *= f, g += i(p[v]);
    return g;
  }
  return ha.decodeBase58 = c, ha;
}
var pa = {}, gb;
function J8() {
  if (gb)
    return pa;
  gb = 1, Object.defineProperty(pa, "__esModule", { value: !0 }), pa.encodeBase64 = pa.decodeBase64 = void 0;
  const e = qi();
  function t(n) {
    n = atob(n);
    const s = new Uint8Array(n.length);
    for (let i = 0; i < n.length; i++)
      s[i] = n.charCodeAt(i);
    return (0, e.getBytes)(s);
  }
  pa.decodeBase64 = t;
  function r(n) {
    const s = (0, e.getBytes)(n);
    let i = "";
    for (let a = 0; a < s.length; a++)
      i += String.fromCharCode(s[a]);
    return btoa(i);
  }
  return pa.encodeBase64 = r, pa;
}
var wl = {}, mb;
function AM() {
  var e;
  if (mb)
    return wl;
  mb = 1, Object.defineProperty(wl, "__esModule", { value: !0 }), wl.EventPayload = void 0;
  const t = nu();
  class r {
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */
    constructor(s, i, a) {
      Se(this, "filter"), Se(this, "emitter"), Fe(this, e, void 0), Ne(this, e, i), (0, t.defineProperties)(this, { emitter: s, filter: a });
    }
    /**
     *  Unregister the triggered listener for future events.
     */
    async removeListener() {
      ae(this, e) != null && await this.emitter.off(this.filter, ae(this, e));
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), wl.EventPayload = r, wl;
}
var Ms = {}, yb = {}, bb;
function V1() {
  return bb || (bb = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8CodePoints = e.toUtf8String = e.toUtf8Bytes = e.Utf8ErrorFuncs = void 0;
    const t = qi(), r = As();
    function n(g, v, O, N, S) {
      (0, r.assertArgument)(!1, `invalid codepoint at offset ${v}; ${g}`, "bytes", O);
    }
    function s(g, v, O, N, S) {
      if (g === "BAD_PREFIX" || g === "UNEXPECTED_CONTINUE") {
        let j = 0;
        for (let B = v + 1; B < O.length && O[B] >> 6 === 2; B++)
          j++;
        return j;
      }
      return g === "OVERRUN" ? O.length - v - 1 : 0;
    }
    function i(g, v, O, N, S) {
      return g === "OVERLONG" ? ((0, r.assertArgument)(typeof S == "number", "invalid bad code point for replacement", "badCodepoint", S), N.push(S), 0) : (N.push(65533), s(g, v, O));
    }
    e.Utf8ErrorFuncs = Object.freeze({
      error: n,
      ignore: s,
      replace: i
    });
    function a(g, v) {
      v == null && (v = e.Utf8ErrorFuncs.error);
      const O = (0, t.getBytes)(g, "bytes"), N = [];
      let S = 0;
      for (; S < O.length; ) {
        const j = O[S++];
        if (!(j >> 7)) {
          N.push(j);
          continue;
        }
        let B = null, M = null;
        if ((j & 224) === 192)
          B = 1, M = 127;
        else if ((j & 240) === 224)
          B = 2, M = 2047;
        else if ((j & 248) === 240)
          B = 3, M = 65535;
        else {
          (j & 192) === 128 ? S += v("UNEXPECTED_CONTINUE", S - 1, O, N) : S += v("BAD_PREFIX", S - 1, O, N);
          continue;
        }
        if (S - 1 + B >= O.length) {
          S += v("OVERRUN", S - 1, O, N);
          continue;
        }
        let I = j & (1 << 8 - B - 1) - 1;
        for (let A = 0; A < B; A++) {
          let R = O[S];
          if ((R & 192) != 128) {
            S += v("MISSING_CONTINUE", S, O, N), I = null;
            break;
          }
          I = I << 6 | R & 63, S++;
        }
        if (I !== null) {
          if (I > 1114111) {
            S += v("OUT_OF_RANGE", S - 1 - B, O, N, I);
            continue;
          }
          if (I >= 55296 && I <= 57343) {
            S += v("UTF16_SURROGATE", S - 1 - B, O, N, I);
            continue;
          }
          if (I <= M) {
            S += v("OVERLONG", S - 1 - B, O, N, I);
            continue;
          }
          N.push(I);
        }
      }
      return N;
    }
    function f(g, v) {
      (0, r.assertArgument)(typeof g == "string", "invalid string value", "str", g), v != null && ((0, r.assertNormalize)(v), g = g.normalize(v));
      let O = [];
      for (let N = 0; N < g.length; N++) {
        const S = g.charCodeAt(N);
        if (S < 128)
          O.push(S);
        else if (S < 2048)
          O.push(S >> 6 | 192), O.push(S & 63 | 128);
        else if ((S & 64512) == 55296) {
          N++;
          const j = g.charCodeAt(N);
          (0, r.assertArgument)(N < g.length && (j & 64512) === 56320, "invalid surrogate pair", "str", g);
          const B = 65536 + ((S & 1023) << 10) + (j & 1023);
          O.push(B >> 18 | 240), O.push(B >> 12 & 63 | 128), O.push(B >> 6 & 63 | 128), O.push(B & 63 | 128);
        } else
          O.push(S >> 12 | 224), O.push(S >> 6 & 63 | 128), O.push(S & 63 | 128);
      }
      return new Uint8Array(O);
    }
    e.toUtf8Bytes = f;
    function d(g) {
      return g.map((v) => v <= 65535 ? String.fromCharCode(v) : (v -= 65536, String.fromCharCode((v >> 10 & 1023) + 55296, (v & 1023) + 56320))).join("");
    }
    function c(g, v) {
      return d(a(g, v));
    }
    e.toUtf8String = c;
    function p(g, v) {
      return a(f(g, v));
    }
    e.toUtf8CodePoints = p;
  }(yb)), yb;
}
var ga = {}, wb;
function EM() {
  if (wb)
    return ga;
  wb = 1, Object.defineProperty(ga, "__esModule", { value: !0 }), ga.getUrl = ga.createGetUrl = void 0;
  const e = As();
  function t(s) {
    async function i(a, f) {
      const d = a.url.split(":")[0].toLowerCase();
      (0, e.assert)(d === "http" || d === "https", `unsupported protocol ${d}`, "UNSUPPORTED_OPERATION", {
        info: { protocol: d },
        operation: "request"
      }), (0, e.assert)(d === "https" || !a.credentials || a.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
        operation: "request"
      });
      let c;
      if (f) {
        const S = new AbortController();
        c = S.signal, f.addListener(() => {
          S.abort();
        });
      }
      const p = {
        method: a.method,
        headers: new Headers(Array.from(a)),
        body: a.body || void 0,
        signal: c
      }, g = await fetch(a.url, p), v = {};
      g.headers.forEach((S, j) => {
        v[j.toLowerCase()] = S;
      });
      const O = await g.arrayBuffer(), N = O == null ? null : new Uint8Array(O);
      return {
        statusCode: g.status,
        statusMessage: g.statusText,
        headers: v,
        body: N
      };
    }
    return i;
  }
  ga.createGetUrl = t;
  const r = t();
  async function n(s, i) {
    return r(s, i);
  }
  return ga.getUrl = n, ga;
}
var vb;
function PM() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N, S, j, B, M, I, A, R, L, K, $;
  if (vb)
    return Ms;
  vb = 1, Object.defineProperty(Ms, "__esModule", { value: !0 }), Ms.FetchResponse = Ms.FetchRequest = Ms.FetchCancelSignal = void 0;
  const k = J8(), V = qi(), C = As(), D = nu(), o = V1(), u = EM(), h = 12, y = 250;
  let E = (0, u.createGetUrl)();
  const P = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), w = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
  let m = !1;
  async function l(te, U) {
    try {
      const ue = te.match(P);
      if (!ue)
        throw new Error("invalid data");
      return new Ee(200, "OK", {
        "content-type": ue[1] || "text/plain"
      }, ue[2] ? (0, k.decodeBase64)(ue[3]) : xe(ue[3]));
    } catch {
      return new Ee(599, "BAD REQUEST (invalid data: URI)", {}, null, new pe(te));
    }
  }
  function b(te) {
    async function U(ue, we) {
      try {
        const ke = ue.match(w);
        if (!ke)
          throw new Error("invalid link");
        return new pe(`${te}${ke[2]}`);
      } catch {
        return new Ee(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new pe(ue));
      }
    }
    return U;
  }
  const W = {
    data: l,
    ipfs: b("https://gateway.ipfs.io/ipfs/")
  }, X = /* @__PURE__ */ new WeakMap();
  class G {
    constructor(U) {
      Fe(this, e, void 0), Fe(this, t, void 0), Ne(this, e, []), Ne(this, t, !1), X.set(U, () => {
        if (!ae(this, t)) {
          Ne(this, t, !0);
          for (const ue of ae(this, e))
            setTimeout(() => {
              ue();
            }, 0);
          Ne(this, e, []);
        }
      });
    }
    addListener(U) {
      (0, C.assert)(!ae(this, t), "singal already cancelled", "UNSUPPORTED_OPERATION", {
        operation: "fetchCancelSignal.addCancelListener"
      }), ae(this, e).push(U);
    }
    get cancelled() {
      return ae(this, t);
    }
    checkSignal() {
      (0, C.assert)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), Ms.FetchCancelSignal = G;
  function re(te) {
    if (te == null)
      throw new Error("missing signal; should not happen");
    return te.checkSignal(), te;
  }
  const ce = class $p {
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */
    constructor(U) {
      Fe(this, B), Fe(this, r, void 0), Fe(this, n, void 0), Fe(this, s, void 0), Fe(this, i, void 0), Fe(this, a, void 0), Fe(this, f, void 0), Fe(this, d, void 0), Fe(this, c, void 0), Fe(this, p, void 0), Fe(this, g, void 0), Fe(this, v, void 0), Fe(this, O, void 0), Fe(this, N, void 0), Fe(this, S, void 0), Fe(this, j, void 0), Ne(this, f, String(U)), Ne(this, r, !1), Ne(this, n, !0), Ne(this, s, {}), Ne(this, i, ""), Ne(this, a, 3e5), Ne(this, S, {
        slotInterval: y,
        maxAttempts: h
      }), Ne(this, j, null);
    }
    /**
     *  The fetch URL to request.
     */
    get url() {
      return ae(this, f);
    }
    set url(U) {
      Ne(this, f, String(U));
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */
    get body() {
      return ae(this, d) == null ? null : new Uint8Array(ae(this, d));
    }
    set body(U) {
      if (U == null)
        Ne(this, d, void 0), Ne(this, c, void 0);
      else if (typeof U == "string")
        Ne(this, d, (0, o.toUtf8Bytes)(U)), Ne(this, c, "text/plain");
      else if (U instanceof Uint8Array)
        Ne(this, d, U), Ne(this, c, "application/octet-stream");
      else if (typeof U == "object")
        Ne(this, d, (0, o.toUtf8Bytes)(JSON.stringify(U))), Ne(this, c, "application/json");
      else
        throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */
    hasBody() {
      return ae(this, d) != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */
    get method() {
      return ae(this, i) ? ae(this, i) : this.hasBody() ? "POST" : "GET";
    }
    set method(U) {
      U == null && (U = ""), Ne(this, i, String(U).toUpperCase());
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */
    get headers() {
      const U = Object.assign({}, ae(this, s));
      return ae(this, p) && (U.authorization = `Basic ${(0, k.encodeBase64)((0, o.toUtf8Bytes)(ae(this, p)))}`), this.allowGzip && (U["accept-encoding"] = "gzip"), U["content-type"] == null && ae(this, c) && (U["content-type"] = ae(this, c)), this.body && (U["content-length"] = String(this.body.length)), U;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */
    getHeader(U) {
      return this.headers[U.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */
    setHeader(U, ue) {
      ae(this, s)[String(U).toLowerCase()] = String(ue);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */
    clearHeaders() {
      Ne(this, s, {});
    }
    [Symbol.iterator]() {
      const U = this.headers, ue = Object.keys(U);
      let we = 0;
      return {
        next: () => {
          if (we < ue.length) {
            const ke = ue[we++];
            return {
              value: [ke, U[ke]],
              done: !1
            };
          }
          return { value: void 0, done: !0 };
        }
      };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */
    get credentials() {
      return ae(this, p) || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */
    setCredentials(U, ue) {
      (0, C.assertArgument)(!U.match(/:/), "invalid basic authentication username", "username", "[REDACTED]"), Ne(this, p, `${U}:${ue}`);
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */
    get allowGzip() {
      return ae(this, n);
    }
    set allowGzip(U) {
      Ne(this, n, !!U);
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */
    get allowInsecureAuthentication() {
      return !!ae(this, r);
    }
    set allowInsecureAuthentication(U) {
      Ne(this, r, !!U);
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */
    get timeout() {
      return ae(this, a);
    }
    set timeout(U) {
      (0, C.assertArgument)(U >= 0, "timeout must be non-zero", "timeout", U), Ne(this, a, U);
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */
    get preflightFunc() {
      return ae(this, g) || null;
    }
    set preflightFunc(U) {
      Ne(this, g, U);
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */
    get processFunc() {
      return ae(this, v) || null;
    }
    set processFunc(U) {
      Ne(this, v, U);
    }
    /**
     *  This function is called on each retry attempt.
     */
    get retryFunc() {
      return ae(this, O) || null;
    }
    set retryFunc(U) {
      Ne(this, O, U);
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */
    get getUrlFunc() {
      return ae(this, j) || E;
    }
    set getUrlFunc(U) {
      Ne(this, j, U);
    }
    toString() {
      return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${ae(this, d) ? (0, V.hexlify)(ae(this, d)) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */
    setThrottleParams(U) {
      U.slotInterval != null && (ae(this, S).slotInterval = U.slotInterval), U.maxAttempts != null && (ae(this, S).maxAttempts = U.maxAttempts);
    }
    /**
     *  Resolves to the response by sending the request.
     */
    send() {
      return (0, C.assert)(ae(this, N) == null, "request already sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.send" }), Ne(this, N, new G(this)), qe(this, B, M).call(this, 0, Pe() + this.timeout, 0, this, new Ee(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */
    cancel() {
      (0, C.assert)(ae(this, N) != null, "request has not been sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.cancel" });
      const U = X.get(this);
      if (!U)
        throw new Error("missing signal; should not happen");
      U();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */
    redirect(U) {
      const ue = this.url.split(":")[0].toLowerCase(), we = U.split(":")[0].toLowerCase();
      (0, C.assert)(this.method === "GET" && (ue !== "https" || we !== "http") && U.match(/^https?:/), "unsupported redirect", "UNSUPPORTED_OPERATION", {
        operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(U)})`
      });
      const ke = new $p(U);
      return ke.method = "GET", ke.allowGzip = this.allowGzip, ke.timeout = this.timeout, Ne(ke, s, Object.assign({}, ae(this, s))), ae(this, d) && Ne(ke, d, new Uint8Array(ae(this, d))), Ne(ke, c, ae(this, c)), ke;
    }
    /**
     *  Create a new copy of this request.
     */
    clone() {
      const U = new $p(this.url);
      return Ne(U, i, ae(this, i)), ae(this, d) && Ne(U, d, ae(this, d)), Ne(U, c, ae(this, c)), Ne(U, s, Object.assign({}, ae(this, s))), Ne(U, p, ae(this, p)), this.allowGzip && (U.allowGzip = !0), U.timeout = this.timeout, this.allowInsecureAuthentication && (U.allowInsecureAuthentication = !0), Ne(U, g, ae(this, g)), Ne(U, v, ae(this, v)), Ne(U, O, ae(this, O)), Ne(U, S, Object.assign({}, ae(this, S))), Ne(U, j, ae(this, j)), U;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */
    static lockConfig() {
      m = !0;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */
    static getGateway(U) {
      return W[U.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */
    static registerGateway(U, ue) {
      if (U = U.toLowerCase(), U === "http" || U === "https")
        throw new Error(`cannot intercept ${U}; use registerGetUrl`);
      if (m)
        throw new Error("gateways locked");
      W[U] = ue;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */
    static registerGetUrl(U) {
      if (m)
        throw new Error("gateways locked");
      E = U;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */
    static createGetUrlFunc(U) {
      return (0, u.createGetUrl)(U);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */
    static createDataGateway() {
      return l;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */
    static createIpfsGatewayFunc(U) {
      return b(U);
    }
  };
  r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakSet(), M = async function(te, U, ue, we, ke) {
    var Re, fe, x;
    if (te >= ae(this, S).maxAttempts)
      return ke.makeServerError("exceeded maximum retry limit");
    (0, C.assert)(Pe() <= U, "timeout", "TIMEOUT", {
      operation: "request.send",
      reason: "timeout",
      request: we
    }), ue > 0 && await me(ue);
    let _ = this.clone();
    const q = (_.url.split(":")[0] || "").toLowerCase();
    if (q in W) {
      const ye = await W[q](_.url, re(ae(we, N)));
      if (ye instanceof Ee) {
        let ge = ye;
        if (this.processFunc) {
          re(ae(we, N));
          try {
            ge = await this.processFunc(_, ge);
          } catch (be) {
            (be.throttle == null || typeof be.stall != "number") && ge.makeServerError("error in post-processing function", be).assertOk();
          }
        }
        return ge;
      }
      _ = ye;
    }
    this.preflightFunc && (_ = await this.preflightFunc(_));
    const ne = await this.getUrlFunc(_, re(ae(we, N)));
    let de = new Ee(ne.statusCode, ne.statusMessage, ne.headers, ne.body, we);
    if (de.statusCode === 301 || de.statusCode === 302) {
      try {
        const ye = de.headers.location || "";
        return qe(Re = _.redirect(ye), B, M).call(Re, te + 1, U, 0, we, de);
      } catch {
      }
      return de;
    } else if (de.statusCode === 429 && (this.retryFunc == null || await this.retryFunc(_, de, te))) {
      const ye = de.headers["retry-after"];
      let ge = ae(this, S).slotInterval * Math.trunc(Math.random() * Math.pow(2, te));
      return typeof ye == "string" && ye.match(/^[1-9][0-9]*$/) && (ge = parseInt(ye)), qe(fe = _.clone(), B, M).call(fe, te + 1, U, ge, we, de);
    }
    if (this.processFunc) {
      re(ae(we, N));
      try {
        de = await this.processFunc(_, de);
      } catch (ye) {
        (ye.throttle == null || typeof ye.stall != "number") && de.makeServerError("error in post-processing function", ye).assertOk();
        let ge = ae(this, S).slotInterval * Math.trunc(Math.random() * Math.pow(2, te));
        return ye.stall >= 0 && (ge = ye.stall), qe(x = _.clone(), B, M).call(x, te + 1, U, ge, we, de);
      }
    }
    return de;
  };
  let pe = ce;
  Ms.FetchRequest = pe;
  const ve = class Q8 {
    constructor(U, ue, we, ke, Re) {
      Fe(this, I, void 0), Fe(this, A, void 0), Fe(this, R, void 0), Fe(this, L, void 0), Fe(this, K, void 0), Fe(this, $, void 0), Ne(this, I, U), Ne(this, A, ue), Ne(this, R, Object.keys(we).reduce((fe, x) => (fe[x.toLowerCase()] = String(we[x]), fe), {})), Ne(this, L, ke == null ? null : new Uint8Array(ke)), Ne(this, K, Re || null), Ne(this, $, { message: "" });
    }
    toString() {
      return `<FetchResponse status=${this.statusCode} body=${ae(this, L) ? (0, V.hexlify)(ae(this, L)) : "null"}>`;
    }
    /**
     *  The response status code.
     */
    get statusCode() {
      return ae(this, I);
    }
    /**
     *  The response status message.
     */
    get statusMessage() {
      return ae(this, A);
    }
    /**
     *  The response headers. All keys are lower-case.
     */
    get headers() {
      return Object.assign({}, ae(this, R));
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */
    get body() {
      return ae(this, L) == null ? null : new Uint8Array(ae(this, L));
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */
    get bodyText() {
      try {
        return ae(this, L) == null ? "" : (0, o.toUtf8String)(ae(this, L));
      } catch {
        (0, C.assert)(!1, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
          operation: "bodyText",
          info: { response: this }
        });
      }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */
    get bodyJson() {
      try {
        return JSON.parse(this.bodyText);
      } catch {
        (0, C.assert)(!1, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
          operation: "bodyJson",
          info: { response: this }
        });
      }
    }
    [Symbol.iterator]() {
      const U = this.headers, ue = Object.keys(U);
      let we = 0;
      return {
        next: () => {
          if (we < ue.length) {
            const ke = ue[we++];
            return {
              value: [ke, U[ke]],
              done: !1
            };
          }
          return { value: void 0, done: !0 };
        }
      };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */
    makeServerError(U, ue) {
      let we;
      U ? we = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${U})` : (U = `${this.statusCode} ${this.statusMessage}`, we = `CLIENT ESCALATED SERVER ERROR (${U})`);
      const ke = new Q8(599, we, this.headers, this.body, ae(this, K) || void 0);
      return Ne(ke, $, { message: U, error: ue }), ke;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */
    throwThrottleError(U, ue) {
      ue == null ? ue = -1 : (0, C.assertArgument)(Number.isInteger(ue) && ue >= 0, "invalid stall timeout", "stall", ue);
      const we = new Error(U || "throttling requests");
      throw (0, D.defineProperties)(we, { stall: ue, throttle: !0 }), we;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */
    getHeader(U) {
      return this.headers[U.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */
    hasBody() {
      return ae(this, L) != null;
    }
    /**
     *  The request made for this response.
     */
    get request() {
      return ae(this, K);
    }
    /**
     *  Returns true if this response was a success statusCode.
     */
    ok() {
      return ae(this, $).message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */
    assertOk() {
      if (this.ok())
        return;
      let { message: U, error: ue } = ae(this, $);
      U === "" && (U = `server response ${this.statusCode} ${this.statusMessage}`);
      let we = null;
      this.request && (we = this.request.url);
      let ke = null;
      try {
        ae(this, L) && (ke = (0, o.toUtf8String)(ae(this, L)));
      } catch {
      }
      (0, C.assert)(!1, U, "SERVER_ERROR", {
        request: this.request || "unknown request",
        response: this,
        error: ue,
        info: {
          requestUrl: we,
          responseBody: ke,
          responseStatus: `${this.statusCode} ${this.statusMessage}`
        }
      });
    }
  };
  I = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), K = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  let Ee = ve;
  Ms.FetchResponse = Ee;
  function Pe() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  function xe(te) {
    return (0, o.toUtf8Bytes)(te.replace(/%([0-9a-f][0-9a-f])/gi, (U, ue) => String.fromCharCode(parseInt(ue, 16))));
  }
  function me(te) {
    return new Promise((U) => setTimeout(U, te));
  }
  return Ms;
}
var vl = {}, Ab;
function Z8() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N;
  if (Ab)
    return vl;
  Ab = 1, Object.defineProperty(vl, "__esModule", { value: !0 }), vl.FixedNumber = void 0;
  const S = qi(), j = As(), B = wd(), M = nu(), I = BigInt(-1), A = BigInt(0), R = BigInt(1), L = BigInt(5), K = {};
  let $ = "0000";
  for (; $.length < 80; )
    $ += $;
  function k(h) {
    let y = $;
    for (; y.length < h; )
      y += y;
    return BigInt("1" + y.substring(0, h));
  }
  function V(h, y, E) {
    const P = BigInt(y.width);
    if (y.signed) {
      const w = R << P - R;
      (0, j.assert)(E == null || h >= -w && h < w, "overflow", "NUMERIC_FAULT", {
        operation: E,
        fault: "overflow",
        value: h
      }), h > A ? h = (0, B.fromTwos)((0, B.mask)(h, P), P) : h = -(0, B.fromTwos)((0, B.mask)(-h, P), P);
    } else {
      const w = R << P;
      (0, j.assert)(E == null || h >= 0 && h < w, "overflow", "NUMERIC_FAULT", {
        operation: E,
        fault: "overflow",
        value: h
      }), h = (h % w + w) % w & w - R;
    }
    return h;
  }
  function C(h) {
    typeof h == "number" && (h = `fixed128x${h}`);
    let y = !0, E = 128, P = 18;
    if (typeof h == "string") {
      if (h !== "fixed")
        if (h === "ufixed")
          y = !1;
        else {
          const m = h.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          (0, j.assertArgument)(m, "invalid fixed format", "format", h), y = m[1] !== "u", E = parseInt(m[2]), P = parseInt(m[3]);
        }
    } else if (h) {
      const m = h, l = (b, W, X) => m[b] == null ? X : ((0, j.assertArgument)(typeof m[b] === W, "invalid fixed format (" + b + " not " + W + ")", "format." + b, m[b]), m[b]);
      y = l("signed", "boolean", y), E = l("width", "number", E), P = l("decimals", "number", P);
    }
    (0, j.assertArgument)(E % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", E), (0, j.assertArgument)(P <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", P);
    const w = (y ? "" : "u") + "fixed" + String(E) + "x" + String(P);
    return { signed: y, width: E, decimals: P, name: w };
  }
  function D(h, y) {
    let E = "";
    h < A && (E = "-", h *= I);
    let P = h.toString();
    if (y === 0)
      return E + P;
    for (; P.length <= y; )
      P = $ + P;
    const w = P.length - y;
    for (P = P.substring(0, w) + "." + P.substring(w); P[0] === "0" && P[1] !== "."; )
      P = P.substring(1);
    for (; P[P.length - 1] === "0" && P[P.length - 2] !== "."; )
      P = P.substring(0, P.length - 1);
    return E + P;
  }
  const o = class wu {
    // Use this when changing this file to get some typing info,
    // but then switch to any to mask the internal type
    //constructor(guard: any, value: bigint, format: _FixedFormat) {
    /**
     *  @private
     */
    constructor(y, E, P) {
      Fe(this, n), Fe(this, i), Fe(this, f), Fe(this, c), Fe(this, g), Fe(this, O), Se(this, "format"), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Se(this, "_value"), (0, j.assertPrivate)(y, K, "FixedNumber"), Ne(this, t, E), Ne(this, e, P);
      const w = D(E, P.decimals);
      (0, M.defineProperties)(this, { format: P.name, _value: w }), Ne(this, r, k(P.decimals));
    }
    /**
     *  If true, negative values are permitted, otherwise only
     *  positive values and zero are allowed.
     */
    get signed() {
      return ae(this, e).signed;
    }
    /**
     *  The number of bits available to store the value.
     */
    get width() {
      return ae(this, e).width;
    }
    /**
     *  The number of decimal places in the fixed-point arithment field.
     */
    get decimals() {
      return ae(this, e).decimals;
    }
    /**
     *  The value as an integer, based on the smallest unit the
     *  [[decimals]] allow.
     */
    get value() {
      return ae(this, t);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%, ignoring overflow.
     */
    addUnsafe(y) {
      return qe(this, f, d).call(this, y);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    add(y) {
      return qe(this, f, d).call(this, y, "add");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%, ignoring overflow.
     */
    subUnsafe(y) {
      return qe(this, c, p).call(this, y);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    sub(y) {
      return qe(this, c, p).call(this, y, "sub");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%, ignoring overflow and underflow (precision loss).
     */
    mulUnsafe(y) {
      return qe(this, g, v).call(this, y);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    mul(y) {
      return qe(this, g, v).call(this, y, "mul");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs or if underflow (precision loss) occurs.
     */
    mulSignal(y) {
      qe(this, n, s).call(this, y);
      const E = ae(this, t) * ae(y, t);
      return (0, j.assert)(E % ae(this, r) === A, "precision lost during signalling mul", "NUMERIC_FAULT", {
        operation: "mulSignal",
        fault: "underflow",
        value: this
      }), qe(this, i, a).call(this, E / ae(this, r), "mulSignal");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */
    divUnsafe(y) {
      return qe(this, O, N).call(this, y);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */
    div(y) {
      return qe(this, O, N).call(this, y, "div");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
     *  (precision loss) occurs.
     */
    divSignal(y) {
      (0, j.assert)(ae(y, t) !== A, "division by zero", "NUMERIC_FAULT", {
        operation: "div",
        fault: "divide-by-zero",
        value: this
      }), qe(this, n, s).call(this, y);
      const E = ae(this, t) * ae(this, r);
      return (0, j.assert)(E % ae(y, t) === A, "precision lost during signalling div", "NUMERIC_FAULT", {
        operation: "divSignal",
        fault: "underflow",
        value: this
      }), qe(this, i, a).call(this, E / ae(y, t), "divSignal");
    }
    /**
     *  Returns a comparison result between %%this%% and %%other%%.
     *
     *  This is suitable for use in sorting, where ``-1`` implies %%this%%
     *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
     *  both are equal.
     */
    cmp(y) {
      let E = this.value, P = y.value;
      const w = this.decimals - y.decimals;
      return w > 0 ? P *= k(w) : w < 0 && (E *= k(-w)), E < P ? -1 : E > P ? 1 : 0;
    }
    /**
     *  Returns true if %%other%% is equal to %%this%%.
     */
    eq(y) {
      return this.cmp(y) === 0;
    }
    /**
     *  Returns true if %%other%% is less than to %%this%%.
     */
    lt(y) {
      return this.cmp(y) < 0;
    }
    /**
     *  Returns true if %%other%% is less than or equal to %%this%%.
     */
    lte(y) {
      return this.cmp(y) <= 0;
    }
    /**
     *  Returns true if %%other%% is greater than to %%this%%.
     */
    gt(y) {
      return this.cmp(y) > 0;
    }
    /**
     *  Returns true if %%other%% is greater than or equal to %%this%%.
     */
    gte(y) {
      return this.cmp(y) >= 0;
    }
    /**
     *  Returns a new [[FixedNumber]] which is the largest **integer**
     *  that is less than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */
    floor() {
      let y = ae(this, t);
      return ae(this, t) < A && (y -= ae(this, r) - R), y = ae(this, t) / ae(this, r) * ae(this, r), qe(this, i, a).call(this, y, "floor");
    }
    /**
     *  Returns a new [[FixedNumber]] which is the smallest **integer**
     *  that is greater than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */
    ceiling() {
      let y = ae(this, t);
      return ae(this, t) > A && (y += ae(this, r) - R), y = ae(this, t) / ae(this, r) * ae(this, r), qe(this, i, a).call(this, y, "ceiling");
    }
    /**
     *  Returns a new [[FixedNumber]] with the decimal component
     *  rounded up on ties at %%decimals%% places.
     */
    round(y) {
      if (y == null && (y = 0), y >= this.decimals)
        return this;
      const E = this.decimals - y, P = L * k(E - 1);
      let w = this.value + P;
      const m = k(E);
      return w = w / m * m, V(w, ae(this, e), "round"), new wu(K, w, ae(this, e));
    }
    /**
     *  Returns true if %%this%% is equal to ``0``.
     */
    isZero() {
      return ae(this, t) === A;
    }
    /**
     *  Returns true if %%this%% is less than ``0``.
     */
    isNegative() {
      return ae(this, t) < A;
    }
    /**
     *  Returns the string representation of %%this%%.
     */
    toString() {
      return this._value;
    }
    /**
     *  Returns a float approximation.
     *
     *  Due to IEEE 754 precission (or lack thereof), this function
     *  can only return an approximation and most values will contain
     *  rounding errors.
     */
    toUnsafeFloat() {
      return parseFloat(this.toString());
    }
    /**
     *  Return a new [[FixedNumber]] with the same value but has had
     *  its field set to %%format%%.
     *
     *  This will throw if the value cannot fit into %%format%%.
     */
    toFormat(y) {
      return wu.fromString(this.toString(), y);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% divided by
     *  %%decimal%% places with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
     *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
     *  or underflow (precision loss).
     */
    static fromValue(y, E, P) {
      const w = E == null ? 0 : (0, B.getNumber)(E), m = C(P);
      let l = (0, B.getBigInt)(y, "value");
      const b = w - m.decimals;
      if (b > 0) {
        const W = k(b);
        (0, j.assert)(l % W === A, "value loses precision for format", "NUMERIC_FAULT", {
          operation: "fromValue",
          fault: "underflow",
          value: y
        }), l /= W;
      } else
        b < 0 && (l *= k(-b));
      return V(l, m, "fromValue"), new wu(K, l, m);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%%, either due to overflow or underflow (precision loss).
     */
    static fromString(y, E) {
      const P = y.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
      (0, j.assertArgument)(P && P[2].length + P[3].length > 0, "invalid FixedNumber string value", "value", y);
      const w = C(E);
      let m = P[2] || "0", l = P[3] || "";
      for (; l.length < w.decimals; )
        l += $;
      (0, j.assert)(l.substring(w.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
        operation: "fromString",
        fault: "underflow",
        value: y
      }), l = l.substring(0, w.decimals);
      const b = BigInt(P[1] + m + l);
      return V(b, w, "fromString"), new wu(K, b, w);
    }
    /**
     *  Creates a new [[FixedNumber]] with the big-endian representation
     *  %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%% due to overflow.
     */
    static fromBytes(y, E) {
      let P = (0, B.toBigInt)((0, S.getBytes)(y, "value"));
      const w = C(E);
      return w.signed && (P = (0, B.fromTwos)(P, w.width)), V(P, w, "fromBytes"), new wu(K, P, w);
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakSet(), s = function(h) {
    (0, j.assertArgument)(this.format === h.format, "incompatible format; use fixedNumber.toFormat", "other", h);
  }, i = /* @__PURE__ */ new WeakSet(), a = function(h, y) {
    return h = V(h, ae(this, e), y), new o(K, h, ae(this, e));
  }, f = /* @__PURE__ */ new WeakSet(), d = function(h, y) {
    return qe(this, n, s).call(this, h), qe(this, i, a).call(this, ae(this, t) + ae(h, t), y);
  }, c = /* @__PURE__ */ new WeakSet(), p = function(h, y) {
    return qe(this, n, s).call(this, h), qe(this, i, a).call(this, ae(this, t) - ae(h, t), y);
  }, g = /* @__PURE__ */ new WeakSet(), v = function(h, y) {
    return qe(this, n, s).call(this, h), qe(this, i, a).call(this, ae(this, t) * ae(h, t) / ae(this, r), y);
  }, O = /* @__PURE__ */ new WeakSet(), N = function(h, y) {
    return (0, j.assert)(ae(h, t) !== A, "division by zero", "NUMERIC_FAULT", {
      operation: "div",
      fault: "divide-by-zero",
      value: this
    }), qe(this, n, s).call(this, h), qe(this, i, a).call(this, ae(this, t) * ae(this, r) / ae(h, t), y);
  };
  let u = o;
  return vl.FixedNumber = u, vl;
}
var Al = {}, Eb;
function OM() {
  if (Eb)
    return Al;
  Eb = 1, Object.defineProperty(Al, "__esModule", { value: !0 }), Al.decodeRlp = void 0;
  const e = qi(), t = As(), r = qi();
  function n(d) {
    let c = d.toString(16);
    for (; c.length < 2; )
      c = "0" + c;
    return "0x" + c;
  }
  function s(d, c, p) {
    let g = 0;
    for (let v = 0; v < p; v++)
      g = g * 256 + d[c + v];
    return g;
  }
  function i(d, c, p, g) {
    const v = [];
    for (; p < c + 1 + g; ) {
      const O = a(d, p);
      v.push(O.result), p += O.consumed, (0, t.assert)(p <= c + 1 + g, "child data too short", "BUFFER_OVERRUN", {
        buffer: d,
        length: g,
        offset: c
      });
    }
    return { consumed: 1 + g, result: v };
  }
  function a(d, c) {
    (0, t.assert)(d.length !== 0, "data too short", "BUFFER_OVERRUN", {
      buffer: d,
      length: 0,
      offset: 1
    });
    const p = (g) => {
      (0, t.assert)(g <= d.length, "data short segment too short", "BUFFER_OVERRUN", {
        buffer: d,
        length: d.length,
        offset: g
      });
    };
    if (d[c] >= 248) {
      const g = d[c] - 247;
      p(c + 1 + g);
      const v = s(d, c + 1, g);
      return p(c + 1 + g + v), i(d, c, c + 1 + g, g + v);
    } else if (d[c] >= 192) {
      const g = d[c] - 192;
      return p(c + 1 + g), i(d, c, c + 1, g);
    } else if (d[c] >= 184) {
      const g = d[c] - 183;
      p(c + 1 + g);
      const v = s(d, c + 1, g);
      p(c + 1 + g + v);
      const O = (0, e.hexlify)(d.slice(c + 1 + g, c + 1 + g + v));
      return { consumed: 1 + g + v, result: O };
    } else if (d[c] >= 128) {
      const g = d[c] - 128;
      p(c + 1 + g);
      const v = (0, e.hexlify)(d.slice(c + 1, c + 1 + g));
      return { consumed: 1 + g, result: v };
    }
    return { consumed: 1, result: n(d[c]) };
  }
  function f(d) {
    const c = (0, r.getBytes)(d, "data"), p = a(c, 0);
    return (0, t.assertArgument)(p.consumed === c.length, "unexpected junk after rlp payload", "data", d), p.result;
  }
  return Al.decodeRlp = f, Al;
}
var El = {}, Pb;
function NM() {
  if (Pb)
    return El;
  Pb = 1, Object.defineProperty(El, "__esModule", { value: !0 }), El.encodeRlp = void 0;
  const e = qi();
  function t(i) {
    const a = [];
    for (; i; )
      a.unshift(i & 255), i >>= 8;
    return a;
  }
  function r(i) {
    if (Array.isArray(i)) {
      let d = [];
      if (i.forEach(function(p) {
        d = d.concat(r(p));
      }), d.length <= 55)
        return d.unshift(192 + d.length), d;
      const c = t(d.length);
      return c.unshift(247 + c.length), c.concat(d);
    }
    const a = Array.prototype.slice.call((0, e.getBytes)(i, "object"));
    if (a.length === 1 && a[0] <= 127)
      return a;
    if (a.length <= 55)
      return a.unshift(128 + a.length), a;
    const f = t(a.length);
    return f.unshift(183 + f.length), f.concat(a);
  }
  const n = "0123456789abcdef";
  function s(i) {
    let a = "0x";
    for (const f of r(i))
      a += n[f >> 4], a += n[f & 15];
    return a;
  }
  return El.encodeRlp = s, El;
}
var xi = {}, Ob;
function xM() {
  if (Ob)
    return xi;
  Ob = 1, Object.defineProperty(xi, "__esModule", { value: !0 }), xi.parseEther = xi.formatEther = xi.parseUnits = xi.formatUnits = void 0;
  const e = As(), t = Z8(), r = wd(), n = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
  ];
  function s(d, c) {
    let p = 18;
    if (typeof c == "string") {
      const g = n.indexOf(c);
      (0, e.assertArgument)(g >= 0, "invalid unit", "unit", c), p = 3 * g;
    } else
      c != null && (p = (0, r.getNumber)(c, "unit"));
    return t.FixedNumber.fromValue(d, p, { decimals: p, width: 512 }).toString();
  }
  xi.formatUnits = s;
  function i(d, c) {
    (0, e.assertArgument)(typeof d == "string", "value must be a string", "value", d);
    let p = 18;
    if (typeof c == "string") {
      const g = n.indexOf(c);
      (0, e.assertArgument)(g >= 0, "invalid unit", "unit", c), p = 3 * g;
    } else
      c != null && (p = (0, r.getNumber)(c, "unit"));
    return t.FixedNumber.fromString(d, { decimals: p, width: 512 }).value;
  }
  xi.parseUnits = i;
  function a(d) {
    return s(d, 18);
  }
  xi.formatEther = a;
  function f(d) {
    return i(d, 18);
  }
  return xi.parseEther = f, xi;
}
var Pl = {}, Nb;
function TM() {
  if (Nb)
    return Pl;
  Nb = 1, Object.defineProperty(Pl, "__esModule", { value: !0 }), Pl.uuidV4 = void 0;
  const e = qi();
  function t(r) {
    const n = (0, e.getBytes)(r, "randomBytes");
    n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128;
    const s = (0, e.hexlify)(n);
    return [
      s.substring(2, 10),
      s.substring(10, 14),
      s.substring(14, 18),
      s.substring(18, 22),
      s.substring(22, 34)
    ].join("-");
  }
  return Pl.uuidV4 = t, Pl;
}
var xb;
function vt() {
  return xb || (xb = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8String = e.toUtf8CodePoints = e.toUtf8Bytes = e.parseUnits = e.formatUnits = e.parseEther = e.formatEther = e.encodeRlp = e.decodeRlp = e.defineProperties = e.resolveProperties = e.toQuantity = e.toBeArray = e.toBeHex = e.toNumber = e.toBigInt = e.getUint = e.getNumber = e.getBigInt = e.mask = e.toTwos = e.fromTwos = e.FixedNumber = e.FetchCancelSignal = e.FetchResponse = e.FetchRequest = e.EventPayload = e.makeError = e.assertNormalize = e.assertPrivate = e.assertArgumentCount = e.assertArgument = e.assert = e.isError = e.isCallException = e.zeroPadBytes = e.zeroPadValue = e.stripZerosLeft = e.dataSlice = e.dataLength = e.concat = e.hexlify = e.isBytesLike = e.isHexString = e.getBytesCopy = e.getBytes = e.encodeBase64 = e.decodeBase64 = e.encodeBase58 = e.decodeBase58 = void 0, e.uuidV4 = e.Utf8ErrorFuncs = void 0;
    var t = vM();
    Object.defineProperty(e, "decodeBase58", { enumerable: !0, get: function() {
      return t.decodeBase58;
    } }), Object.defineProperty(e, "encodeBase58", { enumerable: !0, get: function() {
      return t.encodeBase58;
    } });
    var r = J8();
    Object.defineProperty(e, "decodeBase64", { enumerable: !0, get: function() {
      return r.decodeBase64;
    } }), Object.defineProperty(e, "encodeBase64", { enumerable: !0, get: function() {
      return r.encodeBase64;
    } });
    var n = qi();
    Object.defineProperty(e, "getBytes", { enumerable: !0, get: function() {
      return n.getBytes;
    } }), Object.defineProperty(e, "getBytesCopy", { enumerable: !0, get: function() {
      return n.getBytesCopy;
    } }), Object.defineProperty(e, "isHexString", { enumerable: !0, get: function() {
      return n.isHexString;
    } }), Object.defineProperty(e, "isBytesLike", { enumerable: !0, get: function() {
      return n.isBytesLike;
    } }), Object.defineProperty(e, "hexlify", { enumerable: !0, get: function() {
      return n.hexlify;
    } }), Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
      return n.concat;
    } }), Object.defineProperty(e, "dataLength", { enumerable: !0, get: function() {
      return n.dataLength;
    } }), Object.defineProperty(e, "dataSlice", { enumerable: !0, get: function() {
      return n.dataSlice;
    } }), Object.defineProperty(e, "stripZerosLeft", { enumerable: !0, get: function() {
      return n.stripZerosLeft;
    } }), Object.defineProperty(e, "zeroPadValue", { enumerable: !0, get: function() {
      return n.zeroPadValue;
    } }), Object.defineProperty(e, "zeroPadBytes", { enumerable: !0, get: function() {
      return n.zeroPadBytes;
    } });
    var s = As();
    Object.defineProperty(e, "isCallException", { enumerable: !0, get: function() {
      return s.isCallException;
    } }), Object.defineProperty(e, "isError", { enumerable: !0, get: function() {
      return s.isError;
    } }), Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
      return s.assert;
    } }), Object.defineProperty(e, "assertArgument", { enumerable: !0, get: function() {
      return s.assertArgument;
    } }), Object.defineProperty(e, "assertArgumentCount", { enumerable: !0, get: function() {
      return s.assertArgumentCount;
    } }), Object.defineProperty(e, "assertPrivate", { enumerable: !0, get: function() {
      return s.assertPrivate;
    } }), Object.defineProperty(e, "assertNormalize", { enumerable: !0, get: function() {
      return s.assertNormalize;
    } }), Object.defineProperty(e, "makeError", { enumerable: !0, get: function() {
      return s.makeError;
    } });
    var i = AM();
    Object.defineProperty(e, "EventPayload", { enumerable: !0, get: function() {
      return i.EventPayload;
    } });
    var a = PM();
    Object.defineProperty(e, "FetchRequest", { enumerable: !0, get: function() {
      return a.FetchRequest;
    } }), Object.defineProperty(e, "FetchResponse", { enumerable: !0, get: function() {
      return a.FetchResponse;
    } }), Object.defineProperty(e, "FetchCancelSignal", { enumerable: !0, get: function() {
      return a.FetchCancelSignal;
    } });
    var f = Z8();
    Object.defineProperty(e, "FixedNumber", { enumerable: !0, get: function() {
      return f.FixedNumber;
    } });
    var d = wd();
    Object.defineProperty(e, "fromTwos", { enumerable: !0, get: function() {
      return d.fromTwos;
    } }), Object.defineProperty(e, "toTwos", { enumerable: !0, get: function() {
      return d.toTwos;
    } }), Object.defineProperty(e, "mask", { enumerable: !0, get: function() {
      return d.mask;
    } }), Object.defineProperty(e, "getBigInt", { enumerable: !0, get: function() {
      return d.getBigInt;
    } }), Object.defineProperty(e, "getNumber", { enumerable: !0, get: function() {
      return d.getNumber;
    } }), Object.defineProperty(e, "getUint", { enumerable: !0, get: function() {
      return d.getUint;
    } }), Object.defineProperty(e, "toBigInt", { enumerable: !0, get: function() {
      return d.toBigInt;
    } }), Object.defineProperty(e, "toNumber", { enumerable: !0, get: function() {
      return d.toNumber;
    } }), Object.defineProperty(e, "toBeHex", { enumerable: !0, get: function() {
      return d.toBeHex;
    } }), Object.defineProperty(e, "toBeArray", { enumerable: !0, get: function() {
      return d.toBeArray;
    } }), Object.defineProperty(e, "toQuantity", { enumerable: !0, get: function() {
      return d.toQuantity;
    } });
    var c = nu();
    Object.defineProperty(e, "resolveProperties", { enumerable: !0, get: function() {
      return c.resolveProperties;
    } }), Object.defineProperty(e, "defineProperties", { enumerable: !0, get: function() {
      return c.defineProperties;
    } });
    var p = OM();
    Object.defineProperty(e, "decodeRlp", { enumerable: !0, get: function() {
      return p.decodeRlp;
    } });
    var g = NM();
    Object.defineProperty(e, "encodeRlp", { enumerable: !0, get: function() {
      return g.encodeRlp;
    } });
    var v = xM();
    Object.defineProperty(e, "formatEther", { enumerable: !0, get: function() {
      return v.formatEther;
    } }), Object.defineProperty(e, "parseEther", { enumerable: !0, get: function() {
      return v.parseEther;
    } }), Object.defineProperty(e, "formatUnits", { enumerable: !0, get: function() {
      return v.formatUnits;
    } }), Object.defineProperty(e, "parseUnits", { enumerable: !0, get: function() {
      return v.parseUnits;
    } });
    var O = V1();
    Object.defineProperty(e, "toUtf8Bytes", { enumerable: !0, get: function() {
      return O.toUtf8Bytes;
    } }), Object.defineProperty(e, "toUtf8CodePoints", { enumerable: !0, get: function() {
      return O.toUtf8CodePoints;
    } }), Object.defineProperty(e, "toUtf8String", { enumerable: !0, get: function() {
      return O.toUtf8String;
    } }), Object.defineProperty(e, "Utf8ErrorFuncs", { enumerable: !0, get: function() {
      return O.Utf8ErrorFuncs;
    } });
    var N = TM();
    Object.defineProperty(e, "uuidV4", { enumerable: !0, get: function() {
      return N.uuidV4;
    } });
  }(cb)), cb;
}
var Tb = {}, kb;
function Yi() {
  return kb || (kb = 1, function(e) {
    var t, r, n, s, i, a, f, d, c, p, g, v, O, N;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Reader = e.Writer = e.Coder = e.checkResultErrors = e.Result = e.WordSize = void 0;
    const S = vt();
    e.WordSize = 32;
    const j = new Uint8Array(e.WordSize), B = ["then"], M = {};
    function I(D, o) {
      const u = new Error(`deferred error during ABI decoding triggered accessing ${D}`);
      throw u.error = o, u;
    }
    const A = class vu extends Array {
      /**
       *  @private
       */
      constructor(...o) {
        const u = o[0];
        let h = o[1], y = (o[2] || []).slice(), E = !0;
        u !== M && (h = o, y = [], E = !1), super(h.length), Fe(this, t, void 0), h.forEach((w, m) => {
          this[m] = w;
        });
        const P = y.reduce((w, m) => (typeof m == "string" && w.set(m, (w.get(m) || 0) + 1), w), /* @__PURE__ */ new Map());
        if (Ne(this, t, Object.freeze(h.map((w, m) => {
          const l = y[m];
          return l != null && P.get(l) === 1 ? l : null;
        }))), !!E)
          return Object.freeze(this), new Proxy(this, {
            get: (w, m, l) => {
              if (typeof m == "string") {
                if (m.match(/^[0-9]+$/)) {
                  const W = (0, S.getNumber)(m, "%index");
                  if (W < 0 || W >= this.length)
                    throw new RangeError("out of result range");
                  const X = w[W];
                  return X instanceof Error && I(`index ${W}`, X), X;
                }
                if (B.indexOf(m) >= 0)
                  return Reflect.get(w, m, l);
                const b = w[m];
                if (b instanceof Function)
                  return function(...W) {
                    return b.apply(this === l ? w : this, W);
                  };
                if (!(m in w))
                  return w.getValue.apply(this === l ? w : this, [m]);
              }
              return Reflect.get(w, m, l);
            }
          });
      }
      /**
       *  Returns the Result as a normal Array. If %%deep%%, any children
       *  which are Result objects are also converted to a normal Array.
       *
       *  This will throw if there are any outstanding deferred
       *  errors.
       */
      toArray(o) {
        const u = [];
        return this.forEach((h, y) => {
          h instanceof Error && I(`index ${y}`, h), o && h instanceof vu && (h = h.toArray(o)), u.push(h);
        }), u;
      }
      /**
       *  Returns the Result as an Object with each name-value pair. If
       *  %%deep%%, any children which are Result objects are also
       *  converted to an Object.
       *
       *  This will throw if any value is unnamed, or if there are
       *  any outstanding deferred errors.
       */
      toObject(o) {
        return ae(this, t).reduce((u, h, y) => {
          if ((0, S.assert)(h != null, "value at index ${ index } unnamed", "UNSUPPORTED_OPERATION", {
            operation: "toObject()"
          }), !(h in u)) {
            let E = this.getValue(h);
            o && E instanceof vu && (E = E.toObject(o)), u[h] = E;
          }
          return u;
        }, {});
      }
      /**
       *  @_ignore
       */
      slice(o, u) {
        o == null && (o = 0), o < 0 && (o += this.length, o < 0 && (o = 0)), u == null && (u = this.length), u < 0 && (u += this.length, u < 0 && (u = 0)), u > this.length && (u = this.length);
        const h = [], y = [];
        for (let E = o; E < u; E++)
          h.push(this[E]), y.push(ae(this, t)[E]);
        return new vu(M, h, y);
      }
      /**
       *  @_ignore
       */
      filter(o, u) {
        const h = [], y = [];
        for (let E = 0; E < this.length; E++) {
          const P = this[E];
          P instanceof Error && I(`index ${E}`, P), o.call(u, P, E, this) && (h.push(P), y.push(ae(this, t)[E]));
        }
        return new vu(M, h, y);
      }
      /**
       *  @_ignore
       */
      map(o, u) {
        const h = [];
        for (let y = 0; y < this.length; y++) {
          const E = this[y];
          E instanceof Error && I(`index ${y}`, E), h.push(o.call(u, E, y, this));
        }
        return h;
      }
      /**
       *  Returns the value for %%name%%.
       *
       *  Since it is possible to have a key whose name conflicts with
       *  a method on a [[Result]] or its superclass Array, or any
       *  JavaScript keyword, this ensures all named values are still
       *  accessible by name.
       */
      getValue(o) {
        const u = ae(this, t).indexOf(o);
        if (u === -1)
          return;
        const h = this[u];
        return h instanceof Error && I(`property ${JSON.stringify(o)}`, h.error), h;
      }
      /**
       *  Creates a new [[Result]] for %%items%% with each entry
       *  also accessible by its corresponding name in %%keys%%.
       */
      static fromItems(o, u) {
        return new vu(M, o, u);
      }
    };
    t = /* @__PURE__ */ new WeakMap();
    let R = A;
    e.Result = R;
    function L(D) {
      const o = [], u = function(h, y) {
        if (Array.isArray(y))
          for (let E in y) {
            const P = h.slice();
            P.push(E);
            try {
              u(P, y[E]);
            } catch (w) {
              o.push({ path: P, error: w });
            }
          }
      };
      return u([], D), o;
    }
    e.checkResultErrors = L;
    function K(D) {
      let o = (0, S.toBeArray)(D);
      return (0, S.assert)(o.length <= e.WordSize, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: o, length: e.WordSize, offset: o.length }), o.length !== e.WordSize && (o = (0, S.getBytesCopy)((0, S.concat)([j.slice(o.length % e.WordSize), o]))), o;
    }
    class $ {
      constructor(o, u, h, y) {
        Se(this, "name"), Se(this, "type"), Se(this, "localName"), Se(this, "dynamic"), (0, S.defineProperties)(this, { name: o, type: u, localName: h, dynamic: y }, {
          name: "string",
          type: "string",
          localName: "string",
          dynamic: "boolean"
        });
      }
      _throwError(o, u) {
        (0, S.assertArgument)(!1, o, this.localName, u);
      }
    }
    e.Coder = $;
    class k {
      constructor() {
        Fe(this, s), Fe(this, r, void 0), Fe(this, n, void 0), Ne(this, r, []), Ne(this, n, 0);
      }
      get data() {
        return (0, S.concat)(ae(this, r));
      }
      get length() {
        return ae(this, n);
      }
      appendWriter(o) {
        return qe(this, s, i).call(this, (0, S.getBytesCopy)(o.data));
      }
      // Arrayish item; pad on the right to *nearest* WordSize
      writeBytes(o) {
        let u = (0, S.getBytesCopy)(o);
        const h = u.length % e.WordSize;
        return h && (u = (0, S.getBytesCopy)((0, S.concat)([u, j.slice(h)]))), qe(this, s, i).call(this, u);
      }
      // Numeric item; pad on the left *to* WordSize
      writeValue(o) {
        return qe(this, s, i).call(this, K(o));
      }
      // Inserts a numeric place-holder, returning a callback that can
      // be used to asjust the value later
      writeUpdatableValue() {
        const o = ae(this, r).length;
        return ae(this, r).push(j), Ne(this, n, ae(this, n) + e.WordSize), (u) => {
          ae(this, r)[o] = K(u);
        };
      }
    }
    r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakSet(), i = function(D) {
      return ae(this, r).push(D), Ne(this, n, ae(this, n) + D.length), D.length;
    }, e.Writer = k;
    const V = class Y8 {
      constructor(o, u, h) {
        Fe(this, g), Fe(this, O), Se(this, "allowLoose"), Fe(this, a, void 0), Fe(this, f, void 0), Fe(this, d, void 0), Fe(this, c, void 0), Fe(this, p, void 0), (0, S.defineProperties)(this, { allowLoose: !!u }), Ne(this, a, (0, S.getBytesCopy)(o)), Ne(this, d, 0), Ne(this, c, null), Ne(this, p, h ?? 1024), Ne(this, f, 0);
      }
      get data() {
        return (0, S.hexlify)(ae(this, a));
      }
      get dataLength() {
        return ae(this, a).length;
      }
      get consumed() {
        return ae(this, f);
      }
      get bytes() {
        return new Uint8Array(ae(this, a));
      }
      // Create a sub-reader with the same underlying data, but offset
      subReader(o) {
        const u = new Y8(ae(this, a).slice(ae(this, f) + o), this.allowLoose, ae(this, p));
        return Ne(u, c, this), u;
      }
      // Read bytes
      readBytes(o, u) {
        let h = qe(this, O, N).call(this, 0, o, !!u);
        return qe(this, g, v).call(this, o), Ne(this, f, ae(this, f) + h.length), h.slice(0, o);
      }
      // Read a numeric values
      readValue() {
        return (0, S.toBigInt)(this.readBytes(e.WordSize));
      }
      readIndex() {
        return (0, S.toNumber)(this.readBytes(e.WordSize));
      }
    };
    a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakSet(), v = function(D) {
      var o;
      if (ae(this, c))
        return qe(o = ae(this, c), g, v).call(o, D);
      Ne(this, d, ae(this, d) + D), (0, S.assert)(ae(this, p) < 1 || ae(this, d) <= ae(this, p) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${ae(this, p)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
        buffer: (0, S.getBytesCopy)(ae(this, a)),
        offset: ae(this, f),
        length: D,
        info: {
          bytesRead: ae(this, d),
          dataLength: this.dataLength
        }
      });
    }, O = /* @__PURE__ */ new WeakSet(), N = function(D, o, u) {
      let h = Math.ceil(o / e.WordSize) * e.WordSize;
      return ae(this, f) + h > ae(this, a).length && (this.allowLoose && u && ae(this, f) + o <= ae(this, a).length ? h = o : (0, S.assert)(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
        buffer: (0, S.getBytesCopy)(ae(this, a)),
        length: ae(this, a).length,
        offset: ae(this, f) + h
      })), ae(this, a).slice(ae(this, f), ae(this, f) + h);
    };
    let C = V;
    e.Reader = C;
  }(Tb)), Tb;
}
var Ol = {}, Sb = {}, ma = {}, Mb = {}, Nl = {}, Ti = {}, Ib = {}, hn = {}, Rb;
function vd() {
  if (Rb)
    return hn;
  Rb = 1, Object.defineProperty(hn, "__esModule", { value: !0 }), hn.output = hn.exists = hn.hash = hn.bytes = hn.bool = hn.number = void 0;
  function e(f) {
    if (!Number.isSafeInteger(f) || f < 0)
      throw new Error(`Wrong positive integer: ${f}`);
  }
  hn.number = e;
  function t(f) {
    if (typeof f != "boolean")
      throw new Error(`Expected boolean, not ${f}`);
  }
  hn.bool = t;
  function r(f, ...d) {
    if (!(f instanceof Uint8Array))
      throw new Error("Expected Uint8Array");
    if (d.length > 0 && !d.includes(f.length))
      throw new Error(`Expected Uint8Array of length ${d}, not of length=${f.length}`);
  }
  hn.bytes = r;
  function n(f) {
    if (typeof f != "function" || typeof f.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    e(f.outputLen), e(f.blockLen);
  }
  hn.hash = n;
  function s(f, d = !0) {
    if (f.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (d && f.finished)
      throw new Error("Hash#digest() has already been called");
  }
  hn.exists = s;
  function i(f, d) {
    r(f);
    const c = d.outputLen;
    if (f.length < c)
      throw new Error(`digestInto() expects output buffer of length at least ${c}`);
  }
  hn.output = i;
  const a = { number: e, bool: t, bytes: r, hash: n, exists: s, output: i };
  return hn.default = a, hn;
}
var Cb = {}, Dd = {}, Bb;
function kM() {
  return Bb || (Bb = 1, Object.defineProperty(Dd, "__esModule", { value: !0 }), Dd.crypto = void 0, Dd.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0), Dd;
}
var _b;
function Es() {
  return _b || (_b = 1, function(e) {
    /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    Object.defineProperty(e, "__esModule", { value: !0 }), e.randomBytes = e.wrapXOFConstructorWithOpts = e.wrapConstructorWithOpts = e.wrapConstructor = e.checkOpts = e.Hash = e.concatBytes = e.toBytes = e.utf8ToBytes = e.asyncLoop = e.nextTick = e.hexToBytes = e.bytesToHex = e.isLE = e.rotr = e.createView = e.u32 = e.u8 = void 0;
    const t = kM(), r = (L) => L instanceof Uint8Array, n = (L) => new Uint8Array(L.buffer, L.byteOffset, L.byteLength);
    e.u8 = n;
    const s = (L) => new Uint32Array(L.buffer, L.byteOffset, Math.floor(L.byteLength / 4));
    e.u32 = s;
    const i = (L) => new DataView(L.buffer, L.byteOffset, L.byteLength);
    e.createView = i;
    const a = (L, K) => L << 32 - K | L >>> K;
    if (e.rotr = a, e.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, !e.isLE)
      throw new Error("Non little-endian hardware is not supported");
    const f = /* @__PURE__ */ Array.from({ length: 256 }, (L, K) => K.toString(16).padStart(2, "0"));
    function d(L) {
      if (!r(L))
        throw new Error("Uint8Array expected");
      let K = "";
      for (let $ = 0; $ < L.length; $++)
        K += f[L[$]];
      return K;
    }
    e.bytesToHex = d;
    function c(L) {
      if (typeof L != "string")
        throw new Error("hex string expected, got " + typeof L);
      const K = L.length;
      if (K % 2)
        throw new Error("padded hex string expected, got unpadded hex of length " + K);
      const $ = new Uint8Array(K / 2);
      for (let k = 0; k < $.length; k++) {
        const V = k * 2, C = L.slice(V, V + 2), D = Number.parseInt(C, 16);
        if (Number.isNaN(D) || D < 0)
          throw new Error("Invalid byte sequence");
        $[k] = D;
      }
      return $;
    }
    e.hexToBytes = c;
    const p = async () => {
    };
    e.nextTick = p;
    async function g(L, K, $) {
      let k = Date.now();
      for (let V = 0; V < L; V++) {
        $(V);
        const C = Date.now() - k;
        C >= 0 && C < K || (await (0, e.nextTick)(), k += C);
      }
    }
    e.asyncLoop = g;
    function v(L) {
      if (typeof L != "string")
        throw new Error(`utf8ToBytes expected string, got ${typeof L}`);
      return new Uint8Array(new TextEncoder().encode(L));
    }
    e.utf8ToBytes = v;
    function O(L) {
      if (typeof L == "string" && (L = v(L)), !r(L))
        throw new Error(`expected Uint8Array, got ${typeof L}`);
      return L;
    }
    e.toBytes = O;
    function N(...L) {
      const K = new Uint8Array(L.reduce((k, V) => k + V.length, 0));
      let $ = 0;
      return L.forEach((k) => {
        if (!r(k))
          throw new Error("Uint8Array expected");
        K.set(k, $), $ += k.length;
      }), K;
    }
    e.concatBytes = N;
    class S {
      // Safe version that clones internal state
      clone() {
        return this._cloneInto();
      }
    }
    e.Hash = S;
    const j = {}.toString;
    function B(L, K) {
      if (K !== void 0 && j.call(K) !== "[object Object]")
        throw new Error("Options should be object or undefined");
      return Object.assign(L, K);
    }
    e.checkOpts = B;
    function M(L) {
      const K = (k) => L().update(O(k)).digest(), $ = L();
      return K.outputLen = $.outputLen, K.blockLen = $.blockLen, K.create = () => L(), K;
    }
    e.wrapConstructor = M;
    function I(L) {
      const K = (k, V) => L(V).update(O(k)).digest(), $ = L({});
      return K.outputLen = $.outputLen, K.blockLen = $.blockLen, K.create = (k) => L(k), K;
    }
    e.wrapConstructorWithOpts = I;
    function A(L) {
      const K = (k, V) => L(V).update(O(k)).digest(), $ = L({});
      return K.outputLen = $.outputLen, K.blockLen = $.blockLen, K.create = (k) => L(k), K;
    }
    e.wrapXOFConstructorWithOpts = A;
    function R(L = 32) {
      if (t.crypto && typeof t.crypto.getRandomValues == "function")
        return t.crypto.getRandomValues(new Uint8Array(L));
      throw new Error("crypto.getRandomValues must be defined");
    }
    e.randomBytes = R;
  }(Cb)), Cb;
}
var Fb;
function q1() {
  return Fb || (Fb = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hmac = e.HMAC = void 0;
    const t = vd(), r = Es();
    class n extends r.Hash {
      constructor(a, f) {
        super(), this.finished = !1, this.destroyed = !1, (0, t.hash)(a);
        const d = (0, r.toBytes)(f);
        if (this.iHash = a.create(), typeof this.iHash.update != "function")
          throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const c = this.blockLen, p = new Uint8Array(c);
        p.set(d.length > c ? a.create().update(d).digest() : d);
        for (let g = 0; g < p.length; g++)
          p[g] ^= 54;
        this.iHash.update(p), this.oHash = a.create();
        for (let g = 0; g < p.length; g++)
          p[g] ^= 106;
        this.oHash.update(p), p.fill(0);
      }
      update(a) {
        return (0, t.exists)(this), this.iHash.update(a), this;
      }
      digestInto(a) {
        (0, t.exists)(this), (0, t.bytes)(a, this.outputLen), this.finished = !0, this.iHash.digestInto(a), this.oHash.update(a), this.oHash.digestInto(a), this.destroy();
      }
      digest() {
        const a = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(a), a;
      }
      _cloneInto(a) {
        a || (a = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: f, iHash: d, finished: c, destroyed: p, blockLen: g, outputLen: v } = this;
        return a = a, a.finished = c, a.destroyed = p, a.blockLen = g, a.outputLen = v, a.oHash = f._cloneInto(a.oHash), a.iHash = d._cloneInto(a.iHash), a;
      }
      destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
      }
    }
    e.HMAC = n;
    const s = (i, a, f) => new n(i, a).update(f).digest();
    e.hmac = s, e.hmac.create = (i, a) => new n(i, a);
  }(Ib)), Ib;
}
var ya = {}, Ub;
function X8() {
  if (Ub)
    return ya;
  Ub = 1, Object.defineProperty(ya, "__esModule", { value: !0 }), ya.pbkdf2Async = ya.pbkdf2 = void 0;
  const e = vd(), t = q1(), r = Es();
  function n(f, d, c, p) {
    (0, e.hash)(f);
    const g = (0, r.checkOpts)({ dkLen: 32, asyncTick: 10 }, p), { c: v, dkLen: O, asyncTick: N } = g;
    if ((0, e.number)(v), (0, e.number)(O), (0, e.number)(N), v < 1)
      throw new Error("PBKDF2: iterations (c) should be >= 1");
    const S = (0, r.toBytes)(d), j = (0, r.toBytes)(c), B = new Uint8Array(O), M = t.hmac.create(f, S), I = M._cloneInto().update(j);
    return { c: v, dkLen: O, asyncTick: N, DK: B, PRF: M, PRFSalt: I };
  }
  function s(f, d, c, p, g) {
    return f.destroy(), d.destroy(), p && p.destroy(), g.fill(0), c;
  }
  function i(f, d, c, p) {
    const { c: g, dkLen: v, DK: O, PRF: N, PRFSalt: S } = n(f, d, c, p);
    let j;
    const B = new Uint8Array(4), M = (0, r.createView)(B), I = new Uint8Array(N.outputLen);
    for (let A = 1, R = 0; R < v; A++, R += N.outputLen) {
      const L = O.subarray(R, R + N.outputLen);
      M.setInt32(0, A, !1), (j = S._cloneInto(j)).update(B).digestInto(I), L.set(I.subarray(0, L.length));
      for (let K = 1; K < g; K++) {
        N._cloneInto(j).update(I).digestInto(I);
        for (let $ = 0; $ < L.length; $++)
          L[$] ^= I[$];
      }
    }
    return s(N, S, O, j, I);
  }
  ya.pbkdf2 = i;
  async function a(f, d, c, p) {
    const { c: g, dkLen: v, asyncTick: O, DK: N, PRF: S, PRFSalt: j } = n(f, d, c, p);
    let B;
    const M = new Uint8Array(4), I = (0, r.createView)(M), A = new Uint8Array(S.outputLen);
    for (let R = 1, L = 0; L < v; R++, L += S.outputLen) {
      const K = N.subarray(L, L + S.outputLen);
      I.setInt32(0, R, !1), (B = j._cloneInto(B)).update(M).digestInto(A), K.set(A.subarray(0, K.length)), await (0, r.asyncLoop)(g - 1, O, () => {
        S._cloneInto(B).update(A).digestInto(A);
        for (let $ = 0; $ < K.length; $++)
          K[$] ^= A[$];
      });
    }
    return s(S, j, N, B, A);
  }
  return ya.pbkdf2Async = a, ya;
}
var ba = {}, xl = {}, Db;
function $1() {
  if (Db)
    return xl;
  Db = 1, Object.defineProperty(xl, "__esModule", { value: !0 }), xl.SHA2 = void 0;
  const e = vd(), t = Es();
  function r(s, i, a, f) {
    if (typeof s.setBigUint64 == "function")
      return s.setBigUint64(i, a, f);
    const d = BigInt(32), c = BigInt(4294967295), p = Number(a >> d & c), g = Number(a & c), v = f ? 4 : 0, O = f ? 0 : 4;
    s.setUint32(i + v, p, f), s.setUint32(i + O, g, f);
  }
  class n extends t.Hash {
    constructor(i, a, f, d) {
      super(), this.blockLen = i, this.outputLen = a, this.padOffset = f, this.isLE = d, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(i), this.view = (0, t.createView)(this.buffer);
    }
    update(i) {
      (0, e.exists)(this);
      const { view: a, buffer: f, blockLen: d } = this;
      i = (0, t.toBytes)(i);
      const c = i.length;
      for (let p = 0; p < c; ) {
        const g = Math.min(d - this.pos, c - p);
        if (g === d) {
          const v = (0, t.createView)(i);
          for (; d <= c - p; p += d)
            this.process(v, p);
          continue;
        }
        f.set(i.subarray(p, p + g), this.pos), this.pos += g, p += g, this.pos === d && (this.process(a, 0), this.pos = 0);
      }
      return this.length += i.length, this.roundClean(), this;
    }
    digestInto(i) {
      (0, e.exists)(this), (0, e.output)(i, this), this.finished = !0;
      const { buffer: a, view: f, blockLen: d, isLE: c } = this;
      let { pos: p } = this;
      a[p++] = 128, this.buffer.subarray(p).fill(0), this.padOffset > d - p && (this.process(f, 0), p = 0);
      for (let S = p; S < d; S++)
        a[S] = 0;
      r(f, d - 8, BigInt(this.length * 8), c), this.process(f, 0);
      const g = (0, t.createView)(i), v = this.outputLen;
      if (v % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const O = v / 4, N = this.get();
      if (O > N.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let S = 0; S < O; S++)
        g.setUint32(4 * S, N[S], c);
    }
    digest() {
      const { buffer: i, outputLen: a } = this;
      this.digestInto(i);
      const f = i.slice(0, a);
      return this.destroy(), f;
    }
    _cloneInto(i) {
      i || (i = new this.constructor()), i.set(...this.get());
      const { blockLen: a, buffer: f, length: d, finished: c, destroyed: p, pos: g } = this;
      return i.length = d, i.pos = g, i.finished = c, i.destroyed = p, d % a && i.buffer.set(f), i;
    }
  }
  return xl.SHA2 = n, xl;
}
var jb;
function K1() {
  if (jb)
    return ba;
  jb = 1, Object.defineProperty(ba, "__esModule", { value: !0 }), ba.sha224 = ba.sha256 = void 0;
  const e = $1(), t = Es(), r = (c, p, g) => c & p ^ ~c & g, n = (c, p, g) => c & p ^ c & g ^ p & g, s = /* @__PURE__ */ new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), i = /* @__PURE__ */ new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), a = /* @__PURE__ */ new Uint32Array(64);
  class f extends e.SHA2 {
    constructor() {
      super(64, 32, 8, !1), this.A = i[0] | 0, this.B = i[1] | 0, this.C = i[2] | 0, this.D = i[3] | 0, this.E = i[4] | 0, this.F = i[5] | 0, this.G = i[6] | 0, this.H = i[7] | 0;
    }
    get() {
      const { A: p, B: g, C: v, D: O, E: N, F: S, G: j, H: B } = this;
      return [p, g, v, O, N, S, j, B];
    }
    // prettier-ignore
    set(p, g, v, O, N, S, j, B) {
      this.A = p | 0, this.B = g | 0, this.C = v | 0, this.D = O | 0, this.E = N | 0, this.F = S | 0, this.G = j | 0, this.H = B | 0;
    }
    process(p, g) {
      for (let A = 0; A < 16; A++, g += 4)
        a[A] = p.getUint32(g, !1);
      for (let A = 16; A < 64; A++) {
        const R = a[A - 15], L = a[A - 2], K = (0, t.rotr)(R, 7) ^ (0, t.rotr)(R, 18) ^ R >>> 3, $ = (0, t.rotr)(L, 17) ^ (0, t.rotr)(L, 19) ^ L >>> 10;
        a[A] = $ + a[A - 7] + K + a[A - 16] | 0;
      }
      let { A: v, B: O, C: N, D: S, E: j, F: B, G: M, H: I } = this;
      for (let A = 0; A < 64; A++) {
        const R = (0, t.rotr)(j, 6) ^ (0, t.rotr)(j, 11) ^ (0, t.rotr)(j, 25), L = I + R + r(j, B, M) + s[A] + a[A] | 0, K = ((0, t.rotr)(v, 2) ^ (0, t.rotr)(v, 13) ^ (0, t.rotr)(v, 22)) + n(v, O, N) | 0;
        I = M, M = B, B = j, j = S + L | 0, S = N, N = O, O = v, v = L + K | 0;
      }
      v = v + this.A | 0, O = O + this.B | 0, N = N + this.C | 0, S = S + this.D | 0, j = j + this.E | 0, B = B + this.F | 0, M = M + this.G | 0, I = I + this.H | 0, this.set(v, O, N, S, j, B, M, I);
    }
    roundClean() {
      a.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }
  class d extends f {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  }
  return ba.sha256 = (0, t.wrapConstructor)(() => new f()), ba.sha224 = (0, t.wrapConstructor)(() => new d()), ba;
}
var Gn = {}, Wt = {}, Lb;
function e7() {
  if (Lb)
    return Wt;
  Lb = 1, Object.defineProperty(Wt, "__esModule", { value: !0 }), Wt.add5L = Wt.add5H = Wt.add4H = Wt.add4L = Wt.add3H = Wt.add3L = Wt.add = Wt.rotlBL = Wt.rotlBH = Wt.rotlSL = Wt.rotlSH = Wt.rotr32L = Wt.rotr32H = Wt.rotrBL = Wt.rotrBH = Wt.rotrSL = Wt.rotrSH = Wt.shrSL = Wt.shrSH = Wt.toBig = Wt.split = Wt.fromBig = void 0;
  const e = /* @__PURE__ */ BigInt(2 ** 32 - 1), t = /* @__PURE__ */ BigInt(32);
  function r(k, V = !1) {
    return V ? { h: Number(k & e), l: Number(k >> t & e) } : { h: Number(k >> t & e) | 0, l: Number(k & e) | 0 };
  }
  Wt.fromBig = r;
  function n(k, V = !1) {
    let C = new Uint32Array(k.length), D = new Uint32Array(k.length);
    for (let o = 0; o < k.length; o++) {
      const { h: u, l: h } = r(k[o], V);
      [C[o], D[o]] = [u, h];
    }
    return [C, D];
  }
  Wt.split = n;
  const s = (k, V) => BigInt(k >>> 0) << t | BigInt(V >>> 0);
  Wt.toBig = s;
  const i = (k, V, C) => k >>> C;
  Wt.shrSH = i;
  const a = (k, V, C) => k << 32 - C | V >>> C;
  Wt.shrSL = a;
  const f = (k, V, C) => k >>> C | V << 32 - C;
  Wt.rotrSH = f;
  const d = (k, V, C) => k << 32 - C | V >>> C;
  Wt.rotrSL = d;
  const c = (k, V, C) => k << 64 - C | V >>> C - 32;
  Wt.rotrBH = c;
  const p = (k, V, C) => k >>> C - 32 | V << 64 - C;
  Wt.rotrBL = p;
  const g = (k, V) => V;
  Wt.rotr32H = g;
  const v = (k, V) => k;
  Wt.rotr32L = v;
  const O = (k, V, C) => k << C | V >>> 32 - C;
  Wt.rotlSH = O;
  const N = (k, V, C) => V << C | k >>> 32 - C;
  Wt.rotlSL = N;
  const S = (k, V, C) => V << C - 32 | k >>> 64 - C;
  Wt.rotlBH = S;
  const j = (k, V, C) => k << C - 32 | V >>> 64 - C;
  Wt.rotlBL = j;
  function B(k, V, C, D) {
    const o = (V >>> 0) + (D >>> 0);
    return { h: k + C + (o / 2 ** 32 | 0) | 0, l: o | 0 };
  }
  Wt.add = B;
  const M = (k, V, C) => (k >>> 0) + (V >>> 0) + (C >>> 0);
  Wt.add3L = M;
  const I = (k, V, C, D) => V + C + D + (k / 2 ** 32 | 0) | 0;
  Wt.add3H = I;
  const A = (k, V, C, D) => (k >>> 0) + (V >>> 0) + (C >>> 0) + (D >>> 0);
  Wt.add4L = A;
  const R = (k, V, C, D, o) => V + C + D + o + (k / 2 ** 32 | 0) | 0;
  Wt.add4H = R;
  const L = (k, V, C, D, o) => (k >>> 0) + (V >>> 0) + (C >>> 0) + (D >>> 0) + (o >>> 0);
  Wt.add5L = L;
  const K = (k, V, C, D, o, u) => V + C + D + o + u + (k / 2 ** 32 | 0) | 0;
  Wt.add5H = K;
  const $ = {
    fromBig: r,
    split: n,
    toBig: s,
    shrSH: i,
    shrSL: a,
    rotrSH: f,
    rotrSL: d,
    rotrBH: c,
    rotrBL: p,
    rotr32H: g,
    rotr32L: v,
    rotlSH: O,
    rotlSL: N,
    rotlBH: S,
    rotlBL: j,
    add: B,
    add3L: M,
    add3H: I,
    add4L: A,
    add4H: R,
    add5H: K,
    add5L: L
  };
  return Wt.default = $, Wt;
}
var Hb;
function SM() {
  if (Hb)
    return Gn;
  Hb = 1, Object.defineProperty(Gn, "__esModule", { value: !0 }), Gn.sha384 = Gn.sha512_256 = Gn.sha512_224 = Gn.sha512 = Gn.SHA512 = void 0;
  const e = $1(), t = e7(), r = Es(), [n, s] = t.default.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
  ].map((g) => BigInt(g))), i = /* @__PURE__ */ new Uint32Array(80), a = /* @__PURE__ */ new Uint32Array(80);
  class f extends e.SHA2 {
    constructor() {
      super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
      const { Ah: v, Al: O, Bh: N, Bl: S, Ch: j, Cl: B, Dh: M, Dl: I, Eh: A, El: R, Fh: L, Fl: K, Gh: $, Gl: k, Hh: V, Hl: C } = this;
      return [v, O, N, S, j, B, M, I, A, R, L, K, $, k, V, C];
    }
    // prettier-ignore
    set(v, O, N, S, j, B, M, I, A, R, L, K, $, k, V, C) {
      this.Ah = v | 0, this.Al = O | 0, this.Bh = N | 0, this.Bl = S | 0, this.Ch = j | 0, this.Cl = B | 0, this.Dh = M | 0, this.Dl = I | 0, this.Eh = A | 0, this.El = R | 0, this.Fh = L | 0, this.Fl = K | 0, this.Gh = $ | 0, this.Gl = k | 0, this.Hh = V | 0, this.Hl = C | 0;
    }
    process(v, O) {
      for (let u = 0; u < 16; u++, O += 4)
        i[u] = v.getUint32(O), a[u] = v.getUint32(O += 4);
      for (let u = 16; u < 80; u++) {
        const h = i[u - 15] | 0, y = a[u - 15] | 0, E = t.default.rotrSH(h, y, 1) ^ t.default.rotrSH(h, y, 8) ^ t.default.shrSH(h, y, 7), P = t.default.rotrSL(h, y, 1) ^ t.default.rotrSL(h, y, 8) ^ t.default.shrSL(h, y, 7), w = i[u - 2] | 0, m = a[u - 2] | 0, l = t.default.rotrSH(w, m, 19) ^ t.default.rotrBH(w, m, 61) ^ t.default.shrSH(w, m, 6), b = t.default.rotrSL(w, m, 19) ^ t.default.rotrBL(w, m, 61) ^ t.default.shrSL(w, m, 6), W = t.default.add4L(P, b, a[u - 7], a[u - 16]), X = t.default.add4H(W, E, l, i[u - 7], i[u - 16]);
        i[u] = X | 0, a[u] = W | 0;
      }
      let { Ah: N, Al: S, Bh: j, Bl: B, Ch: M, Cl: I, Dh: A, Dl: R, Eh: L, El: K, Fh: $, Fl: k, Gh: V, Gl: C, Hh: D, Hl: o } = this;
      for (let u = 0; u < 80; u++) {
        const h = t.default.rotrSH(L, K, 14) ^ t.default.rotrSH(L, K, 18) ^ t.default.rotrBH(L, K, 41), y = t.default.rotrSL(L, K, 14) ^ t.default.rotrSL(L, K, 18) ^ t.default.rotrBL(L, K, 41), E = L & $ ^ ~L & V, P = K & k ^ ~K & C, w = t.default.add5L(o, y, P, s[u], a[u]), m = t.default.add5H(w, D, h, E, n[u], i[u]), l = w | 0, b = t.default.rotrSH(N, S, 28) ^ t.default.rotrBH(N, S, 34) ^ t.default.rotrBH(N, S, 39), W = t.default.rotrSL(N, S, 28) ^ t.default.rotrBL(N, S, 34) ^ t.default.rotrBL(N, S, 39), X = N & j ^ N & M ^ j & M, G = S & B ^ S & I ^ B & I;
        D = V | 0, o = C | 0, V = $ | 0, C = k | 0, $ = L | 0, k = K | 0, { h: L, l: K } = t.default.add(A | 0, R | 0, m | 0, l | 0), A = M | 0, R = I | 0, M = j | 0, I = B | 0, j = N | 0, B = S | 0;
        const re = t.default.add3L(l, W, G);
        N = t.default.add3H(re, m, b, X), S = re | 0;
      }
      ({ h: N, l: S } = t.default.add(this.Ah | 0, this.Al | 0, N | 0, S | 0)), { h: j, l: B } = t.default.add(this.Bh | 0, this.Bl | 0, j | 0, B | 0), { h: M, l: I } = t.default.add(this.Ch | 0, this.Cl | 0, M | 0, I | 0), { h: A, l: R } = t.default.add(this.Dh | 0, this.Dl | 0, A | 0, R | 0), { h: L, l: K } = t.default.add(this.Eh | 0, this.El | 0, L | 0, K | 0), { h: $, l: k } = t.default.add(this.Fh | 0, this.Fl | 0, $ | 0, k | 0), { h: V, l: C } = t.default.add(this.Gh | 0, this.Gl | 0, V | 0, C | 0), { h: D, l: o } = t.default.add(this.Hh | 0, this.Hl | 0, D | 0, o | 0), this.set(N, S, j, B, M, I, A, R, L, K, $, k, V, C, D, o);
    }
    roundClean() {
      i.fill(0), a.fill(0);
    }
    destroy() {
      this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  Gn.SHA512 = f;
  class d extends f {
    constructor() {
      super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
    }
  }
  class c extends f {
    constructor() {
      super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
    }
  }
  class p extends f {
    constructor() {
      super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
    }
  }
  return Gn.sha512 = (0, r.wrapConstructor)(() => new f()), Gn.sha512_224 = (0, r.wrapConstructor)(() => new d()), Gn.sha512_256 = (0, r.wrapConstructor)(() => new c()), Gn.sha384 = (0, r.wrapConstructor)(() => new p()), Gn;
}
var Wb;
function mf() {
  if (Wb)
    return Ti;
  Wb = 1, Object.defineProperty(Ti, "__esModule", { value: !0 }), Ti.randomBytes = Ti.pbkdf2Sync = Ti.createHmac = Ti.createHash = void 0;
  const e = q1(), t = X8(), r = K1(), n = SM(), s = vt();
  function i() {
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof nr < "u")
      return nr;
    throw new Error("unable to locate global object");
  }
  const a = i(), f = a.crypto || a.msCrypto;
  function d(v) {
    switch (v) {
      case "sha256":
        return r.sha256.create();
      case "sha512":
        return n.sha512.create();
    }
    (0, s.assertArgument)(!1, "invalid hashing algorithm name", "algorithm", v);
  }
  Ti.createHash = d;
  function c(v, O) {
    const N = { sha256: r.sha256, sha512: n.sha512 }[v];
    return (0, s.assertArgument)(N != null, "invalid hmac algorithm", "algorithm", v), e.hmac.create(N, O);
  }
  Ti.createHmac = c;
  function p(v, O, N, S, j) {
    const B = { sha256: r.sha256, sha512: n.sha512 }[j];
    return (0, s.assertArgument)(B != null, "invalid pbkdf2 algorithm", "algorithm", j), (0, t.pbkdf2)(B, v, O, { c: N, dkLen: S });
  }
  Ti.pbkdf2Sync = p;
  function g(v) {
    (0, s.assert)(f != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
      operation: "randomBytes"
    }), (0, s.assertArgument)(Number.isInteger(v) && v > 0 && v <= 1024, "invalid length", "length", v);
    const O = new Uint8Array(v);
    return f.getRandomValues(O), O;
  }
  return Ti.randomBytes = g, Ti;
}
var Gb;
function MM() {
  if (Gb)
    return Nl;
  Gb = 1, Object.defineProperty(Nl, "__esModule", { value: !0 }), Nl.computeHmac = void 0;
  const e = mf(), t = vt();
  let r = !1;
  const n = function(a, f, d) {
    return (0, e.createHmac)(a, f).update(d).digest();
  };
  let s = n;
  function i(a, f, d) {
    const c = (0, t.getBytes)(f, "key"), p = (0, t.getBytes)(d, "data");
    return (0, t.hexlify)(s(a, c, p));
  }
  return Nl.computeHmac = i, i._ = n, i.lock = function() {
    r = !0;
  }, i.register = function(a) {
    if (r)
      throw new Error("computeHmac is locked");
    s = a;
  }, Object.freeze(i), Nl;
}
var Tl = {}, Or = {}, zb;
function IM() {
  if (zb)
    return Or;
  zb = 1, Object.defineProperty(Or, "__esModule", { value: !0 }), Or.shake256 = Or.shake128 = Or.keccak_512 = Or.keccak_384 = Or.keccak_256 = Or.keccak_224 = Or.sha3_512 = Or.sha3_384 = Or.sha3_256 = Or.sha3_224 = Or.Keccak = Or.keccakP = void 0;
  const e = vd(), t = e7(), r = Es(), [n, s, i] = [[], [], []], a = /* @__PURE__ */ BigInt(0), f = /* @__PURE__ */ BigInt(1), d = /* @__PURE__ */ BigInt(2), c = /* @__PURE__ */ BigInt(7), p = /* @__PURE__ */ BigInt(256), g = /* @__PURE__ */ BigInt(113);
  for (let A = 0, R = f, L = 1, K = 0; A < 24; A++) {
    [L, K] = [K, (2 * L + 3 * K) % 5], n.push(2 * (5 * K + L)), s.push((A + 1) * (A + 2) / 2 % 64);
    let $ = a;
    for (let k = 0; k < 7; k++)
      R = (R << f ^ (R >> c) * g) % p, R & d && ($ ^= f << (f << /* @__PURE__ */ BigInt(k)) - f);
    i.push($);
  }
  const [v, O] = /* @__PURE__ */ (0, t.split)(i, !0), N = (A, R, L) => L > 32 ? (0, t.rotlBH)(A, R, L) : (0, t.rotlSH)(A, R, L), S = (A, R, L) => L > 32 ? (0, t.rotlBL)(A, R, L) : (0, t.rotlSL)(A, R, L);
  function j(A, R = 24) {
    const L = new Uint32Array(10);
    for (let K = 24 - R; K < 24; K++) {
      for (let V = 0; V < 10; V++)
        L[V] = A[V] ^ A[V + 10] ^ A[V + 20] ^ A[V + 30] ^ A[V + 40];
      for (let V = 0; V < 10; V += 2) {
        const C = (V + 8) % 10, D = (V + 2) % 10, o = L[D], u = L[D + 1], h = N(o, u, 1) ^ L[C], y = S(o, u, 1) ^ L[C + 1];
        for (let E = 0; E < 50; E += 10)
          A[V + E] ^= h, A[V + E + 1] ^= y;
      }
      let $ = A[2], k = A[3];
      for (let V = 0; V < 24; V++) {
        const C = s[V], D = N($, k, C), o = S($, k, C), u = n[V];
        $ = A[u], k = A[u + 1], A[u] = D, A[u + 1] = o;
      }
      for (let V = 0; V < 50; V += 10) {
        for (let C = 0; C < 10; C++)
          L[C] = A[V + C];
        for (let C = 0; C < 10; C++)
          A[V + C] ^= ~L[(C + 2) % 10] & L[(C + 4) % 10];
      }
      A[0] ^= v[K], A[1] ^= O[K];
    }
    L.fill(0);
  }
  Or.keccakP = j;
  class B extends r.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(R, L, K, $ = !1, k = 24) {
      if (super(), this.blockLen = R, this.suffix = L, this.outputLen = K, this.enableXOF = $, this.rounds = k, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, e.number)(K), 0 >= this.blockLen || this.blockLen >= 200)
        throw new Error("Sha3 supports only keccak-f1600 function");
      this.state = new Uint8Array(200), this.state32 = (0, r.u32)(this.state);
    }
    keccak() {
      j(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
    }
    update(R) {
      (0, e.exists)(this);
      const { blockLen: L, state: K } = this;
      R = (0, r.toBytes)(R);
      const $ = R.length;
      for (let k = 0; k < $; ) {
        const V = Math.min(L - this.pos, $ - k);
        for (let C = 0; C < V; C++)
          K[this.pos++] ^= R[k++];
        this.pos === L && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = !0;
      const { state: R, suffix: L, pos: K, blockLen: $ } = this;
      R[K] ^= L, L & 128 && K === $ - 1 && this.keccak(), R[$ - 1] ^= 128, this.keccak();
    }
    writeInto(R) {
      (0, e.exists)(this, !1), (0, e.bytes)(R), this.finish();
      const L = this.state, { blockLen: K } = this;
      for (let $ = 0, k = R.length; $ < k; ) {
        this.posOut >= K && this.keccak();
        const V = Math.min(K - this.posOut, k - $);
        R.set(L.subarray(this.posOut, this.posOut + V), $), this.posOut += V, $ += V;
      }
      return R;
    }
    xofInto(R) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(R);
    }
    xof(R) {
      return (0, e.number)(R), this.xofInto(new Uint8Array(R));
    }
    digestInto(R) {
      if ((0, e.output)(R, this), this.finished)
        throw new Error("digest() was already called");
      return this.writeInto(R), this.destroy(), R;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(R) {
      const { blockLen: L, suffix: K, outputLen: $, rounds: k, enableXOF: V } = this;
      return R || (R = new B(L, K, $, V, k)), R.state32.set(this.state32), R.pos = this.pos, R.posOut = this.posOut, R.finished = this.finished, R.rounds = k, R.suffix = K, R.outputLen = $, R.enableXOF = V, R.destroyed = this.destroyed, R;
    }
  }
  Or.Keccak = B;
  const M = (A, R, L) => (0, r.wrapConstructor)(() => new B(R, A, L));
  Or.sha3_224 = M(6, 144, 224 / 8), Or.sha3_256 = M(6, 136, 256 / 8), Or.sha3_384 = M(6, 104, 384 / 8), Or.sha3_512 = M(6, 72, 512 / 8), Or.keccak_224 = M(1, 144, 224 / 8), Or.keccak_256 = M(1, 136, 256 / 8), Or.keccak_384 = M(1, 104, 384 / 8), Or.keccak_512 = M(1, 72, 512 / 8);
  const I = (A, R, L) => (0, r.wrapXOFConstructorWithOpts)((K = {}) => new B(R, A, K.dkLen === void 0 ? L : K.dkLen, !0));
  return Or.shake128 = I(31, 168, 128 / 8), Or.shake256 = I(31, 136, 256 / 8), Or;
}
var Vb;
function RM() {
  if (Vb)
    return Tl;
  Vb = 1, Object.defineProperty(Tl, "__esModule", { value: !0 }), Tl.keccak256 = void 0;
  const e = IM(), t = vt();
  let r = !1;
  const n = function(a) {
    return (0, e.keccak_256)(a);
  };
  let s = n;
  function i(a) {
    const f = (0, t.getBytes)(a, "data");
    return (0, t.hexlify)(s(f));
  }
  return Tl.keccak256 = i, i._ = n, i.lock = function() {
    r = !0;
  }, i.register = function(a) {
    if (r)
      throw new TypeError("keccak256 is locked");
    s = a;
  }, Object.freeze(i), Tl;
}
var kl = {}, wa = {}, qb;
function CM() {
  if (qb)
    return wa;
  qb = 1, Object.defineProperty(wa, "__esModule", { value: !0 }), wa.ripemd160 = wa.RIPEMD160 = void 0;
  const e = $1(), t = Es(), r = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), n = /* @__PURE__ */ Uint8Array.from({ length: 16 }, (j, B) => B), s = /* @__PURE__ */ n.map((j) => (9 * j + 5) % 16);
  let i = [n], a = [s];
  for (let j = 0; j < 4; j++)
    for (let B of [i, a])
      B.push(B[j].map((M) => r[M]));
  const f = /* @__PURE__ */ [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
  ].map((j) => new Uint8Array(j)), d = /* @__PURE__ */ i.map((j, B) => j.map((M) => f[B][M])), c = /* @__PURE__ */ a.map((j, B) => j.map((M) => f[B][M])), p = /* @__PURE__ */ new Uint32Array([
    0,
    1518500249,
    1859775393,
    2400959708,
    2840853838
  ]), g = /* @__PURE__ */ new Uint32Array([
    1352829926,
    1548603684,
    1836072691,
    2053994217,
    0
  ]), v = (j, B) => j << B | j >>> 32 - B;
  function O(j, B, M, I) {
    return j === 0 ? B ^ M ^ I : j === 1 ? B & M | ~B & I : j === 2 ? (B | ~M) ^ I : j === 3 ? B & I | M & ~I : B ^ (M | ~I);
  }
  const N = /* @__PURE__ */ new Uint32Array(16);
  class S extends e.SHA2 {
    constructor() {
      super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
    }
    get() {
      const { h0: B, h1: M, h2: I, h3: A, h4: R } = this;
      return [B, M, I, A, R];
    }
    set(B, M, I, A, R) {
      this.h0 = B | 0, this.h1 = M | 0, this.h2 = I | 0, this.h3 = A | 0, this.h4 = R | 0;
    }
    process(B, M) {
      for (let o = 0; o < 16; o++, M += 4)
        N[o] = B.getUint32(M, !0);
      let I = this.h0 | 0, A = I, R = this.h1 | 0, L = R, K = this.h2 | 0, $ = K, k = this.h3 | 0, V = k, C = this.h4 | 0, D = C;
      for (let o = 0; o < 5; o++) {
        const u = 4 - o, h = p[o], y = g[o], E = i[o], P = a[o], w = d[o], m = c[o];
        for (let l = 0; l < 16; l++) {
          const b = v(I + O(o, R, K, k) + N[E[l]] + h, w[l]) + C | 0;
          I = C, C = k, k = v(K, 10) | 0, K = R, R = b;
        }
        for (let l = 0; l < 16; l++) {
          const b = v(A + O(u, L, $, V) + N[P[l]] + y, m[l]) + D | 0;
          A = D, D = V, V = v($, 10) | 0, $ = L, L = b;
        }
      }
      this.set(this.h1 + K + V | 0, this.h2 + k + D | 0, this.h3 + C + A | 0, this.h4 + I + L | 0, this.h0 + R + $ | 0);
    }
    roundClean() {
      N.fill(0);
    }
    destroy() {
      this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
    }
  }
  return wa.RIPEMD160 = S, wa.ripemd160 = (0, t.wrapConstructor)(() => new S()), wa;
}
var $b;
function BM() {
  if ($b)
    return kl;
  $b = 1, Object.defineProperty(kl, "__esModule", { value: !0 }), kl.ripemd160 = void 0;
  const e = CM(), t = vt();
  let r = !1;
  const n = function(a) {
    return (0, e.ripemd160)(a);
  };
  let s = n;
  function i(a) {
    const f = (0, t.getBytes)(a, "data");
    return (0, t.hexlify)(s(f));
  }
  return kl.ripemd160 = i, i._ = n, i.lock = function() {
    r = !0;
  }, i.register = function(a) {
    if (r)
      throw new TypeError("ripemd160 is locked");
    s = a;
  }, Object.freeze(i), kl;
}
var Sl = {}, Kb;
function _M() {
  if (Kb)
    return Sl;
  Kb = 1, Object.defineProperty(Sl, "__esModule", { value: !0 }), Sl.pbkdf2 = void 0;
  const e = mf(), t = vt();
  let r = !1;
  const n = function(a, f, d, c, p) {
    return (0, e.pbkdf2Sync)(a, f, d, c, p);
  };
  let s = n;
  function i(a, f, d, c, p) {
    const g = (0, t.getBytes)(a, "password"), v = (0, t.getBytes)(f, "salt");
    return (0, t.hexlify)(s(g, v, d, c, p));
  }
  return Sl.pbkdf2 = i, i._ = n, i.lock = function() {
    r = !0;
  }, i.register = function(a) {
    if (r)
      throw new Error("pbkdf2 is locked");
    s = a;
  }, Object.freeze(i), Sl;
}
var Ml = {}, Jb;
function FM() {
  if (Jb)
    return Ml;
  Jb = 1, Object.defineProperty(Ml, "__esModule", { value: !0 }), Ml.randomBytes = void 0;
  const e = mf();
  let t = !1;
  const r = function(i) {
    return new Uint8Array((0, e.randomBytes)(i));
  };
  let n = r;
  function s(i) {
    return n(i);
  }
  return Ml.randomBytes = s, s._ = r, s.lock = function() {
    t = !0;
  }, s.register = function(i) {
    if (t)
      throw new Error("randomBytes is locked");
    n = i;
  }, Object.freeze(s), Ml;
}
var va = {}, Aa = {}, Qb;
function UM() {
  if (Qb)
    return Aa;
  Qb = 1, Object.defineProperty(Aa, "__esModule", { value: !0 }), Aa.scryptAsync = Aa.scrypt = void 0;
  const e = vd(), t = K1(), r = X8(), n = Es(), s = (g, v) => g << v | g >>> 32 - v;
  function i(g, v, O, N, S, j) {
    let B = g[v++] ^ O[N++], M = g[v++] ^ O[N++], I = g[v++] ^ O[N++], A = g[v++] ^ O[N++], R = g[v++] ^ O[N++], L = g[v++] ^ O[N++], K = g[v++] ^ O[N++], $ = g[v++] ^ O[N++], k = g[v++] ^ O[N++], V = g[v++] ^ O[N++], C = g[v++] ^ O[N++], D = g[v++] ^ O[N++], o = g[v++] ^ O[N++], u = g[v++] ^ O[N++], h = g[v++] ^ O[N++], y = g[v++] ^ O[N++], E = B, P = M, w = I, m = A, l = R, b = L, W = K, X = $, G = k, re = V, ce = C, pe = D, ve = o, Ee = u, Pe = h, xe = y;
    for (let me = 0; me < 8; me += 2)
      l ^= s(E + ve | 0, 7), G ^= s(l + E | 0, 9), ve ^= s(G + l | 0, 13), E ^= s(ve + G | 0, 18), re ^= s(b + P | 0, 7), Ee ^= s(re + b | 0, 9), P ^= s(Ee + re | 0, 13), b ^= s(P + Ee | 0, 18), Pe ^= s(ce + W | 0, 7), w ^= s(Pe + ce | 0, 9), W ^= s(w + Pe | 0, 13), ce ^= s(W + w | 0, 18), m ^= s(xe + pe | 0, 7), X ^= s(m + xe | 0, 9), pe ^= s(X + m | 0, 13), xe ^= s(pe + X | 0, 18), P ^= s(E + m | 0, 7), w ^= s(P + E | 0, 9), m ^= s(w + P | 0, 13), E ^= s(m + w | 0, 18), W ^= s(b + l | 0, 7), X ^= s(W + b | 0, 9), l ^= s(X + W | 0, 13), b ^= s(l + X | 0, 18), pe ^= s(ce + re | 0, 7), G ^= s(pe + ce | 0, 9), re ^= s(G + pe | 0, 13), ce ^= s(re + G | 0, 18), ve ^= s(xe + Pe | 0, 7), Ee ^= s(ve + xe | 0, 9), Pe ^= s(Ee + ve | 0, 13), xe ^= s(Pe + Ee | 0, 18);
    S[j++] = B + E | 0, S[j++] = M + P | 0, S[j++] = I + w | 0, S[j++] = A + m | 0, S[j++] = R + l | 0, S[j++] = L + b | 0, S[j++] = K + W | 0, S[j++] = $ + X | 0, S[j++] = k + G | 0, S[j++] = V + re | 0, S[j++] = C + ce | 0, S[j++] = D + pe | 0, S[j++] = o + ve | 0, S[j++] = u + Ee | 0, S[j++] = h + Pe | 0, S[j++] = y + xe | 0;
  }
  function a(g, v, O, N, S) {
    let j = N + 0, B = N + 16 * S;
    for (let M = 0; M < 16; M++)
      O[B + M] = g[v + (2 * S - 1) * 16 + M];
    for (let M = 0; M < S; M++, j += 16, v += 16)
      i(O, B, g, v, O, j), M > 0 && (B += 16), i(O, j, g, v += 16, O, B);
  }
  function f(g, v, O) {
    const N = (0, n.checkOpts)({
      dkLen: 32,
      asyncTick: 10,
      maxmem: 1073742848
    }, O), { N: S, r: j, p: B, dkLen: M, asyncTick: I, maxmem: A, onProgress: R } = N;
    if ((0, e.number)(S), (0, e.number)(j), (0, e.number)(B), (0, e.number)(M), (0, e.number)(I), (0, e.number)(A), R !== void 0 && typeof R != "function")
      throw new Error("progressCb should be function");
    const L = 128 * j, K = L / 4;
    if (S <= 1 || S & S - 1 || S >= 2 ** (L / 8) || S > 2 ** 32)
      throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (B < 0 || B > (2 ** 32 - 1) * 32 / L)
      throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (M < 0 || M > (2 ** 32 - 1) * 32)
      throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const $ = L * (S + B);
    if ($ > A)
      throw new Error(`Scrypt: parameters too large, ${$} (128 * r * (N + p)) > ${A} (maxmem)`);
    const k = (0, r.pbkdf2)(t.sha256, g, v, { c: 1, dkLen: L * B }), V = (0, n.u32)(k), C = (0, n.u32)(new Uint8Array(L * S)), D = (0, n.u32)(new Uint8Array(L));
    let o = () => {
    };
    if (R) {
      const u = 2 * S * B, h = Math.max(Math.floor(u / 1e4), 1);
      let y = 0;
      o = () => {
        y++, R && (!(y % h) || y === u) && R(y / u);
      };
    }
    return { N: S, r: j, p: B, dkLen: M, blockSize32: K, V: C, B32: V, B: k, tmp: D, blockMixCb: o, asyncTick: I };
  }
  function d(g, v, O, N, S) {
    const j = (0, r.pbkdf2)(t.sha256, g, O, { c: 1, dkLen: v });
    return O.fill(0), N.fill(0), S.fill(0), j;
  }
  function c(g, v, O) {
    const { N, r: S, p: j, dkLen: B, blockSize32: M, V: I, B32: A, B: R, tmp: L, blockMixCb: K } = f(g, v, O);
    for (let $ = 0; $ < j; $++) {
      const k = M * $;
      for (let V = 0; V < M; V++)
        I[V] = A[k + V];
      for (let V = 0, C = 0; V < N - 1; V++)
        a(I, C, I, C += M, S), K();
      a(I, (N - 1) * M, A, k, S), K();
      for (let V = 0; V < N; V++) {
        const C = A[k + M - 16] % N;
        for (let D = 0; D < M; D++)
          L[D] = A[k + D] ^ I[C * M + D];
        a(L, 0, A, k, S), K();
      }
    }
    return d(g, B, R, I, L);
  }
  Aa.scrypt = c;
  async function p(g, v, O) {
    const { N, r: S, p: j, dkLen: B, blockSize32: M, V: I, B32: A, B: R, tmp: L, blockMixCb: K, asyncTick: $ } = f(g, v, O);
    for (let k = 0; k < j; k++) {
      const V = M * k;
      for (let D = 0; D < M; D++)
        I[D] = A[V + D];
      let C = 0;
      await (0, n.asyncLoop)(N - 1, $, () => {
        a(I, C, I, C += M, S), K();
      }), a(I, (N - 1) * M, A, V, S), K(), await (0, n.asyncLoop)(N, $, () => {
        const D = A[V + M - 16] % N;
        for (let o = 0; o < M; o++)
          L[o] = A[V + o] ^ I[D * M + o];
        a(L, 0, A, V, S), K();
      });
    }
    return d(g, B, R, I, L);
  }
  return Aa.scryptAsync = p, Aa;
}
var Zb;
function DM() {
  if (Zb)
    return va;
  Zb = 1, Object.defineProperty(va, "__esModule", { value: !0 }), va.scryptSync = va.scrypt = void 0;
  const e = UM(), t = vt();
  let r = !1, n = !1;
  const s = async function(p, g, v, O, N, S, j) {
    return await (0, e.scryptAsync)(p, g, { N: v, r: O, p: N, dkLen: S, onProgress: j });
  }, i = function(p, g, v, O, N, S) {
    return (0, e.scrypt)(p, g, { N: v, r: O, p: N, dkLen: S });
  };
  let a = s, f = i;
  async function d(p, g, v, O, N, S, j) {
    const B = (0, t.getBytes)(p, "passwd"), M = (0, t.getBytes)(g, "salt");
    return (0, t.hexlify)(await a(B, M, v, O, N, S, j));
  }
  va.scrypt = d, d._ = s, d.lock = function() {
    n = !0;
  }, d.register = function(p) {
    if (n)
      throw new Error("scrypt is locked");
    a = p;
  }, Object.freeze(d);
  function c(p, g, v, O, N, S) {
    const j = (0, t.getBytes)(p, "passwd"), B = (0, t.getBytes)(g, "salt");
    return (0, t.hexlify)(f(j, B, v, O, N, S));
  }
  return va.scryptSync = c, c._ = i, c.lock = function() {
    r = !0;
  }, c.register = function(p) {
    if (r)
      throw new Error("scryptSync is locked");
    f = p;
  }, Object.freeze(c), va;
}
var Ea = {}, Yb;
function jM() {
  if (Yb)
    return Ea;
  Yb = 1, Object.defineProperty(Ea, "__esModule", { value: !0 }), Ea.sha512 = Ea.sha256 = void 0;
  const e = mf(), t = vt(), r = function(p) {
    return (0, e.createHash)("sha256").update(p).digest();
  }, n = function(p) {
    return (0, e.createHash)("sha512").update(p).digest();
  };
  let s = r, i = n, a = !1, f = !1;
  function d(p) {
    const g = (0, t.getBytes)(p, "data");
    return (0, t.hexlify)(s(g));
  }
  Ea.sha256 = d, d._ = r, d.lock = function() {
    a = !0;
  }, d.register = function(p) {
    if (a)
      throw new Error("sha256 is locked");
    s = p;
  }, Object.freeze(d);
  function c(p) {
    const g = (0, t.getBytes)(p, "data");
    return (0, t.hexlify)(i(g));
  }
  return Ea.sha512 = c, c._ = n, c.lock = function() {
    f = !0;
  }, c.register = function(p) {
    if (f)
      throw new Error("sha512 is locked");
    i = p;
  }, Object.freeze(d), Ea;
}
var Il = {}, Xb = {}, Zt = {}, rr = {}, e6;
function ic() {
  if (e6)
    return rr;
  e6 = 1, Object.defineProperty(rr, "__esModule", { value: !0 }), rr.validateObject = rr.createHmacDrbg = rr.bitMask = rr.bitSet = rr.bitGet = rr.bitLen = rr.utf8ToBytes = rr.equalBytes = rr.concatBytes = rr.ensureBytes = rr.numberToVarBytesBE = rr.numberToBytesLE = rr.numberToBytesBE = rr.bytesToNumberLE = rr.bytesToNumberBE = rr.hexToBytes = rr.hexToNumber = rr.numberToHexUnpadded = rr.bytesToHex = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const e = BigInt(0), t = BigInt(1), r = BigInt(2), n = (C) => C instanceof Uint8Array, s = /* @__PURE__ */ Array.from({ length: 256 }, (C, D) => D.toString(16).padStart(2, "0"));
  function i(C) {
    if (!n(C))
      throw new Error("Uint8Array expected");
    let D = "";
    for (let o = 0; o < C.length; o++)
      D += s[C[o]];
    return D;
  }
  rr.bytesToHex = i;
  function a(C) {
    const D = C.toString(16);
    return D.length & 1 ? `0${D}` : D;
  }
  rr.numberToHexUnpadded = a;
  function f(C) {
    if (typeof C != "string")
      throw new Error("hex string expected, got " + typeof C);
    return BigInt(C === "" ? "0" : `0x${C}`);
  }
  rr.hexToNumber = f;
  function d(C) {
    if (typeof C != "string")
      throw new Error("hex string expected, got " + typeof C);
    const D = C.length;
    if (D % 2)
      throw new Error("padded hex string expected, got unpadded hex of length " + D);
    const o = new Uint8Array(D / 2);
    for (let u = 0; u < o.length; u++) {
      const h = u * 2, y = C.slice(h, h + 2), E = Number.parseInt(y, 16);
      if (Number.isNaN(E) || E < 0)
        throw new Error("Invalid byte sequence");
      o[u] = E;
    }
    return o;
  }
  rr.hexToBytes = d;
  function c(C) {
    return f(i(C));
  }
  rr.bytesToNumberBE = c;
  function p(C) {
    if (!n(C))
      throw new Error("Uint8Array expected");
    return f(i(Uint8Array.from(C).reverse()));
  }
  rr.bytesToNumberLE = p;
  function g(C, D) {
    return d(C.toString(16).padStart(D * 2, "0"));
  }
  rr.numberToBytesBE = g;
  function v(C, D) {
    return g(C, D).reverse();
  }
  rr.numberToBytesLE = v;
  function O(C) {
    return d(a(C));
  }
  rr.numberToVarBytesBE = O;
  function N(C, D, o) {
    let u;
    if (typeof D == "string")
      try {
        u = d(D);
      } catch (y) {
        throw new Error(`${C} must be valid hex string, got "${D}". Cause: ${y}`);
      }
    else if (n(D))
      u = Uint8Array.from(D);
    else
      throw new Error(`${C} must be hex string or Uint8Array`);
    const h = u.length;
    if (typeof o == "number" && h !== o)
      throw new Error(`${C} expected ${o} bytes, got ${h}`);
    return u;
  }
  rr.ensureBytes = N;
  function S(...C) {
    const D = new Uint8Array(C.reduce((u, h) => u + h.length, 0));
    let o = 0;
    return C.forEach((u) => {
      if (!n(u))
        throw new Error("Uint8Array expected");
      D.set(u, o), o += u.length;
    }), D;
  }
  rr.concatBytes = S;
  function j(C, D) {
    if (C.length !== D.length)
      return !1;
    for (let o = 0; o < C.length; o++)
      if (C[o] !== D[o])
        return !1;
    return !0;
  }
  rr.equalBytes = j;
  function B(C) {
    if (typeof C != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof C}`);
    return new Uint8Array(new TextEncoder().encode(C));
  }
  rr.utf8ToBytes = B;
  function M(C) {
    let D;
    for (D = 0; C > e; C >>= t, D += 1)
      ;
    return D;
  }
  rr.bitLen = M;
  function I(C, D) {
    return C >> BigInt(D) & t;
  }
  rr.bitGet = I;
  const A = (C, D, o) => C | (o ? t : e) << BigInt(D);
  rr.bitSet = A;
  const R = (C) => (r << BigInt(C - 1)) - t;
  rr.bitMask = R;
  const L = (C) => new Uint8Array(C), K = (C) => Uint8Array.from(C);
  function $(C, D, o) {
    if (typeof C != "number" || C < 2)
      throw new Error("hashLen must be a number");
    if (typeof D != "number" || D < 2)
      throw new Error("qByteLen must be a number");
    if (typeof o != "function")
      throw new Error("hmacFn must be a function");
    let u = L(C), h = L(C), y = 0;
    const E = () => {
      u.fill(1), h.fill(0), y = 0;
    }, P = (...l) => o(h, u, ...l), w = (l = L()) => {
      h = P(K([0]), l), u = P(), l.length !== 0 && (h = P(K([1]), l), u = P());
    }, m = () => {
      if (y++ >= 1e3)
        throw new Error("drbg: tried 1000 values");
      let l = 0;
      const b = [];
      for (; l < D; ) {
        u = P();
        const W = u.slice();
        b.push(W), l += u.length;
      }
      return S(...b);
    };
    return (l, b) => {
      E(), w(l);
      let W;
      for (; !(W = b(m())); )
        w();
      return E(), W;
    };
  }
  rr.createHmacDrbg = $;
  const k = {
    bigint: (C) => typeof C == "bigint",
    function: (C) => typeof C == "function",
    boolean: (C) => typeof C == "boolean",
    string: (C) => typeof C == "string",
    stringOrUint8Array: (C) => typeof C == "string" || C instanceof Uint8Array,
    isSafeInteger: (C) => Number.isSafeInteger(C),
    array: (C) => Array.isArray(C),
    field: (C, D) => D.Fp.isValid(C),
    hash: (C) => typeof C == "function" && Number.isSafeInteger(C.outputLen)
  };
  function V(C, D, o = {}) {
    const u = (h, y, E) => {
      const P = k[y];
      if (typeof P != "function")
        throw new Error(`Invalid validator "${y}", expected function`);
      const w = C[h];
      if (!(E && w === void 0) && !P(w, C))
        throw new Error(`Invalid param ${String(h)}=${w} (${typeof w}), expected ${y}`);
    };
    for (const [h, y] of Object.entries(D))
      u(h, y, !1);
    for (const [h, y] of Object.entries(o))
      u(h, y, !0);
    return C;
  }
  return rr.validateObject = V, rr;
}
var t6;
function yf() {
  if (t6)
    return Zt;
  t6 = 1, Object.defineProperty(Zt, "__esModule", { value: !0 }), Zt.mapHashToField = Zt.getMinHashLength = Zt.getFieldBytesLength = Zt.hashToPrivateScalar = Zt.FpSqrtEven = Zt.FpSqrtOdd = Zt.Field = Zt.nLength = Zt.FpIsSquare = Zt.FpDiv = Zt.FpInvertBatch = Zt.FpPow = Zt.validateField = Zt.isNegativeLE = Zt.FpSqrt = Zt.tonelliShanks = Zt.invert = Zt.pow2 = Zt.pow = Zt.mod = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const e = ic(), t = BigInt(0), r = BigInt(1), n = BigInt(2), s = BigInt(3), i = BigInt(4), a = BigInt(5), f = BigInt(8);
  BigInt(9), BigInt(16);
  function d(o, u) {
    const h = o % u;
    return h >= t ? h : u + h;
  }
  Zt.mod = d;
  function c(o, u, h) {
    if (h <= t || u < t)
      throw new Error("Expected power/modulo > 0");
    if (h === r)
      return t;
    let y = r;
    for (; u > t; )
      u & r && (y = y * o % h), o = o * o % h, u >>= r;
    return y;
  }
  Zt.pow = c;
  function p(o, u, h) {
    let y = o;
    for (; u-- > t; )
      y *= y, y %= h;
    return y;
  }
  Zt.pow2 = p;
  function g(o, u) {
    if (o === t || u <= t)
      throw new Error(`invert: expected positive integers, got n=${o} mod=${u}`);
    let h = d(o, u), y = u, E = t, P = r;
    for (; h !== t; ) {
      const w = y / h, m = y % h, l = E - P * w;
      y = h, h = m, E = P, P = l;
    }
    if (y !== r)
      throw new Error("invert: does not exist");
    return d(E, u);
  }
  Zt.invert = g;
  function v(o) {
    const u = (o - r) / n;
    let h, y, E;
    for (h = o - r, y = 0; h % n === t; h /= n, y++)
      ;
    for (E = n; E < o && c(E, u, o) !== o - r; E++)
      ;
    if (y === 1) {
      const w = (o + r) / i;
      return function(m, l) {
        const b = m.pow(l, w);
        if (!m.eql(m.sqr(b), l))
          throw new Error("Cannot find square root");
        return b;
      };
    }
    const P = (h + r) / n;
    return function(w, m) {
      if (w.pow(m, u) === w.neg(w.ONE))
        throw new Error("Cannot find square root");
      let l = y, b = w.pow(w.mul(w.ONE, E), h), W = w.pow(m, P), X = w.pow(m, h);
      for (; !w.eql(X, w.ONE); ) {
        if (w.eql(X, w.ZERO))
          return w.ZERO;
        let G = 1;
        for (let ce = w.sqr(X); G < l && !w.eql(ce, w.ONE); G++)
          ce = w.sqr(ce);
        const re = w.pow(b, r << BigInt(l - G - 1));
        b = w.sqr(re), W = w.mul(W, re), X = w.mul(X, b), l = G;
      }
      return W;
    };
  }
  Zt.tonelliShanks = v;
  function O(o) {
    if (o % i === s) {
      const u = (o + r) / i;
      return function(h, y) {
        const E = h.pow(y, u);
        if (!h.eql(h.sqr(E), y))
          throw new Error("Cannot find square root");
        return E;
      };
    }
    if (o % f === a) {
      const u = (o - a) / f;
      return function(h, y) {
        const E = h.mul(y, n), P = h.pow(E, u), w = h.mul(y, P), m = h.mul(h.mul(w, n), P), l = h.mul(w, h.sub(m, h.ONE));
        if (!h.eql(h.sqr(l), y))
          throw new Error("Cannot find square root");
        return l;
      };
    }
    return v(o);
  }
  Zt.FpSqrt = O;
  const N = (o, u) => (d(o, u) & r) === r;
  Zt.isNegativeLE = N;
  const S = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function j(o) {
    const u = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "isSafeInteger",
      BITS: "isSafeInteger"
    }, h = S.reduce((y, E) => (y[E] = "function", y), u);
    return (0, e.validateObject)(o, h);
  }
  Zt.validateField = j;
  function B(o, u, h) {
    if (h < t)
      throw new Error("Expected power > 0");
    if (h === t)
      return o.ONE;
    if (h === r)
      return u;
    let y = o.ONE, E = u;
    for (; h > t; )
      h & r && (y = o.mul(y, E)), E = o.sqr(E), h >>= r;
    return y;
  }
  Zt.FpPow = B;
  function M(o, u) {
    const h = new Array(u.length), y = u.reduce((P, w, m) => o.is0(w) ? P : (h[m] = P, o.mul(P, w)), o.ONE), E = o.inv(y);
    return u.reduceRight((P, w, m) => o.is0(w) ? P : (h[m] = o.mul(P, h[m]), o.mul(P, w)), E), h;
  }
  Zt.FpInvertBatch = M;
  function I(o, u, h) {
    return o.mul(u, typeof h == "bigint" ? g(h, o.ORDER) : o.inv(h));
  }
  Zt.FpDiv = I;
  function A(o) {
    const u = (o.ORDER - r) / n;
    return (h) => {
      const y = o.pow(h, u);
      return o.eql(y, o.ZERO) || o.eql(y, o.ONE);
    };
  }
  Zt.FpIsSquare = A;
  function R(o, u) {
    const h = u !== void 0 ? u : o.toString(2).length, y = Math.ceil(h / 8);
    return { nBitLength: h, nByteLength: y };
  }
  Zt.nLength = R;
  function L(o, u, h = !1, y = {}) {
    if (o <= t)
      throw new Error(`Expected Field ORDER > 0, got ${o}`);
    const { nBitLength: E, nByteLength: P } = R(o, u);
    if (P > 2048)
      throw new Error("Field lengths over 2048 bytes are not supported");
    const w = O(o), m = Object.freeze({
      ORDER: o,
      BITS: E,
      BYTES: P,
      MASK: (0, e.bitMask)(E),
      ZERO: t,
      ONE: r,
      create: (l) => d(l, o),
      isValid: (l) => {
        if (typeof l != "bigint")
          throw new Error(`Invalid field element: expected bigint, got ${typeof l}`);
        return t <= l && l < o;
      },
      is0: (l) => l === t,
      isOdd: (l) => (l & r) === r,
      neg: (l) => d(-l, o),
      eql: (l, b) => l === b,
      sqr: (l) => d(l * l, o),
      add: (l, b) => d(l + b, o),
      sub: (l, b) => d(l - b, o),
      mul: (l, b) => d(l * b, o),
      pow: (l, b) => B(m, l, b),
      div: (l, b) => d(l * g(b, o), o),
      // Same as above, but doesn't normalize
      sqrN: (l) => l * l,
      addN: (l, b) => l + b,
      subN: (l, b) => l - b,
      mulN: (l, b) => l * b,
      inv: (l) => g(l, o),
      sqrt: y.sqrt || ((l) => w(m, l)),
      invertBatch: (l) => M(m, l),
      // TODO: do we really need constant cmov?
      // We don't have const-time bigints anyway, so probably will be not very useful
      cmov: (l, b, W) => W ? b : l,
      toBytes: (l) => h ? (0, e.numberToBytesLE)(l, P) : (0, e.numberToBytesBE)(l, P),
      fromBytes: (l) => {
        if (l.length !== P)
          throw new Error(`Fp.fromBytes: expected ${P}, got ${l.length}`);
        return h ? (0, e.bytesToNumberLE)(l) : (0, e.bytesToNumberBE)(l);
      }
    });
    return Object.freeze(m);
  }
  Zt.Field = L;
  function K(o, u) {
    if (!o.isOdd)
      throw new Error("Field doesn't have isOdd");
    const h = o.sqrt(u);
    return o.isOdd(h) ? h : o.neg(h);
  }
  Zt.FpSqrtOdd = K;
  function $(o, u) {
    if (!o.isOdd)
      throw new Error("Field doesn't have isOdd");
    const h = o.sqrt(u);
    return o.isOdd(h) ? o.neg(h) : h;
  }
  Zt.FpSqrtEven = $;
  function k(o, u, h = !1) {
    o = (0, e.ensureBytes)("privateHash", o);
    const y = o.length, E = R(u).nByteLength + 8;
    if (E < 24 || y < E || y > 1024)
      throw new Error(`hashToPrivateScalar: expected ${E}-1024 bytes of input, got ${y}`);
    const P = h ? (0, e.bytesToNumberLE)(o) : (0, e.bytesToNumberBE)(o);
    return d(P, u - r) + r;
  }
  Zt.hashToPrivateScalar = k;
  function V(o) {
    if (typeof o != "bigint")
      throw new Error("field order must be bigint");
    const u = o.toString(2).length;
    return Math.ceil(u / 8);
  }
  Zt.getFieldBytesLength = V;
  function C(o) {
    const u = V(o);
    return u + Math.ceil(u / 2);
  }
  Zt.getMinHashLength = C;
  function D(o, u, h = !1) {
    const y = o.length, E = V(u), P = C(u);
    if (y < 16 || y < P || y > 1024)
      throw new Error(`expected ${P}-1024 bytes of input, got ${y}`);
    const w = h ? (0, e.bytesToNumberBE)(o) : (0, e.bytesToNumberLE)(o), m = d(w, u - r) + r;
    return h ? (0, e.numberToBytesLE)(m, E) : (0, e.numberToBytesBE)(m, E);
  }
  return Zt.mapHashToField = D, Zt;
}
var r6 = {}, Pa = {}, n6;
function LM() {
  if (n6)
    return Pa;
  n6 = 1, Object.defineProperty(Pa, "__esModule", { value: !0 }), Pa.validateBasic = Pa.wNAF = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const e = yf(), t = ic(), r = BigInt(0), n = BigInt(1);
  function s(a, f) {
    const d = (p, g) => {
      const v = g.negate();
      return p ? v : g;
    }, c = (p) => {
      const g = Math.ceil(f / p) + 1, v = 2 ** (p - 1);
      return { windows: g, windowSize: v };
    };
    return {
      constTimeNegate: d,
      // non-const time multiplication ladder
      unsafeLadder(p, g) {
        let v = a.ZERO, O = p;
        for (; g > r; )
          g & n && (v = v.add(O)), O = O.double(), g >>= n;
        return v;
      },
      /**
       * Creates a wNAF precomputation window. Used for caching.
       * Default window size is set by `utils.precompute()` and is equal to 8.
       * Number of precomputed points depends on the curve size:
       * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
       * - 𝑊 is the window size
       * - 𝑛 is the bitlength of the curve order.
       * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
       * @returns precomputed point tables flattened to a single array
       */
      precomputeWindow(p, g) {
        const { windows: v, windowSize: O } = c(g), N = [];
        let S = p, j = S;
        for (let B = 0; B < v; B++) {
          j = S, N.push(j);
          for (let M = 1; M < O; M++)
            j = j.add(S), N.push(j);
          S = j.double();
        }
        return N;
      },
      /**
       * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
       * @param W window size
       * @param precomputes precomputed tables
       * @param n scalar (we don't check here, but should be less than curve order)
       * @returns real and fake (for const-time) points
       */
      wNAF(p, g, v) {
        const { windows: O, windowSize: N } = c(p);
        let S = a.ZERO, j = a.BASE;
        const B = BigInt(2 ** p - 1), M = 2 ** p, I = BigInt(p);
        for (let A = 0; A < O; A++) {
          const R = A * N;
          let L = Number(v & B);
          v >>= I, L > N && (L -= M, v += n);
          const K = R, $ = R + Math.abs(L) - 1, k = A % 2 !== 0, V = L < 0;
          L === 0 ? j = j.add(d(k, g[K])) : S = S.add(d(V, g[$]));
        }
        return { p: S, f: j };
      },
      wNAFCached(p, g, v, O) {
        const N = p._WINDOW_SIZE || 1;
        let S = g.get(p);
        return S || (S = this.precomputeWindow(p, N), N !== 1 && g.set(p, O(S))), this.wNAF(N, S, v);
      }
    };
  }
  Pa.wNAF = s;
  function i(a) {
    return (0, e.validateField)(a.Fp), (0, t.validateObject)(a, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...(0, e.nLength)(a.n, a.nBitLength),
      ...a,
      p: a.Fp.ORDER
    });
  }
  return Pa.validateBasic = i, Pa;
}
var i6;
function t7() {
  return i6 || (i6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.mapToCurveSimpleSWU = e.SWUFpSqrtRatio = e.weierstrass = e.weierstrassPoints = e.DER = void 0;
    /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    const t = yf(), r = ic(), n = ic(), s = LM();
    function i(M) {
      const I = (0, s.validateBasic)(M);
      r.validateObject(I, {
        a: "field",
        b: "field"
      }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
      });
      const { endo: A, Fp: R, a: L } = I;
      if (A) {
        if (!R.eql(L, R.ZERO))
          throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof A != "object" || typeof A.beta != "bigint" || typeof A.splitScalar != "function")
          throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
      }
      return Object.freeze({ ...I });
    }
    const { bytesToNumberBE: a, hexToBytes: f } = r;
    e.DER = {
      // asn.1 DER encoding utils
      Err: class extends Error {
        constructor(M = "") {
          super(M);
        }
      },
      _parseInt(M) {
        const { Err: I } = e.DER;
        if (M.length < 2 || M[0] !== 2)
          throw new I("Invalid signature integer tag");
        const A = M[1], R = M.subarray(2, A + 2);
        if (!A || R.length !== A)
          throw new I("Invalid signature integer: wrong length");
        if (R[0] & 128)
          throw new I("Invalid signature integer: negative");
        if (R[0] === 0 && !(R[1] & 128))
          throw new I("Invalid signature integer: unnecessary leading zero");
        return { d: a(R), l: M.subarray(A + 2) };
      },
      toSig(M) {
        const { Err: I } = e.DER, A = typeof M == "string" ? f(M) : M;
        if (!(A instanceof Uint8Array))
          throw new Error("ui8a expected");
        let R = A.length;
        if (R < 2 || A[0] != 48)
          throw new I("Invalid signature tag");
        if (A[1] !== R - 2)
          throw new I("Invalid signature: incorrect length");
        const { d: L, l: K } = e.DER._parseInt(A.subarray(2)), { d: $, l: k } = e.DER._parseInt(K);
        if (k.length)
          throw new I("Invalid signature: left bytes after parsing");
        return { r: L, s: $ };
      },
      hexFromSig(M) {
        const I = (C) => Number.parseInt(C[0], 16) & 8 ? "00" + C : C, A = (C) => {
          const D = C.toString(16);
          return D.length & 1 ? `0${D}` : D;
        }, R = I(A(M.s)), L = I(A(M.r)), K = R.length / 2, $ = L.length / 2, k = A(K), V = A($);
        return `30${A($ + K + 4)}02${V}${L}02${k}${R}`;
      }
    };
    const d = BigInt(0), c = BigInt(1), p = BigInt(2), g = BigInt(3), v = BigInt(4);
    function O(M) {
      const I = i(M), { Fp: A } = I, R = I.toBytes || ((y, E, P) => {
        const w = E.toAffine();
        return r.concatBytes(Uint8Array.from([4]), A.toBytes(w.x), A.toBytes(w.y));
      }), L = I.fromBytes || ((y) => {
        const E = y.subarray(1), P = A.fromBytes(E.subarray(0, A.BYTES)), w = A.fromBytes(E.subarray(A.BYTES, 2 * A.BYTES));
        return { x: P, y: w };
      });
      function K(y) {
        const { a: E, b: P } = I, w = A.sqr(y), m = A.mul(w, y);
        return A.add(A.add(m, A.mul(y, E)), P);
      }
      if (!A.eql(A.sqr(I.Gy), K(I.Gx)))
        throw new Error("bad generator point: equation left != right");
      function $(y) {
        return typeof y == "bigint" && d < y && y < I.n;
      }
      function k(y) {
        if (!$(y))
          throw new Error("Expected valid bigint: 0 < bigint < curve.n");
      }
      function V(y) {
        const { allowedPrivateKeyLengths: E, nByteLength: P, wrapPrivateKey: w, n: m } = I;
        if (E && typeof y != "bigint") {
          if (y instanceof Uint8Array && (y = r.bytesToHex(y)), typeof y != "string" || !E.includes(y.length))
            throw new Error("Invalid key");
          y = y.padStart(P * 2, "0");
        }
        let l;
        try {
          l = typeof y == "bigint" ? y : r.bytesToNumberBE((0, n.ensureBytes)("private key", y, P));
        } catch {
          throw new Error(`private key must be ${P} bytes, hex or bigint, not ${typeof y}`);
        }
        return w && (l = t.mod(l, m)), k(l), l;
      }
      const C = /* @__PURE__ */ new Map();
      function D(y) {
        if (!(y instanceof o))
          throw new Error("ProjectivePoint expected");
      }
      class o {
        constructor(E, P, w) {
          if (this.px = E, this.py = P, this.pz = w, E == null || !A.isValid(E))
            throw new Error("x required");
          if (P == null || !A.isValid(P))
            throw new Error("y required");
          if (w == null || !A.isValid(w))
            throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(E) {
          const { x: P, y: w } = E || {};
          if (!E || !A.isValid(P) || !A.isValid(w))
            throw new Error("invalid affine point");
          if (E instanceof o)
            throw new Error("projective point not allowed");
          const m = (l) => A.eql(l, A.ZERO);
          return m(P) && m(w) ? o.ZERO : new o(P, w, A.ONE);
        }
        get x() {
          return this.toAffine().x;
        }
        get y() {
          return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */
        static normalizeZ(E) {
          const P = A.invertBatch(E.map((w) => w.pz));
          return E.map((w, m) => w.toAffine(P[m])).map(o.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */
        static fromHex(E) {
          const P = o.fromAffine(L((0, n.ensureBytes)("pointHex", E)));
          return P.assertValidity(), P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(E) {
          return o.BASE.multiply(V(E));
        }
        // "Private method", don't use it directly
        _setWindowSize(E) {
          this._WINDOW_SIZE = E, C.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
          if (this.is0()) {
            if (I.allowInfinityPoint && !A.is0(this.py))
              return;
            throw new Error("bad point: ZERO");
          }
          const { x: E, y: P } = this.toAffine();
          if (!A.isValid(E) || !A.isValid(P))
            throw new Error("bad point: x or y not FE");
          const w = A.sqr(P), m = K(E);
          if (!A.eql(w, m))
            throw new Error("bad point: equation left != right");
          if (!this.isTorsionFree())
            throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
          const { y: E } = this.toAffine();
          if (A.isOdd)
            return !A.isOdd(E);
          throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */
        equals(E) {
          D(E);
          const { px: P, py: w, pz: m } = this, { px: l, py: b, pz: W } = E, X = A.eql(A.mul(P, W), A.mul(l, m)), G = A.eql(A.mul(w, W), A.mul(b, m));
          return X && G;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */
        negate() {
          return new o(this.px, A.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
          const { a: E, b: P } = I, w = A.mul(P, g), { px: m, py: l, pz: b } = this;
          let W = A.ZERO, X = A.ZERO, G = A.ZERO, re = A.mul(m, m), ce = A.mul(l, l), pe = A.mul(b, b), ve = A.mul(m, l);
          return ve = A.add(ve, ve), G = A.mul(m, b), G = A.add(G, G), W = A.mul(E, G), X = A.mul(w, pe), X = A.add(W, X), W = A.sub(ce, X), X = A.add(ce, X), X = A.mul(W, X), W = A.mul(ve, W), G = A.mul(w, G), pe = A.mul(E, pe), ve = A.sub(re, pe), ve = A.mul(E, ve), ve = A.add(ve, G), G = A.add(re, re), re = A.add(G, re), re = A.add(re, pe), re = A.mul(re, ve), X = A.add(X, re), pe = A.mul(l, b), pe = A.add(pe, pe), re = A.mul(pe, ve), W = A.sub(W, re), G = A.mul(pe, ce), G = A.add(G, G), G = A.add(G, G), new o(W, X, G);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(E) {
          D(E);
          const { px: P, py: w, pz: m } = this, { px: l, py: b, pz: W } = E;
          let X = A.ZERO, G = A.ZERO, re = A.ZERO;
          const ce = I.a, pe = A.mul(I.b, g);
          let ve = A.mul(P, l), Ee = A.mul(w, b), Pe = A.mul(m, W), xe = A.add(P, w), me = A.add(l, b);
          xe = A.mul(xe, me), me = A.add(ve, Ee), xe = A.sub(xe, me), me = A.add(P, m);
          let te = A.add(l, W);
          return me = A.mul(me, te), te = A.add(ve, Pe), me = A.sub(me, te), te = A.add(w, m), X = A.add(b, W), te = A.mul(te, X), X = A.add(Ee, Pe), te = A.sub(te, X), re = A.mul(ce, me), X = A.mul(pe, Pe), re = A.add(X, re), X = A.sub(Ee, re), re = A.add(Ee, re), G = A.mul(X, re), Ee = A.add(ve, ve), Ee = A.add(Ee, ve), Pe = A.mul(ce, Pe), me = A.mul(pe, me), Ee = A.add(Ee, Pe), Pe = A.sub(ve, Pe), Pe = A.mul(ce, Pe), me = A.add(me, Pe), ve = A.mul(Ee, me), G = A.add(G, ve), ve = A.mul(te, me), X = A.mul(xe, X), X = A.sub(X, ve), ve = A.mul(xe, Ee), re = A.mul(te, re), re = A.add(re, ve), new o(X, G, re);
        }
        subtract(E) {
          return this.add(E.negate());
        }
        is0() {
          return this.equals(o.ZERO);
        }
        wNAF(E) {
          return h.wNAFCached(this, C, E, (P) => {
            const w = A.invertBatch(P.map((m) => m.pz));
            return P.map((m, l) => m.toAffine(w[l])).map(o.fromAffine);
          });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(E) {
          const P = o.ZERO;
          if (E === d)
            return P;
          if (k(E), E === c)
            return this;
          const { endo: w } = I;
          if (!w)
            return h.unsafeLadder(this, E);
          let { k1neg: m, k1: l, k2neg: b, k2: W } = w.splitScalar(E), X = P, G = P, re = this;
          for (; l > d || W > d; )
            l & c && (X = X.add(re)), W & c && (G = G.add(re)), re = re.double(), l >>= c, W >>= c;
          return m && (X = X.negate()), b && (G = G.negate()), G = new o(A.mul(G.px, w.beta), G.py, G.pz), X.add(G);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(E) {
          k(E);
          let P = E, w, m;
          const { endo: l } = I;
          if (l) {
            const { k1neg: b, k1: W, k2neg: X, k2: G } = l.splitScalar(P);
            let { p: re, f: ce } = this.wNAF(W), { p: pe, f: ve } = this.wNAF(G);
            re = h.constTimeNegate(b, re), pe = h.constTimeNegate(X, pe), pe = new o(A.mul(pe.px, l.beta), pe.py, pe.pz), w = re.add(pe), m = ce.add(ve);
          } else {
            const { p: b, f: W } = this.wNAF(P);
            w = b, m = W;
          }
          return o.normalizeZ([w, m])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */
        multiplyAndAddUnsafe(E, P, w) {
          const m = o.BASE, l = (W, X) => X === d || X === c || !W.equals(m) ? W.multiplyUnsafe(X) : W.multiply(X), b = l(this, P).add(l(E, w));
          return b.is0() ? void 0 : b;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(E) {
          const { px: P, py: w, pz: m } = this, l = this.is0();
          E == null && (E = l ? A.ONE : A.inv(m));
          const b = A.mul(P, E), W = A.mul(w, E), X = A.mul(m, E);
          if (l)
            return { x: A.ZERO, y: A.ZERO };
          if (!A.eql(X, A.ONE))
            throw new Error("invZ was invalid");
          return { x: b, y: W };
        }
        isTorsionFree() {
          const { h: E, isTorsionFree: P } = I;
          if (E === c)
            return !0;
          if (P)
            return P(o, this);
          throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
          const { h: E, clearCofactor: P } = I;
          return E === c ? this : P ? P(o, this) : this.multiplyUnsafe(I.h);
        }
        toRawBytes(E = !0) {
          return this.assertValidity(), R(o, this, E);
        }
        toHex(E = !0) {
          return r.bytesToHex(this.toRawBytes(E));
        }
      }
      o.BASE = new o(I.Gx, I.Gy, A.ONE), o.ZERO = new o(A.ZERO, A.ONE, A.ZERO);
      const u = I.nBitLength, h = (0, s.wNAF)(o, I.endo ? Math.ceil(u / 2) : u);
      return {
        CURVE: I,
        ProjectivePoint: o,
        normPrivateKeyToScalar: V,
        weierstrassEquation: K,
        isWithinCurveOrder: $
      };
    }
    e.weierstrassPoints = O;
    function N(M) {
      const I = (0, s.validateBasic)(M);
      return r.validateObject(I, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
      }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
      }), Object.freeze({ lowS: !0, ...I });
    }
    function S(M) {
      const I = N(M), { Fp: A, n: R } = I, L = A.BYTES + 1, K = 2 * A.BYTES + 1;
      function $(me) {
        return d < me && me < A.ORDER;
      }
      function k(me) {
        return t.mod(me, R);
      }
      function V(me) {
        return t.invert(me, R);
      }
      const { ProjectivePoint: C, normPrivateKeyToScalar: D, weierstrassEquation: o, isWithinCurveOrder: u } = O({
        ...I,
        toBytes(me, te, U) {
          const ue = te.toAffine(), we = A.toBytes(ue.x), ke = r.concatBytes;
          return U ? ke(Uint8Array.from([te.hasEvenY() ? 2 : 3]), we) : ke(Uint8Array.from([4]), we, A.toBytes(ue.y));
        },
        fromBytes(me) {
          const te = me.length, U = me[0], ue = me.subarray(1);
          if (te === L && (U === 2 || U === 3)) {
            const we = r.bytesToNumberBE(ue);
            if (!$(we))
              throw new Error("Point is not on curve");
            const ke = o(we);
            let Re = A.sqrt(ke);
            const fe = (Re & c) === c;
            return (U & 1) === 1 !== fe && (Re = A.neg(Re)), { x: we, y: Re };
          } else if (te === K && U === 4) {
            const we = A.fromBytes(ue.subarray(0, A.BYTES)), ke = A.fromBytes(ue.subarray(A.BYTES, 2 * A.BYTES));
            return { x: we, y: ke };
          } else
            throw new Error(`Point of length ${te} was invalid. Expected ${L} compressed bytes or ${K} uncompressed bytes`);
        }
      }), h = (me) => r.bytesToHex(r.numberToBytesBE(me, I.nByteLength));
      function y(me) {
        const te = R >> c;
        return me > te;
      }
      function E(me) {
        return y(me) ? k(-me) : me;
      }
      const P = (me, te, U) => r.bytesToNumberBE(me.slice(te, U));
      class w {
        constructor(te, U, ue) {
          this.r = te, this.s = U, this.recovery = ue, this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(te) {
          const U = I.nByteLength;
          return te = (0, n.ensureBytes)("compactSignature", te, U * 2), new w(P(te, 0, U), P(te, U, 2 * U));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(te) {
          const { r: U, s: ue } = e.DER.toSig((0, n.ensureBytes)("DER", te));
          return new w(U, ue);
        }
        assertValidity() {
          if (!u(this.r))
            throw new Error("r must be 0 < r < CURVE.n");
          if (!u(this.s))
            throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(te) {
          return new w(this.r, this.s, te);
        }
        recoverPublicKey(te) {
          const { r: U, s: ue, recovery: we } = this, ke = G((0, n.ensureBytes)("msgHash", te));
          if (we == null || ![0, 1, 2, 3].includes(we))
            throw new Error("recovery id invalid");
          const Re = we === 2 || we === 3 ? U + I.n : U;
          if (Re >= A.ORDER)
            throw new Error("recovery id 2 or 3 invalid");
          const fe = we & 1 ? "03" : "02", x = C.fromHex(fe + h(Re)), _ = V(Re), q = k(-ke * _), ne = k(ue * _), de = C.BASE.multiplyAndAddUnsafe(x, q, ne);
          if (!de)
            throw new Error("point at infinify");
          return de.assertValidity(), de;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
          return y(this.s);
        }
        normalizeS() {
          return this.hasHighS() ? new w(this.r, k(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
          return r.hexToBytes(this.toDERHex());
        }
        toDERHex() {
          return e.DER.hexFromSig({ r: this.r, s: this.s });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
          return r.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
          return h(this.r) + h(this.s);
        }
      }
      const m = {
        isValidPrivateKey(me) {
          try {
            return D(me), !0;
          } catch {
            return !1;
          }
        },
        normPrivateKeyToScalar: D,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */
        randomPrivateKey: () => {
          const me = t.getMinHashLength(I.n);
          return t.mapHashToField(I.randomBytes(me), I.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */
        precompute(me = 8, te = C.BASE) {
          return te._setWindowSize(me), te.multiply(BigInt(3)), te;
        }
      };
      function l(me, te = !0) {
        return C.fromPrivateKey(me).toRawBytes(te);
      }
      function b(me) {
        const te = me instanceof Uint8Array, U = typeof me == "string", ue = (te || U) && me.length;
        return te ? ue === L || ue === K : U ? ue === 2 * L || ue === 2 * K : me instanceof C;
      }
      function W(me, te, U = !0) {
        if (b(me))
          throw new Error("first arg must be private key");
        if (!b(te))
          throw new Error("second arg must be public key");
        return C.fromHex(te).multiply(D(me)).toRawBytes(U);
      }
      const X = I.bits2int || function(me) {
        const te = r.bytesToNumberBE(me), U = me.length * 8 - I.nBitLength;
        return U > 0 ? te >> BigInt(U) : te;
      }, G = I.bits2int_modN || function(me) {
        return k(X(me));
      }, re = r.bitMask(I.nBitLength);
      function ce(me) {
        if (typeof me != "bigint")
          throw new Error("bigint expected");
        if (!(d <= me && me < re))
          throw new Error(`bigint expected < 2^${I.nBitLength}`);
        return r.numberToBytesBE(me, I.nByteLength);
      }
      function pe(me, te, U = ve) {
        if (["recovered", "canonical"].some((ge) => ge in U))
          throw new Error("sign() legacy options not supported");
        const { hash: ue, randomBytes: we } = I;
        let { lowS: ke, prehash: Re, extraEntropy: fe } = U;
        ke == null && (ke = !0), me = (0, n.ensureBytes)("msgHash", me), Re && (me = (0, n.ensureBytes)("prehashed msgHash", ue(me)));
        const x = G(me), _ = D(te), q = [ce(_), ce(x)];
        if (fe != null) {
          const ge = fe === !0 ? we(A.BYTES) : fe;
          q.push((0, n.ensureBytes)("extraEntropy", ge));
        }
        const ne = r.concatBytes(...q), de = x;
        function ye(ge) {
          const be = X(ge);
          if (!u(be))
            return;
          const Me = V(be), Ce = C.BASE.multiply(be).toAffine(), je = k(Ce.x);
          if (je === d)
            return;
          const Ue = k(Me * k(de + je * _));
          if (Ue === d)
            return;
          let Qe = (Ce.x === je ? 0 : 2) | Number(Ce.y & c), Ye = Ue;
          return ke && y(Ue) && (Ye = E(Ue), Qe ^= 1), new w(je, Ye, Qe);
        }
        return { seed: ne, k2sig: ye };
      }
      const ve = { lowS: I.lowS, prehash: !1 }, Ee = { lowS: I.lowS, prehash: !1 };
      function Pe(me, te, U = ve) {
        const { seed: ue, k2sig: we } = pe(me, te, U), ke = I;
        return r.createHmacDrbg(ke.hash.outputLen, ke.nByteLength, ke.hmac)(ue, we);
      }
      C.BASE._setWindowSize(8);
      function xe(me, te, U, ue = Ee) {
        var we;
        const ke = me;
        if (te = (0, n.ensureBytes)("msgHash", te), U = (0, n.ensureBytes)("publicKey", U), "strict" in ue)
          throw new Error("options.strict was renamed to lowS");
        const { lowS: Re, prehash: fe } = ue;
        let x, _;
        try {
          if (typeof ke == "string" || ke instanceof Uint8Array)
            try {
              x = w.fromDER(ke);
            } catch (Ce) {
              if (!(Ce instanceof e.DER.Err))
                throw Ce;
              x = w.fromCompact(ke);
            }
          else if (typeof ke == "object" && typeof ke.r == "bigint" && typeof ke.s == "bigint") {
            const { r: Ce, s: je } = ke;
            x = new w(Ce, je);
          } else
            throw new Error("PARSE");
          _ = C.fromHex(U);
        } catch (Ce) {
          if (Ce.message === "PARSE")
            throw new Error("signature must be Signature instance, Uint8Array or hex string");
          return !1;
        }
        if (Re && x.hasHighS())
          return !1;
        fe && (te = I.hash(te));
        const { r: q, s: ne } = x, de = G(te), ye = V(ne), ge = k(de * ye), be = k(q * ye), Me = (we = C.BASE.multiplyAndAddUnsafe(_, ge, be)) == null ? void 0 : we.toAffine();
        return Me ? k(Me.x) === q : !1;
      }
      return {
        CURVE: I,
        getPublicKey: l,
        getSharedSecret: W,
        sign: Pe,
        verify: xe,
        ProjectivePoint: C,
        Signature: w,
        utils: m
      };
    }
    e.weierstrass = S;
    function j(M, I) {
      const A = M.ORDER;
      let R = d;
      for (let y = A - c; y % p === d; y /= p)
        R += c;
      const L = R, K = p << L - c - c, $ = K * p, k = (A - c) / $, V = (k - c) / p, C = $ - c, D = K, o = M.pow(I, k), u = M.pow(I, (k + c) / p);
      let h = (y, E) => {
        let P = o, w = M.pow(E, C), m = M.sqr(w);
        m = M.mul(m, E);
        let l = M.mul(y, m);
        l = M.pow(l, V), l = M.mul(l, w), w = M.mul(l, E), m = M.mul(l, y);
        let b = M.mul(m, w);
        l = M.pow(b, D);
        let W = M.eql(l, M.ONE);
        w = M.mul(m, u), l = M.mul(b, P), m = M.cmov(w, m, W), b = M.cmov(l, b, W);
        for (let X = L; X > c; X--) {
          let G = X - p;
          G = p << G - c;
          let re = M.pow(b, G);
          const ce = M.eql(re, M.ONE);
          w = M.mul(m, P), P = M.mul(P, P), re = M.mul(b, P), m = M.cmov(w, m, ce), b = M.cmov(re, b, ce);
        }
        return { isValid: W, value: m };
      };
      if (M.ORDER % v === g) {
        const y = (M.ORDER - g) / v, E = M.sqrt(M.neg(I));
        h = (P, w) => {
          let m = M.sqr(w);
          const l = M.mul(P, w);
          m = M.mul(m, l);
          let b = M.pow(m, y);
          b = M.mul(b, l);
          const W = M.mul(b, E), X = M.mul(M.sqr(b), w), G = M.eql(X, P);
          let re = M.cmov(W, b, G);
          return { isValid: G, value: re };
        };
      }
      return h;
    }
    e.SWUFpSqrtRatio = j;
    function B(M, I) {
      if (t.validateField(M), !M.isValid(I.A) || !M.isValid(I.B) || !M.isValid(I.Z))
        throw new Error("mapToCurveSimpleSWU: invalid opts");
      const A = j(M, I.Z);
      if (!M.isOdd)
        throw new Error("Fp.isOdd is not implemented!");
      return (R) => {
        let L, K, $, k, V, C, D, o;
        L = M.sqr(R), L = M.mul(L, I.Z), K = M.sqr(L), K = M.add(K, L), $ = M.add(K, M.ONE), $ = M.mul($, I.B), k = M.cmov(I.Z, M.neg(K), !M.eql(K, M.ZERO)), k = M.mul(k, I.A), K = M.sqr($), C = M.sqr(k), V = M.mul(C, I.A), K = M.add(K, V), K = M.mul(K, $), C = M.mul(C, k), V = M.mul(C, I.B), K = M.add(K, V), D = M.mul(L, $);
        const { isValid: u, value: h } = A(K, C);
        o = M.mul(L, R), o = M.mul(o, h), D = M.cmov(D, $, u), o = M.cmov(o, h, u);
        const y = M.isOdd(R) === M.isOdd(o);
        return o = M.cmov(M.neg(o), o, y), D = M.div(D, k), { x: D, y: o };
      };
    }
    e.mapToCurveSimpleSWU = B;
  }(r6)), r6;
}
var zn = {}, s6;
function HM() {
  if (s6)
    return zn;
  s6 = 1, Object.defineProperty(zn, "__esModule", { value: !0 }), zn.createHasher = zn.isogenyMap = zn.hash_to_field = zn.expand_message_xof = zn.expand_message_xmd = void 0;
  const e = yf(), t = ic();
  function r(O) {
    if (O instanceof Uint8Array)
      return O;
    if (typeof O == "string")
      return (0, t.utf8ToBytes)(O);
    throw new Error("DST must be Uint8Array or string");
  }
  const n = t.bytesToNumberBE;
  function s(O, N) {
    if (O < 0 || O >= 1 << 8 * N)
      throw new Error(`bad I2OSP call: value=${O} length=${N}`);
    const S = Array.from({ length: N }).fill(0);
    for (let j = N - 1; j >= 0; j--)
      S[j] = O & 255, O >>>= 8;
    return new Uint8Array(S);
  }
  function i(O, N) {
    const S = new Uint8Array(O.length);
    for (let j = 0; j < O.length; j++)
      S[j] = O[j] ^ N[j];
    return S;
  }
  function a(O) {
    if (!(O instanceof Uint8Array))
      throw new Error("Uint8Array expected");
  }
  function f(O) {
    if (!Number.isSafeInteger(O))
      throw new Error("number expected");
  }
  function d(O, N, S, j) {
    a(O), a(N), f(S), N.length > 255 && (N = j((0, t.concatBytes)((0, t.utf8ToBytes)("H2C-OVERSIZE-DST-"), N)));
    const { outputLen: B, blockLen: M } = j, I = Math.ceil(S / B);
    if (I > 255)
      throw new Error("Invalid xmd length");
    const A = (0, t.concatBytes)(N, s(N.length, 1)), R = s(0, M), L = s(S, 2), K = new Array(I), $ = j((0, t.concatBytes)(R, O, L, s(0, 1), A));
    K[0] = j((0, t.concatBytes)($, s(1, 1), A));
    for (let k = 1; k <= I; k++) {
      const V = [i($, K[k - 1]), s(k + 1, 1), A];
      K[k] = j((0, t.concatBytes)(...V));
    }
    return (0, t.concatBytes)(...K).slice(0, S);
  }
  zn.expand_message_xmd = d;
  function c(O, N, S, j, B) {
    if (a(O), a(N), f(S), N.length > 255) {
      const M = Math.ceil(2 * j / 8);
      N = B.create({ dkLen: M }).update((0, t.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(N).digest();
    }
    if (S > 65535 || N.length > 255)
      throw new Error("expand_message_xof: invalid lenInBytes");
    return B.create({ dkLen: S }).update(O).update(s(S, 2)).update(N).update(s(N.length, 1)).digest();
  }
  zn.expand_message_xof = c;
  function p(O, N, S) {
    (0, t.validateObject)(S, {
      DST: "stringOrUint8Array",
      p: "bigint",
      m: "isSafeInteger",
      k: "isSafeInteger",
      hash: "hash"
    });
    const { p: j, k: B, m: M, hash: I, expand: A, DST: R } = S;
    a(O), f(N);
    const L = r(R), K = j.toString(2).length, $ = Math.ceil((K + B) / 8), k = N * M * $;
    let V;
    if (A === "xmd")
      V = d(O, L, k, I);
    else if (A === "xof")
      V = c(O, L, k, B, I);
    else if (A === "_internal_pass")
      V = O;
    else
      throw new Error('expand must be "xmd" or "xof"');
    const C = new Array(N);
    for (let D = 0; D < N; D++) {
      const o = new Array(M);
      for (let u = 0; u < M; u++) {
        const h = $ * (u + D * M), y = V.subarray(h, h + $);
        o[u] = (0, e.mod)(n(y), j);
      }
      C[D] = o;
    }
    return C;
  }
  zn.hash_to_field = p;
  function g(O, N) {
    const S = N.map((j) => Array.from(j).reverse());
    return (j, B) => {
      const [M, I, A, R] = S.map((L) => L.reduce((K, $) => O.add(O.mul(K, j), $)));
      return j = O.div(M, I), B = O.mul(B, O.div(A, R)), { x: j, y: B };
    };
  }
  zn.isogenyMap = g;
  function v(O, N, S) {
    if (typeof N != "function")
      throw new Error("mapToCurve() must be defined");
    return {
      // Encodes byte string to elliptic curve.
      // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      hashToCurve(j, B) {
        const M = p(j, 2, { ...S, DST: S.DST, ...B }), I = O.fromAffine(N(M[0])), A = O.fromAffine(N(M[1])), R = I.add(A).clearCofactor();
        return R.assertValidity(), R;
      },
      // Encodes byte string to elliptic curve.
      // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      encodeToCurve(j, B) {
        const M = p(j, 1, { ...S, DST: S.encodeDST, ...B }), I = O.fromAffine(N(M[0])).clearCofactor();
        return I.assertValidity(), I;
      }
    };
  }
  return zn.createHasher = v, zn;
}
var Oa = {}, o6;
function WM() {
  if (o6)
    return Oa;
  o6 = 1, Object.defineProperty(Oa, "__esModule", { value: !0 }), Oa.createCurve = Oa.getHash = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const e = q1(), t = Es(), r = t7();
  function n(i) {
    return {
      hash: i,
      hmac: (a, ...f) => (0, e.hmac)(i, a, (0, t.concatBytes)(...f)),
      randomBytes: t.randomBytes
    };
  }
  Oa.getHash = n;
  function s(i, a) {
    const f = (d) => (0, r.weierstrass)({ ...i, ...n(d) });
    return Object.freeze({ ...f(a), create: f });
  }
  return Oa.createCurve = s, Oa;
}
var a6;
function GM() {
  return a6 || (a6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.encodeToCurve = e.hashToCurve = e.schnorr = e.secp256k1 = void 0;
    /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    const t = K1(), r = Es(), n = yf(), s = t7(), i = ic(), a = HM(), f = WM(), d = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), c = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), p = BigInt(1), g = BigInt(2), v = (w, m) => (w + m / g) / m;
    function O(w) {
      const m = d, l = BigInt(3), b = BigInt(6), W = BigInt(11), X = BigInt(22), G = BigInt(23), re = BigInt(44), ce = BigInt(88), pe = w * w * w % m, ve = pe * pe * w % m, Ee = (0, n.pow2)(ve, l, m) * ve % m, Pe = (0, n.pow2)(Ee, l, m) * ve % m, xe = (0, n.pow2)(Pe, g, m) * pe % m, me = (0, n.pow2)(xe, W, m) * xe % m, te = (0, n.pow2)(me, X, m) * me % m, U = (0, n.pow2)(te, re, m) * te % m, ue = (0, n.pow2)(U, ce, m) * U % m, we = (0, n.pow2)(ue, re, m) * te % m, ke = (0, n.pow2)(we, l, m) * ve % m, Re = (0, n.pow2)(ke, G, m) * me % m, fe = (0, n.pow2)(Re, b, m) * pe % m, x = (0, n.pow2)(fe, g, m);
      if (!N.eql(N.sqr(x), w))
        throw new Error("Cannot find square root");
      return x;
    }
    const N = (0, n.Field)(d, void 0, void 0, { sqrt: O });
    e.secp256k1 = (0, f.createCurve)({
      a: BigInt(0),
      b: BigInt(7),
      Fp: N,
      n: c,
      // Base point (x, y) aka generator point
      Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
      Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
      h: BigInt(1),
      lowS: !0,
      /**
       * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
       * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
       * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
       * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
       */
      endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (w) => {
          const m = c, l = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), b = -p * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), W = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), X = l, G = BigInt("0x100000000000000000000000000000000"), re = v(X * w, m), ce = v(-b * w, m);
          let pe = (0, n.mod)(w - re * l - ce * W, m), ve = (0, n.mod)(-re * b - ce * X, m);
          const Ee = pe > G, Pe = ve > G;
          if (Ee && (pe = m - pe), Pe && (ve = m - ve), pe > G || ve > G)
            throw new Error("splitScalar: Endomorphism failed, k=" + w);
          return { k1neg: Ee, k1: pe, k2neg: Pe, k2: ve };
        }
      }
    }, t.sha256);
    const S = BigInt(0), j = (w) => typeof w == "bigint" && S < w && w < d, B = (w) => typeof w == "bigint" && S < w && w < c, M = {};
    function I(w, ...m) {
      let l = M[w];
      if (l === void 0) {
        const b = (0, t.sha256)(Uint8Array.from(w, (W) => W.charCodeAt(0)));
        l = (0, i.concatBytes)(b, b), M[w] = l;
      }
      return (0, t.sha256)((0, i.concatBytes)(l, ...m));
    }
    const A = (w) => w.toRawBytes(!0).slice(1), R = (w) => (0, i.numberToBytesBE)(w, 32), L = (w) => (0, n.mod)(w, d), K = (w) => (0, n.mod)(w, c), $ = e.secp256k1.ProjectivePoint, k = (w, m, l) => $.BASE.multiplyAndAddUnsafe(w, m, l);
    function V(w) {
      let m = e.secp256k1.utils.normPrivateKeyToScalar(w), l = $.fromPrivateKey(m);
      return { scalar: l.hasEvenY() ? m : K(-m), bytes: A(l) };
    }
    function C(w) {
      if (!j(w))
        throw new Error("bad x: need 0 < x < p");
      const m = L(w * w), l = L(m * w + BigInt(7));
      let b = O(l);
      b % g !== S && (b = L(-b));
      const W = new $(w, b, p);
      return W.assertValidity(), W;
    }
    function D(...w) {
      return K((0, i.bytesToNumberBE)(I("BIP0340/challenge", ...w)));
    }
    function o(w) {
      return V(w).bytes;
    }
    function u(w, m, l = (0, r.randomBytes)(32)) {
      const b = (0, i.ensureBytes)("message", w), { bytes: W, scalar: X } = V(m), G = (0, i.ensureBytes)("auxRand", l, 32), re = R(X ^ (0, i.bytesToNumberBE)(I("BIP0340/aux", G))), ce = I("BIP0340/nonce", re, W, b), pe = K((0, i.bytesToNumberBE)(ce));
      if (pe === S)
        throw new Error("sign failed: k is zero");
      const { bytes: ve, scalar: Ee } = V(pe), Pe = D(ve, W, b), xe = new Uint8Array(64);
      if (xe.set(ve, 0), xe.set(R(K(Ee + Pe * X)), 32), !h(xe, b, W))
        throw new Error("sign: Invalid signature produced");
      return xe;
    }
    function h(w, m, l) {
      const b = (0, i.ensureBytes)("signature", w, 64), W = (0, i.ensureBytes)("message", m), X = (0, i.ensureBytes)("publicKey", l, 32);
      try {
        const G = C((0, i.bytesToNumberBE)(X)), re = (0, i.bytesToNumberBE)(b.subarray(0, 32));
        if (!j(re))
          return !1;
        const ce = (0, i.bytesToNumberBE)(b.subarray(32, 64));
        if (!B(ce))
          return !1;
        const pe = D(R(re), A(G), W), ve = k(G, ce, K(-pe));
        return !(!ve || !ve.hasEvenY() || ve.toAffine().x !== re);
      } catch {
        return !1;
      }
    }
    e.schnorr = {
      getPublicKey: o,
      sign: u,
      verify: h,
      utils: {
        randomPrivateKey: e.secp256k1.utils.randomPrivateKey,
        lift_x: C,
        pointToBytes: A,
        numberToBytesBE: i.numberToBytesBE,
        bytesToNumberBE: i.bytesToNumberBE,
        taggedHash: I,
        mod: n.mod
      }
    };
    const y = (0, a.isogenyMap)(N, [
      // xNum
      [
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
      ],
      // xDen
      [
        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ],
      // yNum
      [
        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
      ],
      // yDen
      [
        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ]
    ].map((w) => w.map((m) => BigInt(m)))), E = (0, s.mapToCurveSimpleSWU)(N, {
      A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
      B: BigInt("1771"),
      Z: N.create(BigInt("-11"))
    }), P = (0, a.createHasher)(e.secp256k1.ProjectivePoint, (w) => {
      const { x: m, y: l } = E(N.create(w[0]));
      return y(m, l);
    }, {
      DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
      encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
      p: N.ORDER,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: t.sha256
    });
    e.hashToCurve = P.hashToCurve, e.encodeToCurve = P.encodeToCurve;
  }(Xb)), Xb;
}
var Rl = {}, u6 = {}, jd = {}, c6;
function r7() {
  return c6 || (c6 = 1, Object.defineProperty(jd, "__esModule", { value: !0 }), jd.ZeroAddress = void 0, jd.ZeroAddress = "0x0000000000000000000000000000000000000000"), jd;
}
var Ld = {}, l6;
function zM() {
  return l6 || (l6 = 1, Object.defineProperty(Ld, "__esModule", { value: !0 }), Ld.ZeroHash = void 0, Ld.ZeroHash = "0x0000000000000000000000000000000000000000000000000000000000000000"), Ld;
}
var oi = {}, d6;
function VM() {
  return d6 || (d6 = 1, Object.defineProperty(oi, "__esModule", { value: !0 }), oi.MaxInt256 = oi.MinInt256 = oi.MaxUint256 = oi.WeiPerEther = oi.N = void 0, oi.N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), oi.WeiPerEther = BigInt("1000000000000000000"), oi.MaxUint256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), oi.MinInt256 = BigInt("0x8000000000000000000000000000000000000000000000000000000000000000") * BigInt(-1), oi.MaxInt256 = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")), oi;
}
var cu = {}, h6;
function qM() {
  return h6 || (h6 = 1, Object.defineProperty(cu, "__esModule", { value: !0 }), cu.MessagePrefix = cu.EtherSymbol = void 0, cu.EtherSymbol = "Ξ", cu.MessagePrefix = `Ethereum Signed Message:
`), cu;
}
var f6;
function Ad() {
  return f6 || (f6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.MessagePrefix = e.EtherSymbol = e.MaxInt256 = e.MinInt256 = e.MaxUint256 = e.WeiPerEther = e.N = e.ZeroHash = e.ZeroAddress = void 0;
    var t = r7();
    Object.defineProperty(e, "ZeroAddress", { enumerable: !0, get: function() {
      return t.ZeroAddress;
    } });
    var r = zM();
    Object.defineProperty(e, "ZeroHash", { enumerable: !0, get: function() {
      return r.ZeroHash;
    } });
    var n = VM();
    Object.defineProperty(e, "N", { enumerable: !0, get: function() {
      return n.N;
    } }), Object.defineProperty(e, "WeiPerEther", { enumerable: !0, get: function() {
      return n.WeiPerEther;
    } }), Object.defineProperty(e, "MaxUint256", { enumerable: !0, get: function() {
      return n.MaxUint256;
    } }), Object.defineProperty(e, "MinInt256", { enumerable: !0, get: function() {
      return n.MinInt256;
    } }), Object.defineProperty(e, "MaxInt256", { enumerable: !0, get: function() {
      return n.MaxInt256;
    } });
    var s = qM();
    Object.defineProperty(e, "EtherSymbol", { enumerable: !0, get: function() {
      return s.EtherSymbol;
    } }), Object.defineProperty(e, "MessagePrefix", { enumerable: !0, get: function() {
      return s.MessagePrefix;
    } });
  }(u6)), u6;
}
var p6;
function n7() {
  var e, t, r, n;
  if (p6)
    return Rl;
  p6 = 1, Object.defineProperty(Rl, "__esModule", { value: !0 }), Rl.Signature = void 0;
  const s = Ad(), i = vt(), a = BigInt(0), f = BigInt(1), d = BigInt(2), c = BigInt(27), p = BigInt(28), g = BigInt(35), v = {};
  function O(j) {
    return (0, i.zeroPadValue)((0, i.toBeArray)(j), 32);
  }
  const N = class is {
    /**
     *  @private
     */
    constructor(B, M, I, A) {
      Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Fe(this, n, void 0), (0, i.assertPrivate)(B, v, "Signature"), Ne(this, e, M), Ne(this, t, I), Ne(this, r, A), Ne(this, n, null);
    }
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */
    get r() {
      return ae(this, e);
    }
    set r(B) {
      (0, i.assertArgument)((0, i.dataLength)(B) === 32, "invalid r", "value", B), Ne(this, e, (0, i.hexlify)(B));
    }
    /**
     *  The ``s`` value for a signature.
     */
    get s() {
      return ae(this, t);
    }
    set s(B) {
      (0, i.assertArgument)((0, i.dataLength)(B) === 32, "invalid s", "value", B);
      const M = (0, i.hexlify)(B);
      (0, i.assertArgument)(parseInt(M.substring(0, 3)) < 8, "non-canonical s", "value", M), Ne(this, t, M);
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */
    get v() {
      return ae(this, r);
    }
    set v(B) {
      const M = (0, i.getNumber)(B, "value");
      (0, i.assertArgument)(M === 27 || M === 28, "invalid v", "v", B), Ne(this, r, M);
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */
    get networkV() {
      return ae(this, n);
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */
    get legacyChainId() {
      const B = this.networkV;
      return B == null ? null : is.getChainId(B);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */
    get yParity() {
      return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */
    get yParityAndS() {
      const B = (0, i.getBytes)(this.s);
      return this.yParity && (B[0] |= 128), (0, i.hexlify)(B);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */
    get compactSerialized() {
      return (0, i.concat)([this.r, this.yParityAndS]);
    }
    /**
     *  The serialized representation.
     */
    get serialized() {
      return (0, i.concat)([this.r, this.s, this.yParity ? "0x1c" : "0x1b"]);
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
      return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */
    clone() {
      const B = new is(v, this.r, this.s, this.v);
      return this.networkV && Ne(B, n, this.networkV), B;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */
    toJSON() {
      const B = this.networkV;
      return {
        _type: "signature",
        networkV: B != null ? B.toString() : null,
        r: this.r,
        s: this.s,
        v: this.v
      };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */
    static getChainId(B) {
      const M = (0, i.getBigInt)(B, "v");
      return M == c || M == p ? a : ((0, i.assertArgument)(M >= g, "invalid EIP-155 v", "v", B), (M - g) / d);
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */
    static getChainIdV(B, M) {
      return (0, i.getBigInt)(B) * d + BigInt(35 + M - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */
    static getNormalizedV(B) {
      const M = (0, i.getBigInt)(B);
      return M === a || M === c ? 27 : M === f || M === p ? 28 : ((0, i.assertArgument)(M >= g, "invalid v", "v", B), M & f ? 27 : 28);
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */
    static from(B) {
      function M(k, V) {
        (0, i.assertArgument)(k, V, "signature", B);
      }
      if (B == null)
        return new is(v, s.ZeroHash, s.ZeroHash, 27);
      if (typeof B == "string") {
        const k = (0, i.getBytes)(B, "signature");
        if (k.length === 64) {
          const V = (0, i.hexlify)(k.slice(0, 32)), C = k.slice(32, 64), D = C[0] & 128 ? 28 : 27;
          return C[0] &= 127, new is(v, V, (0, i.hexlify)(C), D);
        }
        if (k.length === 65) {
          const V = (0, i.hexlify)(k.slice(0, 32)), C = k.slice(32, 64);
          M((C[0] & 128) === 0, "non-canonical s");
          const D = is.getNormalizedV(k[64]);
          return new is(v, V, (0, i.hexlify)(C), D);
        }
        M(!1, "invalid raw signature length");
      }
      if (B instanceof is)
        return B.clone();
      const I = B.r;
      M(I != null, "missing r");
      const A = O(I), R = function(k, V) {
        if (k != null)
          return O(k);
        if (V != null) {
          M((0, i.isHexString)(V, 32), "invalid yParityAndS");
          const C = (0, i.getBytes)(V);
          return C[0] &= 127, (0, i.hexlify)(C);
        }
        M(!1, "missing s");
      }(B.s, B.yParityAndS);
      M(((0, i.getBytes)(R)[0] & 128) == 0, "non-canonical s");
      const { networkV: L, v: K } = function(k, V, C) {
        if (k != null) {
          const D = (0, i.getBigInt)(k);
          return {
            networkV: D >= g ? D : void 0,
            v: is.getNormalizedV(D)
          };
        }
        if (V != null)
          return M((0, i.isHexString)(V, 32), "invalid yParityAndS"), { v: (0, i.getBytes)(V)[0] & 128 ? 28 : 27 };
        if (C != null) {
          switch ((0, i.getNumber)(C, "sig.yParity")) {
            case 0:
              return { v: 27 };
            case 1:
              return { v: 28 };
          }
          M(!1, "invalid yParity");
        }
        M(!1, "missing v");
      }(B.v, B.yParityAndS, B.yParity), $ = new is(v, A, R, K);
      return L && Ne($, n, L), M(B.yParity == null || (0, i.getNumber)(B.yParity, "sig.yParity") === $.yParity, "yParity mismatch"), M(B.yParityAndS == null || B.yParityAndS === $.yParityAndS, "yParityAndS mismatch"), $;
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  let S = N;
  return Rl.Signature = S, Rl;
}
var g6;
function $M() {
  var e;
  if (g6)
    return Il;
  g6 = 1, Object.defineProperty(Il, "__esModule", { value: !0 }), Il.SigningKey = void 0;
  const t = GM(), r = vt(), n = n7(), s = class Au {
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */
    constructor(f) {
      Fe(this, e, void 0), (0, r.assertArgument)((0, r.dataLength)(f) === 32, "invalid private key", "privateKey", "[REDACTED]"), Ne(this, e, (0, r.hexlify)(f));
    }
    /**
     *  The private key.
     */
    get privateKey() {
      return ae(this, e);
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */
    get publicKey() {
      return Au.computePublicKey(ae(this, e));
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */
    get compressedPublicKey() {
      return Au.computePublicKey(ae(this, e), !0);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */
    sign(f) {
      (0, r.assertArgument)((0, r.dataLength)(f) === 32, "invalid digest length", "digest", f);
      const d = t.secp256k1.sign((0, r.getBytesCopy)(f), (0, r.getBytesCopy)(ae(this, e)), {
        lowS: !0
      });
      return n.Signature.from({
        r: (0, r.toBeHex)(d.r, 32),
        s: (0, r.toBeHex)(d.s, 32),
        v: d.recovery ? 28 : 27
      });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */
    computeSharedSecret(f) {
      const d = Au.computePublicKey(f);
      return (0, r.hexlify)(t.secp256k1.getSharedSecret((0, r.getBytesCopy)(ae(this, e)), (0, r.getBytes)(d), !1));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */
    static computePublicKey(f, d) {
      let c = (0, r.getBytes)(f, "key");
      if (c.length === 32) {
        const g = t.secp256k1.getPublicKey(c, !!d);
        return (0, r.hexlify)(g);
      }
      if (c.length === 64) {
        const g = new Uint8Array(65);
        g[0] = 4, g.set(c, 1), c = g;
      }
      const p = t.secp256k1.ProjectivePoint.fromHex(c);
      return (0, r.hexlify)(p.toRawBytes(d));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */
    static recoverPublicKey(f, d) {
      (0, r.assertArgument)((0, r.dataLength)(f) === 32, "invalid digest length", "digest", f);
      const c = n.Signature.from(d);
      let p = t.secp256k1.Signature.fromCompact((0, r.getBytesCopy)((0, r.concat)([c.r, c.s])));
      p = p.addRecoveryBit(c.yParity);
      const g = p.recoverPublicKey((0, r.getBytesCopy)(f));
      return (0, r.assertArgument)(g != null, "invalid signautre for digest", "signature", d), "0x" + g.toHex(!1);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */
    static addPoints(f, d, c) {
      const p = t.secp256k1.ProjectivePoint.fromHex(Au.computePublicKey(f).substring(2)), g = t.secp256k1.ProjectivePoint.fromHex(Au.computePublicKey(d).substring(2));
      return "0x" + p.add(g).toHex(!!c);
    }
  };
  e = /* @__PURE__ */ new WeakMap();
  let i = s;
  return Il.SigningKey = i, Il;
}
var m6;
function ln() {
  return m6 || (m6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.lock = e.Signature = e.SigningKey = e.scryptSync = e.scrypt = e.pbkdf2 = e.sha512 = e.sha256 = e.ripemd160 = e.keccak256 = e.randomBytes = e.computeHmac = void 0;
    const t = MM();
    Object.defineProperty(e, "computeHmac", { enumerable: !0, get: function() {
      return t.computeHmac;
    } });
    const r = RM();
    Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
      return r.keccak256;
    } });
    const n = BM();
    Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
      return n.ripemd160;
    } });
    const s = _M();
    Object.defineProperty(e, "pbkdf2", { enumerable: !0, get: function() {
      return s.pbkdf2;
    } });
    const i = FM();
    Object.defineProperty(e, "randomBytes", { enumerable: !0, get: function() {
      return i.randomBytes;
    } });
    const a = DM();
    Object.defineProperty(e, "scrypt", { enumerable: !0, get: function() {
      return a.scrypt;
    } }), Object.defineProperty(e, "scryptSync", { enumerable: !0, get: function() {
      return a.scryptSync;
    } });
    const f = jM();
    Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
      return f.sha256;
    } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
      return f.sha512;
    } });
    var d = $M();
    Object.defineProperty(e, "SigningKey", { enumerable: !0, get: function() {
      return d.SigningKey;
    } });
    var c = n7();
    Object.defineProperty(e, "Signature", { enumerable: !0, get: function() {
      return c.Signature;
    } });
    function p() {
      t.computeHmac.lock(), r.keccak256.lock(), s.pbkdf2.lock(), i.randomBytes.lock(), n.ripemd160.lock(), a.scrypt.lock(), a.scryptSync.lock(), f.sha256.lock(), f.sha512.lock(), i.randomBytes.lock();
    }
    e.lock = p;
  }(Mb)), Mb;
}
var y6;
function J1() {
  if (y6)
    return ma;
  y6 = 1, Object.defineProperty(ma, "__esModule", { value: !0 }), ma.getIcapAddress = ma.getAddress = void 0;
  const e = ln(), t = vt(), r = BigInt(0), n = BigInt(36);
  function s(v) {
    v = v.toLowerCase();
    const O = v.substring(2).split(""), N = new Uint8Array(40);
    for (let j = 0; j < 40; j++)
      N[j] = O[j].charCodeAt(0);
    const S = (0, t.getBytes)((0, e.keccak256)(N));
    for (let j = 0; j < 40; j += 2)
      S[j >> 1] >> 4 >= 8 && (O[j] = O[j].toUpperCase()), (S[j >> 1] & 15) >= 8 && (O[j + 1] = O[j + 1].toUpperCase());
    return "0x" + O.join("");
  }
  const i = {};
  for (let v = 0; v < 10; v++)
    i[String(v)] = String(v);
  for (let v = 0; v < 26; v++)
    i[String.fromCharCode(65 + v)] = String(10 + v);
  const a = 15;
  function f(v) {
    v = v.toUpperCase(), v = v.substring(4) + v.substring(0, 2) + "00";
    let O = v.split("").map((S) => i[S]).join("");
    for (; O.length >= a; ) {
      let S = O.substring(0, a);
      O = parseInt(S, 10) % 97 + O.substring(S.length);
    }
    let N = String(98 - parseInt(O, 10) % 97);
    for (; N.length < 2; )
      N = "0" + N;
    return N;
  }
  const d = function() {
    const v = {};
    for (let O = 0; O < 36; O++) {
      const N = "0123456789abcdefghijklmnopqrstuvwxyz"[O];
      v[N] = BigInt(O);
    }
    return v;
  }();
  function c(v) {
    v = v.toLowerCase();
    let O = r;
    for (let N = 0; N < v.length; N++)
      O = O * n + d[v[N]];
    return O;
  }
  function p(v) {
    if ((0, t.assertArgument)(typeof v == "string", "invalid address", "address", v), v.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
      v.startsWith("0x") || (v = "0x" + v);
      const O = s(v);
      return (0, t.assertArgument)(!v.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || O === v, "bad address checksum", "address", v), O;
    }
    if (v.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
      (0, t.assertArgument)(v.substring(2, 4) === f(v), "bad icap checksum", "address", v);
      let O = c(v.substring(4)).toString(16);
      for (; O.length < 40; )
        O = "0" + O;
      return s("0x" + O);
    }
    (0, t.assertArgument)(!1, "invalid address", "address", v);
  }
  ma.getAddress = p;
  function g(v) {
    let O = BigInt(p(v)).toString(36).toUpperCase();
    for (; O.length < 30; )
      O = "0" + O;
    return "XE" + f("XE00" + O) + O;
  }
  return ma.getIcapAddress = g, ma;
}
var Na = {}, b6;
function KM() {
  if (b6)
    return Na;
  b6 = 1, Object.defineProperty(Na, "__esModule", { value: !0 }), Na.getCreate2Address = Na.getCreateAddress = void 0;
  const e = ln(), t = vt(), r = J1();
  function n(i) {
    const a = (0, r.getAddress)(i.from);
    let f = (0, t.getBigInt)(i.nonce, "tx.nonce").toString(16);
    return f === "0" ? f = "0x" : f.length % 2 ? f = "0x0" + f : f = "0x" + f, (0, r.getAddress)((0, t.dataSlice)((0, e.keccak256)((0, t.encodeRlp)([a, f])), 12));
  }
  Na.getCreateAddress = n;
  function s(i, a, f) {
    const d = (0, r.getAddress)(i), c = (0, t.getBytes)(a, "salt"), p = (0, t.getBytes)(f, "initCodeHash");
    return (0, t.assertArgument)(c.length === 32, "salt must be 32 bytes", "salt", a), (0, t.assertArgument)(p.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", f), (0, r.getAddress)((0, t.dataSlice)((0, e.keccak256)((0, t.concat)(["0xff", d, c, p])), 12));
  }
  return Na.getCreate2Address = s, Na;
}
var Is = {}, w6;
function JM() {
  if (w6)
    return Is;
  w6 = 1, Object.defineProperty(Is, "__esModule", { value: !0 }), Is.resolveAddress = Is.isAddress = Is.isAddressable = void 0;
  const e = vt(), t = J1();
  function r(a) {
    return a && typeof a.getAddress == "function";
  }
  Is.isAddressable = r;
  function n(a) {
    try {
      return (0, t.getAddress)(a), !0;
    } catch {
    }
    return !1;
  }
  Is.isAddress = n;
  async function s(a, f) {
    const d = await f;
    return (d == null || d === "0x0000000000000000000000000000000000000000") && ((0, e.assert)(typeof a != "string", "unconfigured name", "UNCONFIGURED_NAME", { value: a }), (0, e.assertArgument)(!1, "invalid AddressLike value; did not resolve to a value address", "target", a)), (0, t.getAddress)(d);
  }
  function i(a, f) {
    if (typeof a == "string")
      return a.match(/^0x[0-9a-f]{40}$/i) ? (0, t.getAddress)(a) : ((0, e.assert)(f != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" }), s(a, f.resolveName(a)));
    if (r(a))
      return s(a, a.getAddress());
    if (a && typeof a.then == "function")
      return s(a, a);
    (0, e.assertArgument)(!1, "unsupported addressable value", "target", a);
  }
  return Is.resolveAddress = i, Is;
}
var v6;
function Xr() {
  return v6 || (v6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.resolveAddress = e.isAddress = e.isAddressable = e.getCreate2Address = e.getCreateAddress = e.getIcapAddress = e.getAddress = void 0;
    var t = J1();
    Object.defineProperty(e, "getAddress", { enumerable: !0, get: function() {
      return t.getAddress;
    } }), Object.defineProperty(e, "getIcapAddress", { enumerable: !0, get: function() {
      return t.getIcapAddress;
    } });
    var r = KM();
    Object.defineProperty(e, "getCreateAddress", { enumerable: !0, get: function() {
      return r.getCreateAddress;
    } }), Object.defineProperty(e, "getCreate2Address", { enumerable: !0, get: function() {
      return r.getCreate2Address;
    } });
    var n = JM();
    Object.defineProperty(e, "isAddressable", { enumerable: !0, get: function() {
      return n.isAddressable;
    } }), Object.defineProperty(e, "isAddress", { enumerable: !0, get: function() {
      return n.isAddress;
    } }), Object.defineProperty(e, "resolveAddress", { enumerable: !0, get: function() {
      return n.resolveAddress;
    } });
  }(Sb)), Sb;
}
var Cl = {}, A6;
function io() {
  var e;
  if (A6)
    return Cl;
  A6 = 1, Object.defineProperty(Cl, "__esModule", { value: !0 }), Cl.Typed = void 0;
  const t = vt(), r = {};
  function n(d, c) {
    let p = !1;
    return c < 0 && (p = !0, c *= -1), new f(r, `${p ? "" : "u"}int${c}`, d, { signed: p, width: c });
  }
  function s(d, c) {
    return new f(r, `bytes${c || ""}`, d, { size: c });
  }
  const i = Symbol.for("_ethers_typed"), a = class ho {
    /**
     *  @_ignore:
     */
    constructor(c, p, g, v) {
      Se(this, "type"), Se(this, "value"), Fe(this, e, void 0), Se(this, "_typedSymbol"), v == null && (v = null), (0, t.assertPrivate)(r, c, "Typed"), (0, t.defineProperties)(this, { _typedSymbol: i, type: p, value: g }), Ne(this, e, v), this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */
    format() {
      if (this.type === "array")
        throw new Error("");
      if (this.type === "dynamicArray")
        throw new Error("");
      return this.type === "tuple" ? `tuple(${this.value.map((c) => c.format()).join(",")})` : this.type;
    }
    /**
     *  The default value returned by this type.
     */
    defaultValue() {
      return 0;
    }
    /**
     *  The minimum value for numeric types.
     */
    minValue() {
      return 0;
    }
    /**
     *  The maximum value for numeric types.
     */
    maxValue() {
      return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */
    isBigInt() {
      return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */
    isData() {
      return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */
    isString() {
      return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */
    get tupleName() {
      if (this.type !== "tuple")
        throw TypeError("not a tuple");
      return ae(this, e);
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */
    get arrayLength() {
      if (this.type !== "array")
        throw TypeError("not an array");
      return ae(this, e) === !0 ? -1 : ae(this, e) === !1 ? this.value.length : null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */
    static from(c, p) {
      return new ho(r, c, p);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
    static uint8(c) {
      return n(c, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */
    static uint16(c) {
      return n(c, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */
    static uint24(c) {
      return n(c, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */
    static uint32(c) {
      return n(c, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */
    static uint40(c) {
      return n(c, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */
    static uint48(c) {
      return n(c, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */
    static uint56(c) {
      return n(c, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */
    static uint64(c) {
      return n(c, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */
    static uint72(c) {
      return n(c, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */
    static uint80(c) {
      return n(c, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */
    static uint88(c) {
      return n(c, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */
    static uint96(c) {
      return n(c, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */
    static uint104(c) {
      return n(c, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */
    static uint112(c) {
      return n(c, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */
    static uint120(c) {
      return n(c, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */
    static uint128(c) {
      return n(c, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */
    static uint136(c) {
      return n(c, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */
    static uint144(c) {
      return n(c, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */
    static uint152(c) {
      return n(c, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */
    static uint160(c) {
      return n(c, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */
    static uint168(c) {
      return n(c, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */
    static uint176(c) {
      return n(c, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */
    static uint184(c) {
      return n(c, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */
    static uint192(c) {
      return n(c, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */
    static uint200(c) {
      return n(c, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */
    static uint208(c) {
      return n(c, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */
    static uint216(c) {
      return n(c, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */
    static uint224(c) {
      return n(c, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */
    static uint232(c) {
      return n(c, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */
    static uint240(c) {
      return n(c, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */
    static uint248(c) {
      return n(c, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
    static uint256(c) {
      return n(c, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
    static uint(c) {
      return n(c, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */
    static int8(c) {
      return n(c, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */
    static int16(c) {
      return n(c, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */
    static int24(c) {
      return n(c, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */
    static int32(c) {
      return n(c, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */
    static int40(c) {
      return n(c, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */
    static int48(c) {
      return n(c, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */
    static int56(c) {
      return n(c, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */
    static int64(c) {
      return n(c, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */
    static int72(c) {
      return n(c, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */
    static int80(c) {
      return n(c, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */
    static int88(c) {
      return n(c, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */
    static int96(c) {
      return n(c, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */
    static int104(c) {
      return n(c, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */
    static int112(c) {
      return n(c, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */
    static int120(c) {
      return n(c, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */
    static int128(c) {
      return n(c, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */
    static int136(c) {
      return n(c, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */
    static int144(c) {
      return n(c, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */
    static int152(c) {
      return n(c, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */
    static int160(c) {
      return n(c, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */
    static int168(c) {
      return n(c, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */
    static int176(c) {
      return n(c, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */
    static int184(c) {
      return n(c, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */
    static int192(c) {
      return n(c, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */
    static int200(c) {
      return n(c, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */
    static int208(c) {
      return n(c, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */
    static int216(c) {
      return n(c, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */
    static int224(c) {
      return n(c, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */
    static int232(c) {
      return n(c, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */
    static int240(c) {
      return n(c, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */
    static int248(c) {
      return n(c, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
    static int256(c) {
      return n(c, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
    static int(c) {
      return n(c, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */
    static bytes1(c) {
      return s(c, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */
    static bytes2(c) {
      return s(c, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */
    static bytes3(c) {
      return s(c, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */
    static bytes4(c) {
      return s(c, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */
    static bytes5(c) {
      return s(c, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */
    static bytes6(c) {
      return s(c, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */
    static bytes7(c) {
      return s(c, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */
    static bytes8(c) {
      return s(c, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */
    static bytes9(c) {
      return s(c, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */
    static bytes10(c) {
      return s(c, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */
    static bytes11(c) {
      return s(c, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */
    static bytes12(c) {
      return s(c, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */
    static bytes13(c) {
      return s(c, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */
    static bytes14(c) {
      return s(c, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */
    static bytes15(c) {
      return s(c, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */
    static bytes16(c) {
      return s(c, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */
    static bytes17(c) {
      return s(c, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */
    static bytes18(c) {
      return s(c, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */
    static bytes19(c) {
      return s(c, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */
    static bytes20(c) {
      return s(c, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */
    static bytes21(c) {
      return s(c, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */
    static bytes22(c) {
      return s(c, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */
    static bytes23(c) {
      return s(c, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */
    static bytes24(c) {
      return s(c, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */
    static bytes25(c) {
      return s(c, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */
    static bytes26(c) {
      return s(c, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */
    static bytes27(c) {
      return s(c, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */
    static bytes28(c) {
      return s(c, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */
    static bytes29(c) {
      return s(c, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */
    static bytes30(c) {
      return s(c, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */
    static bytes31(c) {
      return s(c, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */
    static bytes32(c) {
      return s(c, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */
    static address(c) {
      return new ho(r, "address", c);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */
    static bool(c) {
      return new ho(r, "bool", !!c);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */
    static bytes(c) {
      return new ho(r, "bytes", c);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */
    static string(c) {
      return new ho(r, "string", c);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */
    static array(c, p) {
      throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */
    static tuple(c, p) {
      throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
    static overrides(c) {
      return new ho(r, "overrides", Object.assign({}, c));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */
    static isTyped(c) {
      return c && typeof c == "object" && "_typedSymbol" in c && c._typedSymbol === i;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */
    static dereference(c, p) {
      if (ho.isTyped(c)) {
        if (c.type !== p)
          throw new Error(`invalid type: expecetd ${p}, got ${c.type}`);
        return c.value;
      }
      return c;
    }
  };
  e = /* @__PURE__ */ new WeakMap();
  let f = a;
  return Cl.Typed = f, Cl;
}
var E6;
function QM() {
  if (E6)
    return Ol;
  E6 = 1, Object.defineProperty(Ol, "__esModule", { value: !0 }), Ol.AddressCoder = void 0;
  const e = Xr(), t = wd(), r = io(), n = Yi();
  class s extends n.Coder {
    constructor(a) {
      super("address", "address", a, !1);
    }
    defaultValue() {
      return "0x0000000000000000000000000000000000000000";
    }
    encode(a, f) {
      let d = r.Typed.dereference(f, "string");
      try {
        d = (0, e.getAddress)(d);
      } catch (c) {
        return this._throwError(c.message, f);
      }
      return a.writeValue(d);
    }
    decode(a) {
      return (0, e.getAddress)((0, t.toBeHex)(a.readValue(), 20));
    }
  }
  return Ol.AddressCoder = s, Ol;
}
var Rs = {}, Bl = {}, P6;
function ZM() {
  if (P6)
    return Bl;
  P6 = 1, Object.defineProperty(Bl, "__esModule", { value: !0 }), Bl.AnonymousCoder = void 0;
  const e = Yi();
  class t extends e.Coder {
    constructor(n) {
      super(n.name, n.type, "_", n.dynamic), Se(this, "coder"), this.coder = n;
    }
    defaultValue() {
      return this.coder.defaultValue();
    }
    encode(n, s) {
      return this.coder.encode(n, s);
    }
    decode(n) {
      return this.coder.decode(n);
    }
  }
  return Bl.AnonymousCoder = t, Bl;
}
var O6;
function i7() {
  if (O6)
    return Rs;
  O6 = 1, Object.defineProperty(Rs, "__esModule", { value: !0 }), Rs.ArrayCoder = Rs.unpack = Rs.pack = void 0;
  const e = vt(), t = io(), r = Yi(), n = ZM();
  function s(f, d, c) {
    let p = [];
    if (Array.isArray(c))
      p = c;
    else if (c && typeof c == "object") {
      let S = {};
      p = d.map((j) => {
        const B = j.localName;
        return (0, e.assert)(B, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder: j }, value: c }), (0, e.assert)(!S[B], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder: j }, value: c }), S[B] = !0, c[B];
      });
    } else
      (0, e.assertArgument)(!1, "invalid tuple value", "tuple", c);
    (0, e.assertArgument)(d.length === p.length, "types/value length mismatch", "tuple", c);
    let g = new r.Writer(), v = new r.Writer(), O = [];
    d.forEach((S, j) => {
      let B = p[j];
      if (S.dynamic) {
        let M = v.length;
        S.encode(v, B);
        let I = g.writeUpdatableValue();
        O.push((A) => {
          I(A + M);
        });
      } else
        S.encode(g, B);
    }), O.forEach((S) => {
      S(g.length);
    });
    let N = f.appendWriter(g);
    return N += f.appendWriter(v), N;
  }
  Rs.pack = s;
  function i(f, d) {
    let c = [], p = [], g = f.subReader(0);
    return d.forEach((v) => {
      let O = null;
      if (v.dynamic) {
        let N = f.readIndex(), S = g.subReader(N);
        try {
          O = v.decode(S);
        } catch (j) {
          if ((0, e.isError)(j, "BUFFER_OVERRUN"))
            throw j;
          O = j, O.baseType = v.name, O.name = v.localName, O.type = v.type;
        }
      } else
        try {
          O = v.decode(f);
        } catch (N) {
          if ((0, e.isError)(N, "BUFFER_OVERRUN"))
            throw N;
          O = N, O.baseType = v.name, O.name = v.localName, O.type = v.type;
        }
      if (O == null)
        throw new Error("investigate");
      c.push(O), p.push(v.localName || null);
    }), r.Result.fromItems(c, p);
  }
  Rs.unpack = i;
  class a extends r.Coder {
    constructor(d, c, p) {
      const g = d.type + "[" + (c >= 0 ? c : "") + "]", v = c === -1 || d.dynamic;
      super("array", g, p, v), Se(this, "coder"), Se(this, "length"), (0, e.defineProperties)(this, { coder: d, length: c });
    }
    defaultValue() {
      const d = this.coder.defaultValue(), c = [];
      for (let p = 0; p < this.length; p++)
        c.push(d);
      return c;
    }
    encode(d, c) {
      const p = t.Typed.dereference(c, "array");
      Array.isArray(p) || this._throwError("expected array value", p);
      let g = this.length;
      g === -1 && (g = p.length, d.writeValue(p.length)), (0, e.assertArgumentCount)(p.length, g, "coder array" + (this.localName ? " " + this.localName : ""));
      let v = [];
      for (let O = 0; O < p.length; O++)
        v.push(this.coder);
      return s(d, v, p);
    }
    decode(d) {
      let c = this.length;
      c === -1 && (c = d.readIndex(), (0, e.assert)(c * r.WordSize <= d.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: d.bytes, offset: c * r.WordSize, length: d.dataLength }));
      let p = [];
      for (let g = 0; g < c; g++)
        p.push(new n.AnonymousCoder(this.coder));
      return i(d, p);
    }
  }
  return Rs.ArrayCoder = a, Rs;
}
var _l = {}, N6;
function YM() {
  if (N6)
    return _l;
  N6 = 1, Object.defineProperty(_l, "__esModule", { value: !0 }), _l.BooleanCoder = void 0;
  const e = io(), t = Yi();
  class r extends t.Coder {
    constructor(s) {
      super("bool", "bool", s, !1);
    }
    defaultValue() {
      return !1;
    }
    encode(s, i) {
      const a = e.Typed.dereference(i, "bool");
      return s.writeValue(a ? 1 : 0);
    }
    decode(s) {
      return !!s.readValue();
    }
  }
  return _l.BooleanCoder = r, _l;
}
var xa = {}, x6;
function s7() {
  if (x6)
    return xa;
  x6 = 1, Object.defineProperty(xa, "__esModule", { value: !0 }), xa.BytesCoder = xa.DynamicBytesCoder = void 0;
  const e = vt(), t = Yi();
  class r extends t.Coder {
    constructor(i, a) {
      super(i, i, a, !0);
    }
    defaultValue() {
      return "0x";
    }
    encode(i, a) {
      a = (0, e.getBytesCopy)(a);
      let f = i.writeValue(a.length);
      return f += i.writeBytes(a), f;
    }
    decode(i) {
      return i.readBytes(i.readIndex(), !0);
    }
  }
  xa.DynamicBytesCoder = r;
  class n extends r {
    constructor(i) {
      super("bytes", i);
    }
    decode(i) {
      return (0, e.hexlify)(super.decode(i));
    }
  }
  return xa.BytesCoder = n, xa;
}
var Fl = {}, T6;
function XM() {
  if (T6)
    return Fl;
  T6 = 1, Object.defineProperty(Fl, "__esModule", { value: !0 }), Fl.FixedBytesCoder = void 0;
  const e = vt(), t = io(), r = Yi();
  class n extends r.Coder {
    constructor(i, a) {
      let f = "bytes" + String(i);
      super(f, f, a, !1), Se(this, "size"), (0, e.defineProperties)(this, { size: i }, { size: "number" });
    }
    defaultValue() {
      return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(i, a) {
      let f = (0, e.getBytesCopy)(t.Typed.dereference(a, this.type));
      return f.length !== this.size && this._throwError("incorrect data length", a), i.writeBytes(f);
    }
    decode(i) {
      return (0, e.hexlify)(i.readBytes(this.size));
    }
  }
  return Fl.FixedBytesCoder = n, Fl;
}
var Ul = {}, k6;
function eI() {
  if (k6)
    return Ul;
  k6 = 1, Object.defineProperty(Ul, "__esModule", { value: !0 }), Ul.NullCoder = void 0;
  const e = Yi(), t = new Uint8Array([]);
  class r extends e.Coder {
    constructor(s) {
      super("null", "", s, !1);
    }
    defaultValue() {
      return null;
    }
    encode(s, i) {
      return i != null && this._throwError("not null", i), s.writeBytes(t);
    }
    decode(s) {
      return s.readBytes(0), null;
    }
  }
  return Ul.NullCoder = r, Ul;
}
var Dl = {}, S6;
function tI() {
  if (S6)
    return Dl;
  S6 = 1, Object.defineProperty(Dl, "__esModule", { value: !0 }), Dl.NumberCoder = void 0;
  const e = vt(), t = io(), r = Yi(), n = BigInt(0), s = BigInt(1), i = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
  class a extends r.Coder {
    constructor(d, c, p) {
      const g = (c ? "int" : "uint") + d * 8;
      super(g, g, p, !1), Se(this, "size"), Se(this, "signed"), (0, e.defineProperties)(this, { size: d, signed: c }, { size: "number", signed: "boolean" });
    }
    defaultValue() {
      return 0;
    }
    encode(d, c) {
      let p = (0, e.getBigInt)(t.Typed.dereference(c, this.type)), g = (0, e.mask)(i, r.WordSize * 8);
      if (this.signed) {
        let v = (0, e.mask)(g, this.size * 8 - 1);
        (p > v || p < -(v + s)) && this._throwError("value out-of-bounds", c), p = (0, e.toTwos)(p, 8 * r.WordSize);
      } else
        (p < n || p > (0, e.mask)(g, this.size * 8)) && this._throwError("value out-of-bounds", c);
      return d.writeValue(p);
    }
    decode(d) {
      let c = (0, e.mask)(d.readValue(), this.size * 8);
      return this.signed && (c = (0, e.fromTwos)(c, this.size * 8)), c;
    }
  }
  return Dl.NumberCoder = a, Dl;
}
var jl = {}, M6;
function rI() {
  if (M6)
    return jl;
  M6 = 1, Object.defineProperty(jl, "__esModule", { value: !0 }), jl.StringCoder = void 0;
  const e = V1(), t = io(), r = s7();
  class n extends r.DynamicBytesCoder {
    constructor(i) {
      super("string", i);
    }
    defaultValue() {
      return "";
    }
    encode(i, a) {
      return super.encode(i, (0, e.toUtf8Bytes)(t.Typed.dereference(a, "string")));
    }
    decode(i) {
      return (0, e.toUtf8String)(super.decode(i));
    }
  }
  return jl.StringCoder = n, jl;
}
var Ll = {}, I6;
function nI() {
  if (I6)
    return Ll;
  I6 = 1, Object.defineProperty(Ll, "__esModule", { value: !0 }), Ll.TupleCoder = void 0;
  const e = nu(), t = io(), r = Yi(), n = i7();
  class s extends r.Coder {
    constructor(a, f) {
      let d = !1;
      const c = [];
      a.forEach((g) => {
        g.dynamic && (d = !0), c.push(g.type);
      });
      const p = "tuple(" + c.join(",") + ")";
      super("tuple", p, f, d), Se(this, "coders"), (0, e.defineProperties)(this, { coders: Object.freeze(a.slice()) });
    }
    defaultValue() {
      const a = [];
      this.coders.forEach((d) => {
        a.push(d.defaultValue());
      });
      const f = this.coders.reduce((d, c) => {
        const p = c.localName;
        return p && (d[p] || (d[p] = 0), d[p]++), d;
      }, {});
      return this.coders.forEach((d, c) => {
        let p = d.localName;
        !p || f[p] !== 1 || (p === "length" && (p = "_length"), a[p] == null && (a[p] = a[c]));
      }), Object.freeze(a);
    }
    encode(a, f) {
      const d = t.Typed.dereference(f, "tuple");
      return (0, n.pack)(a, this.coders, d);
    }
    decode(a) {
      return (0, n.unpack)(a, this.coders);
    }
  }
  return Ll.TupleCoder = s, Ll;
}
var Gr = {}, R6 = {}, Hl = {}, C6;
function o7() {
  if (C6)
    return Hl;
  C6 = 1, Object.defineProperty(Hl, "__esModule", { value: !0 }), Hl.id = void 0;
  const e = ln(), t = vt();
  function r(n) {
    return (0, e.keccak256)((0, t.toUtf8Bytes)(n));
  }
  return Hl.id = r, Hl;
}
var ki = {}, Vn = {}, B6;
function iI() {
  if (B6)
    return Vn;
  B6 = 1;
  var e = "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";
  const t = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]), r = 4;
  function n(J) {
    let Y = 0;
    function ee() {
      return J[Y++] << 8 | J[Y++];
    }
    let se = ee(), le = 1, Ae = [0, 1];
    for (let wr = 1; wr < se; wr++)
      Ae.push(le += ee());
    let Te = ee(), Ie = Y;
    Y += Te;
    let We = 0, Ke = 0;
    function Le() {
      return We == 0 && (Ke = Ke << 8 | J[Y++], We = 8), Ke >> --We & 1;
    }
    const De = 31, Ge = 2 ** De, Ct = Ge >>> 1, Mt = Ct >> 1, Lt = Ge - 1;
    let Jt = 0;
    for (let wr = 0; wr < De; wr++)
      Jt = Jt << 1 | Le();
    let pr = [], Hr = 0, gr = Ge;
    for (; ; ) {
      let wr = Math.floor(((Jt - Hr + 1) * le - 1) / gr), Cr = 0, er = se;
      for (; er - Cr > 1; ) {
        let Fo = Cr + er >>> 1;
        wr < Ae[Fo] ? er = Fo : Cr = Fo;
      }
      if (Cr == 0)
        break;
      pr.push(Cr);
      let ht = Hr + Math.floor(gr * Ae[Cr] / le), yn = Hr + Math.floor(gr * Ae[Cr + 1] / le) - 1;
      for (; !((ht ^ yn) & Ct); )
        Jt = Jt << 1 & Lt | Le(), ht = ht << 1 & Lt, yn = yn << 1 & Lt | 1;
      for (; ht & ~yn & Mt; )
        Jt = Jt & Ct | Jt << 1 & Lt >>> 1 | Le(), ht = ht << 1 ^ Ct, yn = (yn ^ Ct) << 1 | Ct | 1;
      Hr = ht, gr = 1 + yn - ht;
    }
    let $r = se - 4;
    return pr.map((wr) => {
      switch (wr - $r) {
        case 3:
          return $r + 65792 + (J[Ie++] << 16 | J[Ie++] << 8 | J[Ie++]);
        case 2:
          return $r + 256 + (J[Ie++] << 8 | J[Ie++]);
        case 1:
          return $r + J[Ie++];
        default:
          return wr - 1;
      }
    });
  }
  function s(J) {
    let Y = 0;
    return () => J[Y++];
  }
  function i(J) {
    return s(n(a(J)));
  }
  function a(J) {
    let Y = [];
    [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((le, Ae) => Y[le.charCodeAt(0)] = Ae);
    let ee = J.length, se = new Uint8Array(6 * ee >> 3);
    for (let le = 0, Ae = 0, Te = 0, Ie = 0; le < ee; le++)
      Ie = Ie << 6 | Y[J.charCodeAt(le)], Te += 6, Te >= 8 && (se[Ae++] = Ie >> (Te -= 8));
    return se;
  }
  function f(J) {
    return J & 1 ? ~J >> 1 : J >> 1;
  }
  function d(J, Y) {
    let ee = Array(J);
    for (let se = 0, le = 0; se < J; se++)
      ee[se] = le += f(Y());
    return ee;
  }
  function c(J, Y = 0) {
    let ee = [];
    for (; ; ) {
      let se = J(), le = J();
      if (!le)
        break;
      Y += se;
      for (let Ae = 0; Ae < le; Ae++)
        ee.push(Y + Ae);
      Y += le + 1;
    }
    return ee;
  }
  function p(J) {
    return v(() => {
      let Y = c(J);
      if (Y.length)
        return Y;
    });
  }
  function g(J) {
    let Y = [];
    for (; ; ) {
      let ee = J();
      if (ee == 0)
        break;
      Y.push(N(ee, J));
    }
    for (; ; ) {
      let ee = J() - 1;
      if (ee < 0)
        break;
      Y.push(S(ee, J));
    }
    return Y.flat();
  }
  function v(J) {
    let Y = [];
    for (; ; ) {
      let ee = J(Y.length);
      if (!ee)
        break;
      Y.push(ee);
    }
    return Y;
  }
  function O(J, Y, ee) {
    let se = Array(J).fill().map(() => []);
    for (let le = 0; le < Y; le++)
      d(J, ee).forEach((Ae, Te) => se[Te].push(Ae));
    return se;
  }
  function N(J, Y) {
    let ee = 1 + Y(), se = Y(), le = v(Y);
    return O(le.length, 1 + J, Y).flatMap((Ae, Te) => {
      let [Ie, ...We] = Ae;
      return Array(le[Te]).fill().map((Ke, Le) => {
        let De = Le * se;
        return [Ie + Le * ee, We.map((Ge) => Ge + De)];
      });
    });
  }
  function S(J, Y) {
    let ee = 1 + Y();
    return O(ee, 1 + J, Y).map((se) => [se[0], se.slice(1)]);
  }
  function j(J) {
    let Y = [], ee = c(J);
    return le(se([]), []), Y;
    function se(Ae) {
      let Te = J(), Ie = v(() => {
        let We = c(J).map((Ke) => ee[Ke]);
        if (We.length)
          return se(We);
      });
      return { S: Te, B: Ie, Q: Ae };
    }
    function le({ S: Ae, B: Te }, Ie, We) {
      if (!(Ae & 4 && We === Ie[Ie.length - 1])) {
        Ae & 2 && (We = Ie[Ie.length - 1]), Ae & 1 && Y.push(Ie);
        for (let Ke of Te)
          for (let Le of Ke.Q)
            le(Ke, [...Ie, Le], We);
      }
    }
  }
  function B(J) {
    return J.toString(16).toUpperCase().padStart(2, "0");
  }
  function M(J) {
    return `{${B(J)}}`;
  }
  function I(J) {
    let Y = [];
    for (let ee = 0, se = J.length; ee < se; ) {
      let le = J.codePointAt(ee);
      ee += le < 65536 ? 1 : 2, Y.push(le);
    }
    return Y;
  }
  function A(J) {
    let Y = J.length;
    if (Y < 4096)
      return String.fromCodePoint(...J);
    let ee = [];
    for (let se = 0; se < Y; )
      ee.push(String.fromCodePoint(...J.slice(se, se += 4096)));
    return ee.join("");
  }
  function R(J, Y) {
    let ee = J.length, se = ee - Y.length;
    for (let le = 0; se == 0 && le < ee; le++)
      se = J[le] - Y[le];
    return se;
  }
  var L = "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";
  const K = 44032, $ = 4352, k = 4449, V = 4519, C = 19, D = 21, o = 28, u = D * o, h = C * u, y = K + h, E = $ + C, P = k + D, w = V + o;
  function m(J) {
    return J >> 24 & 255;
  }
  function l(J) {
    return J & 16777215;
  }
  let b, W, X, G;
  function re() {
    let J = i(L);
    b = new Map(p(J).flatMap((Y, ee) => Y.map((se) => [se, ee + 1 << 24]))), W = new Set(c(J)), X = /* @__PURE__ */ new Map(), G = /* @__PURE__ */ new Map();
    for (let [Y, ee] of g(J)) {
      if (!W.has(Y) && ee.length == 2) {
        let [se, le] = ee, Ae = G.get(se);
        Ae || (Ae = /* @__PURE__ */ new Map(), G.set(se, Ae)), Ae.set(le, Y);
      }
      X.set(Y, ee.reverse());
    }
  }
  function ce(J) {
    return J >= K && J < y;
  }
  function pe(J, Y) {
    if (J >= $ && J < E && Y >= k && Y < P)
      return K + (J - $) * u + (Y - k) * o;
    if (ce(J) && Y > V && Y < w && (J - K) % o == 0)
      return J + (Y - V);
    {
      let ee = G.get(J);
      return ee && (ee = ee.get(Y), ee) ? ee : -1;
    }
  }
  function ve(J) {
    b || re();
    let Y = [], ee = [], se = !1;
    function le(Ae) {
      let Te = b.get(Ae);
      Te && (se = !0, Ae |= Te), Y.push(Ae);
    }
    for (let Ae of J)
      for (; ; ) {
        if (Ae < 128)
          Y.push(Ae);
        else if (ce(Ae)) {
          let Te = Ae - K, Ie = Te / u | 0, We = Te % u / o | 0, Ke = Te % o;
          le($ + Ie), le(k + We), Ke > 0 && le(V + Ke);
        } else {
          let Te = X.get(Ae);
          Te ? ee.push(...Te) : le(Ae);
        }
        if (!ee.length)
          break;
        Ae = ee.pop();
      }
    if (se && Y.length > 1) {
      let Ae = m(Y[0]);
      for (let Te = 1; Te < Y.length; Te++) {
        let Ie = m(Y[Te]);
        if (Ie == 0 || Ae <= Ie) {
          Ae = Ie;
          continue;
        }
        let We = Te - 1;
        for (; ; ) {
          let Ke = Y[We + 1];
          if (Y[We + 1] = Y[We], Y[We] = Ke, !We || (Ae = m(Y[--We]), Ae <= Ie))
            break;
        }
        Ae = m(Y[Te]);
      }
    }
    return Y;
  }
  function Ee(J) {
    let Y = [], ee = [], se = -1, le = 0;
    for (let Ae of J) {
      let Te = m(Ae), Ie = l(Ae);
      if (se == -1)
        Te == 0 ? se = Ie : Y.push(Ie);
      else if (le > 0 && le >= Te)
        Te == 0 ? (Y.push(se, ...ee), ee.length = 0, se = Ie) : ee.push(Ie), le = Te;
      else {
        let We = pe(se, Ie);
        We >= 0 ? se = We : le == 0 && Te == 0 ? (Y.push(se), se = Ie) : (ee.push(Ie), le = Te);
      }
    }
    return se >= 0 && Y.push(se, ...ee), Y;
  }
  function Pe(J) {
    return ve(J).map(l);
  }
  function xe(J) {
    return Ee(ve(J));
  }
  const me = 45, te = 46, U = ".", ue = 65039, we = 1, ke = (J) => Array.from(J);
  function Re(J, Y) {
    return J.P.has(Y) || J.Q.has(Y);
  }
  class fe extends Array {
    get is_emoji() {
      return !0;
    }
    // free tagging system
  }
  let x, _, q, ne, de, ye, ge, be, Me, Ce, je, Ue;
  function Qe() {
    if (x)
      return;
    let J = i(e);
    const Y = () => c(J), ee = () => new Set(Y()), se = (Le, De) => De.forEach((Ge) => Le.add(Ge));
    x = new Map(g(J)), _ = ee(), q = Y(), ne = new Set(Y().map((Le) => q[Le])), q = new Set(q), de = ee(), ye = ee();
    let le = p(J), Ae = J();
    const Te = () => {
      let Le = /* @__PURE__ */ new Set();
      return Y().forEach((De) => se(Le, le[De])), se(Le, Y()), Le;
    };
    ge = v((Le) => {
      let De = v(J).map((Ge) => Ge + 96);
      if (De.length) {
        let Ge = Le >= Ae;
        De[0] -= 32, De = A(De), Ge && (De = `Restricted[${De}]`);
        let Ct = Te(), Mt = Te(), Lt = !J();
        return { N: De, P: Ct, Q: Mt, M: Lt, R: Ge };
      }
    }), be = ee(), Me = /* @__PURE__ */ new Map();
    let Ie = Y().concat(ke(be)).sort((Le, De) => Le - De);
    Ie.forEach((Le, De) => {
      let Ge = J(), Ct = Ie[De] = Ge ? Ie[De - Ge] : { V: [], M: /* @__PURE__ */ new Map() };
      Ct.V.push(Le), be.has(Le) || Me.set(Le, Ct);
    });
    for (let { V: Le, M: De } of new Set(Me.values())) {
      let Ge = [];
      for (let Mt of Le) {
        let Lt = ge.filter((pr) => Re(pr, Mt)), Jt = Ge.find(({ G: pr }) => Lt.some((Hr) => pr.has(Hr)));
        Jt || (Jt = { G: /* @__PURE__ */ new Set(), V: [] }, Ge.push(Jt)), Jt.V.push(Mt), se(Jt.G, Lt);
      }
      let Ct = Ge.flatMap((Mt) => ke(Mt.G));
      for (let { G: Mt, V: Lt } of Ge) {
        let Jt = new Set(Ct.filter((pr) => !Mt.has(pr)));
        for (let pr of Lt)
          De.set(pr, Jt);
      }
    }
    Ce = /* @__PURE__ */ new Set();
    let We = /* @__PURE__ */ new Set();
    const Ke = (Le) => Ce.has(Le) ? We.add(Le) : Ce.add(Le);
    for (let Le of ge) {
      for (let De of Le.P)
        Ke(De);
      for (let De of Le.Q)
        Ke(De);
    }
    for (let Le of Ce)
      !Me.has(Le) && !We.has(Le) && Me.set(Le, we);
    se(Ce, Pe(Ce)), je = j(J).map((Le) => fe.from(Le)).sort(R), Ue = /* @__PURE__ */ new Map();
    for (let Le of je) {
      let De = [Ue];
      for (let Ge of Le) {
        let Ct = De.map((Mt) => {
          let Lt = Mt.get(Ge);
          return Lt || (Lt = /* @__PURE__ */ new Map(), Mt.set(Ge, Lt)), Lt;
        });
        Ge === ue ? De.push(...Ct) : De = Ct;
      }
      for (let Ge of De)
        Ge.V = Le;
    }
  }
  function Ye(J) {
    return (st(J) ? "" : `${et(Pt([J]))} `) + M(J);
  }
  function et(J) {
    return `"${J}"‎`;
  }
  function At(J) {
    if (J.length >= 4 && J[2] == me && J[3] == me)
      throw new Error(`invalid label extension: "${A(J.slice(0, 4))}"`);
  }
  function it(J) {
    for (let Y = J.lastIndexOf(95); Y > 0; )
      if (J[--Y] !== 95)
        throw new Error("underscore allowed only at start");
  }
  function tt(J) {
    let Y = J[0], ee = t.get(Y);
    if (ee)
      throw It(`leading ${ee}`);
    let se = J.length, le = -1;
    for (let Ae = 1; Ae < se; Ae++) {
      Y = J[Ae];
      let Te = t.get(Y);
      if (Te) {
        if (le == Ae)
          throw It(`${ee} + ${Te}`);
        le = Ae + 1, ee = Te;
      }
    }
    if (le == se)
      throw It(`trailing ${ee}`);
  }
  function Pt(J, Y = 1 / 0, ee = M) {
    let se = [];
    dt(J[0]) && se.push("◌"), J.length > Y && (Y >>= 1, J = [...J.slice(0, Y), 8230, ...J.slice(-Y)]);
    let le = 0, Ae = J.length;
    for (let Te = 0; Te < Ae; Te++) {
      let Ie = J[Te];
      st(Ie) && (se.push(A(J.slice(le, Te))), se.push(ee(Ie)), le = Te + 1);
    }
    return se.push(A(J.slice(le, Ae))), se.join("");
  }
  function dt(J) {
    return Qe(), q.has(J);
  }
  function st(J) {
    return Qe(), de.has(J);
  }
  function zt() {
    return Qe(), je.map((J) => J.slice());
  }
  function xt(J, Y) {
    Qe();
    let ee = Y ? Pe : xe;
    return J.split(U).map((se) => A(ot(I(se), ee, Rt).flat())).join(U);
  }
  function lt(J) {
    return Vt(Ut(J, xe, Rt));
  }
  function $t(J) {
    let Y = Ut(J, xe, (ee) => ee);
    for (let { type: ee, output: se, error: le } of Y) {
      if (le)
        break;
      ee !== "Greek" && Tt(se, 958, 926);
    }
    return Vt(Y);
  }
  function Tt(J, Y, ee) {
    let se = 0;
    for (; ; ) {
      let le = J.indexOf(Y, se);
      if (le < 0)
        break;
      J[le] = ee, se = le + 1;
    }
  }
  function at(J, Y) {
    return Ut(J, xe, Y ? (ee) => ee.slice() : Rt);
  }
  function Ut(J, Y, ee) {
    if (!J)
      return [];
    Qe();
    let se = 0;
    return J.split(U).map((le) => {
      let Ae = I(le), Te = {
        input: Ae,
        offset: se
        // codepoint, not substring!
      };
      se += Ae.length + 1;
      try {
        let Ie = Te.tokens = ot(Ae, Y, ee), We = Ie.length, Ke;
        if (!We)
          throw new Error("empty label");
        let Le = Te.output = Ie.flat();
        if (it(Le), !(Te.emoji = We > 1 || Ie[0].is_emoji) && Le.every((De) => De < 128))
          At(Le), Ke = "ASCII";
        else {
          let De = Ie.flatMap((Ge) => Ge.is_emoji ? [] : Ge);
          if (!De.length)
            Ke = "Emoji";
          else {
            if (q.has(Le[0]))
              throw It("leading combining mark");
            for (let Mt = 1; Mt < We; Mt++) {
              let Lt = Ie[Mt];
              if (!Lt.is_emoji && q.has(Lt[0]))
                throw It(`emoji + combining mark: "${A(Ie[Mt - 1])} + ${Pt([Lt[0]])}"`);
            }
            tt(Le);
            let Ge = ke(new Set(De)), [Ct] = He(Ge);
            kt(Ct, De), Ot(Ct, Ge), Ke = Ct.N;
          }
        }
        Te.type = Ke;
      } catch (Ie) {
        Te.error = Ie;
      }
      return Te;
    });
  }
  function Ot(J, Y) {
    let ee, se = [];
    for (let le of Y) {
      let Ae = Me.get(le);
      if (Ae === we)
        return;
      if (Ae) {
        let Te = Ae.M.get(le);
        if (ee = ee ? ee.filter((Ie) => Te.has(Ie)) : ke(Te), !ee.length)
          return;
      } else
        se.push(le);
    }
    if (ee) {
      for (let le of ee)
        if (se.every((Ae) => Re(le, Ae)))
          throw new Error(`whole-script confusable: ${J.N}/${le.N}`);
    }
  }
  function He(J) {
    let Y = ge;
    for (let ee of J) {
      let se = Y.filter((le) => Re(le, ee));
      if (!se.length)
        throw ge.some((le) => Re(le, ee)) ? ut(Y[0], ee) : yt(ee);
      if (Y = se, se.length == 1)
        break;
    }
    return Y;
  }
  function Vt(J) {
    return J.map(({ input: Y, error: ee, output: se }) => {
      if (ee) {
        let le = ee.message;
        throw new Error(J.length == 1 ? le : `Invalid label ${et(Pt(Y, 63))}: ${le}`);
      }
      return A(se);
    }).join(U);
  }
  function yt(J) {
    return new Error(`disallowed character: ${Ye(J)}`);
  }
  function ut(J, Y) {
    let ee = Ye(Y), se = ge.find((le) => le.P.has(Y));
    return se && (ee = `${se.N} ${ee}`), new Error(`illegal mixture: ${J.N} + ${ee}`);
  }
  function It(J) {
    return new Error(`illegal placement: ${J}`);
  }
  function kt(J, Y) {
    for (let ee of Y)
      if (!Re(J, ee))
        throw ut(J, ee);
    if (J.M) {
      let ee = Pe(Y);
      for (let se = 1, le = ee.length; se < le; se++)
        if (ne.has(ee[se])) {
          let Ae = se + 1;
          for (let Te; Ae < le && ne.has(Te = ee[Ae]); Ae++)
            for (let Ie = se; Ie < Ae; Ie++)
              if (ee[Ie] == Te)
                throw new Error(`duplicate non-spacing marks: ${Ye(Te)}`);
          if (Ae - se > r)
            throw new Error(`excessive non-spacing marks: ${et(Pt(ee.slice(se - 1, Ae)))} (${Ae - se}/${r})`);
          se = Ae;
        }
    }
  }
  function ot(J, Y, ee) {
    let se = [], le = [];
    for (J = J.slice().reverse(); J.length; ) {
      let Ae = Nt(J);
      if (Ae)
        le.length && (se.push(Y(le)), le = []), se.push(ee(Ae));
      else {
        let Te = J.pop();
        if (Ce.has(Te))
          le.push(Te);
        else {
          let Ie = x.get(Te);
          if (Ie)
            le.push(...Ie);
          else if (!_.has(Te))
            throw yt(Te);
        }
      }
    }
    return le.length && se.push(Y(le)), se;
  }
  function Rt(J) {
    return J.filter((Y) => Y != ue);
  }
  function Nt(J, Y) {
    let ee = Ue, se, le = J.length;
    for (; le && (ee = ee.get(J[--le]), !!ee); ) {
      let { V: Ae } = ee;
      Ae && (se = Ae, Y && Y.push(...J.slice(le).reverse()), J.length = le);
    }
    return se;
  }
  const rt = "valid", Dt = "mapped", St = "ignored", T = "disallowed", F = "emoji", H = "nfc", z = "stop";
  function Q(J, {
    nf: Y = !0
    // collapse unnormalized runs into a single token
  } = {}) {
    Qe();
    let ee = I(J).reverse(), se = [], le = [];
    for (; ee.length; ) {
      let Ae = Nt(ee, se);
      if (Ae)
        le.push({
          type: F,
          emoji: Ae.slice(),
          // copy emoji
          input: se,
          cps: Rt(Ae)
        }), se = [];
      else {
        let Te = ee.pop();
        if (Te == te)
          le.push({ type: z, cp: Te });
        else if (Ce.has(Te))
          le.push({ type: rt, cps: [Te] });
        else if (_.has(Te))
          le.push({ type: St, cp: Te });
        else {
          let Ie = x.get(Te);
          Ie ? le.push({ type: Dt, cp: Te, cps: Ie.slice() }) : le.push({ type: T, cp: Te });
        }
      }
    }
    if (Y)
      for (let Ae = 0, Te = -1; Ae < le.length; Ae++) {
        let Ie = le[Ae];
        if (Z(Ie.type))
          if (ie(Ie.cps)) {
            let We = Ae + 1;
            for (let Ge = We; Ge < le.length; Ge++) {
              let { type: Ct, cps: Mt } = le[Ge];
              if (Z(Ct)) {
                if (!ie(Mt))
                  break;
                We = Ge + 1;
              } else if (Ct !== St)
                break;
            }
            Te < 0 && (Te = Ae);
            let Ke = le.slice(Te, We), Le = Ke.flatMap((Ge) => Z(Ge.type) ? Ge.cps : []), De = xe(Le);
            R(De, Le) ? (le.splice(Te, We - Te, {
              type: H,
              input: Le,
              // there are 3 states: tokens0 ==(process)=> input ==(nfc)=> tokens/cps
              cps: De,
              tokens0: he(Ke),
              tokens: Q(A(De), { nf: !1 })
            }), Ae = Te) : Ae = We - 1, Te = -1;
          } else
            Te = Ae;
        else
          Ie.type !== St && (Te = -1);
      }
    return he(le);
  }
  function Z(J) {
    return J == rt || J == Dt;
  }
  function ie(J) {
    return J.some((Y) => ye.has(Y));
  }
  function he(J) {
    for (let Y = 0; Y < J.length; Y++)
      if (J[Y].type == rt) {
        let ee = Y + 1;
        for (; ee < J.length && J[ee].type == rt; )
          ee++;
        J.splice(Y, ee - Y, { type: rt, cps: J.slice(Y, ee).flatMap((se) => se.cps) });
      }
    return J;
  }
  return Vn.ens_beautify = $t, Vn.ens_emoji = zt, Vn.ens_normalize = lt, Vn.ens_normalize_fragment = xt, Vn.ens_split = at, Vn.ens_tokenize = Q, Vn.is_combining_mark = dt, Vn.nfc = xe, Vn.nfd = Pe, Vn.safe_str_from_cps = Pt, Vn.should_escape = st, Vn;
}
var _6;
function sI() {
  if (_6)
    return ki;
  _6 = 1, Object.defineProperty(ki, "__esModule", { value: !0 }), ki.dnsEncode = ki.namehash = ki.isValidName = ki.ensNormalize = void 0;
  const e = ln(), t = vt(), r = iI(), n = new Uint8Array(32);
  n.fill(0);
  function s(p) {
    return (0, t.assertArgument)(p.length !== 0, "invalid ENS name; empty component", "comp", p), p;
  }
  function i(p) {
    const g = (0, t.toUtf8Bytes)(a(p)), v = [];
    if (p.length === 0)
      return v;
    let O = 0;
    for (let N = 0; N < g.length; N++)
      g[N] === 46 && (v.push(s(g.slice(O, N))), O = N + 1);
    return (0, t.assertArgument)(O < g.length, "invalid ENS name; empty component", "name", p), v.push(s(g.slice(O))), v;
  }
  function a(p) {
    try {
      if (p.length === 0)
        throw new Error("empty label");
      return (0, r.ens_normalize)(p);
    } catch (g) {
      (0, t.assertArgument)(!1, `invalid ENS name (${g.message})`, "name", p);
    }
  }
  ki.ensNormalize = a;
  function f(p) {
    try {
      return i(p).length !== 0;
    } catch {
    }
    return !1;
  }
  ki.isValidName = f;
  function d(p) {
    (0, t.assertArgument)(typeof p == "string", "invalid ENS name; not a string", "name", p), (0, t.assertArgument)(p.length, "invalid ENS name (empty label)", "name", p);
    let g = n;
    const v = i(p);
    for (; v.length; )
      g = (0, e.keccak256)((0, t.concat)([g, (0, e.keccak256)(v.pop())]));
    return (0, t.hexlify)(g);
  }
  ki.namehash = d;
  function c(p, g) {
    const v = g ?? 63;
    return (0, t.assertArgument)(v <= 255, "DNS encoded label cannot exceed 255", "length", v), (0, t.hexlify)((0, t.concat)(i(p).map((O) => {
      (0, t.assertArgument)(O.length <= v, `label ${JSON.stringify(p)} exceeds ${v} bytes`, "name", p);
      const N = new Uint8Array(O.length + 1);
      return N.set(O, 1), N[0] = N.length - 1, N;
    }))) + "00";
  }
  return ki.dnsEncode = c, ki;
}
var Ta = {}, F6 = {}, Wl = {}, U6;
function a7() {
  if (U6)
    return Wl;
  U6 = 1, Object.defineProperty(Wl, "__esModule", { value: !0 }), Wl.accessListify = void 0;
  const e = Xr(), t = vt();
  function r(s, i) {
    return {
      address: (0, e.getAddress)(s),
      storageKeys: i.map((a, f) => ((0, t.assertArgument)((0, t.isHexString)(a, 32), "invalid slot", `storageKeys[${f}]`, a), a.toLowerCase()))
    };
  }
  function n(s) {
    if (Array.isArray(s))
      return s.map((a, f) => Array.isArray(a) ? ((0, t.assertArgument)(a.length === 2, "invalid slot set", `value[${f}]`, a), r(a[0], a[1])) : ((0, t.assertArgument)(a != null && typeof a == "object", "invalid address-slot set", "value", s), r(a.address, a.storageKeys)));
    (0, t.assertArgument)(s != null && typeof s == "object", "invalid access list", "value", s);
    const i = Object.keys(s).map((a) => {
      const f = s[a].reduce((d, c) => (d[c] = !0, d), {});
      return r(a, Object.keys(f).sort());
    });
    return i.sort((a, f) => a.address.localeCompare(f.address)), i;
  }
  return Wl.accessListify = n, Wl;
}
var ka = {}, D6;
function u7() {
  if (D6)
    return ka;
  D6 = 1, Object.defineProperty(ka, "__esModule", { value: !0 }), ka.recoverAddress = ka.computeAddress = void 0;
  const e = Xr(), t = ln();
  function r(s) {
    let i;
    return typeof s == "string" ? i = t.SigningKey.computePublicKey(s, !1) : i = s.publicKey, (0, e.getAddress)((0, t.keccak256)("0x" + i.substring(4)).substring(26));
  }
  ka.computeAddress = r;
  function n(s, i) {
    return r(t.SigningKey.recoverPublicKey(s, i));
  }
  return ka.recoverAddress = n, ka;
}
var Gl = {}, j6;
function oI() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N, S, j, B;
  if (j6)
    return Gl;
  j6 = 1, Object.defineProperty(Gl, "__esModule", { value: !0 }), Gl.Transaction = void 0;
  const M = Xr(), I = r7(), A = ln(), R = vt(), L = a7(), K = u7(), $ = BigInt(0), k = BigInt(2), V = BigInt(27), C = BigInt(28), D = BigInt(35), o = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), u = 4096 * 32;
  function h(te, U) {
    let ue = te.toString(16);
    for (; ue.length < 2; )
      ue = "0" + ue;
    return ue += (0, A.sha256)(U).substring(4), "0x" + ue;
  }
  function y(te) {
    return te === "0x" ? null : (0, M.getAddress)(te);
  }
  function E(te, U) {
    try {
      return (0, L.accessListify)(te);
    } catch (ue) {
      (0, R.assertArgument)(!1, ue.message, U, te);
    }
  }
  function P(te, U) {
    return te === "0x" ? 0 : (0, R.getNumber)(te, U);
  }
  function w(te, U) {
    if (te === "0x")
      return $;
    const ue = (0, R.getBigInt)(te, U);
    return (0, R.assertArgument)(ue <= o, "value exceeds uint size", U, ue), ue;
  }
  function m(te, U) {
    const ue = (0, R.getBigInt)(te, "value"), we = (0, R.toBeArray)(ue);
    return (0, R.assertArgument)(we.length <= 32, "value too large", `tx.${U}`, ue), we;
  }
  function l(te) {
    return (0, L.accessListify)(te).map((U) => [U.address, U.storageKeys]);
  }
  function b(te, U) {
    (0, R.assertArgument)(Array.isArray(te), `invalid ${U}`, "value", te);
    for (let ue = 0; ue < te.length; ue++)
      (0, R.assertArgument)((0, R.isHexString)(te[ue], 32), "invalid ${ param } hash", `value[${ue}]`, te[ue]);
    return te;
  }
  function W(te) {
    const U = (0, R.decodeRlp)(te);
    (0, R.assertArgument)(Array.isArray(U) && (U.length === 9 || U.length === 6), "invalid field count for legacy transaction", "data", te);
    const ue = {
      type: 0,
      nonce: P(U[0], "nonce"),
      gasPrice: w(U[1], "gasPrice"),
      gasLimit: w(U[2], "gasLimit"),
      to: y(U[3]),
      value: w(U[4], "value"),
      data: (0, R.hexlify)(U[5]),
      chainId: $
    };
    if (U.length === 6)
      return ue;
    const we = w(U[6], "v"), ke = w(U[7], "r"), Re = w(U[8], "s");
    if (ke === $ && Re === $)
      ue.chainId = we;
    else {
      let fe = (we - D) / k;
      fe < $ && (fe = $), ue.chainId = fe, (0, R.assertArgument)(fe !== $ || we === V || we === C, "non-canonical legacy v", "v", U[6]), ue.signature = A.Signature.from({
        r: (0, R.zeroPadValue)(U[7], 32),
        s: (0, R.zeroPadValue)(U[8], 32),
        v: we
      });
    }
    return ue;
  }
  function X(te, U) {
    const ue = [
      m(te.nonce, "nonce"),
      m(te.gasPrice || 0, "gasPrice"),
      m(te.gasLimit, "gasLimit"),
      te.to || "0x",
      m(te.value, "value"),
      te.data
    ];
    let we = $;
    if (te.chainId != $)
      we = (0, R.getBigInt)(te.chainId, "tx.chainId"), (0, R.assertArgument)(!U || U.networkV == null || U.legacyChainId === we, "tx.chainId/sig.v mismatch", "sig", U);
    else if (te.signature) {
      const Re = te.signature.legacyChainId;
      Re != null && (we = Re);
    }
    if (!U)
      return we !== $ && (ue.push((0, R.toBeArray)(we)), ue.push("0x"), ue.push("0x")), (0, R.encodeRlp)(ue);
    let ke = BigInt(27 + U.yParity);
    return we !== $ ? ke = A.Signature.getChainIdV(we, U.v) : BigInt(U.v) !== ke && (0, R.assertArgument)(!1, "tx.chainId/sig.v mismatch", "sig", U), ue.push((0, R.toBeArray)(ke)), ue.push((0, R.toBeArray)(U.r)), ue.push((0, R.toBeArray)(U.s)), (0, R.encodeRlp)(ue);
  }
  function G(te, U) {
    let ue;
    try {
      if (ue = P(U[0], "yParity"), ue !== 0 && ue !== 1)
        throw new Error("bad yParity");
    } catch {
      (0, R.assertArgument)(!1, "invalid yParity", "yParity", U[0]);
    }
    const we = (0, R.zeroPadValue)(U[1], 32), ke = (0, R.zeroPadValue)(U[2], 32), Re = A.Signature.from({ r: we, s: ke, yParity: ue });
    te.signature = Re;
  }
  function re(te) {
    const U = (0, R.decodeRlp)((0, R.getBytes)(te).slice(1));
    (0, R.assertArgument)(Array.isArray(U) && (U.length === 9 || U.length === 12), "invalid field count for transaction type: 2", "data", (0, R.hexlify)(te));
    const ue = {
      type: 2,
      chainId: w(U[0], "chainId"),
      nonce: P(U[1], "nonce"),
      maxPriorityFeePerGas: w(U[2], "maxPriorityFeePerGas"),
      maxFeePerGas: w(U[3], "maxFeePerGas"),
      gasPrice: null,
      gasLimit: w(U[4], "gasLimit"),
      to: y(U[5]),
      value: w(U[6], "value"),
      data: (0, R.hexlify)(U[7]),
      accessList: E(U[8], "accessList")
    };
    return U.length === 9 || G(ue, U.slice(9)), ue;
  }
  function ce(te, U) {
    const ue = [
      m(te.chainId, "chainId"),
      m(te.nonce, "nonce"),
      m(te.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
      m(te.maxFeePerGas || 0, "maxFeePerGas"),
      m(te.gasLimit, "gasLimit"),
      te.to || "0x",
      m(te.value, "value"),
      te.data,
      l(te.accessList || [])
    ];
    return U && (ue.push(m(U.yParity, "yParity")), ue.push((0, R.toBeArray)(U.r)), ue.push((0, R.toBeArray)(U.s))), (0, R.concat)(["0x02", (0, R.encodeRlp)(ue)]);
  }
  function pe(te) {
    const U = (0, R.decodeRlp)((0, R.getBytes)(te).slice(1));
    (0, R.assertArgument)(Array.isArray(U) && (U.length === 8 || U.length === 11), "invalid field count for transaction type: 1", "data", (0, R.hexlify)(te));
    const ue = {
      type: 1,
      chainId: w(U[0], "chainId"),
      nonce: P(U[1], "nonce"),
      gasPrice: w(U[2], "gasPrice"),
      gasLimit: w(U[3], "gasLimit"),
      to: y(U[4]),
      value: w(U[5], "value"),
      data: (0, R.hexlify)(U[6]),
      accessList: E(U[7], "accessList")
    };
    return U.length === 8 || G(ue, U.slice(8)), ue;
  }
  function ve(te, U) {
    const ue = [
      m(te.chainId, "chainId"),
      m(te.nonce, "nonce"),
      m(te.gasPrice || 0, "gasPrice"),
      m(te.gasLimit, "gasLimit"),
      te.to || "0x",
      m(te.value, "value"),
      te.data,
      l(te.accessList || [])
    ];
    return U && (ue.push(m(U.yParity, "recoveryParam")), ue.push((0, R.toBeArray)(U.r)), ue.push((0, R.toBeArray)(U.s))), (0, R.concat)(["0x01", (0, R.encodeRlp)(ue)]);
  }
  function Ee(te) {
    let U = (0, R.decodeRlp)((0, R.getBytes)(te).slice(1)), ue = "3", we = null;
    if (U.length === 4 && Array.isArray(U[0])) {
      ue = "3 (network format)";
      const Re = U[1], fe = U[2], x = U[3];
      (0, R.assertArgument)(Array.isArray(Re), "invalid network format: blobs not an array", "fields[1]", Re), (0, R.assertArgument)(Array.isArray(fe), "invalid network format: commitments not an array", "fields[2]", fe), (0, R.assertArgument)(Array.isArray(x), "invalid network format: proofs not an array", "fields[3]", x), (0, R.assertArgument)(Re.length === fe.length, "invalid network format: blobs/commitments length mismatch", "fields", U), (0, R.assertArgument)(Re.length === x.length, "invalid network format: blobs/proofs length mismatch", "fields", U), we = [];
      for (let _ = 0; _ < U[1].length; _++)
        we.push({
          data: Re[_],
          commitment: fe[_],
          proof: x[_]
        });
      U = U[0];
    }
    (0, R.assertArgument)(Array.isArray(U) && (U.length === 11 || U.length === 14), `invalid field count for transaction type: ${ue}`, "data", (0, R.hexlify)(te));
    const ke = {
      type: 3,
      chainId: w(U[0], "chainId"),
      nonce: P(U[1], "nonce"),
      maxPriorityFeePerGas: w(U[2], "maxPriorityFeePerGas"),
      maxFeePerGas: w(U[3], "maxFeePerGas"),
      gasPrice: null,
      gasLimit: w(U[4], "gasLimit"),
      to: y(U[5]),
      value: w(U[6], "value"),
      data: (0, R.hexlify)(U[7]),
      accessList: E(U[8], "accessList"),
      maxFeePerBlobGas: w(U[9], "maxFeePerBlobGas"),
      blobVersionedHashes: U[10]
    };
    we && (ke.blobs = we), (0, R.assertArgument)(ke.to != null, `invalid address for transaction type: ${ue}`, "data", te), (0, R.assertArgument)(Array.isArray(ke.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", te);
    for (let Re = 0; Re < ke.blobVersionedHashes.length; Re++)
      (0, R.assertArgument)((0, R.isHexString)(ke.blobVersionedHashes[Re], 32), `invalid blobVersionedHash at index ${Re}: must be length 32`, "data", te);
    return U.length === 11 || G(ke, U.slice(11)), ke;
  }
  function Pe(te, U, ue) {
    const we = [
      m(te.chainId, "chainId"),
      m(te.nonce, "nonce"),
      m(te.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
      m(te.maxFeePerGas || 0, "maxFeePerGas"),
      m(te.gasLimit, "gasLimit"),
      te.to || I.ZeroAddress,
      m(te.value, "value"),
      te.data,
      l(te.accessList || []),
      m(te.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
      b(te.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    return U && (we.push(m(U.yParity, "yParity")), we.push((0, R.toBeArray)(U.r)), we.push((0, R.toBeArray)(U.s)), ue) ? (0, R.concat)([
      "0x03",
      (0, R.encodeRlp)([
        we,
        ue.map((ke) => ke.data),
        ue.map((ke) => ke.commitment),
        ue.map((ke) => ke.proof)
      ])
    ]) : (0, R.concat)(["0x03", (0, R.encodeRlp)(we)]);
  }
  const xe = class fo {
    /**
     *  Creates a new Transaction with default values.
     */
    constructor() {
      Fe(this, j), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Fe(this, n, void 0), Fe(this, s, void 0), Fe(this, i, void 0), Fe(this, a, void 0), Fe(this, f, void 0), Fe(this, d, void 0), Fe(this, c, void 0), Fe(this, p, void 0), Fe(this, g, void 0), Fe(this, v, void 0), Fe(this, O, void 0), Fe(this, N, void 0), Fe(this, S, void 0), Ne(this, e, null), Ne(this, t, null), Ne(this, n, 0), Ne(this, s, $), Ne(this, i, null), Ne(this, a, null), Ne(this, f, null), Ne(this, r, "0x"), Ne(this, d, $), Ne(this, c, $), Ne(this, p, null), Ne(this, g, null), Ne(this, v, null), Ne(this, O, null), Ne(this, S, null), Ne(this, N, null);
    }
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */
    get type() {
      return ae(this, e);
    }
    set type(U) {
      switch (U) {
        case null:
          Ne(this, e, null);
          break;
        case 0:
        case "legacy":
          Ne(this, e, 0);
          break;
        case 1:
        case "berlin":
        case "eip-2930":
          Ne(this, e, 1);
          break;
        case 2:
        case "london":
        case "eip-1559":
          Ne(this, e, 2);
          break;
        case 3:
        case "cancun":
        case "eip-4844":
          Ne(this, e, 3);
          break;
        default:
          (0, R.assertArgument)(!1, "unsupported transaction type", "type", U);
      }
    }
    /**
     *  The name of the transaction type.
     */
    get typeName() {
      switch (this.type) {
        case 0:
          return "legacy";
        case 1:
          return "eip-2930";
        case 2:
          return "eip-1559";
        case 3:
          return "eip-4844";
      }
      return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */
    get to() {
      const U = ae(this, t);
      return U == null && this.type === 3 ? I.ZeroAddress : U;
    }
    set to(U) {
      Ne(this, t, U == null ? null : (0, M.getAddress)(U));
    }
    /**
     *  The transaction nonce.
     */
    get nonce() {
      return ae(this, n);
    }
    set nonce(U) {
      Ne(this, n, (0, R.getNumber)(U, "value"));
    }
    /**
     *  The gas limit.
     */
    get gasLimit() {
      return ae(this, s);
    }
    set gasLimit(U) {
      Ne(this, s, (0, R.getBigInt)(U));
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */
    get gasPrice() {
      const U = ae(this, i);
      return U == null && (this.type === 0 || this.type === 1) ? $ : U;
    }
    set gasPrice(U) {
      Ne(this, i, U == null ? null : (0, R.getBigInt)(U, "gasPrice"));
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */
    get maxPriorityFeePerGas() {
      return ae(this, a) ?? (this.type === 2 || this.type === 3 ? $ : null);
    }
    set maxPriorityFeePerGas(U) {
      Ne(this, a, U == null ? null : (0, R.getBigInt)(U, "maxPriorityFeePerGas"));
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */
    get maxFeePerGas() {
      return ae(this, f) ?? (this.type === 2 || this.type === 3 ? $ : null);
    }
    set maxFeePerGas(U) {
      Ne(this, f, U == null ? null : (0, R.getBigInt)(U, "maxFeePerGas"));
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */
    get data() {
      return ae(this, r);
    }
    set data(U) {
      Ne(this, r, (0, R.hexlify)(U));
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */
    get value() {
      return ae(this, d);
    }
    set value(U) {
      Ne(this, d, (0, R.getBigInt)(U, "value"));
    }
    /**
     *  The chain ID this transaction is valid on.
     */
    get chainId() {
      return ae(this, c);
    }
    set chainId(U) {
      Ne(this, c, (0, R.getBigInt)(U));
    }
    /**
     *  If signed, the signature for this transaction.
     */
    get signature() {
      return ae(this, p) || null;
    }
    set signature(U) {
      Ne(this, p, U == null ? null : A.Signature.from(U));
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */
    get accessList() {
      return (ae(this, g) || null) ?? (this.type === 1 || this.type === 2 || this.type === 3 ? [] : null);
    }
    set accessList(U) {
      Ne(this, g, U == null ? null : (0, L.accessListify)(U));
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */
    get maxFeePerBlobGas() {
      const U = ae(this, v);
      return U == null && this.type === 3 ? $ : U;
    }
    set maxFeePerBlobGas(U) {
      Ne(this, v, U == null ? null : (0, R.getBigInt)(U, "maxFeePerBlobGas"));
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */
    get blobVersionedHashes() {
      let U = ae(this, O);
      return U == null && this.type === 3 ? [] : U;
    }
    set blobVersionedHashes(U) {
      if (U != null) {
        (0, R.assertArgument)(Array.isArray(U), "blobVersionedHashes must be an Array", "value", U), U = U.slice();
        for (let ue = 0; ue < U.length; ue++)
          (0, R.assertArgument)((0, R.isHexString)(U[ue], 32), "invalid blobVersionedHash", `value[${ue}]`, U[ue]);
      }
      Ne(this, O, U);
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */
    get blobs() {
      return ae(this, S) == null ? null : ae(this, S).map((U) => Object.assign({}, U));
    }
    set blobs(U) {
      if (U == null) {
        Ne(this, S, null);
        return;
      }
      const ue = [], we = [];
      for (let ke = 0; ke < U.length; ke++) {
        const Re = U[ke];
        if ((0, R.isBytesLike)(Re)) {
          (0, R.assert)(ae(this, N), "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
            operation: "set blobs()"
          });
          let fe = (0, R.getBytes)(Re);
          if ((0, R.assertArgument)(fe.length <= u, "blob is too large", `blobs[${ke}]`, Re), fe.length !== u) {
            const q = new Uint8Array(u);
            q.set(fe), fe = q;
          }
          const x = ae(this, N).blobToKzgCommitment(fe), _ = (0, R.hexlify)(ae(this, N).computeBlobKzgProof(fe, x));
          ue.push({
            data: (0, R.hexlify)(fe),
            commitment: (0, R.hexlify)(x),
            proof: _
          }), we.push(h(1, x));
        } else {
          const fe = (0, R.hexlify)(Re.commitment);
          ue.push({
            data: (0, R.hexlify)(Re.data),
            commitment: fe,
            proof: (0, R.hexlify)(Re.proof)
          }), we.push(h(1, fe));
        }
      }
      Ne(this, S, ue), Ne(this, O, we);
    }
    get kzg() {
      return ae(this, N);
    }
    set kzg(U) {
      Ne(this, N, U);
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */
    get hash() {
      return this.signature == null ? null : (0, A.keccak256)(qe(this, j, B).call(this, !0, !1));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */
    get unsignedHash() {
      return (0, A.keccak256)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */
    get from() {
      return this.signature == null ? null : (0, K.recoverAddress)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */
    get fromPublicKey() {
      return this.signature == null ? null : A.SigningKey.recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */
    isSigned() {
      return this.signature != null;
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */
    get serialized() {
      return qe(this, j, B).call(this, !0, !0);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */
    get unsignedSerialized() {
      return qe(this, j, B).call(this, !1, !1);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */
    inferType() {
      const U = this.inferTypes();
      return U.indexOf(2) >= 0 ? 2 : U.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */
    inferTypes() {
      const U = this.gasPrice != null, ue = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null, we = this.accessList != null, ke = ae(this, v) != null || ae(this, O);
      this.maxFeePerGas != null && this.maxPriorityFeePerGas != null && (0, R.assert)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", { value: this }), (0, R.assert)(!ue || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", { value: this }), (0, R.assert)(this.type !== 0 || !we, "legacy transaction cannot have accessList", "BAD_DATA", { value: this });
      const Re = [];
      return this.type != null ? Re.push(this.type) : ue ? Re.push(2) : U ? (Re.push(1), we || Re.push(0)) : we ? (Re.push(1), Re.push(2)) : (ke && this.to || (Re.push(0), Re.push(1), Re.push(2)), Re.push(3)), Re.sort(), Re;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isLegacy() {
      return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isBerlin() {
      return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isLondon() {
      return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isCancun() {
      return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */
    clone() {
      return fo.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */
    toJSON() {
      const U = (ue) => ue == null ? null : ue.toString();
      return {
        type: this.type,
        to: this.to,
        //            from: this.from,
        data: this.data,
        nonce: this.nonce,
        gasLimit: U(this.gasLimit),
        gasPrice: U(this.gasPrice),
        maxPriorityFeePerGas: U(this.maxPriorityFeePerGas),
        maxFeePerGas: U(this.maxFeePerGas),
        value: U(this.value),
        chainId: U(this.chainId),
        sig: this.signature ? this.signature.toJSON() : null,
        accessList: this.accessList
      };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */
    static from(U) {
      if (U == null)
        return new fo();
      if (typeof U == "string") {
        const we = (0, R.getBytes)(U);
        if (we[0] >= 127)
          return fo.from(W(we));
        switch (we[0]) {
          case 1:
            return fo.from(pe(we));
          case 2:
            return fo.from(re(we));
          case 3:
            return fo.from(Ee(we));
        }
        (0, R.assert)(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: "from" });
      }
      const ue = new fo();
      return U.type != null && (ue.type = U.type), U.to != null && (ue.to = U.to), U.nonce != null && (ue.nonce = U.nonce), U.gasLimit != null && (ue.gasLimit = U.gasLimit), U.gasPrice != null && (ue.gasPrice = U.gasPrice), U.maxPriorityFeePerGas != null && (ue.maxPriorityFeePerGas = U.maxPriorityFeePerGas), U.maxFeePerGas != null && (ue.maxFeePerGas = U.maxFeePerGas), U.maxFeePerBlobGas != null && (ue.maxFeePerBlobGas = U.maxFeePerBlobGas), U.data != null && (ue.data = U.data), U.value != null && (ue.value = U.value), U.chainId != null && (ue.chainId = U.chainId), U.signature != null && (ue.signature = A.Signature.from(U.signature)), U.accessList != null && (ue.accessList = U.accessList), U.blobVersionedHashes != null && (ue.blobVersionedHashes = U.blobVersionedHashes), U.kzg != null && (ue.kzg = U.kzg), U.blobs != null && (ue.blobs = U.blobs), U.hash != null && ((0, R.assertArgument)(ue.isSigned(), "unsigned transaction cannot define '.hash'", "tx", U), (0, R.assertArgument)(ue.hash === U.hash, "hash mismatch", "tx", U)), U.from != null && ((0, R.assertArgument)(ue.isSigned(), "unsigned transaction cannot define '.from'", "tx", U), (0, R.assertArgument)(ue.from.toLowerCase() === (U.from || "").toLowerCase(), "from mismatch", "tx", U)), ue;
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakSet(), B = function(te, U) {
    (0, R.assert)(!te || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
    const ue = te ? this.signature : null;
    switch (this.inferType()) {
      case 0:
        return X(this, ue);
      case 1:
        return ve(this, ue);
      case 2:
        return ce(this, ue);
      case 3:
        return Pe(this, ue, U ? this.blobs : null);
    }
    (0, R.assert)(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
  };
  let me = xe;
  return Gl.Transaction = me, Gl;
}
var L6;
function ei() {
  return L6 || (L6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Transaction = e.recoverAddress = e.computeAddress = e.accessListify = void 0;
    var t = a7();
    Object.defineProperty(e, "accessListify", { enumerable: !0, get: function() {
      return t.accessListify;
    } });
    var r = u7();
    Object.defineProperty(e, "computeAddress", { enumerable: !0, get: function() {
      return r.computeAddress;
    } }), Object.defineProperty(e, "recoverAddress", { enumerable: !0, get: function() {
      return r.recoverAddress;
    } });
    var n = oI();
    Object.defineProperty(e, "Transaction", { enumerable: !0, get: function() {
      return n.Transaction;
    } });
  }(F6)), F6;
}
var H6;
function aI() {
  if (H6)
    return Ta;
  H6 = 1, Object.defineProperty(Ta, "__esModule", { value: !0 }), Ta.verifyMessage = Ta.hashMessage = void 0;
  const e = ln(), t = Ad(), r = ei(), n = vt();
  function s(a) {
    return typeof a == "string" && (a = (0, n.toUtf8Bytes)(a)), (0, e.keccak256)((0, n.concat)([
      (0, n.toUtf8Bytes)(t.MessagePrefix),
      (0, n.toUtf8Bytes)(String(a.length)),
      a
    ]));
  }
  Ta.hashMessage = s;
  function i(a, f) {
    const d = s(a);
    return (0, r.recoverAddress)(d, f);
  }
  return Ta.verifyMessage = i, Ta;
}
var Cs = {}, W6;
function uI() {
  if (W6)
    return Cs;
  W6 = 1, Object.defineProperty(Cs, "__esModule", { value: !0 }), Cs.solidityPackedSha256 = Cs.solidityPackedKeccak256 = Cs.solidityPacked = void 0;
  const e = Xr(), t = ln(), r = vt(), n = new RegExp("^bytes([0-9]+)$"), s = new RegExp("^(u?int)([0-9]*)$"), i = new RegExp("^(.*)\\[([0-9]*)\\]$");
  function a(p, g, v) {
    switch (p) {
      case "address":
        return v ? (0, r.getBytes)((0, r.zeroPadValue)(g, 32)) : (0, r.getBytes)((0, e.getAddress)(g));
      case "string":
        return (0, r.toUtf8Bytes)(g);
      case "bytes":
        return (0, r.getBytes)(g);
      case "bool":
        return g = g ? "0x01" : "0x00", v ? (0, r.getBytes)((0, r.zeroPadValue)(g, 32)) : (0, r.getBytes)(g);
    }
    let O = p.match(s);
    if (O) {
      let N = O[1] === "int", S = parseInt(O[2] || "256");
      return (0, r.assertArgument)((!O[2] || O[2] === String(S)) && S % 8 === 0 && S !== 0 && S <= 256, "invalid number type", "type", p), v && (S = 256), N && (g = (0, r.toTwos)(g, S)), (0, r.getBytes)((0, r.zeroPadValue)((0, r.toBeArray)(g), S / 8));
    }
    if (O = p.match(n), O) {
      const N = parseInt(O[1]);
      return (0, r.assertArgument)(String(N) === O[1] && N !== 0 && N <= 32, "invalid bytes type", "type", p), (0, r.assertArgument)((0, r.dataLength)(g) === N, `invalid value for ${p}`, "value", g), v ? (0, r.getBytes)((0, r.zeroPadBytes)(g, 32)) : g;
    }
    if (O = p.match(i), O && Array.isArray(g)) {
      const N = O[1], S = parseInt(O[2] || String(g.length));
      (0, r.assertArgument)(S === g.length, `invalid array length for ${p}`, "value", g);
      const j = [];
      return g.forEach(function(B) {
        j.push(a(N, B, !0));
      }), (0, r.getBytes)((0, r.concat)(j));
    }
    (0, r.assertArgument)(!1, "invalid type", "type", p);
  }
  function f(p, g) {
    (0, r.assertArgument)(p.length === g.length, "wrong number of values; expected ${ types.length }", "values", g);
    const v = [];
    return p.forEach(function(O, N) {
      v.push(a(O, g[N]));
    }), (0, r.hexlify)((0, r.concat)(v));
  }
  Cs.solidityPacked = f;
  function d(p, g) {
    return (0, t.keccak256)(f(p, g));
  }
  Cs.solidityPackedKeccak256 = d;
  function c(p, g) {
    return (0, t.sha256)(f(p, g));
  }
  return Cs.solidityPackedSha256 = c, Cs;
}
var Sa = {}, G6;
function cI() {
  var e, t, r, n, s;
  if (G6)
    return Sa;
  G6 = 1, Object.defineProperty(Sa, "__esModule", { value: !0 }), Sa.verifyTypedData = Sa.TypedDataEncoder = void 0;
  const i = Xr(), a = ln(), f = ei(), d = vt(), c = o7(), p = new Uint8Array(32);
  p.fill(0);
  const g = BigInt(-1), v = BigInt(0), O = BigInt(1), N = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
  function S(D) {
    const o = (0, d.getBytes)(D), u = o.length % 32;
    return u ? (0, d.concat)([o, p.slice(u)]) : (0, d.hexlify)(o);
  }
  const j = (0, d.toBeHex)(O, 32), B = (0, d.toBeHex)(v, 32), M = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
  }, I = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
  ];
  function A(D) {
    return function(o) {
      return (0, d.assertArgument)(typeof o == "string", `invalid domain value for ${JSON.stringify(D)}`, `domain.${D}`, o), o;
    };
  }
  const R = {
    name: A("name"),
    version: A("version"),
    chainId: function(D) {
      const o = (0, d.getBigInt)(D, "domain.chainId");
      return (0, d.assertArgument)(o >= 0, "invalid chain ID", "domain.chainId", D), Number.isSafeInteger(o) ? Number(o) : (0, d.toQuantity)(o);
    },
    verifyingContract: function(D) {
      try {
        return (0, i.getAddress)(D).toLowerCase();
      } catch {
      }
      (0, d.assertArgument)(!1, 'invalid domain value "verifyingContract"', "domain.verifyingContract", D);
    },
    salt: function(D) {
      const o = (0, d.getBytes)(D, "domain.salt");
      return (0, d.assertArgument)(o.length === 32, 'invalid domain value "salt"', "domain.salt", D), (0, d.hexlify)(o);
    }
  };
  function L(D) {
    {
      const o = D.match(/^(u?)int(\d+)$/);
      if (o) {
        const u = o[1] === "", h = parseInt(o[2]);
        (0, d.assertArgument)(h % 8 === 0 && h !== 0 && h <= 256 && o[2] === String(h), "invalid numeric width", "type", D);
        const y = (0, d.mask)(N, u ? h - 1 : h), E = u ? (y + O) * g : v;
        return function(P) {
          const w = (0, d.getBigInt)(P, "value");
          return (0, d.assertArgument)(w >= E && w <= y, `value out-of-bounds for ${D}`, "value", w), (0, d.toBeHex)(u ? (0, d.toTwos)(w, 256) : w, 32);
        };
      }
    }
    {
      const o = D.match(/^bytes(\d+)$/);
      if (o) {
        const u = parseInt(o[1]);
        return (0, d.assertArgument)(u !== 0 && u <= 32 && o[1] === String(u), "invalid bytes width", "type", D), function(h) {
          const y = (0, d.getBytes)(h);
          return (0, d.assertArgument)(y.length === u, `invalid length for ${D}`, "value", h), S(h);
        };
      }
    }
    switch (D) {
      case "address":
        return function(o) {
          return (0, d.zeroPadValue)((0, i.getAddress)(o), 32);
        };
      case "bool":
        return function(o) {
          return o ? j : B;
        };
      case "bytes":
        return function(o) {
          return (0, a.keccak256)(o);
        };
      case "string":
        return function(o) {
          return (0, c.id)(o);
        };
    }
    return null;
  }
  function K(D, o) {
    return `${D}(${o.map(({ name: u, type: h }) => h + " " + u).join(",")})`;
  }
  function $(D) {
    const o = D.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    return o ? {
      base: o[1],
      index: o[2] + o[4],
      array: {
        base: o[1],
        prefix: o[1] + o[2],
        count: o[5] ? parseInt(o[5]) : -1
      }
    } : { base: D };
  }
  const k = class Bi {
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */
    constructor(o) {
      Fe(this, n), Se(this, "primaryType"), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Ne(this, t, /* @__PURE__ */ new Map()), Ne(this, r, /* @__PURE__ */ new Map());
      const u = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), E = {};
      Object.keys(o).forEach((m) => {
        E[m] = o[m].map(({ name: l, type: b }) => {
          let { base: W, index: X } = $(b);
          return W === "int" && !o.int && (W = "int256"), W === "uint" && !o.uint && (W = "uint256"), { name: l, type: W + (X || "") };
        }), u.set(m, /* @__PURE__ */ new Set()), h.set(m, []), y.set(m, /* @__PURE__ */ new Set());
      }), Ne(this, e, JSON.stringify(E));
      for (const m in E) {
        const l = /* @__PURE__ */ new Set();
        for (const b of E[m]) {
          (0, d.assertArgument)(!l.has(b.name), `duplicate variable name ${JSON.stringify(b.name)} in ${JSON.stringify(m)}`, "types", o), l.add(b.name);
          const W = $(b.type).base;
          (0, d.assertArgument)(W !== m, `circular type reference to ${JSON.stringify(W)}`, "types", o), !L(W) && ((0, d.assertArgument)(h.has(W), `unknown type ${JSON.stringify(W)}`, "types", o), h.get(W).push(m), u.get(m).add(W));
        }
      }
      const P = Array.from(h.keys()).filter((m) => h.get(m).length === 0);
      (0, d.assertArgument)(P.length !== 0, "missing primary type", "types", o), (0, d.assertArgument)(P.length === 1, `ambiguous primary types or unused types: ${P.map((m) => JSON.stringify(m)).join(", ")}`, "types", o), (0, d.defineProperties)(this, { primaryType: P[0] });
      function w(m, l) {
        (0, d.assertArgument)(!l.has(m), `circular type reference to ${JSON.stringify(m)}`, "types", o), l.add(m);
        for (const b of u.get(m))
          if (h.has(b)) {
            w(b, l);
            for (const W of l)
              y.get(W).add(b);
          }
        l.delete(m);
      }
      w(this.primaryType, /* @__PURE__ */ new Set());
      for (const [m, l] of y) {
        const b = Array.from(l);
        b.sort(), ae(this, t).set(m, K(m, E[m]) + b.map((W) => K(W, E[W])).join(""));
      }
    }
    /**
     *  The types.
     */
    get types() {
      return JSON.parse(ae(this, e));
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */
    getEncoder(o) {
      let u = ae(this, r).get(o);
      return u || (u = qe(this, n, s).call(this, o), ae(this, r).set(o, u)), u;
    }
    /**
     *  Return the full type for %%name%%.
     */
    encodeType(o) {
      const u = ae(this, t).get(o);
      return (0, d.assertArgument)(u, `unknown type: ${JSON.stringify(o)}`, "name", o), u;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */
    encodeData(o, u) {
      return this.getEncoder(o)(u);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */
    hashStruct(o, u) {
      return (0, a.keccak256)(this.encodeData(o, u));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */
    encode(o) {
      return this.encodeData(this.primaryType, o);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */
    hash(o) {
      return this.hashStruct(this.primaryType, o);
    }
    /**
     *  @_ignore:
     */
    _visit(o, u, h) {
      if (L(o))
        return h(o, u);
      const y = $(o).array;
      if (y)
        return (0, d.assertArgument)(y.count === -1 || y.count === u.length, `array length mismatch; expected length ${y.count}`, "value", u), u.map((P) => this._visit(y.prefix, P, h));
      const E = this.types[o];
      if (E)
        return E.reduce((P, { name: w, type: m }) => (P[w] = this._visit(m, u[w], h), P), {});
      (0, d.assertArgument)(!1, `unknown type: ${o}`, "type", o);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */
    visit(o, u) {
      return this._visit(this.primaryType, o, u);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */
    static from(o) {
      return new Bi(o);
    }
    /**
     *  Return the primary type for %%types%%.
     */
    static getPrimaryType(o) {
      return Bi.from(o).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */
    static hashStruct(o, u, h) {
      return Bi.from(u).hashStruct(o, h);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */
    static hashDomain(o) {
      const u = [];
      for (const h in o) {
        if (o[h] == null)
          continue;
        const y = M[h];
        (0, d.assertArgument)(y, `invalid typed-data domain key: ${JSON.stringify(h)}`, "domain", o), u.push({ name: h, type: y });
      }
      return u.sort((h, y) => I.indexOf(h.name) - I.indexOf(y.name)), Bi.hashStruct("EIP712Domain", { EIP712Domain: u }, o);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */
    static encode(o, u, h) {
      return (0, d.concat)([
        "0x1901",
        Bi.hashDomain(o),
        Bi.from(u).hash(h)
      ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */
    static hash(o, u, h) {
      return (0, a.keccak256)(Bi.encode(o, u, h));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */
    static async resolveNames(o, u, h, y) {
      o = Object.assign({}, o);
      for (const w in o)
        o[w] == null && delete o[w];
      const E = {};
      o.verifyingContract && !(0, d.isHexString)(o.verifyingContract, 20) && (E[o.verifyingContract] = "0x");
      const P = Bi.from(u);
      P.visit(h, (w, m) => (w === "address" && !(0, d.isHexString)(m, 20) && (E[m] = "0x"), m));
      for (const w in E)
        E[w] = await y(w);
      return o.verifyingContract && E[o.verifyingContract] && (o.verifyingContract = E[o.verifyingContract]), h = P.visit(h, (w, m) => w === "address" && E[m] ? E[m] : m), { domain: o, value: h };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */
    static getPayload(o, u, h) {
      Bi.hashDomain(o);
      const y = {}, E = [];
      I.forEach((m) => {
        const l = o[m];
        l != null && (y[m] = R[m](l), E.push({ name: m, type: M[m] }));
      });
      const P = Bi.from(u);
      u = P.types;
      const w = Object.assign({}, u);
      return (0, d.assertArgument)(w.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", u), w.EIP712Domain = E, P.encode(h), {
        types: w,
        domain: y,
        primaryType: P.primaryType,
        message: P.visit(h, (m, l) => {
          if (m.match(/^bytes(\d*)/))
            return (0, d.hexlify)((0, d.getBytes)(l));
          if (m.match(/^u?int/))
            return (0, d.getBigInt)(l).toString();
          switch (m) {
            case "address":
              return l.toLowerCase();
            case "bool":
              return !!l;
            case "string":
              return (0, d.assertArgument)(typeof l == "string", "invalid string", "value", l), l;
          }
          (0, d.assertArgument)(!1, "unsupported type", "type", m);
        })
      };
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakSet(), s = function(D) {
    {
      const h = L(D);
      if (h)
        return h;
    }
    const o = $(D).array;
    if (o) {
      const h = o.prefix, y = this.getEncoder(h);
      return (E) => {
        (0, d.assertArgument)(o.count === -1 || o.count === E.length, `array length mismatch; expected length ${o.count}`, "value", E);
        let P = E.map(y);
        return ae(this, t).has(h) && (P = P.map(a.keccak256)), (0, a.keccak256)((0, d.concat)(P));
      };
    }
    const u = this.types[D];
    if (u) {
      const h = (0, c.id)(ae(this, t).get(D));
      return (y) => {
        const E = u.map(({ name: P, type: w }) => {
          const m = this.getEncoder(w)(y[P]);
          return ae(this, t).has(w) ? (0, a.keccak256)(m) : m;
        });
        return E.unshift(h), (0, d.concat)(E);
      };
    }
    (0, d.assertArgument)(!1, `unknown type: ${D}`, "type", D);
  };
  let V = k;
  Sa.TypedDataEncoder = V;
  function C(D, o, u, h) {
    return (0, f.recoverAddress)(V.hash(D, o, u), h);
  }
  return Sa.verifyTypedData = C, Sa;
}
var z6;
function so() {
  return z6 || (z6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.verifyTypedData = e.TypedDataEncoder = e.solidityPackedSha256 = e.solidityPackedKeccak256 = e.solidityPacked = e.verifyMessage = e.hashMessage = e.dnsEncode = e.namehash = e.isValidName = e.ensNormalize = e.id = void 0;
    var t = o7();
    Object.defineProperty(e, "id", { enumerable: !0, get: function() {
      return t.id;
    } });
    var r = sI();
    Object.defineProperty(e, "ensNormalize", { enumerable: !0, get: function() {
      return r.ensNormalize;
    } }), Object.defineProperty(e, "isValidName", { enumerable: !0, get: function() {
      return r.isValidName;
    } }), Object.defineProperty(e, "namehash", { enumerable: !0, get: function() {
      return r.namehash;
    } }), Object.defineProperty(e, "dnsEncode", { enumerable: !0, get: function() {
      return r.dnsEncode;
    } });
    var n = aI();
    Object.defineProperty(e, "hashMessage", { enumerable: !0, get: function() {
      return n.hashMessage;
    } }), Object.defineProperty(e, "verifyMessage", { enumerable: !0, get: function() {
      return n.verifyMessage;
    } });
    var s = uI();
    Object.defineProperty(e, "solidityPacked", { enumerable: !0, get: function() {
      return s.solidityPacked;
    } }), Object.defineProperty(e, "solidityPackedKeccak256", { enumerable: !0, get: function() {
      return s.solidityPackedKeccak256;
    } }), Object.defineProperty(e, "solidityPackedSha256", { enumerable: !0, get: function() {
      return s.solidityPackedSha256;
    } });
    var i = cI();
    Object.defineProperty(e, "TypedDataEncoder", { enumerable: !0, get: function() {
      return i.TypedDataEncoder;
    } }), Object.defineProperty(e, "verifyTypedData", { enumerable: !0, get: function() {
      return i.verifyTypedData;
    } });
  }(R6)), R6;
}
var V6;
function Q1() {
  var e, t, r, n, s, i;
  if (V6)
    return Gr;
  V6 = 1, Object.defineProperty(Gr, "__esModule", { value: !0 }), Gr.StructFragment = Gr.FunctionFragment = Gr.FallbackFragment = Gr.ConstructorFragment = Gr.EventFragment = Gr.ErrorFragment = Gr.NamedFragment = Gr.Fragment = Gr.ParamType = void 0;
  const a = vt(), f = so();
  function d(fe) {
    const x = /* @__PURE__ */ new Set();
    return fe.forEach((_) => x.add(_)), Object.freeze(x);
  }
  const c = d("external public payable override".split(" ")), p = "constant external internal payable private public pure view override", g = d(p.split(" ")), v = "constructor error event fallback function receive struct", O = d(v.split(" ")), N = "calldata memory storage payable indexed", S = d(N.split(" ")), j = [v, N, "tuple returns", p].join(" "), B = d(j.split(" ")), M = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
  }, I = new RegExp("^(\\s*)"), A = new RegExp("^([0-9]+)"), R = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), L = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), K = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$"), $ = class c7 {
    constructor(x) {
      Fe(this, r), Fe(this, e, void 0), Fe(this, t, void 0), Ne(this, e, 0), Ne(this, t, x.slice());
    }
    get offset() {
      return ae(this, e);
    }
    get length() {
      return ae(this, t).length - ae(this, e);
    }
    clone() {
      return new c7(ae(this, t));
    }
    reset() {
      Ne(this, e, 0);
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(x) {
      const _ = this.peek();
      if (_.type !== "KEYWORD" || !x.has(_.text))
        throw new Error(`expected keyword ${_.text}`);
      return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(x) {
      if (this.peek().type !== x) {
        const _ = this.peek();
        throw new Error(`expected ${x}; got ${_.type} ${JSON.stringify(_.text)}`);
      }
      return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
      const x = this.peek();
      if (x.type !== "OPEN_PAREN")
        throw new Error("bad start");
      const _ = qe(this, r, n).call(this, ae(this, e) + 1, x.match + 1);
      return Ne(this, e, x.match + 1), _;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
      const x = this.peek();
      if (x.type !== "OPEN_PAREN")
        throw new Error("bad start");
      const _ = [];
      for (; ae(this, e) < x.match - 1; ) {
        const q = this.peek().linkNext;
        _.push(qe(this, r, n).call(this, ae(this, e) + 1, q)), Ne(this, e, q);
      }
      return Ne(this, e, x.match + 1), _;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
      if (ae(this, e) >= ae(this, t).length)
        throw new Error("out-of-bounds");
      return ae(this, t)[ae(this, e)];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(x) {
      const _ = this.peekType("KEYWORD");
      return _ != null && x.has(_) ? _ : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(x) {
      if (this.length === 0)
        return null;
      const _ = this.peek();
      return _.type === x ? _.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
      const x = this.peek();
      return ed(this, e)._++, x;
    }
    toString() {
      const x = [];
      for (let _ = ae(this, e); _ < ae(this, t).length; _++) {
        const q = ae(this, t)[_];
        x.push(`${q.type}:${q.text}`);
      }
      return `<TokenString ${x.join(" ")}>`;
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakSet(), n = function(fe = 0, x = 0) {
    return new $(ae(this, t).slice(fe, x).map((_) => Object.freeze(Object.assign({}, _, {
      match: _.match - fe,
      linkBack: _.linkBack - fe,
      linkNext: _.linkNext - fe
    }))));
  };
  let k = $;
  function V(fe) {
    const x = [], _ = (ye) => {
      const ge = de < fe.length ? JSON.stringify(fe[de]) : "$EOI";
      throw new Error(`invalid token ${ge} at ${de}: ${ye}`);
    };
    let q = [], ne = [], de = 0;
    for (; de < fe.length; ) {
      let ye = fe.substring(de), ge = ye.match(I);
      ge && (de += ge[1].length, ye = fe.substring(de));
      const be = { depth: q.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset: de, value: -1 };
      x.push(be);
      let Me = M[ye[0]] || "";
      if (Me) {
        if (be.type = Me, be.text = ye[0], de++, Me === "OPEN_PAREN")
          q.push(x.length - 1), ne.push(x.length - 1);
        else if (Me == "CLOSE_PAREN")
          q.length === 0 && _("no matching open bracket"), be.match = q.pop(), x[be.match].match = x.length - 1, be.depth--, be.linkBack = ne.pop(), x[be.linkBack].linkNext = x.length - 1;
        else if (Me === "COMMA")
          be.linkBack = ne.pop(), x[be.linkBack].linkNext = x.length - 1, ne.push(x.length - 1);
        else if (Me === "OPEN_BRACKET")
          be.type = "BRACKET";
        else if (Me === "CLOSE_BRACKET") {
          let Ce = x.pop().text;
          if (x.length > 0 && x[x.length - 1].type === "NUMBER") {
            const je = x.pop().text;
            Ce = je + Ce, x[x.length - 1].value = (0, a.getNumber)(je);
          }
          if (x.length === 0 || x[x.length - 1].type !== "BRACKET")
            throw new Error("missing opening bracket");
          x[x.length - 1].text += Ce;
        }
        continue;
      }
      if (ge = ye.match(R), ge) {
        if (be.text = ge[1], de += be.text.length, B.has(be.text)) {
          be.type = "KEYWORD";
          continue;
        }
        if (be.text.match(K)) {
          be.type = "TYPE";
          continue;
        }
        be.type = "ID";
        continue;
      }
      if (ge = ye.match(A), ge) {
        be.text = ge[1], be.type = "NUMBER", de += be.text.length;
        continue;
      }
      throw new Error(`unexpected token ${JSON.stringify(ye[0])} at position ${de}`);
    }
    return new k(x.map((ye) => Object.freeze(ye)));
  }
  function C(fe, x) {
    let _ = [];
    for (const q in x.keys())
      fe.has(q) && _.push(q);
    if (_.length > 1)
      throw new Error(`conflicting types: ${_.join(", ")}`);
  }
  function D(fe, x) {
    if (x.peekKeyword(O)) {
      const _ = x.pop().text;
      if (_ !== fe)
        throw new Error(`expected ${fe}, got ${_}`);
    }
    return x.popType("ID");
  }
  function o(fe, x) {
    const _ = /* @__PURE__ */ new Set();
    for (; ; ) {
      const q = fe.peekType("KEYWORD");
      if (q == null || x && !x.has(q))
        break;
      if (fe.pop(), _.has(q))
        throw new Error(`duplicate keywords: ${JSON.stringify(q)}`);
      _.add(q);
    }
    return Object.freeze(_);
  }
  function u(fe) {
    let x = o(fe, g);
    return C(x, d("constant payable nonpayable".split(" "))), C(x, d("pure view payable nonpayable".split(" "))), x.has("view") ? "view" : x.has("pure") ? "pure" : x.has("payable") ? "payable" : x.has("nonpayable") ? "nonpayable" : x.has("constant") ? "view" : "nonpayable";
  }
  function h(fe, x) {
    return fe.popParams().map((_) => Ee.from(_, x));
  }
  function y(fe) {
    if (fe.peekType("AT")) {
      if (fe.pop(), fe.peekType("NUMBER"))
        return (0, a.getBigInt)(fe.pop().text);
      throw new Error("invalid gas");
    }
    return null;
  }
  function E(fe) {
    if (fe.length)
      throw new Error(`unexpected tokens at offset ${fe.offset}: ${fe.toString()}`);
  }
  const P = new RegExp(/^(.*)\[([0-9]*)\]$/);
  function w(fe) {
    const x = fe.match(K);
    if ((0, a.assertArgument)(x, "invalid type", "type", fe), fe === "uint")
      return "uint256";
    if (fe === "int")
      return "int256";
    if (x[2]) {
      const _ = parseInt(x[2]);
      (0, a.assertArgument)(_ !== 0 && _ <= 32, "invalid bytes length", "type", fe);
    } else if (x[3]) {
      const _ = parseInt(x[3]);
      (0, a.assertArgument)(_ !== 0 && _ <= 256 && _ % 8 === 0, "invalid numeric width", "type", fe);
    }
    return fe;
  }
  const m = {}, l = Symbol.for("_ethers_internal"), b = "_ParamTypeInternal", W = "_ErrorInternal", X = "_EventInternal", G = "_ConstructorInternal", re = "_FallbackInternal", ce = "_FunctionInternal", pe = "_StructInternal", ve = class _i {
    /**
     *  @private
     */
    constructor(x, _, q, ne, de, ye, ge, be) {
      if (Fe(this, s), Se(this, "name"), Se(this, "type"), Se(this, "baseType"), Se(this, "indexed"), Se(this, "components"), Se(this, "arrayLength"), Se(this, "arrayChildren"), (0, a.assertPrivate)(x, m, "ParamType"), Object.defineProperty(this, l, { value: b }), ye && (ye = Object.freeze(ye.slice())), ne === "array") {
        if (ge == null || be == null)
          throw new Error("");
      } else if (ge != null || be != null)
        throw new Error("");
      if (ne === "tuple") {
        if (ye == null)
          throw new Error("");
      } else if (ye != null)
        throw new Error("");
      (0, a.defineProperties)(this, {
        name: _,
        type: q,
        baseType: ne,
        indexed: de,
        components: ye,
        arrayLength: ge,
        arrayChildren: be
      });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */
    format(x) {
      if (x == null && (x = "sighash"), x === "json") {
        const q = this.name || "";
        if (this.isArray()) {
          const de = JSON.parse(this.arrayChildren.format("json"));
          return de.name = q, de.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(de);
        }
        const ne = {
          type: this.baseType === "tuple" ? "tuple" : this.type,
          name: q
        };
        return typeof this.indexed == "boolean" && (ne.indexed = this.indexed), this.isTuple() && (ne.components = this.components.map((de) => JSON.parse(de.format(x)))), JSON.stringify(ne);
      }
      let _ = "";
      return this.isArray() ? (_ += this.arrayChildren.format(x), _ += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? _ += "(" + this.components.map((q) => q.format(x)).join(x === "full" ? ", " : ",") + ")" : _ += this.type, x !== "sighash" && (this.indexed === !0 && (_ += " indexed"), x === "full" && this.name && (_ += " " + this.name)), _;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */
    isArray() {
      return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */
    isTuple() {
      return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */
    isIndexable() {
      return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */
    walk(x, _) {
      if (this.isArray()) {
        if (!Array.isArray(x))
          throw new Error("invalid array value");
        if (this.arrayLength !== -1 && x.length !== this.arrayLength)
          throw new Error("array is wrong length");
        const q = this;
        return x.map((ne) => q.arrayChildren.walk(ne, _));
      }
      if (this.isTuple()) {
        if (!Array.isArray(x))
          throw new Error("invalid tuple value");
        if (x.length !== this.components.length)
          throw new Error("array is wrong length");
        const q = this;
        return x.map((ne, de) => q.components[de].walk(ne, _));
      }
      return _(this.type, x);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS naes by walking and resolving each
     *  ``"address"`` type.
     */
    async walkAsync(x, _) {
      const q = [], ne = [x];
      return qe(this, s, i).call(this, q, x, _, (de) => {
        ne[0] = de;
      }), q.length && await Promise.all(q), ne[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */
    static from(x, _) {
      if (_i.isParamType(x))
        return x;
      if (typeof x == "string")
        try {
          return _i.from(V(x), _);
        } catch {
          (0, a.assertArgument)(!1, "invalid param type", "obj", x);
        }
      else if (x instanceof k) {
        let ge = "", be = "", Me = null;
        o(x, d(["tuple"])).has("tuple") || x.peekType("OPEN_PAREN") ? (be = "tuple", Me = x.popParams().map((Ye) => _i.from(Ye)), ge = `tuple(${Me.map((Ye) => Ye.format()).join(",")})`) : (ge = w(x.popType("TYPE")), be = ge);
        let Ce = null, je = null;
        for (; x.length && x.peekType("BRACKET"); ) {
          const Ye = x.pop();
          Ce = new _i(m, "", ge, be, null, Me, je, Ce), je = Ye.value, ge += Ye.text, be = "array", Me = null;
        }
        let Ue = null;
        if (o(x, S).has("indexed")) {
          if (!_)
            throw new Error("");
          Ue = !0;
        }
        const Qe = x.peekType("ID") ? x.pop().text : "";
        if (x.length)
          throw new Error("leftover tokens");
        return new _i(m, Qe, ge, be, Ue, Me, je, Ce);
      }
      const q = x.name;
      (0, a.assertArgument)(!q || typeof q == "string" && q.match(L), "invalid name", "obj.name", q);
      let ne = x.indexed;
      ne != null && ((0, a.assertArgument)(_, "parameter cannot be indexed", "obj.indexed", x.indexed), ne = !!ne);
      let de = x.type, ye = de.match(P);
      if (ye) {
        const ge = parseInt(ye[2] || "-1"), be = _i.from({
          type: ye[1],
          components: x.components
        });
        return new _i(m, q || "", de, "array", ne, null, ge, be);
      }
      if (de === "tuple" || de.startsWith(
        "tuple("
        /* fix: ) */
      ) || de.startsWith(
        "("
        /* fix: ) */
      )) {
        const ge = x.components != null ? x.components.map((be) => _i.from(be)) : null;
        return new _i(m, q || "", de, "tuple", ne, ge, null, null);
      }
      return de = w(x.type), new _i(m, q || "", de, de, ne, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */
    static isParamType(x) {
      return x && x[l] === b;
    }
  };
  s = /* @__PURE__ */ new WeakSet(), i = function(fe, x, _, q) {
    if (this.isArray()) {
      if (!Array.isArray(x))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && x.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const de = this.arrayChildren, ye = x.slice();
      ye.forEach((ge, be) => {
        var Me;
        qe(Me = de, s, i).call(Me, fe, ge, _, (Ce) => {
          ye[be] = Ce;
        });
      }), q(ye);
      return;
    }
    if (this.isTuple()) {
      const de = this.components;
      let ye;
      if (Array.isArray(x))
        ye = x.slice();
      else {
        if (x == null || typeof x != "object")
          throw new Error("invalid tuple value");
        ye = de.map((ge) => {
          if (!ge.name)
            throw new Error("cannot use object value with unnamed components");
          if (!(ge.name in x))
            throw new Error(`missing value for component ${ge.name}`);
          return x[ge.name];
        });
      }
      if (ye.length !== this.components.length)
        throw new Error("array is wrong length");
      ye.forEach((ge, be) => {
        var Me;
        qe(Me = de[be], s, i).call(Me, fe, ge, _, (Ce) => {
          ye[be] = Ce;
        });
      }), q(ye);
      return;
    }
    const ne = _(this.type, x);
    ne.then ? fe.push(async function() {
      q(await ne);
    }()) : q(ne);
  };
  let Ee = ve;
  Gr.ParamType = Ee;
  class Pe {
    /**
     *  @private
     */
    constructor(x, _, q) {
      Se(this, "type"), Se(this, "inputs"), (0, a.assertPrivate)(x, m, "Fragment"), q = Object.freeze(q.slice()), (0, a.defineProperties)(this, { type: _, inputs: q });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */
    static from(x) {
      if (typeof x == "string") {
        try {
          Pe.from(JSON.parse(x));
        } catch {
        }
        return Pe.from(V(x));
      }
      if (x instanceof k)
        switch (x.peekKeyword(O)) {
          case "constructor":
            return ue.from(x);
          case "error":
            return te.from(x);
          case "event":
            return U.from(x);
          case "fallback":
          case "receive":
            return we.from(x);
          case "function":
            return ke.from(x);
          case "struct":
            return Re.from(x);
        }
      else if (typeof x == "object") {
        switch (x.type) {
          case "constructor":
            return ue.from(x);
          case "error":
            return te.from(x);
          case "event":
            return U.from(x);
          case "fallback":
          case "receive":
            return we.from(x);
          case "function":
            return ke.from(x);
          case "struct":
            return Re.from(x);
        }
        (0, a.assert)(!1, `unsupported type: ${x.type}`, "UNSUPPORTED_OPERATION", {
          operation: "Fragment.from"
        });
      }
      (0, a.assertArgument)(!1, "unsupported frgament object", "obj", x);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */
    static isConstructor(x) {
      return ue.isFragment(x);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */
    static isError(x) {
      return te.isFragment(x);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */
    static isEvent(x) {
      return U.isFragment(x);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */
    static isFunction(x) {
      return ke.isFragment(x);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */
    static isStruct(x) {
      return Re.isFragment(x);
    }
  }
  Gr.Fragment = Pe;
  class xe extends Pe {
    /**
     *  @private
     */
    constructor(x, _, q, ne) {
      super(x, _, ne), Se(this, "name"), (0, a.assertArgument)(typeof q == "string" && q.match(L), "invalid identifier", "name", q), ne = Object.freeze(ne.slice()), (0, a.defineProperties)(this, { name: q });
    }
  }
  Gr.NamedFragment = xe;
  function me(fe, x) {
    return "(" + x.map((_) => _.format(fe)).join(fe === "full" ? ", " : ",") + ")";
  }
  class te extends xe {
    /**
     *  @private
     */
    constructor(x, _, q) {
      super(x, "error", _, q), Object.defineProperty(this, l, { value: W });
    }
    /**
     *  The Custom Error selector.
     */
    get selector() {
      return (0, f.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */
    format(x) {
      if (x == null && (x = "sighash"), x === "json")
        return JSON.stringify({
          type: "error",
          name: this.name,
          inputs: this.inputs.map((q) => JSON.parse(q.format(x)))
        });
      const _ = [];
      return x !== "sighash" && _.push("error"), _.push(this.name + me(x, this.inputs)), _.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */
    static from(x) {
      if (te.isFragment(x))
        return x;
      if (typeof x == "string")
        return te.from(V(x));
      if (x instanceof k) {
        const _ = D("error", x), q = h(x);
        return E(x), new te(m, _, q);
      }
      return new te(m, x.name, x.inputs ? x.inputs.map(Ee.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */
    static isFragment(x) {
      return x && x[l] === W;
    }
  }
  Gr.ErrorFragment = te;
  class U extends xe {
    /**
     *  @private
     */
    constructor(x, _, q, ne) {
      super(x, "event", _, q), Se(this, "anonymous"), Object.defineProperty(this, l, { value: X }), (0, a.defineProperties)(this, { anonymous: ne });
    }
    /**
     *  The Event topic hash.
     */
    get topicHash() {
      return (0, f.id)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */
    format(x) {
      if (x == null && (x = "sighash"), x === "json")
        return JSON.stringify({
          type: "event",
          anonymous: this.anonymous,
          name: this.name,
          inputs: this.inputs.map((q) => JSON.parse(q.format(x)))
        });
      const _ = [];
      return x !== "sighash" && _.push("event"), _.push(this.name + me(x, this.inputs)), x !== "sighash" && this.anonymous && _.push("anonymous"), _.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */
    static getTopicHash(x, _) {
      return _ = (_ || []).map((q) => Ee.from(q)), new U(m, x, _, !1).topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */
    static from(x) {
      if (U.isFragment(x))
        return x;
      if (typeof x == "string")
        try {
          return U.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid event fragment", "obj", x);
        }
      else if (x instanceof k) {
        const _ = D("event", x), q = h(x, !0), ne = !!o(x, d(["anonymous"])).has("anonymous");
        return E(x), new U(m, _, q, ne);
      }
      return new U(m, x.name, x.inputs ? x.inputs.map((_) => Ee.from(_, !0)) : [], !!x.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */
    static isFragment(x) {
      return x && x[l] === X;
    }
  }
  Gr.EventFragment = U;
  class ue extends Pe {
    /**
     *  @private
     */
    constructor(x, _, q, ne, de) {
      super(x, _, q), Se(this, "payable"), Se(this, "gas"), Object.defineProperty(this, l, { value: G }), (0, a.defineProperties)(this, { payable: ne, gas: de });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */
    format(x) {
      if ((0, a.assert)(x != null && x !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" }), x === "json")
        return JSON.stringify({
          type: "constructor",
          stateMutability: this.payable ? "payable" : "undefined",
          payable: this.payable,
          gas: this.gas != null ? this.gas : void 0,
          inputs: this.inputs.map((q) => JSON.parse(q.format(x)))
        });
      const _ = [`constructor${me(x, this.inputs)}`];
      return this.payable && _.push("payable"), this.gas != null && _.push(`@${this.gas.toString()}`), _.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */
    static from(x) {
      if (ue.isFragment(x))
        return x;
      if (typeof x == "string")
        try {
          return ue.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid constuctor fragment", "obj", x);
        }
      else if (x instanceof k) {
        o(x, d(["constructor"]));
        const _ = h(x), q = !!o(x, c).has("payable"), ne = y(x);
        return E(x), new ue(m, "constructor", _, q, ne);
      }
      return new ue(m, "constructor", x.inputs ? x.inputs.map(Ee.from) : [], !!x.payable, x.gas != null ? x.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */
    static isFragment(x) {
      return x && x[l] === G;
    }
  }
  Gr.ConstructorFragment = ue;
  class we extends Pe {
    constructor(x, _, q) {
      super(x, "fallback", _), Se(this, "payable"), Object.defineProperty(this, l, { value: re }), (0, a.defineProperties)(this, { payable: q });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */
    format(x) {
      const _ = this.inputs.length === 0 ? "receive" : "fallback";
      if (x === "json") {
        const q = this.payable ? "payable" : "nonpayable";
        return JSON.stringify({ type: _, stateMutability: q });
      }
      return `${_}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */
    static from(x) {
      if (we.isFragment(x))
        return x;
      if (typeof x == "string")
        try {
          return we.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid fallback fragment", "obj", x);
        }
      else if (x instanceof k) {
        const _ = x.toString(), q = x.peekKeyword(d(["fallback", "receive"]));
        if ((0, a.assertArgument)(q, "type must be fallback or receive", "obj", _), x.popKeyword(d(["fallback", "receive"])) === "receive") {
          const ye = h(x);
          return (0, a.assertArgument)(ye.length === 0, "receive cannot have arguments", "obj.inputs", ye), o(x, d(["payable"])), E(x), new we(m, [], !0);
        }
        let ne = h(x);
        ne.length ? (0, a.assertArgument)(ne.length === 1 && ne[0].type === "bytes", "invalid fallback inputs", "obj.inputs", ne.map((ye) => ye.format("minimal")).join(", ")) : ne = [Ee.from("bytes")];
        const de = u(x);
        if ((0, a.assertArgument)(de === "nonpayable" || de === "payable", "fallback cannot be constants", "obj.stateMutability", de), o(x, d(["returns"])).has("returns")) {
          const ye = h(x);
          (0, a.assertArgument)(ye.length === 1 && ye[0].type === "bytes", "invalid fallback outputs", "obj.outputs", ye.map((ge) => ge.format("minimal")).join(", "));
        }
        return E(x), new we(m, ne, de === "payable");
      }
      if (x.type === "receive")
        return new we(m, [], !0);
      if (x.type === "fallback") {
        const _ = [Ee.from("bytes")], q = x.stateMutability === "payable";
        return new we(m, _, q);
      }
      (0, a.assertArgument)(!1, "invalid fallback description", "obj", x);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */
    static isFragment(x) {
      return x && x[l] === re;
    }
  }
  Gr.FallbackFragment = we;
  class ke extends xe {
    /**
     *  @private
     */
    constructor(x, _, q, ne, de, ye) {
      super(x, "function", _, ne), Se(this, "constant"), Se(this, "outputs"), Se(this, "stateMutability"), Se(this, "payable"), Se(this, "gas"), Object.defineProperty(this, l, { value: ce }), de = Object.freeze(de.slice());
      const ge = q === "view" || q === "pure", be = q === "payable";
      (0, a.defineProperties)(this, { constant: ge, gas: ye, outputs: de, payable: be, stateMutability: q });
    }
    /**
     *  The Function selector.
     */
    get selector() {
      return (0, f.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */
    format(x) {
      if (x == null && (x = "sighash"), x === "json")
        return JSON.stringify({
          type: "function",
          name: this.name,
          constant: this.constant,
          stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
          payable: this.payable,
          gas: this.gas != null ? this.gas : void 0,
          inputs: this.inputs.map((q) => JSON.parse(q.format(x))),
          outputs: this.outputs.map((q) => JSON.parse(q.format(x)))
        });
      const _ = [];
      return x !== "sighash" && _.push("function"), _.push(this.name + me(x, this.inputs)), x !== "sighash" && (this.stateMutability !== "nonpayable" && _.push(this.stateMutability), this.outputs && this.outputs.length && (_.push("returns"), _.push(me(x, this.outputs))), this.gas != null && _.push(`@${this.gas.toString()}`)), _.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */
    static getSelector(x, _) {
      return _ = (_ || []).map((q) => Ee.from(q)), new ke(m, x, "view", _, [], null).selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */
    static from(x) {
      if (ke.isFragment(x))
        return x;
      if (typeof x == "string")
        try {
          return ke.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid function fragment", "obj", x);
        }
      else if (x instanceof k) {
        const q = D("function", x), ne = h(x), de = u(x);
        let ye = [];
        o(x, d(["returns"])).has("returns") && (ye = h(x));
        const ge = y(x);
        return E(x), new ke(m, q, de, ne, ye, ge);
      }
      let _ = x.stateMutability;
      return _ == null && (_ = "payable", typeof x.constant == "boolean" ? (_ = "view", x.constant || (_ = "payable", typeof x.payable == "boolean" && !x.payable && (_ = "nonpayable"))) : typeof x.payable == "boolean" && !x.payable && (_ = "nonpayable")), new ke(m, x.name, _, x.inputs ? x.inputs.map(Ee.from) : [], x.outputs ? x.outputs.map(Ee.from) : [], x.gas != null ? x.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */
    static isFragment(x) {
      return x && x[l] === ce;
    }
  }
  Gr.FunctionFragment = ke;
  class Re extends xe {
    /**
     *  @private
     */
    constructor(x, _, q) {
      super(x, "struct", _, q), Object.defineProperty(this, l, { value: pe });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */
    format() {
      throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */
    static from(x) {
      if (typeof x == "string")
        try {
          return Re.from(V(x));
        } catch {
          (0, a.assertArgument)(!1, "invalid struct fragment", "obj", x);
        }
      else if (x instanceof k) {
        const _ = D("struct", x), q = h(x);
        return E(x), new Re(m, _, q);
      }
      return new Re(m, x.name, x.inputs ? x.inputs.map(Ee.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */
    static isFragment(x) {
      return x && x[l] === pe;
    }
  }
  return Gr.StructFragment = Re, Gr;
}
var q6;
function l7() {
  var e, t;
  if (q6)
    return bl;
  q6 = 1, Object.defineProperty(bl, "__esModule", { value: !0 }), bl.AbiCoder = void 0;
  const r = vt(), n = Yi(), s = QM(), i = i7(), a = YM(), f = s7(), d = XM(), c = eI(), p = tI(), g = rI(), v = nI(), O = Q1(), N = Xr(), S = vt(), j = /* @__PURE__ */ new Map();
  j.set(0, "GENERIC_PANIC"), j.set(1, "ASSERT_FALSE"), j.set(17, "OVERFLOW"), j.set(18, "DIVIDE_BY_ZERO"), j.set(33, "ENUM_RANGE_ERROR"), j.set(34, "BAD_STORAGE_DATA"), j.set(49, "STACK_UNDERFLOW"), j.set(50, "ARRAY_RANGE_ERROR"), j.set(65, "OUT_OF_MEMORY"), j.set(81, "UNINITIALIZED_FUNCTION_CALL");
  const B = new RegExp(/^bytes([0-9]*)$/), M = new RegExp(/^(u?int)([0-9]*)$/);
  let I = null, A = 1024;
  function R($, k, V, C) {
    let D = "missing revert data", o = null;
    const u = null;
    let h = null;
    if (V) {
      D = "execution reverted";
      const E = (0, S.getBytes)(V);
      if (V = (0, S.hexlify)(V), E.length === 0)
        D += " (no data present; likely require(false) occurred", o = "require(false)";
      else if (E.length % 32 !== 4)
        D += " (could not decode reason; invalid data length)";
      else if ((0, S.hexlify)(E.slice(0, 4)) === "0x08c379a0")
        try {
          o = C.decode(["string"], E.slice(4))[0], h = {
            signature: "Error(string)",
            name: "Error",
            args: [o]
          }, D += `: ${JSON.stringify(o)}`;
        } catch {
          D += " (could not decode reason; invalid string data)";
        }
      else if ((0, S.hexlify)(E.slice(0, 4)) === "0x4e487b71")
        try {
          const P = Number(C.decode(["uint256"], E.slice(4))[0]);
          h = {
            signature: "Panic(uint256)",
            name: "Panic",
            args: [P]
          }, o = `Panic due to ${j.get(P) || "UNKNOWN"}(${P})`, D += `: ${o}`;
        } catch {
          D += " (could not decode panic code)";
        }
      else
        D += " (unknown custom error)";
    }
    const y = {
      to: k.to ? (0, N.getAddress)(k.to) : null,
      data: k.data || "0x"
    };
    return k.from && (y.from = (0, N.getAddress)(k.from)), (0, S.makeError)(D, "CALL_EXCEPTION", {
      action: $,
      data: V,
      reason: o,
      transaction: y,
      invocation: u,
      revert: h
    });
  }
  const L = class Kp {
    constructor() {
      Fe(this, e);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */
    getDefaultValue(k) {
      const V = k.map((C) => qe(this, e, t).call(this, O.ParamType.from(C)));
      return new v.TupleCoder(V, "_").defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */
    encode(k, V) {
      (0, r.assertArgumentCount)(V.length, k.length, "types/values length mismatch");
      const C = k.map((u) => qe(this, e, t).call(this, O.ParamType.from(u))), D = new v.TupleCoder(C, "_"), o = new n.Writer();
      return D.encode(o, V), o.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */
    decode(k, V, C) {
      const D = k.map((o) => qe(this, e, t).call(this, O.ParamType.from(o)));
      return new v.TupleCoder(D, "_").decode(new n.Reader(V, C, A));
    }
    static _setDefaultMaxInflation(k) {
      (0, r.assertArgument)(typeof k == "number" && Number.isInteger(k), "invalid defaultMaxInflation factor", "value", k), A = k;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */
    static defaultAbiCoder() {
      return I == null && (I = new Kp()), I;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */
    static getBuiltinCallException(k, V, C) {
      return R(k, V, C, Kp.defaultAbiCoder());
    }
  };
  e = /* @__PURE__ */ new WeakSet(), t = function($) {
    if ($.isArray())
      return new i.ArrayCoder(qe(this, e, t).call(this, $.arrayChildren), $.arrayLength, $.name);
    if ($.isTuple())
      return new v.TupleCoder($.components.map((V) => qe(this, e, t).call(this, V)), $.name);
    switch ($.baseType) {
      case "address":
        return new s.AddressCoder($.name);
      case "bool":
        return new a.BooleanCoder($.name);
      case "string":
        return new g.StringCoder($.name);
      case "bytes":
        return new f.BytesCoder($.name);
      case "":
        return new c.NullCoder($.name);
    }
    let k = $.type.match(M);
    if (k) {
      let V = parseInt(k[2] || "256");
      return (0, r.assertArgument)(V !== 0 && V <= 256 && V % 8 === 0, "invalid " + k[1] + " bit length", "param", $), new p.NumberCoder(V / 8, k[1] === "int", $.name);
    }
    if (k = $.type.match(B), k) {
      let V = parseInt(k[1]);
      return (0, r.assertArgument)(V !== 0 && V <= 32, "invalid bytes length", "param", $), new d.FixedBytesCoder(V, $.name);
    }
    (0, r.assertArgument)(!1, "invalid type", "type", $.type);
  };
  let K = L;
  return bl.AbiCoder = K, bl;
}
var Ma = {}, $6;
function lI() {
  if ($6)
    return Ma;
  $6 = 1, Object.defineProperty(Ma, "__esModule", { value: !0 }), Ma.decodeBytes32String = Ma.encodeBytes32String = void 0;
  const e = vt();
  function t(n) {
    const s = (0, e.toUtf8Bytes)(n);
    if (s.length > 31)
      throw new Error("bytes32 string must be less than 32 bytes");
    return (0, e.zeroPadBytes)(s, 32);
  }
  Ma.encodeBytes32String = t;
  function r(n) {
    const s = (0, e.getBytes)(n, "bytes");
    if (s.length !== 32)
      throw new Error("invalid bytes32 - not 32 bytes long");
    if (s[31] !== 0)
      throw new Error("invalid bytes32 string - no null terminator");
    let i = 31;
    for (; s[i - 1] === 0; )
      i--;
    return (0, e.toUtf8String)(s.slice(0, i));
  }
  return Ma.decodeBytes32String = r, Ma;
}
var K6 = {}, J6;
function dI() {
  return J6 || (J6 = 1, function(e) {
    var t, r, n, s, i, a, f, d;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Interface = e.Indexed = e.ErrorDescription = e.TransactionDescription = e.LogDescription = e.Result = e.checkResultErrors = void 0;
    const c = ln(), p = so(), g = vt(), v = l7(), O = Yi();
    Object.defineProperty(e, "checkResultErrors", { enumerable: !0, get: function() {
      return O.checkResultErrors;
    } }), Object.defineProperty(e, "Result", { enumerable: !0, get: function() {
      return O.Result;
    } });
    const N = Q1(), S = io();
    class j {
      /**
       *  @_ignore:
       */
      constructor(k, V, C) {
        Se(this, "fragment"), Se(this, "name"), Se(this, "signature"), Se(this, "topic"), Se(this, "args");
        const D = k.name, o = k.format();
        (0, g.defineProperties)(this, {
          fragment: k,
          name: D,
          signature: o,
          topic: V,
          args: C
        });
      }
    }
    e.LogDescription = j;
    class B {
      /**
       *  @_ignore:
       */
      constructor(k, V, C, D) {
        Se(this, "fragment"), Se(this, "name"), Se(this, "args"), Se(this, "signature"), Se(this, "selector"), Se(this, "value");
        const o = k.name, u = k.format();
        (0, g.defineProperties)(this, {
          fragment: k,
          name: o,
          args: C,
          signature: u,
          selector: V,
          value: D
        });
      }
    }
    e.TransactionDescription = B;
    class M {
      /**
       *  @_ignore:
       */
      constructor(k, V, C) {
        Se(this, "fragment"), Se(this, "name"), Se(this, "args"), Se(this, "signature"), Se(this, "selector");
        const D = k.name, o = k.format();
        (0, g.defineProperties)(this, {
          fragment: k,
          name: D,
          args: C,
          signature: o,
          selector: V
        });
      }
    }
    e.ErrorDescription = M;
    class I {
      /**
       *  @_ignore:
       */
      constructor(k) {
        Se(this, "hash"), Se(this, "_isIndexed"), (0, g.defineProperties)(this, { hash: k, _isIndexed: !0 });
      }
      /**
       *  Returns ``true`` if %%value%% is an **Indexed**.
       *
       *  This provides a Type Guard for property access.
       */
      static isIndexed(k) {
        return !!(k && k._isIndexed);
      }
    }
    e.Indexed = I;
    const A = {
      0: "generic panic",
      1: "assert(false)",
      17: "arithmetic overflow",
      18: "division or modulo by zero",
      33: "enum overflow",
      34: "invalid encoded storage byte array accessed",
      49: "out-of-bounds array access; popping on an empty array",
      50: "out-of-bounds access of an array or bytesN",
      65: "out of memory",
      81: "uninitialized function"
    }, R = {
      "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: ["string"],
        reason: ($) => `reverted with reason string ${JSON.stringify($)}`
      },
      "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: ["uint256"],
        reason: ($) => {
          let k = "unknown panic code";
          return $ >= 0 && $ <= 255 && A[$.toString()] && (k = A[$.toString()]), `reverted with panic code 0x${$.toString(16)} (${k})`;
        }
      }
    }, L = class Eu {
      /**
       *  Create a new Interface for the %%fragments%%.
       */
      constructor(k) {
        Fe(this, i), Fe(this, f), Se(this, "fragments"), Se(this, "deploy"), Se(this, "fallback"), Se(this, "receive"), Fe(this, t, void 0), Fe(this, r, void 0), Fe(this, n, void 0), Fe(this, s, void 0);
        let V = [];
        typeof k == "string" ? V = JSON.parse(k) : V = k, Ne(this, n, /* @__PURE__ */ new Map()), Ne(this, t, /* @__PURE__ */ new Map()), Ne(this, r, /* @__PURE__ */ new Map());
        const C = [];
        for (const u of V)
          try {
            C.push(N.Fragment.from(u));
          } catch (h) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(u)}:`, h.message);
          }
        (0, g.defineProperties)(this, {
          fragments: Object.freeze(C)
        });
        let D = null, o = !1;
        Ne(this, s, this.getAbiCoder()), this.fragments.forEach((u, h) => {
          let y;
          switch (u.type) {
            case "constructor":
              if (this.deploy) {
                console.log("duplicate definition - constructor");
                return;
              }
              (0, g.defineProperties)(this, { deploy: u });
              return;
            case "fallback":
              u.inputs.length === 0 ? o = !0 : ((0, g.assertArgument)(!D || u.payable !== D.payable, "conflicting fallback fragments", `fragments[${h}]`, u), D = u, o = D.payable);
              return;
            case "function":
              y = ae(this, n);
              break;
            case "event":
              y = ae(this, r);
              break;
            case "error":
              y = ae(this, t);
              break;
            default:
              return;
          }
          const E = u.format();
          y.has(E) || y.set(E, u);
        }), this.deploy || (0, g.defineProperties)(this, {
          deploy: N.ConstructorFragment.from("constructor()")
        }), (0, g.defineProperties)(this, { fallback: D, receive: o });
      }
      /**
       *  Returns the entire Human-Readable ABI, as an array of
       *  signatures, optionally as %%minimal%% strings, which
       *  removes parameter names and unneceesary spaces.
       */
      format(k) {
        const V = k ? "minimal" : "full";
        return this.fragments.map((C) => C.format(V));
      }
      /**
       *  Return the JSON-encoded ABI. This is the format Solidiy
       *  returns.
       */
      formatJson() {
        const k = this.fragments.map((V) => V.format("json"));
        return JSON.stringify(k.map((V) => JSON.parse(V)));
      }
      /**
       *  The ABI coder that will be used to encode and decode binary
       *  data.
       */
      getAbiCoder() {
        return v.AbiCoder.defaultAbiCoder();
      }
      /**
       *  Get the function name for %%key%%, which may be a function selector,
       *  function name or function signature that belongs to the ABI.
       */
      getFunctionName(k) {
        const V = qe(this, i, a).call(this, k, null, !1);
        return (0, g.assertArgument)(V, "no matching function", "key", k), V.name;
      }
      /**
       *  Returns true if %%key%% (a function selector, function name or
       *  function signature) is present in the ABI.
       *
       *  In the case of a function name, the name may be ambiguous, so
       *  accessing the [[FunctionFragment]] may require refinement.
       */
      hasFunction(k) {
        return !!qe(this, i, a).call(this, k, null, !1);
      }
      /**
       *  Get the [[FunctionFragment]] for %%key%%, which may be a function
       *  selector, function name or function signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple functions match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single function in
       *  the ABI, this will throw.
       */
      getFunction(k, V) {
        return qe(this, i, a).call(this, k, V || null, !0);
      }
      /**
       *  Iterate over all functions, calling %%callback%%, sorted by their name.
       */
      forEachFunction(k) {
        const V = Array.from(ae(this, n).keys());
        V.sort((C, D) => C.localeCompare(D));
        for (let C = 0; C < V.length; C++) {
          const D = V[C];
          k(ae(this, n).get(D), C);
        }
      }
      /**
       *  Get the event name for %%key%%, which may be a topic hash,
       *  event name or event signature that belongs to the ABI.
       */
      getEventName(k) {
        const V = qe(this, f, d).call(this, k, null, !1);
        return (0, g.assertArgument)(V, "no matching event", "key", k), V.name;
      }
      /**
       *  Returns true if %%key%% (an event topic hash, event name or
       *  event signature) is present in the ABI.
       *
       *  In the case of an event name, the name may be ambiguous, so
       *  accessing the [[EventFragment]] may require refinement.
       */
      hasEvent(k) {
        return !!qe(this, f, d).call(this, k, null, !1);
      }
      /**
       *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
       *  event name or event signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple events match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single event in
       *  the ABI, this will throw.
       */
      getEvent(k, V) {
        return qe(this, f, d).call(this, k, V || null, !0);
      }
      /**
       *  Iterate over all events, calling %%callback%%, sorted by their name.
       */
      forEachEvent(k) {
        const V = Array.from(ae(this, r).keys());
        V.sort((C, D) => C.localeCompare(D));
        for (let C = 0; C < V.length; C++) {
          const D = V[C];
          k(ae(this, r).get(D), C);
        }
      }
      /**
       *  Get the [[ErrorFragment]] for %%key%%, which may be an error
       *  selector, error name or error signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple errors match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single error in
       *  the ABI, this will throw.
       */
      getError(k, V) {
        if ((0, g.isHexString)(k)) {
          const C = k.toLowerCase();
          if (R[C])
            return N.ErrorFragment.from(R[C].signature);
          for (const D of ae(this, t).values())
            if (C === D.selector)
              return D;
          return null;
        }
        if (k.indexOf("(") === -1) {
          const C = [];
          for (const [D, o] of ae(this, t))
            D.split(
              "("
              /* fix:) */
            )[0] === k && C.push(o);
          if (C.length === 0)
            return k === "Error" ? N.ErrorFragment.from("error Error(string)") : k === "Panic" ? N.ErrorFragment.from("error Panic(uint256)") : null;
          if (C.length > 1) {
            const D = C.map((o) => JSON.stringify(o.format())).join(", ");
            (0, g.assertArgument)(!1, `ambiguous error description (i.e. ${D})`, "name", k);
          }
          return C[0];
        }
        return k = N.ErrorFragment.from(k).format(), k === "Error(string)" ? N.ErrorFragment.from("error Error(string)") : k === "Panic(uint256)" ? N.ErrorFragment.from("error Panic(uint256)") : ae(this, t).get(k) || null;
      }
      /**
       *  Iterate over all errors, calling %%callback%%, sorted by their name.
       */
      forEachError(k) {
        const V = Array.from(ae(this, t).keys());
        V.sort((C, D) => C.localeCompare(D));
        for (let C = 0; C < V.length; C++) {
          const D = V[C];
          k(ae(this, t).get(D), C);
        }
      }
      // Get the 4-byte selector used by Solidity to identify a function
      /*
      		getSelector(fragment: ErrorFragment | FunctionFragment): string {
      		    if (typeof(fragment) === "string") {
      		        const matches: Array<Fragment> = [ ];
      
      		        try { matches.push(this.getFunction(fragment)); } catch (error) { }
      		        try { matches.push(this.getError(<string>fragment)); } catch (_) { }
      
      		        if (matches.length === 0) {
      		            logger.throwArgumentError("unknown fragment", "key", fragment);
      		        } else if (matches.length > 1) {
      		            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
      		        }
      
      		        fragment = matches[0];
      		    }
      
      		    return dataSlice(id(fragment.format()), 0, 4);
      		}
      		    */
      // Get the 32-byte topic hash used by Solidity to identify an event
      /*
      getEventTopic(fragment: EventFragment): string {
          //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
          return id(fragment.format());
      }
      */
      _decodeParams(k, V) {
        return ae(this, s).decode(k, V);
      }
      _encodeParams(k, V) {
        return ae(this, s).encode(k, V);
      }
      /**
       *  Encodes a ``tx.data`` object for deploying the Contract with
       *  the %%values%% as the constructor arguments.
       */
      encodeDeploy(k) {
        return this._encodeParams(this.deploy.inputs, k || []);
      }
      /**
       *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
       *  specified error (see [[getError]] for valid values for
       *  %%key%%).
       *
       *  Most developers should prefer the [[parseCallResult]] method instead,
       *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
       *  corresponding error.
       */
      decodeErrorResult(k, V) {
        if (typeof k == "string") {
          const C = this.getError(k);
          (0, g.assertArgument)(C, "unknown error", "fragment", k), k = C;
        }
        return (0, g.assertArgument)((0, g.dataSlice)(V, 0, 4) === k.selector, `data signature does not match error ${k.name}.`, "data", V), this._decodeParams(k.inputs, (0, g.dataSlice)(V, 4));
      }
      /**
       *  Encodes the transaction revert data for a call result that
       *  reverted from the the Contract with the sepcified %%error%%
       *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
       *
       *  This is generally not used by most developers, unless trying to mock
       *  a result from a Contract.
       */
      encodeErrorResult(k, V) {
        if (typeof k == "string") {
          const C = this.getError(k);
          (0, g.assertArgument)(C, "unknown error", "fragment", k), k = C;
        }
        return (0, g.concat)([
          k.selector,
          this._encodeParams(k.inputs, V || [])
        ]);
      }
      /**
       *  Decodes the %%data%% from a transaction ``tx.data`` for
       *  the function specified (see [[getFunction]] for valid values
       *  for %%fragment%%).
       *
       *  Most developers should prefer the [[parseTransaction]] method
       *  instead, which will automatically detect the fragment.
       */
      decodeFunctionData(k, V) {
        if (typeof k == "string") {
          const C = this.getFunction(k);
          (0, g.assertArgument)(C, "unknown function", "fragment", k), k = C;
        }
        return (0, g.assertArgument)((0, g.dataSlice)(V, 0, 4) === k.selector, `data signature does not match function ${k.name}.`, "data", V), this._decodeParams(k.inputs, (0, g.dataSlice)(V, 4));
      }
      /**
       *  Encodes the ``tx.data`` for a transaction that calls the function
       *  specified (see [[getFunction]] for valid values for %%fragment%%) with
       *  the %%values%%.
       */
      encodeFunctionData(k, V) {
        if (typeof k == "string") {
          const C = this.getFunction(k);
          (0, g.assertArgument)(C, "unknown function", "fragment", k), k = C;
        }
        return (0, g.concat)([
          k.selector,
          this._encodeParams(k.inputs, V || [])
        ]);
      }
      /**
       *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
       *  specified function (see [[getFunction]] for valid values for
       *  %%key%%).
       *
       *  Most developers should prefer the [[parseCallResult]] method instead,
       *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
       *  corresponding error.
       */
      decodeFunctionResult(k, V) {
        if (typeof k == "string") {
          const o = this.getFunction(k);
          (0, g.assertArgument)(o, "unknown function", "fragment", k), k = o;
        }
        let C = "invalid length for result data";
        const D = (0, g.getBytesCopy)(V);
        if (D.length % 32 === 0)
          try {
            return ae(this, s).decode(k.outputs, D);
          } catch {
            C = "could not decode result data";
          }
        (0, g.assert)(!1, C, "BAD_DATA", {
          value: (0, g.hexlify)(D),
          info: { method: k.name, signature: k.format() }
        });
      }
      makeError(k, V) {
        const C = (0, g.getBytes)(k, "data"), D = v.AbiCoder.getBuiltinCallException("call", V, C);
        if (D.message.startsWith("execution reverted (unknown custom error)")) {
          const u = (0, g.hexlify)(C.slice(0, 4)), h = this.getError(u);
          if (h)
            try {
              const y = ae(this, s).decode(h.inputs, C.slice(4));
              D.revert = {
                name: h.name,
                signature: h.format(),
                args: y
              }, D.reason = D.revert.signature, D.message = `execution reverted: ${D.reason}`;
            } catch {
              D.message = "execution reverted (coult not decode custom error)";
            }
        }
        const o = this.parseTransaction(V);
        return o && (D.invocation = {
          method: o.name,
          signature: o.signature,
          args: o.args
        }), D;
      }
      /**
       *  Encodes the result data (e.g. from an ``eth_call``) for the
       *  specified function (see [[getFunction]] for valid values
       *  for %%fragment%%) with %%values%%.
       *
       *  This is generally not used by most developers, unless trying to mock
       *  a result from a Contract.
       */
      encodeFunctionResult(k, V) {
        if (typeof k == "string") {
          const C = this.getFunction(k);
          (0, g.assertArgument)(C, "unknown function", "fragment", k), k = C;
        }
        return (0, g.hexlify)(ae(this, s).encode(k.outputs, V || []));
      }
      /*
          spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
              const promises: Array<Promise<>> = [ ];
              const process = function(type: ParamType, value: any): any {
                  if (type.baseType === "array") {
                      return descend(type.child
                  }
                  if (type. === "address") {
                  }
              };
      
              const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                  if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                  
              };
      
              const result: Array<any> = [ ];
              values.forEach((value, index) => {
                  if (value == null) {
                      topics.push(null);
                  } else if (param.baseType === "array" || param.baseType === "tuple") {
                      logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                  } else if (Array.isArray(value)) {
                      topics.push(value.map((value) => encodeTopic(param, value)));
                  } else {
                      topics.push(encodeTopic(param, value));
                  }
              });
          }
      */
      // Create the filter for the event with search criteria (e.g. for eth_filterLog)
      encodeFilterTopics(k, V) {
        if (typeof k == "string") {
          const o = this.getEvent(k);
          (0, g.assertArgument)(o, "unknown event", "eventFragment", k), k = o;
        }
        (0, g.assert)(V.length <= k.inputs.length, `too many arguments for ${k.format()}`, "UNEXPECTED_ARGUMENT", { count: V.length, expectedCount: k.inputs.length });
        const C = [];
        k.anonymous || C.push(k.topicHash);
        const D = (o, u) => o.type === "string" ? (0, p.id)(u) : o.type === "bytes" ? (0, c.keccak256)((0, g.hexlify)(u)) : (o.type === "bool" && typeof u == "boolean" ? u = u ? "0x01" : "0x00" : o.type.match(/^u?int/) ? u = (0, g.toBeHex)(u) : o.type.match(/^bytes/) ? u = (0, g.zeroPadBytes)(u, 32) : o.type === "address" && ae(this, s).encode(["address"], [u]), (0, g.zeroPadValue)((0, g.hexlify)(u), 32));
        for (V.forEach((o, u) => {
          const h = k.inputs[u];
          if (!h.indexed) {
            (0, g.assertArgument)(o == null, "cannot filter non-indexed parameters; must be null", "contract." + h.name, o);
            return;
          }
          o == null ? C.push(null) : h.baseType === "array" || h.baseType === "tuple" ? (0, g.assertArgument)(!1, "filtering with tuples or arrays not supported", "contract." + h.name, o) : Array.isArray(o) ? C.push(o.map((y) => D(h, y))) : C.push(D(h, o));
        }); C.length && C[C.length - 1] === null; )
          C.pop();
        return C;
      }
      encodeEventLog(k, V) {
        if (typeof k == "string") {
          const u = this.getEvent(k);
          (0, g.assertArgument)(u, "unknown event", "eventFragment", k), k = u;
        }
        const C = [], D = [], o = [];
        return k.anonymous || C.push(k.topicHash), (0, g.assertArgument)(V.length === k.inputs.length, "event arguments/values mismatch", "values", V), k.inputs.forEach((u, h) => {
          const y = V[h];
          if (u.indexed)
            if (u.type === "string")
              C.push((0, p.id)(y));
            else if (u.type === "bytes")
              C.push((0, c.keccak256)(y));
            else {
              if (u.baseType === "tuple" || u.baseType === "array")
                throw new Error("not implemented");
              C.push(ae(this, s).encode([u.type], [y]));
            }
          else
            D.push(u), o.push(y);
        }), {
          data: ae(this, s).encode(D, o),
          topics: C
        };
      }
      // Decode a filter for the event and the search criteria
      decodeEventLog(k, V, C) {
        if (typeof k == "string") {
          const l = this.getEvent(k);
          (0, g.assertArgument)(l, "unknown event", "eventFragment", k), k = l;
        }
        if (C != null && !k.anonymous) {
          const l = k.topicHash;
          (0, g.assertArgument)((0, g.isHexString)(C[0], 32) && C[0].toLowerCase() === l, "fragment/topic mismatch", "topics[0]", C[0]), C = C.slice(1);
        }
        const D = [], o = [], u = [];
        k.inputs.forEach((l, b) => {
          l.indexed ? l.type === "string" || l.type === "bytes" || l.baseType === "tuple" || l.baseType === "array" ? (D.push(N.ParamType.from({ type: "bytes32", name: l.name })), u.push(!0)) : (D.push(l), u.push(!1)) : (o.push(l), u.push(!1));
        });
        const h = C != null ? ae(this, s).decode(D, (0, g.concat)(C)) : null, y = ae(this, s).decode(o, V, !0), E = [], P = [];
        let w = 0, m = 0;
        return k.inputs.forEach((l, b) => {
          let W = null;
          if (l.indexed)
            if (h == null)
              W = new I(null);
            else if (u[b])
              W = new I(h[m++]);
            else
              try {
                W = h[m++];
              } catch (X) {
                W = X;
              }
          else
            try {
              W = y[w++];
            } catch (X) {
              W = X;
            }
          E.push(W), P.push(l.name || null);
        }), O.Result.fromItems(E, P);
      }
      /**
       *  Parses a transaction, finding the matching function and extracts
       *  the parameter values along with other useful function details.
       *
       *  If the matching function cannot be found, return null.
       */
      parseTransaction(k) {
        const V = (0, g.getBytes)(k.data, "tx.data"), C = (0, g.getBigInt)(k.value != null ? k.value : 0, "tx.value"), D = this.getFunction((0, g.hexlify)(V.slice(0, 4)));
        if (!D)
          return null;
        const o = ae(this, s).decode(D.inputs, V.slice(4));
        return new B(D, D.selector, o, C);
      }
      parseCallResult(k) {
        throw new Error("@TODO");
      }
      /**
       *  Parses a receipt log, finding the matching event and extracts
       *  the parameter values along with other useful event details.
       *
       *  If the matching event cannot be found, returns null.
       */
      parseLog(k) {
        const V = this.getEvent(k.topics[0]);
        return !V || V.anonymous ? null : new j(V, V.topicHash, this.decodeEventLog(V, k.data, k.topics));
      }
      /**
       *  Parses a revert data, finding the matching error and extracts
       *  the parameter values along with other useful error details.
       *
       *  If the matching error cannot be found, returns null.
       */
      parseError(k) {
        const V = (0, g.hexlify)(k), C = this.getError((0, g.dataSlice)(V, 0, 4));
        if (!C)
          return null;
        const D = ae(this, s).decode(C.inputs, (0, g.dataSlice)(V, 4));
        return new M(C, C.selector, D);
      }
      /**
       *  Creates a new [[Interface]] from the ABI %%value%%.
       *
       *  The %%value%% may be provided as an existing [[Interface]] object,
       *  a JSON-encoded ABI or any Human-Readable ABI format.
       */
      static from(k) {
        return k instanceof Eu ? k : typeof k == "string" ? new Eu(JSON.parse(k)) : typeof k.formatJson == "function" ? new Eu(k.formatJson()) : typeof k.format == "function" ? new Eu(k.format("json")) : new Eu(k);
      }
    };
    t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakSet(), a = function($, k, V) {
      if ((0, g.isHexString)($)) {
        const C = $.toLowerCase();
        for (const D of ae(this, n).values())
          if (C === D.selector)
            return D;
        return null;
      }
      if ($.indexOf("(") === -1) {
        const C = [];
        for (const [D, o] of ae(this, n))
          D.split(
            "("
            /* fix:) */
          )[0] === $ && C.push(o);
        if (k) {
          const D = k.length > 0 ? k[k.length - 1] : null;
          let o = k.length, u = !0;
          S.Typed.isTyped(D) && D.type === "overrides" && (u = !1, o--);
          for (let h = C.length - 1; h >= 0; h--) {
            const y = C[h].inputs.length;
            y !== o && (!u || y !== o - 1) && C.splice(h, 1);
          }
          for (let h = C.length - 1; h >= 0; h--) {
            const y = C[h].inputs;
            for (let E = 0; E < k.length; E++)
              if (S.Typed.isTyped(k[E])) {
                if (E >= y.length) {
                  if (k[E].type === "overrides")
                    continue;
                  C.splice(h, 1);
                  break;
                }
                if (k[E].type !== y[E].baseType) {
                  C.splice(h, 1);
                  break;
                }
              }
          }
        }
        if (C.length === 1 && k && k.length !== C[0].inputs.length) {
          const D = k[k.length - 1];
          (D == null || Array.isArray(D) || typeof D != "object") && C.splice(0, 1);
        }
        if (C.length === 0)
          return null;
        if (C.length > 1 && V) {
          const D = C.map((o) => JSON.stringify(o.format())).join(", ");
          (0, g.assertArgument)(!1, `ambiguous function description (i.e. matches ${D})`, "key", $);
        }
        return C[0];
      }
      return ae(this, n).get(N.FunctionFragment.from($).format()) || null;
    }, f = /* @__PURE__ */ new WeakSet(), d = function($, k, V) {
      if ((0, g.isHexString)($)) {
        const C = $.toLowerCase();
        for (const D of ae(this, r).values())
          if (C === D.topicHash)
            return D;
        return null;
      }
      if ($.indexOf("(") === -1) {
        const C = [];
        for (const [D, o] of ae(this, r))
          D.split(
            "("
            /* fix:) */
          )[0] === $ && C.push(o);
        if (k) {
          for (let D = C.length - 1; D >= 0; D--)
            C[D].inputs.length < k.length && C.splice(D, 1);
          for (let D = C.length - 1; D >= 0; D--) {
            const o = C[D].inputs;
            for (let u = 0; u < k.length; u++)
              if (S.Typed.isTyped(k[u]) && k[u].type !== o[u].baseType) {
                C.splice(D, 1);
                break;
              }
          }
        }
        if (C.length === 0)
          return null;
        if (C.length > 1 && V) {
          const D = C.map((o) => JSON.stringify(o.format())).join(", ");
          (0, g.assertArgument)(!1, `ambiguous event description (i.e. matches ${D})`, "key", $);
        }
        return C[0];
      }
      return ae(this, r).get(N.EventFragment.from($).format()) || null;
    };
    let K = L;
    e.Interface = K;
  }(K6)), K6;
}
var Q6;
function Ed() {
  return Q6 || (Q6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Typed = e.Result = e.TransactionDescription = e.LogDescription = e.ErrorDescription = e.Interface = e.Indexed = e.checkResultErrors = e.StructFragment = e.ParamType = e.NamedFragment = e.FunctionFragment = e.Fragment = e.FallbackFragment = e.EventFragment = e.ErrorFragment = e.ConstructorFragment = e.encodeBytes32String = e.decodeBytes32String = e.AbiCoder = void 0;
    var t = l7();
    Object.defineProperty(e, "AbiCoder", { enumerable: !0, get: function() {
      return t.AbiCoder;
    } });
    var r = lI();
    Object.defineProperty(e, "decodeBytes32String", { enumerable: !0, get: function() {
      return r.decodeBytes32String;
    } }), Object.defineProperty(e, "encodeBytes32String", { enumerable: !0, get: function() {
      return r.encodeBytes32String;
    } });
    var n = Q1();
    Object.defineProperty(e, "ConstructorFragment", { enumerable: !0, get: function() {
      return n.ConstructorFragment;
    } }), Object.defineProperty(e, "ErrorFragment", { enumerable: !0, get: function() {
      return n.ErrorFragment;
    } }), Object.defineProperty(e, "EventFragment", { enumerable: !0, get: function() {
      return n.EventFragment;
    } }), Object.defineProperty(e, "FallbackFragment", { enumerable: !0, get: function() {
      return n.FallbackFragment;
    } }), Object.defineProperty(e, "Fragment", { enumerable: !0, get: function() {
      return n.Fragment;
    } }), Object.defineProperty(e, "FunctionFragment", { enumerable: !0, get: function() {
      return n.FunctionFragment;
    } }), Object.defineProperty(e, "NamedFragment", { enumerable: !0, get: function() {
      return n.NamedFragment;
    } }), Object.defineProperty(e, "ParamType", { enumerable: !0, get: function() {
      return n.ParamType;
    } }), Object.defineProperty(e, "StructFragment", { enumerable: !0, get: function() {
      return n.StructFragment;
    } });
    var s = dI();
    Object.defineProperty(e, "checkResultErrors", { enumerable: !0, get: function() {
      return s.checkResultErrors;
    } }), Object.defineProperty(e, "Indexed", { enumerable: !0, get: function() {
      return s.Indexed;
    } }), Object.defineProperty(e, "Interface", { enumerable: !0, get: function() {
      return s.Interface;
    } }), Object.defineProperty(e, "ErrorDescription", { enumerable: !0, get: function() {
      return s.ErrorDescription;
    } }), Object.defineProperty(e, "LogDescription", { enumerable: !0, get: function() {
      return s.LogDescription;
    } }), Object.defineProperty(e, "TransactionDescription", { enumerable: !0, get: function() {
      return s.TransactionDescription;
    } }), Object.defineProperty(e, "Result", { enumerable: !0, get: function() {
      return s.Result;
    } });
    var i = io();
    Object.defineProperty(e, "Typed", { enumerable: !0, get: function() {
      return i.Typed;
    } });
  }(ub)), ub;
}
var Z6 = {}, Si = {}, vn = {}, Y6;
function Pd() {
  var e, t, r;
  if (Y6)
    return vn;
  Y6 = 1, Object.defineProperty(vn, "__esModule", { value: !0 }), vn.TransactionResponse = vn.TransactionReceipt = vn.Log = vn.Block = vn.copyRequest = vn.FeeData = void 0;
  const n = vt(), s = ei(), i = BigInt(0);
  function a(I) {
    return I ?? null;
  }
  function f(I) {
    return I == null ? null : I.toString();
  }
  class d {
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */
    constructor(A, R, L) {
      Se(this, "gasPrice"), Se(this, "maxFeePerGas"), Se(this, "maxPriorityFeePerGas"), (0, n.defineProperties)(this, {
        gasPrice: a(A),
        maxFeePerGas: a(R),
        maxPriorityFeePerGas: a(L)
      });
    }
    /**
     *  Returns a JSON-friendly value.
     */
    toJSON() {
      const { gasPrice: A, maxFeePerGas: R, maxPriorityFeePerGas: L } = this;
      return {
        _type: "FeeData",
        gasPrice: f(A),
        maxFeePerGas: f(R),
        maxPriorityFeePerGas: f(L)
      };
    }
  }
  vn.FeeData = d;
  function c(I) {
    const A = {};
    I.to && (A.to = I.to), I.from && (A.from = I.from), I.data && (A.data = (0, n.hexlify)(I.data));
    const R = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const K of R)
      !(K in I) || I[K] == null || (A[K] = (0, n.getBigInt)(I[K], `request.${K}`));
    const L = "type,nonce".split(/,/);
    for (const K of L)
      !(K in I) || I[K] == null || (A[K] = (0, n.getNumber)(I[K], `request.${K}`));
    return I.accessList && (A.accessList = (0, s.accessListify)(I.accessList)), "blockTag" in I && (A.blockTag = I.blockTag), "enableCcipRead" in I && (A.enableCcipRead = !!I.enableCcipRead), "customData" in I && (A.customData = I.customData), "blobVersionedHashes" in I && I.blobVersionedHashes && (A.blobVersionedHashes = I.blobVersionedHashes.slice()), "kzg" in I && (A.kzg = I.kzg), "blobs" in I && I.blobs && (A.blobs = I.blobs.map((K) => (0, n.isBytesLike)(K) ? (0, n.hexlify)(K) : Object.assign({}, K))), A;
  }
  vn.copyRequest = c;
  class p {
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */
    constructor(A, R) {
      Se(this, "provider"), Se(this, "number"), Se(this, "hash"), Se(this, "timestamp"), Se(this, "parentHash"), Se(this, "parentBeaconBlockRoot"), Se(this, "nonce"), Se(this, "difficulty"), Se(this, "gasLimit"), Se(this, "gasUsed"), Se(this, "stateRoot"), Se(this, "receiptsRoot"), Se(this, "blobGasUsed"), Se(this, "excessBlobGas"), Se(this, "miner"), Se(this, "prevRandao"), Se(this, "extraData"), Se(this, "baseFeePerGas"), Fe(this, e, void 0), Ne(this, e, A.transactions.map((L) => typeof L != "string" ? new N(L, R) : L)), (0, n.defineProperties)(this, {
        provider: R,
        hash: a(A.hash),
        number: A.number,
        timestamp: A.timestamp,
        parentHash: A.parentHash,
        parentBeaconBlockRoot: A.parentBeaconBlockRoot,
        nonce: A.nonce,
        difficulty: A.difficulty,
        gasLimit: A.gasLimit,
        gasUsed: A.gasUsed,
        blobGasUsed: A.blobGasUsed,
        excessBlobGas: A.excessBlobGas,
        miner: A.miner,
        prevRandao: a(A.prevRandao),
        extraData: A.extraData,
        baseFeePerGas: a(A.baseFeePerGas),
        stateRoot: A.stateRoot,
        receiptsRoot: A.receiptsRoot
      });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */
    get transactions() {
      return ae(this, e).map((A) => typeof A == "string" ? A : A.hash);
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */
    get prefetchedTransactions() {
      const A = ae(this, e).slice();
      return A.length === 0 ? [] : ((0, n.assert)(typeof A[0] == "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
        operation: "transactionResponses()"
      }), A);
    }
    /**
     *  Returns a JSON-friendly value.
     */
    toJSON() {
      const { baseFeePerGas: A, difficulty: R, extraData: L, gasLimit: K, gasUsed: $, hash: k, miner: V, prevRandao: C, nonce: D, number: o, parentHash: u, parentBeaconBlockRoot: h, stateRoot: y, receiptsRoot: E, timestamp: P, transactions: w } = this;
      return {
        _type: "Block",
        baseFeePerGas: f(A),
        difficulty: f(R),
        extraData: L,
        gasLimit: f(K),
        gasUsed: f($),
        blobGasUsed: f(this.blobGasUsed),
        excessBlobGas: f(this.excessBlobGas),
        hash: k,
        miner: V,
        prevRandao: C,
        nonce: D,
        number: o,
        parentHash: u,
        timestamp: P,
        parentBeaconBlockRoot: h,
        stateRoot: y,
        receiptsRoot: E,
        transactions: w
      };
    }
    [Symbol.iterator]() {
      let A = 0;
      const R = this.transactions;
      return {
        next: () => A < this.length ? {
          value: R[A++],
          done: !1
        } : { value: void 0, done: !0 }
      };
    }
    /**
     *  The number of transactions in this block.
     */
    get length() {
      return ae(this, e).length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */
    get date() {
      return this.timestamp == null ? null : new Date(this.timestamp * 1e3);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */
    async getTransaction(A) {
      let R;
      if (typeof A == "number")
        R = ae(this, e)[A];
      else {
        const L = A.toLowerCase();
        for (const K of ae(this, e))
          if (typeof K == "string") {
            if (K !== L)
              continue;
            R = K;
            break;
          } else {
            if (K.hash === L)
              continue;
            R = K;
            break;
          }
      }
      if (R == null)
        throw new Error("no such tx");
      return typeof R == "string" ? await this.provider.getTransaction(R) : R;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */
    getPrefetchedTransaction(A) {
      const R = this.prefetchedTransactions;
      if (typeof A == "number")
        return R[A];
      A = A.toLowerCase();
      for (const L of R)
        if (L.hash === A)
          return L;
      (0, n.assertArgument)(!1, "no matching transaction", "indexOrHash", A);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */
    isMined() {
      return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */
    isLondon() {
      return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */
    orphanedEvent() {
      if (!this.isMined())
        throw new Error("");
      return S(this);
    }
  }
  e = /* @__PURE__ */ new WeakMap(), vn.Block = p;
  class g {
    /**
     *  @_ignore:
     */
    constructor(A, R) {
      Se(this, "provider"), Se(this, "transactionHash"), Se(this, "blockHash"), Se(this, "blockNumber"), Se(this, "removed"), Se(this, "address"), Se(this, "data"), Se(this, "topics"), Se(this, "index"), Se(this, "transactionIndex"), this.provider = R;
      const L = Object.freeze(A.topics.slice());
      (0, n.defineProperties)(this, {
        transactionHash: A.transactionHash,
        blockHash: A.blockHash,
        blockNumber: A.blockNumber,
        removed: A.removed,
        address: A.address,
        data: A.data,
        topics: L,
        index: A.index,
        transactionIndex: A.transactionIndex
      });
    }
    /**
     *  Returns a JSON-compatible object.
     */
    toJSON() {
      const { address: A, blockHash: R, blockNumber: L, data: K, index: $, removed: k, topics: V, transactionHash: C, transactionIndex: D } = this;
      return {
        _type: "log",
        address: A,
        blockHash: R,
        blockNumber: L,
        data: K,
        index: $,
        removed: k,
        topics: V,
        transactionHash: C,
        transactionIndex: D
      };
    }
    /**
     *  Returns the block that this log occurred in.
     */
    async getBlock() {
      const A = await this.provider.getBlock(this.blockHash);
      return (0, n.assert)(!!A, "failed to find transaction", "UNKNOWN_ERROR", {}), A;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */
    async getTransaction() {
      const A = await this.provider.getTransaction(this.transactionHash);
      return (0, n.assert)(!!A, "failed to find transaction", "UNKNOWN_ERROR", {}), A;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */
    async getTransactionReceipt() {
      const A = await this.provider.getTransactionReceipt(this.transactionHash);
      return (0, n.assert)(!!A, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), A;
    }
    /**
     *  @_ignore:
     */
    removedEvent() {
      return M(this);
    }
  }
  vn.Log = g;
  class v {
    /**
     *  @_ignore:
     */
    constructor(A, R) {
      Se(this, "provider"), Se(this, "to"), Se(this, "from"), Se(this, "contractAddress"), Se(this, "hash"), Se(this, "index"), Se(this, "blockHash"), Se(this, "blockNumber"), Se(this, "logsBloom"), Se(this, "gasUsed"), Se(this, "blobGasUsed"), Se(this, "cumulativeGasUsed"), Se(this, "gasPrice"), Se(this, "blobGasPrice"), Se(this, "type"), Se(this, "status"), Se(this, "root"), Fe(this, t, void 0), Ne(this, t, Object.freeze(A.logs.map((K) => new g(K, R))));
      let L = i;
      A.effectiveGasPrice != null ? L = A.effectiveGasPrice : A.gasPrice != null && (L = A.gasPrice), (0, n.defineProperties)(this, {
        provider: R,
        to: A.to,
        from: A.from,
        contractAddress: A.contractAddress,
        hash: A.hash,
        index: A.index,
        blockHash: A.blockHash,
        blockNumber: A.blockNumber,
        logsBloom: A.logsBloom,
        gasUsed: A.gasUsed,
        cumulativeGasUsed: A.cumulativeGasUsed,
        blobGasUsed: A.blobGasUsed,
        gasPrice: L,
        blobGasPrice: A.blobGasPrice,
        type: A.type,
        //byzantium: tx.byzantium,
        status: A.status,
        root: A.root
      });
    }
    /**
     *  The logs for this transaction.
     */
    get logs() {
      return ae(this, t);
    }
    /**
     *  Returns a JSON-compatible representation.
     */
    toJSON() {
      const {
        to: A,
        from: R,
        contractAddress: L,
        hash: K,
        index: $,
        blockHash: k,
        blockNumber: V,
        logsBloom: C,
        logs: D,
        //byzantium, 
        status: o,
        root: u
      } = this;
      return {
        _type: "TransactionReceipt",
        blockHash: k,
        blockNumber: V,
        //byzantium, 
        contractAddress: L,
        cumulativeGasUsed: f(this.cumulativeGasUsed),
        from: R,
        gasPrice: f(this.gasPrice),
        blobGasUsed: f(this.blobGasUsed),
        blobGasPrice: f(this.blobGasPrice),
        gasUsed: f(this.gasUsed),
        hash: K,
        index: $,
        logs: D,
        logsBloom: C,
        root: u,
        status: o,
        to: A
      };
    }
    /**
     *  @_ignore:
     */
    get length() {
      return this.logs.length;
    }
    [Symbol.iterator]() {
      let A = 0;
      return {
        next: () => A < this.length ? { value: this.logs[A++], done: !1 } : { value: void 0, done: !0 }
      };
    }
    /**
     *  The total fee for this transaction, in wei.
     */
    get fee() {
      return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */
    async getBlock() {
      const A = await this.provider.getBlock(this.blockHash);
      if (A == null)
        throw new Error("TODO");
      return A;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */
    async getTransaction() {
      const A = await this.provider.getTransaction(this.hash);
      if (A == null)
        throw new Error("TODO");
      return A;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */
    async getResult() {
      return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */
    async confirmations() {
      return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */
    removedEvent() {
      return B(this);
    }
    /**
     *  @_ignore:
     */
    reorderedEvent(A) {
      return (0, n.assert)(!A || A.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" }), j(this, A);
    }
  }
  t = /* @__PURE__ */ new WeakMap(), vn.TransactionReceipt = v;
  const O = class d7 {
    /**
     *  @_ignore:
     */
    constructor(A, R) {
      Se(this, "provider"), Se(this, "blockNumber"), Se(this, "blockHash"), Se(this, "index"), Se(this, "hash"), Se(this, "type"), Se(this, "to"), Se(this, "from"), Se(this, "nonce"), Se(this, "gasLimit"), Se(this, "gasPrice"), Se(this, "maxPriorityFeePerGas"), Se(this, "maxFeePerGas"), Se(this, "maxFeePerBlobGas"), Se(this, "data"), Se(this, "value"), Se(this, "chainId"), Se(this, "signature"), Se(this, "accessList"), Se(this, "blobVersionedHashes"), Fe(this, r, void 0), this.provider = R, this.blockNumber = A.blockNumber != null ? A.blockNumber : null, this.blockHash = A.blockHash != null ? A.blockHash : null, this.hash = A.hash, this.index = A.index, this.type = A.type, this.from = A.from, this.to = A.to || null, this.gasLimit = A.gasLimit, this.nonce = A.nonce, this.data = A.data, this.value = A.value, this.gasPrice = A.gasPrice, this.maxPriorityFeePerGas = A.maxPriorityFeePerGas != null ? A.maxPriorityFeePerGas : null, this.maxFeePerGas = A.maxFeePerGas != null ? A.maxFeePerGas : null, this.maxFeePerBlobGas = A.maxFeePerBlobGas != null ? A.maxFeePerBlobGas : null, this.chainId = A.chainId, this.signature = A.signature, this.accessList = A.accessList != null ? A.accessList : null, this.blobVersionedHashes = A.blobVersionedHashes != null ? A.blobVersionedHashes : null, Ne(this, r, -1);
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */
    toJSON() {
      const { blockNumber: A, blockHash: R, index: L, hash: K, type: $, to: k, from: V, nonce: C, data: D, signature: o, accessList: u, blobVersionedHashes: h } = this;
      return {
        _type: "TransactionResponse",
        accessList: u,
        blockNumber: A,
        blockHash: R,
        blobVersionedHashes: h,
        chainId: f(this.chainId),
        data: D,
        from: V,
        gasLimit: f(this.gasLimit),
        gasPrice: f(this.gasPrice),
        hash: K,
        maxFeePerGas: f(this.maxFeePerGas),
        maxPriorityFeePerGas: f(this.maxPriorityFeePerGas),
        maxFeePerBlobGas: f(this.maxFeePerBlobGas),
        nonce: C,
        signature: o,
        to: k,
        index: L,
        type: $,
        value: f(this.value)
      };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */
    async getBlock() {
      let A = this.blockNumber;
      if (A == null) {
        const L = await this.getTransaction();
        L && (A = L.blockNumber);
      }
      if (A == null)
        return null;
      const R = this.provider.getBlock(A);
      if (R == null)
        throw new Error("TODO");
      return R;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */
    async getTransaction() {
      return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */
    async confirmations() {
      if (this.blockNumber == null) {
        const { tx: A, blockNumber: R } = await (0, n.resolveProperties)({
          tx: this.getTransaction(),
          blockNumber: this.provider.getBlockNumber()
        });
        return A == null || A.blockNumber == null ? 0 : R - A.blockNumber + 1;
      }
      return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */
    async wait(A, R) {
      const L = A ?? 1, K = R ?? 0;
      let $ = ae(this, r), k = -1, V = $ === -1;
      const C = async () => {
        if (V)
          return null;
        const { blockNumber: u, nonce: h } = await (0, n.resolveProperties)({
          blockNumber: this.provider.getBlockNumber(),
          nonce: this.provider.getTransactionCount(this.from)
        });
        if (h < this.nonce) {
          $ = u;
          return;
        }
        if (V)
          return null;
        const y = await this.getTransaction();
        if (!(y && y.blockNumber != null))
          for (k === -1 && (k = $ - 3, k < ae(this, r) && (k = ae(this, r))); k <= u; ) {
            if (V)
              return null;
            const E = await this.provider.getBlock(k, !0);
            if (E == null)
              return;
            for (const P of E)
              if (P === this.hash)
                return;
            for (let P = 0; P < E.length; P++) {
              const w = await E.getTransaction(P);
              if (w.from === this.from && w.nonce === this.nonce) {
                if (V)
                  return null;
                const m = await this.provider.getTransactionReceipt(w.hash);
                if (m == null || u - m.blockNumber + 1 < L)
                  return;
                let l = "replaced";
                w.data === this.data && w.to === this.to && w.value === this.value ? l = "repriced" : w.data === "0x" && w.from === w.to && w.value === i && (l = "cancelled"), (0, n.assert)(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                  cancelled: l === "replaced" || l === "cancelled",
                  reason: l,
                  replacement: w.replaceableTransaction($),
                  hash: w.hash,
                  receipt: m
                });
              }
            }
            k++;
          }
      }, D = (u) => {
        if (u == null || u.status !== 0)
          return u;
        (0, n.assert)(!1, "transaction execution reverted", "CALL_EXCEPTION", {
          action: "sendTransaction",
          data: null,
          reason: null,
          invocation: null,
          revert: null,
          transaction: {
            to: u.to,
            from: u.from,
            data: ""
            // @TODO: in v7, split out sendTransaction properties
          },
          receipt: u
        });
      }, o = await this.provider.getTransactionReceipt(this.hash);
      if (L === 0)
        return D(o);
      if (o) {
        if (await o.confirmations() >= L)
          return D(o);
      } else if (await C(), L === 0)
        return null;
      return await new Promise((u, h) => {
        const y = [], E = () => {
          y.forEach((w) => w());
        };
        if (y.push(() => {
          V = !0;
        }), K > 0) {
          const w = setTimeout(() => {
            E(), h((0, n.makeError)("wait for transaction timeout", "TIMEOUT"));
          }, K);
          y.push(() => {
            clearTimeout(w);
          });
        }
        const P = async (w) => {
          if (await w.confirmations() >= L) {
            E();
            try {
              u(D(w));
            } catch (m) {
              h(m);
            }
          }
        };
        if (y.push(() => {
          this.provider.off(this.hash, P);
        }), this.provider.on(this.hash, P), $ >= 0) {
          const w = async () => {
            try {
              await C();
            } catch (m) {
              if ((0, n.isError)(m, "TRANSACTION_REPLACED")) {
                E(), h(m);
                return;
              }
            }
            V || this.provider.once("block", w);
          };
          y.push(() => {
            this.provider.off("block", w);
          }), this.provider.once("block", w);
        }
      });
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */
    isMined() {
      return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isLegacy() {
      return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isBerlin() {
      return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isLondon() {
      return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */
    isCancun() {
      return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */
    removedEvent() {
      return (0, n.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), B(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */
    reorderedEvent(A) {
      return (0, n.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), (0, n.assert)(!A || A.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), j(this, A);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */
    replaceableTransaction(A) {
      (0, n.assertArgument)(Number.isInteger(A) && A >= 0, "invalid startBlock", "startBlock", A);
      const R = new d7(this, this.provider);
      return Ne(R, r, A), R;
    }
  };
  r = /* @__PURE__ */ new WeakMap();
  let N = O;
  vn.TransactionResponse = N;
  function S(I) {
    return { orphan: "drop-block", hash: I.hash, number: I.number };
  }
  function j(I, A) {
    return { orphan: "reorder-transaction", tx: I, other: A };
  }
  function B(I) {
    return { orphan: "drop-transaction", tx: I };
  }
  function M(I) {
    return { orphan: "drop-log", log: {
      transactionHash: I.transactionHash,
      blockHash: I.blockHash,
      blockNumber: I.blockNumber,
      address: I.address,
      data: I.data,
      topics: Object.freeze(I.topics.slice()),
      index: I.index
    } };
  }
  return vn;
}
var An = {}, X6;
function h7() {
  var e, t;
  if (X6)
    return An;
  X6 = 1, Object.defineProperty(An, "__esModule", { value: !0 }), An.ContractEventPayload = An.ContractUnknownEventPayload = An.ContractTransactionResponse = An.ContractTransactionReceipt = An.UndecodedEventLog = An.EventLog = void 0;
  const r = Pd(), n = vt();
  class s extends r.Log {
    /**
     * @_ignore:
     */
    constructor(g, v, O) {
      super(g, g.provider), Se(this, "interface"), Se(this, "fragment"), Se(this, "args");
      const N = v.decodeEventLog(O, g.data, g.topics);
      (0, n.defineProperties)(this, { args: N, fragment: O, interface: v });
    }
    /**
     *  The name of the event.
     */
    get eventName() {
      return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */
    get eventSignature() {
      return this.fragment.format();
    }
  }
  An.EventLog = s;
  class i extends r.Log {
    /**
     * @_ignore:
     */
    constructor(g, v) {
      super(g, g.provider), Se(this, "error"), (0, n.defineProperties)(this, { error: v });
    }
  }
  An.UndecodedEventLog = i;
  class a extends r.TransactionReceipt {
    /**
     *  @_ignore:
     */
    constructor(g, v, O) {
      super(O, v), Fe(this, e, void 0), Ne(this, e, g);
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */
    get logs() {
      return super.logs.map((g) => {
        const v = g.topics.length ? ae(this, e).getEvent(g.topics[0]) : null;
        if (v)
          try {
            return new s(g, ae(this, e), v);
          } catch (O) {
            return new i(g, O);
          }
        return g;
      });
    }
  }
  e = /* @__PURE__ */ new WeakMap(), An.ContractTransactionReceipt = a;
  class f extends r.TransactionResponse {
    /**
     *  @_ignore:
     */
    constructor(g, v, O) {
      super(O, v), Fe(this, t, void 0), Ne(this, t, g);
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */
    async wait(g, v) {
      const O = await super.wait(g, v);
      return O == null ? null : new a(ae(this, t), this.provider, O);
    }
  }
  t = /* @__PURE__ */ new WeakMap(), An.ContractTransactionResponse = f;
  class d extends n.EventPayload {
    /**
     *  @_event:
     */
    constructor(g, v, O, N) {
      super(g, v, O), Se(this, "log"), (0, n.defineProperties)(this, { log: N });
    }
    /**
     *  Resolves to the block the event occured in.
     */
    async getBlock() {
      return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */
    async getTransaction() {
      return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */
    async getTransactionReceipt() {
      return await this.log.getTransactionReceipt();
    }
  }
  An.ContractUnknownEventPayload = d;
  class c extends d {
    /**
     *  @_ignore:
     */
    constructor(g, v, O, N, S) {
      super(g, v, O, new s(S, g.interface, N));
      const j = g.interface.decodeEventLog(N, this.log.data, this.log.topics);
      (0, n.defineProperties)(this, { args: j, fragment: N });
    }
    /**
     *  The event name.
     */
    get eventName() {
      return this.fragment.name;
    }
    /**
     *  The event signature.
     */
    get eventSignature() {
      return this.fragment.format();
    }
  }
  return An.ContractEventPayload = c, An;
}
var ew;
function f7() {
  var e, t;
  if (ew)
    return Si;
  ew = 1, Object.defineProperty(Si, "__esModule", { value: !0 }), Si.Contract = Si.BaseContract = Si.resolveArgs = Si.copyOverrides = void 0;
  const r = Ed(), n = Xr(), s = Pd(), i = vt(), a = h7(), f = BigInt(0);
  function d(l) {
    return l && typeof l.call == "function";
  }
  function c(l) {
    return l && typeof l.estimateGas == "function";
  }
  function p(l) {
    return l && typeof l.resolveName == "function";
  }
  function g(l) {
    return l && typeof l.sendTransaction == "function";
  }
  function v(l) {
    if (l != null) {
      if (p(l))
        return l;
      if (l.provider)
        return l.provider;
    }
  }
  class O {
    constructor(b, W, X) {
      if (Fe(this, e, void 0), Se(this, "fragment"), (0, i.defineProperties)(this, { fragment: W }), W.inputs.length < X.length)
        throw new Error("too many arguments");
      const G = N(b.runner, "resolveName"), re = p(G) ? G : null;
      Ne(this, e, async function() {
        const ce = await Promise.all(W.inputs.map((pe, ve) => X[ve] == null ? null : pe.walkAsync(X[ve], (Ee, Pe) => Ee === "address" ? Array.isArray(Pe) ? Promise.all(Pe.map((xe) => (0, n.resolveAddress)(xe, re))) : (0, n.resolveAddress)(Pe, re) : Pe)));
        return b.interface.encodeFilterTopics(W, ce);
      }());
    }
    getTopicFilter() {
      return ae(this, e);
    }
  }
  e = /* @__PURE__ */ new WeakMap();
  function N(l, b) {
    return l == null ? null : typeof l[b] == "function" ? l : l.provider && typeof l.provider[b] == "function" ? l.provider : null;
  }
  function S(l) {
    return l == null ? null : l.provider || null;
  }
  async function j(l, b) {
    const W = r.Typed.dereference(l, "overrides");
    (0, i.assertArgument)(typeof W == "object", "invalid overrides parameter", "overrides", l);
    const X = (0, s.copyRequest)(W);
    return (0, i.assertArgument)(X.to == null || (b || []).indexOf("to") >= 0, "cannot override to", "overrides.to", X.to), (0, i.assertArgument)(X.data == null || (b || []).indexOf("data") >= 0, "cannot override data", "overrides.data", X.data), X.from && (X.from = X.from), X;
  }
  Si.copyOverrides = j;
  async function B(l, b, W) {
    const X = N(l, "resolveName"), G = p(X) ? X : null;
    return await Promise.all(b.map((re, ce) => re.walkAsync(W[ce], (pe, ve) => (ve = r.Typed.dereference(ve, pe), pe === "address" ? (0, n.resolveAddress)(ve, G) : ve))));
  }
  Si.resolveArgs = B;
  function M(l) {
    const b = async function(ce) {
      const pe = await j(ce, ["data"]);
      pe.to = await l.getAddress(), pe.from && (pe.from = await (0, n.resolveAddress)(pe.from, v(l.runner)));
      const ve = l.interface, Ee = (0, i.getBigInt)(pe.value || f, "overrides.value") === f, Pe = (pe.data || "0x") === "0x";
      ve.fallback && !ve.fallback.payable && ve.receive && !Pe && !Ee && (0, i.assertArgument)(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", ce), (0, i.assertArgument)(ve.fallback || Pe, "cannot send data to receive-only contract", "overrides.data", pe.data);
      const xe = ve.receive || ve.fallback && ve.fallback.payable;
      return (0, i.assertArgument)(xe || Ee, "cannot send value to non-payable fallback", "overrides.value", pe.value), (0, i.assertArgument)(ve.fallback || Pe, "cannot send data to receive-only contract", "overrides.data", pe.data), pe;
    }, W = async function(ce) {
      const pe = N(l.runner, "call");
      (0, i.assert)(d(pe), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
      const ve = await b(ce);
      try {
        return await pe.call(ve);
      } catch (Ee) {
        throw (0, i.isCallException)(Ee) && Ee.data ? l.interface.makeError(Ee.data, ve) : Ee;
      }
    }, X = async function(ce) {
      const pe = l.runner;
      (0, i.assert)(g(pe), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
      const ve = await pe.sendTransaction(await b(ce)), Ee = S(l.runner);
      return new a.ContractTransactionResponse(l.interface, Ee, ve);
    }, G = async function(ce) {
      const pe = N(l.runner, "estimateGas");
      return (0, i.assert)(c(pe), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await pe.estimateGas(await b(ce));
    }, re = async (ce) => await X(ce);
    return (0, i.defineProperties)(re, {
      _contract: l,
      estimateGas: G,
      populateTransaction: b,
      send: X,
      staticCall: W
    }), re;
  }
  function I(l, b) {
    const W = function(...Ee) {
      const Pe = l.interface.getFunction(b, Ee);
      return (0, i.assert)(Pe, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: b, args: Ee }
      }), Pe;
    }, X = async function(...Ee) {
      const Pe = W(...Ee);
      let xe = {};
      if (Pe.inputs.length + 1 === Ee.length && (xe = await j(Ee.pop()), xe.from && (xe.from = await (0, n.resolveAddress)(xe.from, v(l.runner)))), Pe.inputs.length !== Ee.length)
        throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
      const me = await B(l.runner, Pe.inputs, Ee);
      return Object.assign({}, xe, await (0, i.resolveProperties)({
        to: l.getAddress(),
        data: l.interface.encodeFunctionData(Pe, me)
      }));
    }, G = async function(...Ee) {
      const Pe = await pe(...Ee);
      return Pe.length === 1 ? Pe[0] : Pe;
    }, re = async function(...Ee) {
      const Pe = l.runner;
      (0, i.assert)(g(Pe), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
      const xe = await Pe.sendTransaction(await X(...Ee)), me = S(l.runner);
      return new a.ContractTransactionResponse(l.interface, me, xe);
    }, ce = async function(...Ee) {
      const Pe = N(l.runner, "estimateGas");
      return (0, i.assert)(c(Pe), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await Pe.estimateGas(await X(...Ee));
    }, pe = async function(...Ee) {
      const Pe = N(l.runner, "call");
      (0, i.assert)(d(Pe), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
      const xe = await X(...Ee);
      let me = "0x";
      try {
        me = await Pe.call(xe);
      } catch (U) {
        throw (0, i.isCallException)(U) && U.data ? l.interface.makeError(U.data, xe) : U;
      }
      const te = W(...Ee);
      return l.interface.decodeFunctionResult(te, me);
    }, ve = async (...Ee) => W(...Ee).constant ? await G(...Ee) : await re(...Ee);
    return (0, i.defineProperties)(ve, {
      name: l.interface.getFunctionName(b),
      _contract: l,
      _key: b,
      getFragment: W,
      estimateGas: ce,
      populateTransaction: X,
      send: re,
      staticCall: G,
      staticCallResult: pe
    }), Object.defineProperty(ve, "fragment", {
      configurable: !1,
      enumerable: !0,
      get: () => {
        const Ee = l.interface.getFunction(b);
        return (0, i.assert)(Ee, "no matching fragment", "UNSUPPORTED_OPERATION", {
          operation: "fragment",
          info: { key: b }
        }), Ee;
      }
    }), ve;
  }
  function A(l, b) {
    const W = function(...G) {
      const re = l.interface.getEvent(b, G);
      return (0, i.assert)(re, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: b, args: G }
      }), re;
    }, X = function(...G) {
      return new O(l, W(...G), G);
    };
    return (0, i.defineProperties)(X, {
      name: l.interface.getEventName(b),
      _contract: l,
      _key: b,
      getFragment: W
    }), Object.defineProperty(X, "fragment", {
      configurable: !1,
      enumerable: !0,
      get: () => {
        const G = l.interface.getEvent(b);
        return (0, i.assert)(G, "no matching fragment", "UNSUPPORTED_OPERATION", {
          operation: "fragment",
          info: { key: b }
        }), G;
      }
    }), X;
  }
  const R = Symbol.for("_ethersInternal_contract"), L = /* @__PURE__ */ new WeakMap();
  function K(l, b) {
    L.set(l[R], b);
  }
  function $(l) {
    return L.get(l[R]);
  }
  function k(l) {
    return l && typeof l == "object" && "getTopicFilter" in l && typeof l.getTopicFilter == "function" && l.fragment;
  }
  async function V(l, b) {
    let W, X = null;
    if (Array.isArray(b)) {
      const re = function(ce) {
        if ((0, i.isHexString)(ce, 32))
          return ce;
        const pe = l.interface.getEvent(ce);
        return (0, i.assertArgument)(pe, "unknown fragment", "name", ce), pe.topicHash;
      };
      W = b.map((ce) => ce == null ? null : Array.isArray(ce) ? ce.map(re) : re(ce));
    } else
      b === "*" ? W = [null] : typeof b == "string" ? (0, i.isHexString)(b, 32) ? W = [b] : (X = l.interface.getEvent(b), (0, i.assertArgument)(X, "unknown fragment", "event", b), W = [X.topicHash]) : k(b) ? W = await b.getTopicFilter() : "fragment" in b ? (X = b.fragment, W = [X.topicHash]) : (0, i.assertArgument)(!1, "unknown event name", "event", b);
    W = W.map((re) => {
      if (re == null)
        return null;
      if (Array.isArray(re)) {
        const ce = Array.from(new Set(re.map((pe) => pe.toLowerCase())).values());
        return ce.length === 1 ? ce[0] : (ce.sort(), ce);
      }
      return re.toLowerCase();
    });
    const G = W.map((re) => re == null ? "null" : Array.isArray(re) ? re.join("|") : re).join("&");
    return { fragment: X, tag: G, topics: W };
  }
  async function C(l, b) {
    const { subs: W } = $(l);
    return W.get((await V(l, b)).tag) || null;
  }
  async function D(l, b, W) {
    const X = S(l.runner);
    (0, i.assert)(X, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation: b });
    const { fragment: G, tag: re, topics: ce } = await V(l, W), { addr: pe, subs: ve } = $(l);
    let Ee = ve.get(re);
    if (!Ee) {
      const Pe = { address: pe || l, topics: ce }, xe = (te) => {
        let U = G;
        if (U == null)
          try {
            U = l.interface.getEvent(te.topics[0]);
          } catch {
          }
        if (U) {
          const ue = U, we = G ? l.interface.decodeEventLog(G, te.data, te.topics) : [];
          h(l, W, we, (ke) => new a.ContractEventPayload(l, ke, W, ue, te));
        } else
          h(l, W, [], (ue) => new a.ContractUnknownEventPayload(l, ue, W, te));
      };
      let me = [];
      Ee = { tag: re, listeners: [], start: () => {
        me.length || me.push(X.on(Pe, xe));
      }, stop: async () => {
        if (me.length == 0)
          return;
        let te = me;
        me = [], await Promise.all(te), X.off(Pe, xe);
      } }, ve.set(re, Ee);
    }
    return Ee;
  }
  let o = Promise.resolve();
  async function u(l, b, W, X) {
    await o;
    const G = await C(l, b);
    if (!G)
      return !1;
    const re = G.listeners.length;
    return G.listeners = G.listeners.filter(({ listener: ce, once: pe }) => {
      const ve = Array.from(W);
      X && ve.push(X(pe ? null : ce));
      try {
        ce.call(l, ...ve);
      } catch {
      }
      return !pe;
    }), G.listeners.length === 0 && (G.stop(), $(l).subs.delete(G.tag)), re > 0;
  }
  async function h(l, b, W, X) {
    try {
      await o;
    } catch {
    }
    const G = u(l, b, W, X);
    return o = G, await G;
  }
  const y = ["then"], E = class ih {
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */
    constructor(b, W, X, G) {
      Se(this, "target"), Se(this, "interface"), Se(this, "runner"), Se(this, "filters"), Se(this, t), Se(this, "fallback"), (0, i.assertArgument)(typeof b == "string" || (0, n.isAddressable)(b), "invalid value for Contract target", "target", b), X == null && (X = null);
      const re = r.Interface.from(W);
      (0, i.defineProperties)(this, { target: b, runner: X, interface: re }), Object.defineProperty(this, R, { value: {} });
      let ce, pe = null, ve = null;
      if (G) {
        const xe = S(X);
        ve = new a.ContractTransactionResponse(this.interface, xe, G);
      }
      let Ee = /* @__PURE__ */ new Map();
      if (typeof b == "string")
        if ((0, i.isHexString)(b))
          pe = b, ce = Promise.resolve(b);
        else {
          const xe = N(X, "resolveName");
          if (!p(xe))
            throw (0, i.makeError)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
              operation: "resolveName"
            });
          ce = xe.resolveName(b).then((me) => {
            if (me == null)
              throw (0, i.makeError)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                value: b
              });
            return $(this).addr = me, me;
          });
        }
      else
        ce = b.getAddress().then((xe) => {
          if (xe == null)
            throw new Error("TODO");
          return $(this).addr = xe, xe;
        });
      K(this, { addrPromise: ce, addr: pe, deployTx: ve, subs: Ee });
      const Pe = new Proxy({}, {
        get: (xe, me, te) => {
          if (typeof me == "symbol" || y.indexOf(me) >= 0)
            return Reflect.get(xe, me, te);
          try {
            return this.getEvent(me);
          } catch (U) {
            if (!(0, i.isError)(U, "INVALID_ARGUMENT") || U.argument !== "key")
              throw U;
          }
        },
        has: (xe, me) => y.indexOf(me) >= 0 ? Reflect.has(xe, me) : Reflect.has(xe, me) || this.interface.hasEvent(String(me))
      });
      return (0, i.defineProperties)(this, { filters: Pe }), (0, i.defineProperties)(this, {
        fallback: re.receive || re.fallback ? M(this) : null
      }), new Proxy(this, {
        get: (xe, me, te) => {
          if (typeof me == "symbol" || me in xe || y.indexOf(me) >= 0)
            return Reflect.get(xe, me, te);
          try {
            return xe.getFunction(me);
          } catch (U) {
            if (!(0, i.isError)(U, "INVALID_ARGUMENT") || U.argument !== "key")
              throw U;
          }
        },
        has: (xe, me) => typeof me == "symbol" || me in xe || y.indexOf(me) >= 0 ? Reflect.has(xe, me) : xe.interface.hasFunction(me)
      });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */
    connect(b) {
      return new ih(this.target, this.interface, b);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */
    attach(b) {
      return new ih(b, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */
    async getAddress() {
      return await $(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */
    async getDeployedCode() {
      const b = S(this.runner);
      (0, i.assert)(b, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
      const W = await b.getCode(await this.getAddress());
      return W === "0x" ? null : W;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */
    async waitForDeployment() {
      const b = this.deploymentTransaction();
      if (b)
        return await b.wait(), this;
      if (await this.getDeployedCode() != null)
        return this;
      const W = S(this.runner);
      return (0, i.assert)(W != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" }), new Promise((X, G) => {
        const re = async () => {
          try {
            if (await this.getDeployedCode() != null)
              return X(this);
            W.once("block", re);
          } catch (ce) {
            G(ce);
          }
        };
        re();
      });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */
    deploymentTransaction() {
      return $(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */
    getFunction(b) {
      return typeof b != "string" && (b = b.format()), I(this, b);
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */
    getEvent(b) {
      return typeof b != "string" && (b = b.format()), A(this, b);
    }
    /**
     *  @_ignore:
     */
    async queryTransaction(b) {
      throw new Error("@TODO");
    }
    /*
    	    // @TODO: this is a non-backwards compatible change, but will be added
    	    //        in v7 and in a potential SmartContract class in an upcoming
    	    //        v6 release
    	    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
    	        const provider = getProvider(this.runner);
    	        assert(provider, "contract runner does not have a provider",
    	            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
    
    	        const receipt = await provider.getTransactionReceipt(hash);
    	        if (receipt == null) { return null; }
    
    	        return new ContractTransactionReceipt(this.interface, provider, receipt);
    	    }
    	    */
    /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */
    async queryFilter(b, W, X) {
      W == null && (W = 0), X == null && (X = "latest");
      const { addr: G, addrPromise: re } = $(this), ce = G || await re, { fragment: pe, topics: ve } = await V(this, b), Ee = { address: ce, topics: ve, fromBlock: W, toBlock: X }, Pe = S(this.runner);
      return (0, i.assert)(Pe, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" }), (await Pe.getLogs(Ee)).map((xe) => {
        let me = pe;
        if (me == null)
          try {
            me = this.interface.getEvent(xe.topics[0]);
          } catch {
          }
        if (me)
          try {
            return new a.EventLog(xe, this.interface, me);
          } catch (te) {
            return new a.UndecodedEventLog(xe, te);
          }
        return new s.Log(xe, Pe);
      });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */
    async on(b, W) {
      const X = await D(this, "on", b);
      return X.listeners.push({ listener: W, once: !1 }), X.start(), this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */
    async once(b, W) {
      const X = await D(this, "once", b);
      return X.listeners.push({ listener: W, once: !0 }), X.start(), this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */
    async emit(b, ...W) {
      return await h(this, b, W, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */
    async listenerCount(b) {
      if (b) {
        const G = await C(this, b);
        return G ? G.listeners.length : 0;
      }
      const { subs: W } = $(this);
      let X = 0;
      for (const { listeners: G } of W.values())
        X += G.length;
      return X;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */
    async listeners(b) {
      if (b) {
        const G = await C(this, b);
        return G ? G.listeners.map(({ listener: re }) => re) : [];
      }
      const { subs: W } = $(this);
      let X = [];
      for (const { listeners: G } of W.values())
        X = X.concat(G.map(({ listener: re }) => re));
      return X;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */
    async off(b, W) {
      const X = await C(this, b);
      if (!X)
        return this;
      if (W) {
        const G = X.listeners.map(({ listener: re }) => re).indexOf(W);
        G >= 0 && X.listeners.splice(G, 1);
      }
      return (W == null || X.listeners.length === 0) && (X.stop(), $(this).subs.delete(X.tag)), this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */
    async removeAllListeners(b) {
      if (b) {
        const W = await C(this, b);
        if (!W)
          return this;
        W.stop(), $(this).subs.delete(W.tag);
      } else {
        const { subs: W } = $(this);
        for (const { tag: X, stop: G } of W.values())
          G(), W.delete(X);
      }
      return this;
    }
    /**
     *  Alias for [on].
     */
    async addListener(b, W) {
      return await this.on(b, W);
    }
    /**
     *  Alias for [off].
     */
    async removeListener(b, W) {
      return await this.off(b, W);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */
    static buildClass(b) {
      class W extends ih {
        constructor(G, re = null) {
          super(G, b, re);
        }
      }
      return W;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */
    static from(b, W, X) {
      return X == null && (X = null), new this(b, W, X);
    }
  };
  t = R;
  let P = E;
  Si.BaseContract = P;
  function w() {
    return P;
  }
  class m extends w() {
  }
  return Si.Contract = m, Si;
}
var zl = {}, tw;
function hI() {
  if (tw)
    return zl;
  tw = 1, Object.defineProperty(zl, "__esModule", { value: !0 }), zl.ContractFactory = void 0;
  const e = Ed(), t = Xr(), r = vt(), n = f7();
  class s {
    /**
     *  Create a new **ContractFactory** with %%abi%% and %%bytecode%%,
     *  optionally connected to %%runner%%.
     *
     *  The %%bytecode%% may be the ``bytecode`` property within the
     *  standard Solidity JSON output.
     */
    constructor(a, f, d) {
      Se(this, "interface"), Se(this, "bytecode"), Se(this, "runner");
      const c = e.Interface.from(a);
      f instanceof Uint8Array || (typeof f == "object" && (f = f.object), f.startsWith("0x") || (f = "0x" + f)), f = (0, r.hexlify)((0, r.getBytes)(f)), (0, r.defineProperties)(this, {
        bytecode: f,
        interface: c,
        runner: d || null
      });
    }
    attach(a) {
      return new n.BaseContract(a, this.interface, this.runner);
    }
    /**
     *  Resolves to the transaction to deploy the contract, passing %%args%%
     *  into the constructor.
     */
    async getDeployTransaction(...a) {
      let f = {};
      const d = this.interface.deploy;
      if (d.inputs.length + 1 === a.length && (f = await (0, n.copyOverrides)(a.pop())), d.inputs.length !== a.length)
        throw new Error("incorrect number of arguments to constructor");
      const c = await (0, n.resolveArgs)(this.runner, d.inputs, a), p = (0, r.concat)([this.bytecode, this.interface.encodeDeploy(c)]);
      return Object.assign({}, f, { data: p });
    }
    /**
     *  Resolves to the Contract deployed by passing %%args%% into the
     *  constructor.
     *
     *  This will resolve to the Contract before it has been deployed to the
     *  network, so the [[BaseContract-waitForDeployment]] should be used before
     *  sending any transactions to it.
     */
    async deploy(...a) {
      const f = await this.getDeployTransaction(...a);
      (0, r.assert)(this.runner && typeof this.runner.sendTransaction == "function", "factory runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
        operation: "sendTransaction"
      });
      const d = await this.runner.sendTransaction(f), c = (0, t.getCreateAddress)(d);
      return new n.BaseContract(c, this.interface, this.runner, d);
    }
    /**
     *  Return a new **ContractFactory** with the same ABI and bytecode,
     *  but connected to %%runner%%.
     */
    connect(a) {
      return new s(this.interface, this.bytecode, a);
    }
    /**
     *  Create a new **ContractFactory** from the standard Solidity JSON output.
     */
    static fromSolidity(a, f) {
      (0, r.assertArgument)(a != null, "bad compiler output", "output", a), typeof a == "string" && (a = JSON.parse(a));
      const d = a.abi;
      let c = "";
      return a.bytecode ? c = a.bytecode : a.evm && a.evm.bytecode && (c = a.evm.bytecode), new this(d, c, f);
    }
  }
  return zl.ContractFactory = s, zl;
}
var rw;
function bf() {
  return rw || (rw = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.UndecodedEventLog = e.EventLog = e.ContractTransactionResponse = e.ContractTransactionReceipt = e.ContractUnknownEventPayload = e.ContractEventPayload = e.ContractFactory = e.Contract = e.BaseContract = void 0;
    var t = f7();
    Object.defineProperty(e, "BaseContract", { enumerable: !0, get: function() {
      return t.BaseContract;
    } }), Object.defineProperty(e, "Contract", { enumerable: !0, get: function() {
      return t.Contract;
    } });
    var r = hI();
    Object.defineProperty(e, "ContractFactory", { enumerable: !0, get: function() {
      return r.ContractFactory;
    } });
    var n = h7();
    Object.defineProperty(e, "ContractEventPayload", { enumerable: !0, get: function() {
      return n.ContractEventPayload;
    } }), Object.defineProperty(e, "ContractUnknownEventPayload", { enumerable: !0, get: function() {
      return n.ContractUnknownEventPayload;
    } }), Object.defineProperty(e, "ContractTransactionReceipt", { enumerable: !0, get: function() {
      return n.ContractTransactionReceipt;
    } }), Object.defineProperty(e, "ContractTransactionResponse", { enumerable: !0, get: function() {
      return n.ContractTransactionResponse;
    } }), Object.defineProperty(e, "EventLog", { enumerable: !0, get: function() {
      return n.EventLog;
    } }), Object.defineProperty(e, "UndecodedEventLog", { enumerable: !0, get: function() {
      return n.UndecodedEventLog;
    } });
  }(Z6)), Z6;
}
var nw = {}, Ia = {}, Bs = {}, iw;
function p7() {
  var e, t, r, n, s, i;
  if (iw)
    return Bs;
  iw = 1, Object.defineProperty(Bs, "__esModule", { value: !0 }), Bs.EnsResolver = Bs.BasicMulticoinProviderPlugin = Bs.MulticoinProviderPlugin = void 0;
  const a = Xr(), f = Ad(), d = bf(), c = so(), p = vt();
  function g(I) {
    return I.match(/^ipfs:\/\/ipfs\//i) ? I = I.substring(12) : I.match(/^ipfs:\/\//i) ? I = I.substring(7) : (0, p.assertArgument)(!1, "unsupported IPFS format", "link", I), `https://gateway.ipfs.io/ipfs/${I}`;
  }
  class v {
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */
    constructor(A) {
      Se(this, "name"), (0, p.defineProperties)(this, { name: A });
    }
    connect(A) {
      return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */
    supportsCoinType(A) {
      return !1;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */
    async encodeAddress(A, R) {
      throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */
    async decodeAddress(A, R) {
      throw new Error("unsupported coin");
    }
  }
  Bs.MulticoinProviderPlugin = v;
  const O = "org.ethers.plugins.provider.BasicMulticoin";
  class N extends v {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */
    constructor() {
      super(O);
    }
  }
  Bs.BasicMulticoinProviderPlugin = N;
  const S = new RegExp("^(ipfs)://(.*)$", "i"), j = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    S,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
  ], B = class Jp {
    constructor(A, R, L) {
      Fe(this, r), Se(this, "provider"), Se(this, "address"), Se(this, "name"), Fe(this, e, void 0), Fe(this, t, void 0), (0, p.defineProperties)(this, { provider: A, address: R, name: L }), Ne(this, e, null), Ne(this, t, new d.Contract(R, [
        "function supportsInterface(bytes4) view returns (bool)",
        "function resolve(bytes, bytes) view returns (bytes)",
        "function addr(bytes32) view returns (address)",
        "function addr(bytes32, uint) view returns (bytes)",
        "function text(bytes32, string) view returns (string)",
        "function contenthash(bytes32) view returns (bytes)"
      ], A));
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */
    async supportsWildcard() {
      return ae(this, e) == null && Ne(this, e, (async () => {
        try {
          return await ae(this, t).supportsInterface("0x9061b923");
        } catch (A) {
          if ((0, p.isError)(A, "CALL_EXCEPTION"))
            return !1;
          throw Ne(this, e, null), A;
        }
      })()), await ae(this, e);
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */
    async getAddress(A) {
      if (A == null && (A = 60), A === 60)
        try {
          const $ = await qe(this, r, n).call(this, "addr(bytes32)");
          return $ == null || $ === f.ZeroAddress ? null : $;
        } catch ($) {
          if ((0, p.isError)($, "CALL_EXCEPTION"))
            return null;
          throw $;
        }
      if (A >= 0 && A < 2147483648) {
        let $ = A + 2147483648;
        const k = await qe(this, r, n).call(this, "addr(bytes32,uint)", [$]);
        if ((0, p.isHexString)(k, 20))
          return (0, a.getAddress)(k);
      }
      let R = null;
      for (const $ of this.provider.plugins)
        if ($ instanceof v && $.supportsCoinType(A)) {
          R = $;
          break;
        }
      if (R == null)
        return null;
      const L = await qe(this, r, n).call(this, "addr(bytes32,uint)", [A]);
      if (L == null || L === "0x")
        return null;
      const K = await R.decodeAddress(A, L);
      if (K != null)
        return K;
      (0, p.assert)(!1, "invalid coin data", "UNSUPPORTED_OPERATION", {
        operation: `getAddress(${A})`,
        info: { coinType: A, data: L }
      });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */
    async getText(A) {
      const R = await qe(this, r, n).call(this, "text(bytes32,string)", [A]);
      return R == null || R === "0x" ? null : R;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */
    async getContentHash() {
      const A = await qe(this, r, n).call(this, "contenthash(bytes32)");
      if (A == null || A === "0x")
        return null;
      const R = A.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (R) {
        const K = R[1] === "e3010170" ? "ipfs" : "ipns", $ = parseInt(R[4], 16);
        if (R[5].length === $ * 2)
          return `${K}://${(0, p.encodeBase58)("0x" + R[2])}`;
      }
      const L = A.match(/^0xe40101fa011b20([0-9a-f]*)$/);
      if (L && L[1].length === 64)
        return `bzz://${L[1]}`;
      (0, p.assert)(!1, "invalid or unsupported content hash data", "UNSUPPORTED_OPERATION", {
        operation: "getContentHash()",
        info: { data: A }
      });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */
    async getAvatar() {
      return (await this._getAvatar()).url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */
    async _getAvatar() {
      const A = [{ type: "name", value: this.name }];
      try {
        const R = await this.getText("avatar");
        if (R == null)
          return A.push({ type: "!avatar", value: "" }), { url: null, linkage: A };
        A.push({ type: "avatar", value: R });
        for (let L = 0; L < j.length; L++) {
          const K = R.match(j[L]);
          if (K == null)
            continue;
          const $ = K[1].toLowerCase();
          switch ($) {
            case "https":
            case "data":
              return A.push({ type: "url", value: R }), { linkage: A, url: R };
            case "ipfs": {
              const k = g(R);
              return A.push({ type: "ipfs", value: R }), A.push({ type: "url", value: k }), { linkage: A, url: k };
            }
            case "erc721":
            case "erc1155": {
              const k = $ === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
              A.push({ type: $, value: R });
              const V = await this.getAddress();
              if (V == null)
                return A.push({ type: "!owner", value: "" }), { url: null, linkage: A };
              const C = (K[2] || "").split("/");
              if (C.length !== 2)
                return A.push({ type: `!${$}caip`, value: K[2] || "" }), { url: null, linkage: A };
              const D = C[1], o = new d.Contract(C[0], [
                // ERC-721
                "function tokenURI(uint) view returns (string)",
                "function ownerOf(uint) view returns (address)",
                // ERC-1155
                "function uri(uint) view returns (string)",
                "function balanceOf(address, uint256) view returns (uint)"
              ], this.provider);
              if ($ === "erc721") {
                const P = await o.ownerOf(D);
                if (V !== P)
                  return A.push({ type: "!owner", value: P }), { url: null, linkage: A };
                A.push({ type: "owner", value: P });
              } else if ($ === "erc1155") {
                const P = await o.balanceOf(V, D);
                if (!P)
                  return A.push({ type: "!balance", value: "0" }), { url: null, linkage: A };
                A.push({ type: "balance", value: P.toString() });
              }
              let u = await o[k](D);
              if (u == null || u === "0x")
                return A.push({ type: "!metadata-url", value: "" }), { url: null, linkage: A };
              A.push({ type: "metadata-url-base", value: u }), $ === "erc1155" && (u = u.replace("{id}", (0, p.toBeHex)(D, 32).substring(2)), A.push({ type: "metadata-url-expanded", value: u })), u.match(/^ipfs:/i) && (u = g(u)), A.push({ type: "metadata-url", value: u });
              let h = {};
              const y = await new p.FetchRequest(u).send();
              y.assertOk();
              try {
                h = y.bodyJson;
              } catch {
                try {
                  A.push({ type: "!metadata", value: y.bodyText });
                } catch {
                  const P = y.body;
                  return P && A.push({ type: "!metadata", value: (0, p.hexlify)(P) }), { url: null, linkage: A };
                }
                return { url: null, linkage: A };
              }
              if (!h)
                return A.push({ type: "!metadata", value: "" }), { url: null, linkage: A };
              A.push({ type: "metadata", value: JSON.stringify(h) });
              let E = h.image;
              if (typeof E != "string")
                return A.push({ type: "!imageUrl", value: "" }), { url: null, linkage: A };
              if (!E.match(/^(https:\/\/|data:)/i)) {
                if (E.match(S) == null)
                  return A.push({ type: "!imageUrl-ipfs", value: E }), { url: null, linkage: A };
                A.push({ type: "imageUrl-ipfs", value: E }), E = g(E);
              }
              return A.push({ type: "url", value: E }), { linkage: A, url: E };
            }
          }
        }
      } catch {
      }
      return { linkage: A, url: null };
    }
    static async getEnsAddress(A) {
      const R = await A.getNetwork(), L = R.getPlugin("org.ethers.plugins.network.Ens");
      return (0, p.assert)(L, "network does not support ENS", "UNSUPPORTED_OPERATION", {
        operation: "getEnsAddress",
        info: { network: R }
      }), L.address;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */
    static async fromName(A, R) {
      var L;
      let K = R;
      for (; ; ) {
        if (K === "" || K === "." || R !== "eth" && K === "eth")
          return null;
        const $ = await qe(L = Jp, s, i).call(L, A, K);
        if ($ != null) {
          const k = new Jp(A, $, R);
          return K !== R && !await k.supportsWildcard() ? null : k;
        }
        K = K.split(".").slice(1).join(".");
      }
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakSet(), n = async function(I, A) {
    A = (A || []).slice();
    const R = ae(this, t).interface;
    A.unshift((0, c.namehash)(this.name));
    let L = null;
    await this.supportsWildcard() && (L = R.getFunction(I), (0, p.assert)(L, "missing fragment", "UNKNOWN_ERROR", {
      info: { funcName: I }
    }), A = [
      (0, c.dnsEncode)(this.name, 255),
      R.encodeFunctionData(L, A)
    ], I = "resolve(bytes,bytes)"), A.push({
      enableCcipRead: !0
    });
    try {
      const K = await ae(this, t)[I](...A);
      return L ? R.decodeFunctionResult(L, K)[0] : K;
    } catch (K) {
      if (!(0, p.isError)(K, "CALL_EXCEPTION"))
        throw K;
    }
    return null;
  }, s = /* @__PURE__ */ new WeakSet(), i = async function(I, A) {
    const R = await B.getEnsAddress(I);
    try {
      const L = await new d.Contract(R, [
        "function resolver(bytes32) view returns (address)"
      ], I).resolver((0, c.namehash)(A), {
        enableCcipRead: !0
      });
      return L === f.ZeroAddress ? null : L;
    } catch (L) {
      throw L;
    }
    return null;
  }, Fe(B, s);
  let M = B;
  return Bs.EnsResolver = M, Bs;
}
var Nr = {}, sw;
function fI() {
  if (sw)
    return Nr;
  sw = 1, Object.defineProperty(Nr, "__esModule", { value: !0 }), Nr.formatTransactionResponse = Nr.formatTransactionReceipt = Nr.formatReceiptLog = Nr.formatBlock = Nr.formatLog = Nr.formatUint256 = Nr.formatHash = Nr.formatData = Nr.formatBoolean = Nr.object = Nr.arrayOf = Nr.allowNull = void 0;
  const e = Xr(), t = ln(), r = ei(), n = vt(), s = BigInt(0);
  function i(R, L) {
    return function(K) {
      return K == null ? L : R(K);
    };
  }
  Nr.allowNull = i;
  function a(R, L) {
    return (K) => {
      if (L && K == null)
        return null;
      if (!Array.isArray(K))
        throw new Error("not an array");
      return K.map(($) => R($));
    };
  }
  Nr.arrayOf = a;
  function f(R, L) {
    return (K) => {
      const $ = {};
      for (const k in R) {
        let V = k;
        if (L && k in L && !(V in K)) {
          for (const C of L[k])
            if (C in K) {
              V = C;
              break;
            }
        }
        try {
          const C = R[k](K[V]);
          C !== void 0 && ($[k] = C);
        } catch (C) {
          const D = C instanceof Error ? C.message : "not-an-error";
          (0, n.assert)(!1, `invalid value for value.${k} (${D})`, "BAD_DATA", { value: K });
        }
      }
      return $;
    };
  }
  Nr.object = f;
  function d(R) {
    switch (R) {
      case !0:
      case "true":
        return !0;
      case !1:
      case "false":
        return !1;
    }
    (0, n.assertArgument)(!1, `invalid boolean; ${JSON.stringify(R)}`, "value", R);
  }
  Nr.formatBoolean = d;
  function c(R) {
    return (0, n.assertArgument)((0, n.isHexString)(R, !0), "invalid data", "value", R), R;
  }
  Nr.formatData = c;
  function p(R) {
    return (0, n.assertArgument)((0, n.isHexString)(R, 32), "invalid hash", "value", R), R;
  }
  Nr.formatHash = p;
  function g(R) {
    if (!(0, n.isHexString)(R))
      throw new Error("invalid uint256");
    return (0, n.zeroPadValue)(R, 32);
  }
  Nr.formatUint256 = g;
  const v = f({
    address: e.getAddress,
    blockHash: p,
    blockNumber: n.getNumber,
    data: c,
    index: n.getNumber,
    removed: i(d, !1),
    topics: a(p),
    transactionHash: p,
    transactionIndex: n.getNumber
  }, {
    index: ["logIndex"]
  });
  function O(R) {
    return v(R);
  }
  Nr.formatLog = O;
  const N = f({
    hash: i(p),
    parentHash: p,
    parentBeaconBlockRoot: i(p, null),
    number: n.getNumber,
    timestamp: n.getNumber,
    nonce: i(c),
    difficulty: n.getBigInt,
    gasLimit: n.getBigInt,
    gasUsed: n.getBigInt,
    stateRoot: i(p, null),
    receiptsRoot: i(p, null),
    blobGasUsed: i(n.getBigInt, null),
    excessBlobGas: i(n.getBigInt, null),
    miner: i(e.getAddress),
    prevRandao: i(p, null),
    extraData: c,
    baseFeePerGas: i(n.getBigInt)
  }, {
    prevRandao: ["mixHash"]
  });
  function S(R) {
    const L = N(R);
    return L.transactions = R.transactions.map((K) => typeof K == "string" ? K : A(K)), L;
  }
  Nr.formatBlock = S;
  const j = f({
    transactionIndex: n.getNumber,
    blockNumber: n.getNumber,
    transactionHash: p,
    address: e.getAddress,
    topics: a(p),
    data: c,
    index: n.getNumber,
    blockHash: p
  }, {
    index: ["logIndex"]
  });
  function B(R) {
    return j(R);
  }
  Nr.formatReceiptLog = B;
  const M = f({
    to: i(e.getAddress, null),
    from: i(e.getAddress, null),
    contractAddress: i(e.getAddress, null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: n.getNumber,
    root: i(n.hexlify),
    gasUsed: n.getBigInt,
    blobGasUsed: i(n.getBigInt, null),
    logsBloom: i(c),
    blockHash: p,
    hash: p,
    logs: a(B),
    blockNumber: n.getNumber,
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: n.getBigInt,
    effectiveGasPrice: i(n.getBigInt),
    blobGasPrice: i(n.getBigInt, null),
    status: i(n.getNumber),
    type: i(n.getNumber, 0)
  }, {
    effectiveGasPrice: ["gasPrice"],
    hash: ["transactionHash"],
    index: ["transactionIndex"]
  });
  function I(R) {
    return M(R);
  }
  Nr.formatTransactionReceipt = I;
  function A(R) {
    R.to && (0, n.getBigInt)(R.to) === s && (R.to = "0x0000000000000000000000000000000000000000");
    const L = f({
      hash: p,
      // Some nodes do not return this, usually test nodes (like Ganache)
      index: i(n.getNumber, void 0),
      type: (K) => K === "0x" || K == null ? 0 : (0, n.getNumber)(K),
      accessList: i(r.accessListify, null),
      blobVersionedHashes: i(a(p, !0), null),
      blockHash: i(p, null),
      blockNumber: i(n.getNumber, null),
      transactionIndex: i(n.getNumber, null),
      from: e.getAddress,
      // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
      gasPrice: i(n.getBigInt),
      maxPriorityFeePerGas: i(n.getBigInt),
      maxFeePerGas: i(n.getBigInt),
      maxFeePerBlobGas: i(n.getBigInt, null),
      gasLimit: n.getBigInt,
      to: i(e.getAddress, null),
      value: n.getBigInt,
      nonce: n.getNumber,
      data: c,
      creates: i(e.getAddress, null),
      chainId: i(n.getBigInt, null)
    }, {
      data: ["input"],
      gasLimit: ["gas"],
      index: ["transactionIndex"]
    })(R);
    if (L.to == null && L.creates == null && (L.creates = (0, e.getCreateAddress)(L)), (R.type === 1 || R.type === 2) && R.accessList == null && (L.accessList = []), R.signature ? L.signature = t.Signature.from(R.signature) : L.signature = t.Signature.from(R), L.chainId == null) {
      const K = L.signature.legacyChainId;
      K != null && (L.chainId = K);
    }
    return L.blockHash && (0, n.getBigInt)(L.blockHash) === s && (L.blockHash = null), L;
  }
  return Nr.formatTransactionResponse = A, Nr;
}
var Vl = {}, qn = {}, ow;
function Z1() {
  var e, t, r;
  if (ow)
    return qn;
  ow = 1, Object.defineProperty(qn, "__esModule", { value: !0 }), qn.FetchUrlFeeDataNetworkPlugin = qn.FeeDataNetworkPlugin = qn.EnsPlugin = qn.GasCostPlugin = qn.NetworkPlugin = void 0;
  const n = nu(), s = vt(), i = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
  class a {
    /**
     *  Creates a new **NetworkPlugin**.
     */
    constructor(O) {
      Se(this, "name"), (0, n.defineProperties)(this, { name: O });
    }
    /**
     *  Creates a copy of this plugin.
     */
    clone() {
      return new a(this.name);
    }
  }
  qn.NetworkPlugin = a;
  class f extends a {
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */
    constructor(O, N) {
      O == null && (O = 0), super(`org.ethers.network.plugins.GasCost#${O || 0}`), Se(this, "effectiveBlock"), Se(this, "txBase"), Se(this, "txCreate"), Se(this, "txDataZero"), Se(this, "txDataNonzero"), Se(this, "txAccessListStorageKey"), Se(this, "txAccessListAddress");
      const S = { effectiveBlock: O };
      function j(B, M) {
        let I = (N || {})[B];
        I == null && (I = M), (0, s.assertArgument)(typeof I == "number", `invalud value for ${B}`, "costs", N), S[B] = I;
      }
      j("txBase", 21e3), j("txCreate", 32e3), j("txDataZero", 4), j("txDataNonzero", 16), j("txAccessListStorageKey", 1900), j("txAccessListAddress", 2400), (0, n.defineProperties)(this, S);
    }
    clone() {
      return new f(this.effectiveBlock, this);
    }
  }
  qn.GasCostPlugin = f;
  class d extends a {
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */
    constructor(O, N) {
      super("org.ethers.plugins.network.Ens"), Se(this, "address"), Se(this, "targetNetwork"), (0, n.defineProperties)(this, {
        address: O || i,
        targetNetwork: N ?? 1
      });
    }
    clone() {
      return new d(this.address, this.targetNetwork);
    }
  }
  qn.EnsPlugin = d;
  const c = class g7 extends a {
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */
    constructor(O) {
      super("org.ethers.plugins.network.FeeData"), Fe(this, e, void 0), Ne(this, e, O);
    }
    /**
     *  The fee data function provided to the constructor.
     */
    get feeDataFunc() {
      return ae(this, e);
    }
    /**
     *  Resolves to the fee data.
     */
    async getFeeData(O) {
      return await ae(this, e).call(this, O);
    }
    clone() {
      return new g7(ae(this, e));
    }
  };
  e = /* @__PURE__ */ new WeakMap();
  let p = c;
  qn.FeeDataNetworkPlugin = p;
  class g extends a {
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */
    constructor(O, N) {
      super("org.ethers.plugins.network.FetchUrlFeeDataPlugin"), Fe(this, t, void 0), Fe(this, r, void 0), Ne(this, t, O), Ne(this, r, N);
    }
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */
    get url() {
      return ae(this, t);
    }
    /**
     *  The callback to use when computing the FeeData.
     */
    get processFunc() {
      return ae(this, r);
    }
    // We are immutable, so we can serve as our own clone
    clone() {
      return this;
    }
  }
  return t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), qn.FetchUrlFeeDataNetworkPlugin = g, qn;
}
var aw;
function ti() {
  var e, t, r;
  if (aw)
    return Vl;
  aw = 1, Object.defineProperty(Vl, "__esModule", { value: !0 }), Vl.Network = void 0;
  const n = ei(), s = vt(), i = Z1(), a = /* @__PURE__ */ new Map(), f = class k0 {
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */
    constructor(N, S) {
      Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Ne(this, e, N), Ne(this, t, (0, s.getBigInt)(S)), Ne(this, r, /* @__PURE__ */ new Map());
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */
    toJSON() {
      return { name: this.name, chainId: String(this.chainId) };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */
    get name() {
      return ae(this, e);
    }
    set name(N) {
      Ne(this, e, N);
    }
    /**
     *  The network chain ID.
     */
    get chainId() {
      return ae(this, t);
    }
    set chainId(N) {
      Ne(this, t, (0, s.getBigInt)(N, "chainId"));
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */
    matches(N) {
      if (N == null)
        return !1;
      if (typeof N == "string") {
        try {
          return this.chainId === (0, s.getBigInt)(N);
        } catch {
        }
        return this.name === N;
      }
      if (typeof N == "number" || typeof N == "bigint") {
        try {
          return this.chainId === (0, s.getBigInt)(N);
        } catch {
        }
        return !1;
      }
      if (typeof N == "object") {
        if (N.chainId != null) {
          try {
            return this.chainId === (0, s.getBigInt)(N.chainId);
          } catch {
          }
          return !1;
        }
        return N.name != null ? this.name === N.name : !1;
      }
      return !1;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */
    get plugins() {
      return Array.from(ae(this, r).values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */
    attachPlugin(N) {
      if (ae(this, r).get(N.name))
        throw new Error(`cannot replace existing plugin: ${N.name} `);
      return ae(this, r).set(N.name, N.clone()), this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */
    getPlugin(N) {
      return ae(this, r).get(N) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */
    getPlugins(N) {
      return this.plugins.filter((S) => S.name.split("#")[0] === N);
    }
    /**
     *  Create a copy of this Network.
     */
    clone() {
      const N = new k0(this.name, this.chainId);
      return this.plugins.forEach((S) => {
        N.attachPlugin(S.clone());
      }), N;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */
    computeIntrinsicGas(N) {
      const S = this.getPlugin("org.ethers.plugins.network.GasCost") || new i.GasCostPlugin();
      let j = S.txBase;
      if (N.to == null && (j += S.txCreate), N.data)
        for (let B = 2; B < N.data.length; B += 2)
          N.data.substring(B, B + 2) === "00" ? j += S.txDataZero : j += S.txDataNonzero;
      if (N.accessList) {
        const B = (0, n.accessListify)(N.accessList);
        for (const M in B)
          j += S.txAccessListAddress + S.txAccessListStorageKey * B[M].storageKeys.length;
      }
      return j;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */
    static from(N) {
      if (v(), N == null)
        return k0.from("mainnet");
      if (typeof N == "number" && (N = BigInt(N)), typeof N == "string" || typeof N == "bigint") {
        const S = a.get(N);
        if (S)
          return S();
        if (typeof N == "bigint")
          return new k0("unknown", N);
        (0, s.assertArgument)(!1, "unknown network", "network", N);
      }
      if (typeof N.clone == "function")
        return N.clone();
      if (typeof N == "object") {
        (0, s.assertArgument)(typeof N.name == "string" && typeof N.chainId == "number", "invalid network object name or chainId", "network", N);
        const S = new k0(N.name, N.chainId);
        return (N.ensAddress || N.ensNetwork != null) && S.attachPlugin(new i.EnsPlugin(N.ensAddress, N.ensNetwork)), S;
      }
      (0, s.assertArgument)(!1, "invalid network", "network", N);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */
    static register(N, S) {
      typeof N == "number" && (N = BigInt(N));
      const j = a.get(N);
      j && (0, s.assertArgument)(!1, `conflicting network for ${JSON.stringify(j.name)}`, "nameOrChainId", N), a.set(N, S);
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  let d = f;
  Vl.Network = d;
  function c(O, N) {
    const S = String(O);
    if (!S.match(/^[0-9.]+$/))
      throw new Error(`invalid gwei value: ${O}`);
    const j = S.split(".");
    if (j.length === 1 && j.push(""), j.length !== 2)
      throw new Error(`invalid gwei value: ${O}`);
    for (; j[1].length < N; )
      j[1] += "0";
    if (j[1].length > 9) {
      let B = BigInt(j[1].substring(0, 9));
      j[1].substring(9).match(/^0+$/) || B++, j[1] = B.toString();
    }
    return BigInt(j[0] + j[1]);
  }
  function p(O) {
    return new i.FetchUrlFeeDataNetworkPlugin(O, async (N, S, j) => {
      j.setHeader("User-Agent", "ethers");
      let B;
      try {
        const [M, I] = await Promise.all([
          j.send(),
          N()
        ]);
        B = M;
        const A = B.bodyJson.standard;
        return {
          gasPrice: I.gasPrice,
          maxFeePerGas: c(A.maxFee, 9),
          maxPriorityFeePerGas: c(A.maxPriorityFee, 9)
        };
      } catch (M) {
        (0, s.assert)(!1, `error encountered with polygon gas station (${JSON.stringify(j.url)})`, "SERVER_ERROR", { request: j, response: B, error: M });
      }
    });
  }
  let g = !1;
  function v() {
    if (g)
      return;
    g = !0;
    function O(N, S, j) {
      const B = function() {
        const M = new d(N, S);
        return j.ensNetwork != null && M.attachPlugin(new i.EnsPlugin(null, j.ensNetwork)), M.attachPlugin(new i.GasCostPlugin()), (j.plugins || []).forEach((I) => {
          M.attachPlugin(I);
        }), M;
      };
      d.register(N, B), d.register(S, B), j.altNames && j.altNames.forEach((M) => {
        d.register(M, B);
      });
    }
    O("mainnet", 1, { ensNetwork: 1, altNames: ["homestead"] }), O("ropsten", 3, { ensNetwork: 3 }), O("rinkeby", 4, { ensNetwork: 4 }), O("goerli", 5, { ensNetwork: 5 }), O("kovan", 42, { ensNetwork: 42 }), O("sepolia", 11155111, { ensNetwork: 11155111 }), O("holesky", 17e3, { ensNetwork: 17e3 }), O("classic", 61, {}), O("classicKotti", 6, {}), O("arbitrum", 42161, {
      ensNetwork: 1
    }), O("arbitrum-goerli", 421613, {}), O("arbitrum-sepolia", 421614, {}), O("base", 8453, { ensNetwork: 1 }), O("base-goerli", 84531, {}), O("base-sepolia", 84532, {}), O("bnb", 56, { ensNetwork: 1 }), O("bnbt", 97, {}), O("linea", 59144, { ensNetwork: 1 }), O("linea-goerli", 59140, {}), O("linea-sepolia", 59141, {}), O("matic", 137, {
      ensNetwork: 1,
      plugins: [
        p("https://gasstation.polygon.technology/v2")
      ]
    }), O("matic-amoy", 80002, {}), O("matic-mumbai", 80001, {
      altNames: ["maticMumbai", "maticmum"],
      plugins: [
        p("https://gasstation-testnet.polygon.technology/v2")
      ]
    }), O("optimism", 10, {
      ensNetwork: 1,
      plugins: []
    }), O("optimism-goerli", 420, {}), O("optimism-sepolia", 11155420, {}), O("xdai", 100, { ensNetwork: 1 });
  }
  return Vl;
}
var tn = {}, uw;
function Y1() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N, S, j, B, M, I;
  if (uw)
    return tn;
  uw = 1, Object.defineProperty(tn, "__esModule", { value: !0 }), tn.PollingEventSubscriber = tn.PollingTransactionSubscriber = tn.PollingOrphanSubscriber = tn.PollingBlockTagSubscriber = tn.OnBlockSubscriber = tn.PollingBlockSubscriber = tn.getPollingSubscriber = void 0;
  const A = vt();
  function R(o) {
    return JSON.parse(JSON.stringify(o));
  }
  function L(o, u) {
    if (u === "block")
      return new K(o);
    if ((0, A.isHexString)(u, 32))
      return new C(o, u);
    (0, A.assert)(!1, "unsupported polling event", "UNSUPPORTED_OPERATION", {
      operation: "getPollingSubscriber",
      info: { event: u }
    });
  }
  tn.getPollingSubscriber = L;
  class K {
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */
    constructor(u) {
      Fe(this, s), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Fe(this, n, void 0), Ne(this, e, u), Ne(this, t, null), Ne(this, r, 4e3), Ne(this, n, -2);
    }
    /**
     *  The polling interval.
     */
    get pollingInterval() {
      return ae(this, r);
    }
    set pollingInterval(u) {
      Ne(this, r, u);
    }
    start() {
      ae(this, t) || (Ne(this, t, ae(this, e)._setTimeout(qe(this, s, i).bind(this), ae(this, r))), qe(this, s, i).call(this));
    }
    stop() {
      ae(this, t) && (ae(this, e)._clearTimeout(ae(this, t)), Ne(this, t, null));
    }
    pause(u) {
      this.stop(), u && Ne(this, n, -2);
    }
    resume() {
      this.start();
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakSet(), i = async function() {
    try {
      const o = await ae(this, e).getBlockNumber();
      if (ae(this, n) === -2) {
        Ne(this, n, o);
        return;
      }
      if (o !== ae(this, n)) {
        for (let u = ae(this, n) + 1; u <= o; u++) {
          if (ae(this, t) == null)
            return;
          await ae(this, e).emit("block", u);
        }
        Ne(this, n, o);
      }
    } catch {
    }
    ae(this, t) != null && Ne(this, t, ae(this, e)._setTimeout(qe(this, s, i).bind(this), ae(this, r)));
  }, tn.PollingBlockSubscriber = K;
  class $ {
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */
    constructor(u) {
      Fe(this, a, void 0), Fe(this, f, void 0), Fe(this, d, void 0), Ne(this, a, u), Ne(this, d, !1), Ne(this, f, (h) => {
        this._poll(h, ae(this, a));
      });
    }
    /**
     *  Called on every new block.
     */
    async _poll(u, h) {
      throw new Error("sub-classes must override this");
    }
    start() {
      ae(this, d) || (Ne(this, d, !0), ae(this, f).call(this, -2), ae(this, a).on("block", ae(this, f)));
    }
    stop() {
      ae(this, d) && (Ne(this, d, !1), ae(this, a).off("block", ae(this, f)));
    }
    pause(u) {
      this.stop();
    }
    resume() {
      this.start();
    }
  }
  a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), tn.OnBlockSubscriber = $;
  class k extends $ {
    constructor(u, h) {
      super(u), Fe(this, c, void 0), Fe(this, p, void 0), Ne(this, c, h), Ne(this, p, -2);
    }
    pause(u) {
      u && Ne(this, p, -2), super.pause(u);
    }
    async _poll(u, h) {
      const y = await h.getBlock(ae(this, c));
      y != null && (ae(this, p) === -2 ? Ne(this, p, y.number) : y.number > ae(this, p) && (h.emit(ae(this, c), y.number), Ne(this, p, y.number)));
    }
  }
  c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), tn.PollingBlockTagSubscriber = k;
  class V extends $ {
    constructor(u, h) {
      super(u), Fe(this, g, void 0), Ne(this, g, R(h));
    }
    async _poll(u, h) {
      throw new Error("@TODO");
    }
  }
  g = /* @__PURE__ */ new WeakMap(), tn.PollingOrphanSubscriber = V;
  class C extends $ {
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */
    constructor(u, h) {
      super(u), Fe(this, v, void 0), Ne(this, v, h);
    }
    async _poll(u, h) {
      const y = await h.getTransactionReceipt(ae(this, v));
      y && h.emit(ae(this, v), y);
    }
  }
  v = /* @__PURE__ */ new WeakMap(), tn.PollingTransactionSubscriber = C;
  class D {
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */
    constructor(u, h) {
      Fe(this, M), Fe(this, O, void 0), Fe(this, N, void 0), Fe(this, S, void 0), Fe(this, j, void 0), Fe(this, B, void 0), Ne(this, O, u), Ne(this, N, R(h)), Ne(this, S, qe(this, M, I).bind(this)), Ne(this, j, !1), Ne(this, B, -2);
    }
    start() {
      ae(this, j) || (Ne(this, j, !0), ae(this, B) === -2 && ae(this, O).getBlockNumber().then((u) => {
        Ne(this, B, u);
      }), ae(this, O).on("block", ae(this, S)));
    }
    stop() {
      ae(this, j) && (Ne(this, j, !1), ae(this, O).off("block", ae(this, S)));
    }
    pause(u) {
      this.stop(), u && Ne(this, B, -2);
    }
    resume() {
      this.start();
    }
  }
  return O = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakSet(), I = async function(o) {
    if (ae(this, B) === -2)
      return;
    const u = R(ae(this, N));
    u.fromBlock = ae(this, B) + 1, u.toBlock = o;
    const h = await ae(this, O).getLogs(u);
    if (h.length === 0) {
      ae(this, B) < o - 60 && Ne(this, B, o - 60);
      return;
    }
    for (const y of h)
      ae(this, O).emit(ae(this, N), y), Ne(this, B, y.blockNumber);
  }, tn.PollingEventSubscriber = D, tn;
}
var cw;
function Od() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v, O, N, S, j, B, M, I, A, R, L, K, $, k;
  if (cw)
    return Ia;
  cw = 1, Object.defineProperty(Ia, "__esModule", { value: !0 }), Ia.AbstractProvider = Ia.UnmanagedSubscriber = void 0;
  const V = Xr(), C = Ad(), D = bf(), o = so(), u = ei(), h = vt(), y = p7(), E = fI(), P = ti(), w = Pd(), m = Y1(), l = BigInt(2), b = 10;
  function W(fe) {
    return fe && typeof fe.then == "function";
  }
  function X(fe, x) {
    return fe + ":" + JSON.stringify(x, (_, q) => {
      if (q == null)
        return "null";
      if (typeof q == "bigint")
        return `bigint:${q.toString()}`;
      if (typeof q == "string")
        return q.toLowerCase();
      if (typeof q == "object" && !Array.isArray(q)) {
        const ne = Object.keys(q);
        return ne.sort(), ne.reduce((de, ye) => (de[ye] = q[ye], de), {});
      }
      return q;
    });
  }
  class G {
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */
    constructor(x) {
      Se(this, "name"), (0, h.defineProperties)(this, { name: x });
    }
    start() {
    }
    stop() {
    }
    pause(x) {
    }
    resume() {
    }
  }
  Ia.UnmanagedSubscriber = G;
  function re(fe) {
    return JSON.parse(JSON.stringify(fe));
  }
  function ce(fe) {
    return fe = Array.from(new Set(fe).values()), fe.sort(), fe;
  }
  async function pe(fe, x) {
    if (fe == null)
      throw new Error("invalid event");
    if (Array.isArray(fe) && (fe = { topics: fe }), typeof fe == "string")
      switch (fe) {
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
          return { type: fe, tag: fe };
      }
    if ((0, h.isHexString)(fe, 32)) {
      const _ = fe.toLowerCase();
      return { type: "transaction", tag: X("tx", { hash: _ }), hash: _ };
    }
    if (fe.orphan) {
      const _ = fe;
      return { type: "orphan", tag: X("orphan", _), filter: re(_) };
    }
    if (fe.address || fe.topics) {
      const _ = fe, q = {
        topics: (_.topics || []).map((ne) => ne == null ? null : Array.isArray(ne) ? ce(ne.map((de) => de.toLowerCase())) : ne.toLowerCase())
      };
      if (_.address) {
        const ne = [], de = [], ye = (ge) => {
          (0, h.isHexString)(ge) ? ne.push(ge) : de.push((async () => {
            ne.push(await (0, V.resolveAddress)(ge, x));
          })());
        };
        Array.isArray(_.address) ? _.address.forEach(ye) : ye(_.address), de.length && await Promise.all(de), q.address = ce(ne.map((ge) => ge.toLowerCase()));
      }
      return { filter: q, tag: X("event", q), type: "event" };
    }
    (0, h.assertArgument)(!1, "unknown ProviderEvent", "event", fe);
  }
  function ve() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  const Ee = {
    cacheTimeout: 250,
    pollingInterval: 4e3
  };
  class Pe {
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */
    constructor(x, _) {
      if (Fe(this, v), Fe(this, N), Fe(this, j), Fe(this, M), Fe(this, A), Fe(this, L), Fe(this, $), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Fe(this, n, void 0), Fe(this, s, void 0), Fe(this, i, void 0), Fe(this, a, void 0), Fe(this, f, void 0), Fe(this, d, void 0), Fe(this, c, void 0), Fe(this, p, void 0), Fe(this, g, void 0), Ne(this, g, Object.assign({}, Ee, _ || {})), x === "any")
        Ne(this, i, !0), Ne(this, s, null);
      else if (x) {
        const q = P.Network.from(x);
        Ne(this, i, !1), Ne(this, s, Promise.resolve(q)), setTimeout(() => {
          this.emit("network", q, null);
        }, 0);
      } else
        Ne(this, i, !1), Ne(this, s, null);
      Ne(this, f, -1), Ne(this, a, /* @__PURE__ */ new Map()), Ne(this, e, /* @__PURE__ */ new Map()), Ne(this, t, /* @__PURE__ */ new Map()), Ne(this, r, null), Ne(this, n, !1), Ne(this, d, 1), Ne(this, c, /* @__PURE__ */ new Map()), Ne(this, p, !1);
    }
    get pollingInterval() {
      return ae(this, g).pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */
    get provider() {
      return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */
    get plugins() {
      return Array.from(ae(this, t).values());
    }
    /**
     *  Attach a new plug-in.
     */
    attachPlugin(x) {
      if (ae(this, t).get(x.name))
        throw new Error(`cannot replace existing plugin: ${x.name} `);
      return ae(this, t).set(x.name, x.connect(this)), this;
    }
    /**
     *  Get a plugin by name.
     */
    getPlugin(x) {
      return ae(this, t).get(x) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */
    get disableCcipRead() {
      return ae(this, p);
    }
    set disableCcipRead(x) {
      Ne(this, p, !!x);
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */
    async ccipReadFetch(x, _, q) {
      if (this.disableCcipRead || q.length === 0 || x.to == null)
        return null;
      const ne = x.to.toLowerCase(), de = _.toLowerCase(), ye = [];
      for (let ge = 0; ge < q.length; ge++) {
        const be = q[ge], Me = be.replace("{sender}", ne).replace("{data}", de), Ce = new h.FetchRequest(Me);
        be.indexOf("{data}") === -1 && (Ce.body = { data: de, sender: ne }), this.emit("debug", { action: "sendCcipReadFetchRequest", request: Ce, index: ge, urls: q });
        let je = "unknown error";
        const Ue = await Ce.send();
        try {
          const Qe = Ue.bodyJson;
          if (Qe.data)
            return this.emit("debug", { action: "receiveCcipReadFetchResult", request: Ce, result: Qe }), Qe.data;
          Qe.message && (je = Qe.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: Ce, result: Qe });
        } catch {
        }
        (0, h.assert)(Ue.statusCode < 400 || Ue.statusCode >= 500, `response not found during CCIP fetch: ${je}`, "OFFCHAIN_FAULT", { reason: "404_MISSING_RESOURCE", transaction: x, info: { url: be, errorMessage: je } }), ye.push(je);
      }
      (0, h.assert)(!1, `error encountered during CCIP fetch: ${ye.map((ge) => JSON.stringify(ge)).join(", ")}`, "OFFCHAIN_FAULT", {
        reason: "500_SERVER_ERROR",
        transaction: x,
        info: { urls: q, errorMessages: ye }
      });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */
    _wrapBlock(x, _) {
      return new w.Block((0, E.formatBlock)(x), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */
    _wrapLog(x, _) {
      return new w.Log((0, E.formatLog)(x), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */
    _wrapTransactionReceipt(x, _) {
      return new w.TransactionReceipt((0, E.formatTransactionReceipt)(x), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */
    _wrapTransactionResponse(x, _) {
      return new w.TransactionResponse((0, E.formatTransactionResponse)(x), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */
    _detectNetwork() {
      (0, h.assert)(!1, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
        operation: "_detectNetwork"
      });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */
    async _perform(x) {
      (0, h.assert)(!1, `unsupported method: ${x.method}`, "UNSUPPORTED_OPERATION", {
        operation: x.method,
        info: x
      });
    }
    // State
    async getBlockNumber() {
      const x = (0, h.getNumber)(await qe(this, v, O).call(this, { method: "getBlockNumber" }), "%response");
      return ae(this, f) >= 0 && Ne(this, f, x), x;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */
    _getAddress(x) {
      return (0, V.resolveAddress)(x, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */
    _getBlockTag(x) {
      if (x == null)
        return "latest";
      switch (x) {
        case "earliest":
          return "0x0";
        case "finalized":
        case "latest":
        case "pending":
        case "safe":
          return x;
      }
      if ((0, h.isHexString)(x))
        return (0, h.isHexString)(x, 32) ? x : (0, h.toQuantity)(x);
      if (typeof x == "bigint" && (x = (0, h.getNumber)(x, "blockTag")), typeof x == "number")
        return x >= 0 ? (0, h.toQuantity)(x) : ae(this, f) >= 0 ? (0, h.toQuantity)(ae(this, f) + x) : this.getBlockNumber().then((_) => (0, h.toQuantity)(_ + x));
      (0, h.assertArgument)(!1, "invalid blockTag", "blockTag", x);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */
    _getFilter(x) {
      const _ = (x.topics || []).map((be) => be == null ? null : Array.isArray(be) ? ce(be.map((Me) => Me.toLowerCase())) : be.toLowerCase()), q = "blockHash" in x ? x.blockHash : void 0, ne = (be, Me, Ce) => {
        let je;
        switch (be.length) {
          case 0:
            break;
          case 1:
            je = be[0];
            break;
          default:
            be.sort(), je = be;
        }
        if (q && (Me != null || Ce != null))
          throw new Error("invalid filter");
        const Ue = {};
        return je && (Ue.address = je), _.length && (Ue.topics = _), Me && (Ue.fromBlock = Me), Ce && (Ue.toBlock = Ce), q && (Ue.blockHash = q), Ue;
      };
      let de = [];
      if (x.address)
        if (Array.isArray(x.address))
          for (const be of x.address)
            de.push(this._getAddress(be));
        else
          de.push(this._getAddress(x.address));
      let ye;
      "fromBlock" in x && (ye = this._getBlockTag(x.fromBlock));
      let ge;
      return "toBlock" in x && (ge = this._getBlockTag(x.toBlock)), de.filter((be) => typeof be != "string").length || ye != null && typeof ye != "string" || ge != null && typeof ge != "string" ? Promise.all([Promise.all(de), ye, ge]).then((be) => ne(be[0], be[1], be[2])) : ne(de, ye, ge);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */
    _getTransactionRequest(x) {
      const _ = (0, w.copyRequest)(x), q = [];
      if (["to", "from"].forEach((ne) => {
        if (_[ne] == null)
          return;
        const de = (0, V.resolveAddress)(_[ne], this);
        W(de) ? q.push(async function() {
          _[ne] = await de;
        }()) : _[ne] = de;
      }), _.blockTag != null) {
        const ne = this._getBlockTag(_.blockTag);
        W(ne) ? q.push(async function() {
          _.blockTag = await ne;
        }()) : _.blockTag = ne;
      }
      return q.length ? async function() {
        return await Promise.all(q), _;
      }() : _;
    }
    async getNetwork() {
      if (ae(this, s) == null) {
        const ne = (async () => {
          try {
            const de = await this._detectNetwork();
            return this.emit("network", de, null), de;
          } catch (de) {
            throw ae(this, s) === ne && Ne(this, s, null), de;
          }
        })();
        return Ne(this, s, ne), (await ne).clone();
      }
      const x = ae(this, s), [_, q] = await Promise.all([
        x,
        this._detectNetwork()
        // The actual connected network
      ]);
      return _.chainId !== q.chainId && (ae(this, i) ? (this.emit("network", q, _), ae(this, s) === x && Ne(this, s, Promise.resolve(q))) : (0, h.assert)(!1, `network changed: ${_.chainId} => ${q.chainId} `, "NETWORK_ERROR", {
        event: "changed"
      })), _.clone();
    }
    async getFeeData() {
      const x = await this.getNetwork(), _ = async () => {
        const { _block: ne, gasPrice: de, priorityFee: ye } = await (0, h.resolveProperties)({
          _block: qe(this, A, R).call(this, "latest", !1),
          gasPrice: (async () => {
            try {
              const Ce = await qe(this, v, O).call(this, { method: "getGasPrice" });
              return (0, h.getBigInt)(Ce, "%response");
            } catch {
            }
            return null;
          })(),
          priorityFee: (async () => {
            try {
              const Ce = await qe(this, v, O).call(this, { method: "getPriorityFee" });
              return (0, h.getBigInt)(Ce, "%response");
            } catch {
            }
            return null;
          })()
        });
        let ge = null, be = null;
        const Me = this._wrapBlock(ne, x);
        return Me && Me.baseFeePerGas && (be = ye ?? BigInt("1000000000"), ge = Me.baseFeePerGas * l + be), new w.FeeData(de, ge, be);
      }, q = x.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
      if (q) {
        const ne = new h.FetchRequest(q.url), de = await q.processFunc(_, this, ne);
        return new w.FeeData(de.gasPrice, de.maxFeePerGas, de.maxPriorityFeePerGas);
      }
      return await _();
    }
    async estimateGas(x) {
      let _ = this._getTransactionRequest(x);
      return W(_) && (_ = await _), (0, h.getBigInt)(await qe(this, v, O).call(this, {
        method: "estimateGas",
        transaction: _
      }), "%response");
    }
    async call(x) {
      const { tx: _, blockTag: q } = await (0, h.resolveProperties)({
        tx: this._getTransactionRequest(x),
        blockTag: this._getBlockTag(x.blockTag)
      });
      return await qe(this, j, B).call(this, qe(this, N, S).call(this, _, q, x.enableCcipRead ? 0 : -1));
    }
    async getBalance(x, _) {
      return (0, h.getBigInt)(await qe(this, M, I).call(this, { method: "getBalance" }, x, _), "%response");
    }
    async getTransactionCount(x, _) {
      return (0, h.getNumber)(await qe(this, M, I).call(this, { method: "getTransactionCount" }, x, _), "%response");
    }
    async getCode(x, _) {
      return (0, h.hexlify)(await qe(this, M, I).call(this, { method: "getCode" }, x, _));
    }
    async getStorage(x, _, q) {
      const ne = (0, h.getBigInt)(_, "position");
      return (0, h.hexlify)(await qe(this, M, I).call(this, { method: "getStorage", position: ne }, x, q));
    }
    // Write
    async broadcastTransaction(x) {
      const { blockNumber: _, hash: q, network: ne } = await (0, h.resolveProperties)({
        blockNumber: this.getBlockNumber(),
        hash: this._perform({
          method: "broadcastTransaction",
          signedTransaction: x
        }),
        network: this.getNetwork()
      }), de = u.Transaction.from(x);
      if (de.hash !== q)
        throw new Error("@TODO: the returned hash did not match");
      return this._wrapTransactionResponse(de, ne).replaceableTransaction(_);
    }
    // Queries
    async getBlock(x, _) {
      const { network: q, params: ne } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        params: qe(this, A, R).call(this, x, !!_)
      });
      return ne == null ? null : this._wrapBlock(ne, q);
    }
    async getTransaction(x) {
      const { network: _, params: q } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        params: qe(this, v, O).call(this, { method: "getTransaction", hash: x })
      });
      return q == null ? null : this._wrapTransactionResponse(q, _);
    }
    async getTransactionReceipt(x) {
      const { network: _, params: q } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        params: qe(this, v, O).call(this, { method: "getTransactionReceipt", hash: x })
      });
      if (q == null)
        return null;
      if (q.gasPrice == null && q.effectiveGasPrice == null) {
        const ne = await qe(this, v, O).call(this, { method: "getTransaction", hash: x });
        if (ne == null)
          throw new Error("report this; could not find tx or effectiveGasPrice");
        q.effectiveGasPrice = ne.gasPrice;
      }
      return this._wrapTransactionReceipt(q, _);
    }
    async getTransactionResult(x) {
      const { result: _ } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        result: qe(this, v, O).call(this, { method: "getTransactionResult", hash: x })
      });
      return _ == null ? null : (0, h.hexlify)(_);
    }
    // Bloom-filter Queries
    async getLogs(x) {
      let _ = this._getFilter(x);
      W(_) && (_ = await _);
      const { network: q, params: ne } = await (0, h.resolveProperties)({
        network: this.getNetwork(),
        params: qe(this, v, O).call(this, { method: "getLogs", filter: _ })
      });
      return ne.map((de) => this._wrapLog(de, q));
    }
    // ENS
    _getProvider(x) {
      (0, h.assert)(!1, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
        operation: "_getProvider()"
      });
    }
    async getResolver(x) {
      return await y.EnsResolver.fromName(this, x);
    }
    async getAvatar(x) {
      const _ = await this.getResolver(x);
      return _ ? await _.getAvatar() : null;
    }
    async resolveName(x) {
      const _ = await this.getResolver(x);
      return _ ? await _.getAddress() : null;
    }
    async lookupAddress(x) {
      x = (0, V.getAddress)(x);
      const _ = (0, o.namehash)(x.substring(2).toLowerCase() + ".addr.reverse");
      try {
        const q = await y.EnsResolver.getEnsAddress(this), ne = await new D.Contract(q, [
          "function resolver(bytes32) view returns (address)"
        ], this).resolver(_);
        if (ne == null || ne === C.ZeroAddress)
          return null;
        const de = await new D.Contract(ne, [
          "function name(bytes32) view returns (string)"
        ], this).name(_);
        return await this.resolveName(de) !== x ? null : de;
      } catch (q) {
        if ((0, h.isError)(q, "BAD_DATA") && q.value === "0x" || (0, h.isError)(q, "CALL_EXCEPTION"))
          return null;
        throw q;
      }
      return null;
    }
    async waitForTransaction(x, _, q) {
      const ne = _ ?? 1;
      return ne === 0 ? this.getTransactionReceipt(x) : new Promise(async (de, ye) => {
        let ge = null;
        const be = async (Me) => {
          try {
            const Ce = await this.getTransactionReceipt(x);
            if (Ce != null && Me - Ce.blockNumber + 1 >= ne) {
              de(Ce), ge && (clearTimeout(ge), ge = null);
              return;
            }
          } catch (Ce) {
            console.log("EEE", Ce);
          }
          this.once("block", be);
        };
        q != null && (ge = setTimeout(() => {
          ge != null && (ge = null, this.off("block", be), ye((0, h.makeError)("timeout", "TIMEOUT", { reason: "timeout" })));
        }, q)), be(await this.getBlockNumber());
      });
    }
    async waitForBlock(x) {
      (0, h.assert)(!1, "not implemented yet", "NOT_IMPLEMENTED", {
        operation: "waitForBlock"
      });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */
    _clearTimeout(x) {
      const _ = ae(this, c).get(x);
      _ && (_.timer && clearTimeout(_.timer), ae(this, c).delete(x));
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */
    _setTimeout(x, _) {
      _ == null && (_ = 0);
      const q = ed(this, d)._++, ne = () => {
        ae(this, c).delete(q), x();
      };
      if (this.paused)
        ae(this, c).set(q, { timer: null, func: ne, time: _ });
      else {
        const de = setTimeout(ne, _);
        ae(this, c).set(q, { timer: de, func: ne, time: ve() });
      }
      return q;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */
    _forEachSubscriber(x) {
      for (const _ of ae(this, e).values())
        x(_.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */
    _getSubscriber(x) {
      switch (x.type) {
        case "debug":
        case "error":
        case "network":
          return new G(x.type);
        case "block": {
          const _ = new m.PollingBlockSubscriber(this);
          return _.pollingInterval = this.pollingInterval, _;
        }
        case "safe":
        case "finalized":
          return new m.PollingBlockTagSubscriber(this, x.type);
        case "event":
          return new m.PollingEventSubscriber(this, x.filter);
        case "transaction":
          return new m.PollingTransactionSubscriber(this, x.hash);
        case "orphan":
          return new m.PollingOrphanSubscriber(this, x.filter);
      }
      throw new Error(`unsupported event: ${x.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */
    _recoverSubscriber(x, _) {
      for (const q of ae(this, e).values())
        if (q.subscriber === x) {
          q.started && q.subscriber.stop(), q.subscriber = _, q.started && _.start(), ae(this, r) != null && _.pause(ae(this, r));
          break;
        }
    }
    async on(x, _) {
      const q = await qe(this, $, k).call(this, x);
      return q.listeners.push({ listener: _, once: !1 }), q.started || (q.subscriber.start(), q.started = !0, ae(this, r) != null && q.subscriber.pause(ae(this, r))), this;
    }
    async once(x, _) {
      const q = await qe(this, $, k).call(this, x);
      return q.listeners.push({ listener: _, once: !0 }), q.started || (q.subscriber.start(), q.started = !0, ae(this, r) != null && q.subscriber.pause(ae(this, r))), this;
    }
    async emit(x, ..._) {
      const q = await qe(this, L, K).call(this, x, _);
      if (!q || q.listeners.length === 0)
        return !1;
      const ne = q.listeners.length;
      return q.listeners = q.listeners.filter(({ listener: de, once: ye }) => {
        const ge = new h.EventPayload(this, ye ? null : de, x);
        try {
          de.call(this, ..._, ge);
        } catch {
        }
        return !ye;
      }), q.listeners.length === 0 && (q.started && q.subscriber.stop(), ae(this, e).delete(q.tag)), ne > 0;
    }
    async listenerCount(x) {
      if (x) {
        const q = await qe(this, L, K).call(this, x);
        return q ? q.listeners.length : 0;
      }
      let _ = 0;
      for (const { listeners: q } of ae(this, e).values())
        _ += q.length;
      return _;
    }
    async listeners(x) {
      if (x) {
        const q = await qe(this, L, K).call(this, x);
        return q ? q.listeners.map(({ listener: ne }) => ne) : [];
      }
      let _ = [];
      for (const { listeners: q } of ae(this, e).values())
        _ = _.concat(q.map(({ listener: ne }) => ne));
      return _;
    }
    async off(x, _) {
      const q = await qe(this, L, K).call(this, x);
      if (!q)
        return this;
      if (_) {
        const ne = q.listeners.map(({ listener: de }) => de).indexOf(_);
        ne >= 0 && q.listeners.splice(ne, 1);
      }
      return (!_ || q.listeners.length === 0) && (q.started && q.subscriber.stop(), ae(this, e).delete(q.tag)), this;
    }
    async removeAllListeners(x) {
      if (x) {
        const { tag: _, started: q, subscriber: ne } = await qe(this, $, k).call(this, x);
        q && ne.stop(), ae(this, e).delete(_);
      } else
        for (const [_, { started: q, subscriber: ne }] of ae(this, e))
          q && ne.stop(), ae(this, e).delete(_);
      return this;
    }
    // Alias for "on"
    async addListener(x, _) {
      return await this.on(x, _);
    }
    // Alias for "off"
    async removeListener(x, _) {
      return this.off(x, _);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */
    get destroyed() {
      return ae(this, n);
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */
    destroy() {
      this.removeAllListeners();
      for (const x of ae(this, c).keys())
        this._clearTimeout(x);
      Ne(this, n, !0);
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */
    get paused() {
      return ae(this, r) != null;
    }
    set paused(x) {
      !!x !== this.paused && (this.paused ? this.resume() : this.pause(!1));
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */
    pause(x) {
      if (Ne(this, f, -1), ae(this, r) != null) {
        if (ae(this, r) == !!x)
          return;
        (0, h.assert)(!1, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
          operation: "pause"
        });
      }
      this._forEachSubscriber((_) => _.pause(x)), Ne(this, r, !!x);
      for (const _ of ae(this, c).values())
        _.timer && clearTimeout(_.timer), _.time = ve() - _.time;
    }
    /**
     *  Resume the provider.
     */
    resume() {
      if (ae(this, r) != null) {
        this._forEachSubscriber((x) => x.resume()), Ne(this, r, null);
        for (const x of ae(this, c).values()) {
          let _ = x.time;
          _ < 0 && (_ = 0), x.time = ve(), setTimeout(x.func, _);
        }
      }
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakSet(), O = async function(fe) {
    const x = ae(this, g).cacheTimeout;
    if (x < 0)
      return await this._perform(fe);
    const _ = X(fe.method, fe);
    let q = ae(this, a).get(_);
    return q || (q = this._perform(fe), ae(this, a).set(_, q), setTimeout(() => {
      ae(this, a).get(_) === q && ae(this, a).delete(_);
    }, x)), await q;
  }, N = /* @__PURE__ */ new WeakSet(), S = async function(fe, x, _) {
    (0, h.assert)(_ < b, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
      reason: "TOO_MANY_REDIRECTS",
      transaction: Object.assign({}, fe, { blockTag: x, enableCcipRead: !0 })
    });
    const q = (0, w.copyRequest)(fe);
    try {
      return (0, h.hexlify)(await this._perform({ method: "call", transaction: q, blockTag: x }));
    } catch (ne) {
      if (!this.disableCcipRead && (0, h.isCallException)(ne) && ne.data && _ >= 0 && x === "latest" && q.to != null && (0, h.dataSlice)(ne.data, 0, 4) === "0x556f1830") {
        const de = ne.data, ye = await (0, V.resolveAddress)(q.to, this);
        let ge;
        try {
          ge = Re((0, h.dataSlice)(ne.data, 4));
        } catch (Ce) {
          (0, h.assert)(!1, Ce.message, "OFFCHAIN_FAULT", {
            reason: "BAD_DATA",
            transaction: q,
            info: { data: de }
          });
        }
        (0, h.assert)(ge.sender.toLowerCase() === ye.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
          action: "call",
          data: de,
          reason: "OffchainLookup",
          transaction: q,
          invocation: null,
          revert: {
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            name: "OffchainLookup",
            args: ge.errorArgs
          }
        });
        const be = await this.ccipReadFetch(q, ge.calldata, ge.urls);
        (0, h.assert)(be != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
          reason: "FETCH_FAILED",
          transaction: q,
          info: { data: ne.data, errorArgs: ge.errorArgs }
        });
        const Me = {
          to: ye,
          data: (0, h.concat)([ge.selector, we([be, ge.extraData])])
        };
        this.emit("debug", { action: "sendCcipReadCall", transaction: Me });
        try {
          const Ce = await qe(this, N, S).call(this, Me, x, _ + 1);
          return this.emit("debug", { action: "receiveCcipReadCallResult", transaction: Object.assign({}, Me), result: Ce }), Ce;
        } catch (Ce) {
          throw this.emit("debug", { action: "receiveCcipReadCallError", transaction: Object.assign({}, Me), error: Ce }), Ce;
        }
      }
      throw ne;
    }
  }, j = /* @__PURE__ */ new WeakSet(), B = async function(fe) {
    const { value: x } = await (0, h.resolveProperties)({
      network: this.getNetwork(),
      value: fe
    });
    return x;
  }, M = /* @__PURE__ */ new WeakSet(), I = async function(fe, x, _) {
    let q = this._getAddress(x), ne = this._getBlockTag(_);
    return (typeof q != "string" || typeof ne != "string") && ([q, ne] = await Promise.all([q, ne])), await qe(this, j, B).call(this, qe(this, v, O).call(this, Object.assign(fe, { address: q, blockTag: ne })));
  }, A = /* @__PURE__ */ new WeakSet(), R = async function(fe, x) {
    if ((0, h.isHexString)(fe, 32))
      return await qe(this, v, O).call(this, {
        method: "getBlock",
        blockHash: fe,
        includeTransactions: x
      });
    let _ = this._getBlockTag(fe);
    return typeof _ != "string" && (_ = await _), await qe(this, v, O).call(this, {
      method: "getBlock",
      blockTag: _,
      includeTransactions: x
    });
  }, L = /* @__PURE__ */ new WeakSet(), K = async function(fe, x) {
    let _ = await pe(fe, this);
    return _.type === "event" && x && x.length > 0 && x[0].removed === !0 && (_ = await pe({ orphan: "drop-log", log: x[0] }, this)), ae(this, e).get(_.tag) || null;
  }, $ = /* @__PURE__ */ new WeakSet(), k = async function(fe) {
    const x = await pe(fe, this), _ = x.tag;
    let q = ae(this, e).get(_);
    return q || (q = { subscriber: this._getSubscriber(x), tag: _, addressableMap: /* @__PURE__ */ new WeakMap(), nameMap: /* @__PURE__ */ new Map(), started: !1, listeners: [] }, ae(this, e).set(_, q)), q;
  }, Ia.AbstractProvider = Pe;
  function xe(fe, x) {
    try {
      const _ = me(fe, x);
      if (_)
        return (0, h.toUtf8String)(_);
    } catch {
    }
    return null;
  }
  function me(fe, x) {
    if (fe === "0x")
      return null;
    try {
      const _ = (0, h.getNumber)((0, h.dataSlice)(fe, x, x + 32)), q = (0, h.getNumber)((0, h.dataSlice)(fe, _, _ + 32));
      return (0, h.dataSlice)(fe, _ + 32, _ + 32 + q);
    } catch {
    }
    return null;
  }
  function te(fe) {
    const x = (0, h.toBeArray)(fe);
    if (x.length > 32)
      throw new Error("internal; should not happen");
    const _ = new Uint8Array(32);
    return _.set(x, 32 - x.length), _;
  }
  function U(fe) {
    if (fe.length % 32 === 0)
      return fe;
    const x = new Uint8Array(Math.ceil(fe.length / 32) * 32);
    return x.set(fe), x;
  }
  const ue = new Uint8Array([]);
  function we(fe) {
    const x = [];
    let _ = 0;
    for (let q = 0; q < fe.length; q++)
      x.push(ue), _ += 32;
    for (let q = 0; q < fe.length; q++) {
      const ne = (0, h.getBytes)(fe[q]);
      x[q] = te(_), x.push(te(ne.length)), x.push(U(ne)), _ += 32 + Math.ceil(ne.length / 32) * 32;
    }
    return (0, h.concat)(x);
  }
  const ke = "0x0000000000000000000000000000000000000000000000000000000000000000";
  function Re(fe) {
    const x = {
      sender: "",
      urls: [],
      calldata: "",
      selector: "",
      extraData: "",
      errorArgs: []
    };
    (0, h.assert)((0, h.dataLength)(fe) >= 5 * 32, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
      reason: "insufficient OffchainLookup data"
    });
    const _ = (0, h.dataSlice)(fe, 0, 32);
    (0, h.assert)((0, h.dataSlice)(_, 0, 12) === (0, h.dataSlice)(ke, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup sender"
    }), x.sender = (0, h.dataSlice)(_, 12);
    try {
      const q = [], ne = (0, h.getNumber)((0, h.dataSlice)(fe, 32, 64)), de = (0, h.getNumber)((0, h.dataSlice)(fe, ne, ne + 32)), ye = (0, h.dataSlice)(fe, ne + 32);
      for (let ge = 0; ge < de; ge++) {
        const be = xe(ye, ge * 32);
        if (be == null)
          throw new Error("abort");
        q.push(be);
      }
      x.urls = q;
    } catch {
      (0, h.assert)(!1, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup urls"
      });
    }
    try {
      const q = me(fe, 64);
      if (q == null)
        throw new Error("abort");
      x.calldata = q;
    } catch {
      (0, h.assert)(!1, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup calldata"
      });
    }
    (0, h.assert)((0, h.dataSlice)(fe, 100, 128) === (0, h.dataSlice)(ke, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup callbaackSelector"
    }), x.selector = (0, h.dataSlice)(fe, 96, 100);
    try {
      const q = me(fe, 128);
      if (q == null)
        throw new Error("abort");
      x.extraData = q;
    } catch {
      (0, h.assert)(!1, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup extraData"
      });
    }
    return x.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((q) => x[q]), x;
  }
  return Ia;
}
var Ra = {}, lw;
function X1() {
  var e, t;
  if (lw)
    return Ra;
  lw = 1, Object.defineProperty(Ra, "__esModule", { value: !0 }), Ra.VoidSigner = Ra.AbstractSigner = void 0;
  const r = Xr(), n = ei(), s = vt(), i = Pd();
  function a(g, v) {
    if (g.provider)
      return g.provider;
    (0, s.assert)(!1, "missing provider", "UNSUPPORTED_OPERATION", { operation: v });
  }
  async function f(g, v) {
    let O = (0, i.copyRequest)(v);
    if (O.to != null && (O.to = (0, r.resolveAddress)(O.to, g)), O.from != null) {
      const N = O.from;
      O.from = Promise.all([
        g.getAddress(),
        (0, r.resolveAddress)(N, g)
      ]).then(([S, j]) => ((0, s.assertArgument)(S.toLowerCase() === j.toLowerCase(), "transaction from mismatch", "tx.from", j), S));
    } else
      O.from = g.getAddress();
    return await (0, s.resolveProperties)(O);
  }
  class d {
    /**
     *  Creates a new Signer connected to %%provider%%.
     */
    constructor(v) {
      Se(this, "provider"), (0, s.defineProperties)(this, { provider: v || null });
    }
    async getNonce(v) {
      return a(this, "getTransactionCount").getTransactionCount(await this.getAddress(), v);
    }
    async populateCall(v) {
      return await f(this, v);
    }
    async populateTransaction(v) {
      const O = a(this, "populateTransaction"), N = await f(this, v);
      N.nonce == null && (N.nonce = await this.getNonce("pending")), N.gasLimit == null && (N.gasLimit = await this.estimateGas(N));
      const S = await this.provider.getNetwork();
      if (N.chainId != null) {
        const B = (0, s.getBigInt)(N.chainId);
        (0, s.assertArgument)(B === S.chainId, "transaction chainId mismatch", "tx.chainId", v.chainId);
      } else
        N.chainId = S.chainId;
      const j = N.maxFeePerGas != null || N.maxPriorityFeePerGas != null;
      if (N.gasPrice != null && (N.type === 2 || j) ? (0, s.assertArgument)(!1, "eip-1559 transaction do not support gasPrice", "tx", v) : (N.type === 0 || N.type === 1) && j && (0, s.assertArgument)(!1, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", v), (N.type === 2 || N.type == null) && N.maxFeePerGas != null && N.maxPriorityFeePerGas != null)
        N.type = 2;
      else if (N.type === 0 || N.type === 1) {
        const B = await O.getFeeData();
        (0, s.assert)(B.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
          operation: "getGasPrice"
        }), N.gasPrice == null && (N.gasPrice = B.gasPrice);
      } else {
        const B = await O.getFeeData();
        if (N.type == null)
          if (B.maxFeePerGas != null && B.maxPriorityFeePerGas != null)
            if (N.type = 2, N.gasPrice != null) {
              const M = N.gasPrice;
              delete N.gasPrice, N.maxFeePerGas = M, N.maxPriorityFeePerGas = M;
            } else
              N.maxFeePerGas == null && (N.maxFeePerGas = B.maxFeePerGas), N.maxPriorityFeePerGas == null && (N.maxPriorityFeePerGas = B.maxPriorityFeePerGas);
          else
            B.gasPrice != null ? ((0, s.assert)(!j, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
              operation: "populateTransaction"
            }), N.gasPrice == null && (N.gasPrice = B.gasPrice), N.type = 0) : (0, s.assert)(!1, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
              operation: "signer.getFeeData"
            });
        else
          (N.type === 2 || N.type === 3) && (N.maxFeePerGas == null && (N.maxFeePerGas = B.maxFeePerGas), N.maxPriorityFeePerGas == null && (N.maxPriorityFeePerGas = B.maxPriorityFeePerGas));
      }
      return await (0, s.resolveProperties)(N);
    }
    async estimateGas(v) {
      return a(this, "estimateGas").estimateGas(await this.populateCall(v));
    }
    async call(v) {
      return a(this, "call").call(await this.populateCall(v));
    }
    async resolveName(v) {
      return await a(this, "resolveName").resolveName(v);
    }
    async sendTransaction(v) {
      const O = a(this, "sendTransaction"), N = await this.populateTransaction(v);
      delete N.from;
      const S = n.Transaction.from(N);
      return await O.broadcastTransaction(await this.signTransaction(S));
    }
  }
  Ra.AbstractSigner = d;
  const c = class m7 extends d {
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */
    constructor(v, O) {
      super(O), Fe(this, e), Se(this, "address"), (0, s.defineProperties)(this, { address: v });
    }
    async getAddress() {
      return this.address;
    }
    connect(v) {
      return new m7(this.address, v);
    }
    async signTransaction(v) {
      qe(this, e, t).call(this, "transactions", "signTransaction");
    }
    async signMessage(v) {
      qe(this, e, t).call(this, "messages", "signMessage");
    }
    async signTypedData(v, O, N) {
      qe(this, e, t).call(this, "typed-data", "signTypedData");
    }
  };
  e = /* @__PURE__ */ new WeakSet(), t = function(g, v) {
    (0, s.assert)(!1, `VoidSigner cannot sign ${g}`, "UNSUPPORTED_OPERATION", { operation: v });
  };
  let p = c;
  return Ra.VoidSigner = p, Ra;
}
var ql = {}, dw;
function _o() {
  if (dw)
    return ql;
  dw = 1, Object.defineProperty(ql, "__esModule", { value: !0 }), ql.showThrottleMessage = void 0;
  const e = /* @__PURE__ */ new Set();
  function t(r) {
    e.has(r) || (e.add(r), console.log("========= NOTICE ========="), console.log(`Request-Rate Exceeded for ${r} (this message will not be repeated)`), console.log(""), console.log("The default API keys for each service are provided as a highly-throttled,"), console.log("community resource for low-traffic projects and early prototyping."), console.log(""), console.log("While your application will continue to function, we highly recommended"), console.log("signing up for your own API keys to improve performance, increase your"), console.log("request rate/limit and enable other perks, such as metrics and advanced APIs."), console.log(""), console.log("For more details: https://docs.ethers.org/api-keys/"), console.log("=========================="));
  }
  return ql.showThrottleMessage = t, ql;
}
var $l = {}, Kl = {}, Mi = {}, _s = {}, hw;
function pI() {
  var e, t, r, n, s, i, a, f, d, c, p;
  if (hw)
    return _s;
  hw = 1, Object.defineProperty(_s, "__esModule", { value: !0 }), _s.FilterIdPendingSubscriber = _s.FilterIdEventSubscriber = _s.FilterIdSubscriber = void 0;
  const g = vt(), v = Y1();
  function O(B) {
    return JSON.parse(JSON.stringify(B));
  }
  class N {
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */
    constructor(M) {
      Fe(this, a), Fe(this, d), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Fe(this, n, void 0), Fe(this, s, void 0), Fe(this, i, void 0), Ne(this, e, M), Ne(this, t, null), Ne(this, r, qe(this, a, f).bind(this)), Ne(this, n, !1), Ne(this, s, null), Ne(this, i, !1);
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */
    _subscribe(M) {
      throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */
    _emitResults(M, I) {
      throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */
    _recover(M) {
      throw new Error("subclasses must override this");
    }
    start() {
      ae(this, n) || (Ne(this, n, !0), qe(this, a, f).call(this, -2));
    }
    stop() {
      ae(this, n) && (Ne(this, n, !1), Ne(this, i, !0), qe(this, d, c).call(this), ae(this, e).off("block", ae(this, r)));
    }
    pause(M) {
      M && qe(this, d, c).call(this), ae(this, e).off("block", ae(this, r));
    }
    resume() {
      this.start();
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakSet(), f = async function(B) {
    try {
      ae(this, t) == null && Ne(this, t, this._subscribe(ae(this, e)));
      let M = null;
      try {
        M = await ae(this, t);
      } catch (R) {
        if (!(0, g.isError)(R, "UNSUPPORTED_OPERATION") || R.operation !== "eth_newFilter")
          throw R;
      }
      if (M == null) {
        Ne(this, t, null), ae(this, e)._recoverSubscriber(this, this._recover(ae(this, e)));
        return;
      }
      const I = await ae(this, e).getNetwork();
      if (ae(this, s) || Ne(this, s, I), ae(this, s).chainId !== I.chainId)
        throw new Error("chaid changed");
      if (ae(this, i))
        return;
      const A = await ae(this, e).send("eth_getFilterChanges", [M]);
      await this._emitResults(ae(this, e), A);
    } catch (M) {
      console.log("@TODO", M);
    }
    ae(this, e).once("block", ae(this, r));
  }, d = /* @__PURE__ */ new WeakSet(), c = function() {
    const B = ae(this, t);
    B && (Ne(this, t, null), B.then((M) => {
      ae(this, e).destroyed || ae(this, e).send("eth_uninstallFilter", [M]);
    }));
  }, _s.FilterIdSubscriber = N;
  class S extends N {
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */
    constructor(M, I) {
      super(M), Fe(this, p, void 0), Ne(this, p, O(I));
    }
    _recover(M) {
      return new v.PollingEventSubscriber(M, ae(this, p));
    }
    async _subscribe(M) {
      return await M.send("eth_newFilter", [ae(this, p)]);
    }
    async _emitResults(M, I) {
      for (const A of I)
        M.emit(ae(this, p), M._wrapLog(A, M._network));
    }
  }
  p = /* @__PURE__ */ new WeakMap(), _s.FilterIdEventSubscriber = S;
  class j extends N {
    async _subscribe(M) {
      return await M.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(M, I) {
      for (const A of I)
        M.emit("pending", A);
    }
  }
  return _s.FilterIdPendingSubscriber = j, _s;
}
var fw;
function Xi() {
  var e, t, r, n, s, i, a, f, d, c, p;
  if (fw)
    return Mi;
  fw = 1, Object.defineProperty(Mi, "__esModule", { value: !0 }), Mi.JsonRpcProvider = Mi.JsonRpcApiPollingProvider = Mi.JsonRpcApiProvider = Mi.JsonRpcSigner = void 0;
  const g = Ed(), v = Xr(), O = so(), N = ei(), S = vt(), j = Od(), B = X1(), M = ti(), I = pI(), A = Y1(), R = "bigint,boolean,function,number,string,symbol".split(/,/g);
  function L(P) {
    if (P == null || R.indexOf(typeof P) >= 0 || typeof P.getAddress == "function")
      return P;
    if (Array.isArray(P))
      return P.map(L);
    if (typeof P == "object")
      return Object.keys(P).reduce((w, m) => (w[m] = P[m], w), {});
    throw new Error(`should not happen: ${P} (${typeof P})`);
  }
  function K(P) {
    return new Promise((w) => {
      setTimeout(w, P);
    });
  }
  function $(P) {
    return P && P.toLowerCase();
  }
  function k(P) {
    return P && typeof P.pollingInterval == "number";
  }
  const V = {
    polling: !1,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1 << 20,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4e3
  };
  class C extends B.AbstractSigner {
    constructor(w, m) {
      super(w), Se(this, "address"), m = (0, v.getAddress)(m), (0, S.defineProperties)(this, { address: m });
    }
    connect(w) {
      (0, S.assert)(!1, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
        operation: "signer.connect"
      });
    }
    async getAddress() {
      return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(w) {
      return await this.populateCall(w);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(w) {
      const m = L(w), l = [];
      if (m.from) {
        const W = m.from;
        l.push((async () => {
          const X = await (0, v.resolveAddress)(W, this.provider);
          (0, S.assertArgument)(X != null && X.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", w), m.from = X;
        })());
      } else
        m.from = this.address;
      if (m.gasLimit == null && l.push((async () => {
        m.gasLimit = await this.provider.estimateGas({ ...m, from: this.address });
      })()), m.to != null) {
        const W = m.to;
        l.push((async () => {
          m.to = await (0, v.resolveAddress)(W, this.provider);
        })());
      }
      l.length && await Promise.all(l);
      const b = this.provider.getRpcTransaction(m);
      return this.provider.send("eth_sendTransaction", [b]);
    }
    async sendTransaction(w) {
      const m = await this.provider.getBlockNumber(), l = await this.sendUncheckedTransaction(w);
      return await new Promise((b, W) => {
        const X = [1e3, 100];
        let G = 0;
        const re = async () => {
          try {
            const ce = await this.provider.getTransaction(l);
            if (ce != null) {
              b(ce.replaceableTransaction(m));
              return;
            }
          } catch (ce) {
            if ((0, S.isError)(ce, "CANCELLED") || (0, S.isError)(ce, "BAD_DATA") || (0, S.isError)(ce, "NETWORK_ERROR")) {
              ce.info == null && (ce.info = {}), ce.info.sendTransactionHash = l, W(ce);
              return;
            }
            if ((0, S.isError)(ce, "INVALID_ARGUMENT") && (G++, ce.info == null && (ce.info = {}), ce.info.sendTransactionHash = l, G > 10)) {
              W(ce);
              return;
            }
            this.provider.emit("error", (0, S.makeError)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", { error: ce }));
          }
          this.provider._setTimeout(() => {
            re();
          }, X.pop() || 4e3);
        };
        re();
      });
    }
    async signTransaction(w) {
      const m = L(w);
      if (m.from) {
        const b = await (0, v.resolveAddress)(m.from, this.provider);
        (0, S.assertArgument)(b != null && b.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", w), m.from = b;
      } else
        m.from = this.address;
      const l = this.provider.getRpcTransaction(m);
      return await this.provider.send("eth_signTransaction", [l]);
    }
    async signMessage(w) {
      const m = typeof w == "string" ? (0, S.toUtf8Bytes)(w) : w;
      return await this.provider.send("personal_sign", [
        (0, S.hexlify)(m),
        this.address.toLowerCase()
      ]);
    }
    async signTypedData(w, m, l) {
      const b = L(l), W = await O.TypedDataEncoder.resolveNames(w, m, b, async (X) => {
        const G = await (0, v.resolveAddress)(X);
        return (0, S.assertArgument)(G != null, "TypedData does not support null address", "value", X), G;
      });
      return await this.provider.send("eth_signTypedData_v4", [
        this.address.toLowerCase(),
        JSON.stringify(O.TypedDataEncoder.getPayload(W.domain, m, W.value))
      ]);
    }
    async unlock(w) {
      return this.provider.send("personal_unlockAccount", [
        this.address.toLowerCase(),
        w,
        null
      ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(w) {
      const m = typeof w == "string" ? (0, S.toUtf8Bytes)(w) : w;
      return await this.provider.send("eth_sign", [
        this.address.toLowerCase(),
        (0, S.hexlify)(m)
      ]);
    }
  }
  Mi.JsonRpcSigner = C;
  class D extends j.AbstractProvider {
    constructor(w, m) {
      super(w, m), Fe(this, f), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Fe(this, n, void 0), Fe(this, s, void 0), Fe(this, i, void 0), Fe(this, a, void 0), Ne(this, t, 1), Ne(this, e, Object.assign({}, V, m || {})), Ne(this, r, []), Ne(this, n, null), Ne(this, i, null), Ne(this, a, null);
      {
        let b = null;
        const W = new Promise((X) => {
          b = X;
        });
        Ne(this, s, { promise: W, resolve: b });
      }
      const l = this._getOption("staticNetwork");
      typeof l == "boolean" ? ((0, S.assertArgument)(!l || w !== "any", "staticNetwork cannot be used on special network 'any'", "options", m), l && w != null && Ne(this, i, M.Network.from(w))) : l && ((0, S.assertArgument)(w == null || l.matches(w), "staticNetwork MUST match network object", "options", m), Ne(this, i, l));
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */
    _getOption(w) {
      return ae(this, e)[w];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */
    get _network() {
      return (0, S.assert)(ae(this, i), "network is not available yet", "NETWORK_ERROR"), ae(this, i);
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */
    async _perform(w) {
      if (w.method === "call" || w.method === "estimateGas") {
        let l = w.transaction;
        if (l && l.type != null && (0, S.getBigInt)(l.type) && l.maxFeePerGas == null && l.maxPriorityFeePerGas == null) {
          const b = await this.getFeeData();
          b.maxFeePerGas == null && b.maxPriorityFeePerGas == null && (w = Object.assign({}, w, {
            transaction: Object.assign({}, l, { type: void 0 })
          }));
        }
      }
      const m = this.getRpcRequest(w);
      return m != null ? await this.send(m.method, m.args) : super._perform(w);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */
    async _detectNetwork() {
      const w = this._getOption("staticNetwork");
      if (w)
        if (w === !0) {
          if (ae(this, i))
            return ae(this, i);
        } else
          return w;
      return ae(this, a) ? await ae(this, a) : this.ready ? (Ne(this, a, (async () => {
        try {
          const m = M.Network.from((0, S.getBigInt)(await this.send("eth_chainId", [])));
          return Ne(this, a, null), m;
        } catch (m) {
          throw Ne(this, a, null), m;
        }
      })()), await ae(this, a)) : (Ne(this, a, (async () => {
        const m = {
          id: ed(this, t)._++,
          method: "eth_chainId",
          params: [],
          jsonrpc: "2.0"
        };
        this.emit("debug", { action: "sendRpcPayload", payload: m });
        let l;
        try {
          l = (await this._send(m))[0], Ne(this, a, null);
        } catch (b) {
          throw Ne(this, a, null), this.emit("debug", { action: "receiveRpcError", error: b }), b;
        }
        if (this.emit("debug", { action: "receiveRpcResult", result: l }), "result" in l)
          return M.Network.from((0, S.getBigInt)(l.result));
        throw this.getRpcError(m, l);
      })()), await ae(this, a));
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */
    _start() {
      ae(this, s) == null || ae(this, s).resolve == null || (ae(this, s).resolve(), Ne(this, s, null), (async () => {
        for (; ae(this, i) == null && !this.destroyed; )
          try {
            Ne(this, i, await this._detectNetwork());
          } catch (w) {
            if (this.destroyed)
              break;
            console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)"), this.emit("error", (0, S.makeError)("failed to bootstrap network detection", "NETWORK_ERROR", { event: "initial-network-discovery", info: { error: w } })), await K(1e3);
          }
        qe(this, f, d).call(this);
      })());
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */
    async _waitUntilReady() {
      if (ae(this, s) != null)
        return await ae(this, s).promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */
    _getSubscriber(w) {
      return w.type === "pending" ? new I.FilterIdPendingSubscriber(this) : w.type === "event" ? this._getOption("polling") ? new A.PollingEventSubscriber(this, w.filter) : new I.FilterIdEventSubscriber(this, w.filter) : w.type === "orphan" && w.filter.orphan === "drop-log" ? new j.UnmanagedSubscriber("orphan") : super._getSubscriber(w);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */
    get ready() {
      return ae(this, s) == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */
    getRpcTransaction(w) {
      const m = {};
      return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach((l) => {
        if (w[l] == null)
          return;
        let b = l;
        l === "gasLimit" && (b = "gas"), m[b] = (0, S.toQuantity)((0, S.getBigInt)(w[l], `tx.${l}`));
      }), ["from", "to", "data"].forEach((l) => {
        w[l] != null && (m[l] = (0, S.hexlify)(w[l]));
      }), w.accessList && (m.accessList = (0, N.accessListify)(w.accessList)), m;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */
    getRpcRequest(w) {
      switch (w.method) {
        case "chainId":
          return { method: "eth_chainId", args: [] };
        case "getBlockNumber":
          return { method: "eth_blockNumber", args: [] };
        case "getGasPrice":
          return { method: "eth_gasPrice", args: [] };
        case "getPriorityFee":
          return { method: "eth_maxPriorityFeePerGas", args: [] };
        case "getBalance":
          return {
            method: "eth_getBalance",
            args: [$(w.address), w.blockTag]
          };
        case "getTransactionCount":
          return {
            method: "eth_getTransactionCount",
            args: [$(w.address), w.blockTag]
          };
        case "getCode":
          return {
            method: "eth_getCode",
            args: [$(w.address), w.blockTag]
          };
        case "getStorage":
          return {
            method: "eth_getStorageAt",
            args: [
              $(w.address),
              "0x" + w.position.toString(16),
              w.blockTag
            ]
          };
        case "broadcastTransaction":
          return {
            method: "eth_sendRawTransaction",
            args: [w.signedTransaction]
          };
        case "getBlock":
          if ("blockTag" in w)
            return {
              method: "eth_getBlockByNumber",
              args: [w.blockTag, !!w.includeTransactions]
            };
          if ("blockHash" in w)
            return {
              method: "eth_getBlockByHash",
              args: [w.blockHash, !!w.includeTransactions]
            };
          break;
        case "getTransaction":
          return {
            method: "eth_getTransactionByHash",
            args: [w.hash]
          };
        case "getTransactionReceipt":
          return {
            method: "eth_getTransactionReceipt",
            args: [w.hash]
          };
        case "call":
          return {
            method: "eth_call",
            args: [this.getRpcTransaction(w.transaction), w.blockTag]
          };
        case "estimateGas":
          return {
            method: "eth_estimateGas",
            args: [this.getRpcTransaction(w.transaction)]
          };
        case "getLogs":
          return w.filter && w.filter.address != null && (Array.isArray(w.filter.address) ? w.filter.address = w.filter.address.map($) : w.filter.address = $(w.filter.address)), { method: "eth_getLogs", args: [w.filter] };
      }
      return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */
    getRpcError(w, m) {
      const { method: l } = w, { error: b } = m;
      if (l === "eth_estimateGas" && b.message) {
        const G = b.message;
        if (!G.match(/revert/i) && G.match(/insufficient funds/i))
          return (0, S.makeError)("insufficient funds", "INSUFFICIENT_FUNDS", {
            transaction: w.params[0],
            info: { payload: w, error: b }
          });
      }
      if (l === "eth_call" || l === "eth_estimateGas") {
        const G = h(b), re = g.AbiCoder.getBuiltinCallException(l === "eth_call" ? "call" : "estimateGas", w.params[0], G ? G.data : null);
        return re.info = { error: b, payload: w }, re;
      }
      const W = JSON.stringify(E(b));
      if (typeof b.message == "string" && b.message.match(/user denied|ethers-user-denied/i)) {
        const G = {
          eth_sign: "signMessage",
          personal_sign: "signMessage",
          eth_signTypedData_v4: "signTypedData",
          eth_signTransaction: "signTransaction",
          eth_sendTransaction: "sendTransaction",
          eth_requestAccounts: "requestAccess",
          wallet_requestAccounts: "requestAccess"
        };
        return (0, S.makeError)("user rejected action", "ACTION_REJECTED", {
          action: G[l] || "unknown",
          reason: "rejected",
          info: { payload: w, error: b }
        });
      }
      if (l === "eth_sendRawTransaction" || l === "eth_sendTransaction") {
        const G = w.params[0];
        if (W.match(/insufficient funds|base fee exceeds gas limit/i))
          return (0, S.makeError)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
            transaction: G,
            info: { error: b }
          });
        if (W.match(/nonce/i) && W.match(/too low/i))
          return (0, S.makeError)("nonce has already been used", "NONCE_EXPIRED", { transaction: G, info: { error: b } });
        if (W.match(/replacement transaction/i) && W.match(/underpriced/i))
          return (0, S.makeError)("replacement fee too low", "REPLACEMENT_UNDERPRICED", { transaction: G, info: { error: b } });
        if (W.match(/only replay-protected/i))
          return (0, S.makeError)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
            operation: l,
            info: { transaction: G, info: { error: b } }
          });
      }
      let X = !!W.match(/the method .* does not exist/i);
      return X || b && b.details && b.details.startsWith("Unauthorized method:") && (X = !0), X ? (0, S.makeError)("unsupported operation", "UNSUPPORTED_OPERATION", {
        operation: w.method,
        info: { error: b, payload: w }
      }) : (0, S.makeError)("could not coalesce error", "UNKNOWN_ERROR", { error: b, payload: w });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */
    send(w, m) {
      if (this.destroyed)
        return Promise.reject((0, S.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: w }));
      const l = ed(this, t)._++, b = new Promise((W, X) => {
        ae(this, r).push({
          resolve: W,
          reject: X,
          payload: { method: w, params: m, id: l, jsonrpc: "2.0" }
        });
      });
      return qe(this, f, d).call(this), b;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */
    async getSigner(w) {
      w == null && (w = 0);
      const m = this.send("eth_accounts", []);
      if (typeof w == "number") {
        const b = await m;
        if (w >= b.length)
          throw new Error("no such account");
        return new C(this, b[w]);
      }
      const { accounts: l } = await (0, S.resolveProperties)({
        network: this.getNetwork(),
        accounts: m
      });
      w = (0, v.getAddress)(w);
      for (const b of l)
        if ((0, v.getAddress)(b) === w)
          return new C(this, w);
      throw new Error("invalid account");
    }
    async listAccounts() {
      return (await this.send("eth_accounts", [])).map((w) => new C(this, w));
    }
    destroy() {
      ae(this, n) && (clearTimeout(ae(this, n)), Ne(this, n, null));
      for (const { payload: w, reject: m } of ae(this, r))
        m((0, S.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: w.method }));
      Ne(this, r, []), super.destroy();
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakSet(), d = function() {
    if (ae(this, n))
      return;
    const P = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
    Ne(this, n, setTimeout(() => {
      Ne(this, n, null);
      const w = ae(this, r);
      for (Ne(this, r, []); w.length; ) {
        const m = [w.shift()];
        for (; w.length && m.length !== ae(this, e).batchMaxCount; )
          if (m.push(w.shift()), JSON.stringify(m.map((l) => l.payload)).length > ae(this, e).batchMaxSize) {
            w.unshift(m.pop());
            break;
          }
        (async () => {
          const l = m.length === 1 ? m[0].payload : m.map((b) => b.payload);
          this.emit("debug", { action: "sendRpcPayload", payload: l });
          try {
            const b = await this._send(l);
            this.emit("debug", { action: "receiveRpcResult", result: b });
            for (const { resolve: W, reject: X, payload: G } of m) {
              if (this.destroyed) {
                X((0, S.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: G.method }));
                continue;
              }
              const re = b.filter((ce) => ce.id === G.id)[0];
              if (re == null) {
                const ce = (0, S.makeError)("missing response for request", "BAD_DATA", {
                  value: b,
                  info: { payload: G }
                });
                this.emit("error", ce), X(ce);
                continue;
              }
              if ("error" in re) {
                X(this.getRpcError(G, re));
                continue;
              }
              W(re.result);
            }
          } catch (b) {
            this.emit("debug", { action: "receiveRpcError", error: b });
            for (const { reject: W } of m)
              W(b);
          }
        })();
      }
    }, P));
  }, Mi.JsonRpcApiProvider = D;
  class o extends D {
    constructor(w, m) {
      super(w, m), Fe(this, c, void 0);
      let l = this._getOption("pollingInterval");
      l == null && (l = V.pollingInterval), Ne(this, c, l);
    }
    _getSubscriber(w) {
      const m = super._getSubscriber(w);
      return k(m) && (m.pollingInterval = ae(this, c)), m;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */
    get pollingInterval() {
      return ae(this, c);
    }
    set pollingInterval(w) {
      if (!Number.isInteger(w) || w < 0)
        throw new Error("invalid interval");
      Ne(this, c, w), this._forEachSubscriber((m) => {
        k(m) && (m.pollingInterval = ae(this, c));
      });
    }
  }
  c = /* @__PURE__ */ new WeakMap(), Mi.JsonRpcApiPollingProvider = o;
  class u extends o {
    constructor(w, m, l) {
      w == null && (w = "http://localhost:8545"), super(m, l), Fe(this, p, void 0), typeof w == "string" ? Ne(this, p, new S.FetchRequest(w)) : Ne(this, p, w.clone());
    }
    _getConnection() {
      return ae(this, p).clone();
    }
    async send(w, m) {
      return await this._start(), await super.send(w, m);
    }
    async _send(w) {
      const m = this._getConnection();
      m.body = JSON.stringify(w), m.setHeader("content-type", "application/json");
      const l = await m.send();
      l.assertOk();
      let b = l.bodyJson;
      return Array.isArray(b) || (b = [b]), b;
    }
  }
  p = /* @__PURE__ */ new WeakMap(), Mi.JsonRpcProvider = u;
  function h(P) {
    if (P == null)
      return null;
    if (typeof P.message == "string" && P.message.match(/revert/i) && (0, S.isHexString)(P.data))
      return { message: P.message, data: P.data };
    if (typeof P == "object") {
      for (const w in P) {
        const m = h(P[w]);
        if (m)
          return m;
      }
      return null;
    }
    if (typeof P == "string")
      try {
        return h(JSON.parse(P));
      } catch {
      }
    return null;
  }
  function y(P, w) {
    if (P != null) {
      if (typeof P.message == "string" && w.push(P.message), typeof P == "object")
        for (const m in P)
          y(P[m], w);
      if (typeof P == "string")
        try {
          return y(JSON.parse(P), w);
        } catch {
        }
    }
  }
  function E(P) {
    const w = [];
    return y(P, w), w;
  }
  return Mi;
}
var pw;
function y7() {
  if (pw)
    return Kl;
  pw = 1, Object.defineProperty(Kl, "__esModule", { value: !0 }), Kl.AnkrProvider = void 0;
  const e = vt(), t = _o(), r = ti(), n = Xi(), s = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
  function i(f) {
    switch (f) {
      case "mainnet":
        return "rpc.ankr.com/eth";
      case "goerli":
        return "rpc.ankr.com/eth_goerli";
      case "sepolia":
        return "rpc.ankr.com/eth_sepolia";
      case "arbitrum":
        return "rpc.ankr.com/arbitrum";
      case "base":
        return "rpc.ankr.com/base";
      case "base-goerli":
        return "rpc.ankr.com/base_goerli";
      case "base-sepolia":
        return "rpc.ankr.com/base_sepolia";
      case "bnb":
        return "rpc.ankr.com/bsc";
      case "bnbt":
        return "rpc.ankr.com/bsc_testnet_chapel";
      case "matic":
        return "rpc.ankr.com/polygon";
      case "matic-mumbai":
        return "rpc.ankr.com/polygon_mumbai";
      case "optimism":
        return "rpc.ankr.com/optimism";
      case "optimism-goerli":
        return "rpc.ankr.com/optimism_testnet";
      case "optimism-sepolia":
        return "rpc.ankr.com/optimism_sepolia";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Create a new **AnkrProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */
    constructor(d, c) {
      d == null && (d = "mainnet");
      const p = r.Network.from(d);
      c == null && (c = s);
      const g = { polling: !0, staticNetwork: p }, v = a.getRequest(p, c);
      super(v, p, g), Se(this, "apiKey"), (0, e.defineProperties)(this, { apiKey: c });
    }
    _getProvider(d) {
      try {
        return new a(d, this.apiKey);
      } catch {
      }
      return super._getProvider(d);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%apiKey%%.
     */
    static getRequest(d, c) {
      c == null && (c = s);
      const p = new e.FetchRequest(`https://${i(d.name)}/${c}`);
      return p.allowGzip = !0, c === s && (p.retryFunc = async (g, v, O) => ((0, t.showThrottleMessage)("AnkrProvider"), !0)), p;
    }
    getRpcError(d, c) {
      return d.method === "eth_sendRawTransaction" && c && c.error && c.error.message === "INTERNAL_ERROR: could not replace existing tx" && (c.error.message = "replacement transaction underpriced"), super.getRpcError(d, c);
    }
    isCommunityResource() {
      return this.apiKey === s;
    }
  }
  return Kl.AnkrProvider = a, Kl;
}
var Jl = {}, gw;
function b7() {
  if (gw)
    return Jl;
  gw = 1, Object.defineProperty(Jl, "__esModule", { value: !0 }), Jl.AlchemyProvider = void 0;
  const e = vt(), t = _o(), r = ti(), n = Xi(), s = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
  function i(f) {
    switch (f) {
      case "mainnet":
        return "eth-mainnet.alchemyapi.io";
      case "goerli":
        return "eth-goerli.g.alchemy.com";
      case "sepolia":
        return "eth-sepolia.g.alchemy.com";
      case "arbitrum":
        return "arb-mainnet.g.alchemy.com";
      case "arbitrum-goerli":
        return "arb-goerli.g.alchemy.com";
      case "arbitrum-sepolia":
        return "arb-sepolia.g.alchemy.com";
      case "base":
        return "base-mainnet.g.alchemy.com";
      case "base-goerli":
        return "base-goerli.g.alchemy.com";
      case "base-sepolia":
        return "base-sepolia.g.alchemy.com";
      case "matic":
        return "polygon-mainnet.g.alchemy.com";
      case "matic-amoy":
        return "polygon-amoy.g.alchemy.com";
      case "matic-mumbai":
        return "polygon-mumbai.g.alchemy.com";
      case "optimism":
        return "opt-mainnet.g.alchemy.com";
      case "optimism-goerli":
        return "opt-goerli.g.alchemy.com";
      case "optimism-sepolia":
        return "opt-sepolia.g.alchemy.com";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    constructor(d, c) {
      d == null && (d = "mainnet");
      const p = r.Network.from(d);
      c == null && (c = s);
      const g = a.getRequest(p, c);
      super(g, p, { staticNetwork: p }), Se(this, "apiKey"), (0, e.defineProperties)(this, { apiKey: c });
    }
    _getProvider(d) {
      try {
        return new a(d, this.apiKey);
      } catch {
      }
      return super._getProvider(d);
    }
    async _perform(d) {
      if (d.method === "getTransactionResult") {
        const { trace: c, tx: p } = await (0, e.resolveProperties)({
          trace: this.send("trace_transaction", [d.hash]),
          tx: this.getTransaction(d.hash)
        });
        if (c == null || p == null)
          return null;
        let g, v = !1;
        try {
          g = c[0].result.output, v = c[0].error === "Reverted";
        } catch {
        }
        if (g)
          return (0, e.assert)(!v, "an error occurred during transaction executions", "CALL_EXCEPTION", {
            action: "getTransactionResult",
            data: g,
            reason: null,
            transaction: p,
            invocation: null,
            revert: null
            // @TODO
          }), g;
        (0, e.assert)(!1, "could not parse trace result", "BAD_DATA", { value: c });
      }
      return await super._perform(d);
    }
    isCommunityResource() {
      return this.apiKey === s;
    }
    static getRequest(d, c) {
      c == null && (c = s);
      const p = new e.FetchRequest(`https://${i(d.name)}/v2/${c}`);
      return p.allowGzip = !0, c === s && (p.retryFunc = async (g, v, O) => ((0, t.showThrottleMessage)("alchemy"), !0)), p;
    }
  }
  return Jl.AlchemyProvider = a, Jl;
}
var Ql = {}, mw;
function w7() {
  if (mw)
    return Ql;
  mw = 1, Object.defineProperty(Ql, "__esModule", { value: !0 }), Ql.ChainstackProvider = void 0;
  const e = vt(), t = _o(), r = ti(), n = Xi();
  function s(f) {
    switch (f) {
      case "mainnet":
        return "39f1d67cedf8b7831010a665328c9197";
      case "arbitrum":
        return "0550c209db33c3abf4cc927e1e18cea1";
      case "bnb":
        return "98b5a77e531614387366f6fc5da097f8";
      case "matic":
        return "cd9d4d70377471aa7c142ec4a4205249";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  function i(f) {
    switch (f) {
      case "mainnet":
        return "ethereum-mainnet.core.chainstack.com";
      case "arbitrum":
        return "arbitrum-mainnet.core.chainstack.com";
      case "bnb":
        return "bsc-mainnet.core.chainstack.com";
      case "matic":
        return "polygon-mainnet.core.chainstack.com";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Creates a new **ChainstackProvider**.
     */
    constructor(d, c) {
      d == null && (d = "mainnet");
      const p = r.Network.from(d);
      c == null && (c = s(p.name));
      const g = a.getRequest(p, c);
      super(g, p, { staticNetwork: p }), Se(this, "apiKey"), (0, e.defineProperties)(this, { apiKey: c });
    }
    _getProvider(d) {
      try {
        return new a(d, this.apiKey);
      } catch {
      }
      return super._getProvider(d);
    }
    isCommunityResource() {
      return this.apiKey === s(this._network.name);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%apiKey%% and %%projectSecret%%.
     */
    static getRequest(d, c) {
      c == null && (c = s(d.name));
      const p = new e.FetchRequest(`https://${i(d.name)}/${c}`);
      return p.allowGzip = !0, c === s(d.name) && (p.retryFunc = async (g, v, O) => ((0, t.showThrottleMessage)("ChainstackProvider"), !0)), p;
    }
  }
  return Ql.ChainstackProvider = a, Ql;
}
var Zl = {}, yw;
function v7() {
  if (yw)
    return Zl;
  yw = 1, Object.defineProperty(Zl, "__esModule", { value: !0 }), Zl.CloudflareProvider = void 0;
  const e = vt(), t = ti(), r = Xi();
  class n extends r.JsonRpcProvider {
    constructor(i) {
      i == null && (i = "mainnet");
      const a = t.Network.from(i);
      (0, e.assertArgument)(a.name === "mainnet", "unsupported network", "network", i), super("https://cloudflare-eth.com/", a, { staticNetwork: a });
    }
  }
  return Zl.CloudflareProvider = n, Zl;
}
var Ca = {}, bw;
function A7() {
  var e;
  if (bw)
    return Ca;
  bw = 1, Object.defineProperty(Ca, "__esModule", { value: !0 }), Ca.EtherscanProvider = Ca.EtherscanPlugin = void 0;
  const t = Ed(), r = bf(), n = ei(), s = vt(), i = Od(), a = ti(), f = Z1(), d = _o(), c = 2e3;
  function p(j) {
    return j && typeof j.then == "function";
  }
  const g = "org.ethers.plugins.provider.Etherscan";
  class v extends f.NetworkPlugin {
    /**
     *  Creates a new **EtherscanProvider** which will use
     *  %%baseUrl%%.
     */
    constructor(B) {
      super(g), Se(this, "baseUrl"), (0, s.defineProperties)(this, { baseUrl: B });
    }
    clone() {
      return new v(this.baseUrl);
    }
  }
  Ca.EtherscanPlugin = v;
  const O = ["enableCcipRead"];
  let N = 1;
  class S extends i.AbstractProvider {
    /**
     *  Creates a new **EtherscanBaseProvider**.
     */
    constructor(B, M) {
      const I = M ?? null;
      super(), Se(this, "network"), Se(this, "apiKey"), Fe(this, e, void 0);
      const A = a.Network.from(B);
      Ne(this, e, A.getPlugin(g)), (0, s.defineProperties)(this, { apiKey: I, network: A }), this.getBaseUrl();
    }
    /**
     *  Returns the base URL.
     *
     *  If an [[EtherscanPlugin]] is configured on the
     *  [[EtherscanBaseProvider_network]], returns the plugin's
     *  baseUrl.
     */
    getBaseUrl() {
      if (ae(this, e))
        return ae(this, e).baseUrl;
      switch (this.network.name) {
        case "mainnet":
          return "https://api.etherscan.io";
        case "goerli":
          return "https://api-goerli.etherscan.io";
        case "sepolia":
          return "https://api-sepolia.etherscan.io";
        case "holesky":
          return "https://api-holesky.etherscan.io";
        case "arbitrum":
          return "https://api.arbiscan.io";
        case "arbitrum-goerli":
          return "https://api-goerli.arbiscan.io";
        case "bnb":
          return "https://api.bscscan.com";
        case "bnbt":
          return "https://api-testnet.bscscan.com";
        case "matic":
          return "https://api.polygonscan.com";
        case "matic-amoy":
          return "https://api-amoy.polygonscan.com";
        case "matic-mumbai":
          return "https://api-testnet.polygonscan.com";
        case "optimism":
          return "https://api-optimistic.etherscan.io";
        case "optimism-goerli":
          return "https://api-goerli-optimistic.etherscan.io";
      }
      (0, s.assertArgument)(!1, "unsupported network", "network", this.network);
    }
    /**
     *  Returns the URL for the %%module%% and %%params%%.
     */
    getUrl(B, M) {
      const I = Object.keys(M).reduce((R, L) => {
        const K = M[L];
        return K != null && (R += `&${L}=${K}`), R;
      }, ""), A = this.apiKey ? `&apikey=${this.apiKey}` : "";
      return `${this.getBaseUrl()}/api?module=${B}${I}${A}`;
    }
    /**
     *  Returns the URL for using POST requests.
     */
    getPostUrl() {
      return `${this.getBaseUrl()}/api`;
    }
    /**
     *  Returns the parameters for using POST requests.
     */
    getPostData(B, M) {
      return M.module = B, M.apikey = this.apiKey, M;
    }
    async detectNetwork() {
      return this.network;
    }
    /**
     *  Resolves to the result of calling %%module%% with %%params%%.
     *
     *  If %%post%%, the request is made as a POST request.
     */
    async fetch(B, M, I) {
      const A = N++, R = I ? this.getPostUrl() : this.getUrl(B, M), L = I ? this.getPostData(B, M) : null;
      this.emit("debug", { action: "sendRequest", id: A, url: R, payload: L });
      const K = new s.FetchRequest(R);
      K.setThrottleParams({ slotInterval: 1e3 }), K.retryFunc = (V, C, D) => (this.isCommunityResource() && (0, d.showThrottleMessage)("Etherscan"), Promise.resolve(!0)), K.processFunc = async (V, C) => {
        const D = C.hasBody() ? JSON.parse((0, s.toUtf8String)(C.body)) : {}, o = (typeof D.result == "string" ? D.result : "").toLowerCase().indexOf("rate limit") >= 0;
        return B === "proxy" ? D && D.status == 0 && D.message == "NOTOK" && o && (this.emit("debug", { action: "receiveError", id: A, reason: "proxy-NOTOK", error: D }), C.throwThrottleError(D.result, c)) : o && (this.emit("debug", { action: "receiveError", id: A, reason: "null result", error: D.result }), C.throwThrottleError(D.result, c)), C;
      }, L && (K.setHeader("content-type", "application/x-www-form-urlencoded; charset=UTF-8"), K.body = Object.keys(L).map((V) => `${V}=${L[V]}`).join("&"));
      const $ = await K.send();
      try {
        $.assertOk();
      } catch (V) {
        this.emit("debug", { action: "receiveError", id: A, error: V, reason: "assertOk" }), (0, s.assert)(!1, "response error", "SERVER_ERROR", { request: K, response: $ });
      }
      $.hasBody() || (this.emit("debug", { action: "receiveError", id: A, error: "missing body", reason: "null body" }), (0, s.assert)(!1, "missing response", "SERVER_ERROR", { request: K, response: $ }));
      const k = JSON.parse((0, s.toUtf8String)($.body));
      return B === "proxy" ? (k.jsonrpc != "2.0" && (this.emit("debug", { action: "receiveError", id: A, result: k, reason: "invalid JSON-RPC" }), (0, s.assert)(!1, "invalid JSON-RPC response (missing jsonrpc='2.0')", "SERVER_ERROR", { request: K, response: $, info: { result: k } })), k.error && (this.emit("debug", { action: "receiveError", id: A, result: k, reason: "JSON-RPC error" }), (0, s.assert)(!1, "error response", "SERVER_ERROR", { request: K, response: $, info: { result: k } })), this.emit("debug", { action: "receiveRequest", id: A, result: k }), k.result) : k.status == 0 && (k.message === "No records found" || k.message === "No transactions found") ? (this.emit("debug", { action: "receiveRequest", id: A, result: k }), k.result) : ((k.status != 1 || typeof k.message == "string" && !k.message.match(/^OK/)) && (this.emit("debug", { action: "receiveError", id: A, result: k }), (0, s.assert)(!1, "error response", "SERVER_ERROR", { request: K, response: $, info: { result: k } })), this.emit("debug", { action: "receiveRequest", id: A, result: k }), k.result);
    }
    /**
     *  Returns %%transaction%% normalized for the Etherscan API.
     */
    _getTransactionPostData(B) {
      const M = {};
      for (let I in B) {
        if (O.indexOf(I) >= 0 || B[I] == null)
          continue;
        let A = B[I];
        I === "type" && A === 0 || I === "blockTag" && A === "latest" || ({ type: !0, gasLimit: !0, gasPrice: !0, maxFeePerGs: !0, maxPriorityFeePerGas: !0, nonce: !0, value: !0 }[I] ? A = (0, s.toQuantity)(A) : I === "accessList" ? A = "[" + (0, n.accessListify)(A).map((R) => `{address:"${R.address}",storageKeys:["${R.storageKeys.join('","')}"]}`).join(",") + "]" : A = (0, s.hexlify)(A), M[I] = A);
      }
      return M;
    }
    /**
     *  Throws the normalized Etherscan error.
     */
    _checkError(B, M, I) {
      let A = "";
      if ((0, s.isError)(M, "SERVER_ERROR")) {
        try {
          A = M.info.result.error.message;
        } catch {
        }
        if (!A)
          try {
            A = M.info.message;
          } catch {
          }
      }
      if (B.method === "estimateGas" && !A.match(/revert/i) && A.match(/insufficient funds/i) && (0, s.assert)(!1, "insufficient funds", "INSUFFICIENT_FUNDS", {
        transaction: B.transaction
      }), (B.method === "call" || B.method === "estimateGas") && A.match(/execution reverted/i)) {
        let R = "";
        try {
          R = M.info.result.error.data;
        } catch {
        }
        const L = t.AbiCoder.getBuiltinCallException(B.method, B.transaction, R);
        throw L.info = { request: B, error: M }, L;
      }
      if (A && B.method === "broadcastTransaction") {
        const R = n.Transaction.from(B.signedTransaction);
        A.match(/replacement/i) && A.match(/underpriced/i) && (0, s.assert)(!1, "replacement fee too low", "REPLACEMENT_UNDERPRICED", {
          transaction: R
        }), A.match(/insufficient funds/) && (0, s.assert)(!1, "insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
          transaction: R
        }), A.match(/same hash was already imported|transaction nonce is too low|nonce too low/) && (0, s.assert)(!1, "nonce has already been used", "NONCE_EXPIRED", {
          transaction: R
        });
      }
      throw M;
    }
    async _detectNetwork() {
      return this.network;
    }
    async _perform(B) {
      switch (B.method) {
        case "chainId":
          return this.network.chainId;
        case "getBlockNumber":
          return this.fetch("proxy", { action: "eth_blockNumber" });
        case "getGasPrice":
          return this.fetch("proxy", { action: "eth_gasPrice" });
        case "getPriorityFee":
          if (this.network.name === "mainnet")
            return "1000000000";
          if (this.network.name === "optimism")
            return "1000000";
          throw new Error("fallback onto the AbstractProvider default");
        case "getBalance":
          return this.fetch("account", {
            action: "balance",
            address: B.address,
            tag: B.blockTag
          });
        case "getTransactionCount":
          return this.fetch("proxy", {
            action: "eth_getTransactionCount",
            address: B.address,
            tag: B.blockTag
          });
        case "getCode":
          return this.fetch("proxy", {
            action: "eth_getCode",
            address: B.address,
            tag: B.blockTag
          });
        case "getStorage":
          return this.fetch("proxy", {
            action: "eth_getStorageAt",
            address: B.address,
            position: B.position,
            tag: B.blockTag
          });
        case "broadcastTransaction":
          return this.fetch("proxy", {
            action: "eth_sendRawTransaction",
            hex: B.signedTransaction
          }, !0).catch((M) => this._checkError(B, M, B.signedTransaction));
        case "getBlock":
          if ("blockTag" in B)
            return this.fetch("proxy", {
              action: "eth_getBlockByNumber",
              tag: B.blockTag,
              boolean: B.includeTransactions ? "true" : "false"
            });
          (0, s.assert)(!1, "getBlock by blockHash not supported by Etherscan", "UNSUPPORTED_OPERATION", {
            operation: "getBlock(blockHash)"
          });
        case "getTransaction":
          return this.fetch("proxy", {
            action: "eth_getTransactionByHash",
            txhash: B.hash
          });
        case "getTransactionReceipt":
          return this.fetch("proxy", {
            action: "eth_getTransactionReceipt",
            txhash: B.hash
          });
        case "call": {
          if (B.blockTag !== "latest")
            throw new Error("EtherscanProvider does not support blockTag for call");
          const M = this._getTransactionPostData(B.transaction);
          M.module = "proxy", M.action = "eth_call";
          try {
            return await this.fetch("proxy", M, !0);
          } catch (I) {
            return this._checkError(B, I, B.transaction);
          }
        }
        case "estimateGas": {
          const M = this._getTransactionPostData(B.transaction);
          M.module = "proxy", M.action = "eth_estimateGas";
          try {
            return await this.fetch("proxy", M, !0);
          } catch (I) {
            return this._checkError(B, I, B.transaction);
          }
        }
      }
      return super._perform(B);
    }
    async getNetwork() {
      return this.network;
    }
    /**
     *  Resolves to the current price of ether.
     *
     *  This returns ``0`` on any network other than ``mainnet``.
     */
    async getEtherPrice() {
      return this.network.name !== "mainnet" ? 0 : parseFloat((await this.fetch("stats", { action: "ethprice" })).ethusd);
    }
    /**
     *  Resolves to a [Contract]] for %%address%%, using the
     *  Etherscan API to retreive the Contract ABI.
     */
    async getContract(B) {
      let M = this._getAddress(B);
      p(M) && (M = await M);
      try {
        const I = await this.fetch("contract", {
          action: "getabi",
          address: M
        }), A = JSON.parse(I);
        return new r.Contract(M, A, this);
      } catch {
        return null;
      }
    }
    isCommunityResource() {
      return this.apiKey == null;
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), Ca.EtherscanProvider = S, Ca;
}
var Ba = {}, Yl = {}, Xl = {}, ww;
function gI() {
  if (ww)
    return Xl;
  ww = 1, Object.defineProperty(Xl, "__esModule", { value: !0 }), Xl.WebSocket = void 0;
  function e() {
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof nr < "u")
      return nr;
    throw new Error("unable to locate global object");
  }
  const t = e().WebSocket;
  return Xl.WebSocket = t, Xl;
}
var $n = {}, vw;
function Qp() {
  var e, t, r, n, s, i, a, f, d;
  if (vw)
    return $n;
  vw = 1, Object.defineProperty($n, "__esModule", { value: !0 }), $n.SocketProvider = $n.SocketEventSubscriber = $n.SocketPendingSubscriber = $n.SocketBlockSubscriber = $n.SocketSubscriber = void 0;
  const c = Od(), p = vt(), g = Xi();
  class v {
    /**
     *  Creates a new **SocketSubscriber** attached to %%provider%% listening
     *  to %%filter%%.
     */
    constructor(M, I) {
      Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Fe(this, n, void 0), Fe(this, s, void 0), Ne(this, e, M), Ne(this, t, JSON.stringify(I)), Ne(this, r, null), Ne(this, n, null), Ne(this, s, null);
    }
    /**
     *  The filter.
     */
    get filter() {
      return JSON.parse(ae(this, t));
    }
    start() {
      Ne(this, r, ae(this, e).send("eth_subscribe", this.filter).then((M) => (ae(this, e)._register(M, this), M)));
    }
    stop() {
      ae(this, r).then((M) => {
        ae(this, e).destroyed || ae(this, e).send("eth_unsubscribe", [M]);
      }), Ne(this, r, null);
    }
    // @TODO: pause should trap the current blockNumber, unsub, and on resume use getLogs
    //        and resume
    pause(M) {
      (0, p.assert)(M, "preserve logs while paused not supported by SocketSubscriber yet", "UNSUPPORTED_OPERATION", { operation: "pause(false)" }), Ne(this, n, !!M);
    }
    resume() {
      Ne(this, n, null);
    }
    /**
     *  @_ignore:
     */
    _handleMessage(M) {
      if (ae(this, r) != null && ae(this, n) === null) {
        let I = ae(this, s);
        I == null ? I = this._emit(ae(this, e), M) : I = I.then(async () => {
          await this._emit(ae(this, e), M);
        }), Ne(this, s, I.then(() => {
          ae(this, s) === I && Ne(this, s, null);
        }));
      }
    }
    /**
     *  Sub-classes **must** override this to emit the events on the
     *  provider.
     */
    async _emit(M, I) {
      throw new Error("sub-classes must implemente this; _emit");
    }
  }
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), $n.SocketSubscriber = v;
  class O extends v {
    /**
     *  @_ignore:
     */
    constructor(M) {
      super(M, ["newHeads"]);
    }
    async _emit(M, I) {
      M.emit("block", parseInt(I.number));
    }
  }
  $n.SocketBlockSubscriber = O;
  class N extends v {
    /**
     *  @_ignore:
     */
    constructor(M) {
      super(M, ["newPendingTransactions"]);
    }
    async _emit(M, I) {
      M.emit("pending", I);
    }
  }
  $n.SocketPendingSubscriber = N;
  class S extends v {
    /**
     *  @_ignore:
     */
    constructor(M, I) {
      super(M, ["logs", I]), Fe(this, i, void 0), Ne(this, i, JSON.stringify(I));
    }
    /**
     *  The filter.
     */
    get logFilter() {
      return JSON.parse(ae(this, i));
    }
    async _emit(M, I) {
      M.emit(this.logFilter, M._wrapLog(I, M._network));
    }
  }
  i = /* @__PURE__ */ new WeakMap(), $n.SocketEventSubscriber = S;
  class j extends g.JsonRpcApiProvider {
    /**
     *  Creates a new **SocketProvider** connected to %%network%%.
     *
     *  If unspecified, the network will be discovered.
     */
    constructor(M, I) {
      const A = Object.assign({}, I ?? {});
      (0, p.assertArgument)(A.batchMaxCount == null || A.batchMaxCount === 1, "sockets-based providers do not support batches", "options.batchMaxCount", I), A.batchMaxCount = 1, A.staticNetwork == null && (A.staticNetwork = !0), super(M, A), Fe(this, a, void 0), Fe(this, f, void 0), Fe(this, d, void 0), Ne(this, a, /* @__PURE__ */ new Map()), Ne(this, f, /* @__PURE__ */ new Map()), Ne(this, d, /* @__PURE__ */ new Map());
    }
    // This value is only valid after _start has been called
    /*
    get _network(): Network {
        if (this.#network == null) {
            throw new Error("this shouldn't happen");
        }
        return this.#network.clone();
    }
    */
    _getSubscriber(M) {
      switch (M.type) {
        case "close":
          return new c.UnmanagedSubscriber("close");
        case "block":
          return new O(this);
        case "pending":
          return new N(this);
        case "event":
          return new S(this, M.filter);
        case "orphan":
          if (M.filter.orphan === "drop-log")
            return new c.UnmanagedSubscriber("drop-log");
      }
      return super._getSubscriber(M);
    }
    /**
     *  Register a new subscriber. This is used internalled by Subscribers
     *  and generally is unecessary unless extending capabilities.
     */
    _register(M, I) {
      ae(this, f).set(M, I);
      const A = ae(this, d).get(M);
      if (A) {
        for (const R of A)
          I._handleMessage(R);
        ae(this, d).delete(M);
      }
    }
    async _send(M) {
      (0, p.assertArgument)(!Array.isArray(M), "WebSocket does not support batch send", "payload", M);
      const I = new Promise((A, R) => {
        ae(this, a).set(M.id, { payload: M, resolve: A, reject: R });
      });
      return await this._waitUntilReady(), await this._write(JSON.stringify(M)), [await I];
    }
    // Sub-classes must call this once they are connected
    /*
    	    async _start(): Promise<void> {
    	        if (this.#ready) { return; }
    
    	        for (const { payload } of this.#callbacks.values()) {
    	            await this._write(JSON.stringify(payload));
    	        }
    
    	        this.#ready = (async function() {
    	            await super._start();
    	        })();
    	    }
    	    */
    /**
     *  Sub-classes **must** call this with messages received over their
     *  transport to be processed and dispatched.
     */
    async _processMessage(M) {
      const I = JSON.parse(M);
      if (I && typeof I == "object" && "id" in I) {
        const A = ae(this, a).get(I.id);
        if (A == null) {
          this.emit("error", (0, p.makeError)("received result for unknown id", "UNKNOWN_ERROR", {
            reasonCode: "UNKNOWN_ID",
            result: I
          }));
          return;
        }
        ae(this, a).delete(I.id), A.resolve(I);
      } else if (I && I.method === "eth_subscription") {
        const A = I.params.subscription, R = ae(this, f).get(A);
        if (R)
          R._handleMessage(I.params.result);
        else {
          let L = ae(this, d).get(A);
          L == null && (L = [], ae(this, d).set(A, L)), L.push(I.params.result);
        }
      } else {
        this.emit("error", (0, p.makeError)("received unexpected message", "UNKNOWN_ERROR", {
          reasonCode: "UNEXPECTED_MESSAGE",
          result: I
        }));
        return;
      }
    }
    /**
     *  Sub-classes **must** override this to send %%message%% over their
     *  transport.
     */
    async _write(M) {
      throw new Error("sub-classes must override this");
    }
  }
  return a = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), $n.SocketProvider = j, $n;
}
var Aw;
function eg() {
  var e, t;
  if (Aw)
    return Yl;
  Aw = 1, Object.defineProperty(Yl, "__esModule", { value: !0 }), Yl.WebSocketProvider = void 0;
  const r = gI(), n = Qp();
  class s extends n.SocketProvider {
    constructor(a, f, d) {
      super(f, d), Fe(this, e, void 0), Fe(this, t, void 0), typeof a == "string" ? (Ne(this, e, () => new r.WebSocket(a)), Ne(this, t, ae(this, e).call(this))) : typeof a == "function" ? (Ne(this, e, a), Ne(this, t, a())) : (Ne(this, e, null), Ne(this, t, a)), this.websocket.onopen = async () => {
        try {
          await this._start(), this.resume();
        } catch (c) {
          console.log("failed to start WebsocketProvider", c);
        }
      }, this.websocket.onmessage = (c) => {
        this._processMessage(c.data);
      };
    }
    get websocket() {
      if (ae(this, t) == null)
        throw new Error("websocket closed");
      return ae(this, t);
    }
    async _write(a) {
      this.websocket.send(a);
    }
    async destroy() {
      ae(this, t) != null && (ae(this, t).close(), Ne(this, t, null)), super.destroy();
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), Yl.WebSocketProvider = s, Yl;
}
var Ew;
function E7() {
  if (Ew)
    return Ba;
  Ew = 1, Object.defineProperty(Ba, "__esModule", { value: !0 }), Ba.InfuraProvider = Ba.InfuraWebSocketProvider = void 0;
  const e = vt(), t = _o(), r = ti(), n = Xi(), s = eg(), i = "84842078b09946638c03157f83405213";
  function a(c) {
    switch (c) {
      case "mainnet":
        return "mainnet.infura.io";
      case "goerli":
        return "goerli.infura.io";
      case "sepolia":
        return "sepolia.infura.io";
      case "arbitrum":
        return "arbitrum-mainnet.infura.io";
      case "arbitrum-goerli":
        return "arbitrum-goerli.infura.io";
      case "arbitrum-sepolia":
        return "arbitrum-sepolia.infura.io";
      case "base":
        return "base-mainnet.infura.io";
      case "base-goerlia":
        return "base-goerli.infura.io";
      case "base-sepolia":
        return "base-sepolia.infura.io";
      case "bnb":
        return "bnbsmartchain-mainnet.infura.io";
      case "bnbt":
        return "bnbsmartchain-testnet.infura.io";
      case "linea":
        return "linea-mainnet.infura.io";
      case "linea-goerli":
        return "linea-goerli.infura.io";
      case "linea-sepolia":
        return "linea-sepolia.infura.io";
      case "matic":
        return "polygon-mainnet.infura.io";
      case "matic-amoy":
        return "polygon-amoy.infura.io";
      case "matic-mumbai":
        return "polygon-mumbai.infura.io";
      case "optimism":
        return "optimism-mainnet.infura.io";
      case "optimism-goerli":
        return "optimism-goerli.infura.io";
      case "optimism-sepolia":
        return "optimism-sepolia.infura.io";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", c);
  }
  class f extends s.WebSocketProvider {
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */
    constructor(p, g) {
      const v = new d(p, g), O = v._getConnection();
      (0, e.assert)(!O.credentials, "INFURA WebSocket project secrets unsupported", "UNSUPPORTED_OPERATION", { operation: "InfuraProvider.getWebSocketProvider()" });
      const N = O.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
      super(N, v._network), Se(this, "projectId"), Se(this, "projectSecret"), (0, e.defineProperties)(this, {
        projectId: v.projectId,
        projectSecret: v.projectSecret
      });
    }
    isCommunityResource() {
      return this.projectId === i;
    }
  }
  Ba.InfuraWebSocketProvider = f;
  class d extends n.JsonRpcProvider {
    /**
     *  Creates a new **InfuraProvider**.
     */
    constructor(p, g, v) {
      p == null && (p = "mainnet");
      const O = r.Network.from(p);
      g == null && (g = i), v == null && (v = null);
      const N = d.getRequest(O, g, v);
      super(N, O, { staticNetwork: O }), Se(this, "projectId"), Se(this, "projectSecret"), (0, e.defineProperties)(this, { projectId: g, projectSecret: v });
    }
    _getProvider(p) {
      try {
        return new d(p, this.projectId, this.projectSecret);
      } catch {
      }
      return super._getProvider(p);
    }
    isCommunityResource() {
      return this.projectId === i;
    }
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */
    static getWebSocketProvider(p, g) {
      return new f(p, g);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%projectId%% and %%projectSecret%%.
     */
    static getRequest(p, g, v) {
      g == null && (g = i), v == null && (v = null);
      const O = new e.FetchRequest(`https://${a(p.name)}/v3/${g}`);
      return O.allowGzip = !0, v && O.setCredentials("", v), g === i && (O.retryFunc = async (N, S, j) => ((0, t.showThrottleMessage)("InfuraProvider"), !0)), O;
    }
  }
  return Ba.InfuraProvider = d, Ba;
}
var e0 = {}, Pw;
function P7() {
  if (Pw)
    return e0;
  Pw = 1, Object.defineProperty(e0, "__esModule", { value: !0 }), e0.QuickNodeProvider = void 0;
  const e = vt(), t = _o(), r = ti(), n = Xi(), s = "919b412a057b5e9c9b6dce193c5a60242d6efadb";
  function i(f) {
    switch (f) {
      case "mainnet":
        return "ethers.quiknode.pro";
      case "goerli":
        return "ethers.ethereum-goerli.quiknode.pro";
      case "sepolia":
        return "ethers.ethereum-sepolia.quiknode.pro";
      case "holesky":
        return "ethers.ethereum-holesky.quiknode.pro";
      case "arbitrum":
        return "ethers.arbitrum-mainnet.quiknode.pro";
      case "arbitrum-goerli":
        return "ethers.arbitrum-goerli.quiknode.pro";
      case "arbitrum-sepolia":
        return "ethers.arbitrum-sepolia.quiknode.pro";
      case "base":
        return "ethers.base-mainnet.quiknode.pro";
      case "base-goerli":
        return "ethers.base-goerli.quiknode.pro";
      case "base-spolia":
        return "ethers.base-sepolia.quiknode.pro";
      case "bnb":
        return "ethers.bsc.quiknode.pro";
      case "bnbt":
        return "ethers.bsc-testnet.quiknode.pro";
      case "matic":
        return "ethers.matic.quiknode.pro";
      case "matic-mumbai":
        return "ethers.matic-testnet.quiknode.pro";
      case "optimism":
        return "ethers.optimism.quiknode.pro";
      case "optimism-goerli":
        return "ethers.optimism-goerli.quiknode.pro";
      case "optimism-sepolia":
        return "ethers.optimism-sepolia.quiknode.pro";
      case "xdai":
        return "ethers.xdai.quiknode.pro";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Creates a new **QuickNodeProvider**.
     */
    constructor(d, c) {
      d == null && (d = "mainnet");
      const p = r.Network.from(d);
      c == null && (c = s);
      const g = a.getRequest(p, c);
      super(g, p, { staticNetwork: p }), Se(this, "token"), (0, e.defineProperties)(this, { token: c });
    }
    _getProvider(d) {
      try {
        return new a(d, this.token);
      } catch {
      }
      return super._getProvider(d);
    }
    isCommunityResource() {
      return this.token === s;
    }
    /**
     *  Returns a new request prepared for %%network%% and the
     *  %%token%%.
     */
    static getRequest(d, c) {
      c == null && (c = s);
      const p = new e.FetchRequest(`https://${i(d.name)}/${c}`);
      return p.allowGzip = !0, c === s && (p.retryFunc = async (g, v, O) => ((0, t.showThrottleMessage)("QuickNodeProvider"), !0)), p;
    }
  }
  return e0.QuickNodeProvider = a, e0;
}
var t0 = {}, Ow;
function O7() {
  var e, t, r, n, s, i, a, f, d, c, p, g, v;
  if (Ow)
    return t0;
  Ow = 1, Object.defineProperty(t0, "__esModule", { value: !0 }), t0.FallbackProvider = void 0;
  const O = vt(), N = Od(), S = ti(), j = BigInt("1"), B = BigInt("2");
  function M(y) {
    for (let E = y.length - 1; E > 0; E--) {
      const P = Math.floor(Math.random() * (E + 1)), w = y[E];
      y[E] = y[P], y[P] = w;
    }
  }
  function I(y) {
    return new Promise((E) => {
      setTimeout(E, y);
    });
  }
  function A() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  function R(y) {
    return JSON.stringify(y, (E, P) => typeof P == "bigint" ? { type: "bigint", value: P.toString() } : P);
  }
  const L = { stallTimeout: 400, priority: 1, weight: 1 }, K = {
    blockNumber: -2,
    requests: 0,
    lateResponses: 0,
    errorResponses: 0,
    outOfSync: -1,
    unsupportedEvents: 0,
    rollingDuration: 0,
    score: 0,
    _network: null,
    _updateNumber: null,
    _totalTime: 0,
    _lastFatalError: null,
    _lastFatalErrorTimestamp: 0
  };
  async function $(y, E) {
    for (; (y.blockNumber < 0 || y.blockNumber < E) && (y._updateNumber || (y._updateNumber = (async () => {
      try {
        const P = await y.provider.getBlockNumber();
        P > y.blockNumber && (y.blockNumber = P);
      } catch (P) {
        y.blockNumber = -2, y._lastFatalError = P, y._lastFatalErrorTimestamp = A();
      }
      y._updateNumber = null;
    })()), await y._updateNumber, y.outOfSync++, !y._lastFatalError); )
      ;
  }
  function k(y) {
    if (y == null)
      return "null";
    if (Array.isArray(y))
      return "[" + y.map(k).join(",") + "]";
    if (typeof y == "object" && typeof y.toJSON == "function")
      return k(y.toJSON());
    switch (typeof y) {
      case "boolean":
      case "symbol":
        return y.toString();
      case "bigint":
      case "number":
        return BigInt(y).toString();
      case "string":
        return JSON.stringify(y);
      case "object": {
        const E = Object.keys(y);
        return E.sort(), "{" + E.map((P) => `${JSON.stringify(P)}:${k(y[P])}`).join(",") + "}";
      }
    }
    throw console.log("Could not serialize", y), new Error("Hmm...");
  }
  function V(y) {
    if ("error" in y) {
      const P = y.error;
      return { tag: k(P), value: P };
    }
    const E = y.result;
    return { tag: k(E), value: E };
  }
  function C(y, E) {
    const P = /* @__PURE__ */ new Map();
    for (const { value: m, tag: l, weight: b } of E) {
      const W = P.get(l) || { value: m, weight: 0 };
      W.weight += b, P.set(l, W);
    }
    let w = null;
    for (const m of P.values())
      m.weight >= y && (!w || m.weight > w.weight) && (w = m);
    if (w)
      return w.value;
  }
  function D(y, E) {
    let P = 0;
    const w = /* @__PURE__ */ new Map();
    let m = null;
    const l = [];
    for (const { value: W, tag: X, weight: G } of E)
      if (W instanceof Error) {
        const re = w.get(X) || { value: W, weight: 0 };
        re.weight += G, w.set(X, re), (m == null || re.weight > m.weight) && (m = re);
      } else
        l.push(BigInt(W)), P += G;
    if (P < y)
      return m && m.weight >= y ? m.value : void 0;
    l.sort((W, X) => W < X ? -1 : X > W ? 1 : 0);
    const b = Math.floor(l.length / 2);
    return l.length % 2 ? l[b] : (l[b - 1] + l[b] + j) / B;
  }
  function o(y, E) {
    const P = C(y, E);
    if (P !== void 0)
      return P;
    for (const w of E)
      if (w.value)
        return w.value;
  }
  function u(y, E) {
    if (y === 1)
      return (0, O.getNumber)(D(y, E), "%internal");
    const P = /* @__PURE__ */ new Map(), w = (b, W) => {
      const X = P.get(b) || { result: b, weight: 0 };
      X.weight += W, P.set(b, X);
    };
    for (const { weight: b, value: W } of E) {
      const X = (0, O.getNumber)(W);
      w(X - 1, b), w(X, b), w(X + 1, b);
    }
    let m = 0, l;
    for (const { weight: b, result: W } of P.values())
      b >= y && (b > m || l != null && b === m && W > l) && (m = b, l = W);
    return l;
  }
  class h extends N.AbstractProvider {
    /**
     *  Creates a new **FallbackProvider** with %%providers%% connected to
     *  %%network%%.
     *
     *  If a [[Provider]] is included in %%providers%%, defaults are used
     *  for the configuration.
     */
    constructor(E, P, w) {
      super(P, w), Fe(this, n), Fe(this, i), Fe(this, f), Fe(this, c), Fe(this, g), Se(this, "quorum"), Se(this, "eventQuorum"), Se(this, "eventWorkers"), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Ne(this, e, E.map((m) => m instanceof N.AbstractProvider ? Object.assign({ provider: m }, L, K) : Object.assign({}, L, m, K))), Ne(this, t, -2), Ne(this, r, null), w && w.quorum != null ? this.quorum = w.quorum : this.quorum = Math.ceil(ae(this, e).reduce((m, l) => (m += l.weight, m), 0) / 2), this.eventQuorum = 1, this.eventWorkers = 1, (0, O.assertArgument)(this.quorum <= ae(this, e).reduce((m, l) => m + l.weight, 0), "quorum exceed provider weight", "quorum", this.quorum);
    }
    get providerConfigs() {
      return ae(this, e).map((E) => {
        const P = Object.assign({}, E);
        for (const w in P)
          w[0] === "_" && delete P[w];
        return P;
      });
    }
    async _detectNetwork() {
      return S.Network.from((0, O.getBigInt)(await this._perform({ method: "chainId" })));
    }
    // @TODO: Add support to select providers to be the event subscriber
    //_getSubscriber(sub: Subscription): Subscriber {
    //    throw new Error("@TODO");
    //}
    /**
     *  Transforms a %%req%% into the correct method call on %%provider%%.
     */
    async _translatePerform(E, P) {
      switch (P.method) {
        case "broadcastTransaction":
          return await E.broadcastTransaction(P.signedTransaction);
        case "call":
          return await E.call(Object.assign({}, P.transaction, { blockTag: P.blockTag }));
        case "chainId":
          return (await E.getNetwork()).chainId;
        case "estimateGas":
          return await E.estimateGas(P.transaction);
        case "getBalance":
          return await E.getBalance(P.address, P.blockTag);
        case "getBlock": {
          const w = "blockHash" in P ? P.blockHash : P.blockTag;
          return await E.getBlock(w, P.includeTransactions);
        }
        case "getBlockNumber":
          return await E.getBlockNumber();
        case "getCode":
          return await E.getCode(P.address, P.blockTag);
        case "getGasPrice":
          return (await E.getFeeData()).gasPrice;
        case "getPriorityFee":
          return (await E.getFeeData()).maxPriorityFeePerGas;
        case "getLogs":
          return await E.getLogs(P.filter);
        case "getStorage":
          return await E.getStorage(P.address, P.position, P.blockTag);
        case "getTransaction":
          return await E.getTransaction(P.hash);
        case "getTransactionCount":
          return await E.getTransactionCount(P.address, P.blockTag);
        case "getTransactionReceipt":
          return await E.getTransactionReceipt(P.hash);
        case "getTransactionResult":
          return await E.getTransactionResult(P.hash);
      }
    }
    async _perform(E) {
      if (E.method === "broadcastTransaction") {
        const l = ae(this, e).map((X) => null), b = ae(this, e).map(async ({ provider: X, weight: G }, re) => {
          try {
            const ce = await X._perform(E);
            l[re] = Object.assign(V({ result: ce }), { weight: G });
          } catch (ce) {
            l[re] = Object.assign(V({ error: ce }), { weight: G });
          }
        });
        for (; ; ) {
          const X = l.filter((ce) => ce != null);
          for (const { value: ce } of X)
            if (!(ce instanceof Error))
              return ce;
          const G = C(this.quorum, l.filter((ce) => ce != null));
          if ((0, O.isError)(G, "INSUFFICIENT_FUNDS"))
            throw G;
          const re = b.filter((ce, pe) => l[pe] == null);
          if (re.length === 0)
            break;
          await Promise.race(re);
        }
        const W = o(this.quorum, l);
        if ((0, O.assert)(W !== void 0, "problem multi-broadcasting", "SERVER_ERROR", {
          request: "%sub-requests",
          info: { request: E, results: l.map(R) }
        }), W instanceof Error)
          throw W;
        return W;
      }
      await qe(this, f, d).call(this);
      const P = /* @__PURE__ */ new Set();
      let w = 0;
      for (; ; ) {
        const l = qe(this, i, a).call(this, P, E);
        if (l == null || (w += l.config.weight, w >= this.quorum))
          break;
      }
      const m = await qe(this, g, v).call(this, P, E);
      for (const l of P)
        l.perform && l.result == null && l.config.lateResponses++;
      return m;
    }
    async destroy() {
      for (const { provider: E } of ae(this, e))
        E.destroy();
      super.destroy();
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakSet(), s = function(y) {
    const E = Array.from(y).map((w) => w.config), P = ae(this, e).slice();
    M(P), P.sort((w, m) => w.priority - m.priority);
    for (const w of P)
      if (!w._lastFatalError && E.indexOf(w) === -1)
        return w;
    return null;
  }, i = /* @__PURE__ */ new WeakSet(), a = function(y, E) {
    const P = qe(this, n, s).call(this, y);
    if (P == null)
      return null;
    const w = {
      config: P,
      result: null,
      didBump: !1,
      perform: null,
      staller: null
    }, m = A();
    return w.perform = (async () => {
      try {
        P.requests++;
        const b = await this._translatePerform(P.provider, E);
        w.result = { result: b };
      } catch (b) {
        P.errorResponses++, w.result = { error: b };
      }
      const l = A() - m;
      P._totalTime += l, P.rollingDuration = 0.95 * P.rollingDuration + 0.05 * l, w.perform = null;
    })(), w.staller = (async () => {
      await I(P.stallTimeout), w.staller = null;
    })(), y.add(w), w;
  }, f = /* @__PURE__ */ new WeakSet(), d = async function() {
    let y = ae(this, r);
    if (!y) {
      const E = [];
      ae(this, e).forEach((P) => {
        E.push((async () => {
          await $(P, 0), P._lastFatalError || (P._network = await P.provider.getNetwork());
        })());
      }), Ne(this, r, y = (async () => {
        await Promise.all(E);
        let P = null;
        for (const w of ae(this, e)) {
          if (w._lastFatalError)
            continue;
          const m = w._network;
          P == null ? P = m.chainId : m.chainId !== P && (0, O.assert)(!1, "cannot mix providers on different networks", "UNSUPPORTED_OPERATION", {
            operation: "new FallbackProvider"
          });
        }
      })());
    }
    await y;
  }, c = /* @__PURE__ */ new WeakSet(), p = async function(y, E) {
    const P = [];
    for (const w of y)
      if (w.result != null) {
        const { tag: m, value: l } = V(w.result);
        P.push({ tag: m, value: l, weight: w.config.weight });
      }
    if (!(P.reduce((w, m) => w + m.weight, 0) < this.quorum)) {
      switch (E.method) {
        case "getBlockNumber": {
          ae(this, t) === -2 && Ne(this, t, Math.ceil((0, O.getNumber)(D(this.quorum, ae(this, e).filter((m) => !m._lastFatalError).map((m) => ({
            value: m.blockNumber,
            tag: (0, O.getNumber)(m.blockNumber).toString(),
            weight: m.weight
          }))))));
          const w = u(this.quorum, P);
          return w === void 0 ? void 0 : (w > ae(this, t) && Ne(this, t, w), ae(this, t));
        }
        case "getGasPrice":
        case "getPriorityFee":
        case "estimateGas":
          return D(this.quorum, P);
        case "getBlock":
          return "blockTag" in E && E.blockTag === "pending" ? o(this.quorum, P) : C(this.quorum, P);
        case "call":
        case "chainId":
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorage":
        case "getTransaction":
        case "getTransactionReceipt":
        case "getLogs":
          return C(this.quorum, P);
        case "broadcastTransaction":
          return o(this.quorum, P);
      }
      (0, O.assert)(!1, "unsupported method", "UNSUPPORTED_OPERATION", {
        operation: `_perform(${R(E.method)})`
      });
    }
  }, g = /* @__PURE__ */ new WeakSet(), v = async function(y, E) {
    if (y.size === 0)
      throw new Error("no runners?!");
    const P = [];
    let w = 0;
    for (const l of y) {
      if (l.perform && P.push(l.perform), l.staller) {
        P.push(l.staller);
        continue;
      }
      l.didBump || (l.didBump = !0, w++);
    }
    const m = await qe(this, c, p).call(this, y, E);
    if (m !== void 0) {
      if (m instanceof Error)
        throw m;
      return m;
    }
    for (let l = 0; l < w; l++)
      qe(this, i, a).call(this, y, E);
    return (0, O.assert)(P.length > 0, "quorum not met", "SERVER_ERROR", {
      request: "%sub-requests",
      info: { request: E, results: Array.from(y).map((l) => R(l.result)) }
    }), await Promise.race(P), await qe(this, g, v).call(this, y, E);
  }, t0.FallbackProvider = h, t0;
}
var Nw;
function mI() {
  if (Nw)
    return $l;
  Nw = 1, Object.defineProperty($l, "__esModule", { value: !0 }), $l.getDefaultProvider = void 0;
  const e = vt(), t = y7(), r = b7(), n = w7(), s = v7(), i = A7(), a = E7(), f = P7(), d = O7(), c = Xi(), p = ti(), g = eg();
  function v(S) {
    return S && typeof S.send == "function" && typeof S.close == "function";
  }
  const O = "goerli kovan sepolia classicKotti optimism-goerli arbitrum-goerli matic-mumbai bnbt".split(" ");
  function N(S, j) {
    j == null && (j = {});
    const B = (R) => j[R] === "-" ? !1 : typeof j.exclusive == "string" ? R === j.exclusive : Array.isArray(j.exclusive) ? j.exclusive.indexOf(R) !== -1 : !0;
    if (typeof S == "string" && S.match(/^https?:/))
      return new c.JsonRpcProvider(S);
    if (typeof S == "string" && S.match(/^wss?:/) || v(S))
      return new g.WebSocketProvider(S);
    let M = null;
    try {
      M = p.Network.from(S);
    } catch {
    }
    const I = [];
    if (B("publicPolygon") && M && (M.name === "matic" ? I.push(new c.JsonRpcProvider("https://polygon-rpc.com/", M, { staticNetwork: M })) : M.name === "matic-amoy" && I.push(new c.JsonRpcProvider("https://rpc-amoy.polygon.technology/", M, { staticNetwork: M }))), B("alchemy"))
      try {
        I.push(new r.AlchemyProvider(S, j.alchemy));
      } catch {
      }
    if (B("ankr") && j.ankr != null)
      try {
        I.push(new t.AnkrProvider(S, j.ankr));
      } catch {
      }
    if (B("chainstack"))
      try {
        I.push(new n.ChainstackProvider(S, j.chainstack));
      } catch {
      }
    if (B("cloudflare"))
      try {
        I.push(new s.CloudflareProvider(S));
      } catch {
      }
    if (B("etherscan"))
      try {
        I.push(new i.EtherscanProvider(S, j.etherscan));
      } catch {
      }
    if (B("infura"))
      try {
        let R = j.infura, L;
        typeof R == "object" && (L = R.projectSecret, R = R.projectId), I.push(new a.InfuraProvider(S, R, L));
      } catch {
      }
    if (B("quicknode"))
      try {
        let R = j.quicknode;
        I.push(new f.QuickNodeProvider(S, R));
      } catch {
      }
    if ((0, e.assert)(I.length, "unsupported default network", "UNSUPPORTED_OPERATION", {
      operation: "getDefaultProvider"
    }), I.length === 1)
      return I[0];
    let A = Math.floor(I.length / 2);
    return A > 2 && (A = 2), M && O.indexOf(M.name) !== -1 && (A = 1), j && j.quorum && (A = j.quorum), new d.FallbackProvider(I, void 0, { quorum: A });
  }
  return $l.getDefaultProvider = N, $l;
}
var r0 = {}, xw;
function yI() {
  var e, t;
  if (xw)
    return r0;
  xw = 1, Object.defineProperty(r0, "__esModule", { value: !0 }), r0.NonceManager = void 0;
  const r = vt(), n = X1(), s = class N7 extends n.AbstractSigner {
    /**
     *  Creates a new **NonceManager** to manage %%signer%%.
     */
    constructor(f) {
      super(f.provider), Se(this, "signer"), Fe(this, e, void 0), Fe(this, t, void 0), (0, r.defineProperties)(this, { signer: f }), Ne(this, e, null), Ne(this, t, 0);
    }
    async getAddress() {
      return this.signer.getAddress();
    }
    connect(f) {
      return new N7(this.signer.connect(f));
    }
    async getNonce(f) {
      if (f === "pending") {
        ae(this, e) == null && Ne(this, e, super.getNonce("pending"));
        const d = ae(this, t);
        return await ae(this, e) + d;
      }
      return super.getNonce(f);
    }
    /**
     *  Manually increment the nonce. This may be useful when managng
     *  offline transactions.
     */
    increment() {
      ed(this, t)._++;
    }
    /**
     *  Resets the nonce, causing the **NonceManager** to reload the current
     *  nonce from the blockchain on the next transaction.
     */
    reset() {
      Ne(this, t, 0), Ne(this, e, null);
    }
    async sendTransaction(f) {
      const d = this.getNonce("pending");
      return this.increment(), f = await this.signer.populateTransaction(f), f.nonce = await d, await this.signer.sendTransaction(f);
    }
    signTransaction(f) {
      return this.signer.signTransaction(f);
    }
    signMessage(f) {
      return this.signer.signMessage(f);
    }
    signTypedData(f, d, c) {
      return this.signer.signTypedData(f, d, c);
    }
  };
  e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  let i = s;
  return r0.NonceManager = i, r0;
}
var n0 = {}, Tw;
function bI() {
  var e;
  if (Tw)
    return n0;
  Tw = 1, Object.defineProperty(n0, "__esModule", { value: !0 }), n0.BrowserProvider = void 0;
  const t = vt(), r = Xi();
  class n extends r.JsonRpcApiPollingProvider {
    /**
     *  Connnect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */
    constructor(i, a) {
      (0, t.assertArgument)(i && i.request, "invalid EIP-1193 provider", "ethereum", i), super(a, { batchMaxCount: 1 }), Fe(this, e, void 0), Ne(this, e, async (f, d) => {
        const c = { method: f, params: d };
        this.emit("debug", { action: "sendEip1193Request", payload: c });
        try {
          const p = await i.request(c);
          return this.emit("debug", { action: "receiveEip1193Result", result: p }), p;
        } catch (p) {
          const g = new Error(p.message);
          throw g.code = p.code, g.data = p.data, g.payload = c, this.emit("debug", { action: "receiveEip1193Error", error: g }), g;
        }
      });
    }
    async send(i, a) {
      return await this._start(), await super.send(i, a);
    }
    async _send(i) {
      (0, t.assertArgument)(!Array.isArray(i), "EIP-1193 does not support batch request", "payload", i);
      try {
        const a = await ae(this, e).call(this, i.method, i.params || []);
        return [{ id: i.id, result: a }];
      } catch (a) {
        return [{
          id: i.id,
          error: { code: a.code, data: a.data, message: a.message }
        }];
      }
    }
    getRpcError(i, a) {
      switch (a = JSON.parse(JSON.stringify(a)), a.error.code || -1) {
        case 4001:
          a.error.message = `ethers-user-denied: ${a.error.message}`;
          break;
        case 4200:
          a.error.message = `ethers-unsupported: ${a.error.message}`;
          break;
      }
      return super.getRpcError(i, a);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */
    async hasSigner(i) {
      i == null && (i = 0);
      const a = await this.send("eth_accounts", []);
      return typeof i == "number" ? a.length > i : (i = i.toLowerCase(), a.filter((f) => f.toLowerCase() === i).length !== 0);
    }
    async getSigner(i) {
      if (i == null && (i = 0), !await this.hasSigner(i))
        try {
          await ae(this, e).call(this, "eth_requestAccounts", []);
        } catch (a) {
          const f = a.payload;
          throw this.getRpcError(f, { id: f.id, error: a });
        }
      return await super.getSigner(i);
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), n0.BrowserProvider = n, n0;
}
var i0 = {}, kw;
function wI() {
  if (kw)
    return i0;
  kw = 1, Object.defineProperty(i0, "__esModule", { value: !0 }), i0.PocketProvider = void 0;
  const e = vt(), t = _o(), r = ti(), n = Xi(), s = "62e1ad51b37b8e00394bda3b";
  function i(f) {
    switch (f) {
      case "mainnet":
        return "eth-mainnet.gateway.pokt.network";
      case "goerli":
        return "eth-goerli.gateway.pokt.network";
      case "matic":
        return "poly-mainnet.gateway.pokt.network";
      case "matic-mumbai":
        return "polygon-mumbai-rpc.gateway.pokt.network";
    }
    (0, e.assertArgument)(!1, "unsupported network", "network", f);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Create a new **PocketProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */
    constructor(d, c, p) {
      d == null && (d = "mainnet");
      const g = r.Network.from(d);
      c == null && (c = s), p == null && (p = null);
      const v = { staticNetwork: g }, O = a.getRequest(g, c, p);
      super(O, g, v), Se(this, "applicationId"), Se(this, "applicationSecret"), (0, e.defineProperties)(this, { applicationId: c, applicationSecret: p });
    }
    _getProvider(d) {
      try {
        return new a(d, this.applicationId, this.applicationSecret);
      } catch {
      }
      return super._getProvider(d);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%applicationId%%.
     */
    static getRequest(d, c, p) {
      c == null && (c = s);
      const g = new e.FetchRequest(`https://${i(d.name)}/v1/lb/${c}`);
      return g.allowGzip = !0, p && g.setCredentials("", p), c === s && (g.retryFunc = async (v, O, N) => ((0, t.showThrottleMessage)("PocketProvider"), !0)), g;
    }
    isCommunityResource() {
      return this.applicationId === s;
    }
  }
  return i0.PocketProvider = a, i0;
}
var s0 = {}, Sw;
function vI() {
  if (Sw)
    return s0;
  Sw = 1, Object.defineProperty(s0, "__esModule", { value: !0 }), s0.IpcSocketProvider = void 0;
  const e = void 0;
  return s0.IpcSocketProvider = e, s0;
}
var Mw;
function tg() {
  return Mw || (Mw = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SocketEventSubscriber = e.SocketPendingSubscriber = e.SocketBlockSubscriber = e.SocketSubscriber = e.WebSocketProvider = e.SocketProvider = e.IpcSocketProvider = e.QuickNodeProvider = e.PocketProvider = e.InfuraWebSocketProvider = e.InfuraProvider = e.EtherscanPlugin = e.EtherscanProvider = e.ChainstackProvider = e.CloudflareProvider = e.AnkrProvider = e.AlchemyProvider = e.BrowserProvider = e.JsonRpcSigner = e.JsonRpcProvider = e.JsonRpcApiProvider = e.FallbackProvider = e.copyRequest = e.TransactionResponse = e.TransactionReceipt = e.Log = e.FeeData = e.Block = e.FetchUrlFeeDataNetworkPlugin = e.FeeDataNetworkPlugin = e.EnsPlugin = e.GasCostPlugin = e.NetworkPlugin = e.NonceManager = e.Network = e.MulticoinProviderPlugin = e.EnsResolver = e.getDefaultProvider = e.showThrottleMessage = e.VoidSigner = e.AbstractSigner = e.UnmanagedSubscriber = e.AbstractProvider = void 0;
    var t = Od();
    Object.defineProperty(e, "AbstractProvider", { enumerable: !0, get: function() {
      return t.AbstractProvider;
    } }), Object.defineProperty(e, "UnmanagedSubscriber", { enumerable: !0, get: function() {
      return t.UnmanagedSubscriber;
    } });
    var r = X1();
    Object.defineProperty(e, "AbstractSigner", { enumerable: !0, get: function() {
      return r.AbstractSigner;
    } }), Object.defineProperty(e, "VoidSigner", { enumerable: !0, get: function() {
      return r.VoidSigner;
    } });
    var n = _o();
    Object.defineProperty(e, "showThrottleMessage", { enumerable: !0, get: function() {
      return n.showThrottleMessage;
    } });
    var s = mI();
    Object.defineProperty(e, "getDefaultProvider", { enumerable: !0, get: function() {
      return s.getDefaultProvider;
    } });
    var i = p7();
    Object.defineProperty(e, "EnsResolver", { enumerable: !0, get: function() {
      return i.EnsResolver;
    } }), Object.defineProperty(e, "MulticoinProviderPlugin", { enumerable: !0, get: function() {
      return i.MulticoinProviderPlugin;
    } });
    var a = ti();
    Object.defineProperty(e, "Network", { enumerable: !0, get: function() {
      return a.Network;
    } });
    var f = yI();
    Object.defineProperty(e, "NonceManager", { enumerable: !0, get: function() {
      return f.NonceManager;
    } });
    var d = Z1();
    Object.defineProperty(e, "NetworkPlugin", { enumerable: !0, get: function() {
      return d.NetworkPlugin;
    } }), Object.defineProperty(e, "GasCostPlugin", { enumerable: !0, get: function() {
      return d.GasCostPlugin;
    } }), Object.defineProperty(e, "EnsPlugin", { enumerable: !0, get: function() {
      return d.EnsPlugin;
    } }), Object.defineProperty(e, "FeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return d.FeeDataNetworkPlugin;
    } }), Object.defineProperty(e, "FetchUrlFeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return d.FetchUrlFeeDataNetworkPlugin;
    } });
    var c = Pd();
    Object.defineProperty(e, "Block", { enumerable: !0, get: function() {
      return c.Block;
    } }), Object.defineProperty(e, "FeeData", { enumerable: !0, get: function() {
      return c.FeeData;
    } }), Object.defineProperty(e, "Log", { enumerable: !0, get: function() {
      return c.Log;
    } }), Object.defineProperty(e, "TransactionReceipt", { enumerable: !0, get: function() {
      return c.TransactionReceipt;
    } }), Object.defineProperty(e, "TransactionResponse", { enumerable: !0, get: function() {
      return c.TransactionResponse;
    } }), Object.defineProperty(e, "copyRequest", { enumerable: !0, get: function() {
      return c.copyRequest;
    } });
    var p = O7();
    Object.defineProperty(e, "FallbackProvider", { enumerable: !0, get: function() {
      return p.FallbackProvider;
    } });
    var g = Xi();
    Object.defineProperty(e, "JsonRpcApiProvider", { enumerable: !0, get: function() {
      return g.JsonRpcApiProvider;
    } }), Object.defineProperty(e, "JsonRpcProvider", { enumerable: !0, get: function() {
      return g.JsonRpcProvider;
    } }), Object.defineProperty(e, "JsonRpcSigner", { enumerable: !0, get: function() {
      return g.JsonRpcSigner;
    } });
    var v = bI();
    Object.defineProperty(e, "BrowserProvider", { enumerable: !0, get: function() {
      return v.BrowserProvider;
    } });
    var O = b7();
    Object.defineProperty(e, "AlchemyProvider", { enumerable: !0, get: function() {
      return O.AlchemyProvider;
    } });
    var N = y7();
    Object.defineProperty(e, "AnkrProvider", { enumerable: !0, get: function() {
      return N.AnkrProvider;
    } });
    var S = v7();
    Object.defineProperty(e, "CloudflareProvider", { enumerable: !0, get: function() {
      return S.CloudflareProvider;
    } });
    var j = w7();
    Object.defineProperty(e, "ChainstackProvider", { enumerable: !0, get: function() {
      return j.ChainstackProvider;
    } });
    var B = A7();
    Object.defineProperty(e, "EtherscanProvider", { enumerable: !0, get: function() {
      return B.EtherscanProvider;
    } }), Object.defineProperty(e, "EtherscanPlugin", { enumerable: !0, get: function() {
      return B.EtherscanPlugin;
    } });
    var M = E7();
    Object.defineProperty(e, "InfuraProvider", { enumerable: !0, get: function() {
      return M.InfuraProvider;
    } }), Object.defineProperty(e, "InfuraWebSocketProvider", { enumerable: !0, get: function() {
      return M.InfuraWebSocketProvider;
    } });
    var I = wI();
    Object.defineProperty(e, "PocketProvider", { enumerable: !0, get: function() {
      return I.PocketProvider;
    } });
    var A = P7();
    Object.defineProperty(e, "QuickNodeProvider", { enumerable: !0, get: function() {
      return A.QuickNodeProvider;
    } });
    const R = vI();
    Object.defineProperty(e, "IpcSocketProvider", { enumerable: !0, get: function() {
      return R.IpcSocketProvider;
    } });
    var L = Qp();
    Object.defineProperty(e, "SocketProvider", { enumerable: !0, get: function() {
      return L.SocketProvider;
    } });
    var K = eg();
    Object.defineProperty(e, "WebSocketProvider", { enumerable: !0, get: function() {
      return K.WebSocketProvider;
    } });
    var $ = Qp();
    Object.defineProperty(e, "SocketSubscriber", { enumerable: !0, get: function() {
      return $.SocketSubscriber;
    } }), Object.defineProperty(e, "SocketBlockSubscriber", { enumerable: !0, get: function() {
      return $.SocketBlockSubscriber;
    } }), Object.defineProperty(e, "SocketPendingSubscriber", { enumerable: !0, get: function() {
      return $.SocketPendingSubscriber;
    } }), Object.defineProperty(e, "SocketEventSubscriber", { enumerable: !0, get: function() {
      return $.SocketEventSubscriber;
    } });
  }(nw)), nw;
}
var Iw = {}, o0 = {}, Rw;
function rg() {
  var e;
  if (Rw)
    return o0;
  Rw = 1, Object.defineProperty(o0, "__esModule", { value: !0 }), o0.BaseWallet = void 0;
  const t = Xr(), r = so(), n = tg(), s = ei(), i = vt(), a = class x7 extends n.AbstractSigner {
    /**
     *  Creates a new BaseWallet for %%privateKey%%, optionally
     *  connected to %%provider%%.
     *
     *  If %%provider%% is not specified, only offline methods can
     *  be used.
     */
    constructor(c, p) {
      super(p), Se(this, "address"), Fe(this, e, void 0), (0, i.assertArgument)(c && typeof c.sign == "function", "invalid private key", "privateKey", "[ REDACTED ]"), Ne(this, e, c);
      const g = (0, s.computeAddress)(this.signingKey.publicKey);
      (0, i.defineProperties)(this, { address: g });
    }
    // Store private values behind getters to reduce visibility
    // in console.log
    /**
     *  The [[SigningKey]] used for signing payloads.
     */
    get signingKey() {
      return ae(this, e);
    }
    /**
     *  The private key for this wallet.
     */
    get privateKey() {
      return this.signingKey.privateKey;
    }
    async getAddress() {
      return this.address;
    }
    connect(c) {
      return new x7(ae(this, e), c);
    }
    async signTransaction(c) {
      const { to: p, from: g } = await (0, i.resolveProperties)({
        to: c.to ? (0, t.resolveAddress)(c.to, this.provider) : void 0,
        from: c.from ? (0, t.resolveAddress)(c.from, this.provider) : void 0
      });
      p != null && (c.to = p), g != null && (c.from = g), c.from != null && ((0, i.assertArgument)((0, t.getAddress)(c.from) === this.address, "transaction from address mismatch", "tx.from", c.from), delete c.from);
      const v = s.Transaction.from(c);
      return v.signature = this.signingKey.sign(v.unsignedHash), v.serialized;
    }
    async signMessage(c) {
      return this.signMessageSync(c);
    }
    // @TODO: Add a secialized signTx and signTyped sync that enforces
    // all parameters are known?
    /**
     *  Returns the signature for %%message%% signed with this wallet.
     */
    signMessageSync(c) {
      return this.signingKey.sign((0, r.hashMessage)(c)).serialized;
    }
    async signTypedData(c, p, g) {
      const v = await r.TypedDataEncoder.resolveNames(c, p, g, async (O) => {
        (0, i.assert)(this.provider != null, "cannot resolve ENS names without a provider", "UNSUPPORTED_OPERATION", {
          operation: "resolveName",
          info: { name: O }
        });
        const N = await this.provider.resolveName(O);
        return (0, i.assert)(N != null, "unconfigured ENS name", "UNCONFIGURED_NAME", {
          value: O
        }), N;
      });
      return this.signingKey.sign(r.TypedDataEncoder.hash(v.domain, p, v.value)).serialized;
    }
  };
  e = /* @__PURE__ */ new WeakMap();
  let f = a;
  return o0.BaseWallet = f, o0;
}
var Cw = {}, a0 = {}, u0 = {}, _a = {}, Bw;
function T7() {
  if (Bw)
    return _a;
  Bw = 1, Object.defineProperty(_a, "__esModule", { value: !0 }), _a.decodeOwl = _a.decode = void 0;
  const e = vt(), t = " !#$%&'()*+,-./<=>?@[]^_`{|}~", r = /^[a-z]*$/i;
  function n(a, f) {
    let d = 97;
    return a.reduce((c, p) => (p === f ? d++ : p.match(r) ? c.push(String.fromCharCode(d) + p) : (d = 97, c.push(p)), c), []);
  }
  function s(a, f) {
    for (let p = t.length - 1; p >= 0; p--)
      a = a.split(t[p]).join(f.substring(2 * p, 2 * p + 2));
    const d = [], c = a.replace(/(:|([0-9])|([A-Z][a-z]*))/g, (p, g, v, O) => {
      if (v)
        for (let N = parseInt(v); N >= 0; N--)
          d.push(";");
      else
        d.push(g.toLowerCase());
      return "";
    });
    if (c)
      throw new Error(`leftovers: ${JSON.stringify(c)}`);
    return n(n(d, ";"), ":");
  }
  _a.decode = s;
  function i(a) {
    return (0, e.assertArgument)(a[0] === "0", "unsupported auwl data", "data", a), s(a.substring(1 + 2 * t.length), a.substring(1, 1 + 2 * t.length));
  }
  return _a.decodeOwl = i, _a;
}
var c0 = {}, _w;
function k7() {
  if (_w)
    return c0;
  _w = 1, Object.defineProperty(c0, "__esModule", { value: !0 }), c0.Wordlist = void 0;
  const e = vt();
  class t {
    /**
     *  Creates a new Wordlist instance.
     *
     *  Sub-classes MUST call this if they provide their own constructor,
     *  passing in the locale string of the language.
     *
     *  Generally there is no need to create instances of a Wordlist,
     *  since each language-specific Wordlist creates an instance and
     *  there is no state kept internally, so they are safe to share.
     */
    constructor(n) {
      Se(this, "locale"), (0, e.defineProperties)(this, { locale: n });
    }
    /**
     *  Sub-classes may override this to provide a language-specific
     *  method for spliting %%phrase%% into individual words.
     *
     *  By default, %%phrase%% is split using any sequences of
     *  white-space as defined by regular expressions (i.e. ``/\s+/``).
     */
    split(n) {
      return n.toLowerCase().split(/\s+/g);
    }
    /**
     *  Sub-classes may override this to provider a language-specific
     *  method for joining %%words%% into a phrase.
     *
     *  By default, %%words%% are joined by a single space.
     */
    join(n) {
      return n.join(" ");
    }
  }
  return c0.Wordlist = t, c0;
}
var Fw;
function ng() {
  var e, t, r, n, s;
  if (Fw)
    return u0;
  Fw = 1, Object.defineProperty(u0, "__esModule", { value: !0 }), u0.WordlistOwl = void 0;
  const i = so(), a = vt(), f = T7(), d = k7();
  class c extends d.Wordlist {
    /**
     *  Creates a new Wordlist for %%locale%% using the OWL %%data%%
     *  and validated against the %%checksum%%.
     */
    constructor(g, v, O) {
      super(g), Fe(this, n), Fe(this, e, void 0), Fe(this, t, void 0), Fe(this, r, void 0), Ne(this, e, v), Ne(this, t, O), Ne(this, r, null);
    }
    /**
     *  The OWL-encoded data.
     */
    get _data() {
      return ae(this, e);
    }
    /**
     *  Decode all the words for the wordlist.
     */
    _decodeWords() {
      return (0, f.decodeOwl)(ae(this, e));
    }
    getWord(g) {
      const v = qe(this, n, s).call(this);
      return (0, a.assertArgument)(g >= 0 && g < v.length, `invalid word index: ${g}`, "index", g), v[g];
    }
    getWordIndex(g) {
      return qe(this, n, s).call(this).indexOf(g);
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakSet(), s = function() {
    if (ae(this, r) == null) {
      const p = this._decodeWords();
      if ((0, i.id)(p.join(`
`) + `
`) !== ae(this, t))
        throw new Error(`BIP39 Wordlist for ${this.locale} FAILED`);
      Ne(this, r, p);
    }
    return ae(this, r);
  }, u0.WordlistOwl = c, u0;
}
var Uw;
function wf() {
  if (Uw)
    return a0;
  Uw = 1, Object.defineProperty(a0, "__esModule", { value: !0 }), a0.LangEn = void 0;
  const e = ng(), t = "0erleonalorenseinceregesticitStanvetearctssi#ch2Athck&tneLl0And#Il.yLeOutO=S|S%b/ra@SurdU'0Ce[Cid|CountCu'Hie=IdOu,-Qui*Ro[TT]T%T*[Tu$0AptDD-tD*[Ju,M.UltV<)Vi)0Rob-0FairF%dRaid0A(EEntRee0Ead0MRRp%tS!_rmBumCoholErtI&LLeyLowMo,O}PhaReadySoT Ways0A>urAz(gOngOuntU'd0Aly,Ch%Ci|G G!GryIm$K!Noun)Nu$O` Sw T&naTiqueXietyY1ArtOlogyPe?P!Pro=Ril1ChCt-EaEnaGueMMedM%MyOundR<+Re,Ri=RowTTefa@Ti,Tw%k0KPe@SaultSetSi,SumeThma0H!>OmTa{T&dT.udeTra@0Ct]D.Gu,NtTh%ToTumn0Era+OcadoOid0AkeA*AyEsomeFulKw?d0Is:ByChel%C#D+GL<)Lc#y~MbooN<aNn RRelyRga(R*lSeS-SketTt!3A^AnAutyCau'ComeEfF%eG(Ha=H(dLie=LowLtN^Nef./TrayTt Twe&Y#d3Cyc!DKeNdOlogyRdR`Tt _{AdeAmeAnketA,EakE[IndOodO[omOu'UeUrUsh_rdAtDyIlMbNeNusOkO,Rd R(gRrowSsTtomUn)XY_{etA(AndA[A=EadEezeI{Id+IefIghtIngIskOccoliOk&OnzeOomO` OwnUsh2Bb!DdyD+tFf$oIldLbLkL!tNd!Nk Rd&Rg R,SS(e[SyTt Y Zz:Bba+B(B!CtusGeKe~LmM aMpNN$N)lNdyNn#NoeNvasNy#Pab!P.$Pta(RRb#RdRgoRpetRryRtSeShS(o/!Su$TT$ogT^Teg%yTt!UghtU'Ut]Ve3Il(gL yM|NsusNturyRe$Rta(_irAlkAmp]An+AosApt Ar+A'AtEapE{Ee'EfErryE,I{&IefIldIm}yOi)Oo'R#-U{!UnkUrn0G?Nnam#Rc!Tiz&TyVil_imApArifyAwAyE<ErkEv I{I|IffImbIn-IpO{OgO'O`OudOwnUbUmpU, Ut^_^A,C#utDeFfeeIlInL!@L%LumnMb(eMeMf%tM-Mm#Mp<yNc tNdu@NfirmNg*[N}@Nsid NtrolNv()OkOlPp PyR$ReRnR*@/Tt#U^UntryUp!Ur'Us(V Yo>_{Ad!AftAmA}AshAt AwlAzyEamEd.EekEwI{etImeIspIt-OpO[Ou^OwdUci$UelUi'Umb!Un^UshYY,$2BeLtu*PPbo?dRiousRr|Rta(R=Sh]/omTe3C!:DMa+MpN)Ng R(gShUght WnY3AlBa>BrisCadeCemb CideCl(eC%a>C*a'ErF&'F(eFyG*eLayLiv M<dMi'Ni$Nti,NyP?tP&dPos.P`PutyRi=ScribeS tSignSkSpair/royTailTe@VelopVi)Vo>3AgramAlAm#dAryCeE'lEtFf G.$Gn.yLemmaNn NosaurRe@RtSag*eScov Sea'ShSmi[S%d Splay/<)V tVideV%)Zzy5Ct%Cum|G~Lph(Ma(Na>NkeyN%OrSeUb!Ve_ftAg#AmaA,-AwEamE[IftIllInkIpI=OpUmY2CkMbNeR(g/T^Ty1Arf1Nam-:G G!RlyRnR`Sily/Sy1HoOlogyOnomy0GeItUca>1F%t0G1GhtTh 2BowD E@r-Eg<tEm|Eph<tEvat%I>Se0B?kBodyBra)Er+Ot]PloyPow Pty0Ab!A@DD![D%'EmyErgyF%)Ga+G(eH<)JoyLi,OughR-hRollSu*T Ti*TryVelope1Isode0U$Uip0AA'OdeOs]R%Upt0CapeSayS&)Ta>0Ern$H-s1Id&)IlOkeOl=1A@Amp!Ce[Ch<+C.eCludeCu'Ecu>Erci'Hau,Hib.I!I,ItOt-P<dPe@Pi*Pla(Po'P*[T&dTra0EEbrow:Br-CeCultyDeIntI`~L'MeMilyMousNNcyNtasyRmSh]TT$Th TigueUltV%.e3Atu*Bru?yD $EEdElMa!N)/iv$T^V W3B Ct]EldGu*LeLmLt N$NdNeNg NishReRmR,Sc$ShTT}[X_gAmeAshAtAv%EeIghtIpOatO{O%Ow UidUshY_mCusGIlLd~owOdOtR)Re,R+tRkRtu}RumRw?dSsil/ UndX_gi!AmeEqu|EshI&dIn+OgOntO,OwnOz&U.2ElNNnyRna)RyTu*:D+tInLaxy~ yMePRa+Rba+Rd&Rl-Rm|SSpTeTh U+Ze3N $NiusN*Nt!Nu(e/u*2O,0AntFtGg!Ng RaffeRlVe_dAn)A*A[IdeImp'ObeOomOryO=OwUe_tDde[LdOdO'RillaSpelSsipV nWn_bA)A(AntApeA[Av.yEatE&IdIefItOc yOupOwUnt_rdE[IdeIltIt?N3M:B.IrLfMm M, NdPpyRb%RdRshR=,TVeWkZ?d3AdAl`ArtAvyD+hogIght~oLmetLpNRo3Dd&Gh~NtPRe/%y5BbyCkeyLdLeLiday~owMeNeyOdPeRnRr%R'Sp.$/TelUrV 5BGeM<Mb!M%Nd*dNgryNtRd!RryRtSb<d3Brid:1EOn0EaEntifyLe2N%e4LLeg$L}[0A+Ita>M&'Mu}Pa@Po'Pro=Pul'0ChCludeComeC*a'DexD-a>Do%Du,ryF<tFl-tF%mHa!H .Iti$Je@JuryMa>N Noc|PutQuiryS<eSe@SideSpi*/$lTa@T e,ToVe,V.eVol=3On0L<dOla>Sue0Em1Ory:CketGu?RZz3AlousAns~yWel9BInKeUr}yY5D+I)MpNg!Ni%Nk/:Ng?oo3EnEpT^upY3CkDD}yNdNgdomSsTT^&TeTt&Wi4EeIfeO{Ow:BBelB%Dd DyKeMpNgua+PtopR+T T(UghUndryVaWWnWsu.Y Zy3Ad AfArnA=Ctu*FtGG$G&dIsu*M#NdNg`NsOp?dSs#Tt Vel3ArB tyBr?yC&'FeFtGhtKeMbM.NkOnQuid/Tt!VeZ?d5AdAnB, C$CkG-NelyNgOpTt yUdUn+VeY$5CkyGga+Mb N?N^Xury3R-s:Ch(eDG-G}tIdIlInJ%KeMm$NNa+Nda>NgoNs]Nu$P!Rb!R^Rg(R(eRketRria+SkSs/ T^T i$ThTrixTt XimumZe3AdowAnAsu*AtCh<-D$DiaLodyLtMb M%yNt]NuRcyR+R.RryShSsa+T$Thod3Dd!DnightLk~]M-NdNimumN%Nu>Rac!Rr%S ySs/akeXXedXtu*5Bi!DelDifyMM|N.%NkeyN, N`OnR$ReRn(gSqu.oTh T]T%Unta(U'VeVie5ChFf(LeLtiplySc!SeumShroomS-/Tu$3Self/ yTh:I=MePk(Rrow/yT]Tu*3ArCkEdGati=G!@I` PhewR=/TTw%kUtr$V WsXt3CeGht5B!I'M(eeOd!Rm$R`SeTab!TeTh(gTi)VelW5C!?Mb R'T:K0EyJe@Li+Scu*S =Ta(Vious0CurE<Tob 0Or1FF Fi)T&2L1Ay0DI=Ymp-0It0CeEI#L(eLy1EnEraIn]Po'T]1An+B.Ch?dD D(?yG<I|Ig($Ph<0Tr-h0H 0Tdo%T TputTside0AlEnEr0NN 0Yg&0/ 0O}:CtDd!GeIrLa)LmNdaNelN-N` P RadeR|RkRrotRtySsT^ThTi|TrolTt nU'VeYm|3A)AnutArAs<tL-<NN$tyNcilOp!Pp Rfe@Rm.Rs#T2O}OtoRa'Ys-$0AnoCn-Ctu*E)GGe#~LotNkO} Pe/olT^Zza_)A}tA,-A>AyEa'Ed+U{UgUn+2EmEtIntL?LeLi)NdNyOlPul?Rt]S.]Ssib!/TatoTt yV tyWd W _@i)Ai'Ed-tEf Epa*Es|EttyEv|I)IdeIm?yIntI%.yIs#Iva>IzeOb!mO)[Odu)Of.OgramOje@Omo>OofOp tyOsp O>@OudOvide2Bl-Dd(g~LpL'Mpk(N^PilPpyR^a'R.yRpo'R'ShTZz!3Ramid:99Al.yAntumArt E,]I{ItIzO>:Bb.Cco#CeCkD?DioIlInI'~yMpN^NdomN+PidReTeTh V&WZ%3AdyAlAs#BelBuildC$lCei=CipeC%dCyc!Du)F!@F%mFu'G]G*tGul?Je@LaxLea'LiefLyMa(Memb M(dMo=Nd NewNtOp&PairPeatPla)P%tQui*ScueSemb!Si,Sour)Sp#'SultTi*T*atTurnUn]Ve$ViewW?d2Y`m0BBb#CeChDeD+F!GhtGidNgOtPp!SkTu$V$V 5AdA,BotBu,CketM<)OfOkieOmSeTa>UghUndU>Y$5Bb DeGLeNNwayR$:DDd!D}[FeIlLadLm#L#LtLu>MeMp!NdTisfyToshiU)Usa+VeY1A!AnA*Att E}HemeHoolI&)I[%sOrp]OutRapRe&RiptRub1AAr^As#AtC#dC*tCt]Cur.yEdEkGm|Le@~M(?Ni%N'Nt&)RiesRvi)Ss]Tt!TupV&_dowAftAllowA*EdEllEriffIeldIftI}IpIv O{OeOotOpOrtOuld O=RimpRugUff!Y0Bl(gCkDeE+GhtGnL|Lk~yLv Mil?Mp!N)NgR&/ Tua>XZe1A>Et^IIllInIrtUll0AbAmEepEnd I)IdeIghtImOg<OtOwUsh0AllArtI!OkeOo`0A{AkeApIffOw0ApCc Ci$CkDaFtL?Ldi LidLut]L=Me#eNgOnRryRtUlUndUpUr)U`0A)A*Ati$AwnEakEci$EedEllEndH eI)Id IkeInIr.L.OilOns%O#OrtOtRayReadR(gY0Ua*UeezeUir*l_b!AdiumAffA+AirsAmpAndArtA>AyEakEelEmEpE*oI{IllIngO{Oma^O}OolOryO=Ra>gyReetRikeR#gRugg!Ud|UffUmb!Y!0Bje@Bm.BwayC)[ChDd&Ff G?G+,ItMm NNnyN'tP PplyP*meReRfa)R+Rpri'RroundR=ySpe@/a(1AllowAmpApArmE?EetIftImIngIt^Ord1MbolMptomRup/em:B!Ck!GIlL|LkNkPeR+tSk/eTtooXi3A^Am~NN<tNnisNtRm/Xt_nkAtEmeEnE%yE*EyIngIsOughtReeRi=RowUmbUnd 0CketDeG LtMb MeNyPRedSsueT!5A,BaccoDayDdl EGe` I!tK&MatoM%rowNeNgueNightOlO`PP-Pp!R^RnadoRtoi'SsT$Uri,W?dW WnY_{AdeAff-Ag-A(Ansf ApAshA=lAyEatEeEndI$IbeI{Igg ImIpOphyOub!U{UeUlyUmpetU,U`Y2BeIt]Mb!NaN}lRkeyRnRt!1El=EntyI)InI,O1PeP-$:5Ly5B*lla0Ab!Awa*C!Cov D DoFairFoldHappyIf%mIqueItIv 'KnownLo{TilUsu$Veil1Da>GradeHoldOnP Set1B<Ge0A+EEdEfulE![U$0Il.y:C<tCuumGueLidL!yL=NNishP%Rious/Ult3H-!L=tNd%Ntu*NueRbRifyRs]RyS'lT <3Ab!Br<tCiousCt%yDeoEw~a+Nta+Ol(Rtu$RusSaS.Su$T$Vid5C$I)IdLc<oLumeTeYa+:GeG#ItLk~LnutNtRfa*RmRri%ShSp/eT VeY3Al`Ap#ArA'lA` BDd(gEk&dIrdLcome/T_!AtEatEelEnE*IpIsp 0DeD`FeLd~NNdowNeNgNkNn Nt ReSdomSeShT}[5LfM<Nd OdOlRdRkRldRryR`_pE{E,!I,I>Ong::Rd3Ar~ow9UUngU`:3BraRo9NeO", r = "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60";
  let n = null;
  class s extends e.WordlistOwl {
    /**
     *  Creates a new instance of the English language Wordlist.
     *
     *  This should be unnecessary most of the time as the exported
     *  [[langEn]] should suffice.
     *
     *  @_ignore:
     */
    constructor() {
      super("en", t, r);
    }
    /**
     *  Returns a singleton instance of a ``LangEn``, creating it
     *  if this is the first time being called.
     */
    static wordlist() {
      return n == null && (n = new s()), n;
    }
  }
  return a0.LangEn = s, a0;
}
var l0 = {}, Dw;
function ig() {
  if (Dw)
    return l0;
  Dw = 1, Object.defineProperty(l0, "__esModule", { value: !0 }), l0.Mnemonic = void 0;
  const e = ln(), t = vt(), r = wf();
  function n(c) {
    return (1 << c) - 1 << 8 - c & 255;
  }
  function s(c) {
    return (1 << c) - 1 & 255;
  }
  function i(c, p) {
    (0, t.assertNormalize)("NFKD"), p == null && (p = r.LangEn.wordlist());
    const g = p.split(c);
    (0, t.assertArgument)(g.length % 3 === 0 && g.length >= 12 && g.length <= 24, "invalid mnemonic length", "mnemonic", "[ REDACTED ]");
    const v = new Uint8Array(Math.ceil(11 * g.length / 8));
    let O = 0;
    for (let M = 0; M < g.length; M++) {
      let I = p.getWordIndex(g[M].normalize("NFKD"));
      (0, t.assertArgument)(I >= 0, `invalid mnemonic word at index ${M}`, "mnemonic", "[ REDACTED ]");
      for (let A = 0; A < 11; A++)
        I & 1 << 10 - A && (v[O >> 3] |= 1 << 7 - O % 8), O++;
    }
    const N = 32 * g.length / 3, S = g.length / 3, j = n(S), B = (0, t.getBytes)((0, e.sha256)(v.slice(0, N / 8)))[0] & j;
    return (0, t.assertArgument)(B === (v[v.length - 1] & j), "invalid mnemonic checksum", "mnemonic", "[ REDACTED ]"), (0, t.hexlify)(v.slice(0, N / 8));
  }
  function a(c, p) {
    (0, t.assertArgument)(c.length % 4 === 0 && c.length >= 16 && c.length <= 32, "invalid entropy size", "entropy", "[ REDACTED ]"), p == null && (p = r.LangEn.wordlist());
    const g = [0];
    let v = 11;
    for (let S = 0; S < c.length; S++)
      v > 8 ? (g[g.length - 1] <<= 8, g[g.length - 1] |= c[S], v -= 8) : (g[g.length - 1] <<= v, g[g.length - 1] |= c[S] >> 8 - v, g.push(c[S] & s(8 - v)), v += 3);
    const O = c.length / 4, N = parseInt((0, e.sha256)(c).substring(2, 4), 16) & n(O);
    return g[g.length - 1] <<= O, g[g.length - 1] |= N >> 8 - O, p.join(g.map((S) => p.getWord(S)));
  }
  const f = {};
  class d {
    /**
     *  @private
     */
    constructor(p, g, v, O, N) {
      Se(this, "phrase"), Se(this, "password"), Se(this, "wordlist"), Se(this, "entropy"), O == null && (O = ""), N == null && (N = r.LangEn.wordlist()), (0, t.assertPrivate)(p, f, "Mnemonic"), (0, t.defineProperties)(this, { phrase: v, password: O, wordlist: N, entropy: g });
    }
    /**
     *  Returns the seed for the mnemonic.
     */
    computeSeed() {
      const p = (0, t.toUtf8Bytes)("mnemonic" + this.password, "NFKD");
      return (0, e.pbkdf2)((0, t.toUtf8Bytes)(this.phrase, "NFKD"), p, 2048, 64, "sha512");
    }
    /**
     *  Creates a new Mnemonic for the %%phrase%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */
    static fromPhrase(p, g, v) {
      const O = i(p, v);
      return p = a((0, t.getBytes)(O), v), new d(f, O, p, g, v);
    }
    /**
     *  Create a new **Mnemonic** from the %%entropy%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */
    static fromEntropy(p, g, v) {
      const O = (0, t.getBytes)(p, "entropy"), N = a(O, v);
      return new d(f, (0, t.hexlify)(O), N, g, v);
    }
    /**
     *  Returns the phrase for %%mnemonic%%.
     */
    static entropyToPhrase(p, g) {
      const v = (0, t.getBytes)(p, "entropy");
      return a(v, g);
    }
    /**
     *  Returns the entropy for %%phrase%%.
     */
    static phraseToEntropy(p, g) {
      return i(p, g);
    }
    /**
     *  Returns true if %%phrase%% is a valid [[link-bip-39]] phrase.
     *
     *  This checks all the provided words belong to the %%wordlist%%,
     *  that the length is valid and the checksum is correct.
     */
    static isValidMnemonic(p, g) {
      try {
        return i(p, g), !0;
      } catch {
      }
      return !1;
    }
  }
  return l0.Mnemonic = d, l0;
}
var Kn = {}, jw = {}, d0 = {}, Lw;
function S7() {
  if (Lw)
    return d0;
  Lw = 1;
  /*! MIT License. Copyright 2015-2022 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */
  var e = nr && nr.__classPrivateFieldGet || function(K, $, k, V) {
    if (k === "a" && !V)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof $ == "function" ? K !== $ || !V : !$.has(K))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return k === "m" ? V : k === "a" ? V.call(K) : V ? V.value : $.get(K);
  }, t = nr && nr.__classPrivateFieldSet || function(K, $, k, V, C) {
    if (V === "m")
      throw new TypeError("Private method is not writable");
    if (V === "a" && !C)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof $ == "function" ? K !== $ || !C : !$.has(K))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return V === "a" ? C.call(K, k) : C ? C.value = k : $.set(K, k), k;
  }, r, n, s;
  Object.defineProperty(d0, "__esModule", { value: !0 }), d0.AES = void 0;
  const i = { 16: 10, 24: 12, 32: 14 }, a = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], f = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], d = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], c = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], p = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], g = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], v = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], O = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], N = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], S = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], j = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], B = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], M = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], I = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], A = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
  function R(K) {
    const $ = [];
    for (let k = 0; k < K.length; k += 4)
      $.push(K[k] << 24 | K[k + 1] << 16 | K[k + 2] << 8 | K[k + 3]);
    return $;
  }
  class L {
    get key() {
      return e(this, r, "f").slice();
    }
    constructor($) {
      if (r.set(this, void 0), n.set(this, void 0), s.set(this, void 0), !(this instanceof L))
        throw Error("AES must be instanitated with `new`");
      t(this, r, new Uint8Array($), "f");
      const k = i[this.key.length];
      if (k == null)
        throw new TypeError("invalid key size (must be 16, 24 or 32 bytes)");
      t(this, s, [], "f"), t(this, n, [], "f");
      for (let E = 0; E <= k; E++)
        e(this, s, "f").push([0, 0, 0, 0]), e(this, n, "f").push([0, 0, 0, 0]);
      const V = (k + 1) * 4, C = this.key.length / 4, D = R(this.key);
      let o;
      for (let E = 0; E < C; E++)
        o = E >> 2, e(this, s, "f")[o][E % 4] = D[E], e(this, n, "f")[k - o][E % 4] = D[E];
      let u = 0, h = C, y;
      for (; h < V; ) {
        if (y = D[C - 1], D[0] ^= f[y >> 16 & 255] << 24 ^ f[y >> 8 & 255] << 16 ^ f[y & 255] << 8 ^ f[y >> 24 & 255] ^ a[u] << 24, u += 1, C != 8)
          for (let m = 1; m < C; m++)
            D[m] ^= D[m - 1];
        else {
          for (let m = 1; m < C / 2; m++)
            D[m] ^= D[m - 1];
          y = D[C / 2 - 1], D[C / 2] ^= f[y & 255] ^ f[y >> 8 & 255] << 8 ^ f[y >> 16 & 255] << 16 ^ f[y >> 24 & 255] << 24;
          for (let m = C / 2 + 1; m < C; m++)
            D[m] ^= D[m - 1];
        }
        let E = 0, P, w;
        for (; E < C && h < V; )
          P = h >> 2, w = h % 4, e(this, s, "f")[P][w] = D[E], e(this, n, "f")[k - P][w] = D[E++], h++;
      }
      for (let E = 1; E < k; E++)
        for (let P = 0; P < 4; P++)
          y = e(this, n, "f")[E][P], e(this, n, "f")[E][P] = B[y >> 24 & 255] ^ M[y >> 16 & 255] ^ I[y >> 8 & 255] ^ A[y & 255];
    }
    encrypt($) {
      if ($.length != 16)
        throw new TypeError("invalid plaintext size (must be 16 bytes)");
      const k = e(this, s, "f").length - 1, V = [0, 0, 0, 0];
      let C = R($);
      for (let u = 0; u < 4; u++)
        C[u] ^= e(this, s, "f")[0][u];
      for (let u = 1; u < k; u++) {
        for (let h = 0; h < 4; h++)
          V[h] = c[C[h] >> 24 & 255] ^ p[C[(h + 1) % 4] >> 16 & 255] ^ g[C[(h + 2) % 4] >> 8 & 255] ^ v[C[(h + 3) % 4] & 255] ^ e(this, s, "f")[u][h];
        C = V.slice();
      }
      const D = new Uint8Array(16);
      let o = 0;
      for (let u = 0; u < 4; u++)
        o = e(this, s, "f")[k][u], D[4 * u] = (f[C[u] >> 24 & 255] ^ o >> 24) & 255, D[4 * u + 1] = (f[C[(u + 1) % 4] >> 16 & 255] ^ o >> 16) & 255, D[4 * u + 2] = (f[C[(u + 2) % 4] >> 8 & 255] ^ o >> 8) & 255, D[4 * u + 3] = (f[C[(u + 3) % 4] & 255] ^ o) & 255;
      return D;
    }
    decrypt($) {
      if ($.length != 16)
        throw new TypeError("invalid ciphertext size (must be 16 bytes)");
      const k = e(this, n, "f").length - 1, V = [0, 0, 0, 0];
      let C = R($);
      for (let u = 0; u < 4; u++)
        C[u] ^= e(this, n, "f")[0][u];
      for (let u = 1; u < k; u++) {
        for (let h = 0; h < 4; h++)
          V[h] = O[C[h] >> 24 & 255] ^ N[C[(h + 3) % 4] >> 16 & 255] ^ S[C[(h + 2) % 4] >> 8 & 255] ^ j[C[(h + 1) % 4] & 255] ^ e(this, n, "f")[u][h];
        C = V.slice();
      }
      const D = new Uint8Array(16);
      let o = 0;
      for (let u = 0; u < 4; u++)
        o = e(this, n, "f")[k][u], D[4 * u] = (d[C[u] >> 24 & 255] ^ o >> 24) & 255, D[4 * u + 1] = (d[C[(u + 3) % 4] >> 16 & 255] ^ o >> 16) & 255, D[4 * u + 2] = (d[C[(u + 2) % 4] >> 8 & 255] ^ o >> 8) & 255, D[4 * u + 3] = (d[C[(u + 1) % 4] & 255] ^ o) & 255;
      return D;
    }
  }
  return d0.AES = L, r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), d0;
}
var h0 = {}, Hw;
function uc() {
  if (Hw)
    return h0;
  Hw = 1, Object.defineProperty(h0, "__esModule", { value: !0 }), h0.ModeOfOperation = void 0;
  const e = S7();
  class t {
    constructor(n, s, i) {
      if (i && !(this instanceof i))
        throw new Error(`${n} must be instantiated with "new"`);
      Object.defineProperties(this, {
        aes: { enumerable: !0, value: new e.AES(s) },
        name: { enumerable: !0, value: n }
      });
    }
  }
  return h0.ModeOfOperation = t, h0;
}
var f0 = {}, Ww;
function AI() {
  if (Ww)
    return f0;
  Ww = 1;
  var e = nr && nr.__classPrivateFieldSet || function(a, f, d, c, p) {
    if (c === "m")
      throw new TypeError("Private method is not writable");
    if (c === "a" && !p)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof f == "function" ? a !== f || !p : !f.has(a))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return c === "a" ? p.call(a, d) : p ? p.value = d : f.set(a, d), d;
  }, t = nr && nr.__classPrivateFieldGet || function(a, f, d, c) {
    if (d === "a" && !c)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof f == "function" ? a !== f || !c : !f.has(a))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return d === "m" ? c : d === "a" ? c.call(a) : c ? c.value : f.get(a);
  }, r, n;
  Object.defineProperty(f0, "__esModule", { value: !0 }), f0.CBC = void 0;
  const s = uc();
  class i extends s.ModeOfOperation {
    constructor(f, d) {
      if (super("ECC", f, i), r.set(this, void 0), n.set(this, void 0), d) {
        if (d.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        e(this, r, new Uint8Array(d), "f");
      } else
        e(this, r, new Uint8Array(16), "f");
      e(this, n, this.iv, "f");
    }
    get iv() {
      return new Uint8Array(t(this, r, "f"));
    }
    encrypt(f) {
      if (f.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const d = new Uint8Array(f.length);
      for (let c = 0; c < f.length; c += 16) {
        for (let p = 0; p < 16; p++)
          t(this, n, "f")[p] ^= f[c + p];
        e(this, n, this.aes.encrypt(t(this, n, "f")), "f"), d.set(t(this, n, "f"), c);
      }
      return d;
    }
    decrypt(f) {
      if (f.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      const d = new Uint8Array(f.length);
      for (let c = 0; c < f.length; c += 16) {
        const p = this.aes.decrypt(f.subarray(c, c + 16));
        for (let g = 0; g < 16; g++)
          d[c + g] = p[g] ^ t(this, n, "f")[g], t(this, n, "f")[g] = f[c + g];
      }
      return d;
    }
  }
  return f0.CBC = i, r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), f0;
}
var p0 = {}, Gw;
function EI() {
  if (Gw)
    return p0;
  Gw = 1;
  var e = nr && nr.__classPrivateFieldSet || function(d, c, p, g, v) {
    if (g === "m")
      throw new TypeError("Private method is not writable");
    if (g === "a" && !v)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof c == "function" ? d !== c || !v : !c.has(d))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return g === "a" ? v.call(d, p) : v ? v.value = p : c.set(d, p), p;
  }, t = nr && nr.__classPrivateFieldGet || function(d, c, p, g) {
    if (p === "a" && !g)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof c == "function" ? d !== c || !g : !c.has(d))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return p === "m" ? g : p === "a" ? g.call(d) : g ? g.value : c.get(d);
  }, r, n, s, i;
  Object.defineProperty(p0, "__esModule", { value: !0 }), p0.CFB = void 0;
  const a = uc();
  class f extends a.ModeOfOperation {
    constructor(c, p, g = 8) {
      if (super("CFB", c, f), r.add(this), n.set(this, void 0), s.set(this, void 0), !Number.isInteger(g) || g % 8)
        throw new TypeError("invalid segmentSize");
      if (Object.defineProperties(this, {
        segmentSize: { enumerable: !0, value: g }
      }), p) {
        if (p.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        e(this, n, new Uint8Array(p), "f");
      } else
        e(this, n, new Uint8Array(16), "f");
      e(this, s, this.iv, "f");
    }
    get iv() {
      return new Uint8Array(t(this, n, "f"));
    }
    encrypt(c) {
      if (8 * c.length % this.segmentSize)
        throw new TypeError("invalid plaintext size (must be multiple of segmentSize bytes)");
      const p = this.segmentSize / 8, g = new Uint8Array(c);
      for (let v = 0; v < g.length; v += p) {
        const O = this.aes.encrypt(t(this, s, "f"));
        for (let N = 0; N < p; N++)
          g[v + N] ^= O[N];
        t(this, r, "m", i).call(this, g.subarray(v));
      }
      return g;
    }
    decrypt(c) {
      if (8 * c.length % this.segmentSize)
        throw new TypeError("invalid ciphertext size (must be multiple of segmentSize bytes)");
      const p = this.segmentSize / 8, g = new Uint8Array(c);
      for (let v = 0; v < g.length; v += p) {
        const O = this.aes.encrypt(t(this, s, "f"));
        for (let N = 0; N < p; N++)
          g[v + N] ^= O[N];
        t(this, r, "m", i).call(this, c.subarray(v));
      }
      return g;
    }
  }
  return p0.CFB = f, n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakSet(), i = function(d) {
    const c = this.segmentSize / 8;
    t(this, s, "f").set(t(this, s, "f").subarray(c)), t(this, s, "f").set(d.subarray(0, c), 16 - c);
  }, p0;
}
var g0 = {}, zw;
function PI() {
  if (zw)
    return g0;
  zw = 1;
  var e = nr && nr.__classPrivateFieldSet || function(f, d, c, p, g) {
    if (p === "m")
      throw new TypeError("Private method is not writable");
    if (p === "a" && !g)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof d == "function" ? f !== d || !g : !d.has(f))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return p === "a" ? g.call(f, c) : g ? g.value = c : d.set(f, c), c;
  }, t = nr && nr.__classPrivateFieldGet || function(f, d, c, p) {
    if (c === "a" && !p)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof d == "function" ? f !== d || !p : !d.has(f))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return c === "m" ? p : c === "a" ? p.call(f) : p ? p.value : d.get(f);
  }, r, n, s;
  Object.defineProperty(g0, "__esModule", { value: !0 }), g0.CTR = void 0;
  const i = uc();
  class a extends i.ModeOfOperation {
    constructor(d, c) {
      super("CTR", d, a), r.set(this, void 0), n.set(this, void 0), s.set(this, void 0), e(this, s, new Uint8Array(16), "f"), t(this, s, "f").fill(0), e(this, r, t(this, s, "f"), "f"), e(this, n, 16, "f"), c == null && (c = 1), typeof c == "number" ? this.setCounterValue(c) : this.setCounterBytes(c);
    }
    get counter() {
      return new Uint8Array(t(this, s, "f"));
    }
    setCounterValue(d) {
      if (!Number.isInteger(d) || d < 0 || d > Number.MAX_SAFE_INTEGER)
        throw new TypeError("invalid counter initial integer value");
      for (let c = 15; c >= 0; --c)
        t(this, s, "f")[c] = d % 256, d = Math.floor(d / 256);
    }
    setCounterBytes(d) {
      if (d.length !== 16)
        throw new TypeError("invalid counter initial Uint8Array value length");
      t(this, s, "f").set(d);
    }
    increment() {
      for (let d = 15; d >= 0; d--)
        if (t(this, s, "f")[d] === 255)
          t(this, s, "f")[d] = 0;
        else {
          t(this, s, "f")[d]++;
          break;
        }
    }
    encrypt(d) {
      var c, p;
      const g = new Uint8Array(d);
      for (let v = 0; v < g.length; v++)
        t(this, n, "f") === 16 && (e(this, r, this.aes.encrypt(t(this, s, "f")), "f"), e(this, n, 0, "f"), this.increment()), g[v] ^= t(this, r, "f")[e(this, n, (p = t(this, n, "f"), c = p++, p), "f"), c];
      return g;
    }
    decrypt(d) {
      return this.encrypt(d);
    }
  }
  return g0.CTR = a, r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), g0;
}
var m0 = {}, Vw;
function OI() {
  if (Vw)
    return m0;
  Vw = 1, Object.defineProperty(m0, "__esModule", { value: !0 }), m0.ECB = void 0;
  const e = uc();
  class t extends e.ModeOfOperation {
    constructor(n) {
      super("ECB", n, t);
    }
    encrypt(n) {
      if (n.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const s = new Uint8Array(n.length);
      for (let i = 0; i < n.length; i += 16)
        s.set(this.aes.encrypt(n.subarray(i, i + 16)), i);
      return s;
    }
    decrypt(n) {
      if (n.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      const s = new Uint8Array(n.length);
      for (let i = 0; i < n.length; i += 16)
        s.set(this.aes.decrypt(n.subarray(i, i + 16)), i);
      return s;
    }
  }
  return m0.ECB = t, m0;
}
var y0 = {}, qw;
function NI() {
  if (qw)
    return y0;
  qw = 1;
  var e = nr && nr.__classPrivateFieldSet || function(f, d, c, p, g) {
    if (p === "m")
      throw new TypeError("Private method is not writable");
    if (p === "a" && !g)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof d == "function" ? f !== d || !g : !d.has(f))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return p === "a" ? g.call(f, c) : g ? g.value = c : d.set(f, c), c;
  }, t = nr && nr.__classPrivateFieldGet || function(f, d, c, p) {
    if (c === "a" && !p)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof d == "function" ? f !== d || !p : !d.has(f))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return c === "m" ? p : c === "a" ? p.call(f) : p ? p.value : d.get(f);
  }, r, n, s;
  Object.defineProperty(y0, "__esModule", { value: !0 }), y0.OFB = void 0;
  const i = uc();
  class a extends i.ModeOfOperation {
    constructor(d, c) {
      if (super("OFB", d, a), r.set(this, void 0), n.set(this, void 0), s.set(this, void 0), c) {
        if (c.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        e(this, r, new Uint8Array(c), "f");
      } else
        e(this, r, new Uint8Array(16), "f");
      e(this, n, this.iv, "f"), e(this, s, 16, "f");
    }
    get iv() {
      return new Uint8Array(t(this, r, "f"));
    }
    encrypt(d) {
      var c, p;
      if (d.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const g = new Uint8Array(d);
      for (let v = 0; v < g.length; v++)
        t(this, s, "f") === 16 && (e(this, n, this.aes.encrypt(t(this, n, "f")), "f"), e(this, s, 0, "f")), g[v] ^= t(this, n, "f")[e(this, s, (p = t(this, s, "f"), c = p++, p), "f"), c];
      return g;
    }
    decrypt(d) {
      if (d.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      return this.encrypt(d);
    }
  }
  return y0.OFB = a, r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), y0;
}
var Fa = {}, $w;
function xI() {
  if ($w)
    return Fa;
  $w = 1, Object.defineProperty(Fa, "__esModule", { value: !0 }), Fa.pkcs7Strip = Fa.pkcs7Pad = void 0;
  function e(r) {
    const n = 16 - r.length % 16, s = new Uint8Array(r.length + n);
    s.set(r);
    for (let i = r.length; i < s.length; i++)
      s[i] = n;
    return s;
  }
  Fa.pkcs7Pad = e;
  function t(r) {
    if (r.length < 16)
      throw new TypeError("PKCS#7 invalid length");
    const n = r[r.length - 1];
    if (n > 16)
      throw new TypeError("PKCS#7 padding byte out of range");
    const s = r.length - n;
    for (let i = 0; i < n; i++)
      if (r[s + i] !== n)
        throw new TypeError("PKCS#7 invalid padding byte");
    return new Uint8Array(r.subarray(0, s));
  }
  return Fa.pkcs7Strip = t, Fa;
}
var Kw;
function M7() {
  return Kw || (Kw = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.pkcs7Strip = e.pkcs7Pad = e.OFB = e.ECB = e.CTR = e.CFB = e.CBC = e.ModeOfOperation = e.AES = void 0;
    var t = S7();
    Object.defineProperty(e, "AES", { enumerable: !0, get: function() {
      return t.AES;
    } });
    var r = uc();
    Object.defineProperty(e, "ModeOfOperation", { enumerable: !0, get: function() {
      return r.ModeOfOperation;
    } });
    var n = AI();
    Object.defineProperty(e, "CBC", { enumerable: !0, get: function() {
      return n.CBC;
    } });
    var s = EI();
    Object.defineProperty(e, "CFB", { enumerable: !0, get: function() {
      return s.CFB;
    } });
    var i = PI();
    Object.defineProperty(e, "CTR", { enumerable: !0, get: function() {
      return i.CTR;
    } });
    var a = OI();
    Object.defineProperty(e, "ECB", { enumerable: !0, get: function() {
      return a.ECB;
    } });
    var f = NI();
    Object.defineProperty(e, "OFB", { enumerable: !0, get: function() {
      return f.OFB;
    } });
    var d = xI();
    Object.defineProperty(e, "pkcs7Pad", { enumerable: !0, get: function() {
      return d.pkcs7Pad;
    } }), Object.defineProperty(e, "pkcs7Strip", { enumerable: !0, get: function() {
      return d.pkcs7Strip;
    } });
  }(jw)), jw;
}
var Ii = {}, Jw;
function I7() {
  if (Jw)
    return Ii;
  Jw = 1, Object.defineProperty(Ii, "__esModule", { value: !0 }), Ii.spelunk = Ii.getPassword = Ii.zpad = Ii.looseArrayify = void 0;
  const e = vt();
  function t(i) {
    return typeof i == "string" && !i.startsWith("0x") && (i = "0x" + i), (0, e.getBytesCopy)(i);
  }
  Ii.looseArrayify = t;
  function r(i, a) {
    for (i = String(i); i.length < a; )
      i = "0" + i;
    return i;
  }
  Ii.zpad = r;
  function n(i) {
    return typeof i == "string" ? (0, e.toUtf8Bytes)(i, "NFKC") : (0, e.getBytesCopy)(i);
  }
  Ii.getPassword = n;
  function s(i, a) {
    const f = a.match(/^([a-z0-9$_.-]*)(:([a-z]+))?(!)?$/i);
    (0, e.assertArgument)(f != null, "invalid path", "path", a);
    const d = f[1], c = f[3], p = f[4] === "!";
    let g = i;
    for (const v of d.toLowerCase().split(".")) {
      if (Array.isArray(g)) {
        if (!v.match(/^[0-9]+$/))
          break;
        g = g[parseInt(v)];
      } else if (typeof g == "object") {
        let O = null;
        for (const N in g)
          if (N.toLowerCase() === v) {
            O = g[N];
            break;
          }
        g = O;
      } else
        g = null;
      if (g == null)
        break;
    }
    if ((0, e.assertArgument)(!p || g != null, "missing required value", "path", d), c && g != null) {
      if (c === "int") {
        if (typeof g == "string" && g.match(/^-?[0-9]+$/))
          return parseInt(g);
        if (Number.isSafeInteger(g))
          return g;
      }
      if (c === "number" && typeof g == "string" && g.match(/^-?[0-9.]*$/))
        return parseFloat(g);
      if (c === "data" && typeof g == "string")
        return t(g);
      if (c === "array" && Array.isArray(g) || c === typeof g)
        return g;
      (0, e.assertArgument)(!1, `wrong type found for ${c} `, "path", d);
    }
    return g;
  }
  return Ii.spelunk = s, Ii;
}
var Qw;
function sg() {
  if (Qw)
    return Kn;
  Qw = 1, Object.defineProperty(Kn, "__esModule", { value: !0 }), Kn.encryptKeystoreJson = Kn.encryptKeystoreJsonSync = Kn.decryptKeystoreJson = Kn.decryptKeystoreJsonSync = Kn.isKeystoreJson = void 0;
  const e = M7(), t = Xr(), r = ln(), n = ei(), s = vt(), i = I7(), a = z1(), f = "m/44'/60'/0'/0/0";
  function d(I) {
    try {
      const A = JSON.parse(I);
      if ((A.version != null ? parseInt(A.version) : 0) === 3)
        return !0;
    } catch {
    }
    return !1;
  }
  Kn.isKeystoreJson = d;
  function c(I, A, R) {
    if ((0, i.spelunk)(I, "crypto.cipher:string") === "aes-128-ctr") {
      const L = (0, i.spelunk)(I, "crypto.cipherparams.iv:data!"), K = new e.CTR(A, L);
      return (0, s.hexlify)(K.decrypt(R));
    }
    (0, s.assert)(!1, "unsupported cipher", "UNSUPPORTED_OPERATION", {
      operation: "decrypt"
    });
  }
  function p(I, A) {
    const R = (0, s.getBytes)(A), L = (0, i.spelunk)(I, "crypto.ciphertext:data!"), K = (0, s.hexlify)((0, r.keccak256)((0, s.concat)([R.slice(16, 32), L]))).substring(2);
    (0, s.assertArgument)(K === (0, i.spelunk)(I, "crypto.mac:string!").toLowerCase(), "incorrect password", "password", "[ REDACTED ]");
    const $ = c(I, R.slice(0, 16), L), k = (0, n.computeAddress)($);
    if (I.address) {
      let C = I.address.toLowerCase();
      C.startsWith("0x") || (C = "0x" + C), (0, s.assertArgument)((0, t.getAddress)(C) === k, "keystore address/privateKey mismatch", "address", I.address);
    }
    const V = { address: k, privateKey: $ };
    if ((0, i.spelunk)(I, "x-ethers.version:string") === "0.1") {
      const C = R.slice(32, 64), D = (0, i.spelunk)(I, "x-ethers.mnemonicCiphertext:data!"), o = (0, i.spelunk)(I, "x-ethers.mnemonicCounter:data!"), u = new e.CTR(C, o);
      V.mnemonic = {
        path: (0, i.spelunk)(I, "x-ethers.path:string") || f,
        locale: (0, i.spelunk)(I, "x-ethers.locale:string") || "en",
        entropy: (0, s.hexlify)((0, s.getBytes)(u.decrypt(D)))
      };
    }
    return V;
  }
  function g(I) {
    const A = (0, i.spelunk)(I, "crypto.kdf:string");
    if (A && typeof A == "string") {
      if (A.toLowerCase() === "scrypt") {
        const R = (0, i.spelunk)(I, "crypto.kdfparams.salt:data!"), L = (0, i.spelunk)(I, "crypto.kdfparams.n:int!"), K = (0, i.spelunk)(I, "crypto.kdfparams.r:int!"), $ = (0, i.spelunk)(I, "crypto.kdfparams.p:int!");
        (0, s.assertArgument)(L > 0 && (L & L - 1) === 0, "invalid kdf.N", "kdf.N", L), (0, s.assertArgument)(K > 0 && $ > 0, "invalid kdf", "kdf", A);
        const k = (0, i.spelunk)(I, "crypto.kdfparams.dklen:int!");
        return (0, s.assertArgument)(k === 32, "invalid kdf.dklen", "kdf.dflen", k), { name: "scrypt", salt: R, N: L, r: K, p: $, dkLen: 64 };
      } else if (A.toLowerCase() === "pbkdf2") {
        const R = (0, i.spelunk)(I, "crypto.kdfparams.salt:data!"), L = (0, i.spelunk)(I, "crypto.kdfparams.prf:string!"), K = L.split("-").pop();
        (0, s.assertArgument)(K === "sha256" || K === "sha512", "invalid kdf.pdf", "kdf.pdf", L);
        const $ = (0, i.spelunk)(I, "crypto.kdfparams.c:int!"), k = (0, i.spelunk)(I, "crypto.kdfparams.dklen:int!");
        return (0, s.assertArgument)(k === 32, "invalid kdf.dklen", "kdf.dklen", k), { name: "pbkdf2", salt: R, count: $, dkLen: k, algorithm: K };
      }
    }
    (0, s.assertArgument)(!1, "unsupported key-derivation function", "kdf", A);
  }
  function v(I, A) {
    const R = JSON.parse(I), L = (0, i.getPassword)(A), K = g(R);
    if (K.name === "pbkdf2") {
      const { salt: u, count: h, dkLen: y, algorithm: E } = K, P = (0, r.pbkdf2)(L, u, h, y, E);
      return p(R, P);
    }
    (0, s.assert)(K.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: K });
    const { salt: $, N: k, r: V, p: C, dkLen: D } = K, o = (0, r.scryptSync)(L, $, k, V, C, D);
    return p(R, o);
  }
  Kn.decryptKeystoreJsonSync = v;
  function O(I) {
    return new Promise((A) => {
      setTimeout(() => {
        A();
      }, I);
    });
  }
  async function N(I, A, R) {
    const L = JSON.parse(I), K = (0, i.getPassword)(A), $ = g(L);
    if ($.name === "pbkdf2") {
      R && (R(0), await O(0));
      const { salt: h, count: y, dkLen: E, algorithm: P } = $, w = (0, r.pbkdf2)(K, h, y, E, P);
      return R && (R(1), await O(0)), p(L, w);
    }
    (0, s.assert)($.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: $ });
    const { salt: k, N: V, r: C, p: D, dkLen: o } = $, u = await (0, r.scrypt)(K, k, V, C, D, o, R);
    return p(L, u);
  }
  Kn.decryptKeystoreJson = N;
  function S(I) {
    const A = I.salt != null ? (0, s.getBytes)(I.salt, "options.salt") : (0, r.randomBytes)(32);
    let R = 1 << 17, L = 8, K = 1;
    return I.scrypt && (I.scrypt.N && (R = I.scrypt.N), I.scrypt.r && (L = I.scrypt.r), I.scrypt.p && (K = I.scrypt.p)), (0, s.assertArgument)(typeof R == "number" && R > 0 && Number.isSafeInteger(R) && (BigInt(R) & BigInt(R - 1)) === BigInt(0), "invalid scrypt N parameter", "options.N", R), (0, s.assertArgument)(typeof L == "number" && L > 0 && Number.isSafeInteger(L), "invalid scrypt r parameter", "options.r", L), (0, s.assertArgument)(typeof K == "number" && K > 0 && Number.isSafeInteger(K), "invalid scrypt p parameter", "options.p", K), { name: "scrypt", dkLen: 32, salt: A, N: R, r: L, p: K };
  }
  function j(I, A, R, L) {
    const K = (0, s.getBytes)(R.privateKey, "privateKey"), $ = L.iv != null ? (0, s.getBytes)(L.iv, "options.iv") : (0, r.randomBytes)(16);
    (0, s.assertArgument)($.length === 16, "invalid options.iv length", "options.iv", L.iv);
    const k = L.uuid != null ? (0, s.getBytes)(L.uuid, "options.uuid") : (0, r.randomBytes)(16);
    (0, s.assertArgument)(k.length === 16, "invalid options.uuid length", "options.uuid", L.iv);
    const V = I.slice(0, 16), C = I.slice(16, 32), D = new e.CTR(V, $), o = (0, s.getBytes)(D.encrypt(K)), u = (0, r.keccak256)((0, s.concat)([C, o])), h = {
      address: R.address.substring(2).toLowerCase(),
      id: (0, s.uuidV4)(k),
      version: 3,
      Crypto: {
        cipher: "aes-128-ctr",
        cipherparams: {
          iv: (0, s.hexlify)($).substring(2)
        },
        ciphertext: (0, s.hexlify)(o).substring(2),
        kdf: "scrypt",
        kdfparams: {
          salt: (0, s.hexlify)(A.salt).substring(2),
          n: A.N,
          dklen: 32,
          p: A.p,
          r: A.r
        },
        mac: u.substring(2)
      }
    };
    if (R.mnemonic) {
      const y = L.client != null ? L.client : `ethers/${a.version}`, E = R.mnemonic.path || f, P = R.mnemonic.locale || "en", w = I.slice(32, 64), m = (0, s.getBytes)(R.mnemonic.entropy, "account.mnemonic.entropy"), l = (0, r.randomBytes)(16), b = new e.CTR(w, l), W = (0, s.getBytes)(b.encrypt(m)), X = /* @__PURE__ */ new Date(), G = "UTC--" + (X.getUTCFullYear() + "-" + (0, i.zpad)(X.getUTCMonth() + 1, 2) + "-" + (0, i.zpad)(X.getUTCDate(), 2) + "T" + (0, i.zpad)(X.getUTCHours(), 2) + "-" + (0, i.zpad)(X.getUTCMinutes(), 2) + "-" + (0, i.zpad)(X.getUTCSeconds(), 2) + ".0Z") + "--" + h.address;
      h["x-ethers"] = {
        client: y,
        gethFilename: G,
        path: E,
        locale: P,
        mnemonicCounter: (0, s.hexlify)(l).substring(2),
        mnemonicCiphertext: (0, s.hexlify)(W).substring(2),
        version: "0.1"
      };
    }
    return JSON.stringify(h);
  }
  function B(I, A, R) {
    R == null && (R = {});
    const L = (0, i.getPassword)(A), K = S(R), $ = (0, r.scryptSync)(L, K.salt, K.N, K.r, K.p, 64);
    return j((0, s.getBytes)($), K, I, R);
  }
  Kn.encryptKeystoreJsonSync = B;
  async function M(I, A, R) {
    R == null && (R = {});
    const L = (0, i.getPassword)(A), K = S(R), $ = await (0, r.scrypt)(L, K.salt, K.N, K.r, K.p, 64, R.progressCallback);
    return j((0, s.getBytes)($), K, I, R);
  }
  return Kn.encryptKeystoreJson = M, Kn;
}
var Zw;
function R7() {
  return Zw || (Zw = 1, function(e) {
    var t, r, n, s;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getIndexedAccountPath = e.getAccountPath = e.HDNodeVoidWallet = e.HDNodeWallet = e.defaultPath = void 0;
    const i = ln(), a = tg(), f = ei(), d = vt(), c = wf(), p = rg(), g = ig(), v = sg();
    e.defaultPath = "m/44'/60'/0'/0/0";
    const O = new Uint8Array([66, 105, 116, 99, 111, 105, 110, 32, 115, 101, 101, 100]), N = 2147483648, S = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), j = "0123456789abcdef";
    function B(C, D) {
      let o = "";
      for (; C; )
        o = j[C % 16] + o, C = Math.trunc(C / 16);
      for (; o.length < D * 2; )
        o = "0" + o;
      return "0x" + o;
    }
    function M(C) {
      const D = (0, d.getBytes)(C), o = (0, d.dataSlice)((0, i.sha256)((0, i.sha256)(D)), 0, 4), u = (0, d.concat)([D, o]);
      return (0, d.encodeBase58)(u);
    }
    const I = {};
    function A(C, D, o, u) {
      const h = new Uint8Array(37);
      C & N ? ((0, d.assert)(u != null, "cannot derive child of neutered node", "UNSUPPORTED_OPERATION", {
        operation: "deriveChild"
      }), h.set((0, d.getBytes)(u), 1)) : h.set((0, d.getBytes)(o));
      for (let E = 24; E >= 0; E -= 8)
        h[33 + (E >> 3)] = C >> 24 - E & 255;
      const y = (0, d.getBytes)((0, i.computeHmac)("sha512", D, h));
      return { IL: y.slice(0, 32), IR: y.slice(32) };
    }
    function R(C, D) {
      const o = D.split("/");
      (0, d.assertArgument)(o.length > 0, "invalid path", "path", D), o[0] === "m" && ((0, d.assertArgument)(C.depth === 0, `cannot derive root path (i.e. path starting with "m/") for a node at non-zero depth ${C.depth}`, "path", D), o.shift());
      let u = C;
      for (let h = 0; h < o.length; h++) {
        const y = o[h];
        if (y.match(/^[0-9]+'$/)) {
          const E = parseInt(y.substring(0, y.length - 1));
          (0, d.assertArgument)(E < N, "invalid path index", `path[${h}]`, y), u = u.deriveChild(N + E);
        } else if (y.match(/^[0-9]+$/)) {
          const E = parseInt(y);
          (0, d.assertArgument)(E < N, "invalid path index", `path[${h}]`, y), u = u.deriveChild(E);
        } else
          (0, d.assertArgument)(!1, "invalid path component", `path[${h}]`, y);
      }
      return u;
    }
    const L = class po extends p.BaseWallet {
      /**
       *  @private
       */
      constructor(D, o, u, h, y, E, P, w, m) {
        super(o, m), Fe(this, t), Se(this, "publicKey"), Se(this, "fingerprint"), Se(this, "parentFingerprint"), Se(this, "mnemonic"), Se(this, "chainCode"), Se(this, "path"), Se(this, "index"), Se(this, "depth"), (0, d.assertPrivate)(D, I, "HDNodeWallet"), (0, d.defineProperties)(this, { publicKey: o.compressedPublicKey });
        const l = (0, d.dataSlice)((0, i.ripemd160)((0, i.sha256)(this.publicKey)), 0, 4);
        (0, d.defineProperties)(this, {
          parentFingerprint: u,
          fingerprint: l,
          chainCode: h,
          path: y,
          index: E,
          depth: P
        }), (0, d.defineProperties)(this, { mnemonic: w });
      }
      connect(D) {
        return new po(I, this.signingKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.mnemonic, D);
      }
      /**
       *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
       *  %%password%%.
       *
       *  If %%progressCallback%% is specified, it will receive periodic
       *  updates as the encryption process progreses.
       */
      async encrypt(D, o) {
        return await (0, v.encryptKeystoreJson)(qe(this, t, r).call(this), D, { progressCallback: o });
      }
      /**
       *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
       *  %%password%%.
       *
       *  It is preferred to use the [async version](encrypt) instead,
       *  which allows a [[ProgressCallback]] to keep the user informed.
       *
       *  This method will block the event loop (freezing all UI) until
       *  it is complete, which may be a non-trivial duration.
       */
      encryptSync(D) {
        return (0, v.encryptKeystoreJsonSync)(qe(this, t, r).call(this), D);
      }
      /**
       *  The extended key.
       *
       *  This key will begin with the prefix ``xpriv`` and can be used to
       *  reconstruct this HD Node to derive its children.
       */
      get extendedKey() {
        return (0, d.assert)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), M((0, d.concat)([
          "0x0488ADE4",
          B(this.depth, 1),
          this.parentFingerprint,
          B(this.index, 4),
          this.chainCode,
          (0, d.concat)(["0x00", this.privateKey])
        ]));
      }
      /**
       *  Returns true if this wallet has a path, providing a Type Guard
       *  that the path is non-null.
       */
      hasPath() {
        return this.path != null;
      }
      /**
       *  Returns a neutered HD Node, which removes the private details
       *  of an HD Node.
       *
       *  A neutered node has no private key, but can be used to derive
       *  child addresses and other public data about the HD Node.
       */
      neuter() {
        return new $(I, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.provider);
      }
      /**
       *  Return the child for %%index%%.
       */
      deriveChild(D) {
        const o = (0, d.getNumber)(D, "index");
        (0, d.assertArgument)(o <= 4294967295, "invalid index", "index", o);
        let u = this.path;
        u && (u += "/" + (o & ~N), o & N && (u += "'"));
        const { IR: h, IL: y } = A(o, this.chainCode, this.publicKey, this.privateKey), E = new i.SigningKey((0, d.toBeHex)(((0, d.toBigInt)(y) + BigInt(this.privateKey)) % S, 32));
        return new po(I, E, this.fingerprint, (0, d.hexlify)(h), u, o, this.depth + 1, this.mnemonic, this.provider);
      }
      /**
       *  Return the HDNode for %%path%% from this node.
       */
      derivePath(D) {
        return R(this, D);
      }
      /**
       *  Creates a new HD Node from %%extendedKey%%.
       *
       *  If the %%extendedKey%% will either have a prefix or ``xpub`` or
       *  ``xpriv``, returning a neutered HD Node ([[HDNodeVoidWallet]])
       *  or full HD Node ([[HDNodeWallet) respectively.
       */
      static fromExtendedKey(D) {
        const o = (0, d.toBeArray)((0, d.decodeBase58)(D));
        (0, d.assertArgument)(o.length === 82 || M(o.slice(0, 78)) === D, "invalid extended key", "extendedKey", "[ REDACTED ]");
        const u = o[4], h = (0, d.hexlify)(o.slice(5, 9)), y = parseInt((0, d.hexlify)(o.slice(9, 13)).substring(2), 16), E = (0, d.hexlify)(o.slice(13, 45)), P = o.slice(45, 78);
        switch ((0, d.hexlify)(o.slice(0, 4))) {
          case "0x0488b21e":
          case "0x043587cf": {
            const w = (0, d.hexlify)(P);
            return new $(I, (0, f.computeAddress)(w), w, h, E, null, y, u, null);
          }
          case "0x0488ade4":
          case "0x04358394 ":
            if (P[0] !== 0)
              break;
            return new po(I, new i.SigningKey(P.slice(1)), h, E, null, y, u, null, null);
        }
        (0, d.assertArgument)(!1, "invalid extended key prefix", "extendedKey", "[ REDACTED ]");
      }
      /**
       *  Creates a new random HDNode.
       */
      static createRandom(D, o, u) {
        var h;
        D == null && (D = ""), o == null && (o = e.defaultPath), u == null && (u = c.LangEn.wordlist());
        const y = g.Mnemonic.fromEntropy((0, i.randomBytes)(16), D, u);
        return qe(h = po, n, s).call(h, y.computeSeed(), y).derivePath(o);
      }
      /**
       *  Create an HD Node from %%mnemonic%%.
       */
      static fromMnemonic(D, o) {
        var u;
        return o || (o = e.defaultPath), qe(u = po, n, s).call(u, D.computeSeed(), D).derivePath(o);
      }
      /**
       *  Creates an HD Node from a mnemonic %%phrase%%.
       */
      static fromPhrase(D, o, u, h) {
        var y;
        o == null && (o = ""), u == null && (u = e.defaultPath), h == null && (h = c.LangEn.wordlist());
        const E = g.Mnemonic.fromPhrase(D, o, h);
        return qe(y = po, n, s).call(y, E.computeSeed(), E).derivePath(u);
      }
      /**
       *  Creates an HD Node from a %%seed%%.
       */
      static fromSeed(D) {
        var o;
        return qe(o = po, n, s).call(o, D, null);
      }
    };
    t = /* @__PURE__ */ new WeakSet(), r = function() {
      const C = { address: this.address, privateKey: this.privateKey }, D = this.mnemonic;
      return this.path && D && D.wordlist.locale === "en" && D.password === "" && (C.mnemonic = {
        path: this.path,
        locale: "en",
        entropy: D.entropy
      }), C;
    }, n = /* @__PURE__ */ new WeakSet(), s = function(C, D) {
      (0, d.assertArgument)((0, d.isBytesLike)(C), "invalid seed", "seed", "[REDACTED]");
      const o = (0, d.getBytes)(C, "seed");
      (0, d.assertArgument)(o.length >= 16 && o.length <= 64, "invalid seed", "seed", "[REDACTED]");
      const u = (0, d.getBytes)((0, i.computeHmac)("sha512", O, o)), h = new i.SigningKey((0, d.hexlify)(u.slice(0, 32)));
      return new L(I, h, "0x00000000", (0, d.hexlify)(u.slice(32)), "m", 0, 0, D, null);
    }, Fe(L, n);
    let K = L;
    e.HDNodeWallet = K;
    class $ extends a.VoidSigner {
      /**
       *  @private
       */
      constructor(D, o, u, h, y, E, P, w, m) {
        super(o, m), Se(this, "publicKey"), Se(this, "fingerprint"), Se(this, "parentFingerprint"), Se(this, "chainCode"), Se(this, "path"), Se(this, "index"), Se(this, "depth"), (0, d.assertPrivate)(D, I, "HDNodeVoidWallet"), (0, d.defineProperties)(this, { publicKey: u });
        const l = (0, d.dataSlice)((0, i.ripemd160)((0, i.sha256)(u)), 0, 4);
        (0, d.defineProperties)(this, {
          publicKey: u,
          fingerprint: l,
          parentFingerprint: h,
          chainCode: y,
          path: E,
          index: P,
          depth: w
        });
      }
      connect(D) {
        return new $(I, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, D);
      }
      /**
       *  The extended key.
       *
       *  This key will begin with the prefix ``xpub`` and can be used to
       *  reconstruct this neutered key to derive its children addresses.
       */
      get extendedKey() {
        return (0, d.assert)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), M((0, d.concat)([
          "0x0488B21E",
          B(this.depth, 1),
          this.parentFingerprint,
          B(this.index, 4),
          this.chainCode,
          this.publicKey
        ]));
      }
      /**
       *  Returns true if this wallet has a path, providing a Type Guard
       *  that the path is non-null.
       */
      hasPath() {
        return this.path != null;
      }
      /**
       *  Return the child for %%index%%.
       */
      deriveChild(D) {
        const o = (0, d.getNumber)(D, "index");
        (0, d.assertArgument)(o <= 4294967295, "invalid index", "index", o);
        let u = this.path;
        u && (u += "/" + (o & ~N), o & N && (u += "'"));
        const { IR: h, IL: y } = A(o, this.chainCode, this.publicKey, null), E = i.SigningKey.addPoints(y, this.publicKey, !0), P = (0, f.computeAddress)(E);
        return new $(I, P, E, this.fingerprint, (0, d.hexlify)(h), u, o, this.depth + 1, this.provider);
      }
      /**
       *  Return the signer for %%path%% from this node.
       */
      derivePath(D) {
        return R(this, D);
      }
    }
    e.HDNodeVoidWallet = $;
    function k(C) {
      const D = (0, d.getNumber)(C, "index");
      return (0, d.assertArgument)(D >= 0 && D < N, "invalid account index", "index", D), `m/44'/60'/${D}'/0/0`;
    }
    e.getAccountPath = k;
    function V(C) {
      const D = (0, d.getNumber)(C, "index");
      return (0, d.assertArgument)(D >= 0 && D < N, "invalid account index", "index", D), `m/44'/60'/0'/0/${D}`;
    }
    e.getIndexedAccountPath = V;
  }(Cw)), Cw;
}
var Ua = {}, Yw;
function C7() {
  if (Yw)
    return Ua;
  Yw = 1, Object.defineProperty(Ua, "__esModule", { value: !0 }), Ua.decryptCrowdsaleJson = Ua.isCrowdsaleJson = void 0;
  const e = M7(), t = Xr(), r = ln(), n = so(), s = vt(), i = I7();
  function a(d) {
    try {
      if (JSON.parse(d).encseed)
        return !0;
    } catch {
    }
    return !1;
  }
  Ua.isCrowdsaleJson = a;
  function f(d, c) {
    const p = JSON.parse(d), g = (0, i.getPassword)(c), v = (0, t.getAddress)((0, i.spelunk)(p, "ethaddr:string!")), O = (0, i.looseArrayify)((0, i.spelunk)(p, "encseed:string!"));
    (0, s.assertArgument)(O && O.length % 16 === 0, "invalid encseed", "json", d);
    const N = (0, s.getBytes)((0, r.pbkdf2)(g, g, 2e3, 32, "sha256")).slice(0, 16), S = O.slice(0, 16), j = O.slice(16), B = new e.CBC(N, S), M = (0, e.pkcs7Strip)((0, s.getBytes)(B.decrypt(j)));
    let I = "";
    for (let A = 0; A < M.length; A++)
      I += String.fromCharCode(M[A]);
    return { address: v, privateKey: (0, n.id)(I) };
  }
  return Ua.decryptCrowdsaleJson = f, Ua;
}
var b0 = {}, Xw;
function TI() {
  var e, t;
  if (Xw)
    return b0;
  Xw = 1, Object.defineProperty(b0, "__esModule", { value: !0 }), b0.Wallet = void 0;
  const r = ln(), n = vt(), s = rg(), i = R7(), a = C7(), f = sg(), d = ig();
  function c(v) {
    return new Promise((O) => {
      setTimeout(() => {
        O();
      }, v);
    });
  }
  const p = class sh extends s.BaseWallet {
    /**
     *  Create a new wallet for the private %%key%%, optionally connected
     *  to %%provider%%.
     */
    constructor(O, N) {
      typeof O == "string" && !O.startsWith("0x") && (O = "0x" + O);
      let S = typeof O == "string" ? new r.SigningKey(O) : O;
      super(S, N);
    }
    connect(O) {
      return new sh(this.signingKey, O);
    }
    /**
     *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
     *  %%password%%.
     *
     *  If %%progressCallback%% is specified, it will receive periodic
     *  updates as the encryption process progreses.
     */
    async encrypt(O, N) {
      const S = { address: this.address, privateKey: this.privateKey };
      return await (0, f.encryptKeystoreJson)(S, O, { progressCallback: N });
    }
    /**
     *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
     *  %%password%%.
     *
     *  It is preferred to use the [async version](encrypt) instead,
     *  which allows a [[ProgressCallback]] to keep the user informed.
     *
     *  This method will block the event loop (freezing all UI) until
     *  it is complete, which may be a non-trivial duration.
     */
    encryptSync(O) {
      const N = { address: this.address, privateKey: this.privateKey };
      return (0, f.encryptKeystoreJsonSync)(N, O);
    }
    /**
     *  Creates (asynchronously) a **Wallet** by decrypting the %%json%%
     *  with %%password%%.
     *
     *  If %%progress%% is provided, it is called periodically during
     *  decryption so that any UI can be updated.
     */
    static async fromEncryptedJson(O, N, S) {
      var j;
      let B = null;
      return (0, f.isKeystoreJson)(O) ? B = await (0, f.decryptKeystoreJson)(O, N, S) : (0, a.isCrowdsaleJson)(O) && (S && (S(0), await c(0)), B = (0, a.decryptCrowdsaleJson)(O, N), S && (S(1), await c(0))), qe(j = sh, e, t).call(j, B);
    }
    /**
     *  Creates a **Wallet** by decrypting the %%json%% with %%password%%.
     *
     *  The [[fromEncryptedJson]] method is preferred, as this method
     *  will lock up and freeze the UI during decryption, which may take
     *  some time.
     */
    static fromEncryptedJsonSync(O, N) {
      var S;
      let j = null;
      return (0, f.isKeystoreJson)(O) ? j = (0, f.decryptKeystoreJsonSync)(O, N) : (0, a.isCrowdsaleJson)(O) ? j = (0, a.decryptCrowdsaleJson)(O, N) : (0, n.assertArgument)(!1, "invalid JSON wallet", "json", "[ REDACTED ]"), qe(S = sh, e, t).call(S, j);
    }
    /**
     *  Creates a new random [[HDNodeWallet]] using the available
     *  [cryptographic random source](randomBytes).
     *
     *  If there is no crytographic random source, this will throw.
     */
    static createRandom(O) {
      const N = i.HDNodeWallet.createRandom();
      return O ? N.connect(O) : N;
    }
    /**
     *  Creates a [[HDNodeWallet]] for %%phrase%%.
     */
    static fromPhrase(O, N) {
      const S = i.HDNodeWallet.fromPhrase(O);
      return N ? S.connect(N) : S;
    }
  };
  e = /* @__PURE__ */ new WeakSet(), t = function(v) {
    if ((0, n.assertArgument)(v, "invalid JSON wallet", "json", "[ REDACTED ]"), "mnemonic" in v && v.mnemonic && v.mnemonic.locale === "en") {
      const N = d.Mnemonic.fromEntropy(v.mnemonic.entropy), S = i.HDNodeWallet.fromMnemonic(N, v.mnemonic.path);
      if (S.address === v.address && S.privateKey === v.privateKey)
        return S;
      console.log("WARNING: JSON mismatch address/privateKey != mnemonic; fallback onto private key");
    }
    const O = new p(v.privateKey);
    return (0, n.assertArgument)(O.address === v.address, "address/privateKey mismatch", "json", "[ REDACTED ]"), O;
  }, Fe(p, e);
  let g = p;
  return b0.Wallet = g, b0;
}
var e4;
function kI() {
  return e4 || (e4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Wallet = e.Mnemonic = e.encryptKeystoreJsonSync = e.encryptKeystoreJson = e.decryptKeystoreJson = e.decryptKeystoreJsonSync = e.isKeystoreJson = e.decryptCrowdsaleJson = e.isCrowdsaleJson = e.HDNodeVoidWallet = e.HDNodeWallet = e.getIndexedAccountPath = e.getAccountPath = e.defaultPath = e.BaseWallet = void 0;
    var t = rg();
    Object.defineProperty(e, "BaseWallet", { enumerable: !0, get: function() {
      return t.BaseWallet;
    } });
    var r = R7();
    Object.defineProperty(e, "defaultPath", { enumerable: !0, get: function() {
      return r.defaultPath;
    } }), Object.defineProperty(e, "getAccountPath", { enumerable: !0, get: function() {
      return r.getAccountPath;
    } }), Object.defineProperty(e, "getIndexedAccountPath", { enumerable: !0, get: function() {
      return r.getIndexedAccountPath;
    } }), Object.defineProperty(e, "HDNodeWallet", { enumerable: !0, get: function() {
      return r.HDNodeWallet;
    } }), Object.defineProperty(e, "HDNodeVoidWallet", { enumerable: !0, get: function() {
      return r.HDNodeVoidWallet;
    } });
    var n = C7();
    Object.defineProperty(e, "isCrowdsaleJson", { enumerable: !0, get: function() {
      return n.isCrowdsaleJson;
    } }), Object.defineProperty(e, "decryptCrowdsaleJson", { enumerable: !0, get: function() {
      return n.decryptCrowdsaleJson;
    } });
    var s = sg();
    Object.defineProperty(e, "isKeystoreJson", { enumerable: !0, get: function() {
      return s.isKeystoreJson;
    } }), Object.defineProperty(e, "decryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return s.decryptKeystoreJsonSync;
    } }), Object.defineProperty(e, "decryptKeystoreJson", { enumerable: !0, get: function() {
      return s.decryptKeystoreJson;
    } }), Object.defineProperty(e, "encryptKeystoreJson", { enumerable: !0, get: function() {
      return s.encryptKeystoreJson;
    } }), Object.defineProperty(e, "encryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return s.encryptKeystoreJsonSync;
    } });
    var i = ig();
    Object.defineProperty(e, "Mnemonic", { enumerable: !0, get: function() {
      return i.Mnemonic;
    } });
    var a = TI();
    Object.defineProperty(e, "Wallet", { enumerable: !0, get: function() {
      return a.Wallet;
    } });
  }(Iw)), Iw;
}
var t4 = {}, w0 = {}, v0 = {}, A0 = {}, r4;
function SI() {
  if (r4)
    return A0;
  r4 = 1, Object.defineProperty(A0, "__esModule", { value: !0 }), A0.decodeBits = void 0;
  const e = ")!@#$%^&*(ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_";
  function t(r, n) {
    const s = (1 << r) - 1, i = [];
    let a = 0, f = 0, d = 0;
    for (let c = 0; c < n.length; c++)
      for (a = a << 6 | e.indexOf(n[c]), f += 6; f >= r; ) {
        const p = a >> f - r;
        a &= (1 << f - r) - 1, f -= r, p === 0 ? d += s : (i.push(p + d), d = 0);
      }
    return i;
  }
  return A0.decodeBits = t, A0;
}
var n4;
function MI() {
  if (n4)
    return v0;
  n4 = 1, Object.defineProperty(v0, "__esModule", { value: !0 }), v0.decodeOwlA = void 0;
  const e = vt(), t = SI(), r = T7();
  function n(s, i) {
    let a = (0, r.decodeOwl)(s).join(",");
    return i.split(/,/g).forEach((f) => {
      const d = f.match(/^([a-z]*)([0-9]+)([0-9])(.*)$/);
      (0, e.assertArgument)(d !== null, "internal error parsing accents", "accents", i);
      let c = 0;
      const p = (0, t.decodeBits)(parseInt(d[3]), d[4]), g = parseInt(d[2]), v = new RegExp(`([${d[1]}])`, "g");
      a = a.replace(v, (O, N) => (--p[c] === 0 && (N = String.fromCharCode(N.charCodeAt(0), g), c++), N));
    }), a.split(",");
  }
  return v0.decodeOwlA = n, v0;
}
var i4;
function II() {
  var e;
  if (i4)
    return w0;
  i4 = 1, Object.defineProperty(w0, "__esModule", { value: !0 }), w0.WordlistOwlA = void 0;
  const t = ng(), r = MI();
  class n extends t.WordlistOwl {
    /**
     *  Creates a new Wordlist for %%locale%% using the OWLA %%data%%
     *  and %%accent%% data and validated against the %%checksum%%.
     */
    constructor(i, a, f, d) {
      super(i, a, d), Fe(this, e, void 0), Ne(this, e, f);
    }
    /**
     *  The OWLA-encoded accent data.
     */
    get _accent() {
      return ae(this, e);
    }
    /**
     *  Decode all the words for the wordlist.
     */
    _decodeWords() {
      return (0, r.decodeOwlA)(this._data, this._accent);
    }
  }
  return e = /* @__PURE__ */ new WeakMap(), w0.WordlistOwlA = n, w0;
}
var E0 = {}, s4;
function RI() {
  if (s4)
    return E0;
  s4 = 1, Object.defineProperty(E0, "__esModule", { value: !0 }), E0.wordlists = void 0;
  const e = wf();
  return E0.wordlists = {
    en: e.LangEn.wordlist()
  }, E0;
}
var o4;
function CI() {
  return o4 || (o4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.wordlists = e.WordlistOwlA = e.WordlistOwl = e.LangEn = e.Wordlist = void 0;
    var t = k7();
    Object.defineProperty(e, "Wordlist", { enumerable: !0, get: function() {
      return t.Wordlist;
    } });
    var r = wf();
    Object.defineProperty(e, "LangEn", { enumerable: !0, get: function() {
      return r.LangEn;
    } });
    var n = ng();
    Object.defineProperty(e, "WordlistOwl", { enumerable: !0, get: function() {
      return n.WordlistOwl;
    } });
    var s = II();
    Object.defineProperty(e, "WordlistOwlA", { enumerable: !0, get: function() {
      return s.WordlistOwlA;
    } });
    var i = RI();
    Object.defineProperty(e, "wordlists", { enumerable: !0, get: function() {
      return i.wordlists;
    } });
  }(t4)), t4;
}
var a4;
function u4() {
  return a4 || (a4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ripemd160 = e.keccak256 = e.randomBytes = e.computeHmac = e.UndecodedEventLog = e.EventLog = e.ContractUnknownEventPayload = e.ContractTransactionResponse = e.ContractTransactionReceipt = e.ContractEventPayload = e.ContractFactory = e.Contract = e.BaseContract = e.MessagePrefix = e.EtherSymbol = e.ZeroHash = e.N = e.MaxInt256 = e.MinInt256 = e.MaxUint256 = e.WeiPerEther = e.ZeroAddress = e.resolveAddress = e.isAddress = e.isAddressable = e.getCreate2Address = e.getCreateAddress = e.getIcapAddress = e.getAddress = e.Typed = e.TransactionDescription = e.Result = e.LogDescription = e.Interface = e.Indexed = e.ErrorDescription = e.checkResultErrors = e.StructFragment = e.ParamType = e.NamedFragment = e.FunctionFragment = e.FallbackFragment = e.Fragment = e.EventFragment = e.ErrorFragment = e.ConstructorFragment = e.AbiCoder = e.encodeBytes32String = e.decodeBytes32String = e.version = void 0, e.EnsPlugin = e.Network = e.EnsResolver = e.WebSocketProvider = e.SocketProvider = e.IpcSocketProvider = e.QuickNodeProvider = e.PocketProvider = e.InfuraWebSocketProvider = e.InfuraProvider = e.EtherscanProvider = e.CloudflareProvider = e.ChainstackProvider = e.AnkrProvider = e.AlchemyProvider = e.BrowserProvider = e.JsonRpcSigner = e.JsonRpcProvider = e.JsonRpcApiProvider = e.FallbackProvider = e.AbstractProvider = e.VoidSigner = e.NonceManager = e.AbstractSigner = e.TransactionResponse = e.TransactionReceipt = e.Log = e.FeeData = e.Block = e.getDefaultProvider = e.verifyTypedData = e.TypedDataEncoder = e.solidityPackedSha256 = e.solidityPackedKeccak256 = e.solidityPacked = e.verifyMessage = e.hashMessage = e.dnsEncode = e.namehash = e.isValidName = e.ensNormalize = e.id = e.SigningKey = e.Signature = e.lock = e.scryptSync = e.scrypt = e.pbkdf2 = e.sha512 = e.sha256 = void 0, e.getUint = e.getNumber = e.getBigInt = e.FixedNumber = e.FetchCancelSignal = e.FetchResponse = e.FetchRequest = e.EventPayload = e.isError = e.isCallException = e.makeError = e.assertPrivate = e.assertNormalize = e.assertArgumentCount = e.assertArgument = e.assert = e.resolveProperties = e.defineProperties = e.zeroPadValue = e.zeroPadBytes = e.stripZerosLeft = e.isBytesLike = e.isHexString = e.hexlify = e.getBytesCopy = e.getBytes = e.dataSlice = e.dataLength = e.concat = e.encodeBase64 = e.decodeBase64 = e.encodeBase58 = e.decodeBase58 = e.Transaction = e.recoverAddress = e.computeAddress = e.accessListify = e.showThrottleMessage = e.copyRequest = e.UnmanagedSubscriber = e.SocketSubscriber = e.SocketPendingSubscriber = e.SocketEventSubscriber = e.SocketBlockSubscriber = e.MulticoinProviderPlugin = e.NetworkPlugin = e.GasCostPlugin = e.FetchUrlFeeDataNetworkPlugin = e.FeeDataNetworkPlugin = e.EtherscanPlugin = void 0, e.wordlists = e.WordlistOwlA = e.WordlistOwl = e.LangEn = e.Wordlist = e.encryptKeystoreJsonSync = e.encryptKeystoreJson = e.decryptKeystoreJson = e.decryptKeystoreJsonSync = e.decryptCrowdsaleJson = e.isKeystoreJson = e.isCrowdsaleJson = e.getIndexedAccountPath = e.getAccountPath = e.defaultPath = e.Wallet = e.HDNodeVoidWallet = e.HDNodeWallet = e.BaseWallet = e.Mnemonic = e.uuidV4 = e.encodeRlp = e.decodeRlp = e.Utf8ErrorFuncs = e.toUtf8String = e.toUtf8CodePoints = e.toUtf8Bytes = e.parseUnits = e.formatUnits = e.parseEther = e.formatEther = e.mask = e.toTwos = e.fromTwos = e.toQuantity = e.toNumber = e.toBeHex = e.toBigInt = e.toBeArray = void 0;
    var t = z1();
    Object.defineProperty(e, "version", { enumerable: !0, get: function() {
      return t.version;
    } });
    var r = Ed();
    Object.defineProperty(e, "decodeBytes32String", { enumerable: !0, get: function() {
      return r.decodeBytes32String;
    } }), Object.defineProperty(e, "encodeBytes32String", { enumerable: !0, get: function() {
      return r.encodeBytes32String;
    } }), Object.defineProperty(e, "AbiCoder", { enumerable: !0, get: function() {
      return r.AbiCoder;
    } }), Object.defineProperty(e, "ConstructorFragment", { enumerable: !0, get: function() {
      return r.ConstructorFragment;
    } }), Object.defineProperty(e, "ErrorFragment", { enumerable: !0, get: function() {
      return r.ErrorFragment;
    } }), Object.defineProperty(e, "EventFragment", { enumerable: !0, get: function() {
      return r.EventFragment;
    } }), Object.defineProperty(e, "Fragment", { enumerable: !0, get: function() {
      return r.Fragment;
    } }), Object.defineProperty(e, "FallbackFragment", { enumerable: !0, get: function() {
      return r.FallbackFragment;
    } }), Object.defineProperty(e, "FunctionFragment", { enumerable: !0, get: function() {
      return r.FunctionFragment;
    } }), Object.defineProperty(e, "NamedFragment", { enumerable: !0, get: function() {
      return r.NamedFragment;
    } }), Object.defineProperty(e, "ParamType", { enumerable: !0, get: function() {
      return r.ParamType;
    } }), Object.defineProperty(e, "StructFragment", { enumerable: !0, get: function() {
      return r.StructFragment;
    } }), Object.defineProperty(e, "checkResultErrors", { enumerable: !0, get: function() {
      return r.checkResultErrors;
    } }), Object.defineProperty(e, "ErrorDescription", { enumerable: !0, get: function() {
      return r.ErrorDescription;
    } }), Object.defineProperty(e, "Indexed", { enumerable: !0, get: function() {
      return r.Indexed;
    } }), Object.defineProperty(e, "Interface", { enumerable: !0, get: function() {
      return r.Interface;
    } }), Object.defineProperty(e, "LogDescription", { enumerable: !0, get: function() {
      return r.LogDescription;
    } }), Object.defineProperty(e, "Result", { enumerable: !0, get: function() {
      return r.Result;
    } }), Object.defineProperty(e, "TransactionDescription", { enumerable: !0, get: function() {
      return r.TransactionDescription;
    } }), Object.defineProperty(e, "Typed", { enumerable: !0, get: function() {
      return r.Typed;
    } });
    var n = Xr();
    Object.defineProperty(e, "getAddress", { enumerable: !0, get: function() {
      return n.getAddress;
    } }), Object.defineProperty(e, "getIcapAddress", { enumerable: !0, get: function() {
      return n.getIcapAddress;
    } }), Object.defineProperty(e, "getCreateAddress", { enumerable: !0, get: function() {
      return n.getCreateAddress;
    } }), Object.defineProperty(e, "getCreate2Address", { enumerable: !0, get: function() {
      return n.getCreate2Address;
    } }), Object.defineProperty(e, "isAddressable", { enumerable: !0, get: function() {
      return n.isAddressable;
    } }), Object.defineProperty(e, "isAddress", { enumerable: !0, get: function() {
      return n.isAddress;
    } }), Object.defineProperty(e, "resolveAddress", { enumerable: !0, get: function() {
      return n.resolveAddress;
    } });
    var s = Ad();
    Object.defineProperty(e, "ZeroAddress", { enumerable: !0, get: function() {
      return s.ZeroAddress;
    } }), Object.defineProperty(e, "WeiPerEther", { enumerable: !0, get: function() {
      return s.WeiPerEther;
    } }), Object.defineProperty(e, "MaxUint256", { enumerable: !0, get: function() {
      return s.MaxUint256;
    } }), Object.defineProperty(e, "MinInt256", { enumerable: !0, get: function() {
      return s.MinInt256;
    } }), Object.defineProperty(e, "MaxInt256", { enumerable: !0, get: function() {
      return s.MaxInt256;
    } }), Object.defineProperty(e, "N", { enumerable: !0, get: function() {
      return s.N;
    } }), Object.defineProperty(e, "ZeroHash", { enumerable: !0, get: function() {
      return s.ZeroHash;
    } }), Object.defineProperty(e, "EtherSymbol", { enumerable: !0, get: function() {
      return s.EtherSymbol;
    } }), Object.defineProperty(e, "MessagePrefix", { enumerable: !0, get: function() {
      return s.MessagePrefix;
    } });
    var i = bf();
    Object.defineProperty(e, "BaseContract", { enumerable: !0, get: function() {
      return i.BaseContract;
    } }), Object.defineProperty(e, "Contract", { enumerable: !0, get: function() {
      return i.Contract;
    } }), Object.defineProperty(e, "ContractFactory", { enumerable: !0, get: function() {
      return i.ContractFactory;
    } }), Object.defineProperty(e, "ContractEventPayload", { enumerable: !0, get: function() {
      return i.ContractEventPayload;
    } }), Object.defineProperty(e, "ContractTransactionReceipt", { enumerable: !0, get: function() {
      return i.ContractTransactionReceipt;
    } }), Object.defineProperty(e, "ContractTransactionResponse", { enumerable: !0, get: function() {
      return i.ContractTransactionResponse;
    } }), Object.defineProperty(e, "ContractUnknownEventPayload", { enumerable: !0, get: function() {
      return i.ContractUnknownEventPayload;
    } }), Object.defineProperty(e, "EventLog", { enumerable: !0, get: function() {
      return i.EventLog;
    } }), Object.defineProperty(e, "UndecodedEventLog", { enumerable: !0, get: function() {
      return i.UndecodedEventLog;
    } });
    var a = ln();
    Object.defineProperty(e, "computeHmac", { enumerable: !0, get: function() {
      return a.computeHmac;
    } }), Object.defineProperty(e, "randomBytes", { enumerable: !0, get: function() {
      return a.randomBytes;
    } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
      return a.keccak256;
    } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
      return a.ripemd160;
    } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
      return a.sha256;
    } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
      return a.sha512;
    } }), Object.defineProperty(e, "pbkdf2", { enumerable: !0, get: function() {
      return a.pbkdf2;
    } }), Object.defineProperty(e, "scrypt", { enumerable: !0, get: function() {
      return a.scrypt;
    } }), Object.defineProperty(e, "scryptSync", { enumerable: !0, get: function() {
      return a.scryptSync;
    } }), Object.defineProperty(e, "lock", { enumerable: !0, get: function() {
      return a.lock;
    } }), Object.defineProperty(e, "Signature", { enumerable: !0, get: function() {
      return a.Signature;
    } }), Object.defineProperty(e, "SigningKey", { enumerable: !0, get: function() {
      return a.SigningKey;
    } });
    var f = so();
    Object.defineProperty(e, "id", { enumerable: !0, get: function() {
      return f.id;
    } }), Object.defineProperty(e, "ensNormalize", { enumerable: !0, get: function() {
      return f.ensNormalize;
    } }), Object.defineProperty(e, "isValidName", { enumerable: !0, get: function() {
      return f.isValidName;
    } }), Object.defineProperty(e, "namehash", { enumerable: !0, get: function() {
      return f.namehash;
    } }), Object.defineProperty(e, "dnsEncode", { enumerable: !0, get: function() {
      return f.dnsEncode;
    } }), Object.defineProperty(e, "hashMessage", { enumerable: !0, get: function() {
      return f.hashMessage;
    } }), Object.defineProperty(e, "verifyMessage", { enumerable: !0, get: function() {
      return f.verifyMessage;
    } }), Object.defineProperty(e, "solidityPacked", { enumerable: !0, get: function() {
      return f.solidityPacked;
    } }), Object.defineProperty(e, "solidityPackedKeccak256", { enumerable: !0, get: function() {
      return f.solidityPackedKeccak256;
    } }), Object.defineProperty(e, "solidityPackedSha256", { enumerable: !0, get: function() {
      return f.solidityPackedSha256;
    } }), Object.defineProperty(e, "TypedDataEncoder", { enumerable: !0, get: function() {
      return f.TypedDataEncoder;
    } }), Object.defineProperty(e, "verifyTypedData", { enumerable: !0, get: function() {
      return f.verifyTypedData;
    } });
    var d = tg();
    Object.defineProperty(e, "getDefaultProvider", { enumerable: !0, get: function() {
      return d.getDefaultProvider;
    } }), Object.defineProperty(e, "Block", { enumerable: !0, get: function() {
      return d.Block;
    } }), Object.defineProperty(e, "FeeData", { enumerable: !0, get: function() {
      return d.FeeData;
    } }), Object.defineProperty(e, "Log", { enumerable: !0, get: function() {
      return d.Log;
    } }), Object.defineProperty(e, "TransactionReceipt", { enumerable: !0, get: function() {
      return d.TransactionReceipt;
    } }), Object.defineProperty(e, "TransactionResponse", { enumerable: !0, get: function() {
      return d.TransactionResponse;
    } }), Object.defineProperty(e, "AbstractSigner", { enumerable: !0, get: function() {
      return d.AbstractSigner;
    } }), Object.defineProperty(e, "NonceManager", { enumerable: !0, get: function() {
      return d.NonceManager;
    } }), Object.defineProperty(e, "VoidSigner", { enumerable: !0, get: function() {
      return d.VoidSigner;
    } }), Object.defineProperty(e, "AbstractProvider", { enumerable: !0, get: function() {
      return d.AbstractProvider;
    } }), Object.defineProperty(e, "FallbackProvider", { enumerable: !0, get: function() {
      return d.FallbackProvider;
    } }), Object.defineProperty(e, "JsonRpcApiProvider", { enumerable: !0, get: function() {
      return d.JsonRpcApiProvider;
    } }), Object.defineProperty(e, "JsonRpcProvider", { enumerable: !0, get: function() {
      return d.JsonRpcProvider;
    } }), Object.defineProperty(e, "JsonRpcSigner", { enumerable: !0, get: function() {
      return d.JsonRpcSigner;
    } }), Object.defineProperty(e, "BrowserProvider", { enumerable: !0, get: function() {
      return d.BrowserProvider;
    } }), Object.defineProperty(e, "AlchemyProvider", { enumerable: !0, get: function() {
      return d.AlchemyProvider;
    } }), Object.defineProperty(e, "AnkrProvider", { enumerable: !0, get: function() {
      return d.AnkrProvider;
    } }), Object.defineProperty(e, "ChainstackProvider", { enumerable: !0, get: function() {
      return d.ChainstackProvider;
    } }), Object.defineProperty(e, "CloudflareProvider", { enumerable: !0, get: function() {
      return d.CloudflareProvider;
    } }), Object.defineProperty(e, "EtherscanProvider", { enumerable: !0, get: function() {
      return d.EtherscanProvider;
    } }), Object.defineProperty(e, "InfuraProvider", { enumerable: !0, get: function() {
      return d.InfuraProvider;
    } }), Object.defineProperty(e, "InfuraWebSocketProvider", { enumerable: !0, get: function() {
      return d.InfuraWebSocketProvider;
    } }), Object.defineProperty(e, "PocketProvider", { enumerable: !0, get: function() {
      return d.PocketProvider;
    } }), Object.defineProperty(e, "QuickNodeProvider", { enumerable: !0, get: function() {
      return d.QuickNodeProvider;
    } }), Object.defineProperty(e, "IpcSocketProvider", { enumerable: !0, get: function() {
      return d.IpcSocketProvider;
    } }), Object.defineProperty(e, "SocketProvider", { enumerable: !0, get: function() {
      return d.SocketProvider;
    } }), Object.defineProperty(e, "WebSocketProvider", { enumerable: !0, get: function() {
      return d.WebSocketProvider;
    } }), Object.defineProperty(e, "EnsResolver", { enumerable: !0, get: function() {
      return d.EnsResolver;
    } }), Object.defineProperty(e, "Network", { enumerable: !0, get: function() {
      return d.Network;
    } }), Object.defineProperty(e, "EnsPlugin", { enumerable: !0, get: function() {
      return d.EnsPlugin;
    } }), Object.defineProperty(e, "EtherscanPlugin", { enumerable: !0, get: function() {
      return d.EtherscanPlugin;
    } }), Object.defineProperty(e, "FeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return d.FeeDataNetworkPlugin;
    } }), Object.defineProperty(e, "FetchUrlFeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return d.FetchUrlFeeDataNetworkPlugin;
    } }), Object.defineProperty(e, "GasCostPlugin", { enumerable: !0, get: function() {
      return d.GasCostPlugin;
    } }), Object.defineProperty(e, "NetworkPlugin", { enumerable: !0, get: function() {
      return d.NetworkPlugin;
    } }), Object.defineProperty(e, "MulticoinProviderPlugin", { enumerable: !0, get: function() {
      return d.MulticoinProviderPlugin;
    } }), Object.defineProperty(e, "SocketBlockSubscriber", { enumerable: !0, get: function() {
      return d.SocketBlockSubscriber;
    } }), Object.defineProperty(e, "SocketEventSubscriber", { enumerable: !0, get: function() {
      return d.SocketEventSubscriber;
    } }), Object.defineProperty(e, "SocketPendingSubscriber", { enumerable: !0, get: function() {
      return d.SocketPendingSubscriber;
    } }), Object.defineProperty(e, "SocketSubscriber", { enumerable: !0, get: function() {
      return d.SocketSubscriber;
    } }), Object.defineProperty(e, "UnmanagedSubscriber", { enumerable: !0, get: function() {
      return d.UnmanagedSubscriber;
    } }), Object.defineProperty(e, "copyRequest", { enumerable: !0, get: function() {
      return d.copyRequest;
    } }), Object.defineProperty(e, "showThrottleMessage", { enumerable: !0, get: function() {
      return d.showThrottleMessage;
    } });
    var c = ei();
    Object.defineProperty(e, "accessListify", { enumerable: !0, get: function() {
      return c.accessListify;
    } }), Object.defineProperty(e, "computeAddress", { enumerable: !0, get: function() {
      return c.computeAddress;
    } }), Object.defineProperty(e, "recoverAddress", { enumerable: !0, get: function() {
      return c.recoverAddress;
    } }), Object.defineProperty(e, "Transaction", { enumerable: !0, get: function() {
      return c.Transaction;
    } });
    var p = vt();
    Object.defineProperty(e, "decodeBase58", { enumerable: !0, get: function() {
      return p.decodeBase58;
    } }), Object.defineProperty(e, "encodeBase58", { enumerable: !0, get: function() {
      return p.encodeBase58;
    } }), Object.defineProperty(e, "decodeBase64", { enumerable: !0, get: function() {
      return p.decodeBase64;
    } }), Object.defineProperty(e, "encodeBase64", { enumerable: !0, get: function() {
      return p.encodeBase64;
    } }), Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
      return p.concat;
    } }), Object.defineProperty(e, "dataLength", { enumerable: !0, get: function() {
      return p.dataLength;
    } }), Object.defineProperty(e, "dataSlice", { enumerable: !0, get: function() {
      return p.dataSlice;
    } }), Object.defineProperty(e, "getBytes", { enumerable: !0, get: function() {
      return p.getBytes;
    } }), Object.defineProperty(e, "getBytesCopy", { enumerable: !0, get: function() {
      return p.getBytesCopy;
    } }), Object.defineProperty(e, "hexlify", { enumerable: !0, get: function() {
      return p.hexlify;
    } }), Object.defineProperty(e, "isHexString", { enumerable: !0, get: function() {
      return p.isHexString;
    } }), Object.defineProperty(e, "isBytesLike", { enumerable: !0, get: function() {
      return p.isBytesLike;
    } }), Object.defineProperty(e, "stripZerosLeft", { enumerable: !0, get: function() {
      return p.stripZerosLeft;
    } }), Object.defineProperty(e, "zeroPadBytes", { enumerable: !0, get: function() {
      return p.zeroPadBytes;
    } }), Object.defineProperty(e, "zeroPadValue", { enumerable: !0, get: function() {
      return p.zeroPadValue;
    } }), Object.defineProperty(e, "defineProperties", { enumerable: !0, get: function() {
      return p.defineProperties;
    } }), Object.defineProperty(e, "resolveProperties", { enumerable: !0, get: function() {
      return p.resolveProperties;
    } }), Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
      return p.assert;
    } }), Object.defineProperty(e, "assertArgument", { enumerable: !0, get: function() {
      return p.assertArgument;
    } }), Object.defineProperty(e, "assertArgumentCount", { enumerable: !0, get: function() {
      return p.assertArgumentCount;
    } }), Object.defineProperty(e, "assertNormalize", { enumerable: !0, get: function() {
      return p.assertNormalize;
    } }), Object.defineProperty(e, "assertPrivate", { enumerable: !0, get: function() {
      return p.assertPrivate;
    } }), Object.defineProperty(e, "makeError", { enumerable: !0, get: function() {
      return p.makeError;
    } }), Object.defineProperty(e, "isCallException", { enumerable: !0, get: function() {
      return p.isCallException;
    } }), Object.defineProperty(e, "isError", { enumerable: !0, get: function() {
      return p.isError;
    } }), Object.defineProperty(e, "EventPayload", { enumerable: !0, get: function() {
      return p.EventPayload;
    } }), Object.defineProperty(e, "FetchRequest", { enumerable: !0, get: function() {
      return p.FetchRequest;
    } }), Object.defineProperty(e, "FetchResponse", { enumerable: !0, get: function() {
      return p.FetchResponse;
    } }), Object.defineProperty(e, "FetchCancelSignal", { enumerable: !0, get: function() {
      return p.FetchCancelSignal;
    } }), Object.defineProperty(e, "FixedNumber", { enumerable: !0, get: function() {
      return p.FixedNumber;
    } }), Object.defineProperty(e, "getBigInt", { enumerable: !0, get: function() {
      return p.getBigInt;
    } }), Object.defineProperty(e, "getNumber", { enumerable: !0, get: function() {
      return p.getNumber;
    } }), Object.defineProperty(e, "getUint", { enumerable: !0, get: function() {
      return p.getUint;
    } }), Object.defineProperty(e, "toBeArray", { enumerable: !0, get: function() {
      return p.toBeArray;
    } }), Object.defineProperty(e, "toBigInt", { enumerable: !0, get: function() {
      return p.toBigInt;
    } }), Object.defineProperty(e, "toBeHex", { enumerable: !0, get: function() {
      return p.toBeHex;
    } }), Object.defineProperty(e, "toNumber", { enumerable: !0, get: function() {
      return p.toNumber;
    } }), Object.defineProperty(e, "toQuantity", { enumerable: !0, get: function() {
      return p.toQuantity;
    } }), Object.defineProperty(e, "fromTwos", { enumerable: !0, get: function() {
      return p.fromTwos;
    } }), Object.defineProperty(e, "toTwos", { enumerable: !0, get: function() {
      return p.toTwos;
    } }), Object.defineProperty(e, "mask", { enumerable: !0, get: function() {
      return p.mask;
    } }), Object.defineProperty(e, "formatEther", { enumerable: !0, get: function() {
      return p.formatEther;
    } }), Object.defineProperty(e, "parseEther", { enumerable: !0, get: function() {
      return p.parseEther;
    } }), Object.defineProperty(e, "formatUnits", { enumerable: !0, get: function() {
      return p.formatUnits;
    } }), Object.defineProperty(e, "parseUnits", { enumerable: !0, get: function() {
      return p.parseUnits;
    } }), Object.defineProperty(e, "toUtf8Bytes", { enumerable: !0, get: function() {
      return p.toUtf8Bytes;
    } }), Object.defineProperty(e, "toUtf8CodePoints", { enumerable: !0, get: function() {
      return p.toUtf8CodePoints;
    } }), Object.defineProperty(e, "toUtf8String", { enumerable: !0, get: function() {
      return p.toUtf8String;
    } }), Object.defineProperty(e, "Utf8ErrorFuncs", { enumerable: !0, get: function() {
      return p.Utf8ErrorFuncs;
    } }), Object.defineProperty(e, "decodeRlp", { enumerable: !0, get: function() {
      return p.decodeRlp;
    } }), Object.defineProperty(e, "encodeRlp", { enumerable: !0, get: function() {
      return p.encodeRlp;
    } }), Object.defineProperty(e, "uuidV4", { enumerable: !0, get: function() {
      return p.uuidV4;
    } });
    var g = kI();
    Object.defineProperty(e, "Mnemonic", { enumerable: !0, get: function() {
      return g.Mnemonic;
    } }), Object.defineProperty(e, "BaseWallet", { enumerable: !0, get: function() {
      return g.BaseWallet;
    } }), Object.defineProperty(e, "HDNodeWallet", { enumerable: !0, get: function() {
      return g.HDNodeWallet;
    } }), Object.defineProperty(e, "HDNodeVoidWallet", { enumerable: !0, get: function() {
      return g.HDNodeVoidWallet;
    } }), Object.defineProperty(e, "Wallet", { enumerable: !0, get: function() {
      return g.Wallet;
    } }), Object.defineProperty(e, "defaultPath", { enumerable: !0, get: function() {
      return g.defaultPath;
    } }), Object.defineProperty(e, "getAccountPath", { enumerable: !0, get: function() {
      return g.getAccountPath;
    } }), Object.defineProperty(e, "getIndexedAccountPath", { enumerable: !0, get: function() {
      return g.getIndexedAccountPath;
    } }), Object.defineProperty(e, "isCrowdsaleJson", { enumerable: !0, get: function() {
      return g.isCrowdsaleJson;
    } }), Object.defineProperty(e, "isKeystoreJson", { enumerable: !0, get: function() {
      return g.isKeystoreJson;
    } }), Object.defineProperty(e, "decryptCrowdsaleJson", { enumerable: !0, get: function() {
      return g.decryptCrowdsaleJson;
    } }), Object.defineProperty(e, "decryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return g.decryptKeystoreJsonSync;
    } }), Object.defineProperty(e, "decryptKeystoreJson", { enumerable: !0, get: function() {
      return g.decryptKeystoreJson;
    } }), Object.defineProperty(e, "encryptKeystoreJson", { enumerable: !0, get: function() {
      return g.encryptKeystoreJson;
    } }), Object.defineProperty(e, "encryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return g.encryptKeystoreJsonSync;
    } });
    var v = CI();
    Object.defineProperty(e, "Wordlist", { enumerable: !0, get: function() {
      return v.Wordlist;
    } }), Object.defineProperty(e, "LangEn", { enumerable: !0, get: function() {
      return v.LangEn;
    } }), Object.defineProperty(e, "WordlistOwl", { enumerable: !0, get: function() {
      return v.WordlistOwl;
    } }), Object.defineProperty(e, "WordlistOwlA", { enumerable: !0, get: function() {
      return v.WordlistOwlA;
    } }), Object.defineProperty(e, "wordlists", { enumerable: !0, get: function() {
      return v.wordlists;
    } });
  }(ob)), ob;
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ethers = void 0;
  const t = wM, r = t.__importStar(u4());
  e.ethers = r, t.__exportStar(u4(), e);
})($8);
Object.defineProperty(nc, "__esModule", { value: !0 });
nc.parseEthersError = nc.TransactionErrors = void 0;
const lu = $8;
var ui;
(function(e) {
  e[e.REJECTED = 0] = "REJECTED", e[e.REPLACED = 1] = "REPLACED", e[e.CANCELLED = 2] = "CANCELLED", e[e.EXCEPTION = 3] = "EXCEPTION", e[e.LEDGER_ERROR = 4] = "LEDGER_ERROR", e[e.INSUFFICIENT_FUNDS = 5] = "INSUFFICIENT_FUNDS", e[e.PENDING = 6] = "PENDING", e[e.OTHER = 7] = "OTHER";
})(ui || (nc.TransactionErrors = ui = {}));
const BI = (e) => (0, lu.isError)(e, "ACTION_REJECTED") ? ui.REJECTED : (0, lu.isError)(e, "TRANSACTION_REPLACED") ? ui.REPLACED : (0, lu.isError)(e, "INSUFFICIENT_FUNDS") ? ui.INSUFFICIENT_FUNDS : e.message.includes("Ledger") ? ui.LEDGER_ERROR : e.message.includes("UserRefusedOnDevice") ? ui.REJECTED : parseInt(e.code) === -32002 && e.message && e.message.includes("pending") ? (console.warn("Transaction pending in wallet error"), ui.PENDING) : e.message.includes("cancelled") && !(e != null && e.cancelled) ? ui.REJECTED : (0, lu.isError)(e, "CANCELLED") ? ui.CANCELLED : (0, lu.isError)(e, "CALL_EXCEPTION") ? ui.EXCEPTION : ((0, lu.isError)(e, "UNKNOWN_ERROR"), ui.OTHER);
nc.parseEthersError = BI;
var _I = nr && nr.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var s = Object.getOwnPropertyDescriptor(t, r);
  (!s || ("get" in s ? !t.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, s);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), FI = nr && nr.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), es = nr && nr.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && _I(t, e, r);
  return FI(t, e), t;
};
Object.defineProperty(Fr, "__esModule", { value: !0 });
Fr.Misc = Fr.StringUtils = Fr.Web3TransactionError = Fr.Cookies = Fr.Media = Fr.URLs = S0 = Fr.Network = Fr.Constants = Fr.Currency = Fr.ProviderEvents = Fr.Countdown = void 0;
const UI = es(ec);
Fr.Constants = UI;
const DI = es(O8);
Fr.Cookies = DI;
const jI = es(tc);
Fr.Countdown = jI;
const LI = es(fi);
Fr.Currency = LI;
const HI = es(L8);
Fr.Media = HI;
const WI = es(hs);
Fr.Misc = WI;
const GI = es(pf);
var S0 = Fr.Network = GI;
const zI = es(j1);
Fr.ProviderEvents = zI;
const VI = es(pi);
Fr.StringUtils = VI;
const qI = es(kr);
Fr.URLs = qI;
const $I = es(nc);
Fr.Web3TransactionError = $I;
var og = ((e) => (e[e.MAINNET = S0.NETWORK_IDS.MAINNET] = "MAINNET", e[e.OPTIMISM = S0.NETWORK_IDS.OPTIMISM] = "OPTIMISM", e[e.BASE = S0.NETWORK_IDS.BASE] = "BASE", e[e.SEPOLIA = S0.NETWORK_IDS.SEPOLIA] = "SEPOLIA", e))(og || {});
const KI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Constant: P8,
  FieldType: zr,
  SupportedNetwork: og
}, Symbol.toStringTag, { value: "Module" }));
function JI(e) {
  return e in og;
}
const QI = "(mainnet, sepolia, optimism, base)";
function ZI(e) {
  if (!e.length)
    throw new Error("[マ Studio App SDK Error]: Expected at least 1 network value; received 0.");
  const t = [];
  for (const r of e) {
    if (typeof r != "number")
      throw new Error(
        "[マ Studio App SDK Error]: Non-number network provided. Expected network values to all be numbers."
      );
    JI(r) || t.push(r);
  }
  if (t.length)
    throw new Error(
      `[マ Studio App SDK Error]: Unsupported network value(s) provided. Please use the supported networks ${QI} instead. Invalid network value(s): ${t.join(
        ", "
      )}.`
    );
  return !0;
}
function YI(e) {
  let t = "";
  if (e.clearOnPublish && (e.isImmutable && (t += "isImmutable=true"), e.isPublic && (t += `${t.length ? ", " : ""}isPublic=true`)), t.length)
    throw new Error(
      `[マ Studio App SDK Error]: ${t} cannot co-exist with clearOnPublish=true.`
    );
  return !0;
}
function XI(e) {
  const t = [];
  if (Object.entries(e).forEach(([r, n]) => {
    (n.isImmutable !== void 0 || n.isPublic !== void 0 || n.clearOnPublish !== void 0) && t.push("'" + r + "'");
  }), t.length)
    throw new Error(
      `[マ Studio App SDK Error]: Cannot specify visibility, immutability, clearability for nested fields. Invalid fields: ${t.join(
        ", "
      )}.`
    );
}
class qr {
  constructor(t) {
    Se(this, "isPublic"), Se(this, "isImmutable"), Se(this, "clearOnPublish"), Se(this, "_output"), t && YI(t) && (t.clearOnPublish ? this.clearOnPublish = !0 : (this.isPublic = t.isPublic, this.isImmutable = t.isImmutable));
  }
}
class eR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.Address);
  }
}
class tR extends qr {
  constructor(t, r) {
    super(r), Se(this, "type", zr.Array), Se(this, "items"), this.items = t;
  }
}
class rR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.Asset);
  }
}
class nR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.AssetSeries);
  }
}
class iR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.AudienceBlueprint);
  }
}
class sR extends qr {
  constructor(t, r) {
    super(r), Se(this, "type", zr.InstanceAllowlist), Se(this, "indexed"), this.indexed = t;
  }
}
class oR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.InstanceBlueprint);
  }
}
class aR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.Boolean);
  }
}
class B7 extends qr {
  constructor(t, r) {
    super({ isImmutable: r == null ? void 0 : r.isImmutable, isPublic: !0 }), Se(this, "type", zr.Contract), Se(this, "network"), this.network = t;
  }
}
class uR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.Date);
  }
}
class cR extends qr {
  constructor(t, r) {
    super(r), Se(this, "type", zr.Enum), Se(this, "values"), this.values = t;
  }
}
class lR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.File);
  }
}
class Ru extends qr {
  /**
   * private constructor to request constructing through the static methods.
   *
   * @param values - The networks that this field will support
   * @param options - type inferred from the type options (Clearable, Nested) passed in. If nested,
   *                  the expected type of `options` has `isImmutable` and `isPublic` as
   *                  `undefined`. If clearable, the expected type of `options` has
   *                  `clearOnPublish` set to `true`. If neither, the expected type of `options`
   *                  has `isImmutable` and `isPublic` as `true`.
   */
  constructor(t, r) {
    super(
      r
    ), Se(this, "type", zr.Network), Se(this, "values"), ZI(t), this.values = t;
  }
  /**
   * @param values - The networks that this field will support
   * @param options - options that determine how the field is constructed.
   *                  keeping `clearOnPublish` to offer a similar API to other fields
   * @returns if options.nested is true: a network field with `isImmutable` and `isPublic` set to
   *                                     undefined.
   *          if options.clearOnPublish is true: a network field with `clearOnPublish` set to `true`
   *                                             and `isImmutable` and `isPublic` set to undefined.
   *          if neither, a network field with `isImmutable` and `isPublic` set to true.
   */
  static create(t, r) {
    if (r != null && r.nested && r != null && r.clearOnPublish)
      throw new Error(
        "[マ Studio App SDK Error]: A Network field cannot be both nested and clearable."
      );
    return r != null && r.nested ? new Ru(t, {
      isImmutable: void 0,
      isPublic: void 0
    }) : r != null && r.clearOnPublish ? new Ru(t, {
      clearOnPublish: !0
    }) : new Ru(t, {
      isImmutable: !0,
      isPublic: !0
    });
  }
}
class dR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.Integer);
  }
}
class _7 extends qr {
  constructor(t, r, n, s, i) {
    super(i), Se(this, "type", zr.Price), Se(this, "currencies"), Se(this, "network"), Se(this, "erc20Disabled"), Se(this, "enableCustomCurrency"), this.currencies = t, this.network = r, this.erc20Disabled = n, this.enableCustomCurrency = s;
  }
}
class hR extends qr {
  constructor(t, r, n) {
    super(n), Se(this, "type", zr.String), Se(this, "regex"), Se(this, "regexErrorMessage"), this.regex = t, this.regexErrorMessage = r;
  }
}
class F7 extends qr {
  constructor(t, r) {
    XI(t), super(r), Se(this, "type", zr.Struct), Se(this, "fields"), this.fields = t;
  }
}
class U7 extends qr {
  constructor(t, r) {
    super({ isImmutable: !0, isPublic: !0 }), Se(this, "type", zr.StudioContract), Se(this, "network"), Se(this, "specs"), this.network = t, this.specs = r;
  }
}
class fR extends qr {
  constructor() {
    super(...arguments), Se(this, "type", zr.Url);
  }
}
const D7 = {
  Address: (e) => new eR(e),
  /**
   * @warn cannot contain any of the following Field types
   *   - FieldType.Contract
   *   - FieldType.StudioContract
   *   - FieldType.Asset
   *   - FieldType.AssetSeries
   *   - FieldType.InstanceAllowlist
   */
  Array: (e, t) => new tR(e, t),
  /**
   * @dev Assets are always non-clearable.
   */
  Asset: (e) => new rR(e),
  /**
   * @dev AssetSeries are always non-clearable.
   */
  AssetSeries: (e) => new nR(e),
  AudienceBlueprint: (e) => new iR(e),
  Boolean: (e) => new aR(e),
  /**
   * @dev Constant's are always immutable, non-clearable, and public.
   */
  Constant: (e) => new P8(e),
  /**
   * @dev Contract's are always non-clearable and public.
   * @WARN Do not use currently, we have no UX support for this field type.
   */
  Contract: ({
    network: e,
    options: t
  }) => new B7(e, t),
  Date: (e) => new uR(e),
  Enum: (e, t) => new cR(e, t),
  File: (e) => new lR(e),
  InstanceAllowlist: (e, t) => new sR((e == null ? void 0 : e.indexed) ?? !1, t),
  /**
   * @dev InstanceBlueprints are always non-clearable.
   */
  InstanceBlueprint: (e) => new oR(e),
  /**
   * @dev A Network is always public and always immutable when it is a non-clearable field and a root-level field.
   */
  Network: Ru.create,
  /**
   * @dev IntegerField and f.Integer() have no validation on the BE related to min or max.
   *      That should be handled by the front end before saving to this field type.
   */
  Integer: (e) => new dR(e),
  /**
   * @note requires a `network`, which is a string that is a key in your schema
   *       which leads to a f.Network() definition.
   * @warn All f.Price() fields must be set AFTER their corresponding `network` field is set.
   *       This is because the `network` field is used to determine available currencies.
   * @warn Be sure to only ever save the integer value of the BigNumber to this field as string.
   */
  Price: ({
    currencies: e,
    network: t,
    erc20Disabled: r = !1,
    enableCustomCurrency: n = !1,
    options: s
  }) => new _7(e, t, r, n, s),
  /**
   * @dev  StringField has an optional regex and regexErrorMessage for validation.
   *       If regexErrorMessage is not provided, the default error message is used which includes the regex in the message.
   * @note regex should be escaped correctly if special characters are used.
   * @ex  '\\d+' matches any digit
   */
  String: (e) => new hR(
    e == null ? void 0 : e.regex,
    e == null ? void 0 : e.regexErrorMessage,
    e == null ? void 0 : e.options
  ),
  /**
   * @warn cannot contain any of the following fields as children
   *   - FieldType.Contract
   *   - FieldType.StudioContract
   *   - FieldType.Asset
   *   - FieldType.AssetSeries
   *   - FieldType.AudienceBlueprint
   *   - FieldType.InstanceAllowlist
   *   - FieldType.InstanceBlueprint
   */
  Struct: (e, t) => new F7(e, t),
  /**
   * @dev StudioContracts are always public, always immutable, and non-clearable.
   *      The `specs` array is optional and can be used to specify which contract specs are allowed.
   *      If no specs are provided, all contract specs are allowed.
   *      The `network` field must be a string that is a key in your schema
   *      which leads to a f.Network() definition.
   */
  StudioContract: ({
    network: e,
    specs: t
  }) => new U7(e, t),
  Url: (e) => new fR(e)
};
class j7 {
  constructor(t) {
    Se(this, "fields"), this.fields = t;
  }
  /** readies the schema for any fetch requests. JSON.stringify-s any constant field types */
  serialize() {
    const t = JSON.parse(JSON.stringify(this.fields));
    for (const r in t)
      t[r].type === "constant" && (t[r].value = JSON.stringify(t[r].value)), t[r].type === "enum" && (t[r].values = t[r].values.map((n) => n.value));
    return JSON.stringify(t);
  }
}
Se(j7, "Field", D7);
class pR extends Error {
  constructor(t) {
    super(t.message), Se(this, "networkId"), this.networkId = t.networkId, this.name = "WrongNetworkError";
  }
}
const gR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WrongNetworkError: pR
}, Symbol.toStringTag, { value: "Module" })), mR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), yR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseField: qr,
  ContractField: B7,
  Errors: gR,
  InstanceSchema: j7,
  Job: mR,
  NetworkField: Ru,
  PriceField: _7,
  Schema: KI,
  StructField: F7,
  StudioContractField: U7,
  f: D7
}, Symbol.toStringTag, { value: "Module" })), du = "0x0000000000000000000000000000000000000000", vf = {
  APE: {
    coinGeckoId: "apecoin",
    erc20: {
      [pt.Mainnet]: {
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        decimals: 18
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [pt.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [pt.Base]: {
        address: void 0,
        decimals: 18
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "APE"
  },
  ASH: {
    coinGeckoId: "ash",
    erc20: {
      [pt.Mainnet]: {
        address: "0x64d91f12ece7362f91a6f8e7940cd55f05060b92",
        decimals: 18
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [pt.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [pt.Base]: {
        address: void 0,
        decimals: 18
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "ASH"
  },
  DAI: {
    coinGeckoId: "dai",
    erc20: {
      [pt.Mainnet]: {
        address: "0x6b175474e89094c44da98b954eedeac495271d0f",
        decimals: 18
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [pt.Optimism]: {
        address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
        decimals: 18
      },
      [pt.Base]: {
        address: "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
        decimals: 18
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "DAI"
  },
  ETH: {
    coinGeckoId: "ethereum",
    erc20: {
      [pt.Mainnet]: {
        address: du,
        decimals: 18
      },
      [pt.Goerli]: {
        address: du,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: du,
        decimals: 18
      },
      [pt.Optimism]: {
        address: du,
        decimals: 18
      },
      [pt.Base]: {
        address: du,
        decimals: 18
      },
      [pt.Matic]: {
        address: du,
        decimals: 18
      }
    },
    name: "ETH"
  },
  LOOKS: {
    coinGeckoId: "looksrare",
    erc20: {
      [pt.Mainnet]: {
        address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
        decimals: 18
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [pt.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [pt.Base]: {
        address: void 0,
        decimals: 18
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "LOOKS"
  },
  PEPE: {
    coinGeckoId: "pepe",
    erc20: {
      [pt.Mainnet]: {
        address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
        decimals: 18
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [pt.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [pt.Base]: {
        address: void 0,
        decimals: 18
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "PEPE"
  },
  RARE: {
    coinGeckoId: "superrare",
    erc20: {
      [pt.Mainnet]: {
        address: "0xba5bde662c17e2adff1075610382b9b691296350",
        decimals: 18
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [pt.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [pt.Base]: {
        address: void 0,
        decimals: 18
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "RARE"
  },
  TURBO: {
    coinGeckoId: "turbo",
    erc20: {
      [pt.Mainnet]: {
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        decimals: 18
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [pt.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [pt.Base]: {
        address: void 0,
        decimals: 18
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "TURBO"
  },
  USDC: {
    coinGeckoId: "usd-coin",
    erc20: {
      [pt.Mainnet]: {
        address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        decimals: 6
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 6
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 6
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 6
      },
      [pt.Optimism]: {
        address: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
        decimals: 6
      },
      [pt.Base]: {
        address: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
        decimals: 6
      }
    },
    name: "USDC"
  },
  USDT: {
    coinGeckoId: "tether",
    erc20: {
      [pt.Mainnet]: {
        address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        decimals: 6
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 6
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 6
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 6
      },
      [pt.Optimism]: {
        address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
        decimals: 6
      },
      [pt.Base]: {
        address: void 0,
        decimals: 6
      }
    },
    name: "USDT"
  },
  WETH: {
    coinGeckoId: "weth",
    erc20: {
      [pt.Mainnet]: {
        address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
        decimals: 18
      },
      [pt.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [pt.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [pt.Matic]: {
        address: void 0,
        decimals: 18
      },
      [pt.Optimism]: {
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18
      },
      [pt.Base]: {
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18
      }
    },
    name: "WETH"
  }
};
function L7(e, t) {
  return new Lu(e).toFixed(t, Lu.ROUND_UP);
}
function bR(e, t) {
  return d9(L7(e, t));
}
function wR(e) {
  switch (e) {
    case pt.Mainnet:
      return "ETH";
    case pt.Goerli:
      return "GoETH";
    case pt.Optimism:
      return "OETH";
    case pt.Base:
      return "BETH";
    default:
      return "ETH";
  }
}
function H7(e) {
  return e in vf;
}
const W7 = (e) => {
  if (!H7(e))
    throw new Error(`Currency ${e} not supported`);
  return vf[e];
}, vR = (e) => J7(e) ? Object.entries(vf).filter(([, t]) => t.erc20[e].address).map(([t]) => t) : [];
async function G7(e, t, r) {
  var a, f;
  for (const [d, c] of Object.entries(vf))
    if (((f = (a = c.erc20[e]) == null ? void 0 : a.address) == null ? void 0 : f.toLowerCase()) === t.toLowerCase())
      return {
        symbol: d,
        decimals: c.erc20[e].decimals
      };
  if (e !== Number(r._network.chainId))
    throw new yR.Errors.WrongNetworkError({
      message: "Please switch to the correct network",
      networkId: e
    });
  const n = new HE(t, pv.ERC20ABI, r), [s, i] = await Promise.all([n.decimals(), n.symbol()]);
  return {
    symbol: i,
    decimals: s
  };
}
async function AR(e, t, r, n) {
  if (e === "0")
    return "Free";
  if (t && r) {
    let s;
    if (KA(t)) {
      if (!n)
        throw new Error("Provider is required");
      s = await G7(r, t, n);
      const i = Q7(r, t);
      return `${e ? Ag(e, s.decimals).toString() : ""} <a href=${i} target="_blank">${s.symbol}</a>`;
    } else
      return s = W7(t), `${e ? Ag(e, s.erc20[r].decimals).toString() : ""} ${t}`;
  }
  return "";
}
const TR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  commifiedRoundedNumberString: bR,
  ethCurrencyNameForNetwork: wR,
  formatCurrency: AR,
  getCurrenciesOnNetwork: vR,
  getERC20Metadata: G7,
  getSupportedCurrencyInfo: W7,
  isSupportedCurrency: H7,
  numberStringRound: L7
}, Symbol.toStringTag, { value: "Module" }));
export {
  bR as a,
  vR as b,
  TR as c,
  G7 as d,
  wR as e,
  AR as f,
  W7 as g,
  H7 as i,
  L7 as n
};
